function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire30f4"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire30f4"] = parcelRequire;
}
parcelRequire.register("eN4lT", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $ac49048bedeacd41$export$ffb0004e005737fa, (v) => $ac49048bedeacd41$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $ac49048bedeacd41$export$34b9dba7ce09269b, (v) => $ac49048bedeacd41$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $ac49048bedeacd41$export$25062201e9e25d76, (v) => $ac49048bedeacd41$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ac49048bedeacd41$export$ffb0004e005737fa;
var $ac49048bedeacd41$export$34b9dba7ce09269b;
var $ac49048bedeacd41$export$25062201e9e25d76;
"use strict";

var $8T3gX = parcelRequire("8T3gX");
var $ac49048bedeacd41$var$k = Symbol.for("react.element"), $ac49048bedeacd41$var$l = Symbol.for("react.fragment"), $ac49048bedeacd41$var$m = Object.prototype.hasOwnProperty, $ac49048bedeacd41$var$n = $8T3gX.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $ac49048bedeacd41$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $ac49048bedeacd41$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$ac49048bedeacd41$var$m.call(a, b) && !$ac49048bedeacd41$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $ac49048bedeacd41$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $ac49048bedeacd41$var$n.current
    };
}
$ac49048bedeacd41$export$ffb0004e005737fa = $ac49048bedeacd41$var$l;
$ac49048bedeacd41$export$34b9dba7ce09269b = $ac49048bedeacd41$var$q;
$ac49048bedeacd41$export$25062201e9e25d76 = $ac49048bedeacd41$var$q;

});
parcelRequire.register("8T3gX", function(module, exports) {
"use strict";

module.exports = (parcelRequire("6VuwR"));

});
parcelRequire.register("6VuwR", function(module, exports) {

$parcel$export(module.exports, "Children", () => $50afbf63db049363$export$dca3b0875bd9a954, (v) => $50afbf63db049363$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $50afbf63db049363$export$16fa2f45be04daa8, (v) => $50afbf63db049363$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $50afbf63db049363$export$ffb0004e005737fa, (v) => $50afbf63db049363$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $50afbf63db049363$export$e2c29f18771995cb, (v) => $50afbf63db049363$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $50afbf63db049363$export$221d75b3f55bb0bd, (v) => $50afbf63db049363$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $50afbf63db049363$export$5f8d39834fd61797, (v) => $50afbf63db049363$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $50afbf63db049363$export$74bf444e3cd11ea5, (v) => $50afbf63db049363$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $50afbf63db049363$export$ae55be85d98224ed, (v) => $50afbf63db049363$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $50afbf63db049363$export$e530037191fcd5d7, (v) => $50afbf63db049363$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $50afbf63db049363$export$fd42f52fd3ae1109, (v) => $50afbf63db049363$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $50afbf63db049363$export$c8a8987d4410bf2d, (v) => $50afbf63db049363$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $50afbf63db049363$export$d38cd72104c1f0e9, (v) => $50afbf63db049363$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $50afbf63db049363$export$7d1e3a5e95ceca43, (v) => $50afbf63db049363$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $50afbf63db049363$export$257a8862b851cb5b, (v) => $50afbf63db049363$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $50afbf63db049363$export$a8257692ac88316c, (v) => $50afbf63db049363$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $50afbf63db049363$export$488013bae63b21da, (v) => $50afbf63db049363$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $50afbf63db049363$export$7c73462e0d25e514, (v) => $50afbf63db049363$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $50afbf63db049363$export$7568632d0d33d16d, (v) => $50afbf63db049363$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $50afbf63db049363$export$88948ce120ea2619, (v) => $50afbf63db049363$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $50afbf63db049363$export$35808ee640e87ca7, (v) => $50afbf63db049363$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $50afbf63db049363$export$fae74005e78b1a27, (v) => $50afbf63db049363$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $50afbf63db049363$export$dc8fbce3eb94dc1e, (v) => $50afbf63db049363$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $50afbf63db049363$export$6a7bc4e911dc01cf, (v) => $50afbf63db049363$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $50afbf63db049363$export$6d9c69b0de29b591, (v) => $50afbf63db049363$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $50afbf63db049363$export$f680877a34711e37, (v) => $50afbf63db049363$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $50afbf63db049363$export$d5a552a76deda3c2, (v) => $50afbf63db049363$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $50afbf63db049363$export$aaabe4eda9ed9969, (v) => $50afbf63db049363$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $50afbf63db049363$export$e5c5a5f917a5871c, (v) => $50afbf63db049363$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $50afbf63db049363$export$1538c33de8887b59, (v) => $50afbf63db049363$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $50afbf63db049363$export$13e3392192263954, (v) => $50afbf63db049363$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $50afbf63db049363$export$b8f5890fc79d6aca, (v) => $50afbf63db049363$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $50afbf63db049363$export$60241385465d0a34, (v) => $50afbf63db049363$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $50afbf63db049363$export$306c0aa65ff9ec16, (v) => $50afbf63db049363$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $50afbf63db049363$export$7b286972b8d8ccbf, (v) => $50afbf63db049363$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $50afbf63db049363$export$83d89fbfd8236492, (v) => $50afbf63db049363$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $50afbf63db049363$export$dca3b0875bd9a954;
var $50afbf63db049363$export$16fa2f45be04daa8;
var $50afbf63db049363$export$ffb0004e005737fa;
var $50afbf63db049363$export$e2c29f18771995cb;
var $50afbf63db049363$export$221d75b3f55bb0bd;
var $50afbf63db049363$export$5f8d39834fd61797;
var $50afbf63db049363$export$74bf444e3cd11ea5;
var $50afbf63db049363$export$ae55be85d98224ed;
var $50afbf63db049363$export$e530037191fcd5d7;
var $50afbf63db049363$export$fd42f52fd3ae1109;
var $50afbf63db049363$export$c8a8987d4410bf2d;
var $50afbf63db049363$export$d38cd72104c1f0e9;
var $50afbf63db049363$export$7d1e3a5e95ceca43;
var $50afbf63db049363$export$257a8862b851cb5b;
var $50afbf63db049363$export$a8257692ac88316c;
var $50afbf63db049363$export$488013bae63b21da;
var $50afbf63db049363$export$7c73462e0d25e514;
var $50afbf63db049363$export$7568632d0d33d16d;
var $50afbf63db049363$export$88948ce120ea2619;
var $50afbf63db049363$export$35808ee640e87ca7;
var $50afbf63db049363$export$fae74005e78b1a27;
var $50afbf63db049363$export$dc8fbce3eb94dc1e;
var $50afbf63db049363$export$6a7bc4e911dc01cf;
var $50afbf63db049363$export$6d9c69b0de29b591;
var $50afbf63db049363$export$f680877a34711e37;
var $50afbf63db049363$export$d5a552a76deda3c2;
var $50afbf63db049363$export$aaabe4eda9ed9969;
var $50afbf63db049363$export$e5c5a5f917a5871c;
var $50afbf63db049363$export$1538c33de8887b59;
var $50afbf63db049363$export$13e3392192263954;
var $50afbf63db049363$export$b8f5890fc79d6aca;
var $50afbf63db049363$export$60241385465d0a34;
var $50afbf63db049363$export$306c0aa65ff9ec16;
var $50afbf63db049363$export$7b286972b8d8ccbf;
var $50afbf63db049363$export$83d89fbfd8236492;
"use strict";
var $50afbf63db049363$var$l = Symbol.for("react.element"), $50afbf63db049363$var$n = Symbol.for("react.portal"), $50afbf63db049363$var$p = Symbol.for("react.fragment"), $50afbf63db049363$var$q = Symbol.for("react.strict_mode"), $50afbf63db049363$var$r = Symbol.for("react.profiler"), $50afbf63db049363$var$t = Symbol.for("react.provider"), $50afbf63db049363$var$u = Symbol.for("react.context"), $50afbf63db049363$var$v = Symbol.for("react.forward_ref"), $50afbf63db049363$var$w = Symbol.for("react.suspense"), $50afbf63db049363$var$x = Symbol.for("react.memo"), $50afbf63db049363$var$y = Symbol.for("react.lazy"), $50afbf63db049363$var$z = Symbol.iterator;
function $50afbf63db049363$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $50afbf63db049363$var$z && a[$50afbf63db049363$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $50afbf63db049363$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $50afbf63db049363$var$C = Object.assign, $50afbf63db049363$var$D = {};
function $50afbf63db049363$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $50afbf63db049363$var$D;
    this.updater = e || $50afbf63db049363$var$B;
}
$50afbf63db049363$var$E.prototype.isReactComponent = {};
$50afbf63db049363$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$50afbf63db049363$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $50afbf63db049363$var$F() {}
$50afbf63db049363$var$F.prototype = $50afbf63db049363$var$E.prototype;
function $50afbf63db049363$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $50afbf63db049363$var$D;
    this.updater = e || $50afbf63db049363$var$B;
}
var $50afbf63db049363$var$H = $50afbf63db049363$var$G.prototype = new $50afbf63db049363$var$F;
$50afbf63db049363$var$H.constructor = $50afbf63db049363$var$G;
$50afbf63db049363$var$C($50afbf63db049363$var$H, $50afbf63db049363$var$E.prototype);
$50afbf63db049363$var$H.isPureReactComponent = !0;
var $50afbf63db049363$var$I = Array.isArray, $50afbf63db049363$var$J = Object.prototype.hasOwnProperty, $50afbf63db049363$var$K = {
    current: null
}, $50afbf63db049363$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $50afbf63db049363$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$50afbf63db049363$var$J.call(b, d) && !$50afbf63db049363$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $50afbf63db049363$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $50afbf63db049363$var$K.current
    };
}
function $50afbf63db049363$var$N(a, b) {
    return {
        $$typeof: $50afbf63db049363$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $50afbf63db049363$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $50afbf63db049363$var$l;
}
function $50afbf63db049363$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $50afbf63db049363$var$P = /\/+/g;
function $50afbf63db049363$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $50afbf63db049363$var$escape("" + a.key) : b.toString(36);
}
function $50afbf63db049363$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $50afbf63db049363$var$l:
                case $50afbf63db049363$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $50afbf63db049363$var$Q(h, 0) : d, $50afbf63db049363$var$I(c) ? (e = "", null != a && (e = a.replace($50afbf63db049363$var$P, "$&/") + "/"), $50afbf63db049363$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($50afbf63db049363$var$O(c) && (c = $50afbf63db049363$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($50afbf63db049363$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($50afbf63db049363$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $50afbf63db049363$var$Q(k, g);
        h += $50afbf63db049363$var$R(k, b, e, f, c);
    }
    else if (f = $50afbf63db049363$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $50afbf63db049363$var$Q(k, g++), h += $50afbf63db049363$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $50afbf63db049363$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $50afbf63db049363$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $50afbf63db049363$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $50afbf63db049363$var$U = {
    current: null
}, $50afbf63db049363$var$V = {
    transition: null
}, $50afbf63db049363$var$W = {
    ReactCurrentDispatcher: $50afbf63db049363$var$U,
    ReactCurrentBatchConfig: $50afbf63db049363$var$V,
    ReactCurrentOwner: $50afbf63db049363$var$K
};
$50afbf63db049363$export$dca3b0875bd9a954 = {
    map: $50afbf63db049363$var$S,
    forEach: function(a, b, e) {
        $50afbf63db049363$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $50afbf63db049363$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $50afbf63db049363$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$50afbf63db049363$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$50afbf63db049363$export$16fa2f45be04daa8 = $50afbf63db049363$var$E;
$50afbf63db049363$export$ffb0004e005737fa = $50afbf63db049363$var$p;
$50afbf63db049363$export$e2c29f18771995cb = $50afbf63db049363$var$r;
$50afbf63db049363$export$221d75b3f55bb0bd = $50afbf63db049363$var$G;
$50afbf63db049363$export$5f8d39834fd61797 = $50afbf63db049363$var$q;
$50afbf63db049363$export$74bf444e3cd11ea5 = $50afbf63db049363$var$w;
$50afbf63db049363$export$ae55be85d98224ed = $50afbf63db049363$var$W;
$50afbf63db049363$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $50afbf63db049363$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $50afbf63db049363$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$50afbf63db049363$var$J.call(b, f) && !$50afbf63db049363$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $50afbf63db049363$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$50afbf63db049363$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $50afbf63db049363$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $50afbf63db049363$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$50afbf63db049363$export$c8a8987d4410bf2d = $50afbf63db049363$var$M;
$50afbf63db049363$export$d38cd72104c1f0e9 = function(a) {
    var b = $50afbf63db049363$var$M.bind(null, a);
    b.type = a;
    return b;
};
$50afbf63db049363$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$50afbf63db049363$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $50afbf63db049363$var$v,
        render: a
    };
};
$50afbf63db049363$export$a8257692ac88316c = $50afbf63db049363$var$O;
$50afbf63db049363$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $50afbf63db049363$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $50afbf63db049363$var$T
    };
};
$50afbf63db049363$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $50afbf63db049363$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$50afbf63db049363$export$7568632d0d33d16d = function(a) {
    var b = $50afbf63db049363$var$V.transition;
    $50afbf63db049363$var$V.transition = {};
    try {
        a();
    } finally{
        $50afbf63db049363$var$V.transition = b;
    }
};
$50afbf63db049363$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$50afbf63db049363$export$35808ee640e87ca7 = function(a, b) {
    return $50afbf63db049363$var$U.current.useCallback(a, b);
};
$50afbf63db049363$export$fae74005e78b1a27 = function(a) {
    return $50afbf63db049363$var$U.current.useContext(a);
};
$50afbf63db049363$export$dc8fbce3eb94dc1e = function() {};
$50afbf63db049363$export$6a7bc4e911dc01cf = function(a) {
    return $50afbf63db049363$var$U.current.useDeferredValue(a);
};
$50afbf63db049363$export$6d9c69b0de29b591 = function(a, b) {
    return $50afbf63db049363$var$U.current.useEffect(a, b);
};
$50afbf63db049363$export$f680877a34711e37 = function() {
    return $50afbf63db049363$var$U.current.useId();
};
$50afbf63db049363$export$d5a552a76deda3c2 = function(a, b, e) {
    return $50afbf63db049363$var$U.current.useImperativeHandle(a, b, e);
};
$50afbf63db049363$export$aaabe4eda9ed9969 = function(a, b) {
    return $50afbf63db049363$var$U.current.useInsertionEffect(a, b);
};
$50afbf63db049363$export$e5c5a5f917a5871c = function(a, b) {
    return $50afbf63db049363$var$U.current.useLayoutEffect(a, b);
};
$50afbf63db049363$export$1538c33de8887b59 = function(a, b) {
    return $50afbf63db049363$var$U.current.useMemo(a, b);
};
$50afbf63db049363$export$13e3392192263954 = function(a, b, e) {
    return $50afbf63db049363$var$U.current.useReducer(a, b, e);
};
$50afbf63db049363$export$b8f5890fc79d6aca = function(a) {
    return $50afbf63db049363$var$U.current.useRef(a);
};
$50afbf63db049363$export$60241385465d0a34 = function(a) {
    return $50afbf63db049363$var$U.current.useState(a);
};
$50afbf63db049363$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $50afbf63db049363$var$U.current.useSyncExternalStore(a, b, e);
};
$50afbf63db049363$export$7b286972b8d8ccbf = function() {
    return $50afbf63db049363$var$U.current.useTransition();
};
$50afbf63db049363$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("WeH8M", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0af0d0faab426b68$export$ae55be85d98224ed, (v) => $0af0d0faab426b68$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0af0d0faab426b68$export$d39a5bbd09211389, (v) => $0af0d0faab426b68$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0af0d0faab426b68$export$882461b6382ed46c, (v) => $0af0d0faab426b68$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0af0d0faab426b68$export$466bfc07425424d5, (v) => $0af0d0faab426b68$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0af0d0faab426b68$export$cd75ccfd720a3cd4, (v) => $0af0d0faab426b68$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0af0d0faab426b68$export$fa8d919ba61d84db, (v) => $0af0d0faab426b68$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0af0d0faab426b68$export$757ceba2d55c277e, (v) => $0af0d0faab426b68$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0af0d0faab426b68$export$b3890eb0ae9dca99, (v) => $0af0d0faab426b68$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0af0d0faab426b68$export$502457920280e6be, (v) => $0af0d0faab426b68$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0af0d0faab426b68$export$c78a37762a8d58e1, (v) => $0af0d0faab426b68$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0af0d0faab426b68$export$dc54d992c10e8a18, (v) => $0af0d0faab426b68$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0af0d0faab426b68$export$83d89fbfd8236492, (v) => $0af0d0faab426b68$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0af0d0faab426b68$export$ae55be85d98224ed;
var $0af0d0faab426b68$export$d39a5bbd09211389;
var $0af0d0faab426b68$export$882461b6382ed46c;
var $0af0d0faab426b68$export$466bfc07425424d5;
var $0af0d0faab426b68$export$cd75ccfd720a3cd4;
var $0af0d0faab426b68$export$fa8d919ba61d84db;
var $0af0d0faab426b68$export$757ceba2d55c277e;
var $0af0d0faab426b68$export$b3890eb0ae9dca99;
var $0af0d0faab426b68$export$502457920280e6be;
var $0af0d0faab426b68$export$c78a37762a8d58e1;
var $0af0d0faab426b68$export$dc54d992c10e8a18;
var $0af0d0faab426b68$export$83d89fbfd8236492;
"use strict";

var $8T3gX = parcelRequire("8T3gX");

var $74qJ9 = parcelRequire("74qJ9");
function $0af0d0faab426b68$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0af0d0faab426b68$var$da = new Set, $0af0d0faab426b68$var$ea = {};
function $0af0d0faab426b68$var$fa(a, b) {
    $0af0d0faab426b68$var$ha(a, b);
    $0af0d0faab426b68$var$ha(a + "Capture", b);
}
function $0af0d0faab426b68$var$ha(a, b) {
    $0af0d0faab426b68$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0af0d0faab426b68$var$da.add(b[a]);
}
var $0af0d0faab426b68$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0af0d0faab426b68$var$ja = Object.prototype.hasOwnProperty, $0af0d0faab426b68$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0af0d0faab426b68$var$la = {}, $0af0d0faab426b68$var$ma = {};
function $0af0d0faab426b68$var$oa(a) {
    if ($0af0d0faab426b68$var$ja.call($0af0d0faab426b68$var$ma, a)) return !0;
    if ($0af0d0faab426b68$var$ja.call($0af0d0faab426b68$var$la, a)) return !1;
    if ($0af0d0faab426b68$var$ka.test(a)) return $0af0d0faab426b68$var$ma[a] = !0;
    $0af0d0faab426b68$var$la[a] = !0;
    return !1;
}
function $0af0d0faab426b68$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0af0d0faab426b68$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0af0d0faab426b68$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0af0d0faab426b68$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0af0d0faab426b68$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0af0d0faab426b68$var$z[a] = new $0af0d0faab426b68$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0af0d0faab426b68$var$z[b] = new $0af0d0faab426b68$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0af0d0faab426b68$var$z[a] = new $0af0d0faab426b68$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0af0d0faab426b68$var$z[a] = new $0af0d0faab426b68$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0af0d0faab426b68$var$z[a] = new $0af0d0faab426b68$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0af0d0faab426b68$var$z[a] = new $0af0d0faab426b68$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0af0d0faab426b68$var$z[a] = new $0af0d0faab426b68$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0af0d0faab426b68$var$z[a] = new $0af0d0faab426b68$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0af0d0faab426b68$var$z[a] = new $0af0d0faab426b68$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0af0d0faab426b68$var$ra = /[\-:]([a-z])/g;
function $0af0d0faab426b68$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0af0d0faab426b68$var$ra, $0af0d0faab426b68$var$sa);
    $0af0d0faab426b68$var$z[b] = new $0af0d0faab426b68$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0af0d0faab426b68$var$ra, $0af0d0faab426b68$var$sa);
    $0af0d0faab426b68$var$z[b] = new $0af0d0faab426b68$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0af0d0faab426b68$var$ra, $0af0d0faab426b68$var$sa);
    $0af0d0faab426b68$var$z[b] = new $0af0d0faab426b68$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0af0d0faab426b68$var$z[a] = new $0af0d0faab426b68$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0af0d0faab426b68$var$z.xlinkHref = new $0af0d0faab426b68$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0af0d0faab426b68$var$z[a] = new $0af0d0faab426b68$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0af0d0faab426b68$var$ta(a, b, c, d) {
    var e = $0af0d0faab426b68$var$z.hasOwnProperty(b) ? $0af0d0faab426b68$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0af0d0faab426b68$var$qa(b, c, e, d) && (c = null), d || null === e ? $0af0d0faab426b68$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0af0d0faab426b68$var$ua = $8T3gX.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0af0d0faab426b68$var$va = Symbol.for("react.element"), $0af0d0faab426b68$var$wa = Symbol.for("react.portal"), $0af0d0faab426b68$var$ya = Symbol.for("react.fragment"), $0af0d0faab426b68$var$za = Symbol.for("react.strict_mode"), $0af0d0faab426b68$var$Aa = Symbol.for("react.profiler"), $0af0d0faab426b68$var$Ba = Symbol.for("react.provider"), $0af0d0faab426b68$var$Ca = Symbol.for("react.context"), $0af0d0faab426b68$var$Da = Symbol.for("react.forward_ref"), $0af0d0faab426b68$var$Ea = Symbol.for("react.suspense"), $0af0d0faab426b68$var$Fa = Symbol.for("react.suspense_list"), $0af0d0faab426b68$var$Ga = Symbol.for("react.memo"), $0af0d0faab426b68$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0af0d0faab426b68$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0af0d0faab426b68$var$Ja = Symbol.iterator;
function $0af0d0faab426b68$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0af0d0faab426b68$var$Ja && a[$0af0d0faab426b68$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0af0d0faab426b68$var$A = Object.assign, $0af0d0faab426b68$var$La;
function $0af0d0faab426b68$var$Ma(a) {
    if (void 0 === $0af0d0faab426b68$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0af0d0faab426b68$var$La = b && b[1] || "";
    }
    return "\n" + $0af0d0faab426b68$var$La + a;
}
var $0af0d0faab426b68$var$Na = !1;
function $0af0d0faab426b68$var$Oa(a, b) {
    if (!a || $0af0d0faab426b68$var$Na) return "";
    $0af0d0faab426b68$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0af0d0faab426b68$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0af0d0faab426b68$var$Ma(a) : "";
}
function $0af0d0faab426b68$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0af0d0faab426b68$var$Ma(a.type);
        case 16:
            return $0af0d0faab426b68$var$Ma("Lazy");
        case 13:
            return $0af0d0faab426b68$var$Ma("Suspense");
        case 19:
            return $0af0d0faab426b68$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0af0d0faab426b68$var$Oa(a.type, !1), a;
        case 11:
            return a = $0af0d0faab426b68$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0af0d0faab426b68$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0af0d0faab426b68$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0af0d0faab426b68$var$ya:
            return "Fragment";
        case $0af0d0faab426b68$var$wa:
            return "Portal";
        case $0af0d0faab426b68$var$Aa:
            return "Profiler";
        case $0af0d0faab426b68$var$za:
            return "StrictMode";
        case $0af0d0faab426b68$var$Ea:
            return "Suspense";
        case $0af0d0faab426b68$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0af0d0faab426b68$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0af0d0faab426b68$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0af0d0faab426b68$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0af0d0faab426b68$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0af0d0faab426b68$var$Qa(a.type) || "Memo";
        case $0af0d0faab426b68$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0af0d0faab426b68$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0af0d0faab426b68$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0af0d0faab426b68$var$Qa(b);
        case 8:
            return b === $0af0d0faab426b68$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0af0d0faab426b68$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0af0d0faab426b68$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0af0d0faab426b68$var$Ua(a) {
    var b = $0af0d0faab426b68$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0af0d0faab426b68$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0af0d0faab426b68$var$Ua(a));
}
function $0af0d0faab426b68$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0af0d0faab426b68$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0af0d0faab426b68$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0af0d0faab426b68$var$Ya(a, b) {
    var c = b.checked;
    return $0af0d0faab426b68$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0af0d0faab426b68$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0af0d0faab426b68$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0af0d0faab426b68$var$ab(a, b) {
    b = b.checked;
    null != b && $0af0d0faab426b68$var$ta(a, "checked", b, !1);
}
function $0af0d0faab426b68$var$bb(a, b) {
    $0af0d0faab426b68$var$ab(a, b);
    var c = $0af0d0faab426b68$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0af0d0faab426b68$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0af0d0faab426b68$var$cb(a, b.type, $0af0d0faab426b68$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0af0d0faab426b68$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0af0d0faab426b68$var$cb(a, b, c) {
    if ("number" !== b || $0af0d0faab426b68$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0af0d0faab426b68$var$eb = Array.isArray;
function $0af0d0faab426b68$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0af0d0faab426b68$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0af0d0faab426b68$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0af0d0faab426b68$var$p(91));
    return $0af0d0faab426b68$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0af0d0faab426b68$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0af0d0faab426b68$var$p(92));
            if ($0af0d0faab426b68$var$eb(c)) {
                if (1 < c.length) throw Error($0af0d0faab426b68$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0af0d0faab426b68$var$Sa(c)
    };
}
function $0af0d0faab426b68$var$ib(a, b) {
    var c = $0af0d0faab426b68$var$Sa(b.value), d = $0af0d0faab426b68$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0af0d0faab426b68$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0af0d0faab426b68$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0af0d0faab426b68$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0af0d0faab426b68$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0af0d0faab426b68$var$mb, $0af0d0faab426b68$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0af0d0faab426b68$var$mb = $0af0d0faab426b68$var$mb || document.createElement("div");
        $0af0d0faab426b68$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0af0d0faab426b68$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0af0d0faab426b68$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0af0d0faab426b68$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0af0d0faab426b68$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0af0d0faab426b68$var$pb).forEach(function(a) {
    $0af0d0faab426b68$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0af0d0faab426b68$var$pb[b] = $0af0d0faab426b68$var$pb[a];
    });
});
function $0af0d0faab426b68$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0af0d0faab426b68$var$pb.hasOwnProperty(a) && $0af0d0faab426b68$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0af0d0faab426b68$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0af0d0faab426b68$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0af0d0faab426b68$var$tb = $0af0d0faab426b68$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0af0d0faab426b68$var$ub(a, b) {
    if (b) {
        if ($0af0d0faab426b68$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0af0d0faab426b68$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0af0d0faab426b68$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0af0d0faab426b68$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0af0d0faab426b68$var$p(62));
    }
}
function $0af0d0faab426b68$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0af0d0faab426b68$var$wb = null;
function $0af0d0faab426b68$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0af0d0faab426b68$var$yb = null, $0af0d0faab426b68$var$zb = null, $0af0d0faab426b68$var$Ab = null;
function $0af0d0faab426b68$var$Bb(a) {
    if (a = $0af0d0faab426b68$var$Cb(a)) {
        if ("function" !== typeof $0af0d0faab426b68$var$yb) throw Error($0af0d0faab426b68$var$p(280));
        var b = a.stateNode;
        b && (b = $0af0d0faab426b68$var$Db(b), $0af0d0faab426b68$var$yb(a.stateNode, a.type, b));
    }
}
function $0af0d0faab426b68$var$Eb(a) {
    $0af0d0faab426b68$var$zb ? $0af0d0faab426b68$var$Ab ? $0af0d0faab426b68$var$Ab.push(a) : $0af0d0faab426b68$var$Ab = [
        a
    ] : $0af0d0faab426b68$var$zb = a;
}
function $0af0d0faab426b68$var$Fb() {
    if ($0af0d0faab426b68$var$zb) {
        var a = $0af0d0faab426b68$var$zb, b = $0af0d0faab426b68$var$Ab;
        $0af0d0faab426b68$var$Ab = $0af0d0faab426b68$var$zb = null;
        $0af0d0faab426b68$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0af0d0faab426b68$var$Bb(b[a]);
    }
}
function $0af0d0faab426b68$var$Gb(a, b) {
    return a(b);
}
function $0af0d0faab426b68$var$Hb() {}
var $0af0d0faab426b68$var$Ib = !1;
function $0af0d0faab426b68$var$Jb(a, b, c) {
    if ($0af0d0faab426b68$var$Ib) return a(b, c);
    $0af0d0faab426b68$var$Ib = !0;
    try {
        return $0af0d0faab426b68$var$Gb(a, b, c);
    } finally{
        if ($0af0d0faab426b68$var$Ib = !1, null !== $0af0d0faab426b68$var$zb || null !== $0af0d0faab426b68$var$Ab) $0af0d0faab426b68$var$Hb(), $0af0d0faab426b68$var$Fb();
    }
}
function $0af0d0faab426b68$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0af0d0faab426b68$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0af0d0faab426b68$var$p(231, b, typeof c));
    return c;
}
var $0af0d0faab426b68$var$Lb = !1;
if ($0af0d0faab426b68$var$ia) try {
    var $0af0d0faab426b68$var$Mb = {};
    Object.defineProperty($0af0d0faab426b68$var$Mb, "passive", {
        get: function() {
            $0af0d0faab426b68$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0af0d0faab426b68$var$Mb, $0af0d0faab426b68$var$Mb);
    window.removeEventListener("test", $0af0d0faab426b68$var$Mb, $0af0d0faab426b68$var$Mb);
} catch (a) {
    $0af0d0faab426b68$var$Lb = !1;
}
function $0af0d0faab426b68$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0af0d0faab426b68$var$Ob = !1, $0af0d0faab426b68$var$Pb = null, $0af0d0faab426b68$var$Qb = !1, $0af0d0faab426b68$var$Rb = null, $0af0d0faab426b68$var$Sb = {
    onError: function(a) {
        $0af0d0faab426b68$var$Ob = !0;
        $0af0d0faab426b68$var$Pb = a;
    }
};
function $0af0d0faab426b68$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0af0d0faab426b68$var$Ob = !1;
    $0af0d0faab426b68$var$Pb = null;
    $0af0d0faab426b68$var$Nb.apply($0af0d0faab426b68$var$Sb, arguments);
}
function $0af0d0faab426b68$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0af0d0faab426b68$var$Tb.apply(this, arguments);
    if ($0af0d0faab426b68$var$Ob) {
        if ($0af0d0faab426b68$var$Ob) {
            var l = $0af0d0faab426b68$var$Pb;
            $0af0d0faab426b68$var$Ob = !1;
            $0af0d0faab426b68$var$Pb = null;
        } else throw Error($0af0d0faab426b68$var$p(198));
        $0af0d0faab426b68$var$Qb || ($0af0d0faab426b68$var$Qb = !0, $0af0d0faab426b68$var$Rb = l);
    }
}
function $0af0d0faab426b68$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0af0d0faab426b68$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0af0d0faab426b68$var$Xb(a) {
    if ($0af0d0faab426b68$var$Vb(a) !== a) throw Error($0af0d0faab426b68$var$p(188));
}
function $0af0d0faab426b68$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0af0d0faab426b68$var$Vb(a);
        if (null === b) throw Error($0af0d0faab426b68$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0af0d0faab426b68$var$Xb(e), a;
                if (f === d) return $0af0d0faab426b68$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0af0d0faab426b68$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0af0d0faab426b68$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0af0d0faab426b68$var$p(190));
    }
    if (3 !== c.tag) throw Error($0af0d0faab426b68$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0af0d0faab426b68$var$Zb(a) {
    a = $0af0d0faab426b68$var$Yb(a);
    return null !== a ? $0af0d0faab426b68$var$$b(a) : null;
}
function $0af0d0faab426b68$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0af0d0faab426b68$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0af0d0faab426b68$var$ac = $74qJ9.unstable_scheduleCallback, $0af0d0faab426b68$var$bc = $74qJ9.unstable_cancelCallback, $0af0d0faab426b68$var$cc = $74qJ9.unstable_shouldYield, $0af0d0faab426b68$var$dc = $74qJ9.unstable_requestPaint, $0af0d0faab426b68$var$B = $74qJ9.unstable_now, $0af0d0faab426b68$var$ec = $74qJ9.unstable_getCurrentPriorityLevel, $0af0d0faab426b68$var$fc = $74qJ9.unstable_ImmediatePriority, $0af0d0faab426b68$var$gc = $74qJ9.unstable_UserBlockingPriority, $0af0d0faab426b68$var$hc = $74qJ9.unstable_NormalPriority, $0af0d0faab426b68$var$ic = $74qJ9.unstable_LowPriority, $0af0d0faab426b68$var$jc = $74qJ9.unstable_IdlePriority, $0af0d0faab426b68$var$kc = null, $0af0d0faab426b68$var$lc = null;
function $0af0d0faab426b68$var$mc(a) {
    if ($0af0d0faab426b68$var$lc && "function" === typeof $0af0d0faab426b68$var$lc.onCommitFiberRoot) try {
        $0af0d0faab426b68$var$lc.onCommitFiberRoot($0af0d0faab426b68$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0af0d0faab426b68$var$oc = Math.clz32 ? Math.clz32 : $0af0d0faab426b68$var$nc, $0af0d0faab426b68$var$pc = Math.log, $0af0d0faab426b68$var$qc = Math.LN2;
function $0af0d0faab426b68$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0af0d0faab426b68$var$pc(a) / $0af0d0faab426b68$var$qc | 0) | 0;
}
var $0af0d0faab426b68$var$rc = 64, $0af0d0faab426b68$var$sc = 4194304;
function $0af0d0faab426b68$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0af0d0faab426b68$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0af0d0faab426b68$var$tc(h) : (f &= g, 0 !== f && (d = $0af0d0faab426b68$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0af0d0faab426b68$var$tc(g) : 0 !== f && (d = $0af0d0faab426b68$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0af0d0faab426b68$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0af0d0faab426b68$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0af0d0faab426b68$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0af0d0faab426b68$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0af0d0faab426b68$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0af0d0faab426b68$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0af0d0faab426b68$var$yc() {
    var a = $0af0d0faab426b68$var$rc;
    $0af0d0faab426b68$var$rc <<= 1;
    0 === ($0af0d0faab426b68$var$rc & 4194240) && ($0af0d0faab426b68$var$rc = 64);
    return a;
}
function $0af0d0faab426b68$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0af0d0faab426b68$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0af0d0faab426b68$var$oc(b);
    a[b] = c;
}
function $0af0d0faab426b68$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0af0d0faab426b68$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0af0d0faab426b68$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0af0d0faab426b68$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0af0d0faab426b68$var$C = 0;
function $0af0d0faab426b68$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0af0d0faab426b68$var$Ec, $0af0d0faab426b68$var$Fc, $0af0d0faab426b68$var$Gc, $0af0d0faab426b68$var$Hc, $0af0d0faab426b68$var$Ic, $0af0d0faab426b68$var$Jc = !1, $0af0d0faab426b68$var$Kc = [], $0af0d0faab426b68$var$Lc = null, $0af0d0faab426b68$var$Mc = null, $0af0d0faab426b68$var$Nc = null, $0af0d0faab426b68$var$Oc = new Map, $0af0d0faab426b68$var$Pc = new Map, $0af0d0faab426b68$var$Qc = [], $0af0d0faab426b68$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0af0d0faab426b68$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0af0d0faab426b68$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0af0d0faab426b68$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0af0d0faab426b68$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0af0d0faab426b68$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0af0d0faab426b68$var$Pc.delete(b.pointerId);
    }
}
function $0af0d0faab426b68$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0af0d0faab426b68$var$Cb(b), null !== b && $0af0d0faab426b68$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0af0d0faab426b68$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0af0d0faab426b68$var$Lc = $0af0d0faab426b68$var$Tc($0af0d0faab426b68$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0af0d0faab426b68$var$Mc = $0af0d0faab426b68$var$Tc($0af0d0faab426b68$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0af0d0faab426b68$var$Nc = $0af0d0faab426b68$var$Tc($0af0d0faab426b68$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0af0d0faab426b68$var$Oc.set(f, $0af0d0faab426b68$var$Tc($0af0d0faab426b68$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0af0d0faab426b68$var$Pc.set(f, $0af0d0faab426b68$var$Tc($0af0d0faab426b68$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0af0d0faab426b68$var$Vc(a) {
    var b = $0af0d0faab426b68$var$Wc(a.target);
    if (null !== b) {
        var c = $0af0d0faab426b68$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0af0d0faab426b68$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0af0d0faab426b68$var$Ic(a.priority, function() {
                        $0af0d0faab426b68$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0af0d0faab426b68$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0af0d0faab426b68$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0af0d0faab426b68$var$wb = d;
            c.target.dispatchEvent(d);
            $0af0d0faab426b68$var$wb = null;
        } else return b = $0af0d0faab426b68$var$Cb(c), null !== b && $0af0d0faab426b68$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0af0d0faab426b68$var$Zc(a, b, c) {
    $0af0d0faab426b68$var$Xc(a) && c.delete(b);
}
function $0af0d0faab426b68$var$$c() {
    $0af0d0faab426b68$var$Jc = !1;
    null !== $0af0d0faab426b68$var$Lc && $0af0d0faab426b68$var$Xc($0af0d0faab426b68$var$Lc) && ($0af0d0faab426b68$var$Lc = null);
    null !== $0af0d0faab426b68$var$Mc && $0af0d0faab426b68$var$Xc($0af0d0faab426b68$var$Mc) && ($0af0d0faab426b68$var$Mc = null);
    null !== $0af0d0faab426b68$var$Nc && $0af0d0faab426b68$var$Xc($0af0d0faab426b68$var$Nc) && ($0af0d0faab426b68$var$Nc = null);
    $0af0d0faab426b68$var$Oc.forEach($0af0d0faab426b68$var$Zc);
    $0af0d0faab426b68$var$Pc.forEach($0af0d0faab426b68$var$Zc);
}
function $0af0d0faab426b68$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0af0d0faab426b68$var$Jc || ($0af0d0faab426b68$var$Jc = !0, $74qJ9.unstable_scheduleCallback($74qJ9.unstable_NormalPriority, $0af0d0faab426b68$var$$c)));
}
function $0af0d0faab426b68$var$bd(a) {
    function b(b) {
        return $0af0d0faab426b68$var$ad(b, a);
    }
    if (0 < $0af0d0faab426b68$var$Kc.length) {
        $0af0d0faab426b68$var$ad($0af0d0faab426b68$var$Kc[0], a);
        for(var c = 1; c < $0af0d0faab426b68$var$Kc.length; c++){
            var d = $0af0d0faab426b68$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0af0d0faab426b68$var$Lc && $0af0d0faab426b68$var$ad($0af0d0faab426b68$var$Lc, a);
    null !== $0af0d0faab426b68$var$Mc && $0af0d0faab426b68$var$ad($0af0d0faab426b68$var$Mc, a);
    null !== $0af0d0faab426b68$var$Nc && $0af0d0faab426b68$var$ad($0af0d0faab426b68$var$Nc, a);
    $0af0d0faab426b68$var$Oc.forEach(b);
    $0af0d0faab426b68$var$Pc.forEach(b);
    for(c = 0; c < $0af0d0faab426b68$var$Qc.length; c++)d = $0af0d0faab426b68$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0af0d0faab426b68$var$Qc.length && (c = $0af0d0faab426b68$var$Qc[0], null === c.blockedOn);)$0af0d0faab426b68$var$Vc(c), null === c.blockedOn && $0af0d0faab426b68$var$Qc.shift();
}
var $0af0d0faab426b68$var$cd = $0af0d0faab426b68$var$ua.ReactCurrentBatchConfig, $0af0d0faab426b68$var$dd = !0;
function $0af0d0faab426b68$var$ed(a, b, c, d) {
    var e = $0af0d0faab426b68$var$C, f = $0af0d0faab426b68$var$cd.transition;
    $0af0d0faab426b68$var$cd.transition = null;
    try {
        $0af0d0faab426b68$var$C = 1, $0af0d0faab426b68$var$fd(a, b, c, d);
    } finally{
        $0af0d0faab426b68$var$C = e, $0af0d0faab426b68$var$cd.transition = f;
    }
}
function $0af0d0faab426b68$var$gd(a, b, c, d) {
    var e = $0af0d0faab426b68$var$C, f = $0af0d0faab426b68$var$cd.transition;
    $0af0d0faab426b68$var$cd.transition = null;
    try {
        $0af0d0faab426b68$var$C = 4, $0af0d0faab426b68$var$fd(a, b, c, d);
    } finally{
        $0af0d0faab426b68$var$C = e, $0af0d0faab426b68$var$cd.transition = f;
    }
}
function $0af0d0faab426b68$var$fd(a, b, c, d) {
    if ($0af0d0faab426b68$var$dd) {
        var e = $0af0d0faab426b68$var$Yc(a, b, c, d);
        if (null === e) $0af0d0faab426b68$var$hd(a, b, d, $0af0d0faab426b68$var$id, c), $0af0d0faab426b68$var$Sc(a, d);
        else if ($0af0d0faab426b68$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0af0d0faab426b68$var$Sc(a, d), b & 4 && -1 < $0af0d0faab426b68$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0af0d0faab426b68$var$Cb(e);
                null !== f && $0af0d0faab426b68$var$Ec(f);
                f = $0af0d0faab426b68$var$Yc(a, b, c, d);
                null === f && $0af0d0faab426b68$var$hd(a, b, d, $0af0d0faab426b68$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0af0d0faab426b68$var$hd(a, b, d, null, c);
    }
}
var $0af0d0faab426b68$var$id = null;
function $0af0d0faab426b68$var$Yc(a, b, c, d) {
    $0af0d0faab426b68$var$id = null;
    a = $0af0d0faab426b68$var$xb(d);
    a = $0af0d0faab426b68$var$Wc(a);
    if (null !== a) {
        if (b = $0af0d0faab426b68$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0af0d0faab426b68$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0af0d0faab426b68$var$id = a;
    return null;
}
function $0af0d0faab426b68$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0af0d0faab426b68$var$ec()){
                case $0af0d0faab426b68$var$fc:
                    return 1;
                case $0af0d0faab426b68$var$gc:
                    return 4;
                case $0af0d0faab426b68$var$hc:
                case $0af0d0faab426b68$var$ic:
                    return 16;
                case $0af0d0faab426b68$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0af0d0faab426b68$var$kd = null, $0af0d0faab426b68$var$ld = null, $0af0d0faab426b68$var$md = null;
function $0af0d0faab426b68$var$nd() {
    if ($0af0d0faab426b68$var$md) return $0af0d0faab426b68$var$md;
    var a, b = $0af0d0faab426b68$var$ld, c = b.length, d, e = "value" in $0af0d0faab426b68$var$kd ? $0af0d0faab426b68$var$kd.value : $0af0d0faab426b68$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0af0d0faab426b68$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0af0d0faab426b68$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0af0d0faab426b68$var$pd() {
    return !0;
}
function $0af0d0faab426b68$var$qd() {
    return !1;
}
function $0af0d0faab426b68$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0af0d0faab426b68$var$pd : $0af0d0faab426b68$var$qd;
        this.isPropagationStopped = $0af0d0faab426b68$var$qd;
        return this;
    }
    $0af0d0faab426b68$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0af0d0faab426b68$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0af0d0faab426b68$var$pd);
        },
        persist: function() {},
        isPersistent: $0af0d0faab426b68$var$pd
    });
    return b;
}
var $0af0d0faab426b68$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0af0d0faab426b68$var$td = $0af0d0faab426b68$var$rd($0af0d0faab426b68$var$sd), $0af0d0faab426b68$var$ud = $0af0d0faab426b68$var$A({}, $0af0d0faab426b68$var$sd, {
    view: 0,
    detail: 0
}), $0af0d0faab426b68$var$vd = $0af0d0faab426b68$var$rd($0af0d0faab426b68$var$ud), $0af0d0faab426b68$var$wd, $0af0d0faab426b68$var$xd, $0af0d0faab426b68$var$yd, $0af0d0faab426b68$var$Ad = $0af0d0faab426b68$var$A({}, $0af0d0faab426b68$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0af0d0faab426b68$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0af0d0faab426b68$var$yd && ($0af0d0faab426b68$var$yd && "mousemove" === a.type ? ($0af0d0faab426b68$var$wd = a.screenX - $0af0d0faab426b68$var$yd.screenX, $0af0d0faab426b68$var$xd = a.screenY - $0af0d0faab426b68$var$yd.screenY) : $0af0d0faab426b68$var$xd = $0af0d0faab426b68$var$wd = 0, $0af0d0faab426b68$var$yd = a);
        return $0af0d0faab426b68$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0af0d0faab426b68$var$xd;
    }
}), $0af0d0faab426b68$var$Bd = $0af0d0faab426b68$var$rd($0af0d0faab426b68$var$Ad), $0af0d0faab426b68$var$Cd = $0af0d0faab426b68$var$A({}, $0af0d0faab426b68$var$Ad, {
    dataTransfer: 0
}), $0af0d0faab426b68$var$Dd = $0af0d0faab426b68$var$rd($0af0d0faab426b68$var$Cd), $0af0d0faab426b68$var$Ed = $0af0d0faab426b68$var$A({}, $0af0d0faab426b68$var$ud, {
    relatedTarget: 0
}), $0af0d0faab426b68$var$Fd = $0af0d0faab426b68$var$rd($0af0d0faab426b68$var$Ed), $0af0d0faab426b68$var$Gd = $0af0d0faab426b68$var$A({}, $0af0d0faab426b68$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0af0d0faab426b68$var$Hd = $0af0d0faab426b68$var$rd($0af0d0faab426b68$var$Gd), $0af0d0faab426b68$var$Id = $0af0d0faab426b68$var$A({}, $0af0d0faab426b68$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0af0d0faab426b68$var$Jd = $0af0d0faab426b68$var$rd($0af0d0faab426b68$var$Id), $0af0d0faab426b68$var$Kd = $0af0d0faab426b68$var$A({}, $0af0d0faab426b68$var$sd, {
    data: 0
}), $0af0d0faab426b68$var$Ld = $0af0d0faab426b68$var$rd($0af0d0faab426b68$var$Kd), $0af0d0faab426b68$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0af0d0faab426b68$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0af0d0faab426b68$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0af0d0faab426b68$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0af0d0faab426b68$var$Od[a]) ? !!b[a] : !1;
}
function $0af0d0faab426b68$var$zd() {
    return $0af0d0faab426b68$var$Pd;
}
var $0af0d0faab426b68$var$Qd = $0af0d0faab426b68$var$A({}, $0af0d0faab426b68$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0af0d0faab426b68$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0af0d0faab426b68$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0af0d0faab426b68$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0af0d0faab426b68$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0af0d0faab426b68$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0af0d0faab426b68$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0af0d0faab426b68$var$Rd = $0af0d0faab426b68$var$rd($0af0d0faab426b68$var$Qd), $0af0d0faab426b68$var$Sd = $0af0d0faab426b68$var$A({}, $0af0d0faab426b68$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0af0d0faab426b68$var$Td = $0af0d0faab426b68$var$rd($0af0d0faab426b68$var$Sd), $0af0d0faab426b68$var$Ud = $0af0d0faab426b68$var$A({}, $0af0d0faab426b68$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0af0d0faab426b68$var$zd
}), $0af0d0faab426b68$var$Vd = $0af0d0faab426b68$var$rd($0af0d0faab426b68$var$Ud), $0af0d0faab426b68$var$Wd = $0af0d0faab426b68$var$A({}, $0af0d0faab426b68$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0af0d0faab426b68$var$Xd = $0af0d0faab426b68$var$rd($0af0d0faab426b68$var$Wd), $0af0d0faab426b68$var$Yd = $0af0d0faab426b68$var$A({}, $0af0d0faab426b68$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0af0d0faab426b68$var$Zd = $0af0d0faab426b68$var$rd($0af0d0faab426b68$var$Yd), $0af0d0faab426b68$var$$d = [
    9,
    13,
    27,
    32
], $0af0d0faab426b68$var$ae = $0af0d0faab426b68$var$ia && "CompositionEvent" in window, $0af0d0faab426b68$var$be = null;
$0af0d0faab426b68$var$ia && "documentMode" in document && ($0af0d0faab426b68$var$be = document.documentMode);
var $0af0d0faab426b68$var$ce = $0af0d0faab426b68$var$ia && "TextEvent" in window && !$0af0d0faab426b68$var$be, $0af0d0faab426b68$var$de = $0af0d0faab426b68$var$ia && (!$0af0d0faab426b68$var$ae || $0af0d0faab426b68$var$be && 8 < $0af0d0faab426b68$var$be && 11 >= $0af0d0faab426b68$var$be), $0af0d0faab426b68$var$ee = String.fromCharCode(32), $0af0d0faab426b68$var$fe = !1;
function $0af0d0faab426b68$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0af0d0faab426b68$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0af0d0faab426b68$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0af0d0faab426b68$var$ie = !1;
function $0af0d0faab426b68$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0af0d0faab426b68$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0af0d0faab426b68$var$fe = !0;
            return $0af0d0faab426b68$var$ee;
        case "textInput":
            return a = b.data, a === $0af0d0faab426b68$var$ee && $0af0d0faab426b68$var$fe ? null : a;
        default:
            return null;
    }
}
function $0af0d0faab426b68$var$ke(a, b) {
    if ($0af0d0faab426b68$var$ie) return "compositionend" === a || !$0af0d0faab426b68$var$ae && $0af0d0faab426b68$var$ge(a, b) ? (a = $0af0d0faab426b68$var$nd(), $0af0d0faab426b68$var$md = $0af0d0faab426b68$var$ld = $0af0d0faab426b68$var$kd = null, $0af0d0faab426b68$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0af0d0faab426b68$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0af0d0faab426b68$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0af0d0faab426b68$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0af0d0faab426b68$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0af0d0faab426b68$var$ne(a, b, c, d) {
    $0af0d0faab426b68$var$Eb(d);
    b = $0af0d0faab426b68$var$oe(b, "onChange");
    0 < b.length && (c = new $0af0d0faab426b68$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0af0d0faab426b68$var$pe = null, $0af0d0faab426b68$var$qe = null;
function $0af0d0faab426b68$var$re(a) {
    $0af0d0faab426b68$var$se(a, 0);
}
function $0af0d0faab426b68$var$te(a) {
    var b = $0af0d0faab426b68$var$ue(a);
    if ($0af0d0faab426b68$var$Wa(b)) return a;
}
function $0af0d0faab426b68$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0af0d0faab426b68$var$we = !1;
if ($0af0d0faab426b68$var$ia) {
    var $0af0d0faab426b68$var$xe;
    if ($0af0d0faab426b68$var$ia) {
        var $0af0d0faab426b68$var$ye = "oninput" in document;
        if (!$0af0d0faab426b68$var$ye) {
            var $0af0d0faab426b68$var$ze = document.createElement("div");
            $0af0d0faab426b68$var$ze.setAttribute("oninput", "return;");
            $0af0d0faab426b68$var$ye = "function" === typeof $0af0d0faab426b68$var$ze.oninput;
        }
        $0af0d0faab426b68$var$xe = $0af0d0faab426b68$var$ye;
    } else $0af0d0faab426b68$var$xe = !1;
    $0af0d0faab426b68$var$we = $0af0d0faab426b68$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0af0d0faab426b68$var$Ae() {
    $0af0d0faab426b68$var$pe && ($0af0d0faab426b68$var$pe.detachEvent("onpropertychange", $0af0d0faab426b68$var$Be), $0af0d0faab426b68$var$qe = $0af0d0faab426b68$var$pe = null);
}
function $0af0d0faab426b68$var$Be(a) {
    if ("value" === a.propertyName && $0af0d0faab426b68$var$te($0af0d0faab426b68$var$qe)) {
        var b = [];
        $0af0d0faab426b68$var$ne(b, $0af0d0faab426b68$var$qe, a, $0af0d0faab426b68$var$xb(a));
        $0af0d0faab426b68$var$Jb($0af0d0faab426b68$var$re, b);
    }
}
function $0af0d0faab426b68$var$Ce(a, b, c) {
    "focusin" === a ? ($0af0d0faab426b68$var$Ae(), $0af0d0faab426b68$var$pe = b, $0af0d0faab426b68$var$qe = c, $0af0d0faab426b68$var$pe.attachEvent("onpropertychange", $0af0d0faab426b68$var$Be)) : "focusout" === a && $0af0d0faab426b68$var$Ae();
}
function $0af0d0faab426b68$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0af0d0faab426b68$var$te($0af0d0faab426b68$var$qe);
}
function $0af0d0faab426b68$var$Ee(a, b) {
    if ("click" === a) return $0af0d0faab426b68$var$te(b);
}
function $0af0d0faab426b68$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0af0d0faab426b68$var$te(b);
}
function $0af0d0faab426b68$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0af0d0faab426b68$var$He = "function" === typeof Object.is ? Object.is : $0af0d0faab426b68$var$Ge;
function $0af0d0faab426b68$var$Ie(a, b) {
    if ($0af0d0faab426b68$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0af0d0faab426b68$var$ja.call(b, e) || !$0af0d0faab426b68$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0af0d0faab426b68$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0af0d0faab426b68$var$Ke(a, b) {
    var c = $0af0d0faab426b68$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0af0d0faab426b68$var$Je(c);
    }
}
function $0af0d0faab426b68$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0af0d0faab426b68$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0af0d0faab426b68$var$Me() {
    for(var a = window, b = $0af0d0faab426b68$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0af0d0faab426b68$var$Xa(a.document);
    }
    return b;
}
function $0af0d0faab426b68$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0af0d0faab426b68$var$Oe(a) {
    var b = $0af0d0faab426b68$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0af0d0faab426b68$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0af0d0faab426b68$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0af0d0faab426b68$var$Ke(c, f);
                var g = $0af0d0faab426b68$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0af0d0faab426b68$var$Pe = $0af0d0faab426b68$var$ia && "documentMode" in document && 11 >= document.documentMode, $0af0d0faab426b68$var$Qe = null, $0af0d0faab426b68$var$Re = null, $0af0d0faab426b68$var$Se = null, $0af0d0faab426b68$var$Te = !1;
function $0af0d0faab426b68$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0af0d0faab426b68$var$Te || null == $0af0d0faab426b68$var$Qe || $0af0d0faab426b68$var$Qe !== $0af0d0faab426b68$var$Xa(d) || (d = $0af0d0faab426b68$var$Qe, "selectionStart" in d && $0af0d0faab426b68$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0af0d0faab426b68$var$Se && $0af0d0faab426b68$var$Ie($0af0d0faab426b68$var$Se, d) || ($0af0d0faab426b68$var$Se = d, d = $0af0d0faab426b68$var$oe($0af0d0faab426b68$var$Re, "onSelect"), 0 < d.length && (b = new $0af0d0faab426b68$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0af0d0faab426b68$var$Qe)));
}
function $0af0d0faab426b68$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0af0d0faab426b68$var$We = {
    animationend: $0af0d0faab426b68$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0af0d0faab426b68$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0af0d0faab426b68$var$Ve("Animation", "AnimationStart"),
    transitionend: $0af0d0faab426b68$var$Ve("Transition", "TransitionEnd")
}, $0af0d0faab426b68$var$Xe = {}, $0af0d0faab426b68$var$Ye = {};
$0af0d0faab426b68$var$ia && ($0af0d0faab426b68$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0af0d0faab426b68$var$We.animationend.animation, delete $0af0d0faab426b68$var$We.animationiteration.animation, delete $0af0d0faab426b68$var$We.animationstart.animation), "TransitionEvent" in window || delete $0af0d0faab426b68$var$We.transitionend.transition);
function $0af0d0faab426b68$var$Ze(a) {
    if ($0af0d0faab426b68$var$Xe[a]) return $0af0d0faab426b68$var$Xe[a];
    if (!$0af0d0faab426b68$var$We[a]) return a;
    var b = $0af0d0faab426b68$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0af0d0faab426b68$var$Ye) return $0af0d0faab426b68$var$Xe[a] = b[c];
    return a;
}
var $0af0d0faab426b68$var$$e = $0af0d0faab426b68$var$Ze("animationend"), $0af0d0faab426b68$var$af = $0af0d0faab426b68$var$Ze("animationiteration"), $0af0d0faab426b68$var$bf = $0af0d0faab426b68$var$Ze("animationstart"), $0af0d0faab426b68$var$cf = $0af0d0faab426b68$var$Ze("transitionend"), $0af0d0faab426b68$var$df = new Map, $0af0d0faab426b68$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0af0d0faab426b68$var$ff(a, b) {
    $0af0d0faab426b68$var$df.set(a, b);
    $0af0d0faab426b68$var$fa(b, [
        a
    ]);
}
for(var $0af0d0faab426b68$var$gf = 0; $0af0d0faab426b68$var$gf < $0af0d0faab426b68$var$ef.length; $0af0d0faab426b68$var$gf++){
    var $0af0d0faab426b68$var$hf = $0af0d0faab426b68$var$ef[$0af0d0faab426b68$var$gf], $0af0d0faab426b68$var$jf = $0af0d0faab426b68$var$hf.toLowerCase(), $0af0d0faab426b68$var$kf = $0af0d0faab426b68$var$hf[0].toUpperCase() + $0af0d0faab426b68$var$hf.slice(1);
    $0af0d0faab426b68$var$ff($0af0d0faab426b68$var$jf, "on" + $0af0d0faab426b68$var$kf);
}
$0af0d0faab426b68$var$ff($0af0d0faab426b68$var$$e, "onAnimationEnd");
$0af0d0faab426b68$var$ff($0af0d0faab426b68$var$af, "onAnimationIteration");
$0af0d0faab426b68$var$ff($0af0d0faab426b68$var$bf, "onAnimationStart");
$0af0d0faab426b68$var$ff("dblclick", "onDoubleClick");
$0af0d0faab426b68$var$ff("focusin", "onFocus");
$0af0d0faab426b68$var$ff("focusout", "onBlur");
$0af0d0faab426b68$var$ff($0af0d0faab426b68$var$cf, "onTransitionEnd");
$0af0d0faab426b68$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0af0d0faab426b68$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0af0d0faab426b68$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0af0d0faab426b68$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0af0d0faab426b68$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0af0d0faab426b68$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0af0d0faab426b68$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0af0d0faab426b68$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0af0d0faab426b68$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0af0d0faab426b68$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0af0d0faab426b68$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0af0d0faab426b68$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0af0d0faab426b68$var$lf));
function $0af0d0faab426b68$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0af0d0faab426b68$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0af0d0faab426b68$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0af0d0faab426b68$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0af0d0faab426b68$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0af0d0faab426b68$var$Qb) throw a = $0af0d0faab426b68$var$Rb, $0af0d0faab426b68$var$Qb = !1, $0af0d0faab426b68$var$Rb = null, a;
}
function $0af0d0faab426b68$var$D(a, b) {
    var c = b[$0af0d0faab426b68$var$of];
    void 0 === c && (c = b[$0af0d0faab426b68$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0af0d0faab426b68$var$pf(b, a, 2, !1), c.add(d));
}
function $0af0d0faab426b68$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0af0d0faab426b68$var$pf(c, a, d, b);
}
var $0af0d0faab426b68$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0af0d0faab426b68$var$sf(a) {
    if (!a[$0af0d0faab426b68$var$rf]) {
        a[$0af0d0faab426b68$var$rf] = !0;
        $0af0d0faab426b68$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0af0d0faab426b68$var$mf.has(b) || $0af0d0faab426b68$var$qf(b, !1, a), $0af0d0faab426b68$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0af0d0faab426b68$var$rf] || (b[$0af0d0faab426b68$var$rf] = !0, $0af0d0faab426b68$var$qf("selectionchange", !1, b));
    }
}
function $0af0d0faab426b68$var$pf(a, b, c, d) {
    switch($0af0d0faab426b68$var$jd(b)){
        case 1:
            var e = $0af0d0faab426b68$var$ed;
            break;
        case 4:
            e = $0af0d0faab426b68$var$gd;
            break;
        default:
            e = $0af0d0faab426b68$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0af0d0faab426b68$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0af0d0faab426b68$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0af0d0faab426b68$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0af0d0faab426b68$var$Jb(function() {
        var d = f, e = $0af0d0faab426b68$var$xb(c), g = [];
        a: {
            var h = $0af0d0faab426b68$var$df.get(a);
            if (void 0 !== h) {
                var k = $0af0d0faab426b68$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0af0d0faab426b68$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0af0d0faab426b68$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0af0d0faab426b68$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0af0d0faab426b68$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0af0d0faab426b68$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0af0d0faab426b68$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0af0d0faab426b68$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0af0d0faab426b68$var$Vd;
                        break;
                    case $0af0d0faab426b68$var$$e:
                    case $0af0d0faab426b68$var$af:
                    case $0af0d0faab426b68$var$bf:
                        k = $0af0d0faab426b68$var$Hd;
                        break;
                    case $0af0d0faab426b68$var$cf:
                        k = $0af0d0faab426b68$var$Xd;
                        break;
                    case "scroll":
                        k = $0af0d0faab426b68$var$vd;
                        break;
                    case "wheel":
                        k = $0af0d0faab426b68$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0af0d0faab426b68$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0af0d0faab426b68$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0af0d0faab426b68$var$Kb(w, x), null != F && t.push($0af0d0faab426b68$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0af0d0faab426b68$var$wb && (n = c.relatedTarget || c.fromElement) && ($0af0d0faab426b68$var$Wc(n) || n[$0af0d0faab426b68$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0af0d0faab426b68$var$Wc(n) : null, null !== n && (J = $0af0d0faab426b68$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0af0d0faab426b68$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0af0d0faab426b68$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0af0d0faab426b68$var$ue(k);
                        u = null == n ? h : $0af0d0faab426b68$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0af0d0faab426b68$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0af0d0faab426b68$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0af0d0faab426b68$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0af0d0faab426b68$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0af0d0faab426b68$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0af0d0faab426b68$var$vf(t);
                                x = $0af0d0faab426b68$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0af0d0faab426b68$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0af0d0faab426b68$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0af0d0faab426b68$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0af0d0faab426b68$var$ve;
                else if ($0af0d0faab426b68$var$me(h)) {
                    if ($0af0d0faab426b68$var$we) na = $0af0d0faab426b68$var$Fe;
                    else {
                        na = $0af0d0faab426b68$var$De;
                        var xa = $0af0d0faab426b68$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0af0d0faab426b68$var$Ee);
                if (na && (na = na(a, d))) {
                    $0af0d0faab426b68$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0af0d0faab426b68$var$cb(h, "number", h.value);
            }
            xa = d ? $0af0d0faab426b68$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0af0d0faab426b68$var$me(xa) || "true" === xa.contentEditable) $0af0d0faab426b68$var$Qe = xa, $0af0d0faab426b68$var$Re = d, $0af0d0faab426b68$var$Se = null;
                    break;
                case "focusout":
                    $0af0d0faab426b68$var$Se = $0af0d0faab426b68$var$Re = $0af0d0faab426b68$var$Qe = null;
                    break;
                case "mousedown":
                    $0af0d0faab426b68$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0af0d0faab426b68$var$Te = !1;
                    $0af0d0faab426b68$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0af0d0faab426b68$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0af0d0faab426b68$var$Ue(g, c, e);
            }
            var $a;
            if ($0af0d0faab426b68$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0af0d0faab426b68$var$ie ? $0af0d0faab426b68$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0af0d0faab426b68$var$de && "ko" !== c.locale && ($0af0d0faab426b68$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0af0d0faab426b68$var$ie && ($a = $0af0d0faab426b68$var$nd()) : ($0af0d0faab426b68$var$kd = e, $0af0d0faab426b68$var$ld = "value" in $0af0d0faab426b68$var$kd ? $0af0d0faab426b68$var$kd.value : $0af0d0faab426b68$var$kd.textContent, $0af0d0faab426b68$var$ie = !0)), xa = $0af0d0faab426b68$var$oe(d, ba), 0 < xa.length && (ba = new $0af0d0faab426b68$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0af0d0faab426b68$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0af0d0faab426b68$var$ce ? $0af0d0faab426b68$var$je(a, c) : $0af0d0faab426b68$var$ke(a, c)) d = $0af0d0faab426b68$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0af0d0faab426b68$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0af0d0faab426b68$var$se(g, b);
    });
}
function $0af0d0faab426b68$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0af0d0faab426b68$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0af0d0faab426b68$var$Kb(a, c), null != f && d.unshift($0af0d0faab426b68$var$tf(a, f, e)), f = $0af0d0faab426b68$var$Kb(a, b), null != f && d.push($0af0d0faab426b68$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0af0d0faab426b68$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0af0d0faab426b68$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0af0d0faab426b68$var$Kb(c, f), null != k && g.unshift($0af0d0faab426b68$var$tf(c, k, h))) : e || (k = $0af0d0faab426b68$var$Kb(c, f), null != k && g.push($0af0d0faab426b68$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0af0d0faab426b68$var$xf = /\r\n?/g, $0af0d0faab426b68$var$yf = /\u0000|\uFFFD/g;
function $0af0d0faab426b68$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0af0d0faab426b68$var$xf, "\n").replace($0af0d0faab426b68$var$yf, "");
}
function $0af0d0faab426b68$var$Af(a, b, c) {
    b = $0af0d0faab426b68$var$zf(b);
    if ($0af0d0faab426b68$var$zf(a) !== b && c) throw Error($0af0d0faab426b68$var$p(425));
}
function $0af0d0faab426b68$var$Bf() {}
var $0af0d0faab426b68$var$Cf = null, $0af0d0faab426b68$var$Df = null;
function $0af0d0faab426b68$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0af0d0faab426b68$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0af0d0faab426b68$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0af0d0faab426b68$var$Hf = "function" === typeof Promise ? Promise : void 0, $0af0d0faab426b68$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0af0d0faab426b68$var$Hf ? function(a) {
    return $0af0d0faab426b68$var$Hf.resolve(null).then(a).catch($0af0d0faab426b68$var$If);
} : $0af0d0faab426b68$var$Ff;
function $0af0d0faab426b68$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0af0d0faab426b68$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0af0d0faab426b68$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0af0d0faab426b68$var$bd(b);
}
function $0af0d0faab426b68$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0af0d0faab426b68$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0af0d0faab426b68$var$Nf = Math.random().toString(36).slice(2), $0af0d0faab426b68$var$Of = "__reactFiber$" + $0af0d0faab426b68$var$Nf, $0af0d0faab426b68$var$Pf = "__reactProps$" + $0af0d0faab426b68$var$Nf, $0af0d0faab426b68$var$uf = "__reactContainer$" + $0af0d0faab426b68$var$Nf, $0af0d0faab426b68$var$of = "__reactEvents$" + $0af0d0faab426b68$var$Nf, $0af0d0faab426b68$var$Qf = "__reactListeners$" + $0af0d0faab426b68$var$Nf, $0af0d0faab426b68$var$Rf = "__reactHandles$" + $0af0d0faab426b68$var$Nf;
function $0af0d0faab426b68$var$Wc(a) {
    var b = a[$0af0d0faab426b68$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0af0d0faab426b68$var$uf] || c[$0af0d0faab426b68$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0af0d0faab426b68$var$Mf(a); null !== a;){
                if (c = a[$0af0d0faab426b68$var$Of]) return c;
                a = $0af0d0faab426b68$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0af0d0faab426b68$var$Cb(a) {
    a = a[$0af0d0faab426b68$var$Of] || a[$0af0d0faab426b68$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0af0d0faab426b68$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0af0d0faab426b68$var$p(33));
}
function $0af0d0faab426b68$var$Db(a) {
    return a[$0af0d0faab426b68$var$Pf] || null;
}
var $0af0d0faab426b68$var$Sf = [], $0af0d0faab426b68$var$Tf = -1;
function $0af0d0faab426b68$var$Uf(a) {
    return {
        current: a
    };
}
function $0af0d0faab426b68$var$E(a) {
    0 > $0af0d0faab426b68$var$Tf || (a.current = $0af0d0faab426b68$var$Sf[$0af0d0faab426b68$var$Tf], $0af0d0faab426b68$var$Sf[$0af0d0faab426b68$var$Tf] = null, $0af0d0faab426b68$var$Tf--);
}
function $0af0d0faab426b68$var$G(a, b) {
    $0af0d0faab426b68$var$Tf++;
    $0af0d0faab426b68$var$Sf[$0af0d0faab426b68$var$Tf] = a.current;
    a.current = b;
}
var $0af0d0faab426b68$var$Vf = {}, $0af0d0faab426b68$var$H = $0af0d0faab426b68$var$Uf($0af0d0faab426b68$var$Vf), $0af0d0faab426b68$var$Wf = $0af0d0faab426b68$var$Uf(!1), $0af0d0faab426b68$var$Xf = $0af0d0faab426b68$var$Vf;
function $0af0d0faab426b68$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0af0d0faab426b68$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0af0d0faab426b68$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0af0d0faab426b68$var$$f() {
    $0af0d0faab426b68$var$E($0af0d0faab426b68$var$Wf);
    $0af0d0faab426b68$var$E($0af0d0faab426b68$var$H);
}
function $0af0d0faab426b68$var$ag(a, b, c) {
    if ($0af0d0faab426b68$var$H.current !== $0af0d0faab426b68$var$Vf) throw Error($0af0d0faab426b68$var$p(168));
    $0af0d0faab426b68$var$G($0af0d0faab426b68$var$H, b);
    $0af0d0faab426b68$var$G($0af0d0faab426b68$var$Wf, c);
}
function $0af0d0faab426b68$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0af0d0faab426b68$var$p(108, $0af0d0faab426b68$var$Ra(a) || "Unknown", e));
    return $0af0d0faab426b68$var$A({}, c, d);
}
function $0af0d0faab426b68$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0af0d0faab426b68$var$Vf;
    $0af0d0faab426b68$var$Xf = $0af0d0faab426b68$var$H.current;
    $0af0d0faab426b68$var$G($0af0d0faab426b68$var$H, a);
    $0af0d0faab426b68$var$G($0af0d0faab426b68$var$Wf, $0af0d0faab426b68$var$Wf.current);
    return !0;
}
function $0af0d0faab426b68$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0af0d0faab426b68$var$p(169));
    c ? (a = $0af0d0faab426b68$var$bg(a, b, $0af0d0faab426b68$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0af0d0faab426b68$var$E($0af0d0faab426b68$var$Wf), $0af0d0faab426b68$var$E($0af0d0faab426b68$var$H), $0af0d0faab426b68$var$G($0af0d0faab426b68$var$H, a)) : $0af0d0faab426b68$var$E($0af0d0faab426b68$var$Wf);
    $0af0d0faab426b68$var$G($0af0d0faab426b68$var$Wf, c);
}
var $0af0d0faab426b68$var$eg = null, $0af0d0faab426b68$var$fg = !1, $0af0d0faab426b68$var$gg = !1;
function $0af0d0faab426b68$var$hg(a) {
    null === $0af0d0faab426b68$var$eg ? $0af0d0faab426b68$var$eg = [
        a
    ] : $0af0d0faab426b68$var$eg.push(a);
}
function $0af0d0faab426b68$var$ig(a) {
    $0af0d0faab426b68$var$fg = !0;
    $0af0d0faab426b68$var$hg(a);
}
function $0af0d0faab426b68$var$jg() {
    if (!$0af0d0faab426b68$var$gg && null !== $0af0d0faab426b68$var$eg) {
        $0af0d0faab426b68$var$gg = !0;
        var a = 0, b = $0af0d0faab426b68$var$C;
        try {
            var c = $0af0d0faab426b68$var$eg;
            for($0af0d0faab426b68$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0af0d0faab426b68$var$eg = null;
            $0af0d0faab426b68$var$fg = !1;
        } catch (e) {
            throw null !== $0af0d0faab426b68$var$eg && ($0af0d0faab426b68$var$eg = $0af0d0faab426b68$var$eg.slice(a + 1)), $0af0d0faab426b68$var$ac($0af0d0faab426b68$var$fc, $0af0d0faab426b68$var$jg), e;
        } finally{
            $0af0d0faab426b68$var$C = b, $0af0d0faab426b68$var$gg = !1;
        }
    }
    return null;
}
var $0af0d0faab426b68$var$kg = [], $0af0d0faab426b68$var$lg = 0, $0af0d0faab426b68$var$mg = null, $0af0d0faab426b68$var$ng = 0, $0af0d0faab426b68$var$og = [], $0af0d0faab426b68$var$pg = 0, $0af0d0faab426b68$var$qg = null, $0af0d0faab426b68$var$rg = 1, $0af0d0faab426b68$var$sg = "";
function $0af0d0faab426b68$var$tg(a, b) {
    $0af0d0faab426b68$var$kg[$0af0d0faab426b68$var$lg++] = $0af0d0faab426b68$var$ng;
    $0af0d0faab426b68$var$kg[$0af0d0faab426b68$var$lg++] = $0af0d0faab426b68$var$mg;
    $0af0d0faab426b68$var$mg = a;
    $0af0d0faab426b68$var$ng = b;
}
function $0af0d0faab426b68$var$ug(a, b, c) {
    $0af0d0faab426b68$var$og[$0af0d0faab426b68$var$pg++] = $0af0d0faab426b68$var$rg;
    $0af0d0faab426b68$var$og[$0af0d0faab426b68$var$pg++] = $0af0d0faab426b68$var$sg;
    $0af0d0faab426b68$var$og[$0af0d0faab426b68$var$pg++] = $0af0d0faab426b68$var$qg;
    $0af0d0faab426b68$var$qg = a;
    var d = $0af0d0faab426b68$var$rg;
    a = $0af0d0faab426b68$var$sg;
    var e = 32 - $0af0d0faab426b68$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0af0d0faab426b68$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0af0d0faab426b68$var$rg = 1 << 32 - $0af0d0faab426b68$var$oc(b) + e | c << e | d;
        $0af0d0faab426b68$var$sg = f + a;
    } else $0af0d0faab426b68$var$rg = 1 << f | c << e | d, $0af0d0faab426b68$var$sg = a;
}
function $0af0d0faab426b68$var$vg(a) {
    null !== a.return && ($0af0d0faab426b68$var$tg(a, 1), $0af0d0faab426b68$var$ug(a, 1, 0));
}
function $0af0d0faab426b68$var$wg(a) {
    for(; a === $0af0d0faab426b68$var$mg;)$0af0d0faab426b68$var$mg = $0af0d0faab426b68$var$kg[--$0af0d0faab426b68$var$lg], $0af0d0faab426b68$var$kg[$0af0d0faab426b68$var$lg] = null, $0af0d0faab426b68$var$ng = $0af0d0faab426b68$var$kg[--$0af0d0faab426b68$var$lg], $0af0d0faab426b68$var$kg[$0af0d0faab426b68$var$lg] = null;
    for(; a === $0af0d0faab426b68$var$qg;)$0af0d0faab426b68$var$qg = $0af0d0faab426b68$var$og[--$0af0d0faab426b68$var$pg], $0af0d0faab426b68$var$og[$0af0d0faab426b68$var$pg] = null, $0af0d0faab426b68$var$sg = $0af0d0faab426b68$var$og[--$0af0d0faab426b68$var$pg], $0af0d0faab426b68$var$og[$0af0d0faab426b68$var$pg] = null, $0af0d0faab426b68$var$rg = $0af0d0faab426b68$var$og[--$0af0d0faab426b68$var$pg], $0af0d0faab426b68$var$og[$0af0d0faab426b68$var$pg] = null;
}
var $0af0d0faab426b68$var$xg = null, $0af0d0faab426b68$var$yg = null, $0af0d0faab426b68$var$I = !1, $0af0d0faab426b68$var$zg = null;
function $0af0d0faab426b68$var$Ag(a, b) {
    var c = $0af0d0faab426b68$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0af0d0faab426b68$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0af0d0faab426b68$var$xg = a, $0af0d0faab426b68$var$yg = $0af0d0faab426b68$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0af0d0faab426b68$var$xg = a, $0af0d0faab426b68$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0af0d0faab426b68$var$qg ? {
                id: $0af0d0faab426b68$var$rg,
                overflow: $0af0d0faab426b68$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0af0d0faab426b68$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0af0d0faab426b68$var$xg = a, $0af0d0faab426b68$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0af0d0faab426b68$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0af0d0faab426b68$var$Eg(a) {
    if ($0af0d0faab426b68$var$I) {
        var b = $0af0d0faab426b68$var$yg;
        if (b) {
            var c = b;
            if (!$0af0d0faab426b68$var$Cg(a, b)) {
                if ($0af0d0faab426b68$var$Dg(a)) throw Error($0af0d0faab426b68$var$p(418));
                b = $0af0d0faab426b68$var$Lf(c.nextSibling);
                var d = $0af0d0faab426b68$var$xg;
                b && $0af0d0faab426b68$var$Cg(a, b) ? $0af0d0faab426b68$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0af0d0faab426b68$var$I = !1, $0af0d0faab426b68$var$xg = a);
            }
        } else {
            if ($0af0d0faab426b68$var$Dg(a)) throw Error($0af0d0faab426b68$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0af0d0faab426b68$var$I = !1;
            $0af0d0faab426b68$var$xg = a;
        }
    }
}
function $0af0d0faab426b68$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0af0d0faab426b68$var$xg = a;
}
function $0af0d0faab426b68$var$Gg(a) {
    if (a !== $0af0d0faab426b68$var$xg) return !1;
    if (!$0af0d0faab426b68$var$I) return $0af0d0faab426b68$var$Fg(a), $0af0d0faab426b68$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0af0d0faab426b68$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0af0d0faab426b68$var$yg)) {
        if ($0af0d0faab426b68$var$Dg(a)) throw $0af0d0faab426b68$var$Hg(), Error($0af0d0faab426b68$var$p(418));
        for(; b;)$0af0d0faab426b68$var$Ag(a, b), b = $0af0d0faab426b68$var$Lf(b.nextSibling);
    }
    $0af0d0faab426b68$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0af0d0faab426b68$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0af0d0faab426b68$var$yg = $0af0d0faab426b68$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0af0d0faab426b68$var$yg = null;
        }
    } else $0af0d0faab426b68$var$yg = $0af0d0faab426b68$var$xg ? $0af0d0faab426b68$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0af0d0faab426b68$var$Hg() {
    for(var a = $0af0d0faab426b68$var$yg; a;)a = $0af0d0faab426b68$var$Lf(a.nextSibling);
}
function $0af0d0faab426b68$var$Ig() {
    $0af0d0faab426b68$var$yg = $0af0d0faab426b68$var$xg = null;
    $0af0d0faab426b68$var$I = !1;
}
function $0af0d0faab426b68$var$Jg(a) {
    null === $0af0d0faab426b68$var$zg ? $0af0d0faab426b68$var$zg = [
        a
    ] : $0af0d0faab426b68$var$zg.push(a);
}
var $0af0d0faab426b68$var$Kg = $0af0d0faab426b68$var$ua.ReactCurrentBatchConfig;
function $0af0d0faab426b68$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0af0d0faab426b68$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0af0d0faab426b68$var$Mg = $0af0d0faab426b68$var$Uf(null), $0af0d0faab426b68$var$Ng = null, $0af0d0faab426b68$var$Og = null, $0af0d0faab426b68$var$Pg = null;
function $0af0d0faab426b68$var$Qg() {
    $0af0d0faab426b68$var$Pg = $0af0d0faab426b68$var$Og = $0af0d0faab426b68$var$Ng = null;
}
function $0af0d0faab426b68$var$Rg(a) {
    var b = $0af0d0faab426b68$var$Mg.current;
    $0af0d0faab426b68$var$E($0af0d0faab426b68$var$Mg);
    a._currentValue = b;
}
function $0af0d0faab426b68$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0af0d0faab426b68$var$Tg(a, b) {
    $0af0d0faab426b68$var$Ng = a;
    $0af0d0faab426b68$var$Pg = $0af0d0faab426b68$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0af0d0faab426b68$var$Ug = !0), a.firstContext = null);
}
function $0af0d0faab426b68$var$Vg(a) {
    var b = a._currentValue;
    if ($0af0d0faab426b68$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0af0d0faab426b68$var$Og) {
            if (null === $0af0d0faab426b68$var$Ng) throw Error($0af0d0faab426b68$var$p(308));
            $0af0d0faab426b68$var$Og = a;
            $0af0d0faab426b68$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0af0d0faab426b68$var$Og = $0af0d0faab426b68$var$Og.next = a;
    }
    return b;
}
var $0af0d0faab426b68$var$Wg = null;
function $0af0d0faab426b68$var$Xg(a) {
    null === $0af0d0faab426b68$var$Wg ? $0af0d0faab426b68$var$Wg = [
        a
    ] : $0af0d0faab426b68$var$Wg.push(a);
}
function $0af0d0faab426b68$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0af0d0faab426b68$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0af0d0faab426b68$var$Zg(a, d);
}
function $0af0d0faab426b68$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0af0d0faab426b68$var$$g = !1;
function $0af0d0faab426b68$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0af0d0faab426b68$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0af0d0faab426b68$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0af0d0faab426b68$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0af0d0faab426b68$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0af0d0faab426b68$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0af0d0faab426b68$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0af0d0faab426b68$var$Zg(a, c);
}
function $0af0d0faab426b68$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0af0d0faab426b68$var$Cc(a, c);
    }
}
function $0af0d0faab426b68$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0af0d0faab426b68$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0af0d0faab426b68$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0af0d0faab426b68$var$A({}, q, r);
                            break a;
                        case 2:
                            $0af0d0faab426b68$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0af0d0faab426b68$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0af0d0faab426b68$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0af0d0faab426b68$var$p(191, e));
            e.call(d);
        }
    }
}
var $0af0d0faab426b68$var$jh = (new $8T3gX.Component).refs;
function $0af0d0faab426b68$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0af0d0faab426b68$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0af0d0faab426b68$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0af0d0faab426b68$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0af0d0faab426b68$var$L(), e = $0af0d0faab426b68$var$lh(a), f = $0af0d0faab426b68$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0af0d0faab426b68$var$dh(a, f, e);
        null !== b && ($0af0d0faab426b68$var$mh(b, a, e, d), $0af0d0faab426b68$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0af0d0faab426b68$var$L(), e = $0af0d0faab426b68$var$lh(a), f = $0af0d0faab426b68$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0af0d0faab426b68$var$dh(a, f, e);
        null !== b && ($0af0d0faab426b68$var$mh(b, a, e, d), $0af0d0faab426b68$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0af0d0faab426b68$var$L(), d = $0af0d0faab426b68$var$lh(a), e = $0af0d0faab426b68$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0af0d0faab426b68$var$dh(a, e, d);
        null !== b && ($0af0d0faab426b68$var$mh(b, a, d, c), $0af0d0faab426b68$var$eh(b, a, d));
    }
};
function $0af0d0faab426b68$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0af0d0faab426b68$var$Ie(c, d) || !$0af0d0faab426b68$var$Ie(e, f) : !0;
}
function $0af0d0faab426b68$var$ph(a, b, c) {
    var d = !1, e = $0af0d0faab426b68$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0af0d0faab426b68$var$Vg(f) : (e = $0af0d0faab426b68$var$Zf(b) ? $0af0d0faab426b68$var$Xf : $0af0d0faab426b68$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0af0d0faab426b68$var$Yf(a, e) : $0af0d0faab426b68$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0af0d0faab426b68$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0af0d0faab426b68$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0af0d0faab426b68$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0af0d0faab426b68$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0af0d0faab426b68$var$jh;
    $0af0d0faab426b68$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0af0d0faab426b68$var$Vg(f) : (f = $0af0d0faab426b68$var$Zf(b) ? $0af0d0faab426b68$var$Xf : $0af0d0faab426b68$var$H.current, e.context = $0af0d0faab426b68$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0af0d0faab426b68$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0af0d0faab426b68$var$nh.enqueueReplaceState(e, e.state, null), $0af0d0faab426b68$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0af0d0faab426b68$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0af0d0faab426b68$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0af0d0faab426b68$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0af0d0faab426b68$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0af0d0faab426b68$var$p(284));
        if (!c._owner) throw Error($0af0d0faab426b68$var$p(290, a));
    }
    return a;
}
function $0af0d0faab426b68$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0af0d0faab426b68$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0af0d0faab426b68$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0af0d0faab426b68$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0af0d0faab426b68$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0af0d0faab426b68$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0af0d0faab426b68$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0af0d0faab426b68$var$Ha && $0af0d0faab426b68$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0af0d0faab426b68$var$sh(a, b, c), d.return = a, d;
        d = $0af0d0faab426b68$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0af0d0faab426b68$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0af0d0faab426b68$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0af0d0faab426b68$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0af0d0faab426b68$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0af0d0faab426b68$var$va:
                    return c = $0af0d0faab426b68$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0af0d0faab426b68$var$sh(a, null, b), c.return = a, c;
                case $0af0d0faab426b68$var$wa:
                    return b = $0af0d0faab426b68$var$zh(b, a.mode, c), b.return = a, b;
                case $0af0d0faab426b68$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0af0d0faab426b68$var$eb(b) || $0af0d0faab426b68$var$Ka(b)) return b = $0af0d0faab426b68$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0af0d0faab426b68$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0af0d0faab426b68$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0af0d0faab426b68$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0af0d0faab426b68$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0af0d0faab426b68$var$eb(c) || $0af0d0faab426b68$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0af0d0faab426b68$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0af0d0faab426b68$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0af0d0faab426b68$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0af0d0faab426b68$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0af0d0faab426b68$var$eb(d) || $0af0d0faab426b68$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0af0d0faab426b68$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0af0d0faab426b68$var$I && $0af0d0faab426b68$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0af0d0faab426b68$var$I && $0af0d0faab426b68$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0af0d0faab426b68$var$I && $0af0d0faab426b68$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0af0d0faab426b68$var$Ka(h);
        if ("function" !== typeof l) throw Error($0af0d0faab426b68$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0af0d0faab426b68$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0af0d0faab426b68$var$I && $0af0d0faab426b68$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0af0d0faab426b68$var$I && $0af0d0faab426b68$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0af0d0faab426b68$var$I && $0af0d0faab426b68$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0af0d0faab426b68$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0af0d0faab426b68$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0af0d0faab426b68$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0af0d0faab426b68$var$Ha && $0af0d0faab426b68$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0af0d0faab426b68$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0af0d0faab426b68$var$ya ? (d = $0af0d0faab426b68$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0af0d0faab426b68$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0af0d0faab426b68$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0af0d0faab426b68$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0af0d0faab426b68$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0af0d0faab426b68$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0af0d0faab426b68$var$eb(f)) return n(a, d, f, h);
            if ($0af0d0faab426b68$var$Ka(f)) return t(a, d, f, h);
            $0af0d0faab426b68$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0af0d0faab426b68$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0af0d0faab426b68$var$Bh = $0af0d0faab426b68$var$vh(!0), $0af0d0faab426b68$var$Ch = $0af0d0faab426b68$var$vh(!1), $0af0d0faab426b68$var$Dh = {}, $0af0d0faab426b68$var$Eh = $0af0d0faab426b68$var$Uf($0af0d0faab426b68$var$Dh), $0af0d0faab426b68$var$Fh = $0af0d0faab426b68$var$Uf($0af0d0faab426b68$var$Dh), $0af0d0faab426b68$var$Gh = $0af0d0faab426b68$var$Uf($0af0d0faab426b68$var$Dh);
function $0af0d0faab426b68$var$Hh(a) {
    if (a === $0af0d0faab426b68$var$Dh) throw Error($0af0d0faab426b68$var$p(174));
    return a;
}
function $0af0d0faab426b68$var$Ih(a, b) {
    $0af0d0faab426b68$var$G($0af0d0faab426b68$var$Gh, b);
    $0af0d0faab426b68$var$G($0af0d0faab426b68$var$Fh, a);
    $0af0d0faab426b68$var$G($0af0d0faab426b68$var$Eh, $0af0d0faab426b68$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0af0d0faab426b68$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0af0d0faab426b68$var$lb(b, a);
    }
    $0af0d0faab426b68$var$E($0af0d0faab426b68$var$Eh);
    $0af0d0faab426b68$var$G($0af0d0faab426b68$var$Eh, b);
}
function $0af0d0faab426b68$var$Jh() {
    $0af0d0faab426b68$var$E($0af0d0faab426b68$var$Eh);
    $0af0d0faab426b68$var$E($0af0d0faab426b68$var$Fh);
    $0af0d0faab426b68$var$E($0af0d0faab426b68$var$Gh);
}
function $0af0d0faab426b68$var$Kh(a) {
    $0af0d0faab426b68$var$Hh($0af0d0faab426b68$var$Gh.current);
    var b = $0af0d0faab426b68$var$Hh($0af0d0faab426b68$var$Eh.current);
    var c = $0af0d0faab426b68$var$lb(b, a.type);
    b !== c && ($0af0d0faab426b68$var$G($0af0d0faab426b68$var$Fh, a), $0af0d0faab426b68$var$G($0af0d0faab426b68$var$Eh, c));
}
function $0af0d0faab426b68$var$Lh(a) {
    $0af0d0faab426b68$var$Fh.current === a && ($0af0d0faab426b68$var$E($0af0d0faab426b68$var$Eh), $0af0d0faab426b68$var$E($0af0d0faab426b68$var$Fh));
}
var $0af0d0faab426b68$var$M = $0af0d0faab426b68$var$Uf(0);
function $0af0d0faab426b68$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0af0d0faab426b68$var$Nh = [];
function $0af0d0faab426b68$var$Oh() {
    for(var a = 0; a < $0af0d0faab426b68$var$Nh.length; a++)$0af0d0faab426b68$var$Nh[a]._workInProgressVersionPrimary = null;
    $0af0d0faab426b68$var$Nh.length = 0;
}
var $0af0d0faab426b68$var$Ph = $0af0d0faab426b68$var$ua.ReactCurrentDispatcher, $0af0d0faab426b68$var$Qh = $0af0d0faab426b68$var$ua.ReactCurrentBatchConfig, $0af0d0faab426b68$var$Rh = 0, $0af0d0faab426b68$var$N = null, $0af0d0faab426b68$var$O = null, $0af0d0faab426b68$var$P = null, $0af0d0faab426b68$var$Sh = !1, $0af0d0faab426b68$var$Th = !1, $0af0d0faab426b68$var$Uh = 0, $0af0d0faab426b68$var$Vh = 0;
function $0af0d0faab426b68$var$Q() {
    throw Error($0af0d0faab426b68$var$p(321));
}
function $0af0d0faab426b68$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0af0d0faab426b68$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0af0d0faab426b68$var$Xh(a, b, c, d, e, f) {
    $0af0d0faab426b68$var$Rh = f;
    $0af0d0faab426b68$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0af0d0faab426b68$var$Ph.current = null === a || null === a.memoizedState ? $0af0d0faab426b68$var$Yh : $0af0d0faab426b68$var$Zh;
    a = c(d, e);
    if ($0af0d0faab426b68$var$Th) {
        f = 0;
        do {
            $0af0d0faab426b68$var$Th = !1;
            $0af0d0faab426b68$var$Uh = 0;
            if (25 <= f) throw Error($0af0d0faab426b68$var$p(301));
            f += 1;
            $0af0d0faab426b68$var$P = $0af0d0faab426b68$var$O = null;
            b.updateQueue = null;
            $0af0d0faab426b68$var$Ph.current = $0af0d0faab426b68$var$$h;
            a = c(d, e);
        }while ($0af0d0faab426b68$var$Th);
    }
    $0af0d0faab426b68$var$Ph.current = $0af0d0faab426b68$var$ai;
    b = null !== $0af0d0faab426b68$var$O && null !== $0af0d0faab426b68$var$O.next;
    $0af0d0faab426b68$var$Rh = 0;
    $0af0d0faab426b68$var$P = $0af0d0faab426b68$var$O = $0af0d0faab426b68$var$N = null;
    $0af0d0faab426b68$var$Sh = !1;
    if (b) throw Error($0af0d0faab426b68$var$p(300));
    return a;
}
function $0af0d0faab426b68$var$bi() {
    var a = 0 !== $0af0d0faab426b68$var$Uh;
    $0af0d0faab426b68$var$Uh = 0;
    return a;
}
function $0af0d0faab426b68$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0af0d0faab426b68$var$P ? $0af0d0faab426b68$var$N.memoizedState = $0af0d0faab426b68$var$P = a : $0af0d0faab426b68$var$P = $0af0d0faab426b68$var$P.next = a;
    return $0af0d0faab426b68$var$P;
}
function $0af0d0faab426b68$var$di() {
    if (null === $0af0d0faab426b68$var$O) {
        var a = $0af0d0faab426b68$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0af0d0faab426b68$var$O.next;
    var b = null === $0af0d0faab426b68$var$P ? $0af0d0faab426b68$var$N.memoizedState : $0af0d0faab426b68$var$P.next;
    if (null !== b) $0af0d0faab426b68$var$P = b, $0af0d0faab426b68$var$O = a;
    else {
        if (null === a) throw Error($0af0d0faab426b68$var$p(310));
        $0af0d0faab426b68$var$O = a;
        a = {
            memoizedState: $0af0d0faab426b68$var$O.memoizedState,
            baseState: $0af0d0faab426b68$var$O.baseState,
            baseQueue: $0af0d0faab426b68$var$O.baseQueue,
            queue: $0af0d0faab426b68$var$O.queue,
            next: null
        };
        null === $0af0d0faab426b68$var$P ? $0af0d0faab426b68$var$N.memoizedState = $0af0d0faab426b68$var$P = a : $0af0d0faab426b68$var$P = $0af0d0faab426b68$var$P.next = a;
    }
    return $0af0d0faab426b68$var$P;
}
function $0af0d0faab426b68$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0af0d0faab426b68$var$fi(a) {
    var b = $0af0d0faab426b68$var$di(), c = b.queue;
    if (null === c) throw Error($0af0d0faab426b68$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0af0d0faab426b68$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0af0d0faab426b68$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0af0d0faab426b68$var$N.lanes |= m;
                $0af0d0faab426b68$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0af0d0faab426b68$var$He(d, b.memoizedState) || ($0af0d0faab426b68$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0af0d0faab426b68$var$N.lanes |= f, $0af0d0faab426b68$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0af0d0faab426b68$var$gi(a) {
    var b = $0af0d0faab426b68$var$di(), c = b.queue;
    if (null === c) throw Error($0af0d0faab426b68$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0af0d0faab426b68$var$He(f, b.memoizedState) || ($0af0d0faab426b68$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0af0d0faab426b68$var$hi() {}
function $0af0d0faab426b68$var$ii(a, b) {
    var c = $0af0d0faab426b68$var$N, d = $0af0d0faab426b68$var$di(), e = b(), f = !$0af0d0faab426b68$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0af0d0faab426b68$var$Ug = !0);
    d = d.queue;
    $0af0d0faab426b68$var$ji($0af0d0faab426b68$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0af0d0faab426b68$var$P && $0af0d0faab426b68$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0af0d0faab426b68$var$li(9, $0af0d0faab426b68$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0af0d0faab426b68$var$R) throw Error($0af0d0faab426b68$var$p(349));
        0 !== ($0af0d0faab426b68$var$Rh & 30) || $0af0d0faab426b68$var$ni(c, b, e);
    }
    return e;
}
function $0af0d0faab426b68$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0af0d0faab426b68$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0af0d0faab426b68$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0af0d0faab426b68$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0af0d0faab426b68$var$oi(b) && $0af0d0faab426b68$var$pi(a);
}
function $0af0d0faab426b68$var$ki(a, b, c) {
    return c(function() {
        $0af0d0faab426b68$var$oi(b) && $0af0d0faab426b68$var$pi(a);
    });
}
function $0af0d0faab426b68$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0af0d0faab426b68$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0af0d0faab426b68$var$pi(a) {
    var b = $0af0d0faab426b68$var$Zg(a, 1);
    null !== b && $0af0d0faab426b68$var$mh(b, a, 1, -1);
}
function $0af0d0faab426b68$var$qi(a) {
    var b = $0af0d0faab426b68$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0af0d0faab426b68$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0af0d0faab426b68$var$ri.bind(null, $0af0d0faab426b68$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0af0d0faab426b68$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0af0d0faab426b68$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0af0d0faab426b68$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0af0d0faab426b68$var$si() {
    return $0af0d0faab426b68$var$di().memoizedState;
}
function $0af0d0faab426b68$var$ti(a, b, c, d) {
    var e = $0af0d0faab426b68$var$ci();
    $0af0d0faab426b68$var$N.flags |= a;
    e.memoizedState = $0af0d0faab426b68$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0af0d0faab426b68$var$ui(a, b, c, d) {
    var e = $0af0d0faab426b68$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0af0d0faab426b68$var$O) {
        var g = $0af0d0faab426b68$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0af0d0faab426b68$var$Wh(d, g.deps)) {
            e.memoizedState = $0af0d0faab426b68$var$li(b, c, f, d);
            return;
        }
    }
    $0af0d0faab426b68$var$N.flags |= a;
    e.memoizedState = $0af0d0faab426b68$var$li(1 | b, c, f, d);
}
function $0af0d0faab426b68$var$vi(a, b) {
    return $0af0d0faab426b68$var$ti(8390656, 8, a, b);
}
function $0af0d0faab426b68$var$ji(a, b) {
    return $0af0d0faab426b68$var$ui(2048, 8, a, b);
}
function $0af0d0faab426b68$var$wi(a, b) {
    return $0af0d0faab426b68$var$ui(4, 2, a, b);
}
function $0af0d0faab426b68$var$xi(a, b) {
    return $0af0d0faab426b68$var$ui(4, 4, a, b);
}
function $0af0d0faab426b68$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0af0d0faab426b68$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0af0d0faab426b68$var$ui(4, 4, $0af0d0faab426b68$var$yi.bind(null, b, a), c);
}
function $0af0d0faab426b68$var$Ai() {}
function $0af0d0faab426b68$var$Bi(a, b) {
    var c = $0af0d0faab426b68$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0af0d0faab426b68$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0af0d0faab426b68$var$Ci(a, b) {
    var c = $0af0d0faab426b68$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0af0d0faab426b68$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0af0d0faab426b68$var$Di(a, b, c) {
    if (0 === ($0af0d0faab426b68$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0af0d0faab426b68$var$Ug = !0), a.memoizedState = c;
    $0af0d0faab426b68$var$He(c, b) || (c = $0af0d0faab426b68$var$yc(), $0af0d0faab426b68$var$N.lanes |= c, $0af0d0faab426b68$var$hh |= c, a.baseState = !0);
    return b;
}
function $0af0d0faab426b68$var$Ei(a, b) {
    var c = $0af0d0faab426b68$var$C;
    $0af0d0faab426b68$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0af0d0faab426b68$var$Qh.transition;
    $0af0d0faab426b68$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0af0d0faab426b68$var$C = c, $0af0d0faab426b68$var$Qh.transition = d;
    }
}
function $0af0d0faab426b68$var$Fi() {
    return $0af0d0faab426b68$var$di().memoizedState;
}
function $0af0d0faab426b68$var$Gi(a, b, c) {
    var d = $0af0d0faab426b68$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0af0d0faab426b68$var$Hi(a)) $0af0d0faab426b68$var$Ii(b, c);
    else if (c = $0af0d0faab426b68$var$Yg(a, b, c, d), null !== c) {
        var e = $0af0d0faab426b68$var$L();
        $0af0d0faab426b68$var$mh(c, a, d, e);
        $0af0d0faab426b68$var$Ji(c, b, d);
    }
}
function $0af0d0faab426b68$var$ri(a, b, c) {
    var d = $0af0d0faab426b68$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0af0d0faab426b68$var$Hi(a)) $0af0d0faab426b68$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0af0d0faab426b68$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0af0d0faab426b68$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0af0d0faab426b68$var$Yg(a, b, e, d);
        null !== c && (e = $0af0d0faab426b68$var$L(), $0af0d0faab426b68$var$mh(c, a, d, e), $0af0d0faab426b68$var$Ji(c, b, d));
    }
}
function $0af0d0faab426b68$var$Hi(a) {
    var b = a.alternate;
    return a === $0af0d0faab426b68$var$N || null !== b && b === $0af0d0faab426b68$var$N;
}
function $0af0d0faab426b68$var$Ii(a, b) {
    $0af0d0faab426b68$var$Th = $0af0d0faab426b68$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0af0d0faab426b68$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0af0d0faab426b68$var$Cc(a, c);
    }
}
var $0af0d0faab426b68$var$ai = {
    readContext: $0af0d0faab426b68$var$Vg,
    useCallback: $0af0d0faab426b68$var$Q,
    useContext: $0af0d0faab426b68$var$Q,
    useEffect: $0af0d0faab426b68$var$Q,
    useImperativeHandle: $0af0d0faab426b68$var$Q,
    useInsertionEffect: $0af0d0faab426b68$var$Q,
    useLayoutEffect: $0af0d0faab426b68$var$Q,
    useMemo: $0af0d0faab426b68$var$Q,
    useReducer: $0af0d0faab426b68$var$Q,
    useRef: $0af0d0faab426b68$var$Q,
    useState: $0af0d0faab426b68$var$Q,
    useDebugValue: $0af0d0faab426b68$var$Q,
    useDeferredValue: $0af0d0faab426b68$var$Q,
    useTransition: $0af0d0faab426b68$var$Q,
    useMutableSource: $0af0d0faab426b68$var$Q,
    useSyncExternalStore: $0af0d0faab426b68$var$Q,
    useId: $0af0d0faab426b68$var$Q,
    unstable_isNewReconciler: !1
}, $0af0d0faab426b68$var$Yh = {
    readContext: $0af0d0faab426b68$var$Vg,
    useCallback: function(a, b) {
        $0af0d0faab426b68$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0af0d0faab426b68$var$Vg,
    useEffect: $0af0d0faab426b68$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0af0d0faab426b68$var$ti(4194308, 4, $0af0d0faab426b68$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0af0d0faab426b68$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0af0d0faab426b68$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0af0d0faab426b68$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0af0d0faab426b68$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0af0d0faab426b68$var$Gi.bind(null, $0af0d0faab426b68$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0af0d0faab426b68$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0af0d0faab426b68$var$qi,
    useDebugValue: $0af0d0faab426b68$var$Ai,
    useDeferredValue: function(a) {
        return $0af0d0faab426b68$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0af0d0faab426b68$var$qi(!1), b = a[0];
        a = $0af0d0faab426b68$var$Ei.bind(null, a[1]);
        $0af0d0faab426b68$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0af0d0faab426b68$var$N, e = $0af0d0faab426b68$var$ci();
        if ($0af0d0faab426b68$var$I) {
            if (void 0 === c) throw Error($0af0d0faab426b68$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0af0d0faab426b68$var$R) throw Error($0af0d0faab426b68$var$p(349));
            0 !== ($0af0d0faab426b68$var$Rh & 30) || $0af0d0faab426b68$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0af0d0faab426b68$var$vi($0af0d0faab426b68$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0af0d0faab426b68$var$li(9, $0af0d0faab426b68$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0af0d0faab426b68$var$ci(), b = $0af0d0faab426b68$var$R.identifierPrefix;
        if ($0af0d0faab426b68$var$I) {
            var c = $0af0d0faab426b68$var$sg;
            var d = $0af0d0faab426b68$var$rg;
            c = (d & ~(1 << 32 - $0af0d0faab426b68$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0af0d0faab426b68$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0af0d0faab426b68$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0af0d0faab426b68$var$Zh = {
    readContext: $0af0d0faab426b68$var$Vg,
    useCallback: $0af0d0faab426b68$var$Bi,
    useContext: $0af0d0faab426b68$var$Vg,
    useEffect: $0af0d0faab426b68$var$ji,
    useImperativeHandle: $0af0d0faab426b68$var$zi,
    useInsertionEffect: $0af0d0faab426b68$var$wi,
    useLayoutEffect: $0af0d0faab426b68$var$xi,
    useMemo: $0af0d0faab426b68$var$Ci,
    useReducer: $0af0d0faab426b68$var$fi,
    useRef: $0af0d0faab426b68$var$si,
    useState: function() {
        return $0af0d0faab426b68$var$fi($0af0d0faab426b68$var$ei);
    },
    useDebugValue: $0af0d0faab426b68$var$Ai,
    useDeferredValue: function(a) {
        var b = $0af0d0faab426b68$var$di();
        return $0af0d0faab426b68$var$Di(b, $0af0d0faab426b68$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0af0d0faab426b68$var$fi($0af0d0faab426b68$var$ei)[0], b = $0af0d0faab426b68$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0af0d0faab426b68$var$hi,
    useSyncExternalStore: $0af0d0faab426b68$var$ii,
    useId: $0af0d0faab426b68$var$Fi,
    unstable_isNewReconciler: !1
}, $0af0d0faab426b68$var$$h = {
    readContext: $0af0d0faab426b68$var$Vg,
    useCallback: $0af0d0faab426b68$var$Bi,
    useContext: $0af0d0faab426b68$var$Vg,
    useEffect: $0af0d0faab426b68$var$ji,
    useImperativeHandle: $0af0d0faab426b68$var$zi,
    useInsertionEffect: $0af0d0faab426b68$var$wi,
    useLayoutEffect: $0af0d0faab426b68$var$xi,
    useMemo: $0af0d0faab426b68$var$Ci,
    useReducer: $0af0d0faab426b68$var$gi,
    useRef: $0af0d0faab426b68$var$si,
    useState: function() {
        return $0af0d0faab426b68$var$gi($0af0d0faab426b68$var$ei);
    },
    useDebugValue: $0af0d0faab426b68$var$Ai,
    useDeferredValue: function(a) {
        var b = $0af0d0faab426b68$var$di();
        return null === $0af0d0faab426b68$var$O ? b.memoizedState = a : $0af0d0faab426b68$var$Di(b, $0af0d0faab426b68$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0af0d0faab426b68$var$gi($0af0d0faab426b68$var$ei)[0], b = $0af0d0faab426b68$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0af0d0faab426b68$var$hi,
    useSyncExternalStore: $0af0d0faab426b68$var$ii,
    useId: $0af0d0faab426b68$var$Fi,
    unstable_isNewReconciler: !1
};
function $0af0d0faab426b68$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0af0d0faab426b68$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0af0d0faab426b68$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0af0d0faab426b68$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0af0d0faab426b68$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0af0d0faab426b68$var$Oi(a, b, c) {
    c = $0af0d0faab426b68$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0af0d0faab426b68$var$Pi || ($0af0d0faab426b68$var$Pi = !0, $0af0d0faab426b68$var$Qi = d);
        $0af0d0faab426b68$var$Mi(a, b);
    };
    return c;
}
function $0af0d0faab426b68$var$Ri(a, b, c) {
    c = $0af0d0faab426b68$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0af0d0faab426b68$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0af0d0faab426b68$var$Mi(a, b);
        "function" !== typeof d && (null === $0af0d0faab426b68$var$Si ? $0af0d0faab426b68$var$Si = new Set([
            this
        ]) : $0af0d0faab426b68$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0af0d0faab426b68$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0af0d0faab426b68$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0af0d0faab426b68$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0af0d0faab426b68$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0af0d0faab426b68$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0af0d0faab426b68$var$ch(-1, 1), b.tag = 2, $0af0d0faab426b68$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0af0d0faab426b68$var$Xi = $0af0d0faab426b68$var$ua.ReactCurrentOwner, $0af0d0faab426b68$var$Ug = !1;
function $0af0d0faab426b68$var$Yi(a, b, c, d) {
    b.child = null === a ? $0af0d0faab426b68$var$Ch(b, null, c, d) : $0af0d0faab426b68$var$Bh(b, a.child, c, d);
}
function $0af0d0faab426b68$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0af0d0faab426b68$var$Tg(b, e);
    d = $0af0d0faab426b68$var$Xh(a, b, c, d, f, e);
    c = $0af0d0faab426b68$var$bi();
    if (null !== a && !$0af0d0faab426b68$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0af0d0faab426b68$var$$i(a, b, e);
    $0af0d0faab426b68$var$I && c && $0af0d0faab426b68$var$vg(b);
    b.flags |= 1;
    $0af0d0faab426b68$var$Yi(a, b, d, e);
    return b.child;
}
function $0af0d0faab426b68$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0af0d0faab426b68$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0af0d0faab426b68$var$cj(a, b, f, d, e);
        a = $0af0d0faab426b68$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0af0d0faab426b68$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0af0d0faab426b68$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0af0d0faab426b68$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0af0d0faab426b68$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0af0d0faab426b68$var$Ie(f, d) && a.ref === b.ref) {
            if ($0af0d0faab426b68$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0af0d0faab426b68$var$Ug = !0);
            else return b.lanes = a.lanes, $0af0d0faab426b68$var$$i(a, b, e);
        }
    }
    return $0af0d0faab426b68$var$dj(a, b, c, d, e);
}
function $0af0d0faab426b68$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0af0d0faab426b68$var$G($0af0d0faab426b68$var$fj, $0af0d0faab426b68$var$gj), $0af0d0faab426b68$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0af0d0faab426b68$var$G($0af0d0faab426b68$var$fj, $0af0d0faab426b68$var$gj), $0af0d0faab426b68$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0af0d0faab426b68$var$G($0af0d0faab426b68$var$fj, $0af0d0faab426b68$var$gj);
            $0af0d0faab426b68$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0af0d0faab426b68$var$G($0af0d0faab426b68$var$fj, $0af0d0faab426b68$var$gj), $0af0d0faab426b68$var$gj |= d;
    $0af0d0faab426b68$var$Yi(a, b, e, c);
    return b.child;
}
function $0af0d0faab426b68$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0af0d0faab426b68$var$dj(a, b, c, d, e) {
    var f = $0af0d0faab426b68$var$Zf(c) ? $0af0d0faab426b68$var$Xf : $0af0d0faab426b68$var$H.current;
    f = $0af0d0faab426b68$var$Yf(b, f);
    $0af0d0faab426b68$var$Tg(b, e);
    c = $0af0d0faab426b68$var$Xh(a, b, c, d, f, e);
    d = $0af0d0faab426b68$var$bi();
    if (null !== a && !$0af0d0faab426b68$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0af0d0faab426b68$var$$i(a, b, e);
    $0af0d0faab426b68$var$I && d && $0af0d0faab426b68$var$vg(b);
    b.flags |= 1;
    $0af0d0faab426b68$var$Yi(a, b, c, e);
    return b.child;
}
function $0af0d0faab426b68$var$ij(a, b, c, d, e) {
    if ($0af0d0faab426b68$var$Zf(c)) {
        var f = !0;
        $0af0d0faab426b68$var$cg(b);
    } else f = !1;
    $0af0d0faab426b68$var$Tg(b, e);
    if (null === b.stateNode) $0af0d0faab426b68$var$jj(a, b), $0af0d0faab426b68$var$ph(b, c, d), $0af0d0faab426b68$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0af0d0faab426b68$var$Vg(l) : (l = $0af0d0faab426b68$var$Zf(c) ? $0af0d0faab426b68$var$Xf : $0af0d0faab426b68$var$H.current, l = $0af0d0faab426b68$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0af0d0faab426b68$var$qh(b, g, d, l);
        $0af0d0faab426b68$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0af0d0faab426b68$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0af0d0faab426b68$var$Wf.current || $0af0d0faab426b68$var$$g ? ("function" === typeof m && ($0af0d0faab426b68$var$kh(b, c, m, d), k = b.memoizedState), (h = $0af0d0faab426b68$var$$g || $0af0d0faab426b68$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0af0d0faab426b68$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0af0d0faab426b68$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0af0d0faab426b68$var$Vg(k) : (k = $0af0d0faab426b68$var$Zf(c) ? $0af0d0faab426b68$var$Xf : $0af0d0faab426b68$var$H.current, k = $0af0d0faab426b68$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0af0d0faab426b68$var$qh(b, g, d, k);
        $0af0d0faab426b68$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0af0d0faab426b68$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0af0d0faab426b68$var$Wf.current || $0af0d0faab426b68$var$$g ? ("function" === typeof y && ($0af0d0faab426b68$var$kh(b, c, y, d), n = b.memoizedState), (l = $0af0d0faab426b68$var$$g || $0af0d0faab426b68$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0af0d0faab426b68$var$kj(a, b, c, d, f, e);
}
function $0af0d0faab426b68$var$kj(a, b, c, d, e, f) {
    $0af0d0faab426b68$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0af0d0faab426b68$var$dg(b, c, !1), $0af0d0faab426b68$var$$i(a, b, f);
    d = b.stateNode;
    $0af0d0faab426b68$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0af0d0faab426b68$var$Bh(b, a.child, null, f), b.child = $0af0d0faab426b68$var$Bh(b, null, h, f)) : $0af0d0faab426b68$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0af0d0faab426b68$var$dg(b, c, !0);
    return b.child;
}
function $0af0d0faab426b68$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0af0d0faab426b68$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0af0d0faab426b68$var$ag(a, b.context, !1);
    $0af0d0faab426b68$var$Ih(a, b.containerInfo);
}
function $0af0d0faab426b68$var$mj(a, b, c, d, e) {
    $0af0d0faab426b68$var$Ig();
    $0af0d0faab426b68$var$Jg(e);
    b.flags |= 256;
    $0af0d0faab426b68$var$Yi(a, b, c, d);
    return b.child;
}
var $0af0d0faab426b68$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0af0d0faab426b68$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0af0d0faab426b68$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0af0d0faab426b68$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0af0d0faab426b68$var$G($0af0d0faab426b68$var$M, e & 1);
    if (null === a) {
        $0af0d0faab426b68$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0af0d0faab426b68$var$qj(g, d, 0, null), a = $0af0d0faab426b68$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0af0d0faab426b68$var$oj(c), b.memoizedState = $0af0d0faab426b68$var$nj, a) : $0af0d0faab426b68$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0af0d0faab426b68$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0af0d0faab426b68$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0af0d0faab426b68$var$wh(h, f) : (f = $0af0d0faab426b68$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0af0d0faab426b68$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0af0d0faab426b68$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0af0d0faab426b68$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0af0d0faab426b68$var$rj(a, b) {
    b = $0af0d0faab426b68$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0af0d0faab426b68$var$tj(a, b, c, d) {
    null !== d && $0af0d0faab426b68$var$Jg(d);
    $0af0d0faab426b68$var$Bh(b, a.child, null, c);
    a = $0af0d0faab426b68$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0af0d0faab426b68$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0af0d0faab426b68$var$Li(Error($0af0d0faab426b68$var$p(422))), $0af0d0faab426b68$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0af0d0faab426b68$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0af0d0faab426b68$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0af0d0faab426b68$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0af0d0faab426b68$var$oj(g);
        b.memoizedState = $0af0d0faab426b68$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0af0d0faab426b68$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0af0d0faab426b68$var$p(419));
        d = $0af0d0faab426b68$var$Li(f, d, void 0);
        return $0af0d0faab426b68$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0af0d0faab426b68$var$Ug || h) {
        d = $0af0d0faab426b68$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0af0d0faab426b68$var$Zg(a, e), $0af0d0faab426b68$var$mh(d, a, e, -1));
        }
        $0af0d0faab426b68$var$uj();
        d = $0af0d0faab426b68$var$Li(Error($0af0d0faab426b68$var$p(421)));
        return $0af0d0faab426b68$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0af0d0faab426b68$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0af0d0faab426b68$var$yg = $0af0d0faab426b68$var$Lf(e.nextSibling);
    $0af0d0faab426b68$var$xg = b;
    $0af0d0faab426b68$var$I = !0;
    $0af0d0faab426b68$var$zg = null;
    null !== a && ($0af0d0faab426b68$var$og[$0af0d0faab426b68$var$pg++] = $0af0d0faab426b68$var$rg, $0af0d0faab426b68$var$og[$0af0d0faab426b68$var$pg++] = $0af0d0faab426b68$var$sg, $0af0d0faab426b68$var$og[$0af0d0faab426b68$var$pg++] = $0af0d0faab426b68$var$qg, $0af0d0faab426b68$var$rg = a.id, $0af0d0faab426b68$var$sg = a.overflow, $0af0d0faab426b68$var$qg = b);
    b = $0af0d0faab426b68$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0af0d0faab426b68$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0af0d0faab426b68$var$Sg(a.return, b, c);
}
function $0af0d0faab426b68$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0af0d0faab426b68$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0af0d0faab426b68$var$Yi(a, b, d.children, c);
    d = $0af0d0faab426b68$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0af0d0faab426b68$var$wj(a, c, b);
            else if (19 === a.tag) $0af0d0faab426b68$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0af0d0faab426b68$var$G($0af0d0faab426b68$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0af0d0faab426b68$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0af0d0faab426b68$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0af0d0faab426b68$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0af0d0faab426b68$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0af0d0faab426b68$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0af0d0faab426b68$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0af0d0faab426b68$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0af0d0faab426b68$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0af0d0faab426b68$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0af0d0faab426b68$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0af0d0faab426b68$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0af0d0faab426b68$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0af0d0faab426b68$var$lj(b);
            $0af0d0faab426b68$var$Ig();
            break;
        case 5:
            $0af0d0faab426b68$var$Kh(b);
            break;
        case 1:
            $0af0d0faab426b68$var$Zf(b.type) && $0af0d0faab426b68$var$cg(b);
            break;
        case 4:
            $0af0d0faab426b68$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0af0d0faab426b68$var$G($0af0d0faab426b68$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0af0d0faab426b68$var$G($0af0d0faab426b68$var$M, $0af0d0faab426b68$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0af0d0faab426b68$var$pj(a, b, c);
                $0af0d0faab426b68$var$G($0af0d0faab426b68$var$M, $0af0d0faab426b68$var$M.current & 1);
                a = $0af0d0faab426b68$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0af0d0faab426b68$var$G($0af0d0faab426b68$var$M, $0af0d0faab426b68$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0af0d0faab426b68$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0af0d0faab426b68$var$G($0af0d0faab426b68$var$M, $0af0d0faab426b68$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0af0d0faab426b68$var$ej(a, b, c);
    }
    return $0af0d0faab426b68$var$$i(a, b, c);
}
var $0af0d0faab426b68$var$Aj, $0af0d0faab426b68$var$Bj, $0af0d0faab426b68$var$Cj, $0af0d0faab426b68$var$Dj;
$0af0d0faab426b68$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0af0d0faab426b68$var$Bj = function() {};
$0af0d0faab426b68$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0af0d0faab426b68$var$Hh($0af0d0faab426b68$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0af0d0faab426b68$var$Ya(a, e);
                d = $0af0d0faab426b68$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0af0d0faab426b68$var$A({}, e, {
                    value: void 0
                });
                d = $0af0d0faab426b68$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0af0d0faab426b68$var$gb(a, e);
                d = $0af0d0faab426b68$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0af0d0faab426b68$var$Bf);
        }
        $0af0d0faab426b68$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0af0d0faab426b68$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0af0d0faab426b68$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0af0d0faab426b68$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0af0d0faab426b68$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0af0d0faab426b68$var$Ej(a, b) {
    if (!$0af0d0faab426b68$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0af0d0faab426b68$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0af0d0faab426b68$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0af0d0faab426b68$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0af0d0faab426b68$var$S(b), null;
        case 1:
            return $0af0d0faab426b68$var$Zf(b.type) && $0af0d0faab426b68$var$$f(), $0af0d0faab426b68$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0af0d0faab426b68$var$Jh();
            $0af0d0faab426b68$var$E($0af0d0faab426b68$var$Wf);
            $0af0d0faab426b68$var$E($0af0d0faab426b68$var$H);
            $0af0d0faab426b68$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0af0d0faab426b68$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0af0d0faab426b68$var$zg && ($0af0d0faab426b68$var$Gj($0af0d0faab426b68$var$zg), $0af0d0faab426b68$var$zg = null));
            $0af0d0faab426b68$var$Bj(a, b);
            $0af0d0faab426b68$var$S(b);
            return null;
        case 5:
            $0af0d0faab426b68$var$Lh(b);
            var e = $0af0d0faab426b68$var$Hh($0af0d0faab426b68$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0af0d0faab426b68$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0af0d0faab426b68$var$p(166));
                    $0af0d0faab426b68$var$S(b);
                    return null;
                }
                a = $0af0d0faab426b68$var$Hh($0af0d0faab426b68$var$Eh.current);
                if ($0af0d0faab426b68$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0af0d0faab426b68$var$Of] = b;
                    d[$0af0d0faab426b68$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0af0d0faab426b68$var$D("cancel", d);
                            $0af0d0faab426b68$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0af0d0faab426b68$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0af0d0faab426b68$var$lf.length; e++)$0af0d0faab426b68$var$D($0af0d0faab426b68$var$lf[e], d);
                            break;
                        case "source":
                            $0af0d0faab426b68$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0af0d0faab426b68$var$D("error", d);
                            $0af0d0faab426b68$var$D("load", d);
                            break;
                        case "details":
                            $0af0d0faab426b68$var$D("toggle", d);
                            break;
                        case "input":
                            $0af0d0faab426b68$var$Za(d, f);
                            $0af0d0faab426b68$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0af0d0faab426b68$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0af0d0faab426b68$var$hb(d, f), $0af0d0faab426b68$var$D("invalid", d);
                    }
                    $0af0d0faab426b68$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0af0d0faab426b68$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0af0d0faab426b68$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0af0d0faab426b68$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0af0d0faab426b68$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0af0d0faab426b68$var$Va(d);
                            $0af0d0faab426b68$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0af0d0faab426b68$var$Va(d);
                            $0af0d0faab426b68$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0af0d0faab426b68$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0af0d0faab426b68$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0af0d0faab426b68$var$Of] = b;
                    a[$0af0d0faab426b68$var$Pf] = d;
                    $0af0d0faab426b68$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0af0d0faab426b68$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0af0d0faab426b68$var$D("cancel", a);
                                $0af0d0faab426b68$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0af0d0faab426b68$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0af0d0faab426b68$var$lf.length; e++)$0af0d0faab426b68$var$D($0af0d0faab426b68$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0af0d0faab426b68$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0af0d0faab426b68$var$D("error", a);
                                $0af0d0faab426b68$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0af0d0faab426b68$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0af0d0faab426b68$var$Za(a, d);
                                e = $0af0d0faab426b68$var$Ya(a, d);
                                $0af0d0faab426b68$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0af0d0faab426b68$var$A({}, d, {
                                    value: void 0
                                });
                                $0af0d0faab426b68$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0af0d0faab426b68$var$hb(a, d);
                                e = $0af0d0faab426b68$var$gb(a, d);
                                $0af0d0faab426b68$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0af0d0faab426b68$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0af0d0faab426b68$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0af0d0faab426b68$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0af0d0faab426b68$var$ob(a, k) : "number" === typeof k && $0af0d0faab426b68$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0af0d0faab426b68$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0af0d0faab426b68$var$D("scroll", a) : null != k && $0af0d0faab426b68$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0af0d0faab426b68$var$Va(a);
                                $0af0d0faab426b68$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0af0d0faab426b68$var$Va(a);
                                $0af0d0faab426b68$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0af0d0faab426b68$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0af0d0faab426b68$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0af0d0faab426b68$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0af0d0faab426b68$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0af0d0faab426b68$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0af0d0faab426b68$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0af0d0faab426b68$var$p(166));
                c = $0af0d0faab426b68$var$Hh($0af0d0faab426b68$var$Gh.current);
                $0af0d0faab426b68$var$Hh($0af0d0faab426b68$var$Eh.current);
                if ($0af0d0faab426b68$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0af0d0faab426b68$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0af0d0faab426b68$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0af0d0faab426b68$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0af0d0faab426b68$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0af0d0faab426b68$var$Of] = b, b.stateNode = d;
            }
            $0af0d0faab426b68$var$S(b);
            return null;
        case 13:
            $0af0d0faab426b68$var$E($0af0d0faab426b68$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0af0d0faab426b68$var$I && null !== $0af0d0faab426b68$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0af0d0faab426b68$var$Hg(), $0af0d0faab426b68$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0af0d0faab426b68$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0af0d0faab426b68$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0af0d0faab426b68$var$p(317));
                        f[$0af0d0faab426b68$var$Of] = b;
                    } else $0af0d0faab426b68$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0af0d0faab426b68$var$S(b);
                    f = !1;
                } else null !== $0af0d0faab426b68$var$zg && ($0af0d0faab426b68$var$Gj($0af0d0faab426b68$var$zg), $0af0d0faab426b68$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0af0d0faab426b68$var$M.current & 1) ? 0 === $0af0d0faab426b68$var$T && ($0af0d0faab426b68$var$T = 3) : $0af0d0faab426b68$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0af0d0faab426b68$var$S(b);
            return null;
        case 4:
            return $0af0d0faab426b68$var$Jh(), $0af0d0faab426b68$var$Bj(a, b), null === a && $0af0d0faab426b68$var$sf(b.stateNode.containerInfo), $0af0d0faab426b68$var$S(b), null;
        case 10:
            return $0af0d0faab426b68$var$Rg(b.type._context), $0af0d0faab426b68$var$S(b), null;
        case 17:
            return $0af0d0faab426b68$var$Zf(b.type) && $0af0d0faab426b68$var$$f(), $0af0d0faab426b68$var$S(b), null;
        case 19:
            $0af0d0faab426b68$var$E($0af0d0faab426b68$var$M);
            f = b.memoizedState;
            if (null === f) return $0af0d0faab426b68$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0af0d0faab426b68$var$Ej(f, !1);
                else {
                    if (0 !== $0af0d0faab426b68$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0af0d0faab426b68$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0af0d0faab426b68$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0af0d0faab426b68$var$G($0af0d0faab426b68$var$M, $0af0d0faab426b68$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0af0d0faab426b68$var$B() > $0af0d0faab426b68$var$Hj && (b.flags |= 128, d = !0, $0af0d0faab426b68$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0af0d0faab426b68$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0af0d0faab426b68$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0af0d0faab426b68$var$I) return $0af0d0faab426b68$var$S(b), null;
                    } else 2 * $0af0d0faab426b68$var$B() - f.renderingStartTime > $0af0d0faab426b68$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0af0d0faab426b68$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0af0d0faab426b68$var$B(), b.sibling = null, c = $0af0d0faab426b68$var$M.current, $0af0d0faab426b68$var$G($0af0d0faab426b68$var$M, d ? c & 1 | 2 : c & 1), b;
            $0af0d0faab426b68$var$S(b);
            return null;
        case 22:
        case 23:
            return $0af0d0faab426b68$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0af0d0faab426b68$var$gj & 1073741824) && ($0af0d0faab426b68$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0af0d0faab426b68$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0af0d0faab426b68$var$p(156, b.tag));
}
function $0af0d0faab426b68$var$Jj(a, b) {
    $0af0d0faab426b68$var$wg(b);
    switch(b.tag){
        case 1:
            return $0af0d0faab426b68$var$Zf(b.type) && $0af0d0faab426b68$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0af0d0faab426b68$var$Jh(), $0af0d0faab426b68$var$E($0af0d0faab426b68$var$Wf), $0af0d0faab426b68$var$E($0af0d0faab426b68$var$H), $0af0d0faab426b68$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0af0d0faab426b68$var$Lh(b), null;
        case 13:
            $0af0d0faab426b68$var$E($0af0d0faab426b68$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0af0d0faab426b68$var$p(340));
                $0af0d0faab426b68$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0af0d0faab426b68$var$E($0af0d0faab426b68$var$M), null;
        case 4:
            return $0af0d0faab426b68$var$Jh(), null;
        case 10:
            return $0af0d0faab426b68$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0af0d0faab426b68$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0af0d0faab426b68$var$Kj = !1, $0af0d0faab426b68$var$U = !1, $0af0d0faab426b68$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0af0d0faab426b68$var$V = null;
function $0af0d0faab426b68$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0af0d0faab426b68$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0af0d0faab426b68$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0af0d0faab426b68$var$W(a, b, d);
    }
}
var $0af0d0faab426b68$var$Oj = !1;
function $0af0d0faab426b68$var$Pj(a, b) {
    $0af0d0faab426b68$var$Cf = $0af0d0faab426b68$var$dd;
    a = $0af0d0faab426b68$var$Me();
    if ($0af0d0faab426b68$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0af0d0faab426b68$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0af0d0faab426b68$var$dd = !1;
    for($0af0d0faab426b68$var$V = b; null !== $0af0d0faab426b68$var$V;)if (b = $0af0d0faab426b68$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0af0d0faab426b68$var$V = a;
    else for(; null !== $0af0d0faab426b68$var$V;){
        b = $0af0d0faab426b68$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0af0d0faab426b68$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0af0d0faab426b68$var$p(163));
            }
        } catch (F) {
            $0af0d0faab426b68$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0af0d0faab426b68$var$V = a;
            break;
        }
        $0af0d0faab426b68$var$V = b.return;
    }
    n = $0af0d0faab426b68$var$Oj;
    $0af0d0faab426b68$var$Oj = !1;
    return n;
}
function $0af0d0faab426b68$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0af0d0faab426b68$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0af0d0faab426b68$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0af0d0faab426b68$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0af0d0faab426b68$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0af0d0faab426b68$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0af0d0faab426b68$var$Of], delete b[$0af0d0faab426b68$var$Pf], delete b[$0af0d0faab426b68$var$of], delete b[$0af0d0faab426b68$var$Qf], delete b[$0af0d0faab426b68$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0af0d0faab426b68$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0af0d0faab426b68$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0af0d0faab426b68$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0af0d0faab426b68$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0af0d0faab426b68$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0af0d0faab426b68$var$Wj(a, b, c), a = a.sibling; null !== a;)$0af0d0faab426b68$var$Wj(a, b, c), a = a.sibling;
}
function $0af0d0faab426b68$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0af0d0faab426b68$var$Xj(a, b, c), a = a.sibling; null !== a;)$0af0d0faab426b68$var$Xj(a, b, c), a = a.sibling;
}
var $0af0d0faab426b68$var$X = null, $0af0d0faab426b68$var$Yj = !1;
function $0af0d0faab426b68$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0af0d0faab426b68$var$ak(a, b, c), c = c.sibling;
}
function $0af0d0faab426b68$var$ak(a, b, c) {
    if ($0af0d0faab426b68$var$lc && "function" === typeof $0af0d0faab426b68$var$lc.onCommitFiberUnmount) try {
        $0af0d0faab426b68$var$lc.onCommitFiberUnmount($0af0d0faab426b68$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0af0d0faab426b68$var$U || $0af0d0faab426b68$var$Mj(c, b);
        case 6:
            var d = $0af0d0faab426b68$var$X, e = $0af0d0faab426b68$var$Yj;
            $0af0d0faab426b68$var$X = null;
            $0af0d0faab426b68$var$Zj(a, b, c);
            $0af0d0faab426b68$var$X = d;
            $0af0d0faab426b68$var$Yj = e;
            null !== $0af0d0faab426b68$var$X && ($0af0d0faab426b68$var$Yj ? (a = $0af0d0faab426b68$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0af0d0faab426b68$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0af0d0faab426b68$var$X && ($0af0d0faab426b68$var$Yj ? (a = $0af0d0faab426b68$var$X, c = c.stateNode, 8 === a.nodeType ? $0af0d0faab426b68$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0af0d0faab426b68$var$Kf(a, c), $0af0d0faab426b68$var$bd(a)) : $0af0d0faab426b68$var$Kf($0af0d0faab426b68$var$X, c.stateNode));
            break;
        case 4:
            d = $0af0d0faab426b68$var$X;
            e = $0af0d0faab426b68$var$Yj;
            $0af0d0faab426b68$var$X = c.stateNode.containerInfo;
            $0af0d0faab426b68$var$Yj = !0;
            $0af0d0faab426b68$var$Zj(a, b, c);
            $0af0d0faab426b68$var$X = d;
            $0af0d0faab426b68$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0af0d0faab426b68$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0af0d0faab426b68$var$Nj(c, b, g) : 0 !== (f & 4) && $0af0d0faab426b68$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0af0d0faab426b68$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0af0d0faab426b68$var$U && ($0af0d0faab426b68$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0af0d0faab426b68$var$W(c, b, h);
            }
            $0af0d0faab426b68$var$Zj(a, b, c);
            break;
        case 21:
            $0af0d0faab426b68$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0af0d0faab426b68$var$U = (d = $0af0d0faab426b68$var$U) || null !== c.memoizedState, $0af0d0faab426b68$var$Zj(a, b, c), $0af0d0faab426b68$var$U = d) : $0af0d0faab426b68$var$Zj(a, b, c);
            break;
        default:
            $0af0d0faab426b68$var$Zj(a, b, c);
    }
}
function $0af0d0faab426b68$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0af0d0faab426b68$var$Lj);
        b.forEach(function(b) {
            var d = $0af0d0faab426b68$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0af0d0faab426b68$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0af0d0faab426b68$var$X = h.stateNode;
                        $0af0d0faab426b68$var$Yj = !1;
                        break a;
                    case 3:
                        $0af0d0faab426b68$var$X = h.stateNode.containerInfo;
                        $0af0d0faab426b68$var$Yj = !0;
                        break a;
                    case 4:
                        $0af0d0faab426b68$var$X = h.stateNode.containerInfo;
                        $0af0d0faab426b68$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0af0d0faab426b68$var$X) throw Error($0af0d0faab426b68$var$p(160));
            $0af0d0faab426b68$var$ak(f, g, e);
            $0af0d0faab426b68$var$X = null;
            $0af0d0faab426b68$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0af0d0faab426b68$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0af0d0faab426b68$var$ek(b, a), b = b.sibling;
}
function $0af0d0faab426b68$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0af0d0faab426b68$var$dk(b, a);
            $0af0d0faab426b68$var$fk(a);
            if (d & 4) {
                try {
                    $0af0d0faab426b68$var$Qj(3, a, a.return), $0af0d0faab426b68$var$Rj(3, a);
                } catch (t) {
                    $0af0d0faab426b68$var$W(a, a.return, t);
                }
                try {
                    $0af0d0faab426b68$var$Qj(5, a, a.return);
                } catch (t) {
                    $0af0d0faab426b68$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0af0d0faab426b68$var$dk(b, a);
            $0af0d0faab426b68$var$fk(a);
            d & 512 && null !== c && $0af0d0faab426b68$var$Mj(c, c.return);
            break;
        case 5:
            $0af0d0faab426b68$var$dk(b, a);
            $0af0d0faab426b68$var$fk(a);
            d & 512 && null !== c && $0af0d0faab426b68$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0af0d0faab426b68$var$ob(e, "");
                } catch (t) {
                    $0af0d0faab426b68$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0af0d0faab426b68$var$ab(e, f);
                    $0af0d0faab426b68$var$vb(h, g);
                    var l = $0af0d0faab426b68$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0af0d0faab426b68$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0af0d0faab426b68$var$nb(e, q) : "children" === m ? $0af0d0faab426b68$var$ob(e, q) : $0af0d0faab426b68$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0af0d0faab426b68$var$bb(e, f);
                            break;
                        case "textarea":
                            $0af0d0faab426b68$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0af0d0faab426b68$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0af0d0faab426b68$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0af0d0faab426b68$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0af0d0faab426b68$var$Pf] = f;
                } catch (t) {
                    $0af0d0faab426b68$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0af0d0faab426b68$var$dk(b, a);
            $0af0d0faab426b68$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0af0d0faab426b68$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0af0d0faab426b68$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0af0d0faab426b68$var$dk(b, a);
            $0af0d0faab426b68$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0af0d0faab426b68$var$bd(b.containerInfo);
            } catch (t) {
                $0af0d0faab426b68$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0af0d0faab426b68$var$dk(b, a);
            $0af0d0faab426b68$var$fk(a);
            break;
        case 13:
            $0af0d0faab426b68$var$dk(b, a);
            $0af0d0faab426b68$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0af0d0faab426b68$var$gk = $0af0d0faab426b68$var$B()));
            d & 4 && $0af0d0faab426b68$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0af0d0faab426b68$var$U = (l = $0af0d0faab426b68$var$U) || m, $0af0d0faab426b68$var$dk(b, a), $0af0d0faab426b68$var$U = l) : $0af0d0faab426b68$var$dk(b, a);
            $0af0d0faab426b68$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0af0d0faab426b68$var$V = a, m = a.child; null !== m;){
                    for(q = $0af0d0faab426b68$var$V = m; null !== $0af0d0faab426b68$var$V;){
                        r = $0af0d0faab426b68$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0af0d0faab426b68$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0af0d0faab426b68$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0af0d0faab426b68$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0af0d0faab426b68$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0af0d0faab426b68$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0af0d0faab426b68$var$V = y) : $0af0d0faab426b68$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0af0d0faab426b68$var$rb("display", g));
                            } catch (t) {
                                $0af0d0faab426b68$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0af0d0faab426b68$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0af0d0faab426b68$var$dk(b, a);
            $0af0d0faab426b68$var$fk(a);
            d & 4 && $0af0d0faab426b68$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0af0d0faab426b68$var$dk(b, a), $0af0d0faab426b68$var$fk(a);
    }
}
function $0af0d0faab426b68$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0af0d0faab426b68$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0af0d0faab426b68$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0af0d0faab426b68$var$ob(e, ""), d.flags &= -33);
                    var f = $0af0d0faab426b68$var$Vj(a);
                    $0af0d0faab426b68$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0af0d0faab426b68$var$Vj(a);
                    $0af0d0faab426b68$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0af0d0faab426b68$var$p(161));
            }
        } catch (k) {
            $0af0d0faab426b68$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0af0d0faab426b68$var$ik(a, b, c) {
    $0af0d0faab426b68$var$V = a;
    $0af0d0faab426b68$var$jk(a, b, c);
}
function $0af0d0faab426b68$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0af0d0faab426b68$var$V;){
        var e = $0af0d0faab426b68$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0af0d0faab426b68$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0af0d0faab426b68$var$U;
                h = $0af0d0faab426b68$var$Kj;
                var l = $0af0d0faab426b68$var$U;
                $0af0d0faab426b68$var$Kj = g;
                if (($0af0d0faab426b68$var$U = k) && !l) for($0af0d0faab426b68$var$V = e; null !== $0af0d0faab426b68$var$V;)g = $0af0d0faab426b68$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0af0d0faab426b68$var$kk(e) : null !== k ? (k.return = g, $0af0d0faab426b68$var$V = k) : $0af0d0faab426b68$var$kk(e);
                for(; null !== f;)$0af0d0faab426b68$var$V = f, $0af0d0faab426b68$var$jk(f, b, c), f = f.sibling;
                $0af0d0faab426b68$var$V = e;
                $0af0d0faab426b68$var$Kj = h;
                $0af0d0faab426b68$var$U = l;
            }
            $0af0d0faab426b68$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0af0d0faab426b68$var$V = f) : $0af0d0faab426b68$var$lk(a, b, c);
    }
}
function $0af0d0faab426b68$var$lk(a) {
    for(; null !== $0af0d0faab426b68$var$V;){
        var b = $0af0d0faab426b68$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0af0d0faab426b68$var$U || $0af0d0faab426b68$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0af0d0faab426b68$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0af0d0faab426b68$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0af0d0faab426b68$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0af0d0faab426b68$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0af0d0faab426b68$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0af0d0faab426b68$var$p(163));
                }
                $0af0d0faab426b68$var$U || b.flags & 512 && $0af0d0faab426b68$var$Sj(b);
            } catch (r) {
                $0af0d0faab426b68$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0af0d0faab426b68$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0af0d0faab426b68$var$V = c;
            break;
        }
        $0af0d0faab426b68$var$V = b.return;
    }
}
function $0af0d0faab426b68$var$hk(a) {
    for(; null !== $0af0d0faab426b68$var$V;){
        var b = $0af0d0faab426b68$var$V;
        if (b === a) {
            $0af0d0faab426b68$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0af0d0faab426b68$var$V = c;
            break;
        }
        $0af0d0faab426b68$var$V = b.return;
    }
}
function $0af0d0faab426b68$var$kk(a) {
    for(; null !== $0af0d0faab426b68$var$V;){
        var b = $0af0d0faab426b68$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0af0d0faab426b68$var$Rj(4, b);
                    } catch (k) {
                        $0af0d0faab426b68$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0af0d0faab426b68$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0af0d0faab426b68$var$Sj(b);
                    } catch (k) {
                        $0af0d0faab426b68$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0af0d0faab426b68$var$Sj(b);
                    } catch (k) {
                        $0af0d0faab426b68$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0af0d0faab426b68$var$W(b, b.return, k);
        }
        if (b === a) {
            $0af0d0faab426b68$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0af0d0faab426b68$var$V = h;
            break;
        }
        $0af0d0faab426b68$var$V = b.return;
    }
}
var $0af0d0faab426b68$var$mk = Math.ceil, $0af0d0faab426b68$var$nk = $0af0d0faab426b68$var$ua.ReactCurrentDispatcher, $0af0d0faab426b68$var$ok = $0af0d0faab426b68$var$ua.ReactCurrentOwner, $0af0d0faab426b68$var$pk = $0af0d0faab426b68$var$ua.ReactCurrentBatchConfig, $0af0d0faab426b68$var$K = 0, $0af0d0faab426b68$var$R = null, $0af0d0faab426b68$var$Y = null, $0af0d0faab426b68$var$Z = 0, $0af0d0faab426b68$var$gj = 0, $0af0d0faab426b68$var$fj = $0af0d0faab426b68$var$Uf(0), $0af0d0faab426b68$var$T = 0, $0af0d0faab426b68$var$qk = null, $0af0d0faab426b68$var$hh = 0, $0af0d0faab426b68$var$rk = 0, $0af0d0faab426b68$var$sk = 0, $0af0d0faab426b68$var$tk = null, $0af0d0faab426b68$var$uk = null, $0af0d0faab426b68$var$gk = 0, $0af0d0faab426b68$var$Hj = Infinity, $0af0d0faab426b68$var$vk = null, $0af0d0faab426b68$var$Pi = !1, $0af0d0faab426b68$var$Qi = null, $0af0d0faab426b68$var$Si = null, $0af0d0faab426b68$var$wk = !1, $0af0d0faab426b68$var$xk = null, $0af0d0faab426b68$var$yk = 0, $0af0d0faab426b68$var$zk = 0, $0af0d0faab426b68$var$Ak = null, $0af0d0faab426b68$var$Bk = -1, $0af0d0faab426b68$var$Ck = 0;
function $0af0d0faab426b68$var$L() {
    return 0 !== ($0af0d0faab426b68$var$K & 6) ? $0af0d0faab426b68$var$B() : -1 !== $0af0d0faab426b68$var$Bk ? $0af0d0faab426b68$var$Bk : $0af0d0faab426b68$var$Bk = $0af0d0faab426b68$var$B();
}
function $0af0d0faab426b68$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0af0d0faab426b68$var$K & 2) && 0 !== $0af0d0faab426b68$var$Z) return $0af0d0faab426b68$var$Z & -$0af0d0faab426b68$var$Z;
    if (null !== $0af0d0faab426b68$var$Kg.transition) return 0 === $0af0d0faab426b68$var$Ck && ($0af0d0faab426b68$var$Ck = $0af0d0faab426b68$var$yc()), $0af0d0faab426b68$var$Ck;
    a = $0af0d0faab426b68$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0af0d0faab426b68$var$jd(a.type);
    return a;
}
function $0af0d0faab426b68$var$mh(a, b, c, d) {
    if (50 < $0af0d0faab426b68$var$zk) throw $0af0d0faab426b68$var$zk = 0, $0af0d0faab426b68$var$Ak = null, Error($0af0d0faab426b68$var$p(185));
    $0af0d0faab426b68$var$Ac(a, c, d);
    if (0 === ($0af0d0faab426b68$var$K & 2) || a !== $0af0d0faab426b68$var$R) a === $0af0d0faab426b68$var$R && (0 === ($0af0d0faab426b68$var$K & 2) && ($0af0d0faab426b68$var$rk |= c), 4 === $0af0d0faab426b68$var$T && $0af0d0faab426b68$var$Dk(a, $0af0d0faab426b68$var$Z)), $0af0d0faab426b68$var$Ek(a, d), 1 === c && 0 === $0af0d0faab426b68$var$K && 0 === (b.mode & 1) && ($0af0d0faab426b68$var$Hj = $0af0d0faab426b68$var$B() + 500, $0af0d0faab426b68$var$fg && $0af0d0faab426b68$var$jg());
}
function $0af0d0faab426b68$var$Ek(a, b) {
    var c = a.callbackNode;
    $0af0d0faab426b68$var$wc(a, b);
    var d = $0af0d0faab426b68$var$uc(a, a === $0af0d0faab426b68$var$R ? $0af0d0faab426b68$var$Z : 0);
    if (0 === d) null !== c && $0af0d0faab426b68$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0af0d0faab426b68$var$bc(c);
        if (1 === b) 0 === a.tag ? $0af0d0faab426b68$var$ig($0af0d0faab426b68$var$Fk.bind(null, a)) : $0af0d0faab426b68$var$hg($0af0d0faab426b68$var$Fk.bind(null, a)), $0af0d0faab426b68$var$Jf(function() {
            0 === ($0af0d0faab426b68$var$K & 6) && $0af0d0faab426b68$var$jg();
        }), c = null;
        else {
            switch($0af0d0faab426b68$var$Dc(d)){
                case 1:
                    c = $0af0d0faab426b68$var$fc;
                    break;
                case 4:
                    c = $0af0d0faab426b68$var$gc;
                    break;
                case 16:
                    c = $0af0d0faab426b68$var$hc;
                    break;
                case 536870912:
                    c = $0af0d0faab426b68$var$jc;
                    break;
                default:
                    c = $0af0d0faab426b68$var$hc;
            }
            c = $0af0d0faab426b68$var$Gk(c, $0af0d0faab426b68$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0af0d0faab426b68$var$Hk(a, b) {
    $0af0d0faab426b68$var$Bk = -1;
    $0af0d0faab426b68$var$Ck = 0;
    if (0 !== ($0af0d0faab426b68$var$K & 6)) throw Error($0af0d0faab426b68$var$p(327));
    var c = a.callbackNode;
    if ($0af0d0faab426b68$var$Ik() && a.callbackNode !== c) return null;
    var d = $0af0d0faab426b68$var$uc(a, a === $0af0d0faab426b68$var$R ? $0af0d0faab426b68$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0af0d0faab426b68$var$Jk(a, d);
    else {
        b = d;
        var e = $0af0d0faab426b68$var$K;
        $0af0d0faab426b68$var$K |= 2;
        var f = $0af0d0faab426b68$var$Kk();
        if ($0af0d0faab426b68$var$R !== a || $0af0d0faab426b68$var$Z !== b) $0af0d0faab426b68$var$vk = null, $0af0d0faab426b68$var$Hj = $0af0d0faab426b68$var$B() + 500, $0af0d0faab426b68$var$Lk(a, b);
        for(;;)try {
            $0af0d0faab426b68$var$Mk();
            break;
        } catch (h) {
            $0af0d0faab426b68$var$Nk(a, h);
        }
        $0af0d0faab426b68$var$Qg();
        $0af0d0faab426b68$var$nk.current = f;
        $0af0d0faab426b68$var$K = e;
        null !== $0af0d0faab426b68$var$Y ? b = 0 : ($0af0d0faab426b68$var$R = null, $0af0d0faab426b68$var$Z = 0, b = $0af0d0faab426b68$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0af0d0faab426b68$var$xc(a), 0 !== e && (d = e, b = $0af0d0faab426b68$var$Ok(a, e)));
        if (1 === b) throw c = $0af0d0faab426b68$var$qk, $0af0d0faab426b68$var$Lk(a, 0), $0af0d0faab426b68$var$Dk(a, d), $0af0d0faab426b68$var$Ek(a, $0af0d0faab426b68$var$B()), c;
        if (6 === b) $0af0d0faab426b68$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0af0d0faab426b68$var$Pk(e) && (b = $0af0d0faab426b68$var$Jk(a, d), 2 === b && (f = $0af0d0faab426b68$var$xc(a), 0 !== f && (d = f, b = $0af0d0faab426b68$var$Ok(a, f))), 1 === b)) throw c = $0af0d0faab426b68$var$qk, $0af0d0faab426b68$var$Lk(a, 0), $0af0d0faab426b68$var$Dk(a, d), $0af0d0faab426b68$var$Ek(a, $0af0d0faab426b68$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0af0d0faab426b68$var$p(345));
                case 2:
                    $0af0d0faab426b68$var$Qk(a, $0af0d0faab426b68$var$uk, $0af0d0faab426b68$var$vk);
                    break;
                case 3:
                    $0af0d0faab426b68$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0af0d0faab426b68$var$gk + 500 - $0af0d0faab426b68$var$B(), 10 < b)) {
                        if (0 !== $0af0d0faab426b68$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0af0d0faab426b68$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0af0d0faab426b68$var$Ff($0af0d0faab426b68$var$Qk.bind(null, a, $0af0d0faab426b68$var$uk, $0af0d0faab426b68$var$vk), b);
                        break;
                    }
                    $0af0d0faab426b68$var$Qk(a, $0af0d0faab426b68$var$uk, $0af0d0faab426b68$var$vk);
                    break;
                case 4:
                    $0af0d0faab426b68$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0af0d0faab426b68$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0af0d0faab426b68$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0af0d0faab426b68$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0af0d0faab426b68$var$Ff($0af0d0faab426b68$var$Qk.bind(null, a, $0af0d0faab426b68$var$uk, $0af0d0faab426b68$var$vk), d);
                        break;
                    }
                    $0af0d0faab426b68$var$Qk(a, $0af0d0faab426b68$var$uk, $0af0d0faab426b68$var$vk);
                    break;
                case 5:
                    $0af0d0faab426b68$var$Qk(a, $0af0d0faab426b68$var$uk, $0af0d0faab426b68$var$vk);
                    break;
                default:
                    throw Error($0af0d0faab426b68$var$p(329));
            }
        }
    }
    $0af0d0faab426b68$var$Ek(a, $0af0d0faab426b68$var$B());
    return a.callbackNode === c ? $0af0d0faab426b68$var$Hk.bind(null, a) : null;
}
function $0af0d0faab426b68$var$Ok(a, b) {
    var c = $0af0d0faab426b68$var$tk;
    a.current.memoizedState.isDehydrated && ($0af0d0faab426b68$var$Lk(a, b).flags |= 256);
    a = $0af0d0faab426b68$var$Jk(a, b);
    2 !== a && (b = $0af0d0faab426b68$var$uk, $0af0d0faab426b68$var$uk = c, null !== b && $0af0d0faab426b68$var$Gj(b));
    return a;
}
function $0af0d0faab426b68$var$Gj(a) {
    null === $0af0d0faab426b68$var$uk ? $0af0d0faab426b68$var$uk = a : $0af0d0faab426b68$var$uk.push.apply($0af0d0faab426b68$var$uk, a);
}
function $0af0d0faab426b68$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0af0d0faab426b68$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0af0d0faab426b68$var$Dk(a, b) {
    b &= ~$0af0d0faab426b68$var$sk;
    b &= ~$0af0d0faab426b68$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0af0d0faab426b68$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0af0d0faab426b68$var$Fk(a) {
    if (0 !== ($0af0d0faab426b68$var$K & 6)) throw Error($0af0d0faab426b68$var$p(327));
    $0af0d0faab426b68$var$Ik();
    var b = $0af0d0faab426b68$var$uc(a, 0);
    if (0 === (b & 1)) return $0af0d0faab426b68$var$Ek(a, $0af0d0faab426b68$var$B()), null;
    var c = $0af0d0faab426b68$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0af0d0faab426b68$var$xc(a);
        0 !== d && (b = d, c = $0af0d0faab426b68$var$Ok(a, d));
    }
    if (1 === c) throw c = $0af0d0faab426b68$var$qk, $0af0d0faab426b68$var$Lk(a, 0), $0af0d0faab426b68$var$Dk(a, b), $0af0d0faab426b68$var$Ek(a, $0af0d0faab426b68$var$B()), c;
    if (6 === c) throw Error($0af0d0faab426b68$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0af0d0faab426b68$var$Qk(a, $0af0d0faab426b68$var$uk, $0af0d0faab426b68$var$vk);
    $0af0d0faab426b68$var$Ek(a, $0af0d0faab426b68$var$B());
    return null;
}
function $0af0d0faab426b68$var$Rk(a, b) {
    var c = $0af0d0faab426b68$var$K;
    $0af0d0faab426b68$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0af0d0faab426b68$var$K = c, 0 === $0af0d0faab426b68$var$K && ($0af0d0faab426b68$var$Hj = $0af0d0faab426b68$var$B() + 500, $0af0d0faab426b68$var$fg && $0af0d0faab426b68$var$jg());
    }
}
function $0af0d0faab426b68$var$Sk(a) {
    null !== $0af0d0faab426b68$var$xk && 0 === $0af0d0faab426b68$var$xk.tag && 0 === ($0af0d0faab426b68$var$K & 6) && $0af0d0faab426b68$var$Ik();
    var b = $0af0d0faab426b68$var$K;
    $0af0d0faab426b68$var$K |= 1;
    var c = $0af0d0faab426b68$var$pk.transition, d = $0af0d0faab426b68$var$C;
    try {
        if ($0af0d0faab426b68$var$pk.transition = null, $0af0d0faab426b68$var$C = 1, a) return a();
    } finally{
        $0af0d0faab426b68$var$C = d, $0af0d0faab426b68$var$pk.transition = c, $0af0d0faab426b68$var$K = b, 0 === ($0af0d0faab426b68$var$K & 6) && $0af0d0faab426b68$var$jg();
    }
}
function $0af0d0faab426b68$var$Ij() {
    $0af0d0faab426b68$var$gj = $0af0d0faab426b68$var$fj.current;
    $0af0d0faab426b68$var$E($0af0d0faab426b68$var$fj);
}
function $0af0d0faab426b68$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0af0d0faab426b68$var$Gf(c));
    if (null !== $0af0d0faab426b68$var$Y) for(c = $0af0d0faab426b68$var$Y.return; null !== c;){
        var d = c;
        $0af0d0faab426b68$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0af0d0faab426b68$var$$f();
                break;
            case 3:
                $0af0d0faab426b68$var$Jh();
                $0af0d0faab426b68$var$E($0af0d0faab426b68$var$Wf);
                $0af0d0faab426b68$var$E($0af0d0faab426b68$var$H);
                $0af0d0faab426b68$var$Oh();
                break;
            case 5:
                $0af0d0faab426b68$var$Lh(d);
                break;
            case 4:
                $0af0d0faab426b68$var$Jh();
                break;
            case 13:
                $0af0d0faab426b68$var$E($0af0d0faab426b68$var$M);
                break;
            case 19:
                $0af0d0faab426b68$var$E($0af0d0faab426b68$var$M);
                break;
            case 10:
                $0af0d0faab426b68$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0af0d0faab426b68$var$Ij();
        }
        c = c.return;
    }
    $0af0d0faab426b68$var$R = a;
    $0af0d0faab426b68$var$Y = a = $0af0d0faab426b68$var$wh(a.current, null);
    $0af0d0faab426b68$var$Z = $0af0d0faab426b68$var$gj = b;
    $0af0d0faab426b68$var$T = 0;
    $0af0d0faab426b68$var$qk = null;
    $0af0d0faab426b68$var$sk = $0af0d0faab426b68$var$rk = $0af0d0faab426b68$var$hh = 0;
    $0af0d0faab426b68$var$uk = $0af0d0faab426b68$var$tk = null;
    if (null !== $0af0d0faab426b68$var$Wg) {
        for(b = 0; b < $0af0d0faab426b68$var$Wg.length; b++)if (c = $0af0d0faab426b68$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0af0d0faab426b68$var$Wg = null;
    }
    return a;
}
function $0af0d0faab426b68$var$Nk(a, b) {
    do {
        var c = $0af0d0faab426b68$var$Y;
        try {
            $0af0d0faab426b68$var$Qg();
            $0af0d0faab426b68$var$Ph.current = $0af0d0faab426b68$var$ai;
            if ($0af0d0faab426b68$var$Sh) {
                for(var d = $0af0d0faab426b68$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0af0d0faab426b68$var$Sh = !1;
            }
            $0af0d0faab426b68$var$Rh = 0;
            $0af0d0faab426b68$var$P = $0af0d0faab426b68$var$O = $0af0d0faab426b68$var$N = null;
            $0af0d0faab426b68$var$Th = !1;
            $0af0d0faab426b68$var$Uh = 0;
            $0af0d0faab426b68$var$ok.current = null;
            if (null === c || null === c.return) {
                $0af0d0faab426b68$var$T = 1;
                $0af0d0faab426b68$var$qk = b;
                $0af0d0faab426b68$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0af0d0faab426b68$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0af0d0faab426b68$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0af0d0faab426b68$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0af0d0faab426b68$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0af0d0faab426b68$var$Ti(f, l, b);
                            $0af0d0faab426b68$var$uj();
                            break a;
                        }
                        k = Error($0af0d0faab426b68$var$p(426));
                    }
                } else if ($0af0d0faab426b68$var$I && h.mode & 1) {
                    var J = $0af0d0faab426b68$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0af0d0faab426b68$var$Wi(J, g, h, f, b);
                        $0af0d0faab426b68$var$Jg($0af0d0faab426b68$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0af0d0faab426b68$var$Ki(k, h);
                4 !== $0af0d0faab426b68$var$T && ($0af0d0faab426b68$var$T = 2);
                null === $0af0d0faab426b68$var$tk ? $0af0d0faab426b68$var$tk = [
                    f
                ] : $0af0d0faab426b68$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0af0d0faab426b68$var$Oi(f, k, b);
                            $0af0d0faab426b68$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0af0d0faab426b68$var$Si || !$0af0d0faab426b68$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0af0d0faab426b68$var$Ri(f, h, b);
                                $0af0d0faab426b68$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0af0d0faab426b68$var$Tk(c);
        } catch (na) {
            b = na;
            $0af0d0faab426b68$var$Y === c && null !== c && ($0af0d0faab426b68$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0af0d0faab426b68$var$Kk() {
    var a = $0af0d0faab426b68$var$nk.current;
    $0af0d0faab426b68$var$nk.current = $0af0d0faab426b68$var$ai;
    return null === a ? $0af0d0faab426b68$var$ai : a;
}
function $0af0d0faab426b68$var$uj() {
    if (0 === $0af0d0faab426b68$var$T || 3 === $0af0d0faab426b68$var$T || 2 === $0af0d0faab426b68$var$T) $0af0d0faab426b68$var$T = 4;
    null === $0af0d0faab426b68$var$R || 0 === ($0af0d0faab426b68$var$hh & 268435455) && 0 === ($0af0d0faab426b68$var$rk & 268435455) || $0af0d0faab426b68$var$Dk($0af0d0faab426b68$var$R, $0af0d0faab426b68$var$Z);
}
function $0af0d0faab426b68$var$Jk(a, b) {
    var c = $0af0d0faab426b68$var$K;
    $0af0d0faab426b68$var$K |= 2;
    var d = $0af0d0faab426b68$var$Kk();
    if ($0af0d0faab426b68$var$R !== a || $0af0d0faab426b68$var$Z !== b) $0af0d0faab426b68$var$vk = null, $0af0d0faab426b68$var$Lk(a, b);
    for(;;)try {
        $0af0d0faab426b68$var$Uk();
        break;
    } catch (e) {
        $0af0d0faab426b68$var$Nk(a, e);
    }
    $0af0d0faab426b68$var$Qg();
    $0af0d0faab426b68$var$K = c;
    $0af0d0faab426b68$var$nk.current = d;
    if (null !== $0af0d0faab426b68$var$Y) throw Error($0af0d0faab426b68$var$p(261));
    $0af0d0faab426b68$var$R = null;
    $0af0d0faab426b68$var$Z = 0;
    return $0af0d0faab426b68$var$T;
}
function $0af0d0faab426b68$var$Uk() {
    for(; null !== $0af0d0faab426b68$var$Y;)$0af0d0faab426b68$var$Vk($0af0d0faab426b68$var$Y);
}
function $0af0d0faab426b68$var$Mk() {
    for(; null !== $0af0d0faab426b68$var$Y && !$0af0d0faab426b68$var$cc();)$0af0d0faab426b68$var$Vk($0af0d0faab426b68$var$Y);
}
function $0af0d0faab426b68$var$Vk(a) {
    var b = $0af0d0faab426b68$var$Wk(a.alternate, a, $0af0d0faab426b68$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0af0d0faab426b68$var$Tk(a) : $0af0d0faab426b68$var$Y = b;
    $0af0d0faab426b68$var$ok.current = null;
}
function $0af0d0faab426b68$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0af0d0faab426b68$var$Fj(c, b, $0af0d0faab426b68$var$gj), null !== c) {
                $0af0d0faab426b68$var$Y = c;
                return;
            }
        } else {
            c = $0af0d0faab426b68$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0af0d0faab426b68$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0af0d0faab426b68$var$T = 6;
                $0af0d0faab426b68$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0af0d0faab426b68$var$Y = b;
            return;
        }
        $0af0d0faab426b68$var$Y = b = a;
    }while (null !== b);
    0 === $0af0d0faab426b68$var$T && ($0af0d0faab426b68$var$T = 5);
}
function $0af0d0faab426b68$var$Qk(a, b, c) {
    var d = $0af0d0faab426b68$var$C, e = $0af0d0faab426b68$var$pk.transition;
    try {
        $0af0d0faab426b68$var$pk.transition = null, $0af0d0faab426b68$var$C = 1, $0af0d0faab426b68$var$Xk(a, b, c, d);
    } finally{
        $0af0d0faab426b68$var$pk.transition = e, $0af0d0faab426b68$var$C = d;
    }
    return null;
}
function $0af0d0faab426b68$var$Xk(a, b, c, d) {
    do $0af0d0faab426b68$var$Ik();
    while (null !== $0af0d0faab426b68$var$xk);
    if (0 !== ($0af0d0faab426b68$var$K & 6)) throw Error($0af0d0faab426b68$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0af0d0faab426b68$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0af0d0faab426b68$var$Bc(a, f);
    a === $0af0d0faab426b68$var$R && ($0af0d0faab426b68$var$Y = $0af0d0faab426b68$var$R = null, $0af0d0faab426b68$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0af0d0faab426b68$var$wk || ($0af0d0faab426b68$var$wk = !0, $0af0d0faab426b68$var$Gk($0af0d0faab426b68$var$hc, function() {
        $0af0d0faab426b68$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0af0d0faab426b68$var$pk.transition;
        $0af0d0faab426b68$var$pk.transition = null;
        var g = $0af0d0faab426b68$var$C;
        $0af0d0faab426b68$var$C = 1;
        var h = $0af0d0faab426b68$var$K;
        $0af0d0faab426b68$var$K |= 4;
        $0af0d0faab426b68$var$ok.current = null;
        $0af0d0faab426b68$var$Pj(a, c);
        $0af0d0faab426b68$var$ek(c, a);
        $0af0d0faab426b68$var$Oe($0af0d0faab426b68$var$Df);
        $0af0d0faab426b68$var$dd = !!$0af0d0faab426b68$var$Cf;
        $0af0d0faab426b68$var$Df = $0af0d0faab426b68$var$Cf = null;
        a.current = c;
        $0af0d0faab426b68$var$ik(c, a, e);
        $0af0d0faab426b68$var$dc();
        $0af0d0faab426b68$var$K = h;
        $0af0d0faab426b68$var$C = g;
        $0af0d0faab426b68$var$pk.transition = f;
    } else a.current = c;
    $0af0d0faab426b68$var$wk && ($0af0d0faab426b68$var$wk = !1, $0af0d0faab426b68$var$xk = a, $0af0d0faab426b68$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0af0d0faab426b68$var$Si = null);
    $0af0d0faab426b68$var$mc(c.stateNode, d);
    $0af0d0faab426b68$var$Ek(a, $0af0d0faab426b68$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0af0d0faab426b68$var$Pi) throw $0af0d0faab426b68$var$Pi = !1, a = $0af0d0faab426b68$var$Qi, $0af0d0faab426b68$var$Qi = null, a;
    0 !== ($0af0d0faab426b68$var$yk & 1) && 0 !== a.tag && $0af0d0faab426b68$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0af0d0faab426b68$var$Ak ? $0af0d0faab426b68$var$zk++ : ($0af0d0faab426b68$var$zk = 0, $0af0d0faab426b68$var$Ak = a) : $0af0d0faab426b68$var$zk = 0;
    $0af0d0faab426b68$var$jg();
    return null;
}
function $0af0d0faab426b68$var$Ik() {
    if (null !== $0af0d0faab426b68$var$xk) {
        var a = $0af0d0faab426b68$var$Dc($0af0d0faab426b68$var$yk), b = $0af0d0faab426b68$var$pk.transition, c = $0af0d0faab426b68$var$C;
        try {
            $0af0d0faab426b68$var$pk.transition = null;
            $0af0d0faab426b68$var$C = 16 > a ? 16 : a;
            if (null === $0af0d0faab426b68$var$xk) var d = !1;
            else {
                a = $0af0d0faab426b68$var$xk;
                $0af0d0faab426b68$var$xk = null;
                $0af0d0faab426b68$var$yk = 0;
                if (0 !== ($0af0d0faab426b68$var$K & 6)) throw Error($0af0d0faab426b68$var$p(331));
                var e = $0af0d0faab426b68$var$K;
                $0af0d0faab426b68$var$K |= 4;
                for($0af0d0faab426b68$var$V = a.current; null !== $0af0d0faab426b68$var$V;){
                    var f = $0af0d0faab426b68$var$V, g = f.child;
                    if (0 !== ($0af0d0faab426b68$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0af0d0faab426b68$var$V = l; null !== $0af0d0faab426b68$var$V;){
                                    var m = $0af0d0faab426b68$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0af0d0faab426b68$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0af0d0faab426b68$var$V = q;
                                    else for(; null !== $0af0d0faab426b68$var$V;){
                                        m = $0af0d0faab426b68$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0af0d0faab426b68$var$Tj(m);
                                        if (m === l) {
                                            $0af0d0faab426b68$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0af0d0faab426b68$var$V = r;
                                            break;
                                        }
                                        $0af0d0faab426b68$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0af0d0faab426b68$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0af0d0faab426b68$var$V = g;
                    else b: for(; null !== $0af0d0faab426b68$var$V;){
                        f = $0af0d0faab426b68$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0af0d0faab426b68$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0af0d0faab426b68$var$V = x;
                            break b;
                        }
                        $0af0d0faab426b68$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0af0d0faab426b68$var$V = w; null !== $0af0d0faab426b68$var$V;){
                    g = $0af0d0faab426b68$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0af0d0faab426b68$var$V = u;
                    else b: for(g = w; null !== $0af0d0faab426b68$var$V;){
                        h = $0af0d0faab426b68$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0af0d0faab426b68$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0af0d0faab426b68$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0af0d0faab426b68$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0af0d0faab426b68$var$V = F;
                            break b;
                        }
                        $0af0d0faab426b68$var$V = h.return;
                    }
                }
                $0af0d0faab426b68$var$K = e;
                $0af0d0faab426b68$var$jg();
                if ($0af0d0faab426b68$var$lc && "function" === typeof $0af0d0faab426b68$var$lc.onPostCommitFiberRoot) try {
                    $0af0d0faab426b68$var$lc.onPostCommitFiberRoot($0af0d0faab426b68$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0af0d0faab426b68$var$C = c, $0af0d0faab426b68$var$pk.transition = b;
        }
    }
    return !1;
}
function $0af0d0faab426b68$var$Yk(a, b, c) {
    b = $0af0d0faab426b68$var$Ki(c, b);
    b = $0af0d0faab426b68$var$Oi(a, b, 1);
    a = $0af0d0faab426b68$var$dh(a, b, 1);
    b = $0af0d0faab426b68$var$L();
    null !== a && ($0af0d0faab426b68$var$Ac(a, 1, b), $0af0d0faab426b68$var$Ek(a, b));
}
function $0af0d0faab426b68$var$W(a, b, c) {
    if (3 === a.tag) $0af0d0faab426b68$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0af0d0faab426b68$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0af0d0faab426b68$var$Si || !$0af0d0faab426b68$var$Si.has(d))) {
                a = $0af0d0faab426b68$var$Ki(c, a);
                a = $0af0d0faab426b68$var$Ri(b, a, 1);
                b = $0af0d0faab426b68$var$dh(b, a, 1);
                a = $0af0d0faab426b68$var$L();
                null !== b && ($0af0d0faab426b68$var$Ac(b, 1, a), $0af0d0faab426b68$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0af0d0faab426b68$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0af0d0faab426b68$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0af0d0faab426b68$var$R === a && ($0af0d0faab426b68$var$Z & c) === c && (4 === $0af0d0faab426b68$var$T || 3 === $0af0d0faab426b68$var$T && ($0af0d0faab426b68$var$Z & 130023424) === $0af0d0faab426b68$var$Z && 500 > $0af0d0faab426b68$var$B() - $0af0d0faab426b68$var$gk ? $0af0d0faab426b68$var$Lk(a, 0) : $0af0d0faab426b68$var$sk |= c);
    $0af0d0faab426b68$var$Ek(a, b);
}
function $0af0d0faab426b68$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0af0d0faab426b68$var$sc, $0af0d0faab426b68$var$sc <<= 1, 0 === ($0af0d0faab426b68$var$sc & 130023424) && ($0af0d0faab426b68$var$sc = 4194304)));
    var c = $0af0d0faab426b68$var$L();
    a = $0af0d0faab426b68$var$Zg(a, b);
    null !== a && ($0af0d0faab426b68$var$Ac(a, b, c), $0af0d0faab426b68$var$Ek(a, c));
}
function $0af0d0faab426b68$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0af0d0faab426b68$var$Zk(a, c);
}
function $0af0d0faab426b68$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0af0d0faab426b68$var$p(314));
    }
    null !== d && d.delete(b);
    $0af0d0faab426b68$var$Zk(a, c);
}
var $0af0d0faab426b68$var$Wk;
$0af0d0faab426b68$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0af0d0faab426b68$var$Wf.current) $0af0d0faab426b68$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0af0d0faab426b68$var$Ug = !1, $0af0d0faab426b68$var$zj(a, b, c);
            $0af0d0faab426b68$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0af0d0faab426b68$var$Ug = !1, $0af0d0faab426b68$var$I && 0 !== (b.flags & 1048576) && $0af0d0faab426b68$var$ug(b, $0af0d0faab426b68$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0af0d0faab426b68$var$jj(a, b);
            a = b.pendingProps;
            var e = $0af0d0faab426b68$var$Yf(b, $0af0d0faab426b68$var$H.current);
            $0af0d0faab426b68$var$Tg(b, c);
            e = $0af0d0faab426b68$var$Xh(null, b, d, a, e, c);
            var f = $0af0d0faab426b68$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0af0d0faab426b68$var$Zf(d) ? (f = !0, $0af0d0faab426b68$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0af0d0faab426b68$var$ah(b), e.updater = $0af0d0faab426b68$var$nh, b.stateNode = e, e._reactInternals = b, $0af0d0faab426b68$var$rh(b, d, a, c), b = $0af0d0faab426b68$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0af0d0faab426b68$var$I && f && $0af0d0faab426b68$var$vg(b), $0af0d0faab426b68$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0af0d0faab426b68$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0af0d0faab426b68$var$$k(d);
                a = $0af0d0faab426b68$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0af0d0faab426b68$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0af0d0faab426b68$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0af0d0faab426b68$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0af0d0faab426b68$var$aj(null, b, d, $0af0d0faab426b68$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0af0d0faab426b68$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0af0d0faab426b68$var$Lg(d, e), $0af0d0faab426b68$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0af0d0faab426b68$var$Lg(d, e), $0af0d0faab426b68$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0af0d0faab426b68$var$lj(b);
                if (null === a) throw Error($0af0d0faab426b68$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0af0d0faab426b68$var$bh(a, b);
                $0af0d0faab426b68$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0af0d0faab426b68$var$Ki(Error($0af0d0faab426b68$var$p(423)), b);
                        b = $0af0d0faab426b68$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0af0d0faab426b68$var$Ki(Error($0af0d0faab426b68$var$p(424)), b);
                        b = $0af0d0faab426b68$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0af0d0faab426b68$var$yg = $0af0d0faab426b68$var$Lf(b.stateNode.containerInfo.firstChild), $0af0d0faab426b68$var$xg = b, $0af0d0faab426b68$var$I = !0, $0af0d0faab426b68$var$zg = null, c = $0af0d0faab426b68$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0af0d0faab426b68$var$Ig();
                    if (d === e) {
                        b = $0af0d0faab426b68$var$$i(a, b, c);
                        break a;
                    }
                    $0af0d0faab426b68$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0af0d0faab426b68$var$Kh(b), null === a && $0af0d0faab426b68$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0af0d0faab426b68$var$Ef(d, e) ? g = null : null !== f && $0af0d0faab426b68$var$Ef(d, f) && (b.flags |= 32), $0af0d0faab426b68$var$hj(a, b), $0af0d0faab426b68$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0af0d0faab426b68$var$Eg(b), null;
        case 13:
            return $0af0d0faab426b68$var$pj(a, b, c);
        case 4:
            return $0af0d0faab426b68$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0af0d0faab426b68$var$Bh(b, null, d, c) : $0af0d0faab426b68$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0af0d0faab426b68$var$Lg(d, e), $0af0d0faab426b68$var$Zi(a, b, d, e, c);
        case 7:
            return $0af0d0faab426b68$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0af0d0faab426b68$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0af0d0faab426b68$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0af0d0faab426b68$var$G($0af0d0faab426b68$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0af0d0faab426b68$var$He(f.value, g)) {
                        if (f.children === e.children && !$0af0d0faab426b68$var$Wf.current) {
                            b = $0af0d0faab426b68$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0af0d0faab426b68$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0af0d0faab426b68$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0af0d0faab426b68$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0af0d0faab426b68$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0af0d0faab426b68$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0af0d0faab426b68$var$Tg(b, c), e = $0af0d0faab426b68$var$Vg(e), d = d(e), b.flags |= 1, $0af0d0faab426b68$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0af0d0faab426b68$var$Lg(d, b.pendingProps), e = $0af0d0faab426b68$var$Lg(d.type, e), $0af0d0faab426b68$var$aj(a, b, d, e, c);
        case 15:
            return $0af0d0faab426b68$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0af0d0faab426b68$var$Lg(d, e), $0af0d0faab426b68$var$jj(a, b), b.tag = 1, $0af0d0faab426b68$var$Zf(d) ? (a = !0, $0af0d0faab426b68$var$cg(b)) : a = !1, $0af0d0faab426b68$var$Tg(b, c), $0af0d0faab426b68$var$ph(b, d, e), $0af0d0faab426b68$var$rh(b, d, e, c), $0af0d0faab426b68$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0af0d0faab426b68$var$yj(a, b, c);
        case 22:
            return $0af0d0faab426b68$var$ej(a, b, c);
    }
    throw Error($0af0d0faab426b68$var$p(156, b.tag));
};
function $0af0d0faab426b68$var$Gk(a, b) {
    return $0af0d0faab426b68$var$ac(a, b);
}
function $0af0d0faab426b68$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0af0d0faab426b68$var$Bg(a, b, c, d) {
    return new $0af0d0faab426b68$var$al(a, b, c, d);
}
function $0af0d0faab426b68$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0af0d0faab426b68$var$$k(a) {
    if ("function" === typeof a) return $0af0d0faab426b68$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0af0d0faab426b68$var$Da) return 11;
        if (a === $0af0d0faab426b68$var$Ga) return 14;
    }
    return 2;
}
function $0af0d0faab426b68$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0af0d0faab426b68$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0af0d0faab426b68$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0af0d0faab426b68$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0af0d0faab426b68$var$ya:
            return $0af0d0faab426b68$var$Ah(c.children, e, f, b);
        case $0af0d0faab426b68$var$za:
            g = 8;
            e |= 8;
            break;
        case $0af0d0faab426b68$var$Aa:
            return a = $0af0d0faab426b68$var$Bg(12, c, b, e | 2), a.elementType = $0af0d0faab426b68$var$Aa, a.lanes = f, a;
        case $0af0d0faab426b68$var$Ea:
            return a = $0af0d0faab426b68$var$Bg(13, c, b, e), a.elementType = $0af0d0faab426b68$var$Ea, a.lanes = f, a;
        case $0af0d0faab426b68$var$Fa:
            return a = $0af0d0faab426b68$var$Bg(19, c, b, e), a.elementType = $0af0d0faab426b68$var$Fa, a.lanes = f, a;
        case $0af0d0faab426b68$var$Ia:
            return $0af0d0faab426b68$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0af0d0faab426b68$var$Ba:
                    g = 10;
                    break a;
                case $0af0d0faab426b68$var$Ca:
                    g = 9;
                    break a;
                case $0af0d0faab426b68$var$Da:
                    g = 11;
                    break a;
                case $0af0d0faab426b68$var$Ga:
                    g = 14;
                    break a;
                case $0af0d0faab426b68$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0af0d0faab426b68$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0af0d0faab426b68$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0af0d0faab426b68$var$Ah(a, b, c, d) {
    a = $0af0d0faab426b68$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0af0d0faab426b68$var$qj(a, b, c, d) {
    a = $0af0d0faab426b68$var$Bg(22, a, d, b);
    a.elementType = $0af0d0faab426b68$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0af0d0faab426b68$var$xh(a, b, c) {
    a = $0af0d0faab426b68$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0af0d0faab426b68$var$zh(a, b, c) {
    b = $0af0d0faab426b68$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0af0d0faab426b68$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0af0d0faab426b68$var$zc(0);
    this.expirationTimes = $0af0d0faab426b68$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0af0d0faab426b68$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0af0d0faab426b68$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0af0d0faab426b68$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0af0d0faab426b68$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0af0d0faab426b68$var$ah(f);
    return a;
}
function $0af0d0faab426b68$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0af0d0faab426b68$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0af0d0faab426b68$var$el(a) {
    if (!a) return $0af0d0faab426b68$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0af0d0faab426b68$var$Vb(a) !== a || 1 !== a.tag) throw Error($0af0d0faab426b68$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0af0d0faab426b68$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0af0d0faab426b68$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0af0d0faab426b68$var$Zf(c)) return $0af0d0faab426b68$var$bg(a, c, b);
    }
    return b;
}
function $0af0d0faab426b68$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0af0d0faab426b68$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0af0d0faab426b68$var$el(null);
    c = a.current;
    d = $0af0d0faab426b68$var$L();
    e = $0af0d0faab426b68$var$lh(c);
    f = $0af0d0faab426b68$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0af0d0faab426b68$var$dh(c, f, e);
    a.current.lanes = e;
    $0af0d0faab426b68$var$Ac(a, e, d);
    $0af0d0faab426b68$var$Ek(a, d);
    return a;
}
function $0af0d0faab426b68$var$gl(a, b, c, d) {
    var e = b.current, f = $0af0d0faab426b68$var$L(), g = $0af0d0faab426b68$var$lh(e);
    c = $0af0d0faab426b68$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0af0d0faab426b68$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0af0d0faab426b68$var$dh(e, b, g);
    null !== a && ($0af0d0faab426b68$var$mh(a, e, g, f), $0af0d0faab426b68$var$eh(a, e, g));
    return g;
}
function $0af0d0faab426b68$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0af0d0faab426b68$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0af0d0faab426b68$var$jl(a, b) {
    $0af0d0faab426b68$var$il(a, b);
    (a = a.alternate) && $0af0d0faab426b68$var$il(a, b);
}
function $0af0d0faab426b68$var$kl() {
    return null;
}
var $0af0d0faab426b68$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0af0d0faab426b68$var$ml(a) {
    this._internalRoot = a;
}
$0af0d0faab426b68$var$nl.prototype.render = $0af0d0faab426b68$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0af0d0faab426b68$var$p(409));
    $0af0d0faab426b68$var$gl(a, b, null, null);
};
$0af0d0faab426b68$var$nl.prototype.unmount = $0af0d0faab426b68$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0af0d0faab426b68$var$Sk(function() {
            $0af0d0faab426b68$var$gl(null, a, null, null);
        });
        b[$0af0d0faab426b68$var$uf] = null;
    }
};
function $0af0d0faab426b68$var$nl(a) {
    this._internalRoot = a;
}
$0af0d0faab426b68$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0af0d0faab426b68$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0af0d0faab426b68$var$Qc.length && 0 !== b && b < $0af0d0faab426b68$var$Qc[c].priority; c++);
        $0af0d0faab426b68$var$Qc.splice(c, 0, a);
        0 === c && $0af0d0faab426b68$var$Vc(a);
    }
};
function $0af0d0faab426b68$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0af0d0faab426b68$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0af0d0faab426b68$var$ql() {}
function $0af0d0faab426b68$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0af0d0faab426b68$var$hl(g);
                f.call(a);
            };
        }
        var g = $0af0d0faab426b68$var$fl(b, d, a, 0, null, !1, !1, "", $0af0d0faab426b68$var$ql);
        a._reactRootContainer = g;
        a[$0af0d0faab426b68$var$uf] = g.current;
        $0af0d0faab426b68$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0af0d0faab426b68$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0af0d0faab426b68$var$hl(k);
            h.call(a);
        };
    }
    var k = $0af0d0faab426b68$var$cl(a, 0, !1, null, null, !1, !1, "", $0af0d0faab426b68$var$ql);
    a._reactRootContainer = k;
    a[$0af0d0faab426b68$var$uf] = k.current;
    $0af0d0faab426b68$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0af0d0faab426b68$var$Sk(function() {
        $0af0d0faab426b68$var$gl(b, k, c, d);
    });
    return k;
}
function $0af0d0faab426b68$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0af0d0faab426b68$var$hl(g);
                h.call(a);
            };
        }
        $0af0d0faab426b68$var$gl(b, g, a, e);
    } else g = $0af0d0faab426b68$var$rl(c, b, a, e, d);
    return $0af0d0faab426b68$var$hl(g);
}
$0af0d0faab426b68$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0af0d0faab426b68$var$tc(b.pendingLanes);
                0 !== c && ($0af0d0faab426b68$var$Cc(b, c | 1), $0af0d0faab426b68$var$Ek(b, $0af0d0faab426b68$var$B()), 0 === ($0af0d0faab426b68$var$K & 6) && ($0af0d0faab426b68$var$Hj = $0af0d0faab426b68$var$B() + 500, $0af0d0faab426b68$var$jg()));
            }
            break;
        case 13:
            $0af0d0faab426b68$var$Sk(function() {
                var b = $0af0d0faab426b68$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0af0d0faab426b68$var$L();
                    $0af0d0faab426b68$var$mh(b, a, 1, c);
                }
            }), $0af0d0faab426b68$var$jl(a, 1);
    }
};
$0af0d0faab426b68$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0af0d0faab426b68$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0af0d0faab426b68$var$L();
            $0af0d0faab426b68$var$mh(b, a, 134217728, c);
        }
        $0af0d0faab426b68$var$jl(a, 134217728);
    }
};
$0af0d0faab426b68$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0af0d0faab426b68$var$lh(a), c = $0af0d0faab426b68$var$Zg(a, b);
        if (null !== c) {
            var d = $0af0d0faab426b68$var$L();
            $0af0d0faab426b68$var$mh(c, a, b, d);
        }
        $0af0d0faab426b68$var$jl(a, b);
    }
};
$0af0d0faab426b68$var$Hc = function() {
    return $0af0d0faab426b68$var$C;
};
$0af0d0faab426b68$var$Ic = function(a, b) {
    var c = $0af0d0faab426b68$var$C;
    try {
        return $0af0d0faab426b68$var$C = a, b();
    } finally{
        $0af0d0faab426b68$var$C = c;
    }
};
$0af0d0faab426b68$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0af0d0faab426b68$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0af0d0faab426b68$var$Db(d);
                        if (!e) throw Error($0af0d0faab426b68$var$p(90));
                        $0af0d0faab426b68$var$Wa(d);
                        $0af0d0faab426b68$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0af0d0faab426b68$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0af0d0faab426b68$var$fb(a, !!c.multiple, b, !1);
    }
};
$0af0d0faab426b68$var$Gb = $0af0d0faab426b68$var$Rk;
$0af0d0faab426b68$var$Hb = $0af0d0faab426b68$var$Sk;
var $0af0d0faab426b68$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0af0d0faab426b68$var$Cb,
        $0af0d0faab426b68$var$ue,
        $0af0d0faab426b68$var$Db,
        $0af0d0faab426b68$var$Eb,
        $0af0d0faab426b68$var$Fb,
        $0af0d0faab426b68$var$Rk
    ]
}, $0af0d0faab426b68$var$ul = {
    findFiberByHostInstance: $0af0d0faab426b68$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0af0d0faab426b68$var$vl = {
    bundleType: $0af0d0faab426b68$var$ul.bundleType,
    version: $0af0d0faab426b68$var$ul.version,
    rendererPackageName: $0af0d0faab426b68$var$ul.rendererPackageName,
    rendererConfig: $0af0d0faab426b68$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0af0d0faab426b68$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0af0d0faab426b68$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0af0d0faab426b68$var$ul.findFiberByHostInstance || $0af0d0faab426b68$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0af0d0faab426b68$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0af0d0faab426b68$var$wl.isDisabled && $0af0d0faab426b68$var$wl.supportsFiber) try {
        $0af0d0faab426b68$var$kc = $0af0d0faab426b68$var$wl.inject($0af0d0faab426b68$var$vl), $0af0d0faab426b68$var$lc = $0af0d0faab426b68$var$wl;
    } catch (a) {}
}
$0af0d0faab426b68$export$ae55be85d98224ed = $0af0d0faab426b68$var$tl;
$0af0d0faab426b68$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0af0d0faab426b68$var$ol(b)) throw Error($0af0d0faab426b68$var$p(200));
    return $0af0d0faab426b68$var$dl(a, b, null, c);
};
$0af0d0faab426b68$export$882461b6382ed46c = function(a, b) {
    if (!$0af0d0faab426b68$var$ol(a)) throw Error($0af0d0faab426b68$var$p(299));
    var c = !1, d = "", e = $0af0d0faab426b68$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0af0d0faab426b68$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0af0d0faab426b68$var$uf] = b.current;
    $0af0d0faab426b68$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0af0d0faab426b68$var$ml(b);
};
$0af0d0faab426b68$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0af0d0faab426b68$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0af0d0faab426b68$var$p(268, a));
    }
    a = $0af0d0faab426b68$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0af0d0faab426b68$export$cd75ccfd720a3cd4 = function(a) {
    return $0af0d0faab426b68$var$Sk(a);
};
$0af0d0faab426b68$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0af0d0faab426b68$var$pl(b)) throw Error($0af0d0faab426b68$var$p(200));
    return $0af0d0faab426b68$var$sl(null, a, b, !0, c);
};
$0af0d0faab426b68$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0af0d0faab426b68$var$ol(a)) throw Error($0af0d0faab426b68$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0af0d0faab426b68$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0af0d0faab426b68$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0af0d0faab426b68$var$uf] = b.current;
    $0af0d0faab426b68$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0af0d0faab426b68$var$nl(b);
};
$0af0d0faab426b68$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0af0d0faab426b68$var$pl(b)) throw Error($0af0d0faab426b68$var$p(200));
    return $0af0d0faab426b68$var$sl(null, a, b, !1, c);
};
$0af0d0faab426b68$export$502457920280e6be = function(a) {
    if (!$0af0d0faab426b68$var$pl(a)) throw Error($0af0d0faab426b68$var$p(40));
    return a._reactRootContainer ? ($0af0d0faab426b68$var$Sk(function() {
        $0af0d0faab426b68$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0af0d0faab426b68$var$uf] = null;
        });
    }), !0) : !1;
};
$0af0d0faab426b68$export$c78a37762a8d58e1 = $0af0d0faab426b68$var$Rk;
$0af0d0faab426b68$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0af0d0faab426b68$var$pl(c)) throw Error($0af0d0faab426b68$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0af0d0faab426b68$var$p(38));
    return $0af0d0faab426b68$var$sl(a, b, c, !1, d);
};
$0af0d0faab426b68$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("74qJ9", function(module, exports) {
"use strict";

module.exports = (parcelRequire("euVoi"));

});
parcelRequire.register("euVoi", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $a8e062ac81949a09$export$c4744153514ff05d, (v) => $a8e062ac81949a09$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $a8e062ac81949a09$export$3e506c1ccc9cc1a7, (v) => $a8e062ac81949a09$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $a8e062ac81949a09$export$e26fe2ed2fa76875, (v) => $a8e062ac81949a09$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $a8e062ac81949a09$export$502329bbf4b505b1, (v) => $a8e062ac81949a09$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $a8e062ac81949a09$export$6e3807111c4874c4, (v) => $a8e062ac81949a09$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $a8e062ac81949a09$export$c27134553091fb3a, (v) => $a8e062ac81949a09$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $a8e062ac81949a09$export$33ee1acdc04fd2a2, (v) => $a8e062ac81949a09$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $a8e062ac81949a09$export$b00a404bbd5edef2, (v) => $a8e062ac81949a09$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $a8e062ac81949a09$export$8352ce38b91d0c62, (v) => $a8e062ac81949a09$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $a8e062ac81949a09$export$d66a1c1c77bd778b, (v) => $a8e062ac81949a09$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $a8e062ac81949a09$export$d3dfb8e4810cb555, (v) => $a8e062ac81949a09$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $a8e062ac81949a09$export$839f9183b0465a69, (v) => $a8e062ac81949a09$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $a8e062ac81949a09$export$72fdf0e06517287b, (v) => $a8e062ac81949a09$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $a8e062ac81949a09$export$4b844e58a3e414b4, (v) => $a8e062ac81949a09$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $a8e062ac81949a09$export$816d2913ae6b83b1, (v) => $a8e062ac81949a09$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $a8e062ac81949a09$export$61bcfe829111a1d0, (v) => $a8e062ac81949a09$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $a8e062ac81949a09$export$7ee8c9beb337bc3f, (v) => $a8e062ac81949a09$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $a8e062ac81949a09$export$b5836b71941fa3ed, (v) => $a8e062ac81949a09$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $a8e062ac81949a09$export$cf845f2c119da08a, (v) => $a8e062ac81949a09$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a8e062ac81949a09$export$c4744153514ff05d;
var $a8e062ac81949a09$export$3e506c1ccc9cc1a7;
var $a8e062ac81949a09$export$e26fe2ed2fa76875;
var $a8e062ac81949a09$export$502329bbf4b505b1;
var $a8e062ac81949a09$export$6e3807111c4874c4;
var $a8e062ac81949a09$export$c27134553091fb3a;
var $a8e062ac81949a09$export$33ee1acdc04fd2a2;
var $a8e062ac81949a09$export$b00a404bbd5edef2;
var $a8e062ac81949a09$export$8352ce38b91d0c62;
var $a8e062ac81949a09$export$d66a1c1c77bd778b;
var $a8e062ac81949a09$export$d3dfb8e4810cb555;
var $a8e062ac81949a09$export$839f9183b0465a69;
var $a8e062ac81949a09$export$72fdf0e06517287b;
var $a8e062ac81949a09$export$4b844e58a3e414b4;
var $a8e062ac81949a09$export$816d2913ae6b83b1;
var $a8e062ac81949a09$export$61bcfe829111a1d0;
var $a8e062ac81949a09$export$7ee8c9beb337bc3f;
var $a8e062ac81949a09$export$b5836b71941fa3ed;
var $a8e062ac81949a09$export$cf845f2c119da08a;
"use strict";
function $a8e062ac81949a09$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $a8e062ac81949a09$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $a8e062ac81949a09$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $a8e062ac81949a09$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $a8e062ac81949a09$var$g(C, c)) n < e && 0 > $a8e062ac81949a09$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $a8e062ac81949a09$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $a8e062ac81949a09$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $a8e062ac81949a09$var$l = performance;
    $a8e062ac81949a09$export$c4744153514ff05d = function() {
        return $a8e062ac81949a09$var$l.now();
    };
} else {
    var $a8e062ac81949a09$var$p = Date, $a8e062ac81949a09$var$q = $a8e062ac81949a09$var$p.now();
    $a8e062ac81949a09$export$c4744153514ff05d = function() {
        return $a8e062ac81949a09$var$p.now() - $a8e062ac81949a09$var$q;
    };
}
var $a8e062ac81949a09$var$r = [], $a8e062ac81949a09$var$t = [], $a8e062ac81949a09$var$u = 1, $a8e062ac81949a09$var$v = null, $a8e062ac81949a09$var$y = 3, $a8e062ac81949a09$var$z = !1, $a8e062ac81949a09$var$A = !1, $a8e062ac81949a09$var$B = !1, $a8e062ac81949a09$var$D = "function" === typeof setTimeout ? setTimeout : null, $a8e062ac81949a09$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $a8e062ac81949a09$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $a8e062ac81949a09$var$G(a) {
    for(var b = $a8e062ac81949a09$var$h($a8e062ac81949a09$var$t); null !== b;){
        if (null === b.callback) $a8e062ac81949a09$var$k($a8e062ac81949a09$var$t);
        else if (b.startTime <= a) $a8e062ac81949a09$var$k($a8e062ac81949a09$var$t), b.sortIndex = b.expirationTime, $a8e062ac81949a09$var$f($a8e062ac81949a09$var$r, b);
        else break;
        b = $a8e062ac81949a09$var$h($a8e062ac81949a09$var$t);
    }
}
function $a8e062ac81949a09$var$H(a) {
    $a8e062ac81949a09$var$B = !1;
    $a8e062ac81949a09$var$G(a);
    if (!$a8e062ac81949a09$var$A) {
        if (null !== $a8e062ac81949a09$var$h($a8e062ac81949a09$var$r)) $a8e062ac81949a09$var$A = !0, $a8e062ac81949a09$var$I($a8e062ac81949a09$var$J);
        else {
            var b = $a8e062ac81949a09$var$h($a8e062ac81949a09$var$t);
            null !== b && $a8e062ac81949a09$var$K($a8e062ac81949a09$var$H, b.startTime - a);
        }
    }
}
function $a8e062ac81949a09$var$J(a, b) {
    $a8e062ac81949a09$var$A = !1;
    $a8e062ac81949a09$var$B && ($a8e062ac81949a09$var$B = !1, $a8e062ac81949a09$var$E($a8e062ac81949a09$var$L), $a8e062ac81949a09$var$L = -1);
    $a8e062ac81949a09$var$z = !0;
    var c = $a8e062ac81949a09$var$y;
    try {
        $a8e062ac81949a09$var$G(b);
        for($a8e062ac81949a09$var$v = $a8e062ac81949a09$var$h($a8e062ac81949a09$var$r); null !== $a8e062ac81949a09$var$v && (!($a8e062ac81949a09$var$v.expirationTime > b) || a && !$a8e062ac81949a09$var$M());){
            var d = $a8e062ac81949a09$var$v.callback;
            if ("function" === typeof d) {
                $a8e062ac81949a09$var$v.callback = null;
                $a8e062ac81949a09$var$y = $a8e062ac81949a09$var$v.priorityLevel;
                var e = d($a8e062ac81949a09$var$v.expirationTime <= b);
                b = $a8e062ac81949a09$export$c4744153514ff05d();
                "function" === typeof e ? $a8e062ac81949a09$var$v.callback = e : $a8e062ac81949a09$var$v === $a8e062ac81949a09$var$h($a8e062ac81949a09$var$r) && $a8e062ac81949a09$var$k($a8e062ac81949a09$var$r);
                $a8e062ac81949a09$var$G(b);
            } else $a8e062ac81949a09$var$k($a8e062ac81949a09$var$r);
            $a8e062ac81949a09$var$v = $a8e062ac81949a09$var$h($a8e062ac81949a09$var$r);
        }
        if (null !== $a8e062ac81949a09$var$v) var w = !0;
        else {
            var m = $a8e062ac81949a09$var$h($a8e062ac81949a09$var$t);
            null !== m && $a8e062ac81949a09$var$K($a8e062ac81949a09$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $a8e062ac81949a09$var$v = null, $a8e062ac81949a09$var$y = c, $a8e062ac81949a09$var$z = !1;
    }
}
var $a8e062ac81949a09$var$N = !1, $a8e062ac81949a09$var$O = null, $a8e062ac81949a09$var$L = -1, $a8e062ac81949a09$var$P = 5, $a8e062ac81949a09$var$Q = -1;
function $a8e062ac81949a09$var$M() {
    return $a8e062ac81949a09$export$c4744153514ff05d() - $a8e062ac81949a09$var$Q < $a8e062ac81949a09$var$P ? !1 : !0;
}
function $a8e062ac81949a09$var$R() {
    if (null !== $a8e062ac81949a09$var$O) {
        var a = $a8e062ac81949a09$export$c4744153514ff05d();
        $a8e062ac81949a09$var$Q = a;
        var b = !0;
        try {
            b = $a8e062ac81949a09$var$O(!0, a);
        } finally{
            b ? $a8e062ac81949a09$var$S() : ($a8e062ac81949a09$var$N = !1, $a8e062ac81949a09$var$O = null);
        }
    } else $a8e062ac81949a09$var$N = !1;
}
var $a8e062ac81949a09$var$S;
if ("function" === typeof $a8e062ac81949a09$var$F) $a8e062ac81949a09$var$S = function() {
    $a8e062ac81949a09$var$F($a8e062ac81949a09$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $a8e062ac81949a09$var$T = new MessageChannel, $a8e062ac81949a09$var$U = $a8e062ac81949a09$var$T.port2;
    $a8e062ac81949a09$var$T.port1.onmessage = $a8e062ac81949a09$var$R;
    $a8e062ac81949a09$var$S = function() {
        $a8e062ac81949a09$var$U.postMessage(null);
    };
} else $a8e062ac81949a09$var$S = function() {
    $a8e062ac81949a09$var$D($a8e062ac81949a09$var$R, 0);
};
function $a8e062ac81949a09$var$I(a) {
    $a8e062ac81949a09$var$O = a;
    $a8e062ac81949a09$var$N || ($a8e062ac81949a09$var$N = !0, $a8e062ac81949a09$var$S());
}
function $a8e062ac81949a09$var$K(a, b) {
    $a8e062ac81949a09$var$L = $a8e062ac81949a09$var$D(function() {
        a($a8e062ac81949a09$export$c4744153514ff05d());
    }, b);
}
$a8e062ac81949a09$export$3e506c1ccc9cc1a7 = 5;
$a8e062ac81949a09$export$e26fe2ed2fa76875 = 1;
$a8e062ac81949a09$export$502329bbf4b505b1 = 4;
$a8e062ac81949a09$export$6e3807111c4874c4 = 3;
$a8e062ac81949a09$export$c27134553091fb3a = null;
$a8e062ac81949a09$export$33ee1acdc04fd2a2 = 2;
$a8e062ac81949a09$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$a8e062ac81949a09$export$8352ce38b91d0c62 = function() {
    $a8e062ac81949a09$var$A || $a8e062ac81949a09$var$z || ($a8e062ac81949a09$var$A = !0, $a8e062ac81949a09$var$I($a8e062ac81949a09$var$J));
};
$a8e062ac81949a09$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $a8e062ac81949a09$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$a8e062ac81949a09$export$d3dfb8e4810cb555 = function() {
    return $a8e062ac81949a09$var$y;
};
$a8e062ac81949a09$export$839f9183b0465a69 = function() {
    return $a8e062ac81949a09$var$h($a8e062ac81949a09$var$r);
};
$a8e062ac81949a09$export$72fdf0e06517287b = function(a) {
    switch($a8e062ac81949a09$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $a8e062ac81949a09$var$y;
    }
    var c = $a8e062ac81949a09$var$y;
    $a8e062ac81949a09$var$y = b;
    try {
        return a();
    } finally{
        $a8e062ac81949a09$var$y = c;
    }
};
$a8e062ac81949a09$export$4b844e58a3e414b4 = function() {};
$a8e062ac81949a09$export$816d2913ae6b83b1 = function() {};
$a8e062ac81949a09$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $a8e062ac81949a09$var$y;
    $a8e062ac81949a09$var$y = a;
    try {
        return b();
    } finally{
        $a8e062ac81949a09$var$y = c;
    }
};
$a8e062ac81949a09$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $a8e062ac81949a09$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $a8e062ac81949a09$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $a8e062ac81949a09$var$f($a8e062ac81949a09$var$t, a), null === $a8e062ac81949a09$var$h($a8e062ac81949a09$var$r) && a === $a8e062ac81949a09$var$h($a8e062ac81949a09$var$t) && ($a8e062ac81949a09$var$B ? ($a8e062ac81949a09$var$E($a8e062ac81949a09$var$L), $a8e062ac81949a09$var$L = -1) : $a8e062ac81949a09$var$B = !0, $a8e062ac81949a09$var$K($a8e062ac81949a09$var$H, c - d))) : (a.sortIndex = e, $a8e062ac81949a09$var$f($a8e062ac81949a09$var$r, a), $a8e062ac81949a09$var$A || $a8e062ac81949a09$var$z || ($a8e062ac81949a09$var$A = !0, $a8e062ac81949a09$var$I($a8e062ac81949a09$var$J)));
    return a;
};
$a8e062ac81949a09$export$b5836b71941fa3ed = $a8e062ac81949a09$var$M;
$a8e062ac81949a09$export$cf845f2c119da08a = function(a) {
    var b = $a8e062ac81949a09$var$y;
    return function() {
        var c = $a8e062ac81949a09$var$y;
        $a8e062ac81949a09$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $a8e062ac81949a09$var$y = c;
        }
    };
};

});



parcelRequire.register("fdGrT", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b148ff5b5aa079db$var$ReactIs, $b148ff5b5aa079db$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("7in6f"))();

});
parcelRequire.register("7in6f", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $7bPDF = parcelRequire("7bPDF");
function $54fc21f9f61dba00$var$emptyFunction() {}
function $54fc21f9f61dba00$var$emptyFunctionWithReset() {}
$54fc21f9f61dba00$var$emptyFunctionWithReset.resetWarningCache = $54fc21f9f61dba00$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $7bPDF) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $54fc21f9f61dba00$var$emptyFunctionWithReset,
        resetWarningCache: $54fc21f9f61dba00$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("7bPDF", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $53c19de1399be13b$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $53c19de1399be13b$var$ReactPropTypesSecret;

});



parcelRequire.register("8Gg0l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $651ea920ecc257a4$var$_react = $651ea920ecc257a4$var$_interopRequireDefault((parcelRequire("8T3gX")));

var $651ea920ecc257a4$var$_propTypes = $651ea920ecc257a4$var$_interopRequireDefault((parcelRequire("fdGrT")));
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
var $3T949 = parcelRequire("3T949");
var $651ea920ecc257a4$var$_excluded = [
    "children",
    "onClick",
    "replace",
    "to",
    "state",
    "activeClassName",
    "className",
    "activeStyle",
    "style",
    "isActive"
];
function $651ea920ecc257a4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $651ea920ecc257a4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $651ea920ecc257a4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $651ea920ecc257a4$var$ownKeys(Object(source), !0).forEach(function(key) {
            $651ea920ecc257a4$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $651ea920ecc257a4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $651ea920ecc257a4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $651ea920ecc257a4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $651ea920ecc257a4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $651ea920ecc257a4$var$_typeof(obj);
}
function $651ea920ecc257a4$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $651ea920ecc257a4$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $651ea920ecc257a4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $651ea920ecc257a4$var$isModifiedEvent = function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};
var $651ea920ecc257a4$var$LinkContainer = function LinkContainer(_ref) {
    var children = _ref.children, onClick = _ref.onClick, replace = _ref.replace, to = _ref.to, state = _ref.state, activeClassName = _ref.activeClassName, className = _ref.className, activeStyle = _ref.activeStyle, style = _ref.style, getIsActive = _ref.isActive, props = $651ea920ecc257a4$var$_objectWithoutProperties(_ref, $651ea920ecc257a4$var$_excluded);
    var path = $651ea920ecc257a4$var$_typeof(to) === "object" ? to.pathname || "" : to;
    var navigate = (0, $3T949.useNavigate)();
    var href = (0, $3T949.useHref)(typeof to === "string" ? {
        pathname: to
    } : to);
    var match = (0, $3T949.useMatch)(path);
    var location = (0, $3T949.useLocation)();
    var child = $651ea920ecc257a4$var$_react["default"].Children.only(children);
    var isActive = !!(getIsActive ? typeof getIsActive === "function" ? getIsActive(match, location) : getIsActive : match);
    var handleClick = function handleClick(event) {
        if (children.props.onClick) children.props.onClick(event);
        if (onClick) onClick(event);
        if (!event.defaultPrevented && // onClick prevented default
        event.button === 0 && // ignore right clicks
        !$651ea920ecc257a4$var$isModifiedEvent(event) // ignore clicks with modifier keys
        ) {
            event.preventDefault();
            navigate(to, {
                replace: replace,
                state: state
            });
        }
    };
    return /*#__PURE__*/ $651ea920ecc257a4$var$_react["default"].cloneElement(child, $651ea920ecc257a4$var$_objectSpread($651ea920ecc257a4$var$_objectSpread({}, props), {}, {
        className: [
            className,
            child.props.className,
            isActive ? activeClassName : null
        ].join(" ").trim(),
        style: isActive ? $651ea920ecc257a4$var$_objectSpread($651ea920ecc257a4$var$_objectSpread({}, style), activeStyle) : style,
        href: href,
        onClick: handleClick
    }));
};
$651ea920ecc257a4$var$LinkContainer.propTypes = {
    children: $651ea920ecc257a4$var$_propTypes["default"].element.isRequired,
    onClick: $651ea920ecc257a4$var$_propTypes["default"].func,
    replace: $651ea920ecc257a4$var$_propTypes["default"].bool,
    to: $651ea920ecc257a4$var$_propTypes["default"].oneOfType([
        $651ea920ecc257a4$var$_propTypes["default"].string,
        $651ea920ecc257a4$var$_propTypes["default"].object
    ]).isRequired,
    state: $651ea920ecc257a4$var$_propTypes["default"].object,
    className: $651ea920ecc257a4$var$_propTypes["default"].string,
    activeClassName: $651ea920ecc257a4$var$_propTypes["default"].string,
    style: $651ea920ecc257a4$var$_propTypes["default"].objectOf($651ea920ecc257a4$var$_propTypes["default"].oneOfType([
        $651ea920ecc257a4$var$_propTypes["default"].string,
        $651ea920ecc257a4$var$_propTypes["default"].number
    ])),
    activeStyle: $651ea920ecc257a4$var$_propTypes["default"].objectOf($651ea920ecc257a4$var$_propTypes["default"].oneOfType([
        $651ea920ecc257a4$var$_propTypes["default"].string,
        $651ea920ecc257a4$var$_propTypes["default"].number
    ])),
    isActive: $651ea920ecc257a4$var$_propTypes["default"].oneOfType([
        $651ea920ecc257a4$var$_propTypes["default"].func,
        $651ea920ecc257a4$var$_propTypes["default"].bool
    ])
};
$651ea920ecc257a4$var$LinkContainer.defaultProps = {
    replace: false,
    activeClassName: "active",
    onClick: null,
    className: null,
    style: null,
    activeStyle: null,
    isActive: null
};
var $651ea920ecc257a4$var$_default = $651ea920ecc257a4$var$LinkContainer;
module.exports["default"] = $651ea920ecc257a4$var$_default;

});
parcelRequire.register("fIsAN", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", () => $b71124f85d4fc180$export$9ba4e89fdfa1fc54);
$parcel$export(module.exports, "Link", () => $b71124f85d4fc180$export$a6c7ac8248d6e38a);
$parcel$export(module.exports, "NavLink", () => $b71124f85d4fc180$export$b0d92dbee9b5b60d);
$parcel$export(module.exports, "useHref", () => (parcelRequire("3T949")).useHref);
$parcel$export(module.exports, "useLocation", () => (parcelRequire("3T949")).useLocation);
$parcel$export(module.exports, "useNavigate", () => (parcelRequire("3T949")).useNavigate);
/**
 * React Router DOM v6.13.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8T3gX = parcelRequire("8T3gX");

var $bnQ5y = parcelRequire("bnQ5y");
var $3T949 = parcelRequire("3T949");

var $bnQ5y = parcelRequire("bnQ5y");
function $b71124f85d4fc180$var$_extends() {
    $b71124f85d4fc180$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b71124f85d4fc180$var$_extends.apply(this, arguments);
}
function $b71124f85d4fc180$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $b71124f85d4fc180$var$defaultMethod = "get";
const $b71124f85d4fc180$var$defaultEncType = "application/x-www-form-urlencoded";
function $b71124f85d4fc180$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $b71124f85d4fc180$var$isButtonElement(object) {
    return $b71124f85d4fc180$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $b71124f85d4fc180$var$isFormElement(object) {
    return $b71124f85d4fc180$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $b71124f85d4fc180$var$isInputElement(object) {
    return $b71124f85d4fc180$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $b71124f85d4fc180$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $b71124f85d4fc180$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$b71124f85d4fc180$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $b71124f85d4fc180$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $b71124f85d4fc180$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $b71124f85d4fc180$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) {
        for (let key of defaultSearchParams.keys())if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    }
    return searchParams;
}
function $b71124f85d4fc180$var$getFormSubmissionInfo(target, options, basename) {
    let method;
    let action = null;
    let encType;
    let formData;
    if ($b71124f85d4fc180$var$isFormElement(target)) {
        let submissionTrigger = options.submissionTrigger;
        if (options.action) action = options.action;
        else {
            // When grabbing the action from the element, it will have had the basename
            // prefixed to ensure non-JS scenarios work, so strip it since we'll
            // re-prefix in the router
            let attr = target.getAttribute("action");
            action = attr ? (0, $bnQ5y.stripBasename)(attr, basename) : null;
        }
        method = options.method || target.getAttribute("method") || $b71124f85d4fc180$var$defaultMethod;
        encType = options.encType || target.getAttribute("enctype") || $b71124f85d4fc180$var$defaultEncType;
        formData = new FormData(target);
        if (submissionTrigger && submissionTrigger.name) formData.append(submissionTrigger.name, submissionTrigger.value);
    } else if ($b71124f85d4fc180$var$isButtonElement(target) || $b71124f85d4fc180$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        if (options.action) action = options.action;
        else {
            // When grabbing the action from the element, it will have had the basename
            // prefixed to ensure non-JS scenarios work, so strip it since we'll
            // re-prefix in the router
            let attr = target.getAttribute("formaction") || form.getAttribute("action");
            action = attr ? (0, $bnQ5y.stripBasename)(attr, basename) : null;
        }
        method = options.method || target.getAttribute("formmethod") || form.getAttribute("method") || $b71124f85d4fc180$var$defaultMethod;
        encType = options.encType || target.getAttribute("formenctype") || form.getAttribute("enctype") || $b71124f85d4fc180$var$defaultEncType;
        formData = new FormData(form);
        // Include name + value from a <button>, appending in case the button name
        // matches an existing input name
        if (target.name) formData.append(target.name, target.value);
    } else if ($b71124f85d4fc180$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = options.method || $b71124f85d4fc180$var$defaultMethod;
        action = options.action || null;
        encType = options.encType || $b71124f85d4fc180$var$defaultEncType;
        if (target instanceof FormData) formData = target;
        else {
            formData = new FormData();
            if (target instanceof URLSearchParams) for (let [name, value] of target)formData.append(name, value);
            else if (target != null) for (let name of Object.keys(target))formData.append(name, target[name]);
        }
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData
    };
}
const $b71124f85d4fc180$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $b71124f85d4fc180$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $b71124f85d4fc180$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "method",
    "action",
    "onSubmit",
    "fetcherKey",
    "routeId",
    "relative",
    "preventScrollReset"
];
function $b71124f85d4fc180$export$1f3f55432a00e06d(routes, opts) {
    return (0, $bnQ5y.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $b71124f85d4fc180$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $bnQ5y.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $b71124f85d4fc180$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $3T949.UNSAFE_mapRouteProperties)
    }).initialize();
}
function $b71124f85d4fc180$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $bnQ5y.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $b71124f85d4fc180$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $bnQ5y.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $b71124f85d4fc180$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $3T949.UNSAFE_mapRouteProperties)
    }).initialize();
}
function $b71124f85d4fc180$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $b71124f85d4fc180$var$_extends({}, state, {
        errors: $b71124f85d4fc180$var$deserializeErrors(state.errors)
    });
    return state;
}
function $b71124f85d4fc180$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $bnQ5y.ErrorResponse)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            let error = new Error(val.message);
            // Wipe away the client-side stack trace.  Nothing to fill it in with
            // because we don't serialize SSR stack traces for security reasons
            error.stack = "";
            serialized[key] = error;
        } else serialized[key] = val;
    }
    return serialized;
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $b71124f85d4fc180$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename , children: children , future: future , window: window1  } = _ref;
    let historyRef = $8T3gX.useRef();
    if (historyRef.current == null) historyRef.current = (0, $bnQ5y.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8T3gX.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition  } = future || {};
    let setState = $8T3gX.useCallback((newState)=>{
        v7_startTransition && (0, $3T949.UNSAFE_startTransitionImpl) ? (0, $3T949.UNSAFE_startTransitionImpl)(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8T3gX.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8T3gX.createElement((0, $3T949.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $b71124f85d4fc180$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename , children: children , future: future , window: window1  } = _ref2;
    let historyRef = $8T3gX.useRef();
    if (historyRef.current == null) historyRef.current = (0, $bnQ5y.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8T3gX.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition  } = future || {};
    let setState = $8T3gX.useCallback((newState)=>{
        v7_startTransition && (0, $3T949.UNSAFE_startTransitionImpl) ? (0, $3T949.UNSAFE_startTransitionImpl)(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8T3gX.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8T3gX.createElement((0, $3T949.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $b71124f85d4fc180$export$eefb0c834599897e(_ref3) {
    let { basename: basename , children: children , future: future , history: history  } = _ref3;
    let [state, setStateImpl] = $8T3gX.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition  } = future || {};
    let setState = $8T3gX.useCallback((newState)=>{
        v7_startTransition && (0, $3T949.UNSAFE_startTransitionImpl) ? (0, $3T949.UNSAFE_startTransitionImpl)(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8T3gX.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8T3gX.createElement((0, $3T949.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $b71124f85d4fc180$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $b71124f85d4fc180$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ const $b71124f85d4fc180$export$a6c7ac8248d6e38a = /*#__PURE__*/ $8T3gX.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick , relative: relative , reloadDocument: reloadDocument , replace: replace , state: state , target: target , to: to , preventScrollReset: preventScrollReset  } = _ref4, rest = $b71124f85d4fc180$var$_objectWithoutPropertiesLoose(_ref4, $b71124f85d4fc180$var$_excluded);
    let { basename: basename  } = $8T3gX.useContext((0, $3T949.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $b71124f85d4fc180$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($b71124f85d4fc180$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $bnQ5y.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $3T949.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $b71124f85d4fc180$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $8T3gX.createElement("a", $b71124f85d4fc180$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $b71124f85d4fc180$export$b0d92dbee9b5b60d = /*#__PURE__*/ $8T3gX.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page" , caseSensitive: caseSensitive = false , className: classNameProp = "" , end: end = false , style: styleProp , to: to , children: children  } = _ref5, rest = $b71124f85d4fc180$var$_objectWithoutPropertiesLoose(_ref5, $b71124f85d4fc180$var$_excluded2);
    let path = (0, $3T949.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $3T949.useLocation)();
    let routerState = $8T3gX.useContext((0, $3T949.UNSAFE_DataRouterStateContext));
    let { navigator: navigator  } = $8T3gX.useContext((0, $3T949.UNSAFE_NavigationContext));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $8T3gX.createElement($b71124f85d4fc180$export$a6c7ac8248d6e38a, $b71124f85d4fc180$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $b71124f85d4fc180$export$a7fed597f4b8afd8 = /*#__PURE__*/ $8T3gX.forwardRef((props, ref)=>{
    return /*#__PURE__*/ $8T3gX.createElement($b71124f85d4fc180$var$FormImpl, $b71124f85d4fc180$var$_extends({}, props, {
        ref: ref
    }));
});
const $b71124f85d4fc180$var$FormImpl = /*#__PURE__*/ $8T3gX.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument , replace: replace , method: method = $b71124f85d4fc180$var$defaultMethod , action: action , onSubmit: onSubmit , fetcherKey: fetcherKey , routeId: routeId , relative: relative , preventScrollReset: preventScrollReset  } = _ref6, props = $b71124f85d4fc180$var$_objectWithoutPropertiesLoose(_ref6, $b71124f85d4fc180$var$_excluded3);
    let submit = $b71124f85d4fc180$var$useSubmitImpl(fetcherKey, routeId);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $b71124f85d4fc180$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $8T3gX.createElement("form", $b71124f85d4fc180$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $b71124f85d4fc180$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey , storageKey: storageKey  } = _ref7;
    $b71124f85d4fc180$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $b71124f85d4fc180$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmitImpl"] = "useSubmitImpl";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($b71124f85d4fc180$var$DataRouterHook || ($b71124f85d4fc180$var$DataRouterHook = {}));
var $b71124f85d4fc180$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($b71124f85d4fc180$var$DataRouterStateHook || ($b71124f85d4fc180$var$DataRouterStateHook = {}));
function $b71124f85d4fc180$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $b71124f85d4fc180$var$useDataRouterContext(hookName) {
    let ctx = $8T3gX.useContext((0, $3T949.UNSAFE_DataRouterContext));
    !ctx && (0, $bnQ5y.UNSAFE_invariant)(false);
    return ctx;
}
function $b71124f85d4fc180$var$useDataRouterState(hookName) {
    let state = $8T3gX.useContext((0, $3T949.UNSAFE_DataRouterStateContext));
    !state && (0, $bnQ5y.UNSAFE_invariant)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $b71124f85d4fc180$export$67621102c14d847(to, _temp) {
    let { target: target , replace: replaceProp , state: state , preventScrollReset: preventScrollReset , relative: relative  } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $3T949.useNavigate)();
    let location = (0, $3T949.useLocation)();
    let path = (0, $3T949.useResolvedPath)(to, {
        relative: relative
    });
    return $8T3gX.useCallback((event)=>{
        if ($b71124f85d4fc180$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $bnQ5y.createPath)(location) === (0, $bnQ5y.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $b71124f85d4fc180$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $8T3gX.useRef($b71124f85d4fc180$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $8T3gX.useRef(false);
    let location = (0, $3T949.useLocation)();
    let searchParams = $8T3gX.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $b71124f85d4fc180$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $3T949.useNavigate)();
    let setSearchParams = $8T3gX.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $b71124f85d4fc180$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $b71124f85d4fc180$export$47c85c6e3a081d3() {
    return $b71124f85d4fc180$var$useSubmitImpl();
}
function $b71124f85d4fc180$var$useSubmitImpl(fetcherKey, fetcherRouteId) {
    let { router: router  } = $b71124f85d4fc180$var$useDataRouterContext($b71124f85d4fc180$var$DataRouterHook.UseSubmitImpl);
    let { basename: basename  } = $8T3gX.useContext((0, $3T949.UNSAFE_NavigationContext));
    let currentRouteId = (0, $3T949.UNSAFE_useRouteId)();
    return $8T3gX.useCallback(function(target, options) {
        if (options === void 0) options = {};
        if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
        let { action: action , method: method , encType: encType , formData: formData  } = $b71124f85d4fc180$var$getFormSubmissionInfo(target, options, basename);
        // Base options shared between fetch() and navigate()
        let opts = {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            formMethod: method,
            formEncType: encType
        };
        if (fetcherKey) {
            !(fetcherRouteId != null) && (0, $bnQ5y.UNSAFE_invariant)(false);
            router.fetch(fetcherKey, fetcherRouteId, action, opts);
        } else router.navigate(action, $b71124f85d4fc180$var$_extends({}, opts, {
            replace: options.replace,
            fromRouteId: currentRouteId
        }));
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $b71124f85d4fc180$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative  } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename  } = $8T3gX.useContext((0, $3T949.UNSAFE_NavigationContext));
    let routeContext = $8T3gX.useContext((0, $3T949.UNSAFE_RouteContext));
    !routeContext && (0, $bnQ5y.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $b71124f85d4fc180$var$_extends({}, (0, $3T949.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $3T949.useLocation)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $bnQ5y.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $bnQ5y.createPath)(path);
}
function $b71124f85d4fc180$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $8T3gX.forwardRef((props, ref)=>{
        return /*#__PURE__*/ $8T3gX.createElement($b71124f85d4fc180$var$FormImpl, $b71124f85d4fc180$var$_extends({}, props, {
            ref: ref,
            fetcherKey: fetcherKey,
            routeId: routeId
        }));
    });
    return FetcherForm;
}
let $b71124f85d4fc180$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $b71124f85d4fc180$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router  } = $b71124f85d4fc180$var$useDataRouterContext($b71124f85d4fc180$var$DataRouterHook.UseFetcher);
    let route = $8T3gX.useContext((0, $3T949.UNSAFE_RouteContext));
    !route && (0, $bnQ5y.UNSAFE_invariant)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $bnQ5y.UNSAFE_invariant)(false);
    let [fetcherKey] = $8T3gX.useState(()=>String(++$b71124f85d4fc180$var$fetcherId));
    let [Form] = $8T3gX.useState(()=>{
        !routeId && (0, $bnQ5y.UNSAFE_invariant)(false);
        return $b71124f85d4fc180$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $8T3gX.useState(()=>(href)=>{
            !router && (0, $bnQ5y.UNSAFE_invariant)(false);
            !routeId && (0, $bnQ5y.UNSAFE_invariant)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $b71124f85d4fc180$var$useSubmitImpl(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $8T3gX.useMemo(()=>$b71124f85d4fc180$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $8T3gX.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $b71124f85d4fc180$export$fa996778a3a31087() {
    let state = $b71124f85d4fc180$var$useDataRouterState($b71124f85d4fc180$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $b71124f85d4fc180$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $b71124f85d4fc180$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $b71124f85d4fc180$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey , storageKey: storageKey  } = _temp3 === void 0 ? {} : _temp3;
    let { router: router  } = $b71124f85d4fc180$var$useDataRouterContext($b71124f85d4fc180$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition , preventScrollReset: preventScrollReset  } = $b71124f85d4fc180$var$useDataRouterState($b71124f85d4fc180$var$DataRouterStateHook.UseScrollRestoration);
    let location = (0, $3T949.useLocation)();
    let matches = (0, $3T949.useMatches)();
    let navigation = (0, $3T949.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $8T3gX.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $b71124f85d4fc180$var$usePageHide($8T3gX.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $b71124f85d4fc180$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $b71124f85d4fc180$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($b71124f85d4fc180$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8T3gX.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $b71124f85d4fc180$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $b71124f85d4fc180$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8T3gX.useLayoutEffect(()=>{
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($b71124f85d4fc180$var$savedScrollPositions, ()=>window.scrollY, getKey);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8T3gX.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(location.hash.slice(1));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $b71124f85d4fc180$export$c0a586b329cae57d(callback, options) {
    let { capture: capture  } = options || {};
    $8T3gX.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $b71124f85d4fc180$var$usePageHide(callback, options) {
    let { capture: capture  } = options || {};
    $8T3gX.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $b71124f85d4fc180$export$39f4eb3dbd812741(_ref8) {
    let { when: when , message: message  } = _ref8;
    let blocker = (0, $3T949.unstable_useBlocker)(when);
    $8T3gX.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
    $8T3gX.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
}

});
parcelRequire.register("bnQ5y", function(module, exports) {

$parcel$export(module.exports, "Action", () => $849a3f667a98fd57$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $849a3f667a98fd57$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $849a3f667a98fd57$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $849a3f667a98fd57$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "createBrowserHistory", () => $849a3f667a98fd57$export$719fc203c4e16dee);
$parcel$export(module.exports, "createHashHistory", () => $849a3f667a98fd57$export$b71fdd3798280242);
$parcel$export(module.exports, "UNSAFE_invariant", () => $849a3f667a98fd57$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $849a3f667a98fd57$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $849a3f667a98fd57$export$b69e3301ce081aa3);
$parcel$export(module.exports, "joinPaths", () => $849a3f667a98fd57$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $849a3f667a98fd57$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getPathContributingMatches", () => $849a3f667a98fd57$export$90ba53ce1c7fdff2);
$parcel$export(module.exports, "resolveTo", () => $849a3f667a98fd57$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $849a3f667a98fd57$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "ErrorResponse", () => $849a3f667a98fd57$export$acf1a680051f5031);
$parcel$export(module.exports, "isRouteErrorResponse", () => $849a3f667a98fd57$export$972111febbeef05b);
$parcel$export(module.exports, "createRouter", () => $849a3f667a98fd57$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.6.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $849a3f667a98fd57$var$_extends() {
    $849a3f667a98fd57$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $849a3f667a98fd57$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $849a3f667a98fd57$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($849a3f667a98fd57$export$e19cd5f9376f8cee || ($849a3f667a98fd57$export$e19cd5f9376f8cee = {}));
const $849a3f667a98fd57$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $849a3f667a98fd57$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ] , initialIndex: initialIndex , v5Compat: v5Compat = false  } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $849a3f667a98fd57$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $849a3f667a98fd57$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $849a3f667a98fd57$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $849a3f667a98fd57$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $849a3f667a98fd57$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $849a3f667a98fd57$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $849a3f667a98fd57$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $849a3f667a98fd57$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $849a3f667a98fd57$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname , search: search , hash: hash  } = window1.location;
        return $849a3f667a98fd57$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $849a3f667a98fd57$export$fe53371bee54353d(to);
    }
    return $849a3f667a98fd57$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $849a3f667a98fd57$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/" , search: search = "" , hash: hash = ""  } = $849a3f667a98fd57$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        return $849a3f667a98fd57$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $849a3f667a98fd57$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $849a3f667a98fd57$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $849a3f667a98fd57$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $849a3f667a98fd57$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $849a3f667a98fd57$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $849a3f667a98fd57$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $849a3f667a98fd57$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $849a3f667a98fd57$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $849a3f667a98fd57$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $849a3f667a98fd57$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $849a3f667a98fd57$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $849a3f667a98fd57$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/" , search: search = "" , hash: hash = ""  } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $849a3f667a98fd57$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $849a3f667a98fd57$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView , v5Compat: v5Compat = false  } = options;
    let globalHistory = window1.history;
    let action = $849a3f667a98fd57$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($849a3f667a98fd57$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $849a3f667a98fd57$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $849a3f667a98fd57$export$e19cd5f9376f8cee.Push;
        let location = $849a3f667a98fd57$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $849a3f667a98fd57$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $849a3f667a98fd57$export$e19cd5f9376f8cee.Replace;
        let location = $849a3f667a98fd57$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $849a3f667a98fd57$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $849a3f667a98fd57$export$fe53371bee54353d(to);
        $849a3f667a98fd57$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($849a3f667a98fd57$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($849a3f667a98fd57$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $849a3f667a98fd57$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($849a3f667a98fd57$var$ResultType || ($849a3f667a98fd57$var$ResultType = {}));
const $849a3f667a98fd57$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $849a3f667a98fd57$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $849a3f667a98fd57$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $849a3f667a98fd57$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $849a3f667a98fd57$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($849a3f667a98fd57$var$isIndexRoute(route)) {
            let indexRoute = $849a3f667a98fd57$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $849a3f667a98fd57$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $849a3f667a98fd57$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $849a3f667a98fd57$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $849a3f667a98fd57$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $849a3f667a98fd57$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $849a3f667a98fd57$var$flattenRoutes(routes);
    $849a3f667a98fd57$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $849a3f667a98fd57$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $849a3f667a98fd57$var$safelyDecodeURI(pathname));
    return matches;
}
function $849a3f667a98fd57$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $849a3f667a98fd57$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $849a3f667a98fd57$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $849a3f667a98fd57$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $849a3f667a98fd57$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $849a3f667a98fd57$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $849a3f667a98fd57$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $849a3f667a98fd57$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $849a3f667a98fd57$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $849a3f667a98fd57$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $849a3f667a98fd57$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $849a3f667a98fd57$var$paramRe = /^:\w+$/;
const $849a3f667a98fd57$var$dynamicSegmentValue = 3;
const $849a3f667a98fd57$var$indexRouteValue = 2;
const $849a3f667a98fd57$var$emptySegmentValue = 1;
const $849a3f667a98fd57$var$staticSegmentValue = 10;
const $849a3f667a98fd57$var$splatPenalty = -2;
const $849a3f667a98fd57$var$isSplat = (s)=>s === "*";
function $849a3f667a98fd57$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($849a3f667a98fd57$var$isSplat)) initialScore += $849a3f667a98fd57$var$splatPenalty;
    if (index) initialScore += $849a3f667a98fd57$var$indexRouteValue;
    return segments.filter((s)=>!$849a3f667a98fd57$var$isSplat(s)).reduce((score, segment)=>score + ($849a3f667a98fd57$var$paramRe.test(segment) ? $849a3f667a98fd57$var$dynamicSegmentValue : segment === "" ? $849a3f667a98fd57$var$emptySegmentValue : $849a3f667a98fd57$var$staticSegmentValue), initialScore);
}
function $849a3f667a98fd57$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $849a3f667a98fd57$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta  } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $849a3f667a98fd57$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $849a3f667a98fd57$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $849a3f667a98fd57$export$a5c6d149b50c1d86($849a3f667a98fd57$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $849a3f667a98fd57$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $849a3f667a98fd57$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $849a3f667a98fd57$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            const starParam = params[star];
            // Apply the splat
            return starParam;
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            if (optional === "?") return param == null ? "" : param;
            if (param == null) $849a3f667a98fd57$export$3e9cee6b33872309(false, 'Missing ":' + key + '" param');
            return param;
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $849a3f667a98fd57$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $849a3f667a98fd57$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $849a3f667a98fd57$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $849a3f667a98fd57$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $849a3f667a98fd57$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $849a3f667a98fd57$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $849a3f667a98fd57$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $849a3f667a98fd57$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $849a3f667a98fd57$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $849a3f667a98fd57$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $849a3f667a98fd57$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname , search: search = "" , hash: hash = ""  } = typeof to === "string" ? $849a3f667a98fd57$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $849a3f667a98fd57$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $849a3f667a98fd57$var$normalizeSearch(search),
        hash: $849a3f667a98fd57$var$normalizeHash(hash)
    };
}
function $849a3f667a98fd57$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $849a3f667a98fd57$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $849a3f667a98fd57$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $849a3f667a98fd57$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $849a3f667a98fd57$export$8ccf933b0513f8d0(toArg);
    else {
        to = $849a3f667a98fd57$var$_extends({}, toArg);
        $849a3f667a98fd57$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $849a3f667a98fd57$var$getInvalidPathError("?", "pathname", "search", to));
        $849a3f667a98fd57$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $849a3f667a98fd57$var$getInvalidPathError("#", "pathname", "hash", to));
        $849a3f667a98fd57$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $849a3f667a98fd57$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $849a3f667a98fd57$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $849a3f667a98fd57$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $849a3f667a98fd57$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $849a3f667a98fd57$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $849a3f667a98fd57$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $849a3f667a98fd57$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $849a3f667a98fd57$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $849a3f667a98fd57$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $849a3f667a98fd57$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $849a3f667a98fd57$export$42a99a7a4bc0e76a extends Error {
}
class $849a3f667a98fd57$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $849a3f667a98fd57$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $849a3f667a98fd57$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, null, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $849a3f667a98fd57$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        if (error) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $849a3f667a98fd57$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $849a3f667a98fd57$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $849a3f667a98fd57$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $849a3f667a98fd57$var$unwrapTrackedPromise(value) {
    if (!$849a3f667a98fd57$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $849a3f667a98fd57$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $849a3f667a98fd57$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $849a3f667a98fd57$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $849a3f667a98fd57$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $849a3f667a98fd57$export$acf1a680051f5031 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $849a3f667a98fd57$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $849a3f667a98fd57$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $849a3f667a98fd57$var$validMutationMethods = new Set($849a3f667a98fd57$var$validMutationMethodsArr);
const $849a3f667a98fd57$var$validRequestMethodsArr = [
    "get",
    ...$849a3f667a98fd57$var$validMutationMethodsArr
];
const $849a3f667a98fd57$var$validRequestMethods = new Set($849a3f667a98fd57$var$validRequestMethodsArr);
const $849a3f667a98fd57$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $849a3f667a98fd57$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $849a3f667a98fd57$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $849a3f667a98fd57$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $849a3f667a98fd57$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $849a3f667a98fd57$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $849a3f667a98fd57$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $849a3f667a98fd57$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $849a3f667a98fd57$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $849a3f667a98fd57$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $849a3f667a98fd57$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $849a3f667a98fd57$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $849a3f667a98fd57$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $849a3f667a98fd57$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches , route: route  } = $849a3f667a98fd57$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $849a3f667a98fd57$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $849a3f667a98fd57$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction , location: location , delta: delta  } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $849a3f667a98fd57$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        deleteBlocker(blockerKey);
                        updateState({
                            blockers: new Map(router.state.blockers)
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($849a3f667a98fd57$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $849a3f667a98fd57$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $849a3f667a98fd57$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $849a3f667a98fd57$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        for (let [key] of blockerFunctions)deleteBlocker(key);
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $849a3f667a98fd57$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        updateState($849a3f667a98fd57$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $849a3f667a98fd57$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: new Map(state.blockers)
        }));
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $849a3f667a98fd57$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $849a3f667a98fd57$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $849a3f667a98fd57$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        // Reset stateful navigation vars
        pendingAction = $849a3f667a98fd57$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $849a3f667a98fd57$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path , submission: submission , error: error  } = $849a3f667a98fd57$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $849a3f667a98fd57$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $849a3f667a98fd57$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $849a3f667a98fd57$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $849a3f667a98fd57$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $849a3f667a98fd57$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $849a3f667a98fd57$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    deleteBlocker(blockerKey);
                    updateState({
                        blockers: new Map(state.blockers)
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $849a3f667a98fd57$export$2708184779ceb39d(routesToUse, location, basename);
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $849a3f667a98fd57$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches , route: route  } = $849a3f667a98fd57$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $849a3f667a98fd57$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $849a3f667a98fd57$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $849a3f667a98fd57$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$849a3f667a98fd57$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $849a3f667a98fd57$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            let navigation = $849a3f667a98fd57$var$_extends({
                state: "loading",
                location: location
            }, opts.submission);
            loadingNavigation = navigation;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited , loaderData: loaderData , errors: errors  } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $849a3f667a98fd57$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $849a3f667a98fd57$var$_extends({
            state: "submitting",
            location: location
        }, submission);
        updateState({
            navigation: navigation
        });
        // Call our action and get the result
        let result;
        let actionMatch = $849a3f667a98fd57$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $849a3f667a98fd57$var$ResultType.error,
            error: $849a3f667a98fd57$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $849a3f667a98fd57$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($849a3f667a98fd57$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($849a3f667a98fd57$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $849a3f667a98fd57$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $849a3f667a98fd57$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($849a3f667a98fd57$var$isDeferredResult(result)) throw $849a3f667a98fd57$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation;
        if (!loadingNavigation) {
            let navigation = $849a3f667a98fd57$var$_extends({
                state: "loading",
                location: location,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            }, submission);
            loadingNavigation = navigation;
        }
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission ? submission || fetcherSubmission : loadingNavigation.formMethod && loadingNavigation.formAction && loadingNavigation.formData && loadingNavigation.formEncType ? {
            formMethod: loadingNavigation.formMethod,
            formAction: loadingNavigation.formAction,
            formData: loadingNavigation.formData,
            formEncType: loadingNavigation.formEncType
        } : undefined;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $849a3f667a98fd57$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $849a3f667a98fd57$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = {
                    state: "loading",
                    data: fetcher && fetcher.data,
                    formMethod: undefined,
                    formAction: undefined,
                    formEncType: undefined,
                    formData: undefined,
                    " _hasFetcherDoneAnything ": true
                };
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($849a3f667a98fd57$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        pendingNavigationLoadId = ++incrementingLoadId;
        revalidatingFetchers.forEach((rf)=>{
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results , loaderResults: loaderResults , fetcherResults: fetcherResults  } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $849a3f667a98fd57$var$findRedirect(results);
        if (redirect) {
            await startRedirectNavigation(state, redirect, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData , errors: errors  } = $849a3f667a98fd57$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $849a3f667a98fd57$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $849a3f667a98fd57$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $849a3f667a98fd57$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $849a3f667a98fd57$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $849a3f667a98fd57$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path , submission: submission  } = $849a3f667a98fd57$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        let match = $849a3f667a98fd57$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $849a3f667a98fd57$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $849a3f667a98fd57$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $849a3f667a98fd57$var$_extends({
            state: "submitting"
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $849a3f667a98fd57$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let actionResult = await $849a3f667a98fd57$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($849a3f667a98fd57$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            fetchRedirectIds.add(key);
            let loadingFetcher = $849a3f667a98fd57$var$_extends({
                state: "loading"
            }, submission, {
                data: undefined,
                " _hasFetcherDoneAnything ": true
            });
            state.fetchers.set(key, loadingFetcher);
            updateState({
                fetchers: new Map(state.fetchers)
            });
            return startRedirectNavigation(state, actionResult, {
                submission: submission,
                isFetchActionRedirect: true
            });
        }
        // Process any non-redirect errors thrown
        if ($849a3f667a98fd57$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($849a3f667a98fd57$var$isDeferredResult(actionResult)) throw $849a3f667a98fd57$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $849a3f667a98fd57$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $849a3f667a98fd57$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $849a3f667a98fd57$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $849a3f667a98fd57$var$_extends({
            state: "loading",
            data: actionResult.data
        }, submission, {
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $849a3f667a98fd57$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = {
                state: "loading",
                data: existingFetcher && existingFetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results , loaderResults: loaderResults , fetcherResults: fetcherResults  } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $849a3f667a98fd57$var$findRedirect(results);
        if (redirect) return startRedirectNavigation(state, redirect);
        // Process and commit output from loaders
        let { loaderData: loaderData , errors: errors  } = $849a3f667a98fd57$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = {
                state: "idle",
                data: actionResult.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
        let didAbortFetchLoads = abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $849a3f667a98fd57$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($849a3f667a98fd57$var$_extends({
                errors: errors,
                loaderData: $849a3f667a98fd57$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key);
        // Put this fetcher into it's loading state
        let loadingFetcher = $849a3f667a98fd57$var$_extends({
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $849a3f667a98fd57$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let result = await $849a3f667a98fd57$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($849a3f667a98fd57$var$isDeferredResult(result)) result = await $849a3f667a98fd57$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($849a3f667a98fd57$var$isRedirectResult(result)) {
            fetchRedirectIds.add(key);
            await startRedirectNavigation(state, result);
            return;
        }
        // Process any non-redirect errors thrown
        if ($849a3f667a98fd57$var$isErrorResult(result)) {
            let boundaryMatch = $849a3f667a98fd57$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key);
            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $849a3f667a98fd57$export$3e9cee6b33872309(!$849a3f667a98fd57$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        let doneFetcher = {
            state: "idle",
            data: result.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            " _hasFetcherDoneAnything ": true
        };
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        let { submission: submission , replace: replace , isFetchActionRedirect: isFetchActionRedirect  } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $849a3f667a98fd57$var$createLocation(state.location, redirect.location, $849a3f667a98fd57$var$_extends({
            _isRedirect: true
        }, isFetchActionRedirect ? {
            _isFetchActionRedirect: true
        } : {}));
        $849a3f667a98fd57$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        // Check if this an absolute external redirect that goes to a new origin
        if ($849a3f667a98fd57$var$ABSOLUTE_URL_REGEX.test(redirect.location) && isBrowser) {
            let url = init.history.createURL(redirect.location);
            let isDifferentBasename = $849a3f667a98fd57$export$b69e3301ce081aa3(url.pathname, basename) == null;
            if (routerWindow.location.origin !== url.origin || isDifferentBasename) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $849a3f667a98fd57$export$e19cd5f9376f8cee.Replace : $849a3f667a98fd57$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod , formAction: formAction , formEncType: formEncType , formData: formData  } = state.navigation;
        if (!submission && formMethod && formAction && formData && formEncType) submission = {
            formMethod: formMethod,
            formAction: formAction,
            formEncType: formEncType,
            formData: formData
        };
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        if ($849a3f667a98fd57$var$redirectPreserveMethodStatusCodes.has(redirect.status) && submission && $849a3f667a98fd57$var$isMutationMethod(submission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $849a3f667a98fd57$var$_extends({}, submission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else if (isFetchActionRedirect) // For a fetch action redirect, we kick off a new loading navigation
        // without the fetcher submission, but we send it along for shouldRevalidate
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: {
                state: "loading",
                location: redirectLocation,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            },
            fetcherSubmission: submission,
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else // Otherwise, we kick off a new loading navigation, preserving the
        // submission info for the duration of this navigation
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: {
                state: "loading",
                location: redirectLocation,
                formMethod: submission ? submission.formMethod : undefined,
                formAction: submission ? submission.formAction : undefined,
                formEncType: submission ? submission.formEncType : undefined,
                formData: submission ? submission.formData : undefined
            },
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$849a3f667a98fd57$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $849a3f667a98fd57$var$callLoaderOrAction("loader", $849a3f667a98fd57$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $849a3f667a98fd57$var$ResultType.error,
                        error: $849a3f667a98fd57$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $849a3f667a98fd57$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $849a3f667a98fd57$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $849a3f667a98fd57$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $849a3f667a98fd57$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = {
                state: "idle",
                data: fetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $849a3f667a98fd57$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $849a3f667a98fd57$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $849a3f667a98fd57$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $849a3f667a98fd57$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $849a3f667a98fd57$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        state.blockers.set(key, newBlocker);
        updateState({
            blockers: new Map(state.blockers)
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation , nextLocation: nextLocation , historyAction: historyAction  } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $849a3f667a98fd57$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || ((location)=>location.key);
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $849a3f667a98fd57$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$849a3f667a98fd57$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$849a3f667a98fd57$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $849a3f667a98fd57$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $849a3f667a98fd57$export$4d0306f8f6a4585b = Symbol("deferred");
function $849a3f667a98fd57$export$3336b097a6fbc59a(routes, opts) {
    $849a3f667a98fd57$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $849a3f667a98fd57$var$defaultMapRouteProperties;
    let dataRoutes = $849a3f667a98fd57$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext  } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $849a3f667a98fd57$var$createLocation("", $849a3f667a98fd57$export$fe53371bee54353d(url), null, "default");
        let matches = $849a3f667a98fd57$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$849a3f667a98fd57$var$isValidMethod(method) && method !== "HEAD") {
            let error = $849a3f667a98fd57$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches , route: route  } = $849a3f667a98fd57$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $849a3f667a98fd57$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches , route: route  } = $849a3f667a98fd57$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($849a3f667a98fd57$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $849a3f667a98fd57$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId , requestContext: requestContext  } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $849a3f667a98fd57$var$createLocation("", $849a3f667a98fd57$export$fe53371bee54353d(url), null, "default");
        let matches = $849a3f667a98fd57$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$849a3f667a98fd57$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $849a3f667a98fd57$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $849a3f667a98fd57$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $849a3f667a98fd57$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $849a3f667a98fd57$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $849a3f667a98fd57$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($849a3f667a98fd57$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$849a3f667a98fd57$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $849a3f667a98fd57$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($849a3f667a98fd57$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $849a3f667a98fd57$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $849a3f667a98fd57$var$isResponse(result) ? result : $849a3f667a98fd57$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($849a3f667a98fd57$var$isQueryRouteResponse(e)) {
                if (e.type === $849a3f667a98fd57$var$ResultType.error && !$849a3f667a98fd57$var$isRedirectResponse(e.response)) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($849a3f667a98fd57$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $849a3f667a98fd57$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $849a3f667a98fd57$var$ResultType.error,
                error: error
            };
        } else {
            result = await $849a3f667a98fd57$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, true, isRouteRequest, requestContext);
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted");
            }
        }
        if ($849a3f667a98fd57$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($849a3f667a98fd57$var$isDeferredResult(result)) {
            let error = $849a3f667a98fd57$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $849a3f667a98fd57$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($849a3f667a98fd57$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($849a3f667a98fd57$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $849a3f667a98fd57$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $849a3f667a98fd57$var$_extends({}, context, {
                statusCode: $849a3f667a98fd57$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $849a3f667a98fd57$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $849a3f667a98fd57$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $849a3f667a98fd57$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $849a3f667a98fd57$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $849a3f667a98fd57$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$849a3f667a98fd57$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, true, isRouteRequest, requestContext))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted");
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $849a3f667a98fd57$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $849a3f667a98fd57$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $849a3f667a98fd57$export$fec11da027c70692(routes, context, error) {
    let newContext = $849a3f667a98fd57$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $849a3f667a98fd57$var$isSubmissionNavigation(opts) {
    return opts != null && "formData" in opts;
}
function $849a3f667a98fd57$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $849a3f667a98fd57$export$cae722b0cc860f13(to ? to : ".", $849a3f667a98fd57$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $849a3f667a98fd57$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$849a3f667a98fd57$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $849a3f667a98fd57$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $849a3f667a98fd57$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $849a3f667a98fd57$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$849a3f667a98fd57$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$849a3f667a98fd57$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $849a3f667a98fd57$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    // Create a Submission on non-GET navigations
    let submission;
    if (opts.formData) {
        let formMethod = opts.formMethod || "get";
        submission = {
            formMethod: normalizeFormMethod ? formMethod.toUpperCase() : formMethod.toLowerCase(),
            formAction: $849a3f667a98fd57$var$stripHashFromPath(path),
            formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
            formData: opts.formData
        };
        if ($849a3f667a98fd57$var$isMutationMethod(submission.formMethod)) return {
            path: path,
            submission: submission
        };
    }
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $849a3f667a98fd57$export$8ccf933b0513f8d0(path);
    let searchParams = $849a3f667a98fd57$var$convertFormDataToSearchParams(opts.formData);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $849a3f667a98fd57$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $849a3f667a98fd57$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $849a3f667a98fd57$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $849a3f667a98fd57$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $849a3f667a98fd57$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($849a3f667a98fd57$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $849a3f667a98fd57$var$shouldRevalidateLoader(match, $849a3f667a98fd57$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $849a3f667a98fd57$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $849a3f667a98fd57$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        let fetcherMatch = $849a3f667a98fd57$var$getTargetMatch(fetcherMatches, f.path);
        if (cancelledFetcherLoads.includes(key)) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: fetcherMatches,
                match: fetcherMatch,
                controller: new AbortController()
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // hit a static href, so they _always_ check shouldRevalidate and the
        // default is strictly if a revalidation is explicitly required (action
        // submissions, useRevalidator, X-Remix-Revalidate).
        let shouldRevalidate = $849a3f667a98fd57$var$shouldRevalidateLoader(fetcherMatch, $849a3f667a98fd57$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $849a3f667a98fd57$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $849a3f667a98fd57$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $849a3f667a98fd57$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $849a3f667a98fd57$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $849a3f667a98fd57$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $849a3f667a98fd57$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$849a3f667a98fd57$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $849a3f667a98fd57$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $849a3f667a98fd57$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, isStaticRequest, isRouteRequest, requestContext) {
    if (isStaticRequest === void 0) isStaticRequest = false;
    if (isRouteRequest === void 0) isRouteRequest = false;
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let values = await Promise.all([
                    runHandler(handler),
                    $849a3f667a98fd57$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $849a3f667a98fd57$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $849a3f667a98fd57$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $849a3f667a98fd57$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $849a3f667a98fd57$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $849a3f667a98fd57$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $849a3f667a98fd57$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($849a3f667a98fd57$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($849a3f667a98fd57$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $849a3f667a98fd57$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$849a3f667a98fd57$var$ABSOLUTE_URL_REGEX.test(location)) location = $849a3f667a98fd57$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $849a3f667a98fd57$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $849a3f667a98fd57$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (isRouteRequest) // eslint-disable-next-line no-throw-literal
        throw {
            type: resultType || $849a3f667a98fd57$var$ResultType.data,
            response: result
        };
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $849a3f667a98fd57$var$ResultType.error) return {
            type: resultType,
            error: new $849a3f667a98fd57$export$acf1a680051f5031(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $849a3f667a98fd57$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $849a3f667a98fd57$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($849a3f667a98fd57$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $849a3f667a98fd57$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $849a3f667a98fd57$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $849a3f667a98fd57$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($849a3f667a98fd57$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $849a3f667a98fd57$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod , formEncType: formEncType , formData: formData  } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        init.body = formEncType === "application/x-www-form-urlencoded" ? $849a3f667a98fd57$var$convertFormDataToSearchParams(formData) : formData;
    }
    // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
    return new Request(url, init);
}
function $849a3f667a98fd57$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, value instanceof File ? value.name : value);
    return searchParams;
}
function $849a3f667a98fd57$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $849a3f667a98fd57$export$3e9cee6b33872309(!$849a3f667a98fd57$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($849a3f667a98fd57$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $849a3f667a98fd57$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $849a3f667a98fd57$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($849a3f667a98fd57$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $849a3f667a98fd57$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData , errors: errors  } = $849a3f667a98fd57$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key , match: match , controller: controller  } = revalidatingFetchers[index];
        $849a3f667a98fd57$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($849a3f667a98fd57$var$isErrorResult(result)) {
            let boundaryMatch = $849a3f667a98fd57$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $849a3f667a98fd57$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($849a3f667a98fd57$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $849a3f667a98fd57$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($849a3f667a98fd57$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $849a3f667a98fd57$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = {
                state: "idle",
                data: result.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $849a3f667a98fd57$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $849a3f667a98fd57$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $849a3f667a98fd57$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $849a3f667a98fd57$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $849a3f667a98fd57$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname , routeId: routeId , method: method , type: type  } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $849a3f667a98fd57$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $849a3f667a98fd57$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($849a3f667a98fd57$var$isRedirectResult(result)) return result;
    }
}
function $849a3f667a98fd57$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $849a3f667a98fd57$export$8ccf933b0513f8d0(path) : path;
    return $849a3f667a98fd57$export$fe53371bee54353d($849a3f667a98fd57$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $849a3f667a98fd57$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $849a3f667a98fd57$var$isDeferredResult(result) {
    return result.type === $849a3f667a98fd57$var$ResultType.deferred;
}
function $849a3f667a98fd57$var$isErrorResult(result) {
    return result.type === $849a3f667a98fd57$var$ResultType.error;
}
function $849a3f667a98fd57$var$isRedirectResult(result) {
    return (result && result.type) === $849a3f667a98fd57$var$ResultType.redirect;
}
function $849a3f667a98fd57$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $849a3f667a98fd57$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $849a3f667a98fd57$var$isRedirectResponse(result) {
    if (!$849a3f667a98fd57$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $849a3f667a98fd57$var$isQueryRouteResponse(obj) {
    return obj && $849a3f667a98fd57$var$isResponse(obj.response) && (obj.type === $849a3f667a98fd57$var$ResultType.data || $849a3f667a98fd57$var$ResultType.error);
}
function $849a3f667a98fd57$var$isValidMethod(method) {
    return $849a3f667a98fd57$var$validRequestMethods.has(method.toLowerCase());
}
function $849a3f667a98fd57$var$isMutationMethod(method) {
    return $849a3f667a98fd57$var$validMutationMethods.has(method.toLowerCase());
}
async function $849a3f667a98fd57$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$849a3f667a98fd57$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($849a3f667a98fd57$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $849a3f667a98fd57$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $849a3f667a98fd57$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $849a3f667a98fd57$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $849a3f667a98fd57$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $849a3f667a98fd57$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $849a3f667a98fd57$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $849a3f667a98fd57$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
// Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $849a3f667a98fd57$var$createUseMatchesMatch(match, loaderData) {
    let { route: route , pathname: pathname , params: params  } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $849a3f667a98fd57$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $849a3f667a98fd57$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $849a3f667a98fd57$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $849a3f667a98fd57$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}

});

parcelRequire.register("3T949", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_startTransitionImpl", () => $2d4d8a77428439fe$export$c3891eca2daa19d8);
$parcel$export(module.exports, "UNSAFE_DataRouterContext", () => $2d4d8a77428439fe$export$3add0d5dce533e2e);
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", () => $2d4d8a77428439fe$export$145dfa71566a64dc);
$parcel$export(module.exports, "UNSAFE_NavigationContext", () => $2d4d8a77428439fe$export$26749e8557646306);
$parcel$export(module.exports, "UNSAFE_RouteContext", () => $2d4d8a77428439fe$export$9072aa6dd1f93057);
$parcel$export(module.exports, "useHref", () => $2d4d8a77428439fe$export$b66bb29c5006f12f);
$parcel$export(module.exports, "useResolvedPath", () => $2d4d8a77428439fe$export$e75d2a2d1b3c245b);
$parcel$export(module.exports, "useLocation", () => $2d4d8a77428439fe$export$45d76561a5302f2b);
$parcel$export(module.exports, "useMatch", () => $2d4d8a77428439fe$export$6c330e8992e8a295);
$parcel$export(module.exports, "useNavigate", () => $2d4d8a77428439fe$export$9770f232ac06a008);
$parcel$export(module.exports, "useParams", () => $2d4d8a77428439fe$export$99eaa27ddbbb95ef);
$parcel$export(module.exports, "UNSAFE_useRouteId", () => $2d4d8a77428439fe$export$5fc8298006ad9e58);
$parcel$export(module.exports, "useNavigation", () => $2d4d8a77428439fe$export$d0fd4b7106de2769);
$parcel$export(module.exports, "useMatches", () => $2d4d8a77428439fe$export$2378eb7f5ff86053);
$parcel$export(module.exports, "unstable_useBlocker", () => $2d4d8a77428439fe$export$2af03a1de5c0910);
$parcel$export(module.exports, "Router", () => $2d4d8a77428439fe$export$55185c17a0fcbe46);
$parcel$export(module.exports, "Navigate", () => $2d4d8a77428439fe$export$444b3ab0cb9aec40);
$parcel$export(module.exports, "Outlet", () => $2d4d8a77428439fe$export$910ae8079b2c2852);
$parcel$export(module.exports, "Route", () => $2d4d8a77428439fe$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Routes", () => $2d4d8a77428439fe$export$3565eb3d00ca5a74);
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", () => $2d4d8a77428439fe$export$52b333d321859367);
/**
 * React Router v6.13.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8T3gX = parcelRequire("8T3gX");

var $bnQ5y = parcelRequire("bnQ5y");
function $2d4d8a77428439fe$var$_extends() {
    $2d4d8a77428439fe$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2d4d8a77428439fe$var$_extends.apply(this, arguments);
}
/**
  Not a true "polyfill" since we guard via the feature flag at runtime,
  but close enough :)

  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $2d4d8a77428439fe$var$START_TRANSITION = "startTransition";
var $2d4d8a77428439fe$export$c3891eca2daa19d8 = $8T3gX[$2d4d8a77428439fe$var$START_TRANSITION];
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $2d4d8a77428439fe$export$3add0d5dce533e2e = /*#__PURE__*/ $8T3gX.createContext(null);
const $2d4d8a77428439fe$export$145dfa71566a64dc = /*#__PURE__*/ $8T3gX.createContext(null);
const $2d4d8a77428439fe$var$AwaitContext = /*#__PURE__*/ $8T3gX.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level <Router> API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $2d4d8a77428439fe$export$26749e8557646306 = /*#__PURE__*/ $8T3gX.createContext(null);
const $2d4d8a77428439fe$export$c7914228fb69b0f5 = /*#__PURE__*/ $8T3gX.createContext(null);
const $2d4d8a77428439fe$export$9072aa6dd1f93057 = /*#__PURE__*/ $8T3gX.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $2d4d8a77428439fe$var$RouteErrorContext = /*#__PURE__*/ $8T3gX.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $2d4d8a77428439fe$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative  } = _temp === void 0 ? {} : _temp;
    !$2d4d8a77428439fe$export$9c954a9d03d32f4a() && (0, $bnQ5y.UNSAFE_invariant)(false);
    let { basename: basename , navigator: navigator  } = $8T3gX.useContext($2d4d8a77428439fe$export$26749e8557646306);
    let { hash: hash , pathname: pathname , search: search  } = $2d4d8a77428439fe$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $bnQ5y.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $2d4d8a77428439fe$export$9c954a9d03d32f4a() {
    return $8T3gX.useContext($2d4d8a77428439fe$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $2d4d8a77428439fe$export$45d76561a5302f2b() {
    !$2d4d8a77428439fe$export$9c954a9d03d32f4a() && (0, $bnQ5y.UNSAFE_invariant)(false);
    return $8T3gX.useContext($2d4d8a77428439fe$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $2d4d8a77428439fe$export$1b3f31771c5d07c() {
    return $8T3gX.useContext($2d4d8a77428439fe$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $2d4d8a77428439fe$export$6c330e8992e8a295(pattern) {
    !$2d4d8a77428439fe$export$9c954a9d03d32f4a() && (0, $bnQ5y.UNSAFE_invariant)(false);
    let { pathname: pathname  } = $2d4d8a77428439fe$export$45d76561a5302f2b();
    return $8T3gX.useMemo(()=>(0, $bnQ5y.matchPath)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $2d4d8a77428439fe$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $2d4d8a77428439fe$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $8T3gX.useContext($2d4d8a77428439fe$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8T3gX.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $2d4d8a77428439fe$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute  } = $8T3gX.useContext($2d4d8a77428439fe$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $2d4d8a77428439fe$var$useNavigateStable() : $2d4d8a77428439fe$var$useNavigateUnstable();
}
function $2d4d8a77428439fe$var$useNavigateUnstable() {
    !$2d4d8a77428439fe$export$9c954a9d03d32f4a() && (0, $bnQ5y.UNSAFE_invariant)(false);
    let dataRouterContext = $8T3gX.useContext($2d4d8a77428439fe$export$3add0d5dce533e2e);
    let { basename: basename , navigator: navigator  } = $8T3gX.useContext($2d4d8a77428439fe$export$26749e8557646306);
    let { matches: matches  } = $8T3gX.useContext($2d4d8a77428439fe$export$9072aa6dd1f93057);
    let { pathname: locationPathname  } = $2d4d8a77428439fe$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $bnQ5y.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase));
    let activeRef = $8T3gX.useRef(false);
    $2d4d8a77428439fe$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8T3gX.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $bnQ5y.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $bnQ5y.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $2d4d8a77428439fe$var$OutletContext = /*#__PURE__*/ $8T3gX.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $2d4d8a77428439fe$export$4138103a3ae699cc() {
    return $8T3gX.useContext($2d4d8a77428439fe$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $2d4d8a77428439fe$export$a3be3530d8e40d0b(context) {
    let outlet = $8T3gX.useContext($2d4d8a77428439fe$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $2d4d8a77428439fe$export$99eaa27ddbbb95ef() {
    let { matches: matches  } = $8T3gX.useContext($2d4d8a77428439fe$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $2d4d8a77428439fe$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative  } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches  } = $8T3gX.useContext($2d4d8a77428439fe$export$9072aa6dd1f93057);
    let { pathname: locationPathname  } = $2d4d8a77428439fe$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $bnQ5y.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase));
    return $8T3gX.useMemo(()=>(0, $bnQ5y.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $2d4d8a77428439fe$export$5d3fca4a98652595(routes, locationArg) {
    return $2d4d8a77428439fe$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $2d4d8a77428439fe$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$2d4d8a77428439fe$export$9c954a9d03d32f4a() && (0, $bnQ5y.UNSAFE_invariant)(false);
    let { navigator: navigator  } = $8T3gX.useContext($2d4d8a77428439fe$export$26749e8557646306);
    let { matches: parentMatches  } = $8T3gX.useContext($2d4d8a77428439fe$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $2d4d8a77428439fe$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $bnQ5y.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $bnQ5y.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $bnQ5y.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $2d4d8a77428439fe$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $bnQ5y.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $bnQ5y.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $2d4d8a77428439fe$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $bnQ5y.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $2d4d8a77428439fe$var$DefaultErrorComponent() {
    let error = $2d4d8a77428439fe$export$ed527bf60f6e05f2();
    let message = (0, $bnQ5y.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $8T3gX.createElement($8T3gX.Fragment, null, /*#__PURE__*/ $8T3gX.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $8T3gX.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $8T3gX.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $2d4d8a77428439fe$var$defaultErrorElement = /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$DefaultErrorComponent, null);
class $2d4d8a77428439fe$var$RenderErrorBoundary extends $8T3gX.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $2d4d8a77428439fe$var$RenderedRoute(_ref) {
    let { routeContext: routeContext , match: match , children: children  } = _ref;
    let dataRouterContext = $8T3gX.useContext($2d4d8a77428439fe$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $2d4d8a77428439fe$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $bnQ5y.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $2d4d8a77428439fe$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $8T3gX.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $2d4d8a77428439fe$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
})($2d4d8a77428439fe$var$DataRouterHook || ($2d4d8a77428439fe$var$DataRouterHook = {}));
var $2d4d8a77428439fe$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
})($2d4d8a77428439fe$var$DataRouterStateHook || ($2d4d8a77428439fe$var$DataRouterStateHook = {}));
function $2d4d8a77428439fe$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $2d4d8a77428439fe$var$useDataRouterContext(hookName) {
    let ctx = $8T3gX.useContext($2d4d8a77428439fe$export$3add0d5dce533e2e);
    !ctx && (0, $bnQ5y.UNSAFE_invariant)(false);
    return ctx;
}
function $2d4d8a77428439fe$var$useDataRouterState(hookName) {
    let state = $8T3gX.useContext($2d4d8a77428439fe$export$145dfa71566a64dc);
    !state && (0, $bnQ5y.UNSAFE_invariant)(false);
    return state;
}
function $2d4d8a77428439fe$var$useRouteContext(hookName) {
    let route = $8T3gX.useContext($2d4d8a77428439fe$export$9072aa6dd1f93057);
    !route && (0, $bnQ5y.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $2d4d8a77428439fe$var$useCurrentRouteId(hookName) {
    let route = $2d4d8a77428439fe$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $bnQ5y.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $2d4d8a77428439fe$export$5fc8298006ad9e58() {
    return $2d4d8a77428439fe$var$useCurrentRouteId($2d4d8a77428439fe$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $2d4d8a77428439fe$export$d0fd4b7106de2769() {
    let state = $2d4d8a77428439fe$var$useDataRouterState($2d4d8a77428439fe$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $2d4d8a77428439fe$export$600dc272ed516c15() {
    let dataRouterContext = $2d4d8a77428439fe$var$useDataRouterContext($2d4d8a77428439fe$var$DataRouterHook.UseRevalidator);
    let state = $2d4d8a77428439fe$var$useDataRouterState($2d4d8a77428439fe$var$DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $2d4d8a77428439fe$export$2378eb7f5ff86053() {
    let { matches: matches , loaderData: loaderData  } = $2d4d8a77428439fe$var$useDataRouterState($2d4d8a77428439fe$var$DataRouterStateHook.UseMatches);
    return $8T3gX.useMemo(()=>matches.map((match)=>{
            let { pathname: pathname , params: params  } = match;
            // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        }), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $2d4d8a77428439fe$export$1448a5050d252c4d() {
    let state = $2d4d8a77428439fe$var$useDataRouterState($2d4d8a77428439fe$var$DataRouterStateHook.UseLoaderData);
    let routeId = $2d4d8a77428439fe$var$useCurrentRouteId($2d4d8a77428439fe$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $2d4d8a77428439fe$export$fd5d37484eab868d(routeId) {
    let state = $2d4d8a77428439fe$var$useDataRouterState($2d4d8a77428439fe$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $2d4d8a77428439fe$export$fdc00f3f26066d5e() {
    let state = $2d4d8a77428439fe$var$useDataRouterState($2d4d8a77428439fe$var$DataRouterStateHook.UseActionData);
    let route = $8T3gX.useContext($2d4d8a77428439fe$export$9072aa6dd1f93057);
    !route && (0, $bnQ5y.UNSAFE_invariant)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $2d4d8a77428439fe$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $8T3gX.useContext($2d4d8a77428439fe$var$RouteErrorContext);
    let state = $2d4d8a77428439fe$var$useDataRouterState($2d4d8a77428439fe$var$DataRouterStateHook.UseRouteError);
    let routeId = $2d4d8a77428439fe$var$useCurrentRouteId($2d4d8a77428439fe$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $2d4d8a77428439fe$export$78a72ddb39bdd145() {
    let value = $8T3gX.useContext($2d4d8a77428439fe$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $2d4d8a77428439fe$export$17f53340677d5831() {
    let value = $8T3gX.useContext($2d4d8a77428439fe$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $2d4d8a77428439fe$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $2d4d8a77428439fe$export$2af03a1de5c0910(shouldBlock) {
    let { router: router  } = $2d4d8a77428439fe$var$useDataRouterContext($2d4d8a77428439fe$var$DataRouterHook.UseBlocker);
    let state = $2d4d8a77428439fe$var$useDataRouterState($2d4d8a77428439fe$var$DataRouterStateHook.UseBlocker);
    let [blockerKey] = $8T3gX.useState(()=>String(++$2d4d8a77428439fe$var$blockerId));
    let blockerFunction = $8T3gX.useCallback((args)=>{
        return typeof shouldBlock === "function" ? !!shouldBlock(args) : !!shouldBlock;
    }, [
        shouldBlock
    ]);
    let blocker = router.getBlocker(blockerKey, blockerFunction);
    // Cleanup on unmount
    $8T3gX.useEffect(()=>()=>router.deleteBlocker(blockerKey), [
        router,
        blockerKey
    ]);
    // Prefer the blocker from state since DataRouterContext is memoized so this
    // ensures we update on blocker state updates
    return state.blockers.get(blockerKey) || blocker;
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $2d4d8a77428439fe$var$useNavigateStable() {
    let { router: router  } = $2d4d8a77428439fe$var$useDataRouterContext($2d4d8a77428439fe$var$DataRouterHook.UseNavigateStable);
    let id = $2d4d8a77428439fe$var$useCurrentRouteId($2d4d8a77428439fe$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $8T3gX.useRef(false);
    $2d4d8a77428439fe$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8T3gX.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $2d4d8a77428439fe$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $2d4d8a77428439fe$var$alreadyWarned = {};
function $2d4d8a77428439fe$var$warningOnce(key, cond, message) {
    if (!cond && !$2d4d8a77428439fe$var$alreadyWarned[key]) $2d4d8a77428439fe$var$alreadyWarned[key] = true;
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $2d4d8a77428439fe$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement , router: router , future: future  } = _ref;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    let [state, setStateImpl] = $8T3gX.useState(router.state);
    let { v7_startTransition: v7_startTransition  } = future || {};
    let setState = $8T3gX.useCallback((newState)=>{
        v7_startTransition && $2d4d8a77428439fe$export$c3891eca2daa19d8 ? $2d4d8a77428439fe$export$c3891eca2daa19d8(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8T3gX.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $8T3gX.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8T3gX.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8T3gX.createElement($8T3gX.Fragment, null, /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $2d4d8a77428439fe$var$DataRoutes(_ref2) {
    let { routes: routes , state: state  } = _ref2;
    return $2d4d8a77428439fe$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $2d4d8a77428439fe$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename , children: children , initialEntries: initialEntries , initialIndex: initialIndex , future: future  } = _ref3;
    let historyRef = $8T3gX.useRef();
    if (historyRef.current == null) historyRef.current = (0, $bnQ5y.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8T3gX.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition  } = future || {};
    let setState = $8T3gX.useCallback((newState)=>{
        v7_startTransition && $2d4d8a77428439fe$export$c3891eca2daa19d8 ? $2d4d8a77428439fe$export$c3891eca2daa19d8(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8T3gX.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $2d4d8a77428439fe$export$444b3ab0cb9aec40(_ref4) {
    let { to: to , replace: replace , state: state , relative: relative  } = _ref4;
    !$2d4d8a77428439fe$export$9c954a9d03d32f4a() && (0, $bnQ5y.UNSAFE_invariant)(false);
    let { matches: matches  } = $8T3gX.useContext($2d4d8a77428439fe$export$9072aa6dd1f93057);
    let { pathname: locationPathname  } = $2d4d8a77428439fe$export$45d76561a5302f2b();
    let navigate = $2d4d8a77428439fe$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $bnQ5y.resolveTo)(to, (0, $bnQ5y.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $8T3gX.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $2d4d8a77428439fe$export$910ae8079b2c2852(props) {
    return $2d4d8a77428439fe$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $2d4d8a77428439fe$export$e7b0ac011bb776c6(_props) {
    (0, $bnQ5y.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $2d4d8a77428439fe$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/" , children: children = null , location: locationProp , navigationType: navigationType = (0, $bnQ5y.Action).Pop , navigator: navigator , static: staticProp = false  } = _ref5;
    !!$2d4d8a77428439fe$export$9c954a9d03d32f4a() && (0, $bnQ5y.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $8T3gX.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $bnQ5y.parsePath)(locationProp);
    let { pathname: pathname = "/" , search: search = "" , hash: hash = "" , state: state = null , key: key = "default"  } = locationProp;
    let locationContext = $8T3gX.useMemo(()=>{
        let trailingPathname = (0, $bnQ5y.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $2d4d8a77428439fe$export$3565eb3d00ca5a74(_ref6) {
    let { children: children , location: location  } = _ref6;
    return $2d4d8a77428439fe$export$5d3fca4a98652595($2d4d8a77428439fe$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $2d4d8a77428439fe$export$6ddabde395c8c576(_ref7) {
    let { children: children , errorElement: errorElement , resolve: resolve  } = _ref7;
    return /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$ResolveAwait, null, children));
}
var $2d4d8a77428439fe$var$AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})($2d4d8a77428439fe$var$AwaitRenderStatus || ($2d4d8a77428439fe$var$AwaitRenderStatus = {}));
const $2d4d8a77428439fe$var$neverSettledPromise = new Promise(()=>{});
class $2d4d8a77428439fe$var$AwaitErrorBoundary extends $8T3gX.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children , errorElement: errorElement , resolve: resolve  } = this.props;
        let promise = null;
        let status = $2d4d8a77428439fe$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $2d4d8a77428439fe$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $2d4d8a77428439fe$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $2d4d8a77428439fe$var$AwaitRenderStatus.error : promise._data !== undefined ? $2d4d8a77428439fe$var$AwaitRenderStatus.success : $2d4d8a77428439fe$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $2d4d8a77428439fe$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $2d4d8a77428439fe$var$AwaitRenderStatus.error && promise._error instanceof (0, $bnQ5y.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $2d4d8a77428439fe$var$neverSettledPromise;
        if (status === $2d4d8a77428439fe$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $2d4d8a77428439fe$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $2d4d8a77428439fe$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $2d4d8a77428439fe$var$ResolveAwait(_ref8) {
    let { children: children  } = _ref8;
    let data = $2d4d8a77428439fe$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $8T3gX.createElement($8T3gX.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $2d4d8a77428439fe$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $8T3gX.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $8T3gX.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $8T3gX.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $2d4d8a77428439fe$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $2d4d8a77428439fe$export$e7b0ac011bb776c6) && (0, $bnQ5y.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $bnQ5y.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $2d4d8a77428439fe$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $2d4d8a77428439fe$export$daf73786167a7f72(matches) {
    return $2d4d8a77428439fe$var$_renderMatches(matches);
}
function $2d4d8a77428439fe$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $8T3gX.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $8T3gX.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $2d4d8a77428439fe$export$f30f7e456d254e83(routes, opts) {
    return (0, $bnQ5y.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $2d4d8a77428439fe$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $bnQ5y.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $2d4d8a77428439fe$export$52b333d321859367
    }).initialize();
}

});



parcelRequire.register("hAe8M", function(module, exports) {

var $yRFSk = parcelRequire("yRFSk");

var $1L6TK = parcelRequire("1L6TK");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $yRFSk.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $1L6TK;
module.exports = isBuffer;

});
parcelRequire.register("yRFSk", function(module, exports) {

var $55VOZ = parcelRequire("55VOZ");
/** Detect free variable `self`. */ var $068ccfb5ba5f84f2$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $068ccfb5ba5f84f2$var$root = $55VOZ || $068ccfb5ba5f84f2$var$freeSelf || Function("return this")();
module.exports = $068ccfb5ba5f84f2$var$root;

});
parcelRequire.register("55VOZ", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $3b5a45856125f3a7$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $3b5a45856125f3a7$var$freeGlobal;

});


parcelRequire.register("1L6TK", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $147f880e19c4ccad$var$stubFalse() {
    return false;
}
module.exports = $147f880e19c4ccad$var$stubFalse;

});


parcelRequire.register("3TIQ3", function(module, exports) {

var $55VOZ = parcelRequire("55VOZ");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $55VOZ.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRequire.register("hK0qV", function(module, exports) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`

module.exports = (parcelRequire("hFb7y"));

});
parcelRequire.register("hFb7y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "scaleBand", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_band.default;
    }
});
Object.defineProperty(module.exports, "scaleDiverging", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "scaleDivergingLog", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_diverging.divergingLog;
    }
});
Object.defineProperty(module.exports, "scaleDivergingPow", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_diverging.divergingPow;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSqrt", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_diverging.divergingSqrt;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSymlog", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_diverging.divergingSymlog;
    }
});
Object.defineProperty(module.exports, "scaleIdentity", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_identity.default;
    }
});
Object.defineProperty(module.exports, "scaleImplicit", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_ordinal.implicit;
    }
});
Object.defineProperty(module.exports, "scaleLinear", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "scaleLog", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_log.default;
    }
});
Object.defineProperty(module.exports, "scaleOrdinal", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_ordinal.default;
    }
});
Object.defineProperty(module.exports, "scalePoint", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_band.point;
    }
});
Object.defineProperty(module.exports, "scalePow", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_pow.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantile", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantize", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_quantize.default;
    }
});
Object.defineProperty(module.exports, "scaleRadial", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_radial.default;
    }
});
Object.defineProperty(module.exports, "scaleSequential", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_sequential.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialLog", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_sequential.sequentialLog;
    }
});
Object.defineProperty(module.exports, "scaleSequentialPow", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_sequential.sequentialPow;
    }
});
Object.defineProperty(module.exports, "scaleSequentialQuantile", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_sequentialQuantile.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSqrt", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_sequential.sequentialSqrt;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSymlog", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_sequential.sequentialSymlog;
    }
});
Object.defineProperty(module.exports, "scaleSqrt", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_pow.sqrt;
    }
});
Object.defineProperty(module.exports, "scaleSymlog", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_symlog.default;
    }
});
Object.defineProperty(module.exports, "scaleThreshold", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_threshold.default;
    }
});
Object.defineProperty(module.exports, "scaleTime", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_time.default;
    }
});
Object.defineProperty(module.exports, "scaleUtc", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_utcTime.default;
    }
});
Object.defineProperty(module.exports, "tickFormat", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_tickFormat.default;
    }
});

var $cdbee463a1ef7488$var$_band = $cdbee463a1ef7488$var$_interopRequireWildcard((parcelRequire("9JfWo")));

var $cdbee463a1ef7488$var$_identity = $cdbee463a1ef7488$var$_interopRequireDefault((parcelRequire("6kEZa")));

var $cdbee463a1ef7488$var$_linear = $cdbee463a1ef7488$var$_interopRequireDefault((parcelRequire("hHCkv")));

var $cdbee463a1ef7488$var$_log = $cdbee463a1ef7488$var$_interopRequireDefault((parcelRequire("jdUqB")));

var $cdbee463a1ef7488$var$_symlog = $cdbee463a1ef7488$var$_interopRequireDefault((parcelRequire("glCnt")));

var $cdbee463a1ef7488$var$_ordinal = $cdbee463a1ef7488$var$_interopRequireWildcard((parcelRequire("6Gt5K")));

var $cdbee463a1ef7488$var$_pow = $cdbee463a1ef7488$var$_interopRequireWildcard((parcelRequire("9R4Yk")));

var $cdbee463a1ef7488$var$_radial = $cdbee463a1ef7488$var$_interopRequireDefault((parcelRequire("iDRGP")));

var $cdbee463a1ef7488$var$_quantile = $cdbee463a1ef7488$var$_interopRequireDefault((parcelRequire("iYUPw")));

var $cdbee463a1ef7488$var$_quantize = $cdbee463a1ef7488$var$_interopRequireDefault((parcelRequire("c6un6")));

var $cdbee463a1ef7488$var$_threshold = $cdbee463a1ef7488$var$_interopRequireDefault((parcelRequire("oBu3L")));

var $cdbee463a1ef7488$var$_time = $cdbee463a1ef7488$var$_interopRequireDefault((parcelRequire("lze8j")));

var $cdbee463a1ef7488$var$_utcTime = $cdbee463a1ef7488$var$_interopRequireDefault((parcelRequire("3ZSjS")));

var $cdbee463a1ef7488$var$_sequential = $cdbee463a1ef7488$var$_interopRequireWildcard((parcelRequire("a9B8z")));

var $cdbee463a1ef7488$var$_sequentialQuantile = $cdbee463a1ef7488$var$_interopRequireDefault((parcelRequire("jatwg")));

var $cdbee463a1ef7488$var$_diverging = $cdbee463a1ef7488$var$_interopRequireWildcard((parcelRequire("5i1Ze")));

var $cdbee463a1ef7488$var$_tickFormat = $cdbee463a1ef7488$var$_interopRequireDefault((parcelRequire("kkpqj")));
function $cdbee463a1ef7488$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cdbee463a1ef7488$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($cdbee463a1ef7488$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $cdbee463a1ef7488$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $cdbee463a1ef7488$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRequire.register("9JfWo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7154ae890f0acee1$var$band;
module.exports.point = $7154ae890f0acee1$var$point;

var $k5p7I = parcelRequire("k5p7I");

var $dVAcc = parcelRequire("dVAcc");

var $7154ae890f0acee1$var$_ordinal = $7154ae890f0acee1$var$_interopRequireDefault((parcelRequire("6Gt5K")));
function $7154ae890f0acee1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7154ae890f0acee1$var$band() {
    var scale = (0, $7154ae890f0acee1$var$_ordinal.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $k5p7I.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $7154ae890f0acee1$var$band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return $dVAcc.initRange.apply(rescale(), arguments);
}
function $7154ae890f0acee1$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $7154ae890f0acee1$var$pointish(copy());
    };
    return scale;
}
function $7154ae890f0acee1$var$point() {
    return $7154ae890f0acee1$var$pointish($7154ae890f0acee1$var$band.apply(null, arguments).paddingInner(1));
}

});
parcelRequire.register("k5p7I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Adder", {
    enumerable: true,
    get: function() {
        return $gpt8f.Adder;
    }
});
Object.defineProperty(module.exports, "InternMap", {
    enumerable: true,
    get: function() {
        return $7I6G6.InternMap;
    }
});
Object.defineProperty(module.exports, "InternSet", {
    enumerable: true,
    get: function() {
        return $7I6G6.InternSet;
    }
});
Object.defineProperty(module.exports, "ascending", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "bin", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "bisect", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_bisect.default;
    }
});
Object.defineProperty(module.exports, "bisectCenter", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_bisect.bisectCenter;
    }
});
Object.defineProperty(module.exports, "bisectLeft", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_bisect.bisectLeft;
    }
});
Object.defineProperty(module.exports, "bisectRight", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_bisect.bisectRight;
    }
});
Object.defineProperty(module.exports, "bisector", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_bisector.default;
    }
});
Object.defineProperty(module.exports, "count", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_count.default;
    }
});
Object.defineProperty(module.exports, "cross", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "cumsum", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_cumsum.default;
    }
});
Object.defineProperty(module.exports, "descending", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "deviation", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_deviation.default;
    }
});
Object.defineProperty(module.exports, "difference", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_difference.default;
    }
});
Object.defineProperty(module.exports, "disjoint", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_disjoint.default;
    }
});
Object.defineProperty(module.exports, "every", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_every.default;
    }
});
Object.defineProperty(module.exports, "extent", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_extent.default;
    }
});
Object.defineProperty(module.exports, "fcumsum", {
    enumerable: true,
    get: function() {
        return $gpt8f.fcumsum;
    }
});
Object.defineProperty(module.exports, "filter", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_filter.default;
    }
});
Object.defineProperty(module.exports, "flatGroup", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_group.flatGroup;
    }
});
Object.defineProperty(module.exports, "flatRollup", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_group.flatRollup;
    }
});
Object.defineProperty(module.exports, "fsum", {
    enumerable: true,
    get: function() {
        return $gpt8f.fsum;
    }
});
Object.defineProperty(module.exports, "greatest", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_greatest.default;
    }
});
Object.defineProperty(module.exports, "greatestIndex", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_greatestIndex.default;
    }
});
Object.defineProperty(module.exports, "group", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_group.default;
    }
});
Object.defineProperty(module.exports, "groupSort", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_groupSort.default;
    }
});
Object.defineProperty(module.exports, "groups", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_group.groups;
    }
});
Object.defineProperty(module.exports, "histogram", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "index", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_group.index;
    }
});
Object.defineProperty(module.exports, "indexes", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_group.indexes;
    }
});
Object.defineProperty(module.exports, "intersection", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_intersection.default;
    }
});
Object.defineProperty(module.exports, "least", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_least.default;
    }
});
Object.defineProperty(module.exports, "leastIndex", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_leastIndex.default;
    }
});
Object.defineProperty(module.exports, "map", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_map.default;
    }
});
Object.defineProperty(module.exports, "max", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_max.default;
    }
});
Object.defineProperty(module.exports, "maxIndex", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_maxIndex.default;
    }
});
Object.defineProperty(module.exports, "mean", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_mean.default;
    }
});
Object.defineProperty(module.exports, "median", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_median.default;
    }
});
Object.defineProperty(module.exports, "merge", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_merge.default;
    }
});
Object.defineProperty(module.exports, "min", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_min.default;
    }
});
Object.defineProperty(module.exports, "minIndex", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_minIndex.default;
    }
});
Object.defineProperty(module.exports, "mode", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_mode.default;
    }
});
Object.defineProperty(module.exports, "nice", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_nice.default;
    }
});
Object.defineProperty(module.exports, "pairs", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_pairs.default;
    }
});
Object.defineProperty(module.exports, "permute", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_permute.default;
    }
});
Object.defineProperty(module.exports, "quantile", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "quantileSorted", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_quantile.quantileSorted;
    }
});
Object.defineProperty(module.exports, "quickselect", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_quickselect.default;
    }
});
Object.defineProperty(module.exports, "range", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_range.default;
    }
});
Object.defineProperty(module.exports, "rank", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_rank.default;
    }
});
Object.defineProperty(module.exports, "reduce", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_reduce.default;
    }
});
Object.defineProperty(module.exports, "reverse", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "rollup", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_group.rollup;
    }
});
Object.defineProperty(module.exports, "rollups", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_group.rollups;
    }
});
Object.defineProperty(module.exports, "scan", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_scan.default;
    }
});
Object.defineProperty(module.exports, "shuffle", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_shuffle.default;
    }
});
Object.defineProperty(module.exports, "shuffler", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_shuffle.shuffler;
    }
});
Object.defineProperty(module.exports, "some", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_some.default;
    }
});
Object.defineProperty(module.exports, "sort", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_sort.default;
    }
});
Object.defineProperty(module.exports, "subset", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_subset.default;
    }
});
Object.defineProperty(module.exports, "sum", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_sum.default;
    }
});
Object.defineProperty(module.exports, "superset", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_superset.default;
    }
});
Object.defineProperty(module.exports, "thresholdFreedmanDiaconis", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_freedmanDiaconis.default;
    }
});
Object.defineProperty(module.exports, "thresholdScott", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_scott.default;
    }
});
Object.defineProperty(module.exports, "thresholdSturges", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_sturges.default;
    }
});
Object.defineProperty(module.exports, "tickIncrement", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_ticks.tickIncrement;
    }
});
Object.defineProperty(module.exports, "tickStep", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_ticks.tickStep;
    }
});
Object.defineProperty(module.exports, "ticks", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_ticks.default;
    }
});
Object.defineProperty(module.exports, "transpose", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_transpose.default;
    }
});
Object.defineProperty(module.exports, "union", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_union.default;
    }
});
Object.defineProperty(module.exports, "variance", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_variance.default;
    }
});
Object.defineProperty(module.exports, "zip", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_zip.default;
    }
});

var $e9f7c34a33272be2$var$_bisect = $e9f7c34a33272be2$var$_interopRequireWildcard((parcelRequire("43yeO")));

var $e9f7c34a33272be2$var$_ascending = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("39Ini")));

var $e9f7c34a33272be2$var$_bisector = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("lGmGV")));

var $e9f7c34a33272be2$var$_count = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("l8jtH")));

var $e9f7c34a33272be2$var$_cross = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("hanMz")));

var $e9f7c34a33272be2$var$_cumsum = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("76RIn")));

var $e9f7c34a33272be2$var$_descending = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("9A73e")));

var $e9f7c34a33272be2$var$_deviation = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("j7SXB")));

var $e9f7c34a33272be2$var$_extent = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("lsEcM")));

var $gpt8f = parcelRequire("gpt8f");

var $e9f7c34a33272be2$var$_group = $e9f7c34a33272be2$var$_interopRequireWildcard((parcelRequire("1xyM5")));

var $e9f7c34a33272be2$var$_groupSort = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("6GPk3")));

var $e9f7c34a33272be2$var$_bin = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("bEkSl")));

var $e9f7c34a33272be2$var$_freedmanDiaconis = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("acyHX")));

var $e9f7c34a33272be2$var$_scott = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("hAOtB")));

var $e9f7c34a33272be2$var$_sturges = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("2KDlL")));

var $e9f7c34a33272be2$var$_max = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("16Hj2")));

var $e9f7c34a33272be2$var$_maxIndex = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("8HAZf")));

var $e9f7c34a33272be2$var$_mean = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("do0SF")));

var $e9f7c34a33272be2$var$_median = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("hTPcL")));

var $e9f7c34a33272be2$var$_merge = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("gspOS")));

var $e9f7c34a33272be2$var$_min = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("42F9U")));

var $e9f7c34a33272be2$var$_minIndex = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("ihqQu")));

var $e9f7c34a33272be2$var$_mode = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("igvuR")));

var $e9f7c34a33272be2$var$_nice = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("bGzLU")));

var $e9f7c34a33272be2$var$_pairs = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("bR440")));

var $e9f7c34a33272be2$var$_permute = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("1G2j3")));

var $e9f7c34a33272be2$var$_quantile = $e9f7c34a33272be2$var$_interopRequireWildcard((parcelRequire("lpFOV")));

var $e9f7c34a33272be2$var$_quickselect = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("axdrO")));

var $e9f7c34a33272be2$var$_range = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("iojua")));

var $e9f7c34a33272be2$var$_rank = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("3lynj")));

var $e9f7c34a33272be2$var$_least = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("8wDXM")));

var $e9f7c34a33272be2$var$_leastIndex = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("1Uixs")));

var $e9f7c34a33272be2$var$_greatest = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("ft5uT")));

var $e9f7c34a33272be2$var$_greatestIndex = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("dlgbV")));

var $e9f7c34a33272be2$var$_scan = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("d6Hkq")));

var $e9f7c34a33272be2$var$_shuffle = $e9f7c34a33272be2$var$_interopRequireWildcard((parcelRequire("ijGLX")));

var $e9f7c34a33272be2$var$_sum = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("lmtWS")));

var $e9f7c34a33272be2$var$_ticks = $e9f7c34a33272be2$var$_interopRequireWildcard((parcelRequire("yiH15")));

var $e9f7c34a33272be2$var$_transpose = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("007tl")));

var $e9f7c34a33272be2$var$_variance = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("eXBTy")));

var $e9f7c34a33272be2$var$_zip = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("8aP8p")));

var $e9f7c34a33272be2$var$_every = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("77fyv")));

var $e9f7c34a33272be2$var$_some = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("aO6H2")));

var $e9f7c34a33272be2$var$_filter = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("7ZpDD")));

var $e9f7c34a33272be2$var$_map = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("e5d2T")));

var $e9f7c34a33272be2$var$_reduce = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("3VQEL")));

var $e9f7c34a33272be2$var$_reverse = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("4jdv2")));

var $e9f7c34a33272be2$var$_sort = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("6iLdw")));

var $e9f7c34a33272be2$var$_difference = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("4yReJ")));

var $e9f7c34a33272be2$var$_disjoint = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("eDFdh")));

var $e9f7c34a33272be2$var$_intersection = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("c2YWQ")));

var $e9f7c34a33272be2$var$_subset = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("3euGV")));

var $e9f7c34a33272be2$var$_superset = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("dBs94")));

var $e9f7c34a33272be2$var$_union = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("fomCn")));

var $7I6G6 = parcelRequire("7I6G6");
function $e9f7c34a33272be2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e9f7c34a33272be2$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($e9f7c34a33272be2$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $e9f7c34a33272be2$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $e9f7c34a33272be2$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRequire.register("43yeO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.bisectRight = module.exports.bisectLeft = module.exports.bisectCenter = void 0;

var $2f420026f0b5df06$var$_ascending = $2f420026f0b5df06$var$_interopRequireDefault((parcelRequire("39Ini")));

var $2f420026f0b5df06$var$_bisector = $2f420026f0b5df06$var$_interopRequireDefault((parcelRequire("lGmGV")));

var $2f420026f0b5df06$var$_number = $2f420026f0b5df06$var$_interopRequireDefault((parcelRequire("3J6uV")));
function $2f420026f0b5df06$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2f420026f0b5df06$var$ascendingBisect = (0, $2f420026f0b5df06$var$_bisector.default)($2f420026f0b5df06$var$_ascending.default);
const $2f420026f0b5df06$var$bisectRight = $2f420026f0b5df06$var$ascendingBisect.right;
module.exports.bisectRight = $2f420026f0b5df06$var$bisectRight;
const $2f420026f0b5df06$var$bisectLeft = $2f420026f0b5df06$var$ascendingBisect.left;
module.exports.bisectLeft = $2f420026f0b5df06$var$bisectLeft;
const $2f420026f0b5df06$var$bisectCenter = (0, $2f420026f0b5df06$var$_bisector.default)($2f420026f0b5df06$var$_number.default).center;
module.exports.bisectCenter = $2f420026f0b5df06$var$bisectCenter;
var $2f420026f0b5df06$var$_default = $2f420026f0b5df06$var$bisectRight;
module.exports.default = $2f420026f0b5df06$var$_default;

});
parcelRequire.register("39Ini", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $24c4a23eba981b5a$var$ascending;
function $24c4a23eba981b5a$var$ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRequire.register("lGmGV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fc8f1f42fbec9319$var$bisector;

var $fc8f1f42fbec9319$var$_ascending = $fc8f1f42fbec9319$var$_interopRequireDefault((parcelRequire("39Ini")));

var $fc8f1f42fbec9319$var$_descending = $fc8f1f42fbec9319$var$_interopRequireDefault((parcelRequire("9A73e")));
function $fc8f1f42fbec9319$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fc8f1f42fbec9319$var$bisector(f) {
    let compare1, compare2, delta; // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = $fc8f1f42fbec9319$var$_ascending.default;
        compare2 = (d, x)=>(0, $fc8f1f42fbec9319$var$_ascending.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === $fc8f1f42fbec9319$var$_ascending.default || f === $fc8f1f42fbec9319$var$_descending.default ? f : $fc8f1f42fbec9319$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $fc8f1f42fbec9319$var$zero() {
    return 0;
}

});
parcelRequire.register("9A73e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6f9cf2144ff8ada8$var$descending;
function $6f9cf2144ff8ada8$var$descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRequire.register("3J6uV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2b6a9d5e6226de5e$var$number;
module.exports.numbers = $2b6a9d5e6226de5e$var$numbers;
function $2b6a9d5e6226de5e$var$number(x) {
    return x === null ? NaN : +x;
}
function* $2b6a9d5e6226de5e$var$numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRequire.register("l8jtH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f62974484cee4b56$var$count;
function $f62974484cee4b56$var$count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

});

parcelRequire.register("hanMz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c7f5d186996ed1d4$var$cross;
function $c7f5d186996ed1d4$var$length(array) {
    return array.length | 0;
}
function $c7f5d186996ed1d4$var$empty(length) {
    return !(length > 0);
}
function $c7f5d186996ed1d4$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $c7f5d186996ed1d4$var$reducer(reduce) {
    return (values)=>reduce(...values);
}
function $c7f5d186996ed1d4$var$cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && $c7f5d186996ed1d4$var$reducer(values.pop());
    values = values.map($c7f5d186996ed1d4$var$arrayify);
    const lengths = values.map($c7f5d186996ed1d4$var$length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some($c7f5d186996ed1d4$var$empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

});

parcelRequire.register("76RIn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $52d2c29036e05511$var$cumsum;
function $52d2c29036e05511$var$cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

});

parcelRequire.register("j7SXB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dec94dbe3b2ab56b$var$deviation;

var $dec94dbe3b2ab56b$var$_variance = $dec94dbe3b2ab56b$var$_interopRequireDefault((parcelRequire("eXBTy")));
function $dec94dbe3b2ab56b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $dec94dbe3b2ab56b$var$deviation(values, valueof) {
    const v = (0, $dec94dbe3b2ab56b$var$_variance.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

});
parcelRequire.register("eXBTy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ae43f88f121b97b0$var$variance;
function $ae43f88f121b97b0$var$variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

});


parcelRequire.register("lsEcM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f9fb66603451a4bb$var$extent;
function $f9fb66603451a4bb$var$extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRequire.register("gpt8f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Adder = void 0;
module.exports.fcumsum = $bf259425590a864c$var$fcumsum;
module.exports.fsum = $bf259425590a864c$var$fsum;
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $bf259425590a864c$var$Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
module.exports.Adder = $bf259425590a864c$var$Adder;
function $bf259425590a864c$var$fsum(values, valueof) {
    const adder = new $bf259425590a864c$var$Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $bf259425590a864c$var$fcumsum(values, valueof) {
    const adder = new $bf259425590a864c$var$Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

});

parcelRequire.register("1xyM5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $11f3d904556acb08$var$group;
module.exports.flatGroup = $11f3d904556acb08$var$flatGroup;
module.exports.flatRollup = $11f3d904556acb08$var$flatRollup;
module.exports.groups = $11f3d904556acb08$var$groups;
module.exports.index = $11f3d904556acb08$var$index;
module.exports.indexes = $11f3d904556acb08$var$indexes;
module.exports.rollup = $11f3d904556acb08$var$rollup;
module.exports.rollups = $11f3d904556acb08$var$rollups;

var $7I6G6 = parcelRequire("7I6G6");

var $11f3d904556acb08$var$_identity = $11f3d904556acb08$var$_interopRequireDefault((parcelRequire("evjAl")));
function $11f3d904556acb08$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $11f3d904556acb08$var$group(values, ...keys) {
    return $11f3d904556acb08$var$nest(values, $11f3d904556acb08$var$_identity.default, $11f3d904556acb08$var$_identity.default, keys);
}
function $11f3d904556acb08$var$groups(values, ...keys) {
    return $11f3d904556acb08$var$nest(values, Array.from, $11f3d904556acb08$var$_identity.default, keys);
}
function $11f3d904556acb08$var$flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function $11f3d904556acb08$var$flatGroup(values, ...keys) {
    return $11f3d904556acb08$var$flatten($11f3d904556acb08$var$groups(values, ...keys), keys);
}
function $11f3d904556acb08$var$flatRollup(values, reduce, ...keys) {
    return $11f3d904556acb08$var$flatten($11f3d904556acb08$var$rollups(values, reduce, ...keys), keys);
}
function $11f3d904556acb08$var$rollup(values, reduce, ...keys) {
    return $11f3d904556acb08$var$nest(values, $11f3d904556acb08$var$_identity.default, reduce, keys);
}
function $11f3d904556acb08$var$rollups(values, reduce, ...keys) {
    return $11f3d904556acb08$var$nest(values, Array.from, reduce, keys);
}
function $11f3d904556acb08$var$index(values, ...keys) {
    return $11f3d904556acb08$var$nest(values, $11f3d904556acb08$var$_identity.default, $11f3d904556acb08$var$unique, keys);
}
function $11f3d904556acb08$var$indexes(values, ...keys) {
    return $11f3d904556acb08$var$nest(values, Array.from, $11f3d904556acb08$var$unique, keys);
}
function $11f3d904556acb08$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $11f3d904556acb08$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new $7I6G6.InternMap();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

});
parcelRequire.register("7I6G6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InternSet = module.exports.InternMap = void 0;
class $59d1d29d433f1f05$var$InternMap extends Map {
    constructor(entries, key = $59d1d29d433f1f05$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($59d1d29d433f1f05$var$intern_get(this, key));
    }
    has(key) {
        return super.has($59d1d29d433f1f05$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($59d1d29d433f1f05$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($59d1d29d433f1f05$var$intern_delete(this, key));
    }
}
module.exports.InternMap = $59d1d29d433f1f05$var$InternMap;
class $59d1d29d433f1f05$var$InternSet extends Set {
    constructor(values, key = $59d1d29d433f1f05$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($59d1d29d433f1f05$var$intern_get(this, value));
    }
    add(value) {
        return super.add($59d1d29d433f1f05$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($59d1d29d433f1f05$var$intern_delete(this, value));
    }
}
module.exports.InternSet = $59d1d29d433f1f05$var$InternSet;
function $59d1d29d433f1f05$var$intern_get({ _intern: _intern , _key: _key  }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $59d1d29d433f1f05$var$intern_set({ _intern: _intern , _key: _key  }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $59d1d29d433f1f05$var$intern_delete({ _intern: _intern , _key: _key  }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $59d1d29d433f1f05$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});

parcelRequire.register("evjAl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a8f3272c1dc35fb8$var$identity;
function $a8f3272c1dc35fb8$var$identity(x) {
    return x;
}

});


parcelRequire.register("6GPk3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4dee79e32c8e62ca$var$groupSort;

var $4dee79e32c8e62ca$var$_ascending = $4dee79e32c8e62ca$var$_interopRequireDefault((parcelRequire("39Ini")));

var $4dee79e32c8e62ca$var$_group = $4dee79e32c8e62ca$var$_interopRequireWildcard((parcelRequire("1xyM5")));

var $4dee79e32c8e62ca$var$_sort = $4dee79e32c8e62ca$var$_interopRequireDefault((parcelRequire("6iLdw")));
function $4dee79e32c8e62ca$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($4dee79e32c8e62ca$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $4dee79e32c8e62ca$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $4dee79e32c8e62ca$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $4dee79e32c8e62ca$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4dee79e32c8e62ca$var$groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, $4dee79e32c8e62ca$var$_sort.default)((0, $4dee79e32c8e62ca$var$_group.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, $4dee79e32c8e62ca$var$_ascending.default)(av, bv) || (0, $4dee79e32c8e62ca$var$_ascending.default)(ak, bk)) : (0, $4dee79e32c8e62ca$var$_sort.default)((0, $4dee79e32c8e62ca$var$_group.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, $4dee79e32c8e62ca$var$_ascending.default)(ak, bk))).map(([key])=>key);
}

});
parcelRequire.register("6iLdw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ascendingDefined = $49690cd6da047ee5$var$ascendingDefined;
module.exports.compareDefined = $49690cd6da047ee5$var$compareDefined;
module.exports.default = $49690cd6da047ee5$var$sort;

var $49690cd6da047ee5$var$_ascending = $49690cd6da047ee5$var$_interopRequireDefault((parcelRequire("39Ini")));

var $49690cd6da047ee5$var$_permute = $49690cd6da047ee5$var$_interopRequireDefault((parcelRequire("1G2j3")));
function $49690cd6da047ee5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $49690cd6da047ee5$var$sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $49690cd6da047ee5$var$ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$49690cd6da047ee5$var$ascendingDefined(f[i], f[j]));
        }
        return (0, $49690cd6da047ee5$var$_permute.default)(values, index);
    }
    return values.sort($49690cd6da047ee5$var$compareDefined(f));
}
function $49690cd6da047ee5$var$compareDefined(compare = $49690cd6da047ee5$var$_ascending.default) {
    if (compare === $49690cd6da047ee5$var$_ascending.default) return $49690cd6da047ee5$var$ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $49690cd6da047ee5$var$ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

});
parcelRequire.register("1G2j3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $138b80b04d84d08a$var$permute;
function $138b80b04d84d08a$var$permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

});



parcelRequire.register("bEkSl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $87b39f8f1316f26e$var$bin;

var $g2fqu = parcelRequire("g2fqu");

var $87b39f8f1316f26e$var$_bisect = $87b39f8f1316f26e$var$_interopRequireDefault((parcelRequire("43yeO")));

var $87b39f8f1316f26e$var$_constant = $87b39f8f1316f26e$var$_interopRequireDefault((parcelRequire("kprME")));

var $87b39f8f1316f26e$var$_extent = $87b39f8f1316f26e$var$_interopRequireDefault((parcelRequire("lsEcM")));

var $87b39f8f1316f26e$var$_identity = $87b39f8f1316f26e$var$_interopRequireDefault((parcelRequire("evjAl")));

var $87b39f8f1316f26e$var$_nice = $87b39f8f1316f26e$var$_interopRequireDefault((parcelRequire("bGzLU")));

var $87b39f8f1316f26e$var$_ticks = $87b39f8f1316f26e$var$_interopRequireWildcard((parcelRequire("yiH15")));

var $87b39f8f1316f26e$var$_sturges = $87b39f8f1316f26e$var$_interopRequireDefault((parcelRequire("2KDlL")));
function $87b39f8f1316f26e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($87b39f8f1316f26e$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $87b39f8f1316f26e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $87b39f8f1316f26e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $87b39f8f1316f26e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $87b39f8f1316f26e$var$bin() {
    var value = $87b39f8f1316f26e$var$_identity.default, domain = $87b39f8f1316f26e$var$_extent.default, threshold = $87b39f8f1316f26e$var$_sturges.default;
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1); // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === $87b39f8f1316f26e$var$_extent.default) [x0, x1] = (0, $87b39f8f1316f26e$var$_nice.default)(x0, x1, tn);
            tz = (0, $87b39f8f1316f26e$var$_ticks.default)(x0, x1, tn); // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, $87b39f8f1316f26e$var$_ticks.tickIncrement)(x0, x1, tn); // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === $87b39f8f1316f26e$var$_extent.default) {
                    const step = (0, $87b39f8f1316f26e$var$_ticks.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        } // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin; // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        } // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, $87b39f8f1316f26e$var$_bisect.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $87b39f8f1316f26e$var$_constant.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $87b39f8f1316f26e$var$_constant.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $87b39f8f1316f26e$var$_constant.default)($g2fqu.slice.call(_)) : (0, $87b39f8f1316f26e$var$_constant.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRequire.register("g2fqu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slice = module.exports.map = void 0;
var $bac8cc90bc9c1575$var$array = Array.prototype;
var $bac8cc90bc9c1575$var$slice = $bac8cc90bc9c1575$var$array.slice;
module.exports.slice = $bac8cc90bc9c1575$var$slice;
var $bac8cc90bc9c1575$var$map = $bac8cc90bc9c1575$var$array.map;
module.exports.map = $bac8cc90bc9c1575$var$map;

});

parcelRequire.register("kprME", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $edbbb1b3ee9e2bfe$var$constant;
function $edbbb1b3ee9e2bfe$var$constant(x) {
    return ()=>x;
}

});

parcelRequire.register("bGzLU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $881f5d72be009a6c$var$nice;

var $yiH15 = parcelRequire("yiH15");
function $881f5d72be009a6c$var$nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, $yiH15.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

});
parcelRequire.register("yiH15", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0671ad1829c0816d$var$ticks;
module.exports.tickIncrement = $0671ad1829c0816d$var$tickIncrement;
module.exports.tickStep = $0671ad1829c0816d$var$tickStep;
var $0671ad1829c0816d$var$e10 = Math.sqrt(50), $0671ad1829c0816d$var$e5 = Math.sqrt(10), $0671ad1829c0816d$var$e2 = Math.sqrt(2);
function $0671ad1829c0816d$var$ticks(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $0671ad1829c0816d$var$tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $0671ad1829c0816d$var$tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $0671ad1829c0816d$var$e10 ? 10 : error >= $0671ad1829c0816d$var$e5 ? 5 : error >= $0671ad1829c0816d$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $0671ad1829c0816d$var$e10 ? 10 : error >= $0671ad1829c0816d$var$e5 ? 5 : error >= $0671ad1829c0816d$var$e2 ? 2 : 1);
}
function $0671ad1829c0816d$var$tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $0671ad1829c0816d$var$e10) step1 *= 10;
    else if (error >= $0671ad1829c0816d$var$e5) step1 *= 5;
    else if (error >= $0671ad1829c0816d$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});


parcelRequire.register("2KDlL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $200e66c047a151fe$var$thresholdSturges;

var $200e66c047a151fe$var$_count = $200e66c047a151fe$var$_interopRequireDefault((parcelRequire("l8jtH")));
function $200e66c047a151fe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $200e66c047a151fe$var$thresholdSturges(values) {
    return Math.ceil(Math.log((0, $200e66c047a151fe$var$_count.default)(values)) / Math.LN2) + 1;
}

});


parcelRequire.register("acyHX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $76d5f2a97bb94038$var$thresholdFreedmanDiaconis;

var $76d5f2a97bb94038$var$_count = $76d5f2a97bb94038$var$_interopRequireDefault((parcelRequire("l8jtH")));

var $76d5f2a97bb94038$var$_quantile = $76d5f2a97bb94038$var$_interopRequireDefault((parcelRequire("lpFOV")));
function $76d5f2a97bb94038$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $76d5f2a97bb94038$var$thresholdFreedmanDiaconis(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, $76d5f2a97bb94038$var$_quantile.default)(values, 0.75) - (0, $76d5f2a97bb94038$var$_quantile.default)(values, 0.25)) * Math.pow((0, $76d5f2a97bb94038$var$_count.default)(values), -1 / 3)));
}

});
parcelRequire.register("lpFOV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f96c5f6e49ea0733$var$quantile;
module.exports.quantileSorted = $f96c5f6e49ea0733$var$quantileSorted;

var $f96c5f6e49ea0733$var$_max = $f96c5f6e49ea0733$var$_interopRequireDefault((parcelRequire("16Hj2")));

var $f96c5f6e49ea0733$var$_min = $f96c5f6e49ea0733$var$_interopRequireDefault((parcelRequire("42F9U")));

var $f96c5f6e49ea0733$var$_quickselect = $f96c5f6e49ea0733$var$_interopRequireDefault((parcelRequire("axdrO")));

var $f96c5f6e49ea0733$var$_number = $f96c5f6e49ea0733$var$_interopRequireWildcard((parcelRequire("3J6uV")));
function $f96c5f6e49ea0733$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f96c5f6e49ea0733$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f96c5f6e49ea0733$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f96c5f6e49ea0733$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $f96c5f6e49ea0733$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f96c5f6e49ea0733$var$quantile(values, p, valueof) {
    values = Float64Array.from((0, $f96c5f6e49ea0733$var$_number.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, $f96c5f6e49ea0733$var$_min.default)(values);
    if (p >= 1) return (0, $f96c5f6e49ea0733$var$_max.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $f96c5f6e49ea0733$var$_max.default)((0, $f96c5f6e49ea0733$var$_quickselect.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, $f96c5f6e49ea0733$var$_min.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $f96c5f6e49ea0733$var$quantileSorted(values, p, valueof = $f96c5f6e49ea0733$var$_number.default) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});
parcelRequire.register("16Hj2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0ce7f1aed049e347$var$max;
function $0ce7f1aed049e347$var$max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRequire.register("42F9U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2f17469b425004be$var$min;
function $2f17469b425004be$var$min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

});

parcelRequire.register("axdrO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7ab76ad7e6f16842$var$quickselect;

var $6iLdw = parcelRequire("6iLdw");
// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function $7ab76ad7e6f16842$var$quickselect(array, k, left = 0, right = array.length - 1, compare) {
    compare = compare === undefined ? $6iLdw.ascendingDefined : (0, $6iLdw.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $7ab76ad7e6f16842$var$quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $7ab76ad7e6f16842$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $7ab76ad7e6f16842$var$swap(array, left, right);
        while(i < j){
            $7ab76ad7e6f16842$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $7ab76ad7e6f16842$var$swap(array, left, j);
        else ++j, $7ab76ad7e6f16842$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $7ab76ad7e6f16842$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

});



parcelRequire.register("hAOtB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ccecf4085382ea07$var$thresholdScott;

var $ccecf4085382ea07$var$_count = $ccecf4085382ea07$var$_interopRequireDefault((parcelRequire("l8jtH")));

var $ccecf4085382ea07$var$_deviation = $ccecf4085382ea07$var$_interopRequireDefault((parcelRequire("j7SXB")));
function $ccecf4085382ea07$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ccecf4085382ea07$var$thresholdScott(values, min, max) {
    return Math.ceil((max - min) * Math.cbrt((0, $ccecf4085382ea07$var$_count.default)(values)) / (3.49 * (0, $ccecf4085382ea07$var$_deviation.default)(values)));
}

});

parcelRequire.register("8HAZf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $655f07b3eccfc9a9$var$maxIndex;
function $655f07b3eccfc9a9$var$maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

});

parcelRequire.register("do0SF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9bee331fb011122b$var$mean;
function $9bee331fb011122b$var$mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

});

parcelRequire.register("hTPcL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d07f4af01fcb554b$var$median;

var $d07f4af01fcb554b$var$_quantile = $d07f4af01fcb554b$var$_interopRequireDefault((parcelRequire("lpFOV")));
function $d07f4af01fcb554b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d07f4af01fcb554b$var$median(values, valueof) {
    return (0, $d07f4af01fcb554b$var$_quantile.default)(values, 0.5, valueof);
}

});

parcelRequire.register("gspOS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bfb34a1b1f2378dd$var$merge;
function* $bfb34a1b1f2378dd$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $bfb34a1b1f2378dd$var$merge(arrays) {
    return Array.from($bfb34a1b1f2378dd$var$flatten(arrays));
}

});

parcelRequire.register("ihqQu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d4eea380e0705f67$var$minIndex;
function $d4eea380e0705f67$var$minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

});

parcelRequire.register("igvuR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d4c22730f6c87526$var$mode;

var $7I6G6 = parcelRequire("7I6G6");
function $d4c22730f6c87526$var$mode(values, valueof) {
    const counts = new $7I6G6.InternMap();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

});

parcelRequire.register("bR440", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8a17cbe542601361$var$pairs;
module.exports.pair = $8a17cbe542601361$var$pair;
function $8a17cbe542601361$var$pairs(values, pairof = $8a17cbe542601361$var$pair) {
    const pairs = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs;
}
function $8a17cbe542601361$var$pair(a, b) {
    return [
        a,
        b
    ];
}

});

parcelRequire.register("iojua", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d63995507c4c9b1e$var$range;
function $d63995507c4c9b1e$var$range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRequire.register("3lynj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $26fdff6c1444b4ef$var$rank;

var $26fdff6c1444b4ef$var$_ascending = $26fdff6c1444b4ef$var$_interopRequireDefault((parcelRequire("39Ini")));

var $6iLdw = parcelRequire("6iLdw");
function $26fdff6c1444b4ef$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $26fdff6c1444b4ef$var$rank(values, valueof = $26fdff6c1444b4ef$var$_ascending.default) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = $26fdff6c1444b4ef$var$_ascending.default;
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    Uint32Array.from(V, (_, i)=>i).sort(valueof === $26fdff6c1444b4ef$var$_ascending.default ? (i, j)=>(0, $6iLdw.ascendingDefined)(V[i], V[j]) : (0, $6iLdw.compareDefined)(compareIndex)).forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

});

parcelRequire.register("8wDXM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $63504fbc0fced18c$var$least;

var $63504fbc0fced18c$var$_ascending = $63504fbc0fced18c$var$_interopRequireDefault((parcelRequire("39Ini")));
function $63504fbc0fced18c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $63504fbc0fced18c$var$least(values, compare = $63504fbc0fced18c$var$_ascending.default) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $63504fbc0fced18c$var$_ascending.default)(value, minValue) < 0 : (0, $63504fbc0fced18c$var$_ascending.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

});

parcelRequire.register("1Uixs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $163966ceed2dfabf$var$leastIndex;

var $163966ceed2dfabf$var$_ascending = $163966ceed2dfabf$var$_interopRequireDefault((parcelRequire("39Ini")));

var $163966ceed2dfabf$var$_minIndex = $163966ceed2dfabf$var$_interopRequireDefault((parcelRequire("ihqQu")));
function $163966ceed2dfabf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $163966ceed2dfabf$var$leastIndex(values, compare = $163966ceed2dfabf$var$_ascending.default) {
    if (compare.length === 1) return (0, $163966ceed2dfabf$var$_minIndex.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

});

parcelRequire.register("ft5uT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b42dd413fab8f9f3$var$greatest;

var $b42dd413fab8f9f3$var$_ascending = $b42dd413fab8f9f3$var$_interopRequireDefault((parcelRequire("39Ini")));
function $b42dd413fab8f9f3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b42dd413fab8f9f3$var$greatest(values, compare = $b42dd413fab8f9f3$var$_ascending.default) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $b42dd413fab8f9f3$var$_ascending.default)(value, maxValue) > 0 : (0, $b42dd413fab8f9f3$var$_ascending.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

});

parcelRequire.register("dlgbV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9b69cbcab3b4b555$var$greatestIndex;

var $9b69cbcab3b4b555$var$_ascending = $9b69cbcab3b4b555$var$_interopRequireDefault((parcelRequire("39Ini")));

var $9b69cbcab3b4b555$var$_maxIndex = $9b69cbcab3b4b555$var$_interopRequireDefault((parcelRequire("8HAZf")));
function $9b69cbcab3b4b555$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9b69cbcab3b4b555$var$greatestIndex(values, compare = $9b69cbcab3b4b555$var$_ascending.default) {
    if (compare.length === 1) return (0, $9b69cbcab3b4b555$var$_maxIndex.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

});

parcelRequire.register("d6Hkq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $98ad7203b0ae11ff$var$scan;

var $98ad7203b0ae11ff$var$_leastIndex = $98ad7203b0ae11ff$var$_interopRequireDefault((parcelRequire("1Uixs")));
function $98ad7203b0ae11ff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $98ad7203b0ae11ff$var$scan(values, compare) {
    const index = (0, $98ad7203b0ae11ff$var$_leastIndex.default)(values, compare);
    return index < 0 ? undefined : index;
}

});

parcelRequire.register("ijGLX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.shuffler = $d55b2e14c78999ed$var$shuffler;
var $d55b2e14c78999ed$var$_default = $d55b2e14c78999ed$var$shuffler(Math.random);
module.exports.default = $d55b2e14c78999ed$var$_default;
function $d55b2e14c78999ed$var$shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

});

parcelRequire.register("lmtWS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f8d2e23b8cf5374c$var$sum;
function $f8d2e23b8cf5374c$var$sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

});

parcelRequire.register("007tl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $000017ef9ef15772$var$transpose;

var $000017ef9ef15772$var$_min = $000017ef9ef15772$var$_interopRequireDefault((parcelRequire("42F9U")));
function $000017ef9ef15772$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $000017ef9ef15772$var$transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $000017ef9ef15772$var$_min.default)(matrix, $000017ef9ef15772$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $000017ef9ef15772$var$length(d) {
    return d.length;
}

});

parcelRequire.register("8aP8p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5f36ec2a0ce9afb5$var$zip;

var $5f36ec2a0ce9afb5$var$_transpose = $5f36ec2a0ce9afb5$var$_interopRequireDefault((parcelRequire("007tl")));
function $5f36ec2a0ce9afb5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5f36ec2a0ce9afb5$var$zip() {
    return (0, $5f36ec2a0ce9afb5$var$_transpose.default)(arguments);
}

});

parcelRequire.register("77fyv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $52e540e022190437$var$every;
function $52e540e022190437$var$every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

});

parcelRequire.register("aO6H2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7de3c4068a3b6429$var$some;
function $7de3c4068a3b6429$var$some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

});

parcelRequire.register("7ZpDD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5d121e217c855b48$var$filter;
function $5d121e217c855b48$var$filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

});

parcelRequire.register("e5d2T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a40ba6eb8081c873$var$map;
function $a40ba6eb8081c873$var$map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

});

parcelRequire.register("3VQEL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2dcf8a7410cb5180$var$reduce;
function $2dcf8a7410cb5180$var$reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done: done , value: value  } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done: done , value: next  } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

});

parcelRequire.register("4jdv2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $323368893ca474f3$var$reverse;
function $323368893ca474f3$var$reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

});

parcelRequire.register("4yReJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3523a218fb8ad9df$var$difference;

var $7I6G6 = parcelRequire("7I6G6");
function $3523a218fb8ad9df$var$difference(values, ...others) {
    values = new $7I6G6.InternSet(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

});

parcelRequire.register("eDFdh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aa84ad4663c83148$var$disjoint;

var $7I6G6 = parcelRequire("7I6G6");
function $aa84ad4663c83148$var$disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new $7I6G6.InternSet();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value: value , done: done  } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

});

parcelRequire.register("c2YWQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8c54f2f635050cc2$var$intersection;

var $7I6G6 = parcelRequire("7I6G6");
function $8c54f2f635050cc2$var$intersection(values, ...others) {
    values = new $7I6G6.InternSet(values);
    others = others.map($8c54f2f635050cc2$var$set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function $8c54f2f635050cc2$var$set(values) {
    return values instanceof $7I6G6.InternSet ? values : new $7I6G6.InternSet(values);
}

});

parcelRequire.register("3euGV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $25aa7c910c6a8d4e$var$subset;

var $25aa7c910c6a8d4e$var$_superset = $25aa7c910c6a8d4e$var$_interopRequireDefault((parcelRequire("dBs94")));
function $25aa7c910c6a8d4e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $25aa7c910c6a8d4e$var$subset(values, other) {
    return (0, $25aa7c910c6a8d4e$var$_superset.default)(other, values);
}

});
parcelRequire.register("dBs94", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9e74901da348be74$var$superset;
function $9e74901da348be74$var$superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = $9e74901da348be74$var$intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value: value , done: done  } = iterator.next()){
            if (done) return false;
            const ivalue = $9e74901da348be74$var$intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function $9e74901da348be74$var$intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});


parcelRequire.register("fomCn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b34aa459427165bb$var$union;

var $7I6G6 = parcelRequire("7I6G6");
function $b34aa459427165bb$var$union(...others) {
    const set = new $7I6G6.InternSet();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

});


parcelRequire.register("dVAcc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initInterpolator = $a23cacef886ea7a0$var$initInterpolator;
module.exports.initRange = $a23cacef886ea7a0$var$initRange;
function $a23cacef886ea7a0$var$initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $a23cacef886ea7a0$var$initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRequire.register("6Gt5K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4ddd3b522464a8eb$var$ordinal;
module.exports.implicit = void 0;

var $k5p7I = parcelRequire("k5p7I");

var $dVAcc = parcelRequire("dVAcc");
const $4ddd3b522464a8eb$var$implicit = Symbol("implicit");
module.exports.implicit = $4ddd3b522464a8eb$var$implicit;
function $4ddd3b522464a8eb$var$ordinal() {
    var index = new $k5p7I.InternMap(), domain = [], range = [], unknown = $4ddd3b522464a8eb$var$implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $4ddd3b522464a8eb$var$implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new $k5p7I.InternMap();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $4ddd3b522464a8eb$var$ordinal(domain, range).unknown(unknown);
    };
    $dVAcc.initRange.apply(scale, arguments);
    return scale;
}

});


parcelRequire.register("6kEZa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $49c4673966f527a8$var$identity;

var $hHCkv = parcelRequire("hHCkv");

var $49c4673966f527a8$var$_number = $49c4673966f527a8$var$_interopRequireDefault((parcelRequire("66OMX")));
function $49c4673966f527a8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $49c4673966f527a8$var$identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, $49c4673966f527a8$var$_number.default), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $49c4673966f527a8$var$identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, $49c4673966f527a8$var$_number.default) : [
        0,
        1
    ];
    return (0, $hHCkv.linearish)(scale);
}

});
parcelRequire.register("hHCkv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ce342f4f280b4073$var$linear;
module.exports.linearish = $ce342f4f280b4073$var$linearish;

var $k5p7I = parcelRequire("k5p7I");

var $ce342f4f280b4073$var$_continuous = $ce342f4f280b4073$var$_interopRequireWildcard((parcelRequire("aiVEG")));

var $dVAcc = parcelRequire("dVAcc");

var $ce342f4f280b4073$var$_tickFormat = $ce342f4f280b4073$var$_interopRequireDefault((parcelRequire("kkpqj")));
function $ce342f4f280b4073$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ce342f4f280b4073$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($ce342f4f280b4073$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $ce342f4f280b4073$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $ce342f4f280b4073$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $ce342f4f280b4073$var$linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $k5p7I.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $ce342f4f280b4073$var$_tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $k5p7I.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $ce342f4f280b4073$var$linear() {
    var scale = (0, $ce342f4f280b4073$var$_continuous.default)();
    scale.copy = function() {
        return (0, $ce342f4f280b4073$var$_continuous.copy)(scale, $ce342f4f280b4073$var$linear());
    };
    $dVAcc.initRange.apply(scale, arguments);
    return $ce342f4f280b4073$var$linearish(scale);
}

});
parcelRequire.register("aiVEG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $78084eee6fcde26c$var$copy;
module.exports.default = $78084eee6fcde26c$var$continuous;
module.exports.identity = $78084eee6fcde26c$var$identity;
module.exports.transformer = $78084eee6fcde26c$var$transformer;

var $k5p7I = parcelRequire("k5p7I");

var $asL1O = parcelRequire("asL1O");

var $78084eee6fcde26c$var$_constant = $78084eee6fcde26c$var$_interopRequireDefault((parcelRequire("cqkH3")));

var $78084eee6fcde26c$var$_number = $78084eee6fcde26c$var$_interopRequireDefault((parcelRequire("66OMX")));
function $78084eee6fcde26c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $78084eee6fcde26c$var$unit = [
    0,
    1
];
function $78084eee6fcde26c$var$identity(x) {
    return x;
}
function $78084eee6fcde26c$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $78084eee6fcde26c$var$_constant.default)(isNaN(b) ? NaN : 0.5);
}
function $78084eee6fcde26c$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
} // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $78084eee6fcde26c$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $78084eee6fcde26c$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $78084eee6fcde26c$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $78084eee6fcde26c$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1; // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $78084eee6fcde26c$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $k5p7I.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $78084eee6fcde26c$var$copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $78084eee6fcde26c$var$transformer() {
    var domain = $78084eee6fcde26c$var$unit, range = $78084eee6fcde26c$var$unit, interpolate = $asL1O.interpolate, transform, untransform, unknown, clamp = $78084eee6fcde26c$var$identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $78084eee6fcde26c$var$identity) clamp = $78084eee6fcde26c$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $78084eee6fcde26c$var$polymap : $78084eee6fcde26c$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), $asL1O.interpolateNumber)))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, $78084eee6fcde26c$var$_number.default), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = $asL1O.interpolateRound, rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $78084eee6fcde26c$var$identity, rescale()) : clamp !== $78084eee6fcde26c$var$identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $78084eee6fcde26c$var$continuous() {
    return $78084eee6fcde26c$var$transformer()($78084eee6fcde26c$var$identity, $78084eee6fcde26c$var$identity);
}

});
parcelRequire.register("asL1O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "interpolate", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_value.default;
    }
});
Object.defineProperty(module.exports, "interpolateArray", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_array.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasis", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasisClosed", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelix", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelixLong", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_cubehelix.cubehelixLong;
    }
});
Object.defineProperty(module.exports, "interpolateDate", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_date.default;
    }
});
Object.defineProperty(module.exports, "interpolateDiscrete", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_discrete.default;
    }
});
Object.defineProperty(module.exports, "interpolateHcl", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_hcl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHclLong", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_hcl.hclLong;
    }
});
Object.defineProperty(module.exports, "interpolateHsl", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_hsl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHslLong", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_hsl.hslLong;
    }
});
Object.defineProperty(module.exports, "interpolateHue", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_hue.default;
    }
});
Object.defineProperty(module.exports, "interpolateLab", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumber", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_number.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumberArray", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_numberArray.default;
    }
});
Object.defineProperty(module.exports, "interpolateObject", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_object.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgb", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_rgb.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasis", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_rgb.rgbBasis;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasisClosed", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_rgb.rgbBasisClosed;
    }
});
Object.defineProperty(module.exports, "interpolateRound", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_round.default;
    }
});
Object.defineProperty(module.exports, "interpolateString", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_string.default;
    }
});
Object.defineProperty(module.exports, "interpolateTransformCss", {
    enumerable: true,
    get: function() {
        return $gQqF8.interpolateTransformCss;
    }
});
Object.defineProperty(module.exports, "interpolateTransformSvg", {
    enumerable: true,
    get: function() {
        return $gQqF8.interpolateTransformSvg;
    }
});
Object.defineProperty(module.exports, "interpolateZoom", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_zoom.default;
    }
});
Object.defineProperty(module.exports, "piecewise", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_piecewise.default;
    }
});
Object.defineProperty(module.exports, "quantize", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_quantize.default;
    }
});

var $79e0ffbad0c465ce$var$_value = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("aQYao")));

var $79e0ffbad0c465ce$var$_array = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("c4KMz")));

var $79e0ffbad0c465ce$var$_basis = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("ezZsL")));

var $79e0ffbad0c465ce$var$_basisClosed = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("d2lJY")));

var $79e0ffbad0c465ce$var$_date = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("iyq1R")));

var $79e0ffbad0c465ce$var$_discrete = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("7oUoq")));

var $79e0ffbad0c465ce$var$_hue = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("71uY5")));

var $79e0ffbad0c465ce$var$_number = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("6PTwm")));

var $79e0ffbad0c465ce$var$_numberArray = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("ioONj")));

var $79e0ffbad0c465ce$var$_object = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("7dlFo")));

var $79e0ffbad0c465ce$var$_round = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("4MvlC")));

var $79e0ffbad0c465ce$var$_string = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("8AKoU")));

var $gQqF8 = parcelRequire("gQqF8");

var $79e0ffbad0c465ce$var$_zoom = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("5SD24")));

var $79e0ffbad0c465ce$var$_rgb = $79e0ffbad0c465ce$var$_interopRequireWildcard((parcelRequire("1fggl")));

var $79e0ffbad0c465ce$var$_hsl = $79e0ffbad0c465ce$var$_interopRequireWildcard((parcelRequire("giUqz")));

var $79e0ffbad0c465ce$var$_lab = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("l2CY2")));

var $79e0ffbad0c465ce$var$_hcl = $79e0ffbad0c465ce$var$_interopRequireWildcard((parcelRequire("SKV88")));

var $79e0ffbad0c465ce$var$_cubehelix = $79e0ffbad0c465ce$var$_interopRequireWildcard((parcelRequire("frD9h")));

var $79e0ffbad0c465ce$var$_piecewise = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("6DVQq")));

var $79e0ffbad0c465ce$var$_quantize = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("deK3z")));
function $79e0ffbad0c465ce$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($79e0ffbad0c465ce$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $79e0ffbad0c465ce$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $79e0ffbad0c465ce$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $79e0ffbad0c465ce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRequire.register("aQYao", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7e6d6e89b3f8ba29$var$_default;

var $fqfF4 = parcelRequire("fqfF4");

var $7e6d6e89b3f8ba29$var$_rgb = $7e6d6e89b3f8ba29$var$_interopRequireDefault((parcelRequire("1fggl")));

var $c4KMz = parcelRequire("c4KMz");

var $7e6d6e89b3f8ba29$var$_date = $7e6d6e89b3f8ba29$var$_interopRequireDefault((parcelRequire("iyq1R")));

var $7e6d6e89b3f8ba29$var$_number = $7e6d6e89b3f8ba29$var$_interopRequireDefault((parcelRequire("6PTwm")));

var $7e6d6e89b3f8ba29$var$_object = $7e6d6e89b3f8ba29$var$_interopRequireDefault((parcelRequire("7dlFo")));

var $7e6d6e89b3f8ba29$var$_string = $7e6d6e89b3f8ba29$var$_interopRequireDefault((parcelRequire("8AKoU")));

var $7e6d6e89b3f8ba29$var$_constant = $7e6d6e89b3f8ba29$var$_interopRequireDefault((parcelRequire("fHinc")));

var $7e6d6e89b3f8ba29$var$_numberArray = $7e6d6e89b3f8ba29$var$_interopRequireWildcard((parcelRequire("ioONj")));
function $7e6d6e89b3f8ba29$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($7e6d6e89b3f8ba29$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $7e6d6e89b3f8ba29$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $7e6d6e89b3f8ba29$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $7e6d6e89b3f8ba29$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7e6d6e89b3f8ba29$var$_default(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $7e6d6e89b3f8ba29$var$_constant.default)(b) : (t === "number" ? $7e6d6e89b3f8ba29$var$_number.default : t === "string" ? (c = (0, $fqfF4.color)(b)) ? (b = c, $7e6d6e89b3f8ba29$var$_rgb.default) : $7e6d6e89b3f8ba29$var$_string.default : b instanceof $fqfF4.color ? $7e6d6e89b3f8ba29$var$_rgb.default : b instanceof Date ? $7e6d6e89b3f8ba29$var$_date.default : (0, $7e6d6e89b3f8ba29$var$_numberArray.isNumberArray)(b) ? $7e6d6e89b3f8ba29$var$_numberArray.default : Array.isArray(b) ? $c4KMz.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? $7e6d6e89b3f8ba29$var$_object.default : $7e6d6e89b3f8ba29$var$_number.default)(a, b);
}

});
parcelRequire.register("fqfF4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "color", {
    enumerable: true,
    get: function() {
        return $02e5c3d9c0e069ee$var$_color.default;
    }
});
Object.defineProperty(module.exports, "cubehelix", {
    enumerable: true,
    get: function() {
        return $02e5c3d9c0e069ee$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "gray", {
    enumerable: true,
    get: function() {
        return $02e5c3d9c0e069ee$var$_lab.gray;
    }
});
Object.defineProperty(module.exports, "hcl", {
    enumerable: true,
    get: function() {
        return $02e5c3d9c0e069ee$var$_lab.hcl;
    }
});
Object.defineProperty(module.exports, "hsl", {
    enumerable: true,
    get: function() {
        return $02e5c3d9c0e069ee$var$_color.hsl;
    }
});
Object.defineProperty(module.exports, "lab", {
    enumerable: true,
    get: function() {
        return $02e5c3d9c0e069ee$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "lch", {
    enumerable: true,
    get: function() {
        return $02e5c3d9c0e069ee$var$_lab.lch;
    }
});
Object.defineProperty(module.exports, "rgb", {
    enumerable: true,
    get: function() {
        return $02e5c3d9c0e069ee$var$_color.rgb;
    }
});

var $02e5c3d9c0e069ee$var$_color = $02e5c3d9c0e069ee$var$_interopRequireWildcard((parcelRequire("fBwMw")));

var $02e5c3d9c0e069ee$var$_lab = $02e5c3d9c0e069ee$var$_interopRequireWildcard((parcelRequire("8bmD3")));

var $02e5c3d9c0e069ee$var$_cubehelix = $02e5c3d9c0e069ee$var$_interopRequireDefault((parcelRequire("e7YcQ")));
function $02e5c3d9c0e069ee$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $02e5c3d9c0e069ee$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($02e5c3d9c0e069ee$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $02e5c3d9c0e069ee$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $02e5c3d9c0e069ee$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRequire.register("fBwMw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Color = $b5c3bd712c9dea25$var$Color;
module.exports.Rgb = $b5c3bd712c9dea25$var$Rgb;
module.exports.darker = module.exports.brighter = void 0;
module.exports.default = $b5c3bd712c9dea25$var$color;
module.exports.hsl = $b5c3bd712c9dea25$var$hsl;
module.exports.hslConvert = $b5c3bd712c9dea25$var$hslConvert;
module.exports.rgb = $b5c3bd712c9dea25$var$rgb;
module.exports.rgbConvert = $b5c3bd712c9dea25$var$rgbConvert;

var $b5c3bd712c9dea25$var$_define = $b5c3bd712c9dea25$var$_interopRequireWildcard((parcelRequire("4P4QL")));
function $b5c3bd712c9dea25$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($b5c3bd712c9dea25$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $b5c3bd712c9dea25$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $b5c3bd712c9dea25$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $b5c3bd712c9dea25$var$Color() {}
var $b5c3bd712c9dea25$var$darker = 0.7;
module.exports.darker = $b5c3bd712c9dea25$var$darker;
var $b5c3bd712c9dea25$var$brighter = 1 / $b5c3bd712c9dea25$var$darker;
module.exports.brighter = $b5c3bd712c9dea25$var$brighter;
var $b5c3bd712c9dea25$var$reI = "\\s*([+-]?\\d+)\\s*", $b5c3bd712c9dea25$var$reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", $b5c3bd712c9dea25$var$reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", $b5c3bd712c9dea25$var$reHex = /^#([0-9a-f]{3,8})$/, $b5c3bd712c9dea25$var$reRgbInteger = new RegExp(`^rgb\\(${$b5c3bd712c9dea25$var$reI},${$b5c3bd712c9dea25$var$reI},${$b5c3bd712c9dea25$var$reI}\\)$`), $b5c3bd712c9dea25$var$reRgbPercent = new RegExp(`^rgb\\(${$b5c3bd712c9dea25$var$reP},${$b5c3bd712c9dea25$var$reP},${$b5c3bd712c9dea25$var$reP}\\)$`), $b5c3bd712c9dea25$var$reRgbaInteger = new RegExp(`^rgba\\(${$b5c3bd712c9dea25$var$reI},${$b5c3bd712c9dea25$var$reI},${$b5c3bd712c9dea25$var$reI},${$b5c3bd712c9dea25$var$reN}\\)$`), $b5c3bd712c9dea25$var$reRgbaPercent = new RegExp(`^rgba\\(${$b5c3bd712c9dea25$var$reP},${$b5c3bd712c9dea25$var$reP},${$b5c3bd712c9dea25$var$reP},${$b5c3bd712c9dea25$var$reN}\\)$`), $b5c3bd712c9dea25$var$reHslPercent = new RegExp(`^hsl\\(${$b5c3bd712c9dea25$var$reN},${$b5c3bd712c9dea25$var$reP},${$b5c3bd712c9dea25$var$reP}\\)$`), $b5c3bd712c9dea25$var$reHslaPercent = new RegExp(`^hsla\\(${$b5c3bd712c9dea25$var$reN},${$b5c3bd712c9dea25$var$reP},${$b5c3bd712c9dea25$var$reP},${$b5c3bd712c9dea25$var$reN}\\)$`);
var $b5c3bd712c9dea25$var$named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $b5c3bd712c9dea25$var$_define.default)($b5c3bd712c9dea25$var$Color, $b5c3bd712c9dea25$var$color, {
    copy (channels) {
        return Object.assign(new this.constructor(), this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: $b5c3bd712c9dea25$var$color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: $b5c3bd712c9dea25$var$color_formatHex,
    formatHex8: $b5c3bd712c9dea25$var$color_formatHex8,
    formatHsl: $b5c3bd712c9dea25$var$color_formatHsl,
    formatRgb: $b5c3bd712c9dea25$var$color_formatRgb,
    toString: $b5c3bd712c9dea25$var$color_formatRgb
});
function $b5c3bd712c9dea25$var$color_formatHex() {
    return this.rgb().formatHex();
}
function $b5c3bd712c9dea25$var$color_formatHex8() {
    return this.rgb().formatHex8();
}
function $b5c3bd712c9dea25$var$color_formatHsl() {
    return $b5c3bd712c9dea25$var$hslConvert(this).formatHsl();
}
function $b5c3bd712c9dea25$var$color_formatRgb() {
    return this.rgb().formatRgb();
}
function $b5c3bd712c9dea25$var$color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = $b5c3bd712c9dea25$var$reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? $b5c3bd712c9dea25$var$rgbn(m) // #ff0000
     : l === 3 ? new $b5c3bd712c9dea25$var$Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? $b5c3bd712c9dea25$var$rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? $b5c3bd712c9dea25$var$rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = $b5c3bd712c9dea25$var$reRgbInteger.exec(format)) ? new $b5c3bd712c9dea25$var$Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = $b5c3bd712c9dea25$var$reRgbPercent.exec(format)) ? new $b5c3bd712c9dea25$var$Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = $b5c3bd712c9dea25$var$reRgbaInteger.exec(format)) ? $b5c3bd712c9dea25$var$rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = $b5c3bd712c9dea25$var$reRgbaPercent.exec(format)) ? $b5c3bd712c9dea25$var$rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = $b5c3bd712c9dea25$var$reHslPercent.exec(format)) ? $b5c3bd712c9dea25$var$hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = $b5c3bd712c9dea25$var$reHslaPercent.exec(format)) ? $b5c3bd712c9dea25$var$hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : $b5c3bd712c9dea25$var$named.hasOwnProperty(format) ? $b5c3bd712c9dea25$var$rgbn($b5c3bd712c9dea25$var$named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new $b5c3bd712c9dea25$var$Rgb(NaN, NaN, NaN, 0) : null;
}
function $b5c3bd712c9dea25$var$rgbn(n) {
    return new $b5c3bd712c9dea25$var$Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function $b5c3bd712c9dea25$var$rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new $b5c3bd712c9dea25$var$Rgb(r, g, b, a);
}
function $b5c3bd712c9dea25$var$rgbConvert(o) {
    if (!(o instanceof $b5c3bd712c9dea25$var$Color)) o = $b5c3bd712c9dea25$var$color(o);
    if (!o) return new $b5c3bd712c9dea25$var$Rgb();
    o = o.rgb();
    return new $b5c3bd712c9dea25$var$Rgb(o.r, o.g, o.b, o.opacity);
}
function $b5c3bd712c9dea25$var$rgb(r, g, b, opacity) {
    return arguments.length === 1 ? $b5c3bd712c9dea25$var$rgbConvert(r) : new $b5c3bd712c9dea25$var$Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function $b5c3bd712c9dea25$var$Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $b5c3bd712c9dea25$var$_define.default)($b5c3bd712c9dea25$var$Rgb, $b5c3bd712c9dea25$var$rgb, (0, $b5c3bd712c9dea25$var$_define.extend)($b5c3bd712c9dea25$var$Color, {
    brighter (k) {
        k = k == null ? $b5c3bd712c9dea25$var$brighter : Math.pow($b5c3bd712c9dea25$var$brighter, k);
        return new $b5c3bd712c9dea25$var$Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $b5c3bd712c9dea25$var$darker : Math.pow($b5c3bd712c9dea25$var$darker, k);
        return new $b5c3bd712c9dea25$var$Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new $b5c3bd712c9dea25$var$Rgb($b5c3bd712c9dea25$var$clampi(this.r), $b5c3bd712c9dea25$var$clampi(this.g), $b5c3bd712c9dea25$var$clampi(this.b), $b5c3bd712c9dea25$var$clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: $b5c3bd712c9dea25$var$rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: $b5c3bd712c9dea25$var$rgb_formatHex,
    formatHex8: $b5c3bd712c9dea25$var$rgb_formatHex8,
    formatRgb: $b5c3bd712c9dea25$var$rgb_formatRgb,
    toString: $b5c3bd712c9dea25$var$rgb_formatRgb
}));
function $b5c3bd712c9dea25$var$rgb_formatHex() {
    return `#${$b5c3bd712c9dea25$var$hex(this.r)}${$b5c3bd712c9dea25$var$hex(this.g)}${$b5c3bd712c9dea25$var$hex(this.b)}`;
}
function $b5c3bd712c9dea25$var$rgb_formatHex8() {
    return `#${$b5c3bd712c9dea25$var$hex(this.r)}${$b5c3bd712c9dea25$var$hex(this.g)}${$b5c3bd712c9dea25$var$hex(this.b)}${$b5c3bd712c9dea25$var$hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function $b5c3bd712c9dea25$var$rgb_formatRgb() {
    const a = $b5c3bd712c9dea25$var$clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${$b5c3bd712c9dea25$var$clampi(this.r)}, ${$b5c3bd712c9dea25$var$clampi(this.g)}, ${$b5c3bd712c9dea25$var$clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function $b5c3bd712c9dea25$var$clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function $b5c3bd712c9dea25$var$clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function $b5c3bd712c9dea25$var$hex(value) {
    value = $b5c3bd712c9dea25$var$clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function $b5c3bd712c9dea25$var$hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new $b5c3bd712c9dea25$var$Hsl(h, s, l, a);
}
function $b5c3bd712c9dea25$var$hslConvert(o) {
    if (o instanceof $b5c3bd712c9dea25$var$Hsl) return new $b5c3bd712c9dea25$var$Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $b5c3bd712c9dea25$var$Color)) o = $b5c3bd712c9dea25$var$color(o);
    if (!o) return new $b5c3bd712c9dea25$var$Hsl();
    if (o instanceof $b5c3bd712c9dea25$var$Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new $b5c3bd712c9dea25$var$Hsl(h, s, l, o.opacity);
}
function $b5c3bd712c9dea25$var$hsl(h, s, l, opacity) {
    return arguments.length === 1 ? $b5c3bd712c9dea25$var$hslConvert(h) : new $b5c3bd712c9dea25$var$Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function $b5c3bd712c9dea25$var$Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $b5c3bd712c9dea25$var$_define.default)($b5c3bd712c9dea25$var$Hsl, $b5c3bd712c9dea25$var$hsl, (0, $b5c3bd712c9dea25$var$_define.extend)($b5c3bd712c9dea25$var$Color, {
    brighter (k) {
        k = k == null ? $b5c3bd712c9dea25$var$brighter : Math.pow($b5c3bd712c9dea25$var$brighter, k);
        return new $b5c3bd712c9dea25$var$Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $b5c3bd712c9dea25$var$darker : Math.pow($b5c3bd712c9dea25$var$darker, k);
        return new $b5c3bd712c9dea25$var$Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new $b5c3bd712c9dea25$var$Rgb($b5c3bd712c9dea25$var$hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), $b5c3bd712c9dea25$var$hsl2rgb(h, m1, m2), $b5c3bd712c9dea25$var$hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new $b5c3bd712c9dea25$var$Hsl($b5c3bd712c9dea25$var$clamph(this.h), $b5c3bd712c9dea25$var$clampt(this.s), $b5c3bd712c9dea25$var$clampt(this.l), $b5c3bd712c9dea25$var$clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = $b5c3bd712c9dea25$var$clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${$b5c3bd712c9dea25$var$clamph(this.h)}, ${$b5c3bd712c9dea25$var$clampt(this.s) * 100}%, ${$b5c3bd712c9dea25$var$clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function $b5c3bd712c9dea25$var$clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function $b5c3bd712c9dea25$var$clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function $b5c3bd712c9dea25$var$hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRequire.register("4P4QL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $382faff515c79b7a$var$_default;
module.exports.extend = $382faff515c79b7a$var$extend;
function $382faff515c79b7a$var$_default(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $382faff515c79b7a$var$extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRequire.register("8bmD3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hcl = $5f50e76ecb168c5d$var$Hcl;
module.exports.Lab = $5f50e76ecb168c5d$var$Lab;
module.exports.default = $5f50e76ecb168c5d$var$lab;
module.exports.gray = $5f50e76ecb168c5d$var$gray;
module.exports.hcl = $5f50e76ecb168c5d$var$hcl;
module.exports.lch = $5f50e76ecb168c5d$var$lch;

var $5f50e76ecb168c5d$var$_define = $5f50e76ecb168c5d$var$_interopRequireWildcard((parcelRequire("4P4QL")));

var $fBwMw = parcelRequire("fBwMw");

var $gvcbX = parcelRequire("gvcbX");
function $5f50e76ecb168c5d$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($5f50e76ecb168c5d$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $5f50e76ecb168c5d$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $5f50e76ecb168c5d$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
// https://observablehq.com/@mbostock/lab-and-rgb
const $5f50e76ecb168c5d$var$K = 18, $5f50e76ecb168c5d$var$Xn = 0.96422, $5f50e76ecb168c5d$var$Yn = 1, $5f50e76ecb168c5d$var$Zn = 0.82521, $5f50e76ecb168c5d$var$t0 = 4 / 29, $5f50e76ecb168c5d$var$t1 = 6 / 29, $5f50e76ecb168c5d$var$t2 = 3 * $5f50e76ecb168c5d$var$t1 * $5f50e76ecb168c5d$var$t1, $5f50e76ecb168c5d$var$t3 = $5f50e76ecb168c5d$var$t1 * $5f50e76ecb168c5d$var$t1 * $5f50e76ecb168c5d$var$t1;
function $5f50e76ecb168c5d$var$labConvert(o) {
    if (o instanceof $5f50e76ecb168c5d$var$Lab) return new $5f50e76ecb168c5d$var$Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof $5f50e76ecb168c5d$var$Hcl) return $5f50e76ecb168c5d$var$hcl2lab(o);
    if (!(o instanceof $fBwMw.Rgb)) o = (0, $fBwMw.rgbConvert)(o);
    var r = $5f50e76ecb168c5d$var$rgb2lrgb(o.r), g = $5f50e76ecb168c5d$var$rgb2lrgb(o.g), b = $5f50e76ecb168c5d$var$rgb2lrgb(o.b), y = $5f50e76ecb168c5d$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $5f50e76ecb168c5d$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $5f50e76ecb168c5d$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $5f50e76ecb168c5d$var$Xn);
        z = $5f50e76ecb168c5d$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $5f50e76ecb168c5d$var$Zn);
    }
    return new $5f50e76ecb168c5d$var$Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $5f50e76ecb168c5d$var$gray(l, opacity) {
    return new $5f50e76ecb168c5d$var$Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function $5f50e76ecb168c5d$var$lab(l, a, b, opacity) {
    return arguments.length === 1 ? $5f50e76ecb168c5d$var$labConvert(l) : new $5f50e76ecb168c5d$var$Lab(l, a, b, opacity == null ? 1 : opacity);
}
function $5f50e76ecb168c5d$var$Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $5f50e76ecb168c5d$var$_define.default)($5f50e76ecb168c5d$var$Lab, $5f50e76ecb168c5d$var$lab, (0, $5f50e76ecb168c5d$var$_define.extend)($fBwMw.Color, {
    brighter (k) {
        return new $5f50e76ecb168c5d$var$Lab(this.l + $5f50e76ecb168c5d$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $5f50e76ecb168c5d$var$Lab(this.l - $5f50e76ecb168c5d$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $5f50e76ecb168c5d$var$Xn * $5f50e76ecb168c5d$var$lab2xyz(x);
        y = $5f50e76ecb168c5d$var$Yn * $5f50e76ecb168c5d$var$lab2xyz(y);
        z = $5f50e76ecb168c5d$var$Zn * $5f50e76ecb168c5d$var$lab2xyz(z);
        return new $fBwMw.Rgb($5f50e76ecb168c5d$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $5f50e76ecb168c5d$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $5f50e76ecb168c5d$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $5f50e76ecb168c5d$var$xyz2lab(t) {
    return t > $5f50e76ecb168c5d$var$t3 ? Math.pow(t, 1 / 3) : t / $5f50e76ecb168c5d$var$t2 + $5f50e76ecb168c5d$var$t0;
}
function $5f50e76ecb168c5d$var$lab2xyz(t) {
    return t > $5f50e76ecb168c5d$var$t1 ? t * t * t : $5f50e76ecb168c5d$var$t2 * (t - $5f50e76ecb168c5d$var$t0);
}
function $5f50e76ecb168c5d$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $5f50e76ecb168c5d$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $5f50e76ecb168c5d$var$hclConvert(o) {
    if (o instanceof $5f50e76ecb168c5d$var$Hcl) return new $5f50e76ecb168c5d$var$Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $5f50e76ecb168c5d$var$Lab)) o = $5f50e76ecb168c5d$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $5f50e76ecb168c5d$var$Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * $gvcbX.degrees;
    return new $5f50e76ecb168c5d$var$Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $5f50e76ecb168c5d$var$lch(l, c, h, opacity) {
    return arguments.length === 1 ? $5f50e76ecb168c5d$var$hclConvert(l) : new $5f50e76ecb168c5d$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $5f50e76ecb168c5d$var$hcl(h, c, l, opacity) {
    return arguments.length === 1 ? $5f50e76ecb168c5d$var$hclConvert(h) : new $5f50e76ecb168c5d$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $5f50e76ecb168c5d$var$Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $5f50e76ecb168c5d$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $5f50e76ecb168c5d$var$Lab(o.l, 0, 0, o.opacity);
    var h = o.h * $gvcbX.radians;
    return new $5f50e76ecb168c5d$var$Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $5f50e76ecb168c5d$var$_define.default)($5f50e76ecb168c5d$var$Hcl, $5f50e76ecb168c5d$var$hcl, (0, $5f50e76ecb168c5d$var$_define.extend)($fBwMw.Color, {
    brighter (k) {
        return new $5f50e76ecb168c5d$var$Hcl(this.h, this.c, this.l + $5f50e76ecb168c5d$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $5f50e76ecb168c5d$var$Hcl(this.h, this.c, this.l - $5f50e76ecb168c5d$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $5f50e76ecb168c5d$var$hcl2lab(this).rgb();
    }
}));

});
parcelRequire.register("gvcbX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.radians = module.exports.degrees = void 0;
const $c038ffa20e550349$var$radians = Math.PI / 180;
module.exports.radians = $c038ffa20e550349$var$radians;
const $c038ffa20e550349$var$degrees = 180 / Math.PI;
module.exports.degrees = $c038ffa20e550349$var$degrees;

});


parcelRequire.register("e7YcQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cubehelix = $a4906bcfd69c68e6$var$Cubehelix;
module.exports.default = $a4906bcfd69c68e6$var$cubehelix;

var $a4906bcfd69c68e6$var$_define = $a4906bcfd69c68e6$var$_interopRequireWildcard((parcelRequire("4P4QL")));

var $fBwMw = parcelRequire("fBwMw");

var $gvcbX = parcelRequire("gvcbX");
function $a4906bcfd69c68e6$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($a4906bcfd69c68e6$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $a4906bcfd69c68e6$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $a4906bcfd69c68e6$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $a4906bcfd69c68e6$var$A = -0.14861, $a4906bcfd69c68e6$var$B = 1.78277, $a4906bcfd69c68e6$var$C = -0.29227, $a4906bcfd69c68e6$var$D = -0.90649, $a4906bcfd69c68e6$var$E = 1.97294, $a4906bcfd69c68e6$var$ED = $a4906bcfd69c68e6$var$E * $a4906bcfd69c68e6$var$D, $a4906bcfd69c68e6$var$EB = $a4906bcfd69c68e6$var$E * $a4906bcfd69c68e6$var$B, $a4906bcfd69c68e6$var$BC_DA = $a4906bcfd69c68e6$var$B * $a4906bcfd69c68e6$var$C - $a4906bcfd69c68e6$var$D * $a4906bcfd69c68e6$var$A;
function $a4906bcfd69c68e6$var$cubehelixConvert(o) {
    if (o instanceof $a4906bcfd69c68e6$var$Cubehelix) return new $a4906bcfd69c68e6$var$Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $fBwMw.Rgb)) o = (0, $fBwMw.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($a4906bcfd69c68e6$var$BC_DA * b + $a4906bcfd69c68e6$var$ED * r - $a4906bcfd69c68e6$var$EB * g) / ($a4906bcfd69c68e6$var$BC_DA + $a4906bcfd69c68e6$var$ED - $a4906bcfd69c68e6$var$EB), bl = b - l, k = ($a4906bcfd69c68e6$var$E * (g - l) - $a4906bcfd69c68e6$var$C * bl) / $a4906bcfd69c68e6$var$D, s = Math.sqrt(k * k + bl * bl) / ($a4906bcfd69c68e6$var$E * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * $gvcbX.degrees - 120 : NaN;
    return new $a4906bcfd69c68e6$var$Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $a4906bcfd69c68e6$var$cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? $a4906bcfd69c68e6$var$cubehelixConvert(h) : new $a4906bcfd69c68e6$var$Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function $a4906bcfd69c68e6$var$Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $a4906bcfd69c68e6$var$_define.default)($a4906bcfd69c68e6$var$Cubehelix, $a4906bcfd69c68e6$var$cubehelix, (0, $a4906bcfd69c68e6$var$_define.extend)($fBwMw.Color, {
    brighter (k) {
        k = k == null ? $fBwMw.brighter : Math.pow($fBwMw.brighter, k);
        return new $a4906bcfd69c68e6$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $fBwMw.darker : Math.pow($fBwMw.darker, k);
        return new $a4906bcfd69c68e6$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * $gvcbX.radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new $fBwMw.Rgb(255 * (l + a * ($a4906bcfd69c68e6$var$A * cosh + $a4906bcfd69c68e6$var$B * sinh)), 255 * (l + a * ($a4906bcfd69c68e6$var$C * cosh + $a4906bcfd69c68e6$var$D * sinh)), 255 * (l + a * ($a4906bcfd69c68e6$var$E * cosh)), this.opacity);
    }
}));

});


parcelRequire.register("1fggl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rgbBasisClosed = module.exports.rgbBasis = module.exports.default = void 0;

var $fqfF4 = parcelRequire("fqfF4");

var $0e83ce9100e93721$var$_basis = $0e83ce9100e93721$var$_interopRequireDefault((parcelRequire("ezZsL")));

var $0e83ce9100e93721$var$_basisClosed = $0e83ce9100e93721$var$_interopRequireDefault((parcelRequire("d2lJY")));

var $0e83ce9100e93721$var$_color = $0e83ce9100e93721$var$_interopRequireWildcard((parcelRequire("a2qj8")));
function $0e83ce9100e93721$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($0e83ce9100e93721$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $0e83ce9100e93721$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $0e83ce9100e93721$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $0e83ce9100e93721$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0e83ce9100e93721$var$_default = function rgbGamma(y) {
    var color = (0, $0e83ce9100e93721$var$_color.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $fqfF4.rgb)(start)).r, (end = (0, $fqfF4.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $0e83ce9100e93721$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
module.exports.default = $0e83ce9100e93721$var$_default;
function $0e83ce9100e93721$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $fqfF4.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $0e83ce9100e93721$var$rgbBasis = $0e83ce9100e93721$var$rgbSpline($0e83ce9100e93721$var$_basis.default);
module.exports.rgbBasis = $0e83ce9100e93721$var$rgbBasis;
var $0e83ce9100e93721$var$rgbBasisClosed = $0e83ce9100e93721$var$rgbSpline($0e83ce9100e93721$var$_basisClosed.default);
module.exports.rgbBasisClosed = $0e83ce9100e93721$var$rgbBasisClosed;

});
parcelRequire.register("ezZsL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.basis = $a9d402d3c456627a$var$basis;
module.exports.default = $a9d402d3c456627a$var$_default;
function $a9d402d3c456627a$var$basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $a9d402d3c456627a$var$_default(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $a9d402d3c456627a$var$basis((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRequire.register("d2lJY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $97dc537ab71e269f$var$_default;

var $ezZsL = parcelRequire("ezZsL");
function $97dc537ab71e269f$var$_default(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $ezZsL.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRequire.register("a2qj8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $74ee7f740b85be57$var$nogamma;
module.exports.gamma = $74ee7f740b85be57$var$gamma;
module.exports.hue = $74ee7f740b85be57$var$hue;

var $74ee7f740b85be57$var$_constant = $74ee7f740b85be57$var$_interopRequireDefault((parcelRequire("fHinc")));
function $74ee7f740b85be57$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $74ee7f740b85be57$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $74ee7f740b85be57$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $74ee7f740b85be57$var$hue(a, b) {
    var d = b - a;
    return d ? $74ee7f740b85be57$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $74ee7f740b85be57$var$_constant.default)(isNaN(a) ? b : a);
}
function $74ee7f740b85be57$var$gamma(y) {
    return (y = +y) === 1 ? $74ee7f740b85be57$var$nogamma : function(a, b) {
        return b - a ? $74ee7f740b85be57$var$exponential(a, b, y) : (0, $74ee7f740b85be57$var$_constant.default)(isNaN(a) ? b : a);
    };
}
function $74ee7f740b85be57$var$nogamma(a, b) {
    var d = b - a;
    return d ? $74ee7f740b85be57$var$linear(a, d) : (0, $74ee7f740b85be57$var$_constant.default)(isNaN(a) ? b : a);
}

});
parcelRequire.register("fHinc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $b6d91fb02510ebba$var$_default = (x)=>()=>x;
module.exports.default = $b6d91fb02510ebba$var$_default;

});



parcelRequire.register("c4KMz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8caa25ca1fb345f4$var$_default;
module.exports.genericArray = $8caa25ca1fb345f4$var$genericArray;

var $8caa25ca1fb345f4$var$_value = $8caa25ca1fb345f4$var$_interopRequireDefault((parcelRequire("aQYao")));

var $8caa25ca1fb345f4$var$_numberArray = $8caa25ca1fb345f4$var$_interopRequireWildcard((parcelRequire("ioONj")));
function $8caa25ca1fb345f4$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8caa25ca1fb345f4$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8caa25ca1fb345f4$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8caa25ca1fb345f4$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $8caa25ca1fb345f4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8caa25ca1fb345f4$var$_default(a, b) {
    return ((0, $8caa25ca1fb345f4$var$_numberArray.isNumberArray)(b) ? $8caa25ca1fb345f4$var$_numberArray.default : $8caa25ca1fb345f4$var$genericArray)(a, b);
}
function $8caa25ca1fb345f4$var$genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $8caa25ca1fb345f4$var$_value.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRequire.register("ioONj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d651de931eb8616f$var$_default;
module.exports.isNumberArray = $d651de931eb8616f$var$isNumberArray;
function $d651de931eb8616f$var$_default(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $d651de931eb8616f$var$isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRequire.register("iyq1R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d81f97c4c18ce18a$var$_default;
function $d81f97c4c18ce18a$var$_default(a, b) {
    var d = new Date();
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRequire.register("6PTwm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4fa292cfa1685f7a$var$_default;
function $4fa292cfa1685f7a$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRequire.register("7dlFo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $540a8ddd0d79ad30$var$_default;

var $540a8ddd0d79ad30$var$_value = $540a8ddd0d79ad30$var$_interopRequireDefault((parcelRequire("aQYao")));
function $540a8ddd0d79ad30$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $540a8ddd0d79ad30$var$_default(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $540a8ddd0d79ad30$var$_value.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRequire.register("8AKoU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6415adc11dbe5d5b$var$_default;

var $6415adc11dbe5d5b$var$_number = $6415adc11dbe5d5b$var$_interopRequireDefault((parcelRequire("6PTwm")));
function $6415adc11dbe5d5b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6415adc11dbe5d5b$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $6415adc11dbe5d5b$var$reB = new RegExp($6415adc11dbe5d5b$var$reA.source, "g");
function $6415adc11dbe5d5b$var$zero(b) {
    return function() {
        return b;
    };
}
function $6415adc11dbe5d5b$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $6415adc11dbe5d5b$var$_default(a, b) {
    var bi = $6415adc11dbe5d5b$var$reA.lastIndex = $6415adc11dbe5d5b$var$reB.lastIndex = 0, // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + ""; // Interpolate pairs of numbers in a & b.
    while((am = $6415adc11dbe5d5b$var$reA.exec(a)) && (bm = $6415adc11dbe5d5b$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            // interpolate non-matching numbers
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $6415adc11dbe5d5b$var$_number.default)(am, bm)
            });
        }
        bi = $6415adc11dbe5d5b$var$reB.lastIndex;
    } // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    } // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $6415adc11dbe5d5b$var$one(q[0].x) : $6415adc11dbe5d5b$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRequire.register("7oUoq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $563684c591961a4d$var$_default;
function $563684c591961a4d$var$_default(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

});

parcelRequire.register("71uY5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $51d0a601e41fca5c$var$_default;

var $a2qj8 = parcelRequire("a2qj8");
function $51d0a601e41fca5c$var$_default(a, b) {
    var i = (0, $a2qj8.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

});

parcelRequire.register("4MvlC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $37b3f61e3707e37c$var$_default;
function $37b3f61e3707e37c$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRequire.register("gQqF8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTransformSvg = module.exports.interpolateTransformCss = void 0;

var $c4362f4b224bcba9$var$_number = $c4362f4b224bcba9$var$_interopRequireDefault((parcelRequire("6PTwm")));

var $hd2Dk = parcelRequire("hd2Dk");
function $c4362f4b224bcba9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c4362f4b224bcba9$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $c4362f4b224bcba9$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $c4362f4b224bcba9$var$_number.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $c4362f4b224bcba9$var$_number.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $c4362f4b224bcba9$var$_number.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $c4362f4b224bcba9$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $c4362f4b224bcba9$var$_number.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], // string constants and placeholders
        q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $c4362f4b224bcba9$var$interpolateTransformCss = $c4362f4b224bcba9$var$interpolateTransform($hd2Dk.parseCss, "px, ", "px)", "deg)");
module.exports.interpolateTransformCss = $c4362f4b224bcba9$var$interpolateTransformCss;
var $c4362f4b224bcba9$var$interpolateTransformSvg = $c4362f4b224bcba9$var$interpolateTransform($hd2Dk.parseSvg, ", ", ")", ")");
module.exports.interpolateTransformSvg = $c4362f4b224bcba9$var$interpolateTransformSvg;

});
parcelRequire.register("hd2Dk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCss = $c875b1824016711e$var$parseCss;
module.exports.parseSvg = $c875b1824016711e$var$parseSvg;

var $c875b1824016711e$var$_decompose = $c875b1824016711e$var$_interopRequireWildcard((parcelRequire("gepHo")));
function $c875b1824016711e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c875b1824016711e$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c875b1824016711e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c875b1824016711e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $c875b1824016711e$var$svgNode;
/* eslint-disable no-undef */ function $c875b1824016711e$var$parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? $c875b1824016711e$var$_decompose.identity : (0, $c875b1824016711e$var$_decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $c875b1824016711e$var$parseSvg(value) {
    if (value == null) return $c875b1824016711e$var$_decompose.identity;
    if (!$c875b1824016711e$var$svgNode) $c875b1824016711e$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $c875b1824016711e$var$svgNode.setAttribute("transform", value);
    if (!(value = $c875b1824016711e$var$svgNode.transform.baseVal.consolidate())) return $c875b1824016711e$var$_decompose.identity;
    value = value.matrix;
    return (0, $c875b1824016711e$var$_decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRequire.register("gepHo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bd11e36d3ab0dc05$var$_default;
module.exports.identity = void 0;
var $bd11e36d3ab0dc05$var$degrees = 180 / Math.PI;
var $bd11e36d3ab0dc05$var$identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
module.exports.identity = $bd11e36d3ab0dc05$var$identity;
function $bd11e36d3ab0dc05$var$_default(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $bd11e36d3ab0dc05$var$degrees,
        skewX: Math.atan(skewX) * $bd11e36d3ab0dc05$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRequire.register("5SD24", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $448045e8872f9858$var$epsilon2 = 1e-12;
function $448045e8872f9858$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $448045e8872f9858$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $448045e8872f9858$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $448045e8872f9858$var$_default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S; // Special case for u0 ≅ u1.
        if (d2 < $448045e8872f9858$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $448045e8872f9858$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $448045e8872f9858$var$tanh(rho * s + r0) - $448045e8872f9858$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $448045e8872f9858$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);
module.exports.default = $448045e8872f9858$var$_default;

});

parcelRequire.register("giUqz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hslLong = module.exports.default = void 0;

var $fqfF4 = parcelRequire("fqfF4");

var $bdea191d5613e178$var$_color = $bdea191d5613e178$var$_interopRequireWildcard((parcelRequire("a2qj8")));
function $bdea191d5613e178$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($bdea191d5613e178$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $bdea191d5613e178$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $bdea191d5613e178$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $bdea191d5613e178$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $fqfF4.hsl)(start)).h, (end = (0, $fqfF4.hsl)(end)).h), s = (0, $bdea191d5613e178$var$_color.default)(start.s, end.s), l = (0, $bdea191d5613e178$var$_color.default)(start.l, end.l), opacity = (0, $bdea191d5613e178$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $bdea191d5613e178$var$_default = $bdea191d5613e178$var$hsl($bdea191d5613e178$var$_color.hue);
module.exports.default = $bdea191d5613e178$var$_default;
var $bdea191d5613e178$var$hslLong = $bdea191d5613e178$var$hsl($bdea191d5613e178$var$_color.default);
module.exports.hslLong = $bdea191d5613e178$var$hslLong;

});

parcelRequire.register("l2CY2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f51802fcabb23955$var$lab;

var $fqfF4 = parcelRequire("fqfF4");

var $f51802fcabb23955$var$_color = $f51802fcabb23955$var$_interopRequireDefault((parcelRequire("a2qj8")));
function $f51802fcabb23955$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f51802fcabb23955$var$lab(start, end) {
    var l = (0, $f51802fcabb23955$var$_color.default)((start = (0, $fqfF4.lab)(start)).l, (end = (0, $fqfF4.lab)(end)).l), a = (0, $f51802fcabb23955$var$_color.default)(start.a, end.a), b = (0, $f51802fcabb23955$var$_color.default)(start.b, end.b), opacity = (0, $f51802fcabb23955$var$_color.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});

parcelRequire.register("SKV88", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hclLong = module.exports.default = void 0;

var $fqfF4 = parcelRequire("fqfF4");

var $0a4970af5e834e88$var$_color = $0a4970af5e834e88$var$_interopRequireWildcard((parcelRequire("a2qj8")));
function $0a4970af5e834e88$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($0a4970af5e834e88$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $0a4970af5e834e88$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $0a4970af5e834e88$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $0a4970af5e834e88$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $fqfF4.hcl)(start)).h, (end = (0, $fqfF4.hcl)(end)).h), c = (0, $0a4970af5e834e88$var$_color.default)(start.c, end.c), l = (0, $0a4970af5e834e88$var$_color.default)(start.l, end.l), opacity = (0, $0a4970af5e834e88$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $0a4970af5e834e88$var$_default = $0a4970af5e834e88$var$hcl($0a4970af5e834e88$var$_color.hue);
module.exports.default = $0a4970af5e834e88$var$_default;
var $0a4970af5e834e88$var$hclLong = $0a4970af5e834e88$var$hcl($0a4970af5e834e88$var$_color.default);
module.exports.hclLong = $0a4970af5e834e88$var$hclLong;

});

parcelRequire.register("frD9h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.cubehelixLong = void 0;

var $fqfF4 = parcelRequire("fqfF4");

var $b3e7bebf07490885$var$_color = $b3e7bebf07490885$var$_interopRequireWildcard((parcelRequire("a2qj8")));
function $b3e7bebf07490885$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($b3e7bebf07490885$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $b3e7bebf07490885$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $b3e7bebf07490885$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $b3e7bebf07490885$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $fqfF4.cubehelix)(start)).h, (end = (0, $fqfF4.cubehelix)(end)).h), s = (0, $b3e7bebf07490885$var$_color.default)(start.s, end.s), l = (0, $b3e7bebf07490885$var$_color.default)(start.l, end.l), opacity = (0, $b3e7bebf07490885$var$_color.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $b3e7bebf07490885$var$_default = $b3e7bebf07490885$var$cubehelix($b3e7bebf07490885$var$_color.hue);
module.exports.default = $b3e7bebf07490885$var$_default;
var $b3e7bebf07490885$var$cubehelixLong = $b3e7bebf07490885$var$cubehelix($b3e7bebf07490885$var$_color.default);
module.exports.cubehelixLong = $b3e7bebf07490885$var$cubehelixLong;

});

parcelRequire.register("6DVQq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4d634155e0f68c2c$var$piecewise;

var $4d634155e0f68c2c$var$_value = $4d634155e0f68c2c$var$_interopRequireDefault((parcelRequire("aQYao")));
function $4d634155e0f68c2c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4d634155e0f68c2c$var$piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = $4d634155e0f68c2c$var$_value.default;
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRequire.register("deK3z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9a304f0854fc30b1$var$_default;
function $9a304f0854fc30b1$var$_default(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

});


parcelRequire.register("cqkH3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $90b7f705a2031463$var$constants;
function $90b7f705a2031463$var$constants(x) {
    return function() {
        return x;
    };
}

});

parcelRequire.register("66OMX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $472ab334b6bbafb2$var$number;
function $472ab334b6bbafb2$var$number(x) {
    return +x;
}

});


parcelRequire.register("kkpqj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ecc9657ae29c5d96$var$tickFormat;

var $k5p7I = parcelRequire("k5p7I");

var $8IRyN = parcelRequire("8IRyN");
function $ecc9657ae29c5d96$var$tickFormat(start, stop, count, specifier) {
    var step = (0, $k5p7I.tickStep)(start, stop, count), precision;
    specifier = (0, $8IRyN.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $8IRyN.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, $8IRyN.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $8IRyN.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $8IRyN.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $8IRyN.format)(specifier);
}

});
parcelRequire.register("8IRyN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "FormatSpecifier", {
    enumerable: true,
    get: function() {
        return $659bfab6ed69b083$var$_formatSpecifier.FormatSpecifier;
    }
});
Object.defineProperty(module.exports, "format", {
    enumerable: true,
    get: function() {
        return $659bfab6ed69b083$var$_defaultLocale.format;
    }
});
Object.defineProperty(module.exports, "formatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $659bfab6ed69b083$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "formatLocale", {
    enumerable: true,
    get: function() {
        return $659bfab6ed69b083$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "formatPrefix", {
    enumerable: true,
    get: function() {
        return $659bfab6ed69b083$var$_defaultLocale.formatPrefix;
    }
});
Object.defineProperty(module.exports, "formatSpecifier", {
    enumerable: true,
    get: function() {
        return $659bfab6ed69b083$var$_formatSpecifier.default;
    }
});
Object.defineProperty(module.exports, "precisionFixed", {
    enumerable: true,
    get: function() {
        return $659bfab6ed69b083$var$_precisionFixed.default;
    }
});
Object.defineProperty(module.exports, "precisionPrefix", {
    enumerable: true,
    get: function() {
        return $659bfab6ed69b083$var$_precisionPrefix.default;
    }
});
Object.defineProperty(module.exports, "precisionRound", {
    enumerable: true,
    get: function() {
        return $659bfab6ed69b083$var$_precisionRound.default;
    }
});

var $659bfab6ed69b083$var$_defaultLocale = $659bfab6ed69b083$var$_interopRequireWildcard((parcelRequire("fhPvr")));

var $659bfab6ed69b083$var$_locale = $659bfab6ed69b083$var$_interopRequireDefault((parcelRequire("6M7wL")));

var $659bfab6ed69b083$var$_formatSpecifier = $659bfab6ed69b083$var$_interopRequireWildcard((parcelRequire("l0Bnb")));

var $659bfab6ed69b083$var$_precisionFixed = $659bfab6ed69b083$var$_interopRequireDefault((parcelRequire("2vC31")));

var $659bfab6ed69b083$var$_precisionPrefix = $659bfab6ed69b083$var$_interopRequireDefault((parcelRequire("599TG")));

var $659bfab6ed69b083$var$_precisionRound = $659bfab6ed69b083$var$_interopRequireDefault((parcelRequire("9ldvR")));
function $659bfab6ed69b083$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $659bfab6ed69b083$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($659bfab6ed69b083$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $659bfab6ed69b083$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $659bfab6ed69b083$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRequire.register("fhPvr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b21065954b90c70f$var$defaultLocale;
module.exports.formatPrefix = module.exports.format = void 0;

var $b21065954b90c70f$var$_locale = $b21065954b90c70f$var$_interopRequireDefault((parcelRequire("6M7wL")));
function $b21065954b90c70f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b21065954b90c70f$var$locale;
var $b21065954b90c70f$var$format;
module.exports.format = $b21065954b90c70f$var$format;
var $b21065954b90c70f$var$formatPrefix;
module.exports.formatPrefix = $b21065954b90c70f$var$formatPrefix;
$b21065954b90c70f$var$defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $b21065954b90c70f$var$defaultLocale(definition) {
    $b21065954b90c70f$var$locale = (0, $b21065954b90c70f$var$_locale.default)(definition);
    module.exports.format = $b21065954b90c70f$var$format = $b21065954b90c70f$var$locale.format;
    module.exports.formatPrefix = $b21065954b90c70f$var$formatPrefix = $b21065954b90c70f$var$locale.formatPrefix;
    return $b21065954b90c70f$var$locale;
}

});
parcelRequire.register("6M7wL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4eed10961416700f$var$_default;

var $4eed10961416700f$var$_exponent = $4eed10961416700f$var$_interopRequireDefault((parcelRequire("bCTYq")));

var $4eed10961416700f$var$_formatGroup = $4eed10961416700f$var$_interopRequireDefault((parcelRequire("afjzp")));

var $4eed10961416700f$var$_formatNumerals = $4eed10961416700f$var$_interopRequireDefault((parcelRequire("jcQm2")));

var $4eed10961416700f$var$_formatSpecifier = $4eed10961416700f$var$_interopRequireDefault((parcelRequire("l0Bnb")));

var $4eed10961416700f$var$_formatTrim = $4eed10961416700f$var$_interopRequireDefault((parcelRequire("2z1OO")));

var $4eed10961416700f$var$_formatTypes = $4eed10961416700f$var$_interopRequireDefault((parcelRequire("quRiu")));

var $2joex = parcelRequire("2joex");

var $4eed10961416700f$var$_identity = $4eed10961416700f$var$_interopRequireDefault((parcelRequire("5sMvb")));
function $4eed10961416700f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4eed10961416700f$var$map = Array.prototype.map, $4eed10961416700f$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $4eed10961416700f$var$_default(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? $4eed10961416700f$var$_identity.default : (0, $4eed10961416700f$var$_formatGroup.default)($4eed10961416700f$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? $4eed10961416700f$var$_identity.default : (0, $4eed10961416700f$var$_formatNumerals.default)($4eed10961416700f$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "−" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $4eed10961416700f$var$_formatSpecifier.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type; // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g"; // The "" type, and any invalid type, is an alias for ".12~g".
        else if (!$4eed10961416700f$var$_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g"; // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "="; // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : ""; // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = $4eed10961416700f$var$_formatTypes.default[type], maybeSuffix = /[defgprs%]/.test(type); // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value; // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0; // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision); // Trim insignificant zeros.
                if (trim) value = (0, $4eed10961416700f$var$_formatTrim.default)(value); // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false; // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $4eed10961416700f$var$prefixes[8 + $2joex.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : ""); // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            } // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity); // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : ""; // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = ""; // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $4eed10961416700f$var$_formatSpecifier.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $4eed10961416700f$var$_exponent.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $4eed10961416700f$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRequire.register("bCTYq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $876ea97cfbf829c9$var$_default;

var $3pHAx = parcelRequire("3pHAx");
function $876ea97cfbf829c9$var$_default(x) {
    return x = (0, $3pHAx.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRequire.register("3pHAx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $27c5849fd7d04816$var$_default;
module.exports.formatDecimalParts = $27c5849fd7d04816$var$formatDecimalParts;
function $27c5849fd7d04816$var$_default(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
} // Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function $27c5849fd7d04816$var$formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i); // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRequire.register("afjzp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $775a7c4f5d32743d$var$_default;
function $775a7c4f5d32743d$var$_default(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRequire.register("jcQm2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $039bbce674a387a9$var$_default;
function $039bbce674a387a9$var$_default(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRequire.register("l0Bnb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatSpecifier = $f4b6968f0048d612$var$FormatSpecifier;
module.exports.default = $f4b6968f0048d612$var$formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $f4b6968f0048d612$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $f4b6968f0048d612$var$formatSpecifier(specifier) {
    if (!(match = $f4b6968f0048d612$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $f4b6968f0048d612$var$FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$f4b6968f0048d612$var$formatSpecifier.prototype = $f4b6968f0048d612$var$FormatSpecifier.prototype; // instanceof
function $f4b6968f0048d612$var$FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$f4b6968f0048d612$var$FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRequire.register("2z1OO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1de042cb5305a1fe$var$_default;
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $1de042cb5305a1fe$var$_default(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRequire.register("quRiu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $04fa5db44b79c391$var$_formatDecimal = $04fa5db44b79c391$var$_interopRequireDefault((parcelRequire("3pHAx")));

var $04fa5db44b79c391$var$_formatPrefixAuto = $04fa5db44b79c391$var$_interopRequireDefault((parcelRequire("2joex")));

var $04fa5db44b79c391$var$_formatRounded = $04fa5db44b79c391$var$_interopRequireDefault((parcelRequire("6TuYM")));
function $04fa5db44b79c391$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $04fa5db44b79c391$var$_default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": $04fa5db44b79c391$var$_formatDecimal.default,
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $04fa5db44b79c391$var$_formatRounded.default)(x * 100, p),
    "r": $04fa5db44b79c391$var$_formatRounded.default,
    "s": $04fa5db44b79c391$var$_formatPrefixAuto.default,
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};
module.exports.default = $04fa5db44b79c391$var$_default;

});
parcelRequire.register("2joex", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1af027689f1bf4c5$var$_default;
module.exports.prefixExponent = void 0;

var $3pHAx = parcelRequire("3pHAx");
var $1af027689f1bf4c5$var$prefixExponent;
module.exports.prefixExponent = $1af027689f1bf4c5$var$prefixExponent;
function $1af027689f1bf4c5$var$_default(x, p) {
    var d = (0, $3pHAx.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - (module.exports.prefixExponent = $1af027689f1bf4c5$var$prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $3pHAx.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRequire.register("6TuYM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $504fe900bbbc2bc1$var$_default;

var $3pHAx = parcelRequire("3pHAx");
function $504fe900bbbc2bc1$var$_default(x, p) {
    var d = (0, $3pHAx.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRequire.register("5sMvb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3fa530becec8abeb$var$_default;
function $3fa530becec8abeb$var$_default(x) {
    return x;
}

});



parcelRequire.register("2vC31", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1d3bfd7f25169481$var$_default;

var $1d3bfd7f25169481$var$_exponent = $1d3bfd7f25169481$var$_interopRequireDefault((parcelRequire("bCTYq")));
function $1d3bfd7f25169481$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1d3bfd7f25169481$var$_default(step) {
    return Math.max(0, -(0, $1d3bfd7f25169481$var$_exponent.default)(Math.abs(step)));
}

});

parcelRequire.register("599TG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3bf5785eeadb41d3$var$_default;

var $3bf5785eeadb41d3$var$_exponent = $3bf5785eeadb41d3$var$_interopRequireDefault((parcelRequire("bCTYq")));
function $3bf5785eeadb41d3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3bf5785eeadb41d3$var$_default(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $3bf5785eeadb41d3$var$_exponent.default)(value) / 3))) * 3 - (0, $3bf5785eeadb41d3$var$_exponent.default)(Math.abs(step)));
}

});

parcelRequire.register("9ldvR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6cd08e97b56d36d7$var$_default;

var $6cd08e97b56d36d7$var$_exponent = $6cd08e97b56d36d7$var$_interopRequireDefault((parcelRequire("bCTYq")));
function $6cd08e97b56d36d7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6cd08e97b56d36d7$var$_default(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $6cd08e97b56d36d7$var$_exponent.default)(max) - (0, $6cd08e97b56d36d7$var$_exponent.default)(step)) + 1;
}

});





parcelRequire.register("jdUqB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dfeb00a4a69ec5d6$var$log;
module.exports.loggish = $dfeb00a4a69ec5d6$var$loggish;

var $k5p7I = parcelRequire("k5p7I");

var $8IRyN = parcelRequire("8IRyN");

var $dfeb00a4a69ec5d6$var$_nice = $dfeb00a4a69ec5d6$var$_interopRequireDefault((parcelRequire("2xas7")));

var $aiVEG = parcelRequire("aiVEG");

var $dVAcc = parcelRequire("dVAcc");
function $dfeb00a4a69ec5d6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $dfeb00a4a69ec5d6$var$transformLog(x) {
    return Math.log(x);
}
function $dfeb00a4a69ec5d6$var$transformExp(x) {
    return Math.exp(x);
}
function $dfeb00a4a69ec5d6$var$transformLogn(x) {
    return -Math.log(-x);
}
function $dfeb00a4a69ec5d6$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $dfeb00a4a69ec5d6$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $dfeb00a4a69ec5d6$var$powp(base) {
    return base === 10 ? $dfeb00a4a69ec5d6$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $dfeb00a4a69ec5d6$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $dfeb00a4a69ec5d6$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $dfeb00a4a69ec5d6$var$loggish(transform) {
    const scale = transform($dfeb00a4a69ec5d6$var$transformLog, $dfeb00a4a69ec5d6$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $dfeb00a4a69ec5d6$var$logp(base), pows = $dfeb00a4a69ec5d6$var$powp(base);
        if (domain()[0] < 0) {
            logs = $dfeb00a4a69ec5d6$var$reflect(logs), pows = $dfeb00a4a69ec5d6$var$reflect(pows);
            transform($dfeb00a4a69ec5d6$var$transformLogn, $dfeb00a4a69ec5d6$var$transformExpn);
        } else transform($dfeb00a4a69ec5d6$var$transformLog, $dfeb00a4a69ec5d6$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $k5p7I.ticks)(u, v, n);
        } else z = (0, $k5p7I.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $8IRyN.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $8IRyN.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $dfeb00a4a69ec5d6$var$_nice.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $dfeb00a4a69ec5d6$var$log() {
    const scale = $dfeb00a4a69ec5d6$var$loggish((0, $aiVEG.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $aiVEG.copy)(scale, $dfeb00a4a69ec5d6$var$log()).base(scale.base());
    $dVAcc.initRange.apply(scale, arguments);
    return scale;
}

});
parcelRequire.register("2xas7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1d86c57d8457bae5$var$nice;
function $1d86c57d8457bae5$var$nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRequire.register("glCnt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $be6c607d03b65299$var$symlog;
module.exports.symlogish = $be6c607d03b65299$var$symlogish;

var $hHCkv = parcelRequire("hHCkv");

var $aiVEG = parcelRequire("aiVEG");

var $dVAcc = parcelRequire("dVAcc");
function $be6c607d03b65299$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $be6c607d03b65299$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $be6c607d03b65299$var$symlogish(transform) {
    var c = 1, scale = transform($be6c607d03b65299$var$transformSymlog(c), $be6c607d03b65299$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($be6c607d03b65299$var$transformSymlog(c = +_), $be6c607d03b65299$var$transformSymexp(c)) : c;
    };
    return (0, $hHCkv.linearish)(scale);
}
function $be6c607d03b65299$var$symlog() {
    var scale = $be6c607d03b65299$var$symlogish((0, $aiVEG.transformer)());
    scale.copy = function() {
        return (0, $aiVEG.copy)(scale, $be6c607d03b65299$var$symlog()).constant(scale.constant());
    };
    return $dVAcc.initRange.apply(scale, arguments);
}

});

parcelRequire.register("9R4Yk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $01da03ccd9a0cf94$var$pow;
module.exports.powish = $01da03ccd9a0cf94$var$powish;
module.exports.sqrt = $01da03ccd9a0cf94$var$sqrt;

var $hHCkv = parcelRequire("hHCkv");

var $aiVEG = parcelRequire("aiVEG");

var $dVAcc = parcelRequire("dVAcc");
function $01da03ccd9a0cf94$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $01da03ccd9a0cf94$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $01da03ccd9a0cf94$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $01da03ccd9a0cf94$var$powish(transform) {
    var scale = transform($aiVEG.identity, $aiVEG.identity), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform($aiVEG.identity, $aiVEG.identity) : exponent === 0.5 ? transform($01da03ccd9a0cf94$var$transformSqrt, $01da03ccd9a0cf94$var$transformSquare) : transform($01da03ccd9a0cf94$var$transformPow(exponent), $01da03ccd9a0cf94$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $hHCkv.linearish)(scale);
}
function $01da03ccd9a0cf94$var$pow() {
    var scale = $01da03ccd9a0cf94$var$powish((0, $aiVEG.transformer)());
    scale.copy = function() {
        return (0, $aiVEG.copy)(scale, $01da03ccd9a0cf94$var$pow()).exponent(scale.exponent());
    };
    $dVAcc.initRange.apply(scale, arguments);
    return scale;
}
function $01da03ccd9a0cf94$var$sqrt() {
    return $01da03ccd9a0cf94$var$pow.apply(null, arguments).exponent(0.5);
}

});

parcelRequire.register("iDRGP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d9258432786682eb$var$radial;

var $d9258432786682eb$var$_continuous = $d9258432786682eb$var$_interopRequireDefault((parcelRequire("aiVEG")));

var $dVAcc = parcelRequire("dVAcc");

var $hHCkv = parcelRequire("hHCkv");

var $d9258432786682eb$var$_number = $d9258432786682eb$var$_interopRequireDefault((parcelRequire("66OMX")));
function $d9258432786682eb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d9258432786682eb$var$square(x) {
    return Math.sign(x) * x * x;
}
function $d9258432786682eb$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $d9258432786682eb$var$radial() {
    var squared = (0, $d9258432786682eb$var$_continuous.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $d9258432786682eb$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($d9258432786682eb$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, $d9258432786682eb$var$_number.default)).map($d9258432786682eb$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $d9258432786682eb$var$radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    $dVAcc.initRange.apply(scale, arguments);
    return (0, $hHCkv.linearish)(scale);
}

});

parcelRequire.register("iYUPw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dd19e9db56024c62$var$quantile;

var $k5p7I = parcelRequire("k5p7I");

var $dVAcc = parcelRequire("dVAcc");
function $dd19e9db56024c62$var$quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $k5p7I.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $k5p7I.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($k5p7I.ascending);
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $dd19e9db56024c62$var$quantile().domain(domain).range(range).unknown(unknown);
    };
    return $dVAcc.initRange.apply(scale, arguments);
}

});

parcelRequire.register("c6un6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8cfd9abe096a5b49$var$quantize;

var $k5p7I = parcelRequire("k5p7I");

var $hHCkv = parcelRequire("hHCkv");

var $dVAcc = parcelRequire("dVAcc");
function $8cfd9abe096a5b49$var$quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $k5p7I.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $8cfd9abe096a5b49$var$quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return $dVAcc.initRange.apply((0, $hHCkv.linearish)(scale), arguments);
}

});

parcelRequire.register("oBu3L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $049f51839723afd2$var$threshold;

var $k5p7I = parcelRequire("k5p7I");

var $dVAcc = parcelRequire("dVAcc");
function $049f51839723afd2$var$threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $k5p7I.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $049f51839723afd2$var$threshold().domain(domain).range(range).unknown(unknown);
    };
    return $dVAcc.initRange.apply(scale, arguments);
}

});

parcelRequire.register("lze8j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calendar = $fb37d469c84fee4a$var$calendar;
module.exports.default = $fb37d469c84fee4a$var$time;

var $a7jHS = parcelRequire("a7jHS");

var $abRJC = parcelRequire("abRJC");

var $fb37d469c84fee4a$var$_continuous = $fb37d469c84fee4a$var$_interopRequireWildcard((parcelRequire("aiVEG")));

var $dVAcc = parcelRequire("dVAcc");

var $fb37d469c84fee4a$var$_nice = $fb37d469c84fee4a$var$_interopRequireDefault((parcelRequire("2xas7")));
function $fb37d469c84fee4a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fb37d469c84fee4a$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($fb37d469c84fee4a$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $fb37d469c84fee4a$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $fb37d469c84fee4a$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $fb37d469c84fee4a$var$date(t) {
    return new Date(t);
}
function $fb37d469c84fee4a$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $fb37d469c84fee4a$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $fb37d469c84fee4a$var$_continuous.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $fb37d469c84fee4a$var$number)) : domain().map($fb37d469c84fee4a$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $fb37d469c84fee4a$var$_nice.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $fb37d469c84fee4a$var$_continuous.copy)(scale, $fb37d469c84fee4a$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $fb37d469c84fee4a$var$time() {
    return $dVAcc.initRange.apply($fb37d469c84fee4a$var$calendar($a7jHS.timeTicks, $a7jHS.timeTickInterval, $a7jHS.timeYear, $a7jHS.timeMonth, $a7jHS.timeWeek, $a7jHS.timeDay, $a7jHS.timeHour, $a7jHS.timeMinute, $a7jHS.timeSecond, $abRJC.timeFormat).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRequire.register("a7jHS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "timeDay", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_day.default;
    }
});
Object.defineProperty(module.exports, "timeDays", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_day.days;
    }
});
Object.defineProperty(module.exports, "timeFriday", {
    enumerable: true,
    get: function() {
        return $2K514.friday;
    }
});
Object.defineProperty(module.exports, "timeFridays", {
    enumerable: true,
    get: function() {
        return $2K514.fridays;
    }
});
Object.defineProperty(module.exports, "timeHour", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_hour.default;
    }
});
Object.defineProperty(module.exports, "timeHours", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_hour.hours;
    }
});
Object.defineProperty(module.exports, "timeInterval", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_interval.default;
    }
});
Object.defineProperty(module.exports, "timeMillisecond", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "timeMilliseconds", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "timeMinute", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_minute.default;
    }
});
Object.defineProperty(module.exports, "timeMinutes", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_minute.minutes;
    }
});
Object.defineProperty(module.exports, "timeMonday", {
    enumerable: true,
    get: function() {
        return $2K514.monday;
    }
});
Object.defineProperty(module.exports, "timeMondays", {
    enumerable: true,
    get: function() {
        return $2K514.mondays;
    }
});
Object.defineProperty(module.exports, "timeMonth", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_month.default;
    }
});
Object.defineProperty(module.exports, "timeMonths", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_month.months;
    }
});
Object.defineProperty(module.exports, "timeSaturday", {
    enumerable: true,
    get: function() {
        return $2K514.saturday;
    }
});
Object.defineProperty(module.exports, "timeSaturdays", {
    enumerable: true,
    get: function() {
        return $2K514.saturdays;
    }
});
Object.defineProperty(module.exports, "timeSecond", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_second.default;
    }
});
Object.defineProperty(module.exports, "timeSeconds", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "timeSunday", {
    enumerable: true,
    get: function() {
        return $2K514.sunday;
    }
});
Object.defineProperty(module.exports, "timeSundays", {
    enumerable: true,
    get: function() {
        return $2K514.sundays;
    }
});
Object.defineProperty(module.exports, "timeThursday", {
    enumerable: true,
    get: function() {
        return $2K514.thursday;
    }
});
Object.defineProperty(module.exports, "timeThursdays", {
    enumerable: true,
    get: function() {
        return $2K514.thursdays;
    }
});
Object.defineProperty(module.exports, "timeTickInterval", {
    enumerable: true,
    get: function() {
        return $kEk4s.timeTickInterval;
    }
});
Object.defineProperty(module.exports, "timeTicks", {
    enumerable: true,
    get: function() {
        return $kEk4s.timeTicks;
    }
});
Object.defineProperty(module.exports, "timeTuesday", {
    enumerable: true,
    get: function() {
        return $2K514.tuesday;
    }
});
Object.defineProperty(module.exports, "timeTuesdays", {
    enumerable: true,
    get: function() {
        return $2K514.tuesdays;
    }
});
Object.defineProperty(module.exports, "timeWednesday", {
    enumerable: true,
    get: function() {
        return $2K514.wednesday;
    }
});
Object.defineProperty(module.exports, "timeWednesdays", {
    enumerable: true,
    get: function() {
        return $2K514.wednesdays;
    }
});
Object.defineProperty(module.exports, "timeWeek", {
    enumerable: true,
    get: function() {
        return $2K514.sunday;
    }
});
Object.defineProperty(module.exports, "timeWeeks", {
    enumerable: true,
    get: function() {
        return $2K514.sundays;
    }
});
Object.defineProperty(module.exports, "timeYear", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_year.default;
    }
});
Object.defineProperty(module.exports, "timeYears", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_year.years;
    }
});
Object.defineProperty(module.exports, "utcDay", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_utcDay.default;
    }
});
Object.defineProperty(module.exports, "utcDays", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_utcDay.utcDays;
    }
});
Object.defineProperty(module.exports, "utcFriday", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcFriday;
    }
});
Object.defineProperty(module.exports, "utcFridays", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcFridays;
    }
});
Object.defineProperty(module.exports, "utcHour", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_utcHour.default;
    }
});
Object.defineProperty(module.exports, "utcHours", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_utcHour.utcHours;
    }
});
Object.defineProperty(module.exports, "utcMillisecond", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "utcMilliseconds", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "utcMinute", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_utcMinute.default;
    }
});
Object.defineProperty(module.exports, "utcMinutes", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_utcMinute.utcMinutes;
    }
});
Object.defineProperty(module.exports, "utcMonday", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcMonday;
    }
});
Object.defineProperty(module.exports, "utcMondays", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcMondays;
    }
});
Object.defineProperty(module.exports, "utcMonth", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_utcMonth.default;
    }
});
Object.defineProperty(module.exports, "utcMonths", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_utcMonth.utcMonths;
    }
});
Object.defineProperty(module.exports, "utcSaturday", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcSaturday;
    }
});
Object.defineProperty(module.exports, "utcSaturdays", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcSaturdays;
    }
});
Object.defineProperty(module.exports, "utcSecond", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_second.default;
    }
});
Object.defineProperty(module.exports, "utcSeconds", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "utcSunday", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcSundays", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcThursday", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcThursday;
    }
});
Object.defineProperty(module.exports, "utcThursdays", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcThursdays;
    }
});
Object.defineProperty(module.exports, "utcTickInterval", {
    enumerable: true,
    get: function() {
        return $kEk4s.utcTickInterval;
    }
});
Object.defineProperty(module.exports, "utcTicks", {
    enumerable: true,
    get: function() {
        return $kEk4s.utcTicks;
    }
});
Object.defineProperty(module.exports, "utcTuesday", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcTuesday;
    }
});
Object.defineProperty(module.exports, "utcTuesdays", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcTuesdays;
    }
});
Object.defineProperty(module.exports, "utcWednesday", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcWednesday;
    }
});
Object.defineProperty(module.exports, "utcWednesdays", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcWednesdays;
    }
});
Object.defineProperty(module.exports, "utcWeek", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcWeeks", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcYear", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_utcYear.default;
    }
});
Object.defineProperty(module.exports, "utcYears", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_utcYear.utcYears;
    }
});

var $75d9d82d7313d446$var$_interval = $75d9d82d7313d446$var$_interopRequireDefault((parcelRequire("avnhx")));

var $75d9d82d7313d446$var$_millisecond = $75d9d82d7313d446$var$_interopRequireWildcard((parcelRequire("8VCua")));

var $75d9d82d7313d446$var$_second = $75d9d82d7313d446$var$_interopRequireWildcard((parcelRequire("aKEL2")));

var $75d9d82d7313d446$var$_minute = $75d9d82d7313d446$var$_interopRequireWildcard((parcelRequire("dnUab")));

var $75d9d82d7313d446$var$_hour = $75d9d82d7313d446$var$_interopRequireWildcard((parcelRequire("jfjWs")));

var $75d9d82d7313d446$var$_day = $75d9d82d7313d446$var$_interopRequireWildcard((parcelRequire("5Zobx")));

var $2K514 = parcelRequire("2K514");

var $75d9d82d7313d446$var$_month = $75d9d82d7313d446$var$_interopRequireWildcard((parcelRequire("hCn8d")));

var $75d9d82d7313d446$var$_year = $75d9d82d7313d446$var$_interopRequireWildcard((parcelRequire("iUukc")));

var $75d9d82d7313d446$var$_utcMinute = $75d9d82d7313d446$var$_interopRequireWildcard((parcelRequire("eIOju")));

var $75d9d82d7313d446$var$_utcHour = $75d9d82d7313d446$var$_interopRequireWildcard((parcelRequire("4edXK")));

var $75d9d82d7313d446$var$_utcDay = $75d9d82d7313d446$var$_interopRequireWildcard((parcelRequire("gfGMZ")));

var $gVQv0 = parcelRequire("gVQv0");

var $75d9d82d7313d446$var$_utcMonth = $75d9d82d7313d446$var$_interopRequireWildcard((parcelRequire("8IrcU")));

var $75d9d82d7313d446$var$_utcYear = $75d9d82d7313d446$var$_interopRequireWildcard((parcelRequire("cQP75")));

var $kEk4s = parcelRequire("kEk4s");
function $75d9d82d7313d446$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($75d9d82d7313d446$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $75d9d82d7313d446$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $75d9d82d7313d446$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $75d9d82d7313d446$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRequire.register("avnhx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7a5edbe781297ef1$var$newInterval;
var $7a5edbe781297ef1$var$t0 = new Date(), $7a5edbe781297ef1$var$t1 = new Date();
function $7a5edbe781297ef1$var$newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $7a5edbe781297ef1$var$newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $7a5edbe781297ef1$var$t0.setTime(+start), $7a5edbe781297ef1$var$t1.setTime(+end);
            floori($7a5edbe781297ef1$var$t0), floori($7a5edbe781297ef1$var$t1);
            return Math.floor(count($7a5edbe781297ef1$var$t0, $7a5edbe781297ef1$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRequire.register("8VCua", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.milliseconds = module.exports.default = void 0;

var $68018007151518ca$var$_interval = $68018007151518ca$var$_interopRequireDefault((parcelRequire("avnhx")));
function $68018007151518ca$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $68018007151518ca$var$millisecond = (0, $68018007151518ca$var$_interval.default)(function() {}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
}); // An optimized implementation for this simple case.
$68018007151518ca$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $68018007151518ca$var$millisecond;
    return (0, $68018007151518ca$var$_interval.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $68018007151518ca$var$_default = $68018007151518ca$var$millisecond;
module.exports.default = $68018007151518ca$var$_default;
var $68018007151518ca$var$milliseconds = $68018007151518ca$var$millisecond.range;
module.exports.milliseconds = $68018007151518ca$var$milliseconds;

});

parcelRequire.register("aKEL2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.seconds = module.exports.default = void 0;

var $7d3dd0e33d596a95$var$_interval = $7d3dd0e33d596a95$var$_interopRequireDefault((parcelRequire("avnhx")));

var $5fpF5 = parcelRequire("5fpF5");
function $7d3dd0e33d596a95$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7d3dd0e33d596a95$var$second = (0, $7d3dd0e33d596a95$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * $5fpF5.durationSecond);
}, function(start, end) {
    return (end - start) / $5fpF5.durationSecond;
}, function(date) {
    return date.getUTCSeconds();
});
var $7d3dd0e33d596a95$var$_default = $7d3dd0e33d596a95$var$second;
module.exports.default = $7d3dd0e33d596a95$var$_default;
var $7d3dd0e33d596a95$var$seconds = $7d3dd0e33d596a95$var$second.range;
module.exports.seconds = $7d3dd0e33d596a95$var$seconds;

});
parcelRequire.register("5fpF5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.durationYear = module.exports.durationWeek = module.exports.durationSecond = module.exports.durationMonth = module.exports.durationMinute = module.exports.durationHour = module.exports.durationDay = void 0;
const $3d224252ae19d98a$var$durationSecond = 1000;
module.exports.durationSecond = $3d224252ae19d98a$var$durationSecond;
const $3d224252ae19d98a$var$durationMinute = $3d224252ae19d98a$var$durationSecond * 60;
module.exports.durationMinute = $3d224252ae19d98a$var$durationMinute;
const $3d224252ae19d98a$var$durationHour = $3d224252ae19d98a$var$durationMinute * 60;
module.exports.durationHour = $3d224252ae19d98a$var$durationHour;
const $3d224252ae19d98a$var$durationDay = $3d224252ae19d98a$var$durationHour * 24;
module.exports.durationDay = $3d224252ae19d98a$var$durationDay;
const $3d224252ae19d98a$var$durationWeek = $3d224252ae19d98a$var$durationDay * 7;
module.exports.durationWeek = $3d224252ae19d98a$var$durationWeek;
const $3d224252ae19d98a$var$durationMonth = $3d224252ae19d98a$var$durationDay * 30;
module.exports.durationMonth = $3d224252ae19d98a$var$durationMonth;
const $3d224252ae19d98a$var$durationYear = $3d224252ae19d98a$var$durationDay * 365;
module.exports.durationYear = $3d224252ae19d98a$var$durationYear;

});


parcelRequire.register("dnUab", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.minutes = module.exports.default = void 0;

var $9be8fd311671f9cb$var$_interval = $9be8fd311671f9cb$var$_interopRequireDefault((parcelRequire("avnhx")));

var $5fpF5 = parcelRequire("5fpF5");
function $9be8fd311671f9cb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9be8fd311671f9cb$var$minute = (0, $9be8fd311671f9cb$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $5fpF5.durationSecond);
}, function(date, step) {
    date.setTime(+date + step * $5fpF5.durationMinute);
}, function(start, end) {
    return (end - start) / $5fpF5.durationMinute;
}, function(date) {
    return date.getMinutes();
});
var $9be8fd311671f9cb$var$_default = $9be8fd311671f9cb$var$minute;
module.exports.default = $9be8fd311671f9cb$var$_default;
var $9be8fd311671f9cb$var$minutes = $9be8fd311671f9cb$var$minute.range;
module.exports.minutes = $9be8fd311671f9cb$var$minutes;

});

parcelRequire.register("jfjWs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hours = module.exports.default = void 0;

var $e02ee30d1a5a72e7$var$_interval = $e02ee30d1a5a72e7$var$_interopRequireDefault((parcelRequire("avnhx")));

var $5fpF5 = parcelRequire("5fpF5");
function $e02ee30d1a5a72e7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e02ee30d1a5a72e7$var$hour = (0, $e02ee30d1a5a72e7$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $5fpF5.durationSecond - date.getMinutes() * $5fpF5.durationMinute);
}, function(date, step) {
    date.setTime(+date + step * $5fpF5.durationHour);
}, function(start, end) {
    return (end - start) / $5fpF5.durationHour;
}, function(date) {
    return date.getHours();
});
var $e02ee30d1a5a72e7$var$_default = $e02ee30d1a5a72e7$var$hour;
module.exports.default = $e02ee30d1a5a72e7$var$_default;
var $e02ee30d1a5a72e7$var$hours = $e02ee30d1a5a72e7$var$hour.range;
module.exports.hours = $e02ee30d1a5a72e7$var$hours;

});

parcelRequire.register("5Zobx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.days = void 0;

var $45c568ea21f6963e$var$_interval = $45c568ea21f6963e$var$_interopRequireDefault((parcelRequire("avnhx")));

var $5fpF5 = parcelRequire("5fpF5");
function $45c568ea21f6963e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $45c568ea21f6963e$var$day = (0, $45c568ea21f6963e$var$_interval.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $5fpF5.durationMinute) / $5fpF5.durationDay, (date)=>date.getDate() - 1);
var $45c568ea21f6963e$var$_default = $45c568ea21f6963e$var$day;
module.exports.default = $45c568ea21f6963e$var$_default;
var $45c568ea21f6963e$var$days = $45c568ea21f6963e$var$day.range;
module.exports.days = $45c568ea21f6963e$var$days;

});

parcelRequire.register("2K514", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wednesdays = module.exports.wednesday = module.exports.tuesdays = module.exports.tuesday = module.exports.thursdays = module.exports.thursday = module.exports.sundays = module.exports.sunday = module.exports.saturdays = module.exports.saturday = module.exports.mondays = module.exports.monday = module.exports.fridays = module.exports.friday = void 0;

var $1ff3c4cab7f28ab7$var$_interval = $1ff3c4cab7f28ab7$var$_interopRequireDefault((parcelRequire("avnhx")));

var $5fpF5 = parcelRequire("5fpF5");
function $1ff3c4cab7f28ab7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1ff3c4cab7f28ab7$var$weekday(i) {
    return (0, $1ff3c4cab7f28ab7$var$_interval.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $5fpF5.durationMinute) / $5fpF5.durationWeek;
    });
}
var $1ff3c4cab7f28ab7$var$sunday = $1ff3c4cab7f28ab7$var$weekday(0);
module.exports.sunday = $1ff3c4cab7f28ab7$var$sunday;
var $1ff3c4cab7f28ab7$var$monday = $1ff3c4cab7f28ab7$var$weekday(1);
module.exports.monday = $1ff3c4cab7f28ab7$var$monday;
var $1ff3c4cab7f28ab7$var$tuesday = $1ff3c4cab7f28ab7$var$weekday(2);
module.exports.tuesday = $1ff3c4cab7f28ab7$var$tuesday;
var $1ff3c4cab7f28ab7$var$wednesday = $1ff3c4cab7f28ab7$var$weekday(3);
module.exports.wednesday = $1ff3c4cab7f28ab7$var$wednesday;
var $1ff3c4cab7f28ab7$var$thursday = $1ff3c4cab7f28ab7$var$weekday(4);
module.exports.thursday = $1ff3c4cab7f28ab7$var$thursday;
var $1ff3c4cab7f28ab7$var$friday = $1ff3c4cab7f28ab7$var$weekday(5);
module.exports.friday = $1ff3c4cab7f28ab7$var$friday;
var $1ff3c4cab7f28ab7$var$saturday = $1ff3c4cab7f28ab7$var$weekday(6);
module.exports.saturday = $1ff3c4cab7f28ab7$var$saturday;
var $1ff3c4cab7f28ab7$var$sundays = $1ff3c4cab7f28ab7$var$sunday.range;
module.exports.sundays = $1ff3c4cab7f28ab7$var$sundays;
var $1ff3c4cab7f28ab7$var$mondays = $1ff3c4cab7f28ab7$var$monday.range;
module.exports.mondays = $1ff3c4cab7f28ab7$var$mondays;
var $1ff3c4cab7f28ab7$var$tuesdays = $1ff3c4cab7f28ab7$var$tuesday.range;
module.exports.tuesdays = $1ff3c4cab7f28ab7$var$tuesdays;
var $1ff3c4cab7f28ab7$var$wednesdays = $1ff3c4cab7f28ab7$var$wednesday.range;
module.exports.wednesdays = $1ff3c4cab7f28ab7$var$wednesdays;
var $1ff3c4cab7f28ab7$var$thursdays = $1ff3c4cab7f28ab7$var$thursday.range;
module.exports.thursdays = $1ff3c4cab7f28ab7$var$thursdays;
var $1ff3c4cab7f28ab7$var$fridays = $1ff3c4cab7f28ab7$var$friday.range;
module.exports.fridays = $1ff3c4cab7f28ab7$var$fridays;
var $1ff3c4cab7f28ab7$var$saturdays = $1ff3c4cab7f28ab7$var$saturday.range;
module.exports.saturdays = $1ff3c4cab7f28ab7$var$saturdays;

});

parcelRequire.register("hCn8d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.months = module.exports.default = void 0;

var $cd37edb99cc629c8$var$_interval = $cd37edb99cc629c8$var$_interopRequireDefault((parcelRequire("avnhx")));
function $cd37edb99cc629c8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $cd37edb99cc629c8$var$month = (0, $cd37edb99cc629c8$var$_interval.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $cd37edb99cc629c8$var$_default = $cd37edb99cc629c8$var$month;
module.exports.default = $cd37edb99cc629c8$var$_default;
var $cd37edb99cc629c8$var$months = $cd37edb99cc629c8$var$month.range;
module.exports.months = $cd37edb99cc629c8$var$months;

});

parcelRequire.register("iUukc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.years = module.exports.default = void 0;

var $dc44fad24c185d66$var$_interval = $dc44fad24c185d66$var$_interopRequireDefault((parcelRequire("avnhx")));
function $dc44fad24c185d66$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $dc44fad24c185d66$var$year = (0, $dc44fad24c185d66$var$_interval.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
}); // An optimized implementation for this simple case.
$dc44fad24c185d66$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $dc44fad24c185d66$var$_interval.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $dc44fad24c185d66$var$_default = $dc44fad24c185d66$var$year;
module.exports.default = $dc44fad24c185d66$var$_default;
var $dc44fad24c185d66$var$years = $dc44fad24c185d66$var$year.range;
module.exports.years = $dc44fad24c185d66$var$years;

});

parcelRequire.register("eIOju", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMinutes = module.exports.default = void 0;

var $ab7c33f0c3895f25$var$_interval = $ab7c33f0c3895f25$var$_interopRequireDefault((parcelRequire("avnhx")));

var $5fpF5 = parcelRequire("5fpF5");
function $ab7c33f0c3895f25$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ab7c33f0c3895f25$var$utcMinute = (0, $ab7c33f0c3895f25$var$_interval.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * $5fpF5.durationMinute);
}, function(start, end) {
    return (end - start) / $5fpF5.durationMinute;
}, function(date) {
    return date.getUTCMinutes();
});
var $ab7c33f0c3895f25$var$_default = $ab7c33f0c3895f25$var$utcMinute;
module.exports.default = $ab7c33f0c3895f25$var$_default;
var $ab7c33f0c3895f25$var$utcMinutes = $ab7c33f0c3895f25$var$utcMinute.range;
module.exports.utcMinutes = $ab7c33f0c3895f25$var$utcMinutes;

});

parcelRequire.register("4edXK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcHours = module.exports.default = void 0;

var $31434ce923f6b039$var$_interval = $31434ce923f6b039$var$_interopRequireDefault((parcelRequire("avnhx")));

var $5fpF5 = parcelRequire("5fpF5");
function $31434ce923f6b039$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $31434ce923f6b039$var$utcHour = (0, $31434ce923f6b039$var$_interval.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * $5fpF5.durationHour);
}, function(start, end) {
    return (end - start) / $5fpF5.durationHour;
}, function(date) {
    return date.getUTCHours();
});
var $31434ce923f6b039$var$_default = $31434ce923f6b039$var$utcHour;
module.exports.default = $31434ce923f6b039$var$_default;
var $31434ce923f6b039$var$utcHours = $31434ce923f6b039$var$utcHour.range;
module.exports.utcHours = $31434ce923f6b039$var$utcHours;

});

parcelRequire.register("gfGMZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcDays = module.exports.default = void 0;

var $bd4f3d18a1e6ab93$var$_interval = $bd4f3d18a1e6ab93$var$_interopRequireDefault((parcelRequire("avnhx")));

var $5fpF5 = parcelRequire("5fpF5");
function $bd4f3d18a1e6ab93$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $bd4f3d18a1e6ab93$var$utcDay = (0, $bd4f3d18a1e6ab93$var$_interval.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / $5fpF5.durationDay;
}, function(date) {
    return date.getUTCDate() - 1;
});
var $bd4f3d18a1e6ab93$var$_default = $bd4f3d18a1e6ab93$var$utcDay;
module.exports.default = $bd4f3d18a1e6ab93$var$_default;
var $bd4f3d18a1e6ab93$var$utcDays = $bd4f3d18a1e6ab93$var$utcDay.range;
module.exports.utcDays = $bd4f3d18a1e6ab93$var$utcDays;

});

parcelRequire.register("gVQv0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcWednesdays = module.exports.utcWednesday = module.exports.utcTuesdays = module.exports.utcTuesday = module.exports.utcThursdays = module.exports.utcThursday = module.exports.utcSundays = module.exports.utcSunday = module.exports.utcSaturdays = module.exports.utcSaturday = module.exports.utcMondays = module.exports.utcMonday = module.exports.utcFridays = module.exports.utcFriday = void 0;

var $c53ab17541a5b5bc$var$_interval = $c53ab17541a5b5bc$var$_interopRequireDefault((parcelRequire("avnhx")));

var $5fpF5 = parcelRequire("5fpF5");
function $c53ab17541a5b5bc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c53ab17541a5b5bc$var$utcWeekday(i) {
    return (0, $c53ab17541a5b5bc$var$_interval.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / $5fpF5.durationWeek;
    });
}
var $c53ab17541a5b5bc$var$utcSunday = $c53ab17541a5b5bc$var$utcWeekday(0);
module.exports.utcSunday = $c53ab17541a5b5bc$var$utcSunday;
var $c53ab17541a5b5bc$var$utcMonday = $c53ab17541a5b5bc$var$utcWeekday(1);
module.exports.utcMonday = $c53ab17541a5b5bc$var$utcMonday;
var $c53ab17541a5b5bc$var$utcTuesday = $c53ab17541a5b5bc$var$utcWeekday(2);
module.exports.utcTuesday = $c53ab17541a5b5bc$var$utcTuesday;
var $c53ab17541a5b5bc$var$utcWednesday = $c53ab17541a5b5bc$var$utcWeekday(3);
module.exports.utcWednesday = $c53ab17541a5b5bc$var$utcWednesday;
var $c53ab17541a5b5bc$var$utcThursday = $c53ab17541a5b5bc$var$utcWeekday(4);
module.exports.utcThursday = $c53ab17541a5b5bc$var$utcThursday;
var $c53ab17541a5b5bc$var$utcFriday = $c53ab17541a5b5bc$var$utcWeekday(5);
module.exports.utcFriday = $c53ab17541a5b5bc$var$utcFriday;
var $c53ab17541a5b5bc$var$utcSaturday = $c53ab17541a5b5bc$var$utcWeekday(6);
module.exports.utcSaturday = $c53ab17541a5b5bc$var$utcSaturday;
var $c53ab17541a5b5bc$var$utcSundays = $c53ab17541a5b5bc$var$utcSunday.range;
module.exports.utcSundays = $c53ab17541a5b5bc$var$utcSundays;
var $c53ab17541a5b5bc$var$utcMondays = $c53ab17541a5b5bc$var$utcMonday.range;
module.exports.utcMondays = $c53ab17541a5b5bc$var$utcMondays;
var $c53ab17541a5b5bc$var$utcTuesdays = $c53ab17541a5b5bc$var$utcTuesday.range;
module.exports.utcTuesdays = $c53ab17541a5b5bc$var$utcTuesdays;
var $c53ab17541a5b5bc$var$utcWednesdays = $c53ab17541a5b5bc$var$utcWednesday.range;
module.exports.utcWednesdays = $c53ab17541a5b5bc$var$utcWednesdays;
var $c53ab17541a5b5bc$var$utcThursdays = $c53ab17541a5b5bc$var$utcThursday.range;
module.exports.utcThursdays = $c53ab17541a5b5bc$var$utcThursdays;
var $c53ab17541a5b5bc$var$utcFridays = $c53ab17541a5b5bc$var$utcFriday.range;
module.exports.utcFridays = $c53ab17541a5b5bc$var$utcFridays;
var $c53ab17541a5b5bc$var$utcSaturdays = $c53ab17541a5b5bc$var$utcSaturday.range;
module.exports.utcSaturdays = $c53ab17541a5b5bc$var$utcSaturdays;

});

parcelRequire.register("8IrcU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMonths = module.exports.default = void 0;

var $65878994030f3314$var$_interval = $65878994030f3314$var$_interopRequireDefault((parcelRequire("avnhx")));
function $65878994030f3314$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $65878994030f3314$var$utcMonth = (0, $65878994030f3314$var$_interval.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $65878994030f3314$var$_default = $65878994030f3314$var$utcMonth;
module.exports.default = $65878994030f3314$var$_default;
var $65878994030f3314$var$utcMonths = $65878994030f3314$var$utcMonth.range;
module.exports.utcMonths = $65878994030f3314$var$utcMonths;

});

parcelRequire.register("cQP75", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcYears = module.exports.default = void 0;

var $95b1fd66ff42ad48$var$_interval = $95b1fd66ff42ad48$var$_interopRequireDefault((parcelRequire("avnhx")));
function $95b1fd66ff42ad48$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $95b1fd66ff42ad48$var$utcYear = (0, $95b1fd66ff42ad48$var$_interval.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
}); // An optimized implementation for this simple case.
$95b1fd66ff42ad48$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $95b1fd66ff42ad48$var$_interval.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $95b1fd66ff42ad48$var$_default = $95b1fd66ff42ad48$var$utcYear;
module.exports.default = $95b1fd66ff42ad48$var$_default;
var $95b1fd66ff42ad48$var$utcYears = $95b1fd66ff42ad48$var$utcYear.range;
module.exports.utcYears = $95b1fd66ff42ad48$var$utcYears;

});

parcelRequire.register("kEk4s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcTicks = module.exports.utcTickInterval = module.exports.timeTicks = module.exports.timeTickInterval = void 0;

var $k5p7I = parcelRequire("k5p7I");

var $5fpF5 = parcelRequire("5fpF5");

var $f0871cb69aa37b20$var$_millisecond = $f0871cb69aa37b20$var$_interopRequireDefault((parcelRequire("8VCua")));

var $f0871cb69aa37b20$var$_second = $f0871cb69aa37b20$var$_interopRequireDefault((parcelRequire("aKEL2")));

var $f0871cb69aa37b20$var$_minute = $f0871cb69aa37b20$var$_interopRequireDefault((parcelRequire("dnUab")));

var $f0871cb69aa37b20$var$_hour = $f0871cb69aa37b20$var$_interopRequireDefault((parcelRequire("jfjWs")));

var $f0871cb69aa37b20$var$_day = $f0871cb69aa37b20$var$_interopRequireDefault((parcelRequire("5Zobx")));

var $2K514 = parcelRequire("2K514");

var $f0871cb69aa37b20$var$_month = $f0871cb69aa37b20$var$_interopRequireDefault((parcelRequire("hCn8d")));

var $f0871cb69aa37b20$var$_year = $f0871cb69aa37b20$var$_interopRequireDefault((parcelRequire("iUukc")));

var $f0871cb69aa37b20$var$_utcMinute = $f0871cb69aa37b20$var$_interopRequireDefault((parcelRequire("eIOju")));

var $f0871cb69aa37b20$var$_utcHour = $f0871cb69aa37b20$var$_interopRequireDefault((parcelRequire("4edXK")));

var $f0871cb69aa37b20$var$_utcDay = $f0871cb69aa37b20$var$_interopRequireDefault((parcelRequire("gfGMZ")));

var $gVQv0 = parcelRequire("gVQv0");

var $f0871cb69aa37b20$var$_utcMonth = $f0871cb69aa37b20$var$_interopRequireDefault((parcelRequire("8IrcU")));

var $f0871cb69aa37b20$var$_utcYear = $f0871cb69aa37b20$var$_interopRequireDefault((parcelRequire("cQP75")));
function $f0871cb69aa37b20$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f0871cb69aa37b20$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            $f0871cb69aa37b20$var$_second.default,
            1,
            $5fpF5.durationSecond
        ],
        [
            $f0871cb69aa37b20$var$_second.default,
            5,
            5 * $5fpF5.durationSecond
        ],
        [
            $f0871cb69aa37b20$var$_second.default,
            15,
            15 * $5fpF5.durationSecond
        ],
        [
            $f0871cb69aa37b20$var$_second.default,
            30,
            30 * $5fpF5.durationSecond
        ],
        [
            minute,
            1,
            $5fpF5.durationMinute
        ],
        [
            minute,
            5,
            5 * $5fpF5.durationMinute
        ],
        [
            minute,
            15,
            15 * $5fpF5.durationMinute
        ],
        [
            minute,
            30,
            30 * $5fpF5.durationMinute
        ],
        [
            hour,
            1,
            $5fpF5.durationHour
        ],
        [
            hour,
            3,
            3 * $5fpF5.durationHour
        ],
        [
            hour,
            6,
            6 * $5fpF5.durationHour
        ],
        [
            hour,
            12,
            12 * $5fpF5.durationHour
        ],
        [
            day,
            1,
            $5fpF5.durationDay
        ],
        [
            day,
            2,
            2 * $5fpF5.durationDay
        ],
        [
            week,
            1,
            $5fpF5.durationWeek
        ],
        [
            month,
            1,
            $5fpF5.durationMonth
        ],
        [
            month,
            3,
            3 * $5fpF5.durationMonth
        ],
        [
            year,
            1,
            $5fpF5.durationYear
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $k5p7I.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $k5p7I.tickStep)(start / $5fpF5.durationYear, stop / $5fpF5.durationYear, count));
        if (i === 0) return $f0871cb69aa37b20$var$_millisecond.default.every(Math.max((0, $k5p7I.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$f0871cb69aa37b20$var$utcTicks, $f0871cb69aa37b20$var$utcTickInterval] = $f0871cb69aa37b20$var$ticker($f0871cb69aa37b20$var$_utcYear.default, $f0871cb69aa37b20$var$_utcMonth.default, $gVQv0.utcSunday, $f0871cb69aa37b20$var$_utcDay.default, $f0871cb69aa37b20$var$_utcHour.default, $f0871cb69aa37b20$var$_utcMinute.default);
module.exports.utcTickInterval = $f0871cb69aa37b20$var$utcTickInterval;
module.exports.utcTicks = $f0871cb69aa37b20$var$utcTicks;
const [$f0871cb69aa37b20$var$timeTicks, $f0871cb69aa37b20$var$timeTickInterval] = $f0871cb69aa37b20$var$ticker($f0871cb69aa37b20$var$_year.default, $f0871cb69aa37b20$var$_month.default, $2K514.sunday, $f0871cb69aa37b20$var$_day.default, $f0871cb69aa37b20$var$_hour.default, $f0871cb69aa37b20$var$_minute.default);
module.exports.timeTickInterval = $f0871cb69aa37b20$var$timeTickInterval;
module.exports.timeTicks = $f0871cb69aa37b20$var$timeTicks;

});


parcelRequire.register("abRJC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "isoFormat", {
    enumerable: true,
    get: function() {
        return $76b49d13e27da572$var$_isoFormat.default;
    }
});
Object.defineProperty(module.exports, "isoParse", {
    enumerable: true,
    get: function() {
        return $76b49d13e27da572$var$_isoParse.default;
    }
});
Object.defineProperty(module.exports, "timeFormat", {
    enumerable: true,
    get: function() {
        return $76b49d13e27da572$var$_defaultLocale.timeFormat;
    }
});
Object.defineProperty(module.exports, "timeFormatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $76b49d13e27da572$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "timeFormatLocale", {
    enumerable: true,
    get: function() {
        return $76b49d13e27da572$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "timeParse", {
    enumerable: true,
    get: function() {
        return $76b49d13e27da572$var$_defaultLocale.timeParse;
    }
});
Object.defineProperty(module.exports, "utcFormat", {
    enumerable: true,
    get: function() {
        return $76b49d13e27da572$var$_defaultLocale.utcFormat;
    }
});
Object.defineProperty(module.exports, "utcParse", {
    enumerable: true,
    get: function() {
        return $76b49d13e27da572$var$_defaultLocale.utcParse;
    }
});

var $76b49d13e27da572$var$_defaultLocale = $76b49d13e27da572$var$_interopRequireWildcard((parcelRequire("30er6")));

var $76b49d13e27da572$var$_locale = $76b49d13e27da572$var$_interopRequireDefault((parcelRequire("hB79x")));

var $76b49d13e27da572$var$_isoFormat = $76b49d13e27da572$var$_interopRequireDefault((parcelRequire("cX5Ls")));

var $76b49d13e27da572$var$_isoParse = $76b49d13e27da572$var$_interopRequireDefault((parcelRequire("e2YhZ")));
function $76b49d13e27da572$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $76b49d13e27da572$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($76b49d13e27da572$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $76b49d13e27da572$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $76b49d13e27da572$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRequire.register("30er6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $22fc91e6254d1e2c$var$defaultLocale;
module.exports.utcParse = module.exports.utcFormat = module.exports.timeParse = module.exports.timeFormat = void 0;

var $22fc91e6254d1e2c$var$_locale = $22fc91e6254d1e2c$var$_interopRequireDefault((parcelRequire("hB79x")));
function $22fc91e6254d1e2c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $22fc91e6254d1e2c$var$locale;
var $22fc91e6254d1e2c$var$timeFormat;
module.exports.timeFormat = $22fc91e6254d1e2c$var$timeFormat;
var $22fc91e6254d1e2c$var$timeParse;
module.exports.timeParse = $22fc91e6254d1e2c$var$timeParse;
var $22fc91e6254d1e2c$var$utcFormat;
module.exports.utcFormat = $22fc91e6254d1e2c$var$utcFormat;
var $22fc91e6254d1e2c$var$utcParse;
module.exports.utcParse = $22fc91e6254d1e2c$var$utcParse;
$22fc91e6254d1e2c$var$defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $22fc91e6254d1e2c$var$defaultLocale(definition) {
    $22fc91e6254d1e2c$var$locale = (0, $22fc91e6254d1e2c$var$_locale.default)(definition);
    module.exports.timeFormat = $22fc91e6254d1e2c$var$timeFormat = $22fc91e6254d1e2c$var$locale.format;
    module.exports.timeParse = $22fc91e6254d1e2c$var$timeParse = $22fc91e6254d1e2c$var$locale.parse;
    module.exports.utcFormat = $22fc91e6254d1e2c$var$utcFormat = $22fc91e6254d1e2c$var$locale.utcFormat;
    module.exports.utcParse = $22fc91e6254d1e2c$var$utcParse = $22fc91e6254d1e2c$var$locale.utcParse;
    return $22fc91e6254d1e2c$var$locale;
}

});
parcelRequire.register("hB79x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ccfb70c24839d7ef$var$formatLocale;

var $a7jHS = parcelRequire("a7jHS");
function $ccfb70c24839d7ef$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $ccfb70c24839d7ef$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $ccfb70c24839d7ef$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $ccfb70c24839d7ef$var$formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $ccfb70c24839d7ef$var$formatRe(locale_periods), periodLookup = $ccfb70c24839d7ef$var$formatLookup(locale_periods), weekdayRe = $ccfb70c24839d7ef$var$formatRe(locale_weekdays), weekdayLookup = $ccfb70c24839d7ef$var$formatLookup(locale_weekdays), shortWeekdayRe = $ccfb70c24839d7ef$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $ccfb70c24839d7ef$var$formatLookup(locale_shortWeekdays), monthRe = $ccfb70c24839d7ef$var$formatRe(locale_months), monthLookup = $ccfb70c24839d7ef$var$formatLookup(locale_months), shortMonthRe = $ccfb70c24839d7ef$var$formatRe(locale_shortMonths), shortMonthLookup = $ccfb70c24839d7ef$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $ccfb70c24839d7ef$var$formatDayOfMonth,
        "e": $ccfb70c24839d7ef$var$formatDayOfMonth,
        "f": $ccfb70c24839d7ef$var$formatMicroseconds,
        "g": $ccfb70c24839d7ef$var$formatYearISO,
        "G": $ccfb70c24839d7ef$var$formatFullYearISO,
        "H": $ccfb70c24839d7ef$var$formatHour24,
        "I": $ccfb70c24839d7ef$var$formatHour12,
        "j": $ccfb70c24839d7ef$var$formatDayOfYear,
        "L": $ccfb70c24839d7ef$var$formatMilliseconds,
        "m": $ccfb70c24839d7ef$var$formatMonthNumber,
        "M": $ccfb70c24839d7ef$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $ccfb70c24839d7ef$var$formatUnixTimestamp,
        "s": $ccfb70c24839d7ef$var$formatUnixTimestampSeconds,
        "S": $ccfb70c24839d7ef$var$formatSeconds,
        "u": $ccfb70c24839d7ef$var$formatWeekdayNumberMonday,
        "U": $ccfb70c24839d7ef$var$formatWeekNumberSunday,
        "V": $ccfb70c24839d7ef$var$formatWeekNumberISO,
        "w": $ccfb70c24839d7ef$var$formatWeekdayNumberSunday,
        "W": $ccfb70c24839d7ef$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $ccfb70c24839d7ef$var$formatYear,
        "Y": $ccfb70c24839d7ef$var$formatFullYear,
        "Z": $ccfb70c24839d7ef$var$formatZone,
        "%": $ccfb70c24839d7ef$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $ccfb70c24839d7ef$var$formatUTCDayOfMonth,
        "e": $ccfb70c24839d7ef$var$formatUTCDayOfMonth,
        "f": $ccfb70c24839d7ef$var$formatUTCMicroseconds,
        "g": $ccfb70c24839d7ef$var$formatUTCYearISO,
        "G": $ccfb70c24839d7ef$var$formatUTCFullYearISO,
        "H": $ccfb70c24839d7ef$var$formatUTCHour24,
        "I": $ccfb70c24839d7ef$var$formatUTCHour12,
        "j": $ccfb70c24839d7ef$var$formatUTCDayOfYear,
        "L": $ccfb70c24839d7ef$var$formatUTCMilliseconds,
        "m": $ccfb70c24839d7ef$var$formatUTCMonthNumber,
        "M": $ccfb70c24839d7ef$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $ccfb70c24839d7ef$var$formatUnixTimestamp,
        "s": $ccfb70c24839d7ef$var$formatUnixTimestampSeconds,
        "S": $ccfb70c24839d7ef$var$formatUTCSeconds,
        "u": $ccfb70c24839d7ef$var$formatUTCWeekdayNumberMonday,
        "U": $ccfb70c24839d7ef$var$formatUTCWeekNumberSunday,
        "V": $ccfb70c24839d7ef$var$formatUTCWeekNumberISO,
        "w": $ccfb70c24839d7ef$var$formatUTCWeekdayNumberSunday,
        "W": $ccfb70c24839d7ef$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $ccfb70c24839d7ef$var$formatUTCYear,
        "Y": $ccfb70c24839d7ef$var$formatUTCFullYear,
        "Z": $ccfb70c24839d7ef$var$formatUTCZone,
        "%": $ccfb70c24839d7ef$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $ccfb70c24839d7ef$var$parseDayOfMonth,
        "e": $ccfb70c24839d7ef$var$parseDayOfMonth,
        "f": $ccfb70c24839d7ef$var$parseMicroseconds,
        "g": $ccfb70c24839d7ef$var$parseYear,
        "G": $ccfb70c24839d7ef$var$parseFullYear,
        "H": $ccfb70c24839d7ef$var$parseHour24,
        "I": $ccfb70c24839d7ef$var$parseHour24,
        "j": $ccfb70c24839d7ef$var$parseDayOfYear,
        "L": $ccfb70c24839d7ef$var$parseMilliseconds,
        "m": $ccfb70c24839d7ef$var$parseMonthNumber,
        "M": $ccfb70c24839d7ef$var$parseMinutes,
        "p": parsePeriod,
        "q": $ccfb70c24839d7ef$var$parseQuarter,
        "Q": $ccfb70c24839d7ef$var$parseUnixTimestamp,
        "s": $ccfb70c24839d7ef$var$parseUnixTimestampSeconds,
        "S": $ccfb70c24839d7ef$var$parseSeconds,
        "u": $ccfb70c24839d7ef$var$parseWeekdayNumberMonday,
        "U": $ccfb70c24839d7ef$var$parseWeekNumberSunday,
        "V": $ccfb70c24839d7ef$var$parseWeekNumberISO,
        "w": $ccfb70c24839d7ef$var$parseWeekdayNumberSunday,
        "W": $ccfb70c24839d7ef$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $ccfb70c24839d7ef$var$parseYear,
        "Y": $ccfb70c24839d7ef$var$parseFullYear,
        "Z": $ccfb70c24839d7ef$var$parseZone,
        "%": $ccfb70c24839d7ef$var$parseLiteralPercent
    }; // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $ccfb70c24839d7ef$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $ccfb70c24839d7ef$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null; // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0)); // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0; // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12; // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0; // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $ccfb70c24839d7ef$var$utcDate($ccfb70c24839d7ef$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? $a7jHS.utcMonday.ceil(week) : (0, $a7jHS.utcMonday)(week);
                    week = $a7jHS.utcDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $ccfb70c24839d7ef$var$localDate($ccfb70c24839d7ef$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? $a7jHS.timeMonday.ceil(week) : (0, $a7jHS.timeMonday)(week);
                    week = $a7jHS.timeDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $ccfb70c24839d7ef$var$utcDate($ccfb70c24839d7ef$var$newDate(d.y, 0, 1)).getUTCDay() : $ccfb70c24839d7ef$var$localDate($ccfb70c24839d7ef$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            } // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $ccfb70c24839d7ef$var$utcDate(d);
            } // Otherwise, all fields are in local time.
            return $ccfb70c24839d7ef$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $ccfb70c24839d7ef$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $ccfb70c24839d7ef$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $ccfb70c24839d7ef$var$numberRe = /^\s*\d+/, // note: ignores next directive
$ccfb70c24839d7ef$var$percentRe = /^%/, $ccfb70c24839d7ef$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $ccfb70c24839d7ef$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $ccfb70c24839d7ef$var$requote(s) {
    return s.replace($ccfb70c24839d7ef$var$requoteRe, "\\$&");
}
function $ccfb70c24839d7ef$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($ccfb70c24839d7ef$var$requote).join("|") + ")", "i");
}
function $ccfb70c24839d7ef$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $ccfb70c24839d7ef$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseWeekNumberSunday(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseWeekNumberISO(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseWeekNumberMonday(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseFullYear(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseYear(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseQuarter(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseMonthNumber(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseDayOfMonth(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseDayOfYear(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseHour24(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseMinutes(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseSeconds(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseMilliseconds(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseMicroseconds(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseLiteralPercent(d, string, i) {
    var n = $ccfb70c24839d7ef$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $ccfb70c24839d7ef$var$parseUnixTimestamp(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$formatDayOfMonth(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getDate(), p, 2);
}
function $ccfb70c24839d7ef$var$formatHour24(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getHours(), p, 2);
}
function $ccfb70c24839d7ef$var$formatHour12(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $ccfb70c24839d7ef$var$formatDayOfYear(d, p) {
    return $ccfb70c24839d7ef$var$pad(1 + $a7jHS.timeDay.count((0, $a7jHS.timeYear)(d), d), p, 3);
}
function $ccfb70c24839d7ef$var$formatMilliseconds(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getMilliseconds(), p, 3);
}
function $ccfb70c24839d7ef$var$formatMicroseconds(d, p) {
    return $ccfb70c24839d7ef$var$formatMilliseconds(d, p) + "000";
}
function $ccfb70c24839d7ef$var$formatMonthNumber(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getMonth() + 1, p, 2);
}
function $ccfb70c24839d7ef$var$formatMinutes(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getMinutes(), p, 2);
}
function $ccfb70c24839d7ef$var$formatSeconds(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getSeconds(), p, 2);
}
function $ccfb70c24839d7ef$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $ccfb70c24839d7ef$var$formatWeekNumberSunday(d, p) {
    return $ccfb70c24839d7ef$var$pad($a7jHS.timeSunday.count((0, $a7jHS.timeYear)(d) - 1, d), p, 2);
}
function $ccfb70c24839d7ef$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $a7jHS.timeThursday)(d) : $a7jHS.timeThursday.ceil(d);
}
function $ccfb70c24839d7ef$var$formatWeekNumberISO(d, p) {
    d = $ccfb70c24839d7ef$var$dISO(d);
    return $ccfb70c24839d7ef$var$pad($a7jHS.timeThursday.count((0, $a7jHS.timeYear)(d), d) + ((0, $a7jHS.timeYear)(d).getDay() === 4), p, 2);
}
function $ccfb70c24839d7ef$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $ccfb70c24839d7ef$var$formatWeekNumberMonday(d, p) {
    return $ccfb70c24839d7ef$var$pad($a7jHS.timeMonday.count((0, $a7jHS.timeYear)(d) - 1, d), p, 2);
}
function $ccfb70c24839d7ef$var$formatYear(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getFullYear() % 100, p, 2);
}
function $ccfb70c24839d7ef$var$formatYearISO(d, p) {
    d = $ccfb70c24839d7ef$var$dISO(d);
    return $ccfb70c24839d7ef$var$pad(d.getFullYear() % 100, p, 2);
}
function $ccfb70c24839d7ef$var$formatFullYear(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getFullYear() % 10000, p, 4);
}
function $ccfb70c24839d7ef$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $a7jHS.timeThursday)(d) : $a7jHS.timeThursday.ceil(d);
    return $ccfb70c24839d7ef$var$pad(d.getFullYear() % 10000, p, 4);
}
function $ccfb70c24839d7ef$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $ccfb70c24839d7ef$var$pad(z / 60 | 0, "0", 2) + $ccfb70c24839d7ef$var$pad(z % 60, "0", 2);
}
function $ccfb70c24839d7ef$var$formatUTCDayOfMonth(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getUTCDate(), p, 2);
}
function $ccfb70c24839d7ef$var$formatUTCHour24(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getUTCHours(), p, 2);
}
function $ccfb70c24839d7ef$var$formatUTCHour12(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $ccfb70c24839d7ef$var$formatUTCDayOfYear(d, p) {
    return $ccfb70c24839d7ef$var$pad(1 + $a7jHS.utcDay.count((0, $a7jHS.utcYear)(d), d), p, 3);
}
function $ccfb70c24839d7ef$var$formatUTCMilliseconds(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $ccfb70c24839d7ef$var$formatUTCMicroseconds(d, p) {
    return $ccfb70c24839d7ef$var$formatUTCMilliseconds(d, p) + "000";
}
function $ccfb70c24839d7ef$var$formatUTCMonthNumber(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $ccfb70c24839d7ef$var$formatUTCMinutes(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getUTCMinutes(), p, 2);
}
function $ccfb70c24839d7ef$var$formatUTCSeconds(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getUTCSeconds(), p, 2);
}
function $ccfb70c24839d7ef$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $ccfb70c24839d7ef$var$formatUTCWeekNumberSunday(d, p) {
    return $ccfb70c24839d7ef$var$pad($a7jHS.utcSunday.count((0, $a7jHS.utcYear)(d) - 1, d), p, 2);
}
function $ccfb70c24839d7ef$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $a7jHS.utcThursday)(d) : $a7jHS.utcThursday.ceil(d);
}
function $ccfb70c24839d7ef$var$formatUTCWeekNumberISO(d, p) {
    d = $ccfb70c24839d7ef$var$UTCdISO(d);
    return $ccfb70c24839d7ef$var$pad($a7jHS.utcThursday.count((0, $a7jHS.utcYear)(d), d) + ((0, $a7jHS.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $ccfb70c24839d7ef$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $ccfb70c24839d7ef$var$formatUTCWeekNumberMonday(d, p) {
    return $ccfb70c24839d7ef$var$pad($a7jHS.utcMonday.count((0, $a7jHS.utcYear)(d) - 1, d), p, 2);
}
function $ccfb70c24839d7ef$var$formatUTCYear(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $ccfb70c24839d7ef$var$formatUTCYearISO(d, p) {
    d = $ccfb70c24839d7ef$var$UTCdISO(d);
    return $ccfb70c24839d7ef$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $ccfb70c24839d7ef$var$formatUTCFullYear(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $ccfb70c24839d7ef$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $a7jHS.utcThursday)(d) : $a7jHS.utcThursday.ceil(d);
    return $ccfb70c24839d7ef$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $ccfb70c24839d7ef$var$formatUTCZone() {
    return "+0000";
}
function $ccfb70c24839d7ef$var$formatLiteralPercent() {
    return "%";
}
function $ccfb70c24839d7ef$var$formatUnixTimestamp(d) {
    return +d;
}
function $ccfb70c24839d7ef$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});


parcelRequire.register("cX5Ls", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isoSpecifier = module.exports.default = void 0;

var $30er6 = parcelRequire("30er6");
var $96df776faae95ce0$var$isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
module.exports.isoSpecifier = $96df776faae95ce0$var$isoSpecifier;
function $96df776faae95ce0$var$formatIsoNative(date) {
    return date.toISOString();
}
var $96df776faae95ce0$var$formatIso = Date.prototype.toISOString ? $96df776faae95ce0$var$formatIsoNative : (0, $30er6.utcFormat)($96df776faae95ce0$var$isoSpecifier);
var $96df776faae95ce0$var$_default = $96df776faae95ce0$var$formatIso;
module.exports.default = $96df776faae95ce0$var$_default;

});

parcelRequire.register("e2YhZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cX5Ls = parcelRequire("cX5Ls");

var $30er6 = parcelRequire("30er6");
function $a3a004c04b263162$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $a3a004c04b263162$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $a3a004c04b263162$var$parseIsoNative : (0, $30er6.utcParse)($cX5Ls.isoSpecifier);
var $a3a004c04b263162$var$_default = $a3a004c04b263162$var$parseIso;
module.exports.default = $a3a004c04b263162$var$_default;

});



parcelRequire.register("3ZSjS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2e91345135b85899$var$utcTime;

var $a7jHS = parcelRequire("a7jHS");

var $abRJC = parcelRequire("abRJC");

var $lze8j = parcelRequire("lze8j");

var $dVAcc = parcelRequire("dVAcc");
function $2e91345135b85899$var$utcTime() {
    return $dVAcc.initRange.apply((0, $lze8j.calendar)($a7jHS.utcTicks, $a7jHS.utcTickInterval, $a7jHS.utcYear, $a7jHS.utcMonth, $a7jHS.utcWeek, $a7jHS.utcDay, $a7jHS.utcHour, $a7jHS.utcMinute, $a7jHS.utcSecond, $abRJC.utcFormat).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});

parcelRequire.register("a9B8z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $76478d546f753609$var$copy;
module.exports.default = $76478d546f753609$var$sequential;
module.exports.sequentialLog = $76478d546f753609$var$sequentialLog;
module.exports.sequentialPow = $76478d546f753609$var$sequentialPow;
module.exports.sequentialSqrt = $76478d546f753609$var$sequentialSqrt;
module.exports.sequentialSymlog = $76478d546f753609$var$sequentialSymlog;

var $asL1O = parcelRequire("asL1O");

var $aiVEG = parcelRequire("aiVEG");

var $dVAcc = parcelRequire("dVAcc");

var $hHCkv = parcelRequire("hHCkv");

var $jdUqB = parcelRequire("jdUqB");

var $glCnt = parcelRequire("glCnt");

var $9R4Yk = parcelRequire("9R4Yk");
function $76478d546f753609$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = $aiVEG.identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range($asL1O.interpolate);
    scale.rangeRound = range($asL1O.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $76478d546f753609$var$copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $76478d546f753609$var$sequential() {
    var scale = (0, $hHCkv.linearish)($76478d546f753609$var$transformer()($aiVEG.identity));
    scale.copy = function() {
        return $76478d546f753609$var$copy(scale, $76478d546f753609$var$sequential());
    };
    return $dVAcc.initInterpolator.apply(scale, arguments);
}
function $76478d546f753609$var$sequentialLog() {
    var scale = (0, $jdUqB.loggish)($76478d546f753609$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $76478d546f753609$var$copy(scale, $76478d546f753609$var$sequentialLog()).base(scale.base());
    };
    return $dVAcc.initInterpolator.apply(scale, arguments);
}
function $76478d546f753609$var$sequentialSymlog() {
    var scale = (0, $glCnt.symlogish)($76478d546f753609$var$transformer());
    scale.copy = function() {
        return $76478d546f753609$var$copy(scale, $76478d546f753609$var$sequentialSymlog()).constant(scale.constant());
    };
    return $dVAcc.initInterpolator.apply(scale, arguments);
}
function $76478d546f753609$var$sequentialPow() {
    var scale = (0, $9R4Yk.powish)($76478d546f753609$var$transformer());
    scale.copy = function() {
        return $76478d546f753609$var$copy(scale, $76478d546f753609$var$sequentialPow()).exponent(scale.exponent());
    };
    return $dVAcc.initInterpolator.apply(scale, arguments);
}
function $76478d546f753609$var$sequentialSqrt() {
    return $76478d546f753609$var$sequentialPow.apply(null, arguments).exponent(0.5);
}

});

parcelRequire.register("jatwg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $df45d96e9fe52c57$var$sequentialQuantile;

var $k5p7I = parcelRequire("k5p7I");

var $aiVEG = parcelRequire("aiVEG");

var $dVAcc = parcelRequire("dVAcc");
function $df45d96e9fe52c57$var$sequentialQuantile() {
    var domain = [], interpolator = $aiVEG.identity;
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $k5p7I.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($k5p7I.ascending);
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $k5p7I.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return $df45d96e9fe52c57$var$sequentialQuantile(interpolator).domain(domain);
    };
    return $dVAcc.initInterpolator.apply(scale, arguments);
}

});

parcelRequire.register("5i1Ze", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3da02caf9c6b3ea1$var$diverging;
module.exports.divergingLog = $3da02caf9c6b3ea1$var$divergingLog;
module.exports.divergingPow = $3da02caf9c6b3ea1$var$divergingPow;
module.exports.divergingSqrt = $3da02caf9c6b3ea1$var$divergingSqrt;
module.exports.divergingSymlog = $3da02caf9c6b3ea1$var$divergingSymlog;

var $asL1O = parcelRequire("asL1O");

var $aiVEG = parcelRequire("aiVEG");

var $dVAcc = parcelRequire("dVAcc");

var $hHCkv = parcelRequire("hHCkv");

var $jdUqB = parcelRequire("jdUqB");

var $a9B8z = parcelRequire("a9B8z");

var $glCnt = parcelRequire("glCnt");

var $9R4Yk = parcelRequire("9R4Yk");
function $3da02caf9c6b3ea1$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = $aiVEG.identity, transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $asL1O.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range($asL1O.interpolate);
    scale.rangeRound = range($asL1O.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $3da02caf9c6b3ea1$var$diverging() {
    var scale = (0, $hHCkv.linearish)($3da02caf9c6b3ea1$var$transformer()($aiVEG.identity));
    scale.copy = function() {
        return (0, $a9B8z.copy)(scale, $3da02caf9c6b3ea1$var$diverging());
    };
    return $dVAcc.initInterpolator.apply(scale, arguments);
}
function $3da02caf9c6b3ea1$var$divergingLog() {
    var scale = (0, $jdUqB.loggish)($3da02caf9c6b3ea1$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $a9B8z.copy)(scale, $3da02caf9c6b3ea1$var$divergingLog()).base(scale.base());
    };
    return $dVAcc.initInterpolator.apply(scale, arguments);
}
function $3da02caf9c6b3ea1$var$divergingSymlog() {
    var scale = (0, $glCnt.symlogish)($3da02caf9c6b3ea1$var$transformer());
    scale.copy = function() {
        return (0, $a9B8z.copy)(scale, $3da02caf9c6b3ea1$var$divergingSymlog()).constant(scale.constant());
    };
    return $dVAcc.initInterpolator.apply(scale, arguments);
}
function $3da02caf9c6b3ea1$var$divergingPow() {
    var scale = (0, $9R4Yk.powish)($3da02caf9c6b3ea1$var$transformer());
    scale.copy = function() {
        return (0, $a9B8z.copy)(scale, $3da02caf9c6b3ea1$var$divergingPow()).exponent(scale.exponent());
    };
    return $dVAcc.initInterpolator.apply(scale, arguments);
}
function $3da02caf9c6b3ea1$var$divergingSqrt() {
    return $3da02caf9c6b3ea1$var$divergingPow.apply(null, arguments).exponent(0.5);
}

});



parcelRequire.register("3kTGk", function(module, exports) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`

module.exports = (parcelRequire("gfgOr"));

});
parcelRequire.register("gfgOr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "arc", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_arc.default;
    }
});
Object.defineProperty(module.exports, "area", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_area.default;
    }
});
Object.defineProperty(module.exports, "areaRadial", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "curveBasis", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "curveBasisClosed", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "curveBasisOpen", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_basisOpen.default;
    }
});
Object.defineProperty(module.exports, "curveBumpX", {
    enumerable: true,
    get: function() {
        return $2baBG.bumpX;
    }
});
Object.defineProperty(module.exports, "curveBumpY", {
    enumerable: true,
    get: function() {
        return $2baBG.bumpY;
    }
});
Object.defineProperty(module.exports, "curveBundle", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_bundle.default;
    }
});
Object.defineProperty(module.exports, "curveCardinal", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_cardinal.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalClosed", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_cardinalClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalOpen", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_cardinalOpen.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRom", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_catmullRom.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomClosed", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_catmullRomClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomOpen", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_catmullRomOpen.default;
    }
});
Object.defineProperty(module.exports, "curveLinear", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "curveLinearClosed", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_linearClosed.default;
    }
});
Object.defineProperty(module.exports, "curveMonotoneX", {
    enumerable: true,
    get: function() {
        return $cAgWu.monotoneX;
    }
});
Object.defineProperty(module.exports, "curveMonotoneY", {
    enumerable: true,
    get: function() {
        return $cAgWu.monotoneY;
    }
});
Object.defineProperty(module.exports, "curveNatural", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_natural.default;
    }
});
Object.defineProperty(module.exports, "curveStep", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_step.default;
    }
});
Object.defineProperty(module.exports, "curveStepAfter", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_step.stepAfter;
    }
});
Object.defineProperty(module.exports, "curveStepBefore", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_step.stepBefore;
    }
});
Object.defineProperty(module.exports, "line", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_line.default;
    }
});
Object.defineProperty(module.exports, "lineRadial", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "link", {
    enumerable: true,
    get: function() {
        return $iKlfq.link;
    }
});
Object.defineProperty(module.exports, "linkHorizontal", {
    enumerable: true,
    get: function() {
        return $iKlfq.linkHorizontal;
    }
});
Object.defineProperty(module.exports, "linkRadial", {
    enumerable: true,
    get: function() {
        return $iKlfq.linkRadial;
    }
});
Object.defineProperty(module.exports, "linkVertical", {
    enumerable: true,
    get: function() {
        return $iKlfq.linkVertical;
    }
});
Object.defineProperty(module.exports, "pie", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_pie.default;
    }
});
Object.defineProperty(module.exports, "pointRadial", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_pointRadial.default;
    }
});
Object.defineProperty(module.exports, "radialArea", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "radialLine", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "stack", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_stack.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetDiverging", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetExpand", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_expand.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetNone", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_none.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetSilhouette", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_silhouette.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetWiggle", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_wiggle.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAppearance", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_appearance.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAscending", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderDescending", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderInsideOut", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_insideOut.default;
    }
});
Object.defineProperty(module.exports, "stackOrderNone", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_none2.default;
    }
});
Object.defineProperty(module.exports, "stackOrderReverse", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "symbol", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_symbol.default;
    }
});
Object.defineProperty(module.exports, "symbolAsterisk", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_asterisk.default;
    }
});
Object.defineProperty(module.exports, "symbolCircle", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_circle.default;
    }
});
Object.defineProperty(module.exports, "symbolCross", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_diamond.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond2", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_diamond2.default;
    }
});
Object.defineProperty(module.exports, "symbolPlus", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_plus.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_square.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare2", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_square2.default;
    }
});
Object.defineProperty(module.exports, "symbolStar", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_star.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_triangle.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle2", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_triangle2.default;
    }
});
Object.defineProperty(module.exports, "symbolWye", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_wye.default;
    }
});
Object.defineProperty(module.exports, "symbolX", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_x.default;
    }
});
Object.defineProperty(module.exports, "symbols", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsFill", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsStroke", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_symbol.symbolsStroke;
    }
});

var $bd3b16ab731a8bf0$var$_arc = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("elRpZ")));

var $bd3b16ab731a8bf0$var$_area = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("gS2TC")));

var $bd3b16ab731a8bf0$var$_line = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("7N8XC")));

var $bd3b16ab731a8bf0$var$_pie = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("bgX8T")));

var $bd3b16ab731a8bf0$var$_areaRadial = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("9chv5")));

var $bd3b16ab731a8bf0$var$_lineRadial = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("6ZTS2")));

var $bd3b16ab731a8bf0$var$_pointRadial = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("ktVyl")));

var $iKlfq = parcelRequire("iKlfq");

var $bd3b16ab731a8bf0$var$_symbol = $bd3b16ab731a8bf0$var$_interopRequireWildcard((parcelRequire("kO7AZ")));

var $bd3b16ab731a8bf0$var$_asterisk = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("dbcns")));

var $bd3b16ab731a8bf0$var$_circle = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("hqkBb")));

var $bd3b16ab731a8bf0$var$_cross = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("l7oKy")));

var $bd3b16ab731a8bf0$var$_diamond = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("1vGBb")));

var $bd3b16ab731a8bf0$var$_diamond2 = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("d39kR")));

var $bd3b16ab731a8bf0$var$_plus = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("gHoIh")));

var $bd3b16ab731a8bf0$var$_square = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("jGx5Y")));

var $bd3b16ab731a8bf0$var$_square2 = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("h3HrK")));

var $bd3b16ab731a8bf0$var$_star = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("eItmn")));

var $bd3b16ab731a8bf0$var$_triangle = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("gRLO6")));

var $bd3b16ab731a8bf0$var$_triangle2 = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("5YgcO")));

var $bd3b16ab731a8bf0$var$_wye = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("jWKwo")));

var $bd3b16ab731a8bf0$var$_x = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("42j01")));

var $bd3b16ab731a8bf0$var$_basisClosed = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("4LqwK")));

var $bd3b16ab731a8bf0$var$_basisOpen = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("4ACCw")));

var $bd3b16ab731a8bf0$var$_basis = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("dqqOB")));

var $2baBG = parcelRequire("2baBG");

var $bd3b16ab731a8bf0$var$_bundle = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("8nEjr")));

var $bd3b16ab731a8bf0$var$_cardinalClosed = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("bzrZk")));

var $bd3b16ab731a8bf0$var$_cardinalOpen = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("fTXUm")));

var $bd3b16ab731a8bf0$var$_cardinal = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("1hE1S")));

var $bd3b16ab731a8bf0$var$_catmullRomClosed = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("35AdY")));

var $bd3b16ab731a8bf0$var$_catmullRomOpen = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("ls28s")));

var $bd3b16ab731a8bf0$var$_catmullRom = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("knKEk")));

var $bd3b16ab731a8bf0$var$_linearClosed = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("e53uY")));

var $bd3b16ab731a8bf0$var$_linear = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("63A84")));

var $cAgWu = parcelRequire("cAgWu");

var $bd3b16ab731a8bf0$var$_natural = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("kg6IS")));

var $bd3b16ab731a8bf0$var$_step = $bd3b16ab731a8bf0$var$_interopRequireWildcard((parcelRequire("hbQiR")));

var $bd3b16ab731a8bf0$var$_stack = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("10FpT")));

var $bd3b16ab731a8bf0$var$_expand = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("2fNxx")));

var $bd3b16ab731a8bf0$var$_diverging = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("6a5UN")));

var $bd3b16ab731a8bf0$var$_none = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("boWNO")));

var $bd3b16ab731a8bf0$var$_silhouette = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("9ehm8")));

var $bd3b16ab731a8bf0$var$_wiggle = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("306kH")));

var $bd3b16ab731a8bf0$var$_appearance = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("f5Lyt")));

var $bd3b16ab731a8bf0$var$_ascending = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("ffEmz")));

var $bd3b16ab731a8bf0$var$_descending = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("aQPCV")));

var $bd3b16ab731a8bf0$var$_insideOut = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("4aPb6")));

var $bd3b16ab731a8bf0$var$_none2 = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("kymiB")));

var $bd3b16ab731a8bf0$var$_reverse = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("4uoTs")));
function $bd3b16ab731a8bf0$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($bd3b16ab731a8bf0$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $bd3b16ab731a8bf0$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $bd3b16ab731a8bf0$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $bd3b16ab731a8bf0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRequire.register("elRpZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a72c769c892a94c3$var$_default;

var $6ECsr = parcelRequire("6ECsr");

var $a72c769c892a94c3$var$_constant = $a72c769c892a94c3$var$_interopRequireDefault((parcelRequire("8jJxm")));

var $ig0Mq = parcelRequire("ig0Mq");
function $a72c769c892a94c3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a72c769c892a94c3$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $a72c769c892a94c3$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $a72c769c892a94c3$var$arcStartAngle(d) {
    return d.startAngle;
}
function $a72c769c892a94c3$var$arcEndAngle(d) {
    return d.endAngle;
}
function $a72c769c892a94c3$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $a72c769c892a94c3$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < $ig0Mq.epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
} // Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $a72c769c892a94c3$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $ig0Mq.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $ig0Mq.sqrt)((0, $ig0Mq.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00; // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $a72c769c892a94c3$var$_default() {
    var innerRadius = $a72c769c892a94c3$var$arcInnerRadius, outerRadius = $a72c769c892a94c3$var$arcOuterRadius, cornerRadius = (0, $a72c769c892a94c3$var$_constant.default)(0), padRadius = null, startAngle = $a72c769c892a94c3$var$arcStartAngle, endAngle = $a72c769c892a94c3$var$arcEndAngle, padAngle = $a72c769c892a94c3$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - $ig0Mq.halfPi, a1 = endAngle.apply(this, arguments) - $ig0Mq.halfPi, da = (0, $ig0Mq.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $6ECsr.path)(); // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r; // Is it a point?
        if (!(r1 > $ig0Mq.epsilon)) context.moveTo(0, 0); // Or is it a circle or annulus?
        else if (da > $ig0Mq.tau - $ig0Mq.epsilon) {
            context.moveTo(r1 * (0, $ig0Mq.cos)(a0), r1 * (0, $ig0Mq.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > $ig0Mq.epsilon) {
                context.moveTo(r0 * (0, $ig0Mq.cos)(a1), r0 * (0, $ig0Mq.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > $ig0Mq.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, $ig0Mq.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $ig0Mq.min)((0, $ig0Mq.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1; // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > $ig0Mq.epsilon) {
                var p0 = (0, $ig0Mq.asin)(rp / r0 * (0, $ig0Mq.sin)(ap)), p1 = (0, $ig0Mq.asin)(rp / r1 * (0, $ig0Mq.sin)(ap));
                if ((da0 -= p0 * 2) > $ig0Mq.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > $ig0Mq.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $ig0Mq.cos)(a01), y01 = r1 * (0, $ig0Mq.sin)(a01), x10 = r0 * (0, $ig0Mq.cos)(a10), y10 = r0 * (0, $ig0Mq.sin)(a10); // Apply rounded corners?
            if (rc > $ig0Mq.epsilon) {
                var x11 = r1 * (0, $ig0Mq.cos)(a11), y11 = r1 * (0, $ig0Mq.sin)(a11), x00 = r0 * (0, $ig0Mq.cos)(a00), y00 = r0 * (0, $ig0Mq.sin)(a00), oc; // Restrict the corner radius according to the sector angle.
                if (da < $ig0Mq.pi && (oc = $a72c769c892a94c3$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $ig0Mq.sin)((0, $ig0Mq.acos)((ax * bx + ay * by) / ((0, $ig0Mq.sqrt)(ax * ax + ay * ay) * (0, $ig0Mq.sqrt)(bx * bx + by * by))) / 2), lc = (0, $ig0Mq.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $ig0Mq.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $ig0Mq.min)(rc, (r1 - lc) / (kc + 1));
                }
            } // Is the sector collapsed to a line?
            if (!(da1 > $ig0Mq.epsilon)) context.moveTo(x01, y01); // Does the sector’s outer ring have rounded corners?
            else if (rc1 > $ig0Mq.epsilon) {
                t0 = $a72c769c892a94c3$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $a72c769c892a94c3$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $ig0Mq.atan2)(t0.y01, t0.x01), (0, $ig0Mq.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $ig0Mq.atan2)(t0.y01, t0.x01), (0, $ig0Mq.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $ig0Mq.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $ig0Mq.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $ig0Mq.atan2)(t1.y11, t1.x11), (0, $ig0Mq.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw); // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > $ig0Mq.epsilon) || !(da0 > $ig0Mq.epsilon)) context.lineTo(x10, y10); // Does the sector’s inner ring (or point) have rounded corners?
            else if (rc0 > $ig0Mq.epsilon) {
                t0 = $a72c769c892a94c3$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $a72c769c892a94c3$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $ig0Mq.atan2)(t0.y01, t0.x01), (0, $ig0Mq.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $ig0Mq.atan2)(t0.y01, t0.x01), (0, $ig0Mq.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $ig0Mq.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $ig0Mq.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $ig0Mq.atan2)(t1.y11, t1.x11), (0, $ig0Mq.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - $ig0Mq.pi / 2;
        return [
            (0, $ig0Mq.cos)(a) * r,
            (0, $ig0Mq.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $a72c769c892a94c3$var$_constant.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $a72c769c892a94c3$var$_constant.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $a72c769c892a94c3$var$_constant.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $a72c769c892a94c3$var$_constant.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $a72c769c892a94c3$var$_constant.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $a72c769c892a94c3$var$_constant.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $a72c769c892a94c3$var$_constant.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRequire.register("6ECsr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "path", {
    enumerable: true,
    get: function() {
        return $4d844f69f7836a64$var$_path.default;
    }
});

var $4d844f69f7836a64$var$_path = $4d844f69f7836a64$var$_interopRequireDefault((parcelRequire("1gkEM")));
function $4d844f69f7836a64$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRequire.register("1gkEM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $0eb74f127941ed8e$var$pi = Math.PI, $0eb74f127941ed8e$var$tau = 2 * $0eb74f127941ed8e$var$pi, $0eb74f127941ed8e$var$epsilon = 1e-6, $0eb74f127941ed8e$var$tauEpsilon = $0eb74f127941ed8e$var$tau - $0eb74f127941ed8e$var$epsilon;
function $0eb74f127941ed8e$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $0eb74f127941ed8e$var$path() {
    return new $0eb74f127941ed8e$var$Path();
}
$0eb74f127941ed8e$var$Path.prototype = $0eb74f127941ed8e$var$path.prototype = {
    constructor: $0eb74f127941ed8e$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $0eb74f127941ed8e$var$epsilon)) ; // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $0eb74f127941ed8e$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($0eb74f127941ed8e$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21; // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $0eb74f127941ed8e$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $0eb74f127941ed8e$var$epsilon || Math.abs(this._y1 - y0) > $0eb74f127941ed8e$var$epsilon) this._ += "L" + x0 + "," + y0;
         // Is this arc empty? We’re done.
        if (!r) return; // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $0eb74f127941ed8e$var$tau + $0eb74f127941ed8e$var$tau; // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $0eb74f127941ed8e$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $0eb74f127941ed8e$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $0eb74f127941ed8e$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $0eb74f127941ed8e$var$_default = $0eb74f127941ed8e$var$path;
module.exports.default = $0eb74f127941ed8e$var$_default;

});


parcelRequire.register("8jJxm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $60e36bc81be26027$var$_default;
function $60e36bc81be26027$var$_default(x) {
    return function constant() {
        return x;
    };
}

});

parcelRequire.register("ig0Mq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.abs = void 0;
module.exports.acos = $d4aa537edeb5204d$var$acos;
module.exports.asin = $d4aa537edeb5204d$var$asin;
module.exports.tau = module.exports.sqrt = module.exports.sin = module.exports.pi = module.exports.min = module.exports.max = module.exports.halfPi = module.exports.epsilon = module.exports.cos = module.exports.atan2 = void 0;
const $d4aa537edeb5204d$var$abs = Math.abs;
module.exports.abs = $d4aa537edeb5204d$var$abs;
const $d4aa537edeb5204d$var$atan2 = Math.atan2;
module.exports.atan2 = $d4aa537edeb5204d$var$atan2;
const $d4aa537edeb5204d$var$cos = Math.cos;
module.exports.cos = $d4aa537edeb5204d$var$cos;
const $d4aa537edeb5204d$var$max = Math.max;
module.exports.max = $d4aa537edeb5204d$var$max;
const $d4aa537edeb5204d$var$min = Math.min;
module.exports.min = $d4aa537edeb5204d$var$min;
const $d4aa537edeb5204d$var$sin = Math.sin;
module.exports.sin = $d4aa537edeb5204d$var$sin;
const $d4aa537edeb5204d$var$sqrt = Math.sqrt;
module.exports.sqrt = $d4aa537edeb5204d$var$sqrt;
const $d4aa537edeb5204d$var$epsilon = 1e-12;
module.exports.epsilon = $d4aa537edeb5204d$var$epsilon;
const $d4aa537edeb5204d$var$pi = Math.PI;
module.exports.pi = $d4aa537edeb5204d$var$pi;
const $d4aa537edeb5204d$var$halfPi = $d4aa537edeb5204d$var$pi / 2;
module.exports.halfPi = $d4aa537edeb5204d$var$halfPi;
const $d4aa537edeb5204d$var$tau = 2 * $d4aa537edeb5204d$var$pi;
module.exports.tau = $d4aa537edeb5204d$var$tau;
function $d4aa537edeb5204d$var$acos(x) {
    return x > 1 ? 0 : x < -1 ? $d4aa537edeb5204d$var$pi : Math.acos(x);
}
function $d4aa537edeb5204d$var$asin(x) {
    return x >= 1 ? $d4aa537edeb5204d$var$halfPi : x <= -1 ? -$d4aa537edeb5204d$var$halfPi : Math.asin(x);
}

});


parcelRequire.register("gS2TC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c483ef965bb9f52d$var$_default;

var $6ECsr = parcelRequire("6ECsr");

var $c483ef965bb9f52d$var$_array = $c483ef965bb9f52d$var$_interopRequireDefault((parcelRequire("1Joyq")));

var $c483ef965bb9f52d$var$_constant = $c483ef965bb9f52d$var$_interopRequireDefault((parcelRequire("8jJxm")));

var $c483ef965bb9f52d$var$_linear = $c483ef965bb9f52d$var$_interopRequireDefault((parcelRequire("63A84")));

var $c483ef965bb9f52d$var$_line = $c483ef965bb9f52d$var$_interopRequireDefault((parcelRequire("7N8XC")));

var $ht2xs = parcelRequire("ht2xs");
function $c483ef965bb9f52d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c483ef965bb9f52d$var$_default(x0, y0, y1) {
    var x1 = null, defined = (0, $c483ef965bb9f52d$var$_constant.default)(true), context = null, curve = $c483ef965bb9f52d$var$_linear.default, output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? $ht2xs.x : (0, $c483ef965bb9f52d$var$_constant.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $c483ef965bb9f52d$var$_constant.default)(0) : (0, $c483ef965bb9f52d$var$_constant.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? $ht2xs.y : (0, $c483ef965bb9f52d$var$_constant.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $c483ef965bb9f52d$var$_array.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $6ECsr.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $c483ef965bb9f52d$var$_line.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $c483ef965bb9f52d$var$_constant.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $c483ef965bb9f52d$var$_constant.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $c483ef965bb9f52d$var$_constant.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $c483ef965bb9f52d$var$_constant.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $c483ef965bb9f52d$var$_constant.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $c483ef965bb9f52d$var$_constant.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $c483ef965bb9f52d$var$_constant.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRequire.register("1Joyq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $142d0a6576e73134$var$_default;
module.exports.slice = void 0;
var $142d0a6576e73134$var$slice = Array.prototype.slice;
module.exports.slice = $142d0a6576e73134$var$slice;
function $142d0a6576e73134$var$_default(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRequire.register("63A84", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $468f0c69528eb9c3$var$_default;
function $468f0c69528eb9c3$var$Linear(context) {
    this._context = context;
}
$468f0c69528eb9c3$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $468f0c69528eb9c3$var$_default(context) {
    return new $468f0c69528eb9c3$var$Linear(context);
}

});

parcelRequire.register("7N8XC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5ac40f6641846b59$var$_default;

var $6ECsr = parcelRequire("6ECsr");

var $5ac40f6641846b59$var$_array = $5ac40f6641846b59$var$_interopRequireDefault((parcelRequire("1Joyq")));

var $5ac40f6641846b59$var$_constant = $5ac40f6641846b59$var$_interopRequireDefault((parcelRequire("8jJxm")));

var $5ac40f6641846b59$var$_linear = $5ac40f6641846b59$var$_interopRequireDefault((parcelRequire("63A84")));

var $ht2xs = parcelRequire("ht2xs");
function $5ac40f6641846b59$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5ac40f6641846b59$var$_default(x, y) {
    var defined = (0, $5ac40f6641846b59$var$_constant.default)(true), context = null, curve = $5ac40f6641846b59$var$_linear.default, output = null;
    x = typeof x === "function" ? x : x === undefined ? $ht2xs.x : (0, $5ac40f6641846b59$var$_constant.default)(x);
    y = typeof y === "function" ? y : y === undefined ? $ht2xs.y : (0, $5ac40f6641846b59$var$_constant.default)(y);
    function line(data) {
        var i, n = (data = (0, $5ac40f6641846b59$var$_array.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $6ECsr.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $5ac40f6641846b59$var$_constant.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $5ac40f6641846b59$var$_constant.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $5ac40f6641846b59$var$_constant.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRequire.register("ht2xs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.x = $cb771d3dedd7df05$var$x;
module.exports.y = $cb771d3dedd7df05$var$y;
function $cb771d3dedd7df05$var$x(p) {
    return p[0];
}
function $cb771d3dedd7df05$var$y(p) {
    return p[1];
}

});



parcelRequire.register("bgX8T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $834f10cc0d12313a$var$_default;

var $834f10cc0d12313a$var$_array = $834f10cc0d12313a$var$_interopRequireDefault((parcelRequire("1Joyq")));

var $834f10cc0d12313a$var$_constant = $834f10cc0d12313a$var$_interopRequireDefault((parcelRequire("8jJxm")));

var $834f10cc0d12313a$var$_descending = $834f10cc0d12313a$var$_interopRequireDefault((parcelRequire("7kkzx")));

var $834f10cc0d12313a$var$_identity = $834f10cc0d12313a$var$_interopRequireDefault((parcelRequire("8aNJQ")));

var $ig0Mq = parcelRequire("ig0Mq");
function $834f10cc0d12313a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $834f10cc0d12313a$var$_default() {
    var value = $834f10cc0d12313a$var$_identity.default, sortValues = $834f10cc0d12313a$var$_descending.default, sort = null, startAngle = (0, $834f10cc0d12313a$var$_constant.default)(0), endAngle = (0, $834f10cc0d12313a$var$_constant.default)($ig0Mq.tau), padAngle = (0, $834f10cc0d12313a$var$_constant.default)(0);
    function pie(data) {
        var i, n = (data = (0, $834f10cc0d12313a$var$_array.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min($ig0Mq.tau, Math.max(-$ig0Mq.tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
         // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        }); // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $834f10cc0d12313a$var$_constant.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $834f10cc0d12313a$var$_constant.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $834f10cc0d12313a$var$_constant.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $834f10cc0d12313a$var$_constant.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRequire.register("7kkzx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $555a5bd86b7b72f6$var$_default;
function $555a5bd86b7b72f6$var$_default(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRequire.register("8aNJQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5f35d6e69eddef7c$var$_default;
function $5f35d6e69eddef7c$var$_default(d) {
    return d;
}

});


parcelRequire.register("9chv5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6b22cf482fefb72a$var$_default;

var $6b22cf482fefb72a$var$_radial = $6b22cf482fefb72a$var$_interopRequireWildcard((parcelRequire("1DlwC")));

var $6b22cf482fefb72a$var$_area = $6b22cf482fefb72a$var$_interopRequireDefault((parcelRequire("gS2TC")));

var $6ZTS2 = parcelRequire("6ZTS2");
function $6b22cf482fefb72a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6b22cf482fefb72a$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($6b22cf482fefb72a$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $6b22cf482fefb72a$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $6b22cf482fefb72a$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $6b22cf482fefb72a$var$_default() {
    var a = (0, $6b22cf482fefb72a$var$_area.default)().curve($6b22cf482fefb72a$var$_radial.curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $6ZTS2.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $6ZTS2.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $6ZTS2.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $6ZTS2.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $6b22cf482fefb72a$var$_radial.default)(_)) : c()._curve;
    };
    return a;
}

});
parcelRequire.register("1DlwC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.curveRadialLinear = void 0;
module.exports.default = $130a2162ff2e37e0$var$curveRadial;

var $130a2162ff2e37e0$var$_linear = $130a2162ff2e37e0$var$_interopRequireDefault((parcelRequire("63A84")));
function $130a2162ff2e37e0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $130a2162ff2e37e0$var$curveRadialLinear = $130a2162ff2e37e0$var$curveRadial($130a2162ff2e37e0$var$_linear.default);
module.exports.curveRadialLinear = $130a2162ff2e37e0$var$curveRadialLinear;
function $130a2162ff2e37e0$var$Radial(curve) {
    this._curve = curve;
}
$130a2162ff2e37e0$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $130a2162ff2e37e0$var$curveRadial(curve) {
    function radial(context) {
        return new $130a2162ff2e37e0$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

});

parcelRequire.register("6ZTS2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5183c74b00000e4c$var$_default;
module.exports.lineRadial = $5183c74b00000e4c$var$lineRadial;

var $5183c74b00000e4c$var$_radial = $5183c74b00000e4c$var$_interopRequireWildcard((parcelRequire("1DlwC")));

var $5183c74b00000e4c$var$_line = $5183c74b00000e4c$var$_interopRequireDefault((parcelRequire("7N8XC")));
function $5183c74b00000e4c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5183c74b00000e4c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($5183c74b00000e4c$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $5183c74b00000e4c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $5183c74b00000e4c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $5183c74b00000e4c$var$lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $5183c74b00000e4c$var$_radial.default)(_)) : c()._curve;
    };
    return l;
}
function $5183c74b00000e4c$var$_default() {
    return $5183c74b00000e4c$var$lineRadial((0, $5183c74b00000e4c$var$_line.default)().curve($5183c74b00000e4c$var$_radial.curveRadialLinear));
}

});


parcelRequire.register("ktVyl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ee9328eb446de5f7$var$_default;
function $ee9328eb446de5f7$var$_default(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});

parcelRequire.register("iKlfq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.link = $da5d0137600e9a35$var$link;
module.exports.linkHorizontal = $da5d0137600e9a35$var$linkHorizontal;
module.exports.linkRadial = $da5d0137600e9a35$var$linkRadial;
module.exports.linkVertical = $da5d0137600e9a35$var$linkVertical;

var $6ECsr = parcelRequire("6ECsr");

var $1Joyq = parcelRequire("1Joyq");

var $da5d0137600e9a35$var$_constant = $da5d0137600e9a35$var$_interopRequireDefault((parcelRequire("8jJxm")));

var $2baBG = parcelRequire("2baBG");

var $ht2xs = parcelRequire("ht2xs");
function $da5d0137600e9a35$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $da5d0137600e9a35$var$linkSource(d) {
    return d.source;
}
function $da5d0137600e9a35$var$linkTarget(d) {
    return d.target;
}
function $da5d0137600e9a35$var$link(curve) {
    let source = $da5d0137600e9a35$var$linkSource;
    let target = $da5d0137600e9a35$var$linkTarget;
    let x = $ht2xs.x;
    let y = $ht2xs.y;
    let context = null;
    let output = null;
    function link() {
        let buffer;
        const argv = $1Joyq.slice.call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = (0, $6ECsr.path)());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $da5d0137600e9a35$var$_constant.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $da5d0137600e9a35$var$_constant.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function $da5d0137600e9a35$var$linkHorizontal() {
    return $da5d0137600e9a35$var$link($2baBG.bumpX);
}
function $da5d0137600e9a35$var$linkVertical() {
    return $da5d0137600e9a35$var$link($2baBG.bumpY);
}
function $da5d0137600e9a35$var$linkRadial() {
    const l = $da5d0137600e9a35$var$link($2baBG.bumpRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

});
parcelRequire.register("2baBG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bumpRadial = $1964d62a208e710a$var$bumpRadial;
module.exports.bumpX = $1964d62a208e710a$var$bumpX;
module.exports.bumpY = $1964d62a208e710a$var$bumpY;

var $1964d62a208e710a$var$_pointRadial = $1964d62a208e710a$var$_interopRequireDefault((parcelRequire("ktVyl")));
function $1964d62a208e710a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class $1964d62a208e710a$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $1964d62a208e710a$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point++ === 0) this._x0 = x, this._y0 = y;
        else {
            const p0 = (0, $1964d62a208e710a$var$_pointRadial.default)(this._x0, this._y0);
            const p1 = (0, $1964d62a208e710a$var$_pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $1964d62a208e710a$var$_pointRadial.default)(x, this._y0);
            const p3 = (0, $1964d62a208e710a$var$_pointRadial.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
    }
}
function $1964d62a208e710a$var$bumpX(context) {
    return new $1964d62a208e710a$var$Bump(context, true);
}
function $1964d62a208e710a$var$bumpY(context) {
    return new $1964d62a208e710a$var$Bump(context, false);
}
function $1964d62a208e710a$var$bumpRadial(context) {
    return new $1964d62a208e710a$var$BumpRadial(context);
}

});


parcelRequire.register("kO7AZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f25e5e7d622fb590$var$Symbol;
module.exports.symbolsStroke = module.exports.symbolsFill = void 0;

var $6ECsr = parcelRequire("6ECsr");

var $f25e5e7d622fb590$var$_constant = $f25e5e7d622fb590$var$_interopRequireDefault((parcelRequire("8jJxm")));

var $f25e5e7d622fb590$var$_asterisk = $f25e5e7d622fb590$var$_interopRequireDefault((parcelRequire("dbcns")));

var $f25e5e7d622fb590$var$_circle = $f25e5e7d622fb590$var$_interopRequireDefault((parcelRequire("hqkBb")));

var $f25e5e7d622fb590$var$_cross = $f25e5e7d622fb590$var$_interopRequireDefault((parcelRequire("l7oKy")));

var $f25e5e7d622fb590$var$_diamond = $f25e5e7d622fb590$var$_interopRequireDefault((parcelRequire("1vGBb")));

var $f25e5e7d622fb590$var$_diamond2 = $f25e5e7d622fb590$var$_interopRequireDefault((parcelRequire("d39kR")));

var $f25e5e7d622fb590$var$_plus = $f25e5e7d622fb590$var$_interopRequireDefault((parcelRequire("gHoIh")));

var $f25e5e7d622fb590$var$_square = $f25e5e7d622fb590$var$_interopRequireDefault((parcelRequire("jGx5Y")));

var $f25e5e7d622fb590$var$_square2 = $f25e5e7d622fb590$var$_interopRequireDefault((parcelRequire("h3HrK")));

var $f25e5e7d622fb590$var$_star = $f25e5e7d622fb590$var$_interopRequireDefault((parcelRequire("eItmn")));

var $f25e5e7d622fb590$var$_triangle = $f25e5e7d622fb590$var$_interopRequireDefault((parcelRequire("gRLO6")));

var $f25e5e7d622fb590$var$_triangle2 = $f25e5e7d622fb590$var$_interopRequireDefault((parcelRequire("5YgcO")));

var $f25e5e7d622fb590$var$_wye = $f25e5e7d622fb590$var$_interopRequireDefault((parcelRequire("jWKwo")));

var $f25e5e7d622fb590$var$_x = $f25e5e7d622fb590$var$_interopRequireDefault((parcelRequire("42j01")));
function $f25e5e7d622fb590$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// These symbols are designed to be filled.
const $f25e5e7d622fb590$var$symbolsFill = [
    $f25e5e7d622fb590$var$_circle.default,
    $f25e5e7d622fb590$var$_cross.default,
    $f25e5e7d622fb590$var$_diamond.default,
    $f25e5e7d622fb590$var$_square.default,
    $f25e5e7d622fb590$var$_star.default,
    $f25e5e7d622fb590$var$_triangle.default,
    $f25e5e7d622fb590$var$_wye.default
]; // These symbols are designed to be stroked (with a width of 1.5px and round caps).
module.exports.symbolsFill = $f25e5e7d622fb590$var$symbolsFill;
const $f25e5e7d622fb590$var$symbolsStroke = [
    $f25e5e7d622fb590$var$_circle.default,
    $f25e5e7d622fb590$var$_plus.default,
    $f25e5e7d622fb590$var$_x.default,
    $f25e5e7d622fb590$var$_triangle2.default,
    $f25e5e7d622fb590$var$_asterisk.default,
    $f25e5e7d622fb590$var$_square2.default,
    $f25e5e7d622fb590$var$_diamond2.default
];
module.exports.symbolsStroke = $f25e5e7d622fb590$var$symbolsStroke;
function $f25e5e7d622fb590$var$Symbol(type, size) {
    let context = null;
    type = typeof type === "function" ? type : (0, $f25e5e7d622fb590$var$_constant.default)(type || $f25e5e7d622fb590$var$_circle.default);
    size = typeof size === "function" ? size : (0, $f25e5e7d622fb590$var$_constant.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = (0, $6ECsr.path)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $f25e5e7d622fb590$var$_constant.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $f25e5e7d622fb590$var$_constant.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

});
parcelRequire.register("dbcns", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ig0Mq = parcelRequire("ig0Mq");
const $9985e7557a3cd12a$var$sqrt3 = (0, $ig0Mq.sqrt)(3);
var $9985e7557a3cd12a$var$_default = {
    draw (context, size) {
        const r = (0, $ig0Mq.sqrt)(size + (0, $ig0Mq.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $9985e7557a3cd12a$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};
module.exports.default = $9985e7557a3cd12a$var$_default;

});

parcelRequire.register("hqkBb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ig0Mq = parcelRequire("ig0Mq");
var $caf4d7d747950d99$var$_default = {
    draw (context, size) {
        const r = (0, $ig0Mq.sqrt)(size / $ig0Mq.pi);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, $ig0Mq.tau);
    }
};
module.exports.default = $caf4d7d747950d99$var$_default;

});

parcelRequire.register("l7oKy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ig0Mq = parcelRequire("ig0Mq");
var $f5fd733e8a665c56$var$_default = {
    draw (context, size) {
        const r = (0, $ig0Mq.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};
module.exports.default = $f5fd733e8a665c56$var$_default;

});

parcelRequire.register("1vGBb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ig0Mq = parcelRequire("ig0Mq");
const $1199bae444d0594d$var$tan30 = (0, $ig0Mq.sqrt)(1 / 3);
const $1199bae444d0594d$var$tan30_2 = $1199bae444d0594d$var$tan30 * 2;
var $1199bae444d0594d$var$_default = {
    draw (context, size) {
        const y = (0, $ig0Mq.sqrt)(size / $1199bae444d0594d$var$tan30_2);
        const x = y * $1199bae444d0594d$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};
module.exports.default = $1199bae444d0594d$var$_default;

});

parcelRequire.register("d39kR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ig0Mq = parcelRequire("ig0Mq");
var $9802cc06456a4377$var$_default = {
    draw (context, size) {
        const r = (0, $ig0Mq.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};
module.exports.default = $9802cc06456a4377$var$_default;

});

parcelRequire.register("gHoIh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ig0Mq = parcelRequire("ig0Mq");
var $c283d500c783ad5d$var$_default = {
    draw (context, size) {
        const r = (0, $ig0Mq.sqrt)(size - (0, $ig0Mq.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};
module.exports.default = $c283d500c783ad5d$var$_default;

});

parcelRequire.register("jGx5Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ig0Mq = parcelRequire("ig0Mq");
var $03b2c4972e6b8a1d$var$_default = {
    draw (context, size) {
        const w = (0, $ig0Mq.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};
module.exports.default = $03b2c4972e6b8a1d$var$_default;

});

parcelRequire.register("h3HrK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ig0Mq = parcelRequire("ig0Mq");
var $c6b46b0cdb9a482d$var$_default = {
    draw (context, size) {
        const r = (0, $ig0Mq.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};
module.exports.default = $c6b46b0cdb9a482d$var$_default;

});

parcelRequire.register("eItmn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ig0Mq = parcelRequire("ig0Mq");
const $ab6bf307a80a5bcb$var$ka = 0.89081309152928522810;
const $ab6bf307a80a5bcb$var$kr = (0, $ig0Mq.sin)($ig0Mq.pi / 10) / (0, $ig0Mq.sin)(7 * $ig0Mq.pi / 10);
const $ab6bf307a80a5bcb$var$kx = (0, $ig0Mq.sin)($ig0Mq.tau / 10) * $ab6bf307a80a5bcb$var$kr;
const $ab6bf307a80a5bcb$var$ky = -(0, $ig0Mq.cos)($ig0Mq.tau / 10) * $ab6bf307a80a5bcb$var$kr;
var $ab6bf307a80a5bcb$var$_default = {
    draw (context, size) {
        const r = (0, $ig0Mq.sqrt)(size * $ab6bf307a80a5bcb$var$ka);
        const x = $ab6bf307a80a5bcb$var$kx * r;
        const y = $ab6bf307a80a5bcb$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = $ig0Mq.tau * i / 5;
            const c = (0, $ig0Mq.cos)(a);
            const s = (0, $ig0Mq.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};
module.exports.default = $ab6bf307a80a5bcb$var$_default;

});

parcelRequire.register("gRLO6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ig0Mq = parcelRequire("ig0Mq");
const $032b345b1218b4bd$var$sqrt3 = (0, $ig0Mq.sqrt)(3);
var $032b345b1218b4bd$var$_default = {
    draw (context, size) {
        const y = -(0, $ig0Mq.sqrt)(size / ($032b345b1218b4bd$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$032b345b1218b4bd$var$sqrt3 * y, -y);
        context.lineTo($032b345b1218b4bd$var$sqrt3 * y, -y);
        context.closePath();
    }
};
module.exports.default = $032b345b1218b4bd$var$_default;

});

parcelRequire.register("5YgcO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ig0Mq = parcelRequire("ig0Mq");
const $458f206df33bed1b$var$sqrt3 = (0, $ig0Mq.sqrt)(3);
var $458f206df33bed1b$var$_default = {
    draw (context, size) {
        const s = (0, $ig0Mq.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * $458f206df33bed1b$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};
module.exports.default = $458f206df33bed1b$var$_default;

});

parcelRequire.register("jWKwo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ig0Mq = parcelRequire("ig0Mq");
const $e8578548d922b436$var$c = -0.5;
const $e8578548d922b436$var$s = (0, $ig0Mq.sqrt)(3) / 2;
const $e8578548d922b436$var$k = 1 / (0, $ig0Mq.sqrt)(12);
const $e8578548d922b436$var$a = ($e8578548d922b436$var$k / 2 + 1) * 3;
var $e8578548d922b436$var$_default = {
    draw (context, size) {
        const r = (0, $ig0Mq.sqrt)(size / $e8578548d922b436$var$a);
        const x0 = r / 2, y0 = r * $e8578548d922b436$var$k;
        const x1 = x0, y1 = r * $e8578548d922b436$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($e8578548d922b436$var$c * x0 - $e8578548d922b436$var$s * y0, $e8578548d922b436$var$s * x0 + $e8578548d922b436$var$c * y0);
        context.lineTo($e8578548d922b436$var$c * x1 - $e8578548d922b436$var$s * y1, $e8578548d922b436$var$s * x1 + $e8578548d922b436$var$c * y1);
        context.lineTo($e8578548d922b436$var$c * x2 - $e8578548d922b436$var$s * y2, $e8578548d922b436$var$s * x2 + $e8578548d922b436$var$c * y2);
        context.lineTo($e8578548d922b436$var$c * x0 + $e8578548d922b436$var$s * y0, $e8578548d922b436$var$c * y0 - $e8578548d922b436$var$s * x0);
        context.lineTo($e8578548d922b436$var$c * x1 + $e8578548d922b436$var$s * y1, $e8578548d922b436$var$c * y1 - $e8578548d922b436$var$s * x1);
        context.lineTo($e8578548d922b436$var$c * x2 + $e8578548d922b436$var$s * y2, $e8578548d922b436$var$c * y2 - $e8578548d922b436$var$s * x2);
        context.closePath();
    }
};
module.exports.default = $e8578548d922b436$var$_default;

});

parcelRequire.register("42j01", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ig0Mq = parcelRequire("ig0Mq");
var $2f06163546352e5b$var$_default = {
    draw (context, size) {
        const r = (0, $ig0Mq.sqrt)(size - (0, $ig0Mq.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};
module.exports.default = $2f06163546352e5b$var$_default;

});


parcelRequire.register("4LqwK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $378020f90c7b265b$var$_default;

var $378020f90c7b265b$var$_noop = $378020f90c7b265b$var$_interopRequireDefault((parcelRequire("jNHOl")));

var $dqqOB = parcelRequire("dqqOB");
function $378020f90c7b265b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $378020f90c7b265b$var$BasisClosed(context) {
    this._context = context;
}
$378020f90c7b265b$var$BasisClosed.prototype = {
    areaStart: $378020f90c7b265b$var$_noop.default,
    areaEnd: $378020f90c7b265b$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $dqqOB.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $378020f90c7b265b$var$_default(context) {
    return new $378020f90c7b265b$var$BasisClosed(context);
}

});
parcelRequire.register("jNHOl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e6a493db9cca7bf8$var$_default;
function $e6a493db9cca7bf8$var$_default() {}

});

parcelRequire.register("dqqOB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Basis = $9c6280fd008771dd$var$Basis;
module.exports.default = $9c6280fd008771dd$var$_default;
module.exports.point = $9c6280fd008771dd$var$point;
function $9c6280fd008771dd$var$point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $9c6280fd008771dd$var$Basis(context) {
    this._context = context;
}
$9c6280fd008771dd$var$Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $9c6280fd008771dd$var$point(this, this._x1, this._y1);
            // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
            // falls through
            default:
                $9c6280fd008771dd$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $9c6280fd008771dd$var$_default(context) {
    return new $9c6280fd008771dd$var$Basis(context);
}

});


parcelRequire.register("4ACCw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $35787b644e1095a6$var$_default;

var $dqqOB = parcelRequire("dqqOB");
function $35787b644e1095a6$var$BasisOpen(context) {
    this._context = context;
}
$35787b644e1095a6$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $dqqOB.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $35787b644e1095a6$var$_default(context) {
    return new $35787b644e1095a6$var$BasisOpen(context);
}

});

parcelRequire.register("8nEjr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dqqOB = parcelRequire("dqqOB");
function $619fbdf851b1b16d$var$Bundle(context, beta) {
    this._basis = new $dqqOB.Basis(context);
    this._beta = beta;
}
$619fbdf851b1b16d$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $619fbdf851b1b16d$var$_default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new $dqqOB.Basis(context) : new $619fbdf851b1b16d$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);
module.exports.default = $619fbdf851b1b16d$var$_default;

});

parcelRequire.register("bzrZk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalClosed = $86c8ac7c006d1147$var$CardinalClosed;
module.exports.default = void 0;

var $86c8ac7c006d1147$var$_noop = $86c8ac7c006d1147$var$_interopRequireDefault((parcelRequire("jNHOl")));

var $1hE1S = parcelRequire("1hE1S");
function $86c8ac7c006d1147$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $86c8ac7c006d1147$var$CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$86c8ac7c006d1147$var$CardinalClosed.prototype = {
    areaStart: $86c8ac7c006d1147$var$_noop.default,
    areaEnd: $86c8ac7c006d1147$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $1hE1S.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $86c8ac7c006d1147$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $86c8ac7c006d1147$var$CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $86c8ac7c006d1147$var$_default;

});
parcelRequire.register("1hE1S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cardinal = $0ef66df2c76a6789$var$Cardinal;
module.exports.default = void 0;
module.exports.point = $0ef66df2c76a6789$var$point;
function $0ef66df2c76a6789$var$point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $0ef66df2c76a6789$var$Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$0ef66df2c76a6789$var$Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $0ef66df2c76a6789$var$point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                $0ef66df2c76a6789$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $0ef66df2c76a6789$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $0ef66df2c76a6789$var$Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $0ef66df2c76a6789$var$_default;

});


parcelRequire.register("fTXUm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalOpen = $b93a7691033ea5b7$var$CardinalOpen;
module.exports.default = void 0;

var $1hE1S = parcelRequire("1hE1S");
function $b93a7691033ea5b7$var$CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$b93a7691033ea5b7$var$CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $1hE1S.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $b93a7691033ea5b7$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $b93a7691033ea5b7$var$CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $b93a7691033ea5b7$var$_default;

});

parcelRequire.register("35AdY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bzrZk = parcelRequire("bzrZk");

var $23fdf0240a80ea26$var$_noop = $23fdf0240a80ea26$var$_interopRequireDefault((parcelRequire("jNHOl")));

var $knKEk = parcelRequire("knKEk");
function $23fdf0240a80ea26$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $23fdf0240a80ea26$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$23fdf0240a80ea26$var$CatmullRomClosed.prototype = {
    areaStart: $23fdf0240a80ea26$var$_noop.default,
    areaEnd: $23fdf0240a80ea26$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $knKEk.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $23fdf0240a80ea26$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $23fdf0240a80ea26$var$CatmullRomClosed(context, alpha) : new $bzrZk.CardinalClosed(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $23fdf0240a80ea26$var$_default;

});
parcelRequire.register("knKEk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.point = $ed6a243ad33fad69$var$point;

var $ig0Mq = parcelRequire("ig0Mq");

var $1hE1S = parcelRequire("1hE1S");
function $ed6a243ad33fad69$var$point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > $ig0Mq.epsilon) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > $ig0Mq.epsilon) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function $ed6a243ad33fad69$var$CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$ed6a243ad33fad69$var$CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                $ed6a243ad33fad69$var$point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $ed6a243ad33fad69$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $ed6a243ad33fad69$var$CatmullRom(context, alpha) : new $1hE1S.Cardinal(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $ed6a243ad33fad69$var$_default;

});


parcelRequire.register("ls28s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fTXUm = parcelRequire("fTXUm");

var $knKEk = parcelRequire("knKEk");
function $f9ddde88534ec720$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$f9ddde88534ec720$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $knKEk.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $f9ddde88534ec720$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $f9ddde88534ec720$var$CatmullRomOpen(context, alpha) : new $fTXUm.CardinalOpen(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $f9ddde88534ec720$var$_default;

});

parcelRequire.register("e53uY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a4043f15171fb5ea$var$_default;

var $a4043f15171fb5ea$var$_noop = $a4043f15171fb5ea$var$_interopRequireDefault((parcelRequire("jNHOl")));
function $a4043f15171fb5ea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a4043f15171fb5ea$var$LinearClosed(context) {
    this._context = context;
}
$a4043f15171fb5ea$var$LinearClosed.prototype = {
    areaStart: $a4043f15171fb5ea$var$_noop.default,
    areaEnd: $a4043f15171fb5ea$var$_noop.default,
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $a4043f15171fb5ea$var$_default(context) {
    return new $a4043f15171fb5ea$var$LinearClosed(context);
}

});

parcelRequire.register("cAgWu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.monotoneX = $9295fd3fa69f33ec$var$monotoneX;
module.exports.monotoneY = $9295fd3fa69f33ec$var$monotoneY;
function $9295fd3fa69f33ec$var$sign(x) {
    return x < 0 ? -1 : 1;
} // Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $9295fd3fa69f33ec$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($9295fd3fa69f33ec$var$sign(s0) + $9295fd3fa69f33ec$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
} // Calculate a one-sided slope.
function $9295fd3fa69f33ec$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
} // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $9295fd3fa69f33ec$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $9295fd3fa69f33ec$var$MonotoneX(context) {
    this._context = context;
}
$9295fd3fa69f33ec$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $9295fd3fa69f33ec$var$point(this, this._t0, $9295fd3fa69f33ec$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $9295fd3fa69f33ec$var$point(this, $9295fd3fa69f33ec$var$slope2(this, t1 = $9295fd3fa69f33ec$var$slope3(this, x, y)), t1);
                break;
            default:
                $9295fd3fa69f33ec$var$point(this, this._t0, t1 = $9295fd3fa69f33ec$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $9295fd3fa69f33ec$var$MonotoneY(context) {
    this._context = new $9295fd3fa69f33ec$var$ReflectContext(context);
}
($9295fd3fa69f33ec$var$MonotoneY.prototype = Object.create($9295fd3fa69f33ec$var$MonotoneX.prototype)).point = function(x, y) {
    $9295fd3fa69f33ec$var$MonotoneX.prototype.point.call(this, y, x);
};
function $9295fd3fa69f33ec$var$ReflectContext(context) {
    this._context = context;
}
$9295fd3fa69f33ec$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $9295fd3fa69f33ec$var$monotoneX(context) {
    return new $9295fd3fa69f33ec$var$MonotoneX(context);
}
function $9295fd3fa69f33ec$var$monotoneY(context) {
    return new $9295fd3fa69f33ec$var$MonotoneY(context);
}

});

parcelRequire.register("kg6IS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ebfa84454e967b93$var$_default;
function $ebfa84454e967b93$var$Natural(context) {
    this._context = context;
}
$ebfa84454e967b93$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $ebfa84454e967b93$var$controlPoints(x), py = $ebfa84454e967b93$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
}; // See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $ebfa84454e967b93$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $ebfa84454e967b93$var$_default(context) {
    return new $ebfa84454e967b93$var$Natural(context);
}

});

parcelRequire.register("hbQiR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c83c090d7aba40ae$var$_default;
module.exports.stepAfter = $c83c090d7aba40ae$var$stepAfter;
module.exports.stepBefore = $c83c090d7aba40ae$var$stepBefore;
function $c83c090d7aba40ae$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$c83c090d7aba40ae$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $c83c090d7aba40ae$var$_default(context) {
    return new $c83c090d7aba40ae$var$Step(context, 0.5);
}
function $c83c090d7aba40ae$var$stepBefore(context) {
    return new $c83c090d7aba40ae$var$Step(context, 0);
}
function $c83c090d7aba40ae$var$stepAfter(context) {
    return new $c83c090d7aba40ae$var$Step(context, 1);
}

});

parcelRequire.register("10FpT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0bc5eafd8e57918e$var$_default;

var $0bc5eafd8e57918e$var$_array = $0bc5eafd8e57918e$var$_interopRequireDefault((parcelRequire("1Joyq")));

var $0bc5eafd8e57918e$var$_constant = $0bc5eafd8e57918e$var$_interopRequireDefault((parcelRequire("8jJxm")));

var $0bc5eafd8e57918e$var$_none = $0bc5eafd8e57918e$var$_interopRequireDefault((parcelRequire("boWNO")));

var $0bc5eafd8e57918e$var$_none2 = $0bc5eafd8e57918e$var$_interopRequireDefault((parcelRequire("kymiB")));
function $0bc5eafd8e57918e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0bc5eafd8e57918e$var$stackValue(d, key) {
    return d[key];
}
function $0bc5eafd8e57918e$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $0bc5eafd8e57918e$var$_default() {
    var keys = (0, $0bc5eafd8e57918e$var$_constant.default)([]), order = $0bc5eafd8e57918e$var$_none2.default, offset = $0bc5eafd8e57918e$var$_none.default, value = $0bc5eafd8e57918e$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $0bc5eafd8e57918e$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $0bc5eafd8e57918e$var$_array.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $0bc5eafd8e57918e$var$_constant.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $0bc5eafd8e57918e$var$_constant.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? $0bc5eafd8e57918e$var$_none2.default : typeof _ === "function" ? _ : (0, $0bc5eafd8e57918e$var$_constant.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? $0bc5eafd8e57918e$var$_none.default : _, stack) : offset;
    };
    return stack;
}

});
parcelRequire.register("boWNO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $84cf8c88b974edba$var$_default;
function $84cf8c88b974edba$var$_default(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRequire.register("kymiB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ef6847c538260f10$var$_default;
function $ef6847c538260f10$var$_default(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRequire.register("2fNxx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1a4369187fee9a84$var$_default;

var $1a4369187fee9a84$var$_none = $1a4369187fee9a84$var$_interopRequireDefault((parcelRequire("boWNO")));
function $1a4369187fee9a84$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1a4369187fee9a84$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $1a4369187fee9a84$var$_none.default)(series, order);
}

});

parcelRequire.register("6a5UN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $47c843dc0711c2e3$var$_default;
function $47c843dc0711c2e3$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

});

parcelRequire.register("9ehm8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6b82e262e5b77959$var$_default;

var $6b82e262e5b77959$var$_none = $6b82e262e5b77959$var$_interopRequireDefault((parcelRequire("boWNO")));
function $6b82e262e5b77959$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6b82e262e5b77959$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $6b82e262e5b77959$var$_none.default)(series, order);
}

});

parcelRequire.register("306kH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $22f648bcd88c806c$var$_default;

var $22f648bcd88c806c$var$_none = $22f648bcd88c806c$var$_interopRequireDefault((parcelRequire("boWNO")));
function $22f648bcd88c806c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $22f648bcd88c806c$var$_default(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $22f648bcd88c806c$var$_none.default)(series, order);
}

});

parcelRequire.register("f5Lyt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $afcc3618ba3d6d0a$var$_default;

var $afcc3618ba3d6d0a$var$_none = $afcc3618ba3d6d0a$var$_interopRequireDefault((parcelRequire("kymiB")));
function $afcc3618ba3d6d0a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $afcc3618ba3d6d0a$var$_default(series) {
    var peaks = series.map($afcc3618ba3d6d0a$var$peak);
    return (0, $afcc3618ba3d6d0a$var$_none.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $afcc3618ba3d6d0a$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

});

parcelRequire.register("ffEmz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b1a790f74abf04ef$var$_default;
module.exports.sum = $b1a790f74abf04ef$var$sum;

var $b1a790f74abf04ef$var$_none = $b1a790f74abf04ef$var$_interopRequireDefault((parcelRequire("kymiB")));
function $b1a790f74abf04ef$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b1a790f74abf04ef$var$_default(series) {
    var sums = series.map($b1a790f74abf04ef$var$sum);
    return (0, $b1a790f74abf04ef$var$_none.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $b1a790f74abf04ef$var$sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});

parcelRequire.register("aQPCV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7e66cebbcfb08699$var$_default;

var $7e66cebbcfb08699$var$_ascending = $7e66cebbcfb08699$var$_interopRequireDefault((parcelRequire("ffEmz")));
function $7e66cebbcfb08699$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7e66cebbcfb08699$var$_default(series) {
    return (0, $7e66cebbcfb08699$var$_ascending.default)(series).reverse();
}

});

parcelRequire.register("4aPb6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $309fcb837cf8d70d$var$_default;

var $309fcb837cf8d70d$var$_appearance = $309fcb837cf8d70d$var$_interopRequireDefault((parcelRequire("f5Lyt")));

var $ffEmz = parcelRequire("ffEmz");
function $309fcb837cf8d70d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $309fcb837cf8d70d$var$_default(series) {
    var n = series.length, i, j, sums = series.map($ffEmz.sum), order = (0, $309fcb837cf8d70d$var$_appearance.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});

parcelRequire.register("4uoTs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $344d46126eba1748$var$_default;

var $344d46126eba1748$var$_none = $344d46126eba1748$var$_interopRequireDefault((parcelRequire("kymiB")));
function $344d46126eba1748$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $344d46126eba1748$var$_default(series) {
    return (0, $344d46126eba1748$var$_none.default)(series).reverse();
}

});



parcelRequire.register("9E7Nf", function(module, exports) {
// `victory-vendor/d3-ease` (CommonJS)
// See upstream license: https://github.com/d3/d3-ease/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-ease`

module.exports = (parcelRequire("4lL52"));

});
parcelRequire.register("4lL52", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "easeBack", {
    enumerable: true,
    get: function() {
        return $b90NK.backInOut;
    }
});
Object.defineProperty(module.exports, "easeBackIn", {
    enumerable: true,
    get: function() {
        return $b90NK.backIn;
    }
});
Object.defineProperty(module.exports, "easeBackInOut", {
    enumerable: true,
    get: function() {
        return $b90NK.backInOut;
    }
});
Object.defineProperty(module.exports, "easeBackOut", {
    enumerable: true,
    get: function() {
        return $b90NK.backOut;
    }
});
Object.defineProperty(module.exports, "easeBounce", {
    enumerable: true,
    get: function() {
        return $cWYp2.bounceOut;
    }
});
Object.defineProperty(module.exports, "easeBounceIn", {
    enumerable: true,
    get: function() {
        return $cWYp2.bounceIn;
    }
});
Object.defineProperty(module.exports, "easeBounceInOut", {
    enumerable: true,
    get: function() {
        return $cWYp2.bounceInOut;
    }
});
Object.defineProperty(module.exports, "easeBounceOut", {
    enumerable: true,
    get: function() {
        return $cWYp2.bounceOut;
    }
});
Object.defineProperty(module.exports, "easeCircle", {
    enumerable: true,
    get: function() {
        return $atIap.circleInOut;
    }
});
Object.defineProperty(module.exports, "easeCircleIn", {
    enumerable: true,
    get: function() {
        return $atIap.circleIn;
    }
});
Object.defineProperty(module.exports, "easeCircleInOut", {
    enumerable: true,
    get: function() {
        return $atIap.circleInOut;
    }
});
Object.defineProperty(module.exports, "easeCircleOut", {
    enumerable: true,
    get: function() {
        return $atIap.circleOut;
    }
});
Object.defineProperty(module.exports, "easeCubic", {
    enumerable: true,
    get: function() {
        return $7xAAe.cubicInOut;
    }
});
Object.defineProperty(module.exports, "easeCubicIn", {
    enumerable: true,
    get: function() {
        return $7xAAe.cubicIn;
    }
});
Object.defineProperty(module.exports, "easeCubicInOut", {
    enumerable: true,
    get: function() {
        return $7xAAe.cubicInOut;
    }
});
Object.defineProperty(module.exports, "easeCubicOut", {
    enumerable: true,
    get: function() {
        return $7xAAe.cubicOut;
    }
});
Object.defineProperty(module.exports, "easeElastic", {
    enumerable: true,
    get: function() {
        return $lQwcB.elasticOut;
    }
});
Object.defineProperty(module.exports, "easeElasticIn", {
    enumerable: true,
    get: function() {
        return $lQwcB.elasticIn;
    }
});
Object.defineProperty(module.exports, "easeElasticInOut", {
    enumerable: true,
    get: function() {
        return $lQwcB.elasticInOut;
    }
});
Object.defineProperty(module.exports, "easeElasticOut", {
    enumerable: true,
    get: function() {
        return $lQwcB.elasticOut;
    }
});
Object.defineProperty(module.exports, "easeExp", {
    enumerable: true,
    get: function() {
        return $kpVwj.expInOut;
    }
});
Object.defineProperty(module.exports, "easeExpIn", {
    enumerable: true,
    get: function() {
        return $kpVwj.expIn;
    }
});
Object.defineProperty(module.exports, "easeExpInOut", {
    enumerable: true,
    get: function() {
        return $kpVwj.expInOut;
    }
});
Object.defineProperty(module.exports, "easeExpOut", {
    enumerable: true,
    get: function() {
        return $kpVwj.expOut;
    }
});
Object.defineProperty(module.exports, "easeLinear", {
    enumerable: true,
    get: function() {
        return $1l5u9.linear;
    }
});
Object.defineProperty(module.exports, "easePoly", {
    enumerable: true,
    get: function() {
        return $bur1V.polyInOut;
    }
});
Object.defineProperty(module.exports, "easePolyIn", {
    enumerable: true,
    get: function() {
        return $bur1V.polyIn;
    }
});
Object.defineProperty(module.exports, "easePolyInOut", {
    enumerable: true,
    get: function() {
        return $bur1V.polyInOut;
    }
});
Object.defineProperty(module.exports, "easePolyOut", {
    enumerable: true,
    get: function() {
        return $bur1V.polyOut;
    }
});
Object.defineProperty(module.exports, "easeQuad", {
    enumerable: true,
    get: function() {
        return $bLZSO.quadInOut;
    }
});
Object.defineProperty(module.exports, "easeQuadIn", {
    enumerable: true,
    get: function() {
        return $bLZSO.quadIn;
    }
});
Object.defineProperty(module.exports, "easeQuadInOut", {
    enumerable: true,
    get: function() {
        return $bLZSO.quadInOut;
    }
});
Object.defineProperty(module.exports, "easeQuadOut", {
    enumerable: true,
    get: function() {
        return $bLZSO.quadOut;
    }
});
Object.defineProperty(module.exports, "easeSin", {
    enumerable: true,
    get: function() {
        return $3EdQ6.sinInOut;
    }
});
Object.defineProperty(module.exports, "easeSinIn", {
    enumerable: true,
    get: function() {
        return $3EdQ6.sinIn;
    }
});
Object.defineProperty(module.exports, "easeSinInOut", {
    enumerable: true,
    get: function() {
        return $3EdQ6.sinInOut;
    }
});
Object.defineProperty(module.exports, "easeSinOut", {
    enumerable: true,
    get: function() {
        return $3EdQ6.sinOut;
    }
});

var $1l5u9 = parcelRequire("1l5u9");

var $bLZSO = parcelRequire("bLZSO");

var $7xAAe = parcelRequire("7xAAe");

var $bur1V = parcelRequire("bur1V");

var $3EdQ6 = parcelRequire("3EdQ6");

var $kpVwj = parcelRequire("kpVwj");

var $atIap = parcelRequire("atIap");

var $cWYp2 = parcelRequire("cWYp2");

var $b90NK = parcelRequire("b90NK");

var $lQwcB = parcelRequire("lQwcB");

});
parcelRequire.register("1l5u9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.linear = void 0;
const $0f9c01e6d2265209$var$linear = (t)=>+t;
module.exports.linear = $0f9c01e6d2265209$var$linear;

});

parcelRequire.register("bLZSO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.quadIn = $892416301ad81157$var$quadIn;
module.exports.quadInOut = $892416301ad81157$var$quadInOut;
module.exports.quadOut = $892416301ad81157$var$quadOut;
function $892416301ad81157$var$quadIn(t) {
    return t * t;
}
function $892416301ad81157$var$quadOut(t) {
    return t * (2 - t);
}
function $892416301ad81157$var$quadInOut(t) {
    return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}

});

parcelRequire.register("7xAAe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cubicIn = $57d7fe2a05d9abe4$var$cubicIn;
module.exports.cubicInOut = $57d7fe2a05d9abe4$var$cubicInOut;
module.exports.cubicOut = $57d7fe2a05d9abe4$var$cubicOut;
function $57d7fe2a05d9abe4$var$cubicIn(t) {
    return t * t * t;
}
function $57d7fe2a05d9abe4$var$cubicOut(t) {
    return --t * t * t + 1;
}
function $57d7fe2a05d9abe4$var$cubicInOut(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

});

parcelRequire.register("bur1V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.polyOut = module.exports.polyInOut = module.exports.polyIn = void 0;
var $85d776a53648a131$var$exponent = 3;
var $85d776a53648a131$var$polyIn = function custom(e) {
    e = +e;
    function polyIn(t) {
        return Math.pow(t, e);
    }
    polyIn.exponent = custom;
    return polyIn;
}($85d776a53648a131$var$exponent);
module.exports.polyIn = $85d776a53648a131$var$polyIn;
var $85d776a53648a131$var$polyOut = function custom(e) {
    e = +e;
    function polyOut(t) {
        return 1 - Math.pow(1 - t, e);
    }
    polyOut.exponent = custom;
    return polyOut;
}($85d776a53648a131$var$exponent);
module.exports.polyOut = $85d776a53648a131$var$polyOut;
var $85d776a53648a131$var$polyInOut = function custom(e) {
    e = +e;
    function polyInOut(t) {
        return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
    }
    polyInOut.exponent = custom;
    return polyInOut;
}($85d776a53648a131$var$exponent);
module.exports.polyInOut = $85d776a53648a131$var$polyInOut;

});

parcelRequire.register("3EdQ6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sinIn = $2a7fd7b9b8883c76$var$sinIn;
module.exports.sinInOut = $2a7fd7b9b8883c76$var$sinInOut;
module.exports.sinOut = $2a7fd7b9b8883c76$var$sinOut;
var $2a7fd7b9b8883c76$var$pi = Math.PI, $2a7fd7b9b8883c76$var$halfPi = $2a7fd7b9b8883c76$var$pi / 2;
function $2a7fd7b9b8883c76$var$sinIn(t) {
    return +t === 1 ? 1 : 1 - Math.cos(t * $2a7fd7b9b8883c76$var$halfPi);
}
function $2a7fd7b9b8883c76$var$sinOut(t) {
    return Math.sin(t * $2a7fd7b9b8883c76$var$halfPi);
}
function $2a7fd7b9b8883c76$var$sinInOut(t) {
    return (1 - Math.cos($2a7fd7b9b8883c76$var$pi * t)) / 2;
}

});

parcelRequire.register("kpVwj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.expIn = $edd2c2c402bcfbc4$var$expIn;
module.exports.expInOut = $edd2c2c402bcfbc4$var$expInOut;
module.exports.expOut = $edd2c2c402bcfbc4$var$expOut;

var $awUBX = parcelRequire("awUBX");
function $edd2c2c402bcfbc4$var$expIn(t) {
    return (0, $awUBX.tpmt)(1 - +t);
}
function $edd2c2c402bcfbc4$var$expOut(t) {
    return 1 - (0, $awUBX.tpmt)(t);
}
function $edd2c2c402bcfbc4$var$expInOut(t) {
    return ((t *= 2) <= 1 ? (0, $awUBX.tpmt)(1 - t) : 2 - (0, $awUBX.tpmt)(t - 1)) / 2;
}

});
parcelRequire.register("awUBX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tpmt = $7aa8ce5f7e515913$var$tpmt;
// tpmt is two power minus ten times t scaled to [0,1]
function $7aa8ce5f7e515913$var$tpmt(x) {
    return (Math.pow(2, -10 * x) - 0.0009765625) * 1.0009775171065494;
}

});


parcelRequire.register("atIap", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.circleIn = $7a0edf6d572fe11c$var$circleIn;
module.exports.circleInOut = $7a0edf6d572fe11c$var$circleInOut;
module.exports.circleOut = $7a0edf6d572fe11c$var$circleOut;
function $7a0edf6d572fe11c$var$circleIn(t) {
    return 1 - Math.sqrt(1 - t * t);
}
function $7a0edf6d572fe11c$var$circleOut(t) {
    return Math.sqrt(1 - --t * t);
}
function $7a0edf6d572fe11c$var$circleInOut(t) {
    return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}

});

parcelRequire.register("cWYp2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bounceIn = $96d9c18cd2c7bc85$var$bounceIn;
module.exports.bounceInOut = $96d9c18cd2c7bc85$var$bounceInOut;
module.exports.bounceOut = $96d9c18cd2c7bc85$var$bounceOut;
var $96d9c18cd2c7bc85$var$b1 = 4 / 11, $96d9c18cd2c7bc85$var$b2 = 6 / 11, $96d9c18cd2c7bc85$var$b3 = 8 / 11, $96d9c18cd2c7bc85$var$b4 = 3 / 4, $96d9c18cd2c7bc85$var$b5 = 9 / 11, $96d9c18cd2c7bc85$var$b6 = 10 / 11, $96d9c18cd2c7bc85$var$b7 = 15 / 16, $96d9c18cd2c7bc85$var$b8 = 21 / 22, $96d9c18cd2c7bc85$var$b9 = 63 / 64, $96d9c18cd2c7bc85$var$b0 = 1 / $96d9c18cd2c7bc85$var$b1 / $96d9c18cd2c7bc85$var$b1;
function $96d9c18cd2c7bc85$var$bounceIn(t) {
    return 1 - $96d9c18cd2c7bc85$var$bounceOut(1 - t);
}
function $96d9c18cd2c7bc85$var$bounceOut(t) {
    return (t = +t) < $96d9c18cd2c7bc85$var$b1 ? $96d9c18cd2c7bc85$var$b0 * t * t : t < $96d9c18cd2c7bc85$var$b3 ? $96d9c18cd2c7bc85$var$b0 * (t -= $96d9c18cd2c7bc85$var$b2) * t + $96d9c18cd2c7bc85$var$b4 : t < $96d9c18cd2c7bc85$var$b6 ? $96d9c18cd2c7bc85$var$b0 * (t -= $96d9c18cd2c7bc85$var$b5) * t + $96d9c18cd2c7bc85$var$b7 : $96d9c18cd2c7bc85$var$b0 * (t -= $96d9c18cd2c7bc85$var$b8) * t + $96d9c18cd2c7bc85$var$b9;
}
function $96d9c18cd2c7bc85$var$bounceInOut(t) {
    return ((t *= 2) <= 1 ? 1 - $96d9c18cd2c7bc85$var$bounceOut(1 - t) : $96d9c18cd2c7bc85$var$bounceOut(t - 1) + 1) / 2;
}

});

parcelRequire.register("b90NK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.backOut = module.exports.backInOut = module.exports.backIn = void 0;
var $81d1281edbf77b5d$var$overshoot = 1.70158;
var $81d1281edbf77b5d$var$backIn = function custom(s) {
    s = +s;
    function backIn(t) {
        return (t = +t) * t * (s * (t - 1) + t);
    }
    backIn.overshoot = custom;
    return backIn;
}($81d1281edbf77b5d$var$overshoot);
module.exports.backIn = $81d1281edbf77b5d$var$backIn;
var $81d1281edbf77b5d$var$backOut = function custom(s) {
    s = +s;
    function backOut(t) {
        return --t * t * ((t + 1) * s + t) + 1;
    }
    backOut.overshoot = custom;
    return backOut;
}($81d1281edbf77b5d$var$overshoot);
module.exports.backOut = $81d1281edbf77b5d$var$backOut;
var $81d1281edbf77b5d$var$backInOut = function custom(s) {
    s = +s;
    function backInOut(t) {
        return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
    }
    backInOut.overshoot = custom;
    return backInOut;
}($81d1281edbf77b5d$var$overshoot);
module.exports.backInOut = $81d1281edbf77b5d$var$backInOut;

});

parcelRequire.register("lQwcB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.elasticOut = module.exports.elasticInOut = module.exports.elasticIn = void 0;

var $awUBX = parcelRequire("awUBX");
var $fe776efd26d2983d$var$tau = 2 * Math.PI, $fe776efd26d2983d$var$amplitude = 1, $fe776efd26d2983d$var$period = 0.3;
var $fe776efd26d2983d$var$elasticIn = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= $fe776efd26d2983d$var$tau);
    function elasticIn(t) {
        return a * (0, $awUBX.tpmt)(- --t) * Math.sin((s - t) / p);
    }
    elasticIn.amplitude = function(a) {
        return custom(a, p * $fe776efd26d2983d$var$tau);
    };
    elasticIn.period = function(p) {
        return custom(a, p);
    };
    return elasticIn;
}($fe776efd26d2983d$var$amplitude, $fe776efd26d2983d$var$period);
module.exports.elasticIn = $fe776efd26d2983d$var$elasticIn;
var $fe776efd26d2983d$var$elasticOut = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= $fe776efd26d2983d$var$tau);
    function elasticOut(t) {
        return 1 - a * (0, $awUBX.tpmt)(t = +t) * Math.sin((t + s) / p);
    }
    elasticOut.amplitude = function(a) {
        return custom(a, p * $fe776efd26d2983d$var$tau);
    };
    elasticOut.period = function(p) {
        return custom(a, p);
    };
    return elasticOut;
}($fe776efd26d2983d$var$amplitude, $fe776efd26d2983d$var$period);
module.exports.elasticOut = $fe776efd26d2983d$var$elasticOut;
var $fe776efd26d2983d$var$elasticInOut = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= $fe776efd26d2983d$var$tau);
    function elasticInOut(t) {
        return ((t = t * 2 - 1) < 0 ? a * (0, $awUBX.tpmt)(-t) * Math.sin((s - t) / p) : 2 - a * (0, $awUBX.tpmt)(t) * Math.sin((s + t) / p)) / 2;
    }
    elasticInOut.amplitude = function(a) {
        return custom(a, p * $fe776efd26d2983d$var$tau);
    };
    elasticInOut.period = function(p) {
        return custom(a, p);
    };
    return elasticInOut;
}($fe776efd26d2983d$var$amplitude, $fe776efd26d2983d$var$period);
module.exports.elasticInOut = $fe776efd26d2983d$var$elasticInOut;

});



parcelRequire.register("dup5t", function(module, exports) {
// `victory-vendor/d3-interpolate` (CommonJS)
// See upstream license: https://github.com/d3/d3-interpolate/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-interpolate`

module.exports = (parcelRequire("asL1O"));

});

parcelRequire.register("iCY1N", function(module, exports) {
// `victory-vendor/d3-timer` (CommonJS)
// See upstream license: https://github.com/d3/d3-timer/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-timer`

module.exports = (parcelRequire("gZFvD"));

});
parcelRequire.register("gZFvD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "interval", {
    enumerable: true,
    get: function() {
        return $c5f28ab7e8f83d06$var$_interval.default;
    }
});
Object.defineProperty(module.exports, "now", {
    enumerable: true,
    get: function() {
        return $jgBKf.now;
    }
});
Object.defineProperty(module.exports, "timeout", {
    enumerable: true,
    get: function() {
        return $c5f28ab7e8f83d06$var$_timeout.default;
    }
});
Object.defineProperty(module.exports, "timer", {
    enumerable: true,
    get: function() {
        return $jgBKf.timer;
    }
});
Object.defineProperty(module.exports, "timerFlush", {
    enumerable: true,
    get: function() {
        return $jgBKf.timerFlush;
    }
});

var $jgBKf = parcelRequire("jgBKf");

var $c5f28ab7e8f83d06$var$_timeout = $c5f28ab7e8f83d06$var$_interopRequireDefault((parcelRequire("ff1b1")));

var $c5f28ab7e8f83d06$var$_interval = $c5f28ab7e8f83d06$var$_interopRequireDefault((parcelRequire("2dSBH")));
function $c5f28ab7e8f83d06$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRequire.register("jgBKf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Timer = $e06cca534f2049fc$var$Timer;
module.exports.now = $e06cca534f2049fc$var$now;
module.exports.timer = $e06cca534f2049fc$var$timer;
module.exports.timerFlush = $e06cca534f2049fc$var$timerFlush;
var $e06cca534f2049fc$var$frame = 0, // is an animation frame pending?
$e06cca534f2049fc$var$timeout = 0, // is a timeout pending?
$e06cca534f2049fc$var$interval = 0, // are any timers active?
$e06cca534f2049fc$var$pokeDelay = 1000, // how frequently we check for clock skew
$e06cca534f2049fc$var$taskHead, $e06cca534f2049fc$var$taskTail, $e06cca534f2049fc$var$clockLast = 0, $e06cca534f2049fc$var$clockNow = 0, $e06cca534f2049fc$var$clockSkew = 0, $e06cca534f2049fc$var$clock = typeof performance === "object" && performance.now ? performance : Date, $e06cca534f2049fc$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $e06cca534f2049fc$var$now() {
    return $e06cca534f2049fc$var$clockNow || ($e06cca534f2049fc$var$setFrame($e06cca534f2049fc$var$clearNow), $e06cca534f2049fc$var$clockNow = $e06cca534f2049fc$var$clock.now() + $e06cca534f2049fc$var$clockSkew);
}
function $e06cca534f2049fc$var$clearNow() {
    $e06cca534f2049fc$var$clockNow = 0;
}
function $e06cca534f2049fc$var$Timer() {
    this._call = this._time = this._next = null;
}
$e06cca534f2049fc$var$Timer.prototype = $e06cca534f2049fc$var$timer.prototype = {
    constructor: $e06cca534f2049fc$var$Timer,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $e06cca534f2049fc$var$now() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $e06cca534f2049fc$var$taskTail !== this) {
            if ($e06cca534f2049fc$var$taskTail) $e06cca534f2049fc$var$taskTail._next = this;
            else $e06cca534f2049fc$var$taskHead = this;
            $e06cca534f2049fc$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $e06cca534f2049fc$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $e06cca534f2049fc$var$sleep();
        }
    }
};
function $e06cca534f2049fc$var$timer(callback, delay, time) {
    var t = new $e06cca534f2049fc$var$Timer();
    t.restart(callback, delay, time);
    return t;
}
function $e06cca534f2049fc$var$timerFlush() {
    $e06cca534f2049fc$var$now(); // Get the current time, if not already set.
    ++$e06cca534f2049fc$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $e06cca534f2049fc$var$taskHead, e;
    while(t){
        if ((e = $e06cca534f2049fc$var$clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --$e06cca534f2049fc$var$frame;
}
function $e06cca534f2049fc$var$wake() {
    $e06cca534f2049fc$var$clockNow = ($e06cca534f2049fc$var$clockLast = $e06cca534f2049fc$var$clock.now()) + $e06cca534f2049fc$var$clockSkew;
    $e06cca534f2049fc$var$frame = $e06cca534f2049fc$var$timeout = 0;
    try {
        $e06cca534f2049fc$var$timerFlush();
    } finally{
        $e06cca534f2049fc$var$frame = 0;
        $e06cca534f2049fc$var$nap();
        $e06cca534f2049fc$var$clockNow = 0;
    }
}
function $e06cca534f2049fc$var$poke() {
    var now = $e06cca534f2049fc$var$clock.now(), delay = now - $e06cca534f2049fc$var$clockLast;
    if (delay > $e06cca534f2049fc$var$pokeDelay) $e06cca534f2049fc$var$clockSkew -= delay, $e06cca534f2049fc$var$clockLast = now;
}
function $e06cca534f2049fc$var$nap() {
    var t0, t1 = $e06cca534f2049fc$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $e06cca534f2049fc$var$taskHead = t2;
    }
    $e06cca534f2049fc$var$taskTail = t0;
    $e06cca534f2049fc$var$sleep(time);
}
function $e06cca534f2049fc$var$sleep(time) {
    if ($e06cca534f2049fc$var$frame) return; // Soonest alarm already set, or will be.
    if ($e06cca534f2049fc$var$timeout) $e06cca534f2049fc$var$timeout = clearTimeout($e06cca534f2049fc$var$timeout);
    var delay = time - $e06cca534f2049fc$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $e06cca534f2049fc$var$timeout = setTimeout($e06cca534f2049fc$var$wake, time - $e06cca534f2049fc$var$clock.now() - $e06cca534f2049fc$var$clockSkew);
        if ($e06cca534f2049fc$var$interval) $e06cca534f2049fc$var$interval = clearInterval($e06cca534f2049fc$var$interval);
    } else {
        if (!$e06cca534f2049fc$var$interval) $e06cca534f2049fc$var$clockLast = $e06cca534f2049fc$var$clock.now(), $e06cca534f2049fc$var$interval = setInterval($e06cca534f2049fc$var$poke, $e06cca534f2049fc$var$pokeDelay);
        $e06cca534f2049fc$var$frame = 1, $e06cca534f2049fc$var$setFrame($e06cca534f2049fc$var$wake);
    }
}

});

parcelRequire.register("ff1b1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b1892b6f1bb8e061$var$_default;

var $jgBKf = parcelRequire("jgBKf");
function $b1892b6f1bb8e061$var$_default(callback, delay, time) {
    var t = new $jgBKf.Timer();
    delay = delay == null ? 0 : +delay;
    t.restart((elapsed)=>{
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}

});

parcelRequire.register("2dSBH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $19e7278200e39dde$var$_default;

var $jgBKf = parcelRequire("jgBKf");
function $19e7278200e39dde$var$_default(callback, delay, time) {
    var t = new $jgBKf.Timer(), total = delay;
    if (delay == null) return t.restart(callback, delay, time), t;
    t._restart = t.restart;
    t.restart = function(callback, delay, time) {
        delay = +delay, time = time == null ? (0, $jgBKf.now)() : +time;
        t._restart(function tick(elapsed) {
            elapsed += total;
            t._restart(tick, total += delay, time);
            callback(elapsed);
        }, delay, time);
    };
    t.restart(callback, delay, time);
    return t;
}

});



parcelRequire.register("8VBTQ", function(module, exports) {
exports = module.exports = stringify;
exports.getSerialize = serializer;
function stringify(obj, replacer, spaces, cycleReplacer) {
    return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
}
function serializer(replacer, cycleReplacer) {
    var stack = [], keys = [];
    if (cycleReplacer == null) cycleReplacer = function(key, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value);
        } else stack.push(value);
        return replacer == null ? value : replacer.call(this, key, value);
    };
}

});

var $e9bc3aadba8432ee$exports = {};
"use strict";

$e9bc3aadba8432ee$exports = (parcelRequire("eN4lT"));


// Regex for identifying class names in CSS selectors
//
// REF: https://www.w3.org/TR/selectors-3/#lex
const $79a9f4a27a5785fc$var$CLASS_IDENT_REGEX = /\.-?(?:[_a-z]|[^\0-\x7f]|\\[0-9a-f]{1,6}\s?|\\[^\s0-9a-f])(?:[_a-z0-9-]|[^\0-\x7f]|\\[0-9a-f]{1,6}\s?|\\[^\s0-9a-f])*/gi;
function $79a9f4a27a5785fc$export$8bd7b5e91f1302e8(rule) {
    return (rule?.cssRules?.length ?? 0) > 0;
}
function $79a9f4a27a5785fc$export$420f30688de25102(rule) {
    return rule && "selectorText" in rule;
}
function $79a9f4a27a5785fc$export$45a5e7f76e0caa8d(el) {
    return el?.nodeType === 1;
}
function $79a9f4a27a5785fc$export$a8faa48da8fdb1ce(el) {
    return el.nodeName === "LINK" && el.tagName?.toLowerCase() === "link";
}
function $79a9f4a27a5785fc$export$77ba3b159735e900(sel) {
    const classnames = new Set();
    const matches = sel.match($79a9f4a27a5785fc$var$CLASS_IDENT_REGEX);
    if (matches) for (let cl of matches){
        // Strip '.'
        cl = cl.substring(1);
        // Unescape numeric escape sequences (\###)
        cl = cl.replaceAll(/\\[0-9a-f]{1,6}\s?/gi, (escape)=>{
            return String.fromCodePoint(parseInt(escape.substring(1), 16));
        });
        // Unescape character escape sequences (\[some char])
        cl = cl.replaceAll(/\\[^\s0-9a-f]/g, (c)=>c.substring(1));
        classnames.add(cl);
    }
    return classnames;
}


var $f618023073b7010a$export$7fd9d5d533532f41;
(function(ClassnameStatus) {
    ClassnameStatus[ClassnameStatus["DETECTED"] = 0] = "DETECTED";
    ClassnameStatus[ClassnameStatus["IGNORED"] = 1] = "IGNORED";
    ClassnameStatus[ClassnameStatus["EMITTED"] = 2] = "EMITTED";
    ClassnameStatus[ClassnameStatus["DEFINED"] = 3] = "DEFINED";
})($f618023073b7010a$export$7fd9d5d533532f41 || ($f618023073b7010a$export$7fd9d5d533532f41 = {}));
class $f618023073b7010a$export$828abbd689d9a96 {
    // Classnames defined in stylesheets
    #classnames = new Map();
    // # of external stylesheets that actively loading.
    #pending = 0;
    // Default root element to scan for classnames
    #documentElement;
    #observer;
    #watch = false;
    // Check timer
    #timer;
    // Map that tracks the number of rules found in STYLE elements
    #seenStylesheets = new WeakMap();
    // Hook for filtering classnames in DOM. This is called whenever a new
    // classname is detected in the DOM. Callback should return true to indicate
    // the class should be checked, false to ignore.
    onClassnameDetected;
    // Callback when undefined classname is detected (defaults to console.log())
    onUndefinedClassname(classname) {
        console.log(`%ccheckcss%c: No CSS rule for %c.${classname}`, "color: darkorange", "", "font-weight: bold", this.#documentElement.querySelectorAll(`.${CSS.escape(classname)}`));
    }
    constructor(document1 = window.document){
        this.#documentElement = document1.documentElement;
    }
    #check(delay = 0) {
        // Defer check until all LINK stylesheets have loaded
        if (this.#pending > 0) delay = 3000;
        // Clear timer
        clearTimeout(this.#timer);
        this.#timer = undefined;
        // Defer if requested
        if (delay > 0) {
            this.#timer = setTimeout(()=>this.#check(0), delay);
            return;
        }
        // Scan LINK[rel="stylesheet"] elements we haven't seen yet
        const styleLinks = this.#documentElement.querySelectorAll('link[rel="stylesheet"]');
        for (const styleLink of styleLinks){
            if (styleLink.dataset.ccScanned !== undefined) continue;
            styleLink.dataset.ccScanned = ""; // Set attribute
            this.#processStylesheet(styleLink);
        }
        // Scan STYLE elements we haven't seen yet, or that might have changed
        const styleElements = this.#documentElement.querySelectorAll("style");
        for (const styleElement of styleElements){
            const { sheet: sheet  } = styleElement;
            if (!sheet) continue;
            const rules = sheet.cssRules;
            // Skip style elements we've seen before.  This is complicated by how
            // STYLE elements can be dynamically modified, in one of two ways:
            //
            // 1. Setting `styleElement.textContent`, which blows away the
            //    `styleElement.sheet`
            // 2. Methods like `sheet#insertRule()` and `sheet#replace()`
            //
            // However none of these trigger DOM mutation events, so we have to resort
            // to the crude logic here to see if anythings change.  While this logic
            // isn't perfect, it's reasonably performant and good enough for most
            // purposes.
            const expectedLength = this.#seenStylesheets.get(rules) ?? 0;
            const actualLength = rules.length;
            if (expectedLength === actualLength) continue;
            this.#seenStylesheets.set(rules, actualLength);
            this.#processStylesheet(styleElement);
        }
        for (const [classname, status] of this.#classnames)if (status == $f618023073b7010a$export$7fd9d5d533532f41.DETECTED) {
            this.#classnames.set(classname, $f618023073b7010a$export$7fd9d5d533532f41.EMITTED);
            this.onUndefinedClassname?.(classname);
        }
        // Repeat as long as we're in watch mode
        if (this.#watch) this.#check(5000);
    }
    #processElement(el, includeChildren = true) {
        // Skip non-Element nodes
        if (el.nodeType !== 1) return;
        // Detect styles referenced in "class" attribute
        for (const n of el.classList){
            if (this.#classnames.has(n)) continue;
            if (this.onClassnameDetected?.(n, el) === false) this.#classnames.set(n, $f618023073b7010a$export$7fd9d5d533532f41.IGNORED);
            else this.#classnames.set(n, $f618023073b7010a$export$7fd9d5d533532f41.DETECTED);
        }
        // Recurse into children(?)
        if (includeChildren) for (const cel of el.querySelectorAll("*"))this.#processElement(cel, false);
    }
    #processStylesheet(sheet) {
        let rules;
        try {
            rules = (0, $79a9f4a27a5785fc$export$8bd7b5e91f1302e8)(sheet) ? sheet?.cssRules : sheet.sheet?.cssRules;
        } catch (e) {
            if (!(e instanceof Error)) throw e;
            if (e.name === "SecurityError") console.log("%ccheckcss:", "color: darkorange", "Inaccessible stylesheet may contain classes reported as undefined.  Use `onClassnameDetected` to ignore erroneously reported classes.", sheet);
            else {
                e.message += "\n\n(Please report this error to https://github.com/broofa/checkcss/issues)";
                throw e;
            }
        }
        if (!rules) return;
        for (const rule of rules){
            if ((0, $79a9f4a27a5785fc$export$8bd7b5e91f1302e8)(rule)) // Recurse into grouping rules (e.g. CSSMediaRule)
            this.#processStylesheet(rule);
            else if ((0, $79a9f4a27a5785fc$export$420f30688de25102)(rule)) // Add each classname to the defined set
            for (const classname of (0, $79a9f4a27a5785fc$export$77ba3b159735e900)(rule.selectorText))this.#classnames.set(classname, $f618023073b7010a$export$7fd9d5d533532f41.DEFINED);
        }
    }
    // FOR TESTING ONLY.  This may be removed or changed without warning.
    get _testState() {
        return this.#classnames;
    }
    scan() {
        this.#processElement(this.#documentElement);
        this.#check(100);
        return this;
    }
    watch() {
        this.#watch = true;
        if (this.#observer) return;
        this.#observer = new MutationObserver((mutationsList)=>{
            for (const mut of mutationsList)switch(mut.type){
                case "attributes":
                    this.#processElement(mut.target, false);
                case "childList":
                    for (const el of mut.addedNodes){
                        if (!(0, $79a9f4a27a5785fc$export$45a5e7f76e0caa8d)(el)) continue;
                        this.#processElement(el);
                        // Track LINK elements
                        if ((0, $79a9f4a27a5785fc$export$a8faa48da8fdb1ce)(el)) {
                            if (!el.sheet) {
                                // Style sheet link, but w/out styles (so not yet loaded?),
                                // wait until it's loaded
                                this.#pending++;
                                const loader = ()=>{
                                    el.removeEventListener("load", loader);
                                    el.removeEventListener("error", loader);
                                    this.#pending--;
                                    this.#check();
                                };
                                el.addEventListener("load", loader);
                                el.addEventListener("error", loader);
                            }
                        }
                    }
            }
            // Check for undefined classes if there's no stylesheets loading
            this.#check();
        });
        this.#observer.observe(document, {
            attributes: true,
            attributeFilter: [
                "class"
            ],
            childList: true,
            subtree: true
        });
        return this;
    }
}


let $d8def3b9561fd057$var$ignoreRE;
let $d8def3b9561fd057$var$checkcss;
const $d8def3b9561fd057$var$warned = new Set();
function $d8def3b9561fd057$var$warn(msg) {
    if ($d8def3b9561fd057$var$warned.has(msg)) return;
    $d8def3b9561fd057$var$warned.add(msg);
    console.warn(msg);
}
function $d8def3b9561fd057$export$14f0695981e0a2f0(re) {
    $d8def3b9561fd057$var$warn("ignoreRE is deprecated and will be removed in the next major release. Use CheckCSS#onClassnameDetected instead");
    $d8def3b9561fd057$var$ignoreRE = re;
}
function $d8def3b9561fd057$export$2e2bcd8739ae039() {
    $d8def3b9561fd057$var$warn("checkCSS() is deprecated. Use CheckCSS#scan() instead");
    if (!$d8def3b9561fd057$var$checkcss) {
        $d8def3b9561fd057$var$checkcss = new (0, $f618023073b7010a$export$828abbd689d9a96)(document);
        // Legacy API support for ignoreRE.
        $d8def3b9561fd057$var$checkcss.onClassnameDetected = (classname, el)=>{
            return $d8def3b9561fd057$var$ignoreRE?.test(classname) ?? true;
        };
    }
    $d8def3b9561fd057$var$checkcss.scan();
}
function $d8def3b9561fd057$export$9e44b3ffde2e1d49() {
    $d8def3b9561fd057$var$warn("monitorCSS() is deprecated. Use CheckCSS#watch() instead");
    $d8def3b9561fd057$var$checkcss.watch();
}


parcelRequire("8T3gX");
var $11011d7422997104$export$882461b6382ed46c;
var $11011d7422997104$export$757ceba2d55c277e;
"use strict";
var $680cb73086b60533$exports = {};
"use strict";
function $680cb73086b60533$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($680cb73086b60533$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$680cb73086b60533$var$checkDCE();

$680cb73086b60533$exports = (parcelRequire("WeH8M"));


var $11011d7422997104$var$i;
$11011d7422997104$export$882461b6382ed46c = $680cb73086b60533$exports.createRoot;
$11011d7422997104$export$757ceba2d55c277e = $680cb73086b60533$exports.hydrateRoot;



var $fIsAN = parcelRequire("fIsAN");

parcelRequire("8T3gX");
var $d1aa3e5fa51b632d$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, $d1aa3e5fa51b632d$exports) {
        classNames.default = classNames;
        $d1aa3e5fa51b632d$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $8T3gX = parcelRequire("8T3gX");
function $ab913f14053e1f45$export$2e2bcd8739ae039() {
    $ab913f14053e1f45$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ab913f14053e1f45$export$2e2bcd8739ae039.apply(this, arguments);
}


function $b59d967182239c8b$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var $8T3gX = parcelRequire("8T3gX");
var $e72804049adef0ff$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $e72804049adef0ff$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$e72804049adef0ff$exports = $e72804049adef0ff$var$invariant;


var $1d1e36be054e2a9b$var$noop = function noop() {};
function $1d1e36be054e2a9b$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $1d1e36be054e2a9b$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $1d1e36be054e2a9b$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$1d1e36be054e2a9b$export$26cbf8c37e721e67(prop)] = $1d1e36be054e2a9b$var$noop;
        var handler;
    });
    return propTypes;
}
function $1d1e36be054e2a9b$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $1d1e36be054e2a9b$export$26cbf8c37e721e67(key) {
    return "default" + key.charAt(0).toUpperCase() + key.substr(1);
}
function $1d1e36be054e2a9b$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== "function" || component.prototype && component.prototype.isReactComponent);
}


function $43a5c6b75c3b0a1f$var$_toPropertyKey(arg) {
    var key = $43a5c6b75c3b0a1f$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $43a5c6b75c3b0a1f$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $43a5c6b75c3b0a1f$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $8T3gX.useRef)(propValue !== undefined);
    var _useState = (0, $8T3gX.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $8T3gX.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $43a5c6b75c3b0a1f$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$1d1e36be054e2a9b$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $b59d967182239c8b$export$2e2bcd8739ae039)(_ref, [
            $1d1e36be054e2a9b$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($43a5c6b75c3b0a1f$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $43a5c6b75c3b0a1f$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $ab913f14053e1f45$export$2e2bcd8739ae039)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}




function $eae1023a9d0c6269$export$2e2bcd8739ae039(o, p) {
    $eae1023a9d0c6269$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $eae1023a9d0c6269$export$2e2bcd8739ae039(o, p);
}


function $61fb52508441c2fd$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $eae1023a9d0c6269$export$2e2bcd8739ae039)(subClass, superClass);
}



var $8T3gX = parcelRequire("8T3gX");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $9ff33d5a54088650$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $9ff33d5a54088650$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $9ff33d5a54088650$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$9ff33d5a54088650$var$componentWillMount.__suppressDeprecationWarning = true;
$9ff33d5a54088650$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$9ff33d5a54088650$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $9ff33d5a54088650$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = $9ff33d5a54088650$var$componentWillMount;
        prototype.componentWillReceiveProps = $9ff33d5a54088650$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = $9ff33d5a54088650$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $54d086656e2d7020$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $54d086656e2d7020$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || "Component";
    var canAcceptRef = $1d1e36be054e2a9b$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($1d1e36be054e2a9b$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($e72804049adef0ff$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $61fb52508441c2fd$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $ab913f14053e1f45$export$2e2bcd8739ae039)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$1d1e36be054e2a9b$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $ab913f14053e1f45$export$2e2bcd8739ae039)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$1d1e36be054e2a9b$export$12ae2baa35bd9b8b(props, key) && $1d1e36be054e2a9b$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$1d1e36be054e2a9b$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $b59d967182239c8b$export$2e2bcd8739ae039)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement(Component, (0, $ab913f14053e1f45$export$2e2bcd8739ae039)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Component);
    (0, $9ff33d5a54088650$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $ab913f14053e1f45$export$2e2bcd8739ae039)({
        innerRef: function innerRef() {}
    }, $1d1e36be054e2a9b$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement(UncontrolledComponent, (0, $ab913f14053e1f45$export$2e2bcd8739ae039)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $54d086656e2d7020$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $54d086656e2d7020$export$2e2bcd8739ae039(newComponent, (0, $ab913f14053e1f45$export$2e2bcd8739ae039)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}





var $8T3gX = parcelRequire("8T3gX");

var $8T3gX = parcelRequire("8T3gX");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $0bd4ca3936ccf850$var$useCommittedRef(value) {
    var ref = (0, $8T3gX.useRef)(value);
    (0, $8T3gX.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $0bd4ca3936ccf850$export$2e2bcd8739ae039 = $0bd4ca3936ccf850$var$useCommittedRef;


function $47b6b666cdb493de$export$2e2bcd8739ae039(fn) {
    var ref = (0, $0bd4ca3936ccf850$export$2e2bcd8739ae039)(fn);
    return (0, $8T3gX.useCallback)(function() {
        return ref.current && ref.current.apply(ref, arguments);
    }, [
        ref
    ]);
}



var $8T3gX = parcelRequire("8T3gX");

var $8T3gX = parcelRequire("8T3gX");
function $a20f7a0618b40b39$export$2e2bcd8739ae039() {
    return (0, $8T3gX.useState)(null);
}





var $8T3gX = parcelRequire("8T3gX");

function $df22fcd2694e3548$export$2e2bcd8739ae039(eventTarget, event, listener, capture) {
    if (capture === void 0) capture = false;
    var handler = (0, $47b6b666cdb493de$export$2e2bcd8739ae039)(listener);
    (0, $8T3gX.useEffect)(function() {
        var target = typeof eventTarget === "function" ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return function() {
            return target.removeEventListener(event, handler, capture);
        };
    }, [
        eventTarget
    ]);
}




var $8T3gX = parcelRequire("8T3gX");
function $c32604b402f746f8$export$2e2bcd8739ae039(event, handler, capture) {
    if (capture === void 0) capture = false;
    var documentTarget = (0, $8T3gX.useCallback)(function() {
        return document;
    }, []);
    return (0, $df22fcd2694e3548$export$2e2bcd8739ae039)(documentTarget, event, handler, capture);
}



var $8T3gX = parcelRequire("8T3gX");

/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ function $110e1457a353e2f3$var$useInterval(fn, ms, paused, runImmediately) {
    if (paused === void 0) paused = false;
    if (runImmediately === void 0) runImmediately = false;
    var handle;
    var fnRef = (0, $0bd4ca3936ccf850$export$2e2bcd8739ae039)(fn); // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    var pausedRef = (0, $0bd4ca3936ccf850$export$2e2bcd8739ae039)(paused);
    var tick = function tick() {
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    var schedule = function schedule() {
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $8T3gX.useEffect)(function() {
        if (runImmediately) tick();
        else schedule();
        return function() {
            return clearTimeout(handle);
        };
    }, [
        paused,
        runImmediately
    ]);
}
var $110e1457a353e2f3$export$2e2bcd8739ae039 = $110e1457a353e2f3$var$useInterval;



var $8T3gX = parcelRequire("8T3gX");

function $fa4546647cf9cdbf$var$useRafInterval(fn, ms, paused) {
    if (paused === void 0) paused = false;
    var handle;
    var start = new Date().getTime();
    var fnRef = (0, $0bd4ca3936ccf850$export$2e2bcd8739ae039)(fn); // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    var pausedRef = (0, $0bd4ca3936ccf850$export$2e2bcd8739ae039)(paused);
    function loop() {
        var current = new Date().getTime();
        var delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $8T3gX.useEffect)(function() {
        handle = requestAnimationFrame(loop);
        return function() {
            return cancelAnimationFrame(handle);
        };
    }, []);
}
var $fa4546647cf9cdbf$export$2e2bcd8739ae039 = $fa4546647cf9cdbf$var$useRafInterval;



var $8T3gX = parcelRequire("8T3gX");
function $fe4222ca29460051$var$_extends() {
    $fe4222ca29460051$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fe4222ca29460051$var$_extends.apply(this, arguments);
}
function $fe4222ca29460051$export$2e2bcd8739ae039(initialState) {
    var _useState = (0, $8T3gX.useState)(initialState), state = _useState[0], setState = _useState[1];
    var updater = (0, $8T3gX.useCallback)(function(update) {
        if (update === null) return;
        if (typeof update === "function") setState(function(state) {
            var nextState = update(state);
            return nextState == null ? state : $fe4222ca29460051$var$_extends({}, state, nextState);
        });
        else setState(function(state) {
            return $fe4222ca29460051$var$_extends({}, state, update);
        });
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}



function $0550f21809ffef16$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    var _useMergeState = (0, $fe4222ca29460051$export$2e2bcd8739ae039)(initialState), state = _useMergeState[0], setState = _useMergeState[1];
    var nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}



var $8T3gX = parcelRequire("8T3gX");
function $53f0b42aae35fa6f$export$2e2bcd8739ae039() {
    var mounted = (0, $8T3gX.useRef)(true);
    var isMounted = (0, $8T3gX.useRef)(function() {
        return mounted.current;
    });
    (0, $8T3gX.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}



var $8T3gX = parcelRequire("8T3gX");
function $9a92a54037561a3a$export$2e2bcd8739ae039(value) {
    var ref = (0, $8T3gX.useRef)(null);
    (0, $8T3gX.useEffect)(function() {
        ref.current = value;
    });
    return ref.current;
}



var $8T3gX = parcelRequire("8T3gX");
function $d8bf11daed356bd3$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    var _useState = (0, $8T3gX.useState)({
        image: null,
        error: null
    }), state = _useState[0], setState = _useState[1];
    (0, $8T3gX.useEffect)(function() {
        if (!imageOrUrl) return undefined;
        var image;
        if (typeof imageOrUrl === "string") {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener("load", onLoad);
        image.addEventListener("error", onError);
        return function() {
            image.removeEventListener("load", onLoad);
            image.removeEventListener("error", onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}



var $8T3gX = parcelRequire("8T3gX");

var $8T3gX = parcelRequire("8T3gX");
var $92e18d6cf48ef440$var$isReactNative = typeof $parcel$global !== "undefined" && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === "ReactNative";
var $92e18d6cf48ef440$var$isDOM = typeof document !== "undefined";
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $92e18d6cf48ef440$export$2e2bcd8739ae039 = $92e18d6cf48ef440$var$isDOM || $92e18d6cf48ef440$var$isReactNative ? (0, $8T3gX.useLayoutEffect) : (0, $8T3gX.useEffect);


var $a3333ee352f4511b$var$targetMap = new WeakMap();
var $a3333ee352f4511b$var$resizeObserver;
function $a3333ee352f4511b$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $a3333ee352f4511b$var$resizeObserver = $a3333ee352f4511b$var$resizeObserver || new window.ResizeObserver(function(entries) {
        entries.forEach(function(entry) {
            var handler = $a3333ee352f4511b$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $a3333ee352f4511b$export$2e2bcd8739ae039(element) {
    var _useState = (0, $8T3gX.useState)(null), rect = _useState[0], setRect = _useState[1];
    (0, $92e18d6cf48ef440$export$2e2bcd8739ae039)(function() {
        if (!element) return;
        $a3333ee352f4511b$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $a3333ee352f4511b$var$targetMap.set(element, function(rect) {
            setRect(rect);
        });
        return function() {
            $a3333ee352f4511b$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}





var $8T3gX = parcelRequire("8T3gX");

const $2188ccbcf240de19$var$_excluded = [
    "as",
    "disabled"
];
function $2188ccbcf240de19$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $2188ccbcf240de19$export$72369ab2cc99204b(href) {
    return !href || href.trim() === "#";
}
function $2188ccbcf240de19$export$a0ee72f2c720a5c3({ tagName: tagName , disabled: disabled , href: href , target: target , rel: rel , role: role , onClick: onClick , tabIndex: tabIndex = 0 , type: type  }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = "a";
        else tagName = "button";
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === "button") return [
        {
            type: type || "button",
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === "a" && $2188ccbcf240de19$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === " ") {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === "a") {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = "#");
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : "button",
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === "a" ? target : undefined,
            "aria-disabled": !disabled ? undefined : disabled,
            rel: tagName === "a" ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $2188ccbcf240de19$var$Button = /*#__PURE__*/ $8T3gX.forwardRef((_ref, ref)=>{
    let { as: asProp , disabled: disabled  } = _ref, props = $2188ccbcf240de19$var$_objectWithoutPropertiesLoose(_ref, $2188ccbcf240de19$var$_excluded);
    const [buttonProps, { tagName: Component  }] = $2188ccbcf240de19$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$2188ccbcf240de19$var$Button.displayName = "Button";
var $2188ccbcf240de19$export$2e2bcd8739ae039 = $2188ccbcf240de19$var$Button;



const $b8fe270a58aab61c$var$_excluded = [
    "onKeyDown"
];
function $b8fe270a58aab61c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b8fe270a58aab61c$export$72369ab2cc99204b(href) {
    return !href || href.trim() === "#";
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const $b8fe270a58aab61c$var$Anchor = /*#__PURE__*/ $8T3gX.forwardRef((_ref, ref)=>{
    let { onKeyDown: onKeyDown  } = _ref, props = $b8fe270a58aab61c$var$_objectWithoutPropertiesLoose(_ref, $b8fe270a58aab61c$var$_excluded);
    const [buttonProps] = (0, $2188ccbcf240de19$export$a0ee72f2c720a5c3)(Object.assign({
        tagName: "a"
    }, props));
    const handleKeyDown = (0, $47b6b666cdb493de$export$2e2bcd8739ae039)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($b8fe270a58aab61c$export$72369ab2cc99204b(props.href) || props.role === "button") return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$b8fe270a58aab61c$var$Anchor.displayName = "Anchor";
var $b8fe270a58aab61c$export$2e2bcd8739ae039 = $b8fe270a58aab61c$var$Anchor;



var $8T3gX = parcelRequire("8T3gX");

const $fa98af941750c85d$export$666ad80b5007f835 = [
    "xxl",
    "xl",
    "lg",
    "md",
    "sm",
    "xs"
];
const $fa98af941750c85d$export$ff817e17bad2e091 = "xs";
const $fa98af941750c85d$var$ThemeContext = /*#__PURE__*/ $8T3gX.createContext({
    prefixes: {},
    breakpoints: $fa98af941750c85d$export$666ad80b5007f835,
    minBreakpoint: $fa98af941750c85d$export$ff817e17bad2e091
});
const { Consumer: $fa98af941750c85d$export$b631efc24e9d5e2f , Provider: $fa98af941750c85d$var$Provider  } = $fa98af941750c85d$var$ThemeContext;
function $fa98af941750c85d$var$ThemeProvider({ prefixes: prefixes = {} , breakpoints: breakpoints = $fa98af941750c85d$export$666ad80b5007f835 , minBreakpoint: minBreakpoint = $fa98af941750c85d$export$ff817e17bad2e091 , dir: dir , children: children  }) {
    const contextValue = (0, $8T3gX.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)($fa98af941750c85d$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $fa98af941750c85d$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes  } = (0, $8T3gX.useContext)($fa98af941750c85d$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $fa98af941750c85d$export$8970c8db816a5863() {
    const { breakpoints: breakpoints  } = (0, $8T3gX.useContext)($fa98af941750c85d$var$ThemeContext);
    return breakpoints;
}
function $fa98af941750c85d$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint  } = (0, $8T3gX.useContext)($fa98af941750c85d$var$ThemeContext);
    return minBreakpoint;
}
function $fa98af941750c85d$export$35e511eefa30ac5a() {
    const { dir: dir  } = (0, $8T3gX.useContext)($fa98af941750c85d$var$ThemeContext);
    return dir === "rtl";
}
function $fa98af941750c85d$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === "string") opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix , forwardRefAs: forwardRefAs = isClassy ? "ref" : "innerRef"  } = opts;
    const Wrapped = /*#__PURE__*/ $8T3gX.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = $fa98af941750c85d$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $fa98af941750c85d$export$2e2bcd8739ae039 = $fa98af941750c85d$var$ThemeProvider;




var $8T3gX = parcelRequire("8T3gX");




var $8T3gX = parcelRequire("8T3gX");

var $e174d6163163820e$export$2e2bcd8739ae039 = {
    disabled: false
};




var $8T3gX = parcelRequire("8T3gX");
var $57ed79c62785b036$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createContext(null);


var $cefc240922d198a6$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $63c98853081657d7$export$bb38bb9a1161268 = "unmounted";
var $63c98853081657d7$export$84cbff306f539230 = "exited";
var $63c98853081657d7$export$df38205c966be359 = "entering";
var $63c98853081657d7$export$78e9e6e3e014d60a = "entered";
var $63c98853081657d7$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $63c98853081657d7$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $61fb52508441c2fd$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $63c98853081657d7$export$84cbff306f539230;
                _this.appearStatus = $63c98853081657d7$export$df38205c966be359;
            } else initialStatus = $63c98853081657d7$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $63c98853081657d7$export$bb38bb9a1161268;
        else initialStatus = $63c98853081657d7$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $63c98853081657d7$export$bb38bb9a1161268) return {
            status: $63c98853081657d7$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $63c98853081657d7$export$df38205c966be359 && status !== $63c98853081657d7$export$78e9e6e3e014d60a) nextStatus = $63c98853081657d7$export$df38205c966be359;
            } else if (status === $63c98853081657d7$export$df38205c966be359 || status === $63c98853081657d7$export$78e9e6e3e014d60a) nextStatus = $63c98853081657d7$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $63c98853081657d7$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($680cb73086b60533$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $cefc240922d198a6$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $63c98853081657d7$export$84cbff306f539230) this.setState({
            status: $63c98853081657d7$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($680cb73086b60533$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $e174d6163163820e$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $63c98853081657d7$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $63c98853081657d7$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $63c98853081657d7$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($680cb73086b60533$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $e174d6163163820e$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $63c98853081657d7$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $63c98853081657d7$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $63c98853081657d7$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($680cb73086b60533$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $63c98853081657d7$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $b59d967182239c8b$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $57ed79c62785b036$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Component);
$63c98853081657d7$var$Transition.contextType = (0, $57ed79c62785b036$export$2e2bcd8739ae039);
$63c98853081657d7$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $63c98853081657d7$var$noop() {}
$63c98853081657d7$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $63c98853081657d7$var$noop,
    onEntering: $63c98853081657d7$var$noop,
    onEntered: $63c98853081657d7$var$noop,
    onExit: $63c98853081657d7$var$noop,
    onExiting: $63c98853081657d7$var$noop,
    onExited: $63c98853081657d7$var$noop
};
$63c98853081657d7$var$Transition.UNMOUNTED = $63c98853081657d7$export$bb38bb9a1161268;
$63c98853081657d7$var$Transition.EXITED = $63c98853081657d7$export$84cbff306f539230;
$63c98853081657d7$var$Transition.ENTERING = $63c98853081657d7$export$df38205c966be359;
$63c98853081657d7$var$Transition.ENTERED = $63c98853081657d7$export$78e9e6e3e014d60a;
$63c98853081657d7$var$Transition.EXITING = $63c98853081657d7$export$4aacc83d4d59139f;
var $63c98853081657d7$export$2e2bcd8739ae039 = $63c98853081657d7$var$Transition;


/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $c65895a0e633f08a$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $4cd0b239df68707e$export$2e2bcd8739ae039(node) {
    var doc = (0, $c65895a0e633f08a$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $946dcafbbbac8b25$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $4cd0b239df68707e$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $649753a07958bff4$var$rUpper = /([A-Z])/g;
function $649753a07958bff4$export$2e2bcd8739ae039(string) {
    return string.replace($649753a07958bff4$var$rUpper, "-$1").toLowerCase();
}


var $b6168436f319dd5c$var$msPattern = /^ms-/;
function $b6168436f319dd5c$export$2e2bcd8739ae039(string) {
    return (0, $649753a07958bff4$export$2e2bcd8739ae039)(string).replace($b6168436f319dd5c$var$msPattern, "-ms-");
}


var $2bd5dac13bb33476$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $2bd5dac13bb33476$export$2e2bcd8739ae039(value) {
    return !!(value && $2bd5dac13bb33476$var$supportedTransforms.test(value));
}


function $cefc685938ef1085$var$style(node, property) {
    var css = "";
    var transforms = "";
    if (typeof property === "string") return node.style.getPropertyValue((0, $b6168436f319dd5c$export$2e2bcd8739ae039)(property)) || (0, $946dcafbbbac8b25$export$2e2bcd8739ae039)(node).getPropertyValue((0, $b6168436f319dd5c$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $b6168436f319dd5c$export$2e2bcd8739ae039)(key));
        else if ((0, $2bd5dac13bb33476$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $b6168436f319dd5c$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $cefc685938ef1085$export$2e2bcd8739ae039 = $cefc685938ef1085$var$style;



/* eslint-disable no-return-assign */ var $5d1f306240459aa4$export$2e2bcd8739ae039 = !!(typeof window !== "undefined" && window.document && window.document.createElement);


var $e7cff1023d0c73c4$export$63fefd044b2bc624 = false;
var $e7cff1023d0c73c4$export$a614c6b395900f69 = false;
try {
    var $e7cff1023d0c73c4$var$options = {
        get passive () {
            return $e7cff1023d0c73c4$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $e7cff1023d0c73c4$export$a614c6b395900f69 = $e7cff1023d0c73c4$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $5d1f306240459aa4$export$2e2bcd8739ae039) {
        window.addEventListener("test", $e7cff1023d0c73c4$var$options, $e7cff1023d0c73c4$var$options);
        window.removeEventListener("test", $e7cff1023d0c73c4$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $e7cff1023d0c73c4$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== "boolean" && !$e7cff1023d0c73c4$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$e7cff1023d0c73c4$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $e7cff1023d0c73c4$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $e7cff1023d0c73c4$export$2e2bcd8739ae039 = $e7cff1023d0c73c4$var$addEventListener;


/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $76865a0011944031$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== "boolean" ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $76865a0011944031$export$2e2bcd8739ae039 = $76865a0011944031$var$removeEventListener;


function $79ee32458d0e6378$var$listen(node, eventName, handler, options) {
    (0, $e7cff1023d0c73c4$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $76865a0011944031$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $79ee32458d0e6378$export$2e2bcd8739ae039 = $79ee32458d0e6378$var$listen;


/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $320bc213081c5103$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent("HTMLEvents");
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}


function $3e2975719edb44ef$var$parseDuration(node) {
    var str = (0, $cefc685938ef1085$export$2e2bcd8739ae039)(node, "transitionDuration") || "";
    var mult = str.indexOf("ms") === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $3e2975719edb44ef$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $320bc213081c5103$export$2e2bcd8739ae039)(element, "transitionend", true);
    }, duration + padding);
    var remove = (0, $79ee32458d0e6378$export$2e2bcd8739ae039)(element, "transitionend", function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $3e2975719edb44ef$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $3e2975719edb44ef$var$parseDuration(element) || 0;
    var removeEmulate = $3e2975719edb44ef$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $79ee32458d0e6378$export$2e2bcd8739ae039)(element, "transitionend", handler);
    return function() {
        removeEmulate();
        remove();
    };
}


function $2675c0d5845ad502$var$parseDuration(node, property) {
    const str = (0, $cefc685938ef1085$export$2e2bcd8739ae039)(node, property) || "";
    const mult = str.indexOf("ms") === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $2675c0d5845ad502$export$2e2bcd8739ae039(element, handler) {
    const duration = $2675c0d5845ad502$var$parseDuration(element, "transitionDuration");
    const delay = $2675c0d5845ad502$var$parseDuration(element, "transitionDelay");
    const remove = (0, $3e2975719edb44ef$export$2e2bcd8739ae039)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}


// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $a46c705cdf1e8082$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}



var $8T3gX = parcelRequire("8T3gX");


var $8T3gX = parcelRequire("8T3gX");
var $3334d009365bf881$var$toFnRef = function toFnRef(ref) {
    return !ref || typeof ref === "function" ? ref : function(value) {
        ref.current = value;
    };
};
function $3334d009365bf881$export$c9058316764c140e(refA, refB) {
    var a = $3334d009365bf881$var$toFnRef(refA);
    var b = $3334d009365bf881$var$toFnRef(refB);
    return function(value) {
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $3334d009365bf881$var$useMergedRefs(refA, refB) {
    return (0, $8T3gX.useMemo)(function() {
        return $3334d009365bf881$export$c9058316764c140e(refA, refB);
    }, [
        refA,
        refB
    ]);
}
var $3334d009365bf881$export$2e2bcd8739ae039 = $3334d009365bf881$var$useMergedRefs;



function $b126ff963e939b98$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && "setState" in componentOrElement) return (0, (/*@__PURE__*/$parcel$interopDefault($680cb73086b60533$exports))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}



// Normalizes Transition callbacks when nodeRef is used.
const $4d7e429a98f3ba4d$var$TransitionWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).forwardRef(({ onEnter: onEnter , onEntering: onEntering , onEntered: onEntered , onExit: onExit , onExiting: onExiting , onExited: onExited , addEndListener: addEndListener , children: children , childRef: childRef , ...props }, ref)=>{
    const nodeRef = (0, $8T3gX.useRef)(null);
    const mergedRef = (0, $3334d009365bf881$export$2e2bcd8739ae039)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $b126ff963e939b98$export$2e2bcd8739ae039)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $8T3gX.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $8T3gX.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $8T3gX.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $8T3gX.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $8T3gX.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $8T3gX.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $8T3gX.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $63c98853081657d7$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === "function" ? (status, innerProps)=>children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(children, {
            ref: attachRef
        })
    });
});
var $4d7e429a98f3ba4d$export$2e2bcd8739ae039 = $4d7e429a98f3ba4d$var$TransitionWrapper;



const $e996a38072c77732$var$fadeStyles = {
    [(0, $63c98853081657d7$export$df38205c966be359)]: "show",
    [(0, $63c98853081657d7$export$78e9e6e3e014d60a)]: "show"
};
const $e996a38072c77732$var$Fade = /*#__PURE__*/ $8T3gX.forwardRef(({ className: className , children: children , transitionClasses: transitionClasses = {} , onEnter: onEnter , ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, $8T3gX.useCallback)((node, isAppearing)=>{
        (0, $a46c705cdf1e8082$export$2e2bcd8739ae039)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $4d7e429a98f3ba4d$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $2675c0d5845ad502$export$2e2bcd8739ae039),
        ...props,
        onEnter: handleEnter,
        childRef: children.ref,
        children: (status, innerProps)=>/*#__PURE__*/ $8T3gX.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))("fade", className, children.props.className, $e996a38072c77732$var$fadeStyles[status], transitionClasses[status])
            })
    });
});
$e996a38072c77732$var$Fade.displayName = "Fade";
var $e996a38072c77732$export$2e2bcd8739ae039 = $e996a38072c77732$var$Fade;



var $fdGrT = parcelRequire("fdGrT");

var $8T3gX = parcelRequire("8T3gX");


const $8dfc29fc92784a3c$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        "white"
    ])
};
const $8dfc29fc92784a3c$var$CloseButton = /*#__PURE__*/ $8T3gX.forwardRef(({ className: className , variant: variant , "aria-label": ariaLabel = "Close" , ...props }, ref)=>/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("button", {
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))("btn-close", variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel,
        ...props
    }));
$8dfc29fc92784a3c$var$CloseButton.displayName = "CloseButton";
$8dfc29fc92784a3c$var$CloseButton.propTypes = $8dfc29fc92784a3c$var$propTypes;
var $8dfc29fc92784a3c$export$2e2bcd8739ae039 = $8dfc29fc92784a3c$var$CloseButton;



var $8T3gX = parcelRequire("8T3gX");


var $87aacb5e98a57b39$export$2e2bcd8739ae039 = (className)=>/*#__PURE__*/ $8T3gX.forwardRef((p, ref)=>/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
            ...p,
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(p.className, className)
        }));



var $2e6522ebb58b65b5$var$rHyphen = /-(.)/g;
function $2e6522ebb58b65b5$export$2e2bcd8739ae039(string) {
    return string.replace($2e6522ebb58b65b5$var$rHyphen, function(_, chr) {
        return chr.toUpperCase();
    });
}



var $8T3gX = parcelRequire("8T3gX");


const $94fe4a2899ec2691$var$pascalCase = (str)=>str[0].toUpperCase() + (0, $2e6522ebb58b65b5$export$2e2bcd8739ae039)(str).slice(1);
function $94fe4a2899ec2691$export$2e2bcd8739ae039(prefix, { displayName: displayName = $94fe4a2899ec2691$var$pascalCase(prefix) , Component: Component , defaultProps: defaultProps  } = {}) {
    const BsComponent = /*#__PURE__*/ $8T3gX.forwardRef(({ className: className , bsPrefix: bsPrefix , as: Tag = Component || "div" , ...props }, ref)=>{
        const componentProps = {
            ...defaultProps,
            ...props
        };
        const resolvedPrefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, prefix);
        return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(Tag, {
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, resolvedPrefix),
            ...componentProps
        });
    });
    BsComponent.displayName = displayName;
    return BsComponent;
}



const $1d0a237fe4c0025c$var$DivStyledAsH4 = (0, $87aacb5e98a57b39$export$2e2bcd8739ae039)("h4");
$1d0a237fe4c0025c$var$DivStyledAsH4.displayName = "DivStyledAsH4";
const $1d0a237fe4c0025c$var$AlertHeading = (0, $94fe4a2899ec2691$export$2e2bcd8739ae039)("alert-heading", {
    Component: $1d0a237fe4c0025c$var$DivStyledAsH4
});
const $1d0a237fe4c0025c$var$AlertLink = (0, $94fe4a2899ec2691$export$2e2bcd8739ae039)("alert-link", {
    Component: (0, $b8fe270a58aab61c$export$2e2bcd8739ae039)
});
const $1d0a237fe4c0025c$var$Alert = /*#__PURE__*/ $8T3gX.forwardRef((uncontrolledProps, ref)=>{
    const { bsPrefix: bsPrefix , show: show = true , closeLabel: closeLabel = "Close alert" , closeVariant: closeVariant , className: className , children: children , variant: variant = "primary" , onClose: onClose , dismissible: dismissible , transition: transition = (0, $e996a38072c77732$export$2e2bcd8739ae039) , ...props } = (0, $43a5c6b75c3b0a1f$export$2e2bcd8739ae039)(uncontrolledProps, {
        show: "onClose"
    });
    const prefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, "alert");
    const handleClose = (0, $47b6b666cdb493de$export$2e2bcd8739ae039)((e)=>{
        if (onClose) onClose(false, e);
    });
    const Transition = transition === true ? (0, $e996a38072c77732$export$2e2bcd8739ae039) : transition;
    const alert = /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
        role: "alert",
        ...!Transition ? props : undefined,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, prefix, variant && `${prefix}-${variant}`, dismissible && `${prefix}-dismissible`),
        children: [
            dismissible && /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $8dfc29fc92784a3c$export$2e2bcd8739ae039), {
                onClick: handleClose,
                "aria-label": closeLabel,
                variant: closeVariant
            }),
            children
        ]
    });
    if (!Transition) return show ? alert : null;
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(Transition, {
        unmountOnExit: true,
        ...props,
        ref: undefined,
        in: show,
        children: alert
    });
});
$1d0a237fe4c0025c$var$Alert.displayName = "Alert";
var $1d0a237fe4c0025c$export$2e2bcd8739ae039 = Object.assign($1d0a237fe4c0025c$var$Alert, {
    Link: $1d0a237fe4c0025c$var$AlertLink,
    Heading: $1d0a237fe4c0025c$var$AlertHeading
});



var $3T949 = parcelRequire("3T949");parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");


var $8T3gX = parcelRequire("8T3gX");
// eslint-disable-next-line @typescript-eslint/no-explicit-any

var $8T3gX = parcelRequire("8T3gX");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $11e801b827ed84d2$var$queue = [];
let $11e801b827ed84d2$var$onLog = ()=>{};
function $11e801b827ed84d2$export$d05b0649e996f88() {
    const [log, setLog] = (0, $8T3gX.useState)($11e801b827ed84d2$var$queue);
    $11e801b827ed84d2$var$onLog = ()=>setLog($11e801b827ed84d2$var$queue);
    return log;
}
function $11e801b827ed84d2$export$bef1f36f5486a6a3(...args) {
    $11e801b827ed84d2$var$queue = [
        ...$11e801b827ed84d2$var$queue,
        args
    ];
    $11e801b827ed84d2$var$onLog();
}
function $11e801b827ed84d2$export$42ffd38884aecdac() {
    $11e801b827ed84d2$var$queue = [];
    $11e801b827ed84d2$var$onLog();
}




let $40b0ef4339cb3cfb$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $40b0ef4339cb3cfb$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = "";
        while(true){
            let bytes = getRandom(step);
            let j = step;
            while(j--){
                id += alphabet[bytes[j] & mask] || "";
                if (id.length === size) return id;
            }
        }
    };
};
let $40b0ef4339cb3cfb$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$40b0ef4339cb3cfb$export$a5cee9e955a615e5(alphabet, size, $40b0ef4339cb3cfb$export$4385e60b38654f68);
let $40b0ef4339cb3cfb$export$ac4959f4f1338dfc = (size = 21)=>crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte)=>{
        byte &= 63;
        if (byte < 36) id += byte.toString(36);
        else if (byte < 62) id += (byte - 26).toString(36).toUpperCase();
        else if (byte > 62) id += "-";
        else id += "_";
        return id;
    }, "");


parcelRequire("8T3gX");


var $8T3gX = parcelRequire("8T3gX");



const $049664ec30473d5e$var$Button = /*#__PURE__*/ $8T3gX.forwardRef(({ as: as , bsPrefix: bsPrefix , variant: variant = "primary" , size: size , active: active = false , disabled: disabled = false , className: className , ...props }, ref)=>{
    const prefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, "btn");
    const [buttonProps, { tagName: tagName  }] = (0, $2188ccbcf240de19$export$a0ee72f2c720a5c3)({
        tagName: as,
        disabled: disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, prefix, active && "active", variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && "disabled")
    });
});
$049664ec30473d5e$var$Button.displayName = "Button";
var $049664ec30473d5e$export$2e2bcd8739ae039 = $049664ec30473d5e$var$Button;



/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ var $c68e419b2a37d2b9$exports = {};
// shim for using process in browser
var $c68e419b2a37d2b9$var$process = $c68e419b2a37d2b9$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $c68e419b2a37d2b9$var$cachedSetTimeout;
var $c68e419b2a37d2b9$var$cachedClearTimeout;
function $c68e419b2a37d2b9$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $c68e419b2a37d2b9$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $c68e419b2a37d2b9$var$cachedSetTimeout = setTimeout;
        else $c68e419b2a37d2b9$var$cachedSetTimeout = $c68e419b2a37d2b9$var$defaultSetTimout;
    } catch (e) {
        $c68e419b2a37d2b9$var$cachedSetTimeout = $c68e419b2a37d2b9$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $c68e419b2a37d2b9$var$cachedClearTimeout = clearTimeout;
        else $c68e419b2a37d2b9$var$cachedClearTimeout = $c68e419b2a37d2b9$var$defaultClearTimeout;
    } catch (e) {
        $c68e419b2a37d2b9$var$cachedClearTimeout = $c68e419b2a37d2b9$var$defaultClearTimeout;
    }
})();
function $c68e419b2a37d2b9$var$runTimeout(fun) {
    if ($c68e419b2a37d2b9$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($c68e419b2a37d2b9$var$cachedSetTimeout === $c68e419b2a37d2b9$var$defaultSetTimout || !$c68e419b2a37d2b9$var$cachedSetTimeout) && setTimeout) {
        $c68e419b2a37d2b9$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $c68e419b2a37d2b9$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $c68e419b2a37d2b9$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $c68e419b2a37d2b9$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $c68e419b2a37d2b9$var$runClearTimeout(marker) {
    if ($c68e419b2a37d2b9$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($c68e419b2a37d2b9$var$cachedClearTimeout === $c68e419b2a37d2b9$var$defaultClearTimeout || !$c68e419b2a37d2b9$var$cachedClearTimeout) && clearTimeout) {
        $c68e419b2a37d2b9$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $c68e419b2a37d2b9$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $c68e419b2a37d2b9$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $c68e419b2a37d2b9$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $c68e419b2a37d2b9$var$queue = [];
var $c68e419b2a37d2b9$var$draining = false;
var $c68e419b2a37d2b9$var$currentQueue;
var $c68e419b2a37d2b9$var$queueIndex = -1;
function $c68e419b2a37d2b9$var$cleanUpNextTick() {
    if (!$c68e419b2a37d2b9$var$draining || !$c68e419b2a37d2b9$var$currentQueue) return;
    $c68e419b2a37d2b9$var$draining = false;
    if ($c68e419b2a37d2b9$var$currentQueue.length) $c68e419b2a37d2b9$var$queue = $c68e419b2a37d2b9$var$currentQueue.concat($c68e419b2a37d2b9$var$queue);
    else $c68e419b2a37d2b9$var$queueIndex = -1;
    if ($c68e419b2a37d2b9$var$queue.length) $c68e419b2a37d2b9$var$drainQueue();
}
function $c68e419b2a37d2b9$var$drainQueue() {
    if ($c68e419b2a37d2b9$var$draining) return;
    var timeout = $c68e419b2a37d2b9$var$runTimeout($c68e419b2a37d2b9$var$cleanUpNextTick);
    $c68e419b2a37d2b9$var$draining = true;
    var len = $c68e419b2a37d2b9$var$queue.length;
    while(len){
        $c68e419b2a37d2b9$var$currentQueue = $c68e419b2a37d2b9$var$queue;
        $c68e419b2a37d2b9$var$queue = [];
        while(++$c68e419b2a37d2b9$var$queueIndex < len)if ($c68e419b2a37d2b9$var$currentQueue) $c68e419b2a37d2b9$var$currentQueue[$c68e419b2a37d2b9$var$queueIndex].run();
        $c68e419b2a37d2b9$var$queueIndex = -1;
        len = $c68e419b2a37d2b9$var$queue.length;
    }
    $c68e419b2a37d2b9$var$currentQueue = null;
    $c68e419b2a37d2b9$var$draining = false;
    $c68e419b2a37d2b9$var$runClearTimeout(timeout);
}
$c68e419b2a37d2b9$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $c68e419b2a37d2b9$var$queue.push(new $c68e419b2a37d2b9$var$Item(fun, args));
    if ($c68e419b2a37d2b9$var$queue.length === 1 && !$c68e419b2a37d2b9$var$draining) $c68e419b2a37d2b9$var$runTimeout($c68e419b2a37d2b9$var$drainQueue);
};
// v8 likes predictible objects
function $c68e419b2a37d2b9$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$c68e419b2a37d2b9$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$c68e419b2a37d2b9$var$process.title = "browser";
$c68e419b2a37d2b9$var$process.browser = true;
$c68e419b2a37d2b9$var$process.env = {};
$c68e419b2a37d2b9$var$process.argv = [];
$c68e419b2a37d2b9$var$process.version = ""; // empty string to avoid regexp issues
$c68e419b2a37d2b9$var$process.versions = {};
function $c68e419b2a37d2b9$var$noop() {}
$c68e419b2a37d2b9$var$process.on = $c68e419b2a37d2b9$var$noop;
$c68e419b2a37d2b9$var$process.addListener = $c68e419b2a37d2b9$var$noop;
$c68e419b2a37d2b9$var$process.once = $c68e419b2a37d2b9$var$noop;
$c68e419b2a37d2b9$var$process.off = $c68e419b2a37d2b9$var$noop;
$c68e419b2a37d2b9$var$process.removeListener = $c68e419b2a37d2b9$var$noop;
$c68e419b2a37d2b9$var$process.removeAllListeners = $c68e419b2a37d2b9$var$noop;
$c68e419b2a37d2b9$var$process.emit = $c68e419b2a37d2b9$var$noop;
$c68e419b2a37d2b9$var$process.prependListener = $c68e419b2a37d2b9$var$noop;
$c68e419b2a37d2b9$var$process.prependOnceListener = $c68e419b2a37d2b9$var$noop;
$c68e419b2a37d2b9$var$process.listeners = function(name) {
    return [];
};
$c68e419b2a37d2b9$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$c68e419b2a37d2b9$var$process.cwd = function() {
    return "/";
};
$c68e419b2a37d2b9$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$c68e419b2a37d2b9$var$process.umask = function() {
    return 0;
};


const $fc59d49e1bb53b6a$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $fc59d49e1bb53b6a$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $fc59d49e1bb53b6a$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $fc59d49e1bb53b6a$export$a39cad550e7ab28a = function(message) {
    return new Error("Firebase Database (" + $fc59d49e1bb53b6a$export$588c7fdda06fbb0a.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fc59d49e1bb53b6a$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $fc59d49e1bb53b6a$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const $fc59d49e1bb53b6a$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($fc59d49e1bb53b6a$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $fc59d49e1bb53b6a$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $fc59d49e1bb53b6a$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $fc59d49e1bb53b6a$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = "DecodeBase64StringError";
    }
}
/**
 * URL-safe base64 encoding
 */ const $fc59d49e1bb53b6a$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $fc59d49e1bb53b6a$var$stringToByteArray$1(str);
    return $fc59d49e1bb53b6a$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $fc59d49e1bb53b6a$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $fc59d49e1bb53b6a$export$e510a73ee562749(str).replace(/\./g, "");
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $fc59d49e1bb53b6a$export$c62426fdd000a97e = function(str) {
    try {
        return $fc59d49e1bb53b6a$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $fc59d49e1bb53b6a$export$6c40052bed430212(value) {
    return $fc59d49e1bb53b6a$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $fc59d49e1bb53b6a$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$fc59d49e1bb53b6a$var$isValidKey(prop)) continue;
        target[prop] = $fc59d49e1bb53b6a$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $fc59d49e1bb53b6a$var$isValidKey(key) {
    return key !== "__proto__";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $fc59d49e1bb53b6a$export$a4e55266d2135a7f() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fc59d49e1bb53b6a$var$getDefaultsFromGlobal = ()=>$fc59d49e1bb53b6a$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $fc59d49e1bb53b6a$var$getDefaultsFromEnvVariable = ()=>{
    if (typeof $c68e419b2a37d2b9$exports === "undefined" || typeof $c68e419b2a37d2b9$exports.env === "undefined") return;
    const defaultsJsonString = undefined;
    if (defaultsJsonString) return JSON.parse(defaultsJsonString);
};
const $fc59d49e1bb53b6a$var$getDefaultsFromCookie = ()=>{
    if (typeof document === "undefined") return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $fc59d49e1bb53b6a$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $fc59d49e1bb53b6a$export$212bb2fc580a90a8 = ()=>{
    try {
        return $fc59d49e1bb53b6a$var$getDefaultsFromGlobal() || $fc59d49e1bb53b6a$var$getDefaultsFromEnvVariable() || $fc59d49e1bb53b6a$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $fc59d49e1bb53b6a$export$9c11895284c8adad = (productName)=>{
    var _a, _b;
    return (_b = (_a = $fc59d49e1bb53b6a$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $fc59d49e1bb53b6a$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $fc59d49e1bb53b6a$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(":"); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === "[") // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $fc59d49e1bb53b6a$export$3dfb6827a9f89756 = ()=>{
    var _a;
    return (_a = $fc59d49e1bb53b6a$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $fc59d49e1bb53b6a$export$5539a1a3afe87d6 = (name)=>{
    var _a;
    return (_a = $fc59d49e1bb53b6a$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fc59d49e1bb53b6a$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === "function") {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $fc59d49e1bb53b6a$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: "none",
        type: "JWT"
    };
    const project = projectId || "demo-project";
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: "custom",
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = "";
    return [
        $fc59d49e1bb53b6a$export$4b5284a3025a455(JSON.stringify(header)),
        $fc59d49e1bb53b6a$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $fc59d49e1bb53b6a$export$c36915b22ce77c19() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $fc59d49e1bb53b6a$export$872f8323f01d7ae0() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($fc59d49e1bb53b6a$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $fc59d49e1bb53b6a$export$8ee0fc9ee280b4ee() {
    var _a;
    const forceEnvironment = (_a = $fc59d49e1bb53b6a$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === "node") return true;
    else if (forceEnvironment === "browser") return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $fc59d49e1bb53b6a$export$4e09c449d6c407f7() {
    return typeof self === "object" && self.self === self;
}
function $fc59d49e1bb53b6a$export$caa8774a9107a58e() {
    const runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $fc59d49e1bb53b6a$export$f7a1e23e542d38e3() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $fc59d49e1bb53b6a$export$f2f6a8999f8ebd30() {
    return $fc59d49e1bb53b6a$export$c36915b22ce77c19().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $fc59d49e1bb53b6a$export$7e7b1a9668aaed8() {
    const ua = $fc59d49e1bb53b6a$export$c36915b22ce77c19();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $fc59d49e1bb53b6a$export$202944b2d2824246() {
    return $fc59d49e1bb53b6a$export$c36915b22ce77c19().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $fc59d49e1bb53b6a$export$5d1d834fbbf8bab7() {
    return $fc59d49e1bb53b6a$export$588c7fdda06fbb0a.NODE_CLIENT === true || $fc59d49e1bb53b6a$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $fc59d49e1bb53b6a$export$95df08bae54cb4df() {
    return !$fc59d49e1bb53b6a$export$8ee0fc9ee280b4ee() && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $fc59d49e1bb53b6a$export$3865db50535c2055() {
    try {
        return typeof indexedDB === "object";
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $fc59d49e1bb53b6a$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $fc59d49e1bb53b6a$export$f172b7eb6cf60599() {
    if (typeof navigator === "undefined" || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $fc59d49e1bb53b6a$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $fc59d49e1bb53b6a$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $fc59d49e1bb53b6a$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $fc59d49e1bb53b6a$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $fc59d49e1bb53b6a$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $fc59d49e1bb53b6a$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $fc59d49e1bb53b6a$var$replaceTemplate(template, customData) : "Error";
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $fc59d49e1bb53b6a$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $fc59d49e1bb53b6a$var$replaceTemplate(template, data) {
    return template.replace($fc59d49e1bb53b6a$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $fc59d49e1bb53b6a$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $fc59d49e1bb53b6a$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $fc59d49e1bb53b6a$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $fc59d49e1bb53b6a$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = "";
    try {
        const parts = token.split(".");
        header = $fc59d49e1bb53b6a$export$c5a53ce6a17cf18d($fc59d49e1bb53b6a$export$c62426fdd000a97e(parts[0]) || "");
        claims = $fc59d49e1bb53b6a$export$c5a53ce6a17cf18d($fc59d49e1bb53b6a$export$c62426fdd000a97e(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $fc59d49e1bb53b6a$export$5f870fcca7ae6a88 = function(token) {
    const claims = $fc59d49e1bb53b6a$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $fc59d49e1bb53b6a$export$701c661ec91095f2 = function(token) {
    const claims = $fc59d49e1bb53b6a$export$2f872c0f2117be69(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $fc59d49e1bb53b6a$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $fc59d49e1bb53b6a$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $fc59d49e1bb53b6a$export$fc970ed23da99565 = function(token) {
    const claims = $fc59d49e1bb53b6a$export$2f872c0f2117be69(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $fc59d49e1bb53b6a$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $fc59d49e1bb53b6a$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $fc59d49e1bb53b6a$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $fc59d49e1bb53b6a$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $fc59d49e1bb53b6a$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($fc59d49e1bb53b6a$var$isObject(aProp) && $fc59d49e1bb53b6a$var$isObject(bProp)) {
            if (!$fc59d49e1bb53b6a$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $fc59d49e1bb53b6a$var$isObject(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $fc59d49e1bb53b6a$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $fc59d49e1bb53b6a$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject("timeout!"), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $fc59d49e1bb53b6a$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $fc59d49e1bb53b6a$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split("=");
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $fc59d49e1bb53b6a$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf("?");
    if (!queryStart) return "";
    const fragmentStart = url.indexOf("#", queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $fc59d49e1bb53b6a$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === "string") for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === "string") while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $fc59d49e1bb53b6a$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $fc59d49e1bb53b6a$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $fc59d49e1bb53b6a$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
        // Assemble an Observer object when passed as callback functions.
        if ($fc59d49e1bb53b6a$var$implementsAnyMethods(nextOrObserver, [
            "next",
            "error",
            "complete"
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $fc59d49e1bb53b6a$var$noop;
        if (observer.error === undefined) observer.error = $fc59d49e1bb53b6a$var$noop;
        if (observer.complete === undefined) observer.complete = $fc59d49e1bb53b6a$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== "undefined" && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $fc59d49e1bb53b6a$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $fc59d49e1bb53b6a$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === "function") return true;
    }
    return false;
}
function $fc59d49e1bb53b6a$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $fc59d49e1bb53b6a$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        const error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $fc59d49e1bb53b6a$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $fc59d49e1bb53b6a$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($fc59d49e1bb53b6a$export$adea4917e02d93dc(fnName, "namespace") + "must be a valid firebase namespace.");
}
function $fc59d49e1bb53b6a$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($fc59d49e1bb53b6a$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid function.");
}
function $fc59d49e1bb53b6a$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($fc59d49e1bb53b6a$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $fc59d49e1bb53b6a$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $fc59d49e1bb53b6a$export$a7a9523472993e97(i < str.length, "Surrogate pair missing trail surrogate.");
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $fc59d49e1bb53b6a$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */ const $fc59d49e1bb53b6a$export$abe4376e1bf796d6 = function() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0, v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $fc59d49e1bb53b6a$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $fc59d49e1bb53b6a$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $fc59d49e1bb53b6a$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $fc59d49e1bb53b6a$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $fc59d49e1bb53b6a$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $fc59d49e1bb53b6a$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $fc59d49e1bb53b6a$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $fc59d49e1bb53b6a$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($fc59d49e1bb53b6a$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $fc59d49e1bb53b6a$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $fc59d49e1bb53b6a$var$indicator(i);
}
function $fc59d49e1bb53b6a$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return "th";
    const dec = i % 10;
    if (dec === 1) return "st";
    if (dec === 2) return "nd";
    if (dec === 3) return "rd";
    return "th";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $fc59d49e1bb53b6a$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $e04d5da8f80f59f8$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e04d5da8f80f59f8$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $e04d5da8f80f59f8$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $fc59d49e1bb53b6a$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($e04d5da8f80f59f8$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $e04d5da8f80f59f8$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $e04d5da8f80f59f8$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>"INTERNAL" in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>"_delete" in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $e04d5da8f80f59f8$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $e04d5da8f80f59f8$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {}  } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier , options: options = {}  }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $e04d5da8f80f59f8$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $e04d5da8f80f59f8$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $e04d5da8f80f59f8$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $e04d5da8f80f59f8$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $e04d5da8f80f59f8$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $e04d5da8f80f59f8$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $e04d5da8f80f59f8$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $e04d5da8f80f59f8$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $888412469b3c9c09$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $888412469b3c9c09$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($888412469b3c9c09$export$243e62d78d3b544d || ($888412469b3c9c09$export$243e62d78d3b544d = {}));
const $888412469b3c9c09$var$levelStringToEnum = {
    "debug": $888412469b3c9c09$export$243e62d78d3b544d.DEBUG,
    "verbose": $888412469b3c9c09$export$243e62d78d3b544d.VERBOSE,
    "info": $888412469b3c9c09$export$243e62d78d3b544d.INFO,
    "warn": $888412469b3c9c09$export$243e62d78d3b544d.WARN,
    "error": $888412469b3c9c09$export$243e62d78d3b544d.ERROR,
    "silent": $888412469b3c9c09$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $888412469b3c9c09$var$defaultLogLevel = $888412469b3c9c09$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $888412469b3c9c09$var$ConsoleMethod = {
    [$888412469b3c9c09$export$243e62d78d3b544d.DEBUG]: "log",
    [$888412469b3c9c09$export$243e62d78d3b544d.VERBOSE]: "log",
    [$888412469b3c9c09$export$243e62d78d3b544d.INFO]: "info",
    [$888412469b3c9c09$export$243e62d78d3b544d.WARN]: "warn",
    [$888412469b3c9c09$export$243e62d78d3b544d.ERROR]: "error"
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $888412469b3c9c09$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $888412469b3c9c09$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $888412469b3c9c09$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $888412469b3c9c09$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $888412469b3c9c09$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $888412469b3c9c09$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $888412469b3c9c09$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === "string" ? $888412469b3c9c09$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== "function") throw new TypeError("Value assigned to `logHandler` must be a function");
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $888412469b3c9c09$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $888412469b3c9c09$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $888412469b3c9c09$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $888412469b3c9c09$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $888412469b3c9c09$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $888412469b3c9c09$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $888412469b3c9c09$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $888412469b3c9c09$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $888412469b3c9c09$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $888412469b3c9c09$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $888412469b3c9c09$export$c622e99c0ce7b1c9(level) {
    $888412469b3c9c09$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $888412469b3c9c09$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $888412469b3c9c09$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $888412469b3c9c09$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === "string") return arg;
                else if (typeof arg === "number" || typeof arg === "boolean") return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(" ");
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $888412469b3c9c09$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



const $f3ec9a1a57f632b6$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $f3ec9a1a57f632b6$var$idbProxyableTypes;
let $f3ec9a1a57f632b6$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $f3ec9a1a57f632b6$var$getIdbProxyableTypes() {
    return $f3ec9a1a57f632b6$var$idbProxyableTypes || ($f3ec9a1a57f632b6$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $f3ec9a1a57f632b6$var$getCursorAdvanceMethods() {
    return $f3ec9a1a57f632b6$var$cursorAdvanceMethods || ($f3ec9a1a57f632b6$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $f3ec9a1a57f632b6$var$cursorRequestMap = new WeakMap();
const $f3ec9a1a57f632b6$var$transactionDoneMap = new WeakMap();
const $f3ec9a1a57f632b6$var$transactionStoreNamesMap = new WeakMap();
const $f3ec9a1a57f632b6$var$transformCache = new WeakMap();
const $f3ec9a1a57f632b6$export$407448d2b89b1813 = new WeakMap();
function $f3ec9a1a57f632b6$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        const success = ()=>{
            resolve($f3ec9a1a57f632b6$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $f3ec9a1a57f632b6$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $f3ec9a1a57f632b6$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $f3ec9a1a57f632b6$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($f3ec9a1a57f632b6$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $f3ec9a1a57f632b6$var$transactionDoneMap.set(tx, done);
}
let $f3ec9a1a57f632b6$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $f3ec9a1a57f632b6$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || $f3ec9a1a57f632b6$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $f3ec9a1a57f632b6$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $f3ec9a1a57f632b6$export$43caf9889c228507(callback) {
    $f3ec9a1a57f632b6$var$idbProxyTraps = callback($f3ec9a1a57f632b6$var$idbProxyTraps);
}
function $f3ec9a1a57f632b6$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($f3ec9a1a57f632b6$export$3b14a55fb2447963(this), storeNames, ...args);
        $f3ec9a1a57f632b6$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $f3ec9a1a57f632b6$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($f3ec9a1a57f632b6$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($f3ec9a1a57f632b6$export$3b14a55fb2447963(this), args);
        return $f3ec9a1a57f632b6$export$efccba1c4a2ef57b($f3ec9a1a57f632b6$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $f3ec9a1a57f632b6$export$efccba1c4a2ef57b(func.apply($f3ec9a1a57f632b6$export$3b14a55fb2447963(this), args));
    };
}
function $f3ec9a1a57f632b6$var$transformCachableValue(value) {
    if (typeof value === "function") return $f3ec9a1a57f632b6$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $f3ec9a1a57f632b6$var$cacheDonePromiseForTransaction(value);
    if ($f3ec9a1a57f632b6$export$23f2a1d2818174ef(value, $f3ec9a1a57f632b6$var$getIdbProxyableTypes())) return new Proxy(value, $f3ec9a1a57f632b6$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $f3ec9a1a57f632b6$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $f3ec9a1a57f632b6$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($f3ec9a1a57f632b6$var$transformCache.has(value)) return $f3ec9a1a57f632b6$var$transformCache.get(value);
    const newValue = $f3ec9a1a57f632b6$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $f3ec9a1a57f632b6$var$transformCache.set(value, newValue);
        $f3ec9a1a57f632b6$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $f3ec9a1a57f632b6$export$3b14a55fb2447963 = (value)=>$f3ec9a1a57f632b6$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $5b02bbf4cfc2d7e8$export$ca0ed41b1a2af7e(name, version, { blocked: blocked , upgrade: upgrade , blocking: blocking , terminated: terminated  } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $f3ec9a1a57f632b6$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener("upgradeneeded", (event)=>{
        upgrade((0, $f3ec9a1a57f632b6$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $f3ec9a1a57f632b6$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener("close", ()=>terminated());
        if (blocking) db.addEventListener("versionchange", (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $5b02bbf4cfc2d7e8$export$9d6df0ac66a98bb2(name, { blocked: blocked  } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $f3ec9a1a57f632b6$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $5b02bbf4cfc2d7e8$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
const $5b02bbf4cfc2d7e8$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
const $5b02bbf4cfc2d7e8$var$cachedMethods = new Map();
function $5b02bbf4cfc2d7e8$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($5b02bbf4cfc2d7e8$var$cachedMethods.get(prop)) return $5b02bbf4cfc2d7e8$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, "");
    const useIndex = prop !== targetFuncName;
    const isWrite = $5b02bbf4cfc2d7e8$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $5b02bbf4cfc2d7e8$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $5b02bbf4cfc2d7e8$var$cachedMethods.set(prop, method);
    return method;
}
(0, $f3ec9a1a57f632b6$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$5b02bbf4cfc2d7e8$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$5b02bbf4cfc2d7e8$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e3a1e3018df58994$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($e3a1e3018df58994$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(" ");
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $e3a1e3018df58994$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const $e3a1e3018df58994$var$name$o = "@firebase/app";
const $e3a1e3018df58994$var$version$1 = "0.9.12";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e3a1e3018df58994$var$logger = new (0, $888412469b3c9c09$export$efa9a398d6368992)("@firebase/app");
const $e3a1e3018df58994$var$name$n = "@firebase/app-compat";
const $e3a1e3018df58994$var$name$m = "@firebase/analytics-compat";
const $e3a1e3018df58994$var$name$l = "@firebase/analytics";
const $e3a1e3018df58994$var$name$k = "@firebase/app-check-compat";
const $e3a1e3018df58994$var$name$j = "@firebase/app-check";
const $e3a1e3018df58994$var$name$i = "@firebase/auth";
const $e3a1e3018df58994$var$name$h = "@firebase/auth-compat";
const $e3a1e3018df58994$var$name$g = "@firebase/database";
const $e3a1e3018df58994$var$name$f = "@firebase/database-compat";
const $e3a1e3018df58994$var$name$e = "@firebase/functions";
const $e3a1e3018df58994$var$name$d = "@firebase/functions-compat";
const $e3a1e3018df58994$var$name$c = "@firebase/installations";
const $e3a1e3018df58994$var$name$b = "@firebase/installations-compat";
const $e3a1e3018df58994$var$name$a = "@firebase/messaging";
const $e3a1e3018df58994$var$name$9 = "@firebase/messaging-compat";
const $e3a1e3018df58994$var$name$8 = "@firebase/performance";
const $e3a1e3018df58994$var$name$7 = "@firebase/performance-compat";
const $e3a1e3018df58994$var$name$6 = "@firebase/remote-config";
const $e3a1e3018df58994$var$name$5 = "@firebase/remote-config-compat";
const $e3a1e3018df58994$var$name$4 = "@firebase/storage";
const $e3a1e3018df58994$var$name$3 = "@firebase/storage-compat";
const $e3a1e3018df58994$var$name$2 = "@firebase/firestore";
const $e3a1e3018df58994$var$name$1 = "@firebase/firestore-compat";
const $e3a1e3018df58994$var$name = "firebase";
const $e3a1e3018df58994$var$version = "9.22.2";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $e3a1e3018df58994$export$9f30fa0c10967f7f = "[DEFAULT]";
const $e3a1e3018df58994$var$PLATFORM_LOG_STRING = {
    [$e3a1e3018df58994$var$name$o]: "fire-core",
    [$e3a1e3018df58994$var$name$n]: "fire-core-compat",
    [$e3a1e3018df58994$var$name$l]: "fire-analytics",
    [$e3a1e3018df58994$var$name$m]: "fire-analytics-compat",
    [$e3a1e3018df58994$var$name$j]: "fire-app-check",
    [$e3a1e3018df58994$var$name$k]: "fire-app-check-compat",
    [$e3a1e3018df58994$var$name$i]: "fire-auth",
    [$e3a1e3018df58994$var$name$h]: "fire-auth-compat",
    [$e3a1e3018df58994$var$name$g]: "fire-rtdb",
    [$e3a1e3018df58994$var$name$f]: "fire-rtdb-compat",
    [$e3a1e3018df58994$var$name$e]: "fire-fn",
    [$e3a1e3018df58994$var$name$d]: "fire-fn-compat",
    [$e3a1e3018df58994$var$name$c]: "fire-iid",
    [$e3a1e3018df58994$var$name$b]: "fire-iid-compat",
    [$e3a1e3018df58994$var$name$a]: "fire-fcm",
    [$e3a1e3018df58994$var$name$9]: "fire-fcm-compat",
    [$e3a1e3018df58994$var$name$8]: "fire-perf",
    [$e3a1e3018df58994$var$name$7]: "fire-perf-compat",
    [$e3a1e3018df58994$var$name$6]: "fire-rc",
    [$e3a1e3018df58994$var$name$5]: "fire-rc-compat",
    [$e3a1e3018df58994$var$name$4]: "fire-gcs",
    [$e3a1e3018df58994$var$name$3]: "fire-gcs-compat",
    [$e3a1e3018df58994$var$name$2]: "fire-fst",
    [$e3a1e3018df58994$var$name$1]: "fire-fst-compat",
    "fire-js": "fire-js",
    [$e3a1e3018df58994$var$name]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $e3a1e3018df58994$export$b4e3c36c855b14b5 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e3a1e3018df58994$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $e3a1e3018df58994$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $e3a1e3018df58994$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $e3a1e3018df58994$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $e3a1e3018df58994$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($e3a1e3018df58994$export$9566bce3835c0f28.has(componentName)) {
        $e3a1e3018df58994$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $e3a1e3018df58994$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $e3a1e3018df58994$export$b4e3c36c855b14b5.values())$e3a1e3018df58994$export$fa5244b94c62d36a(app, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $e3a1e3018df58994$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider("heartbeat").getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $e3a1e3018df58994$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $e3a1e3018df58994$export$9f30fa0c10967f7f) {
    $e3a1e3018df58994$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 * Test only
 *
 * @internal
 */ function $e3a1e3018df58994$export$3685d89b9c3cdfaf() {
    $e3a1e3018df58994$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e3a1e3018df58994$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["no-options" /* AppError.NO_OPTIONS */ ]: "Need to provide options, when not being deployed to hosting via source.",
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: "First argument to `onLog` must be null or a function.",
    ["idb-open" /* AppError.IDB_OPEN */ ]: "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-get" /* AppError.IDB_GET */ ]: "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-set" /* AppError.IDB_WRITE */ ]: "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-delete" /* AppError.IDB_DELETE */ ]: "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}."
};
const $e3a1e3018df58994$var$ERROR_FACTORY = new (0, $fc59d49e1bb53b6a$export$3fa6e1b18a3b2d40)("app", "Firebase", $e3a1e3018df58994$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e3a1e3018df58994$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $e04d5da8f80f59f8$export$16fa2f45be04daa8)("app", ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $e3a1e3018df58994$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $e3a1e3018df58994$export$31499a9cd224b78c = $e3a1e3018df58994$var$version;
function $e3a1e3018df58994$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== "object") {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $e3a1e3018df58994$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    const name = config.name;
    if (typeof name !== "string" || !name) throw $e3a1e3018df58994$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $fc59d49e1bb53b6a$export$3dfb6827a9f89756)());
    if (!options) throw $e3a1e3018df58994$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $e3a1e3018df58994$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $fc59d49e1bb53b6a$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $fc59d49e1bb53b6a$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $e3a1e3018df58994$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $e04d5da8f80f59f8$export$436a80eea5d5c0c5)(name);
    for (const component of $e3a1e3018df58994$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $e3a1e3018df58994$var$FirebaseAppImpl(options, config, container);
    $e3a1e3018df58994$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $e3a1e3018df58994$export$f9962582c9e66d99(name = $e3a1e3018df58994$export$9f30fa0c10967f7f) {
    const app = $e3a1e3018df58994$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $e3a1e3018df58994$export$9f30fa0c10967f7f && (0, $fc59d49e1bb53b6a$export$3dfb6827a9f89756)()) return $e3a1e3018df58994$export$c55cfd413944906d();
    if (!app) throw $e3a1e3018df58994$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $e3a1e3018df58994$export$68ddedf7d44b3bdf() {
    return Array.from($e3a1e3018df58994$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $e3a1e3018df58994$export$6eec44aa53d5ea34(app) {
    const name = app.name;
    if ($e3a1e3018df58994$export$b4e3c36c855b14b5.has(name)) {
        $e3a1e3018df58994$export$b4e3c36c855b14b5.delete(name);
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $e3a1e3018df58994$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $e3a1e3018df58994$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push("and");
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $e3a1e3018df58994$var$logger.warn(warning.join(" "));
        return;
    }
    $e3a1e3018df58994$export$c930050e7bb63965(new (0, $e04d5da8f80f59f8$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $e3a1e3018df58994$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== "function") throw $e3a1e3018df58994$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $888412469b3c9c09$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $e3a1e3018df58994$export$c622e99c0ce7b1c9(logLevel) {
    (0, $888412469b3c9c09$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e3a1e3018df58994$var$DB_NAME = "firebase-heartbeat-database";
const $e3a1e3018df58994$var$DB_VERSION = 1;
const $e3a1e3018df58994$var$STORE_NAME = "firebase-heartbeat-store";
let $e3a1e3018df58994$var$dbPromise = null;
function $e3a1e3018df58994$var$getDbPromise() {
    if (!$e3a1e3018df58994$var$dbPromise) $e3a1e3018df58994$var$dbPromise = (0, $5b02bbf4cfc2d7e8$export$ca0ed41b1a2af7e)($e3a1e3018df58994$var$DB_NAME, $e3a1e3018df58994$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($e3a1e3018df58994$var$STORE_NAME);
            }
        }
    }).catch((e)=>{
        throw $e3a1e3018df58994$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $e3a1e3018df58994$var$dbPromise;
}
async function $e3a1e3018df58994$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $e3a1e3018df58994$var$getDbPromise();
        const result = await db.transaction($e3a1e3018df58994$var$STORE_NAME).objectStore($e3a1e3018df58994$var$STORE_NAME).get($e3a1e3018df58994$var$computeKey(app));
        return result;
    } catch (e) {
        if (e instanceof (0, $fc59d49e1bb53b6a$export$dd24e9cd51226c56)) $e3a1e3018df58994$var$logger.warn(e.message);
        else {
            const idbGetError = $e3a1e3018df58994$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $e3a1e3018df58994$var$logger.warn(idbGetError.message);
        }
    }
}
async function $e3a1e3018df58994$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $e3a1e3018df58994$var$getDbPromise();
        const tx = db.transaction($e3a1e3018df58994$var$STORE_NAME, "readwrite");
        const objectStore = tx.objectStore($e3a1e3018df58994$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $e3a1e3018df58994$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $fc59d49e1bb53b6a$export$dd24e9cd51226c56)) $e3a1e3018df58994$var$logger.warn(e.message);
        else {
            const idbGetError = $e3a1e3018df58994$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $e3a1e3018df58994$var$logger.warn(idbGetError.message);
        }
    }
}
function $e3a1e3018df58994$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e3a1e3018df58994$var$MAX_HEADER_BYTES = 1024;
// 30 days
const $e3a1e3018df58994$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 2592000000;
class $e3a1e3018df58994$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider("app").getImmediate();
        this._storage = new $e3a1e3018df58994$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        const platformLogger = this.container.getProvider("platform-logger").getImmediate();
        // This is the "Firebase user agent" string from the platform logger
        // service, not the browser user agent.
        const agent = platformLogger.getPlatformInfoString();
        const date = $e3a1e3018df58994$var$getUTCDateString();
        if (this._heartbeatsCache === null) this._heartbeatsCache = await this._heartbeatsCachePromise;
        // Do not store a heartbeat if one is already stored for this day
        // or if a header has already been sent today.
        if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
        else // There is no entry for this date. Create one.
        this._heartbeatsCache.heartbeats.push({
            date: date,
            agent: agent
        });
        // Remove entries older than 30 days.
        this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((singleDateHeartbeat)=>{
            const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
            const now = Date.now();
            return now - hbTimestamp <= $e3a1e3018df58994$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
        });
        return this._storage.overwrite(this._heartbeatsCache);
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
        // If it's still null or the array is empty, there is no data to send.
        if (this._heartbeatsCache === null || this._heartbeatsCache.heartbeats.length === 0) return "";
        const date = $e3a1e3018df58994$var$getUTCDateString();
        // Extract as many heartbeats from the cache as will fit under the size limit.
        const { heartbeatsToSend: heartbeatsToSend , unsentEntries: unsentEntries  } = $e3a1e3018df58994$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
        const headerString = (0, $fc59d49e1bb53b6a$export$4b5284a3025a455)(JSON.stringify({
            version: 2,
            heartbeats: heartbeatsToSend
        }));
        // Store last sent date to prevent another being logged/sent for the same day.
        this._heartbeatsCache.lastSentHeartbeatDate = date;
        if (unsentEntries.length > 0) {
            // Store any unsent entries if they exist.
            this._heartbeatsCache.heartbeats = unsentEntries;
            // This seems more likely than emptying the array (below) to lead to some odd state
            // since the cache isn't empty and this will be called again on the next request,
            // and is probably safest if we await it.
            await this._storage.overwrite(this._heartbeatsCache);
        } else {
            this._heartbeatsCache.heartbeats = [];
            this._storage.overwrite(this._heartbeatsCache);
        }
        return headerString;
    }
}
function $e3a1e3018df58994$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $e3a1e3018df58994$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $e3a1e3018df58994$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($e3a1e3018df58994$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($e3a1e3018df58994$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $e3a1e3018df58994$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $fc59d49e1bb53b6a$export$3865db50535c2055)()) return false;
        else return (0, $fc59d49e1bb53b6a$export$a8a3018f3d187a4d)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $e3a1e3018df58994$var$readHeartbeatsFromIndexedDB(this.app);
            return idbHeartbeatObject || {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $e3a1e3018df58994$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $e3a1e3018df58994$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $e3a1e3018df58994$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $fc59d49e1bb53b6a$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e3a1e3018df58994$var$registerCoreComponents(variant) {
    $e3a1e3018df58994$export$c930050e7bb63965(new (0, $e04d5da8f80f59f8$export$16fa2f45be04daa8)("platform-logger", (container)=>new $e3a1e3018df58994$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $e3a1e3018df58994$export$c930050e7bb63965(new (0, $e04d5da8f80f59f8$export$16fa2f45be04daa8)("heartbeat", (container)=>new $e3a1e3018df58994$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $e3a1e3018df58994$export$d29d5299a7137abc($e3a1e3018df58994$var$name$o, $e3a1e3018df58994$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    $e3a1e3018df58994$export$d29d5299a7137abc($e3a1e3018df58994$var$name$o, $e3a1e3018df58994$var$version$1, "esm2017");
    // Register platform SDK identifier (no version).
    $e3a1e3018df58994$export$d29d5299a7137abc("fire-js", "");
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $e3a1e3018df58994$var$registerCoreComponents("");


var $98819dd33866ab51$var$name = "firebase";
var $98819dd33866ab51$var$version = "9.22.2";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $e3a1e3018df58994$export$d29d5299a7137abc)($98819dd33866ab51$var$name, $98819dd33866ab51$var$version, "app");




/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $3737ada54a48cfc7$var$extendStatics = function(d, b) {
    $3737ada54a48cfc7$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $3737ada54a48cfc7$var$extendStatics(d, b);
};
function $3737ada54a48cfc7$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $3737ada54a48cfc7$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3737ada54a48cfc7$export$18ce0697a983be9b = function() {
    $3737ada54a48cfc7$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3737ada54a48cfc7$export$18ce0697a983be9b.apply(this, arguments);
};
function $3737ada54a48cfc7$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3737ada54a48cfc7$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $3737ada54a48cfc7$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $3737ada54a48cfc7$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $3737ada54a48cfc7$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $3737ada54a48cfc7$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $3737ada54a48cfc7$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $3737ada54a48cfc7$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $3737ada54a48cfc7$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $3737ada54a48cfc7$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $3737ada54a48cfc7$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $3737ada54a48cfc7$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $3737ada54a48cfc7$export$45d3717a4c69092e(o, m, p);
}
function $3737ada54a48cfc7$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $3737ada54a48cfc7$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $3737ada54a48cfc7$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($3737ada54a48cfc7$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $3737ada54a48cfc7$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $3737ada54a48cfc7$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $3737ada54a48cfc7$export$10c90e4f7922046c(v) {
    return this instanceof $3737ada54a48cfc7$export$10c90e4f7922046c ? (this.v = v, this) : new $3737ada54a48cfc7$export$10c90e4f7922046c(v);
}
function $3737ada54a48cfc7$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $3737ada54a48cfc7$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $3737ada54a48cfc7$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $3737ada54a48cfc7$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $3737ada54a48cfc7$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $3737ada54a48cfc7$export$19a8beecd37a4c45 === "function" ? $3737ada54a48cfc7$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $3737ada54a48cfc7$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $3737ada54a48cfc7$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $3737ada54a48cfc7$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3737ada54a48cfc7$export$45d3717a4c69092e(result, mod, k);
    }
    $3737ada54a48cfc7$var$__setModuleDefault(result, mod);
    return result;
}
function $3737ada54a48cfc7$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $3737ada54a48cfc7$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $3737ada54a48cfc7$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $3737ada54a48cfc7$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
var $3737ada54a48cfc7$export$2e2bcd8739ae039 = {
    __extends: $3737ada54a48cfc7$export$a8ba968b8961cb8a,
    __assign: $3737ada54a48cfc7$export$18ce0697a983be9b,
    __rest: $3737ada54a48cfc7$export$3c9a16f847548506,
    __decorate: $3737ada54a48cfc7$export$29e00dfd3077644b,
    __param: $3737ada54a48cfc7$export$d5ad3fd78186038f,
    __metadata: $3737ada54a48cfc7$export$f1db080c865becb9,
    __awaiter: $3737ada54a48cfc7$export$1050f835b63b671e,
    __generator: $3737ada54a48cfc7$export$67ebef60e6f28a6,
    __createBinding: $3737ada54a48cfc7$export$45d3717a4c69092e,
    __exportStar: $3737ada54a48cfc7$export$f33643c0debef087,
    __values: $3737ada54a48cfc7$export$19a8beecd37a4c45,
    __read: $3737ada54a48cfc7$export$8d051b38c9118094,
    __spread: $3737ada54a48cfc7$export$afc72e2116322959,
    __spreadArrays: $3737ada54a48cfc7$export$6388937ca91ccae8,
    __spreadArray: $3737ada54a48cfc7$export$1216008129fb82ed,
    __await: $3737ada54a48cfc7$export$10c90e4f7922046c,
    __asyncGenerator: $3737ada54a48cfc7$export$e427f37a30a4de9b,
    __asyncDelegator: $3737ada54a48cfc7$export$bbd80228419bb833,
    __asyncValues: $3737ada54a48cfc7$export$e3b29a3d6162315f,
    __makeTemplateObject: $3737ada54a48cfc7$export$4fb47efe1390b86f,
    __importStar: $3737ada54a48cfc7$export$c21735bcef00d192,
    __importDefault: $3737ada54a48cfc7$export$da59b14a69baef04,
    __classPrivateFieldGet: $3737ada54a48cfc7$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $3737ada54a48cfc7$export$d40a35129aaff81f,
    __classPrivateFieldIn: $3737ada54a48cfc7$export$81fdc39f203e4e04
};




/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const $8dac729f232ba11e$export$d66501df72047452 = {
    /** Phone as second factor */ PHONE: "phone",
    TOTP: "totp"
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const $8dac729f232ba11e$export$ffb5f4729a158638 = {
    /** Facebook provider ID */ FACEBOOK: "facebook.com",
    /** GitHub provider ID */ GITHUB: "github.com",
    /** Google provider ID */ GOOGLE: "google.com",
    /** Password provider */ PASSWORD: "password",
    /** Phone provider */ PHONE: "phone",
    /** Twitter provider ID */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const $8dac729f232ba11e$export$25ce5a424b770e84 = {
    /** Email link sign in method */ EMAIL_LINK: "emailLink",
    /** Email/password sign in method */ EMAIL_PASSWORD: "password",
    /** Facebook sign in method */ FACEBOOK: "facebook.com",
    /** GitHub sign in method */ GITHUB: "github.com",
    /** Google sign in method */ GOOGLE: "google.com",
    /** Phone sign in method */ PHONE: "phone",
    /** Twitter sign in method */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const $8dac729f232ba11e$export$c4ce752e73470fba = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: "link",
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: "reauthenticate",
    /** Operation involving signing in a user. */ SIGN_IN: "signIn"
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const $8dac729f232ba11e$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: "EMAIL_SIGNIN",
    /** The password reset action. */ PASSWORD_RESET: "PASSWORD_RESET",
    /** The email revocation action. */ RECOVER_EMAIL: "RECOVER_EMAIL",
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: "REVERT_SECOND_FACTOR_ADDITION",
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: "VERIFY_AND_CHANGE_EMAIL",
    /** The email verification action. */ VERIFY_EMAIL: "VERIFY_EMAIL"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8dac729f232ba11e$var$_debugErrorMap() {
    return {
        ["admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ]: "This operation is restricted to administrators only.",
        ["argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ ]: "",
        ["app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* AuthErrorCode.CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ ]: "Cordova framework is not ready.",
        ["cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ ]: "This browser is not supported.",
        ["credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ]: "This credential is already associated with a different user account.",
        ["custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ]: "The custom token corresponds to a different audience.",
        ["requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: "Multi-factor users must always have a verified email.",
        ["email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ]: "The email address is already in use by another account.",
        ["emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ]: "The action code has expired.",
        ["cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ]: "This operation has been cancelled due to another conflicting popup being opened.",
        ["internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ]: "An internal AuthError has occurred.",
        ["invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ ]: "The mobile app identifier is not registed for the current project.",
        ["invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ ]: "An internal AuthError has occurred.",
        ["invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ ]: "The continue URL provided in the request is invalid.",
        ["invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ ]: "The custom token format is incorrect. Please check the documentation.",
        ["invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ ]: "The provided dynamic link domain is not configured or authorized for the current project.",
        ["invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ]: "The email address is badly formatted.",
        ["invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ ]: "Emulator URL must start with a valid scheme (http:// or https://).",
        ["invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ ]: "Your API key is invalid, please check you have copied it correctly.",
        ["invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ ]: "The SHA-1 certificate hash provided is invalid.",
        ["invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ ]: "The supplied auth credential is malformed or has expired.",
        ["invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ]: "The request does not contain a valid proof of first factor successful sign-in.",
        ["invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ]: "The password is invalid or the user does not have a password.",
        ["invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ ]: "The specified persistence type is invalid. It can only be local, session or none.",
        ["invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ ]: "The specified provider ID is invalid.",
        ["invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* AuthErrorCode.INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ]: "The verification ID used to create the phone auth credential is invalid.",
        ["invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ ]: "Login blocked by user-provided method: {$originalMessage}",
        ["missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ]: "An Android Package Name must be provided if the Android App is required to be installed.",
        ["auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* AuthErrorCode.MISSING_CODE */ ]: "The phone auth credential was created with an empty SMS verification code.",
        ["missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ ]: "A continue URL must be provided in the request.",
        ["missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ ]: "An internal AuthError has occurred.",
        ["missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ ]: "An iOS Bundle ID must be provided if an App Store ID is provided.",
        ["missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ]: "A non-empty password must be provided",
        ["missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ]: "No second factor identifier is provided.",
        ["missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ]: "The request is missing proof of first factor successful sign-in.",
        ["missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ ]: "To send verification codes, provide a phone number for the recipient.",
        ["missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ]: "The phone auth credential was created with an empty verification ID.",
        ["app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ ]: "This instance of FirebaseApp has been deleted.",
        ["multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ]: "The user does not have a second factor matching the identifier provided.",
        ["multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ]: "Proof of ownership of a second factor is required to complete sign-in.",
        ["account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ]: "A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.",
        ["no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ]: "An internal AuthError has occurred.",
        ["no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ]: "User was not linked to an account with the given provider.",
        ["null-user" /* AuthErrorCode.NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ ]: "Unable to establish a connection with the popup. It may have been blocked by the browser.",
        ["popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ]: "The popup has been closed by the user before finalizing the operation.",
        ["provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ ]: "User can only be linked to one identity for the given provider.",
        ["quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ ]: "The redirect operation has been cancelled by the user before finalizing.",
        ["redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ ]: "A redirect sign-in operation is already pending.",
        ["rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ ]: "The request contains malformed or mismatching credentials.",
        ["second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ]: "The second factor is already enrolled on this account.",
        ["maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "The maximum allowed number of second factors on a user has been exceeded.",
        ["tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* AuthErrorCode.TIMEOUT */ ]: "The operation has timed out.",
        ["user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ ]: "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.",
        ["unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ ]: "The current environment does not support the specified persistence type.",
        ["unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ ]: "This operation is not supported in a multi-tenant context.",
        ["unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ ]: "The operation requires a verified email.",
        ["user-cancelled" /* AuthErrorCode.USER_CANCELLED */ ]: "The user did not grant your application the permissions it requested.",
        ["user-not-found" /* AuthErrorCode.USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* AuthErrorCode.USER_DISABLED */ ]: "The user account has been disabled by an administrator.",
        ["user-mismatch" /* AuthErrorCode.USER_MISMATCH */ ]: "The supplied credentials do not correspond to the previously signed in user.",
        ["user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ ]: "",
        ["weak-password" /* AuthErrorCode.WEAK_PASSWORD */ ]: "The password must be 6 characters long or more.",
        ["web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ]: "This browser is not supported or 3rd party cookies and data may be disabled.",
        ["already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance.",
        ["missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ]: "The reCAPTCHA token is missing when sending request to the backend.",
        ["invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ]: "The reCAPTCHA token is invalid when sending request to the backend.",
        ["invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ]: "The reCAPTCHA action is invalid when sending request to the backend.",
        ["recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ]: "reCAPTCHA Enterprise integration is not enabled for this project.",
        ["missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ]: "The reCAPTCHA client type is missing when sending request to the backend.",
        ["missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ]: "The reCAPTCHA version is missing when sending request to the backend.",
        ["invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ]: "Invalid request parameters.",
        ["invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ]: "The reCAPTCHA version is invalid when sending request to the backend."
    };
}
function $8dac729f232ba11e$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $8dac729f232ba11e$export$96f57966bedc81b4 = $8dac729f232ba11e$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $8dac729f232ba11e$export$a9c23c6ac3fc3eca = $8dac729f232ba11e$var$_prodErrorMap;
const $8dac729f232ba11e$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $fc59d49e1bb53b6a$export$3fa6e1b18a3b2d40)("auth", "Firebase", $8dac729f232ba11e$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const $8dac729f232ba11e$export$2329c99376c9d0a4 = {
    ADMIN_ONLY_OPERATION: "auth/admin-restricted-operation",
    ARGUMENT_ERROR: "auth/argument-error",
    APP_NOT_AUTHORIZED: "auth/app-not-authorized",
    APP_NOT_INSTALLED: "auth/app-not-installed",
    CAPTCHA_CHECK_FAILED: "auth/captcha-check-failed",
    CODE_EXPIRED: "auth/code-expired",
    CORDOVA_NOT_READY: "auth/cordova-not-ready",
    CORS_UNSUPPORTED: "auth/cors-unsupported",
    CREDENTIAL_ALREADY_IN_USE: "auth/credential-already-in-use",
    CREDENTIAL_MISMATCH: "auth/custom-token-mismatch",
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "auth/requires-recent-login",
    DEPENDENT_SDK_INIT_BEFORE_AUTH: "auth/dependent-sdk-initialized-before-auth",
    DYNAMIC_LINK_NOT_ACTIVATED: "auth/dynamic-link-not-activated",
    EMAIL_CHANGE_NEEDS_VERIFICATION: "auth/email-change-needs-verification",
    EMAIL_EXISTS: "auth/email-already-in-use",
    EMULATOR_CONFIG_FAILED: "auth/emulator-config-failed",
    EXPIRED_OOB_CODE: "auth/expired-action-code",
    EXPIRED_POPUP_REQUEST: "auth/cancelled-popup-request",
    INTERNAL_ERROR: "auth/internal-error",
    INVALID_API_KEY: "auth/invalid-api-key",
    INVALID_APP_CREDENTIAL: "auth/invalid-app-credential",
    INVALID_APP_ID: "auth/invalid-app-id",
    INVALID_AUTH: "auth/invalid-user-token",
    INVALID_AUTH_EVENT: "auth/invalid-auth-event",
    INVALID_CERT_HASH: "auth/invalid-cert-hash",
    INVALID_CODE: "auth/invalid-verification-code",
    INVALID_CONTINUE_URI: "auth/invalid-continue-uri",
    INVALID_CORDOVA_CONFIGURATION: "auth/invalid-cordova-configuration",
    INVALID_CUSTOM_TOKEN: "auth/invalid-custom-token",
    INVALID_DYNAMIC_LINK_DOMAIN: "auth/invalid-dynamic-link-domain",
    INVALID_EMAIL: "auth/invalid-email",
    INVALID_EMULATOR_SCHEME: "auth/invalid-emulator-scheme",
    INVALID_IDP_RESPONSE: "auth/invalid-credential",
    INVALID_MESSAGE_PAYLOAD: "auth/invalid-message-payload",
    INVALID_MFA_SESSION: "auth/invalid-multi-factor-session",
    INVALID_OAUTH_CLIENT_ID: "auth/invalid-oauth-client-id",
    INVALID_OAUTH_PROVIDER: "auth/invalid-oauth-provider",
    INVALID_OOB_CODE: "auth/invalid-action-code",
    INVALID_ORIGIN: "auth/unauthorized-domain",
    INVALID_PASSWORD: "auth/wrong-password",
    INVALID_PERSISTENCE: "auth/invalid-persistence-type",
    INVALID_PHONE_NUMBER: "auth/invalid-phone-number",
    INVALID_PROVIDER_ID: "auth/invalid-provider-id",
    INVALID_RECIPIENT_EMAIL: "auth/invalid-recipient-email",
    INVALID_SENDER: "auth/invalid-sender",
    INVALID_SESSION_INFO: "auth/invalid-verification-id",
    INVALID_TENANT_ID: "auth/invalid-tenant-id",
    MFA_INFO_NOT_FOUND: "auth/multi-factor-info-not-found",
    MFA_REQUIRED: "auth/multi-factor-auth-required",
    MISSING_ANDROID_PACKAGE_NAME: "auth/missing-android-pkg-name",
    MISSING_APP_CREDENTIAL: "auth/missing-app-credential",
    MISSING_AUTH_DOMAIN: "auth/auth-domain-config-required",
    MISSING_CODE: "auth/missing-verification-code",
    MISSING_CONTINUE_URI: "auth/missing-continue-uri",
    MISSING_IFRAME_START: "auth/missing-iframe-start",
    MISSING_IOS_BUNDLE_ID: "auth/missing-ios-bundle-id",
    MISSING_OR_INVALID_NONCE: "auth/missing-or-invalid-nonce",
    MISSING_MFA_INFO: "auth/missing-multi-factor-info",
    MISSING_MFA_SESSION: "auth/missing-multi-factor-session",
    MISSING_PHONE_NUMBER: "auth/missing-phone-number",
    MISSING_SESSION_INFO: "auth/missing-verification-id",
    MODULE_DESTROYED: "auth/app-deleted",
    NEED_CONFIRMATION: "auth/account-exists-with-different-credential",
    NETWORK_REQUEST_FAILED: "auth/network-request-failed",
    NULL_USER: "auth/null-user",
    NO_AUTH_EVENT: "auth/no-auth-event",
    NO_SUCH_PROVIDER: "auth/no-such-provider",
    OPERATION_NOT_ALLOWED: "auth/operation-not-allowed",
    OPERATION_NOT_SUPPORTED: "auth/operation-not-supported-in-this-environment",
    POPUP_BLOCKED: "auth/popup-blocked",
    POPUP_CLOSED_BY_USER: "auth/popup-closed-by-user",
    PROVIDER_ALREADY_LINKED: "auth/provider-already-linked",
    QUOTA_EXCEEDED: "auth/quota-exceeded",
    REDIRECT_CANCELLED_BY_USER: "auth/redirect-cancelled-by-user",
    REDIRECT_OPERATION_PENDING: "auth/redirect-operation-pending",
    REJECTED_CREDENTIAL: "auth/rejected-credential",
    SECOND_FACTOR_ALREADY_ENROLLED: "auth/second-factor-already-in-use",
    SECOND_FACTOR_LIMIT_EXCEEDED: "auth/maximum-second-factor-count-exceeded",
    TENANT_ID_MISMATCH: "auth/tenant-id-mismatch",
    TIMEOUT: "auth/timeout",
    TOKEN_EXPIRED: "auth/user-token-expired",
    TOO_MANY_ATTEMPTS_TRY_LATER: "auth/too-many-requests",
    UNAUTHORIZED_DOMAIN: "auth/unauthorized-continue-uri",
    UNSUPPORTED_FIRST_FACTOR: "auth/unsupported-first-factor",
    UNSUPPORTED_PERSISTENCE: "auth/unsupported-persistence-type",
    UNSUPPORTED_TENANT_OPERATION: "auth/unsupported-tenant-operation",
    UNVERIFIED_EMAIL: "auth/unverified-email",
    USER_CANCELLED: "auth/user-cancelled",
    USER_DELETED: "auth/user-not-found",
    USER_DISABLED: "auth/user-disabled",
    USER_MISMATCH: "auth/user-mismatch",
    USER_SIGNED_OUT: "auth/user-signed-out",
    WEAK_PASSWORD: "auth/weak-password",
    WEB_STORAGE_UNSUPPORTED: "auth/web-storage-unsupported",
    ALREADY_INITIALIZED: "auth/already-initialized",
    RECAPTCHA_NOT_ENABLED: "auth/recaptcha-not-enabled",
    MISSING_RECAPTCHA_TOKEN: "auth/missing-recaptcha-token",
    INVALID_RECAPTCHA_TOKEN: "auth/invalid-recaptcha-token",
    INVALID_RECAPTCHA_ACTION: "auth/invalid-recaptcha-action",
    MISSING_CLIENT_TYPE: "auth/missing-client-type",
    MISSING_RECAPTCHA_VERSION: "auth/missing-recaptcha-version",
    INVALID_RECAPTCHA_VERSION: "auth/invalid-recaptcha-version",
    INVALID_REQ_TYPE: "auth/invalid-req-type"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8dac729f232ba11e$var$logClient = new (0, $888412469b3c9c09$export$efa9a398d6368992)("@firebase/auth");
function $8dac729f232ba11e$var$_logWarn(msg, ...args) {
    if ($8dac729f232ba11e$var$logClient.logLevel <= (0, $888412469b3c9c09$export$243e62d78d3b544d).WARN) $8dac729f232ba11e$var$logClient.warn(`Auth (${(0, $e3a1e3018df58994$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
function $8dac729f232ba11e$var$_logError(msg, ...args) {
    if ($8dac729f232ba11e$var$logClient.logLevel <= (0, $888412469b3c9c09$export$243e62d78d3b544d).ERROR) $8dac729f232ba11e$var$logClient.error(`Auth (${(0, $e3a1e3018df58994$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8dac729f232ba11e$export$d66dc83d8cfc8dd(authOrCode, ...rest) {
    throw $8dac729f232ba11e$var$createErrorInternal(authOrCode, ...rest);
}
function $8dac729f232ba11e$export$3d12bd131bb975d1(authOrCode, ...rest) {
    return $8dac729f232ba11e$var$createErrorInternal(authOrCode, ...rest);
}
function $8dac729f232ba11e$var$_errorWithCustomMessage(auth, code, message) {
    const errorMap = Object.assign(Object.assign({}, $8dac729f232ba11e$export$a9c23c6ac3fc3eca()), {
        [code]: message
    });
    const factory = new (0, $fc59d49e1bb53b6a$export$3fa6e1b18a3b2d40)("auth", "Firebase", errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $8dac729f232ba11e$var$_assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $8dac729f232ba11e$export$d66dc83d8cfc8dd(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw $8dac729f232ba11e$var$_errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function $8dac729f232ba11e$var$createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== "string") {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return $8dac729f232ba11e$var$_DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function $8dac729f232ba11e$export$91c6e00c14e7e6fd(assertion, authOrCode, ...rest) {
    if (!assertion) throw $8dac729f232ba11e$var$createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $8dac729f232ba11e$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    $8dac729f232ba11e$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $8dac729f232ba11e$export$6554612db691658e(assertion, message) {
    if (!assertion) $8dac729f232ba11e$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8dac729f232ba11e$var$_getCurrentUrl() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.href) || "";
}
function $8dac729f232ba11e$var$_isHttpOrHttps() {
    return $8dac729f232ba11e$var$_getCurrentScheme() === "http:" || $8dac729f232ba11e$var$_getCurrentScheme() === "https:";
}
function $8dac729f232ba11e$var$_getCurrentScheme() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $8dac729f232ba11e$var$_isOnline() {
    if (typeof navigator !== "undefined" && navigator && "onLine" in navigator && typeof navigator.onLine === "boolean" && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($8dac729f232ba11e$var$_isHttpOrHttps() || (0, $fc59d49e1bb53b6a$export$caa8774a9107a58e)() || "connection" in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $8dac729f232ba11e$var$_getUserLanguage() {
    if (typeof navigator === "undefined") return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class $8dac729f232ba11e$var$Delay {
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $8dac729f232ba11e$export$6554612db691658e(longDelay > shortDelay, "Short delay should be less than long delay!");
        this.isMobile = (0, $fc59d49e1bb53b6a$export$872f8323f01d7ae0)() || (0, $fc59d49e1bb53b6a$export$f7a1e23e542d38e3)();
    }
    get() {
        if (!$8dac729f232ba11e$var$_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8dac729f232ba11e$var$_emulatorUrl(config, path) {
    $8dac729f232ba11e$export$6554612db691658e(config.emulator, "Emulator should always be set here");
    const { url: url  } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith("/") ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8dac729f232ba11e$export$faec65b429be379 {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== "undefined" && "fetch" in self) return self.fetch;
        $8dac729f232ba11e$var$debugFail("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== "undefined" && "Headers" in self) return self.Headers;
        $8dac729f232ba11e$var$debugFail("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== "undefined" && "Response" in self) return self.Response;
        $8dac729f232ba11e$var$debugFail("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const $8dac729f232ba11e$var$SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ ]: "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ ]: "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ ]: "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ]: "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ ,
    ["INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ ]: "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ ]: "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ ]: "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* ServerError.INVALID_CODE */ ]: "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ ,
    ["MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ ]: "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ ]: "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Recaptcha related errors.
    ["RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ ]: "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ,
    ["MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ ]: "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ ]: "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ ]: "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ,
    ["MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ ]: "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ,
    ["MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ ]: "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ,
    ["INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ ]: "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ,
    ["INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ ]: "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8dac729f232ba11e$var$DEFAULT_API_TIMEOUT_MS = new $8dac729f232ba11e$var$Delay(30000, 60000);
function $8dac729f232ba11e$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return Object.assign(Object.assign({}, request), {
        tenantId: auth.tenantId
    });
    return request;
}
async function $8dac729f232ba11e$var$_performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return $8dac729f232ba11e$var$_performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* HttpMethod.GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, $fc59d49e1bb53b6a$export$ac4103b836844853)(Object.assign({
            key: auth.config.apiKey
        }, params)).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/json";
        if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
        return $8dac729f232ba11e$export$faec65b429be379.fetch()($8dac729f232ba11e$var$_getFinalTarget(auth, auth.config.apiHost, path, query), Object.assign({
            method: method,
            headers: headers,
            referrerPolicy: "no-referrer"
        }, body));
    });
}
async function $8dac729f232ba11e$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = Object.assign(Object.assign({}, $8dac729f232ba11e$var$SERVER_ERROR_MAP), customErrorMap);
    try {
        const networkTimeout = new $8dac729f232ba11e$var$NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ("needConfirmation" in json) throw $8dac729f232ba11e$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
        if (response.ok && !("errorMessage" in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(" : ");
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $8dac729f232ba11e$var$_makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw $8dac729f232ba11e$var$_makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
            else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw $8dac729f232ba11e$var$_makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, "-");
            if (serverErrorMessage) throw $8dac729f232ba11e$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
            else $8dac729f232ba11e$export$d66dc83d8cfc8dd(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, $fc59d49e1bb53b6a$export$dd24e9cd51226c56)) throw e;
        // Changing this to a different error code will log user out when there is a network error
        // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
        // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
        $8dac729f232ba11e$export$d66dc83d8cfc8dd(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
            "message": String(e)
        });
    }
}
async function $8dac729f232ba11e$var$_performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await $8dac729f232ba11e$var$_performApiRequest(auth, method, path, request, customErrorMap);
    if ("mfaPendingCredential" in serverResponse) $8dac729f232ba11e$export$d66dc83d8cfc8dd(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
function $8dac729f232ba11e$var$_getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    if (!auth.config.emulator) return `${auth.config.apiScheme}://${base}`;
    return $8dac729f232ba11e$var$_emulatorUrl(auth.config, base);
}
class $8dac729f232ba11e$var$NetworkTimeout {
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject($8dac729f232ba11e$export$3d12bd131bb975d1(this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $8dac729f232ba11e$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
}
function $8dac729f232ba11e$var$_makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = $8dac729f232ba11e$export$3d12bd131bb975d1(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8dac729f232ba11e$var$deleteAccount(auth, request) {
    return $8dac729f232ba11e$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request);
}
async function $8dac729f232ba11e$var$deleteLinkedAccounts(auth, request) {
    return $8dac729f232ba11e$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function $8dac729f232ba11e$var$getAccountInfo(auth, request) {
    return $8dac729f232ba11e$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8dac729f232ba11e$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $8dac729f232ba11e$export$ab83b03e4111b1d0(user, forceRefresh = false) {
    return (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $8dac729f232ba11e$export$1a82df3d29112e01(user, forceRefresh = false) {
    const userInternal = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = $8dac729f232ba11e$var$_parseToken(token);
    $8dac729f232ba11e$export$91c6e00c14e7e6fd(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === "object" ? claims.firebase : undefined;
    const signInProvider = firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_provider"];
    return {
        claims: claims,
        token: token,
        authTime: $8dac729f232ba11e$var$utcTimestampToDateString($8dac729f232ba11e$var$secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: $8dac729f232ba11e$var$utcTimestampToDateString($8dac729f232ba11e$var$secondsStringToMilliseconds(claims.iat)),
        expirationTime: $8dac729f232ba11e$var$utcTimestampToDateString($8dac729f232ba11e$var$secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: (firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_second_factor"]) || null
    };
}
function $8dac729f232ba11e$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $8dac729f232ba11e$var$_parseToken(token) {
    const [algorithm, payload, signature] = token.split(".");
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $8dac729f232ba11e$var$_logError("JWT malformed, contained fewer than 3 sections");
        return null;
    }
    try {
        const decoded = (0, $fc59d49e1bb53b6a$export$c62426fdd000a97e)(payload);
        if (!decoded) {
            $8dac729f232ba11e$var$_logError("Failed to decode base64 JWT payload");
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $8dac729f232ba11e$var$_logError("Caught error parsing JWT payload as JSON", e === null || e === void 0 ? void 0 : e.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $8dac729f232ba11e$var$_tokenExpiresIn(token) {
    const parsedToken = $8dac729f232ba11e$var$_parseToken(token);
    $8dac729f232ba11e$export$91c6e00c14e7e6fd(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $8dac729f232ba11e$export$91c6e00c14e7e6fd(typeof parsedToken.exp !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $8dac729f232ba11e$export$91c6e00c14e7e6fd(typeof parsedToken.iat !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8dac729f232ba11e$var$_logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, $fc59d49e1bb53b6a$export$dd24e9cd51226c56) && $8dac729f232ba11e$var$isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function $8dac729f232ba11e$var$isUserInvalidated({ code: code  }) {
    return code === `auth/${"user-disabled" /* AuthErrorCode.USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8dac729f232ba11e$var$ProactiveRefresh {
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        var _a;
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
            const expTime = (_a = this.user.stsTokenManager.expirationTime) !== null && _a !== void 0 ? _a : 0;
            const interval = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8dac729f232ba11e$var$UserMetadata {
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = $8dac729f232ba11e$var$utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = $8dac729f232ba11e$var$utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8dac729f232ba11e$var$_reloadWithoutSaving(user) {
    var _a;
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await $8dac729f232ba11e$var$_logoutIfInvalidated(user, $8dac729f232ba11e$var$getAccountInfo(auth, {
        idToken: idToken
    }));
    $8dac729f232ba11e$export$91c6e00c14e7e6fd(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = ((_a = coreAccount.providerUserInfo) === null || _a === void 0 ? void 0 : _a.length) ? $8dac729f232ba11e$var$extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = $8dac729f232ba11e$var$mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData: providerData,
        metadata: new $8dac729f232ba11e$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous: isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function $8dac729f232ba11e$export$2f6ca3d3b1f80bf5(user) {
    const userInternal = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(user);
    await $8dac729f232ba11e$var$_reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function $8dac729f232ba11e$var$mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function $8dac729f232ba11e$var$extractProviderData(providers) {
    return providers.map((_a)=>{
        var { providerId: providerId  } = _a, provider = (0, $3737ada54a48cfc7$export$3c9a16f847548506)(_a, [
            "providerId"
        ]);
        return {
            providerId: providerId,
            uid: provider.rawId || "",
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8dac729f232ba11e$var$requestStsToken(auth, refreshToken) {
    const response = await $8dac729f232ba11e$var$_performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, $fc59d49e1bb53b6a$export$ac4103b836844853)({
            "grant_type": "refresh_token",
            "refresh_token": refreshToken
        }).slice(1);
        const { tokenApiHost: tokenApiHost , apiKey: apiKey  } = auth.config;
        const url = $8dac729f232ba11e$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/x-www-form-urlencoded";
        return $8dac729f232ba11e$export$faec65b429be379.fetch()(url, {
            method: "POST" /* HttpMethod.POST */ ,
            headers: headers,
            body: body
        });
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class $8dac729f232ba11e$var$StsTokenManager {
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(typeof response.idToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(typeof response.refreshToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = "expiresIn" in response && typeof response.expiresIn !== "undefined" ? Number(response.expiresIn) : $8dac729f232ba11e$var$_tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(!this.accessToken || this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken: accessToken , refreshToken: refreshToken , expiresIn: expiresIn  } = await $8dac729f232ba11e$var$requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken: refreshToken , accessToken: accessToken , expirationTime: expirationTime  } = object;
        const manager = new $8dac729f232ba11e$var$StsTokenManager();
        if (refreshToken) {
            $8dac729f232ba11e$export$91c6e00c14e7e6fd(typeof refreshToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            $8dac729f232ba11e$export$91c6e00c14e7e6fd(typeof accessToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            $8dac729f232ba11e$export$91c6e00c14e7e6fd(typeof expirationTime === "number", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new $8dac729f232ba11e$var$StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return $8dac729f232ba11e$var$debugFail("not implemented");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8dac729f232ba11e$var$assertStringOrUndefined(assertion, appName) {
    $8dac729f232ba11e$export$91c6e00c14e7e6fd(typeof assertion === "string" || typeof assertion === "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName: appName
    });
}
class $8dac729f232ba11e$export$b9a6b53f9be3734 {
    constructor(_a){
        var { uid: uid , auth: auth , stsTokenManager: stsTokenManager  } = _a, opt = (0, $3737ada54a48cfc7$export$3c9a16f847548506)(_a, [
            "uid",
            "auth",
            "stsTokenManager"
        ]);
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new $8dac729f232ba11e$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [
            ...opt.providerData
        ] : [];
        this.metadata = new $8dac729f232ba11e$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await $8dac729f232ba11e$var$_logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(accessToken, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return $8dac729f232ba11e$export$1a82df3d29112e01(this, forceRefresh);
    }
    reload() {
        return $8dac729f232ba11e$export$2f6ca3d3b1f80bf5(this);
    }
    _assign(user) {
        if (this === user) return;
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>Object.assign({}, userInfo));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        const newUser = new $8dac729f232ba11e$export$b9a6b53f9be3734(Object.assign(Object.assign({}, this), {
            auth: auth,
            stsTokenManager: this.stsTokenManager._clone()
        }));
        newUser.metadata._copy(this.metadata);
        return newUser;
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await $8dac729f232ba11e$var$_reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        const idToken = await this.getIdToken();
        await $8dac729f232ba11e$var$_logoutIfInvalidated(this, $8dac729f232ba11e$var$deleteAccount(this.auth, {
            idToken: idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return Object.assign(Object.assign({
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>Object.assign({}, userInfo)),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId
        }, this.metadata.toJSON()), {
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        });
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || "";
    }
    static _fromJSON(auth, object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const displayName = (_a = object.displayName) !== null && _a !== void 0 ? _a : undefined;
        const email = (_b = object.email) !== null && _b !== void 0 ? _b : undefined;
        const phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : undefined;
        const photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : undefined;
        const tenantId = (_e = object.tenantId) !== null && _e !== void 0 ? _e : undefined;
        const _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : undefined;
        const createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : undefined;
        const lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : undefined;
        const { uid: uid , emailVerified: emailVerified , isAnonymous: isAnonymous , providerData: providerData , stsTokenManager: plainObjectTokenManager  } = object;
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const stsTokenManager = $8dac729f232ba11e$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(typeof uid === "string", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $8dac729f232ba11e$var$assertStringOrUndefined(displayName, auth.name);
        $8dac729f232ba11e$var$assertStringOrUndefined(email, auth.name);
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(typeof emailVerified === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(typeof isAnonymous === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $8dac729f232ba11e$var$assertStringOrUndefined(phoneNumber, auth.name);
        $8dac729f232ba11e$var$assertStringOrUndefined(photoURL, auth.name);
        $8dac729f232ba11e$var$assertStringOrUndefined(tenantId, auth.name);
        $8dac729f232ba11e$var$assertStringOrUndefined(_redirectEventId, auth.name);
        $8dac729f232ba11e$var$assertStringOrUndefined(createdAt, auth.name);
        $8dac729f232ba11e$var$assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new $8dac729f232ba11e$export$b9a6b53f9be3734({
            uid: uid,
            auth: auth,
            email: email,
            emailVerified: emailVerified,
            displayName: displayName,
            isAnonymous: isAnonymous,
            photoURL: photoURL,
            phoneNumber: phoneNumber,
            tenantId: tenantId,
            stsTokenManager: stsTokenManager,
            createdAt: createdAt,
            lastLoginAt: lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>Object.assign({}, userInfo));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new $8dac729f232ba11e$var$StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new $8dac729f232ba11e$export$b9a6b53f9be3734({
            uid: idTokenResponse.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await $8dac729f232ba11e$var$_reloadWithoutSaving(user);
        return user;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8dac729f232ba11e$var$instanceCache = new Map();
function $8dac729f232ba11e$export$890c4ad488842ce7(cls) {
    $8dac729f232ba11e$export$6554612db691658e(cls instanceof Function, "Expected a class definition");
    let instance = $8dac729f232ba11e$var$instanceCache.get(cls);
    if (instance) {
        $8dac729f232ba11e$export$6554612db691658e(instance instanceof cls, "Instance stored in cache mismatched with class");
        return instance;
    }
    instance = new cls();
    $8dac729f232ba11e$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8dac729f232ba11e$var$InMemoryPersistence {
    constructor(){
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
$8dac729f232ba11e$var$InMemoryPersistence.type = "NONE";
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const $8dac729f232ba11e$export$a07804094c3ecf2d = $8dac729f232ba11e$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8dac729f232ba11e$export$24baa2b76016ce0e(key, apiKey, appName) {
    return `${"firebase" /* Namespace.PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class $8dac729f232ba11e$var$PersistenceUserManager {
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config: config , name: name  } = this.auth;
        this.fullUserKey = $8dac729f232ba11e$export$24baa2b76016ce0e(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $8dac729f232ba11e$export$24baa2b76016ce0e("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        return blob ? $8dac729f232ba11e$export$b9a6b53f9be3734._fromJSON(this.auth, blob) : null;
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* KeyName.AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new $8dac729f232ba11e$var$PersistenceUserManager($8dac729f232ba11e$export$890c4ad488842ce7($8dac729f232ba11e$export$a07804094c3ecf2d), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || $8dac729f232ba11e$export$890c4ad488842ce7($8dac729f232ba11e$export$a07804094c3ecf2d);
        const key = $8dac729f232ba11e$export$24baa2b76016ce0e(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                const user = $8dac729f232ba11e$export$b9a6b53f9be3734._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch (_a) {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new $8dac729f232ba11e$var$PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch (_a) {}
        }));
        return new $8dac729f232ba11e$var$PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $8dac729f232ba11e$var$_getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes("opera/") || ua.includes("opr/") || ua.includes("opios/")) return "Opera" /* BrowserName.OPERA */ ;
    else if ($8dac729f232ba11e$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes("msie") || ua.includes("trident/")) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes("edge/")) return "Edge" /* BrowserName.EDGE */ ;
    else if ($8dac729f232ba11e$var$_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes("silk/")) return "Silk" /* BrowserName.SILK */ ;
    else if ($8dac729f232ba11e$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if ($8dac729f232ba11e$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if ($8dac729f232ba11e$var$_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes("chrome/") || $8dac729f232ba11e$var$_isChromeIOS(ua)) && !ua.includes("edge/")) return "Chrome" /* BrowserName.CHROME */ ;
    else if ($8dac729f232ba11e$export$1fbe638ecf81657e(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function $8dac729f232ba11e$var$_isFirefox(ua = (0, $fc59d49e1bb53b6a$export$c36915b22ce77c19)()) {
    return /firefox\//i.test(ua);
}
function $8dac729f232ba11e$var$_isSafari(userAgent = (0, $fc59d49e1bb53b6a$export$c36915b22ce77c19)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes("safari/") && !ua.includes("chrome/") && !ua.includes("crios/") && !ua.includes("android");
}
function $8dac729f232ba11e$var$_isChromeIOS(ua = (0, $fc59d49e1bb53b6a$export$c36915b22ce77c19)()) {
    return /crios\//i.test(ua);
}
function $8dac729f232ba11e$var$_isIEMobile(ua = (0, $fc59d49e1bb53b6a$export$c36915b22ce77c19)()) {
    return /iemobile/i.test(ua);
}
function $8dac729f232ba11e$export$1fbe638ecf81657e(ua = (0, $fc59d49e1bb53b6a$export$c36915b22ce77c19)()) {
    return /android/i.test(ua);
}
function $8dac729f232ba11e$var$_isBlackBerry(ua = (0, $fc59d49e1bb53b6a$export$c36915b22ce77c19)()) {
    return /blackberry/i.test(ua);
}
function $8dac729f232ba11e$var$_isWebOS(ua = (0, $fc59d49e1bb53b6a$export$c36915b22ce77c19)()) {
    return /webos/i.test(ua);
}
function $8dac729f232ba11e$export$493d36ec626b6698(ua = (0, $fc59d49e1bb53b6a$export$c36915b22ce77c19)()) {
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function $8dac729f232ba11e$export$28f7fcd39efa255(ua = (0, $fc59d49e1bb53b6a$export$c36915b22ce77c19)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $8dac729f232ba11e$var$_isIOSStandalone(ua = (0, $fc59d49e1bb53b6a$export$c36915b22ce77c19)()) {
    var _a;
    return $8dac729f232ba11e$export$493d36ec626b6698(ua) && !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.standalone);
}
function $8dac729f232ba11e$var$_isIE10() {
    return (0, $fc59d49e1bb53b6a$export$7e7b1a9668aaed8)() && document.documentMode === 10;
}
function $8dac729f232ba11e$var$_isMobileBrowser(ua = (0, $fc59d49e1bb53b6a$export$c36915b22ce77c19)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return $8dac729f232ba11e$export$493d36ec626b6698(ua) || $8dac729f232ba11e$export$1fbe638ecf81657e(ua) || $8dac729f232ba11e$var$_isWebOS(ua) || $8dac729f232ba11e$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $8dac729f232ba11e$var$_isIEMobile(ua);
}
function $8dac729f232ba11e$var$_isIframe() {
    try {
        // Check that the current window is not the top window.
        // If so, return true.
        return !!(window && window !== window.top);
    } catch (e) {
        return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $8dac729f232ba11e$export$23ebac1979863676(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $8dac729f232ba11e$var$_getBrowserName((0, $fc59d49e1bb53b6a$export$c36915b22ce77c19)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${$8dac729f232ba11e$var$_getBrowserName((0, $fc59d49e1bb53b6a$export$c36915b22ce77c19)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(",") : "FirebaseCore-web"; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* ClientImplementation.CORE */ }/${0, $e3a1e3018df58994$export$31499a9cd224b78c}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8dac729f232ba11e$var$getRecaptchaParams(auth) {
    return (await $8dac729f232ba11e$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || "";
}
async function $8dac729f232ba11e$var$getRecaptchaConfig(auth, request) {
    return $8dac729f232ba11e$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , $8dac729f232ba11e$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8dac729f232ba11e$var$isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function $8dac729f232ba11e$var$isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
class $8dac729f232ba11e$var$RecaptchaConfig {
    constructor(response){
        /**
         * The reCAPTCHA site key.
         */ this.siteKey = "";
        /**
         * The reCAPTCHA enablement status of the {@link EmailAuthProvider} for the current tenant.
         */ this.emailPasswordEnabled = false;
        if (response.recaptchaKey === undefined) throw new Error("recaptchaKey undefined");
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split("/")[3];
        this.emailPasswordEnabled = response.recaptchaEnforcementState.some((enforcementState)=>enforcementState.provider === "EMAIL_PASSWORD_PROVIDER" && enforcementState.enforcementState !== "OFF");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8dac729f232ba11e$var$getScriptParentElement() {
    var _a, _b;
    return (_b = (_a = document.getElementsByTagName("head")) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : document;
}
function $8dac729f232ba11e$var$_loadJS(url) {
    // TODO: consider adding timeout support & cancellation
    return new Promise((resolve, reject)=>{
        const el = document.createElement("script");
        el.setAttribute("src", url);
        el.onload = resolve;
        el.onerror = (e)=>{
            const error = $8dac729f232ba11e$export$3d12bd131bb975d1("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            error.customData = e;
            reject(error);
        };
        el.type = "text/javascript";
        el.charset = "UTF-8";
        $8dac729f232ba11e$var$getScriptParentElement().appendChild(el);
    });
}
function $8dac729f232ba11e$var$_generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/* eslint-disable @typescript-eslint/no-require-imports */ const $8dac729f232ba11e$var$RECAPTCHA_ENTERPRISE_URL = "https://www.google.com/recaptcha/enterprise.js?render=";
const $8dac729f232ba11e$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = "recaptcha-enterprise";
const $8dac729f232ba11e$var$FAKE_TOKEN = "NO_RECAPTCHA";
class $8dac729f232ba11e$var$RecaptchaEnterpriseVerifier {
    /**
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     */ constructor(authExtern){
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = $8dac729f232ba11e$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = $8dac729f232ba11e$export$a33b77bbdbb8366c(authExtern);
    }
    /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ async verify(action = "verify", forceRefresh = false) {
        async function retrieveSiteKey(auth) {
            if (!forceRefresh) {
                if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return auth._agentRecaptchaConfig.siteKey;
                if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return auth._tenantRecaptchaConfigs[auth.tenantId].siteKey;
            }
            return new Promise(async (resolve, reject)=>{
                $8dac729f232ba11e$var$getRecaptchaConfig(auth, {
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }).then((response)=>{
                    if (response.recaptchaKey === undefined) reject(new Error("recaptcha Enterprise site key undefined"));
                    else {
                        const config = new $8dac729f232ba11e$var$RecaptchaConfig(response);
                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                        return resolve(config.siteKey);
                    }
                }).catch((error)=>{
                    reject(error);
                });
            });
        }
        function retrieveRecaptchaToken(siteKey, resolve, reject) {
            const grecaptcha = window.grecaptcha;
            if ($8dac729f232ba11e$var$isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(()=>{
                grecaptcha.enterprise.execute(siteKey, {
                    action: action
                }).then((token)=>{
                    resolve(token);
                }).catch(()=>{
                    resolve($8dac729f232ba11e$var$FAKE_TOKEN);
                });
            });
            else reject(Error("No reCAPTCHA enterprise script loaded."));
        }
        return new Promise((resolve, reject)=>{
            retrieveSiteKey(this.auth).then((siteKey)=>{
                if (!forceRefresh && $8dac729f232ba11e$var$isEnterprise(window.grecaptcha)) retrieveRecaptchaToken(siteKey, resolve, reject);
                else {
                    if (typeof window === "undefined") {
                        reject(new Error("RecaptchaVerifier is only supported in browser"));
                        return;
                    }
                    $8dac729f232ba11e$var$_loadJS($8dac729f232ba11e$var$RECAPTCHA_ENTERPRISE_URL + siteKey).then(()=>{
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                    }).catch((error)=>{
                        reject(error);
                    });
                }
            }).catch((error)=>{
                reject(error);
            });
        });
    }
}
async function $8dac729f232ba11e$var$injectRecaptchaFields(auth, request, action, captchaResp = false) {
    const verifier = new $8dac729f232ba11e$var$RecaptchaEnterpriseVerifier(auth);
    let captchaResponse;
    try {
        captchaResponse = await verifier.verify(action);
    } catch (error) {
        captchaResponse = await verifier.verify(action, true);
    }
    const newRequest = Object.assign({}, request);
    if (!captchaResp) Object.assign(newRequest, {
        captchaResponse: captchaResponse
    });
    else Object.assign(newRequest, {
        "captchaResp": captchaResponse
    });
    Object.assign(newRequest, {
        "clientType": "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    });
    Object.assign(newRequest, {
        "recaptchaVersion": "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    return newRequest;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8dac729f232ba11e$var$AuthMiddlewareQueue {
    constructor(auth){
        this.auth = auth;
        this.queue = [];
    }
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user)=>new Promise((resolve, reject)=>{
                try {
                    const result = callback(user);
                    // Either resolve with existing promise or wrap a non-promise
                    // return value into a promise.
                    resolve(result);
                } catch (e) {
                    // Sync callback throws.
                    reject(e);
                }
            });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return ()=>{
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = ()=>Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        if (this.auth.currentUser === nextUser) return;
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue){
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
            }
        } catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack)try {
                onAbort();
            } catch (_) {
            /* swallow error */ }
            throw this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                originalMessage: e === null || e === void 0 ? void 0 : e.message
            });
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8dac729f232ba11e$export$a05254e7c3aeba6e {
    constructor(app, heartbeatServiceProvider, appCheckServiceProvider, config){
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $8dac729f232ba11e$var$Subscription(this);
        this.idTokenSubscription = new $8dac729f232ba11e$var$Subscription(this);
        this.beforeStateQueue = new $8dac729f232ba11e$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $8dac729f232ba11e$var$_DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = $8dac729f232ba11e$export$890c4ad488842ce7(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            var _a, _b;
            if (this._deleted) return;
            this.persistenceManager = await $8dac729f232ba11e$var$PersistenceUserManager.create(this, persistenceHierarchy);
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if ((_a = this._popupRedirectResolver) === null || _a === void 0 ? void 0 : _a._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {
            /* Ignore the error */ }
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = ((_b = this.currentUser) === null || _b === void 0 ? void 0 : _b.uid) || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUser(popupRedirectResolver) {
        var _a;
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = await this.assertedPersistence.getCurrentUser();
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = (_a = this.redirectUser) === null || _a === void 0 ? void 0 : _a._redirectEventId;
            const storedUserEventId = futureCurrentUser === null || futureCurrentUser === void 0 ? void 0 : futureCurrentUser._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && (result === null || result === void 0 ? void 0 : result.user)) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) return this.directlySetCurrentUser(null);
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) try {
                await this.beforeStateQueue.runMiddleware(futureCurrentUser);
            } catch (e) {
                futureCurrentUser = previouslyStoredUser;
                // We know this is available since the bit is only set when the
                // resolver is available
                this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(e));
            }
            if (futureCurrentUser) return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            else return this.directlySetCurrentUser(null);
        }
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(this._popupRedirectResolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return this.directlySetCurrentUser(futureCurrentUser);
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await $8dac729f232ba11e$var$_reloadWithoutSaving(user);
        } catch (e) {
            if ((e === null || e === void 0 ? void 0 : e.code) !== `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = $8dac729f232ba11e$var$_getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(userExtern) : null;
        if (user) $8dac729f232ba11e$export$91c6e00c14e7e6fd(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) return;
        if (user) $8dac729f232ba11e$export$91c6e00c14e7e6fd(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
        if (!skipBeforeStateCallbacks) await this.beforeStateQueue.runMiddleware(user);
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence($8dac729f232ba11e$export$890c4ad488842ce7(persistence));
        });
    }
    async initializeRecaptchaConfig() {
        const response = await $8dac729f232ba11e$var$getRecaptchaConfig(this, {
            clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
            version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
        });
        const config = new $8dac729f232ba11e$var$RecaptchaConfig(response);
        if (this.tenantId == null) this._agentRecaptchaConfig = config;
        else this._tenantRecaptchaConfigs[this.tenantId] = config;
        if (config.emailPasswordEnabled) {
            const verifier = new $8dac729f232ba11e$var$RecaptchaEnterpriseVerifier(this);
            verifier.verify();
        }
    }
    _getRecaptchaConfig() {
        if (this.tenantId == null) return this._agentRecaptchaConfig;
        else return this._tenantRecaptchaConfigs[this.tenantId];
    }
    _getPersistence() {
        return this.assertedPersistence.persistence.type;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, $fc59d49e1bb53b6a$export$3fa6e1b18a3b2d40)("auth", "Firebase", errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    toJSON() {
        var _a;
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: (_a = this._currentUser) === null || _a === void 0 ? void 0 : _a.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && $8dac729f232ba11e$export$890c4ad488842ce7(popupRedirectResolver) || this._popupRedirectResolver;
            $8dac729f232ba11e$export$91c6e00c14e7e6fd(resolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await $8dac729f232ba11e$var$PersistenceUserManager.create(this, [
                $8dac729f232ba11e$export$890c4ad488842ce7(resolver._redirectPersistence)
            ], "redirectUser" /* KeyName.REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        var _a, _b;
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (((_a = this._currentUser) === null || _a === void 0 ? void 0 : _a._redirectEventId) === id) return this._currentUser;
        if (((_b = this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        var _a, _b;
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === "function" ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>cb(this.currentUser));
        if (typeof nextOrObserver === "function") return subscription.addObserver(nextOrObserver, error, completed);
        else return subscription.addObserver(nextOrObserver);
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) this._currentUser._stopProactiveRefresh();
        if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = $8dac729f232ba11e$export$23ebac1979863676(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        var _a;
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = this.app.options.appId;
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await ((_a = this.heartbeatServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getHeartbeatsHeader());
        if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
        // If the App Check service exists, add the App Check token in the headers
        const appCheckToken = await this._getAppCheckToken();
        if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
        return headers;
    }
    async _getAppCheckToken() {
        var _a;
        const appCheckTokenResult = await ((_a = this.appCheckServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getToken());
        if (appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.error) // Context: appCheck.getToken() will never throw even if an error happened.
        // In the error case, a dummy token will be returned along with an error field describing
        // the error. In general, we shouldn't care about the error condition and just use
        // the token (actual or dummy) to send requests.
        $8dac729f232ba11e$var$_logWarn(`Error while retrieving App Check token: ${appCheckTokenResult.error}`);
        return appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.token;
    }
}
/**
 * Method to be used to cast down to our private implmentation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $8dac729f232ba11e$export$a33b77bbdbb8366c(auth) {
    return (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(auth);
}
/** Helper class to wrap subscriber logic */ class $8dac729f232ba11e$var$Subscription {
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $fc59d49e1bb53b6a$export$364097d812234b3f)((observer)=>this.observer = observer);
    }
    get next() {
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $8dac729f232ba11e$export$7f8ddf7c7c20b3cd(app, deps) {
    const provider = (0, $e3a1e3018df58994$export$fa0d6da0f5838f50)(app, "auth");
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, $fc59d49e1bb53b6a$export$9cb4719e2e525b7a)(initialOptions, deps !== null && deps !== void 0 ? deps : {})) return auth;
        else $8dac729f232ba11e$export$d66dc83d8cfc8dd(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function $8dac729f232ba11e$var$_initializeAuthInstance(auth, deps) {
    const persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($8dac729f232ba11e$export$890c4ad488842ce7);
    if (deps === null || deps === void 0 ? void 0 : deps.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $8dac729f232ba11e$export$9bb611d729802a56(auth, url, options) {
    const authInternal = $8dac729f232ba11e$export$a33b77bbdbb8366c(auth);
    $8dac729f232ba11e$export$91c6e00c14e7e6fd(authInternal._canInitEmulator, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
    $8dac729f232ba11e$export$91c6e00c14e7e6fd(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!(options === null || options === void 0 ? void 0 : options.disableWarnings);
    const protocol = $8dac729f232ba11e$var$extractProtocol(url);
    const { host: host , port: port  } = $8dac729f232ba11e$var$extractHostAndPort(url);
    const portStr = port === null ? "" : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    authInternal.config.emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    authInternal.settings.appVerificationDisabledForTesting = true;
    authInternal.emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(":", ""),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    if (!disableWarnings) $8dac729f232ba11e$var$emitEmulatorWarning();
}
function $8dac729f232ba11e$var$extractProtocol(url) {
    const protocolEnd = url.indexOf(":");
    return protocolEnd < 0 ? "" : url.substr(0, protocolEnd + 1);
}
function $8dac729f232ba11e$var$extractHostAndPort(url) {
    const protocol = $8dac729f232ba11e$var$extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: "",
        port: null
    };
    const hostAndPort = authority[2].split("@").pop() || ""; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host: host,
            port: $8dac729f232ba11e$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(":");
        return {
            host: host,
            port: $8dac729f232ba11e$var$parsePort(port)
        };
    }
}
function $8dac729f232ba11e$var$parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $8dac729f232ba11e$var$emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement("p");
        const sty = el.style;
        el.innerText = "Running in emulator mode. Do not use with production credentials.";
        sty.position = "fixed";
        sty.width = "100%";
        sty.backgroundColor = "#ffffff";
        sty.border = ".1em solid #000000";
        sty.color = "#b50000";
        sty.bottom = "0px";
        sty.left = "0px";
        sty.margin = "0px";
        sty.zIndex = "10000";
        sty.textAlign = "center";
        el.classList.add("firebase-emulator-warning");
        document.body.appendChild(el);
    }
    if (typeof console !== "undefined" && typeof console.info === "function") console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== "undefined" && typeof document !== "undefined") {
        if (document.readyState === "loading") window.addEventListener("DOMContentLoaded", attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $8dac729f232ba11e$export$b4171a6734a65d42 {
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return $8dac729f232ba11e$var$debugFail("not implemented");
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return $8dac729f232ba11e$var$debugFail("not implemented");
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return $8dac729f232ba11e$var$debugFail("not implemented");
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return $8dac729f232ba11e$var$debugFail("not implemented");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8dac729f232ba11e$var$resetPassword(auth, request) {
    return $8dac729f232ba11e$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , $8dac729f232ba11e$var$_addTidIfNecessary(auth, request));
}
async function $8dac729f232ba11e$var$updateEmailPassword(auth, request) {
    return $8dac729f232ba11e$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function $8dac729f232ba11e$var$applyActionCode$1(auth, request) {
    return $8dac729f232ba11e$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , $8dac729f232ba11e$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8dac729f232ba11e$var$signInWithPassword(auth, request) {
    return $8dac729f232ba11e$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , $8dac729f232ba11e$var$_addTidIfNecessary(auth, request));
}
async function $8dac729f232ba11e$var$sendOobCode(auth, request) {
    return $8dac729f232ba11e$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , $8dac729f232ba11e$var$_addTidIfNecessary(auth, request));
}
async function $8dac729f232ba11e$var$sendEmailVerification$1(auth, request) {
    return $8dac729f232ba11e$var$sendOobCode(auth, request);
}
async function $8dac729f232ba11e$var$sendPasswordResetEmail$1(auth, request) {
    return $8dac729f232ba11e$var$sendOobCode(auth, request);
}
async function $8dac729f232ba11e$var$sendSignInLinkToEmail$1(auth, request) {
    return $8dac729f232ba11e$var$sendOobCode(auth, request);
}
async function $8dac729f232ba11e$var$verifyAndChangeEmail(auth, request) {
    return $8dac729f232ba11e$var$sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8dac729f232ba11e$var$signInWithEmailLink$1(auth, request) {
    return $8dac729f232ba11e$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $8dac729f232ba11e$var$_addTidIfNecessary(auth, request));
}
async function $8dac729f232ba11e$var$signInWithEmailLinkForLinking(auth, request) {
    return $8dac729f232ba11e$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $8dac729f232ba11e$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class $8dac729f232ba11e$export$3466f893ebf79586 extends $8dac729f232ba11e$export$b4171a6734a65d42 {
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* ProviderId.PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new $8dac729f232ba11e$export$3466f893ebf79586(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new $8dac729f232ba11e$export$3466f893ebf79586(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
            if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        var _a;
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                if ((_a = auth._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.emailPasswordEnabled) {
                    const requestWithRecaptcha = await $8dac729f232ba11e$var$injectRecaptchaFields(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ );
                    return $8dac729f232ba11e$var$signInWithPassword(auth, requestWithRecaptcha);
                } else return $8dac729f232ba11e$var$signInWithPassword(auth, request).catch(async (error)=>{
                    if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
                        console.log("Sign-in with email address and password is protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the sign-in flow.");
                        const requestWithRecaptcha = await $8dac729f232ba11e$var$injectRecaptchaFields(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ );
                        return $8dac729f232ba11e$var$signInWithPassword(auth, requestWithRecaptcha);
                    } else return Promise.reject(error);
                });
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $8dac729f232ba11e$var$signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $8dac729f232ba11e$export$d66dc83d8cfc8dd(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                return $8dac729f232ba11e$var$updateEmailPassword(auth, {
                    idToken: idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password
                });
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $8dac729f232ba11e$var$signInWithEmailLinkForLinking(auth, {
                    idToken: idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $8dac729f232ba11e$export$d66dc83d8cfc8dd(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8dac729f232ba11e$var$signInWithIdp(auth, request) {
    return $8dac729f232ba11e$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , $8dac729f232ba11e$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8dac729f232ba11e$var$IDP_REQUEST_URI$1 = "http://localhost";
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $8dac729f232ba11e$export$61196ced6d74a310 extends $8dac729f232ba11e$export$b4171a6734a65d42 {
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */ static _fromParams(params) {
        const cred = new $8dac729f232ba11e$export$61196ced6d74a310(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else $8dac729f232ba11e$export$d66dc83d8cfc8dd("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        const { providerId: providerId , signInMethod: signInMethod  } = obj, rest = (0, $3737ada54a48cfc7$export$3c9a16f847548506)(obj, [
            "providerId",
            "signInMethod"
        ]);
        if (!providerId || !signInMethod) return null;
        const cred = new $8dac729f232ba11e$export$61196ced6d74a310(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $8dac729f232ba11e$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $8dac729f232ba11e$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $8dac729f232ba11e$var$signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: $8dac729f232ba11e$var$IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody["id_token"] = this.idToken;
            if (this.accessToken) postBody["access_token"] = this.accessToken;
            if (this.secret) postBody["oauth_token_secret"] = this.secret;
            postBody["providerId"] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody["nonce"] = this.nonce;
            request.postBody = (0, $fc59d49e1bb53b6a$export$ac4103b836844853)(postBody);
        }
        return request;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8dac729f232ba11e$var$sendPhoneVerificationCode(auth, request) {
    return $8dac729f232ba11e$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , $8dac729f232ba11e$var$_addTidIfNecessary(auth, request));
}
async function $8dac729f232ba11e$var$signInWithPhoneNumber$1(auth, request) {
    return $8dac729f232ba11e$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $8dac729f232ba11e$var$_addTidIfNecessary(auth, request));
}
async function $8dac729f232ba11e$var$linkWithPhoneNumber$1(auth, request) {
    const response = await $8dac729f232ba11e$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $8dac729f232ba11e$var$_addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw $8dac729f232ba11e$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
    return response;
}
const $8dac729f232ba11e$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ 
};
async function $8dac729f232ba11e$var$verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = Object.assign(Object.assign({}, request), {
        operation: "REAUTH"
    });
    return $8dac729f232ba11e$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $8dac729f232ba11e$var$_addTidIfNecessary(auth, apiRequest), $8dac729f232ba11e$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class $8dac729f232ba11e$export$3a1a48c8f6ef640e extends $8dac729f232ba11e$export$b4171a6734a65d42 {
    constructor(params){
        super("phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        this.params = params;
    }
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new $8dac729f232ba11e$export$3a1a48c8f6ef640e({
            verificationId: verificationId,
            verificationCode: verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new $8dac729f232ba11e$export$3a1a48c8f6ef640e({
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return $8dac729f232ba11e$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return $8dac729f232ba11e$var$linkWithPhoneNumber$1(auth, Object.assign({
            idToken: idToken
        }, this._makeVerificationRequest()));
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return $8dac729f232ba11e$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof: temporaryProof , phoneNumber: phoneNumber , verificationId: verificationId , verificationCode: verificationCode  } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof: temporaryProof,
            phoneNumber: phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === "string") json = JSON.parse(json);
        const { verificationId: verificationId , verificationCode: verificationCode , phoneNumber: phoneNumber , temporaryProof: temporaryProof  } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new $8dac729f232ba11e$export$3a1a48c8f6ef640e({
            verificationId: verificationId,
            verificationCode: verificationCode,
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $8dac729f232ba11e$var$parseMode(mode) {
    switch(mode){
        case "recoverEmail":
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case "resetPassword":
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case "signIn":
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case "verifyEmail":
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case "verifyAndChangeEmail":
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case "revertSecondFactorAddition":
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $8dac729f232ba11e$var$parseDeepLink(url) {
    const link = (0, $fc59d49e1bb53b6a$export$c1271ca4c8a70741)((0, $fc59d49e1bb53b6a$export$1a8408415472d8ed)(url))["link"];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, $fc59d49e1bb53b6a$export$c1271ca4c8a70741)((0, $fc59d49e1bb53b6a$export$1a8408415472d8ed)(link))["deep_link_id"] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, $fc59d49e1bb53b6a$export$c1271ca4c8a70741)((0, $fc59d49e1bb53b6a$export$1a8408415472d8ed)(url))["deep_link_id"];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, $fc59d49e1bb53b6a$export$c1271ca4c8a70741)((0, $fc59d49e1bb53b6a$export$1a8408415472d8ed)(iOSDeepLink))["link"] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class $8dac729f232ba11e$export$ee7c8ad385a60b7b {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        var _a, _b, _c, _d, _e, _f;
        const searchParams = (0, $fc59d49e1bb53b6a$export$c1271ca4c8a70741)((0, $fc59d49e1bb53b6a$export$1a8408415472d8ed)(actionLink));
        const apiKey = (_a = searchParams["apiKey" /* QueryField.API_KEY */ ]) !== null && _a !== void 0 ? _a : null;
        const code = (_b = searchParams["oobCode" /* QueryField.CODE */ ]) !== null && _b !== void 0 ? _b : null;
        const operation = $8dac729f232ba11e$var$parseMode((_c = searchParams["mode" /* QueryField.MODE */ ]) !== null && _c !== void 0 ? _c : null);
        // Validate API key, code and mode.
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = (_d = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ]) !== null && _d !== void 0 ? _d : null;
        this.languageCode = (_e = searchParams["languageCode" /* QueryField.LANGUAGE_CODE */ ]) !== null && _e !== void 0 ? _e : null;
        this.tenantId = (_f = searchParams["tenantId" /* QueryField.TENANT_ID */ ]) !== null && _f !== void 0 ? _f : null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = $8dac729f232ba11e$var$parseDeepLink(link);
        try {
            return new $8dac729f232ba11e$export$ee7c8ad385a60b7b(actionLink);
        } catch (_a) {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $8dac729f232ba11e$export$995eb9fca571757(link) {
    return $8dac729f232ba11e$export$ee7c8ad385a60b7b.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class $8dac729f232ba11e$export$3722cfe417b6ed86 {
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = $8dac729f232ba11e$export$3722cfe417b6ed86.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return $8dac729f232ba11e$export$3466f893ebf79586._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = $8dac729f232ba11e$export$ee7c8ad385a60b7b.parseLink(emailLink);
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $8dac729f232ba11e$export$3466f893ebf79586._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $8dac729f232ba11e$export$3722cfe417b6ed86.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $8dac729f232ba11e$export$3722cfe417b6ed86.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $8dac729f232ba11e$export$3722cfe417b6ed86.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class $8dac729f232ba11e$var$FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class $8dac729f232ba11e$var$BaseOAuthProvider extends $8dac729f232ba11e$var$FederatedAuthProvider {
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $8dac729f232ba11e$export$78acf4525d8a74c4 extends $8dac729f232ba11e$var$BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        $8dac729f232ba11e$export$91c6e00c14e7e6fd("providerId" in obj && "signInMethod" in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $8dac729f232ba11e$export$61196ced6d74a310._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential(Object.assign(Object.assign({}, params), {
            nonce: params.rawNonce
        }));
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return $8dac729f232ba11e$export$61196ced6d74a310._fromParams(Object.assign(Object.assign({}, params), {
            providerId: this.providerId,
            signInMethod: this.providerId
        }));
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $8dac729f232ba11e$export$78acf4525d8a74c4.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $8dac729f232ba11e$export$78acf4525d8a74c4.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse  }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken , oauthAccessToken: oauthAccessToken , oauthTokenSecret: oauthTokenSecret , pendingToken: pendingToken , nonce: nonce , providerId: providerId  } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new $8dac729f232ba11e$export$78acf4525d8a74c4(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce: nonce,
                pendingToken: pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $8dac729f232ba11e$export$3a6d5c9ae78a2c08 extends $8dac729f232ba11e$var$BaseOAuthProvider {
    constructor(){
        super("facebook.com" /* ProviderId.FACEBOOK */ );
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return $8dac729f232ba11e$export$61196ced6d74a310._fromParams({
            providerId: $8dac729f232ba11e$export$3a6d5c9ae78a2c08.PROVIDER_ID,
            signInMethod: $8dac729f232ba11e$export$3a6d5c9ae78a2c08.FACEBOOK_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $8dac729f232ba11e$export$3a6d5c9ae78a2c08.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $8dac729f232ba11e$export$3a6d5c9ae78a2c08.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse  }) {
        if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $8dac729f232ba11e$export$3a6d5c9ae78a2c08.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ $8dac729f232ba11e$export$3a6d5c9ae78a2c08.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $8dac729f232ba11e$export$3a6d5c9ae78a2c08.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $8dac729f232ba11e$export$e7c866399fa523f5 extends $8dac729f232ba11e$var$BaseOAuthProvider {
    constructor(){
        super("google.com" /* ProviderId.GOOGLE */ );
        this.addScope("profile");
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return $8dac729f232ba11e$export$61196ced6d74a310._fromParams({
            providerId: $8dac729f232ba11e$export$e7c866399fa523f5.PROVIDER_ID,
            signInMethod: $8dac729f232ba11e$export$e7c866399fa523f5.GOOGLE_SIGN_IN_METHOD,
            idToken: idToken,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $8dac729f232ba11e$export$e7c866399fa523f5.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $8dac729f232ba11e$export$e7c866399fa523f5.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse  }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken , oauthAccessToken: oauthAccessToken  } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return $8dac729f232ba11e$export$e7c866399fa523f5.credential(oauthIdToken, oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ $8dac729f232ba11e$export$e7c866399fa523f5.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $8dac729f232ba11e$export$e7c866399fa523f5.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Github Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Github Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $8dac729f232ba11e$export$71cec2538cb2c617 extends $8dac729f232ba11e$var$BaseOAuthProvider {
    constructor(){
        super("github.com" /* ProviderId.GITHUB */ );
    }
    /**
     * Creates a credential for Github.
     *
     * @param accessToken - Github access token.
     */ static credential(accessToken) {
        return $8dac729f232ba11e$export$61196ced6d74a310._fromParams({
            providerId: $8dac729f232ba11e$export$71cec2538cb2c617.PROVIDER_ID,
            signInMethod: $8dac729f232ba11e$export$71cec2538cb2c617.GITHUB_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $8dac729f232ba11e$export$71cec2538cb2c617.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $8dac729f232ba11e$export$71cec2538cb2c617.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse  }) {
        if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $8dac729f232ba11e$export$71cec2538cb2c617.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ $8dac729f232ba11e$export$71cec2538cb2c617.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $8dac729f232ba11e$export$71cec2538cb2c617.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8dac729f232ba11e$var$IDP_REQUEST_URI = "http://localhost";
/**
 * @public
 */ class $8dac729f232ba11e$export$c03999cb2f36933f extends $8dac729f232ba11e$export$b4171a6734a65d42 {
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $8dac729f232ba11e$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $8dac729f232ba11e$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $8dac729f232ba11e$var$signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        const { providerId: providerId , signInMethod: signInMethod , pendingToken: pendingToken  } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new $8dac729f232ba11e$export$c03999cb2f36933f(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new $8dac729f232ba11e$export$c03999cb2f36933f(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: $8dac729f232ba11e$var$IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8dac729f232ba11e$var$SAML_PROVIDER_PREFIX = "saml.";
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class $8dac729f232ba11e$export$8743009a87fcb00f extends $8dac729f232ba11e$var$FederatedAuthProvider {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(providerId.startsWith($8dac729f232ba11e$var$SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $8dac729f232ba11e$export$8743009a87fcb00f.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $8dac729f232ba11e$export$8743009a87fcb00f.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = $8dac729f232ba11e$export$c03999cb2f36933f.fromJSON(json);
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse  }) {
        if (!tokenResponse) return null;
        const { pendingToken: pendingToken , providerId: providerId  } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return $8dac729f232ba11e$export$c03999cb2f36933f._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class $8dac729f232ba11e$export$dc98b0b04f4c7758 extends $8dac729f232ba11e$var$BaseOAuthProvider {
    constructor(){
        super("twitter.com" /* ProviderId.TWITTER */ );
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return $8dac729f232ba11e$export$61196ced6d74a310._fromParams({
            providerId: $8dac729f232ba11e$export$dc98b0b04f4c7758.PROVIDER_ID,
            signInMethod: $8dac729f232ba11e$export$dc98b0b04f4c7758.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $8dac729f232ba11e$export$dc98b0b04f4c7758.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $8dac729f232ba11e$export$dc98b0b04f4c7758.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse  }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken: oauthAccessToken , oauthTokenSecret: oauthTokenSecret  } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return $8dac729f232ba11e$export$dc98b0b04f4c7758.credential(oauthAccessToken, oauthTokenSecret);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ $8dac729f232ba11e$export$dc98b0b04f4c7758.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $8dac729f232ba11e$export$dc98b0b04f4c7758.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8dac729f232ba11e$var$signUp(auth, request) {
    return $8dac729f232ba11e$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , $8dac729f232ba11e$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8dac729f232ba11e$var$UserCredentialImpl {
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await $8dac729f232ba11e$export$b9a6b53f9be3734._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = $8dac729f232ba11e$var$providerIdForResponse(idTokenResponse);
        const userCred = new $8dac729f232ba11e$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: idTokenResponse,
            operationType: operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = $8dac729f232ba11e$var$providerIdForResponse(response);
        return new $8dac729f232ba11e$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: response,
            operationType: operationType
        });
    }
}
function $8dac729f232ba11e$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ("phoneNumber" in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function $8dac729f232ba11e$export$71511d61b312f219(auth) {
    var _a;
    const authInternal = $8dac729f232ba11e$export$a33b77bbdbb8366c(auth);
    await authInternal._initializationPromise;
    if ((_a = authInternal.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new $8dac729f232ba11e$var$UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* OperationType.SIGN_IN */ 
    });
    const response = await $8dac729f232ba11e$var$signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await $8dac729f232ba11e$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8dac729f232ba11e$var$MultiFactorError extends (0, $fc59d49e1bb53b6a$export$dd24e9cd51226c56) {
    constructor(auth, error, operationType, user){
        var _a;
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $8dac729f232ba11e$var$MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: (_a = auth.tenantId) !== null && _a !== void 0 ? _a : undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new $8dac729f232ba11e$var$MultiFactorError(auth, error, operationType, user);
    }
}
function $8dac729f232ba11e$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ }`) throw $8dac729f232ba11e$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $8dac729f232ba11e$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId: providerId  })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function $8dac729f232ba11e$export$306ddfe3a8403e2(user, providerId) {
    const userInternal = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(user);
    await $8dac729f232ba11e$var$_assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo: providerUserInfo  } = await $8dac729f232ba11e$var$deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = $8dac729f232ba11e$var$providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function $8dac729f232ba11e$var$_link$1(user, credential, bypassAuthState = false) {
    const response = await $8dac729f232ba11e$var$_logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return $8dac729f232ba11e$var$UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response);
}
async function $8dac729f232ba11e$var$_assertLinkedStatus(expected, user, provider) {
    await $8dac729f232ba11e$var$_reloadWithoutSaving(user);
    const providerIds = $8dac729f232ba11e$var$providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
    $8dac729f232ba11e$export$91c6e00c14e7e6fd(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8dac729f232ba11e$var$_reauthenticate(user, credential, bypassAuthState = false) {
    const { auth: auth  } = user;
    const operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
    try {
        const response = await $8dac729f232ba11e$var$_logoutIfInvalidated(user, $8dac729f232ba11e$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const parsed = $8dac729f232ba11e$var$_parseToken(response.idToken);
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const { sub: localId  } = parsed;
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        return $8dac729f232ba11e$var$UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"user-not-found" /* AuthErrorCode.USER_DELETED */ }`) $8dac729f232ba11e$export$d66dc83d8cfc8dd(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8dac729f232ba11e$var$_signInWithCredential(auth, credential, bypassAuthState = false) {
    const operationType = "signIn" /* OperationType.SIGN_IN */ ;
    const response = await $8dac729f232ba11e$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await $8dac729f232ba11e$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $8dac729f232ba11e$export$3d8c2f653ac9d0b9(auth, credential) {
    return $8dac729f232ba11e$var$_signInWithCredential($8dac729f232ba11e$export$a33b77bbdbb8366c(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $8dac729f232ba11e$export$34aec0b863436764(user, credential) {
    const userInternal = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(user);
    await $8dac729f232ba11e$var$_assertLinkedStatus(false, userInternal, credential.providerId);
    return $8dac729f232ba11e$var$_link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $8dac729f232ba11e$export$3c2fa207a37baaea(user, credential) {
    return $8dac729f232ba11e$var$_reauthenticate((0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8dac729f232ba11e$var$signInWithCustomToken$1(auth, request) {
    return $8dac729f232ba11e$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , $8dac729f232ba11e$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function $8dac729f232ba11e$export$ce26c07117d59d6a(auth, customToken) {
    const authInternal = $8dac729f232ba11e$export$a33b77bbdbb8366c(auth);
    const response = await $8dac729f232ba11e$var$signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await $8dac729f232ba11e$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8dac729f232ba11e$var$MultiFactorInfoImpl {
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ("phoneInfo" in enrollment) return $8dac729f232ba11e$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        else if ("totpInfo" in enrollment) return $8dac729f232ba11e$var$TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        return $8dac729f232ba11e$export$d66dc83d8cfc8dd(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
}
class $8dac729f232ba11e$var$PhoneMultiFactorInfoImpl extends $8dac729f232ba11e$var$MultiFactorInfoImpl {
    constructor(response){
        super("phone" /* FactorId.PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $8dac729f232ba11e$var$PhoneMultiFactorInfoImpl(enrollment);
    }
}
class $8dac729f232ba11e$var$TotpMultiFactorInfoImpl extends $8dac729f232ba11e$var$MultiFactorInfoImpl {
    constructor(response){
        super("totp" /* FactorId.TOTP */ , response);
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $8dac729f232ba11e$var$TotpMultiFactorInfoImpl(enrollment);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8dac729f232ba11e$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    var _a;
    $8dac729f232ba11e$export$91c6e00c14e7e6fd(((_a = actionCodeSettings.url) === null || _a === void 0 ? void 0 : _a.length) > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    $8dac729f232ba11e$export$91c6e00c14e7e6fd(typeof actionCodeSettings.dynamicLinkDomain === "undefined" || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a password reset email to the given email address.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $8dac729f232ba11e$export$6559d589eb85fbb6(auth, email, actionCodeSettings) {
    var _a;
    const authInternal = $8dac729f232ba11e$export$a33b77bbdbb8366c(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    if ((_a = authInternal._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.emailPasswordEnabled) {
        const requestWithRecaptcha = await $8dac729f232ba11e$var$injectRecaptchaFields(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , true);
        if (actionCodeSettings) $8dac729f232ba11e$var$_setActionCodeSettingsOnRequest(authInternal, requestWithRecaptcha, actionCodeSettings);
        await $8dac729f232ba11e$var$sendPasswordResetEmail$1(authInternal, requestWithRecaptcha);
    } else {
        if (actionCodeSettings) $8dac729f232ba11e$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
        await $8dac729f232ba11e$var$sendPasswordResetEmail$1(authInternal, request).catch(async (error)=>{
            if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
                console.log("Password resets are protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the password reset flow.");
                const requestWithRecaptcha = await $8dac729f232ba11e$var$injectRecaptchaFields(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , true);
                if (actionCodeSettings) $8dac729f232ba11e$var$_setActionCodeSettingsOnRequest(authInternal, requestWithRecaptcha, actionCodeSettings);
                await $8dac729f232ba11e$var$sendPasswordResetEmail$1(authInternal, requestWithRecaptcha);
            } else return Promise.reject(error);
        });
    }
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function $8dac729f232ba11e$export$efca4cbe5dd06740(auth, oobCode, newPassword) {
    await $8dac729f232ba11e$var$resetPassword((0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode,
        newPassword: newPassword
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $8dac729f232ba11e$export$a8550f7dbe79f93a(auth, oobCode) {
    await $8dac729f232ba11e$var$applyActionCode$1((0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $8dac729f232ba11e$export$2e2af4578d910ddf(auth, oobCode) {
    const authModular = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(auth);
    const response = await $8dac729f232ba11e$var$resetPassword(authModular, {
        oobCode: oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    $8dac729f232ba11e$export$91c6e00c14e7e6fd(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
            $8dac729f232ba11e$export$91c6e00c14e7e6fd(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
            $8dac729f232ba11e$export$91c6e00c14e7e6fd(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // fall through
        default:
            $8dac729f232ba11e$export$91c6e00c14e7e6fd(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = $8dac729f232ba11e$var$MultiFactorInfoImpl._fromServerResponse($8dac729f232ba11e$export$a33b77bbdbb8366c(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo: multiFactorInfo
        },
        operation: operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function $8dac729f232ba11e$export$a93c5207d687da10(auth, code) {
    const { data: data  } = await $8dac729f232ba11e$export$2e2af4578d910ddf((0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function $8dac729f232ba11e$export$c3950d9923825c02(auth, email, password) {
    var _a;
    const authInternal = $8dac729f232ba11e$export$a33b77bbdbb8366c(auth);
    const request = {
        returnSecureToken: true,
        email: email,
        password: password,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    let signUpResponse;
    if ((_a = authInternal._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.emailPasswordEnabled) {
        const requestWithRecaptcha = await $8dac729f232ba11e$var$injectRecaptchaFields(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ );
        signUpResponse = $8dac729f232ba11e$var$signUp(authInternal, requestWithRecaptcha);
    } else signUpResponse = $8dac729f232ba11e$var$signUp(authInternal, request).catch(async (error)=>{
        if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
            console.log("Sign-up is protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the sign-up flow.");
            const requestWithRecaptcha = await $8dac729f232ba11e$var$injectRecaptchaFields(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ );
            return $8dac729f232ba11e$var$signUp(authInternal, requestWithRecaptcha);
        } else return Promise.reject(error);
    });
    const response = await signUpResponse.catch((error)=>{
        return Promise.reject(error);
    });
    const userCredential = await $8dac729f232ba11e$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $8dac729f232ba11e$export$a9c996f45e5784d0(auth, email, password) {
    return $8dac729f232ba11e$export$3d8c2f653ac9d0b9((0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(auth), $8dac729f232ba11e$export$3722cfe417b6ed86.credential(email, password));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $8dac729f232ba11e$export$7910e0436ed8d1de(auth, email, actionCodeSettings) {
    var _a;
    const authInternal = $8dac729f232ba11e$export$a33b77bbdbb8366c(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    function setActionCodeSettings(request, actionCodeSettings) {
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (actionCodeSettings) $8dac729f232ba11e$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    }
    if ((_a = authInternal._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.emailPasswordEnabled) {
        const requestWithRecaptcha = await $8dac729f232ba11e$var$injectRecaptchaFields(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , true);
        setActionCodeSettings(requestWithRecaptcha, actionCodeSettings);
        await $8dac729f232ba11e$var$sendSignInLinkToEmail$1(authInternal, requestWithRecaptcha);
    } else {
        setActionCodeSettings(request, actionCodeSettings);
        await $8dac729f232ba11e$var$sendSignInLinkToEmail$1(authInternal, request).catch(async (error)=>{
            if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
                console.log("Email link sign-in is protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the sign-in flow.");
                const requestWithRecaptcha = await $8dac729f232ba11e$var$injectRecaptchaFields(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , true);
                setActionCodeSettings(requestWithRecaptcha, actionCodeSettings);
                await $8dac729f232ba11e$var$sendSignInLinkToEmail$1(authInternal, requestWithRecaptcha);
            } else return Promise.reject(error);
        });
    }
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $8dac729f232ba11e$export$555508cbc6add439(auth, emailLink) {
    const actionCodeUrl = $8dac729f232ba11e$export$ee7c8ad385a60b7b.parseLink(emailLink);
    return (actionCodeUrl === null || actionCodeUrl === void 0 ? void 0 : actionCodeUrl.operation) === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function $8dac729f232ba11e$export$2219238a014317b0(auth, email, emailLink) {
    const authModular = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(auth);
    const credential = $8dac729f232ba11e$export$3722cfe417b6ed86.credentialWithLink(email, emailLink || $8dac729f232ba11e$var$_getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    $8dac729f232ba11e$export$91c6e00c14e7e6fd(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
    return $8dac729f232ba11e$export$3d8c2f653ac9d0b9(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8dac729f232ba11e$var$createAuthUri(auth, request) {
    return $8dac729f232ba11e$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , $8dac729f232ba11e$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * @public
 */ async function $8dac729f232ba11e$export$4c3d22f3d993c33f(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = $8dac729f232ba11e$var$_isHttpOrHttps() ? $8dac729f232ba11e$var$_getCurrentUrl() : "http://localhost";
    const request = {
        identifier: email,
        continueUri: continueUri
    };
    const { signinMethods: signinMethods  } = await $8dac729f232ba11e$var$createAuthUri((0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $8dac729f232ba11e$export$f787f51d84a910ad(user, actionCodeSettings) {
    const userInternal = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
        idToken: idToken
    };
    if (actionCodeSettings) $8dac729f232ba11e$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email  } = await $8dac729f232ba11e$var$sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $8dac729f232ba11e$export$c9170ad7d4cd7e57(user, newEmail, actionCodeSettings) {
    const userInternal = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
        idToken: idToken,
        newEmail: newEmail
    };
    if (actionCodeSettings) $8dac729f232ba11e$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email  } = await $8dac729f232ba11e$var$verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8dac729f232ba11e$var$updateProfile$1(auth, request) {
    return $8dac729f232ba11e$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function $8dac729f232ba11e$export$f38c853ae54ed474(user, { displayName: displayName , photoURL: photoUrl  }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken: idToken,
        displayName: displayName,
        photoUrl: photoUrl,
        returnSecureToken: true
    };
    const response = await $8dac729f232ba11e$var$_logoutIfInvalidated(userInternal, $8dac729f232ba11e$var$updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId: providerId  })=>providerId === "password" /* ProviderId.PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * @public
 */ function $8dac729f232ba11e$export$3b513254972cfc9c(user, newEmail) {
    return $8dac729f232ba11e$var$updateEmailOrPassword((0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(user), newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $8dac729f232ba11e$export$21579262ef46735b(user, newPassword) {
    return $8dac729f232ba11e$var$updateEmailOrPassword((0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(user), null, newPassword);
}
async function $8dac729f232ba11e$var$updateEmailOrPassword(user, email, password) {
    const { auth: auth  } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken: idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await $8dac729f232ba11e$var$_logoutIfInvalidated(user, $8dac729f232ba11e$var$updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $8dac729f232ba11e$var$_fromIdTokenResponse(idTokenResponse) {
    var _a, _b;
    if (!idTokenResponse) return null;
    const { providerId: providerId  } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
        const signInProvider = (_b = (_a = $8dac729f232ba11e$var$_parseToken(idTokenResponse.idToken)) === null || _a === void 0 ? void 0 : _a.firebase) === null || _b === void 0 ? void 0 : _b["sign_in_provider"];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $8dac729f232ba11e$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new $8dac729f232ba11e$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new $8dac729f232ba11e$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new $8dac729f232ba11e$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new $8dac729f232ba11e$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new $8dac729f232ba11e$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $8dac729f232ba11e$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class $8dac729f232ba11e$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class $8dac729f232ba11e$var$FederatedAdditionalUserInfoWithUsername extends $8dac729f232ba11e$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class $8dac729f232ba11e$var$FacebookAdditionalUserInfo extends $8dac729f232ba11e$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
}
class $8dac729f232ba11e$var$GithubAdditionalUserInfo extends $8dac729f232ba11e$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === "string" ? profile === null || profile === void 0 ? void 0 : profile.login : null);
    }
}
class $8dac729f232ba11e$var$GoogleAdditionalUserInfo extends $8dac729f232ba11e$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
}
class $8dac729f232ba11e$var$TwitterAdditionalUserInfo extends $8dac729f232ba11e$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $8dac729f232ba11e$export$7a38258bbe170828(userCredential) {
    const { user: user , _tokenResponse: _tokenResponse  } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $8dac729f232ba11e$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $8dac729f232ba11e$export$9e5f44173e64f162(auth, persistence) {
    return (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $8dac729f232ba11e$export$625550452a3fa3ec(auth) {
    const authInternal = $8dac729f232ba11e$export$a33b77bbdbb8366c(auth);
    return authInternal.initializeRecaptchaConfig();
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $8dac729f232ba11e$export$90a7f3efeed30595(auth, nextOrObserver, error, completed) {
    return (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $8dac729f232ba11e$export$efccba1c4a2ef57b(auth, callback, onAbort) {
    return (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $8dac729f232ba11e$export$d141bba7fdc215a3(auth, nextOrObserver, error, completed) {
    return (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $8dac729f232ba11e$export$4a5767248b18ef41(auth) {
    (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $8dac729f232ba11e$export$df995fae86a55f06(auth, user) {
    return (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $8dac729f232ba11e$export$ef35774e6d314e91(auth) {
    return (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(auth).signOut();
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function $8dac729f232ba11e$export$e7094788287c5e9b(user) {
    return (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(user).delete();
}
class $8dac729f232ba11e$var$MultiFactorSessionImpl {
    constructor(type, credential, auth){
        this.type = type;
        this.credential = credential;
        this.auth = auth;
    }
    static _fromIdtoken(idToken, auth) {
        return new $8dac729f232ba11e$var$MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, auth);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new $8dac729f232ba11e$var$MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? "idToken" : "pendingCredential";
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        var _a, _b;
        if (obj === null || obj === void 0 ? void 0 : obj.multiFactorSession) {
            if ((_a = obj.multiFactorSession) === null || _a === void 0 ? void 0 : _a.pendingCredential) return $8dac729f232ba11e$var$MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if ((_b = obj.multiFactorSession) === null || _b === void 0 ? void 0 : _b.idToken) return $8dac729f232ba11e$var$MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8dac729f232ba11e$var$MultiFactorResolverImpl {
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */ static _fromError(authExtern, error) {
        const auth = $8dac729f232ba11e$export$a33b77bbdbb8366c(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>$8dac729f232ba11e$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const session = $8dac729f232ba11e$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new $8dac729f232ba11e$var$MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = Object.assign(Object.assign({}, serverResponse), {
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            });
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* OperationType.SIGN_IN */ :
                    const userCredential = await $8dac729f232ba11e$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                    $8dac729f232ba11e$export$91c6e00c14e7e6fd(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return $8dac729f232ba11e$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    $8dac729f232ba11e$export$d66dc83d8cfc8dd(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $8dac729f232ba11e$export$8a5498727ef6be21(auth, error) {
    var _a;
    const authModular = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(auth);
    const errorInternal = error;
    $8dac729f232ba11e$export$91c6e00c14e7e6fd(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    $8dac729f232ba11e$export$91c6e00c14e7e6fd((_a = errorInternal.customData._serverResponse) === null || _a === void 0 ? void 0 : _a.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return $8dac729f232ba11e$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8dac729f232ba11e$var$startEnrollPhoneMfa(auth, request) {
    return $8dac729f232ba11e$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $8dac729f232ba11e$var$_addTidIfNecessary(auth, request));
}
function $8dac729f232ba11e$var$finalizeEnrollPhoneMfa(auth, request) {
    return $8dac729f232ba11e$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $8dac729f232ba11e$var$_addTidIfNecessary(auth, request));
}
function $8dac729f232ba11e$var$startEnrollTotpMfa(auth, request) {
    return $8dac729f232ba11e$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $8dac729f232ba11e$var$_addTidIfNecessary(auth, request));
}
function $8dac729f232ba11e$var$finalizeEnrollTotpMfa(auth, request) {
    return $8dac729f232ba11e$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $8dac729f232ba11e$var$_addTidIfNecessary(auth, request));
}
function $8dac729f232ba11e$var$withdrawMfa(auth, request) {
    return $8dac729f232ba11e$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , $8dac729f232ba11e$var$_addTidIfNecessary(auth, request));
}
class $8dac729f232ba11e$var$MultiFactorUserImpl {
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>$8dac729f232ba11e$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
    static _fromUser(user) {
        return new $8dac729f232ba11e$var$MultiFactorUserImpl(user);
    }
    async getSession() {
        return $8dac729f232ba11e$var$MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken(), this.user.auth);
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await $8dac729f232ba11e$var$_logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === "string" ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        try {
            const idTokenResponse = await $8dac729f232ba11e$var$_logoutIfInvalidated(this.user, $8dac729f232ba11e$var$withdrawMfa(this.user.auth, {
                idToken: idToken,
                mfaEnrollmentId: mfaEnrollmentId
            }));
            // Remove the second factor from the user's list.
            this.enrolledFactors = this.enrolledFactors.filter(({ uid: uid  })=>uid !== mfaEnrollmentId);
            // Depending on whether the backend decided to revoke the user's session,
            // the tokenResponse may be empty. If the tokens were not updated (and they
            // are now invalid), reloading the user will discover this and invalidate
            // the user's state accordingly.
            await this.user._updateTokensIfNecessary(idTokenResponse);
            await this.user.reload();
        } catch (e) {
            throw e;
        }
    }
}
const $8dac729f232ba11e$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $8dac729f232ba11e$export$d24c54395ce0c509(user) {
    const userModular = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(user);
    if (!$8dac729f232ba11e$var$multiFactorUserCache.has(userModular)) $8dac729f232ba11e$var$multiFactorUserCache.set(userModular, $8dac729f232ba11e$var$MultiFactorUserImpl._fromUser(userModular));
    return $8dac729f232ba11e$var$multiFactorUserCache.get(userModular);
}
const $8dac729f232ba11e$var$STORAGE_AVAILABLE_KEY = "__sak";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class $8dac729f232ba11e$var$BrowserPersistenceClass {
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem($8dac729f232ba11e$var$STORAGE_AVAILABLE_KEY, "1");
            this.storage.removeItem($8dac729f232ba11e$var$STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch (_a) {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8dac729f232ba11e$var$_iframeCannotSyncWebStorage() {
    const ua = (0, $fc59d49e1bb53b6a$export$c36915b22ce77c19)();
    return $8dac729f232ba11e$var$_isSafari(ua) || $8dac729f232ba11e$export$493d36ec626b6698(ua);
}
// The polling period in case events are not supported
const $8dac729f232ba11e$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const $8dac729f232ba11e$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class $8dac729f232ba11e$var$BrowserLocalPersistence extends $8dac729f232ba11e$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* PersistenceType.LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Safari or iOS browser and embedded in an iframe.
        this.safariLocalStorageNotSynced = $8dac729f232ba11e$var$_iframeCannotSyncWebStorage() && $8dac729f232ba11e$var$_isIframe();
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = $8dac729f232ba11e$var$_isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        // Safari embedded iframe. Storage event will trigger with the delta
        // changes but no changes will be applied to the iframe localStorage.
        if (this.safariLocalStorageNotSynced) {
            // Get current iframe page value.
            const storedValue = this.storage.getItem(key);
            // Value not synchronized, synchronize manually.
            if (event.newValue !== storedValue) {
                if (event.newValue !== null) // Value changed from current value.
                this.storage.setItem(key, event.newValue);
                else // Current value deleted.
                this.storage.removeItem(key);
            } else if (this.localCache[key] === event.newValue && !poll) // Already detected and processed, do not trigger listeners again.
            return;
        }
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if ($8dac729f232ba11e$var$_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, $8dac729f232ba11e$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent("storage", {
                    key: key,
                    oldValue: oldValue,
                    newValue: newValue
                }), /* poll */ true);
            });
        }, $8dac729f232ba11e$var$_POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener("storage", this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener("storage", this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
$8dac729f232ba11e$var$BrowserLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const $8dac729f232ba11e$export$8b22cf2602fb60ce = $8dac729f232ba11e$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8dac729f232ba11e$var$BrowserSessionPersistence extends $8dac729f232ba11e$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* PersistenceType.SESSION */ );
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
$8dac729f232ba11e$var$BrowserSessionPersistence.type = "SESSION";
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const $8dac729f232ba11e$export$407448d2b89b1813 = $8dac729f232ba11e$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $8dac729f232ba11e$var$_allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value: value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason: reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class $8dac729f232ba11e$var$Receiver {
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new $8dac729f232ba11e$var$Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId: eventId , eventType: eventType , data: data  } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!(handlers === null || handlers === void 0 ? void 0 : handlers.size)) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* _Status.ACK */ ,
            eventId: eventId,
            eventType: eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await $8dac729f232ba11e$var$_allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* _Status.DONE */ ,
            eventId: eventId,
            eventType: eventType,
            response: response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener("message", this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optinoal event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener("message", this.boundEventHandler);
    }
}
$8dac729f232ba11e$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8dac729f232ba11e$export$91477dc880baac21(prefix = "", digits = 10) {
    let random = "";
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class $8dac729f232ba11e$var$Sender {
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener("message", handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* _TimeoutDuration.ACK */ ) {
        const messageChannel = typeof MessageChannel !== "undefined" ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = $8dac729f232ba11e$export$91477dc880baac21("", 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel: messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* _Status.ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                            }, 3000 /* _TimeoutDuration.COMPLETION */ );
                            break;
                        case "done" /* _Status.DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener("message", handler.onMessage);
            this.target.postMessage({
                eventType: eventType,
                eventId: eventId,
                data: data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $8dac729f232ba11e$var$_window() {
    return window;
}
function $8dac729f232ba11e$var$_setWindowLocation(url) {
    $8dac729f232ba11e$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8dac729f232ba11e$var$_isWorker() {
    return typeof $8dac729f232ba11e$var$_window()["WorkerGlobalScope"] !== "undefined" && typeof $8dac729f232ba11e$var$_window()["importScripts"] === "function";
}
async function $8dac729f232ba11e$var$_getActiveServiceWorker() {
    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch (_a) {
        return null;
    }
}
function $8dac729f232ba11e$var$_getServiceWorkerController() {
    var _a;
    return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) || null;
}
function $8dac729f232ba11e$var$_getWorkerGlobalScope() {
    return $8dac729f232ba11e$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8dac729f232ba11e$var$DB_NAME = "firebaseLocalStorageDb";
const $8dac729f232ba11e$var$DB_VERSION = 1;
const $8dac729f232ba11e$var$DB_OBJECTSTORE_NAME = "firebaseLocalStorage";
const $8dac729f232ba11e$var$DB_DATA_KEYPATH = "fbase_key";
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class $8dac729f232ba11e$var$DBPromise {
    constructor(request){
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener("success", ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener("error", ()=>{
                reject(this.request.error);
            });
        });
    }
}
function $8dac729f232ba11e$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $8dac729f232ba11e$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? "readwrite" : "readonly").objectStore($8dac729f232ba11e$var$DB_OBJECTSTORE_NAME);
}
function $8dac729f232ba11e$var$_deleteDatabase() {
    const request = indexedDB.deleteDatabase($8dac729f232ba11e$var$DB_NAME);
    return new $8dac729f232ba11e$var$DBPromise(request).toPromise();
}
function $8dac729f232ba11e$var$_openDatabase() {
    const request = indexedDB.open($8dac729f232ba11e$var$DB_NAME, $8dac729f232ba11e$var$DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener("error", ()=>{
            reject(request.error);
        });
        request.addEventListener("upgradeneeded", ()=>{
            const db = request.result;
            try {
                db.createObjectStore($8dac729f232ba11e$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $8dac729f232ba11e$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener("success", async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains($8dac729f232ba11e$var$DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await $8dac729f232ba11e$var$_deleteDatabase();
                resolve(await $8dac729f232ba11e$var$_openDatabase());
            } else resolve(db);
        });
    });
}
async function $8dac729f232ba11e$var$_putObject(db, key, value) {
    const request = $8dac729f232ba11e$var$getObjectStore(db, true).put({
        [$8dac729f232ba11e$var$DB_DATA_KEYPATH]: key,
        value: value
    });
    return new $8dac729f232ba11e$var$DBPromise(request).toPromise();
}
async function $8dac729f232ba11e$var$getObject(db, key) {
    const request = $8dac729f232ba11e$var$getObjectStore(db, false).get(key);
    const data = await new $8dac729f232ba11e$var$DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function $8dac729f232ba11e$var$_deleteObject(db, key) {
    const request = $8dac729f232ba11e$var$getObjectStore(db, true).delete(key);
    return new $8dac729f232ba11e$var$DBPromise(request).toPromise();
}
const $8dac729f232ba11e$var$_POLLING_INTERVAL_MS = 800;
const $8dac729f232ba11e$var$_TRANSACTION_RETRY_COUNT = 3;
class $8dac729f232ba11e$var$IndexedDBLocalPersistence {
    constructor(){
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
    async _openDb() {
        if (this.db) return this.db;
        this.db = await $8dac729f232ba11e$var$_openDatabase();
        return this.db;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (numAttempts++ > $8dac729f232ba11e$var$_TRANSACTION_RETRY_COUNT) throw e;
            if (this.db) {
                this.db.close();
                this.db = undefined;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return $8dac729f232ba11e$var$_isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = $8dac729f232ba11e$var$Receiver._getInstance($8dac729f232ba11e$var$_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* _EventType.PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* _EventType.KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        var _a, _b;
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await $8dac729f232ba11e$var$_getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new $8dac729f232ba11e$var$Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ );
        if (!results) return;
        if (((_a = results[0]) === null || _a === void 0 ? void 0 : _a.fulfilled) && ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ ))) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || $8dac729f232ba11e$var$_getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                key: key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ );
        } catch (_a) {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            const db = await $8dac729f232ba11e$var$_openDatabase();
            await $8dac729f232ba11e$var$_putObject(db, $8dac729f232ba11e$var$STORAGE_AVAILABLE_KEY, "1");
            await $8dac729f232ba11e$var$_deleteObject(db, $8dac729f232ba11e$var$STORAGE_AVAILABLE_KEY);
            return true;
        } catch (_a) {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$8dac729f232ba11e$var$_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>$8dac729f232ba11e$var$getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$8dac729f232ba11e$var$_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db)=>{
            const getAllRequest = $8dac729f232ba11e$var$getObjectStore(db, false).getAll();
            return new $8dac729f232ba11e$var$DBPromise(getAllRequest).toPromise();
        });
        if (!result) return [];
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) return [];
        const keys = [];
        const keysInResult = new Set();
        for (const { fbase_key: key , value: value  } of result){
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
            // Deleted
            this.notifyListeners(localKey, null);
            keys.push(localKey);
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), $8dac729f232ba11e$var$_POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) this.startPolling();
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) this.stopPolling();
    }
}
$8dac729f232ba11e$var$IndexedDBLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const $8dac729f232ba11e$export$23f2a1d2818174ef = $8dac729f232ba11e$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8dac729f232ba11e$var$startSignInPhoneMfa(auth, request) {
    return $8dac729f232ba11e$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , $8dac729f232ba11e$var$_addTidIfNecessary(auth, request));
}
function $8dac729f232ba11e$var$finalizeSignInPhoneMfa(auth, request) {
    return $8dac729f232ba11e$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $8dac729f232ba11e$var$_addTidIfNecessary(auth, request));
}
function $8dac729f232ba11e$var$finalizeSignInTotpMfa(auth, request) {
    return $8dac729f232ba11e$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $8dac729f232ba11e$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8dac729f232ba11e$var$_SOLVE_TIME_MS = 500;
const $8dac729f232ba11e$var$_EXPIRATION_TIME_MS = 60000;
const $8dac729f232ba11e$var$_WIDGET_ID_START = 1000000000000;
class $8dac729f232ba11e$var$MockReCaptcha {
    constructor(auth){
        this.auth = auth;
        this.counter = $8dac729f232ba11e$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new $8dac729f232ba11e$var$MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        var _a;
        const id = optWidgetId || $8dac729f232ba11e$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        var _a;
        const id = optWidgetId || $8dac729f232ba11e$var$_WIDGET_ID_START;
        return ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.getResponse()) || "";
    }
    async execute(optWidgetId) {
        var _a;
        const id = optWidgetId || $8dac729f232ba11e$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.execute();
        return "";
    }
}
class $8dac729f232ba11e$var$MockWidget {
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== "invisible";
        if (this.isVisible) this.execute();
        else this.container.addEventListener("click", this.clickHandler);
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener("click", this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = $8dac729f232ba11e$var$generateRandomAlphaNumericString(50);
            const { callback: callback , "expired-callback": expiredCallback  } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, $8dac729f232ba11e$var$_EXPIRATION_TIME_MS);
        }, $8dac729f232ba11e$var$_SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error("reCAPTCHA mock was already deleted!");
    }
}
function $8dac729f232ba11e$var$generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join("");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const $8dac729f232ba11e$var$_JSLOAD_CALLBACK = $8dac729f232ba11e$var$_generateCallbackName("rcb");
const $8dac729f232ba11e$var$NETWORK_TIMEOUT_DELAY = new $8dac729f232ba11e$var$Delay(30000, 60000);
const $8dac729f232ba11e$var$RECAPTCHA_BASE = "https://www.google.com/recaptcha/api.js?";
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class $8dac729f232ba11e$var$ReCaptchaLoaderImpl {
    constructor(){
        var _a;
        this.hostLanguage = "";
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!((_a = $8dac729f232ba11e$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render);
    }
    load(auth, hl = "") {
        $8dac729f232ba11e$export$91c6e00c14e7e6fd($8dac729f232ba11e$var$isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl) && $8dac729f232ba11e$var$isV2($8dac729f232ba11e$var$_window().grecaptcha)) return Promise.resolve($8dac729f232ba11e$var$_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = $8dac729f232ba11e$var$_window().setTimeout(()=>{
                reject($8dac729f232ba11e$export$3d12bd131bb975d1(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $8dac729f232ba11e$var$NETWORK_TIMEOUT_DELAY.get());
            $8dac729f232ba11e$var$_window()[$8dac729f232ba11e$var$_JSLOAD_CALLBACK] = ()=>{
                $8dac729f232ba11e$var$_window().clearTimeout(networkTimeout);
                delete $8dac729f232ba11e$var$_window()[$8dac729f232ba11e$var$_JSLOAD_CALLBACK];
                const recaptcha = $8dac729f232ba11e$var$_window().grecaptcha;
                if (!recaptcha || !$8dac729f232ba11e$var$isV2(recaptcha)) {
                    reject($8dac729f232ba11e$export$3d12bd131bb975d1(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the greptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${$8dac729f232ba11e$var$RECAPTCHA_BASE}?${(0, $fc59d49e1bb53b6a$export$ac4103b836844853)({
                onload: $8dac729f232ba11e$var$_JSLOAD_CALLBACK,
                render: "explicit",
                hl: hl
            })}`;
            $8dac729f232ba11e$var$_loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject($8dac729f232ba11e$export$3d12bd131bb975d1(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        var _a;
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!((_a = $8dac729f232ba11e$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render) && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
}
function $8dac729f232ba11e$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class $8dac729f232ba11e$var$MockReCaptchaLoaderImpl {
    async load(auth) {
        return new $8dac729f232ba11e$var$MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8dac729f232ba11e$var$RECAPTCHA_VERIFIER_TYPE = "recaptcha";
const $8dac729f232ba11e$var$DEFAULT_PARAMS = {
    theme: "light",
    type: "image"
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @public
 */ class $8dac729f232ba11e$export$db202ddc8be9136 {
    /**
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     */ constructor(containerOrId, parameters = Object.assign({}, $8dac729f232ba11e$var$DEFAULT_PARAMS), authExtern){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $8dac729f232ba11e$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $8dac729f232ba11e$export$a33b77bbdbb8366c(authExtern);
        this.isInvisible = this.parameters.size === "invisible";
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $8dac729f232ba11e$var$MockReCaptchaLoaderImpl() : new $8dac729f232ba11e$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === "function") existing(token);
            else if (typeof existing === "string") {
                const globalFunc = $8dac729f232ba11e$var$_window()[existing];
                if (typeof globalFunc === "function") globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement("div");
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        $8dac729f232ba11e$export$91c6e00c14e7e6fd($8dac729f232ba11e$var$_isHttpOrHttps() && !$8dac729f232ba11e$var$_isWorker(), this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        await $8dac729f232ba11e$var$domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await $8dac729f232ba11e$var$getRecaptchaParams(this.auth);
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(siteKey, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.recaptcha;
    }
}
function $8dac729f232ba11e$var$domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === "complete") {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener("load", resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener("load", resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8dac729f232ba11e$var$ConfirmationResultImpl {
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = $8dac729f232ba11e$export$3a1a48c8f6ef640e._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method also requires a {@link ApplicationVerifier}.
 * This SDK includes a reCAPTCHA-based implementation, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $8dac729f232ba11e$export$2408f22a0fab9ae5(auth, phoneNumber, appVerifier) {
    const authInternal = $8dac729f232ba11e$export$a33b77bbdbb8366c(auth);
    const verificationId = await $8dac729f232ba11e$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(appVerifier));
    return new $8dac729f232ba11e$var$ConfirmationResultImpl(verificationId, (cred)=>$8dac729f232ba11e$export$3d8c2f653ac9d0b9(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $8dac729f232ba11e$export$882b5998b3b9117c(user, phoneNumber, appVerifier) {
    const userInternal = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(user);
    await $8dac729f232ba11e$var$_assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ );
    const verificationId = await $8dac729f232ba11e$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(appVerifier));
    return new $8dac729f232ba11e$var$ConfirmationResultImpl(verificationId, (cred)=>$8dac729f232ba11e$export$34aec0b863436764(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $8dac729f232ba11e$export$43caf9889c228507(user, phoneNumber, appVerifier) {
    const userInternal = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(user);
    const verificationId = await $8dac729f232ba11e$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(appVerifier));
    return new $8dac729f232ba11e$var$ConfirmationResultImpl(verificationId, (cred)=>$8dac729f232ba11e$export$3c2fa207a37baaea(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function $8dac729f232ba11e$var$_verifyPhoneNumber(auth, options, verifier) {
    var _a;
    const recaptchaToken = await verifier.verify();
    try {
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(typeof recaptchaToken === "string", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(verifier.type === $8dac729f232ba11e$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        let phoneInfoOptions;
        if (typeof options === "string") phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ("session" in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ("phoneNumber" in phoneInfoOptions) {
                $8dac729f232ba11e$export$91c6e00c14e7e6fd(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const response = await $8dac729f232ba11e$var$startEnrollPhoneMfa(auth, {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                $8dac729f232ba11e$export$91c6e00c14e7e6fd(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const mfaEnrollmentId = ((_a = phoneInfoOptions.multiFactorHint) === null || _a === void 0 ? void 0 : _a.uid) || phoneInfoOptions.multiFactorUid;
                $8dac729f232ba11e$export$91c6e00c14e7e6fd(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                const response = await $8dac729f232ba11e$var$startSignInPhoneMfa(auth, {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId: mfaEnrollmentId,
                    phoneSignInInfo: {
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const { sessionInfo: sessionInfo  } = await $8dac729f232ba11e$var$sendPhoneVerificationCode(auth, {
                phoneNumber: phoneInfoOptions.phoneNumber,
                recaptchaToken: recaptchaToken
            });
            return sessionInfo;
        }
    } finally{
        verifier._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function $8dac729f232ba11e$export$3b14a55fb2447963(user, credential) {
    await $8dac729f232ba11e$var$_link$1((0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class $8dac729f232ba11e$export$56c0d5a1e737357d {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = $8dac729f232ba11e$export$56c0d5a1e737357d.PROVIDER_ID;
        this.auth = $8dac729f232ba11e$export$a33b77bbdbb8366c(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - For abuse prevention, this method also requires a
     * {@link ApplicationVerifier}. This SDK includes a reCAPTCHA-based implementation,
     * {@link RecaptchaVerifier}.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow..
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return $8dac729f232ba11e$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return $8dac729f232ba11e$export$3a1a48c8f6ef640e._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return $8dac729f232ba11e$export$56c0d5a1e737357d.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return $8dac729f232ba11e$export$56c0d5a1e737357d.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse  }) {
        if (!tokenResponse) return null;
        const { phoneNumber: phoneNumber , temporaryProof: temporaryProof  } = tokenResponse;
        if (phoneNumber && temporaryProof) return $8dac729f232ba11e$export$3a1a48c8f6ef640e._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */ $8dac729f232ba11e$export$56c0d5a1e737357d.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $8dac729f232ba11e$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $8dac729f232ba11e$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $8dac729f232ba11e$export$890c4ad488842ce7(resolverOverride);
    $8dac729f232ba11e$export$91c6e00c14e7e6fd(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8dac729f232ba11e$var$IdpCredential extends $8dac729f232ba11e$export$b4171a6734a65d42 {
    constructor(params){
        super("custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return $8dac729f232ba11e$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return $8dac729f232ba11e$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return $8dac729f232ba11e$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
}
function $8dac729f232ba11e$var$_signIn(params) {
    return $8dac729f232ba11e$var$_signInWithCredential(params.auth, new $8dac729f232ba11e$var$IdpCredential(params), params.bypassAuthState);
}
function $8dac729f232ba11e$var$_reauth(params) {
    const { auth: auth , user: user  } = params;
    $8dac729f232ba11e$export$91c6e00c14e7e6fd(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $8dac729f232ba11e$var$_reauthenticate(user, new $8dac729f232ba11e$var$IdpCredential(params), params.bypassAuthState);
}
async function $8dac729f232ba11e$var$_link(params) {
    const { auth: auth , user: user  } = params;
    $8dac729f232ba11e$export$91c6e00c14e7e6fd(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $8dac729f232ba11e$var$_link$1(user, new $8dac729f232ba11e$var$IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class $8dac729f232ba11e$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve: resolve,
                reject: reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse: urlResponse , sessionId: sessionId , postBody: postBody , tenantId: tenantId , error: error , type: type  } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                return $8dac729f232ba11e$var$_signIn;
            case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                return $8dac729f232ba11e$var$_link;
            case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                return $8dac729f232ba11e$var$_reauth;
            default:
                $8dac729f232ba11e$export$d66dc83d8cfc8dd(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        $8dac729f232ba11e$export$6554612db691658e(this.pendingPromise, "Pending promise was never set");
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        $8dac729f232ba11e$export$6554612db691658e(this.pendingPromise, "Pending promise was never set");
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8dac729f232ba11e$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $8dac729f232ba11e$var$Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 *
 * @public
 */ async function $8dac729f232ba11e$export$db3b6bfb95261072(auth, provider, resolver) {
    const authInternal = $8dac729f232ba11e$export$a33b77bbdbb8366c(auth);
    $8dac729f232ba11e$var$_assertInstanceOf(auth, provider, $8dac729f232ba11e$var$FederatedAuthProvider);
    const resolverInternal = $8dac729f232ba11e$var$_withDefaultResolver(authInternal, resolver);
    const action = new $8dac729f232ba11e$var$PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $8dac729f232ba11e$export$f1e1789686576879(user, provider, resolver) {
    const userInternal = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(user);
    $8dac729f232ba11e$var$_assertInstanceOf(userInternal.auth, provider, $8dac729f232ba11e$var$FederatedAuthProvider);
    const resolverInternal = $8dac729f232ba11e$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $8dac729f232ba11e$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $8dac729f232ba11e$export$4368d992c4eafac0(user, provider, resolver) {
    const userInternal = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(user);
    $8dac729f232ba11e$var$_assertInstanceOf(userInternal.auth, provider, $8dac729f232ba11e$var$FederatedAuthProvider);
    const resolverInternal = $8dac729f232ba11e$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $8dac729f232ba11e$var$PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class $8dac729f232ba11e$var$PopupOperation extends $8dac729f232ba11e$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if ($8dac729f232ba11e$var$PopupOperation.currentPopupAction) $8dac729f232ba11e$var$PopupOperation.currentPopupAction.cancel();
        $8dac729f232ba11e$var$PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(result, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        $8dac729f232ba11e$export$6554612db691658e(this.filter.length === 1, "Popup operations only handle one event");
        const eventId = $8dac729f232ba11e$export$91477dc880baac21();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject($8dac729f232ba11e$export$3d12bd131bb975d1(this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        var _a;
        return ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.associatedEvent) || null;
    }
    cancel() {
        this.reject($8dac729f232ba11e$export$3d12bd131bb975d1(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        $8dac729f232ba11e$var$PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            var _a, _b;
            if ((_b = (_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight. This is specifically true for
                // Firefox or if the opener is in an iframe, in which case the oauth
                // helper closes the popup.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject($8dac729f232ba11e$export$3d12bd131bb975d1(this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                }, 8000 /* _Timeout.AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, $8dac729f232ba11e$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$8dac729f232ba11e$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8dac729f232ba11e$var$PENDING_REDIRECT_KEY = "pendingRedirect";
// We only get one redirect outcome for any one auth, so just store it
// in here.
const $8dac729f232ba11e$var$redirectOutcomeMap = new Map();
class $8dac729f232ba11e$var$RedirectAction extends $8dac729f232ba11e$var$AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = $8dac729f232ba11e$var$redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await $8dac729f232ba11e$var$_getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            $8dac729f232ba11e$var$redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) $8dac729f232ba11e$var$redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
}
async function $8dac729f232ba11e$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    const key = $8dac729f232ba11e$var$pendingRedirectKey(auth);
    const persistence = $8dac729f232ba11e$var$resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === "true";
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function $8dac729f232ba11e$var$_setPendingRedirectStatus(resolver, auth) {
    return $8dac729f232ba11e$var$resolverPersistence(resolver)._set($8dac729f232ba11e$var$pendingRedirectKey(auth), "true");
}
function $8dac729f232ba11e$export$53a70dd1ebbae346() {
    $8dac729f232ba11e$var$redirectOutcomeMap.clear();
}
function $8dac729f232ba11e$export$cf2f7c5792f80b46(auth, result) {
    $8dac729f232ba11e$var$redirectOutcomeMap.set(auth._key(), result);
}
function $8dac729f232ba11e$var$resolverPersistence(resolver) {
    return $8dac729f232ba11e$export$890c4ad488842ce7(resolver._redirectPersistence);
}
function $8dac729f232ba11e$var$pendingRedirectKey(auth) {
    return $8dac729f232ba11e$export$24baa2b76016ce0e($8dac729f232ba11e$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $8dac729f232ba11e$export$2d1720544b23b823(auth, provider, resolver) {
    return $8dac729f232ba11e$var$_signInWithRedirect(auth, provider, resolver);
}
async function $8dac729f232ba11e$var$_signInWithRedirect(auth, provider, resolver) {
    const authInternal = $8dac729f232ba11e$export$a33b77bbdbb8366c(auth);
    $8dac729f232ba11e$var$_assertInstanceOf(auth, provider, $8dac729f232ba11e$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await authInternal._initializationPromise;
    const resolverInternal = $8dac729f232ba11e$var$_withDefaultResolver(authInternal, resolver);
    await $8dac729f232ba11e$var$_setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $8dac729f232ba11e$export$dda1d9f60106f0e9(user, provider, resolver) {
    return $8dac729f232ba11e$var$_reauthenticateWithRedirect(user, provider, resolver);
}
async function $8dac729f232ba11e$var$_reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(user);
    $8dac729f232ba11e$var$_assertInstanceOf(userInternal.auth, provider, $8dac729f232ba11e$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $8dac729f232ba11e$var$_withDefaultResolver(userInternal.auth, resolver);
    await $8dac729f232ba11e$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $8dac729f232ba11e$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 *
 * @public
 */ function $8dac729f232ba11e$export$39b482c5e57630a8(user, provider, resolver) {
    return $8dac729f232ba11e$var$_linkWithRedirect(user, provider, resolver);
}
async function $8dac729f232ba11e$var$_linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(user);
    $8dac729f232ba11e$var$_assertInstanceOf(userInternal.auth, provider, $8dac729f232ba11e$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $8dac729f232ba11e$var$_withDefaultResolver(userInternal.auth, resolver);
    await $8dac729f232ba11e$var$_assertLinkedStatus(false, userInternal, provider.providerId);
    await $8dac729f232ba11e$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $8dac729f232ba11e$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $8dac729f232ba11e$export$35e795649ee09318(auth, resolver) {
    await $8dac729f232ba11e$export$a33b77bbdbb8366c(auth)._initializationPromise;
    return $8dac729f232ba11e$export$158acd800e1ef08b(auth, resolver, false);
}
async function $8dac729f232ba11e$export$158acd800e1ef08b(auth, resolverExtern, bypassAuthState = false) {
    const authInternal = $8dac729f232ba11e$export$a33b77bbdbb8366c(auth);
    const resolver = $8dac729f232ba11e$var$_withDefaultResolver(authInternal, resolverExtern);
    const action = new $8dac729f232ba11e$var$RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function $8dac729f232ba11e$var$prepareUserForRedirect(user) {
    const eventId = $8dac729f232ba11e$export$91477dc880baac21(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const $8dac729f232ba11e$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class $8dac729f232ba11e$export$9d398bebfec1c039 {
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !$8dac729f232ba11e$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        var _a;
        if (event.error && !$8dac729f232ba11e$var$isNullRedirectEvent(event)) {
            const code = ((_a = event.error.code) === null || _a === void 0 ? void 0 : _a.split("auth/")[1]) || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
            consumer.onError($8dac729f232ba11e$export$3d12bd131bb975d1(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= $8dac729f232ba11e$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has($8dac729f232ba11e$var$eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add($8dac729f232ba11e$var$eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function $8dac729f232ba11e$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join("-");
}
function $8dac729f232ba11e$var$isNullRedirectEvent({ type: type , error: error  }) {
    return type === "unknown" /* AuthEventType.UNKNOWN */  && (error === null || error === void 0 ? void 0 : error.code) === `auth/${"no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ }`;
}
function $8dac729f232ba11e$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return $8dac729f232ba11e$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8dac729f232ba11e$export$9fa96a7d116ea3ce(auth, request = {}) {
    return $8dac729f232ba11e$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8dac729f232ba11e$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const $8dac729f232ba11e$var$HTTP_REGEX = /^https?/;
async function $8dac729f232ba11e$var$_validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains: authorizedDomains  } = await $8dac729f232ba11e$export$9fa96a7d116ea3ce(auth);
    for (const domain of authorizedDomains)try {
        if ($8dac729f232ba11e$var$matchDomain(domain)) return;
    } catch (_a) {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    $8dac729f232ba11e$export$d66dc83d8cfc8dd(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
}
function $8dac729f232ba11e$var$matchDomain(expected) {
    const currentUrl = $8dac729f232ba11e$var$_getCurrentUrl();
    const { protocol: protocol , hostname: hostname  } = new URL(currentUrl);
    if (expected.startsWith("chrome-extension://")) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === "" && hostname === "") // For some reason we're not parsing chrome URLs properly
        return protocol === "chrome-extension:" && expected.replace("chrome-extension://", "") === currentUrl.replace("chrome-extension://", "");
        return protocol === "chrome-extension:" && ceUrl.hostname === hostname;
    }
    if (!$8dac729f232ba11e$var$HTTP_REGEX.test(protocol)) return false;
    if ($8dac729f232ba11e$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, "\\.");
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp("^(.+\\." + escapedDomainPattern + "|" + escapedDomainPattern + ")$", "i");
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8dac729f232ba11e$var$NETWORK_TIMEOUT = new $8dac729f232ba11e$var$Delay(30000, 60000);
/**
 * Reset unlaoded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $8dac729f232ba11e$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = $8dac729f232ba11e$var$_window().___jsl;
    // Get current hint.
    if (beacon === null || beacon === void 0 ? void 0 : beacon.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function $8dac729f232ba11e$var$loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        var _a, _b, _c;
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $8dac729f232ba11e$var$resetUnloadedGapiModules();
            gapi.load("gapi.iframes", {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $8dac729f232ba11e$var$resetUnloadedGapiModules();
                    reject($8dac729f232ba11e$export$3d12bd131bb975d1(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $8dac729f232ba11e$var$NETWORK_TIMEOUT.get()
            });
        }
        if ((_b = (_a = $8dac729f232ba11e$var$_window().gapi) === null || _a === void 0 ? void 0 : _a.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!((_c = $8dac729f232ba11e$var$_window().gapi) === null || _c === void 0 ? void 0 : _c.load)) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = $8dac729f232ba11e$var$_generateCallbackName("iframefcb");
            // GApi loader not available, dynamically load platform.js.
            $8dac729f232ba11e$var$_window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($8dac729f232ba11e$export$3d12bd131bb975d1(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $8dac729f232ba11e$var$_loadJS(`https://apis.google.com/js/api.js?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        $8dac729f232ba11e$var$cachedGApiLoader = null;
        throw error;
    });
}
let $8dac729f232ba11e$var$cachedGApiLoader = null;
function $8dac729f232ba11e$var$_loadGapi(auth) {
    $8dac729f232ba11e$var$cachedGApiLoader = $8dac729f232ba11e$var$cachedGApiLoader || $8dac729f232ba11e$var$loadGapi(auth);
    return $8dac729f232ba11e$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8dac729f232ba11e$var$PING_TIMEOUT = new $8dac729f232ba11e$var$Delay(5000, 15000);
const $8dac729f232ba11e$var$IFRAME_PATH = "__/auth/iframe";
const $8dac729f232ba11e$var$EMULATED_IFRAME_PATH = "emulator/auth/iframe";
const $8dac729f232ba11e$var$IFRAME_ATTRIBUTES = {
    style: {
        position: "absolute",
        top: "-100px",
        width: "1px",
        height: "1px"
    },
    "aria-hidden": "true",
    tabindex: "-1"
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const $8dac729f232ba11e$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        "p"
    ],
    [
        "staging-identitytoolkit.sandbox.googleapis.com",
        "s"
    ],
    [
        "test-identitytoolkit.sandbox.googleapis.com",
        "t"
    ] // test
]);
function $8dac729f232ba11e$var$getIframeUrl(auth) {
    const config = auth.config;
    $8dac729f232ba11e$export$91c6e00c14e7e6fd(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? $8dac729f232ba11e$var$_emulatorUrl(config, $8dac729f232ba11e$var$EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${$8dac729f232ba11e$var$IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $e3a1e3018df58994$export$31499a9cd224b78c)
    };
    const eid = $8dac729f232ba11e$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(",");
    return `${url}?${(0, $fc59d49e1bb53b6a$export$ac4103b836844853)(params).slice(1)}`;
}
async function $8dac729f232ba11e$var$_openIframe(auth) {
    const context = await $8dac729f232ba11e$var$_loadGapi(auth);
    const gapi1 = $8dac729f232ba11e$var$_window().gapi;
    $8dac729f232ba11e$export$91c6e00c14e7e6fd(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: $8dac729f232ba11e$var$getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: $8dac729f232ba11e$var$IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = $8dac729f232ba11e$export$3d12bd131bb975d1(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = $8dac729f232ba11e$var$_window().setTimeout(()=>{
                reject(networkError);
            }, $8dac729f232ba11e$var$PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                $8dac729f232ba11e$var$_window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8dac729f232ba11e$var$BASE_POPUP_OPTIONS = {
    location: "yes",
    resizable: "yes",
    statusbar: "yes",
    toolbar: "no"
};
const $8dac729f232ba11e$var$DEFAULT_WIDTH = 500;
const $8dac729f232ba11e$var$DEFAULT_HEIGHT = 600;
const $8dac729f232ba11e$var$TARGET_BLANK = "_blank";
const $8dac729f232ba11e$var$FIREFOX_EMPTY_URL = "http://localhost";
class $8dac729f232ba11e$export$9f4f30ee63539e24 {
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
}
function $8dac729f232ba11e$var$_open(auth, url, name, width = $8dac729f232ba11e$var$DEFAULT_WIDTH, height = $8dac729f232ba11e$var$DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = "";
    const options = Object.assign(Object.assign({}, $8dac729f232ba11e$var$BASE_POPUP_OPTIONS), {
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    });
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, $fc59d49e1bb53b6a$export$c36915b22ce77c19)().toLowerCase();
    if (name) target = $8dac729f232ba11e$var$_isChromeIOS(ua) ? $8dac729f232ba11e$var$TARGET_BLANK : name;
    if ($8dac729f232ba11e$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $8dac729f232ba11e$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = "yes";
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, "");
    if ($8dac729f232ba11e$var$_isIOSStandalone(ua) && target !== "_self") {
        $8dac729f232ba11e$var$openAsNewWindowIOS(url || "", target);
        return new $8dac729f232ba11e$export$9f4f30ee63539e24(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || "", target, optionsString);
    $8dac729f232ba11e$export$91c6e00c14e7e6fd(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $8dac729f232ba11e$export$9f4f30ee63539e24(newWin);
}
function $8dac729f232ba11e$var$openAsNewWindowIOS(url, target) {
    const el = document.createElement("a");
    el.href = url;
    el.target = target;
    const click = document.createEvent("MouseEvent");
    click.initMouseEvent("click", true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const $8dac729f232ba11e$var$WIDGET_PATH = "__/auth/handler";
/**
 * URL for emulated environment
 *
 * @internal
 */ const $8dac729f232ba11e$var$EMULATOR_WIDGET_PATH = "emulator/auth/handler";
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ const $8dac729f232ba11e$var$FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent("fac");
async function $8dac729f232ba11e$export$92108d983e8ee699(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    $8dac729f232ba11e$export$91c6e00c14e7e6fd(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    $8dac729f232ba11e$export$91c6e00c14e7e6fd(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType: authType,
        redirectUrl: redirectUrl,
        v: (0, $e3a1e3018df58994$export$31499a9cd224b78c),
        eventId: eventId
    };
    if (provider instanceof $8dac729f232ba11e$var$FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || "";
        if (!(0, $fc59d49e1bb53b6a$export$dd1bc94b04021eeb)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof $8dac729f232ba11e$var$BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== "");
        if (scopes.length > 0) params.scopes = scopes.join(",");
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endipointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    // Sets the App Check token to pass to the widget
    const appCheckToken = await auth._getAppCheckToken();
    const appCheckTokenFragment = appCheckToken ? `#${$8dac729f232ba11e$var$FIREBASE_APP_CHECK_FRAGMENT_ID}=${encodeURIComponent(appCheckToken)}` : "";
    // Start at index 1 to skip the leading '&' in the query string
    return `${$8dac729f232ba11e$var$getHandlerBase(auth)}?${(0, $fc59d49e1bb53b6a$export$ac4103b836844853)(paramsDict).slice(1)}${appCheckTokenFragment}`;
}
function $8dac729f232ba11e$var$getHandlerBase({ config: config  }) {
    if (!config.emulator) return `https://${config.authDomain}/${$8dac729f232ba11e$var$WIDGET_PATH}`;
    return $8dac729f232ba11e$var$_emulatorUrl(config, $8dac729f232ba11e$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const $8dac729f232ba11e$var$WEB_STORAGE_SUPPORT_KEY = "webStorageSupport";
class $8dac729f232ba11e$var$BrowserPopupRedirectResolver {
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $8dac729f232ba11e$export$407448d2b89b1813;
        this._completeRedirectFn = $8dac729f232ba11e$export$158acd800e1ef08b;
        this._overrideRedirectResult = $8dac729f232ba11e$export$cf2f7c5792f80b46;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        var _a;
        $8dac729f232ba11e$export$6554612db691658e((_a = this.eventManagers[auth._key()]) === null || _a === void 0 ? void 0 : _a.manager, "_initialize() not called before _openPopup()");
        const url = await $8dac729f232ba11e$export$92108d983e8ee699(auth, provider, authType, $8dac729f232ba11e$var$_getCurrentUrl(), eventId);
        return $8dac729f232ba11e$var$_open(auth, url, $8dac729f232ba11e$export$91477dc880baac21());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        const url = await $8dac729f232ba11e$export$92108d983e8ee699(auth, provider, authType, $8dac729f232ba11e$var$_getCurrentUrl(), eventId);
        $8dac729f232ba11e$var$_setWindowLocation(url);
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager: manager , promise: promise  } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                $8dac729f232ba11e$export$6554612db691658e(promise, "If manager is not set, promise should be");
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise: promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await $8dac729f232ba11e$var$_openIframe(auth);
        const manager = new $8dac729f232ba11e$export$9d398bebfec1c039(auth);
        iframe.register("authEvent", (iframeEvent)=>{
            $8dac729f232ba11e$export$91c6e00c14e7e6fd(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager: manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send($8dac729f232ba11e$var$WEB_STORAGE_SUPPORT_KEY, {
            type: $8dac729f232ba11e$var$WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            var _a;
            const isSupported = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a[$8dac729f232ba11e$var$WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            $8dac729f232ba11e$export$d66dc83d8cfc8dd(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $8dac729f232ba11e$var$_validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return $8dac729f232ba11e$var$_isMobileBrowser() || $8dac729f232ba11e$var$_isSafari() || $8dac729f232ba11e$export$493d36ec626b6698();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @public
 */ const $8dac729f232ba11e$export$342063e11d6c3cad = $8dac729f232ba11e$var$BrowserPopupRedirectResolver;
class $8dac729f232ba11e$var$MultiFactorAssertionImpl {
    constructor(factorId){
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* MultiFactorSessionType.ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return $8dac729f232ba11e$var$debugFail("unexpected MultiFactorSessionType");
        }
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class $8dac729f232ba11e$var$PhoneMultiFactorAssertionImpl extends $8dac729f232ba11e$var$MultiFactorAssertionImpl {
    constructor(credential){
        super("phone" /* FactorId.PHONE */ );
        this.credential = credential;
    }
    /** @internal */ static _fromCredential(credential) {
        return new $8dac729f232ba11e$var$PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return $8dac729f232ba11e$var$finalizeEnrollPhoneMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return $8dac729f232ba11e$var$finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class $8dac729f232ba11e$export$953cecd6e717a553 {
    constructor(){}
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return $8dac729f232ba11e$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */ $8dac729f232ba11e$export$953cecd6e717a553.FACTOR_ID = "phone";
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ class $8dac729f232ba11e$export$971d5caa766a69d7 {
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ static assertionForEnrollment(secret, oneTimePassword) {
        return $8dac729f232ba11e$var$TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
    }
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ static assertionForSignIn(enrollmentId, oneTimePassword) {
        return $8dac729f232ba11e$var$TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
    }
    /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ static async generateSecret(session) {
        const mfaSession = session;
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(typeof mfaSession.auth !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const response = await $8dac729f232ba11e$var$startEnrollTotpMfa(mfaSession.auth, {
            idToken: mfaSession.credential,
            totpEnrollmentInfo: {}
        });
        return $8dac729f232ba11e$export$7ccc53e8f1e7dfc5._fromStartTotpMfaEnrollmentResponse(response, mfaSession.auth);
    }
}
/**
 * The identifier of the TOTP second factor: `totp`.
 */ $8dac729f232ba11e$export$971d5caa766a69d7.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
class $8dac729f232ba11e$var$TotpMultiFactorAssertionImpl extends $8dac729f232ba11e$var$MultiFactorAssertionImpl {
    constructor(otp, enrollmentId, secret){
        super("totp" /* FactorId.TOTP */ );
        this.otp = otp;
        this.enrollmentId = enrollmentId;
        this.secret = secret;
    }
    /** @internal */ static _fromSecret(secret, otp) {
        return new $8dac729f232ba11e$var$TotpMultiFactorAssertionImpl(otp, undefined, secret);
    }
    /** @internal */ static _fromEnrollmentId(enrollmentId, otp) {
        return new $8dac729f232ba11e$var$TotpMultiFactorAssertionImpl(otp, enrollmentId);
    }
    /** @internal */ async _finalizeEnroll(auth, idToken, displayName) {
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(typeof this.secret !== "undefined", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $8dac729f232ba11e$var$finalizeEnrollTotpMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
        });
    }
    /** @internal */ async _finalizeSignIn(auth, mfaPendingCredential) {
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(this.enrollmentId !== undefined && this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        const totpVerificationInfo = {
            verificationCode: this.otp
        };
        return $8dac729f232ba11e$var$finalizeSignInTotpMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            mfaEnrollmentId: this.enrollmentId,
            totpVerificationInfo: totpVerificationInfo
        });
    }
}
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ class $8dac729f232ba11e$export$7ccc53e8f1e7dfc5 {
    // The public members are declared outside the constructor so the docs can be generated.
    constructor(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth){
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    /** @internal */ static _fromStartTotpMfaEnrollmentResponse(response, auth) {
        return new $8dac729f232ba11e$export$7ccc53e8f1e7dfc5(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
    }
    /** @internal */ _makeTotpVerificationInfo(otp) {
        return {
            sessionInfo: this.sessionInfo,
            verificationCode: otp
        };
    }
    /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ generateQrCodeUrl(accountName, issuer) {
        var _a;
        let useDefaults = false;
        if ($8dac729f232ba11e$var$_isEmptyString(accountName) || $8dac729f232ba11e$var$_isEmptyString(issuer)) useDefaults = true;
        if (useDefaults) {
            if ($8dac729f232ba11e$var$_isEmptyString(accountName)) accountName = ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.email) || "unknownuser";
            if ($8dac729f232ba11e$var$_isEmptyString(issuer)) issuer = this.auth.name;
        }
        return `otpauth://totp/${issuer}:${accountName}?secret=${this.secretKey}&issuer=${issuer}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
    }
}
/** @internal */ function $8dac729f232ba11e$var$_isEmptyString(input) {
    return typeof input === "undefined" || (input === null || input === void 0 ? void 0 : input.length) === 0;
}
var $8dac729f232ba11e$var$name = "@firebase/auth";
var $8dac729f232ba11e$var$version = "0.23.2";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8dac729f232ba11e$var$AuthInterop {
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        var _a;
        this.assertAuthConfigured();
        return ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken: accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            listener((user === null || user === void 0 ? void 0 : user.stsTokenManager.accessToken) || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8dac729f232ba11e$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return "node";
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return "rn";
        case "Worker" /* ClientPlatform.WORKER */ :
            return "webworker";
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return "cordova";
        default:
            return undefined;
    }
}
/** @internal */ function $8dac729f232ba11e$var$registerAuth(clientPlatform) {
    (0, $e3a1e3018df58994$export$c930050e7bb63965)(new (0, $e04d5da8f80f59f8$export$16fa2f45be04daa8)("auth" /* _ComponentName.AUTH */ , (container, { options: deps  })=>{
        const app = container.getProvider("app").getImmediate();
        const heartbeatServiceProvider = container.getProvider("heartbeat");
        const appCheckServiceProvider = container.getProvider("app-check-internal");
        const { apiKey: apiKey , authDomain: authDomain  } = app.options;
        $8dac729f232ba11e$export$91c6e00c14e7e6fd(apiKey && !apiKey.includes(":"), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        const config = {
            apiKey: apiKey,
            authDomain: authDomain,
            clientPlatform: clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: $8dac729f232ba11e$export$23ebac1979863676(clientPlatform)
        };
        const authInstance = new $8dac729f232ba11e$export$a05254e7c3aeba6e(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        $8dac729f232ba11e$var$_initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $e3a1e3018df58994$export$c930050e7bb63965)(new (0, $e04d5da8f80f59f8$export$16fa2f45be04daa8)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , (container)=>{
        const auth = $8dac729f232ba11e$export$a33b77bbdbb8366c(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return ((auth)=>new $8dac729f232ba11e$var$AuthInterop(auth))(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, $e3a1e3018df58994$export$d29d5299a7137abc)($8dac729f232ba11e$var$name, $8dac729f232ba11e$var$version, $8dac729f232ba11e$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $e3a1e3018df58994$export$d29d5299a7137abc)($8dac729f232ba11e$var$name, $8dac729f232ba11e$var$version, "esm2017");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8dac729f232ba11e$var$DEFAULT_ID_TOKEN_MAX_AGE = 300;
const $8dac729f232ba11e$var$authIdTokenMaxAge = (0, $fc59d49e1bb53b6a$export$5539a1a3afe87d6)("authIdTokenMaxAge") || $8dac729f232ba11e$var$DEFAULT_ID_TOKEN_MAX_AGE;
let $8dac729f232ba11e$var$lastPostedIdToken = null;
const $8dac729f232ba11e$var$mintCookieFactory = (url)=>async (user)=>{
        const idTokenResult = user && await user.getIdTokenResult();
        const idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
        if (idTokenAge && idTokenAge > $8dac729f232ba11e$var$authIdTokenMaxAge) return;
        // Specifically trip null => undefined when logged out, to delete any existing cookie
        const idToken = idTokenResult === null || idTokenResult === void 0 ? void 0 : idTokenResult.token;
        if ($8dac729f232ba11e$var$lastPostedIdToken === idToken) return;
        $8dac729f232ba11e$var$lastPostedIdToken = idToken;
        await fetch(url, {
            method: idToken ? "POST" : "DELETE",
            headers: idToken ? {
                "Authorization": `Bearer ${idToken}`
            } : {}
        });
    };
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $8dac729f232ba11e$export$ae1af26003f05816(app = (0, $e3a1e3018df58994$export$f9962582c9e66d99)()) {
    const provider = (0, $e3a1e3018df58994$export$fa0d6da0f5838f50)(app, "auth");
    if (provider.isInitialized()) return provider.getImmediate();
    const auth = $8dac729f232ba11e$export$7f8ddf7c7c20b3cd(app, {
        popupRedirectResolver: $8dac729f232ba11e$export$342063e11d6c3cad,
        persistence: [
            $8dac729f232ba11e$export$23f2a1d2818174ef,
            $8dac729f232ba11e$export$8b22cf2602fb60ce,
            $8dac729f232ba11e$export$407448d2b89b1813
        ]
    });
    const authTokenSyncUrl = (0, $fc59d49e1bb53b6a$export$5539a1a3afe87d6)("authTokenSyncURL");
    if (authTokenSyncUrl) {
        const mintCookie = $8dac729f232ba11e$var$mintCookieFactory(authTokenSyncUrl);
        $8dac729f232ba11e$export$efccba1c4a2ef57b(auth, mintCookie, ()=>mintCookie(auth.currentUser));
        $8dac729f232ba11e$export$90a7f3efeed30595(auth, (user)=>mintCookie(user));
    }
    const authEmulatorHost = (0, $fc59d49e1bb53b6a$export$9c11895284c8adad)("auth");
    if (authEmulatorHost) $8dac729f232ba11e$export$9bb611d729802a56(auth, `http://${authEmulatorHost}`);
    return auth;
}
$8dac729f232ba11e$var$registerAuth("Browser" /* ClientPlatform.BROWSER */ );
















const $494ac95ccfb2d9dd$var$name = "@firebase/database";
const $494ac95ccfb2d9dd$var$version = "0.14.4";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The semver (www.semver.org) version of the SDK. */ let $494ac95ccfb2d9dd$var$SDK_VERSION = "";
/**
 * SDK_VERSION should be set before any database instance is created
 * @internal
 */ function $494ac95ccfb2d9dd$export$c9fb972242fcb3c4(version) {
    $494ac95ccfb2d9dd$var$SDK_VERSION = version;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Wraps a DOM Storage object and:
 * - automatically encode objects as JSON strings before storing them to allow us to store arbitrary types.
 * - prefixes names with "firebase:" to avoid collisions with app data.
 *
 * We automatically (see storage.js) create two such wrappers, one for sessionStorage,
 * and one for localStorage.
 *
 */ class $494ac95ccfb2d9dd$var$DOMStorageWrapper {
    /**
     * @param domStorage_ - The underlying storage object (e.g. localStorage or sessionStorage)
     */ constructor(domStorage_){
        this.domStorage_ = domStorage_;
        // Use a prefix to avoid collisions with other stuff saved by the app.
        this.prefix_ = "firebase:";
    }
    /**
     * @param key - The key to save the value under
     * @param value - The value being stored, or null to remove the key.
     */ set(key, value) {
        if (value == null) this.domStorage_.removeItem(this.prefixedName_(key));
        else this.domStorage_.setItem(this.prefixedName_(key), (0, $fc59d49e1bb53b6a$export$fac44ee5b035f737)(value));
    }
    /**
     * @returns The value that was stored under this key, or null
     */ get(key) {
        const storedVal = this.domStorage_.getItem(this.prefixedName_(key));
        if (storedVal == null) return null;
        else return (0, $fc59d49e1bb53b6a$export$c5a53ce6a17cf18d)(storedVal);
    }
    remove(key) {
        this.domStorage_.removeItem(this.prefixedName_(key));
    }
    prefixedName_(name) {
        return this.prefix_ + name;
    }
    toString() {
        return this.domStorage_.toString();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory storage implementation that matches the API of DOMStorageWrapper
 * (TODO: create interface for both to implement).
 */ class $494ac95ccfb2d9dd$var$MemoryStorage {
    constructor(){
        this.cache_ = {};
        this.isInMemoryStorage = true;
    }
    set(key, value) {
        if (value == null) delete this.cache_[key];
        else this.cache_[key] = value;
    }
    get(key) {
        if ((0, $fc59d49e1bb53b6a$export$2344b14b097df817)(this.cache_, key)) return this.cache_[key];
        return null;
    }
    remove(key) {
        delete this.cache_[key];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to create a DOMStorageWrapper or else fall back to MemoryStorage.
 * TODO: Once MemoryStorage and DOMStorageWrapper have a shared interface this method annotation should change
 * to reflect this type
 *
 * @param domStorageName - Name of the underlying storage object
 *   (e.g. 'localStorage' or 'sessionStorage').
 * @returns Turning off type information until a common interface is defined.
 */ const $494ac95ccfb2d9dd$var$createStoragefor = function(domStorageName) {
    try {
        // NOTE: just accessing "localStorage" or "window['localStorage']" may throw a security exception,
        // so it must be inside the try/catch.
        if (typeof window !== "undefined" && typeof window[domStorageName] !== "undefined") {
            // Need to test cache. Just because it's here doesn't mean it works
            const domStorage = window[domStorageName];
            domStorage.setItem("firebase:sentinel", "cache");
            domStorage.removeItem("firebase:sentinel");
            return new $494ac95ccfb2d9dd$var$DOMStorageWrapper(domStorage);
        }
    } catch (e) {}
    // Failed to create wrapper.  Just return in-memory storage.
    // TODO: log?
    return new $494ac95ccfb2d9dd$var$MemoryStorage();
};
/** A storage object that lasts across sessions */ const $494ac95ccfb2d9dd$var$PersistentStorage = $494ac95ccfb2d9dd$var$createStoragefor("localStorage");
/** A storage object that only lasts one session */ const $494ac95ccfb2d9dd$var$SessionStorage = $494ac95ccfb2d9dd$var$createStoragefor("sessionStorage");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $494ac95ccfb2d9dd$var$logClient = new (0, $888412469b3c9c09$export$efa9a398d6368992)("@firebase/database");
/**
 * Returns a locally-unique ID (generated by just incrementing up from 0 each time its called).
 */ const $494ac95ccfb2d9dd$var$LUIDGenerator = function() {
    let id = 1;
    return function() {
        return id++;
    };
}();
/**
 * Sha1 hash of the input string
 * @param str - The string to hash
 * @returns {!string} The resulting hash
 */ const $494ac95ccfb2d9dd$var$sha1 = function(str) {
    const utf8Bytes = (0, $fc59d49e1bb53b6a$export$655666783217a925)(str);
    const sha1 = new (0, $fc59d49e1bb53b6a$export$c85d589bf4e25fef)();
    sha1.update(utf8Bytes);
    const sha1Bytes = sha1.digest();
    return (0, $fc59d49e1bb53b6a$export$b3b2de96497acc47).encodeByteArray(sha1Bytes);
};
const $494ac95ccfb2d9dd$var$buildLogMessage_ = function(...varArgs) {
    let message = "";
    for(let i = 0; i < varArgs.length; i++){
        const arg = varArgs[i];
        if (Array.isArray(arg) || arg && typeof arg === "object" && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        typeof arg.length === "number") message += $494ac95ccfb2d9dd$var$buildLogMessage_.apply(null, arg);
        else if (typeof arg === "object") message += (0, $fc59d49e1bb53b6a$export$fac44ee5b035f737)(arg);
        else message += arg;
        message += " ";
    }
    return message;
};
/**
 * Use this for all debug messages in Firebase.
 */ let $494ac95ccfb2d9dd$var$logger = null;
/**
 * Flag to check for log availability on first log message
 */ let $494ac95ccfb2d9dd$var$firstLog_ = true;
/**
 * The implementation of Firebase.enableLogging (defined here to break dependencies)
 * @param logger_ - A flag to turn on logging, or a custom logger
 * @param persistent - Whether or not to persist logging settings across refreshes
 */ const $494ac95ccfb2d9dd$var$enableLogging$1 = function(logger_, persistent) {
    (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(!persistent || logger_ === true || logger_ === false, "Can't turn on custom loggers persistently.");
    if (logger_ === true) {
        $494ac95ccfb2d9dd$var$logClient.logLevel = (0, $888412469b3c9c09$export$243e62d78d3b544d).VERBOSE;
        $494ac95ccfb2d9dd$var$logger = $494ac95ccfb2d9dd$var$logClient.log.bind($494ac95ccfb2d9dd$var$logClient);
        if (persistent) $494ac95ccfb2d9dd$var$SessionStorage.set("logging_enabled", true);
    } else if (typeof logger_ === "function") $494ac95ccfb2d9dd$var$logger = logger_;
    else {
        $494ac95ccfb2d9dd$var$logger = null;
        $494ac95ccfb2d9dd$var$SessionStorage.remove("logging_enabled");
    }
};
const $494ac95ccfb2d9dd$var$log = function(...varArgs) {
    if ($494ac95ccfb2d9dd$var$firstLog_ === true) {
        $494ac95ccfb2d9dd$var$firstLog_ = false;
        if ($494ac95ccfb2d9dd$var$logger === null && $494ac95ccfb2d9dd$var$SessionStorage.get("logging_enabled") === true) $494ac95ccfb2d9dd$var$enableLogging$1(true);
    }
    if ($494ac95ccfb2d9dd$var$logger) {
        const message = $494ac95ccfb2d9dd$var$buildLogMessage_.apply(null, varArgs);
        $494ac95ccfb2d9dd$var$logger(message);
    }
};
const $494ac95ccfb2d9dd$var$logWrapper = function(prefix) {
    return function(...varArgs) {
        $494ac95ccfb2d9dd$var$log(prefix, ...varArgs);
    };
};
const $494ac95ccfb2d9dd$var$error = function(...varArgs) {
    const message = "FIREBASE INTERNAL ERROR: " + $494ac95ccfb2d9dd$var$buildLogMessage_(...varArgs);
    $494ac95ccfb2d9dd$var$logClient.error(message);
};
const $494ac95ccfb2d9dd$var$fatal = function(...varArgs) {
    const message = `FIREBASE FATAL ERROR: ${$494ac95ccfb2d9dd$var$buildLogMessage_(...varArgs)}`;
    $494ac95ccfb2d9dd$var$logClient.error(message);
    throw new Error(message);
};
const $494ac95ccfb2d9dd$var$warn = function(...varArgs) {
    const message = "FIREBASE WARNING: " + $494ac95ccfb2d9dd$var$buildLogMessage_(...varArgs);
    $494ac95ccfb2d9dd$var$logClient.warn(message);
};
/**
 * Logs a warning if the containing page uses https. Called when a call to new Firebase
 * does not use https.
 */ const $494ac95ccfb2d9dd$var$warnIfPageIsSecure = function() {
    // Be very careful accessing browser globals. Who knows what may or may not exist.
    if (typeof window !== "undefined" && window.location && window.location.protocol && window.location.protocol.indexOf("https:") !== -1) $494ac95ccfb2d9dd$var$warn("Insecure Firebase access from a secure page. Please use https in calls to new Firebase().");
};
/**
 * Returns true if data is NaN, or +/- Infinity.
 */ const $494ac95ccfb2d9dd$var$isInvalidJSONNumber = function(data) {
    return typeof data === "number" && (data !== data || // NaN
    data === Number.POSITIVE_INFINITY || data === Number.NEGATIVE_INFINITY);
};
const $494ac95ccfb2d9dd$var$executeWhenDOMReady = function(fn) {
    if ((0, $fc59d49e1bb53b6a$export$5d1d834fbbf8bab7)() || document.readyState === "complete") fn();
    else {
        // Modeled after jQuery. Try DOMContentLoaded and onreadystatechange (which
        // fire before onload), but fall back to onload.
        let called = false;
        const wrappedFn = function() {
            if (!document.body) {
                setTimeout(wrappedFn, Math.floor(10));
                return;
            }
            if (!called) {
                called = true;
                fn();
            }
        };
        if (document.addEventListener) {
            document.addEventListener("DOMContentLoaded", wrappedFn, false);
            // fallback to onload.
            window.addEventListener("load", wrappedFn, false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } else if (document.attachEvent) {
            // IE.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            document.attachEvent("onreadystatechange", ()=>{
                if (document.readyState === "complete") wrappedFn();
            });
            // fallback to onload.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            window.attachEvent("onload", wrappedFn);
        // jQuery has an extra hack for IE that we could employ (based on
        // http://javascript.nwbox.com/IEContentLoaded/) But it looks really old.
        // I'm hoping we don't need it.
        }
    }
};
/**
 * Minimum key name. Invalid for actual data, used as a marker to sort before any valid names
 */ const $494ac95ccfb2d9dd$var$MIN_NAME = "[MIN_NAME]";
/**
 * Maximum key name. Invalid for actual data, used as a marker to sort above any valid names
 */ const $494ac95ccfb2d9dd$var$MAX_NAME = "[MAX_NAME]";
/**
 * Compares valid Firebase key names, plus min and max name
 */ const $494ac95ccfb2d9dd$var$nameCompare = function(a, b) {
    if (a === b) return 0;
    else if (a === $494ac95ccfb2d9dd$var$MIN_NAME || b === $494ac95ccfb2d9dd$var$MAX_NAME) return -1;
    else if (b === $494ac95ccfb2d9dd$var$MIN_NAME || a === $494ac95ccfb2d9dd$var$MAX_NAME) return 1;
    else {
        const aAsInt = $494ac95ccfb2d9dd$var$tryParseInt(a), bAsInt = $494ac95ccfb2d9dd$var$tryParseInt(b);
        if (aAsInt !== null) {
            if (bAsInt !== null) return aAsInt - bAsInt === 0 ? a.length - b.length : aAsInt - bAsInt;
            else return -1;
        } else if (bAsInt !== null) return 1;
        else return a < b ? -1 : 1;
    }
};
/**
 * @returns {!number} comparison result.
 */ const $494ac95ccfb2d9dd$var$stringCompare = function(a, b) {
    if (a === b) return 0;
    else if (a < b) return -1;
    else return 1;
};
const $494ac95ccfb2d9dd$var$requireKey = function(key, obj) {
    if (obj && key in obj) return obj[key];
    else throw new Error("Missing required key (" + key + ") in object: " + (0, $fc59d49e1bb53b6a$export$fac44ee5b035f737)(obj));
};
const $494ac95ccfb2d9dd$var$ObjectToUniqueKey = function(obj) {
    if (typeof obj !== "object" || obj === null) return (0, $fc59d49e1bb53b6a$export$fac44ee5b035f737)(obj);
    const keys = [];
    // eslint-disable-next-line guard-for-in
    for(const k in obj)keys.push(k);
    // Export as json, but with the keys sorted.
    keys.sort();
    let key = "{";
    for(let i = 0; i < keys.length; i++){
        if (i !== 0) key += ",";
        key += (0, $fc59d49e1bb53b6a$export$fac44ee5b035f737)(keys[i]);
        key += ":";
        key += $494ac95ccfb2d9dd$var$ObjectToUniqueKey(obj[keys[i]]);
    }
    key += "}";
    return key;
};
/**
 * Splits a string into a number of smaller segments of maximum size
 * @param str - The string
 * @param segsize - The maximum number of chars in the string.
 * @returns The string, split into appropriately-sized chunks
 */ const $494ac95ccfb2d9dd$var$splitStringBySize = function(str, segsize) {
    const len = str.length;
    if (len <= segsize) return [
        str
    ];
    const dataSegs = [];
    for(let c = 0; c < len; c += segsize)if (c + segsize > len) dataSegs.push(str.substring(c, len));
    else dataSegs.push(str.substring(c, c + segsize));
    return dataSegs;
};
/**
 * Apply a function to each (key, value) pair in an object or
 * apply a function to each (index, value) pair in an array
 * @param obj - The object or array to iterate over
 * @param fn - The function to apply
 */ function $494ac95ccfb2d9dd$var$each(obj, fn) {
    for(const key in obj)if (obj.hasOwnProperty(key)) fn(key, obj[key]);
}
/**
 * Borrowed from http://hg.secondlife.com/llsd/src/tip/js/typedarray.js (MIT License)
 * I made one modification at the end and removed the NaN / Infinity
 * handling (since it seemed broken [caused an overflow] and we don't need it).  See MJL comments.
 * @param v - A double
 *
 */ const $494ac95ccfb2d9dd$var$doubleToIEEE754String = function(v) {
    (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(!$494ac95ccfb2d9dd$var$isInvalidJSONNumber(v), "Invalid JSON number"); // MJL
    const ebits = 11, fbits = 52;
    const bias = (1 << ebits - 1) - 1;
    let s, e, f, ln, i;
    // Compute sign, exponent, fraction
    // Skip NaN / Infinity handling --MJL.
    if (v === 0) {
        e = 0;
        f = 0;
        s = 1 / v === -Infinity ? 1 : 0;
    } else {
        s = v < 0;
        v = Math.abs(v);
        if (v >= Math.pow(2, 1 - bias)) {
            // Normalized
            ln = Math.min(Math.floor(Math.log(v) / Math.LN2), bias);
            e = ln + bias;
            f = Math.round(v * Math.pow(2, fbits - ln) - Math.pow(2, fbits));
        } else {
            // Denormalized
            e = 0;
            f = Math.round(v / Math.pow(2, 1 - bias - fbits));
        }
    }
    // Pack sign, exponent, fraction
    const bits = [];
    for(i = fbits; i; i -= 1){
        bits.push(f % 2 ? 1 : 0);
        f = Math.floor(f / 2);
    }
    for(i = ebits; i; i -= 1){
        bits.push(e % 2 ? 1 : 0);
        e = Math.floor(e / 2);
    }
    bits.push(s ? 1 : 0);
    bits.reverse();
    const str = bits.join("");
    // Return the data as a hex string. --MJL
    let hexByteString = "";
    for(i = 0; i < 64; i += 8){
        let hexByte = parseInt(str.substr(i, 8), 2).toString(16);
        if (hexByte.length === 1) hexByte = "0" + hexByte;
        hexByteString = hexByteString + hexByte;
    }
    return hexByteString.toLowerCase();
};
/**
 * Used to detect if we're in a Chrome content script (which executes in an
 * isolated environment where long-polling doesn't work).
 */ const $494ac95ccfb2d9dd$var$isChromeExtensionContentScript = function() {
    return !!(typeof window === "object" && window["chrome"] && window["chrome"]["extension"] && !/^chrome/.test(window.location.href));
};
/**
 * Used to detect if we're in a Windows 8 Store app.
 */ const $494ac95ccfb2d9dd$var$isWindowsStoreApp = function() {
    // Check for the presence of a couple WinRT globals
    return typeof Windows === "object" && typeof Windows.UI === "object";
};
/**
 * Converts a server error code to a Javascript Error
 */ function $494ac95ccfb2d9dd$var$errorForServerCode(code, query) {
    let reason = "Unknown Error";
    if (code === "too_big") reason = "The data requested exceeds the maximum size that can be accessed with a single request.";
    else if (code === "permission_denied") reason = "Client doesn't have permission to access the desired data.";
    else if (code === "unavailable") reason = "The service is unavailable";
    const error = new Error(code + " at " + query._path.toString() + ": " + reason);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error.code = code.toUpperCase();
    return error;
}
/**
 * Used to test for integer-looking strings
 */ const $494ac95ccfb2d9dd$var$INTEGER_REGEXP_ = new RegExp("^-?(0*)\\d{1,10}$");
/**
 * For use in keys, the minimum possible 32-bit integer.
 */ const $494ac95ccfb2d9dd$var$INTEGER_32_MIN = -2147483648;
/**
 * For use in kyes, the maximum possible 32-bit integer.
 */ const $494ac95ccfb2d9dd$var$INTEGER_32_MAX = 2147483647;
/**
 * If the string contains a 32-bit integer, return it.  Else return null.
 */ const $494ac95ccfb2d9dd$var$tryParseInt = function(str) {
    if ($494ac95ccfb2d9dd$var$INTEGER_REGEXP_.test(str)) {
        const intVal = Number(str);
        if (intVal >= $494ac95ccfb2d9dd$var$INTEGER_32_MIN && intVal <= $494ac95ccfb2d9dd$var$INTEGER_32_MAX) return intVal;
    }
    return null;
};
/**
 * Helper to run some code but catch any exceptions and re-throw them later.
 * Useful for preventing user callbacks from breaking internal code.
 *
 * Re-throwing the exception from a setTimeout is a little evil, but it's very
 * convenient (we don't have to try to figure out when is a safe point to
 * re-throw it), and the behavior seems reasonable:
 *
 * * If you aren't pausing on exceptions, you get an error in the console with
 *   the correct stack trace.
 * * If you're pausing on all exceptions, the debugger will pause on your
 *   exception and then again when we rethrow it.
 * * If you're only pausing on uncaught exceptions, the debugger will only pause
 *   on us re-throwing it.
 *
 * @param fn - The code to guard.
 */ const $494ac95ccfb2d9dd$var$exceptionGuard = function(fn) {
    try {
        fn();
    } catch (e) {
        // Re-throw exception when it's safe.
        setTimeout(()=>{
            // It used to be that "throw e" would result in a good console error with
            // relevant context, but as of Chrome 39, you just get the firebase.js
            // file/line number where we re-throw it, which is useless. So we log
            // e.stack explicitly.
            const stack = e.stack || "";
            $494ac95ccfb2d9dd$var$warn("Exception was thrown by user callback.", stack);
            throw e;
        }, Math.floor(0));
    }
};
/**
 * @returns {boolean} true if we think we're currently being crawled.
 */ const $494ac95ccfb2d9dd$var$beingCrawled = function() {
    const userAgent = typeof window === "object" && window["navigator"] && window["navigator"]["userAgent"] || "";
    // For now we whitelist the most popular crawlers.  We should refine this to be the set of crawlers we
    // believe to support JavaScript/AJAX rendering.
    // NOTE: Google Webmaster Tools doesn't really belong, but their "This is how a visitor to your website
    // would have seen the page" is flaky if we don't treat it as a crawler.
    return userAgent.search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0;
};
/**
 * Same as setTimeout() except on Node.JS it will /not/ prevent the process from exiting.
 *
 * It is removed with clearTimeout() as normal.
 *
 * @param fn - Function to run.
 * @param time - Milliseconds to wait before running.
 * @returns The setTimeout() return value.
 */ const $494ac95ccfb2d9dd$var$setTimeoutNonBlocking = function(fn, time) {
    const timeout = setTimeout(fn, time);
    // Note: at the time of this comment, unrefTimer is under the unstable set of APIs. Run with --unstable to enable the API.
    if (typeof timeout === "number" && // @ts-ignore Is only defined in Deno environments.
    typeof Deno !== "undefined" && // @ts-ignore Deno and unrefTimer are only defined in Deno environments.
    Deno["unrefTimer"]) // @ts-ignore Deno and unrefTimer are only defined in Deno environments.
    Deno.unrefTimer(timeout);
    else if (typeof timeout === "object" && timeout["unref"]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    timeout["unref"]();
    return timeout;
};
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Abstraction around AppCheck's token fetching capabilities.
 */ class $494ac95ccfb2d9dd$var$AppCheckTokenProvider {
    constructor(appName_, appCheckProvider){
        this.appName_ = appName_;
        this.appCheckProvider = appCheckProvider;
        this.appCheck = appCheckProvider === null || appCheckProvider === void 0 ? void 0 : appCheckProvider.getImmediate({
            optional: true
        });
        if (!this.appCheck) appCheckProvider === null || appCheckProvider === void 0 || appCheckProvider.get().then((appCheck)=>this.appCheck = appCheck);
    }
    getToken(forceRefresh) {
        if (!this.appCheck) return new Promise((resolve, reject)=>{
            // Support delayed initialization of FirebaseAppCheck. This allows our
            // customers to initialize the RTDB SDK before initializing Firebase
            // AppCheck and ensures that all requests are authenticated if a token
            // becomes available before the timoeout below expires.
            setTimeout(()=>{
                if (this.appCheck) this.getToken(forceRefresh).then(resolve, reject);
                else resolve(null);
            }, 0);
        });
        return this.appCheck.getToken(forceRefresh);
    }
    addTokenChangeListener(listener) {
        var _a;
        (_a = this.appCheckProvider) === null || _a === void 0 || _a.get().then((appCheck)=>appCheck.addTokenListener(listener));
    }
    notifyForInvalidToken() {
        $494ac95ccfb2d9dd$var$warn(`Provided AppCheck credentials for the app named "${this.appName_}" ` + "are invalid. This usually indicates your app was not initialized correctly.");
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Abstraction around FirebaseApp's token fetching capabilities.
 */ class $494ac95ccfb2d9dd$var$FirebaseAuthTokenProvider {
    constructor(appName_, firebaseOptions_, authProvider_){
        this.appName_ = appName_;
        this.firebaseOptions_ = firebaseOptions_;
        this.authProvider_ = authProvider_;
        this.auth_ = null;
        this.auth_ = authProvider_.getImmediate({
            optional: true
        });
        if (!this.auth_) authProvider_.onInit((auth)=>this.auth_ = auth);
    }
    getToken(forceRefresh) {
        if (!this.auth_) return new Promise((resolve, reject)=>{
            // Support delayed initialization of FirebaseAuth. This allows our
            // customers to initialize the RTDB SDK before initializing Firebase
            // Auth and ensures that all requests are authenticated if a token
            // becomes available before the timoeout below expires.
            setTimeout(()=>{
                if (this.auth_) this.getToken(forceRefresh).then(resolve, reject);
                else resolve(null);
            }, 0);
        });
        return this.auth_.getToken(forceRefresh).catch((error)=>{
            // TODO: Need to figure out all the cases this is raised and whether
            // this makes sense.
            if (error && error.code === "auth/token-not-initialized") {
                $494ac95ccfb2d9dd$var$log("Got auth/token-not-initialized error.  Treating as null token.");
                return null;
            } else return Promise.reject(error);
        });
    }
    addTokenChangeListener(listener) {
        // TODO: We might want to wrap the listener and call it with no args to
        // avoid a leaky abstraction, but that makes removing the listener harder.
        if (this.auth_) this.auth_.addAuthTokenListener(listener);
        else this.authProvider_.get().then((auth)=>auth.addAuthTokenListener(listener));
    }
    removeTokenChangeListener(listener) {
        this.authProvider_.get().then((auth)=>auth.removeAuthTokenListener(listener));
    }
    notifyForInvalidToken() {
        let errorMessage = 'Provided authentication credentials for the app named "' + this.appName_ + '" are invalid. This usually indicates your app was not ' + "initialized correctly. ";
        if ("credential" in this.firebaseOptions_) errorMessage += 'Make sure the "credential" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.';
        else if ("serviceAccount" in this.firebaseOptions_) errorMessage += 'Make sure the "serviceAccount" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.';
        else errorMessage += 'Make sure the "apiKey" and "databaseURL" properties provided to initializeApp() match the values provided for your app at https://console.firebase.google.com/.';
        $494ac95ccfb2d9dd$var$warn(errorMessage);
    }
}
/* AuthTokenProvider that supplies a constant token. Used by Admin SDK or mockUserToken with emulators. */ class $494ac95ccfb2d9dd$var$EmulatorTokenProvider {
    constructor(accessToken){
        this.accessToken = accessToken;
    }
    getToken(forceRefresh) {
        return Promise.resolve({
            accessToken: this.accessToken
        });
    }
    addTokenChangeListener(listener) {
        // Invoke the listener immediately to match the behavior in Firebase Auth
        // (see packages/auth/src/auth.js#L1807)
        listener(this.accessToken);
    }
    removeTokenChangeListener(listener) {}
    notifyForInvalidToken() {}
}
/** A string that is treated as an admin access token by the RTDB emulator. Used by Admin SDK. */ $494ac95ccfb2d9dd$var$EmulatorTokenProvider.OWNER = "owner";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $494ac95ccfb2d9dd$var$PROTOCOL_VERSION = "5";
const $494ac95ccfb2d9dd$var$VERSION_PARAM = "v";
const $494ac95ccfb2d9dd$var$TRANSPORT_SESSION_PARAM = "s";
const $494ac95ccfb2d9dd$var$REFERER_PARAM = "r";
const $494ac95ccfb2d9dd$var$FORGE_REF = "f";
// Matches console.firebase.google.com, firebase-console-*.corp.google.com and
// firebase.corp.google.com
const $494ac95ccfb2d9dd$var$FORGE_DOMAIN_RE = /(console\.firebase|firebase-console-\w+\.corp|firebase\.corp)\.google\.com/;
const $494ac95ccfb2d9dd$var$LAST_SESSION_PARAM = "ls";
const $494ac95ccfb2d9dd$var$APPLICATION_ID_PARAM = "p";
const $494ac95ccfb2d9dd$var$APP_CHECK_TOKEN_PARAM = "ac";
const $494ac95ccfb2d9dd$var$WEBSOCKET = "websocket";
const $494ac95ccfb2d9dd$var$LONG_POLLING = "long_polling";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class that holds metadata about a Repo object
 */ class $494ac95ccfb2d9dd$var$RepoInfo {
    /**
     * @param host - Hostname portion of the url for the repo
     * @param secure - Whether or not this repo is accessed over ssl
     * @param namespace - The namespace represented by the repo
     * @param webSocketOnly - Whether to prefer websockets over all other transports (used by Nest).
     * @param nodeAdmin - Whether this instance uses Admin SDK credentials
     * @param persistenceKey - Override the default session persistence storage key
     */ constructor(host, secure, namespace, webSocketOnly, nodeAdmin = false, persistenceKey = "", includeNamespaceInQueryParams = false, isUsingEmulator = false){
        this.secure = secure;
        this.namespace = namespace;
        this.webSocketOnly = webSocketOnly;
        this.nodeAdmin = nodeAdmin;
        this.persistenceKey = persistenceKey;
        this.includeNamespaceInQueryParams = includeNamespaceInQueryParams;
        this.isUsingEmulator = isUsingEmulator;
        this._host = host.toLowerCase();
        this._domain = this._host.substr(this._host.indexOf(".") + 1);
        this.internalHost = $494ac95ccfb2d9dd$var$PersistentStorage.get("host:" + host) || this._host;
    }
    isCacheableHost() {
        return this.internalHost.substr(0, 2) === "s-";
    }
    isCustomHost() {
        return this._domain !== "firebaseio.com" && this._domain !== "firebaseio-demo.com";
    }
    get host() {
        return this._host;
    }
    set host(newHost) {
        if (newHost !== this.internalHost) {
            this.internalHost = newHost;
            if (this.isCacheableHost()) $494ac95ccfb2d9dd$var$PersistentStorage.set("host:" + this._host, this.internalHost);
        }
    }
    toString() {
        let str = this.toURLString();
        if (this.persistenceKey) str += "<" + this.persistenceKey + ">";
        return str;
    }
    toURLString() {
        const protocol = this.secure ? "https://" : "http://";
        const query = this.includeNamespaceInQueryParams ? `?ns=${this.namespace}` : "";
        return `${protocol}${this.host}/${query}`;
    }
}
function $494ac95ccfb2d9dd$var$repoInfoNeedsQueryParam(repoInfo) {
    return repoInfo.host !== repoInfo.internalHost || repoInfo.isCustomHost() || repoInfo.includeNamespaceInQueryParams;
}
/**
 * Returns the websocket URL for this repo
 * @param repoInfo - RepoInfo object
 * @param type - of connection
 * @param params - list
 * @returns The URL for this repo
 */ function $494ac95ccfb2d9dd$var$repoInfoConnectionURL(repoInfo, type, params) {
    (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(typeof type === "string", "typeof type must == string");
    (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(typeof params === "object", "typeof params must == object");
    let connURL;
    if (type === $494ac95ccfb2d9dd$var$WEBSOCKET) connURL = (repoInfo.secure ? "wss://" : "ws://") + repoInfo.internalHost + "/.ws?";
    else if (type === $494ac95ccfb2d9dd$var$LONG_POLLING) connURL = (repoInfo.secure ? "https://" : "http://") + repoInfo.internalHost + "/.lp?";
    else throw new Error("Unknown connection type: " + type);
    if ($494ac95ccfb2d9dd$var$repoInfoNeedsQueryParam(repoInfo)) params["ns"] = repoInfo.namespace;
    const pairs = [];
    $494ac95ccfb2d9dd$var$each(params, (key, value)=>{
        pairs.push(key + "=" + value);
    });
    return connURL + pairs.join("&");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Tracks a collection of stats.
 */ class $494ac95ccfb2d9dd$var$StatsCollection {
    constructor(){
        this.counters_ = {};
    }
    incrementCounter(name, amount = 1) {
        if (!(0, $fc59d49e1bb53b6a$export$2344b14b097df817)(this.counters_, name)) this.counters_[name] = 0;
        this.counters_[name] += amount;
    }
    get() {
        return (0, $fc59d49e1bb53b6a$export$6c40052bed430212)(this.counters_);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $494ac95ccfb2d9dd$var$collections = {};
const $494ac95ccfb2d9dd$var$reporters = {};
function $494ac95ccfb2d9dd$var$statsManagerGetCollection(repoInfo) {
    const hashString = repoInfo.toString();
    if (!$494ac95ccfb2d9dd$var$collections[hashString]) $494ac95ccfb2d9dd$var$collections[hashString] = new $494ac95ccfb2d9dd$var$StatsCollection();
    return $494ac95ccfb2d9dd$var$collections[hashString];
}
function $494ac95ccfb2d9dd$var$statsManagerGetOrCreateReporter(repoInfo, creatorFunction) {
    const hashString = repoInfo.toString();
    if (!$494ac95ccfb2d9dd$var$reporters[hashString]) $494ac95ccfb2d9dd$var$reporters[hashString] = creatorFunction();
    return $494ac95ccfb2d9dd$var$reporters[hashString];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class ensures the packets from the server arrive in order
 * This class takes data from the server and ensures it gets passed into the callbacks in order.
 */ class $494ac95ccfb2d9dd$var$PacketReceiver {
    /**
     * @param onMessage_
     */ constructor(onMessage_){
        this.onMessage_ = onMessage_;
        this.pendingResponses = [];
        this.currentResponseNum = 0;
        this.closeAfterResponse = -1;
        this.onClose = null;
    }
    closeAfter(responseNum, callback) {
        this.closeAfterResponse = responseNum;
        this.onClose = callback;
        if (this.closeAfterResponse < this.currentResponseNum) {
            this.onClose();
            this.onClose = null;
        }
    }
    /**
     * Each message from the server comes with a response number, and an array of data. The responseNumber
     * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
     * browsers will respond in the same order as the requests we sent
     */ handleResponse(requestNum, data) {
        this.pendingResponses[requestNum] = data;
        while(this.pendingResponses[this.currentResponseNum]){
            const toProcess = this.pendingResponses[this.currentResponseNum];
            delete this.pendingResponses[this.currentResponseNum];
            for(let i = 0; i < toProcess.length; ++i)if (toProcess[i]) $494ac95ccfb2d9dd$var$exceptionGuard(()=>{
                this.onMessage_(toProcess[i]);
            });
            if (this.currentResponseNum === this.closeAfterResponse) {
                if (this.onClose) {
                    this.onClose();
                    this.onClose = null;
                }
                break;
            }
            this.currentResponseNum++;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // URL query parameters associated with longpolling
const $494ac95ccfb2d9dd$var$FIREBASE_LONGPOLL_START_PARAM = "start";
const $494ac95ccfb2d9dd$var$FIREBASE_LONGPOLL_CLOSE_COMMAND = "close";
const $494ac95ccfb2d9dd$var$FIREBASE_LONGPOLL_COMMAND_CB_NAME = "pLPCommand";
const $494ac95ccfb2d9dd$var$FIREBASE_LONGPOLL_DATA_CB_NAME = "pRTLPCB";
const $494ac95ccfb2d9dd$var$FIREBASE_LONGPOLL_ID_PARAM = "id";
const $494ac95ccfb2d9dd$var$FIREBASE_LONGPOLL_PW_PARAM = "pw";
const $494ac95ccfb2d9dd$var$FIREBASE_LONGPOLL_SERIAL_PARAM = "ser";
const $494ac95ccfb2d9dd$var$FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = "cb";
const $494ac95ccfb2d9dd$var$FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = "seg";
const $494ac95ccfb2d9dd$var$FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = "ts";
const $494ac95ccfb2d9dd$var$FIREBASE_LONGPOLL_DATA_PARAM = "d";
const $494ac95ccfb2d9dd$var$FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = "dframe";
//Data size constants.
//TODO: Perf: the maximum length actually differs from browser to browser.
// We should check what browser we're on and set accordingly.
const $494ac95ccfb2d9dd$var$MAX_URL_DATA_SIZE = 1870;
const $494ac95ccfb2d9dd$var$SEG_HEADER_SIZE = 30; //ie: &seg=8299234&ts=982389123&d=
const $494ac95ccfb2d9dd$var$MAX_PAYLOAD_SIZE = $494ac95ccfb2d9dd$var$MAX_URL_DATA_SIZE - $494ac95ccfb2d9dd$var$SEG_HEADER_SIZE;
/**
 * Keepalive period
 * send a fresh request at minimum every 25 seconds. Opera has a maximum request
 * length of 30 seconds that we can't exceed.
 */ const $494ac95ccfb2d9dd$var$KEEPALIVE_REQUEST_INTERVAL = 25000;
/**
 * How long to wait before aborting a long-polling connection attempt.
 */ const $494ac95ccfb2d9dd$var$LP_CONNECT_TIMEOUT = 30000;
/**
 * This class manages a single long-polling connection.
 */ class $494ac95ccfb2d9dd$var$BrowserPollConnection {
    /**
     * @param connId An identifier for this connection, used for logging
     * @param repoInfo The info for the endpoint to send data to.
     * @param applicationId The Firebase App ID for this project.
     * @param appCheckToken The AppCheck token for this client.
     * @param authToken The AuthToken to use for this connection.
     * @param transportSessionId Optional transportSessionid if we are
     * reconnecting for an existing transport session
     * @param lastSessionId Optional lastSessionId if the PersistentConnection has
     * already created a connection previously
     */ constructor(connId, repoInfo, applicationId, appCheckToken, authToken, transportSessionId, lastSessionId){
        this.connId = connId;
        this.repoInfo = repoInfo;
        this.applicationId = applicationId;
        this.appCheckToken = appCheckToken;
        this.authToken = authToken;
        this.transportSessionId = transportSessionId;
        this.lastSessionId = lastSessionId;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.everConnected_ = false;
        this.log_ = $494ac95ccfb2d9dd$var$logWrapper(connId);
        this.stats_ = $494ac95ccfb2d9dd$var$statsManagerGetCollection(repoInfo);
        this.urlFn = (params)=>{
            // Always add the token if we have one.
            if (this.appCheckToken) params[$494ac95ccfb2d9dd$var$APP_CHECK_TOKEN_PARAM] = this.appCheckToken;
            return $494ac95ccfb2d9dd$var$repoInfoConnectionURL(repoInfo, $494ac95ccfb2d9dd$var$LONG_POLLING, params);
        };
    }
    /**
     * @param onMessage - Callback when messages arrive
     * @param onDisconnect - Callback with connection lost.
     */ open(onMessage, onDisconnect) {
        this.curSegmentNum = 0;
        this.onDisconnect_ = onDisconnect;
        this.myPacketOrderer = new $494ac95ccfb2d9dd$var$PacketReceiver(onMessage);
        this.isClosed_ = false;
        this.connectTimeoutTimer_ = setTimeout(()=>{
            this.log_("Timed out trying to connect.");
            // Make sure we clear the host cache
            this.onClosed_();
            this.connectTimeoutTimer_ = null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor($494ac95ccfb2d9dd$var$LP_CONNECT_TIMEOUT));
        // Ensure we delay the creation of the iframe until the DOM is loaded.
        $494ac95ccfb2d9dd$var$executeWhenDOMReady(()=>{
            if (this.isClosed_) return;
            //Set up a callback that gets triggered once a connection is set up.
            this.scriptTagHolder = new $494ac95ccfb2d9dd$var$FirebaseIFrameScriptHolder((...args)=>{
                const [command, arg1, arg2, arg3, arg4] = args;
                this.incrementIncomingBytes_(args);
                if (!this.scriptTagHolder) return; // we closed the connection.
                if (this.connectTimeoutTimer_) {
                    clearTimeout(this.connectTimeoutTimer_);
                    this.connectTimeoutTimer_ = null;
                }
                this.everConnected_ = true;
                if (command === $494ac95ccfb2d9dd$var$FIREBASE_LONGPOLL_START_PARAM) {
                    this.id = arg1;
                    this.password = arg2;
                } else if (command === $494ac95ccfb2d9dd$var$FIREBASE_LONGPOLL_CLOSE_COMMAND) {
                    // Don't clear the host cache. We got a response from the server, so we know it's reachable
                    if (arg1) {
                        // We aren't expecting any more data (other than what the server's already in the process of sending us
                        // through our already open polls), so don't send any more.
                        this.scriptTagHolder.sendNewPolls = false;
                        // arg1 in this case is the last response number sent by the server. We should try to receive
                        // all of the responses up to this one before closing
                        this.myPacketOrderer.closeAfter(arg1, ()=>{
                            this.onClosed_();
                        });
                    } else this.onClosed_();
                } else throw new Error("Unrecognized command received: " + command);
            }, (...args)=>{
                const [pN, data] = args;
                this.incrementIncomingBytes_(args);
                this.myPacketOrderer.handleResponse(pN, data);
            }, ()=>{
                this.onClosed_();
            }, this.urlFn);
            //Send the initial request to connect. The serial number is simply to keep the browser from pulling previous results
            //from cache.
            const urlParams = {};
            urlParams[$494ac95ccfb2d9dd$var$FIREBASE_LONGPOLL_START_PARAM] = "t";
            urlParams[$494ac95ccfb2d9dd$var$FIREBASE_LONGPOLL_SERIAL_PARAM] = Math.floor(Math.random() * 100000000);
            if (this.scriptTagHolder.uniqueCallbackIdentifier) urlParams[$494ac95ccfb2d9dd$var$FIREBASE_LONGPOLL_CALLBACK_ID_PARAM] = this.scriptTagHolder.uniqueCallbackIdentifier;
            urlParams[$494ac95ccfb2d9dd$var$VERSION_PARAM] = $494ac95ccfb2d9dd$var$PROTOCOL_VERSION;
            if (this.transportSessionId) urlParams[$494ac95ccfb2d9dd$var$TRANSPORT_SESSION_PARAM] = this.transportSessionId;
            if (this.lastSessionId) urlParams[$494ac95ccfb2d9dd$var$LAST_SESSION_PARAM] = this.lastSessionId;
            if (this.applicationId) urlParams[$494ac95ccfb2d9dd$var$APPLICATION_ID_PARAM] = this.applicationId;
            if (this.appCheckToken) urlParams[$494ac95ccfb2d9dd$var$APP_CHECK_TOKEN_PARAM] = this.appCheckToken;
            if (typeof location !== "undefined" && location.hostname && $494ac95ccfb2d9dd$var$FORGE_DOMAIN_RE.test(location.hostname)) urlParams[$494ac95ccfb2d9dd$var$REFERER_PARAM] = $494ac95ccfb2d9dd$var$FORGE_REF;
            const connectURL = this.urlFn(urlParams);
            this.log_("Connecting via long-poll to " + connectURL);
            this.scriptTagHolder.addTag(connectURL, ()=>{
            /* do nothing */ });
        });
    }
    /**
     * Call this when a handshake has completed successfully and we want to consider the connection established
     */ start() {
        this.scriptTagHolder.startLongPoll(this.id, this.password);
        this.addDisconnectPingFrame(this.id, this.password);
    }
    /**
     * Forces long polling to be considered as a potential transport
     */ static forceAllow() {
        $494ac95ccfb2d9dd$var$BrowserPollConnection.forceAllow_ = true;
    }
    /**
     * Forces longpolling to not be considered as a potential transport
     */ static forceDisallow() {
        $494ac95ccfb2d9dd$var$BrowserPollConnection.forceDisallow_ = true;
    }
    // Static method, use string literal so it can be accessed in a generic way
    static isAvailable() {
        if ((0, $fc59d49e1bb53b6a$export$5d1d834fbbf8bab7)()) return false;
        else if ($494ac95ccfb2d9dd$var$BrowserPollConnection.forceAllow_) return true;
        else // NOTE: In React-Native there's normally no 'document', but if you debug a React-Native app in
        // the Chrome debugger, 'document' is defined, but document.createElement is null (2015/06/08).
        return !$494ac95ccfb2d9dd$var$BrowserPollConnection.forceDisallow_ && typeof document !== "undefined" && document.createElement != null && !$494ac95ccfb2d9dd$var$isChromeExtensionContentScript() && !$494ac95ccfb2d9dd$var$isWindowsStoreApp();
    }
    /**
     * No-op for polling
     */ markConnectionHealthy() {}
    /**
     * Stops polling and cleans up the iframe
     */ shutdown_() {
        this.isClosed_ = true;
        if (this.scriptTagHolder) {
            this.scriptTagHolder.close();
            this.scriptTagHolder = null;
        }
        //remove the disconnect frame, which will trigger an XHR call to the server to tell it we're leaving.
        if (this.myDisconnFrame) {
            document.body.removeChild(this.myDisconnFrame);
            this.myDisconnFrame = null;
        }
        if (this.connectTimeoutTimer_) {
            clearTimeout(this.connectTimeoutTimer_);
            this.connectTimeoutTimer_ = null;
        }
    }
    /**
     * Triggered when this transport is closed
     */ onClosed_() {
        if (!this.isClosed_) {
            this.log_("Longpoll is closing itself");
            this.shutdown_();
            if (this.onDisconnect_) {
                this.onDisconnect_(this.everConnected_);
                this.onDisconnect_ = null;
            }
        }
    }
    /**
     * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
     * that we've left.
     */ close() {
        if (!this.isClosed_) {
            this.log_("Longpoll is being closed.");
            this.shutdown_();
        }
    }
    /**
     * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
     * broken into chunks (since URLs have a small maximum length).
     * @param data - The JSON data to transmit.
     */ send(data) {
        const dataStr = (0, $fc59d49e1bb53b6a$export$fac44ee5b035f737)(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter("bytes_sent", dataStr.length);
        //first, lets get the base64-encoded data
        const base64data = (0, $fc59d49e1bb53b6a$export$e510a73ee562749)(dataStr);
        //We can only fit a certain amount in each URL, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        const dataSegs = $494ac95ccfb2d9dd$var$splitStringBySize(base64data, $494ac95ccfb2d9dd$var$MAX_PAYLOAD_SIZE);
        //Enqueue each segment for transmission. We assign each chunk a sequential ID and a total number
        //of segments so that we can reassemble the packet on the server.
        for(let i = 0; i < dataSegs.length; i++){
            this.scriptTagHolder.enqueueSegment(this.curSegmentNum, dataSegs.length, dataSegs[i]);
            this.curSegmentNum++;
        }
    }
    /**
     * This is how we notify the server that we're leaving.
     * We aren't able to send requests with DHTML on a window close event, but we can
     * trigger XHR requests in some browsers (everything but Opera basically).
     */ addDisconnectPingFrame(id, pw) {
        if ((0, $fc59d49e1bb53b6a$export$5d1d834fbbf8bab7)()) return;
        this.myDisconnFrame = document.createElement("iframe");
        const urlParams = {};
        urlParams[$494ac95ccfb2d9dd$var$FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM] = "t";
        urlParams[$494ac95ccfb2d9dd$var$FIREBASE_LONGPOLL_ID_PARAM] = id;
        urlParams[$494ac95ccfb2d9dd$var$FIREBASE_LONGPOLL_PW_PARAM] = pw;
        this.myDisconnFrame.src = this.urlFn(urlParams);
        this.myDisconnFrame.style.display = "none";
        document.body.appendChild(this.myDisconnFrame);
    }
    /**
     * Used to track the bytes received by this client
     */ incrementIncomingBytes_(args) {
        // TODO: This is an annoying perf hit just to track the number of incoming bytes.  Maybe it should be opt-in.
        const bytesReceived = (0, $fc59d49e1bb53b6a$export$fac44ee5b035f737)(args).length;
        this.bytesReceived += bytesReceived;
        this.stats_.incrementCounter("bytes_received", bytesReceived);
    }
}
/*********************************************************************************************
 * A wrapper around an iframe that is used as a long-polling script holder.
 *********************************************************************************************/ class $494ac95ccfb2d9dd$var$FirebaseIFrameScriptHolder {
    /**
     * @param commandCB - The callback to be called when control commands are recevied from the server.
     * @param onMessageCB - The callback to be triggered when responses arrive from the server.
     * @param onDisconnect - The callback to be triggered when this tag holder is closed
     * @param urlFn - A function that provides the URL of the endpoint to send data to.
     */ constructor(commandCB, onMessageCB, onDisconnect, urlFn){
        this.onDisconnect = onDisconnect;
        this.urlFn = urlFn;
        //We maintain a count of all of the outstanding requests, because if we have too many active at once it can cause
        //problems in some browsers.
        this.outstandingRequests = new Set();
        //A queue of the pending segments waiting for transmission to the server.
        this.pendingSegs = [];
        //A serial number. We use this for two things:
        // 1) A way to ensure the browser doesn't cache responses to polls
        // 2) A way to make the server aware when long-polls arrive in a different order than we started them. The
        //    server needs to release both polls in this case or it will cause problems in Opera since Opera can only execute
        //    JSONP code in the order it was added to the iframe.
        this.currentSerial = Math.floor(Math.random() * 100000000);
        // This gets set to false when we're "closing down" the connection (e.g. we're switching transports but there's still
        // incoming data from the server that we're waiting for).
        this.sendNewPolls = true;
        if (!(0, $fc59d49e1bb53b6a$export$5d1d834fbbf8bab7)()) {
            //Each script holder registers a couple of uniquely named callbacks with the window. These are called from the
            //iframes where we put the long-polling script tags. We have two callbacks:
            //   1) Command Callback - Triggered for control issues, like starting a connection.
            //   2) Message Callback - Triggered when new data arrives.
            this.uniqueCallbackIdentifier = $494ac95ccfb2d9dd$var$LUIDGenerator();
            window[$494ac95ccfb2d9dd$var$FIREBASE_LONGPOLL_COMMAND_CB_NAME + this.uniqueCallbackIdentifier] = commandCB;
            window[$494ac95ccfb2d9dd$var$FIREBASE_LONGPOLL_DATA_CB_NAME + this.uniqueCallbackIdentifier] = onMessageCB;
            //Create an iframe for us to add script tags to.
            this.myIFrame = $494ac95ccfb2d9dd$var$FirebaseIFrameScriptHolder.createIFrame_();
            // Set the iframe's contents.
            let script = "";
            // if we set a javascript url, it's IE and we need to set the document domain. The javascript url is sufficient
            // for ie9, but ie8 needs to do it again in the document itself.
            if (this.myIFrame.src && this.myIFrame.src.substr(0, 11) === "javascript:") {
                const currentDomain = document.domain;
                script = '<script>document.domain="' + currentDomain + '";</script>';
            }
            const iframeContents = "<html><body>" + script + "</body></html>";
            try {
                this.myIFrame.doc.open();
                this.myIFrame.doc.write(iframeContents);
                this.myIFrame.doc.close();
            } catch (e) {
                $494ac95ccfb2d9dd$var$log("frame writing exception");
                if (e.stack) $494ac95ccfb2d9dd$var$log(e.stack);
                $494ac95ccfb2d9dd$var$log(e);
            }
        } else {
            this.commandCB = commandCB;
            this.onMessageCB = onMessageCB;
        }
    }
    /**
     * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
     * actually use.
     */ static createIFrame_() {
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        // This is necessary in order to initialize the document inside the iframe
        if (document.body) {
            document.body.appendChild(iframe);
            try {
                // If document.domain has been modified in IE, this will throw an error, and we need to set the
                // domain of the iframe's document manually. We can do this via a javascript: url as the src attribute
                // Also note that we must do this *after* the iframe has been appended to the page. Otherwise it doesn't work.
                const a = iframe.contentWindow.document;
                if (!a) // Apologies for the log-spam, I need to do something to keep closure from optimizing out the assignment above.
                $494ac95ccfb2d9dd$var$log("No IE domain setting required");
            } catch (e) {
                const domain = document.domain;
                iframe.src = "javascript:void((function(){document.open();document.domain='" + domain + "';document.close();})())";
            }
        } else // LongPollConnection attempts to delay initialization until the document is ready, so hopefully this
        // never gets hit.
        throw "Document body has not initialized. Wait to initialize Firebase until after the document is ready.";
        // Get the document of the iframe in a browser-specific way.
        if (iframe.contentDocument) iframe.doc = iframe.contentDocument; // Firefox, Opera, Safari
        else if (iframe.contentWindow) iframe.doc = iframe.contentWindow.document; // Internet Explorer
        else if (iframe.document) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        iframe.doc = iframe.document; //others?
        return iframe;
    }
    /**
     * Cancel all outstanding queries and remove the frame.
     */ close() {
        //Mark this iframe as dead, so no new requests are sent.
        this.alive = false;
        if (this.myIFrame) {
            //We have to actually remove all of the html inside this iframe before removing it from the
            //window, or IE will continue loading and executing the script tags we've already added, which
            //can lead to some errors being thrown. Setting textContent seems to be the safest way to do this.
            this.myIFrame.doc.body.textContent = "";
            setTimeout(()=>{
                if (this.myIFrame !== null) {
                    document.body.removeChild(this.myIFrame);
                    this.myIFrame = null;
                }
            }, Math.floor(0));
        }
        // Protect from being called recursively.
        const onDisconnect = this.onDisconnect;
        if (onDisconnect) {
            this.onDisconnect = null;
            onDisconnect();
        }
    }
    /**
     * Actually start the long-polling session by adding the first script tag(s) to the iframe.
     * @param id - The ID of this connection
     * @param pw - The password for this connection
     */ startLongPoll(id, pw) {
        this.myID = id;
        this.myPW = pw;
        this.alive = true;
        //send the initial request. If there are requests queued, make sure that we transmit as many as we are currently able to.
        while(this.newRequest_());
    }
    /**
     * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
     * too many outstanding requests and we are still alive.
     *
     * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
     * needed.
     */ newRequest_() {
        // We keep one outstanding request open all the time to receive data, but if we need to send data
        // (pendingSegs.length > 0) then we create a new request to send the data.  The server will automatically
        // close the old request.
        if (this.alive && this.sendNewPolls && this.outstandingRequests.size < (this.pendingSegs.length > 0 ? 2 : 1)) {
            //construct our url
            this.currentSerial++;
            const urlParams = {};
            urlParams[$494ac95ccfb2d9dd$var$FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
            urlParams[$494ac95ccfb2d9dd$var$FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
            urlParams[$494ac95ccfb2d9dd$var$FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
            let theURL = this.urlFn(urlParams);
            //Now add as much data as we can.
            let curDataString = "";
            let i = 0;
            while(this.pendingSegs.length > 0){
                //first, lets see if the next segment will fit.
                const nextSeg = this.pendingSegs[0];
                if (nextSeg.d.length + $494ac95ccfb2d9dd$var$SEG_HEADER_SIZE + curDataString.length <= $494ac95ccfb2d9dd$var$MAX_URL_DATA_SIZE) {
                    //great, the segment will fit. Lets append it.
                    const theSeg = this.pendingSegs.shift();
                    curDataString = curDataString + "&" + $494ac95ccfb2d9dd$var$FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM + i + "=" + theSeg.seg + "&" + $494ac95ccfb2d9dd$var$FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET + i + "=" + theSeg.ts + "&" + $494ac95ccfb2d9dd$var$FIREBASE_LONGPOLL_DATA_PARAM + i + "=" + theSeg.d;
                    i++;
                } else break;
            }
            theURL = theURL + curDataString;
            this.addLongPollTag_(theURL, this.currentSerial);
            return true;
        } else return false;
    }
    /**
     * Queue a packet for transmission to the server.
     * @param segnum - A sequential id for this packet segment used for reassembly
     * @param totalsegs - The total number of segments in this packet
     * @param data - The data for this segment.
     */ enqueueSegment(segnum, totalsegs, data) {
        //add this to the queue of segments to send.
        this.pendingSegs.push({
            seg: segnum,
            ts: totalsegs,
            d: data
        });
        //send the data immediately if there isn't already data being transmitted, unless
        //startLongPoll hasn't been called yet.
        if (this.alive) this.newRequest_();
    }
    /**
     * Add a script tag for a regular long-poll request.
     * @param url - The URL of the script tag.
     * @param serial - The serial number of the request.
     */ addLongPollTag_(url, serial) {
        //remember that we sent this request.
        this.outstandingRequests.add(serial);
        const doNewRequest = ()=>{
            this.outstandingRequests.delete(serial);
            this.newRequest_();
        };
        // If this request doesn't return on its own accord (by the server sending us some data), we'll
        // create a new one after the KEEPALIVE interval to make sure we always keep a fresh request open.
        const keepaliveTimeout = setTimeout(doNewRequest, Math.floor($494ac95ccfb2d9dd$var$KEEPALIVE_REQUEST_INTERVAL));
        const readyStateCB = ()=>{
            // Request completed.  Cancel the keepalive.
            clearTimeout(keepaliveTimeout);
            // Trigger a new request so we can continue receiving data.
            doNewRequest();
        };
        this.addTag(url, readyStateCB);
    }
    /**
     * Add an arbitrary script tag to the iframe.
     * @param url - The URL for the script tag source.
     * @param loadCB - A callback to be triggered once the script has loaded.
     */ addTag(url, loadCB) {
        if ((0, $fc59d49e1bb53b6a$export$5d1d834fbbf8bab7)()) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.doNodeLongPoll(url, loadCB);
        else setTimeout(()=>{
            try {
                // if we're already closed, don't add this poll
                if (!this.sendNewPolls) return;
                const newScript = this.myIFrame.doc.createElement("script");
                newScript.type = "text/javascript";
                newScript.async = true;
                newScript.src = url;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                newScript.onload = newScript.onreadystatechange = function() {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const rstate = newScript.readyState;
                    if (!rstate || rstate === "loaded" || rstate === "complete") {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        newScript.onload = newScript.onreadystatechange = null;
                        if (newScript.parentNode) newScript.parentNode.removeChild(newScript);
                        loadCB();
                    }
                };
                newScript.onerror = ()=>{
                    $494ac95ccfb2d9dd$var$log("Long-poll script failed to load: " + url);
                    this.sendNewPolls = false;
                    this.close();
                };
                this.myIFrame.doc.body.appendChild(newScript);
            } catch (e) {
            // TODO: we should make this error visible somehow
            }
        }, Math.floor(1));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $494ac95ccfb2d9dd$var$WEBSOCKET_MAX_FRAME_SIZE = 16384;
const $494ac95ccfb2d9dd$var$WEBSOCKET_KEEPALIVE_INTERVAL = 45000;
let $494ac95ccfb2d9dd$var$WebSocketImpl = null;
if (typeof MozWebSocket !== "undefined") $494ac95ccfb2d9dd$var$WebSocketImpl = MozWebSocket;
else if (typeof WebSocket !== "undefined") $494ac95ccfb2d9dd$var$WebSocketImpl = WebSocket;
/**
 * Create a new websocket connection with the given callbacks.
 */ class $494ac95ccfb2d9dd$var$WebSocketConnection {
    /**
     * @param connId identifier for this transport
     * @param repoInfo The info for the websocket endpoint.
     * @param applicationId The Firebase App ID for this project.
     * @param appCheckToken The App Check Token for this client.
     * @param authToken The Auth Token for this client.
     * @param transportSessionId Optional transportSessionId if this is connecting
     * to an existing transport session
     * @param lastSessionId Optional lastSessionId if there was a previous
     * connection
     */ constructor(connId, repoInfo, applicationId, appCheckToken, authToken, transportSessionId, lastSessionId){
        this.connId = connId;
        this.applicationId = applicationId;
        this.appCheckToken = appCheckToken;
        this.authToken = authToken;
        this.keepaliveTimer = null;
        this.frames = null;
        this.totalFrames = 0;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.log_ = $494ac95ccfb2d9dd$var$logWrapper(this.connId);
        this.stats_ = $494ac95ccfb2d9dd$var$statsManagerGetCollection(repoInfo);
        this.connURL = $494ac95ccfb2d9dd$var$WebSocketConnection.connectionURL_(repoInfo, transportSessionId, lastSessionId, appCheckToken, applicationId);
        this.nodeAdmin = repoInfo.nodeAdmin;
    }
    /**
     * @param repoInfo - The info for the websocket endpoint.
     * @param transportSessionId - Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param lastSessionId - Optional lastSessionId if there was a previous connection
     * @returns connection url
     */ static connectionURL_(repoInfo, transportSessionId, lastSessionId, appCheckToken, applicationId) {
        const urlParams = {};
        urlParams[$494ac95ccfb2d9dd$var$VERSION_PARAM] = $494ac95ccfb2d9dd$var$PROTOCOL_VERSION;
        if (!(0, $fc59d49e1bb53b6a$export$5d1d834fbbf8bab7)() && typeof location !== "undefined" && location.hostname && $494ac95ccfb2d9dd$var$FORGE_DOMAIN_RE.test(location.hostname)) urlParams[$494ac95ccfb2d9dd$var$REFERER_PARAM] = $494ac95ccfb2d9dd$var$FORGE_REF;
        if (transportSessionId) urlParams[$494ac95ccfb2d9dd$var$TRANSPORT_SESSION_PARAM] = transportSessionId;
        if (lastSessionId) urlParams[$494ac95ccfb2d9dd$var$LAST_SESSION_PARAM] = lastSessionId;
        if (appCheckToken) urlParams[$494ac95ccfb2d9dd$var$APP_CHECK_TOKEN_PARAM] = appCheckToken;
        if (applicationId) urlParams[$494ac95ccfb2d9dd$var$APPLICATION_ID_PARAM] = applicationId;
        return $494ac95ccfb2d9dd$var$repoInfoConnectionURL(repoInfo, $494ac95ccfb2d9dd$var$WEBSOCKET, urlParams);
    }
    /**
     * @param onMessage - Callback when messages arrive
     * @param onDisconnect - Callback with connection lost.
     */ open(onMessage, onDisconnect) {
        this.onDisconnect = onDisconnect;
        this.onMessage = onMessage;
        this.log_("Websocket connecting to " + this.connURL);
        this.everConnected_ = false;
        // Assume failure until proven otherwise.
        $494ac95ccfb2d9dd$var$PersistentStorage.set("previous_websocket_failure", true);
        try {
            let options;
            if ((0, $fc59d49e1bb53b6a$export$5d1d834fbbf8bab7)()) {
                const device = this.nodeAdmin ? "AdminNode" : "Node";
                // UA Format: Firebase/<wire_protocol>/<sdk_version>/<platform>/<device>
                options = {
                    headers: {
                        "User-Agent": `Firebase/${$494ac95ccfb2d9dd$var$PROTOCOL_VERSION}/${$494ac95ccfb2d9dd$var$SDK_VERSION}/${$c68e419b2a37d2b9$exports.platform}/${device}`,
                        "X-Firebase-GMPID": this.applicationId || ""
                    }
                };
                // If using Node with admin creds, AppCheck-related checks are unnecessary.
                // Note that we send the credentials here even if they aren't admin credentials, which is
                // not a problem.
                // Note that this header is just used to bypass appcheck, and the token should still be sent
                // through the websocket connection once it is established.
                if (this.authToken) options.headers["Authorization"] = `Bearer ${this.authToken}`;
                if (this.appCheckToken) options.headers["X-Firebase-AppCheck"] = this.appCheckToken;
                // Plumb appropriate http_proxy environment variable into faye-websocket if it exists.
                const env = {};
                const proxy = this.connURL.indexOf("wss://") === 0 ? env["HTTPS_PROXY"] || env["https_proxy"] : env["HTTP_PROXY"] || env["http_proxy"];
                if (proxy) options["proxy"] = {
                    origin: proxy
                };
            }
            this.mySock = new $494ac95ccfb2d9dd$var$WebSocketImpl(this.connURL, [], options);
        } catch (e) {
            this.log_("Error instantiating WebSocket.");
            const error = e.message || e.data;
            if (error) this.log_(error);
            this.onClosed_();
            return;
        }
        this.mySock.onopen = ()=>{
            this.log_("Websocket connected.");
            this.everConnected_ = true;
        };
        this.mySock.onclose = ()=>{
            this.log_("Websocket connection was disconnected.");
            this.mySock = null;
            this.onClosed_();
        };
        this.mySock.onmessage = (m)=>{
            this.handleIncomingFrame(m);
        };
        this.mySock.onerror = (e)=>{
            this.log_("WebSocket error.  Closing connection.");
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const error = e.message || e.data;
            if (error) this.log_(error);
            this.onClosed_();
        };
    }
    /**
     * No-op for websockets, we don't need to do anything once the connection is confirmed as open
     */ start() {}
    static forceDisallow() {
        $494ac95ccfb2d9dd$var$WebSocketConnection.forceDisallow_ = true;
    }
    static isAvailable() {
        let isOldAndroid = false;
        if (typeof navigator !== "undefined" && navigator.userAgent) {
            const oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
            const oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
            if (oldAndroidMatch && oldAndroidMatch.length > 1) {
                if (parseFloat(oldAndroidMatch[1]) < 4.4) isOldAndroid = true;
            }
        }
        return !isOldAndroid && $494ac95ccfb2d9dd$var$WebSocketImpl !== null && !$494ac95ccfb2d9dd$var$WebSocketConnection.forceDisallow_;
    }
    /**
     * Returns true if we previously failed to connect with this transport.
     */ static previouslyFailed() {
        // If our persistent storage is actually only in-memory storage,
        // we default to assuming that it previously failed to be safe.
        return $494ac95ccfb2d9dd$var$PersistentStorage.isInMemoryStorage || $494ac95ccfb2d9dd$var$PersistentStorage.get("previous_websocket_failure") === true;
    }
    markConnectionHealthy() {
        $494ac95ccfb2d9dd$var$PersistentStorage.remove("previous_websocket_failure");
    }
    appendFrame_(data) {
        this.frames.push(data);
        if (this.frames.length === this.totalFrames) {
            const fullMess = this.frames.join("");
            this.frames = null;
            const jsonMess = (0, $fc59d49e1bb53b6a$export$c5a53ce6a17cf18d)(fullMess);
            //handle the message
            this.onMessage(jsonMess);
        }
    }
    /**
     * @param frameCount - The number of frames we are expecting from the server
     */ handleNewFrameCount_(frameCount) {
        this.totalFrames = frameCount;
        this.frames = [];
    }
    /**
     * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
     * @returns Any remaining data to be process, or null if there is none
     */ extractFrameCount_(data) {
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(this.frames === null, "We already have a frame buffer");
        // TODO: The server is only supposed to send up to 9999 frames (i.e. length <= 4), but that isn't being enforced
        // currently.  So allowing larger frame counts (length <= 6).  See https://app.asana.com/0/search/8688598998380/8237608042508
        if (data.length <= 6) {
            const frameCount = Number(data);
            if (!isNaN(frameCount)) {
                this.handleNewFrameCount_(frameCount);
                return null;
            }
        }
        this.handleNewFrameCount_(1);
        return data;
    }
    /**
     * Process a websocket frame that has arrived from the server.
     * @param mess - The frame data
     */ handleIncomingFrame(mess) {
        if (this.mySock === null) return; // Chrome apparently delivers incoming packets even after we .close() the connection sometimes.
        const data = mess["data"];
        this.bytesReceived += data.length;
        this.stats_.incrementCounter("bytes_received", data.length);
        this.resetKeepAlive();
        if (this.frames !== null) // we're buffering
        this.appendFrame_(data);
        else {
            // try to parse out a frame count, otherwise, assume 1 and process it
            const remainingData = this.extractFrameCount_(data);
            if (remainingData !== null) this.appendFrame_(remainingData);
        }
    }
    /**
     * Send a message to the server
     * @param data - The JSON object to transmit
     */ send(data) {
        this.resetKeepAlive();
        const dataStr = (0, $fc59d49e1bb53b6a$export$fac44ee5b035f737)(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter("bytes_sent", dataStr.length);
        //We can only fit a certain amount in each websocket frame, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        const dataSegs = $494ac95ccfb2d9dd$var$splitStringBySize(dataStr, $494ac95ccfb2d9dd$var$WEBSOCKET_MAX_FRAME_SIZE);
        //Send the length header
        if (dataSegs.length > 1) this.sendString_(String(dataSegs.length));
        //Send the actual data in segments.
        for(let i = 0; i < dataSegs.length; i++)this.sendString_(dataSegs[i]);
    }
    shutdown_() {
        this.isClosed_ = true;
        if (this.keepaliveTimer) {
            clearInterval(this.keepaliveTimer);
            this.keepaliveTimer = null;
        }
        if (this.mySock) {
            this.mySock.close();
            this.mySock = null;
        }
    }
    onClosed_() {
        if (!this.isClosed_) {
            this.log_("WebSocket is closing itself");
            this.shutdown_();
            // since this is an internal close, trigger the close listener
            if (this.onDisconnect) {
                this.onDisconnect(this.everConnected_);
                this.onDisconnect = null;
            }
        }
    }
    /**
     * External-facing close handler.
     * Close the websocket and kill the connection.
     */ close() {
        if (!this.isClosed_) {
            this.log_("WebSocket is being closed");
            this.shutdown_();
        }
    }
    /**
     * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
     * the last activity.
     */ resetKeepAlive() {
        clearInterval(this.keepaliveTimer);
        this.keepaliveTimer = setInterval(()=>{
            //If there has been no websocket activity for a while, send a no-op
            if (this.mySock) this.sendString_("0");
            this.resetKeepAlive();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor($494ac95ccfb2d9dd$var$WEBSOCKET_KEEPALIVE_INTERVAL));
    }
    /**
     * Send a string over the websocket.
     *
     * @param str - String to send.
     */ sendString_(str) {
        // Firefox seems to sometimes throw exceptions (NS_ERROR_UNEXPECTED) from websocket .send()
        // calls for some unknown reason.  We treat these as an error and disconnect.
        // See https://app.asana.com/0/58926111402292/68021340250410
        try {
            this.mySock.send(str);
        } catch (e) {
            this.log_("Exception thrown from WebSocket.send():", e.message || e.data, "Closing connection.");
            setTimeout(this.onClosed_.bind(this), 0);
        }
    }
}
/**
 * Number of response before we consider the connection "healthy."
 */ $494ac95ccfb2d9dd$var$WebSocketConnection.responsesRequiredToBeHealthy = 2;
/**
 * Time to wait for the connection te become healthy before giving up.
 */ $494ac95ccfb2d9dd$var$WebSocketConnection.healthyTimeout = 30000;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Currently simplistic, this class manages what transport a Connection should use at various stages of its
 * lifecycle.
 *
 * It starts with longpolling in a browser, and httppolling on node. It then upgrades to websockets if
 * they are available.
 */ class $494ac95ccfb2d9dd$var$TransportManager {
    /**
     * @param repoInfo - Metadata around the namespace we're connecting to
     */ constructor(repoInfo){
        this.initTransports_(repoInfo);
    }
    static get ALL_TRANSPORTS() {
        return [
            $494ac95ccfb2d9dd$var$BrowserPollConnection,
            $494ac95ccfb2d9dd$var$WebSocketConnection
        ];
    }
    /**
     * Returns whether transport has been selected to ensure WebSocketConnection or BrowserPollConnection are not called after
     * TransportManager has already set up transports_
     */ static get IS_TRANSPORT_INITIALIZED() {
        return this.globalTransportInitialized_;
    }
    initTransports_(repoInfo) {
        const isWebSocketsAvailable = $494ac95ccfb2d9dd$var$WebSocketConnection && $494ac95ccfb2d9dd$var$WebSocketConnection["isAvailable"]();
        let isSkipPollConnection = isWebSocketsAvailable && !$494ac95ccfb2d9dd$var$WebSocketConnection.previouslyFailed();
        if (repoInfo.webSocketOnly) {
            if (!isWebSocketsAvailable) $494ac95ccfb2d9dd$var$warn("wss:// URL used, but browser isn't known to support websockets.  Trying anyway.");
            isSkipPollConnection = true;
        }
        if (isSkipPollConnection) this.transports_ = [
            $494ac95ccfb2d9dd$var$WebSocketConnection
        ];
        else {
            const transports = this.transports_ = [];
            for (const transport of $494ac95ccfb2d9dd$var$TransportManager.ALL_TRANSPORTS)if (transport && transport["isAvailable"]()) transports.push(transport);
            $494ac95ccfb2d9dd$var$TransportManager.globalTransportInitialized_ = true;
        }
    }
    /**
     * @returns The constructor for the initial transport to use
     */ initialTransport() {
        if (this.transports_.length > 0) return this.transports_[0];
        else throw new Error("No transports available");
    }
    /**
     * @returns The constructor for the next transport, or null
     */ upgradeTransport() {
        if (this.transports_.length > 1) return this.transports_[1];
        else return null;
    }
}
// Keeps track of whether the TransportManager has already chosen a transport to use
$494ac95ccfb2d9dd$var$TransportManager.globalTransportInitialized_ = false;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Abort upgrade attempt if it takes longer than 60s.
const $494ac95ccfb2d9dd$var$UPGRADE_TIMEOUT = 60000;
// For some transports (WebSockets), we need to "validate" the transport by exchanging a few requests and responses.
// If we haven't sent enough requests within 5s, we'll start sending noop ping requests.
const $494ac95ccfb2d9dd$var$DELAY_BEFORE_SENDING_EXTRA_REQUESTS = 5000;
// If the initial data sent triggers a lot of bandwidth (i.e. it's a large put or a listen for a large amount of data)
// then we may not be able to exchange our ping/pong requests within the healthy timeout.  So if we reach the timeout
// but we've sent/received enough bytes, we don't cancel the connection.
const $494ac95ccfb2d9dd$var$BYTES_SENT_HEALTHY_OVERRIDE = 10240;
const $494ac95ccfb2d9dd$var$BYTES_RECEIVED_HEALTHY_OVERRIDE = 102400;
const $494ac95ccfb2d9dd$var$MESSAGE_TYPE = "t";
const $494ac95ccfb2d9dd$var$MESSAGE_DATA = "d";
const $494ac95ccfb2d9dd$var$CONTROL_SHUTDOWN = "s";
const $494ac95ccfb2d9dd$var$CONTROL_RESET = "r";
const $494ac95ccfb2d9dd$var$CONTROL_ERROR = "e";
const $494ac95ccfb2d9dd$var$CONTROL_PONG = "o";
const $494ac95ccfb2d9dd$var$SWITCH_ACK = "a";
const $494ac95ccfb2d9dd$var$END_TRANSMISSION = "n";
const $494ac95ccfb2d9dd$var$PING = "p";
const $494ac95ccfb2d9dd$var$SERVER_HELLO = "h";
/**
 * Creates a new real-time connection to the server using whichever method works
 * best in the current browser.
 */ class $494ac95ccfb2d9dd$var$Connection {
    /**
     * @param id - an id for this connection
     * @param repoInfo_ - the info for the endpoint to connect to
     * @param applicationId_ - the Firebase App ID for this project
     * @param appCheckToken_ - The App Check Token for this device.
     * @param authToken_ - The auth token for this session.
     * @param onMessage_ - the callback to be triggered when a server-push message arrives
     * @param onReady_ - the callback to be triggered when this connection is ready to send messages.
     * @param onDisconnect_ - the callback to be triggered when a connection was lost
     * @param onKill_ - the callback to be triggered when this connection has permanently shut down.
     * @param lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
     */ constructor(id, repoInfo_, applicationId_, appCheckToken_, authToken_, onMessage_, onReady_, onDisconnect_, onKill_, lastSessionId){
        this.id = id;
        this.repoInfo_ = repoInfo_;
        this.applicationId_ = applicationId_;
        this.appCheckToken_ = appCheckToken_;
        this.authToken_ = authToken_;
        this.onMessage_ = onMessage_;
        this.onReady_ = onReady_;
        this.onDisconnect_ = onDisconnect_;
        this.onKill_ = onKill_;
        this.lastSessionId = lastSessionId;
        this.connectionCount = 0;
        this.pendingDataMessages = [];
        this.state_ = 0 /* RealtimeState.CONNECTING */ ;
        this.log_ = $494ac95ccfb2d9dd$var$logWrapper("c:" + this.id + ":");
        this.transportManager_ = new $494ac95ccfb2d9dd$var$TransportManager(repoInfo_);
        this.log_("Connection created");
        this.start_();
    }
    /**
     * Starts a connection attempt
     */ start_() {
        const conn = this.transportManager_.initialTransport();
        this.conn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, null, this.lastSessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.primaryResponsesRequired_ = conn["responsesRequiredToBeHealthy"] || 0;
        const onMessageReceived = this.connReceiver_(this.conn_);
        const onConnectionLost = this.disconnReceiver_(this.conn_);
        this.tx_ = this.conn_;
        this.rx_ = this.conn_;
        this.secondaryConn_ = null;
        this.isHealthy_ = false;
        /*
         * Firefox doesn't like when code from one iframe tries to create another iframe by way of the parent frame.
         * This can occur in the case of a redirect, i.e. we guessed wrong on what server to connect to and received a reset.
         * Somehow, setTimeout seems to make this ok. That doesn't make sense from a security perspective, since you should
         * still have the context of your originating frame.
         */ setTimeout(()=>{
            // this.conn_ gets set to null in some of the tests. Check to make sure it still exists before using it
            this.conn_ && this.conn_.open(onMessageReceived, onConnectionLost);
        }, Math.floor(0));
        const healthyTimeoutMS = conn["healthyTimeout"] || 0;
        if (healthyTimeoutMS > 0) this.healthyTimeout_ = $494ac95ccfb2d9dd$var$setTimeoutNonBlocking(()=>{
            this.healthyTimeout_ = null;
            if (!this.isHealthy_) {
                if (this.conn_ && this.conn_.bytesReceived > $494ac95ccfb2d9dd$var$BYTES_RECEIVED_HEALTHY_OVERRIDE) {
                    this.log_("Connection exceeded healthy timeout but has received " + this.conn_.bytesReceived + " bytes.  Marking connection healthy.");
                    this.isHealthy_ = true;
                    this.conn_.markConnectionHealthy();
                } else if (this.conn_ && this.conn_.bytesSent > $494ac95ccfb2d9dd$var$BYTES_SENT_HEALTHY_OVERRIDE) this.log_("Connection exceeded healthy timeout but has sent " + this.conn_.bytesSent + " bytes.  Leaving connection alive.");
                else {
                    this.log_("Closing unhealthy connection after timeout.");
                    this.close();
                }
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor(healthyTimeoutMS));
    }
    nextTransportId_() {
        return "c:" + this.id + ":" + this.connectionCount++;
    }
    disconnReceiver_(conn) {
        return (everConnected)=>{
            if (conn === this.conn_) this.onConnectionLost_(everConnected);
            else if (conn === this.secondaryConn_) {
                this.log_("Secondary connection lost.");
                this.onSecondaryConnectionLost_();
            } else this.log_("closing an old connection");
        };
    }
    connReceiver_(conn) {
        return (message)=>{
            if (this.state_ !== 2 /* RealtimeState.DISCONNECTED */ ) {
                if (conn === this.rx_) this.onPrimaryMessageReceived_(message);
                else if (conn === this.secondaryConn_) this.onSecondaryMessageReceived_(message);
                else this.log_("message on old connection");
            }
        };
    }
    /**
     * @param dataMsg - An arbitrary data message to be sent to the server
     */ sendRequest(dataMsg) {
        // wrap in a data message envelope and send it on
        const msg = {
            t: "d",
            d: dataMsg
        };
        this.sendData_(msg);
    }
    tryCleanupConnection() {
        if (this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_) {
            this.log_("cleaning up and promoting a connection: " + this.secondaryConn_.connId);
            this.conn_ = this.secondaryConn_;
            this.secondaryConn_ = null;
        // the server will shutdown the old connection
        }
    }
    onSecondaryControl_(controlData) {
        if ($494ac95ccfb2d9dd$var$MESSAGE_TYPE in controlData) {
            const cmd = controlData[$494ac95ccfb2d9dd$var$MESSAGE_TYPE];
            if (cmd === $494ac95ccfb2d9dd$var$SWITCH_ACK) this.upgradeIfSecondaryHealthy_();
            else if (cmd === $494ac95ccfb2d9dd$var$CONTROL_RESET) {
                // Most likely the session wasn't valid. Abandon the switch attempt
                this.log_("Got a reset on secondary, closing it");
                this.secondaryConn_.close();
                // If we were already using this connection for something, than we need to fully close
                if (this.tx_ === this.secondaryConn_ || this.rx_ === this.secondaryConn_) this.close();
            } else if (cmd === $494ac95ccfb2d9dd$var$CONTROL_PONG) {
                this.log_("got pong on secondary.");
                this.secondaryResponsesRequired_--;
                this.upgradeIfSecondaryHealthy_();
            }
        }
    }
    onSecondaryMessageReceived_(parsedData) {
        const layer = $494ac95ccfb2d9dd$var$requireKey("t", parsedData);
        const data = $494ac95ccfb2d9dd$var$requireKey("d", parsedData);
        if (layer === "c") this.onSecondaryControl_(data);
        else if (layer === "d") // got a data message, but we're still second connection. Need to buffer it up
        this.pendingDataMessages.push(data);
        else throw new Error("Unknown protocol layer: " + layer);
    }
    upgradeIfSecondaryHealthy_() {
        if (this.secondaryResponsesRequired_ <= 0) {
            this.log_("Secondary connection is healthy.");
            this.isHealthy_ = true;
            this.secondaryConn_.markConnectionHealthy();
            this.proceedWithUpgrade_();
        } else {
            // Send a ping to make sure the connection is healthy.
            this.log_("sending ping on secondary.");
            this.secondaryConn_.send({
                t: "c",
                d: {
                    t: $494ac95ccfb2d9dd$var$PING,
                    d: {}
                }
            });
        }
    }
    proceedWithUpgrade_() {
        // tell this connection to consider itself open
        this.secondaryConn_.start();
        // send ack
        this.log_("sending client ack on secondary");
        this.secondaryConn_.send({
            t: "c",
            d: {
                t: $494ac95ccfb2d9dd$var$SWITCH_ACK,
                d: {}
            }
        });
        // send end packet on primary transport, switch to sending on this one
        // can receive on this one, buffer responses until end received on primary transport
        this.log_("Ending transmission on primary");
        this.conn_.send({
            t: "c",
            d: {
                t: $494ac95ccfb2d9dd$var$END_TRANSMISSION,
                d: {}
            }
        });
        this.tx_ = this.secondaryConn_;
        this.tryCleanupConnection();
    }
    onPrimaryMessageReceived_(parsedData) {
        // Must refer to parsedData properties in quotes, so closure doesn't touch them.
        const layer = $494ac95ccfb2d9dd$var$requireKey("t", parsedData);
        const data = $494ac95ccfb2d9dd$var$requireKey("d", parsedData);
        if (layer === "c") this.onControl_(data);
        else if (layer === "d") this.onDataMessage_(data);
    }
    onDataMessage_(message) {
        this.onPrimaryResponse_();
        // We don't do anything with data messages, just kick them up a level
        this.onMessage_(message);
    }
    onPrimaryResponse_() {
        if (!this.isHealthy_) {
            this.primaryResponsesRequired_--;
            if (this.primaryResponsesRequired_ <= 0) {
                this.log_("Primary connection is healthy.");
                this.isHealthy_ = true;
                this.conn_.markConnectionHealthy();
            }
        }
    }
    onControl_(controlData) {
        const cmd = $494ac95ccfb2d9dd$var$requireKey($494ac95ccfb2d9dd$var$MESSAGE_TYPE, controlData);
        if ($494ac95ccfb2d9dd$var$MESSAGE_DATA in controlData) {
            const payload = controlData[$494ac95ccfb2d9dd$var$MESSAGE_DATA];
            if (cmd === $494ac95ccfb2d9dd$var$SERVER_HELLO) {
                const handshakePayload = Object.assign({}, payload);
                if (this.repoInfo_.isUsingEmulator) // Upon connecting, the emulator will pass the hostname that it's aware of, but we prefer the user's set hostname via `connectDatabaseEmulator` over what the emulator passes.
                handshakePayload.h = this.repoInfo_.host;
                this.onHandshake_(handshakePayload);
            } else if (cmd === $494ac95ccfb2d9dd$var$END_TRANSMISSION) {
                this.log_("recvd end transmission on primary");
                this.rx_ = this.secondaryConn_;
                for(let i = 0; i < this.pendingDataMessages.length; ++i)this.onDataMessage_(this.pendingDataMessages[i]);
                this.pendingDataMessages = [];
                this.tryCleanupConnection();
            } else if (cmd === $494ac95ccfb2d9dd$var$CONTROL_SHUTDOWN) // This was previously the 'onKill' callback passed to the lower-level connection
            // payload in this case is the reason for the shutdown. Generally a human-readable error
            this.onConnectionShutdown_(payload);
            else if (cmd === $494ac95ccfb2d9dd$var$CONTROL_RESET) // payload in this case is the host we should contact
            this.onReset_(payload);
            else if (cmd === $494ac95ccfb2d9dd$var$CONTROL_ERROR) $494ac95ccfb2d9dd$var$error("Server Error: " + payload);
            else if (cmd === $494ac95ccfb2d9dd$var$CONTROL_PONG) {
                this.log_("got pong on primary.");
                this.onPrimaryResponse_();
                this.sendPingOnPrimaryIfNecessary_();
            } else $494ac95ccfb2d9dd$var$error("Unknown control packet command: " + cmd);
        }
    }
    /**
     * @param handshake - The handshake data returned from the server
     */ onHandshake_(handshake) {
        const timestamp = handshake.ts;
        const version = handshake.v;
        const host = handshake.h;
        this.sessionId = handshake.s;
        this.repoInfo_.host = host;
        // if we've already closed the connection, then don't bother trying to progress further
        if (this.state_ === 0 /* RealtimeState.CONNECTING */ ) {
            this.conn_.start();
            this.onConnectionEstablished_(this.conn_, timestamp);
            if ($494ac95ccfb2d9dd$var$PROTOCOL_VERSION !== version) $494ac95ccfb2d9dd$var$warn("Protocol version mismatch detected");
            // TODO: do we want to upgrade? when? maybe a delay?
            this.tryStartUpgrade_();
        }
    }
    tryStartUpgrade_() {
        const conn = this.transportManager_.upgradeTransport();
        if (conn) this.startUpgrade_(conn);
    }
    startUpgrade_(conn) {
        this.secondaryConn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, this.sessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.secondaryResponsesRequired_ = conn["responsesRequiredToBeHealthy"] || 0;
        const onMessage = this.connReceiver_(this.secondaryConn_);
        const onDisconnect = this.disconnReceiver_(this.secondaryConn_);
        this.secondaryConn_.open(onMessage, onDisconnect);
        // If we haven't successfully upgraded after UPGRADE_TIMEOUT, give up and kill the secondary.
        $494ac95ccfb2d9dd$var$setTimeoutNonBlocking(()=>{
            if (this.secondaryConn_) {
                this.log_("Timed out trying to upgrade.");
                this.secondaryConn_.close();
            }
        }, Math.floor($494ac95ccfb2d9dd$var$UPGRADE_TIMEOUT));
    }
    onReset_(host) {
        this.log_("Reset packet received.  New host: " + host);
        this.repoInfo_.host = host;
        // TODO: if we're already "connected", we need to trigger a disconnect at the next layer up.
        // We don't currently support resets after the connection has already been established
        if (this.state_ === 1 /* RealtimeState.CONNECTED */ ) this.close();
        else {
            // Close whatever connections we have open and start again.
            this.closeConnections_();
            this.start_();
        }
    }
    onConnectionEstablished_(conn, timestamp) {
        this.log_("Realtime connection established.");
        this.conn_ = conn;
        this.state_ = 1 /* RealtimeState.CONNECTED */ ;
        if (this.onReady_) {
            this.onReady_(timestamp, this.sessionId);
            this.onReady_ = null;
        }
        // If after 5 seconds we haven't sent enough requests to the server to get the connection healthy,
        // send some pings.
        if (this.primaryResponsesRequired_ === 0) {
            this.log_("Primary connection is healthy.");
            this.isHealthy_ = true;
        } else $494ac95ccfb2d9dd$var$setTimeoutNonBlocking(()=>{
            this.sendPingOnPrimaryIfNecessary_();
        }, Math.floor($494ac95ccfb2d9dd$var$DELAY_BEFORE_SENDING_EXTRA_REQUESTS));
    }
    sendPingOnPrimaryIfNecessary_() {
        // If the connection isn't considered healthy yet, we'll send a noop ping packet request.
        if (!this.isHealthy_ && this.state_ === 1 /* RealtimeState.CONNECTED */ ) {
            this.log_("sending ping on primary.");
            this.sendData_({
                t: "c",
                d: {
                    t: $494ac95ccfb2d9dd$var$PING,
                    d: {}
                }
            });
        }
    }
    onSecondaryConnectionLost_() {
        const conn = this.secondaryConn_;
        this.secondaryConn_ = null;
        if (this.tx_ === conn || this.rx_ === conn) // we are relying on this connection already in some capacity. Therefore, a failure is real
        this.close();
    }
    /**
     * @param everConnected - Whether or not the connection ever reached a server. Used to determine if
     * we should flush the host cache
     */ onConnectionLost_(everConnected) {
        this.conn_ = null;
        // NOTE: IF you're seeing a Firefox error for this line, I think it might be because it's getting
        // called on window close and RealtimeState.CONNECTING is no longer defined.  Just a guess.
        if (!everConnected && this.state_ === 0 /* RealtimeState.CONNECTING */ ) {
            this.log_("Realtime connection failed.");
            // Since we failed to connect at all, clear any cached entry for this namespace in case the machine went away
            if (this.repoInfo_.isCacheableHost()) {
                $494ac95ccfb2d9dd$var$PersistentStorage.remove("host:" + this.repoInfo_.host);
                // reset the internal host to what we would show the user, i.e. <ns>.firebaseio.com
                this.repoInfo_.internalHost = this.repoInfo_.host;
            }
        } else if (this.state_ === 1 /* RealtimeState.CONNECTED */ ) this.log_("Realtime connection lost.");
        this.close();
    }
    onConnectionShutdown_(reason) {
        this.log_("Connection shutdown command received. Shutting down...");
        if (this.onKill_) {
            this.onKill_(reason);
            this.onKill_ = null;
        }
        // We intentionally don't want to fire onDisconnect (kill is a different case),
        // so clear the callback.
        this.onDisconnect_ = null;
        this.close();
    }
    sendData_(data) {
        if (this.state_ !== 1 /* RealtimeState.CONNECTED */ ) throw "Connection is not connected";
        else this.tx_.send(data);
    }
    /**
     * Cleans up this connection, calling the appropriate callbacks
     */ close() {
        if (this.state_ !== 2 /* RealtimeState.DISCONNECTED */ ) {
            this.log_("Closing realtime connection.");
            this.state_ = 2 /* RealtimeState.DISCONNECTED */ ;
            this.closeConnections_();
            if (this.onDisconnect_) {
                this.onDisconnect_();
                this.onDisconnect_ = null;
            }
        }
    }
    closeConnections_() {
        this.log_("Shutting down all connections");
        if (this.conn_) {
            this.conn_.close();
            this.conn_ = null;
        }
        if (this.secondaryConn_) {
            this.secondaryConn_.close();
            this.secondaryConn_ = null;
        }
        if (this.healthyTimeout_) {
            clearTimeout(this.healthyTimeout_);
            this.healthyTimeout_ = null;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface defining the set of actions that can be performed against the Firebase server
 * (basically corresponds to our wire protocol).
 *
 * @interface
 */ class $494ac95ccfb2d9dd$var$ServerActions {
    put(pathString, data, onComplete, hash) {}
    merge(pathString, data, onComplete, hash) {}
    /**
     * Refreshes the auth token for the current connection.
     * @param token - The authentication token
     */ refreshAuthToken(token) {}
    /**
     * Refreshes the app check token for the current connection.
     * @param token The app check token
     */ refreshAppCheckToken(token) {}
    onDisconnectPut(pathString, data, onComplete) {}
    onDisconnectMerge(pathString, data, onComplete) {}
    onDisconnectCancel(pathString, onComplete) {}
    reportStats(stats) {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Base class to be used if you want to emit events. Call the constructor with
 * the set of allowed event names.
 */ class $494ac95ccfb2d9dd$var$EventEmitter {
    constructor(allowedEvents_){
        this.allowedEvents_ = allowedEvents_;
        this.listeners_ = {};
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(Array.isArray(allowedEvents_) && allowedEvents_.length > 0, "Requires a non-empty array");
    }
    /**
     * To be called by derived classes to trigger events.
     */ trigger(eventType, ...varArgs) {
        if (Array.isArray(this.listeners_[eventType])) {
            // Clone the list, since callbacks could add/remove listeners.
            const listeners = [
                ...this.listeners_[eventType]
            ];
            for(let i = 0; i < listeners.length; i++)listeners[i].callback.apply(listeners[i].context, varArgs);
        }
    }
    on(eventType, callback, context) {
        this.validateEventType_(eventType);
        this.listeners_[eventType] = this.listeners_[eventType] || [];
        this.listeners_[eventType].push({
            callback: callback,
            context: context
        });
        const eventData = this.getInitialEvent(eventType);
        if (eventData) callback.apply(context, eventData);
    }
    off(eventType, callback, context) {
        this.validateEventType_(eventType);
        const listeners = this.listeners_[eventType] || [];
        for(let i = 0; i < listeners.length; i++)if (listeners[i].callback === callback && (!context || context === listeners[i].context)) {
            listeners.splice(i, 1);
            return;
        }
    }
    validateEventType_(eventType) {
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(this.allowedEvents_.find((et)=>{
            return et === eventType;
        }), "Unknown event: " + eventType);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Monitors online state (as reported by window.online/offline events).
 *
 * The expectation is that this could have many false positives (thinks we are online
 * when we're not), but no false negatives.  So we can safely use it to determine when
 * we definitely cannot reach the internet.
 */ class $494ac95ccfb2d9dd$var$OnlineMonitor extends $494ac95ccfb2d9dd$var$EventEmitter {
    constructor(){
        super([
            "online"
        ]);
        this.online_ = true;
        // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
        // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
        // It would seem that the 'online' event does not always fire consistently. So we disable it
        // for Cordova.
        if (typeof window !== "undefined" && typeof window.addEventListener !== "undefined" && !(0, $fc59d49e1bb53b6a$export$872f8323f01d7ae0)()) {
            window.addEventListener("online", ()=>{
                if (!this.online_) {
                    this.online_ = true;
                    this.trigger("online", true);
                }
            }, false);
            window.addEventListener("offline", ()=>{
                if (this.online_) {
                    this.online_ = false;
                    this.trigger("online", false);
                }
            }, false);
        }
    }
    static getInstance() {
        return new $494ac95ccfb2d9dd$var$OnlineMonitor();
    }
    getInitialEvent(eventType) {
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(eventType === "online", "Unknown event type: " + eventType);
        return [
            this.online_
        ];
    }
    currentlyOnline() {
        return this.online_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Maximum key depth. */ const $494ac95ccfb2d9dd$var$MAX_PATH_DEPTH = 32;
/** Maximum number of (UTF8) bytes in a Firebase path. */ const $494ac95ccfb2d9dd$var$MAX_PATH_LENGTH_BYTES = 768;
/**
 * An immutable object representing a parsed path.  It's immutable so that you
 * can pass them around to other functions without worrying about them changing
 * it.
 */ class $494ac95ccfb2d9dd$var$Path {
    /**
     * @param pathOrString - Path string to parse, or another path, or the raw
     * tokens array
     */ constructor(pathOrString, pieceNum){
        if (pieceNum === void 0) {
            this.pieces_ = pathOrString.split("/");
            // Remove empty pieces.
            let copyTo = 0;
            for(let i = 0; i < this.pieces_.length; i++)if (this.pieces_[i].length > 0) {
                this.pieces_[copyTo] = this.pieces_[i];
                copyTo++;
            }
            this.pieces_.length = copyTo;
            this.pieceNum_ = 0;
        } else {
            this.pieces_ = pathOrString;
            this.pieceNum_ = pieceNum;
        }
    }
    toString() {
        let pathString = "";
        for(let i = this.pieceNum_; i < this.pieces_.length; i++)if (this.pieces_[i] !== "") pathString += "/" + this.pieces_[i];
        return pathString || "/";
    }
}
function $494ac95ccfb2d9dd$var$newEmptyPath() {
    return new $494ac95ccfb2d9dd$var$Path("");
}
function $494ac95ccfb2d9dd$var$pathGetFront(path) {
    if (path.pieceNum_ >= path.pieces_.length) return null;
    return path.pieces_[path.pieceNum_];
}
/**
 * @returns The number of segments in this path
 */ function $494ac95ccfb2d9dd$var$pathGetLength(path) {
    return path.pieces_.length - path.pieceNum_;
}
function $494ac95ccfb2d9dd$var$pathPopFront(path) {
    let pieceNum = path.pieceNum_;
    if (pieceNum < path.pieces_.length) pieceNum++;
    return new $494ac95ccfb2d9dd$var$Path(path.pieces_, pieceNum);
}
function $494ac95ccfb2d9dd$var$pathGetBack(path) {
    if (path.pieceNum_ < path.pieces_.length) return path.pieces_[path.pieces_.length - 1];
    return null;
}
function $494ac95ccfb2d9dd$var$pathToUrlEncodedString(path) {
    let pathString = "";
    for(let i = path.pieceNum_; i < path.pieces_.length; i++)if (path.pieces_[i] !== "") pathString += "/" + encodeURIComponent(String(path.pieces_[i]));
    return pathString || "/";
}
/**
 * Shallow copy of the parts of the path.
 *
 */ function $494ac95ccfb2d9dd$var$pathSlice(path, begin = 0) {
    return path.pieces_.slice(path.pieceNum_ + begin);
}
function $494ac95ccfb2d9dd$var$pathParent(path) {
    if (path.pieceNum_ >= path.pieces_.length) return null;
    const pieces = [];
    for(let i = path.pieceNum_; i < path.pieces_.length - 1; i++)pieces.push(path.pieces_[i]);
    return new $494ac95ccfb2d9dd$var$Path(pieces, 0);
}
function $494ac95ccfb2d9dd$var$pathChild(path, childPathObj) {
    const pieces = [];
    for(let i = path.pieceNum_; i < path.pieces_.length; i++)pieces.push(path.pieces_[i]);
    if (childPathObj instanceof $494ac95ccfb2d9dd$var$Path) for(let i = childPathObj.pieceNum_; i < childPathObj.pieces_.length; i++)pieces.push(childPathObj.pieces_[i]);
    else {
        const childPieces = childPathObj.split("/");
        for(let i = 0; i < childPieces.length; i++)if (childPieces[i].length > 0) pieces.push(childPieces[i]);
    }
    return new $494ac95ccfb2d9dd$var$Path(pieces, 0);
}
/**
 * @returns True if there are no segments in this path
 */ function $494ac95ccfb2d9dd$var$pathIsEmpty(path) {
    return path.pieceNum_ >= path.pieces_.length;
}
/**
 * @returns The path from outerPath to innerPath
 */ function $494ac95ccfb2d9dd$var$newRelativePath(outerPath, innerPath) {
    const outer = $494ac95ccfb2d9dd$var$pathGetFront(outerPath), inner = $494ac95ccfb2d9dd$var$pathGetFront(innerPath);
    if (outer === null) return innerPath;
    else if (outer === inner) return $494ac95ccfb2d9dd$var$newRelativePath($494ac95ccfb2d9dd$var$pathPopFront(outerPath), $494ac95ccfb2d9dd$var$pathPopFront(innerPath));
    else throw new Error("INTERNAL ERROR: innerPath (" + innerPath + ") is not within " + "outerPath (" + outerPath + ")");
}
/**
 * @returns -1, 0, 1 if left is less, equal, or greater than the right.
 */ function $494ac95ccfb2d9dd$var$pathCompare(left, right) {
    const leftKeys = $494ac95ccfb2d9dd$var$pathSlice(left, 0);
    const rightKeys = $494ac95ccfb2d9dd$var$pathSlice(right, 0);
    for(let i = 0; i < leftKeys.length && i < rightKeys.length; i++){
        const cmp = $494ac95ccfb2d9dd$var$nameCompare(leftKeys[i], rightKeys[i]);
        if (cmp !== 0) return cmp;
    }
    if (leftKeys.length === rightKeys.length) return 0;
    return leftKeys.length < rightKeys.length ? -1 : 1;
}
/**
 * @returns true if paths are the same.
 */ function $494ac95ccfb2d9dd$var$pathEquals(path, other) {
    if ($494ac95ccfb2d9dd$var$pathGetLength(path) !== $494ac95ccfb2d9dd$var$pathGetLength(other)) return false;
    for(let i = path.pieceNum_, j = other.pieceNum_; i <= path.pieces_.length; i++, j++){
        if (path.pieces_[i] !== other.pieces_[j]) return false;
    }
    return true;
}
/**
 * @returns True if this path is a parent of (or the same as) other
 */ function $494ac95ccfb2d9dd$var$pathContains(path, other) {
    let i = path.pieceNum_;
    let j = other.pieceNum_;
    if ($494ac95ccfb2d9dd$var$pathGetLength(path) > $494ac95ccfb2d9dd$var$pathGetLength(other)) return false;
    while(i < path.pieces_.length){
        if (path.pieces_[i] !== other.pieces_[j]) return false;
        ++i;
        ++j;
    }
    return true;
}
/**
 * Dynamic (mutable) path used to count path lengths.
 *
 * This class is used to efficiently check paths for valid
 * length (in UTF8 bytes) and depth (used in path validation).
 *
 * Throws Error exception if path is ever invalid.
 *
 * The definition of a path always begins with '/'.
 */ class $494ac95ccfb2d9dd$var$ValidationPath {
    /**
     * @param path - Initial Path.
     * @param errorPrefix_ - Prefix for any error messages.
     */ constructor(path, errorPrefix_){
        this.errorPrefix_ = errorPrefix_;
        this.parts_ = $494ac95ccfb2d9dd$var$pathSlice(path, 0);
        /** Initialize to number of '/' chars needed in path. */ this.byteLength_ = Math.max(1, this.parts_.length);
        for(let i = 0; i < this.parts_.length; i++)this.byteLength_ += (0, $fc59d49e1bb53b6a$export$9536dc0a75b20bf9)(this.parts_[i]);
        $494ac95ccfb2d9dd$var$validationPathCheckValid(this);
    }
}
function $494ac95ccfb2d9dd$var$validationPathPush(validationPath, child) {
    // Count the needed '/'
    if (validationPath.parts_.length > 0) validationPath.byteLength_ += 1;
    validationPath.parts_.push(child);
    validationPath.byteLength_ += (0, $fc59d49e1bb53b6a$export$9536dc0a75b20bf9)(child);
    $494ac95ccfb2d9dd$var$validationPathCheckValid(validationPath);
}
function $494ac95ccfb2d9dd$var$validationPathPop(validationPath) {
    const last = validationPath.parts_.pop();
    validationPath.byteLength_ -= (0, $fc59d49e1bb53b6a$export$9536dc0a75b20bf9)(last);
    // Un-count the previous '/'
    if (validationPath.parts_.length > 0) validationPath.byteLength_ -= 1;
}
function $494ac95ccfb2d9dd$var$validationPathCheckValid(validationPath) {
    if (validationPath.byteLength_ > $494ac95ccfb2d9dd$var$MAX_PATH_LENGTH_BYTES) throw new Error(validationPath.errorPrefix_ + "has a key path longer than " + $494ac95ccfb2d9dd$var$MAX_PATH_LENGTH_BYTES + " bytes (" + validationPath.byteLength_ + ").");
    if (validationPath.parts_.length > $494ac95ccfb2d9dd$var$MAX_PATH_DEPTH) throw new Error(validationPath.errorPrefix_ + "path specified exceeds the maximum depth that can be written (" + $494ac95ccfb2d9dd$var$MAX_PATH_DEPTH + ") or object contains a cycle " + $494ac95ccfb2d9dd$var$validationPathToErrorString(validationPath));
}
/**
 * String for use in error messages - uses '.' notation for path.
 */ function $494ac95ccfb2d9dd$var$validationPathToErrorString(validationPath) {
    if (validationPath.parts_.length === 0) return "";
    return "in property '" + validationPath.parts_.join(".") + "'";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $494ac95ccfb2d9dd$var$VisibilityMonitor extends $494ac95ccfb2d9dd$var$EventEmitter {
    constructor(){
        super([
            "visible"
        ]);
        let hidden;
        let visibilityChange;
        if (typeof document !== "undefined" && typeof document.addEventListener !== "undefined") {
            if (typeof document["hidden"] !== "undefined") {
                // Opera 12.10 and Firefox 18 and later support
                visibilityChange = "visibilitychange";
                hidden = "hidden";
            } else if (typeof document["mozHidden"] !== "undefined") {
                visibilityChange = "mozvisibilitychange";
                hidden = "mozHidden";
            } else if (typeof document["msHidden"] !== "undefined") {
                visibilityChange = "msvisibilitychange";
                hidden = "msHidden";
            } else if (typeof document["webkitHidden"] !== "undefined") {
                visibilityChange = "webkitvisibilitychange";
                hidden = "webkitHidden";
            }
        }
        // Initially, we always assume we are visible. This ensures that in browsers
        // without page visibility support or in cases where we are never visible
        // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
        // reconnects
        this.visible_ = true;
        if (visibilityChange) document.addEventListener(visibilityChange, ()=>{
            const visible = !document[hidden];
            if (visible !== this.visible_) {
                this.visible_ = visible;
                this.trigger("visible", visible);
            }
        }, false);
    }
    static getInstance() {
        return new $494ac95ccfb2d9dd$var$VisibilityMonitor();
    }
    getInitialEvent(eventType) {
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(eventType === "visible", "Unknown event type: " + eventType);
        return [
            this.visible_
        ];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $494ac95ccfb2d9dd$var$RECONNECT_MIN_DELAY = 1000;
const $494ac95ccfb2d9dd$var$RECONNECT_MAX_DELAY_DEFAULT = 300000; // 5 minutes in milliseconds (Case: 1858)
const $494ac95ccfb2d9dd$var$RECONNECT_MAX_DELAY_FOR_ADMINS = 30000; // 30 seconds for admin clients (likely to be a backend server)
const $494ac95ccfb2d9dd$var$RECONNECT_DELAY_MULTIPLIER = 1.3;
const $494ac95ccfb2d9dd$var$RECONNECT_DELAY_RESET_TIMEOUT = 30000; // Reset delay back to MIN_DELAY after being connected for 30sec.
const $494ac95ccfb2d9dd$var$SERVER_KILL_INTERRUPT_REASON = "server_kill";
// If auth fails repeatedly, we'll assume something is wrong and log a warning / back off.
const $494ac95ccfb2d9dd$var$INVALID_TOKEN_THRESHOLD = 3;
/**
 * Firebase connection.  Abstracts wire protocol and handles reconnecting.
 *
 * NOTE: All JSON objects sent to the realtime connection must have property names enclosed
 * in quotes to make sure the closure compiler does not minify them.
 */ class $494ac95ccfb2d9dd$var$PersistentConnection extends $494ac95ccfb2d9dd$var$ServerActions {
    /**
     * @param repoInfo_ - Data about the namespace we are connecting to
     * @param applicationId_ - The Firebase App ID for this project
     * @param onDataUpdate_ - A callback for new data from the server
     */ constructor(repoInfo_, applicationId_, onDataUpdate_, onConnectStatus_, onServerInfoUpdate_, authTokenProvider_, appCheckTokenProvider_, authOverride_){
        super();
        this.repoInfo_ = repoInfo_;
        this.applicationId_ = applicationId_;
        this.onDataUpdate_ = onDataUpdate_;
        this.onConnectStatus_ = onConnectStatus_;
        this.onServerInfoUpdate_ = onServerInfoUpdate_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckTokenProvider_ = appCheckTokenProvider_;
        this.authOverride_ = authOverride_;
        // Used for diagnostic logging.
        this.id = $494ac95ccfb2d9dd$var$PersistentConnection.nextPersistentConnectionId_++;
        this.log_ = $494ac95ccfb2d9dd$var$logWrapper("p:" + this.id + ":");
        this.interruptReasons_ = {};
        this.listens = new Map();
        this.outstandingPuts_ = [];
        this.outstandingGets_ = [];
        this.outstandingPutCount_ = 0;
        this.outstandingGetCount_ = 0;
        this.onDisconnectRequestQueue_ = [];
        this.connected_ = false;
        this.reconnectDelay_ = $494ac95ccfb2d9dd$var$RECONNECT_MIN_DELAY;
        this.maxReconnectDelay_ = $494ac95ccfb2d9dd$var$RECONNECT_MAX_DELAY_DEFAULT;
        this.securityDebugCallback_ = null;
        this.lastSessionId = null;
        this.establishConnectionTimer_ = null;
        this.visible_ = false;
        // Before we get connected, we keep a queue of pending messages to send.
        this.requestCBHash_ = {};
        this.requestNumber_ = 0;
        this.realtime_ = null;
        this.authToken_ = null;
        this.appCheckToken_ = null;
        this.forceTokenRefresh_ = false;
        this.invalidAuthTokenCount_ = 0;
        this.invalidAppCheckTokenCount_ = 0;
        this.firstConnection_ = true;
        this.lastConnectionAttemptTime_ = null;
        this.lastConnectionEstablishedTime_ = null;
        if (authOverride_ && !(0, $fc59d49e1bb53b6a$export$5d1d834fbbf8bab7)()) throw new Error("Auth override specified in options, but not supported on non Node.js platforms");
        $494ac95ccfb2d9dd$var$VisibilityMonitor.getInstance().on("visible", this.onVisible_, this);
        if (repoInfo_.host.indexOf("fblocal") === -1) $494ac95ccfb2d9dd$var$OnlineMonitor.getInstance().on("online", this.onOnline_, this);
    }
    sendRequest(action, body, onResponse) {
        const curReqNum = ++this.requestNumber_;
        const msg = {
            r: curReqNum,
            a: action,
            b: body
        };
        this.log_((0, $fc59d49e1bb53b6a$export$fac44ee5b035f737)(msg));
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(this.connected_, "sendRequest call when we're not connected not allowed.");
        this.realtime_.sendRequest(msg);
        if (onResponse) this.requestCBHash_[curReqNum] = onResponse;
    }
    get(query) {
        this.initConnection_();
        const deferred = new (0, $fc59d49e1bb53b6a$export$85f6557964517f1a)();
        const request = {
            p: query._path.toString(),
            q: query._queryObject
        };
        const outstandingGet = {
            action: "g",
            request: request,
            onComplete: (message)=>{
                const payload = message["d"];
                if (message["s"] === "ok") deferred.resolve(payload);
                else deferred.reject(payload);
            }
        };
        this.outstandingGets_.push(outstandingGet);
        this.outstandingGetCount_++;
        const index = this.outstandingGets_.length - 1;
        if (this.connected_) this.sendGet_(index);
        return deferred.promise;
    }
    listen(query, currentHashFn, tag, onComplete) {
        this.initConnection_();
        const queryId = query._queryIdentifier;
        const pathString = query._path.toString();
        this.log_("Listen called for " + pathString + " " + queryId);
        if (!this.listens.has(pathString)) this.listens.set(pathString, new Map());
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(query._queryParams.isDefault() || !query._queryParams.loadsAllData(), "listen() called for non-default but complete query");
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(!this.listens.get(pathString).has(queryId), `listen() called twice for same path/queryId.`);
        const listenSpec = {
            onComplete: onComplete,
            hashFn: currentHashFn,
            query: query,
            tag: tag
        };
        this.listens.get(pathString).set(queryId, listenSpec);
        if (this.connected_) this.sendListen_(listenSpec);
    }
    sendGet_(index) {
        const get = this.outstandingGets_[index];
        this.sendRequest("g", get.request, (message)=>{
            delete this.outstandingGets_[index];
            this.outstandingGetCount_--;
            if (this.outstandingGetCount_ === 0) this.outstandingGets_ = [];
            if (get.onComplete) get.onComplete(message);
        });
    }
    sendListen_(listenSpec) {
        const query = listenSpec.query;
        const pathString = query._path.toString();
        const queryId = query._queryIdentifier;
        this.log_("Listen on " + pathString + " for " + queryId);
        const req = {
            p: pathString
        };
        const action = "q";
        // Only bother to send query if it's non-default.
        if (listenSpec.tag) {
            req["q"] = query._queryObject;
            req["t"] = listenSpec.tag;
        }
        req[/*hash*/ "h"] = listenSpec.hashFn();
        this.sendRequest(action, req, (message)=>{
            const payload = message[/*data*/ "d"];
            const status = message[/*status*/ "s"];
            // print warnings in any case...
            $494ac95ccfb2d9dd$var$PersistentConnection.warnOnListenWarnings_(payload, query);
            const currentListenSpec = this.listens.get(pathString) && this.listens.get(pathString).get(queryId);
            // only trigger actions if the listen hasn't been removed and readded
            if (currentListenSpec === listenSpec) {
                this.log_("listen response", message);
                if (status !== "ok") this.removeListen_(pathString, queryId);
                if (listenSpec.onComplete) listenSpec.onComplete(status, payload);
            }
        });
    }
    static warnOnListenWarnings_(payload, query) {
        if (payload && typeof payload === "object" && (0, $fc59d49e1bb53b6a$export$2344b14b097df817)(payload, "w")) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const warnings = (0, $fc59d49e1bb53b6a$export$e51ae4db7b428f67)(payload, "w");
            if (Array.isArray(warnings) && ~warnings.indexOf("no_index")) {
                const indexSpec = '".indexOn": "' + query._queryParams.getIndex().toString() + '"';
                const indexPath = query._path.toString();
                $494ac95ccfb2d9dd$var$warn(`Using an unspecified index. Your data will be downloaded and ` + `filtered on the client. Consider adding ${indexSpec} at ` + `${indexPath} to your security rules for better performance.`);
            }
        }
    }
    refreshAuthToken(token) {
        this.authToken_ = token;
        this.log_("Auth token refreshed");
        if (this.authToken_) this.tryAuth();
        else //If we're connected we want to let the server know to unauthenticate us. If we're not connected, simply delete
        //the credential so we dont become authenticated next time we connect.
        if (this.connected_) this.sendRequest("unauth", {}, ()=>{});
        this.reduceReconnectDelayIfAdminCredential_(token);
    }
    reduceReconnectDelayIfAdminCredential_(credential) {
        // NOTE: This isn't intended to be bulletproof (a malicious developer can always just modify the client).
        // Additionally, we don't bother resetting the max delay back to the default if auth fails / expires.
        const isFirebaseSecret = credential && credential.length === 40;
        if (isFirebaseSecret || (0, $fc59d49e1bb53b6a$export$fc970ed23da99565)(credential)) {
            this.log_("Admin auth credential detected.  Reducing max reconnect time.");
            this.maxReconnectDelay_ = $494ac95ccfb2d9dd$var$RECONNECT_MAX_DELAY_FOR_ADMINS;
        }
    }
    refreshAppCheckToken(token) {
        this.appCheckToken_ = token;
        this.log_("App check token refreshed");
        if (this.appCheckToken_) this.tryAppCheck();
        else //If we're connected we want to let the server know to unauthenticate us.
        //If we're not connected, simply delete the credential so we dont become
        // authenticated next time we connect.
        if (this.connected_) this.sendRequest("unappeck", {}, ()=>{});
    }
    /**
     * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
     * a auth revoked (the connection is closed).
     */ tryAuth() {
        if (this.connected_ && this.authToken_) {
            const token = this.authToken_;
            const authMethod = (0, $fc59d49e1bb53b6a$export$9565ca3d387f8aa0)(token) ? "auth" : "gauth";
            const requestData = {
                cred: token
            };
            if (this.authOverride_ === null) requestData["noauth"] = true;
            else if (typeof this.authOverride_ === "object") requestData["authvar"] = this.authOverride_;
            this.sendRequest(authMethod, requestData, (res)=>{
                const status = res[/*status*/ "s"];
                const data = res[/*data*/ "d"] || "error";
                if (this.authToken_ === token) {
                    if (status === "ok") this.invalidAuthTokenCount_ = 0;
                    else // Triggers reconnect and force refresh for auth token
                    this.onAuthRevoked_(status, data);
                }
            });
        }
    }
    /**
     * Attempts to authenticate with the given token. If the authentication
     * attempt fails, it's triggered like the token was revoked (the connection is
     * closed).
     */ tryAppCheck() {
        if (this.connected_ && this.appCheckToken_) this.sendRequest("appcheck", {
            "token": this.appCheckToken_
        }, (res)=>{
            const status = res[/*status*/ "s"];
            const data = res[/*data*/ "d"] || "error";
            if (status === "ok") this.invalidAppCheckTokenCount_ = 0;
            else this.onAppCheckRevoked_(status, data);
        });
    }
    /**
     * @inheritDoc
     */ unlisten(query, tag) {
        const pathString = query._path.toString();
        const queryId = query._queryIdentifier;
        this.log_("Unlisten called for " + pathString + " " + queryId);
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(query._queryParams.isDefault() || !query._queryParams.loadsAllData(), "unlisten() called for non-default but complete query");
        const listen = this.removeListen_(pathString, queryId);
        if (listen && this.connected_) this.sendUnlisten_(pathString, queryId, query._queryObject, tag);
    }
    sendUnlisten_(pathString, queryId, queryObj, tag) {
        this.log_("Unlisten on " + pathString + " for " + queryId);
        const req = {
            p: pathString
        };
        const action = "n";
        // Only bother sending queryId if it's non-default.
        if (tag) {
            req["q"] = queryObj;
            req["t"] = tag;
        }
        this.sendRequest(action, req);
    }
    onDisconnectPut(pathString, data, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_("o", pathString, data, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: "o",
            data: data,
            onComplete: onComplete
        });
    }
    onDisconnectMerge(pathString, data, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_("om", pathString, data, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: "om",
            data: data,
            onComplete: onComplete
        });
    }
    onDisconnectCancel(pathString, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_("oc", pathString, null, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: "oc",
            data: null,
            onComplete: onComplete
        });
    }
    sendOnDisconnect_(action, pathString, data, onComplete) {
        const request = {
            p: pathString,
            /*data*/ d: data
        };
        this.log_("onDisconnect " + action, request);
        this.sendRequest(action, request, (response)=>{
            if (onComplete) setTimeout(()=>{
                onComplete(response[/*status*/ "s"], response[/* data */ "d"]);
            }, Math.floor(0));
        });
    }
    put(pathString, data, onComplete, hash) {
        this.putInternal("p", pathString, data, onComplete, hash);
    }
    merge(pathString, data, onComplete, hash) {
        this.putInternal("m", pathString, data, onComplete, hash);
    }
    putInternal(action, pathString, data, onComplete, hash) {
        this.initConnection_();
        const request = {
            /*path*/ p: pathString,
            /*data*/ d: data
        };
        if (hash !== undefined) request[/*hash*/ "h"] = hash;
        // TODO: Only keep track of the most recent put for a given path?
        this.outstandingPuts_.push({
            action: action,
            request: request,
            onComplete: onComplete
        });
        this.outstandingPutCount_++;
        const index = this.outstandingPuts_.length - 1;
        if (this.connected_) this.sendPut_(index);
        else this.log_("Buffering put: " + pathString);
    }
    sendPut_(index) {
        const action = this.outstandingPuts_[index].action;
        const request = this.outstandingPuts_[index].request;
        const onComplete = this.outstandingPuts_[index].onComplete;
        this.outstandingPuts_[index].queued = this.connected_;
        this.sendRequest(action, request, (message)=>{
            this.log_(action + " response", message);
            delete this.outstandingPuts_[index];
            this.outstandingPutCount_--;
            // Clean up array occasionally.
            if (this.outstandingPutCount_ === 0) this.outstandingPuts_ = [];
            if (onComplete) onComplete(message[/*status*/ "s"], message[/* data */ "d"]);
        });
    }
    reportStats(stats) {
        // If we're not connected, we just drop the stats.
        if (this.connected_) {
            const request = {
                c: stats
            };
            this.log_("reportStats", request);
            this.sendRequest(/*stats*/ "s", request, (result)=>{
                const status = result[/*status*/ "s"];
                if (status !== "ok") {
                    const errorReason = result[/* data */ "d"];
                    this.log_("reportStats", "Error sending stats: " + errorReason);
                }
            });
        }
    }
    onDataMessage_(message) {
        if ("r" in message) {
            // this is a response
            this.log_("from server: " + (0, $fc59d49e1bb53b6a$export$fac44ee5b035f737)(message));
            const reqNum = message["r"];
            const onResponse = this.requestCBHash_[reqNum];
            if (onResponse) {
                delete this.requestCBHash_[reqNum];
                onResponse(message[/*body*/ "b"]);
            }
        } else if ("error" in message) throw "A server-side error has occurred: " + message["error"];
        else if ("a" in message) // a and b are action and body, respectively
        this.onDataPush_(message["a"], message["b"]);
    }
    onDataPush_(action, body) {
        this.log_("handleServerMessage", action, body);
        if (action === "d") this.onDataUpdate_(body[/*path*/ "p"], body[/*data*/ "d"], /*isMerge*/ false, body["t"]);
        else if (action === "m") this.onDataUpdate_(body[/*path*/ "p"], body[/*data*/ "d"], /*isMerge=*/ true, body["t"]);
        else if (action === "c") this.onListenRevoked_(body[/*path*/ "p"], body[/*query*/ "q"]);
        else if (action === "ac") this.onAuthRevoked_(body[/*status code*/ "s"], body[/* explanation */ "d"]);
        else if (action === "apc") this.onAppCheckRevoked_(body[/*status code*/ "s"], body[/* explanation */ "d"]);
        else if (action === "sd") this.onSecurityDebugPacket_(body);
        else $494ac95ccfb2d9dd$var$error("Unrecognized action received from server: " + (0, $fc59d49e1bb53b6a$export$fac44ee5b035f737)(action) + "\nAre you using the latest client?");
    }
    onReady_(timestamp, sessionId) {
        this.log_("connection ready");
        this.connected_ = true;
        this.lastConnectionEstablishedTime_ = new Date().getTime();
        this.handleTimestamp_(timestamp);
        this.lastSessionId = sessionId;
        if (this.firstConnection_) this.sendConnectStats_();
        this.restoreState_();
        this.firstConnection_ = false;
        this.onConnectStatus_(true);
    }
    scheduleConnect_(timeout) {
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(!this.realtime_, "Scheduling a connect when we're already connected/ing?");
        if (this.establishConnectionTimer_) clearTimeout(this.establishConnectionTimer_);
        // NOTE: Even when timeout is 0, it's important to do a setTimeout to work around an infuriating "Security Error" in
        // Firefox when trying to write to our long-polling iframe in some scenarios (e.g. Forge or our unit tests).
        this.establishConnectionTimer_ = setTimeout(()=>{
            this.establishConnectionTimer_ = null;
            this.establishConnection_();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor(timeout));
    }
    initConnection_() {
        if (!this.realtime_ && this.firstConnection_) this.scheduleConnect_(0);
    }
    onVisible_(visible) {
        // NOTE: Tabbing away and back to a window will defeat our reconnect backoff, but I think that's fine.
        if (visible && !this.visible_ && this.reconnectDelay_ === this.maxReconnectDelay_) {
            this.log_("Window became visible.  Reducing delay.");
            this.reconnectDelay_ = $494ac95ccfb2d9dd$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        }
        this.visible_ = visible;
    }
    onOnline_(online) {
        if (online) {
            this.log_("Browser went online.");
            this.reconnectDelay_ = $494ac95ccfb2d9dd$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        } else {
            this.log_("Browser went offline.  Killing connection.");
            if (this.realtime_) this.realtime_.close();
        }
    }
    onRealtimeDisconnect_() {
        this.log_("data client disconnected");
        this.connected_ = false;
        this.realtime_ = null;
        // Since we don't know if our sent transactions succeeded or not, we need to cancel them.
        this.cancelSentTransactions_();
        // Clear out the pending requests.
        this.requestCBHash_ = {};
        if (this.shouldReconnect_()) {
            if (!this.visible_) {
                this.log_("Window isn't visible.  Delaying reconnect.");
                this.reconnectDelay_ = this.maxReconnectDelay_;
                this.lastConnectionAttemptTime_ = new Date().getTime();
            } else if (this.lastConnectionEstablishedTime_) {
                // If we've been connected long enough, reset reconnect delay to minimum.
                const timeSinceLastConnectSucceeded = new Date().getTime() - this.lastConnectionEstablishedTime_;
                if (timeSinceLastConnectSucceeded > $494ac95ccfb2d9dd$var$RECONNECT_DELAY_RESET_TIMEOUT) this.reconnectDelay_ = $494ac95ccfb2d9dd$var$RECONNECT_MIN_DELAY;
                this.lastConnectionEstablishedTime_ = null;
            }
            const timeSinceLastConnectAttempt = new Date().getTime() - this.lastConnectionAttemptTime_;
            let reconnectDelay = Math.max(0, this.reconnectDelay_ - timeSinceLastConnectAttempt);
            reconnectDelay = Math.random() * reconnectDelay;
            this.log_("Trying to reconnect in " + reconnectDelay + "ms");
            this.scheduleConnect_(reconnectDelay);
            // Adjust reconnect delay for next time.
            this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * $494ac95ccfb2d9dd$var$RECONNECT_DELAY_MULTIPLIER);
        }
        this.onConnectStatus_(false);
    }
    async establishConnection_() {
        if (this.shouldReconnect_()) {
            this.log_("Making a connection attempt");
            this.lastConnectionAttemptTime_ = new Date().getTime();
            this.lastConnectionEstablishedTime_ = null;
            const onDataMessage = this.onDataMessage_.bind(this);
            const onReady = this.onReady_.bind(this);
            const onDisconnect = this.onRealtimeDisconnect_.bind(this);
            const connId = this.id + ":" + $494ac95ccfb2d9dd$var$PersistentConnection.nextConnectionId_++;
            const lastSessionId = this.lastSessionId;
            let canceled = false;
            let connection = null;
            const closeFn = function() {
                if (connection) connection.close();
                else {
                    canceled = true;
                    onDisconnect();
                }
            };
            const sendRequestFn = function(msg) {
                (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(connection, "sendRequest call when we're not connected not allowed.");
                connection.sendRequest(msg);
            };
            this.realtime_ = {
                close: closeFn,
                sendRequest: sendRequestFn
            };
            const forceRefresh = this.forceTokenRefresh_;
            this.forceTokenRefresh_ = false;
            try {
                // First fetch auth and app check token, and establish connection after
                // fetching the token was successful
                const [authToken, appCheckToken] = await Promise.all([
                    this.authTokenProvider_.getToken(forceRefresh),
                    this.appCheckTokenProvider_.getToken(forceRefresh)
                ]);
                if (!canceled) {
                    $494ac95ccfb2d9dd$var$log("getToken() completed. Creating connection.");
                    this.authToken_ = authToken && authToken.accessToken;
                    this.appCheckToken_ = appCheckToken && appCheckToken.token;
                    connection = new $494ac95ccfb2d9dd$var$Connection(connId, this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, onDataMessage, onReady, onDisconnect, /* onKill= */ (reason)=>{
                        $494ac95ccfb2d9dd$var$warn(reason + " (" + this.repoInfo_.toString() + ")");
                        this.interrupt($494ac95ccfb2d9dd$var$SERVER_KILL_INTERRUPT_REASON);
                    }, lastSessionId);
                } else $494ac95ccfb2d9dd$var$log("getToken() completed but was canceled");
            } catch (error) {
                this.log_("Failed to get token: " + error);
                if (!canceled) {
                    if (this.repoInfo_.nodeAdmin) // This may be a critical error for the Admin Node.js SDK, so log a warning.
                    // But getToken() may also just have temporarily failed, so we still want to
                    // continue retrying.
                    $494ac95ccfb2d9dd$var$warn(error);
                    closeFn();
                }
            }
        }
    }
    interrupt(reason) {
        $494ac95ccfb2d9dd$var$log("Interrupting connection for reason: " + reason);
        this.interruptReasons_[reason] = true;
        if (this.realtime_) this.realtime_.close();
        else {
            if (this.establishConnectionTimer_) {
                clearTimeout(this.establishConnectionTimer_);
                this.establishConnectionTimer_ = null;
            }
            if (this.connected_) this.onRealtimeDisconnect_();
        }
    }
    resume(reason) {
        $494ac95ccfb2d9dd$var$log("Resuming connection for reason: " + reason);
        delete this.interruptReasons_[reason];
        if ((0, $fc59d49e1bb53b6a$export$dd1bc94b04021eeb)(this.interruptReasons_)) {
            this.reconnectDelay_ = $494ac95ccfb2d9dd$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        }
    }
    handleTimestamp_(timestamp) {
        const delta = timestamp - new Date().getTime();
        this.onServerInfoUpdate_({
            serverTimeOffset: delta
        });
    }
    cancelSentTransactions_() {
        for(let i = 0; i < this.outstandingPuts_.length; i++){
            const put = this.outstandingPuts_[i];
            if (put && /*hash*/ "h" in put.request && put.queued) {
                if (put.onComplete) put.onComplete("disconnect");
                delete this.outstandingPuts_[i];
                this.outstandingPutCount_--;
            }
        }
        // Clean up array occasionally.
        if (this.outstandingPutCount_ === 0) this.outstandingPuts_ = [];
    }
    onListenRevoked_(pathString, query) {
        // Remove the listen and manufacture a "permission_denied" error for the failed listen.
        let queryId;
        if (!query) queryId = "default";
        else queryId = query.map((q)=>$494ac95ccfb2d9dd$var$ObjectToUniqueKey(q)).join("$");
        const listen = this.removeListen_(pathString, queryId);
        if (listen && listen.onComplete) listen.onComplete("permission_denied");
    }
    removeListen_(pathString, queryId) {
        const normalizedPathString = new $494ac95ccfb2d9dd$var$Path(pathString).toString(); // normalize path.
        let listen;
        if (this.listens.has(normalizedPathString)) {
            const map = this.listens.get(normalizedPathString);
            listen = map.get(queryId);
            map.delete(queryId);
            if (map.size === 0) this.listens.delete(normalizedPathString);
        } else // all listens for this path has already been removed
        listen = undefined;
        return listen;
    }
    onAuthRevoked_(statusCode, explanation) {
        $494ac95ccfb2d9dd$var$log("Auth token revoked: " + statusCode + "/" + explanation);
        this.authToken_ = null;
        this.forceTokenRefresh_ = true;
        this.realtime_.close();
        if (statusCode === "invalid_token" || statusCode === "permission_denied") {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAuthTokenCount_++;
            if (this.invalidAuthTokenCount_ >= $494ac95ccfb2d9dd$var$INVALID_TOKEN_THRESHOLD) {
                // Set a long reconnect delay because recovery is unlikely
                this.reconnectDelay_ = $494ac95ccfb2d9dd$var$RECONNECT_MAX_DELAY_FOR_ADMINS;
                // Notify the auth token provider that the token is invalid, which will log
                // a warning
                this.authTokenProvider_.notifyForInvalidToken();
            }
        }
    }
    onAppCheckRevoked_(statusCode, explanation) {
        $494ac95ccfb2d9dd$var$log("App check token revoked: " + statusCode + "/" + explanation);
        this.appCheckToken_ = null;
        this.forceTokenRefresh_ = true;
        // Note: We don't close the connection as the developer may not have
        // enforcement enabled. The backend closes connections with enforcements.
        if (statusCode === "invalid_token" || statusCode === "permission_denied") {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAppCheckTokenCount_++;
            if (this.invalidAppCheckTokenCount_ >= $494ac95ccfb2d9dd$var$INVALID_TOKEN_THRESHOLD) this.appCheckTokenProvider_.notifyForInvalidToken();
        }
    }
    onSecurityDebugPacket_(body) {
        if (this.securityDebugCallback_) this.securityDebugCallback_(body);
        else if ("msg" in body) console.log("FIREBASE: " + body["msg"].replace("\n", "\nFIREBASE: "));
    }
    restoreState_() {
        //Re-authenticate ourselves if we have a credential stored.
        this.tryAuth();
        this.tryAppCheck();
        // Puts depend on having received the corresponding data update from the server before they complete, so we must
        // make sure to send listens before puts.
        for (const queries of this.listens.values())for (const listenSpec of queries.values())this.sendListen_(listenSpec);
        for(let i = 0; i < this.outstandingPuts_.length; i++)if (this.outstandingPuts_[i]) this.sendPut_(i);
        while(this.onDisconnectRequestQueue_.length){
            const request = this.onDisconnectRequestQueue_.shift();
            this.sendOnDisconnect_(request.action, request.pathString, request.data, request.onComplete);
        }
        for(let i = 0; i < this.outstandingGets_.length; i++)if (this.outstandingGets_[i]) this.sendGet_(i);
    }
    /**
     * Sends client stats for first connection
     */ sendConnectStats_() {
        const stats = {};
        let clientName = "js";
        if ((0, $fc59d49e1bb53b6a$export$5d1d834fbbf8bab7)()) {
            if (this.repoInfo_.nodeAdmin) clientName = "admin_node";
            else clientName = "node";
        }
        stats["sdk." + clientName + "." + $494ac95ccfb2d9dd$var$SDK_VERSION.replace(/\./g, "-")] = 1;
        if ((0, $fc59d49e1bb53b6a$export$872f8323f01d7ae0)()) stats["framework.cordova"] = 1;
        else if ((0, $fc59d49e1bb53b6a$export$f7a1e23e542d38e3)()) stats["framework.reactnative"] = 1;
        this.reportStats(stats);
    }
    shouldReconnect_() {
        const online = $494ac95ccfb2d9dd$var$OnlineMonitor.getInstance().currentlyOnline();
        return (0, $fc59d49e1bb53b6a$export$dd1bc94b04021eeb)(this.interruptReasons_) && online;
    }
}
$494ac95ccfb2d9dd$var$PersistentConnection.nextPersistentConnectionId_ = 0;
/**
 * Counter for number of connections created. Mainly used for tagging in the logs
 */ $494ac95ccfb2d9dd$var$PersistentConnection.nextConnectionId_ = 0;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $494ac95ccfb2d9dd$var$NamedNode {
    constructor(name, node){
        this.name = name;
        this.node = node;
    }
    static Wrap(name, node) {
        return new $494ac95ccfb2d9dd$var$NamedNode(name, node);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $494ac95ccfb2d9dd$var$Index {
    /**
     * @returns A standalone comparison function for
     * this index
     */ getCompare() {
        return this.compare.bind(this);
    }
    /**
     * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
     * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
     *
     *
     * @returns True if the portion of the snapshot being indexed changed between oldNode and newNode
     */ indexedValueChanged(oldNode, newNode) {
        const oldWrapped = new $494ac95ccfb2d9dd$var$NamedNode($494ac95ccfb2d9dd$var$MIN_NAME, oldNode);
        const newWrapped = new $494ac95ccfb2d9dd$var$NamedNode($494ac95ccfb2d9dd$var$MIN_NAME, newNode);
        return this.compare(oldWrapped, newWrapped) !== 0;
    }
    /**
     * @returns a node wrapper that will sort equal to or less than
     * any other node wrapper, using this index
     */ minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $494ac95ccfb2d9dd$var$NamedNode.MIN;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $494ac95ccfb2d9dd$var$__EMPTY_NODE;
class $494ac95ccfb2d9dd$var$KeyIndex extends $494ac95ccfb2d9dd$var$Index {
    static get __EMPTY_NODE() {
        return $494ac95ccfb2d9dd$var$__EMPTY_NODE;
    }
    static set __EMPTY_NODE(val) {
        $494ac95ccfb2d9dd$var$__EMPTY_NODE = val;
    }
    compare(a, b) {
        return $494ac95ccfb2d9dd$var$nameCompare(a.name, b.name);
    }
    isDefinedOn(node) {
        // We could probably return true here (since every node has a key), but it's never called
        // so just leaving unimplemented for now.
        throw (0, $fc59d49e1bb53b6a$export$a39cad550e7ab28a)("KeyIndex.isDefinedOn not expected to be called.");
    }
    indexedValueChanged(oldNode, newNode) {
        return false; // The key for a node never changes.
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $494ac95ccfb2d9dd$var$NamedNode.MIN;
    }
    maxPost() {
        // TODO: This should really be created once and cached in a static property, but
        // NamedNode isn't defined yet, so I can't use it in a static.  Bleh.
        return new $494ac95ccfb2d9dd$var$NamedNode($494ac95ccfb2d9dd$var$MAX_NAME, $494ac95ccfb2d9dd$var$__EMPTY_NODE);
    }
    makePost(indexValue, name) {
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(typeof indexValue === "string", "KeyIndex indexValue must always be a string.");
        // We just use empty node, but it'll never be compared, since our comparator only looks at name.
        return new $494ac95ccfb2d9dd$var$NamedNode(indexValue, $494ac95ccfb2d9dd$var$__EMPTY_NODE);
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return ".key";
    }
}
const $494ac95ccfb2d9dd$var$KEY_INDEX = new $494ac95ccfb2d9dd$var$KeyIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An iterator over an LLRBNode.
 */ class $494ac95ccfb2d9dd$var$SortedMapIterator {
    /**
     * @param node - Node to iterate.
     * @param isReverse_ - Whether or not to iterate in reverse
     */ constructor(node, startKey, comparator, isReverse_, resultGenerator_ = null){
        this.isReverse_ = isReverse_;
        this.resultGenerator_ = resultGenerator_;
        this.nodeStack_ = [];
        let cmp = 1;
        while(!node.isEmpty()){
            node;
            cmp = startKey ? comparator(node.key, startKey) : 1;
            // flip the comparison if we're going in reverse
            if (isReverse_) cmp *= -1;
            if (cmp < 0) {
                // This node is less than our start key. ignore it
                if (this.isReverse_) node = node.left;
                else node = node.right;
            } else if (cmp === 0) {
                // This node is exactly equal to our start key. Push it on the stack, but stop iterating;
                this.nodeStack_.push(node);
                break;
            } else {
                // This node is greater than our start key, add it to the stack and move to the next one
                this.nodeStack_.push(node);
                if (this.isReverse_) node = node.right;
                else node = node.left;
            }
        }
    }
    getNext() {
        if (this.nodeStack_.length === 0) return null;
        let node = this.nodeStack_.pop();
        let result;
        if (this.resultGenerator_) result = this.resultGenerator_(node.key, node.value);
        else result = {
            key: node.key,
            value: node.value
        };
        if (this.isReverse_) {
            node = node.left;
            while(!node.isEmpty()){
                this.nodeStack_.push(node);
                node = node.right;
            }
        } else {
            node = node.right;
            while(!node.isEmpty()){
                this.nodeStack_.push(node);
                node = node.left;
            }
        }
        return result;
    }
    hasNext() {
        return this.nodeStack_.length > 0;
    }
    peek() {
        if (this.nodeStack_.length === 0) return null;
        const node = this.nodeStack_[this.nodeStack_.length - 1];
        if (this.resultGenerator_) return this.resultGenerator_(node.key, node.value);
        else return {
            key: node.key,
            value: node.value
        };
    }
}
/**
 * Represents a node in a Left-leaning Red-Black tree.
 */ class $494ac95ccfb2d9dd$var$LLRBNode {
    /**
     * @param key - Key associated with this node.
     * @param value - Value associated with this node.
     * @param color - Whether this node is red.
     * @param left - Left child.
     * @param right - Right child.
     */ constructor(key, value, color, left, right){
        this.key = key;
        this.value = value;
        this.color = color != null ? color : $494ac95ccfb2d9dd$var$LLRBNode.RED;
        this.left = left != null ? left : $494ac95ccfb2d9dd$var$SortedMap.EMPTY_NODE;
        this.right = right != null ? right : $494ac95ccfb2d9dd$var$SortedMap.EMPTY_NODE;
    }
    /**
     * Returns a copy of the current node, optionally replacing pieces of it.
     *
     * @param key - New key for the node, or null.
     * @param value - New value for the node, or null.
     * @param color - New color for the node, or null.
     * @param left - New left child for the node, or null.
     * @param right - New right child for the node, or null.
     * @returns The node copy.
     */ copy(key, value, color, left, right) {
        return new $494ac95ccfb2d9dd$var$LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
    }
    /**
     * @returns The total number of nodes in the tree.
     */ count() {
        return this.left.count() + 1 + this.right.count();
    }
    /**
     * @returns True if the tree is empty.
     */ isEmpty() {
        return false;
    }
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     *   node.  If it returns true, traversal is aborted.
     * @returns The first truthy value returned by action, or the last falsey
     *   value returned by action
     */ inorderTraversal(action) {
        return this.left.inorderTraversal(action) || !!action(this.key, this.value) || this.right.inorderTraversal(action);
    }
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ reverseTraversal(action) {
        return this.right.reverseTraversal(action) || action(this.key, this.value) || this.left.reverseTraversal(action);
    }
    /**
     * @returns The minimum node in the tree.
     */ min_() {
        if (this.left.isEmpty()) return this;
        else return this.left.min_();
    }
    /**
     * @returns The maximum key in the tree.
     */ minKey() {
        return this.min_().key;
    }
    /**
     * @returns The maximum key in the tree.
     */ maxKey() {
        if (this.right.isEmpty()) return this.key;
        else return this.right.maxKey();
    }
    /**
     * @param key - Key to insert.
     * @param value - Value to insert.
     * @param comparator - Comparator.
     * @returns New tree, with the key/value added.
     */ insert(key, value, comparator) {
        let n = this;
        const cmp = comparator(key, n.key);
        if (cmp < 0) n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
        else if (cmp === 0) n = n.copy(null, value, null, null, null);
        else n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
        return n.fixUp_();
    }
    /**
     * @returns New tree, with the minimum key removed.
     */ removeMin_() {
        if (this.left.isEmpty()) return $494ac95ccfb2d9dd$var$SortedMap.EMPTY_NODE;
        let n = this;
        if (!n.left.isRed_() && !n.left.left.isRed_()) n = n.moveRedLeft_();
        n = n.copy(null, null, null, n.left.removeMin_(), null);
        return n.fixUp_();
    }
    /**
     * @param key - The key of the item to remove.
     * @param comparator - Comparator.
     * @returns New tree, with the specified item removed.
     */ remove(key, comparator) {
        let n, smallest;
        n = this;
        if (comparator(key, n.key) < 0) {
            if (!n.left.isEmpty() && !n.left.isRed_() && !n.left.left.isRed_()) n = n.moveRedLeft_();
            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
        } else {
            if (n.left.isRed_()) n = n.rotateRight_();
            if (!n.right.isEmpty() && !n.right.isRed_() && !n.right.left.isRed_()) n = n.moveRedRight_();
            if (comparator(key, n.key) === 0) {
                if (n.right.isEmpty()) return $494ac95ccfb2d9dd$var$SortedMap.EMPTY_NODE;
                else {
                    smallest = n.right.min_();
                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin_());
                }
            }
            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
        }
        return n.fixUp_();
    }
    /**
     * @returns Whether this is a RED node.
     */ isRed_() {
        return this.color;
    }
    /**
     * @returns New tree after performing any needed rotations.
     */ fixUp_() {
        let n = this;
        if (n.right.isRed_() && !n.left.isRed_()) n = n.rotateLeft_();
        if (n.left.isRed_() && n.left.left.isRed_()) n = n.rotateRight_();
        if (n.left.isRed_() && n.right.isRed_()) n = n.colorFlip_();
        return n;
    }
    /**
     * @returns New tree, after moveRedLeft.
     */ moveRedLeft_() {
        let n = this.colorFlip_();
        if (n.right.left.isRed_()) {
            n = n.copy(null, null, null, null, n.right.rotateRight_());
            n = n.rotateLeft_();
            n = n.colorFlip_();
        }
        return n;
    }
    /**
     * @returns New tree, after moveRedRight.
     */ moveRedRight_() {
        let n = this.colorFlip_();
        if (n.left.left.isRed_()) {
            n = n.rotateRight_();
            n = n.colorFlip_();
        }
        return n;
    }
    /**
     * @returns New tree, after rotateLeft.
     */ rotateLeft_() {
        const nl = this.copy(null, null, $494ac95ccfb2d9dd$var$LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, nl, null);
    }
    /**
     * @returns New tree, after rotateRight.
     */ rotateRight_() {
        const nr = this.copy(null, null, $494ac95ccfb2d9dd$var$LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, nr);
    }
    /**
     * @returns Newt ree, after colorFlip.
     */ colorFlip_() {
        const left = this.left.copy(null, null, !this.left.color, null, null);
        const right = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, left, right);
    }
    /**
     * For testing.
     *
     * @returns True if all is well.
     */ checkMaxDepth_() {
        const blackDepth = this.check_();
        return Math.pow(2.0, blackDepth) <= this.count() + 1;
    }
    check_() {
        if (this.isRed_() && this.left.isRed_()) throw new Error("Red node has red child(" + this.key + "," + this.value + ")");
        if (this.right.isRed_()) throw new Error("Right child of (" + this.key + "," + this.value + ") is red");
        const blackDepth = this.left.check_();
        if (blackDepth !== this.right.check_()) throw new Error("Black depths differ");
        else return blackDepth + (this.isRed_() ? 0 : 1);
    }
}
$494ac95ccfb2d9dd$var$LLRBNode.RED = true;
$494ac95ccfb2d9dd$var$LLRBNode.BLACK = false;
/**
 * Represents an empty node (a leaf node in the Red-Black Tree).
 */ class $494ac95ccfb2d9dd$var$LLRBEmptyNode {
    /**
     * Returns a copy of the current node.
     *
     * @returns The node copy.
     */ copy(key, value, color, left, right) {
        return this;
    }
    /**
     * Returns a copy of the tree, with the specified key/value added.
     *
     * @param key - Key to be added.
     * @param value - Value to be added.
     * @param comparator - Comparator.
     * @returns New tree, with item added.
     */ insert(key, value, comparator) {
        return new $494ac95ccfb2d9dd$var$LLRBNode(key, value, null);
    }
    /**
     * Returns a copy of the tree, with the specified key removed.
     *
     * @param key - The key to remove.
     * @param comparator - Comparator.
     * @returns New tree, with item removed.
     */ remove(key, comparator) {
        return this;
    }
    /**
     * @returns The total number of nodes in the tree.
     */ count() {
        return 0;
    }
    /**
     * @returns True if the tree is empty.
     */ isEmpty() {
        return true;
    }
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ inorderTraversal(action) {
        return false;
    }
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ reverseTraversal(action) {
        return false;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    check_() {
        return 0;
    }
    /**
     * @returns Whether this node is red.
     */ isRed_() {
        return false;
    }
}
/**
 * An immutable sorted map implementation, based on a Left-leaning Red-Black
 * tree.
 */ class $494ac95ccfb2d9dd$var$SortedMap {
    /**
     * @param comparator_ - Key comparator.
     * @param root_ - Optional root node for the map.
     */ constructor(comparator_, root_ = $494ac95ccfb2d9dd$var$SortedMap.EMPTY_NODE){
        this.comparator_ = comparator_;
        this.root_ = root_;
    }
    /**
     * Returns a copy of the map, with the specified key/value added or replaced.
     * (TODO: We should perhaps rename this method to 'put')
     *
     * @param key - Key to be added.
     * @param value - Value to be added.
     * @returns New map, with item added.
     */ insert(key, value) {
        return new $494ac95ccfb2d9dd$var$SortedMap(this.comparator_, this.root_.insert(key, value, this.comparator_).copy(null, null, $494ac95ccfb2d9dd$var$LLRBNode.BLACK, null, null));
    }
    /**
     * Returns a copy of the map, with the specified key removed.
     *
     * @param key - The key to remove.
     * @returns New map, with item removed.
     */ remove(key) {
        return new $494ac95ccfb2d9dd$var$SortedMap(this.comparator_, this.root_.remove(key, this.comparator_).copy(null, null, $494ac95ccfb2d9dd$var$LLRBNode.BLACK, null, null));
    }
    /**
     * Returns the value of the node with the given key, or null.
     *
     * @param key - The key to look up.
     * @returns The value of the node with the given key, or null if the
     * key doesn't exist.
     */ get(key) {
        let cmp;
        let node = this.root_;
        while(!node.isEmpty()){
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) return node.value;
            else if (cmp < 0) node = node.left;
            else if (cmp > 0) node = node.right;
        }
        return null;
    }
    /**
     * Returns the key of the item *before* the specified key, or null if key is the first item.
     * @param key - The key to find the predecessor of
     * @returns The predecessor key.
     */ getPredecessorKey(key) {
        let cmp, node = this.root_, rightParent = null;
        while(!node.isEmpty()){
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                if (!node.left.isEmpty()) {
                    node = node.left;
                    while(!node.right.isEmpty())node = node.right;
                    return node.key;
                } else if (rightParent) return rightParent.key;
                else return null; // first item.
            } else if (cmp < 0) node = node.left;
            else if (cmp > 0) {
                rightParent = node;
                node = node.right;
            }
        }
        throw new Error("Attempted to find predecessor key for a nonexistent key.  What gives?");
    }
    /**
     * @returns True if the map is empty.
     */ isEmpty() {
        return this.root_.isEmpty();
    }
    /**
     * @returns The total number of nodes in the map.
     */ count() {
        return this.root_.count();
    }
    /**
     * @returns The minimum key in the map.
     */ minKey() {
        return this.root_.minKey();
    }
    /**
     * @returns The maximum key in the map.
     */ maxKey() {
        return this.root_.maxKey();
    }
    /**
     * Traverses the map in key order and calls the specified action function
     * for each key/value pair.
     *
     * @param action - Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @returns The first truthy value returned by action, or the last falsey
     *   value returned by action
     */ inorderTraversal(action) {
        return this.root_.inorderTraversal(action);
    }
    /**
     * Traverses the map in reverse key order and calls the specified action function
     * for each key/value pair.
     *
     * @param action - Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @returns True if the traversal was aborted.
     */ reverseTraversal(action) {
        return this.root_.reverseTraversal(action);
    }
    /**
     * Returns an iterator over the SortedMap.
     * @returns The iterator.
     */ getIterator(resultGenerator) {
        return new $494ac95ccfb2d9dd$var$SortedMapIterator(this.root_, null, this.comparator_, false, resultGenerator);
    }
    getIteratorFrom(key, resultGenerator) {
        return new $494ac95ccfb2d9dd$var$SortedMapIterator(this.root_, key, this.comparator_, false, resultGenerator);
    }
    getReverseIteratorFrom(key, resultGenerator) {
        return new $494ac95ccfb2d9dd$var$SortedMapIterator(this.root_, key, this.comparator_, true, resultGenerator);
    }
    getReverseIterator(resultGenerator) {
        return new $494ac95ccfb2d9dd$var$SortedMapIterator(this.root_, null, this.comparator_, true, resultGenerator);
    }
}
/**
 * Always use the same empty node, to reduce memory.
 */ $494ac95ccfb2d9dd$var$SortedMap.EMPTY_NODE = new $494ac95ccfb2d9dd$var$LLRBEmptyNode();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $494ac95ccfb2d9dd$var$NAME_ONLY_COMPARATOR(left, right) {
    return $494ac95ccfb2d9dd$var$nameCompare(left.name, right.name);
}
function $494ac95ccfb2d9dd$var$NAME_COMPARATOR(left, right) {
    return $494ac95ccfb2d9dd$var$nameCompare(left, right);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $494ac95ccfb2d9dd$var$MAX_NODE$2;
function $494ac95ccfb2d9dd$var$setMaxNode$1(val) {
    $494ac95ccfb2d9dd$var$MAX_NODE$2 = val;
}
const $494ac95ccfb2d9dd$var$priorityHashText = function(priority) {
    if (typeof priority === "number") return "number:" + $494ac95ccfb2d9dd$var$doubleToIEEE754String(priority);
    else return "string:" + priority;
};
/**
 * Validates that a priority snapshot Node is valid.
 */ const $494ac95ccfb2d9dd$var$validatePriorityNode = function(priorityNode) {
    if (priorityNode.isLeafNode()) {
        const val = priorityNode.val();
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(typeof val === "string" || typeof val === "number" || typeof val === "object" && (0, $fc59d49e1bb53b6a$export$2344b14b097df817)(val, ".sv"), "Priority must be a string or number.");
    } else (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(priorityNode === $494ac95ccfb2d9dd$var$MAX_NODE$2 || priorityNode.isEmpty(), "priority of unexpected type.");
    // Don't call getPriority() on MAX_NODE to avoid hitting assertion.
    (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(priorityNode === $494ac95ccfb2d9dd$var$MAX_NODE$2 || priorityNode.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $494ac95ccfb2d9dd$var$__childrenNodeConstructor;
/**
 * LeafNode is a class for storing leaf nodes in a DataSnapshot.  It
 * implements Node and stores the value of the node (a string,
 * number, or boolean) accessible via getValue().
 */ class $494ac95ccfb2d9dd$var$LeafNode {
    /**
     * @param value_ - The value to store in this leaf node. The object type is
     * possible in the event of a deferred value
     * @param priorityNode_ - The priority of this node.
     */ constructor(value_, priorityNode_ = $494ac95ccfb2d9dd$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE){
        this.value_ = value_;
        this.priorityNode_ = priorityNode_;
        this.lazyHash_ = null;
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(this.value_ !== undefined && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value.");
        $494ac95ccfb2d9dd$var$validatePriorityNode(this.priorityNode_);
    }
    static set __childrenNodeConstructor(val) {
        $494ac95ccfb2d9dd$var$__childrenNodeConstructor = val;
    }
    static get __childrenNodeConstructor() {
        return $494ac95ccfb2d9dd$var$__childrenNodeConstructor;
    }
    /** @inheritDoc */ isLeafNode() {
        return true;
    }
    /** @inheritDoc */ getPriority() {
        return this.priorityNode_;
    }
    /** @inheritDoc */ updatePriority(newPriorityNode) {
        return new $494ac95ccfb2d9dd$var$LeafNode(this.value_, newPriorityNode);
    }
    /** @inheritDoc */ getImmediateChild(childName) {
        // Hack to treat priority as a regular child
        if (childName === ".priority") return this.priorityNode_;
        else return $494ac95ccfb2d9dd$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE;
    }
    /** @inheritDoc */ getChild(path) {
        if ($494ac95ccfb2d9dd$var$pathIsEmpty(path)) return this;
        else if ($494ac95ccfb2d9dd$var$pathGetFront(path) === ".priority") return this.priorityNode_;
        else return $494ac95ccfb2d9dd$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE;
    }
    hasChild() {
        return false;
    }
    /** @inheritDoc */ getPredecessorChildName(childName, childNode) {
        return null;
    }
    /** @inheritDoc */ updateImmediateChild(childName, newChildNode) {
        if (childName === ".priority") return this.updatePriority(newChildNode);
        else if (newChildNode.isEmpty() && childName !== ".priority") return this;
        else return $494ac95ccfb2d9dd$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(childName, newChildNode).updatePriority(this.priorityNode_);
    }
    /** @inheritDoc */ updateChild(path, newChildNode) {
        const front = $494ac95ccfb2d9dd$var$pathGetFront(path);
        if (front === null) return newChildNode;
        else if (newChildNode.isEmpty() && front !== ".priority") return this;
        else {
            (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(front !== ".priority" || $494ac95ccfb2d9dd$var$pathGetLength(path) === 1, ".priority must be the last token in a path");
            return this.updateImmediateChild(front, $494ac95ccfb2d9dd$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateChild($494ac95ccfb2d9dd$var$pathPopFront(path), newChildNode));
        }
    }
    /** @inheritDoc */ isEmpty() {
        return false;
    }
    /** @inheritDoc */ numChildren() {
        return 0;
    }
    /** @inheritDoc */ forEachChild(index, action) {
        return false;
    }
    val(exportFormat) {
        if (exportFormat && !this.getPriority().isEmpty()) return {
            ".value": this.getValue(),
            ".priority": this.getPriority().val()
        };
        else return this.getValue();
    }
    /** @inheritDoc */ hash() {
        if (this.lazyHash_ === null) {
            let toHash = "";
            if (!this.priorityNode_.isEmpty()) toHash += "priority:" + $494ac95ccfb2d9dd$var$priorityHashText(this.priorityNode_.val()) + ":";
            const type = typeof this.value_;
            toHash += type + ":";
            if (type === "number") toHash += $494ac95ccfb2d9dd$var$doubleToIEEE754String(this.value_);
            else toHash += this.value_;
            this.lazyHash_ = $494ac95ccfb2d9dd$var$sha1(toHash);
        }
        return this.lazyHash_;
    }
    /**
     * Returns the value of the leaf node.
     * @returns The value of the node.
     */ getValue() {
        return this.value_;
    }
    compareTo(other) {
        if (other === $494ac95ccfb2d9dd$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE) return 1;
        else if (other instanceof $494ac95ccfb2d9dd$var$LeafNode.__childrenNodeConstructor) return -1;
        else {
            (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(other.isLeafNode(), "Unknown node type");
            return this.compareToLeafNode_(other);
        }
    }
    /**
     * Comparison specifically for two leaf nodes
     */ compareToLeafNode_(otherLeaf) {
        const otherLeafType = typeof otherLeaf.value_;
        const thisLeafType = typeof this.value_;
        const otherIndex = $494ac95ccfb2d9dd$var$LeafNode.VALUE_TYPE_ORDER.indexOf(otherLeafType);
        const thisIndex = $494ac95ccfb2d9dd$var$LeafNode.VALUE_TYPE_ORDER.indexOf(thisLeafType);
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(otherIndex >= 0, "Unknown leaf type: " + otherLeafType);
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(thisIndex >= 0, "Unknown leaf type: " + thisLeafType);
        if (otherIndex === thisIndex) {
            // Same type, compare values
            if (thisLeafType === "object") // Deferred value nodes are all equal, but we should also never get to this point...
            return 0;
            else {
                // Note that this works because true > false, all others are number or string comparisons
                if (this.value_ < otherLeaf.value_) return -1;
                else if (this.value_ === otherLeaf.value_) return 0;
                else return 1;
            }
        } else return thisIndex - otherIndex;
    }
    withIndex() {
        return this;
    }
    isIndexed() {
        return true;
    }
    equals(other) {
        if (other === this) return true;
        else if (other.isLeafNode()) {
            const otherLeaf = other;
            return this.value_ === otherLeaf.value_ && this.priorityNode_.equals(otherLeaf.priorityNode_);
        } else return false;
    }
}
/**
 * The sort order for comparing leaf nodes of different types. If two leaf nodes have
 * the same type, the comparison falls back to their value
 */ $494ac95ccfb2d9dd$var$LeafNode.VALUE_TYPE_ORDER = [
    "object",
    "boolean",
    "number",
    "string"
];
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $494ac95ccfb2d9dd$var$nodeFromJSON$1;
let $494ac95ccfb2d9dd$var$MAX_NODE$1;
function $494ac95ccfb2d9dd$var$setNodeFromJSON(val) {
    $494ac95ccfb2d9dd$var$nodeFromJSON$1 = val;
}
function $494ac95ccfb2d9dd$var$setMaxNode(val) {
    $494ac95ccfb2d9dd$var$MAX_NODE$1 = val;
}
class $494ac95ccfb2d9dd$var$PriorityIndex extends $494ac95ccfb2d9dd$var$Index {
    compare(a, b) {
        const aPriority = a.node.getPriority();
        const bPriority = b.node.getPriority();
        const indexCmp = aPriority.compareTo(bPriority);
        if (indexCmp === 0) return $494ac95ccfb2d9dd$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    isDefinedOn(node) {
        return !node.getPriority().isEmpty();
    }
    indexedValueChanged(oldNode, newNode) {
        return !oldNode.getPriority().equals(newNode.getPriority());
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $494ac95ccfb2d9dd$var$NamedNode.MIN;
    }
    maxPost() {
        return new $494ac95ccfb2d9dd$var$NamedNode($494ac95ccfb2d9dd$var$MAX_NAME, new $494ac95ccfb2d9dd$var$LeafNode("[PRIORITY-POST]", $494ac95ccfb2d9dd$var$MAX_NODE$1));
    }
    makePost(indexValue, name) {
        const priorityNode = $494ac95ccfb2d9dd$var$nodeFromJSON$1(indexValue);
        return new $494ac95ccfb2d9dd$var$NamedNode(name, new $494ac95ccfb2d9dd$var$LeafNode("[PRIORITY-POST]", priorityNode));
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return ".priority";
    }
}
const $494ac95ccfb2d9dd$var$PRIORITY_INDEX = new $494ac95ccfb2d9dd$var$PriorityIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $494ac95ccfb2d9dd$var$LOG_2 = Math.log(2);
class $494ac95ccfb2d9dd$var$Base12Num {
    constructor(length){
        const logBase2 = (num)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            parseInt(Math.log(num) / $494ac95ccfb2d9dd$var$LOG_2, 10);
        const bitMask = (bits)=>parseInt(Array(bits + 1).join("1"), 2);
        this.count = logBase2(length + 1);
        this.current_ = this.count - 1;
        const mask = bitMask(this.count);
        this.bits_ = length + 1 & mask;
    }
    nextBitIsOne() {
        //noinspection JSBitwiseOperatorUsage
        const result = !(this.bits_ & 0x1 << this.current_);
        this.current_--;
        return result;
    }
}
/**
 * Takes a list of child nodes and constructs a SortedSet using the given comparison
 * function
 *
 * Uses the algorithm described in the paper linked here:
 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.46.1458
 *
 * @param childList - Unsorted list of children
 * @param cmp - The comparison method to be used
 * @param keyFn - An optional function to extract K from a node wrapper, if K's
 * type is not NamedNode
 * @param mapSortFn - An optional override for comparator used by the generated sorted map
 */ const $494ac95ccfb2d9dd$var$buildChildSet = function(childList, cmp, keyFn, mapSortFn) {
    childList.sort(cmp);
    const buildBalancedTree = function(low, high) {
        const length = high - low;
        let namedNode;
        let key;
        if (length === 0) return null;
        else if (length === 1) {
            namedNode = childList[low];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new $494ac95ccfb2d9dd$var$LLRBNode(key, namedNode.node, $494ac95ccfb2d9dd$var$LLRBNode.BLACK, null, null);
        } else {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const middle = parseInt(length / 2, 10) + low;
            const left = buildBalancedTree(low, middle);
            const right = buildBalancedTree(middle + 1, high);
            namedNode = childList[middle];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new $494ac95ccfb2d9dd$var$LLRBNode(key, namedNode.node, $494ac95ccfb2d9dd$var$LLRBNode.BLACK, left, right);
        }
    };
    const buildFrom12Array = function(base12) {
        let node = null;
        let root = null;
        let index = childList.length;
        const buildPennant = function(chunkSize, color) {
            const low = index - chunkSize;
            const high = index;
            index -= chunkSize;
            const childTree = buildBalancedTree(low + 1, high);
            const namedNode = childList[low];
            const key = keyFn ? keyFn(namedNode) : namedNode;
            attachPennant(new $494ac95ccfb2d9dd$var$LLRBNode(key, namedNode.node, color, null, childTree));
        };
        const attachPennant = function(pennant) {
            if (node) {
                node.left = pennant;
                node = pennant;
            } else {
                root = pennant;
                node = pennant;
            }
        };
        for(let i = 0; i < base12.count; ++i){
            const isOne = base12.nextBitIsOne();
            // The number of nodes taken in each slice is 2^(arr.length - (i + 1))
            const chunkSize = Math.pow(2, base12.count - (i + 1));
            if (isOne) buildPennant(chunkSize, $494ac95ccfb2d9dd$var$LLRBNode.BLACK);
            else {
                // current == 2
                buildPennant(chunkSize, $494ac95ccfb2d9dd$var$LLRBNode.BLACK);
                buildPennant(chunkSize, $494ac95ccfb2d9dd$var$LLRBNode.RED);
            }
        }
        return root;
    };
    const base12 = new $494ac95ccfb2d9dd$var$Base12Num(childList.length);
    const root = buildFrom12Array(base12);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new $494ac95ccfb2d9dd$var$SortedMap(mapSortFn || cmp, root);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $494ac95ccfb2d9dd$var$_defaultIndexMap;
const $494ac95ccfb2d9dd$var$fallbackObject = {};
class $494ac95ccfb2d9dd$var$IndexMap {
    constructor(indexes_, indexSet_){
        this.indexes_ = indexes_;
        this.indexSet_ = indexSet_;
    }
    /**
     * The default IndexMap for nodes without a priority
     */ static get Default() {
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)($494ac95ccfb2d9dd$var$fallbackObject && $494ac95ccfb2d9dd$var$PRIORITY_INDEX, "ChildrenNode.ts has not been loaded");
        $494ac95ccfb2d9dd$var$_defaultIndexMap = $494ac95ccfb2d9dd$var$_defaultIndexMap || new $494ac95ccfb2d9dd$var$IndexMap({
            ".priority": $494ac95ccfb2d9dd$var$fallbackObject
        }, {
            ".priority": $494ac95ccfb2d9dd$var$PRIORITY_INDEX
        });
        return $494ac95ccfb2d9dd$var$_defaultIndexMap;
    }
    get(indexKey) {
        const sortedMap = (0, $fc59d49e1bb53b6a$export$e51ae4db7b428f67)(this.indexes_, indexKey);
        if (!sortedMap) throw new Error("No index defined for " + indexKey);
        if (sortedMap instanceof $494ac95ccfb2d9dd$var$SortedMap) return sortedMap;
        else // The index exists, but it falls back to just name comparison. Return null so that the calling code uses the
        // regular child map
        return null;
    }
    hasIndex(indexDefinition) {
        return (0, $fc59d49e1bb53b6a$export$2344b14b097df817)(this.indexSet_, indexDefinition.toString());
    }
    addIndex(indexDefinition, existingChildren) {
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(indexDefinition !== $494ac95ccfb2d9dd$var$KEY_INDEX, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
        const childList = [];
        let sawIndexedValue = false;
        const iter = existingChildren.getIterator($494ac95ccfb2d9dd$var$NamedNode.Wrap);
        let next = iter.getNext();
        while(next){
            sawIndexedValue = sawIndexedValue || indexDefinition.isDefinedOn(next.node);
            childList.push(next);
            next = iter.getNext();
        }
        let newIndex;
        if (sawIndexedValue) newIndex = $494ac95ccfb2d9dd$var$buildChildSet(childList, indexDefinition.getCompare());
        else newIndex = $494ac95ccfb2d9dd$var$fallbackObject;
        const indexName = indexDefinition.toString();
        const newIndexSet = Object.assign({}, this.indexSet_);
        newIndexSet[indexName] = indexDefinition;
        const newIndexes = Object.assign({}, this.indexes_);
        newIndexes[indexName] = newIndex;
        return new $494ac95ccfb2d9dd$var$IndexMap(newIndexes, newIndexSet);
    }
    /**
     * Ensure that this node is properly tracked in any indexes that we're maintaining
     */ addToIndexes(namedNode, existingChildren) {
        const newIndexes = (0, $fc59d49e1bb53b6a$export$871de8747c9eaa88)(this.indexes_, (indexedChildren, indexName)=>{
            const index = (0, $fc59d49e1bb53b6a$export$e51ae4db7b428f67)(this.indexSet_, indexName);
            (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(index, "Missing index implementation for " + indexName);
            if (indexedChildren === $494ac95ccfb2d9dd$var$fallbackObject) {
                // Check to see if we need to index everything
                if (index.isDefinedOn(namedNode.node)) {
                    // We need to build this index
                    const childList = [];
                    const iter = existingChildren.getIterator($494ac95ccfb2d9dd$var$NamedNode.Wrap);
                    let next = iter.getNext();
                    while(next){
                        if (next.name !== namedNode.name) childList.push(next);
                        next = iter.getNext();
                    }
                    childList.push(namedNode);
                    return $494ac95ccfb2d9dd$var$buildChildSet(childList, index.getCompare());
                } else // No change, this remains a fallback
                return $494ac95ccfb2d9dd$var$fallbackObject;
            } else {
                const existingSnap = existingChildren.get(namedNode.name);
                let newChildren = indexedChildren;
                if (existingSnap) newChildren = newChildren.remove(new $494ac95ccfb2d9dd$var$NamedNode(namedNode.name, existingSnap));
                return newChildren.insert(namedNode, namedNode.node);
            }
        });
        return new $494ac95ccfb2d9dd$var$IndexMap(newIndexes, this.indexSet_);
    }
    /**
     * Create a new IndexMap instance with the given value removed
     */ removeFromIndexes(namedNode, existingChildren) {
        const newIndexes = (0, $fc59d49e1bb53b6a$export$871de8747c9eaa88)(this.indexes_, (indexedChildren)=>{
            if (indexedChildren === $494ac95ccfb2d9dd$var$fallbackObject) // This is the fallback. Just return it, nothing to do in this case
            return indexedChildren;
            else {
                const existingSnap = existingChildren.get(namedNode.name);
                if (existingSnap) return indexedChildren.remove(new $494ac95ccfb2d9dd$var$NamedNode(namedNode.name, existingSnap));
                else // No record of this child
                return indexedChildren;
            }
        });
        return new $494ac95ccfb2d9dd$var$IndexMap(newIndexes, this.indexSet_);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO: For memory savings, don't store priorityNode_ if it's empty.
let $494ac95ccfb2d9dd$var$EMPTY_NODE;
/**
 * ChildrenNode is a class for storing internal nodes in a DataSnapshot
 * (i.e. nodes with children).  It implements Node and stores the
 * list of children in the children property, sorted by child name.
 */ class $494ac95ccfb2d9dd$var$ChildrenNode {
    /**
     * @param children_ - List of children of this node..
     * @param priorityNode_ - The priority of this node (as a snapshot node).
     */ constructor(children_, priorityNode_, indexMap_){
        this.children_ = children_;
        this.priorityNode_ = priorityNode_;
        this.indexMap_ = indexMap_;
        this.lazyHash_ = null;
        /**
         * Note: The only reason we allow null priority is for EMPTY_NODE, since we can't use
         * EMPTY_NODE as the priority of EMPTY_NODE.  We might want to consider making EMPTY_NODE its own
         * class instead of an empty ChildrenNode.
         */ if (this.priorityNode_) $494ac95ccfb2d9dd$var$validatePriorityNode(this.priorityNode_);
        if (this.children_.isEmpty()) (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(!this.priorityNode_ || this.priorityNode_.isEmpty(), "An empty node cannot have a priority");
    }
    static get EMPTY_NODE() {
        return $494ac95ccfb2d9dd$var$EMPTY_NODE || ($494ac95ccfb2d9dd$var$EMPTY_NODE = new $494ac95ccfb2d9dd$var$ChildrenNode(new $494ac95ccfb2d9dd$var$SortedMap($494ac95ccfb2d9dd$var$NAME_COMPARATOR), null, $494ac95ccfb2d9dd$var$IndexMap.Default));
    }
    /** @inheritDoc */ isLeafNode() {
        return false;
    }
    /** @inheritDoc */ getPriority() {
        return this.priorityNode_ || $494ac95ccfb2d9dd$var$EMPTY_NODE;
    }
    /** @inheritDoc */ updatePriority(newPriorityNode) {
        if (this.children_.isEmpty()) // Don't allow priorities on empty nodes
        return this;
        else return new $494ac95ccfb2d9dd$var$ChildrenNode(this.children_, newPriorityNode, this.indexMap_);
    }
    /** @inheritDoc */ getImmediateChild(childName) {
        // Hack to treat priority as a regular child
        if (childName === ".priority") return this.getPriority();
        else {
            const child = this.children_.get(childName);
            return child === null ? $494ac95ccfb2d9dd$var$EMPTY_NODE : child;
        }
    }
    /** @inheritDoc */ getChild(path) {
        const front = $494ac95ccfb2d9dd$var$pathGetFront(path);
        if (front === null) return this;
        return this.getImmediateChild(front).getChild($494ac95ccfb2d9dd$var$pathPopFront(path));
    }
    /** @inheritDoc */ hasChild(childName) {
        return this.children_.get(childName) !== null;
    }
    /** @inheritDoc */ updateImmediateChild(childName, newChildNode) {
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(newChildNode, "We should always be passing snapshot nodes");
        if (childName === ".priority") return this.updatePriority(newChildNode);
        else {
            const namedNode = new $494ac95ccfb2d9dd$var$NamedNode(childName, newChildNode);
            let newChildren, newIndexMap;
            if (newChildNode.isEmpty()) {
                newChildren = this.children_.remove(childName);
                newIndexMap = this.indexMap_.removeFromIndexes(namedNode, this.children_);
            } else {
                newChildren = this.children_.insert(childName, newChildNode);
                newIndexMap = this.indexMap_.addToIndexes(namedNode, this.children_);
            }
            const newPriority = newChildren.isEmpty() ? $494ac95ccfb2d9dd$var$EMPTY_NODE : this.priorityNode_;
            return new $494ac95ccfb2d9dd$var$ChildrenNode(newChildren, newPriority, newIndexMap);
        }
    }
    /** @inheritDoc */ updateChild(path, newChildNode) {
        const front = $494ac95ccfb2d9dd$var$pathGetFront(path);
        if (front === null) return newChildNode;
        else {
            (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)($494ac95ccfb2d9dd$var$pathGetFront(path) !== ".priority" || $494ac95ccfb2d9dd$var$pathGetLength(path) === 1, ".priority must be the last token in a path");
            const newImmediateChild = this.getImmediateChild(front).updateChild($494ac95ccfb2d9dd$var$pathPopFront(path), newChildNode);
            return this.updateImmediateChild(front, newImmediateChild);
        }
    }
    /** @inheritDoc */ isEmpty() {
        return this.children_.isEmpty();
    }
    /** @inheritDoc */ numChildren() {
        return this.children_.count();
    }
    /** @inheritDoc */ val(exportFormat) {
        if (this.isEmpty()) return null;
        const obj = {};
        let numKeys = 0, maxKey = 0, allIntegerKeys = true;
        this.forEachChild($494ac95ccfb2d9dd$var$PRIORITY_INDEX, (key, childNode)=>{
            obj[key] = childNode.val(exportFormat);
            numKeys++;
            if (allIntegerKeys && $494ac95ccfb2d9dd$var$ChildrenNode.INTEGER_REGEXP_.test(key)) maxKey = Math.max(maxKey, Number(key));
            else allIntegerKeys = false;
        });
        if (!exportFormat && allIntegerKeys && maxKey < 2 * numKeys) {
            // convert to array.
            const array = [];
            // eslint-disable-next-line guard-for-in
            for(const key in obj)array[key] = obj[key];
            return array;
        } else {
            if (exportFormat && !this.getPriority().isEmpty()) obj[".priority"] = this.getPriority().val();
            return obj;
        }
    }
    /** @inheritDoc */ hash() {
        if (this.lazyHash_ === null) {
            let toHash = "";
            if (!this.getPriority().isEmpty()) toHash += "priority:" + $494ac95ccfb2d9dd$var$priorityHashText(this.getPriority().val()) + ":";
            this.forEachChild($494ac95ccfb2d9dd$var$PRIORITY_INDEX, (key, childNode)=>{
                const childHash = childNode.hash();
                if (childHash !== "") toHash += ":" + key + ":" + childHash;
            });
            this.lazyHash_ = toHash === "" ? "" : $494ac95ccfb2d9dd$var$sha1(toHash);
        }
        return this.lazyHash_;
    }
    /** @inheritDoc */ getPredecessorChildName(childName, childNode, index) {
        const idx = this.resolveIndex_(index);
        if (idx) {
            const predecessor = idx.getPredecessorKey(new $494ac95ccfb2d9dd$var$NamedNode(childName, childNode));
            return predecessor ? predecessor.name : null;
        } else return this.children_.getPredecessorKey(childName);
    }
    getFirstChildName(indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            const minKey = idx.minKey();
            return minKey && minKey.name;
        } else return this.children_.minKey();
    }
    getFirstChild(indexDefinition) {
        const minKey = this.getFirstChildName(indexDefinition);
        if (minKey) return new $494ac95ccfb2d9dd$var$NamedNode(minKey, this.children_.get(minKey));
        else return null;
    }
    /**
     * Given an index, return the key name of the largest value we have, according to that index
     */ getLastChildName(indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            const maxKey = idx.maxKey();
            return maxKey && maxKey.name;
        } else return this.children_.maxKey();
    }
    getLastChild(indexDefinition) {
        const maxKey = this.getLastChildName(indexDefinition);
        if (maxKey) return new $494ac95ccfb2d9dd$var$NamedNode(maxKey, this.children_.get(maxKey));
        else return null;
    }
    forEachChild(index, action) {
        const idx = this.resolveIndex_(index);
        if (idx) return idx.inorderTraversal((wrappedNode)=>{
            return action(wrappedNode.name, wrappedNode.node);
        });
        else return this.children_.inorderTraversal(action);
    }
    getIterator(indexDefinition) {
        return this.getIteratorFrom(indexDefinition.minPost(), indexDefinition);
    }
    getIteratorFrom(startPost, indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) return idx.getIteratorFrom(startPost, (key)=>key);
        else {
            const iterator = this.children_.getIteratorFrom(startPost.name, $494ac95ccfb2d9dd$var$NamedNode.Wrap);
            let next = iterator.peek();
            while(next != null && indexDefinition.compare(next, startPost) < 0){
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    }
    getReverseIterator(indexDefinition) {
        return this.getReverseIteratorFrom(indexDefinition.maxPost(), indexDefinition);
    }
    getReverseIteratorFrom(endPost, indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) return idx.getReverseIteratorFrom(endPost, (key)=>{
            return key;
        });
        else {
            const iterator = this.children_.getReverseIteratorFrom(endPost.name, $494ac95ccfb2d9dd$var$NamedNode.Wrap);
            let next = iterator.peek();
            while(next != null && indexDefinition.compare(next, endPost) > 0){
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    }
    compareTo(other) {
        if (this.isEmpty()) {
            if (other.isEmpty()) return 0;
            else return -1;
        } else if (other.isLeafNode() || other.isEmpty()) return 1;
        else if (other === $494ac95ccfb2d9dd$var$MAX_NODE) return -1;
        else // Must be another node with children.
        return 0;
    }
    withIndex(indexDefinition) {
        if (indexDefinition === $494ac95ccfb2d9dd$var$KEY_INDEX || this.indexMap_.hasIndex(indexDefinition)) return this;
        else {
            const newIndexMap = this.indexMap_.addIndex(indexDefinition, this.children_);
            return new $494ac95ccfb2d9dd$var$ChildrenNode(this.children_, this.priorityNode_, newIndexMap);
        }
    }
    isIndexed(index) {
        return index === $494ac95ccfb2d9dd$var$KEY_INDEX || this.indexMap_.hasIndex(index);
    }
    equals(other) {
        if (other === this) return true;
        else if (other.isLeafNode()) return false;
        else {
            const otherChildrenNode = other;
            if (!this.getPriority().equals(otherChildrenNode.getPriority())) return false;
            else if (this.children_.count() === otherChildrenNode.children_.count()) {
                const thisIter = this.getIterator($494ac95ccfb2d9dd$var$PRIORITY_INDEX);
                const otherIter = otherChildrenNode.getIterator($494ac95ccfb2d9dd$var$PRIORITY_INDEX);
                let thisCurrent = thisIter.getNext();
                let otherCurrent = otherIter.getNext();
                while(thisCurrent && otherCurrent){
                    if (thisCurrent.name !== otherCurrent.name || !thisCurrent.node.equals(otherCurrent.node)) return false;
                    thisCurrent = thisIter.getNext();
                    otherCurrent = otherIter.getNext();
                }
                return thisCurrent === null && otherCurrent === null;
            } else return false;
        }
    }
    /**
     * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
     * instead.
     *
     */ resolveIndex_(indexDefinition) {
        if (indexDefinition === $494ac95ccfb2d9dd$var$KEY_INDEX) return null;
        else return this.indexMap_.get(indexDefinition.toString());
    }
}
$494ac95ccfb2d9dd$var$ChildrenNode.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
class $494ac95ccfb2d9dd$var$MaxNode extends $494ac95ccfb2d9dd$var$ChildrenNode {
    constructor(){
        super(new $494ac95ccfb2d9dd$var$SortedMap($494ac95ccfb2d9dd$var$NAME_COMPARATOR), $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE, $494ac95ccfb2d9dd$var$IndexMap.Default);
    }
    compareTo(other) {
        if (other === this) return 0;
        else return 1;
    }
    equals(other) {
        // Not that we every compare it, but MAX_NODE is only ever equal to itself
        return other === this;
    }
    getPriority() {
        return this;
    }
    getImmediateChild(childName) {
        return $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE;
    }
    isEmpty() {
        return false;
    }
}
/**
 * Marker that will sort higher than any other snapshot.
 */ const $494ac95ccfb2d9dd$var$MAX_NODE = new $494ac95ccfb2d9dd$var$MaxNode();
Object.defineProperties($494ac95ccfb2d9dd$var$NamedNode, {
    MIN: {
        value: new $494ac95ccfb2d9dd$var$NamedNode($494ac95ccfb2d9dd$var$MIN_NAME, $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE)
    },
    MAX: {
        value: new $494ac95ccfb2d9dd$var$NamedNode($494ac95ccfb2d9dd$var$MAX_NAME, $494ac95ccfb2d9dd$var$MAX_NODE)
    }
});
/**
 * Reference Extensions
 */ $494ac95ccfb2d9dd$var$KeyIndex.__EMPTY_NODE = $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE;
$494ac95ccfb2d9dd$var$LeafNode.__childrenNodeConstructor = $494ac95ccfb2d9dd$var$ChildrenNode;
$494ac95ccfb2d9dd$var$setMaxNode$1($494ac95ccfb2d9dd$var$MAX_NODE);
$494ac95ccfb2d9dd$var$setMaxNode($494ac95ccfb2d9dd$var$MAX_NODE);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $494ac95ccfb2d9dd$var$USE_HINZE = true;
/**
 * Constructs a snapshot node representing the passed JSON and returns it.
 * @param json - JSON to create a node for.
 * @param priority - Optional priority to use.  This will be ignored if the
 * passed JSON contains a .priority property.
 */ function $494ac95ccfb2d9dd$var$nodeFromJSON(json, priority = null) {
    if (json === null) return $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE;
    if (typeof json === "object" && ".priority" in json) priority = json[".priority"];
    (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(priority === null || typeof priority === "string" || typeof priority === "number" || typeof priority === "object" && ".sv" in priority, "Invalid priority type found: " + typeof priority);
    if (typeof json === "object" && ".value" in json && json[".value"] !== null) json = json[".value"];
    // Valid leaf nodes include non-objects or server-value wrapper objects
    if (typeof json !== "object" || ".sv" in json) {
        const jsonLeaf = json;
        return new $494ac95ccfb2d9dd$var$LeafNode(jsonLeaf, $494ac95ccfb2d9dd$var$nodeFromJSON(priority));
    }
    if (!(json instanceof Array) && $494ac95ccfb2d9dd$var$USE_HINZE) {
        const children = [];
        let childrenHavePriority = false;
        const hinzeJsonObj = json;
        $494ac95ccfb2d9dd$var$each(hinzeJsonObj, (key, child)=>{
            if (key.substring(0, 1) !== ".") {
                // Ignore metadata nodes
                const childNode = $494ac95ccfb2d9dd$var$nodeFromJSON(child);
                if (!childNode.isEmpty()) {
                    childrenHavePriority = childrenHavePriority || !childNode.getPriority().isEmpty();
                    children.push(new $494ac95ccfb2d9dd$var$NamedNode(key, childNode));
                }
            }
        });
        if (children.length === 0) return $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE;
        const childSet = $494ac95ccfb2d9dd$var$buildChildSet(children, $494ac95ccfb2d9dd$var$NAME_ONLY_COMPARATOR, (namedNode)=>namedNode.name, $494ac95ccfb2d9dd$var$NAME_COMPARATOR);
        if (childrenHavePriority) {
            const sortedChildSet = $494ac95ccfb2d9dd$var$buildChildSet(children, $494ac95ccfb2d9dd$var$PRIORITY_INDEX.getCompare());
            return new $494ac95ccfb2d9dd$var$ChildrenNode(childSet, $494ac95ccfb2d9dd$var$nodeFromJSON(priority), new $494ac95ccfb2d9dd$var$IndexMap({
                ".priority": sortedChildSet
            }, {
                ".priority": $494ac95ccfb2d9dd$var$PRIORITY_INDEX
            }));
        } else return new $494ac95ccfb2d9dd$var$ChildrenNode(childSet, $494ac95ccfb2d9dd$var$nodeFromJSON(priority), $494ac95ccfb2d9dd$var$IndexMap.Default);
    } else {
        let node = $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE;
        $494ac95ccfb2d9dd$var$each(json, (key, childData)=>{
            if ((0, $fc59d49e1bb53b6a$export$2344b14b097df817)(json, key)) {
                if (key.substring(0, 1) !== ".") {
                    // ignore metadata nodes.
                    const childNode = $494ac95ccfb2d9dd$var$nodeFromJSON(childData);
                    if (childNode.isLeafNode() || !childNode.isEmpty()) node = node.updateImmediateChild(key, childNode);
                }
            }
        });
        return node.updatePriority($494ac95ccfb2d9dd$var$nodeFromJSON(priority));
    }
}
$494ac95ccfb2d9dd$var$setNodeFromJSON($494ac95ccfb2d9dd$var$nodeFromJSON);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $494ac95ccfb2d9dd$var$PathIndex extends $494ac95ccfb2d9dd$var$Index {
    constructor(indexPath_){
        super();
        this.indexPath_ = indexPath_;
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(!$494ac95ccfb2d9dd$var$pathIsEmpty(indexPath_) && $494ac95ccfb2d9dd$var$pathGetFront(indexPath_) !== ".priority", "Can't create PathIndex with empty path or .priority key");
    }
    extractChild(snap) {
        return snap.getChild(this.indexPath_);
    }
    isDefinedOn(node) {
        return !node.getChild(this.indexPath_).isEmpty();
    }
    compare(a, b) {
        const aChild = this.extractChild(a.node);
        const bChild = this.extractChild(b.node);
        const indexCmp = aChild.compareTo(bChild);
        if (indexCmp === 0) return $494ac95ccfb2d9dd$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    makePost(indexValue, name) {
        const valueNode = $494ac95ccfb2d9dd$var$nodeFromJSON(indexValue);
        const node = $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, valueNode);
        return new $494ac95ccfb2d9dd$var$NamedNode(name, node);
    }
    maxPost() {
        const node = $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, $494ac95ccfb2d9dd$var$MAX_NODE);
        return new $494ac95ccfb2d9dd$var$NamedNode($494ac95ccfb2d9dd$var$MAX_NAME, node);
    }
    toString() {
        return $494ac95ccfb2d9dd$var$pathSlice(this.indexPath_, 0).join("/");
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $494ac95ccfb2d9dd$var$ValueIndex extends $494ac95ccfb2d9dd$var$Index {
    compare(a, b) {
        const indexCmp = a.node.compareTo(b.node);
        if (indexCmp === 0) return $494ac95ccfb2d9dd$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    isDefinedOn(node) {
        return true;
    }
    indexedValueChanged(oldNode, newNode) {
        return !oldNode.equals(newNode);
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $494ac95ccfb2d9dd$var$NamedNode.MIN;
    }
    maxPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $494ac95ccfb2d9dd$var$NamedNode.MAX;
    }
    makePost(indexValue, name) {
        const valueNode = $494ac95ccfb2d9dd$var$nodeFromJSON(indexValue);
        return new $494ac95ccfb2d9dd$var$NamedNode(name, valueNode);
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return ".value";
    }
}
const $494ac95ccfb2d9dd$var$VALUE_INDEX = new $494ac95ccfb2d9dd$var$ValueIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $494ac95ccfb2d9dd$var$changeValue(snapshotNode) {
    return {
        type: "value" /* ChangeType.VALUE */ ,
        snapshotNode: snapshotNode
    };
}
function $494ac95ccfb2d9dd$var$changeChildAdded(childName, snapshotNode) {
    return {
        type: "child_added" /* ChangeType.CHILD_ADDED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
function $494ac95ccfb2d9dd$var$changeChildRemoved(childName, snapshotNode) {
    return {
        type: "child_removed" /* ChangeType.CHILD_REMOVED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
function $494ac95ccfb2d9dd$var$changeChildChanged(childName, snapshotNode, oldSnap) {
    return {
        type: "child_changed" /* ChangeType.CHILD_CHANGED */ ,
        snapshotNode: snapshotNode,
        childName: childName,
        oldSnap: oldSnap
    };
}
function $494ac95ccfb2d9dd$var$changeChildMoved(childName, snapshotNode) {
    return {
        type: "child_moved" /* ChangeType.CHILD_MOVED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Doesn't really filter nodes but applies an index to the node and keeps track of any changes
 */ class $494ac95ccfb2d9dd$var$IndexedFilter {
    constructor(index_){
        this.index_ = index_;
    }
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(snap.isIndexed(this.index_), "A node must be indexed if only a child is updated");
        const oldChild = snap.getImmediateChild(key);
        // Check if anything actually changed.
        if (oldChild.getChild(affectedPath).equals(newChild.getChild(affectedPath))) {
            // There's an edge case where a child can enter or leave the view because affectedPath was set to null.
            // In this case, affectedPath will appear null in both the old and new snapshots.  So we need
            // to avoid treating these cases as "nothing changed."
            if (oldChild.isEmpty() === newChild.isEmpty()) // Nothing changed.
            // This assert should be valid, but it's expensive (can dominate perf testing) so don't actually do it.
            //assert(oldChild.equals(newChild), 'Old and new snapshots should be equal.');
            return snap;
        }
        if (optChangeAccumulator != null) {
            if (newChild.isEmpty()) {
                if (snap.hasChild(key)) optChangeAccumulator.trackChildChange($494ac95ccfb2d9dd$var$changeChildRemoved(key, oldChild));
                else (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(snap.isLeafNode(), "A child remove without an old child only makes sense on a leaf node");
            } else if (oldChild.isEmpty()) optChangeAccumulator.trackChildChange($494ac95ccfb2d9dd$var$changeChildAdded(key, newChild));
            else optChangeAccumulator.trackChildChange($494ac95ccfb2d9dd$var$changeChildChanged(key, newChild, oldChild));
        }
        if (snap.isLeafNode() && newChild.isEmpty()) return snap;
        else // Make sure the node is indexed
        return snap.updateImmediateChild(key, newChild).withIndex(this.index_);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        if (optChangeAccumulator != null) {
            if (!oldSnap.isLeafNode()) oldSnap.forEachChild($494ac95ccfb2d9dd$var$PRIORITY_INDEX, (key, childNode)=>{
                if (!newSnap.hasChild(key)) optChangeAccumulator.trackChildChange($494ac95ccfb2d9dd$var$changeChildRemoved(key, childNode));
            });
            if (!newSnap.isLeafNode()) newSnap.forEachChild($494ac95ccfb2d9dd$var$PRIORITY_INDEX, (key, childNode)=>{
                if (oldSnap.hasChild(key)) {
                    const oldChild = oldSnap.getImmediateChild(key);
                    if (!oldChild.equals(childNode)) optChangeAccumulator.trackChildChange($494ac95ccfb2d9dd$var$changeChildChanged(key, childNode, oldChild));
                } else optChangeAccumulator.trackChildChange($494ac95ccfb2d9dd$var$changeChildAdded(key, childNode));
            });
        }
        return newSnap.withIndex(this.index_);
    }
    updatePriority(oldSnap, newPriority) {
        if (oldSnap.isEmpty()) return $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE;
        else return oldSnap.updatePriority(newPriority);
    }
    filtersNodes() {
        return false;
    }
    getIndexedFilter() {
        return this;
    }
    getIndex() {
        return this.index_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Filters nodes by range and uses an IndexFilter to track any changes after filtering the node
 */ class $494ac95ccfb2d9dd$var$RangedFilter {
    constructor(params){
        this.indexedFilter_ = new $494ac95ccfb2d9dd$var$IndexedFilter(params.getIndex());
        this.index_ = params.getIndex();
        this.startPost_ = $494ac95ccfb2d9dd$var$RangedFilter.getStartPost_(params);
        this.endPost_ = $494ac95ccfb2d9dd$var$RangedFilter.getEndPost_(params);
        this.startIsInclusive_ = !params.startAfterSet_;
        this.endIsInclusive_ = !params.endBeforeSet_;
    }
    getStartPost() {
        return this.startPost_;
    }
    getEndPost() {
        return this.endPost_;
    }
    matches(node) {
        const isWithinStart = this.startIsInclusive_ ? this.index_.compare(this.getStartPost(), node) <= 0 : this.index_.compare(this.getStartPost(), node) < 0;
        const isWithinEnd = this.endIsInclusive_ ? this.index_.compare(node, this.getEndPost()) <= 0 : this.index_.compare(node, this.getEndPost()) < 0;
        return isWithinStart && isWithinEnd;
    }
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.matches(new $494ac95ccfb2d9dd$var$NamedNode(key, newChild))) newChild = $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE;
        return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        if (newSnap.isLeafNode()) // Make sure we have a children node with the correct index, not a leaf node;
        newSnap = $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE;
        let filtered = newSnap.withIndex(this.index_);
        // Don't support priorities on queries
        filtered = filtered.updatePriority($494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE);
        const self = this;
        newSnap.forEachChild($494ac95ccfb2d9dd$var$PRIORITY_INDEX, (key, childNode)=>{
            if (!self.matches(new $494ac95ccfb2d9dd$var$NamedNode(key, childNode))) filtered = filtered.updateImmediateChild(key, $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE);
        });
        return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
    }
    updatePriority(oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    }
    filtersNodes() {
        return true;
    }
    getIndexedFilter() {
        return this.indexedFilter_;
    }
    getIndex() {
        return this.index_;
    }
    static getStartPost_(params) {
        if (params.hasStart()) {
            const startName = params.getIndexStartName();
            return params.getIndex().makePost(params.getIndexStartValue(), startName);
        } else return params.getIndex().minPost();
    }
    static getEndPost_(params) {
        if (params.hasEnd()) {
            const endName = params.getIndexEndName();
            return params.getIndex().makePost(params.getIndexEndValue(), endName);
        } else return params.getIndex().maxPost();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Applies a limit and a range to a node and uses RangedFilter to do the heavy lifting where possible
 */ class $494ac95ccfb2d9dd$var$LimitedFilter {
    constructor(params){
        this.withinDirectionalStart = (node)=>this.reverse_ ? this.withinEndPost(node) : this.withinStartPost(node);
        this.withinDirectionalEnd = (node)=>this.reverse_ ? this.withinStartPost(node) : this.withinEndPost(node);
        this.withinStartPost = (node)=>{
            const compareRes = this.index_.compare(this.rangedFilter_.getStartPost(), node);
            return this.startIsInclusive_ ? compareRes <= 0 : compareRes < 0;
        };
        this.withinEndPost = (node)=>{
            const compareRes = this.index_.compare(node, this.rangedFilter_.getEndPost());
            return this.endIsInclusive_ ? compareRes <= 0 : compareRes < 0;
        };
        this.rangedFilter_ = new $494ac95ccfb2d9dd$var$RangedFilter(params);
        this.index_ = params.getIndex();
        this.limit_ = params.getLimit();
        this.reverse_ = !params.isViewFromLeft();
        this.startIsInclusive_ = !params.startAfterSet_;
        this.endIsInclusive_ = !params.endBeforeSet_;
    }
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.rangedFilter_.matches(new $494ac95ccfb2d9dd$var$NamedNode(key, newChild))) newChild = $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE;
        if (snap.getImmediateChild(key).equals(newChild)) // No change
        return snap;
        else if (snap.numChildren() < this.limit_) return this.rangedFilter_.getIndexedFilter().updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
        else return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        let filtered;
        if (newSnap.isLeafNode() || newSnap.isEmpty()) // Make sure we have a children node with the correct index, not a leaf node;
        filtered = $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE.withIndex(this.index_);
        else if (this.limit_ * 2 < newSnap.numChildren() && newSnap.isIndexed(this.index_)) {
            // Easier to build up a snapshot, since what we're given has more than twice the elements we want
            filtered = $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE.withIndex(this.index_);
            // anchor to the startPost, endPost, or last element as appropriate
            let iterator;
            if (this.reverse_) iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
            else iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
            let count = 0;
            while(iterator.hasNext() && count < this.limit_){
                const next = iterator.getNext();
                if (!this.withinDirectionalStart(next)) continue;
                else if (!this.withinDirectionalEnd(next)) break;
                else {
                    filtered = filtered.updateImmediateChild(next.name, next.node);
                    count++;
                }
            }
        } else {
            // The snap contains less than twice the limit. Faster to delete from the snap than build up a new one
            filtered = newSnap.withIndex(this.index_);
            // Don't support priorities on queries
            filtered = filtered.updatePriority($494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE);
            let iterator;
            if (this.reverse_) iterator = filtered.getReverseIterator(this.index_);
            else iterator = filtered.getIterator(this.index_);
            let count = 0;
            while(iterator.hasNext()){
                const next = iterator.getNext();
                const inRange = count < this.limit_ && this.withinDirectionalStart(next) && this.withinDirectionalEnd(next);
                if (inRange) count++;
                else filtered = filtered.updateImmediateChild(next.name, $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE);
            }
        }
        return this.rangedFilter_.getIndexedFilter().updateFullNode(oldSnap, filtered, optChangeAccumulator);
    }
    updatePriority(oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    }
    filtersNodes() {
        return true;
    }
    getIndexedFilter() {
        return this.rangedFilter_.getIndexedFilter();
    }
    getIndex() {
        return this.index_;
    }
    fullLimitUpdateChild_(snap, childKey, childSnap, source, changeAccumulator) {
        // TODO: rename all cache stuff etc to general snap terminology
        let cmp;
        if (this.reverse_) {
            const indexCmp = this.index_.getCompare();
            cmp = (a, b)=>indexCmp(b, a);
        } else cmp = this.index_.getCompare();
        const oldEventCache = snap;
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(oldEventCache.numChildren() === this.limit_, "");
        const newChildNamedNode = new $494ac95ccfb2d9dd$var$NamedNode(childKey, childSnap);
        const windowBoundary = this.reverse_ ? oldEventCache.getFirstChild(this.index_) : oldEventCache.getLastChild(this.index_);
        const inRange = this.rangedFilter_.matches(newChildNamedNode);
        if (oldEventCache.hasChild(childKey)) {
            const oldChildSnap = oldEventCache.getImmediateChild(childKey);
            let nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
            while(nextChild != null && (nextChild.name === childKey || oldEventCache.hasChild(nextChild.name)))// There is a weird edge case where a node is updated as part of a merge in the write tree, but hasn't
            // been applied to the limited filter yet. Ignore this next child which will be updated later in
            // the limited filter...
            nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
            const compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
            const remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
            if (remainsInWindow) {
                if (changeAccumulator != null) changeAccumulator.trackChildChange($494ac95ccfb2d9dd$var$changeChildChanged(childKey, childSnap, oldChildSnap));
                return oldEventCache.updateImmediateChild(childKey, childSnap);
            } else {
                if (changeAccumulator != null) changeAccumulator.trackChildChange($494ac95ccfb2d9dd$var$changeChildRemoved(childKey, oldChildSnap));
                const newEventCache = oldEventCache.updateImmediateChild(childKey, $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE);
                const nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
                if (nextChildInRange) {
                    if (changeAccumulator != null) changeAccumulator.trackChildChange($494ac95ccfb2d9dd$var$changeChildAdded(nextChild.name, nextChild.node));
                    return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
                } else return newEventCache;
            }
        } else if (childSnap.isEmpty()) // we're deleting a node, but it was not in the window, so ignore it
        return snap;
        else if (inRange) {
            if (cmp(windowBoundary, newChildNamedNode) >= 0) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange($494ac95ccfb2d9dd$var$changeChildRemoved(windowBoundary.name, windowBoundary.node));
                    changeAccumulator.trackChildChange($494ac95ccfb2d9dd$var$changeChildAdded(childKey, childSnap));
                }
                return oldEventCache.updateImmediateChild(childKey, childSnap).updateImmediateChild(windowBoundary.name, $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE);
            } else return snap;
        } else return snap;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class is an immutable-from-the-public-api struct containing a set of query parameters defining a
 * range to be returned for a particular location. It is assumed that validation of parameters is done at the
 * user-facing API level, so it is not done here.
 *
 * @internal
 */ class $494ac95ccfb2d9dd$export$7ba287e361c94330 {
    constructor(){
        this.limitSet_ = false;
        this.startSet_ = false;
        this.startNameSet_ = false;
        this.startAfterSet_ = false; // can only be true if startSet_ is true
        this.endSet_ = false;
        this.endNameSet_ = false;
        this.endBeforeSet_ = false; // can only be true if endSet_ is true
        this.limit_ = 0;
        this.viewFrom_ = "";
        this.indexStartValue_ = null;
        this.indexStartName_ = "";
        this.indexEndValue_ = null;
        this.indexEndName_ = "";
        this.index_ = $494ac95ccfb2d9dd$var$PRIORITY_INDEX;
    }
    hasStart() {
        return this.startSet_;
    }
    /**
     * @returns True if it would return from left.
     */ isViewFromLeft() {
        if (this.viewFrom_ === "") // limit(), rather than limitToFirst or limitToLast was called.
        // This means that only one of startSet_ and endSet_ is true. Use them
        // to calculate which side of the view to anchor to. If neither is set,
        // anchor to the end.
        return this.startSet_;
        else return this.viewFrom_ === "l" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT */ ;
    }
    /**
     * Only valid to call if hasStart() returns true
     */ getIndexStartValue() {
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(this.startSet_, "Only valid if start has been set");
        return this.indexStartValue_;
    }
    /**
     * Only valid to call if hasStart() returns true.
     * Returns the starting key name for the range defined by these query parameters
     */ getIndexStartName() {
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(this.startSet_, "Only valid if start has been set");
        if (this.startNameSet_) return this.indexStartName_;
        else return $494ac95ccfb2d9dd$var$MIN_NAME;
    }
    hasEnd() {
        return this.endSet_;
    }
    /**
     * Only valid to call if hasEnd() returns true.
     */ getIndexEndValue() {
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(this.endSet_, "Only valid if end has been set");
        return this.indexEndValue_;
    }
    /**
     * Only valid to call if hasEnd() returns true.
     * Returns the end key name for the range defined by these query parameters
     */ getIndexEndName() {
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(this.endSet_, "Only valid if end has been set");
        if (this.endNameSet_) return this.indexEndName_;
        else return $494ac95ccfb2d9dd$var$MAX_NAME;
    }
    hasLimit() {
        return this.limitSet_;
    }
    /**
     * @returns True if a limit has been set and it has been explicitly anchored
     */ hasAnchoredLimit() {
        return this.limitSet_ && this.viewFrom_ !== "";
    }
    /**
     * Only valid to call if hasLimit() returns true
     */ getLimit() {
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(this.limitSet_, "Only valid if limit has been set");
        return this.limit_;
    }
    getIndex() {
        return this.index_;
    }
    loadsAllData() {
        return !(this.startSet_ || this.endSet_ || this.limitSet_);
    }
    isDefault() {
        return this.loadsAllData() && this.index_ === $494ac95ccfb2d9dd$var$PRIORITY_INDEX;
    }
    copy() {
        const copy = new $494ac95ccfb2d9dd$export$7ba287e361c94330();
        copy.limitSet_ = this.limitSet_;
        copy.limit_ = this.limit_;
        copy.startSet_ = this.startSet_;
        copy.startAfterSet_ = this.startAfterSet_;
        copy.indexStartValue_ = this.indexStartValue_;
        copy.startNameSet_ = this.startNameSet_;
        copy.indexStartName_ = this.indexStartName_;
        copy.endSet_ = this.endSet_;
        copy.endBeforeSet_ = this.endBeforeSet_;
        copy.indexEndValue_ = this.indexEndValue_;
        copy.endNameSet_ = this.endNameSet_;
        copy.indexEndName_ = this.indexEndName_;
        copy.index_ = this.index_;
        copy.viewFrom_ = this.viewFrom_;
        return copy;
    }
}
function $494ac95ccfb2d9dd$var$queryParamsGetNodeFilter(queryParams) {
    if (queryParams.loadsAllData()) return new $494ac95ccfb2d9dd$var$IndexedFilter(queryParams.getIndex());
    else if (queryParams.hasLimit()) return new $494ac95ccfb2d9dd$var$LimitedFilter(queryParams);
    else return new $494ac95ccfb2d9dd$var$RangedFilter(queryParams);
}
function $494ac95ccfb2d9dd$var$queryParamsLimitToFirst(queryParams, newLimit) {
    const newParams = queryParams.copy();
    newParams.limitSet_ = true;
    newParams.limit_ = newLimit;
    newParams.viewFrom_ = "l" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT */ ;
    return newParams;
}
function $494ac95ccfb2d9dd$var$queryParamsLimitToLast(queryParams, newLimit) {
    const newParams = queryParams.copy();
    newParams.limitSet_ = true;
    newParams.limit_ = newLimit;
    newParams.viewFrom_ = "r" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT */ ;
    return newParams;
}
function $494ac95ccfb2d9dd$var$queryParamsStartAt(queryParams, indexValue, key) {
    const newParams = queryParams.copy();
    newParams.startSet_ = true;
    if (indexValue === undefined) indexValue = null;
    newParams.indexStartValue_ = indexValue;
    if (key != null) {
        newParams.startNameSet_ = true;
        newParams.indexStartName_ = key;
    } else {
        newParams.startNameSet_ = false;
        newParams.indexStartName_ = "";
    }
    return newParams;
}
function $494ac95ccfb2d9dd$var$queryParamsStartAfter(queryParams, indexValue, key) {
    let params;
    if (queryParams.index_ === $494ac95ccfb2d9dd$var$KEY_INDEX || !!key) params = $494ac95ccfb2d9dd$var$queryParamsStartAt(queryParams, indexValue, key);
    else params = $494ac95ccfb2d9dd$var$queryParamsStartAt(queryParams, indexValue, $494ac95ccfb2d9dd$var$MAX_NAME);
    params.startAfterSet_ = true;
    return params;
}
function $494ac95ccfb2d9dd$var$queryParamsEndAt(queryParams, indexValue, key) {
    const newParams = queryParams.copy();
    newParams.endSet_ = true;
    if (indexValue === undefined) indexValue = null;
    newParams.indexEndValue_ = indexValue;
    if (key !== undefined) {
        newParams.endNameSet_ = true;
        newParams.indexEndName_ = key;
    } else {
        newParams.endNameSet_ = false;
        newParams.indexEndName_ = "";
    }
    return newParams;
}
function $494ac95ccfb2d9dd$var$queryParamsEndBefore(queryParams, indexValue, key) {
    let params;
    if (queryParams.index_ === $494ac95ccfb2d9dd$var$KEY_INDEX || !!key) params = $494ac95ccfb2d9dd$var$queryParamsEndAt(queryParams, indexValue, key);
    else params = $494ac95ccfb2d9dd$var$queryParamsEndAt(queryParams, indexValue, $494ac95ccfb2d9dd$var$MIN_NAME);
    params.endBeforeSet_ = true;
    return params;
}
function $494ac95ccfb2d9dd$var$queryParamsOrderBy(queryParams, index) {
    const newParams = queryParams.copy();
    newParams.index_ = index;
    return newParams;
}
/**
 * Returns a set of REST query string parameters representing this query.
 *
 * @returns query string parameters
 */ function $494ac95ccfb2d9dd$var$queryParamsToRestQueryStringParameters(queryParams) {
    const qs = {};
    if (queryParams.isDefault()) return qs;
    let orderBy;
    if (queryParams.index_ === $494ac95ccfb2d9dd$var$PRIORITY_INDEX) orderBy = "$priority" /* REST_QUERY_CONSTANTS.PRIORITY_INDEX */ ;
    else if (queryParams.index_ === $494ac95ccfb2d9dd$var$VALUE_INDEX) orderBy = "$value" /* REST_QUERY_CONSTANTS.VALUE_INDEX */ ;
    else if (queryParams.index_ === $494ac95ccfb2d9dd$var$KEY_INDEX) orderBy = "$key" /* REST_QUERY_CONSTANTS.KEY_INDEX */ ;
    else {
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(queryParams.index_ instanceof $494ac95ccfb2d9dd$var$PathIndex, "Unrecognized index type!");
        orderBy = queryParams.index_.toString();
    }
    qs["orderBy" /* REST_QUERY_CONSTANTS.ORDER_BY */ ] = (0, $fc59d49e1bb53b6a$export$fac44ee5b035f737)(orderBy);
    if (queryParams.startSet_) {
        const startParam = queryParams.startAfterSet_ ? "startAfter" /* REST_QUERY_CONSTANTS.START_AFTER */  : "startAt" /* REST_QUERY_CONSTANTS.START_AT */ ;
        qs[startParam] = (0, $fc59d49e1bb53b6a$export$fac44ee5b035f737)(queryParams.indexStartValue_);
        if (queryParams.startNameSet_) qs[startParam] += "," + (0, $fc59d49e1bb53b6a$export$fac44ee5b035f737)(queryParams.indexStartName_);
    }
    if (queryParams.endSet_) {
        const endParam = queryParams.endBeforeSet_ ? "endBefore" /* REST_QUERY_CONSTANTS.END_BEFORE */  : "endAt" /* REST_QUERY_CONSTANTS.END_AT */ ;
        qs[endParam] = (0, $fc59d49e1bb53b6a$export$fac44ee5b035f737)(queryParams.indexEndValue_);
        if (queryParams.endNameSet_) qs[endParam] += "," + (0, $fc59d49e1bb53b6a$export$fac44ee5b035f737)(queryParams.indexEndName_);
    }
    if (queryParams.limitSet_) {
        if (queryParams.isViewFromLeft()) qs["limitToFirst" /* REST_QUERY_CONSTANTS.LIMIT_TO_FIRST */ ] = queryParams.limit_;
        else qs["limitToLast" /* REST_QUERY_CONSTANTS.LIMIT_TO_LAST */ ] = queryParams.limit_;
    }
    return qs;
}
function $494ac95ccfb2d9dd$var$queryParamsGetQueryObject(queryParams) {
    const obj = {};
    if (queryParams.startSet_) {
        obj["sp" /* WIRE_PROTOCOL_CONSTANTS.INDEX_START_VALUE */ ] = queryParams.indexStartValue_;
        if (queryParams.startNameSet_) obj["sn" /* WIRE_PROTOCOL_CONSTANTS.INDEX_START_NAME */ ] = queryParams.indexStartName_;
        obj["sin" /* WIRE_PROTOCOL_CONSTANTS.INDEX_START_IS_INCLUSIVE */ ] = !queryParams.startAfterSet_;
    }
    if (queryParams.endSet_) {
        obj["ep" /* WIRE_PROTOCOL_CONSTANTS.INDEX_END_VALUE */ ] = queryParams.indexEndValue_;
        if (queryParams.endNameSet_) obj["en" /* WIRE_PROTOCOL_CONSTANTS.INDEX_END_NAME */ ] = queryParams.indexEndName_;
        obj["ein" /* WIRE_PROTOCOL_CONSTANTS.INDEX_END_IS_INCLUSIVE */ ] = !queryParams.endBeforeSet_;
    }
    if (queryParams.limitSet_) {
        obj["l" /* WIRE_PROTOCOL_CONSTANTS.LIMIT */ ] = queryParams.limit_;
        let viewFrom = queryParams.viewFrom_;
        if (viewFrom === "") {
            if (queryParams.isViewFromLeft()) viewFrom = "l" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT */ ;
            else viewFrom = "r" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT */ ;
        }
        obj["vf" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM */ ] = viewFrom;
    }
    // For now, priority index is the default, so we only specify if it's some other index
    if (queryParams.index_ !== $494ac95ccfb2d9dd$var$PRIORITY_INDEX) obj["i" /* WIRE_PROTOCOL_CONSTANTS.INDEX */ ] = queryParams.index_.toString();
    return obj;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An implementation of ServerActions that communicates with the server via REST requests.
 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
 * persistent connection (using WebSockets or long-polling)
 */ class $494ac95ccfb2d9dd$var$ReadonlyRestClient extends $494ac95ccfb2d9dd$var$ServerActions {
    /**
     * @param repoInfo_ - Data about the namespace we are connecting to
     * @param onDataUpdate_ - A callback for new data from the server
     */ constructor(repoInfo_, onDataUpdate_, authTokenProvider_, appCheckTokenProvider_){
        super();
        this.repoInfo_ = repoInfo_;
        this.onDataUpdate_ = onDataUpdate_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckTokenProvider_ = appCheckTokenProvider_;
        /** @private {function(...[*])} */ this.log_ = $494ac95ccfb2d9dd$var$logWrapper("p:rest:");
        /**
         * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
         * that's been removed. :-/
         */ this.listens_ = {};
    }
    reportStats(stats) {
        throw new Error("Method not implemented.");
    }
    static getListenId_(query, tag) {
        if (tag !== undefined) return "tag$" + tag;
        else {
            (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(query._queryParams.isDefault(), "should have a tag if it's not a default query.");
            return query._path.toString();
        }
    }
    /** @inheritDoc */ listen(query, currentHashFn, tag, onComplete) {
        const pathString = query._path.toString();
        this.log_("Listen called for " + pathString + " " + query._queryIdentifier);
        // Mark this listener so we can tell if it's removed.
        const listenId = $494ac95ccfb2d9dd$var$ReadonlyRestClient.getListenId_(query, tag);
        const thisListen = {};
        this.listens_[listenId] = thisListen;
        const queryStringParameters = $494ac95ccfb2d9dd$var$queryParamsToRestQueryStringParameters(query._queryParams);
        this.restRequest_(pathString + ".json", queryStringParameters, (error, result)=>{
            let data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) this.onDataUpdate_(pathString, data, /*isMerge=*/ false, tag);
            if ((0, $fc59d49e1bb53b6a$export$e51ae4db7b428f67)(this.listens_, listenId) === thisListen) {
                let status;
                if (!error) status = "ok";
                else if (error === 401) status = "permission_denied";
                else status = "rest_error:" + error;
                onComplete(status, null);
            }
        });
    }
    /** @inheritDoc */ unlisten(query, tag) {
        const listenId = $494ac95ccfb2d9dd$var$ReadonlyRestClient.getListenId_(query, tag);
        delete this.listens_[listenId];
    }
    get(query) {
        const queryStringParameters = $494ac95ccfb2d9dd$var$queryParamsToRestQueryStringParameters(query._queryParams);
        const pathString = query._path.toString();
        const deferred = new (0, $fc59d49e1bb53b6a$export$85f6557964517f1a)();
        this.restRequest_(pathString + ".json", queryStringParameters, (error, result)=>{
            let data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) {
                this.onDataUpdate_(pathString, data, /*isMerge=*/ false, /*tag=*/ null);
                deferred.resolve(data);
            } else deferred.reject(new Error(data));
        });
        return deferred.promise;
    }
    /** @inheritDoc */ refreshAuthToken(token) {
    // no-op since we just always call getToken.
    }
    /**
     * Performs a REST request to the given path, with the provided query string parameters,
     * and any auth credentials we have.
     */ restRequest_(pathString, queryStringParameters = {}, callback) {
        queryStringParameters["format"] = "export";
        return Promise.all([
            this.authTokenProvider_.getToken(/*forceRefresh=*/ false),
            this.appCheckTokenProvider_.getToken(/*forceRefresh=*/ false)
        ]).then(([authToken, appCheckToken])=>{
            if (authToken && authToken.accessToken) queryStringParameters["auth"] = authToken.accessToken;
            if (appCheckToken && appCheckToken.token) queryStringParameters["ac"] = appCheckToken.token;
            const url = (this.repoInfo_.secure ? "https://" : "http://") + this.repoInfo_.host + pathString + "?" + "ns=" + this.repoInfo_.namespace + (0, $fc59d49e1bb53b6a$export$ac4103b836844853)(queryStringParameters);
            this.log_("Sending REST request for " + url);
            const xhr = new XMLHttpRequest();
            xhr.onreadystatechange = ()=>{
                if (callback && xhr.readyState === 4) {
                    this.log_("REST Response for " + url + " received. status:", xhr.status, "response:", xhr.responseText);
                    let res = null;
                    if (xhr.status >= 200 && xhr.status < 300) {
                        try {
                            res = (0, $fc59d49e1bb53b6a$export$c5a53ce6a17cf18d)(xhr.responseText);
                        } catch (e) {
                            $494ac95ccfb2d9dd$var$warn("Failed to parse JSON response for " + url + ": " + xhr.responseText);
                        }
                        callback(null, res);
                    } else {
                        // 401 and 404 are expected.
                        if (xhr.status !== 401 && xhr.status !== 404) $494ac95ccfb2d9dd$var$warn("Got unsuccessful REST response for " + url + " Status: " + xhr.status);
                        callback(xhr.status);
                    }
                    callback = null;
                }
            };
            xhr.open("GET", url, /*asynchronous=*/ true);
            xhr.send();
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
 */ class $494ac95ccfb2d9dd$var$SnapshotHolder {
    constructor(){
        this.rootNode_ = $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE;
    }
    getNode(path) {
        return this.rootNode_.getChild(path);
    }
    updateSnapshot(path, newSnapshotNode) {
        this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $494ac95ccfb2d9dd$var$newSparseSnapshotTree() {
    return {
        value: null,
        children: new Map()
    };
}
/**
 * Stores the given node at the specified path. If there is already a node
 * at a shallower path, it merges the new data into that snapshot node.
 *
 * @param path - Path to look up snapshot for.
 * @param data - The new data, or null.
 */ function $494ac95ccfb2d9dd$var$sparseSnapshotTreeRemember(sparseSnapshotTree, path, data) {
    if ($494ac95ccfb2d9dd$var$pathIsEmpty(path)) {
        sparseSnapshotTree.value = data;
        sparseSnapshotTree.children.clear();
    } else if (sparseSnapshotTree.value !== null) sparseSnapshotTree.value = sparseSnapshotTree.value.updateChild(path, data);
    else {
        const childKey = $494ac95ccfb2d9dd$var$pathGetFront(path);
        if (!sparseSnapshotTree.children.has(childKey)) sparseSnapshotTree.children.set(childKey, $494ac95ccfb2d9dd$var$newSparseSnapshotTree());
        const child = sparseSnapshotTree.children.get(childKey);
        path = $494ac95ccfb2d9dd$var$pathPopFront(path);
        $494ac95ccfb2d9dd$var$sparseSnapshotTreeRemember(child, path, data);
    }
}
/**
 * Purge the data at path from the cache.
 *
 * @param path - Path to look up snapshot for.
 * @returns True if this node should now be removed.
 */ function $494ac95ccfb2d9dd$var$sparseSnapshotTreeForget(sparseSnapshotTree, path) {
    if ($494ac95ccfb2d9dd$var$pathIsEmpty(path)) {
        sparseSnapshotTree.value = null;
        sparseSnapshotTree.children.clear();
        return true;
    } else {
        if (sparseSnapshotTree.value !== null) {
            if (sparseSnapshotTree.value.isLeafNode()) // We're trying to forget a node that doesn't exist
            return false;
            else {
                const value = sparseSnapshotTree.value;
                sparseSnapshotTree.value = null;
                value.forEachChild($494ac95ccfb2d9dd$var$PRIORITY_INDEX, (key, tree)=>{
                    $494ac95ccfb2d9dd$var$sparseSnapshotTreeRemember(sparseSnapshotTree, new $494ac95ccfb2d9dd$var$Path(key), tree);
                });
                return $494ac95ccfb2d9dd$var$sparseSnapshotTreeForget(sparseSnapshotTree, path);
            }
        } else if (sparseSnapshotTree.children.size > 0) {
            const childKey = $494ac95ccfb2d9dd$var$pathGetFront(path);
            path = $494ac95ccfb2d9dd$var$pathPopFront(path);
            if (sparseSnapshotTree.children.has(childKey)) {
                const safeToRemove = $494ac95ccfb2d9dd$var$sparseSnapshotTreeForget(sparseSnapshotTree.children.get(childKey), path);
                if (safeToRemove) sparseSnapshotTree.children.delete(childKey);
            }
            return sparseSnapshotTree.children.size === 0;
        } else return true;
    }
}
/**
 * Recursively iterates through all of the stored tree and calls the
 * callback on each one.
 *
 * @param prefixPath - Path to look up node for.
 * @param func - The function to invoke for each tree.
 */ function $494ac95ccfb2d9dd$var$sparseSnapshotTreeForEachTree(sparseSnapshotTree, prefixPath, func) {
    if (sparseSnapshotTree.value !== null) func(prefixPath, sparseSnapshotTree.value);
    else $494ac95ccfb2d9dd$var$sparseSnapshotTreeForEachChild(sparseSnapshotTree, (key, tree)=>{
        const path = new $494ac95ccfb2d9dd$var$Path(prefixPath.toString() + "/" + key);
        $494ac95ccfb2d9dd$var$sparseSnapshotTreeForEachTree(tree, path, func);
    });
}
/**
 * Iterates through each immediate child and triggers the callback.
 * Only seems to be used in tests.
 *
 * @param func - The function to invoke for each child.
 */ function $494ac95ccfb2d9dd$var$sparseSnapshotTreeForEachChild(sparseSnapshotTree, func) {
    sparseSnapshotTree.children.forEach((tree, key)=>{
        func(key, tree);
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the delta from the previous call to get stats.
 *
 * @param collection_ - The collection to "listen" to.
 */ class $494ac95ccfb2d9dd$var$StatsListener {
    constructor(collection_){
        this.collection_ = collection_;
        this.last_ = null;
    }
    get() {
        const newStats = this.collection_.get();
        const delta = Object.assign({}, newStats);
        if (this.last_) $494ac95ccfb2d9dd$var$each(this.last_, (stat, value)=>{
            delta[stat] = delta[stat] - value;
        });
        this.last_ = newStats;
        return delta;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
// seconds to try to ensure the Firebase connection is established / settled.
const $494ac95ccfb2d9dd$var$FIRST_STATS_MIN_TIME = 10000;
const $494ac95ccfb2d9dd$var$FIRST_STATS_MAX_TIME = 30000;
// We'll continue to report stats on average every 5 minutes.
const $494ac95ccfb2d9dd$var$REPORT_STATS_INTERVAL = 300000;
class $494ac95ccfb2d9dd$var$StatsReporter {
    constructor(collection, server_){
        this.server_ = server_;
        this.statsToReport_ = {};
        this.statsListener_ = new $494ac95ccfb2d9dd$var$StatsListener(collection);
        const timeout = $494ac95ccfb2d9dd$var$FIRST_STATS_MIN_TIME + ($494ac95ccfb2d9dd$var$FIRST_STATS_MAX_TIME - $494ac95ccfb2d9dd$var$FIRST_STATS_MIN_TIME) * Math.random();
        $494ac95ccfb2d9dd$var$setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
    }
    reportStats_() {
        const stats = this.statsListener_.get();
        const reportedStats = {};
        let haveStatsToReport = false;
        $494ac95ccfb2d9dd$var$each(stats, (stat, value)=>{
            if (value > 0 && (0, $fc59d49e1bb53b6a$export$2344b14b097df817)(this.statsToReport_, stat)) {
                reportedStats[stat] = value;
                haveStatsToReport = true;
            }
        });
        if (haveStatsToReport) this.server_.reportStats(reportedStats);
        // queue our next run.
        $494ac95ccfb2d9dd$var$setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * $494ac95ccfb2d9dd$var$REPORT_STATS_INTERVAL));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 *
 * @enum
 */ var $494ac95ccfb2d9dd$var$OperationType;
(function(OperationType) {
    OperationType[OperationType["OVERWRITE"] = 0] = "OVERWRITE";
    OperationType[OperationType["MERGE"] = 1] = "MERGE";
    OperationType[OperationType["ACK_USER_WRITE"] = 2] = "ACK_USER_WRITE";
    OperationType[OperationType["LISTEN_COMPLETE"] = 3] = "LISTEN_COMPLETE";
})($494ac95ccfb2d9dd$var$OperationType || ($494ac95ccfb2d9dd$var$OperationType = {}));
function $494ac95ccfb2d9dd$var$newOperationSourceUser() {
    return {
        fromUser: true,
        fromServer: false,
        queryId: null,
        tagged: false
    };
}
function $494ac95ccfb2d9dd$var$newOperationSourceServer() {
    return {
        fromUser: false,
        fromServer: true,
        queryId: null,
        tagged: false
    };
}
function $494ac95ccfb2d9dd$var$newOperationSourceServerTaggedQuery(queryId) {
    return {
        fromUser: false,
        fromServer: true,
        queryId: queryId,
        tagged: true
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $494ac95ccfb2d9dd$var$AckUserWrite {
    /**
     * @param affectedTree - A tree containing true for each affected path. Affected paths can't overlap.
     */ constructor(/** @inheritDoc */ path, /** @inheritDoc */ affectedTree, /** @inheritDoc */ revert){
        this.path = path;
        this.affectedTree = affectedTree;
        this.revert = revert;
        /** @inheritDoc */ this.type = $494ac95ccfb2d9dd$var$OperationType.ACK_USER_WRITE;
        /** @inheritDoc */ this.source = $494ac95ccfb2d9dd$var$newOperationSourceUser();
    }
    operationForChild(childName) {
        if (!$494ac95ccfb2d9dd$var$pathIsEmpty(this.path)) {
            (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)($494ac95ccfb2d9dd$var$pathGetFront(this.path) === childName, "operationForChild called for unrelated child.");
            return new $494ac95ccfb2d9dd$var$AckUserWrite($494ac95ccfb2d9dd$var$pathPopFront(this.path), this.affectedTree, this.revert);
        } else if (this.affectedTree.value != null) {
            (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(this.affectedTree.children.isEmpty(), "affectedTree should not have overlapping affected paths.");
            // All child locations are affected as well; just return same operation.
            return this;
        } else {
            const childTree = this.affectedTree.subtree(new $494ac95ccfb2d9dd$var$Path(childName));
            return new $494ac95ccfb2d9dd$var$AckUserWrite($494ac95ccfb2d9dd$var$newEmptyPath(), childTree, this.revert);
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $494ac95ccfb2d9dd$var$ListenComplete {
    constructor(source, path){
        this.source = source;
        this.path = path;
        /** @inheritDoc */ this.type = $494ac95ccfb2d9dd$var$OperationType.LISTEN_COMPLETE;
    }
    operationForChild(childName) {
        if ($494ac95ccfb2d9dd$var$pathIsEmpty(this.path)) return new $494ac95ccfb2d9dd$var$ListenComplete(this.source, $494ac95ccfb2d9dd$var$newEmptyPath());
        else return new $494ac95ccfb2d9dd$var$ListenComplete(this.source, $494ac95ccfb2d9dd$var$pathPopFront(this.path));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $494ac95ccfb2d9dd$var$Overwrite {
    constructor(source, path, snap){
        this.source = source;
        this.path = path;
        this.snap = snap;
        /** @inheritDoc */ this.type = $494ac95ccfb2d9dd$var$OperationType.OVERWRITE;
    }
    operationForChild(childName) {
        if ($494ac95ccfb2d9dd$var$pathIsEmpty(this.path)) return new $494ac95ccfb2d9dd$var$Overwrite(this.source, $494ac95ccfb2d9dd$var$newEmptyPath(), this.snap.getImmediateChild(childName));
        else return new $494ac95ccfb2d9dd$var$Overwrite(this.source, $494ac95ccfb2d9dd$var$pathPopFront(this.path), this.snap);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $494ac95ccfb2d9dd$var$Merge {
    constructor(/** @inheritDoc */ source, /** @inheritDoc */ path, /** @inheritDoc */ children){
        this.source = source;
        this.path = path;
        this.children = children;
        /** @inheritDoc */ this.type = $494ac95ccfb2d9dd$var$OperationType.MERGE;
    }
    operationForChild(childName) {
        if ($494ac95ccfb2d9dd$var$pathIsEmpty(this.path)) {
            const childTree = this.children.subtree(new $494ac95ccfb2d9dd$var$Path(childName));
            if (childTree.isEmpty()) // This child is unaffected
            return null;
            else if (childTree.value) // We have a snapshot for the child in question.  This becomes an overwrite of the child.
            return new $494ac95ccfb2d9dd$var$Overwrite(this.source, $494ac95ccfb2d9dd$var$newEmptyPath(), childTree.value);
            else // This is a merge at a deeper level
            return new $494ac95ccfb2d9dd$var$Merge(this.source, $494ac95ccfb2d9dd$var$newEmptyPath(), childTree);
        } else {
            (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)($494ac95ccfb2d9dd$var$pathGetFront(this.path) === childName, "Can't get a merge for a child not on the path of the operation");
            return new $494ac95ccfb2d9dd$var$Merge(this.source, $494ac95ccfb2d9dd$var$pathPopFront(this.path), this.children);
        }
    }
    toString() {
        return "Operation(" + this.path + ": " + this.source.toString() + " merge: " + this.children.toString() + ")";
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A cache node only stores complete children. Additionally it holds a flag whether the node can be considered fully
 * initialized in the sense that we know at one point in time this represented a valid state of the world, e.g.
 * initialized with data from the server, or a complete overwrite by the client. The filtered flag also tracks
 * whether a node potentially had children removed due to a filter.
 */ class $494ac95ccfb2d9dd$var$CacheNode {
    constructor(node_, fullyInitialized_, filtered_){
        this.node_ = node_;
        this.fullyInitialized_ = fullyInitialized_;
        this.filtered_ = filtered_;
    }
    /**
     * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
     */ isFullyInitialized() {
        return this.fullyInitialized_;
    }
    /**
     * Returns whether this node is potentially missing children due to a filter applied to the node
     */ isFiltered() {
        return this.filtered_;
    }
    isCompleteForPath(path) {
        if ($494ac95ccfb2d9dd$var$pathIsEmpty(path)) return this.isFullyInitialized() && !this.filtered_;
        const childKey = $494ac95ccfb2d9dd$var$pathGetFront(path);
        return this.isCompleteForChild(childKey);
    }
    isCompleteForChild(key) {
        return this.isFullyInitialized() && !this.filtered_ || this.node_.hasChild(key);
    }
    getNode() {
        return this.node_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An EventGenerator is used to convert "raw" changes (Change) as computed by the
 * CacheDiffer into actual events (Event) that can be raised.  See generateEventsForChanges()
 * for details.
 *
 */ class $494ac95ccfb2d9dd$var$EventGenerator {
    constructor(query_){
        this.query_ = query_;
        this.index_ = this.query_._queryParams.getIndex();
    }
}
/**
 * Given a set of raw changes (no moved events and prevName not specified yet), and a set of
 * EventRegistrations that should be notified of these changes, generate the actual events to be raised.
 *
 * Notes:
 *  - child_moved events will be synthesized at this time for any child_changed events that affect
 *    our index.
 *  - prevName will be calculated based on the index ordering.
 */ function $494ac95ccfb2d9dd$var$eventGeneratorGenerateEventsForChanges(eventGenerator, changes, eventCache, eventRegistrations) {
    const events = [];
    const moves = [];
    changes.forEach((change)=>{
        if (change.type === "child_changed" /* ChangeType.CHILD_CHANGED */  && eventGenerator.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) moves.push($494ac95ccfb2d9dd$var$changeChildMoved(change.childName, change.snapshotNode));
    });
    $494ac95ccfb2d9dd$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_removed" /* ChangeType.CHILD_REMOVED */ , changes, eventRegistrations, eventCache);
    $494ac95ccfb2d9dd$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_added" /* ChangeType.CHILD_ADDED */ , changes, eventRegistrations, eventCache);
    $494ac95ccfb2d9dd$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_moved" /* ChangeType.CHILD_MOVED */ , moves, eventRegistrations, eventCache);
    $494ac95ccfb2d9dd$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_changed" /* ChangeType.CHILD_CHANGED */ , changes, eventRegistrations, eventCache);
    $494ac95ccfb2d9dd$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "value" /* ChangeType.VALUE */ , changes, eventRegistrations, eventCache);
    return events;
}
/**
 * Given changes of a single change type, generate the corresponding events.
 */ function $494ac95ccfb2d9dd$var$eventGeneratorGenerateEventsForType(eventGenerator, events, eventType, changes, registrations, eventCache) {
    const filteredChanges = changes.filter((change)=>change.type === eventType);
    filteredChanges.sort((a, b)=>$494ac95ccfb2d9dd$var$eventGeneratorCompareChanges(eventGenerator, a, b));
    filteredChanges.forEach((change)=>{
        const materializedChange = $494ac95ccfb2d9dd$var$eventGeneratorMaterializeSingleChange(eventGenerator, change, eventCache);
        registrations.forEach((registration)=>{
            if (registration.respondsTo(change.type)) events.push(registration.createEvent(materializedChange, eventGenerator.query_));
        });
    });
}
function $494ac95ccfb2d9dd$var$eventGeneratorMaterializeSingleChange(eventGenerator, change, eventCache) {
    if (change.type === "value" || change.type === "child_removed") return change;
    else {
        change.prevName = eventCache.getPredecessorChildName(change.childName, change.snapshotNode, eventGenerator.index_);
        return change;
    }
}
function $494ac95ccfb2d9dd$var$eventGeneratorCompareChanges(eventGenerator, a, b) {
    if (a.childName == null || b.childName == null) throw (0, $fc59d49e1bb53b6a$export$a39cad550e7ab28a)("Should only compare child_ events.");
    const aWrapped = new $494ac95ccfb2d9dd$var$NamedNode(a.childName, a.snapshotNode);
    const bWrapped = new $494ac95ccfb2d9dd$var$NamedNode(b.childName, b.snapshotNode);
    return eventGenerator.index_.compare(aWrapped, bWrapped);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $494ac95ccfb2d9dd$var$newViewCache(eventCache, serverCache) {
    return {
        eventCache: eventCache,
        serverCache: serverCache
    };
}
function $494ac95ccfb2d9dd$var$viewCacheUpdateEventSnap(viewCache, eventSnap, complete, filtered) {
    return $494ac95ccfb2d9dd$var$newViewCache(new $494ac95ccfb2d9dd$var$CacheNode(eventSnap, complete, filtered), viewCache.serverCache);
}
function $494ac95ccfb2d9dd$var$viewCacheUpdateServerSnap(viewCache, serverSnap, complete, filtered) {
    return $494ac95ccfb2d9dd$var$newViewCache(viewCache.eventCache, new $494ac95ccfb2d9dd$var$CacheNode(serverSnap, complete, filtered));
}
function $494ac95ccfb2d9dd$var$viewCacheGetCompleteEventSnap(viewCache) {
    return viewCache.eventCache.isFullyInitialized() ? viewCache.eventCache.getNode() : null;
}
function $494ac95ccfb2d9dd$var$viewCacheGetCompleteServerSnap(viewCache) {
    return viewCache.serverCache.isFullyInitialized() ? viewCache.serverCache.getNode() : null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $494ac95ccfb2d9dd$var$emptyChildrenSingleton;
/**
 * Singleton empty children collection.
 *
 */ const $494ac95ccfb2d9dd$var$EmptyChildren = ()=>{
    if (!$494ac95ccfb2d9dd$var$emptyChildrenSingleton) $494ac95ccfb2d9dd$var$emptyChildrenSingleton = new $494ac95ccfb2d9dd$var$SortedMap($494ac95ccfb2d9dd$var$stringCompare);
    return $494ac95ccfb2d9dd$var$emptyChildrenSingleton;
};
/**
 * A tree with immutable elements.
 */ class $494ac95ccfb2d9dd$var$ImmutableTree {
    constructor(value, children = $494ac95ccfb2d9dd$var$EmptyChildren()){
        this.value = value;
        this.children = children;
    }
    static fromObject(obj) {
        let tree = new $494ac95ccfb2d9dd$var$ImmutableTree(null);
        $494ac95ccfb2d9dd$var$each(obj, (childPath, childSnap)=>{
            tree = tree.set(new $494ac95ccfb2d9dd$var$Path(childPath), childSnap);
        });
        return tree;
    }
    /**
     * True if the value is empty and there are no children
     */ isEmpty() {
        return this.value === null && this.children.isEmpty();
    }
    /**
     * Given a path and predicate, return the first node and the path to that node
     * where the predicate returns true.
     *
     * TODO Do a perf test -- If we're creating a bunch of `{path: value:}`
     * objects on the way back out, it may be better to pass down a pathSoFar obj.
     *
     * @param relativePath - The remainder of the path
     * @param predicate - The predicate to satisfy to return a node
     */ findRootMostMatchingPathAndValue(relativePath, predicate) {
        if (this.value != null && predicate(this.value)) return {
            path: $494ac95ccfb2d9dd$var$newEmptyPath(),
            value: this.value
        };
        else {
            if ($494ac95ccfb2d9dd$var$pathIsEmpty(relativePath)) return null;
            else {
                const front = $494ac95ccfb2d9dd$var$pathGetFront(relativePath);
                const child = this.children.get(front);
                if (child !== null) {
                    const childExistingPathAndValue = child.findRootMostMatchingPathAndValue($494ac95ccfb2d9dd$var$pathPopFront(relativePath), predicate);
                    if (childExistingPathAndValue != null) {
                        const fullPath = $494ac95ccfb2d9dd$var$pathChild(new $494ac95ccfb2d9dd$var$Path(front), childExistingPathAndValue.path);
                        return {
                            path: fullPath,
                            value: childExistingPathAndValue.value
                        };
                    } else return null;
                } else return null;
            }
        }
    }
    /**
     * Find, if it exists, the shortest subpath of the given path that points a defined
     * value in the tree
     */ findRootMostValueAndPath(relativePath) {
        return this.findRootMostMatchingPathAndValue(relativePath, ()=>true);
    }
    /**
     * @returns The subtree at the given path
     */ subtree(relativePath) {
        if ($494ac95ccfb2d9dd$var$pathIsEmpty(relativePath)) return this;
        else {
            const front = $494ac95ccfb2d9dd$var$pathGetFront(relativePath);
            const childTree = this.children.get(front);
            if (childTree !== null) return childTree.subtree($494ac95ccfb2d9dd$var$pathPopFront(relativePath));
            else return new $494ac95ccfb2d9dd$var$ImmutableTree(null);
        }
    }
    /**
     * Sets a value at the specified path.
     *
     * @param relativePath - Path to set value at.
     * @param toSet - Value to set.
     * @returns Resulting tree.
     */ set(relativePath, toSet) {
        if ($494ac95ccfb2d9dd$var$pathIsEmpty(relativePath)) return new $494ac95ccfb2d9dd$var$ImmutableTree(toSet, this.children);
        else {
            const front = $494ac95ccfb2d9dd$var$pathGetFront(relativePath);
            const child = this.children.get(front) || new $494ac95ccfb2d9dd$var$ImmutableTree(null);
            const newChild = child.set($494ac95ccfb2d9dd$var$pathPopFront(relativePath), toSet);
            const newChildren = this.children.insert(front, newChild);
            return new $494ac95ccfb2d9dd$var$ImmutableTree(this.value, newChildren);
        }
    }
    /**
     * Removes the value at the specified path.
     *
     * @param relativePath - Path to value to remove.
     * @returns Resulting tree.
     */ remove(relativePath) {
        if ($494ac95ccfb2d9dd$var$pathIsEmpty(relativePath)) {
            if (this.children.isEmpty()) return new $494ac95ccfb2d9dd$var$ImmutableTree(null);
            else return new $494ac95ccfb2d9dd$var$ImmutableTree(null, this.children);
        } else {
            const front = $494ac95ccfb2d9dd$var$pathGetFront(relativePath);
            const child = this.children.get(front);
            if (child) {
                const newChild = child.remove($494ac95ccfb2d9dd$var$pathPopFront(relativePath));
                let newChildren;
                if (newChild.isEmpty()) newChildren = this.children.remove(front);
                else newChildren = this.children.insert(front, newChild);
                if (this.value === null && newChildren.isEmpty()) return new $494ac95ccfb2d9dd$var$ImmutableTree(null);
                else return new $494ac95ccfb2d9dd$var$ImmutableTree(this.value, newChildren);
            } else return this;
        }
    }
    /**
     * Gets a value from the tree.
     *
     * @param relativePath - Path to get value for.
     * @returns Value at path, or null.
     */ get(relativePath) {
        if ($494ac95ccfb2d9dd$var$pathIsEmpty(relativePath)) return this.value;
        else {
            const front = $494ac95ccfb2d9dd$var$pathGetFront(relativePath);
            const child = this.children.get(front);
            if (child) return child.get($494ac95ccfb2d9dd$var$pathPopFront(relativePath));
            else return null;
        }
    }
    /**
     * Replace the subtree at the specified path with the given new tree.
     *
     * @param relativePath - Path to replace subtree for.
     * @param newTree - New tree.
     * @returns Resulting tree.
     */ setTree(relativePath, newTree) {
        if ($494ac95ccfb2d9dd$var$pathIsEmpty(relativePath)) return newTree;
        else {
            const front = $494ac95ccfb2d9dd$var$pathGetFront(relativePath);
            const child = this.children.get(front) || new $494ac95ccfb2d9dd$var$ImmutableTree(null);
            const newChild = child.setTree($494ac95ccfb2d9dd$var$pathPopFront(relativePath), newTree);
            let newChildren;
            if (newChild.isEmpty()) newChildren = this.children.remove(front);
            else newChildren = this.children.insert(front, newChild);
            return new $494ac95ccfb2d9dd$var$ImmutableTree(this.value, newChildren);
        }
    }
    /**
     * Performs a depth first fold on this tree. Transforms a tree into a single
     * value, given a function that operates on the path to a node, an optional
     * current value, and a map of child names to folded subtrees
     */ fold(fn) {
        return this.fold_($494ac95ccfb2d9dd$var$newEmptyPath(), fn);
    }
    /**
     * Recursive helper for public-facing fold() method
     */ fold_(pathSoFar, fn) {
        const accum = {};
        this.children.inorderTraversal((childKey, childTree)=>{
            accum[childKey] = childTree.fold_($494ac95ccfb2d9dd$var$pathChild(pathSoFar, childKey), fn);
        });
        return fn(pathSoFar, this.value, accum);
    }
    /**
     * Find the first matching value on the given path. Return the result of applying f to it.
     */ findOnPath(path, f) {
        return this.findOnPath_(path, $494ac95ccfb2d9dd$var$newEmptyPath(), f);
    }
    findOnPath_(pathToFollow, pathSoFar, f) {
        const result = this.value ? f(pathSoFar, this.value) : false;
        if (result) return result;
        else {
            if ($494ac95ccfb2d9dd$var$pathIsEmpty(pathToFollow)) return null;
            else {
                const front = $494ac95ccfb2d9dd$var$pathGetFront(pathToFollow);
                const nextChild = this.children.get(front);
                if (nextChild) return nextChild.findOnPath_($494ac95ccfb2d9dd$var$pathPopFront(pathToFollow), $494ac95ccfb2d9dd$var$pathChild(pathSoFar, front), f);
                else return null;
            }
        }
    }
    foreachOnPath(path, f) {
        return this.foreachOnPath_(path, $494ac95ccfb2d9dd$var$newEmptyPath(), f);
    }
    foreachOnPath_(pathToFollow, currentRelativePath, f) {
        if ($494ac95ccfb2d9dd$var$pathIsEmpty(pathToFollow)) return this;
        else {
            if (this.value) f(currentRelativePath, this.value);
            const front = $494ac95ccfb2d9dd$var$pathGetFront(pathToFollow);
            const nextChild = this.children.get(front);
            if (nextChild) return nextChild.foreachOnPath_($494ac95ccfb2d9dd$var$pathPopFront(pathToFollow), $494ac95ccfb2d9dd$var$pathChild(currentRelativePath, front), f);
            else return new $494ac95ccfb2d9dd$var$ImmutableTree(null);
        }
    }
    /**
     * Calls the given function for each node in the tree that has a value.
     *
     * @param f - A function to be called with the path from the root of the tree to
     * a node, and the value at that node. Called in depth-first order.
     */ foreach(f) {
        this.foreach_($494ac95ccfb2d9dd$var$newEmptyPath(), f);
    }
    foreach_(currentRelativePath, f) {
        this.children.inorderTraversal((childName, childTree)=>{
            childTree.foreach_($494ac95ccfb2d9dd$var$pathChild(currentRelativePath, childName), f);
        });
        if (this.value) f(currentRelativePath, this.value);
    }
    foreachChild(f) {
        this.children.inorderTraversal((childName, childTree)=>{
            if (childTree.value) f(childName, childTree.value);
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class holds a collection of writes that can be applied to nodes in unison. It abstracts away the logic with
 * dealing with priority writes and multiple nested writes. At any given path there is only allowed to be one write
 * modifying that path. Any write to an existing path or shadowing an existing path will modify that existing write
 * to reflect the write added.
 */ class $494ac95ccfb2d9dd$var$CompoundWrite {
    constructor(writeTree_){
        this.writeTree_ = writeTree_;
    }
    static empty() {
        return new $494ac95ccfb2d9dd$var$CompoundWrite(new $494ac95ccfb2d9dd$var$ImmutableTree(null));
    }
}
function $494ac95ccfb2d9dd$var$compoundWriteAddWrite(compoundWrite, path, node) {
    if ($494ac95ccfb2d9dd$var$pathIsEmpty(path)) return new $494ac95ccfb2d9dd$var$CompoundWrite(new $494ac95ccfb2d9dd$var$ImmutableTree(node));
    else {
        const rootmost = compoundWrite.writeTree_.findRootMostValueAndPath(path);
        if (rootmost != null) {
            const rootMostPath = rootmost.path;
            let value = rootmost.value;
            const relativePath = $494ac95ccfb2d9dd$var$newRelativePath(rootMostPath, path);
            value = value.updateChild(relativePath, node);
            return new $494ac95ccfb2d9dd$var$CompoundWrite(compoundWrite.writeTree_.set(rootMostPath, value));
        } else {
            const subtree = new $494ac95ccfb2d9dd$var$ImmutableTree(node);
            const newWriteTree = compoundWrite.writeTree_.setTree(path, subtree);
            return new $494ac95ccfb2d9dd$var$CompoundWrite(newWriteTree);
        }
    }
}
function $494ac95ccfb2d9dd$var$compoundWriteAddWrites(compoundWrite, path, updates) {
    let newWrite = compoundWrite;
    $494ac95ccfb2d9dd$var$each(updates, (childKey, node)=>{
        newWrite = $494ac95ccfb2d9dd$var$compoundWriteAddWrite(newWrite, $494ac95ccfb2d9dd$var$pathChild(path, childKey), node);
    });
    return newWrite;
}
/**
 * Will remove a write at the given path and deeper paths. This will <em>not</em> modify a write at a higher
 * location, which must be removed by calling this method with that path.
 *
 * @param compoundWrite - The CompoundWrite to remove.
 * @param path - The path at which a write and all deeper writes should be removed
 * @returns The new CompoundWrite with the removed path
 */ function $494ac95ccfb2d9dd$var$compoundWriteRemoveWrite(compoundWrite, path) {
    if ($494ac95ccfb2d9dd$var$pathIsEmpty(path)) return $494ac95ccfb2d9dd$var$CompoundWrite.empty();
    else {
        const newWriteTree = compoundWrite.writeTree_.setTree(path, new $494ac95ccfb2d9dd$var$ImmutableTree(null));
        return new $494ac95ccfb2d9dd$var$CompoundWrite(newWriteTree);
    }
}
/**
 * Returns whether this CompoundWrite will fully overwrite a node at a given location and can therefore be
 * considered "complete".
 *
 * @param compoundWrite - The CompoundWrite to check.
 * @param path - The path to check for
 * @returns Whether there is a complete write at that path
 */ function $494ac95ccfb2d9dd$var$compoundWriteHasCompleteWrite(compoundWrite, path) {
    return $494ac95ccfb2d9dd$var$compoundWriteGetCompleteNode(compoundWrite, path) != null;
}
/**
 * Returns a node for a path if and only if the node is a "complete" overwrite at that path. This will not aggregate
 * writes from deeper paths, but will return child nodes from a more shallow path.
 *
 * @param compoundWrite - The CompoundWrite to get the node from.
 * @param path - The path to get a complete write
 * @returns The node if complete at that path, or null otherwise.
 */ function $494ac95ccfb2d9dd$var$compoundWriteGetCompleteNode(compoundWrite, path) {
    const rootmost = compoundWrite.writeTree_.findRootMostValueAndPath(path);
    if (rootmost != null) return compoundWrite.writeTree_.get(rootmost.path).getChild($494ac95ccfb2d9dd$var$newRelativePath(rootmost.path, path));
    else return null;
}
/**
 * Returns all children that are guaranteed to be a complete overwrite.
 *
 * @param compoundWrite - The CompoundWrite to get children from.
 * @returns A list of all complete children.
 */ function $494ac95ccfb2d9dd$var$compoundWriteGetCompleteChildren(compoundWrite) {
    const children = [];
    const node = compoundWrite.writeTree_.value;
    if (node != null) // If it's a leaf node, it has no children; so nothing to do.
    {
        if (!node.isLeafNode()) node.forEachChild($494ac95ccfb2d9dd$var$PRIORITY_INDEX, (childName, childNode)=>{
            children.push(new $494ac95ccfb2d9dd$var$NamedNode(childName, childNode));
        });
    } else compoundWrite.writeTree_.children.inorderTraversal((childName, childTree)=>{
        if (childTree.value != null) children.push(new $494ac95ccfb2d9dd$var$NamedNode(childName, childTree.value));
    });
    return children;
}
function $494ac95ccfb2d9dd$var$compoundWriteChildCompoundWrite(compoundWrite, path) {
    if ($494ac95ccfb2d9dd$var$pathIsEmpty(path)) return compoundWrite;
    else {
        const shadowingNode = $494ac95ccfb2d9dd$var$compoundWriteGetCompleteNode(compoundWrite, path);
        if (shadowingNode != null) return new $494ac95ccfb2d9dd$var$CompoundWrite(new $494ac95ccfb2d9dd$var$ImmutableTree(shadowingNode));
        else return new $494ac95ccfb2d9dd$var$CompoundWrite(compoundWrite.writeTree_.subtree(path));
    }
}
/**
 * Returns true if this CompoundWrite is empty and therefore does not modify any nodes.
 * @returns Whether this CompoundWrite is empty
 */ function $494ac95ccfb2d9dd$var$compoundWriteIsEmpty(compoundWrite) {
    return compoundWrite.writeTree_.isEmpty();
}
/**
 * Applies this CompoundWrite to a node. The node is returned with all writes from this CompoundWrite applied to the
 * node
 * @param node - The node to apply this CompoundWrite to
 * @returns The node with all writes applied
 */ function $494ac95ccfb2d9dd$var$compoundWriteApply(compoundWrite, node) {
    return $494ac95ccfb2d9dd$var$applySubtreeWrite($494ac95ccfb2d9dd$var$newEmptyPath(), compoundWrite.writeTree_, node);
}
function $494ac95ccfb2d9dd$var$applySubtreeWrite(relativePath, writeTree, node) {
    if (writeTree.value != null) // Since there a write is always a leaf, we're done here
    return node.updateChild(relativePath, writeTree.value);
    else {
        let priorityWrite = null;
        writeTree.children.inorderTraversal((childKey, childTree)=>{
            if (childKey === ".priority") {
                // Apply priorities at the end so we don't update priorities for either empty nodes or forget
                // to apply priorities to empty nodes that are later filled
                (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(childTree.value !== null, "Priority writes must always be leaf nodes");
                priorityWrite = childTree.value;
            } else node = $494ac95ccfb2d9dd$var$applySubtreeWrite($494ac95ccfb2d9dd$var$pathChild(relativePath, childKey), childTree, node);
        });
        // If there was a priority write, we only apply it if the node is not empty
        if (!node.getChild(relativePath).isEmpty() && priorityWrite !== null) node = node.updateChild($494ac95ccfb2d9dd$var$pathChild(relativePath, ".priority"), priorityWrite);
        return node;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create a new WriteTreeRef for the given path. For use with a new sync point at the given path.
 *
 */ function $494ac95ccfb2d9dd$var$writeTreeChildWrites(writeTree, path) {
    return $494ac95ccfb2d9dd$var$newWriteTreeRef(path, writeTree);
}
/**
 * Record a new overwrite from user code.
 *
 * @param visible - This is set to false by some transactions. It should be excluded from event caches
 */ function $494ac95ccfb2d9dd$var$writeTreeAddOverwrite(writeTree, path, snap, writeId, visible) {
    (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(writeId > writeTree.lastWriteId, "Stacking an older write on top of newer ones");
    if (visible === undefined) visible = true;
    writeTree.allWrites.push({
        path: path,
        snap: snap,
        writeId: writeId,
        visible: visible
    });
    if (visible) writeTree.visibleWrites = $494ac95ccfb2d9dd$var$compoundWriteAddWrite(writeTree.visibleWrites, path, snap);
    writeTree.lastWriteId = writeId;
}
/**
 * Record a new merge from user code.
 */ function $494ac95ccfb2d9dd$var$writeTreeAddMerge(writeTree, path, changedChildren, writeId) {
    (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(writeId > writeTree.lastWriteId, "Stacking an older merge on top of newer ones");
    writeTree.allWrites.push({
        path: path,
        children: changedChildren,
        writeId: writeId,
        visible: true
    });
    writeTree.visibleWrites = $494ac95ccfb2d9dd$var$compoundWriteAddWrites(writeTree.visibleWrites, path, changedChildren);
    writeTree.lastWriteId = writeId;
}
function $494ac95ccfb2d9dd$var$writeTreeGetWrite(writeTree, writeId) {
    for(let i = 0; i < writeTree.allWrites.length; i++){
        const record = writeTree.allWrites[i];
        if (record.writeId === writeId) return record;
    }
    return null;
}
/**
 * Remove a write (either an overwrite or merge) that has been successfully acknowledge by the server. Recalculates
 * the tree if necessary.  We return true if it may have been visible, meaning views need to reevaluate.
 *
 * @returns true if the write may have been visible (meaning we'll need to reevaluate / raise
 * events as a result).
 */ function $494ac95ccfb2d9dd$var$writeTreeRemoveWrite(writeTree, writeId) {
    // Note: disabling this check. It could be a transaction that preempted another transaction, and thus was applied
    // out of order.
    //const validClear = revert || this.allWrites_.length === 0 || writeId <= this.allWrites_[0].writeId;
    //assert(validClear, "Either we don't have this write, or it's the first one in the queue");
    const idx = writeTree.allWrites.findIndex((s)=>{
        return s.writeId === writeId;
    });
    (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(idx >= 0, "removeWrite called with nonexistent writeId.");
    const writeToRemove = writeTree.allWrites[idx];
    writeTree.allWrites.splice(idx, 1);
    let removedWriteWasVisible = writeToRemove.visible;
    let removedWriteOverlapsWithOtherWrites = false;
    let i = writeTree.allWrites.length - 1;
    while(removedWriteWasVisible && i >= 0){
        const currentWrite = writeTree.allWrites[i];
        if (currentWrite.visible) {
            if (i >= idx && $494ac95ccfb2d9dd$var$writeTreeRecordContainsPath_(currentWrite, writeToRemove.path)) // The removed write was completely shadowed by a subsequent write.
            removedWriteWasVisible = false;
            else if ($494ac95ccfb2d9dd$var$pathContains(writeToRemove.path, currentWrite.path)) // Either we're covering some writes or they're covering part of us (depending on which came first).
            removedWriteOverlapsWithOtherWrites = true;
        }
        i--;
    }
    if (!removedWriteWasVisible) return false;
    else if (removedWriteOverlapsWithOtherWrites) {
        // There's some shadowing going on. Just rebuild the visible writes from scratch.
        $494ac95ccfb2d9dd$var$writeTreeResetTree_(writeTree);
        return true;
    } else {
        // There's no shadowing.  We can safely just remove the write(s) from visibleWrites.
        if (writeToRemove.snap) writeTree.visibleWrites = $494ac95ccfb2d9dd$var$compoundWriteRemoveWrite(writeTree.visibleWrites, writeToRemove.path);
        else {
            const children = writeToRemove.children;
            $494ac95ccfb2d9dd$var$each(children, (childName)=>{
                writeTree.visibleWrites = $494ac95ccfb2d9dd$var$compoundWriteRemoveWrite(writeTree.visibleWrites, $494ac95ccfb2d9dd$var$pathChild(writeToRemove.path, childName));
            });
        }
        return true;
    }
}
function $494ac95ccfb2d9dd$var$writeTreeRecordContainsPath_(writeRecord, path) {
    if (writeRecord.snap) return $494ac95ccfb2d9dd$var$pathContains(writeRecord.path, path);
    else {
        for(const childName in writeRecord.children){
            if (writeRecord.children.hasOwnProperty(childName) && $494ac95ccfb2d9dd$var$pathContains($494ac95ccfb2d9dd$var$pathChild(writeRecord.path, childName), path)) return true;
        }
        return false;
    }
}
/**
 * Re-layer the writes and merges into a tree so we can efficiently calculate event snapshots
 */ function $494ac95ccfb2d9dd$var$writeTreeResetTree_(writeTree) {
    writeTree.visibleWrites = $494ac95ccfb2d9dd$var$writeTreeLayerTree_(writeTree.allWrites, $494ac95ccfb2d9dd$var$writeTreeDefaultFilter_, $494ac95ccfb2d9dd$var$newEmptyPath());
    if (writeTree.allWrites.length > 0) writeTree.lastWriteId = writeTree.allWrites[writeTree.allWrites.length - 1].writeId;
    else writeTree.lastWriteId = -1;
}
/**
 * The default filter used when constructing the tree. Keep everything that's visible.
 */ function $494ac95ccfb2d9dd$var$writeTreeDefaultFilter_(write) {
    return write.visible;
}
/**
 * Static method. Given an array of WriteRecords, a filter for which ones to include, and a path, construct the tree of
 * event data at that path.
 */ function $494ac95ccfb2d9dd$var$writeTreeLayerTree_(writes, filter, treeRoot) {
    let compoundWrite = $494ac95ccfb2d9dd$var$CompoundWrite.empty();
    for(let i = 0; i < writes.length; ++i){
        const write = writes[i];
        // Theory, a later set will either:
        // a) abort a relevant transaction, so no need to worry about excluding it from calculating that transaction
        // b) not be relevant to a transaction (separate branch), so again will not affect the data for that transaction
        if (filter(write)) {
            const writePath = write.path;
            let relativePath;
            if (write.snap) {
                if ($494ac95ccfb2d9dd$var$pathContains(treeRoot, writePath)) {
                    relativePath = $494ac95ccfb2d9dd$var$newRelativePath(treeRoot, writePath);
                    compoundWrite = $494ac95ccfb2d9dd$var$compoundWriteAddWrite(compoundWrite, relativePath, write.snap);
                } else if ($494ac95ccfb2d9dd$var$pathContains(writePath, treeRoot)) {
                    relativePath = $494ac95ccfb2d9dd$var$newRelativePath(writePath, treeRoot);
                    compoundWrite = $494ac95ccfb2d9dd$var$compoundWriteAddWrite(compoundWrite, $494ac95ccfb2d9dd$var$newEmptyPath(), write.snap.getChild(relativePath));
                }
            } else if (write.children) {
                if ($494ac95ccfb2d9dd$var$pathContains(treeRoot, writePath)) {
                    relativePath = $494ac95ccfb2d9dd$var$newRelativePath(treeRoot, writePath);
                    compoundWrite = $494ac95ccfb2d9dd$var$compoundWriteAddWrites(compoundWrite, relativePath, write.children);
                } else if ($494ac95ccfb2d9dd$var$pathContains(writePath, treeRoot)) {
                    relativePath = $494ac95ccfb2d9dd$var$newRelativePath(writePath, treeRoot);
                    if ($494ac95ccfb2d9dd$var$pathIsEmpty(relativePath)) compoundWrite = $494ac95ccfb2d9dd$var$compoundWriteAddWrites(compoundWrite, $494ac95ccfb2d9dd$var$newEmptyPath(), write.children);
                    else {
                        const child = (0, $fc59d49e1bb53b6a$export$e51ae4db7b428f67)(write.children, $494ac95ccfb2d9dd$var$pathGetFront(relativePath));
                        if (child) {
                            // There exists a child in this node that matches the root path
                            const deepNode = child.getChild($494ac95ccfb2d9dd$var$pathPopFront(relativePath));
                            compoundWrite = $494ac95ccfb2d9dd$var$compoundWriteAddWrite(compoundWrite, $494ac95ccfb2d9dd$var$newEmptyPath(), deepNode);
                        }
                    }
                }
            } else throw (0, $fc59d49e1bb53b6a$export$a39cad550e7ab28a)("WriteRecord should have .snap or .children");
        }
    }
    return compoundWrite;
}
/**
 * Given optional, underlying server data, and an optional set of constraints (exclude some sets, include hidden
 * writes), attempt to calculate a complete snapshot for the given path
 *
 * @param writeIdsToExclude - An optional set to be excluded
 * @param includeHiddenWrites - Defaults to false, whether or not to layer on writes with visible set to false
 */ function $494ac95ccfb2d9dd$var$writeTreeCalcCompleteEventCache(writeTree, treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
    if (!writeIdsToExclude && !includeHiddenWrites) {
        const shadowingNode = $494ac95ccfb2d9dd$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, treePath);
        if (shadowingNode != null) return shadowingNode;
        else {
            const subMerge = $494ac95ccfb2d9dd$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
            if ($494ac95ccfb2d9dd$var$compoundWriteIsEmpty(subMerge)) return completeServerCache;
            else if (completeServerCache == null && !$494ac95ccfb2d9dd$var$compoundWriteHasCompleteWrite(subMerge, $494ac95ccfb2d9dd$var$newEmptyPath())) // We wouldn't have a complete snapshot, since there's no underlying data and no complete shadow
            return null;
            else {
                const layeredCache = completeServerCache || $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE;
                return $494ac95ccfb2d9dd$var$compoundWriteApply(subMerge, layeredCache);
            }
        }
    } else {
        const merge = $494ac95ccfb2d9dd$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        if (!includeHiddenWrites && $494ac95ccfb2d9dd$var$compoundWriteIsEmpty(merge)) return completeServerCache;
        else {
            // If the server cache is null, and we don't have a complete cache, we need to return null
            if (!includeHiddenWrites && completeServerCache == null && !$494ac95ccfb2d9dd$var$compoundWriteHasCompleteWrite(merge, $494ac95ccfb2d9dd$var$newEmptyPath())) return null;
            else {
                const filter = function(write) {
                    return (write.visible || includeHiddenWrites) && (!writeIdsToExclude || !~writeIdsToExclude.indexOf(write.writeId)) && ($494ac95ccfb2d9dd$var$pathContains(write.path, treePath) || $494ac95ccfb2d9dd$var$pathContains(treePath, write.path));
                };
                const mergeAtPath = $494ac95ccfb2d9dd$var$writeTreeLayerTree_(writeTree.allWrites, filter, treePath);
                const layeredCache = completeServerCache || $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE;
                return $494ac95ccfb2d9dd$var$compoundWriteApply(mergeAtPath, layeredCache);
            }
        }
    }
}
/**
 * With optional, underlying server data, attempt to return a children node of children that we have complete data for.
 * Used when creating new views, to pre-fill their complete event children snapshot.
 */ function $494ac95ccfb2d9dd$var$writeTreeCalcCompleteEventChildren(writeTree, treePath, completeServerChildren) {
    let completeChildren = $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE;
    const topLevelSet = $494ac95ccfb2d9dd$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, treePath);
    if (topLevelSet) {
        if (!topLevelSet.isLeafNode()) // we're shadowing everything. Return the children.
        topLevelSet.forEachChild($494ac95ccfb2d9dd$var$PRIORITY_INDEX, (childName, childSnap)=>{
            completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
        });
        return completeChildren;
    } else if (completeServerChildren) {
        // Layer any children we have on top of this
        // We know we don't have a top-level set, so just enumerate existing children
        const merge = $494ac95ccfb2d9dd$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        completeServerChildren.forEachChild($494ac95ccfb2d9dd$var$PRIORITY_INDEX, (childName, childNode)=>{
            const node = $494ac95ccfb2d9dd$var$compoundWriteApply($494ac95ccfb2d9dd$var$compoundWriteChildCompoundWrite(merge, new $494ac95ccfb2d9dd$var$Path(childName)), childNode);
            completeChildren = completeChildren.updateImmediateChild(childName, node);
        });
        // Add any complete children we have from the set
        $494ac95ccfb2d9dd$var$compoundWriteGetCompleteChildren(merge).forEach((namedNode)=>{
            completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
        });
        return completeChildren;
    } else {
        // We don't have anything to layer on top of. Layer on any children we have
        // Note that we can return an empty snap if we have a defined delete
        const merge = $494ac95ccfb2d9dd$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        $494ac95ccfb2d9dd$var$compoundWriteGetCompleteChildren(merge).forEach((namedNode)=>{
            completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
        });
        return completeChildren;
    }
}
/**
 * Given that the underlying server data has updated, determine what, if anything, needs to be
 * applied to the event cache.
 *
 * Possibilities:
 *
 * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
 *
 * 2. Some write is completely shadowing. No events to be raised
 *
 * 3. Is partially shadowed. Events
 *
 * Either existingEventSnap or existingServerSnap must exist
 */ function $494ac95ccfb2d9dd$var$writeTreeCalcEventCacheAfterServerOverwrite(writeTree, treePath, childPath, existingEventSnap, existingServerSnap) {
    (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(existingEventSnap || existingServerSnap, "Either existingEventSnap or existingServerSnap must exist");
    const path = $494ac95ccfb2d9dd$var$pathChild(treePath, childPath);
    if ($494ac95ccfb2d9dd$var$compoundWriteHasCompleteWrite(writeTree.visibleWrites, path)) // At this point we can probably guarantee that we're in case 2, meaning no events
    // May need to check visibility while doing the findRootMostValueAndPath call
    return null;
    else {
        // No complete shadowing. We're either partially shadowing or not shadowing at all.
        const childMerge = $494ac95ccfb2d9dd$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, path);
        if ($494ac95ccfb2d9dd$var$compoundWriteIsEmpty(childMerge)) // We're not shadowing at all. Case 1
        return existingServerSnap.getChild(childPath);
        else // This could be more efficient if the serverNode + updates doesn't change the eventSnap
        // However this is tricky to find out, since user updates don't necessary change the server
        // snap, e.g. priority updates on empty nodes, or deep deletes. Another special case is if the server
        // adds nodes, but doesn't change any existing writes. It is therefore not enough to
        // only check if the updates change the serverNode.
        // Maybe check if the merge tree contains these special cases and only do a full overwrite in that case?
        return $494ac95ccfb2d9dd$var$compoundWriteApply(childMerge, existingServerSnap.getChild(childPath));
    }
}
/**
 * Returns a complete child for a given server snap after applying all user writes or null if there is no
 * complete child for this ChildKey.
 */ function $494ac95ccfb2d9dd$var$writeTreeCalcCompleteChild(writeTree, treePath, childKey, existingServerSnap) {
    const path = $494ac95ccfb2d9dd$var$pathChild(treePath, childKey);
    const shadowingNode = $494ac95ccfb2d9dd$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, path);
    if (shadowingNode != null) return shadowingNode;
    else {
        if (existingServerSnap.isCompleteForChild(childKey)) {
            const childMerge = $494ac95ccfb2d9dd$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, path);
            return $494ac95ccfb2d9dd$var$compoundWriteApply(childMerge, existingServerSnap.getNode().getImmediateChild(childKey));
        } else return null;
    }
}
/**
 * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
 * a higher path, this will return the child of that write relative to the write and this path.
 * Returns null if there is no write at this path.
 */ function $494ac95ccfb2d9dd$var$writeTreeShadowingWrite(writeTree, path) {
    return $494ac95ccfb2d9dd$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, path);
}
/**
 * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
 * the window, but may now be in the window.
 */ function $494ac95ccfb2d9dd$var$writeTreeCalcIndexedSlice(writeTree, treePath, completeServerData, startPost, count, reverse, index) {
    let toIterate;
    const merge = $494ac95ccfb2d9dd$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
    const shadowingNode = $494ac95ccfb2d9dd$var$compoundWriteGetCompleteNode(merge, $494ac95ccfb2d9dd$var$newEmptyPath());
    if (shadowingNode != null) toIterate = shadowingNode;
    else if (completeServerData != null) toIterate = $494ac95ccfb2d9dd$var$compoundWriteApply(merge, completeServerData);
    else // no children to iterate on
    return [];
    toIterate = toIterate.withIndex(index);
    if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
        const nodes = [];
        const cmp = index.getCompare();
        const iter = reverse ? toIterate.getReverseIteratorFrom(startPost, index) : toIterate.getIteratorFrom(startPost, index);
        let next = iter.getNext();
        while(next && nodes.length < count){
            if (cmp(next, startPost) !== 0) nodes.push(next);
            next = iter.getNext();
        }
        return nodes;
    } else return [];
}
function $494ac95ccfb2d9dd$var$newWriteTree() {
    return {
        visibleWrites: $494ac95ccfb2d9dd$var$CompoundWrite.empty(),
        allWrites: [],
        lastWriteId: -1
    };
}
/**
 * If possible, returns a complete event cache, using the underlying server data if possible. In addition, can be used
 * to get a cache that includes hidden writes, and excludes arbitrary writes. Note that customizing the returned node
 * can lead to a more expensive calculation.
 *
 * @param writeIdsToExclude - Optional writes to exclude.
 * @param includeHiddenWrites - Defaults to false, whether or not to layer on writes with visible set to false
 */ function $494ac95ccfb2d9dd$var$writeTreeRefCalcCompleteEventCache(writeTreeRef, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
    return $494ac95ccfb2d9dd$var$writeTreeCalcCompleteEventCache(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites);
}
/**
 * If possible, returns a children node containing all of the complete children we have data for. The returned data is a
 * mix of the given server data and write data.
 *
 */ function $494ac95ccfb2d9dd$var$writeTreeRefCalcCompleteEventChildren(writeTreeRef, completeServerChildren) {
    return $494ac95ccfb2d9dd$var$writeTreeCalcCompleteEventChildren(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerChildren);
}
/**
 * Given that either the underlying server data has updated or the outstanding writes have updated, determine what,
 * if anything, needs to be applied to the event cache.
 *
 * Possibilities:
 *
 * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
 *
 * 2. Some write is completely shadowing. No events to be raised
 *
 * 3. Is partially shadowed. Events should be raised
 *
 * Either existingEventSnap or existingServerSnap must exist, this is validated via an assert
 *
 *
 */ function $494ac95ccfb2d9dd$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writeTreeRef, path, existingEventSnap, existingServerSnap) {
    return $494ac95ccfb2d9dd$var$writeTreeCalcEventCacheAfterServerOverwrite(writeTreeRef.writeTree, writeTreeRef.treePath, path, existingEventSnap, existingServerSnap);
}
/**
 * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
 * a higher path, this will return the child of that write relative to the write and this path.
 * Returns null if there is no write at this path.
 *
 */ function $494ac95ccfb2d9dd$var$writeTreeRefShadowingWrite(writeTreeRef, path) {
    return $494ac95ccfb2d9dd$var$writeTreeShadowingWrite(writeTreeRef.writeTree, $494ac95ccfb2d9dd$var$pathChild(writeTreeRef.treePath, path));
}
/**
 * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
 * the window, but may now be in the window
 */ function $494ac95ccfb2d9dd$var$writeTreeRefCalcIndexedSlice(writeTreeRef, completeServerData, startPost, count, reverse, index) {
    return $494ac95ccfb2d9dd$var$writeTreeCalcIndexedSlice(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerData, startPost, count, reverse, index);
}
/**
 * Returns a complete child for a given server snap after applying all user writes or null if there is no
 * complete child for this ChildKey.
 */ function $494ac95ccfb2d9dd$var$writeTreeRefCalcCompleteChild(writeTreeRef, childKey, existingServerCache) {
    return $494ac95ccfb2d9dd$var$writeTreeCalcCompleteChild(writeTreeRef.writeTree, writeTreeRef.treePath, childKey, existingServerCache);
}
/**
 * Return a WriteTreeRef for a child.
 */ function $494ac95ccfb2d9dd$var$writeTreeRefChild(writeTreeRef, childName) {
    return $494ac95ccfb2d9dd$var$newWriteTreeRef($494ac95ccfb2d9dd$var$pathChild(writeTreeRef.treePath, childName), writeTreeRef.writeTree);
}
function $494ac95ccfb2d9dd$var$newWriteTreeRef(path, writeTree) {
    return {
        treePath: path,
        writeTree: writeTree
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $494ac95ccfb2d9dd$var$ChildChangeAccumulator {
    constructor(){
        this.changeMap = new Map();
    }
    trackChildChange(change) {
        const type = change.type;
        const childKey = change.childName;
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(type === "child_added" /* ChangeType.CHILD_ADDED */  || type === "child_changed" /* ChangeType.CHILD_CHANGED */  || type === "child_removed" /* ChangeType.CHILD_REMOVED */ , "Only child changes supported for tracking");
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(childKey !== ".priority", "Only non-priority child changes can be tracked.");
        const oldChange = this.changeMap.get(childKey);
        if (oldChange) {
            const oldType = oldChange.type;
            if (type === "child_added" /* ChangeType.CHILD_ADDED */  && oldType === "child_removed" /* ChangeType.CHILD_REMOVED */ ) this.changeMap.set(childKey, $494ac95ccfb2d9dd$var$changeChildChanged(childKey, change.snapshotNode, oldChange.snapshotNode));
            else if (type === "child_removed" /* ChangeType.CHILD_REMOVED */  && oldType === "child_added" /* ChangeType.CHILD_ADDED */ ) this.changeMap.delete(childKey);
            else if (type === "child_removed" /* ChangeType.CHILD_REMOVED */  && oldType === "child_changed" /* ChangeType.CHILD_CHANGED */ ) this.changeMap.set(childKey, $494ac95ccfb2d9dd$var$changeChildRemoved(childKey, oldChange.oldSnap));
            else if (type === "child_changed" /* ChangeType.CHILD_CHANGED */  && oldType === "child_added" /* ChangeType.CHILD_ADDED */ ) this.changeMap.set(childKey, $494ac95ccfb2d9dd$var$changeChildAdded(childKey, change.snapshotNode));
            else if (type === "child_changed" /* ChangeType.CHILD_CHANGED */  && oldType === "child_changed" /* ChangeType.CHILD_CHANGED */ ) this.changeMap.set(childKey, $494ac95ccfb2d9dd$var$changeChildChanged(childKey, change.snapshotNode, oldChange.oldSnap));
            else throw (0, $fc59d49e1bb53b6a$export$a39cad550e7ab28a)("Illegal combination of changes: " + change + " occurred after " + oldChange);
        } else this.changeMap.set(childKey, change);
    }
    getChanges() {
        return Array.from(this.changeMap.values());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An implementation of CompleteChildSource that never returns any additional children
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
class $494ac95ccfb2d9dd$var$NoCompleteChildSource_ {
    getCompleteChild(childKey) {
        return null;
    }
    getChildAfterChild(index, child, reverse) {
        return null;
    }
}
/**
 * Singleton instance.
 */ const $494ac95ccfb2d9dd$var$NO_COMPLETE_CHILD_SOURCE = new $494ac95ccfb2d9dd$var$NoCompleteChildSource_();
/**
 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
 * old event caches available to calculate complete children.
 */ class $494ac95ccfb2d9dd$var$WriteTreeCompleteChildSource {
    constructor(writes_, viewCache_, optCompleteServerCache_ = null){
        this.writes_ = writes_;
        this.viewCache_ = viewCache_;
        this.optCompleteServerCache_ = optCompleteServerCache_;
    }
    getCompleteChild(childKey) {
        const node = this.viewCache_.eventCache;
        if (node.isCompleteForChild(childKey)) return node.getNode().getImmediateChild(childKey);
        else {
            const serverNode = this.optCompleteServerCache_ != null ? new $494ac95ccfb2d9dd$var$CacheNode(this.optCompleteServerCache_, true, false) : this.viewCache_.serverCache;
            return $494ac95ccfb2d9dd$var$writeTreeRefCalcCompleteChild(this.writes_, childKey, serverNode);
        }
    }
    getChildAfterChild(index, child, reverse) {
        const completeServerData = this.optCompleteServerCache_ != null ? this.optCompleteServerCache_ : $494ac95ccfb2d9dd$var$viewCacheGetCompleteServerSnap(this.viewCache_);
        const nodes = $494ac95ccfb2d9dd$var$writeTreeRefCalcIndexedSlice(this.writes_, completeServerData, child, 1, reverse, index);
        if (nodes.length === 0) return null;
        else return nodes[0];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $494ac95ccfb2d9dd$var$newViewProcessor(filter) {
    return {
        filter: filter
    };
}
function $494ac95ccfb2d9dd$var$viewProcessorAssertIndexed(viewProcessor, viewCache) {
    (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(viewCache.eventCache.getNode().isIndexed(viewProcessor.filter.getIndex()), "Event snap not indexed");
    (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(viewCache.serverCache.getNode().isIndexed(viewProcessor.filter.getIndex()), "Server snap not indexed");
}
function $494ac95ccfb2d9dd$var$viewProcessorApplyOperation(viewProcessor, oldViewCache, operation, writesCache, completeCache) {
    const accumulator = new $494ac95ccfb2d9dd$var$ChildChangeAccumulator();
    let newViewCache, filterServerNode;
    if (operation.type === $494ac95ccfb2d9dd$var$OperationType.OVERWRITE) {
        const overwrite = operation;
        if (overwrite.source.fromUser) newViewCache = $494ac95ccfb2d9dd$var$viewProcessorApplyUserOverwrite(viewProcessor, oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
        else {
            (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(overwrite.source.fromServer, "Unknown source.");
            // We filter the node if it's a tagged update or the node has been previously filtered  and the
            // update is not at the root in which case it is ok (and necessary) to mark the node unfiltered
            // again
            filterServerNode = overwrite.source.tagged || oldViewCache.serverCache.isFiltered() && !$494ac95ccfb2d9dd$var$pathIsEmpty(overwrite.path);
            newViewCache = $494ac95ccfb2d9dd$var$viewProcessorApplyServerOverwrite(viewProcessor, oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
        }
    } else if (operation.type === $494ac95ccfb2d9dd$var$OperationType.MERGE) {
        const merge = operation;
        if (merge.source.fromUser) newViewCache = $494ac95ccfb2d9dd$var$viewProcessorApplyUserMerge(viewProcessor, oldViewCache, merge.path, merge.children, writesCache, completeCache, accumulator);
        else {
            (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(merge.source.fromServer, "Unknown source.");
            // We filter the node if it's a tagged update or the node has been previously filtered
            filterServerNode = merge.source.tagged || oldViewCache.serverCache.isFiltered();
            newViewCache = $494ac95ccfb2d9dd$var$viewProcessorApplyServerMerge(viewProcessor, oldViewCache, merge.path, merge.children, writesCache, completeCache, filterServerNode, accumulator);
        }
    } else if (operation.type === $494ac95ccfb2d9dd$var$OperationType.ACK_USER_WRITE) {
        const ackUserWrite = operation;
        if (!ackUserWrite.revert) newViewCache = $494ac95ccfb2d9dd$var$viewProcessorAckUserWrite(viewProcessor, oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
        else newViewCache = $494ac95ccfb2d9dd$var$viewProcessorRevertUserWrite(viewProcessor, oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
    } else if (operation.type === $494ac95ccfb2d9dd$var$OperationType.LISTEN_COMPLETE) newViewCache = $494ac95ccfb2d9dd$var$viewProcessorListenComplete(viewProcessor, oldViewCache, operation.path, writesCache, accumulator);
    else throw (0, $fc59d49e1bb53b6a$export$a39cad550e7ab28a)("Unknown operation type: " + operation.type);
    const changes = accumulator.getChanges();
    $494ac95ccfb2d9dd$var$viewProcessorMaybeAddValueEvent(oldViewCache, newViewCache, changes);
    return {
        viewCache: newViewCache,
        changes: changes
    };
}
function $494ac95ccfb2d9dd$var$viewProcessorMaybeAddValueEvent(oldViewCache, newViewCache, accumulator) {
    const eventSnap = newViewCache.eventCache;
    if (eventSnap.isFullyInitialized()) {
        const isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
        const oldCompleteSnap = $494ac95ccfb2d9dd$var$viewCacheGetCompleteEventSnap(oldViewCache);
        if (accumulator.length > 0 || !oldViewCache.eventCache.isFullyInitialized() || isLeafOrEmpty && !eventSnap.getNode().equals(oldCompleteSnap) || !eventSnap.getNode().getPriority().equals(oldCompleteSnap.getPriority())) accumulator.push($494ac95ccfb2d9dd$var$changeValue($494ac95ccfb2d9dd$var$viewCacheGetCompleteEventSnap(newViewCache)));
    }
}
function $494ac95ccfb2d9dd$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, viewCache, changePath, writesCache, source, accumulator) {
    const oldEventSnap = viewCache.eventCache;
    if ($494ac95ccfb2d9dd$var$writeTreeRefShadowingWrite(writesCache, changePath) != null) // we have a shadowing write, ignore changes
    return viewCache;
    else {
        let newEventCache, serverNode;
        if ($494ac95ccfb2d9dd$var$pathIsEmpty(changePath)) {
            // TODO: figure out how this plays with "sliding ack windows"
            (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(viewCache.serverCache.isFullyInitialized(), "If change path is empty, we must have complete server data");
            if (viewCache.serverCache.isFiltered()) {
                // We need to special case this, because we need to only apply writes to complete children, or
                // we might end up raising events for incomplete children. If the server data is filtered deep
                // writes cannot be guaranteed to be complete
                const serverCache = $494ac95ccfb2d9dd$var$viewCacheGetCompleteServerSnap(viewCache);
                const completeChildren = serverCache instanceof $494ac95ccfb2d9dd$var$ChildrenNode ? serverCache : $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE;
                const completeEventChildren = $494ac95ccfb2d9dd$var$writeTreeRefCalcCompleteEventChildren(writesCache, completeChildren);
                newEventCache = viewProcessor.filter.updateFullNode(viewCache.eventCache.getNode(), completeEventChildren, accumulator);
            } else {
                const completeNode = $494ac95ccfb2d9dd$var$writeTreeRefCalcCompleteEventCache(writesCache, $494ac95ccfb2d9dd$var$viewCacheGetCompleteServerSnap(viewCache));
                newEventCache = viewProcessor.filter.updateFullNode(viewCache.eventCache.getNode(), completeNode, accumulator);
            }
        } else {
            const childKey = $494ac95ccfb2d9dd$var$pathGetFront(changePath);
            if (childKey === ".priority") {
                (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)($494ac95ccfb2d9dd$var$pathGetLength(changePath) === 1, "Can't have a priority with additional path components");
                const oldEventNode = oldEventSnap.getNode();
                serverNode = viewCache.serverCache.getNode();
                // we might have overwrites for this priority
                const updatedPriority = $494ac95ccfb2d9dd$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writesCache, changePath, oldEventNode, serverNode);
                if (updatedPriority != null) newEventCache = viewProcessor.filter.updatePriority(oldEventNode, updatedPriority);
                else // priority didn't change, keep old node
                newEventCache = oldEventSnap.getNode();
            } else {
                const childChangePath = $494ac95ccfb2d9dd$var$pathPopFront(changePath);
                // update child
                let newEventChild;
                if (oldEventSnap.isCompleteForChild(childKey)) {
                    serverNode = viewCache.serverCache.getNode();
                    const eventChildUpdate = $494ac95ccfb2d9dd$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writesCache, changePath, oldEventSnap.getNode(), serverNode);
                    if (eventChildUpdate != null) newEventChild = oldEventSnap.getNode().getImmediateChild(childKey).updateChild(childChangePath, eventChildUpdate);
                    else // Nothing changed, just keep the old child
                    newEventChild = oldEventSnap.getNode().getImmediateChild(childKey);
                } else newEventChild = $494ac95ccfb2d9dd$var$writeTreeRefCalcCompleteChild(writesCache, childKey, viewCache.serverCache);
                if (newEventChild != null) newEventCache = viewProcessor.filter.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
                else // no complete child available or no change
                newEventCache = oldEventSnap.getNode();
            }
        }
        return $494ac95ccfb2d9dd$var$viewCacheUpdateEventSnap(viewCache, newEventCache, oldEventSnap.isFullyInitialized() || $494ac95ccfb2d9dd$var$pathIsEmpty(changePath), viewProcessor.filter.filtersNodes());
    }
}
function $494ac95ccfb2d9dd$var$viewProcessorApplyServerOverwrite(viewProcessor, oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
    const oldServerSnap = oldViewCache.serverCache;
    let newServerCache;
    const serverFilter = filterServerNode ? viewProcessor.filter : viewProcessor.filter.getIndexedFilter();
    if ($494ac95ccfb2d9dd$var$pathIsEmpty(changePath)) newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
    else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
        // we want to filter the server node, but we didn't filter the server node yet, so simulate a full update
        const newServerNode = oldServerSnap.getNode().updateChild(changePath, changedSnap);
        newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
    } else {
        const childKey = $494ac95ccfb2d9dd$var$pathGetFront(changePath);
        if (!oldServerSnap.isCompleteForPath(changePath) && $494ac95ccfb2d9dd$var$pathGetLength(changePath) > 1) // We don't update incomplete nodes with updates intended for other listeners
        return oldViewCache;
        const childChangePath = $494ac95ccfb2d9dd$var$pathPopFront(changePath);
        const childNode = oldServerSnap.getNode().getImmediateChild(childKey);
        const newChildNode = childNode.updateChild(childChangePath, changedSnap);
        if (childKey === ".priority") newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
        else newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, $494ac95ccfb2d9dd$var$NO_COMPLETE_CHILD_SOURCE, null);
    }
    const newViewCache = $494ac95ccfb2d9dd$var$viewCacheUpdateServerSnap(oldViewCache, newServerCache, oldServerSnap.isFullyInitialized() || $494ac95ccfb2d9dd$var$pathIsEmpty(changePath), serverFilter.filtersNodes());
    const source = new $494ac95ccfb2d9dd$var$WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
    return $494ac95ccfb2d9dd$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, newViewCache, changePath, writesCache, source, accumulator);
}
function $494ac95ccfb2d9dd$var$viewProcessorApplyUserOverwrite(viewProcessor, oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
    const oldEventSnap = oldViewCache.eventCache;
    let newViewCache, newEventCache;
    const source = new $494ac95ccfb2d9dd$var$WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
    if ($494ac95ccfb2d9dd$var$pathIsEmpty(changePath)) {
        newEventCache = viewProcessor.filter.updateFullNode(oldViewCache.eventCache.getNode(), changedSnap, accumulator);
        newViewCache = $494ac95ccfb2d9dd$var$viewCacheUpdateEventSnap(oldViewCache, newEventCache, true, viewProcessor.filter.filtersNodes());
    } else {
        const childKey = $494ac95ccfb2d9dd$var$pathGetFront(changePath);
        if (childKey === ".priority") {
            newEventCache = viewProcessor.filter.updatePriority(oldViewCache.eventCache.getNode(), changedSnap);
            newViewCache = $494ac95ccfb2d9dd$var$viewCacheUpdateEventSnap(oldViewCache, newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
        } else {
            const childChangePath = $494ac95ccfb2d9dd$var$pathPopFront(changePath);
            const oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
            let newChild;
            if ($494ac95ccfb2d9dd$var$pathIsEmpty(childChangePath)) // Child overwrite, we can replace the child
            newChild = changedSnap;
            else {
                const childNode = source.getCompleteChild(childKey);
                if (childNode != null) {
                    if ($494ac95ccfb2d9dd$var$pathGetBack(childChangePath) === ".priority" && childNode.getChild($494ac95ccfb2d9dd$var$pathParent(childChangePath)).isEmpty()) // This is a priority update on an empty node. If this node exists on the server, the
                    // server will send down the priority in the update, so ignore for now
                    newChild = childNode;
                    else newChild = childNode.updateChild(childChangePath, changedSnap);
                } else // There is no complete child node available
                newChild = $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE;
            }
            if (!oldChild.equals(newChild)) {
                const newEventSnap = viewProcessor.filter.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
                newViewCache = $494ac95ccfb2d9dd$var$viewCacheUpdateEventSnap(oldViewCache, newEventSnap, oldEventSnap.isFullyInitialized(), viewProcessor.filter.filtersNodes());
            } else newViewCache = oldViewCache;
        }
    }
    return newViewCache;
}
function $494ac95ccfb2d9dd$var$viewProcessorCacheHasChild(viewCache, childKey) {
    return viewCache.eventCache.isCompleteForChild(childKey);
}
function $494ac95ccfb2d9dd$var$viewProcessorApplyUserMerge(viewProcessor, viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
    // HACK: In the case of a limit query, there may be some changes that bump things out of the
    // window leaving room for new items.  It's important we process these changes first, so we
    // iterate the changes twice, first processing any that affect items currently in view.
    // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
    // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
    // not the other.
    let curViewCache = viewCache;
    changedChildren.foreach((relativePath, childNode)=>{
        const writePath = $494ac95ccfb2d9dd$var$pathChild(path, relativePath);
        if ($494ac95ccfb2d9dd$var$viewProcessorCacheHasChild(viewCache, $494ac95ccfb2d9dd$var$pathGetFront(writePath))) curViewCache = $494ac95ccfb2d9dd$var$viewProcessorApplyUserOverwrite(viewProcessor, curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
    });
    changedChildren.foreach((relativePath, childNode)=>{
        const writePath = $494ac95ccfb2d9dd$var$pathChild(path, relativePath);
        if (!$494ac95ccfb2d9dd$var$viewProcessorCacheHasChild(viewCache, $494ac95ccfb2d9dd$var$pathGetFront(writePath))) curViewCache = $494ac95ccfb2d9dd$var$viewProcessorApplyUserOverwrite(viewProcessor, curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
    });
    return curViewCache;
}
function $494ac95ccfb2d9dd$var$viewProcessorApplyMerge(viewProcessor, node, merge) {
    merge.foreach((relativePath, childNode)=>{
        node = node.updateChild(relativePath, childNode);
    });
    return node;
}
function $494ac95ccfb2d9dd$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
    // If we don't have a cache yet, this merge was intended for a previously listen in the same location. Ignore it and
    // wait for the complete data update coming soon.
    if (viewCache.serverCache.getNode().isEmpty() && !viewCache.serverCache.isFullyInitialized()) return viewCache;
    // HACK: In the case of a limit query, there may be some changes that bump things out of the
    // window leaving room for new items.  It's important we process these changes first, so we
    // iterate the changes twice, first processing any that affect items currently in view.
    // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
    // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
    // not the other.
    let curViewCache = viewCache;
    let viewMergeTree;
    if ($494ac95ccfb2d9dd$var$pathIsEmpty(path)) viewMergeTree = changedChildren;
    else viewMergeTree = new $494ac95ccfb2d9dd$var$ImmutableTree(null).setTree(path, changedChildren);
    const serverNode = viewCache.serverCache.getNode();
    viewMergeTree.children.inorderTraversal((childKey, childTree)=>{
        if (serverNode.hasChild(childKey)) {
            const serverChild = viewCache.serverCache.getNode().getImmediateChild(childKey);
            const newChild = $494ac95ccfb2d9dd$var$viewProcessorApplyMerge(viewProcessor, serverChild, childTree);
            curViewCache = $494ac95ccfb2d9dd$var$viewProcessorApplyServerOverwrite(viewProcessor, curViewCache, new $494ac95ccfb2d9dd$var$Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
        }
    });
    viewMergeTree.children.inorderTraversal((childKey, childMergeTree)=>{
        const isUnknownDeepMerge = !viewCache.serverCache.isCompleteForChild(childKey) && childMergeTree.value === null;
        if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
            const serverChild = viewCache.serverCache.getNode().getImmediateChild(childKey);
            const newChild = $494ac95ccfb2d9dd$var$viewProcessorApplyMerge(viewProcessor, serverChild, childMergeTree);
            curViewCache = $494ac95ccfb2d9dd$var$viewProcessorApplyServerOverwrite(viewProcessor, curViewCache, new $494ac95ccfb2d9dd$var$Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
        }
    });
    return curViewCache;
}
function $494ac95ccfb2d9dd$var$viewProcessorAckUserWrite(viewProcessor, viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
    if ($494ac95ccfb2d9dd$var$writeTreeRefShadowingWrite(writesCache, ackPath) != null) return viewCache;
    // Only filter server node if it is currently filtered
    const filterServerNode = viewCache.serverCache.isFiltered();
    // Essentially we'll just get our existing server cache for the affected paths and re-apply it as a server update
    // now that it won't be shadowed.
    const serverCache = viewCache.serverCache;
    if (affectedTree.value != null) {
        // This is an overwrite.
        if ($494ac95ccfb2d9dd$var$pathIsEmpty(ackPath) && serverCache.isFullyInitialized() || serverCache.isCompleteForPath(ackPath)) return $494ac95ccfb2d9dd$var$viewProcessorApplyServerOverwrite(viewProcessor, viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
        else if ($494ac95ccfb2d9dd$var$pathIsEmpty(ackPath)) {
            // This is a goofy edge case where we are acking data at this location but don't have full data.  We
            // should just re-apply whatever we have in our cache as a merge.
            let changedChildren = new $494ac95ccfb2d9dd$var$ImmutableTree(null);
            serverCache.getNode().forEachChild($494ac95ccfb2d9dd$var$KEY_INDEX, (name, node)=>{
                changedChildren = changedChildren.set(new $494ac95ccfb2d9dd$var$Path(name), node);
            });
            return $494ac95ccfb2d9dd$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, ackPath, changedChildren, writesCache, completeCache, filterServerNode, accumulator);
        } else return viewCache;
    } else {
        // This is a merge.
        let changedChildren = new $494ac95ccfb2d9dd$var$ImmutableTree(null);
        affectedTree.foreach((mergePath, value)=>{
            const serverCachePath = $494ac95ccfb2d9dd$var$pathChild(ackPath, mergePath);
            if (serverCache.isCompleteForPath(serverCachePath)) changedChildren = changedChildren.set(mergePath, serverCache.getNode().getChild(serverCachePath));
        });
        return $494ac95ccfb2d9dd$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, ackPath, changedChildren, writesCache, completeCache, filterServerNode, accumulator);
    }
}
function $494ac95ccfb2d9dd$var$viewProcessorListenComplete(viewProcessor, viewCache, path, writesCache, accumulator) {
    const oldServerNode = viewCache.serverCache;
    const newViewCache = $494ac95ccfb2d9dd$var$viewCacheUpdateServerSnap(viewCache, oldServerNode.getNode(), oldServerNode.isFullyInitialized() || $494ac95ccfb2d9dd$var$pathIsEmpty(path), oldServerNode.isFiltered());
    return $494ac95ccfb2d9dd$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, newViewCache, path, writesCache, $494ac95ccfb2d9dd$var$NO_COMPLETE_CHILD_SOURCE, accumulator);
}
function $494ac95ccfb2d9dd$var$viewProcessorRevertUserWrite(viewProcessor, viewCache, path, writesCache, completeServerCache, accumulator) {
    let complete;
    if ($494ac95ccfb2d9dd$var$writeTreeRefShadowingWrite(writesCache, path) != null) return viewCache;
    else {
        const source = new $494ac95ccfb2d9dd$var$WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
        const oldEventCache = viewCache.eventCache.getNode();
        let newEventCache;
        if ($494ac95ccfb2d9dd$var$pathIsEmpty(path) || $494ac95ccfb2d9dd$var$pathGetFront(path) === ".priority") {
            let newNode;
            if (viewCache.serverCache.isFullyInitialized()) newNode = $494ac95ccfb2d9dd$var$writeTreeRefCalcCompleteEventCache(writesCache, $494ac95ccfb2d9dd$var$viewCacheGetCompleteServerSnap(viewCache));
            else {
                const serverChildren = viewCache.serverCache.getNode();
                (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(serverChildren instanceof $494ac95ccfb2d9dd$var$ChildrenNode, "serverChildren would be complete if leaf node");
                newNode = $494ac95ccfb2d9dd$var$writeTreeRefCalcCompleteEventChildren(writesCache, serverChildren);
            }
            newNode;
            newEventCache = viewProcessor.filter.updateFullNode(oldEventCache, newNode, accumulator);
        } else {
            const childKey = $494ac95ccfb2d9dd$var$pathGetFront(path);
            let newChild = $494ac95ccfb2d9dd$var$writeTreeRefCalcCompleteChild(writesCache, childKey, viewCache.serverCache);
            if (newChild == null && viewCache.serverCache.isCompleteForChild(childKey)) newChild = oldEventCache.getImmediateChild(childKey);
            if (newChild != null) newEventCache = viewProcessor.filter.updateChild(oldEventCache, childKey, newChild, $494ac95ccfb2d9dd$var$pathPopFront(path), source, accumulator);
            else if (viewCache.eventCache.getNode().hasChild(childKey)) // No complete child available, delete the existing one, if any
            newEventCache = viewProcessor.filter.updateChild(oldEventCache, childKey, $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE, $494ac95ccfb2d9dd$var$pathPopFront(path), source, accumulator);
            else newEventCache = oldEventCache;
            if (newEventCache.isEmpty() && viewCache.serverCache.isFullyInitialized()) {
                // We might have reverted all child writes. Maybe the old event was a leaf node
                complete = $494ac95ccfb2d9dd$var$writeTreeRefCalcCompleteEventCache(writesCache, $494ac95ccfb2d9dd$var$viewCacheGetCompleteServerSnap(viewCache));
                if (complete.isLeafNode()) newEventCache = viewProcessor.filter.updateFullNode(newEventCache, complete, accumulator);
            }
        }
        complete = viewCache.serverCache.isFullyInitialized() || $494ac95ccfb2d9dd$var$writeTreeRefShadowingWrite(writesCache, $494ac95ccfb2d9dd$var$newEmptyPath()) != null;
        return $494ac95ccfb2d9dd$var$viewCacheUpdateEventSnap(viewCache, newEventCache, complete, viewProcessor.filter.filtersNodes());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A view represents a specific location and query that has 1 or more event registrations.
 *
 * It does several things:
 *  - Maintains the list of event registrations for this location/query.
 *  - Maintains a cache of the data visible for this location/query.
 *  - Applies new operations (via applyOperation), updates the cache, and based on the event
 *    registrations returns the set of events to be raised.
 */ class $494ac95ccfb2d9dd$var$View {
    constructor(query_, initialViewCache){
        this.query_ = query_;
        this.eventRegistrations_ = [];
        const params = this.query_._queryParams;
        const indexFilter = new $494ac95ccfb2d9dd$var$IndexedFilter(params.getIndex());
        const filter = $494ac95ccfb2d9dd$var$queryParamsGetNodeFilter(params);
        this.processor_ = $494ac95ccfb2d9dd$var$newViewProcessor(filter);
        const initialServerCache = initialViewCache.serverCache;
        const initialEventCache = initialViewCache.eventCache;
        // Don't filter server node with other filter than index, wait for tagged listen
        const serverSnap = indexFilter.updateFullNode($494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
        const eventSnap = filter.updateFullNode($494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
        const newServerCache = new $494ac95ccfb2d9dd$var$CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
        const newEventCache = new $494ac95ccfb2d9dd$var$CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter.filtersNodes());
        this.viewCache_ = $494ac95ccfb2d9dd$var$newViewCache(newEventCache, newServerCache);
        this.eventGenerator_ = new $494ac95ccfb2d9dd$var$EventGenerator(this.query_);
    }
    get query() {
        return this.query_;
    }
}
function $494ac95ccfb2d9dd$var$viewGetServerCache(view) {
    return view.viewCache_.serverCache.getNode();
}
function $494ac95ccfb2d9dd$var$viewGetCompleteNode(view) {
    return $494ac95ccfb2d9dd$var$viewCacheGetCompleteEventSnap(view.viewCache_);
}
function $494ac95ccfb2d9dd$var$viewGetCompleteServerCache(view, path) {
    const cache = $494ac95ccfb2d9dd$var$viewCacheGetCompleteServerSnap(view.viewCache_);
    if (cache) {
        // If this isn't a "loadsAllData" view, then cache isn't actually a complete cache and
        // we need to see if it contains the child we're interested in.
        if (view.query._queryParams.loadsAllData() || !$494ac95ccfb2d9dd$var$pathIsEmpty(path) && !cache.getImmediateChild($494ac95ccfb2d9dd$var$pathGetFront(path)).isEmpty()) return cache.getChild(path);
    }
    return null;
}
function $494ac95ccfb2d9dd$var$viewIsEmpty(view) {
    return view.eventRegistrations_.length === 0;
}
function $494ac95ccfb2d9dd$var$viewAddEventRegistration(view, eventRegistration) {
    view.eventRegistrations_.push(eventRegistration);
}
/**
 * @param eventRegistration - If null, remove all callbacks.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @returns Cancel events, if cancelError was provided.
 */ function $494ac95ccfb2d9dd$var$viewRemoveEventRegistration(view, eventRegistration, cancelError) {
    const cancelEvents = [];
    if (cancelError) {
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(eventRegistration == null, "A cancel should cancel all event registrations.");
        const path = view.query._path;
        view.eventRegistrations_.forEach((registration)=>{
            const maybeEvent = registration.createCancelEvent(cancelError, path);
            if (maybeEvent) cancelEvents.push(maybeEvent);
        });
    }
    if (eventRegistration) {
        let remaining = [];
        for(let i = 0; i < view.eventRegistrations_.length; ++i){
            const existing = view.eventRegistrations_[i];
            if (!existing.matches(eventRegistration)) remaining.push(existing);
            else if (eventRegistration.hasAnyCallback()) {
                // We're removing just this one
                remaining = remaining.concat(view.eventRegistrations_.slice(i + 1));
                break;
            }
        }
        view.eventRegistrations_ = remaining;
    } else view.eventRegistrations_ = [];
    return cancelEvents;
}
/**
 * Applies the given Operation, updates our cache, and returns the appropriate events.
 */ function $494ac95ccfb2d9dd$var$viewApplyOperation(view, operation, writesCache, completeServerCache) {
    if (operation.type === $494ac95ccfb2d9dd$var$OperationType.MERGE && operation.source.queryId !== null) {
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)($494ac95ccfb2d9dd$var$viewCacheGetCompleteServerSnap(view.viewCache_), "We should always have a full cache before handling merges");
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)($494ac95ccfb2d9dd$var$viewCacheGetCompleteEventSnap(view.viewCache_), "Missing event cache, even though we have a server cache");
    }
    const oldViewCache = view.viewCache_;
    const result = $494ac95ccfb2d9dd$var$viewProcessorApplyOperation(view.processor_, oldViewCache, operation, writesCache, completeServerCache);
    $494ac95ccfb2d9dd$var$viewProcessorAssertIndexed(view.processor_, result.viewCache);
    (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(result.viewCache.serverCache.isFullyInitialized() || !oldViewCache.serverCache.isFullyInitialized(), "Once a server snap is complete, it should never go back");
    view.viewCache_ = result.viewCache;
    return $494ac95ccfb2d9dd$var$viewGenerateEventsForChanges_(view, result.changes, result.viewCache.eventCache.getNode(), null);
}
function $494ac95ccfb2d9dd$var$viewGetInitialEvents(view, registration) {
    const eventSnap = view.viewCache_.eventCache;
    const initialChanges = [];
    if (!eventSnap.getNode().isLeafNode()) {
        const eventNode = eventSnap.getNode();
        eventNode.forEachChild($494ac95ccfb2d9dd$var$PRIORITY_INDEX, (key, childNode)=>{
            initialChanges.push($494ac95ccfb2d9dd$var$changeChildAdded(key, childNode));
        });
    }
    if (eventSnap.isFullyInitialized()) initialChanges.push($494ac95ccfb2d9dd$var$changeValue(eventSnap.getNode()));
    return $494ac95ccfb2d9dd$var$viewGenerateEventsForChanges_(view, initialChanges, eventSnap.getNode(), registration);
}
function $494ac95ccfb2d9dd$var$viewGenerateEventsForChanges_(view, changes, eventCache, eventRegistration) {
    const registrations = eventRegistration ? [
        eventRegistration
    ] : view.eventRegistrations_;
    return $494ac95ccfb2d9dd$var$eventGeneratorGenerateEventsForChanges(view.eventGenerator_, changes, eventCache, registrations);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $494ac95ccfb2d9dd$var$referenceConstructor$1;
/**
 * SyncPoint represents a single location in a SyncTree with 1 or more event registrations, meaning we need to
 * maintain 1 or more Views at this location to cache server data and raise appropriate events for server changes
 * and user writes (set, transaction, update).
 *
 * It's responsible for:
 *  - Maintaining the set of 1 or more views necessary at this location (a SyncPoint with 0 views should be removed).
 *  - Proxying user / server operations to the views as appropriate (i.e. applyServerOverwrite,
 *    applyUserOverwrite, etc.)
 */ class $494ac95ccfb2d9dd$var$SyncPoint {
    constructor(){
        /**
         * The Views being tracked at this location in the tree, stored as a map where the key is a
         * queryId and the value is the View for that query.
         *
         * NOTE: This list will be quite small (usually 1, but perhaps 2 or 3; any more is an odd use case).
         */ this.views = new Map();
    }
}
function $494ac95ccfb2d9dd$var$syncPointSetReferenceConstructor(val) {
    (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(!$494ac95ccfb2d9dd$var$referenceConstructor$1, "__referenceConstructor has already been defined");
    $494ac95ccfb2d9dd$var$referenceConstructor$1 = val;
}
function $494ac95ccfb2d9dd$var$syncPointGetReferenceConstructor() {
    (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)($494ac95ccfb2d9dd$var$referenceConstructor$1, "Reference.ts has not been loaded");
    return $494ac95ccfb2d9dd$var$referenceConstructor$1;
}
function $494ac95ccfb2d9dd$var$syncPointIsEmpty(syncPoint) {
    return syncPoint.views.size === 0;
}
function $494ac95ccfb2d9dd$var$syncPointApplyOperation(syncPoint, operation, writesCache, optCompleteServerCache) {
    const queryId = operation.source.queryId;
    if (queryId !== null) {
        const view = syncPoint.views.get(queryId);
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(view != null, "SyncTree gave us an op for an invalid query.");
        return $494ac95ccfb2d9dd$var$viewApplyOperation(view, operation, writesCache, optCompleteServerCache);
    } else {
        let events = [];
        for (const view of syncPoint.views.values())events = events.concat($494ac95ccfb2d9dd$var$viewApplyOperation(view, operation, writesCache, optCompleteServerCache));
        return events;
    }
}
/**
 * Get a view for the specified query.
 *
 * @param query - The query to return a view for
 * @param writesCache
 * @param serverCache
 * @param serverCacheComplete
 * @returns Events to raise.
 */ function $494ac95ccfb2d9dd$var$syncPointGetView(syncPoint, query, writesCache, serverCache, serverCacheComplete) {
    const queryId = query._queryIdentifier;
    const view = syncPoint.views.get(queryId);
    if (!view) {
        // TODO: make writesCache take flag for complete server node
        let eventCache = $494ac95ccfb2d9dd$var$writeTreeRefCalcCompleteEventCache(writesCache, serverCacheComplete ? serverCache : null);
        let eventCacheComplete = false;
        if (eventCache) eventCacheComplete = true;
        else if (serverCache instanceof $494ac95ccfb2d9dd$var$ChildrenNode) {
            eventCache = $494ac95ccfb2d9dd$var$writeTreeRefCalcCompleteEventChildren(writesCache, serverCache);
            eventCacheComplete = false;
        } else {
            eventCache = $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE;
            eventCacheComplete = false;
        }
        const viewCache = $494ac95ccfb2d9dd$var$newViewCache(new $494ac95ccfb2d9dd$var$CacheNode(eventCache, eventCacheComplete, false), new $494ac95ccfb2d9dd$var$CacheNode(serverCache, serverCacheComplete, false));
        return new $494ac95ccfb2d9dd$var$View(query, viewCache);
    }
    return view;
}
/**
 * Add an event callback for the specified query.
 *
 * @param query
 * @param eventRegistration
 * @param writesCache
 * @param serverCache - Complete server cache, if we have it.
 * @param serverCacheComplete
 * @returns Events to raise.
 */ function $494ac95ccfb2d9dd$var$syncPointAddEventRegistration(syncPoint, query, eventRegistration, writesCache, serverCache, serverCacheComplete) {
    const view = $494ac95ccfb2d9dd$var$syncPointGetView(syncPoint, query, writesCache, serverCache, serverCacheComplete);
    if (!syncPoint.views.has(query._queryIdentifier)) syncPoint.views.set(query._queryIdentifier, view);
    // This is guaranteed to exist now, we just created anything that was missing
    $494ac95ccfb2d9dd$var$viewAddEventRegistration(view, eventRegistration);
    return $494ac95ccfb2d9dd$var$viewGetInitialEvents(view, eventRegistration);
}
/**
 * Remove event callback(s).  Return cancelEvents if a cancelError is specified.
 *
 * If query is the default query, we'll check all views for the specified eventRegistration.
 * If eventRegistration is null, we'll remove all callbacks for the specified view(s).
 *
 * @param eventRegistration - If null, remove all callbacks.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @returns removed queries and any cancel events
 */ function $494ac95ccfb2d9dd$var$syncPointRemoveEventRegistration(syncPoint, query, eventRegistration, cancelError) {
    const queryId = query._queryIdentifier;
    const removed = [];
    let cancelEvents = [];
    const hadCompleteView = $494ac95ccfb2d9dd$var$syncPointHasCompleteView(syncPoint);
    if (queryId === "default") // When you do ref.off(...), we search all views for the registration to remove.
    for (const [viewQueryId, view] of syncPoint.views.entries()){
        cancelEvents = cancelEvents.concat($494ac95ccfb2d9dd$var$viewRemoveEventRegistration(view, eventRegistration, cancelError));
        if ($494ac95ccfb2d9dd$var$viewIsEmpty(view)) {
            syncPoint.views.delete(viewQueryId);
            // We'll deal with complete views later.
            if (!view.query._queryParams.loadsAllData()) removed.push(view.query);
        }
    }
    else {
        // remove the callback from the specific view.
        const view = syncPoint.views.get(queryId);
        if (view) {
            cancelEvents = cancelEvents.concat($494ac95ccfb2d9dd$var$viewRemoveEventRegistration(view, eventRegistration, cancelError));
            if ($494ac95ccfb2d9dd$var$viewIsEmpty(view)) {
                syncPoint.views.delete(queryId);
                // We'll deal with complete views later.
                if (!view.query._queryParams.loadsAllData()) removed.push(view.query);
            }
        }
    }
    if (hadCompleteView && !$494ac95ccfb2d9dd$var$syncPointHasCompleteView(syncPoint)) // We removed our last complete view.
    removed.push(new ($494ac95ccfb2d9dd$var$syncPointGetReferenceConstructor())(query._repo, query._path));
    return {
        removed: removed,
        events: cancelEvents
    };
}
function $494ac95ccfb2d9dd$var$syncPointGetQueryViews(syncPoint) {
    const result = [];
    for (const view of syncPoint.views.values())if (!view.query._queryParams.loadsAllData()) result.push(view);
    return result;
}
/**
 * @param path - The path to the desired complete snapshot
 * @returns A complete cache, if it exists
 */ function $494ac95ccfb2d9dd$var$syncPointGetCompleteServerCache(syncPoint, path) {
    let serverCache = null;
    for (const view of syncPoint.views.values())serverCache = serverCache || $494ac95ccfb2d9dd$var$viewGetCompleteServerCache(view, path);
    return serverCache;
}
function $494ac95ccfb2d9dd$var$syncPointViewForQuery(syncPoint, query) {
    const params = query._queryParams;
    if (params.loadsAllData()) return $494ac95ccfb2d9dd$var$syncPointGetCompleteView(syncPoint);
    else {
        const queryId = query._queryIdentifier;
        return syncPoint.views.get(queryId);
    }
}
function $494ac95ccfb2d9dd$var$syncPointViewExistsForQuery(syncPoint, query) {
    return $494ac95ccfb2d9dd$var$syncPointViewForQuery(syncPoint, query) != null;
}
function $494ac95ccfb2d9dd$var$syncPointHasCompleteView(syncPoint) {
    return $494ac95ccfb2d9dd$var$syncPointGetCompleteView(syncPoint) != null;
}
function $494ac95ccfb2d9dd$var$syncPointGetCompleteView(syncPoint) {
    for (const view of syncPoint.views.values()){
        if (view.query._queryParams.loadsAllData()) return view;
    }
    return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $494ac95ccfb2d9dd$var$referenceConstructor;
function $494ac95ccfb2d9dd$var$syncTreeSetReferenceConstructor(val) {
    (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(!$494ac95ccfb2d9dd$var$referenceConstructor, "__referenceConstructor has already been defined");
    $494ac95ccfb2d9dd$var$referenceConstructor = val;
}
function $494ac95ccfb2d9dd$var$syncTreeGetReferenceConstructor() {
    (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)($494ac95ccfb2d9dd$var$referenceConstructor, "Reference.ts has not been loaded");
    return $494ac95ccfb2d9dd$var$referenceConstructor;
}
/**
 * Static tracker for next query tag.
 */ let $494ac95ccfb2d9dd$var$syncTreeNextQueryTag_ = 1;
/**
 * SyncTree is the central class for managing event callback registration, data caching, views
 * (query processing), and event generation.  There are typically two SyncTree instances for
 * each Repo, one for the normal Firebase data, and one for the .info data.
 *
 * It has a number of responsibilities, including:
 *  - Tracking all user event callbacks (registered via addEventRegistration() and removeEventRegistration()).
 *  - Applying and caching data changes for user set(), transaction(), and update() calls
 *    (applyUserOverwrite(), applyUserMerge()).
 *  - Applying and caching data changes for server data changes (applyServerOverwrite(),
 *    applyServerMerge()).
 *  - Generating user-facing events for server and user changes (all of the apply* methods
 *    return the set of events that need to be raised as a result).
 *  - Maintaining the appropriate set of server listens to ensure we are always subscribed
 *    to the correct set of paths and queries to satisfy the current set of user event
 *    callbacks (listens are started/stopped using the provided listenProvider).
 *
 * NOTE: Although SyncTree tracks event callbacks and calculates events to raise, the actual
 * events are returned to the caller rather than raised synchronously.
 *
 */ class $494ac95ccfb2d9dd$var$SyncTree {
    /**
     * @param listenProvider_ - Used by SyncTree to start / stop listening
     *   to server data.
     */ constructor(listenProvider_){
        this.listenProvider_ = listenProvider_;
        /**
         * Tree of SyncPoints.  There's a SyncPoint at any location that has 1 or more views.
         */ this.syncPointTree_ = new $494ac95ccfb2d9dd$var$ImmutableTree(null);
        /**
         * A tree of all pending user writes (user-initiated set()'s, transaction()'s, update()'s, etc.).
         */ this.pendingWriteTree_ = $494ac95ccfb2d9dd$var$newWriteTree();
        this.tagToQueryMap = new Map();
        this.queryToTagMap = new Map();
    }
}
/**
 * Apply the data changes for a user-generated set() or transaction() call.
 *
 * @returns Events to raise.
 */ function $494ac95ccfb2d9dd$var$syncTreeApplyUserOverwrite(syncTree, path, newData, writeId, visible) {
    // Record pending write.
    $494ac95ccfb2d9dd$var$writeTreeAddOverwrite(syncTree.pendingWriteTree_, path, newData, writeId, visible);
    if (!visible) return [];
    else return $494ac95ccfb2d9dd$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $494ac95ccfb2d9dd$var$Overwrite($494ac95ccfb2d9dd$var$newOperationSourceUser(), path, newData));
}
/**
 * Apply the data from a user-generated update() call
 *
 * @returns Events to raise.
 */ function $494ac95ccfb2d9dd$var$syncTreeApplyUserMerge(syncTree, path, changedChildren, writeId) {
    // Record pending merge.
    $494ac95ccfb2d9dd$var$writeTreeAddMerge(syncTree.pendingWriteTree_, path, changedChildren, writeId);
    const changeTree = $494ac95ccfb2d9dd$var$ImmutableTree.fromObject(changedChildren);
    return $494ac95ccfb2d9dd$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $494ac95ccfb2d9dd$var$Merge($494ac95ccfb2d9dd$var$newOperationSourceUser(), path, changeTree));
}
/**
 * Acknowledge a pending user write that was previously registered with applyUserOverwrite() or applyUserMerge().
 *
 * @param revert - True if the given write failed and needs to be reverted
 * @returns Events to raise.
 */ function $494ac95ccfb2d9dd$var$syncTreeAckUserWrite(syncTree, writeId, revert = false) {
    const write = $494ac95ccfb2d9dd$var$writeTreeGetWrite(syncTree.pendingWriteTree_, writeId);
    const needToReevaluate = $494ac95ccfb2d9dd$var$writeTreeRemoveWrite(syncTree.pendingWriteTree_, writeId);
    if (!needToReevaluate) return [];
    else {
        let affectedTree = new $494ac95ccfb2d9dd$var$ImmutableTree(null);
        if (write.snap != null) // overwrite
        affectedTree = affectedTree.set($494ac95ccfb2d9dd$var$newEmptyPath(), true);
        else $494ac95ccfb2d9dd$var$each(write.children, (pathString)=>{
            affectedTree = affectedTree.set(new $494ac95ccfb2d9dd$var$Path(pathString), true);
        });
        return $494ac95ccfb2d9dd$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $494ac95ccfb2d9dd$var$AckUserWrite(write.path, affectedTree, revert));
    }
}
/**
 * Apply new server data for the specified path..
 *
 * @returns Events to raise.
 */ function $494ac95ccfb2d9dd$var$syncTreeApplyServerOverwrite(syncTree, path, newData) {
    return $494ac95ccfb2d9dd$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $494ac95ccfb2d9dd$var$Overwrite($494ac95ccfb2d9dd$var$newOperationSourceServer(), path, newData));
}
/**
 * Apply new server data to be merged in at the specified path.
 *
 * @returns Events to raise.
 */ function $494ac95ccfb2d9dd$var$syncTreeApplyServerMerge(syncTree, path, changedChildren) {
    const changeTree = $494ac95ccfb2d9dd$var$ImmutableTree.fromObject(changedChildren);
    return $494ac95ccfb2d9dd$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $494ac95ccfb2d9dd$var$Merge($494ac95ccfb2d9dd$var$newOperationSourceServer(), path, changeTree));
}
/**
 * Apply a listen complete for a query
 *
 * @returns Events to raise.
 */ function $494ac95ccfb2d9dd$var$syncTreeApplyListenComplete(syncTree, path) {
    return $494ac95ccfb2d9dd$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $494ac95ccfb2d9dd$var$ListenComplete($494ac95ccfb2d9dd$var$newOperationSourceServer(), path));
}
/**
 * Apply a listen complete for a tagged query
 *
 * @returns Events to raise.
 */ function $494ac95ccfb2d9dd$var$syncTreeApplyTaggedListenComplete(syncTree, path, tag) {
    const queryKey = $494ac95ccfb2d9dd$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey) {
        const r = $494ac95ccfb2d9dd$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $494ac95ccfb2d9dd$var$newRelativePath(queryPath, path);
        const op = new $494ac95ccfb2d9dd$var$ListenComplete($494ac95ccfb2d9dd$var$newOperationSourceServerTaggedQuery(queryId), relativePath);
        return $494ac95ccfb2d9dd$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // We've already removed the query. No big deal, ignore the update
    return [];
}
/**
 * Remove event callback(s).
 *
 * If query is the default query, we'll check all queries for the specified eventRegistration.
 * If eventRegistration is null, we'll remove all callbacks for the specified query/queries.
 *
 * @param eventRegistration - If null, all callbacks are removed.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @param skipListenerDedup - When performing a `get()`, we don't add any new listeners, so no
 *  deduping needs to take place. This flag allows toggling of that behavior
 * @returns Cancel events, if cancelError was provided.
 */ function $494ac95ccfb2d9dd$var$syncTreeRemoveEventRegistration(syncTree, query, eventRegistration, cancelError, skipListenerDedup = false) {
    // Find the syncPoint first. Then deal with whether or not it has matching listeners
    const path = query._path;
    const maybeSyncPoint = syncTree.syncPointTree_.get(path);
    let cancelEvents = [];
    // A removal on a default query affects all queries at that location. A removal on an indexed query, even one without
    // other query constraints, does *not* affect all queries at that location. So this check must be for 'default', and
    // not loadsAllData().
    if (maybeSyncPoint && (query._queryIdentifier === "default" || $494ac95ccfb2d9dd$var$syncPointViewExistsForQuery(maybeSyncPoint, query))) {
        const removedAndEvents = $494ac95ccfb2d9dd$var$syncPointRemoveEventRegistration(maybeSyncPoint, query, eventRegistration, cancelError);
        if ($494ac95ccfb2d9dd$var$syncPointIsEmpty(maybeSyncPoint)) syncTree.syncPointTree_ = syncTree.syncPointTree_.remove(path);
        const removed = removedAndEvents.removed;
        cancelEvents = removedAndEvents.events;
        if (!skipListenerDedup) {
            /**
             * We may have just removed one of many listeners and can short-circuit this whole process
             * We may also not have removed a default listener, in which case all of the descendant listeners should already be
             * properly set up.
             */ // Since indexed queries can shadow if they don't have other query constraints, check for loadsAllData(), instead of
            // queryId === 'default'
            const removingDefault = -1 !== removed.findIndex((query)=>{
                return query._queryParams.loadsAllData();
            });
            const covered = syncTree.syncPointTree_.findOnPath(path, (relativePath, parentSyncPoint)=>$494ac95ccfb2d9dd$var$syncPointHasCompleteView(parentSyncPoint));
            if (removingDefault && !covered) {
                const subtree = syncTree.syncPointTree_.subtree(path);
                // There are potentially child listeners. Determine what if any listens we need to send before executing the
                // removal
                if (!subtree.isEmpty()) {
                    // We need to fold over our subtree and collect the listeners to send
                    const newViews = $494ac95ccfb2d9dd$var$syncTreeCollectDistinctViewsForSubTree_(subtree);
                    // Ok, we've collected all the listens we need. Set them up.
                    for(let i = 0; i < newViews.length; ++i){
                        const view = newViews[i], newQuery = view.query;
                        const listener = $494ac95ccfb2d9dd$var$syncTreeCreateListenerForView_(syncTree, view);
                        syncTree.listenProvider_.startListening($494ac95ccfb2d9dd$var$syncTreeQueryForListening_(newQuery), $494ac95ccfb2d9dd$var$syncTreeTagForQuery(syncTree, newQuery), listener.hashFn, listener.onComplete);
                    }
                }
            // Otherwise there's nothing below us, so nothing we need to start listening on
            }
            // If we removed anything and we're not covered by a higher up listen, we need to stop listening on this query
            // The above block has us covered in terms of making sure we're set up on listens lower in the tree.
            // Also, note that if we have a cancelError, it's already been removed at the provider level.
            if (!covered && removed.length > 0 && !cancelError) {
                // If we removed a default, then we weren't listening on any of the other queries here. Just cancel the one
                // default. Otherwise, we need to iterate through and cancel each individual query
                if (removingDefault) {
                    // We don't tag default listeners
                    const defaultTag = null;
                    syncTree.listenProvider_.stopListening($494ac95ccfb2d9dd$var$syncTreeQueryForListening_(query), defaultTag);
                } else removed.forEach((queryToRemove)=>{
                    const tagToRemove = syncTree.queryToTagMap.get($494ac95ccfb2d9dd$var$syncTreeMakeQueryKey_(queryToRemove));
                    syncTree.listenProvider_.stopListening($494ac95ccfb2d9dd$var$syncTreeQueryForListening_(queryToRemove), tagToRemove);
                });
            }
        }
        // Now, clear all of the tags we're tracking for the removed listens
        $494ac95ccfb2d9dd$var$syncTreeRemoveTags_(syncTree, removed);
    }
    return cancelEvents;
}
/**
 * Apply new server data for the specified tagged query.
 *
 * @returns Events to raise.
 */ function $494ac95ccfb2d9dd$var$syncTreeApplyTaggedQueryOverwrite(syncTree, path, snap, tag) {
    const queryKey = $494ac95ccfb2d9dd$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey != null) {
        const r = $494ac95ccfb2d9dd$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $494ac95ccfb2d9dd$var$newRelativePath(queryPath, path);
        const op = new $494ac95ccfb2d9dd$var$Overwrite($494ac95ccfb2d9dd$var$newOperationSourceServerTaggedQuery(queryId), relativePath, snap);
        return $494ac95ccfb2d9dd$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // Query must have been removed already
    return [];
}
/**
 * Apply server data to be merged in for the specified tagged query.
 *
 * @returns Events to raise.
 */ function $494ac95ccfb2d9dd$var$syncTreeApplyTaggedQueryMerge(syncTree, path, changedChildren, tag) {
    const queryKey = $494ac95ccfb2d9dd$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey) {
        const r = $494ac95ccfb2d9dd$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $494ac95ccfb2d9dd$var$newRelativePath(queryPath, path);
        const changeTree = $494ac95ccfb2d9dd$var$ImmutableTree.fromObject(changedChildren);
        const op = new $494ac95ccfb2d9dd$var$Merge($494ac95ccfb2d9dd$var$newOperationSourceServerTaggedQuery(queryId), relativePath, changeTree);
        return $494ac95ccfb2d9dd$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // We've already removed the query. No big deal, ignore the update
    return [];
}
/**
 * Add an event callback for the specified query.
 *
 * @returns Events to raise.
 */ function $494ac95ccfb2d9dd$var$syncTreeAddEventRegistration(syncTree, query, eventRegistration, skipSetupListener = false) {
    const path = query._path;
    let serverCache = null;
    let foundAncestorDefaultView = false;
    // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
    // Consider optimizing this once there's a better understanding of what actual behavior will be.
    syncTree.syncPointTree_.foreachOnPath(path, (pathToSyncPoint, sp)=>{
        const relativePath = $494ac95ccfb2d9dd$var$newRelativePath(pathToSyncPoint, path);
        serverCache = serverCache || $494ac95ccfb2d9dd$var$syncPointGetCompleteServerCache(sp, relativePath);
        foundAncestorDefaultView = foundAncestorDefaultView || $494ac95ccfb2d9dd$var$syncPointHasCompleteView(sp);
    });
    let syncPoint = syncTree.syncPointTree_.get(path);
    if (!syncPoint) {
        syncPoint = new $494ac95ccfb2d9dd$var$SyncPoint();
        syncTree.syncPointTree_ = syncTree.syncPointTree_.set(path, syncPoint);
    } else {
        foundAncestorDefaultView = foundAncestorDefaultView || $494ac95ccfb2d9dd$var$syncPointHasCompleteView(syncPoint);
        serverCache = serverCache || $494ac95ccfb2d9dd$var$syncPointGetCompleteServerCache(syncPoint, $494ac95ccfb2d9dd$var$newEmptyPath());
    }
    let serverCacheComplete;
    if (serverCache != null) serverCacheComplete = true;
    else {
        serverCacheComplete = false;
        serverCache = $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE;
        const subtree = syncTree.syncPointTree_.subtree(path);
        subtree.foreachChild((childName, childSyncPoint)=>{
            const completeCache = $494ac95ccfb2d9dd$var$syncPointGetCompleteServerCache(childSyncPoint, $494ac95ccfb2d9dd$var$newEmptyPath());
            if (completeCache) serverCache = serverCache.updateImmediateChild(childName, completeCache);
        });
    }
    const viewAlreadyExists = $494ac95ccfb2d9dd$var$syncPointViewExistsForQuery(syncPoint, query);
    if (!viewAlreadyExists && !query._queryParams.loadsAllData()) {
        // We need to track a tag for this query
        const queryKey = $494ac95ccfb2d9dd$var$syncTreeMakeQueryKey_(query);
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(!syncTree.queryToTagMap.has(queryKey), "View does not exist, but we have a tag");
        const tag = $494ac95ccfb2d9dd$var$syncTreeGetNextQueryTag_();
        syncTree.queryToTagMap.set(queryKey, tag);
        syncTree.tagToQueryMap.set(tag, queryKey);
    }
    const writesCache = $494ac95ccfb2d9dd$var$writeTreeChildWrites(syncTree.pendingWriteTree_, path);
    let events = $494ac95ccfb2d9dd$var$syncPointAddEventRegistration(syncPoint, query, eventRegistration, writesCache, serverCache, serverCacheComplete);
    if (!viewAlreadyExists && !foundAncestorDefaultView && !skipSetupListener) {
        const view = $494ac95ccfb2d9dd$var$syncPointViewForQuery(syncPoint, query);
        events = events.concat($494ac95ccfb2d9dd$var$syncTreeSetupListener_(syncTree, query, view));
    }
    return events;
}
/**
 * Returns a complete cache, if we have one, of the data at a particular path. If the location does not have a
 * listener above it, we will get a false "null". This shouldn't be a problem because transactions will always
 * have a listener above, and atomic operations would correctly show a jitter of <increment value> ->
 *     <incremented total> as the write is applied locally and then acknowledged at the server.
 *
 * Note: this method will *include* hidden writes from transaction with applyLocally set to false.
 *
 * @param path - The path to the data we want
 * @param writeIdsToExclude - A specific set to be excluded
 */ function $494ac95ccfb2d9dd$var$syncTreeCalcCompleteEventCache(syncTree, path, writeIdsToExclude) {
    const includeHiddenSets = true;
    const writeTree = syncTree.pendingWriteTree_;
    const serverCache = syncTree.syncPointTree_.findOnPath(path, (pathSoFar, syncPoint)=>{
        const relativePath = $494ac95ccfb2d9dd$var$newRelativePath(pathSoFar, path);
        const serverCache = $494ac95ccfb2d9dd$var$syncPointGetCompleteServerCache(syncPoint, relativePath);
        if (serverCache) return serverCache;
    });
    return $494ac95ccfb2d9dd$var$writeTreeCalcCompleteEventCache(writeTree, path, serverCache, writeIdsToExclude, includeHiddenSets);
}
function $494ac95ccfb2d9dd$var$syncTreeGetServerValue(syncTree, query) {
    const path = query._path;
    let serverCache = null;
    // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
    // Consider optimizing this once there's a better understanding of what actual behavior will be.
    syncTree.syncPointTree_.foreachOnPath(path, (pathToSyncPoint, sp)=>{
        const relativePath = $494ac95ccfb2d9dd$var$newRelativePath(pathToSyncPoint, path);
        serverCache = serverCache || $494ac95ccfb2d9dd$var$syncPointGetCompleteServerCache(sp, relativePath);
    });
    let syncPoint = syncTree.syncPointTree_.get(path);
    if (!syncPoint) {
        syncPoint = new $494ac95ccfb2d9dd$var$SyncPoint();
        syncTree.syncPointTree_ = syncTree.syncPointTree_.set(path, syncPoint);
    } else serverCache = serverCache || $494ac95ccfb2d9dd$var$syncPointGetCompleteServerCache(syncPoint, $494ac95ccfb2d9dd$var$newEmptyPath());
    const serverCacheComplete = serverCache != null;
    const serverCacheNode = serverCacheComplete ? new $494ac95ccfb2d9dd$var$CacheNode(serverCache, true, false) : null;
    const writesCache = $494ac95ccfb2d9dd$var$writeTreeChildWrites(syncTree.pendingWriteTree_, query._path);
    const view = $494ac95ccfb2d9dd$var$syncPointGetView(syncPoint, query, writesCache, serverCacheComplete ? serverCacheNode.getNode() : $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE, serverCacheComplete);
    return $494ac95ccfb2d9dd$var$viewGetCompleteNode(view);
}
/**
 * A helper method that visits all descendant and ancestor SyncPoints, applying the operation.
 *
 * NOTES:
 * - Descendant SyncPoints will be visited first (since we raise events depth-first).
 *
 * - We call applyOperation() on each SyncPoint passing three things:
 *   1. A version of the Operation that has been made relative to the SyncPoint location.
 *   2. A WriteTreeRef of any writes we have cached at the SyncPoint location.
 *   3. A snapshot Node with cached server data, if we have it.
 *
 * - We concatenate all of the events returned by each SyncPoint and return the result.
 */ function $494ac95ccfb2d9dd$var$syncTreeApplyOperationToSyncPoints_(syncTree, operation) {
    return $494ac95ccfb2d9dd$var$syncTreeApplyOperationHelper_(operation, syncTree.syncPointTree_, /*serverCache=*/ null, $494ac95ccfb2d9dd$var$writeTreeChildWrites(syncTree.pendingWriteTree_, $494ac95ccfb2d9dd$var$newEmptyPath()));
}
/**
 * Recursive helper for applyOperationToSyncPoints_
 */ function $494ac95ccfb2d9dd$var$syncTreeApplyOperationHelper_(operation, syncPointTree, serverCache, writesCache) {
    if ($494ac95ccfb2d9dd$var$pathIsEmpty(operation.path)) return $494ac95ccfb2d9dd$var$syncTreeApplyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
    else {
        const syncPoint = syncPointTree.get($494ac95ccfb2d9dd$var$newEmptyPath());
        // If we don't have cached server data, see if we can get it from this SyncPoint.
        if (serverCache == null && syncPoint != null) serverCache = $494ac95ccfb2d9dd$var$syncPointGetCompleteServerCache(syncPoint, $494ac95ccfb2d9dd$var$newEmptyPath());
        let events = [];
        const childName = $494ac95ccfb2d9dd$var$pathGetFront(operation.path);
        const childOperation = operation.operationForChild(childName);
        const childTree = syncPointTree.children.get(childName);
        if (childTree && childOperation) {
            const childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
            const childWritesCache = $494ac95ccfb2d9dd$var$writeTreeRefChild(writesCache, childName);
            events = events.concat($494ac95ccfb2d9dd$var$syncTreeApplyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
        }
        if (syncPoint) events = events.concat($494ac95ccfb2d9dd$var$syncPointApplyOperation(syncPoint, operation, writesCache, serverCache));
        return events;
    }
}
/**
 * Recursive helper for applyOperationToSyncPoints_
 */ function $494ac95ccfb2d9dd$var$syncTreeApplyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache) {
    const syncPoint = syncPointTree.get($494ac95ccfb2d9dd$var$newEmptyPath());
    // If we don't have cached server data, see if we can get it from this SyncPoint.
    if (serverCache == null && syncPoint != null) serverCache = $494ac95ccfb2d9dd$var$syncPointGetCompleteServerCache(syncPoint, $494ac95ccfb2d9dd$var$newEmptyPath());
    let events = [];
    syncPointTree.children.inorderTraversal((childName, childTree)=>{
        const childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
        const childWritesCache = $494ac95ccfb2d9dd$var$writeTreeRefChild(writesCache, childName);
        const childOperation = operation.operationForChild(childName);
        if (childOperation) events = events.concat($494ac95ccfb2d9dd$var$syncTreeApplyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
    });
    if (syncPoint) events = events.concat($494ac95ccfb2d9dd$var$syncPointApplyOperation(syncPoint, operation, writesCache, serverCache));
    return events;
}
function $494ac95ccfb2d9dd$var$syncTreeCreateListenerForView_(syncTree, view) {
    const query = view.query;
    const tag = $494ac95ccfb2d9dd$var$syncTreeTagForQuery(syncTree, query);
    return {
        hashFn: ()=>{
            const cache = $494ac95ccfb2d9dd$var$viewGetServerCache(view) || $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE;
            return cache.hash();
        },
        onComplete: (status)=>{
            if (status === "ok") {
                if (tag) return $494ac95ccfb2d9dd$var$syncTreeApplyTaggedListenComplete(syncTree, query._path, tag);
                else return $494ac95ccfb2d9dd$var$syncTreeApplyListenComplete(syncTree, query._path);
            } else {
                // If a listen failed, kill all of the listeners here, not just the one that triggered the error.
                // Note that this may need to be scoped to just this listener if we change permissions on filtered children
                const error = $494ac95ccfb2d9dd$var$errorForServerCode(status, query);
                return $494ac95ccfb2d9dd$var$syncTreeRemoveEventRegistration(syncTree, query, /*eventRegistration*/ null, error);
            }
        }
    };
}
/**
 * Return the tag associated with the given query.
 */ function $494ac95ccfb2d9dd$var$syncTreeTagForQuery(syncTree, query) {
    const queryKey = $494ac95ccfb2d9dd$var$syncTreeMakeQueryKey_(query);
    return syncTree.queryToTagMap.get(queryKey);
}
/**
 * Given a query, computes a "queryKey" suitable for use in our queryToTagMap_.
 */ function $494ac95ccfb2d9dd$var$syncTreeMakeQueryKey_(query) {
    return query._path.toString() + "$" + query._queryIdentifier;
}
/**
 * Return the query associated with the given tag, if we have one
 */ function $494ac95ccfb2d9dd$var$syncTreeQueryKeyForTag_(syncTree, tag) {
    return syncTree.tagToQueryMap.get(tag);
}
/**
 * Given a queryKey (created by makeQueryKey), parse it back into a path and queryId.
 */ function $494ac95ccfb2d9dd$var$syncTreeParseQueryKey_(queryKey) {
    const splitIndex = queryKey.indexOf("$");
    (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(splitIndex !== -1 && splitIndex < queryKey.length - 1, "Bad queryKey.");
    return {
        queryId: queryKey.substr(splitIndex + 1),
        path: new $494ac95ccfb2d9dd$var$Path(queryKey.substr(0, splitIndex))
    };
}
/**
 * A helper method to apply tagged operations
 */ function $494ac95ccfb2d9dd$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, operation) {
    const syncPoint = syncTree.syncPointTree_.get(queryPath);
    (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(syncPoint, "Missing sync point for query tag that we're tracking");
    const writesCache = $494ac95ccfb2d9dd$var$writeTreeChildWrites(syncTree.pendingWriteTree_, queryPath);
    return $494ac95ccfb2d9dd$var$syncPointApplyOperation(syncPoint, operation, writesCache, null);
}
/**
 * This collapses multiple unfiltered views into a single view, since we only need a single
 * listener for them.
 */ function $494ac95ccfb2d9dd$var$syncTreeCollectDistinctViewsForSubTree_(subtree) {
    return subtree.fold((relativePath, maybeChildSyncPoint, childMap)=>{
        if (maybeChildSyncPoint && $494ac95ccfb2d9dd$var$syncPointHasCompleteView(maybeChildSyncPoint)) {
            const completeView = $494ac95ccfb2d9dd$var$syncPointGetCompleteView(maybeChildSyncPoint);
            return [
                completeView
            ];
        } else {
            // No complete view here, flatten any deeper listens into an array
            let views = [];
            if (maybeChildSyncPoint) views = $494ac95ccfb2d9dd$var$syncPointGetQueryViews(maybeChildSyncPoint);
            $494ac95ccfb2d9dd$var$each(childMap, (_key, childViews)=>{
                views = views.concat(childViews);
            });
            return views;
        }
    });
}
/**
 * Normalizes a query to a query we send the server for listening
 *
 * @returns The normalized query
 */ function $494ac95ccfb2d9dd$var$syncTreeQueryForListening_(query) {
    if (query._queryParams.loadsAllData() && !query._queryParams.isDefault()) // We treat queries that load all data as default queries
    // Cast is necessary because ref() technically returns Firebase which is actually fb.api.Firebase which inherits
    // from Query
    return new ($494ac95ccfb2d9dd$var$syncTreeGetReferenceConstructor())(query._repo, query._path);
    else return query;
}
function $494ac95ccfb2d9dd$var$syncTreeRemoveTags_(syncTree, queries) {
    for(let j = 0; j < queries.length; ++j){
        const removedQuery = queries[j];
        if (!removedQuery._queryParams.loadsAllData()) {
            // We should have a tag for this
            const removedQueryKey = $494ac95ccfb2d9dd$var$syncTreeMakeQueryKey_(removedQuery);
            const removedQueryTag = syncTree.queryToTagMap.get(removedQueryKey);
            syncTree.queryToTagMap.delete(removedQueryKey);
            syncTree.tagToQueryMap.delete(removedQueryTag);
        }
    }
}
/**
 * Static accessor for query tags.
 */ function $494ac95ccfb2d9dd$var$syncTreeGetNextQueryTag_() {
    return $494ac95ccfb2d9dd$var$syncTreeNextQueryTag_++;
}
/**
 * For a given new listen, manage the de-duplication of outstanding subscriptions.
 *
 * @returns This method can return events to support synchronous data sources
 */ function $494ac95ccfb2d9dd$var$syncTreeSetupListener_(syncTree, query, view) {
    const path = query._path;
    const tag = $494ac95ccfb2d9dd$var$syncTreeTagForQuery(syncTree, query);
    const listener = $494ac95ccfb2d9dd$var$syncTreeCreateListenerForView_(syncTree, view);
    const events = syncTree.listenProvider_.startListening($494ac95ccfb2d9dd$var$syncTreeQueryForListening_(query), tag, listener.hashFn, listener.onComplete);
    const subtree = syncTree.syncPointTree_.subtree(path);
    // The root of this subtree has our query. We're here because we definitely need to send a listen for that, but we
    // may need to shadow other listens as well.
    if (tag) (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(!$494ac95ccfb2d9dd$var$syncPointHasCompleteView(subtree.value), "If we're adding a query, it shouldn't be shadowed");
    else {
        // Shadow everything at or below this location, this is a default listener.
        const queriesToStop = subtree.fold((relativePath, maybeChildSyncPoint, childMap)=>{
            if (!$494ac95ccfb2d9dd$var$pathIsEmpty(relativePath) && maybeChildSyncPoint && $494ac95ccfb2d9dd$var$syncPointHasCompleteView(maybeChildSyncPoint)) return [
                $494ac95ccfb2d9dd$var$syncPointGetCompleteView(maybeChildSyncPoint).query
            ];
            else {
                // No default listener here, flatten any deeper queries into an array
                let queries = [];
                if (maybeChildSyncPoint) queries = queries.concat($494ac95ccfb2d9dd$var$syncPointGetQueryViews(maybeChildSyncPoint).map((view)=>view.query));
                $494ac95ccfb2d9dd$var$each(childMap, (_key, childQueries)=>{
                    queries = queries.concat(childQueries);
                });
                return queries;
            }
        });
        for(let i = 0; i < queriesToStop.length; ++i){
            const queryToStop = queriesToStop[i];
            syncTree.listenProvider_.stopListening($494ac95ccfb2d9dd$var$syncTreeQueryForListening_(queryToStop), $494ac95ccfb2d9dd$var$syncTreeTagForQuery(syncTree, queryToStop));
        }
    }
    return events;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $494ac95ccfb2d9dd$var$ExistingValueProvider {
    constructor(node_){
        this.node_ = node_;
    }
    getImmediateChild(childName) {
        const child = this.node_.getImmediateChild(childName);
        return new $494ac95ccfb2d9dd$var$ExistingValueProvider(child);
    }
    node() {
        return this.node_;
    }
}
class $494ac95ccfb2d9dd$var$DeferredValueProvider {
    constructor(syncTree, path){
        this.syncTree_ = syncTree;
        this.path_ = path;
    }
    getImmediateChild(childName) {
        const childPath = $494ac95ccfb2d9dd$var$pathChild(this.path_, childName);
        return new $494ac95ccfb2d9dd$var$DeferredValueProvider(this.syncTree_, childPath);
    }
    node() {
        return $494ac95ccfb2d9dd$var$syncTreeCalcCompleteEventCache(this.syncTree_, this.path_);
    }
}
/**
 * Generate placeholders for deferred values.
 */ const $494ac95ccfb2d9dd$var$generateWithValues = function(values) {
    values = values || {};
    values["timestamp"] = values["timestamp"] || new Date().getTime();
    return values;
};
/**
 * Value to use when firing local events. When writing server values, fire
 * local events with an approximate value, otherwise return value as-is.
 */ const $494ac95ccfb2d9dd$var$resolveDeferredLeafValue = function(value, existingVal, serverValues) {
    if (!value || typeof value !== "object") return value;
    (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(".sv" in value, "Unexpected leaf node or priority contents");
    if (typeof value[".sv"] === "string") return $494ac95ccfb2d9dd$var$resolveScalarDeferredValue(value[".sv"], existingVal, serverValues);
    else if (typeof value[".sv"] === "object") return $494ac95ccfb2d9dd$var$resolveComplexDeferredValue(value[".sv"], existingVal);
    else (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(false, "Unexpected server value: " + JSON.stringify(value, null, 2));
};
const $494ac95ccfb2d9dd$var$resolveScalarDeferredValue = function(op, existing, serverValues) {
    switch(op){
        case "timestamp":
            return serverValues["timestamp"];
        default:
            (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(false, "Unexpected server value: " + op);
    }
};
const $494ac95ccfb2d9dd$var$resolveComplexDeferredValue = function(op, existing, unused) {
    if (!op.hasOwnProperty("increment")) (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(false, "Unexpected server value: " + JSON.stringify(op, null, 2));
    const delta = op["increment"];
    if (typeof delta !== "number") (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(false, "Unexpected increment value: " + delta);
    const existingNode = existing.node();
    (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(existingNode !== null && typeof existingNode !== "undefined", "Expected ChildrenNode.EMPTY_NODE for nulls");
    // Incrementing a non-number sets the value to the incremented amount
    if (!existingNode.isLeafNode()) return delta;
    const leaf = existingNode;
    const existingVal = leaf.getValue();
    if (typeof existingVal !== "number") return delta;
    // No need to do over/underflow arithmetic here because JS only handles floats under the covers
    return existingVal + delta;
};
/**
 * Recursively replace all deferred values and priorities in the tree with the
 * specified generated replacement values.
 * @param path - path to which write is relative
 * @param node - new data written at path
 * @param syncTree - current data
 */ const $494ac95ccfb2d9dd$var$resolveDeferredValueTree = function(path, node, syncTree, serverValues) {
    return $494ac95ccfb2d9dd$var$resolveDeferredValue(node, new $494ac95ccfb2d9dd$var$DeferredValueProvider(syncTree, path), serverValues);
};
/**
 * Recursively replace all deferred values and priorities in the node with the
 * specified generated replacement values.  If there are no server values in the node,
 * it'll be returned as-is.
 */ const $494ac95ccfb2d9dd$var$resolveDeferredValueSnapshot = function(node, existing, serverValues) {
    return $494ac95ccfb2d9dd$var$resolveDeferredValue(node, new $494ac95ccfb2d9dd$var$ExistingValueProvider(existing), serverValues);
};
function $494ac95ccfb2d9dd$var$resolveDeferredValue(node, existingVal, serverValues) {
    const rawPri = node.getPriority().val();
    const priority = $494ac95ccfb2d9dd$var$resolveDeferredLeafValue(rawPri, existingVal.getImmediateChild(".priority"), serverValues);
    let newNode;
    if (node.isLeafNode()) {
        const leafNode = node;
        const value = $494ac95ccfb2d9dd$var$resolveDeferredLeafValue(leafNode.getValue(), existingVal, serverValues);
        if (value !== leafNode.getValue() || priority !== leafNode.getPriority().val()) return new $494ac95ccfb2d9dd$var$LeafNode(value, $494ac95ccfb2d9dd$var$nodeFromJSON(priority));
        else return node;
    } else {
        const childrenNode = node;
        newNode = childrenNode;
        if (priority !== childrenNode.getPriority().val()) newNode = newNode.updatePriority(new $494ac95ccfb2d9dd$var$LeafNode(priority));
        childrenNode.forEachChild($494ac95ccfb2d9dd$var$PRIORITY_INDEX, (childName, childNode)=>{
            const newChildNode = $494ac95ccfb2d9dd$var$resolveDeferredValue(childNode, existingVal.getImmediateChild(childName), serverValues);
            if (newChildNode !== childNode) newNode = newNode.updateImmediateChild(childName, newChildNode);
        });
        return newNode;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A light-weight tree, traversable by path.  Nodes can have both values and children.
 * Nodes are not enumerated (by forEachChild) unless they have a value or non-empty
 * children.
 */ class $494ac95ccfb2d9dd$var$Tree {
    /**
     * @param name - Optional name of the node.
     * @param parent - Optional parent node.
     * @param node - Optional node to wrap.
     */ constructor(name = "", parent = null, node = {
        children: {},
        childCount: 0
    }){
        this.name = name;
        this.parent = parent;
        this.node = node;
    }
}
/**
 * Returns a sub-Tree for the given path.
 *
 * @param pathObj - Path to look up.
 * @returns Tree for path.
 */ function $494ac95ccfb2d9dd$var$treeSubTree(tree, pathObj) {
    // TODO: Require pathObj to be Path?
    let path = pathObj instanceof $494ac95ccfb2d9dd$var$Path ? pathObj : new $494ac95ccfb2d9dd$var$Path(pathObj);
    let child = tree, next = $494ac95ccfb2d9dd$var$pathGetFront(path);
    while(next !== null){
        const childNode = (0, $fc59d49e1bb53b6a$export$e51ae4db7b428f67)(child.node.children, next) || {
            children: {},
            childCount: 0
        };
        child = new $494ac95ccfb2d9dd$var$Tree(next, child, childNode);
        path = $494ac95ccfb2d9dd$var$pathPopFront(path);
        next = $494ac95ccfb2d9dd$var$pathGetFront(path);
    }
    return child;
}
/**
 * Returns the data associated with this tree node.
 *
 * @returns The data or null if no data exists.
 */ function $494ac95ccfb2d9dd$var$treeGetValue(tree) {
    return tree.node.value;
}
/**
 * Sets data to this tree node.
 *
 * @param value - Value to set.
 */ function $494ac95ccfb2d9dd$var$treeSetValue(tree, value) {
    tree.node.value = value;
    $494ac95ccfb2d9dd$var$treeUpdateParents(tree);
}
/**
 * @returns Whether the tree has any children.
 */ function $494ac95ccfb2d9dd$var$treeHasChildren(tree) {
    return tree.node.childCount > 0;
}
/**
 * @returns Whethe rthe tree is empty (no value or children).
 */ function $494ac95ccfb2d9dd$var$treeIsEmpty(tree) {
    return $494ac95ccfb2d9dd$var$treeGetValue(tree) === undefined && !$494ac95ccfb2d9dd$var$treeHasChildren(tree);
}
/**
 * Calls action for each child of this tree node.
 *
 * @param action - Action to be called for each child.
 */ function $494ac95ccfb2d9dd$var$treeForEachChild(tree, action) {
    $494ac95ccfb2d9dd$var$each(tree.node.children, (child, childTree)=>{
        action(new $494ac95ccfb2d9dd$var$Tree(child, tree, childTree));
    });
}
/**
 * Does a depth-first traversal of this node's descendants, calling action for each one.
 *
 * @param action - Action to be called for each child.
 * @param includeSelf - Whether to call action on this node as well. Defaults to
 *   false.
 * @param childrenFirst - Whether to call action on children before calling it on
 *   parent.
 */ function $494ac95ccfb2d9dd$var$treeForEachDescendant(tree, action, includeSelf, childrenFirst) {
    if (includeSelf && !childrenFirst) action(tree);
    $494ac95ccfb2d9dd$var$treeForEachChild(tree, (child)=>{
        $494ac95ccfb2d9dd$var$treeForEachDescendant(child, action, true, childrenFirst);
    });
    if (includeSelf && childrenFirst) action(tree);
}
/**
 * Calls action on each ancestor node.
 *
 * @param action - Action to be called on each parent; return
 *   true to abort.
 * @param includeSelf - Whether to call action on this node as well.
 * @returns true if the action callback returned true.
 */ function $494ac95ccfb2d9dd$var$treeForEachAncestor(tree, action, includeSelf) {
    let node = includeSelf ? tree : tree.parent;
    while(node !== null){
        if (action(node)) return true;
        node = node.parent;
    }
    return false;
}
/**
 * @returns The path of this tree node, as a Path.
 */ function $494ac95ccfb2d9dd$var$treeGetPath(tree) {
    return new $494ac95ccfb2d9dd$var$Path(tree.parent === null ? tree.name : $494ac95ccfb2d9dd$var$treeGetPath(tree.parent) + "/" + tree.name);
}
/**
 * Adds or removes this child from its parent based on whether it's empty or not.
 */ function $494ac95ccfb2d9dd$var$treeUpdateParents(tree) {
    if (tree.parent !== null) $494ac95ccfb2d9dd$var$treeUpdateChild(tree.parent, tree.name, tree);
}
/**
 * Adds or removes the passed child to this tree node, depending on whether it's empty.
 *
 * @param childName - The name of the child to update.
 * @param child - The child to update.
 */ function $494ac95ccfb2d9dd$var$treeUpdateChild(tree, childName, child) {
    const childEmpty = $494ac95ccfb2d9dd$var$treeIsEmpty(child);
    const childExists = (0, $fc59d49e1bb53b6a$export$2344b14b097df817)(tree.node.children, childName);
    if (childEmpty && childExists) {
        delete tree.node.children[childName];
        tree.node.childCount--;
        $494ac95ccfb2d9dd$var$treeUpdateParents(tree);
    } else if (!childEmpty && !childExists) {
        tree.node.children[childName] = child.node;
        tree.node.childCount++;
        $494ac95ccfb2d9dd$var$treeUpdateParents(tree);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * True for invalid Firebase keys
 */ const $494ac95ccfb2d9dd$var$INVALID_KEY_REGEX_ = /[\[\].#$\/\u0000-\u001F\u007F]/;
/**
 * True for invalid Firebase paths.
 * Allows '/' in paths.
 */ const $494ac95ccfb2d9dd$var$INVALID_PATH_REGEX_ = /[\[\].#$\u0000-\u001F\u007F]/;
/**
 * Maximum number of characters to allow in leaf value
 */ const $494ac95ccfb2d9dd$var$MAX_LEAF_SIZE_ = 10485760;
const $494ac95ccfb2d9dd$var$isValidKey = function(key) {
    return typeof key === "string" && key.length !== 0 && !$494ac95ccfb2d9dd$var$INVALID_KEY_REGEX_.test(key);
};
const $494ac95ccfb2d9dd$var$isValidPathString = function(pathString) {
    return typeof pathString === "string" && pathString.length !== 0 && !$494ac95ccfb2d9dd$var$INVALID_PATH_REGEX_.test(pathString);
};
const $494ac95ccfb2d9dd$var$isValidRootPathString = function(pathString) {
    if (pathString) // Allow '/.info/' at the beginning.
    pathString = pathString.replace(/^\/*\.info(\/|$)/, "/");
    return $494ac95ccfb2d9dd$var$isValidPathString(pathString);
};
const $494ac95ccfb2d9dd$var$isValidPriority = function(priority) {
    return priority === null || typeof priority === "string" || typeof priority === "number" && !$494ac95ccfb2d9dd$var$isInvalidJSONNumber(priority) || priority && typeof priority === "object" && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $fc59d49e1bb53b6a$export$2344b14b097df817)(priority, ".sv");
};
/**
 * Pre-validate a datum passed as an argument to Firebase function.
 */ const $494ac95ccfb2d9dd$var$validateFirebaseDataArg = function(fnName, value, path, optional) {
    if (optional && value === undefined) return;
    $494ac95ccfb2d9dd$var$validateFirebaseData((0, $fc59d49e1bb53b6a$export$adea4917e02d93dc)(fnName, "value"), value, path);
};
/**
 * Validate a data object client-side before sending to server.
 */ const $494ac95ccfb2d9dd$var$validateFirebaseData = function(errorPrefix, data, path_) {
    const path = path_ instanceof $494ac95ccfb2d9dd$var$Path ? new $494ac95ccfb2d9dd$var$ValidationPath(path_, errorPrefix) : path_;
    if (data === undefined) throw new Error(errorPrefix + "contains undefined " + $494ac95ccfb2d9dd$var$validationPathToErrorString(path));
    if (typeof data === "function") throw new Error(errorPrefix + "contains a function " + $494ac95ccfb2d9dd$var$validationPathToErrorString(path) + " with contents = " + data.toString());
    if ($494ac95ccfb2d9dd$var$isInvalidJSONNumber(data)) throw new Error(errorPrefix + "contains " + data.toString() + " " + $494ac95ccfb2d9dd$var$validationPathToErrorString(path));
    // Check max leaf size, but try to avoid the utf8 conversion if we can.
    if (typeof data === "string" && data.length > $494ac95ccfb2d9dd$var$MAX_LEAF_SIZE_ / 3 && (0, $fc59d49e1bb53b6a$export$9536dc0a75b20bf9)(data) > $494ac95ccfb2d9dd$var$MAX_LEAF_SIZE_) throw new Error(errorPrefix + "contains a string greater than " + $494ac95ccfb2d9dd$var$MAX_LEAF_SIZE_ + " utf8 bytes " + $494ac95ccfb2d9dd$var$validationPathToErrorString(path) + " ('" + data.substring(0, 50) + "...')");
    // TODO = Perf = Consider combining the recursive validation of keys into NodeFromJSON
    // to save extra walking of large objects.
    if (data && typeof data === "object") {
        let hasDotValue = false;
        let hasActualChild = false;
        $494ac95ccfb2d9dd$var$each(data, (key, value)=>{
            if (key === ".value") hasDotValue = true;
            else if (key !== ".priority" && key !== ".sv") {
                hasActualChild = true;
                if (!$494ac95ccfb2d9dd$var$isValidKey(key)) throw new Error(errorPrefix + " contains an invalid key (" + key + ") " + $494ac95ccfb2d9dd$var$validationPathToErrorString(path) + ".  Keys must be non-empty strings " + 'and can\'t contain ".", "#", "$", "/", "[", or "]"');
            }
            $494ac95ccfb2d9dd$var$validationPathPush(path, key);
            $494ac95ccfb2d9dd$var$validateFirebaseData(errorPrefix, value, path);
            $494ac95ccfb2d9dd$var$validationPathPop(path);
        });
        if (hasDotValue && hasActualChild) throw new Error(errorPrefix + ' contains ".value" child ' + $494ac95ccfb2d9dd$var$validationPathToErrorString(path) + " in addition to actual children.");
    }
};
/**
 * Pre-validate paths passed in the firebase function.
 */ const $494ac95ccfb2d9dd$var$validateFirebaseMergePaths = function(errorPrefix, mergePaths) {
    let i, curPath;
    for(i = 0; i < mergePaths.length; i++){
        curPath = mergePaths[i];
        const keys = $494ac95ccfb2d9dd$var$pathSlice(curPath);
        for(let j = 0; j < keys.length; j++){
            if (keys[j] === ".priority" && j === keys.length - 1) ;
            else if (!$494ac95ccfb2d9dd$var$isValidKey(keys[j])) throw new Error(errorPrefix + "contains an invalid key (" + keys[j] + ") in path " + curPath.toString() + ". Keys must be non-empty strings " + 'and can\'t contain ".", "#", "$", "/", "[", or "]"');
        }
    }
    // Check that update keys are not descendants of each other.
    // We rely on the property that sorting guarantees that ancestors come
    // right before descendants.
    mergePaths.sort($494ac95ccfb2d9dd$var$pathCompare);
    let prevPath = null;
    for(i = 0; i < mergePaths.length; i++){
        curPath = mergePaths[i];
        if (prevPath !== null && $494ac95ccfb2d9dd$var$pathContains(prevPath, curPath)) throw new Error(errorPrefix + "contains a path " + prevPath.toString() + " that is ancestor of another path " + curPath.toString());
        prevPath = curPath;
    }
};
/**
 * pre-validate an object passed as an argument to firebase function (
 * must be an object - e.g. for firebase.update()).
 */ const $494ac95ccfb2d9dd$var$validateFirebaseMergeDataArg = function(fnName, data, path, optional) {
    if (optional && data === undefined) return;
    const errorPrefix$1 = (0, $fc59d49e1bb53b6a$export$adea4917e02d93dc)(fnName, "values");
    if (!(data && typeof data === "object") || Array.isArray(data)) throw new Error(errorPrefix$1 + " must be an object containing the children to replace.");
    const mergePaths = [];
    $494ac95ccfb2d9dd$var$each(data, (key, value)=>{
        const curPath = new $494ac95ccfb2d9dd$var$Path(key);
        $494ac95ccfb2d9dd$var$validateFirebaseData(errorPrefix$1, value, $494ac95ccfb2d9dd$var$pathChild(path, curPath));
        if ($494ac95ccfb2d9dd$var$pathGetBack(curPath) === ".priority") {
            if (!$494ac95ccfb2d9dd$var$isValidPriority(value)) throw new Error(errorPrefix$1 + "contains an invalid value for '" + curPath.toString() + "', which must be a valid " + "Firebase priority (a string, finite number, server value, or null).");
        }
        mergePaths.push(curPath);
    });
    $494ac95ccfb2d9dd$var$validateFirebaseMergePaths(errorPrefix$1, mergePaths);
};
const $494ac95ccfb2d9dd$var$validatePriority = function(fnName, priority, optional) {
    if (optional && priority === undefined) return;
    if ($494ac95ccfb2d9dd$var$isInvalidJSONNumber(priority)) throw new Error((0, $fc59d49e1bb53b6a$export$adea4917e02d93dc)(fnName, "priority") + "is " + priority.toString() + ", but must be a valid Firebase priority (a string, finite number, " + "server value, or null).");
    // Special case to allow importing data with a .sv.
    if (!$494ac95ccfb2d9dd$var$isValidPriority(priority)) throw new Error((0, $fc59d49e1bb53b6a$export$adea4917e02d93dc)(fnName, "priority") + "must be a valid Firebase priority " + "(a string, finite number, server value, or null).");
};
const $494ac95ccfb2d9dd$var$validateKey = function(fnName, argumentName, key, optional) {
    if (optional && key === undefined) return;
    if (!$494ac95ccfb2d9dd$var$isValidKey(key)) throw new Error((0, $fc59d49e1bb53b6a$export$adea4917e02d93dc)(fnName, argumentName) + 'was an invalid key = "' + key + '".  Firebase keys must be non-empty strings and ' + 'can\'t contain ".", "#", "$", "/", "[", or "]").');
};
/**
 * @internal
 */ const $494ac95ccfb2d9dd$export$8637b026ace8abb1 = function(fnName, argumentName, pathString, optional) {
    if (optional && pathString === undefined) return;
    if (!$494ac95ccfb2d9dd$var$isValidPathString(pathString)) throw new Error((0, $fc59d49e1bb53b6a$export$adea4917e02d93dc)(fnName, argumentName) + 'was an invalid path = "' + pathString + '". Paths must be non-empty strings and ' + 'can\'t contain ".", "#", "$", "[", or "]"');
};
const $494ac95ccfb2d9dd$var$validateRootPathString = function(fnName, argumentName, pathString, optional) {
    if (pathString) // Allow '/.info/' at the beginning.
    pathString = pathString.replace(/^\/*\.info(\/|$)/, "/");
    $494ac95ccfb2d9dd$export$8637b026ace8abb1(fnName, argumentName, pathString, optional);
};
/**
 * @internal
 */ const $494ac95ccfb2d9dd$export$8d83036122ae444e = function(fnName, path) {
    if ($494ac95ccfb2d9dd$var$pathGetFront(path) === ".info") throw new Error(fnName + " failed = Can't modify data under /.info/");
};
const $494ac95ccfb2d9dd$var$validateUrl = function(fnName, parsedUrl) {
    // TODO = Validate server better.
    const pathString = parsedUrl.path.toString();
    if (!(typeof parsedUrl.repoInfo.host === "string") || parsedUrl.repoInfo.host.length === 0 || !$494ac95ccfb2d9dd$var$isValidKey(parsedUrl.repoInfo.namespace) && parsedUrl.repoInfo.host.split(":")[0] !== "localhost" || pathString.length !== 0 && !$494ac95ccfb2d9dd$var$isValidRootPathString(pathString)) throw new Error((0, $fc59d49e1bb53b6a$export$adea4917e02d93dc)(fnName, "url") + "must be a valid firebase URL and " + 'the path can\'t contain ".", "#", "$", "[", or "]".');
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The event queue serves a few purposes:
 * 1. It ensures we maintain event order in the face of event callbacks doing operations that result in more
 *    events being queued.
 * 2. raiseQueuedEvents() handles being called reentrantly nicely.  That is, if in the course of raising events,
 *    raiseQueuedEvents() is called again, the "inner" call will pick up raising events where the "outer" call
 *    left off, ensuring that the events are still raised synchronously and in order.
 * 3. You can use raiseEventsAtPath and raiseEventsForChangedPath to ensure only relevant previously-queued
 *    events are raised synchronously.
 *
 * NOTE: This can all go away if/when we move to async events.
 *
 */ class $494ac95ccfb2d9dd$var$EventQueue {
    constructor(){
        this.eventLists_ = [];
        /**
         * Tracks recursion depth of raiseQueuedEvents_, for debugging purposes.
         */ this.recursionDepth_ = 0;
    }
}
/**
 * @param eventDataList - The new events to queue.
 */ function $494ac95ccfb2d9dd$var$eventQueueQueueEvents(eventQueue, eventDataList) {
    // We group events by path, storing them in a single EventList, to make it easier to skip over them quickly.
    let currList = null;
    for(let i = 0; i < eventDataList.length; i++){
        const data = eventDataList[i];
        const path = data.getPath();
        if (currList !== null && !$494ac95ccfb2d9dd$var$pathEquals(path, currList.path)) {
            eventQueue.eventLists_.push(currList);
            currList = null;
        }
        if (currList === null) currList = {
            events: [],
            path: path
        };
        currList.events.push(data);
    }
    if (currList) eventQueue.eventLists_.push(currList);
}
/**
 * Queues the specified events and synchronously raises all events (including previously queued ones)
 * for the specified path.
 *
 * It is assumed that the new events are all for the specified path.
 *
 * @param path - The path to raise events for.
 * @param eventDataList - The new events to raise.
 */ function $494ac95ccfb2d9dd$var$eventQueueRaiseEventsAtPath(eventQueue, path, eventDataList) {
    $494ac95ccfb2d9dd$var$eventQueueQueueEvents(eventQueue, eventDataList);
    $494ac95ccfb2d9dd$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, (eventPath)=>$494ac95ccfb2d9dd$var$pathEquals(eventPath, path));
}
/**
 * Queues the specified events and synchronously raises all events (including previously queued ones) for
 * locations related to the specified change path (i.e. all ancestors and descendants).
 *
 * It is assumed that the new events are all related (ancestor or descendant) to the specified path.
 *
 * @param changedPath - The path to raise events for.
 * @param eventDataList - The events to raise
 */ function $494ac95ccfb2d9dd$var$eventQueueRaiseEventsForChangedPath(eventQueue, changedPath, eventDataList) {
    $494ac95ccfb2d9dd$var$eventQueueQueueEvents(eventQueue, eventDataList);
    $494ac95ccfb2d9dd$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, (eventPath)=>$494ac95ccfb2d9dd$var$pathContains(eventPath, changedPath) || $494ac95ccfb2d9dd$var$pathContains(changedPath, eventPath));
}
function $494ac95ccfb2d9dd$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, predicate) {
    eventQueue.recursionDepth_++;
    let sentAll = true;
    for(let i = 0; i < eventQueue.eventLists_.length; i++){
        const eventList = eventQueue.eventLists_[i];
        if (eventList) {
            const eventPath = eventList.path;
            if (predicate(eventPath)) {
                $494ac95ccfb2d9dd$var$eventListRaise(eventQueue.eventLists_[i]);
                eventQueue.eventLists_[i] = null;
            } else sentAll = false;
        }
    }
    if (sentAll) eventQueue.eventLists_ = [];
    eventQueue.recursionDepth_--;
}
/**
 * Iterates through the list and raises each event
 */ function $494ac95ccfb2d9dd$var$eventListRaise(eventList) {
    for(let i = 0; i < eventList.events.length; i++){
        const eventData = eventList.events[i];
        if (eventData !== null) {
            eventList.events[i] = null;
            const eventFn = eventData.getEventRunner();
            if ($494ac95ccfb2d9dd$var$logger) $494ac95ccfb2d9dd$var$log("event: " + eventData.toString());
            $494ac95ccfb2d9dd$var$exceptionGuard(eventFn);
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $494ac95ccfb2d9dd$var$INTERRUPT_REASON = "repo_interrupt";
/**
 * If a transaction does not succeed after 25 retries, we abort it. Among other
 * things this ensure that if there's ever a bug causing a mismatch between
 * client / server hashes for some data, we won't retry indefinitely.
 */ const $494ac95ccfb2d9dd$var$MAX_TRANSACTION_RETRIES = 25;
/**
 * A connection to a single data repository.
 */ class $494ac95ccfb2d9dd$var$Repo {
    constructor(repoInfo_, forceRestClient_, authTokenProvider_, appCheckProvider_){
        this.repoInfo_ = repoInfo_;
        this.forceRestClient_ = forceRestClient_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckProvider_ = appCheckProvider_;
        this.dataUpdateCount = 0;
        this.statsListener_ = null;
        this.eventQueue_ = new $494ac95ccfb2d9dd$var$EventQueue();
        this.nextWriteId_ = 1;
        this.interceptServerDataCallback_ = null;
        /** A list of data pieces and paths to be set when this client disconnects. */ this.onDisconnect_ = $494ac95ccfb2d9dd$var$newSparseSnapshotTree();
        /** Stores queues of outstanding transactions for Firebase locations. */ this.transactionQueueTree_ = new $494ac95ccfb2d9dd$var$Tree();
        // TODO: This should be @private but it's used by test_access.js and internal.js
        this.persistentConnection_ = null;
        // This key is intentionally not updated if RepoInfo is later changed or replaced
        this.key = this.repoInfo_.toURLString();
    }
    /**
     * @returns The URL corresponding to the root of this Firebase.
     */ toString() {
        return (this.repoInfo_.secure ? "https://" : "http://") + this.repoInfo_.host;
    }
}
function $494ac95ccfb2d9dd$var$repoStart(repo, appId, authOverride) {
    repo.stats_ = $494ac95ccfb2d9dd$var$statsManagerGetCollection(repo.repoInfo_);
    if (repo.forceRestClient_ || $494ac95ccfb2d9dd$var$beingCrawled()) {
        repo.server_ = new $494ac95ccfb2d9dd$var$ReadonlyRestClient(repo.repoInfo_, (pathString, data, isMerge, tag)=>{
            $494ac95ccfb2d9dd$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag);
        }, repo.authTokenProvider_, repo.appCheckProvider_);
        // Minor hack: Fire onConnect immediately, since there's no actual connection.
        setTimeout(()=>$494ac95ccfb2d9dd$var$repoOnConnectStatus(repo, /* connectStatus= */ true), 0);
    } else {
        // Validate authOverride
        if (typeof authOverride !== "undefined" && authOverride !== null) {
            if (typeof authOverride !== "object") throw new Error("Only objects are supported for option databaseAuthVariableOverride");
            try {
                (0, $fc59d49e1bb53b6a$export$fac44ee5b035f737)(authOverride);
            } catch (e) {
                throw new Error("Invalid authOverride provided: " + e);
            }
        }
        repo.persistentConnection_ = new $494ac95ccfb2d9dd$var$PersistentConnection(repo.repoInfo_, appId, (pathString, data, isMerge, tag)=>{
            $494ac95ccfb2d9dd$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag);
        }, (connectStatus)=>{
            $494ac95ccfb2d9dd$var$repoOnConnectStatus(repo, connectStatus);
        }, (updates)=>{
            $494ac95ccfb2d9dd$var$repoOnServerInfoUpdate(repo, updates);
        }, repo.authTokenProvider_, repo.appCheckProvider_, authOverride);
        repo.server_ = repo.persistentConnection_;
    }
    repo.authTokenProvider_.addTokenChangeListener((token)=>{
        repo.server_.refreshAuthToken(token);
    });
    repo.appCheckProvider_.addTokenChangeListener((result)=>{
        repo.server_.refreshAppCheckToken(result.token);
    });
    // In the case of multiple Repos for the same repoInfo (i.e. there are multiple Firebase.Contexts being used),
    // we only want to create one StatsReporter.  As such, we'll report stats over the first Repo created.
    repo.statsReporter_ = $494ac95ccfb2d9dd$var$statsManagerGetOrCreateReporter(repo.repoInfo_, ()=>new $494ac95ccfb2d9dd$var$StatsReporter(repo.stats_, repo.server_));
    // Used for .info.
    repo.infoData_ = new $494ac95ccfb2d9dd$var$SnapshotHolder();
    repo.infoSyncTree_ = new $494ac95ccfb2d9dd$var$SyncTree({
        startListening: (query, tag, currentHashFn, onComplete)=>{
            let infoEvents = [];
            const node = repo.infoData_.getNode(query._path);
            // This is possibly a hack, but we have different semantics for .info endpoints. We don't raise null events
            // on initial data...
            if (!node.isEmpty()) {
                infoEvents = $494ac95ccfb2d9dd$var$syncTreeApplyServerOverwrite(repo.infoSyncTree_, query._path, node);
                setTimeout(()=>{
                    onComplete("ok");
                }, 0);
            }
            return infoEvents;
        },
        stopListening: ()=>{}
    });
    $494ac95ccfb2d9dd$var$repoUpdateInfo(repo, "connected", false);
    repo.serverSyncTree_ = new $494ac95ccfb2d9dd$var$SyncTree({
        startListening: (query, tag, currentHashFn, onComplete)=>{
            repo.server_.listen(query, currentHashFn, tag, (status, data)=>{
                const events = onComplete(status, data);
                $494ac95ccfb2d9dd$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, query._path, events);
            });
            // No synchronous events for network-backed sync trees
            return [];
        },
        stopListening: (query, tag)=>{
            repo.server_.unlisten(query, tag);
        }
    });
}
/**
 * @returns The time in milliseconds, taking the server offset into account if we have one.
 */ function $494ac95ccfb2d9dd$var$repoServerTime(repo) {
    const offsetNode = repo.infoData_.getNode(new $494ac95ccfb2d9dd$var$Path(".info/serverTimeOffset"));
    const offset = offsetNode.val() || 0;
    return new Date().getTime() + offset;
}
/**
 * Generate ServerValues using some variables from the repo object.
 */ function $494ac95ccfb2d9dd$var$repoGenerateServerValues(repo) {
    return $494ac95ccfb2d9dd$var$generateWithValues({
        timestamp: $494ac95ccfb2d9dd$var$repoServerTime(repo)
    });
}
/**
 * Called by realtime when we get new messages from the server.
 */ function $494ac95ccfb2d9dd$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag) {
    // For testing.
    repo.dataUpdateCount++;
    const path = new $494ac95ccfb2d9dd$var$Path(pathString);
    data = repo.interceptServerDataCallback_ ? repo.interceptServerDataCallback_(pathString, data) : data;
    let events = [];
    if (tag) {
        if (isMerge) {
            const taggedChildren = (0, $fc59d49e1bb53b6a$export$871de8747c9eaa88)(data, (raw)=>$494ac95ccfb2d9dd$var$nodeFromJSON(raw));
            events = $494ac95ccfb2d9dd$var$syncTreeApplyTaggedQueryMerge(repo.serverSyncTree_, path, taggedChildren, tag);
        } else {
            const taggedSnap = $494ac95ccfb2d9dd$var$nodeFromJSON(data);
            events = $494ac95ccfb2d9dd$var$syncTreeApplyTaggedQueryOverwrite(repo.serverSyncTree_, path, taggedSnap, tag);
        }
    } else if (isMerge) {
        const changedChildren = (0, $fc59d49e1bb53b6a$export$871de8747c9eaa88)(data, (raw)=>$494ac95ccfb2d9dd$var$nodeFromJSON(raw));
        events = $494ac95ccfb2d9dd$var$syncTreeApplyServerMerge(repo.serverSyncTree_, path, changedChildren);
    } else {
        const snap = $494ac95ccfb2d9dd$var$nodeFromJSON(data);
        events = $494ac95ccfb2d9dd$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, path, snap);
    }
    let affectedPath = path;
    if (events.length > 0) // Since we have a listener outstanding for each transaction, receiving any events
    // is a proxy for some change having occurred.
    affectedPath = $494ac95ccfb2d9dd$var$repoRerunTransactions(repo, path);
    $494ac95ccfb2d9dd$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, events);
}
function $494ac95ccfb2d9dd$var$repoOnConnectStatus(repo, connectStatus) {
    $494ac95ccfb2d9dd$var$repoUpdateInfo(repo, "connected", connectStatus);
    if (connectStatus === false) $494ac95ccfb2d9dd$var$repoRunOnDisconnectEvents(repo);
}
function $494ac95ccfb2d9dd$var$repoOnServerInfoUpdate(repo, updates) {
    $494ac95ccfb2d9dd$var$each(updates, (key, value)=>{
        $494ac95ccfb2d9dd$var$repoUpdateInfo(repo, key, value);
    });
}
function $494ac95ccfb2d9dd$var$repoUpdateInfo(repo, pathString, value) {
    const path = new $494ac95ccfb2d9dd$var$Path("/.info/" + pathString);
    const newNode = $494ac95ccfb2d9dd$var$nodeFromJSON(value);
    repo.infoData_.updateSnapshot(path, newNode);
    const events = $494ac95ccfb2d9dd$var$syncTreeApplyServerOverwrite(repo.infoSyncTree_, path, newNode);
    $494ac95ccfb2d9dd$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
}
function $494ac95ccfb2d9dd$var$repoGetNextWriteId(repo) {
    return repo.nextWriteId_++;
}
/**
 * The purpose of `getValue` is to return the latest known value
 * satisfying `query`.
 *
 * This method will first check for in-memory cached values
 * belonging to active listeners. If they are found, such values
 * are considered to be the most up-to-date.
 *
 * If the client is not connected, this method will wait until the
 *  repo has established a connection and then request the value for `query`.
 * If the client is not able to retrieve the query result for another reason,
 * it reports an error.
 *
 * @param query - The query to surface a value for.
 */ function $494ac95ccfb2d9dd$var$repoGetValue(repo, query, eventRegistration) {
    // Only active queries are cached. There is no persisted cache.
    const cached = $494ac95ccfb2d9dd$var$syncTreeGetServerValue(repo.serverSyncTree_, query);
    if (cached != null) return Promise.resolve(cached);
    return repo.server_.get(query).then((payload)=>{
        const node = $494ac95ccfb2d9dd$var$nodeFromJSON(payload).withIndex(query._queryParams.getIndex());
        /**
         * Below we simulate the actions of an `onlyOnce` `onValue()` event where:
         * Add an event registration,
         * Update data at the path,
         * Raise any events,
         * Cleanup the SyncTree
         */ $494ac95ccfb2d9dd$var$syncTreeAddEventRegistration(repo.serverSyncTree_, query, eventRegistration, true);
        let events;
        if (query._queryParams.loadsAllData()) events = $494ac95ccfb2d9dd$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, query._path, node);
        else {
            const tag = $494ac95ccfb2d9dd$var$syncTreeTagForQuery(repo.serverSyncTree_, query);
            events = $494ac95ccfb2d9dd$var$syncTreeApplyTaggedQueryOverwrite(repo.serverSyncTree_, query._path, node, tag);
        }
        /*
         * We need to raise events in the scenario where `get()` is called at a parent path, and
         * while the `get()` is pending, `onValue` is called at a child location. While get() is waiting
         * for the data, `onValue` will register a new event. Then, get() will come back, and update the syncTree
         * and its corresponding serverCache, including the child location where `onValue` is called. Then,
         * `onValue` will receive the event from the server, but look at the syncTree and see that the data received
         * from the server is already at the SyncPoint, and so the `onValue` callback will never get fired.
         * Calling `eventQueueRaiseEventsForChangedPath()` is the correct way to propagate the events and
         * ensure the corresponding child events will get fired.
         */ $494ac95ccfb2d9dd$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, query._path, events);
        $494ac95ccfb2d9dd$var$syncTreeRemoveEventRegistration(repo.serverSyncTree_, query, eventRegistration, null, true);
        return node;
    }, (err)=>{
        $494ac95ccfb2d9dd$var$repoLog(repo, "get for query " + (0, $fc59d49e1bb53b6a$export$fac44ee5b035f737)(query) + " failed: " + err);
        return Promise.reject(new Error(err));
    });
}
function $494ac95ccfb2d9dd$var$repoSetWithPriority(repo, path, newVal, newPriority, onComplete) {
    $494ac95ccfb2d9dd$var$repoLog(repo, "set", {
        path: path.toString(),
        value: newVal,
        priority: newPriority
    });
    // TODO: Optimize this behavior to either (a) store flag to skip resolving where possible and / or
    // (b) store unresolved paths on JSON parse
    const serverValues = $494ac95ccfb2d9dd$var$repoGenerateServerValues(repo);
    const newNodeUnresolved = $494ac95ccfb2d9dd$var$nodeFromJSON(newVal, newPriority);
    const existing = $494ac95ccfb2d9dd$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path);
    const newNode = $494ac95ccfb2d9dd$var$resolveDeferredValueSnapshot(newNodeUnresolved, existing, serverValues);
    const writeId = $494ac95ccfb2d9dd$var$repoGetNextWriteId(repo);
    const events = $494ac95ccfb2d9dd$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, path, newNode, writeId, true);
    $494ac95ccfb2d9dd$var$eventQueueQueueEvents(repo.eventQueue_, events);
    repo.server_.put(path.toString(), newNodeUnresolved.val(/*export=*/ true), (status, errorReason)=>{
        const success = status === "ok";
        if (!success) $494ac95ccfb2d9dd$var$warn("set at " + path + " failed: " + status);
        const clearEvents = $494ac95ccfb2d9dd$var$syncTreeAckUserWrite(repo.serverSyncTree_, writeId, !success);
        $494ac95ccfb2d9dd$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, clearEvents);
        $494ac95ccfb2d9dd$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
    const affectedPath = $494ac95ccfb2d9dd$var$repoAbortTransactions(repo, path);
    $494ac95ccfb2d9dd$var$repoRerunTransactions(repo, affectedPath);
    // We queued the events above, so just flush the queue here
    $494ac95ccfb2d9dd$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, []);
}
function $494ac95ccfb2d9dd$var$repoUpdate(repo, path, childrenToMerge, onComplete) {
    $494ac95ccfb2d9dd$var$repoLog(repo, "update", {
        path: path.toString(),
        value: childrenToMerge
    });
    // Start with our existing data and merge each child into it.
    let empty = true;
    const serverValues = $494ac95ccfb2d9dd$var$repoGenerateServerValues(repo);
    const changedChildren = {};
    $494ac95ccfb2d9dd$var$each(childrenToMerge, (changedKey, changedValue)=>{
        empty = false;
        changedChildren[changedKey] = $494ac95ccfb2d9dd$var$resolveDeferredValueTree($494ac95ccfb2d9dd$var$pathChild(path, changedKey), $494ac95ccfb2d9dd$var$nodeFromJSON(changedValue), repo.serverSyncTree_, serverValues);
    });
    if (!empty) {
        const writeId = $494ac95ccfb2d9dd$var$repoGetNextWriteId(repo);
        const events = $494ac95ccfb2d9dd$var$syncTreeApplyUserMerge(repo.serverSyncTree_, path, changedChildren, writeId);
        $494ac95ccfb2d9dd$var$eventQueueQueueEvents(repo.eventQueue_, events);
        repo.server_.merge(path.toString(), childrenToMerge, (status, errorReason)=>{
            const success = status === "ok";
            if (!success) $494ac95ccfb2d9dd$var$warn("update at " + path + " failed: " + status);
            const clearEvents = $494ac95ccfb2d9dd$var$syncTreeAckUserWrite(repo.serverSyncTree_, writeId, !success);
            const affectedPath = clearEvents.length > 0 ? $494ac95ccfb2d9dd$var$repoRerunTransactions(repo, path) : path;
            $494ac95ccfb2d9dd$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, clearEvents);
            $494ac95ccfb2d9dd$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
        });
        $494ac95ccfb2d9dd$var$each(childrenToMerge, (changedPath)=>{
            const affectedPath = $494ac95ccfb2d9dd$var$repoAbortTransactions(repo, $494ac95ccfb2d9dd$var$pathChild(path, changedPath));
            $494ac95ccfb2d9dd$var$repoRerunTransactions(repo, affectedPath);
        });
        // We queued the events above, so just flush the queue here
        $494ac95ccfb2d9dd$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, []);
    } else {
        $494ac95ccfb2d9dd$var$log("update() called with empty data.  Don't do anything.");
        $494ac95ccfb2d9dd$var$repoCallOnCompleteCallback(repo, onComplete, "ok", undefined);
    }
}
/**
 * Applies all of the changes stored up in the onDisconnect_ tree.
 */ function $494ac95ccfb2d9dd$var$repoRunOnDisconnectEvents(repo) {
    $494ac95ccfb2d9dd$var$repoLog(repo, "onDisconnectEvents");
    const serverValues = $494ac95ccfb2d9dd$var$repoGenerateServerValues(repo);
    const resolvedOnDisconnectTree = $494ac95ccfb2d9dd$var$newSparseSnapshotTree();
    $494ac95ccfb2d9dd$var$sparseSnapshotTreeForEachTree(repo.onDisconnect_, $494ac95ccfb2d9dd$var$newEmptyPath(), (path, node)=>{
        const resolved = $494ac95ccfb2d9dd$var$resolveDeferredValueTree(path, node, repo.serverSyncTree_, serverValues);
        $494ac95ccfb2d9dd$var$sparseSnapshotTreeRemember(resolvedOnDisconnectTree, path, resolved);
    });
    let events = [];
    $494ac95ccfb2d9dd$var$sparseSnapshotTreeForEachTree(resolvedOnDisconnectTree, $494ac95ccfb2d9dd$var$newEmptyPath(), (path, snap)=>{
        events = events.concat($494ac95ccfb2d9dd$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, path, snap));
        const affectedPath = $494ac95ccfb2d9dd$var$repoAbortTransactions(repo, path);
        $494ac95ccfb2d9dd$var$repoRerunTransactions(repo, affectedPath);
    });
    repo.onDisconnect_ = $494ac95ccfb2d9dd$var$newSparseSnapshotTree();
    $494ac95ccfb2d9dd$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, $494ac95ccfb2d9dd$var$newEmptyPath(), events);
}
function $494ac95ccfb2d9dd$var$repoOnDisconnectCancel(repo, path, onComplete) {
    repo.server_.onDisconnectCancel(path.toString(), (status, errorReason)=>{
        if (status === "ok") $494ac95ccfb2d9dd$var$sparseSnapshotTreeForget(repo.onDisconnect_, path);
        $494ac95ccfb2d9dd$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $494ac95ccfb2d9dd$var$repoOnDisconnectSet(repo, path, value, onComplete) {
    const newNode = $494ac95ccfb2d9dd$var$nodeFromJSON(value);
    repo.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), (status, errorReason)=>{
        if (status === "ok") $494ac95ccfb2d9dd$var$sparseSnapshotTreeRemember(repo.onDisconnect_, path, newNode);
        $494ac95ccfb2d9dd$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $494ac95ccfb2d9dd$var$repoOnDisconnectSetWithPriority(repo, path, value, priority, onComplete) {
    const newNode = $494ac95ccfb2d9dd$var$nodeFromJSON(value, priority);
    repo.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), (status, errorReason)=>{
        if (status === "ok") $494ac95ccfb2d9dd$var$sparseSnapshotTreeRemember(repo.onDisconnect_, path, newNode);
        $494ac95ccfb2d9dd$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $494ac95ccfb2d9dd$var$repoOnDisconnectUpdate(repo, path, childrenToMerge, onComplete) {
    if ((0, $fc59d49e1bb53b6a$export$dd1bc94b04021eeb)(childrenToMerge)) {
        $494ac95ccfb2d9dd$var$log("onDisconnect().update() called with empty data.  Don't do anything.");
        $494ac95ccfb2d9dd$var$repoCallOnCompleteCallback(repo, onComplete, "ok", undefined);
        return;
    }
    repo.server_.onDisconnectMerge(path.toString(), childrenToMerge, (status, errorReason)=>{
        if (status === "ok") $494ac95ccfb2d9dd$var$each(childrenToMerge, (childName, childNode)=>{
            const newChildNode = $494ac95ccfb2d9dd$var$nodeFromJSON(childNode);
            $494ac95ccfb2d9dd$var$sparseSnapshotTreeRemember(repo.onDisconnect_, $494ac95ccfb2d9dd$var$pathChild(path, childName), newChildNode);
        });
        $494ac95ccfb2d9dd$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $494ac95ccfb2d9dd$var$repoAddEventCallbackForQuery(repo, query, eventRegistration) {
    let events;
    if ($494ac95ccfb2d9dd$var$pathGetFront(query._path) === ".info") events = $494ac95ccfb2d9dd$var$syncTreeAddEventRegistration(repo.infoSyncTree_, query, eventRegistration);
    else events = $494ac95ccfb2d9dd$var$syncTreeAddEventRegistration(repo.serverSyncTree_, query, eventRegistration);
    $494ac95ccfb2d9dd$var$eventQueueRaiseEventsAtPath(repo.eventQueue_, query._path, events);
}
function $494ac95ccfb2d9dd$var$repoRemoveEventCallbackForQuery(repo, query, eventRegistration) {
    // These are guaranteed not to raise events, since we're not passing in a cancelError. However, we can future-proof
    // a little bit by handling the return values anyways.
    let events;
    if ($494ac95ccfb2d9dd$var$pathGetFront(query._path) === ".info") events = $494ac95ccfb2d9dd$var$syncTreeRemoveEventRegistration(repo.infoSyncTree_, query, eventRegistration);
    else events = $494ac95ccfb2d9dd$var$syncTreeRemoveEventRegistration(repo.serverSyncTree_, query, eventRegistration);
    $494ac95ccfb2d9dd$var$eventQueueRaiseEventsAtPath(repo.eventQueue_, query._path, events);
}
function $494ac95ccfb2d9dd$var$repoInterrupt(repo) {
    if (repo.persistentConnection_) repo.persistentConnection_.interrupt($494ac95ccfb2d9dd$var$INTERRUPT_REASON);
}
function $494ac95ccfb2d9dd$var$repoResume(repo) {
    if (repo.persistentConnection_) repo.persistentConnection_.resume($494ac95ccfb2d9dd$var$INTERRUPT_REASON);
}
function $494ac95ccfb2d9dd$var$repoLog(repo, ...varArgs) {
    let prefix = "";
    if (repo.persistentConnection_) prefix = repo.persistentConnection_.id + ":";
    $494ac95ccfb2d9dd$var$log(prefix, ...varArgs);
}
function $494ac95ccfb2d9dd$var$repoCallOnCompleteCallback(repo, callback, status, errorReason) {
    if (callback) $494ac95ccfb2d9dd$var$exceptionGuard(()=>{
        if (status === "ok") callback(null);
        else {
            const code = (status || "error").toUpperCase();
            let message = code;
            if (errorReason) message += ": " + errorReason;
            const error = new Error(message);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            error.code = code;
            callback(error);
        }
    });
}
/**
 * Creates a new transaction, adds it to the transactions we're tracking, and
 * sends it to the server if possible.
 *
 * @param path - Path at which to do transaction.
 * @param transactionUpdate - Update callback.
 * @param onComplete - Completion callback.
 * @param unwatcher - Function that will be called when the transaction no longer
 * need data updates for `path`.
 * @param applyLocally - Whether or not to make intermediate results visible
 */ function $494ac95ccfb2d9dd$var$repoStartTransaction(repo, path, transactionUpdate, onComplete, unwatcher, applyLocally) {
    $494ac95ccfb2d9dd$var$repoLog(repo, "transaction on " + path);
    // Initialize transaction.
    const transaction = {
        path: path,
        update: transactionUpdate,
        onComplete: onComplete,
        // One of TransactionStatus enums.
        status: null,
        // Used when combining transactions at different locations to figure out
        // which one goes first.
        order: $494ac95ccfb2d9dd$var$LUIDGenerator(),
        applyLocally: // Whether to raise local events for this transaction.
        applyLocally,
        // Count of how many times we've retried the transaction.
        retryCount: 0,
        unwatcher: // Function to call to clean up our .on() listener.
        unwatcher,
        // Stores why a transaction was aborted.
        abortReason: null,
        currentWriteId: null,
        currentInputSnapshot: null,
        currentOutputSnapshotRaw: null,
        currentOutputSnapshotResolved: null
    };
    // Run transaction initially.
    const currentState = $494ac95ccfb2d9dd$var$repoGetLatestState(repo, path, undefined);
    transaction.currentInputSnapshot = currentState;
    const newVal = transaction.update(currentState.val());
    if (newVal === undefined) {
        // Abort transaction.
        transaction.unwatcher();
        transaction.currentOutputSnapshotRaw = null;
        transaction.currentOutputSnapshotResolved = null;
        if (transaction.onComplete) transaction.onComplete(null, false, transaction.currentInputSnapshot);
    } else {
        $494ac95ccfb2d9dd$var$validateFirebaseData("transaction failed: Data returned ", newVal, transaction.path);
        // Mark as run and add to our queue.
        transaction.status = 0 /* TransactionStatus.RUN */ ;
        const queueNode = $494ac95ccfb2d9dd$var$treeSubTree(repo.transactionQueueTree_, path);
        const nodeQueue = $494ac95ccfb2d9dd$var$treeGetValue(queueNode) || [];
        nodeQueue.push(transaction);
        $494ac95ccfb2d9dd$var$treeSetValue(queueNode, nodeQueue);
        // Update visibleData and raise events
        // Note: We intentionally raise events after updating all of our
        // transaction state, since the user could start new transactions from the
        // event callbacks.
        let priorityForNode;
        if (typeof newVal === "object" && newVal !== null && (0, $fc59d49e1bb53b6a$export$2344b14b097df817)(newVal, ".priority")) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            priorityForNode = (0, $fc59d49e1bb53b6a$export$e51ae4db7b428f67)(newVal, ".priority");
            (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)($494ac95ccfb2d9dd$var$isValidPriority(priorityForNode), "Invalid priority returned by transaction. Priority must be a valid string, finite number, server value, or null.");
        } else {
            const currentNode = $494ac95ccfb2d9dd$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path) || $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE;
            priorityForNode = currentNode.getPriority().val();
        }
        const serverValues = $494ac95ccfb2d9dd$var$repoGenerateServerValues(repo);
        const newNodeUnresolved = $494ac95ccfb2d9dd$var$nodeFromJSON(newVal, priorityForNode);
        const newNode = $494ac95ccfb2d9dd$var$resolveDeferredValueSnapshot(newNodeUnresolved, currentState, serverValues);
        transaction.currentOutputSnapshotRaw = newNodeUnresolved;
        transaction.currentOutputSnapshotResolved = newNode;
        transaction.currentWriteId = $494ac95ccfb2d9dd$var$repoGetNextWriteId(repo);
        const events = $494ac95ccfb2d9dd$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, path, newNode, transaction.currentWriteId, transaction.applyLocally);
        $494ac95ccfb2d9dd$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
        $494ac95ccfb2d9dd$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
    }
}
/**
 * @param excludeSets - A specific set to exclude
 */ function $494ac95ccfb2d9dd$var$repoGetLatestState(repo, path, excludeSets) {
    return $494ac95ccfb2d9dd$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path, excludeSets) || $494ac95ccfb2d9dd$var$ChildrenNode.EMPTY_NODE;
}
/**
 * Sends any already-run transactions that aren't waiting for outstanding
 * transactions to complete.
 *
 * Externally it's called with no arguments, but it calls itself recursively
 * with a particular transactionQueueTree node to recurse through the tree.
 *
 * @param node - transactionQueueTree node to start at.
 */ function $494ac95ccfb2d9dd$var$repoSendReadyTransactions(repo, node = repo.transactionQueueTree_) {
    // Before recursing, make sure any completed transactions are removed.
    if (!node) $494ac95ccfb2d9dd$var$repoPruneCompletedTransactionsBelowNode(repo, node);
    if ($494ac95ccfb2d9dd$var$treeGetValue(node)) {
        const queue = $494ac95ccfb2d9dd$var$repoBuildTransactionQueue(repo, node);
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(queue.length > 0, "Sending zero length transaction queue");
        const allRun = queue.every((transaction)=>transaction.status === 0 /* TransactionStatus.RUN */ );
        // If they're all run (and not sent), we can send them.  Else, we must wait.
        if (allRun) $494ac95ccfb2d9dd$var$repoSendTransactionQueue(repo, $494ac95ccfb2d9dd$var$treeGetPath(node), queue);
    } else if ($494ac95ccfb2d9dd$var$treeHasChildren(node)) $494ac95ccfb2d9dd$var$treeForEachChild(node, (childNode)=>{
        $494ac95ccfb2d9dd$var$repoSendReadyTransactions(repo, childNode);
    });
}
/**
 * Given a list of run transactions, send them to the server and then handle
 * the result (success or failure).
 *
 * @param path - The location of the queue.
 * @param queue - Queue of transactions under the specified location.
 */ function $494ac95ccfb2d9dd$var$repoSendTransactionQueue(repo, path, queue) {
    // Mark transactions as sent and increment retry count!
    const setsToIgnore = queue.map((txn)=>{
        return txn.currentWriteId;
    });
    const latestState = $494ac95ccfb2d9dd$var$repoGetLatestState(repo, path, setsToIgnore);
    let snapToSend = latestState;
    const latestHash = latestState.hash();
    for(let i = 0; i < queue.length; i++){
        const txn = queue[i];
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(txn.status === 0 /* TransactionStatus.RUN */ , "tryToSendTransactionQueue_: items in queue should all be run.");
        txn.status = 1 /* TransactionStatus.SENT */ ;
        txn.retryCount++;
        const relativePath = $494ac95ccfb2d9dd$var$newRelativePath(path, txn.path);
        // If we've gotten to this point, the output snapshot must be defined.
        snapToSend = snapToSend.updateChild(relativePath /** @type {!Node} */ , txn.currentOutputSnapshotRaw);
    }
    const dataToSend = snapToSend.val(true);
    const pathToSend = path;
    // Send the put.
    repo.server_.put(pathToSend.toString(), dataToSend, (status)=>{
        $494ac95ccfb2d9dd$var$repoLog(repo, "transaction put response", {
            path: pathToSend.toString(),
            status: status
        });
        let events = [];
        if (status === "ok") {
            // Queue up the callbacks and fire them after cleaning up all of our
            // transaction state, since the callback could trigger more
            // transactions or sets.
            const callbacks = [];
            for(let i = 0; i < queue.length; i++){
                queue[i].status = 2 /* TransactionStatus.COMPLETED */ ;
                events = events.concat($494ac95ccfb2d9dd$var$syncTreeAckUserWrite(repo.serverSyncTree_, queue[i].currentWriteId));
                if (queue[i].onComplete) // We never unset the output snapshot, and given that this
                // transaction is complete, it should be set
                callbacks.push(()=>queue[i].onComplete(null, true, queue[i].currentOutputSnapshotResolved));
                queue[i].unwatcher();
            }
            // Now remove the completed transactions.
            $494ac95ccfb2d9dd$var$repoPruneCompletedTransactionsBelowNode(repo, $494ac95ccfb2d9dd$var$treeSubTree(repo.transactionQueueTree_, path));
            // There may be pending transactions that we can now send.
            $494ac95ccfb2d9dd$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
            $494ac95ccfb2d9dd$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
            // Finally, trigger onComplete callbacks.
            for(let i = 0; i < callbacks.length; i++)$494ac95ccfb2d9dd$var$exceptionGuard(callbacks[i]);
        } else {
            // transactions are no longer sent.  Update their status appropriately.
            if (status === "datastale") {
                for(let i = 0; i < queue.length; i++)if (queue[i].status === 3 /* TransactionStatus.SENT_NEEDS_ABORT */ ) queue[i].status = 4 /* TransactionStatus.NEEDS_ABORT */ ;
                else queue[i].status = 0 /* TransactionStatus.RUN */ ;
            } else {
                $494ac95ccfb2d9dd$var$warn("transaction at " + pathToSend.toString() + " failed: " + status);
                for(let i = 0; i < queue.length; i++){
                    queue[i].status = 4 /* TransactionStatus.NEEDS_ABORT */ ;
                    queue[i].abortReason = status;
                }
            }
            $494ac95ccfb2d9dd$var$repoRerunTransactions(repo, path);
        }
    }, latestHash);
}
/**
 * Finds all transactions dependent on the data at changedPath and reruns them.
 *
 * Should be called any time cached data changes.
 *
 * Return the highest path that was affected by rerunning transactions. This
 * is the path at which events need to be raised for.
 *
 * @param changedPath - The path in mergedData that changed.
 * @returns The rootmost path that was affected by rerunning transactions.
 */ function $494ac95ccfb2d9dd$var$repoRerunTransactions(repo, changedPath) {
    const rootMostTransactionNode = $494ac95ccfb2d9dd$var$repoGetAncestorTransactionNode(repo, changedPath);
    const path = $494ac95ccfb2d9dd$var$treeGetPath(rootMostTransactionNode);
    const queue = $494ac95ccfb2d9dd$var$repoBuildTransactionQueue(repo, rootMostTransactionNode);
    $494ac95ccfb2d9dd$var$repoRerunTransactionQueue(repo, queue, path);
    return path;
}
/**
 * Does all the work of rerunning transactions (as well as cleans up aborted
 * transactions and whatnot).
 *
 * @param queue - The queue of transactions to run.
 * @param path - The path the queue is for.
 */ function $494ac95ccfb2d9dd$var$repoRerunTransactionQueue(repo, queue, path) {
    if (queue.length === 0) return; // Nothing to do!
    // Queue up the callbacks and fire them after cleaning up all of our
    // transaction state, since the callback could trigger more transactions or
    // sets.
    const callbacks = [];
    let events = [];
    // Ignore all of the sets we're going to re-run.
    const txnsToRerun = queue.filter((q)=>{
        return q.status === 0 /* TransactionStatus.RUN */ ;
    });
    const setsToIgnore = txnsToRerun.map((q)=>{
        return q.currentWriteId;
    });
    for(let i = 0; i < queue.length; i++){
        const transaction = queue[i];
        const relativePath = $494ac95ccfb2d9dd$var$newRelativePath(path, transaction.path);
        let abortTransaction = false, abortReason;
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(relativePath !== null, "rerunTransactionsUnderNode_: relativePath should not be null.");
        if (transaction.status === 4 /* TransactionStatus.NEEDS_ABORT */ ) {
            abortTransaction = true;
            abortReason = transaction.abortReason;
            events = events.concat($494ac95ccfb2d9dd$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
        } else if (transaction.status === 0 /* TransactionStatus.RUN */ ) {
            if (transaction.retryCount >= $494ac95ccfb2d9dd$var$MAX_TRANSACTION_RETRIES) {
                abortTransaction = true;
                abortReason = "maxretry";
                events = events.concat($494ac95ccfb2d9dd$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
            } else {
                // This code reruns a transaction
                const currentNode = $494ac95ccfb2d9dd$var$repoGetLatestState(repo, transaction.path, setsToIgnore);
                transaction.currentInputSnapshot = currentNode;
                const newData = queue[i].update(currentNode.val());
                if (newData !== undefined) {
                    $494ac95ccfb2d9dd$var$validateFirebaseData("transaction failed: Data returned ", newData, transaction.path);
                    let newDataNode = $494ac95ccfb2d9dd$var$nodeFromJSON(newData);
                    const hasExplicitPriority = typeof newData === "object" && newData != null && (0, $fc59d49e1bb53b6a$export$2344b14b097df817)(newData, ".priority");
                    if (!hasExplicitPriority) // Keep the old priority if there wasn't a priority explicitly specified.
                    newDataNode = newDataNode.updatePriority(currentNode.getPriority());
                    const oldWriteId = transaction.currentWriteId;
                    const serverValues = $494ac95ccfb2d9dd$var$repoGenerateServerValues(repo);
                    const newNodeResolved = $494ac95ccfb2d9dd$var$resolveDeferredValueSnapshot(newDataNode, currentNode, serverValues);
                    transaction.currentOutputSnapshotRaw = newDataNode;
                    transaction.currentOutputSnapshotResolved = newNodeResolved;
                    transaction.currentWriteId = $494ac95ccfb2d9dd$var$repoGetNextWriteId(repo);
                    // Mutates setsToIgnore in place
                    setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
                    events = events.concat($494ac95ccfb2d9dd$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
                    events = events.concat($494ac95ccfb2d9dd$var$syncTreeAckUserWrite(repo.serverSyncTree_, oldWriteId, true));
                } else {
                    abortTransaction = true;
                    abortReason = "nodata";
                    events = events.concat($494ac95ccfb2d9dd$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
                }
            }
        }
        $494ac95ccfb2d9dd$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
        events = [];
        if (abortTransaction) {
            // Abort.
            queue[i].status = 2 /* TransactionStatus.COMPLETED */ ;
            // Removing a listener can trigger pruning which can muck with
            // mergedData/visibleData (as it prunes data). So defer the unwatcher
            // until we're done.
            (function(unwatcher) {
                setTimeout(unwatcher, Math.floor(0));
            })(queue[i].unwatcher);
            if (queue[i].onComplete) {
                if (abortReason === "nodata") callbacks.push(()=>queue[i].onComplete(null, false, queue[i].currentInputSnapshot));
                else callbacks.push(()=>queue[i].onComplete(new Error(abortReason), false, null));
            }
        }
    }
    // Clean up completed transactions.
    $494ac95ccfb2d9dd$var$repoPruneCompletedTransactionsBelowNode(repo, repo.transactionQueueTree_);
    // Now fire callbacks, now that we're in a good, known state.
    for(let i = 0; i < callbacks.length; i++)$494ac95ccfb2d9dd$var$exceptionGuard(callbacks[i]);
    // Try to send the transaction result to the server.
    $494ac95ccfb2d9dd$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
}
/**
 * Returns the rootmost ancestor node of the specified path that has a pending
 * transaction on it, or just returns the node for the given path if there are
 * no pending transactions on any ancestor.
 *
 * @param path - The location to start at.
 * @returns The rootmost node with a transaction.
 */ function $494ac95ccfb2d9dd$var$repoGetAncestorTransactionNode(repo, path) {
    let front;
    // Start at the root and walk deeper into the tree towards path until we
    // find a node with pending transactions.
    let transactionNode = repo.transactionQueueTree_;
    front = $494ac95ccfb2d9dd$var$pathGetFront(path);
    while(front !== null && $494ac95ccfb2d9dd$var$treeGetValue(transactionNode) === undefined){
        transactionNode = $494ac95ccfb2d9dd$var$treeSubTree(transactionNode, front);
        path = $494ac95ccfb2d9dd$var$pathPopFront(path);
        front = $494ac95ccfb2d9dd$var$pathGetFront(path);
    }
    return transactionNode;
}
/**
 * Builds the queue of all transactions at or below the specified
 * transactionNode.
 *
 * @param transactionNode
 * @returns The generated queue.
 */ function $494ac95ccfb2d9dd$var$repoBuildTransactionQueue(repo, transactionNode) {
    // Walk any child transaction queues and aggregate them into a single queue.
    const transactionQueue = [];
    $494ac95ccfb2d9dd$var$repoAggregateTransactionQueuesForNode(repo, transactionNode, transactionQueue);
    // Sort them by the order the transactions were created.
    transactionQueue.sort((a, b)=>a.order - b.order);
    return transactionQueue;
}
function $494ac95ccfb2d9dd$var$repoAggregateTransactionQueuesForNode(repo, node, queue) {
    const nodeQueue = $494ac95ccfb2d9dd$var$treeGetValue(node);
    if (nodeQueue) for(let i = 0; i < nodeQueue.length; i++)queue.push(nodeQueue[i]);
    $494ac95ccfb2d9dd$var$treeForEachChild(node, (child)=>{
        $494ac95ccfb2d9dd$var$repoAggregateTransactionQueuesForNode(repo, child, queue);
    });
}
/**
 * Remove COMPLETED transactions at or below this node in the transactionQueueTree_.
 */ function $494ac95ccfb2d9dd$var$repoPruneCompletedTransactionsBelowNode(repo, node) {
    const queue = $494ac95ccfb2d9dd$var$treeGetValue(node);
    if (queue) {
        let to = 0;
        for(let from = 0; from < queue.length; from++)if (queue[from].status !== 2 /* TransactionStatus.COMPLETED */ ) {
            queue[to] = queue[from];
            to++;
        }
        queue.length = to;
        $494ac95ccfb2d9dd$var$treeSetValue(node, queue.length > 0 ? queue : undefined);
    }
    $494ac95ccfb2d9dd$var$treeForEachChild(node, (childNode)=>{
        $494ac95ccfb2d9dd$var$repoPruneCompletedTransactionsBelowNode(repo, childNode);
    });
}
/**
 * Aborts all transactions on ancestors or descendants of the specified path.
 * Called when doing a set() or update() since we consider them incompatible
 * with transactions.
 *
 * @param path - Path for which we want to abort related transactions.
 */ function $494ac95ccfb2d9dd$var$repoAbortTransactions(repo, path) {
    const affectedPath = $494ac95ccfb2d9dd$var$treeGetPath($494ac95ccfb2d9dd$var$repoGetAncestorTransactionNode(repo, path));
    const transactionNode = $494ac95ccfb2d9dd$var$treeSubTree(repo.transactionQueueTree_, path);
    $494ac95ccfb2d9dd$var$treeForEachAncestor(transactionNode, (node)=>{
        $494ac95ccfb2d9dd$var$repoAbortTransactionsOnNode(repo, node);
    });
    $494ac95ccfb2d9dd$var$repoAbortTransactionsOnNode(repo, transactionNode);
    $494ac95ccfb2d9dd$var$treeForEachDescendant(transactionNode, (node)=>{
        $494ac95ccfb2d9dd$var$repoAbortTransactionsOnNode(repo, node);
    });
    return affectedPath;
}
/**
 * Abort transactions stored in this transaction queue node.
 *
 * @param node - Node to abort transactions for.
 */ function $494ac95ccfb2d9dd$var$repoAbortTransactionsOnNode(repo, node) {
    const queue = $494ac95ccfb2d9dd$var$treeGetValue(node);
    if (queue) {
        // Queue up the callbacks and fire them after cleaning up all of our
        // transaction state, since the callback could trigger more transactions
        // or sets.
        const callbacks = [];
        // Go through queue.  Any already-sent transactions must be marked for
        // abort, while the unsent ones can be immediately aborted and removed.
        let events = [];
        let lastSent = -1;
        for(let i = 0; i < queue.length; i++){
            if (queue[i].status === 3 /* TransactionStatus.SENT_NEEDS_ABORT */ ) ;
            else if (queue[i].status === 1 /* TransactionStatus.SENT */ ) {
                (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(lastSent === i - 1, "All SENT items should be at beginning of queue.");
                lastSent = i;
                // Mark transaction for abort when it comes back.
                queue[i].status = 3 /* TransactionStatus.SENT_NEEDS_ABORT */ ;
                queue[i].abortReason = "set";
            } else {
                (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(queue[i].status === 0 /* TransactionStatus.RUN */ , "Unexpected transaction status in abort");
                // We can abort it immediately.
                queue[i].unwatcher();
                events = events.concat($494ac95ccfb2d9dd$var$syncTreeAckUserWrite(repo.serverSyncTree_, queue[i].currentWriteId, true));
                if (queue[i].onComplete) callbacks.push(queue[i].onComplete.bind(null, new Error("set"), false, null));
            }
        }
        if (lastSent === -1) // We're not waiting for any sent transactions.  We can clear the queue.
        $494ac95ccfb2d9dd$var$treeSetValue(node, undefined);
        else // Remove the transactions we aborted.
        queue.length = lastSent + 1;
        // Now fire the callbacks.
        $494ac95ccfb2d9dd$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, $494ac95ccfb2d9dd$var$treeGetPath(node), events);
        for(let i = 0; i < callbacks.length; i++)$494ac95ccfb2d9dd$var$exceptionGuard(callbacks[i]);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $494ac95ccfb2d9dd$var$decodePath(pathString) {
    let pathStringDecoded = "";
    const pieces = pathString.split("/");
    for(let i = 0; i < pieces.length; i++)if (pieces[i].length > 0) {
        let piece = pieces[i];
        try {
            piece = decodeURIComponent(piece.replace(/\+/g, " "));
        } catch (e) {}
        pathStringDecoded += "/" + piece;
    }
    return pathStringDecoded;
}
/**
 * @returns key value hash
 */ function $494ac95ccfb2d9dd$var$decodeQuery(queryString) {
    const results = {};
    if (queryString.charAt(0) === "?") queryString = queryString.substring(1);
    for (const segment of queryString.split("&")){
        if (segment.length === 0) continue;
        const kv = segment.split("=");
        if (kv.length === 2) results[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
        else $494ac95ccfb2d9dd$var$warn(`Invalid query segment '${segment}' in query '${queryString}'`);
    }
    return results;
}
const $494ac95ccfb2d9dd$var$parseRepoInfo = function(dataURL, nodeAdmin) {
    const parsedUrl = $494ac95ccfb2d9dd$var$parseDatabaseURL(dataURL), namespace = parsedUrl.namespace;
    if (parsedUrl.domain === "firebase.com") $494ac95ccfb2d9dd$var$fatal(parsedUrl.host + " is no longer supported. " + "Please use <YOUR FIREBASE>.firebaseio.com instead");
    // Catch common error of uninitialized namespace value.
    if ((!namespace || namespace === "undefined") && parsedUrl.domain !== "localhost") $494ac95ccfb2d9dd$var$fatal("Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com");
    if (!parsedUrl.secure) $494ac95ccfb2d9dd$var$warnIfPageIsSecure();
    const webSocketOnly = parsedUrl.scheme === "ws" || parsedUrl.scheme === "wss";
    return {
        repoInfo: new $494ac95ccfb2d9dd$var$RepoInfo(parsedUrl.host, parsedUrl.secure, namespace, webSocketOnly, nodeAdmin, /*persistenceKey=*/ "", /*includeNamespaceInQueryParams=*/ namespace !== parsedUrl.subdomain),
        path: new $494ac95ccfb2d9dd$var$Path(parsedUrl.pathString)
    };
};
const $494ac95ccfb2d9dd$var$parseDatabaseURL = function(dataURL) {
    // Default to empty strings in the event of a malformed string.
    let host = "", domain = "", subdomain = "", pathString = "", namespace = "";
    // Always default to SSL, unless otherwise specified.
    let secure = true, scheme = "https", port = 443;
    // Don't do any validation here. The caller is responsible for validating the result of parsing.
    if (typeof dataURL === "string") {
        // Parse scheme.
        let colonInd = dataURL.indexOf("//");
        if (colonInd >= 0) {
            scheme = dataURL.substring(0, colonInd - 1);
            dataURL = dataURL.substring(colonInd + 2);
        }
        // Parse host, path, and query string.
        let slashInd = dataURL.indexOf("/");
        if (slashInd === -1) slashInd = dataURL.length;
        let questionMarkInd = dataURL.indexOf("?");
        if (questionMarkInd === -1) questionMarkInd = dataURL.length;
        host = dataURL.substring(0, Math.min(slashInd, questionMarkInd));
        if (slashInd < questionMarkInd) // For pathString, questionMarkInd will always come after slashInd
        pathString = $494ac95ccfb2d9dd$var$decodePath(dataURL.substring(slashInd, questionMarkInd));
        const queryParams = $494ac95ccfb2d9dd$var$decodeQuery(dataURL.substring(Math.min(dataURL.length, questionMarkInd)));
        // If we have a port, use scheme for determining if it's secure.
        colonInd = host.indexOf(":");
        if (colonInd >= 0) {
            secure = scheme === "https" || scheme === "wss";
            port = parseInt(host.substring(colonInd + 1), 10);
        } else colonInd = host.length;
        const hostWithoutPort = host.slice(0, colonInd);
        if (hostWithoutPort.toLowerCase() === "localhost") domain = "localhost";
        else if (hostWithoutPort.split(".").length <= 2) domain = hostWithoutPort;
        else {
            // Interpret the subdomain of a 3 or more component URL as the namespace name.
            const dotInd = host.indexOf(".");
            subdomain = host.substring(0, dotInd).toLowerCase();
            domain = host.substring(dotInd + 1);
            // Normalize namespaces to lowercase to share storage / connection.
            namespace = subdomain;
        }
        // Always treat the value of the `ns` as the namespace name if it is present.
        if ("ns" in queryParams) namespace = queryParams["ns"];
    }
    return {
        host: host,
        port: port,
        domain: domain,
        subdomain: subdomain,
        secure: secure,
        scheme: scheme,
        pathString: pathString,
        namespace: namespace
    };
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Modeled after base64 web-safe chars, but ordered by ASCII.
const $494ac95ccfb2d9dd$var$PUSH_CHARS = "-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz";
/**
 * Fancy ID generator that creates 20-character string identifiers with the
 * following properties:
 *
 * 1. They're based on timestamp so that they sort *after* any existing ids.
 * 2. They contain 72-bits of random data after the timestamp so that IDs won't
 *    collide with other clients' IDs.
 * 3. They sort *lexicographically* (so the timestamp is converted to characters
 *    that will sort properly).
 * 4. They're monotonically increasing. Even if you generate more than one in
 *    the same timestamp, the latter ones will sort after the former ones. We do
 *    this by using the previous random bits but "incrementing" them by 1 (only
 *    in the case of a timestamp collision).
 */ const $494ac95ccfb2d9dd$var$nextPushId = function() {
    // Timestamp of last push, used to prevent local collisions if you push twice
    // in one ms.
    let lastPushTime = 0;
    // We generate 72-bits of randomness which get turned into 12 characters and
    // appended to the timestamp to prevent collisions with other clients. We
    // store the last characters we generated because in the event of a collision,
    // we'll use those same characters except "incremented" by one.
    const lastRandChars = [];
    return function(now) {
        const duplicateTime = now === lastPushTime;
        lastPushTime = now;
        let i;
        const timeStampChars = new Array(8);
        for(i = 7; i >= 0; i--){
            timeStampChars[i] = $494ac95ccfb2d9dd$var$PUSH_CHARS.charAt(now % 64);
            // NOTE: Can't use << here because javascript will convert to int and lose
            // the upper bits.
            now = Math.floor(now / 64);
        }
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(now === 0, "Cannot push at time == 0");
        let id = timeStampChars.join("");
        if (!duplicateTime) for(i = 0; i < 12; i++)lastRandChars[i] = Math.floor(Math.random() * 64);
        else {
            // If the timestamp hasn't changed since last push, use the same random
            // number, except incremented by 1.
            for(i = 11; i >= 0 && lastRandChars[i] === 63; i--)lastRandChars[i] = 0;
            lastRandChars[i]++;
        }
        for(i = 0; i < 12; i++)id += $494ac95ccfb2d9dd$var$PUSH_CHARS.charAt(lastRandChars[i]);
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(id.length === 20, "nextPushId: Length should be 20.");
        return id;
    };
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Encapsulates the data needed to raise an event
 */ class $494ac95ccfb2d9dd$var$DataEvent {
    /**
     * @param eventType - One of: value, child_added, child_changed, child_moved, child_removed
     * @param eventRegistration - The function to call to with the event data. User provided
     * @param snapshot - The data backing the event
     * @param prevName - Optional, the name of the previous child for child_* events.
     */ constructor(eventType, eventRegistration, snapshot, prevName){
        this.eventType = eventType;
        this.eventRegistration = eventRegistration;
        this.snapshot = snapshot;
        this.prevName = prevName;
    }
    getPath() {
        const ref = this.snapshot.ref;
        if (this.eventType === "value") return ref._path;
        else return ref.parent._path;
    }
    getEventType() {
        return this.eventType;
    }
    getEventRunner() {
        return this.eventRegistration.getEventRunner(this);
    }
    toString() {
        return this.getPath().toString() + ":" + this.eventType + ":" + (0, $fc59d49e1bb53b6a$export$fac44ee5b035f737)(this.snapshot.exportVal());
    }
}
class $494ac95ccfb2d9dd$var$CancelEvent {
    constructor(eventRegistration, error, path){
        this.eventRegistration = eventRegistration;
        this.error = error;
        this.path = path;
    }
    getPath() {
        return this.path;
    }
    getEventType() {
        return "cancel";
    }
    getEventRunner() {
        return this.eventRegistration.getEventRunner(this);
    }
    toString() {
        return this.path.toString() + ":cancel";
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A wrapper class that converts events from the database@exp SDK to the legacy
 * Database SDK. Events are not converted directly as event registration relies
 * on reference comparison of the original user callback (see `matches()`) and
 * relies on equality of the legacy SDK's `context` object.
 */ class $494ac95ccfb2d9dd$var$CallbackContext {
    constructor(snapshotCallback, cancelCallback){
        this.snapshotCallback = snapshotCallback;
        this.cancelCallback = cancelCallback;
    }
    onValue(expDataSnapshot, previousChildName) {
        this.snapshotCallback.call(null, expDataSnapshot, previousChildName);
    }
    onCancel(error) {
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(this.hasCancelCallback, "Raising a cancel event on a listener with no cancel callback");
        return this.cancelCallback.call(null, error);
    }
    get hasCancelCallback() {
        return !!this.cancelCallback;
    }
    matches(other) {
        return this.snapshotCallback === other.snapshotCallback || this.snapshotCallback.userCallback !== undefined && this.snapshotCallback.userCallback === other.snapshotCallback.userCallback && this.snapshotCallback.context === other.snapshotCallback.context;
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The `onDisconnect` class allows you to write or clear data when your client
 * disconnects from the Database server. These updates occur whether your
 * client disconnects cleanly or not, so you can rely on them to clean up data
 * even if a connection is dropped or a client crashes.
 *
 * The `onDisconnect` class is most commonly used to manage presence in
 * applications where it is useful to detect how many clients are connected and
 * when other clients disconnect. See
 * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
 * for more information.
 *
 * To avoid problems when a connection is dropped before the requests can be
 * transferred to the Database server, these functions should be called before
 * writing any data.
 *
 * Note that `onDisconnect` operations are only triggered once. If you want an
 * operation to occur each time a disconnect occurs, you'll need to re-establish
 * the `onDisconnect` operations each time you reconnect.
 */ class $494ac95ccfb2d9dd$export$95b7818b4ee6c2af {
    /** @hideconstructor */ constructor(_repo, _path){
        this._repo = _repo;
        this._path = _path;
    }
    /**
     * Cancels all previously queued `onDisconnect()` set or update events for this
     * location and all children.
     *
     * If a write has been queued for this location via a `set()` or `update()` at a
     * parent location, the write at this location will be canceled, though writes
     * to sibling locations will still occur.
     *
     * @returns Resolves when synchronization to the server is complete.
     */ cancel() {
        const deferred = new (0, $fc59d49e1bb53b6a$export$85f6557964517f1a)();
        $494ac95ccfb2d9dd$var$repoOnDisconnectCancel(this._repo, this._path, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is deleted when the client is disconnected
     * (due to closing the browser, navigating to a new page, or network issues).
     *
     * @returns Resolves when synchronization to the server is complete.
     */ remove() {
        $494ac95ccfb2d9dd$export$8d83036122ae444e("OnDisconnect.remove", this._path);
        const deferred = new (0, $fc59d49e1bb53b6a$export$85f6557964517f1a)();
        $494ac95ccfb2d9dd$var$repoOnDisconnectSet(this._repo, this._path, null, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is set to the specified value when the
     * client is disconnected (due to closing the browser, navigating to a new page,
     * or network issues).
     *
     * `set()` is especially useful for implementing "presence" systems, where a
     * value should be changed or cleared when a user disconnects so that they
     * appear "offline" to other users. See
     * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
     * for more information.
     *
     * Note that `onDisconnect` operations are only triggered once. If you want an
     * operation to occur each time a disconnect occurs, you'll need to re-establish
     * the `onDisconnect` operations each time.
     *
     * @param value - The value to be written to this location on disconnect (can
     * be an object, array, string, number, boolean, or null).
     * @returns Resolves when synchronization to the Database is complete.
     */ set(value) {
        $494ac95ccfb2d9dd$export$8d83036122ae444e("OnDisconnect.set", this._path);
        $494ac95ccfb2d9dd$var$validateFirebaseDataArg("OnDisconnect.set", value, this._path, false);
        const deferred = new (0, $fc59d49e1bb53b6a$export$85f6557964517f1a)();
        $494ac95ccfb2d9dd$var$repoOnDisconnectSet(this._repo, this._path, value, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is set to the specified value and priority
     * when the client is disconnected (due to closing the browser, navigating to a
     * new page, or network issues).
     *
     * @param value - The value to be written to this location on disconnect (can
     * be an object, array, string, number, boolean, or null).
     * @param priority - The priority to be written (string, number, or null).
     * @returns Resolves when synchronization to the Database is complete.
     */ setWithPriority(value, priority) {
        $494ac95ccfb2d9dd$export$8d83036122ae444e("OnDisconnect.setWithPriority", this._path);
        $494ac95ccfb2d9dd$var$validateFirebaseDataArg("OnDisconnect.setWithPriority", value, this._path, false);
        $494ac95ccfb2d9dd$var$validatePriority("OnDisconnect.setWithPriority", priority, false);
        const deferred = new (0, $fc59d49e1bb53b6a$export$85f6557964517f1a)();
        $494ac95ccfb2d9dd$var$repoOnDisconnectSetWithPriority(this._repo, this._path, value, priority, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Writes multiple values at this location when the client is disconnected (due
     * to closing the browser, navigating to a new page, or network issues).
     *
     * The `values` argument contains multiple property-value pairs that will be
     * written to the Database together. Each child property can either be a simple
     * property (for example, "name") or a relative path (for example, "name/first")
     * from the current location to the data to update.
     *
     * As opposed to the `set()` method, `update()` can be use to selectively update
     * only the referenced properties at the current location (instead of replacing
     * all the child properties at the current location).
     *
     * @param values - Object containing multiple values.
     * @returns Resolves when synchronization to the Database is complete.
     */ update(values) {
        $494ac95ccfb2d9dd$export$8d83036122ae444e("OnDisconnect.update", this._path);
        $494ac95ccfb2d9dd$var$validateFirebaseMergeDataArg("OnDisconnect.update", values, this._path, false);
        const deferred = new (0, $fc59d49e1bb53b6a$export$85f6557964517f1a)();
        $494ac95ccfb2d9dd$var$repoOnDisconnectUpdate(this._repo, this._path, values, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ class $494ac95ccfb2d9dd$export$e79c8d837d2220a8 {
    /**
     * @hideconstructor
     */ constructor(_repo, _path, _queryParams, _orderByCalled){
        this._repo = _repo;
        this._path = _path;
        this._queryParams = _queryParams;
        this._orderByCalled = _orderByCalled;
    }
    get key() {
        if ($494ac95ccfb2d9dd$var$pathIsEmpty(this._path)) return null;
        else return $494ac95ccfb2d9dd$var$pathGetBack(this._path);
    }
    get ref() {
        return new $494ac95ccfb2d9dd$export$35c3a5e7c9d1033c(this._repo, this._path);
    }
    get _queryIdentifier() {
        const obj = $494ac95ccfb2d9dd$var$queryParamsGetQueryObject(this._queryParams);
        const id = $494ac95ccfb2d9dd$var$ObjectToUniqueKey(obj);
        return id === "{}" ? "default" : id;
    }
    /**
     * An object representation of the query parameters used by this Query.
     */ get _queryObject() {
        return $494ac95ccfb2d9dd$var$queryParamsGetQueryObject(this._queryParams);
    }
    isEqual(other) {
        other = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(other);
        if (!(other instanceof $494ac95ccfb2d9dd$export$e79c8d837d2220a8)) return false;
        const sameRepo = this._repo === other._repo;
        const samePath = $494ac95ccfb2d9dd$var$pathEquals(this._path, other._path);
        const sameQueryIdentifier = this._queryIdentifier === other._queryIdentifier;
        return sameRepo && samePath && sameQueryIdentifier;
    }
    toJSON() {
        return this.toString();
    }
    toString() {
        return this._repo.toString() + $494ac95ccfb2d9dd$var$pathToUrlEncodedString(this._path);
    }
}
/**
 * Validates that no other order by call has been made
 */ function $494ac95ccfb2d9dd$var$validateNoPreviousOrderByCall(query, fnName) {
    if (query._orderByCalled === true) throw new Error(fnName + ": You can't combine multiple orderBy calls.");
}
/**
 * Validates start/end values for queries.
 */ function $494ac95ccfb2d9dd$var$validateQueryEndpoints(params) {
    let startNode = null;
    let endNode = null;
    if (params.hasStart()) startNode = params.getIndexStartValue();
    if (params.hasEnd()) endNode = params.getIndexEndValue();
    if (params.getIndex() === $494ac95ccfb2d9dd$var$KEY_INDEX) {
        const tooManyArgsError = "Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().";
        const wrongArgTypeError = "Query: When ordering by key, the argument passed to startAt(), startAfter(), endAt(), endBefore(), or equalTo() must be a string.";
        if (params.hasStart()) {
            const startName = params.getIndexStartName();
            if (startName !== $494ac95ccfb2d9dd$var$MIN_NAME) throw new Error(tooManyArgsError);
            else if (typeof startNode !== "string") throw new Error(wrongArgTypeError);
        }
        if (params.hasEnd()) {
            const endName = params.getIndexEndName();
            if (endName !== $494ac95ccfb2d9dd$var$MAX_NAME) throw new Error(tooManyArgsError);
            else if (typeof endNode !== "string") throw new Error(wrongArgTypeError);
        }
    } else if (params.getIndex() === $494ac95ccfb2d9dd$var$PRIORITY_INDEX) {
        if (startNode != null && !$494ac95ccfb2d9dd$var$isValidPriority(startNode) || endNode != null && !$494ac95ccfb2d9dd$var$isValidPriority(endNode)) throw new Error("Query: When ordering by priority, the first argument passed to startAt(), startAfter() endAt(), endBefore(), or equalTo() must be a valid priority value (null, a number, or a string).");
    } else {
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(params.getIndex() instanceof $494ac95ccfb2d9dd$var$PathIndex || params.getIndex() === $494ac95ccfb2d9dd$var$VALUE_INDEX, "unknown index type.");
        if (startNode != null && typeof startNode === "object" || endNode != null && typeof endNode === "object") throw new Error("Query: First argument passed to startAt(), startAfter(), endAt(), endBefore(), or equalTo() cannot be an object.");
    }
}
/**
 * Validates that limit* has been called with the correct combination of parameters
 */ function $494ac95ccfb2d9dd$var$validateLimit(params) {
    if (params.hasStart() && params.hasEnd() && params.hasLimit() && !params.hasAnchoredLimit()) throw new Error("Query: Can't combine startAt(), startAfter(), endAt(), endBefore(), and limit(). Use limitToFirst() or limitToLast() instead.");
}
/**
 * @internal
 */ class $494ac95ccfb2d9dd$export$35c3a5e7c9d1033c extends $494ac95ccfb2d9dd$export$e79c8d837d2220a8 {
    /** @hideconstructor */ constructor(repo, path){
        super(repo, path, new $494ac95ccfb2d9dd$export$7ba287e361c94330(), false);
    }
    get parent() {
        const parentPath = $494ac95ccfb2d9dd$var$pathParent(this._path);
        return parentPath === null ? null : new $494ac95ccfb2d9dd$export$35c3a5e7c9d1033c(this._repo, parentPath);
    }
    get root() {
        let ref = this;
        while(ref.parent !== null)ref = ref.parent;
        return ref;
    }
}
/**
 * A `DataSnapshot` contains data from a Database location.
 *
 * Any time you read data from the Database, you receive the data as a
 * `DataSnapshot`. A `DataSnapshot` is passed to the event callbacks you attach
 * with `on()` or `once()`. You can extract the contents of the snapshot as a
 * JavaScript object by calling the `val()` method. Alternatively, you can
 * traverse into the snapshot by calling `child()` to return child snapshots
 * (which you could then call `val()` on).
 *
 * A `DataSnapshot` is an efficiently generated, immutable copy of the data at
 * a Database location. It cannot be modified and will never change (to modify
 * data, you always call the `set()` method on a `Reference` directly).
 */ class $494ac95ccfb2d9dd$export$80b98bcbc246c942 {
    /**
     * @param _node - A SnapshotNode to wrap.
     * @param ref - The location this snapshot came from.
     * @param _index - The iteration order for this snapshot
     * @hideconstructor
     */ constructor(_node, /**
     * The location of this DataSnapshot.
     */ ref, _index){
        this._node = _node;
        this.ref = ref;
        this._index = _index;
    }
    /**
     * Gets the priority value of the data in this `DataSnapshot`.
     *
     * Applications need not use priority but can order collections by
     * ordinary properties (see
     * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data |Sorting and filtering data}
     * ).
     */ get priority() {
        // typecast here because we never return deferred values or internal priorities (MAX_PRIORITY)
        return this._node.getPriority().val();
    }
    /**
     * The key (last part of the path) of the location of this `DataSnapshot`.
     *
     * The last token in a Database location is considered its key. For example,
     * "ada" is the key for the /users/ada/ node. Accessing the key on any
     * `DataSnapshot` will return the key for the location that generated it.
     * However, accessing the key on the root URL of a Database will return
     * `null`.
     */ get key() {
        return this.ref.key;
    }
    /** Returns the number of child properties of this `DataSnapshot`. */ get size() {
        return this._node.numChildren();
    }
    /**
     * Gets another `DataSnapshot` for the location at the specified relative path.
     *
     * Passing a relative path to the `child()` method of a DataSnapshot returns
     * another `DataSnapshot` for the location at the specified relative path. The
     * relative path can either be a simple child name (for example, "ada") or a
     * deeper, slash-separated path (for example, "ada/name/first"). If the child
     * location has no data, an empty `DataSnapshot` (that is, a `DataSnapshot`
     * whose value is `null`) is returned.
     *
     * @param path - A relative path to the location of child data.
     */ child(path) {
        const childPath = new $494ac95ccfb2d9dd$var$Path(path);
        const childRef = $494ac95ccfb2d9dd$export$f9574b70e1d95d9d(this.ref, path);
        return new $494ac95ccfb2d9dd$export$80b98bcbc246c942(this._node.getChild(childPath), childRef, $494ac95ccfb2d9dd$var$PRIORITY_INDEX);
    }
    /**
     * Returns true if this `DataSnapshot` contains any data. It is slightly more
     * efficient than using `snapshot.val() !== null`.
     */ exists() {
        return !this._node.isEmpty();
    }
    /**
     * Exports the entire contents of the DataSnapshot as a JavaScript object.
     *
     * The `exportVal()` method is similar to `val()`, except priority information
     * is included (if available), making it suitable for backing up your data.
     *
     * @returns The DataSnapshot's contents as a JavaScript value (Object,
     *   Array, string, number, boolean, or `null`).
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    exportVal() {
        return this._node.val(true);
    }
    /**
     * Enumerates the top-level children in the `DataSnapshot`.
     *
     * Because of the way JavaScript objects work, the ordering of data in the
     * JavaScript object returned by `val()` is not guaranteed to match the
     * ordering on the server nor the ordering of `onChildAdded()` events. That is
     * where `forEach()` comes in handy. It guarantees the children of a
     * `DataSnapshot` will be iterated in their query order.
     *
     * If no explicit `orderBy*()` method is used, results are returned
     * ordered by key (unless priorities are used, in which case, results are
     * returned by priority).
     *
     * @param action - A function that will be called for each child DataSnapshot.
     * The callback can return true to cancel further enumeration.
     * @returns true if enumeration was canceled due to your callback returning
     * true.
     */ forEach(action) {
        if (this._node.isLeafNode()) return false;
        const childrenNode = this._node;
        // Sanitize the return value to a boolean. ChildrenNode.forEachChild has a weird return type...
        return !!childrenNode.forEachChild(this._index, (key, node)=>{
            return action(new $494ac95ccfb2d9dd$export$80b98bcbc246c942(node, $494ac95ccfb2d9dd$export$f9574b70e1d95d9d(this.ref, key), $494ac95ccfb2d9dd$var$PRIORITY_INDEX));
        });
    }
    /**
     * Returns true if the specified child path has (non-null) data.
     *
     * @param path - A relative path to the location of a potential child.
     * @returns `true` if data exists at the specified child path; else
     *  `false`.
     */ hasChild(path) {
        const childPath = new $494ac95ccfb2d9dd$var$Path(path);
        return !this._node.getChild(childPath).isEmpty();
    }
    /**
     * Returns whether or not the `DataSnapshot` has any non-`null` child
     * properties.
     *
     * You can use `hasChildren()` to determine if a `DataSnapshot` has any
     * children. If it does, you can enumerate them using `forEach()`. If it
     * doesn't, then either this snapshot contains a primitive value (which can be
     * retrieved with `val()`) or it is empty (in which case, `val()` will return
     * `null`).
     *
     * @returns true if this snapshot has any children; else false.
     */ hasChildren() {
        if (this._node.isLeafNode()) return false;
        else return !this._node.isEmpty();
    }
    /**
     * Returns a JSON-serializable representation of this object.
     */ toJSON() {
        return this.exportVal();
    }
    /**
     * Extracts a JavaScript value from a `DataSnapshot`.
     *
     * Depending on the data in a `DataSnapshot`, the `val()` method may return a
     * scalar type (string, number, or boolean), an array, or an object. It may
     * also return null, indicating that the `DataSnapshot` is empty (contains no
     * data).
     *
     * @returns The DataSnapshot's contents as a JavaScript value (Object,
     *   Array, string, number, boolean, or `null`).
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    val() {
        return this._node.val();
    }
}
/**
 *
 * Returns a `Reference` representing the location in the Database
 * corresponding to the provided path. If no path is provided, the `Reference`
 * will point to the root of the Database.
 *
 * @param db - The database instance to obtain a reference for.
 * @param path - Optional path representing the location the returned
 *   `Reference` will point. If not provided, the returned `Reference` will
 *   point to the root of the Database.
 * @returns If a path is provided, a `Reference`
 *   pointing to the provided path. Otherwise, a `Reference` pointing to the
 *   root of the Database.
 */ function $494ac95ccfb2d9dd$export$eff4d24c3ff7876e(db, path) {
    db = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted("ref");
    return path !== undefined ? $494ac95ccfb2d9dd$export$f9574b70e1d95d9d(db._root, path) : db._root;
}
/**
 * Returns a `Reference` representing the location in the Database
 * corresponding to the provided Firebase URL.
 *
 * An exception is thrown if the URL is not a valid Firebase Database URL or it
 * has a different domain than the current `Database` instance.
 *
 * Note that all query parameters (`orderBy`, `limitToLast`, etc.) are ignored
 * and are not applied to the returned `Reference`.
 *
 * @param db - The database instance to obtain a reference for.
 * @param url - The Firebase URL at which the returned `Reference` will
 *   point.
 * @returns A `Reference` pointing to the provided
 *   Firebase URL.
 */ function $494ac95ccfb2d9dd$export$291fc3c05735451(db, url) {
    db = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted("refFromURL");
    const parsedURL = $494ac95ccfb2d9dd$var$parseRepoInfo(url, db._repo.repoInfo_.nodeAdmin);
    $494ac95ccfb2d9dd$var$validateUrl("refFromURL", parsedURL);
    const repoInfo = parsedURL.repoInfo;
    if (!db._repo.repoInfo_.isCustomHost() && repoInfo.host !== db._repo.repoInfo_.host) $494ac95ccfb2d9dd$var$fatal("refFromURL: Host name does not match the current database: (found " + repoInfo.host + " but expected " + db._repo.repoInfo_.host + ")");
    return $494ac95ccfb2d9dd$export$eff4d24c3ff7876e(db, parsedURL.path.toString());
}
/**
 * Gets a `Reference` for the location at the specified relative path.
 *
 * The relative path can either be a simple child name (for example, "ada") or
 * a deeper slash-separated path (for example, "ada/name/first").
 *
 * @param parent - The parent location.
 * @param path - A relative path from this location to the desired child
 *   location.
 * @returns The specified child location.
 */ function $494ac95ccfb2d9dd$export$f9574b70e1d95d9d(parent, path) {
    parent = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(parent);
    if ($494ac95ccfb2d9dd$var$pathGetFront(parent._path) === null) $494ac95ccfb2d9dd$var$validateRootPathString("child", "path", path, false);
    else $494ac95ccfb2d9dd$export$8637b026ace8abb1("child", "path", path, false);
    return new $494ac95ccfb2d9dd$export$35c3a5e7c9d1033c(parent._repo, $494ac95ccfb2d9dd$var$pathChild(parent._path, path));
}
/**
 * Returns an `OnDisconnect` object - see
 * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
 * for more information on how to use it.
 *
 * @param ref - The reference to add OnDisconnect triggers for.
 */ function $494ac95ccfb2d9dd$export$b61bdcd0bdb4f86a(ref) {
    ref = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(ref);
    return new $494ac95ccfb2d9dd$export$95b7818b4ee6c2af(ref._repo, ref._path);
}
/**
 * Generates a new child location using a unique key and returns its
 * `Reference`.
 *
 * This is the most common pattern for adding data to a collection of items.
 *
 * If you provide a value to `push()`, the value is written to the
 * generated location. If you don't pass a value, nothing is written to the
 * database and the child remains empty (but you can use the `Reference`
 * elsewhere).
 *
 * The unique keys generated by `push()` are ordered by the current time, so the
 * resulting list of items is chronologically sorted. The keys are also
 * designed to be unguessable (they contain 72 random bits of entropy).
 *
 * See {@link https://firebase.google.com/docs/database/web/lists-of-data#append_to_a_list_of_data | Append to a list of data}.
 * See {@link https://firebase.googleblog.com/2015/02/the-2120-ways-to-ensure-unique_68.html | The 2^120 Ways to Ensure Unique Identifiers}.
 *
 * @param parent - The parent location.
 * @param value - Optional value to be written at the generated location.
 * @returns Combined `Promise` and `Reference`; resolves when write is complete,
 * but can be used immediately as the `Reference` to the child location.
 */ function $494ac95ccfb2d9dd$export$4cbf152802aa238(parent, value) {
    parent = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(parent);
    $494ac95ccfb2d9dd$export$8d83036122ae444e("push", parent._path);
    $494ac95ccfb2d9dd$var$validateFirebaseDataArg("push", value, parent._path, true);
    const now = $494ac95ccfb2d9dd$var$repoServerTime(parent._repo);
    const name = $494ac95ccfb2d9dd$var$nextPushId(now);
    // push() returns a ThennableReference whose promise is fulfilled with a
    // regular Reference. We use child() to create handles to two different
    // references. The first is turned into a ThennableReference below by adding
    // then() and catch() methods and is used as the return value of push(). The
    // second remains a regular Reference and is used as the fulfilled value of
    // the first ThennableReference.
    const thennablePushRef = $494ac95ccfb2d9dd$export$f9574b70e1d95d9d(parent, name);
    const pushRef = $494ac95ccfb2d9dd$export$f9574b70e1d95d9d(parent, name);
    let promise;
    if (value != null) promise = $494ac95ccfb2d9dd$export$adaa4cf7ef1b65be(pushRef, value).then(()=>pushRef);
    else promise = Promise.resolve(pushRef);
    thennablePushRef.then = promise.then.bind(promise);
    thennablePushRef.catch = promise.then.bind(promise, undefined);
    return thennablePushRef;
}
/**
 * Removes the data at this Database location.
 *
 * Any data at child locations will also be deleted.
 *
 * The effect of the remove will be visible immediately and the corresponding
 * event 'value' will be triggered. Synchronization of the remove to the
 * Firebase servers will also be started, and the returned Promise will resolve
 * when complete. If provided, the onComplete callback will be called
 * asynchronously after synchronization has finished.
 *
 * @param ref - The location to remove.
 * @returns Resolves when remove on server is complete.
 */ function $494ac95ccfb2d9dd$export$cd7f480d6b8286c3(ref) {
    $494ac95ccfb2d9dd$export$8d83036122ae444e("remove", ref._path);
    return $494ac95ccfb2d9dd$export$adaa4cf7ef1b65be(ref, null);
}
/**
 * Writes data to this Database location.
 *
 * This will overwrite any data at this location and all child locations.
 *
 * The effect of the write will be visible immediately, and the corresponding
 * events ("value", "child_added", etc.) will be triggered. Synchronization of
 * the data to the Firebase servers will also be started, and the returned
 * Promise will resolve when complete. If provided, the `onComplete` callback
 * will be called asynchronously after synchronization has finished.
 *
 * Passing `null` for the new value is equivalent to calling `remove()`; namely,
 * all data at this location and all child locations will be deleted.
 *
 * `set()` will remove any priority stored at this location, so if priority is
 * meant to be preserved, you need to use `setWithPriority()` instead.
 *
 * Note that modifying data with `set()` will cancel any pending transactions
 * at that location, so extreme care should be taken if mixing `set()` and
 * `transaction()` to modify the same data.
 *
 * A single `set()` will generate a single "value" event at the location where
 * the `set()` was performed.
 *
 * @param ref - The location to write to.
 * @param value - The value to be written (string, number, boolean, object,
 *   array, or null).
 * @returns Resolves when write to server is complete.
 */ function $494ac95ccfb2d9dd$export$adaa4cf7ef1b65be(ref, value) {
    ref = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(ref);
    $494ac95ccfb2d9dd$export$8d83036122ae444e("set", ref._path);
    $494ac95ccfb2d9dd$var$validateFirebaseDataArg("set", value, ref._path, false);
    const deferred = new (0, $fc59d49e1bb53b6a$export$85f6557964517f1a)();
    $494ac95ccfb2d9dd$var$repoSetWithPriority(ref._repo, ref._path, value, /*priority=*/ null, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Sets a priority for the data at this Database location.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data | Sorting and filtering data}
 * ).
 *
 * @param ref - The location to write to.
 * @param priority - The priority to be written (string, number, or null).
 * @returns Resolves when write to server is complete.
 */ function $494ac95ccfb2d9dd$export$313bf5dbe7a1196e(ref, priority) {
    ref = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(ref);
    $494ac95ccfb2d9dd$export$8d83036122ae444e("setPriority", ref._path);
    $494ac95ccfb2d9dd$var$validatePriority("setPriority", priority, false);
    const deferred = new (0, $fc59d49e1bb53b6a$export$85f6557964517f1a)();
    $494ac95ccfb2d9dd$var$repoSetWithPriority(ref._repo, $494ac95ccfb2d9dd$var$pathChild(ref._path, ".priority"), priority, null, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Writes data the Database location. Like `set()` but also specifies the
 * priority for that data.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data | Sorting and filtering data}
 * ).
 *
 * @param ref - The location to write to.
 * @param value - The value to be written (string, number, boolean, object,
 *   array, or null).
 * @param priority - The priority to be written (string, number, or null).
 * @returns Resolves when write to server is complete.
 */ function $494ac95ccfb2d9dd$export$1fa5d5bf488088f3(ref, value, priority) {
    $494ac95ccfb2d9dd$export$8d83036122ae444e("setWithPriority", ref._path);
    $494ac95ccfb2d9dd$var$validateFirebaseDataArg("setWithPriority", value, ref._path, false);
    $494ac95ccfb2d9dd$var$validatePriority("setWithPriority", priority, false);
    if (ref.key === ".length" || ref.key === ".keys") throw "setWithPriority failed: " + ref.key + " is a read-only object.";
    const deferred = new (0, $fc59d49e1bb53b6a$export$85f6557964517f1a)();
    $494ac95ccfb2d9dd$var$repoSetWithPriority(ref._repo, ref._path, value, priority, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Writes multiple values to the Database at once.
 *
 * The `values` argument contains multiple property-value pairs that will be
 * written to the Database together. Each child property can either be a simple
 * property (for example, "name") or a relative path (for example,
 * "name/first") from the current location to the data to update.
 *
 * As opposed to the `set()` method, `update()` can be use to selectively update
 * only the referenced properties at the current location (instead of replacing
 * all the child properties at the current location).
 *
 * The effect of the write will be visible immediately, and the corresponding
 * events ('value', 'child_added', etc.) will be triggered. Synchronization of
 * the data to the Firebase servers will also be started, and the returned
 * Promise will resolve when complete. If provided, the `onComplete` callback
 * will be called asynchronously after synchronization has finished.
 *
 * A single `update()` will generate a single "value" event at the location
 * where the `update()` was performed, regardless of how many children were
 * modified.
 *
 * Note that modifying data with `update()` will cancel any pending
 * transactions at that location, so extreme care should be taken if mixing
 * `update()` and `transaction()` to modify the same data.
 *
 * Passing `null` to `update()` will remove the data at this location.
 *
 * See
 * {@link https://firebase.googleblog.com/2015/09/introducing-multi-location-updates-and_86.html | Introducing multi-location updates and more}.
 *
 * @param ref - The location to write to.
 * @param values - Object containing multiple values.
 * @returns Resolves when update on server is complete.
 */ function $494ac95ccfb2d9dd$export$722fbec263ad908a(ref, values) {
    $494ac95ccfb2d9dd$var$validateFirebaseMergeDataArg("update", values, ref._path, false);
    const deferred = new (0, $fc59d49e1bb53b6a$export$85f6557964517f1a)();
    $494ac95ccfb2d9dd$var$repoUpdate(ref._repo, ref._path, values, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Gets the most up-to-date result for this query.
 *
 * @param query - The query to run.
 * @returns A `Promise` which resolves to the resulting DataSnapshot if a value is
 * available, or rejects if the client is unable to return a value (e.g., if the
 * server is unreachable and there is nothing cached).
 */ function $494ac95ccfb2d9dd$export$3988ae62b71be9a3(query) {
    query = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(query);
    const callbackContext = new $494ac95ccfb2d9dd$var$CallbackContext(()=>{});
    const container = new $494ac95ccfb2d9dd$var$ValueEventRegistration(callbackContext);
    return $494ac95ccfb2d9dd$var$repoGetValue(query._repo, query, container).then((node)=>{
        return new $494ac95ccfb2d9dd$export$80b98bcbc246c942(node, new $494ac95ccfb2d9dd$export$35c3a5e7c9d1033c(query._repo, query._path), query._queryParams.getIndex());
    });
}
/**
 * Represents registration for 'value' events.
 */ class $494ac95ccfb2d9dd$var$ValueEventRegistration {
    constructor(callbackContext){
        this.callbackContext = callbackContext;
    }
    respondsTo(eventType) {
        return eventType === "value";
    }
    createEvent(change, query) {
        const index = query._queryParams.getIndex();
        return new $494ac95ccfb2d9dd$var$DataEvent("value", this, new $494ac95ccfb2d9dd$export$80b98bcbc246c942(change.snapshotNode, new $494ac95ccfb2d9dd$export$35c3a5e7c9d1033c(query._repo, query._path), index));
    }
    getEventRunner(eventData) {
        if (eventData.getEventType() === "cancel") return ()=>this.callbackContext.onCancel(eventData.error);
        else return ()=>this.callbackContext.onValue(eventData.snapshot, null);
    }
    createCancelEvent(error, path) {
        if (this.callbackContext.hasCancelCallback) return new $494ac95ccfb2d9dd$var$CancelEvent(this, error, path);
        else return null;
    }
    matches(other) {
        if (!(other instanceof $494ac95ccfb2d9dd$var$ValueEventRegistration)) return false;
        else if (!other.callbackContext || !this.callbackContext) // If no callback specified, we consider it to match any callback.
        return true;
        else return other.callbackContext.matches(this.callbackContext);
    }
    hasAnyCallback() {
        return this.callbackContext !== null;
    }
}
/**
 * Represents the registration of a child_x event.
 */ class $494ac95ccfb2d9dd$var$ChildEventRegistration {
    constructor(eventType, callbackContext){
        this.eventType = eventType;
        this.callbackContext = callbackContext;
    }
    respondsTo(eventType) {
        let eventToCheck = eventType === "children_added" ? "child_added" : eventType;
        eventToCheck = eventToCheck === "children_removed" ? "child_removed" : eventToCheck;
        return this.eventType === eventToCheck;
    }
    createCancelEvent(error, path) {
        if (this.callbackContext.hasCancelCallback) return new $494ac95ccfb2d9dd$var$CancelEvent(this, error, path);
        else return null;
    }
    createEvent(change, query) {
        (0, $fc59d49e1bb53b6a$export$a7a9523472993e97)(change.childName != null, "Child events should have a childName.");
        const childRef = $494ac95ccfb2d9dd$export$f9574b70e1d95d9d(new $494ac95ccfb2d9dd$export$35c3a5e7c9d1033c(query._repo, query._path), change.childName);
        const index = query._queryParams.getIndex();
        return new $494ac95ccfb2d9dd$var$DataEvent(change.type, this, new $494ac95ccfb2d9dd$export$80b98bcbc246c942(change.snapshotNode, childRef, index), change.prevName);
    }
    getEventRunner(eventData) {
        if (eventData.getEventType() === "cancel") return ()=>this.callbackContext.onCancel(eventData.error);
        else return ()=>this.callbackContext.onValue(eventData.snapshot, eventData.prevName);
    }
    matches(other) {
        if (other instanceof $494ac95ccfb2d9dd$var$ChildEventRegistration) return this.eventType === other.eventType && (!this.callbackContext || !other.callbackContext || this.callbackContext.matches(other.callbackContext));
        return false;
    }
    hasAnyCallback() {
        return !!this.callbackContext;
    }
}
function $494ac95ccfb2d9dd$var$addEventListener(query, eventType, callback, cancelCallbackOrListenOptions, options) {
    let cancelCallback;
    if (typeof cancelCallbackOrListenOptions === "object") {
        cancelCallback = undefined;
        options = cancelCallbackOrListenOptions;
    }
    if (typeof cancelCallbackOrListenOptions === "function") cancelCallback = cancelCallbackOrListenOptions;
    if (options && options.onlyOnce) {
        const userCallback = callback;
        const onceCallback = (dataSnapshot, previousChildName)=>{
            $494ac95ccfb2d9dd$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
            userCallback(dataSnapshot, previousChildName);
        };
        onceCallback.userCallback = callback.userCallback;
        onceCallback.context = callback.context;
        callback = onceCallback;
    }
    const callbackContext = new $494ac95ccfb2d9dd$var$CallbackContext(callback, cancelCallback || undefined);
    const container = eventType === "value" ? new $494ac95ccfb2d9dd$var$ValueEventRegistration(callbackContext) : new $494ac95ccfb2d9dd$var$ChildEventRegistration(eventType, callbackContext);
    $494ac95ccfb2d9dd$var$repoAddEventCallbackForQuery(query._repo, query, container);
    return ()=>$494ac95ccfb2d9dd$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
}
function $494ac95ccfb2d9dd$export$ad30f661f41f4d90(query, callback, cancelCallbackOrListenOptions, options) {
    return $494ac95ccfb2d9dd$var$addEventListener(query, "value", callback, cancelCallbackOrListenOptions, options);
}
function $494ac95ccfb2d9dd$export$fdc3e67b2775c753(query, callback, cancelCallbackOrListenOptions, options) {
    return $494ac95ccfb2d9dd$var$addEventListener(query, "child_added", callback, cancelCallbackOrListenOptions, options);
}
function $494ac95ccfb2d9dd$export$a3fdf31223dcb03(query, callback, cancelCallbackOrListenOptions, options) {
    return $494ac95ccfb2d9dd$var$addEventListener(query, "child_changed", callback, cancelCallbackOrListenOptions, options);
}
function $494ac95ccfb2d9dd$export$1b001b15904d2a7f(query, callback, cancelCallbackOrListenOptions, options) {
    return $494ac95ccfb2d9dd$var$addEventListener(query, "child_moved", callback, cancelCallbackOrListenOptions, options);
}
function $494ac95ccfb2d9dd$export$8362b530316d1aba(query, callback, cancelCallbackOrListenOptions, options) {
    return $494ac95ccfb2d9dd$var$addEventListener(query, "child_removed", callback, cancelCallbackOrListenOptions, options);
}
/**
 * Detaches a callback previously attached with the corresponding `on*()` (`onValue`, `onChildAdded`) listener.
 * Note: This is not the recommended way to remove a listener. Instead, please use the returned callback function from
 * the respective `on*` callbacks.
 *
 * Detach a callback previously attached with `on*()`. Calling `off()` on a parent listener
 * will not automatically remove listeners registered on child nodes, `off()`
 * must also be called on any child listeners to remove the callback.
 *
 * If a callback is not specified, all callbacks for the specified eventType
 * will be removed. Similarly, if no eventType is specified, all callbacks
 * for the `Reference` will be removed.
 *
 * Individual listeners can also be removed by invoking their unsubscribe
 * callbacks.
 *
 * @param query - The query that the listener was registered with.
 * @param eventType - One of the following strings: "value", "child_added",
 * "child_changed", "child_removed", or "child_moved." If omitted, all callbacks
 * for the `Reference` will be removed.
 * @param callback - The callback function that was passed to `on()` or
 * `undefined` to remove all callbacks.
 */ function $494ac95ccfb2d9dd$export$8c8705df4a2dcec9(query, eventType, callback) {
    let container = null;
    const expCallback = callback ? new $494ac95ccfb2d9dd$var$CallbackContext(callback) : null;
    if (eventType === "value") container = new $494ac95ccfb2d9dd$var$ValueEventRegistration(expCallback);
    else if (eventType) container = new $494ac95ccfb2d9dd$var$ChildEventRegistration(eventType, expCallback);
    $494ac95ccfb2d9dd$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Database query. `QueryConstraint`s are created by invoking {@link endAt},
 * {@link endBefore}, {@link startAt}, {@link startAfter}, {@link
 * limitToFirst}, {@link limitToLast}, {@link orderByChild},
 * {@link orderByChild}, {@link orderByKey} , {@link orderByPriority} ,
 * {@link orderByValue}  or {@link equalTo} and
 * can then be passed to {@link query} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class $494ac95ccfb2d9dd$export$b0e86f2c7431df4e {
}
class $494ac95ccfb2d9dd$var$QueryEndAtConstraint extends $494ac95ccfb2d9dd$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
    }
    _apply(query) {
        $494ac95ccfb2d9dd$var$validateFirebaseDataArg("endAt", this._value, query._path, true);
        const newParams = $494ac95ccfb2d9dd$var$queryParamsEndAt(query._queryParams, this._value, this._key);
        $494ac95ccfb2d9dd$var$validateLimit(newParams);
        $494ac95ccfb2d9dd$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasEnd()) throw new Error("endAt: Starting point was already set (by another call to endAt, endBefore or equalTo).");
        return new $494ac95ccfb2d9dd$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified ending point.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The ending point is inclusive, so children with exactly the specified value
 * will be included in the query. The optional key argument can be used to
 * further limit the range of the query. If it is specified, then children that
 * have exactly the specified value must also have a key name less than or equal
 * to the specified key.
 *
 * You can read more about `endAt()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to end at. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to end at, among the children with the previously
 * specified priority. This argument is only allowed if ordering by child,
 * value, or priority.
 */ function $494ac95ccfb2d9dd$export$28ec54a8428bdb3f(value, key) {
    $494ac95ccfb2d9dd$var$validateKey("endAt", "key", key, true);
    return new $494ac95ccfb2d9dd$var$QueryEndAtConstraint(value, key);
}
class $494ac95ccfb2d9dd$var$QueryEndBeforeConstraint extends $494ac95ccfb2d9dd$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
    }
    _apply(query) {
        $494ac95ccfb2d9dd$var$validateFirebaseDataArg("endBefore", this._value, query._path, false);
        const newParams = $494ac95ccfb2d9dd$var$queryParamsEndBefore(query._queryParams, this._value, this._key);
        $494ac95ccfb2d9dd$var$validateLimit(newParams);
        $494ac95ccfb2d9dd$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasEnd()) throw new Error("endBefore: Starting point was already set (by another call to endAt, endBefore or equalTo).");
        return new $494ac95ccfb2d9dd$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified ending point (exclusive).
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The ending point is exclusive. If only a value is provided, children
 * with a value less than the specified value will be included in the query.
 * If a key is specified, then children must have a value less than or equal
 * to the specified value and a key name less than the specified key.
 *
 * @param value - The value to end before. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to end before, among the children with the
 * previously specified priority. This argument is only allowed if ordering by
 * child, value, or priority.
 */ function $494ac95ccfb2d9dd$export$57203950645b8b11(value, key) {
    $494ac95ccfb2d9dd$var$validateKey("endBefore", "key", key, true);
    return new $494ac95ccfb2d9dd$var$QueryEndBeforeConstraint(value, key);
}
class $494ac95ccfb2d9dd$var$QueryStartAtConstraint extends $494ac95ccfb2d9dd$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
    }
    _apply(query) {
        $494ac95ccfb2d9dd$var$validateFirebaseDataArg("startAt", this._value, query._path, true);
        const newParams = $494ac95ccfb2d9dd$var$queryParamsStartAt(query._queryParams, this._value, this._key);
        $494ac95ccfb2d9dd$var$validateLimit(newParams);
        $494ac95ccfb2d9dd$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasStart()) throw new Error("startAt: Starting point was already set (by another call to startAt, startBefore or equalTo).");
        return new $494ac95ccfb2d9dd$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified starting point.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The starting point is inclusive, so children with exactly the specified value
 * will be included in the query. The optional key argument can be used to
 * further limit the range of the query. If it is specified, then children that
 * have exactly the specified value must also have a key name greater than or
 * equal to the specified key.
 *
 * You can read more about `startAt()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to start at. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start at. This argument is only allowed if
 * ordering by child, value, or priority.
 */ function $494ac95ccfb2d9dd$export$859941c5fc8eba6b(value = null, key) {
    $494ac95ccfb2d9dd$var$validateKey("startAt", "key", key, true);
    return new $494ac95ccfb2d9dd$var$QueryStartAtConstraint(value, key);
}
class $494ac95ccfb2d9dd$var$QueryStartAfterConstraint extends $494ac95ccfb2d9dd$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
    }
    _apply(query) {
        $494ac95ccfb2d9dd$var$validateFirebaseDataArg("startAfter", this._value, query._path, false);
        const newParams = $494ac95ccfb2d9dd$var$queryParamsStartAfter(query._queryParams, this._value, this._key);
        $494ac95ccfb2d9dd$var$validateLimit(newParams);
        $494ac95ccfb2d9dd$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasStart()) throw new Error("startAfter: Starting point was already set (by another call to startAt, startAfter, or equalTo).");
        return new $494ac95ccfb2d9dd$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified starting point (exclusive).
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The starting point is exclusive. If only a value is provided, children
 * with a value greater than the specified value will be included in the query.
 * If a key is specified, then children must have a value greater than or equal
 * to the specified value and a a key name greater than the specified key.
 *
 * @param value - The value to start after. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start after. This argument is only allowed if
 * ordering by child, value, or priority.
 */ function $494ac95ccfb2d9dd$export$dd8dee5f7b804673(value, key) {
    $494ac95ccfb2d9dd$var$validateKey("startAfter", "key", key, true);
    return new $494ac95ccfb2d9dd$var$QueryStartAfterConstraint(value, key);
}
class $494ac95ccfb2d9dd$var$QueryLimitToFirstConstraint extends $494ac95ccfb2d9dd$export$b0e86f2c7431df4e {
    constructor(_limit){
        super();
        this._limit = _limit;
    }
    _apply(query) {
        if (query._queryParams.hasLimit()) throw new Error("limitToFirst: Limit was already set (by another call to limitToFirst or limitToLast).");
        return new $494ac95ccfb2d9dd$export$e79c8d837d2220a8(query._repo, query._path, $494ac95ccfb2d9dd$var$queryParamsLimitToFirst(query._queryParams, this._limit), query._orderByCalled);
    }
}
/**
 * Creates a new `QueryConstraint` that if limited to the first specific number
 * of children.
 *
 * The `limitToFirst()` method is used to set a maximum number of children to be
 * synced for a given callback. If we set a limit of 100, we will initially only
 * receive up to 100 `child_added` events. If we have fewer than 100 messages
 * stored in our Database, a `child_added` event will fire for each message.
 * However, if we have over 100 messages, we will only receive a `child_added`
 * event for the first 100 ordered messages. As items change, we will receive
 * `child_removed` events for each item that drops out of the active list so
 * that the total number stays at 100.
 *
 * You can read more about `limitToFirst()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param limit - The maximum number of nodes to include in this query.
 */ function $494ac95ccfb2d9dd$export$9d02e839f813b99d(limit) {
    if (typeof limit !== "number" || Math.floor(limit) !== limit || limit <= 0) throw new Error("limitToFirst: First argument must be a positive integer.");
    return new $494ac95ccfb2d9dd$var$QueryLimitToFirstConstraint(limit);
}
class $494ac95ccfb2d9dd$var$QueryLimitToLastConstraint extends $494ac95ccfb2d9dd$export$b0e86f2c7431df4e {
    constructor(_limit){
        super();
        this._limit = _limit;
    }
    _apply(query) {
        if (query._queryParams.hasLimit()) throw new Error("limitToLast: Limit was already set (by another call to limitToFirst or limitToLast).");
        return new $494ac95ccfb2d9dd$export$e79c8d837d2220a8(query._repo, query._path, $494ac95ccfb2d9dd$var$queryParamsLimitToLast(query._queryParams, this._limit), query._orderByCalled);
    }
}
/**
 * Creates a new `QueryConstraint` that is limited to return only the last
 * specified number of children.
 *
 * The `limitToLast()` method is used to set a maximum number of children to be
 * synced for a given callback. If we set a limit of 100, we will initially only
 * receive up to 100 `child_added` events. If we have fewer than 100 messages
 * stored in our Database, a `child_added` event will fire for each message.
 * However, if we have over 100 messages, we will only receive a `child_added`
 * event for the last 100 ordered messages. As items change, we will receive
 * `child_removed` events for each item that drops out of the active list so
 * that the total number stays at 100.
 *
 * You can read more about `limitToLast()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param limit - The maximum number of nodes to include in this query.
 */ function $494ac95ccfb2d9dd$export$f823b3589f69d3b8(limit) {
    if (typeof limit !== "number" || Math.floor(limit) !== limit || limit <= 0) throw new Error("limitToLast: First argument must be a positive integer.");
    return new $494ac95ccfb2d9dd$var$QueryLimitToLastConstraint(limit);
}
class $494ac95ccfb2d9dd$var$QueryOrderByChildConstraint extends $494ac95ccfb2d9dd$export$b0e86f2c7431df4e {
    constructor(_path){
        super();
        this._path = _path;
    }
    _apply(query) {
        $494ac95ccfb2d9dd$var$validateNoPreviousOrderByCall(query, "orderByChild");
        const parsedPath = new $494ac95ccfb2d9dd$var$Path(this._path);
        if ($494ac95ccfb2d9dd$var$pathIsEmpty(parsedPath)) throw new Error("orderByChild: cannot pass in empty path. Use orderByValue() instead.");
        const index = new $494ac95ccfb2d9dd$var$PathIndex(parsedPath);
        const newParams = $494ac95ccfb2d9dd$var$queryParamsOrderBy(query._queryParams, index);
        $494ac95ccfb2d9dd$var$validateQueryEndpoints(newParams);
        return new $494ac95ccfb2d9dd$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by the specified child key.
 *
 * Queries can only order by one key at a time. Calling `orderByChild()`
 * multiple times on the same query is an error.
 *
 * Firebase queries allow you to order your data by any child key on the fly.
 * However, if you know in advance what your indexes will be, you can define
 * them via the .indexOn rule in your Security Rules for better performance. See
 * the{@link https://firebase.google.com/docs/database/security/indexing-data}
 * rule for more information.
 *
 * You can read more about `orderByChild()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 *
 * @param path - The path to order by.
 */ function $494ac95ccfb2d9dd$export$5162bd9025f8e144(path) {
    if (path === "$key") throw new Error('orderByChild: "$key" is invalid.  Use orderByKey() instead.');
    else if (path === "$priority") throw new Error('orderByChild: "$priority" is invalid.  Use orderByPriority() instead.');
    else if (path === "$value") throw new Error('orderByChild: "$value" is invalid.  Use orderByValue() instead.');
    $494ac95ccfb2d9dd$export$8637b026ace8abb1("orderByChild", "path", path, false);
    return new $494ac95ccfb2d9dd$var$QueryOrderByChildConstraint(path);
}
class $494ac95ccfb2d9dd$var$QueryOrderByKeyConstraint extends $494ac95ccfb2d9dd$export$b0e86f2c7431df4e {
    _apply(query) {
        $494ac95ccfb2d9dd$var$validateNoPreviousOrderByCall(query, "orderByKey");
        const newParams = $494ac95ccfb2d9dd$var$queryParamsOrderBy(query._queryParams, $494ac95ccfb2d9dd$var$KEY_INDEX);
        $494ac95ccfb2d9dd$var$validateQueryEndpoints(newParams);
        return new $494ac95ccfb2d9dd$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by the key.
 *
 * Sorts the results of a query by their (ascending) key values.
 *
 * You can read more about `orderByKey()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 */ function $494ac95ccfb2d9dd$export$d5ab8b3bbd8afbf8() {
    return new $494ac95ccfb2d9dd$var$QueryOrderByKeyConstraint();
}
class $494ac95ccfb2d9dd$var$QueryOrderByPriorityConstraint extends $494ac95ccfb2d9dd$export$b0e86f2c7431df4e {
    _apply(query) {
        $494ac95ccfb2d9dd$var$validateNoPreviousOrderByCall(query, "orderByPriority");
        const newParams = $494ac95ccfb2d9dd$var$queryParamsOrderBy(query._queryParams, $494ac95ccfb2d9dd$var$PRIORITY_INDEX);
        $494ac95ccfb2d9dd$var$validateQueryEndpoints(newParams);
        return new $494ac95ccfb2d9dd$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by priority.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}
 * for alternatives to priority.
 */ function $494ac95ccfb2d9dd$export$19e8ae5500cf2e55() {
    return new $494ac95ccfb2d9dd$var$QueryOrderByPriorityConstraint();
}
class $494ac95ccfb2d9dd$var$QueryOrderByValueConstraint extends $494ac95ccfb2d9dd$export$b0e86f2c7431df4e {
    _apply(query) {
        $494ac95ccfb2d9dd$var$validateNoPreviousOrderByCall(query, "orderByValue");
        const newParams = $494ac95ccfb2d9dd$var$queryParamsOrderBy(query._queryParams, $494ac95ccfb2d9dd$var$VALUE_INDEX);
        $494ac95ccfb2d9dd$var$validateQueryEndpoints(newParams);
        return new $494ac95ccfb2d9dd$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by value.
 *
 * If the children of a query are all scalar values (string, number, or
 * boolean), you can order the results by their (ascending) values.
 *
 * You can read more about `orderByValue()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 */ function $494ac95ccfb2d9dd$export$7f2f62793c39d0c0() {
    return new $494ac95ccfb2d9dd$var$QueryOrderByValueConstraint();
}
class $494ac95ccfb2d9dd$var$QueryEqualToValueConstraint extends $494ac95ccfb2d9dd$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
    }
    _apply(query) {
        $494ac95ccfb2d9dd$var$validateFirebaseDataArg("equalTo", this._value, query._path, false);
        if (query._queryParams.hasStart()) throw new Error("equalTo: Starting point was already set (by another call to startAt/startAfter or equalTo).");
        if (query._queryParams.hasEnd()) throw new Error("equalTo: Ending point was already set (by another call to endAt/endBefore or equalTo).");
        return new $494ac95ccfb2d9dd$var$QueryEndAtConstraint(this._value, this._key)._apply(new $494ac95ccfb2d9dd$var$QueryStartAtConstraint(this._value, this._key)._apply(query));
    }
}
/**
 * Creates a `QueryConstraint` that includes children that match the specified
 * value.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The optional key argument can be used to further limit the range of the
 * query. If it is specified, then children that have exactly the specified
 * value must also have exactly the specified key as their key name. This can be
 * used to filter result sets with many matches for the same value.
 *
 * You can read more about `equalTo()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to match for. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start at, among the children with the
 * previously specified priority. This argument is only allowed if ordering by
 * child, value, or priority.
 */ function $494ac95ccfb2d9dd$export$bdcdec1f91f16dff(value, key) {
    $494ac95ccfb2d9dd$var$validateKey("equalTo", "key", key, true);
    return new $494ac95ccfb2d9dd$var$QueryEqualToValueConstraint(value, key);
}
/**
 * Creates a new immutable instance of `Query` that is extended to also include
 * additional query constraints.
 *
 * @param query - The Query instance to use as a base for the new constraints.
 * @param queryConstraints - The list of `QueryConstraint`s to apply.
 * @throws if any of the provided query constraints cannot be combined with the
 * existing or new constraints.
 */ function $494ac95ccfb2d9dd$export$2fa187e846a241c4(query1, ...queryConstraints) {
    let queryImpl = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(query1);
    for (const constraint of queryConstraints)queryImpl = constraint._apply(queryImpl);
    return queryImpl;
}
/**
 * Define reference constructor in various modules
 *
 * We are doing this here to avoid several circular
 * dependency issues
 */ $494ac95ccfb2d9dd$var$syncPointSetReferenceConstructor($494ac95ccfb2d9dd$export$35c3a5e7c9d1033c);
$494ac95ccfb2d9dd$var$syncTreeSetReferenceConstructor($494ac95ccfb2d9dd$export$35c3a5e7c9d1033c);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This variable is also defined in the firebase Node.js Admin SDK. Before
 * modifying this definition, consult the definition in:
 *
 * https://github.com/firebase/firebase-admin-node
 *
 * and make sure the two are consistent.
 */ const $494ac95ccfb2d9dd$var$FIREBASE_DATABASE_EMULATOR_HOST_VAR = "FIREBASE_DATABASE_EMULATOR_HOST";
/**
 * Creates and caches `Repo` instances.
 */ const $494ac95ccfb2d9dd$var$repos = {};
/**
 * If true, any new `Repo` will be created to use `ReadonlyRestClient` (for testing purposes).
 */ let $494ac95ccfb2d9dd$var$useRestClient = false;
/**
 * Update an existing `Repo` in place to point to a new host/port.
 */ function $494ac95ccfb2d9dd$var$repoManagerApplyEmulatorSettings(repo, host, port, tokenProvider) {
    repo.repoInfo_ = new $494ac95ccfb2d9dd$var$RepoInfo(`${host}:${port}`, /* secure= */ false, repo.repoInfo_.namespace, repo.repoInfo_.webSocketOnly, repo.repoInfo_.nodeAdmin, repo.repoInfo_.persistenceKey, repo.repoInfo_.includeNamespaceInQueryParams, /*isUsingEmulator=*/ true);
    if (tokenProvider) repo.authTokenProvider_ = tokenProvider;
}
/**
 * This function should only ever be called to CREATE a new database instance.
 * @internal
 */ function $494ac95ccfb2d9dd$export$a248c1d2ea757674(app, authProvider, appCheckProvider, url, nodeAdmin) {
    let dbUrl = url || app.options.databaseURL;
    if (dbUrl === undefined) {
        if (!app.options.projectId) $494ac95ccfb2d9dd$var$fatal("Can't determine Firebase Database URL. Be sure to include  a Project ID when calling firebase.initializeApp().");
        $494ac95ccfb2d9dd$var$log("Using default host for project ", app.options.projectId);
        dbUrl = `${app.options.projectId}-default-rtdb.firebaseio.com`;
    }
    let parsedUrl = $494ac95ccfb2d9dd$var$parseRepoInfo(dbUrl, nodeAdmin);
    let repoInfo = parsedUrl.repoInfo;
    let isEmulator;
    let dbEmulatorHost = undefined;
    if (typeof $c68e419b2a37d2b9$exports !== "undefined" && $c68e419b2a37d2b9$exports.env) dbEmulatorHost = $c68e419b2a37d2b9$exports.env[$494ac95ccfb2d9dd$var$FIREBASE_DATABASE_EMULATOR_HOST_VAR];
    if (dbEmulatorHost) {
        isEmulator = true;
        dbUrl = `http://${dbEmulatorHost}?ns=${repoInfo.namespace}`;
        parsedUrl = $494ac95ccfb2d9dd$var$parseRepoInfo(dbUrl, nodeAdmin);
        repoInfo = parsedUrl.repoInfo;
    } else isEmulator = !parsedUrl.repoInfo.secure;
    const authTokenProvider = nodeAdmin && isEmulator ? new $494ac95ccfb2d9dd$var$EmulatorTokenProvider($494ac95ccfb2d9dd$var$EmulatorTokenProvider.OWNER) : new $494ac95ccfb2d9dd$var$FirebaseAuthTokenProvider(app.name, app.options, authProvider);
    $494ac95ccfb2d9dd$var$validateUrl("Invalid Firebase Database URL", parsedUrl);
    if (!$494ac95ccfb2d9dd$var$pathIsEmpty(parsedUrl.path)) $494ac95ccfb2d9dd$var$fatal("Database URL must point to the root of a Firebase Database (not including a child path).");
    const repo = $494ac95ccfb2d9dd$var$repoManagerCreateRepo(repoInfo, app, authTokenProvider, new $494ac95ccfb2d9dd$var$AppCheckTokenProvider(app.name, appCheckProvider));
    return new $494ac95ccfb2d9dd$export$6feb5ea51a7b0b47(repo, app);
}
/**
 * Remove the repo and make sure it is disconnected.
 *
 */ function $494ac95ccfb2d9dd$var$repoManagerDeleteRepo(repo, appName) {
    const appRepos = $494ac95ccfb2d9dd$var$repos[appName];
    // This should never happen...
    if (!appRepos || appRepos[repo.key] !== repo) $494ac95ccfb2d9dd$var$fatal(`Database ${appName}(${repo.repoInfo_}) has already been deleted.`);
    $494ac95ccfb2d9dd$var$repoInterrupt(repo);
    delete appRepos[repo.key];
}
/**
 * Ensures a repo doesn't already exist and then creates one using the
 * provided app.
 *
 * @param repoInfo - The metadata about the Repo
 * @returns The Repo object for the specified server / repoName.
 */ function $494ac95ccfb2d9dd$var$repoManagerCreateRepo(repoInfo, app, authTokenProvider, appCheckProvider) {
    let appRepos = $494ac95ccfb2d9dd$var$repos[app.name];
    if (!appRepos) {
        appRepos = {};
        $494ac95ccfb2d9dd$var$repos[app.name] = appRepos;
    }
    let repo = appRepos[repoInfo.toURLString()];
    if (repo) $494ac95ccfb2d9dd$var$fatal("Database initialized multiple times. Please make sure the format of the database URL matches with each database() call.");
    repo = new $494ac95ccfb2d9dd$var$Repo(repoInfo, $494ac95ccfb2d9dd$var$useRestClient, authTokenProvider, appCheckProvider);
    appRepos[repoInfo.toURLString()] = repo;
    return repo;
}
/**
 * Forces us to use ReadonlyRestClient instead of PersistentConnection for new Repos.
 */ function $494ac95ccfb2d9dd$var$repoManagerForceRestClient(forceRestClient) {
    $494ac95ccfb2d9dd$var$useRestClient = forceRestClient;
}
/**
 * Class representing a Firebase Realtime Database.
 */ class $494ac95ccfb2d9dd$export$6feb5ea51a7b0b47 {
    /** @hideconstructor */ constructor(_repoInternal, /** The {@link @firebase/app#FirebaseApp} associated with this Realtime Database instance. */ app){
        this._repoInternal = _repoInternal;
        this.app = app;
        /** Represents a `Database` instance. */ this["type"] = "database";
        /** Track if the instance has been used (root or repo accessed) */ this._instanceStarted = false;
    }
    get _repo() {
        if (!this._instanceStarted) {
            $494ac95ccfb2d9dd$var$repoStart(this._repoInternal, this.app.options.appId, this.app.options["databaseAuthVariableOverride"]);
            this._instanceStarted = true;
        }
        return this._repoInternal;
    }
    get _root() {
        if (!this._rootInternal) this._rootInternal = new $494ac95ccfb2d9dd$export$35c3a5e7c9d1033c(this._repo, $494ac95ccfb2d9dd$var$newEmptyPath());
        return this._rootInternal;
    }
    _delete() {
        if (this._rootInternal !== null) {
            $494ac95ccfb2d9dd$var$repoManagerDeleteRepo(this._repo, this.app.name);
            this._repoInternal = null;
            this._rootInternal = null;
        }
        return Promise.resolve();
    }
    _checkNotDeleted(apiName) {
        if (this._rootInternal === null) $494ac95ccfb2d9dd$var$fatal("Cannot call " + apiName + " on a deleted database.");
    }
}
function $494ac95ccfb2d9dd$var$checkTransportInit() {
    if ($494ac95ccfb2d9dd$var$TransportManager.IS_TRANSPORT_INITIALIZED) $494ac95ccfb2d9dd$var$warn("Transport has already been initialized. Please call this function before calling ref or setting up a listener");
}
/**
 * Force the use of websockets instead of longPolling.
 */ function $494ac95ccfb2d9dd$export$752b38c15a5377b6() {
    $494ac95ccfb2d9dd$var$checkTransportInit();
    $494ac95ccfb2d9dd$var$BrowserPollConnection.forceDisallow();
}
/**
 * Force the use of longPolling instead of websockets. This will be ignored if websocket protocol is used in databaseURL.
 */ function $494ac95ccfb2d9dd$export$387cff57f2608869() {
    $494ac95ccfb2d9dd$var$checkTransportInit();
    $494ac95ccfb2d9dd$var$WebSocketConnection.forceDisallow();
    $494ac95ccfb2d9dd$var$BrowserPollConnection.forceAllow();
}
/**
 * Returns the instance of the Realtime Database SDK that is associated
 * with the provided {@link @firebase/app#FirebaseApp}. Initializes a new instance with
 * with default settings if no instance exists or if the existing instance uses
 * a custom database URL.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} instance that the returned Realtime
 * Database instance is associated with.
 * @param url - The URL of the Realtime Database instance to connect to. If not
 * provided, the SDK connects to the default instance of the Firebase App.
 * @returns The `Database` instance of the provided app.
 */ function $494ac95ccfb2d9dd$export$d0dd861204d0bf72(app = (0, $e3a1e3018df58994$export$f9962582c9e66d99)(), url) {
    const db = (0, $e3a1e3018df58994$export$fa0d6da0f5838f50)(app, "database").getImmediate({
        identifier: url
    });
    if (!db._instanceStarted) {
        const emulator = (0, $fc59d49e1bb53b6a$export$a3febcf1f14a3a0c)("database");
        if (emulator) $494ac95ccfb2d9dd$export$87f3cfc4a2e3958d(db, ...emulator);
    }
    return db;
}
/**
 * Modify the provided instance to communicate with the Realtime Database
 * emulator.
 *
 * <p>Note: This method must be called before performing any other operation.
 *
 * @param db - The instance to modify.
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 8080)
 * @param options.mockUserToken - the mock auth token to use for unit testing Security Rules
 */ function $494ac95ccfb2d9dd$export$87f3cfc4a2e3958d(db, host, port, options = {}) {
    db = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted("useEmulator");
    if (db._instanceStarted) $494ac95ccfb2d9dd$var$fatal("Cannot call useEmulator() after instance has already been initialized.");
    const repo = db._repoInternal;
    let tokenProvider = undefined;
    if (repo.repoInfo_.nodeAdmin) {
        if (options.mockUserToken) $494ac95ccfb2d9dd$var$fatal('mockUserToken is not supported by the Admin SDK. For client access with mock users, please use the "firebase" package instead of "firebase-admin".');
        tokenProvider = new $494ac95ccfb2d9dd$var$EmulatorTokenProvider($494ac95ccfb2d9dd$var$EmulatorTokenProvider.OWNER);
    } else if (options.mockUserToken) {
        const token = typeof options.mockUserToken === "string" ? options.mockUserToken : (0, $fc59d49e1bb53b6a$export$367bf224123348f1)(options.mockUserToken, db.app.options.projectId);
        tokenProvider = new $494ac95ccfb2d9dd$var$EmulatorTokenProvider(token);
    }
    // Modify the repo to apply emulator settings
    $494ac95ccfb2d9dd$var$repoManagerApplyEmulatorSettings(repo, host, port, tokenProvider);
}
/**
 * Disconnects from the server (all Database operations will be completed
 * offline).
 *
 * The client automatically maintains a persistent connection to the Database
 * server, which will remain active indefinitely and reconnect when
 * disconnected. However, the `goOffline()` and `goOnline()` methods may be used
 * to control the client connection in cases where a persistent connection is
 * undesirable.
 *
 * While offline, the client will no longer receive data updates from the
 * Database. However, all Database operations performed locally will continue to
 * immediately fire events, allowing your application to continue behaving
 * normally. Additionally, each operation performed locally will automatically
 * be queued and retried upon reconnection to the Database server.
 *
 * To reconnect to the Database and begin receiving remote events, see
 * `goOnline()`.
 *
 * @param db - The instance to disconnect.
 */ function $494ac95ccfb2d9dd$export$bee838355d017f0a(db) {
    db = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted("goOffline");
    $494ac95ccfb2d9dd$var$repoInterrupt(db._repo);
}
/**
 * Reconnects to the server and synchronizes the offline Database state
 * with the server state.
 *
 * This method should be used after disabling the active connection with
 * `goOffline()`. Once reconnected, the client will transmit the proper data
 * and fire the appropriate events so that your client "catches up"
 * automatically.
 *
 * @param db - The instance to reconnect.
 */ function $494ac95ccfb2d9dd$export$e0eecaabee32dd(db) {
    db = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted("goOnline");
    $494ac95ccfb2d9dd$var$repoResume(db._repo);
}
function $494ac95ccfb2d9dd$export$4e1d237eb9e560af(logger, persistent) {
    $494ac95ccfb2d9dd$var$enableLogging$1(logger, persistent);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $494ac95ccfb2d9dd$var$registerDatabase(variant) {
    $494ac95ccfb2d9dd$export$c9fb972242fcb3c4((0, $e3a1e3018df58994$export$31499a9cd224b78c));
    (0, $e3a1e3018df58994$export$c930050e7bb63965)(new (0, $e04d5da8f80f59f8$export$16fa2f45be04daa8)("database", (container, { instanceIdentifier: url  })=>{
        const app = container.getProvider("app").getImmediate();
        const authProvider = container.getProvider("auth-internal");
        const appCheckProvider = container.getProvider("app-check-internal");
        return $494ac95ccfb2d9dd$export$a248c1d2ea757674(app, authProvider, appCheckProvider, url);
    }, "PUBLIC" /* ComponentType.PUBLIC */ ).setMultipleInstances(true));
    (0, $e3a1e3018df58994$export$d29d5299a7137abc)($494ac95ccfb2d9dd$var$name, $494ac95ccfb2d9dd$var$version, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $e3a1e3018df58994$export$d29d5299a7137abc)($494ac95ccfb2d9dd$var$name, $494ac95ccfb2d9dd$var$version, "esm2017");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $494ac95ccfb2d9dd$var$SERVER_TIMESTAMP = {
    ".sv": "timestamp"
};
/**
 * Returns a placeholder value for auto-populating the current timestamp (time
 * since the Unix epoch, in milliseconds) as determined by the Firebase
 * servers.
 */ function $494ac95ccfb2d9dd$export$3ff8e7e00c3264b7() {
    return $494ac95ccfb2d9dd$var$SERVER_TIMESTAMP;
}
/**
 * Returns a placeholder value that can be used to atomically increment the
 * current database value by the provided delta.
 *
 * @param delta - the amount to modify the current value atomically.
 * @returns A placeholder value for modifying data atomically server-side.
 */ function $494ac95ccfb2d9dd$export$a2647aa13413c947(delta) {
    return {
        ".sv": {
            "increment": delta
        }
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A type for the resolve value of {@link runTransaction}.
 */ class $494ac95ccfb2d9dd$export$7a6f238067628c6b {
    /** @hideconstructor */ constructor(/** Whether the transaction was successfully committed. */ committed, /** The resulting data snapshot. */ snapshot){
        this.committed = committed;
        this.snapshot = snapshot;
    }
    /** Returns a JSON-serializable representation of this object. */ toJSON() {
        return {
            committed: this.committed,
            snapshot: this.snapshot.toJSON()
        };
    }
}
/**
 * Atomically modifies the data at this location.
 *
 * Atomically modify the data at this location. Unlike a normal `set()`, which
 * just overwrites the data regardless of its previous value, `runTransaction()` is
 * used to modify the existing value to a new value, ensuring there are no
 * conflicts with other clients writing to the same location at the same time.
 *
 * To accomplish this, you pass `runTransaction()` an update function which is
 * used to transform the current value into a new value. If another client
 * writes to the location before your new value is successfully written, your
 * update function will be called again with the new current value, and the
 * write will be retried. This will happen repeatedly until your write succeeds
 * without conflict or you abort the transaction by not returning a value from
 * your update function.
 *
 * Note: Modifying data with `set()` will cancel any pending transactions at
 * that location, so extreme care should be taken if mixing `set()` and
 * `runTransaction()` to update the same data.
 *
 * Note: When using transactions with Security and Firebase Rules in place, be
 * aware that a client needs `.read` access in addition to `.write` access in
 * order to perform a transaction. This is because the client-side nature of
 * transactions requires the client to read the data in order to transactionally
 * update it.
 *
 * @param ref - The location to atomically modify.
 * @param transactionUpdate - A developer-supplied function which will be passed
 * the current data stored at this location (as a JavaScript object). The
 * function should return the new value it would like written (as a JavaScript
 * object). If `undefined` is returned (i.e. you return with no arguments) the
 * transaction will be aborted and the data at this location will not be
 * modified.
 * @param options - An options object to configure transactions.
 * @returns A `Promise` that can optionally be used instead of the `onComplete`
 * callback to handle success and failure.
 */ function $494ac95ccfb2d9dd$export$3c54e006bf9c93b7(ref, // eslint-disable-next-line @typescript-eslint/no-explicit-any
transactionUpdate, options) {
    var _a;
    ref = (0, $fc59d49e1bb53b6a$export$4befe9b5fa509a1b)(ref);
    $494ac95ccfb2d9dd$export$8d83036122ae444e("Reference.transaction", ref._path);
    if (ref.key === ".length" || ref.key === ".keys") throw "Reference.transaction failed: " + ref.key + " is a read-only object.";
    const applyLocally = (_a = options === null || options === void 0 ? void 0 : options.applyLocally) !== null && _a !== void 0 ? _a : true;
    const deferred = new (0, $fc59d49e1bb53b6a$export$85f6557964517f1a)();
    const promiseComplete = (error, committed, node)=>{
        let dataSnapshot = null;
        if (error) deferred.reject(error);
        else {
            dataSnapshot = new $494ac95ccfb2d9dd$export$80b98bcbc246c942(node, new $494ac95ccfb2d9dd$export$35c3a5e7c9d1033c(ref._repo, ref._path), $494ac95ccfb2d9dd$var$PRIORITY_INDEX);
            deferred.resolve(new $494ac95ccfb2d9dd$export$7a6f238067628c6b(committed, dataSnapshot));
        }
    };
    // Add a watch to make sure we get server updates.
    const unwatcher = $494ac95ccfb2d9dd$export$ad30f661f41f4d90(ref, ()=>{});
    $494ac95ccfb2d9dd$var$repoStartTransaction(ref._repo, ref._path, transactionUpdate, promiseComplete, unwatcher, applyLocally);
    return deferred.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $494ac95ccfb2d9dd$var$PersistentConnection;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$494ac95ccfb2d9dd$var$PersistentConnection.prototype.simpleListen = function(pathString, onComplete) {
    this.sendRequest("q", {
        p: pathString
    }, onComplete);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$494ac95ccfb2d9dd$var$PersistentConnection.prototype.echo = function(data, onEcho) {
    this.sendRequest("echo", {
        d: data
    }, onEcho);
};
// RealTimeConnection properties that we use in tests.
$494ac95ccfb2d9dd$var$Connection;
/**
 * @internal
 */ const $494ac95ccfb2d9dd$export$3f9782a4529ff160 = function(newHash) {
    const oldPut = $494ac95ccfb2d9dd$var$PersistentConnection.prototype.put;
    $494ac95ccfb2d9dd$var$PersistentConnection.prototype.put = function(pathString, data, onComplete, hash) {
        if (hash !== undefined) hash = newHash();
        oldPut.call(this, pathString, data, onComplete, hash);
    };
    return function() {
        $494ac95ccfb2d9dd$var$PersistentConnection.prototype.put = oldPut;
    };
};
$494ac95ccfb2d9dd$var$RepoInfo;
/**
 * Forces the RepoManager to create Repos that use ReadonlyRestClient instead of PersistentConnection.
 * @internal
 */ const $494ac95ccfb2d9dd$export$868c9f20a76f0839 = function(forceRestClient) {
    $494ac95ccfb2d9dd$var$repoManagerForceRestClient(forceRestClient);
};
/**
 * Firebase Realtime Database
 *
 * @packageDocumentation
 */ $494ac95ccfb2d9dd$var$registerDatabase();





var $8T3gX = parcelRequire("8T3gX");

parcelRequire("8T3gX");

let $3eda0b7570ee1d13$var$_flashes = [];
const $3eda0b7570ee1d13$export$fc8909f42473b306 = (flashes)=>{};
function $3eda0b7570ee1d13$var$addFlash(node) {
    $3eda0b7570ee1d13$var$_flashes = [
        ...$3eda0b7570ee1d13$var$_flashes,
        node
    ];
    const flashEvent = new CustomEvent("flashChange", {
        detail: $3eda0b7570ee1d13$var$_flashes
    });
    document.dispatchEvent(flashEvent);
    // Return a function to remove the flash
    return ()=>$3eda0b7570ee1d13$var$removeFlash(node);
}
function $3eda0b7570ee1d13$var$removeFlash(node) {
    $3eda0b7570ee1d13$var$_flashes = $3eda0b7570ee1d13$var$_flashes.filter((n)=>n !== node);
    $3eda0b7570ee1d13$export$fc8909f42473b306($3eda0b7570ee1d13$var$_flashes);
}
function $3eda0b7570ee1d13$export$fff9462e59a6c087(node) {
    if (node instanceof Error) node = /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $1d0a237fe4c0025c$export$2e2bcd8739ae039), {
        variant: "danger",
        children: node.message
    });
    else if (typeof node === "string") node = /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $1d0a237fe4c0025c$export$2e2bcd8739ae039), {
        variant: "success",
        children: node
    });
    const unflash = $3eda0b7570ee1d13$var$addFlash(node);
    setTimeout(unflash, 10000);
}


function $4ac80628868fb8a2$export$3efb1a4ef0888a13(action) {
    action.catch((err)=>(0, $3eda0b7570ee1d13$export$fff9462e59a6c087)(err));
    return action;
}


(0, $e3a1e3018df58994$export$c622e99c0ce7b1c9)("error");
let $febfa929b76327ac$var$app = window.app;
// Prevent duplicate DBs with HMR'ing
if (!$febfa929b76327ac$var$app) $febfa929b76327ac$var$app = window.app = (0, $e3a1e3018df58994$export$c55cfd413944906d)({
    apiKey: "AIzaSyARx6u575DX4gjtzhHzT86DJ34s5GHxmRo",
    authDomain: "flightcard-63595.firebaseapp.com",
    projectId: "flightcard-63595",
    databaseURL: "https://flightcard-63595-default-rtdb.firebaseio.com/",
    storageBucket: "flightcard-63595.appspot.com",
    messagingSenderId: "816049894238",
    appId: "1:816049894238:web:1ff228f2c97ad5ecc215cf",
    measurementId: "G-HFR5HRJG36"
});
const $febfa929b76327ac$export$4bd2facc4a3e6aa1 = null;
const $febfa929b76327ac$export$a62f5db2b03ceea3 = (0, $494ac95ccfb2d9dd$export$d0dd861204d0bf72)($febfa929b76327ac$var$app);
const $febfa929b76327ac$export$73693bad9f5880b0 = (0, $8dac729f232ba11e$export$ae1af26003f05816)($febfa929b76327ac$var$app);
async function $febfa929b76327ac$export$c10e31973268dac4(path) {
    return path.isValid() ? (await (0, $4ac80628868fb8a2$export$3efb1a4ef0888a13)((0, $494ac95ccfb2d9dd$export$3988ae62b71be9a3)((0, $494ac95ccfb2d9dd$export$eff4d24c3ff7876e)($febfa929b76327ac$export$a62f5db2b03ceea3, String(path))))).val() : undefined;
}
function $febfa929b76327ac$export$2ef6846d36515d5(path, value) {
    return (0, $4ac80628868fb8a2$export$3efb1a4ef0888a13)((0, $494ac95ccfb2d9dd$export$adaa4cf7ef1b65be)((0, $494ac95ccfb2d9dd$export$eff4d24c3ff7876e)($febfa929b76327ac$export$a62f5db2b03ceea3, String(path)), value));
}
function $febfa929b76327ac$export$3f3cbd6c9a0055d0(path) {
    return (0, $4ac80628868fb8a2$export$3efb1a4ef0888a13)((0, $494ac95ccfb2d9dd$export$cd7f480d6b8286c3)((0, $494ac95ccfb2d9dd$export$eff4d24c3ff7876e)($febfa929b76327ac$export$a62f5db2b03ceea3, String(path))));
}
function $febfa929b76327ac$export$78d8dceb730843fa(path, state) {
    return (0, $4ac80628868fb8a2$export$3efb1a4ef0888a13)((0, $494ac95ccfb2d9dd$export$722fbec263ad908a)((0, $494ac95ccfb2d9dd$export$eff4d24c3ff7876e)($febfa929b76327ac$export$a62f5db2b03ceea3, String(path)), state));
}
function $febfa929b76327ac$export$bc6fa55e832fa0cb() {
    const updates = {};
    return {
        updates: updates,
        update (path, state) {
            updates[path.toString()] = state;
        },
        async commit () {
            return (0, $4ac80628868fb8a2$export$3efb1a4ef0888a13)((0, $494ac95ccfb2d9dd$export$722fbec263ad908a)((0, $494ac95ccfb2d9dd$export$eff4d24c3ff7876e)($febfa929b76327ac$export$a62f5db2b03ceea3), updates));
        }
    };
}
function $febfa929b76327ac$export$fe4c1a3a7af84c36(path, setter) {
    const [val, setVal] = (0, $8T3gX.useState)();
    const [loading, setLoading] = (0, $8T3gX.useState)(true);
    const [error, setError] = (0, $8T3gX.useState)();
    (0, $8T3gX.useEffect)(()=>{
        // Silently ignore attempts to use invalid paths.
        if (!path.isValid()) {
            setLoading(false);
            setError(new Error(path.errorMessage));
            return;
        }
        // Reset loading and error state
        setLoading(true);
        setError(undefined);
        const unsubscribe = (0, $494ac95ccfb2d9dd$export$ad30f661f41f4d90)((0, $494ac95ccfb2d9dd$export$eff4d24c3ff7876e)($febfa929b76327ac$export$a62f5db2b03ceea3, String(path)), (s)=>{
            const dbVal = s.val();
            if (setter) setter(dbVal);
            setVal(dbVal ?? undefined);
            setLoading(false);
        }, (err)=>{
            setError(err);
            setLoading(false);
        });
        return unsubscribe;
    }, [
        path,
        setter
    ]);
    return [
        val,
        loading,
        error
    ];
}


/**
 * Typed realtime path support.  RTPath instances are immutable, and consist of
 * a path template like "/users/:launchId/:userId" and an optional field tokens
 * object (e.g. {launchId: '123', userId: '456'}) to use when rendering the path
 * to a string.
 *
 * RTPaths do double duty as both path templates, and as path strings.  Because
 * of this, they are allowed to exist in "invalid" states where an instance may
 * not have the fields needed to wholly render a path.   In this case,
 * attempting to convert the path to a string will throw an error!  Callers are
 * expected to validate any path prior to using it.  To that end, paths support
 * validate() and isValid() methods.
 */ 
const $ada1a645c4c4dba1$var$memos = new Map();
class $ada1a645c4c4dba1$export$adde49a0578c7691 {
    #path;
    #errorString;
    constructor(template, fields){
        this.template = template;
        this.fields = fields;
        this.id = (0, $40b0ef4339cb3cfb$export$ac4959f4f1338dfc)();
        if (template.endsWith("/")) throw Error("Path template must not end with /");
        // Ad-hoc memoization here avoids the need for useMemo() in components. Yes,
        // this is a memory leak, but it's not expected to be an issue in practice.
        const fieldKey = fields ? Object.entries(fields ?? {}).map(([k, v])=>`${k}:${v}`).join(", ") : "";
        const memoKey = `${template} (${fieldKey})`;
        const instance = $ada1a645c4c4dba1$var$memos.get(memoKey);
        if (instance) return instance;
        $ada1a645c4c4dba1$var$memos.set(memoKey, this);
        this.render(fields);
    }
    render(fields) {
        const missing = [];
        const path = this.template.replace(/:\w+/g, (match)=>{
            const token = match.substring(1);
            const val = fields?.[token];
            if (!val) missing.push(token);
            return val || "<missing>";
        });
        if (path) this.#path = path;
        if (missing.length) this.#errorString = `Missing fields: ${missing.join(", ")} in ${this.template}`;
    }
    with(fields) {
        return new $ada1a645c4c4dba1$export$adde49a0578c7691(this.template, fields);
    }
    append(subpath, extraFields) {
        const newFields = extraFields ? {
            ...this.fields,
            ...extraFields
        } : undefined;
        return new $ada1a645c4c4dba1$export$adde49a0578c7691(this.template + "/" + subpath, newFields);
    }
    isValid() {
        return !this.#errorString;
    }
    get errorMessage() {
        return this.#errorString;
    }
    toString() {
        if (this.#errorString) throw Error(this.#errorString);
        if (!this.#path) throw Error("Undefined path"); // This should never throw
        return this.#path;
    }
}


const $71b3f0397fe2ca79$export$1ba679a5cc178147 = new (0, $ada1a645c4c4dba1$export$adde49a0578c7691)("/users/:authId");
const $71b3f0397fe2ca79$export$e718fbba97c40982 = $71b3f0397fe2ca79$export$1ba679a5cc178147.append("units");
const $71b3f0397fe2ca79$export$c0f6655c856f383a = new (0, $ada1a645c4c4dba1$export$adde49a0578c7691)("/attendees");
const $71b3f0397fe2ca79$export$ac9b3f0445b3a6da = $71b3f0397fe2ca79$export$c0f6655c856f383a.append(":launchId");
const $71b3f0397fe2ca79$export$9b60127abde046a1 = $71b3f0397fe2ca79$export$ac9b3f0445b3a6da.append(":userId");
const $71b3f0397fe2ca79$export$25c084e96a349cfd = $71b3f0397fe2ca79$export$9b60127abde046a1.append("certs");
const $71b3f0397fe2ca79$export$fcb89df7dbf28b19 = $71b3f0397fe2ca79$export$9b60127abde046a1.append("certs/TRA");
const $71b3f0397fe2ca79$export$7bb590570d143469 = $71b3f0397fe2ca79$export$9b60127abde046a1.append("certs/NAR");
const $71b3f0397fe2ca79$export$44a4a6081810942c = $71b3f0397fe2ca79$export$9b60127abde046a1.append("role");
const $71b3f0397fe2ca79$export$50e9aca848382ff9 = new (0, $ada1a645c4c4dba1$export$adde49a0578c7691)("/officers/:launchId");
const $71b3f0397fe2ca79$export$63aafa5cd2e21081 = $71b3f0397fe2ca79$export$50e9aca848382ff9.append(":userId");
const $71b3f0397fe2ca79$export$76a1f8a1cbbffae1 = new (0, $ada1a645c4c4dba1$export$adde49a0578c7691)("/pads");
const $71b3f0397fe2ca79$export$83289c7452cd8ea9 = $71b3f0397fe2ca79$export$76a1f8a1cbbffae1.append("/:launchId");
const $71b3f0397fe2ca79$export$beff8d4a9be6e9d7 = $71b3f0397fe2ca79$export$83289c7452cd8ea9.append(":padId");
const $71b3f0397fe2ca79$export$d6be259d96b74ffe = new (0, $ada1a645c4c4dba1$export$adde49a0578c7691)("/launches");
const $71b3f0397fe2ca79$export$90058626e653e0cd = $71b3f0397fe2ca79$export$d6be259d96b74ffe.append(":launchId");
const $71b3f0397fe2ca79$export$5350b4cf31a863ce = $71b3f0397fe2ca79$export$90058626e653e0cd.append("ridealong");
const $71b3f0397fe2ca79$export$24d8af51036a7c7 = new (0, $ada1a645c4c4dba1$export$adde49a0578c7691)("/cards");
const $71b3f0397fe2ca79$export$d7220bf6225e19b7 = $71b3f0397fe2ca79$export$24d8af51036a7c7.append(":launchId");
const $71b3f0397fe2ca79$export$c180d6f0b8dacb9f = $71b3f0397fe2ca79$export$d7220bf6225e19b7.append(":cardId");
const $71b3f0397fe2ca79$export$50a18a722f04f5f9 = $71b3f0397fe2ca79$export$c180d6f0b8dacb9f.append("status");
const $71b3f0397fe2ca79$export$8d9b735d66078003 = $71b3f0397fe2ca79$export$c180d6f0b8dacb9f.append("motors");
const $71b3f0397fe2ca79$export$c86ca1e8f0edf269 = $71b3f0397fe2ca79$export$8d9b735d66078003.append(":motorId");
const $71b3f0397fe2ca79$export$dd27bd64c4016e52 = $71b3f0397fe2ca79$export$c180d6f0b8dacb9f.append("rocket");
const $71b3f0397fe2ca79$export$fed7e30935905c1 = $71b3f0397fe2ca79$export$dd27bd64c4016e52.append("mass");


async function $8611998942a98b80$var$complete_migrateMotors() {
    (0, $11e801b827ed84d2$export$bef1f36f5486a6a3)(/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h3", {
        children: "Migrating cards/:launchId/:cardId/motors..."
    }));
    const allCards = await (0, $febfa929b76327ac$export$c10e31973268dac4)((0, $71b3f0397fe2ca79$export$24d8af51036a7c7));
    for (const [launchId, cards] of Object.entries(allCards)){
        (0, $11e801b827ed84d2$export$bef1f36f5486a6a3)(/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("h4", {
            children: [
                "Launch ",
                launchId
            ]
        }));
        for (const [cardId, card] of Object.entries(cards)){
            if (!card.motors) continue;
            const motorEntries = Object.entries(card.motors);
            let needsWrite = false;
            for (const entry of motorEntries){
                const [motorId, motor] = entry;
                if (motorId != motor.id) {
                    if (!motor.id) motor.id = (0, $40b0ef4339cb3cfb$export$ac4959f4f1338dfc)();
                    entry[0] = motor.id;
                    needsWrite = true;
                }
            }
            if (needsWrite) {
                const rtPath = (0, $71b3f0397fe2ca79$export$8d9b735d66078003).with({
                    launchId: launchId,
                    cardId: cardId
                });
                (0, $11e801b827ed84d2$export$bef1f36f5486a6a3)("Updating", rtPath);
                await (0, $febfa929b76327ac$export$2ef6846d36515d5)(rtPath, Object.fromEntries(motorEntries));
            }
        }
    }
}
async function $8611998942a98b80$var$migrateCardStatus() {
    (0, $11e801b827ed84d2$export$bef1f36f5486a6a3)(/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h3", {
        children: "Migrating cards/:launchId/:cardId/motors..."
    }));
    const allCards = await (0, $febfa929b76327ac$export$c10e31973268dac4)((0, $71b3f0397fe2ca79$export$24d8af51036a7c7));
    const transaction = (0, $febfa929b76327ac$export$bc6fa55e832fa0cb)();
    for (const [launchId, cards] of Object.entries(allCards)){
        (0, $11e801b827ed84d2$export$bef1f36f5486a6a3)(/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("h4", {
            children: [
                "Launch ",
                launchId
            ]
        }));
        for (const [cardId, card] of Object.entries(cards)){
            const status = {
                undefined: "draft",
                draft: "draft",
                0: "draft",
                1: "review",
                review: "review",
                ready: "fly",
                2: "fly",
                fly: "fly",
                3: "done",
                done: "done"
            }[card.status] ?? (0, $febfa929b76327ac$export$4bd2facc4a3e6aa1);
            if (status === card.status) continue;
            const rtPath = (0, $71b3f0397fe2ca79$export$c180d6f0b8dacb9f).append("status").with({
                launchId: launchId,
                cardId: cardId
            });
            (0, $11e801b827ed84d2$export$bef1f36f5486a6a3)("Updating", rtPath.toString(), card.status, "=>", status);
        // transaction.update<string>(rtPath, status);
        }
        await transaction.commit();
    }
}
async function $8611998942a98b80$var$complete_migratePadLaunchId() {
    (0, $11e801b827ed84d2$export$bef1f36f5486a6a3)(/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h3", {
        children: "Migrating cards/:launchId/:cardId/motors..."
    }));
    const allPads = await (0, $febfa929b76327ac$export$c10e31973268dac4)((0, $71b3f0397fe2ca79$export$76a1f8a1cbbffae1));
    const transaction = (0, $febfa929b76327ac$export$bc6fa55e832fa0cb)();
    for (const [launchId, pads] of Object.entries(allPads)){
        (0, $11e801b827ed84d2$export$bef1f36f5486a6a3)(/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("h4", {
            children: [
                "Launch ",
                launchId
            ]
        }));
        for (const [padId, pad] of Object.entries(pads)){
            if (!pad.launchId) continue;
            pad.launchId = (0, $febfa929b76327ac$export$4bd2facc4a3e6aa1);
            const rtPath = (0, $71b3f0397fe2ca79$export$beff8d4a9be6e9d7).with({
                launchId: launchId,
                padId: padId
            });
            transaction.update(rtPath, pad);
        }
    }
    await transaction.commit();
}
async function $8611998942a98b80$var$handleClick() {
    (0, $11e801b827ed84d2$export$42ffd38884aecdac)();
    (0, $11e801b827ed84d2$export$bef1f36f5486a6a3)(/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h2", {
        children: "Starting..."
    }));
    // await migratePadLaunchId();
    (0, $11e801b827ed84d2$export$bef1f36f5486a6a3)(/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h2", {
        children: "--- Fin ---"
    }));
}
function $8611998942a98b80$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
        variant: "warning",
        onClick: ()=>{
            $8611998942a98b80$var$handleClick().catch((err)=>{
                (0, $11e801b827ed84d2$export$bef1f36f5486a6a3)(err);
                console.error(err);
            });
        },
        children: "Migrate DB"
    });
}




var $8T3gX = parcelRequire("8T3gX");



var $fa64700f0ee1e308$exports = {};
$fa64700f0ee1e308$exports = JSON.parse('[{"availability":"regular","avgThrustN":0.284,"burnTimeS":0.772,"certOrg":"National Association of Rocketry","commonName":"1/8A0.3","dataFiles":3,"delays":"1","designation":"MICRO_MAXX_II","diameter":6,"impulseClass":"A","length":26,"manufacturer":"Quest Aerospace","manufacturerAbbrev":"Quest","maxThrustN":2.108,"motorId":"5f4294d20002310000000001","propInfo":"black powder","propWeightG":0.5,"samples":[[0,0],[0.026,0.03946],[0.036,0.1215],[0.04,0.206],[0.05,0.4447],[0.056,0.6803],[0.06,0.8996],[0.066,1.359],[0.068,1.476],[0.07,1.567],[0.074,1.625],[0.088,1.19],[0.112,0.831],[0.126,0.4399],[0.134,0.3198],[0.144,0.249],[0.174,0.1657],[0.206,0.1919],[0.258,0.1262],[0.342,0.1601],[0.366,0.1386],[0.384,0.1795],[0.494,0.2184],[0.546,0.1541],[0.56,0.1782],[0.608,0.1524],[0.682,0.2095],[0.698,0.1837],[0.712,0.2202],[0.742,0.209],[0.768,0.04035],[0.785,0]],"totImpulseNs":0.218,"totalWeightG":1,"type":"SU","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":0.163,"burnTimeS":0.827,"certOrg":"National Association of Rocketry","commonName":"1/8A0.3","dataFiles":2,"delays":"1","designation":"MICRO_MAXX","diameter":6,"impulseClass":"A","infoUrl":"http://www.nar.org/SandT/pdf/Quest/MicroMaxx.pdf","length":26,"manufacturer":"Quest Aerospace","manufacturerAbbrev":"Quest","maxThrustN":1.898,"motorId":"5f4294d20002310000000002","propInfo":"black powder","propWeightG":0.4,"samples":[[0,0],[0.016,0.05304],[0.02,0.09855],[0.024,0.1767],[0.03,0.4159],[0.032,0.4349],[0.038,0.658],[0.052,1.247],[0.058,1.454],[0.064,1.701],[0.066,1.756],[0.07,1.952],[0.074,2.065],[0.076,2.099],[0.078,2.099],[0.08,2.028],[0.082,1.912],[0.084,1.619],[0.086,1.152],[0.088,0.7283],[0.09,0.4336],[0.092,0.293],[0.098,0.2175],[0.154,0.2244],[0.172,0.1502],[0.196,0.09986],[0.23,0.0786],[0.414,0.06256],[0.7559,0.08211],[0.8219,0.06076],[0.833,0.02085],[0.834,0]],"totImpulseNs":0.135,"totalWeightG":1.07,"type":"SU","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":2.48,"burnTimeS":0.23,"certOrg":"National Association of Rocketry","commonName":"1/4A2","dataFiles":2,"delays":"2,4","designation":"1/4A2","diameter":10.5,"impulseClass":"A","infoUrl":"http://nar.org/SandT/pdf/Apogee/qtrA2.pdf","length":38,"manufacturer":"Apogee Components","manufacturerAbbrev":"Apogee","maxThrustN":5.4,"motorId":"5f4294d20002310000000003","propWeightG":0.75,"samples":[[0,0],[0.007,0.162],[0.023,0.65],[0.041,1.463],[0.058,2.519],[0.074,3.738],[0.079,3.9],[0.088,4.915],[0.097,5.119],[0.106,5.4],[0.11,5.119],[0.118,3.981],[0.125,3.656],[0.132,3.453],[0.136,3.209],[0.151,3.169],[0.156,2.966],[0.168,2.884],[0.18,2.397],[0.194,1.625],[0.207,1.056],[0.218,0.406],[0.23,0]],"totImpulseNs":0.57,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":2.36,"burnTimeS":0.25,"certOrg":"National Association of Rocketry","commonName":"1/4A3","dataFiles":2,"delays":"3","designation":"1/4A3","diameter":13,"impulseClass":"A","infoUrl":"http://nar.org/SandT/pdf/Estes/qtrA3.pdf","length":45,"manufacturer":"Estes Industries","manufacturerAbbrev":"Estes","maxThrustN":4.95,"motorId":"5f4294d20002310000000004","propInfo":"black powder","propWeightG":0.83,"samples":[[0,0],[0.016,0.243],[0.044,1.164],[0.08,2.698],[0.088,2.851],[0.096,3.312],[0.105,3.804],[0.116,4.325],[0.129,4.754],[0.131,4.754],[0.135,4.95],[0.139,4.815],[0.143,4.814],[0.149,4.66],[0.157,4.289],[0.173,3.548],[0.187,2.808],[0.194,2.592],[0.197,2.13],[0.202,1.913],[0.206,1.512],[0.213,1.389],[0.218,1.112],[0.227,0.802],[0.236,0.493],[0.241,0.277],[0.25,0]],"totImpulseNs":0.59,"totalWeightG":6.1,"type":"SU","updatedOn":"2019-10-05"},{"availability":"OOP","avgThrustN":1.94,"burnTimeS":0.63,"certOrg":"National Association of Rocketry","commonName":"1/2A2","dataFiles":2,"delays":"2,4,6","designation":"1/2A2","diameter":10.5,"impulseClass":"A","infoUrl":"http://nar.org/SandT/pdf/Apogee/halfA2.pdf","length":38,"manufacturer":"Apogee Components","manufacturerAbbrev":"Apogee","maxThrustN":3.97,"motorId":"5f4294d20002310000000005","propWeightG":1.5,"samples":[[0,0],[0.007,0.19],[0.045,1.494],[0.078,3.152],[0.088,3.805],[0.093,3.805],[0.1,3.97],[0.105,3.696],[0.11,3.071],[0.117,2.554],[0.123,2.582],[0.132,2.31],[0.163,2.146],[0.2,1.984],[0.242,1.902],[0.253,2.01],[0.275,1.929],[0.342,1.929],[0.403,1.929],[0.41,1.848],[0.42,1.902],[0.467,1.902],[0.528,1.929],[0.565,1.929],[0.58,1.902],[0.593,1.848],[0.603,1.657],[0.61,1.141],[0.615,0.597],[0.622,0.244],[0.63,0]],"totImpulseNs":1.22,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":3.03,"burnTimeS":0.36,"certOrg":"National Association of Rocketry","commonName":"1/2A3","dataFiles":2,"delays":"2,4","designation":"1/2A3","diameter":13,"impulseClass":"A","infoUrl":"http://nar.org/SandT/pdf/Estes/halfA3T.pdf","length":45,"manufacturer":"Estes Industries","manufacturerAbbrev":"Estes","maxThrustN":7.62,"motorId":"5f4294d20002310000000006","propInfo":"black powder","propWeightG":2,"samples":[[0,0],[0.024,0.501],[0.042,1.454],[0.064,3.009],[0.076,4.062],[0.088,4.914],[0.093,5.065],[0.103,6.068],[0.112,6.87],[0.117,7.021],[0.126,7.62],[0.137,7.472],[0.146,6.87],[0.153,6.118],[0.159,5.065],[0.166,4.363],[0.179,3.66],[0.197,2.908],[0.222,2.256],[0.25,2.156],[0.277,2.106],[0.294,2.056],[0.304,2.156],[0.316,1.955],[0.326,1.554],[0.339,1.053],[0.35,0.651],[0.36,0]],"totImpulseNs":1.09,"totalWeightG":6.6,"type":"SU","updatedOn":"2019-10-05"},{"availability":"regular","avgThrustN":3.42,"burnTimeS":0.33,"certOrg":"National Association of Rocketry","commonName":"1/2A6","dataFiles":2,"delays":"2","designation":"1/2A6","diameter":18,"impulseClass":"A","infoUrl":"http://nar.org/SandT/pdf/Estes/halfA6.pdf","length":70,"manufacturer":"Estes Industries","manufacturerAbbrev":"Estes","maxThrustN":7.86,"motorId":"5f4294d20002310000000007","propInfo":"black powder","propWeightG":2.6,"samples":[[0,0],[0.031,0.404],[0.064,1.258],[0.096,2.263],[0.124,3.467],[0.149,4.72],[0.172,6.023],[0.196,7.027],[0.21,7.528],[0.225,7.86],[0.235,7.482],[0.244,6.683],[0.254,5.685],[0.263,4.487],[0.269,4.087],[0.279,3.039],[0.29,1.79],[0.297,1.042],[0.306,0.593],[0.314,0.344],[0.33,0]],"totImpulseNs":1.13,"type":"SU","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1.89,"burnTimeS":1.31,"certOrg":"National Association of Rocketry","commonName":"A2","dataFiles":2,"delays":"0,3,5,7","designation":"A2","diameter":10.5,"impulseClass":"A","infoUrl":"http://nar.org/SandT/pdf/Apogee/A2.pdf","length":57,"manufacturer":"Apogee Components","manufacturerAbbrev":"Apogee","maxThrustN":4.82,"motorId":"5f4294d20002310000000008","propWeightG":3,"samples":[[0,0],[0.014,0.241],[0.036,0.895],[0.064,2.618],[0.1,4.82],[0.111,4.133],[0.125,2.687],[0.139,2.307],[0.185,2.031],[0.296,1.928],[0.481,1.825],[0.517,1.722],[0.538,1.791],[0.649,1.688],[0.748,1.757],[0.869,1.825],[1.04,1.894],[1.101,1.894],[1.119,1.825],[1.144,1.928],[1.229,1.859],[1.265,1.894],[1.283,1.757],[1.29,1.412],[1.293,0.688],[1.3,0.275],[1.31,0]],"totImpulseNs":2.47,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":2.2,"burnTimeS":1.01,"certOrg":"National Association of Rocketry","commonName":"A3","dataFiles":2,"delays":"2,4,6","designation":"A3","diameter":13,"impulseClass":"A","infoUrl":"https://nar.org/SandT/pdf/Estes/Estes_A3T_2022.pdf","length":45,"manufacturer":"Estes Industries","manufacturerAbbrev":"Estes","maxThrustN":5.83,"motorId":"5f4294d20002310000000009","propInfo":"black powder","propWeightG":3.3,"samples":[[0,0],[0.024,0.195],[0.048,0.899],[0.086,2.658],[0.11,4.183],[0.14,5.83],[0.159,5.395],[0.18,4.301],[0.199,3.635],[0.215,2.736],[0.234,2.267],[0.258,2.15],[0.315,2.072],[0.441,1.993],[0.554,2.033],[0.605,2.072],[0.673,1.954],[0.764,1.954],[0.874,2.072],[0.931,2.15],[0.953,2.072],[0.966,1.719],[0.977,1.173],[0.993,0.547],[1.01,0]],"totImpulseNs":2.5,"totalWeightG":8.5,"type":"SU","updatedOn":"2022-07-27"},{"availability":"regular","avgThrustN":4.16,"burnTimeS":0.55,"certOrg":"National Association of Rocketry","commonName":"A6","dataFiles":2,"delays":"4","designation":"A6","diameter":18,"impulseClass":"A","infoUrl":"http://www.nar.org/SandT/pdf/Quest/A6_cn.pdf","length":70,"manufacturer":"Quest Aerospace","manufacturerAbbrev":"Quest","maxThrustN":10.07,"motorId":"5f4294d2000231000000000a","propInfo":"black powder","propWeightG":3.5,"samples":[[0,0],[0.1,4.8],[0.2,11.82],[0.23,7.9],[0.3,4.8],[0.41,0]],"totImpulseNs":2.3,"totalWeightG":12,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":3.18,"burnTimeS":0.73,"certOrg":"National Association of Rocketry","commonName":"A8","dataFiles":3,"delays":"0,3,5","designation":"A8","diameter":18,"impulseClass":"A","infoUrl":"http://nar.org/SandT/pdf/Estes/A8.pdf","length":70,"manufacturer":"Estes Industries","manufacturerAbbrev":"Estes","maxThrustN":9.73,"motorId":"5f4294d2000231000000000b","propInfo":"black powder","propWeightG":3.3,"samples":[[0,0],[0.016,1.08],[0.036,0.293],[0.05,0.259],[0.06,0.357],[0.07,0.419],[0.08,0.355],[0.102,0.781],[0.124,1.443],[0.152,2.966],[0.17,4.426],[0.202,7.16],[0.224,9.051],[0.246,9.555],[0.256,9.317],[0.276,7.958],[0.294,6.108],[0.326,4.235],[0.35,3.813],[0.376,3.997],[0.41,3.926],[0.452,3.724],[0.474,4.046],[0.502,4.092],[0.532,4.146],[0.534,0]],"totImpulseNs":2.5,"totalWeightG":16.3,"type":"SU","updatedOn":"2019-10-05"},{"availability":"regular","avgThrustN":2.35,"burnTimeS":0.85,"certOrg":"National Association of Rocketry","commonName":"A10","dataFiles":3,"delays":"0,3,P","designation":"A10","diameter":13,"impulseClass":"A","infoUrl":"http://www.nar.org/SandT/pdf/Estes/A10T.pdf","length":45,"manufacturer":"Estes Industries","manufacturerAbbrev":"Estes","maxThrustN":12.64,"motorId":"5f4294d2000231000000000c","propInfo":"black powder","propWeightG":3.8,"samples":[[0,0],[0.016,0.492],[0.04,0.752],[0.062,0.962],[0.078,2.051],[0.096,2.858],[0.122,4.611],[0.138,6.054],[0.162,8.1],[0.18,9.502],[0.198,9.74],[0.212,8.204],[0.224,4.53],[0.238,2.054],[0.268,1.414],[0.292,1.385],[0.324,1.067],[0.364,1.099],[0.396,0.957],[0.446,0.995],[0.49,0.901],[0.574,0.909],[0.676,0.909],[0.782,1.031],[0.886,1.048],[0.98,1.029],[1.006,0.995],[1.038,1.049],[1.05,0.741],[1.06,0]],"totImpulseNs":2.5,"totalWeightG":8.25,"type":"SU","updatedOn":"2019-10-05"},{"availability":"OOP","avgThrustN":1.91,"burnTimeS":2.53,"certOrg":"National Association of Rocketry","commonName":"B2","dataFiles":2,"delays":"0,3,5,7,9","designation":"B2","diameter":10.5,"impulseClass":"B","infoUrl":"http://nar.org/SandT/pdf/Apogee/B2.pdf","length":88,"manufacturer":"Apogee Components","manufacturerAbbrev":"Apogee","maxThrustN":5.48,"motorId":"5f4294d2000231000000000d","propWeightG":6,"samples":[[0,0],[0.057,1.637],[0.093,4.091],[0.121,5.48],[0.143,4.787],[0.157,3.478],[0.207,2.578],[0.328,2.087],[0.371,2.087],[0.406,1.882],[0.641,1.841],[0.869,1.841],[1.283,1.882],[1.361,1.882],[1.397,1.718],[1.439,1.841],[1.532,1.718],[1.71,1.841],[1.888,1.882],[2.095,1.8],[2.23,1.8],[2.295,1.677],[2.423,1.759],[2.444,1.637],[2.466,0.982],[2.494,0.327],[2.53,0]],"totImpulseNs":4.82,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":4.17,"burnTimeS":1.03,"certOrg":"National Association of Rocketry","commonName":"B4","dataFiles":3,"delays":"2,4","designation":"B4","diameter":18,"impulseClass":"B","infoUrl":"http://nar.org/SandT/pdf/Estes/B4.pdf","length":70,"manufacturer":"Estes Industries","manufacturerAbbrev":"Estes","maxThrustN":12.75,"motorId":"5f4294d2000231000000000e","propInfo":"black powder","propWeightG":6,"samples":[[0,0],[0.02,0.418],[0.04,1.673],[0.065,4.076],[0.085,6.69],[0.105,9.304],[0.119,11.5],[0.136,12.75],[0.153,11.92],[0.173,10.67],[0.187,9.304],[0.198,7.214],[0.207,5.645],[0.226,4.809],[0.258,4.182],[0.326,3.763],[0.422,3.554],[0.549,3.345],[0.665,3.345],[0.776,3.345],[0.863,3.345],[0.94,3.449],[0.991,3.449],[1.002,2.404],[1.01,1.254],[1.03,0]],"totImpulseNs":5,"totalWeightG":18.85,"type":"SU","updatedOn":"2019-10-05"},{"availability":"OOP","avgThrustN":6.17,"burnTimeS":0.75,"certOrg":"National Association of Rocketry","commonName":"B6","dataFiles":2,"delays":"0,2,4","designation":"B6","diameter":18,"impulseClass":"B","infoUrl":"http://nar.org/SandT/pdf/Quest/B6~04.pdf","length":70,"manufacturer":"Quest Aerospace","manufacturerAbbrev":"Quest","maxThrustN":14.38,"motorId":"5f4294d2000231000000000f","propInfo":"black powder","propWeightG":6.5,"samples":[[0,0],[0.1,7],[0.18,14.38],[0.2,10.2],[0.24,6.6],[0.3,6],[0.4,6.1],[0.5,6.2],[0.6,6.3],[0.65,6.6],[0.7,3],[0.75,0]],"totImpulseNs":4.63,"totalWeightG":18.4,"type":"SU","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":5.03,"burnTimeS":0.86,"certOrg":"National Association of Rocketry","commonName":"B6","dataFiles":2,"delays":"0,2,4,6","designation":"B6","diameter":18,"impulseClass":"B","infoUrl":"http://www.nar.org/SandT/pdf/Estes/B6.pdf","length":70,"manufacturer":"Estes Industries","manufacturerAbbrev":"Estes","maxThrustN":12.14,"motorId":"5f4294d20002310000000010","propInfo":"black powder","propWeightG":5.6,"samples":[[0,0],[0.036,1.364],[0.064,2.727],[0.082,4.215],[0.111,6.694],[0.135,9.05],[0.146,9.545],[0.172,11.9],[0.181,12.15],[0.191,11.9],[0.211,9.174],[0.239,7.314],[0.264,6.074],[0.275,5.95],[0.333,5.207],[0.394,4.835],[0.445,4.835],[0.556,4.339],[0.667,4.587],[0.723,4.339],[0.78,4.339],[0.793,4.091],[0.812,2.603],[0.833,1.24],[0.857,0]],"totImpulseNs":4.33,"totalWeightG":19.1,"type":"SU","updatedOn":"2022-11-30"},{"availability":"OOP","avgThrustN":6.72,"burnTimeS":0.74,"certOrg":"National Association of Rocketry","commonName":"B7","dataFiles":2,"delays":"4,6,8,10","designation":"B7","diameter":13,"impulseClass":"B","infoUrl":"http://nar.org/SandT/pdf/Apogee/B7.pdf","length":50,"manufacturer":"Apogee Components","manufacturerAbbrev":"Apogee","maxThrustN":14.76,"motorId":"5f4294d20002310000000012","propWeightG":2.8,"samples":[[0,0],[0.007,5.708],[0.013,7.211],[0.032,6.111],[0.045,8.116],[0.056,7.717],[0.069,9.02],[0.078,12.12],[0.087,14.76],[0.106,13.83],[0.117,13.73],[0.125,12.64],[0.155,12.44],[0.168,11.84],[0.2,11.24],[0.209,11.74],[0.219,10.74],[0.266,9.846],[0.29,9.849],[0.299,8.949],[0.367,7.456],[0.393,7.159],[0.429,5.761],[0.487,4.567],[0.571,2.975],[0.607,2.178],[0.669,1.084],[0.708,0.489],[0.74,0]],"totImpulseNs":4.97,"type":"SU","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":3.8,"burnTimeS":2.35,"certOrg":"National Association of Rocketry","commonName":"C4","dataFiles":2,"delays":"3,5,7","designation":"C4","diameter":18,"impulseClass":"C","infoUrl":"http://nar.org/SandT/pdf/Apogee/C4.pdf","length":50,"manufacturer":"Apogee Components","manufacturerAbbrev":"Apogee","maxThrustN":11.31,"motorId":"5f4294d20002310000000013","propWeightG":4.5,"samples":[[0,0],[0.018,3.23],[0.041,6.874],[0.147,8.779],[0.294,10.68],[0.365,11.31],[0.388,10.52],[0.412,8.779],[0.441,7.04],[0.465,4.555],[0.529,3.479],[0.629,2.981],[0.653,3.23],[0.718,2.816],[0.853,2.733],[1.065,2.65],[1.253,2.567],[1.453,2.401],[1.694,2.484],[1.794,2.484],[1.812,2.733],[1.841,2.401],[1.947,2.401],[2.112,2.401],[2.235,2.401],[2.282,2.236],[2.312,1.656],[2.329,0.662],[2.35,0]],"totImpulseNs":8.92,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":3.91,"burnTimeS":1.99,"certOrg":"National Association of Rocketry","commonName":"C5","dataFiles":4,"delays":"3","designation":"C5","diameter":18,"impulseClass":"C","infoUrl":"https://nar.org/SandT/pdf/Estes/Estes_C5_2019.pdf","length":70,"manufacturer":"Estes Industries","manufacturerAbbrev":"Estes","maxThrustN":20.41,"motorId":"5f4294d20002310000000014","propInfo":"black powder","propWeightG":11.3,"samples":[[0,0],[0.005,1.422],[0.031,2.695],[0.063,5.503],[0.117,10.44],[0.151,14.37],[0.168,16.36],[0.174,16.47],[0.179,17.59],[0.199,18.6],[0.211,19.88],[0.217,20.4],[0.23,20.29],[0.234,18.68],[0.239,18.23],[0.252,13.81],[0.258,9.021],[0.265,6.588],[0.28,4.904],[0.296,4.08],[0.349,3.481],[0.438,2.995],[0.504,2.733],[0.611,2.807],[0.815,2.695],[0.97,2.695],[1.335,2.695],[1.598,2.658],[1.794,2.695],[1.96,2.733],[1.987,1.16],[1.992,0]],"totImpulseNs":7.79,"totalWeightG":24.8,"type":"SU","updatedOn":"2022-07-27"},{"availability":"regular","avgThrustN":4.74,"burnTimeS":1.86,"certOrg":"National Association of Rocketry","commonName":"C6","dataFiles":3,"delays":"0,3,5,7","designation":"C6","diameter":18,"impulseClass":"C","infoUrl":"http://nar.org/SandT/pdf/Estes/C6.pdf","length":70,"manufacturer":"Estes Industries","manufacturerAbbrev":"Estes","maxThrustN":14.09,"motorId":"5f4294d20002310000000015","propInfo":"black powder","propWeightG":10.8,"samples":[[0,0],[0.031,0.946],[0.092,4.826],[0.139,9.936],[0.192,14.09],[0.209,11.45],[0.231,7.381],[0.248,6.151],[0.292,5.489],[0.37,4.921],[0.475,4.448],[0.671,4.258],[0.702,4.542],[0.723,4.164],[0.85,4.448],[1.063,4.353],[1.211,4.353],[1.242,4.069],[1.303,4.258],[1.468,4.353],[1.656,4.448],[1.821,4.448],[1.834,2.933],[1.847,1.325],[1.86,0]],"totImpulseNs":8.82,"totalWeightG":24.1,"type":"SU","updatedOn":"2019-10-05"},{"availability":"regular","avgThrustN":3.45,"burnTimeS":2.54,"certOrg":"National Association of Rocketry","commonName":"C6","dataFiles":2,"delays":"0,3,5","designation":"C6","diameter":18,"impulseClass":"C","infoUrl":"http://www.nar.org/SandT/pdf/Quest/C6_cn.pdf","length":70,"manufacturer":"Quest Aerospace","manufacturerAbbrev":"Quest","maxThrustN":15.46,"motorId":"5f4294d20002310000000016","propInfo":"black powder","propWeightG":12,"samples":[[0,0],[0.02,0.497],[0.057,2.539],[0.089,5.132],[0.129,7.947],[0.159,9.437],[0.171,21.25],[0.181,23.23],[0.194,22.96],[0.204,22.18],[0.218,19.59],[0.233,17.88],[0.258,10.49],[0.308,2.428],[0.338,2.539],[0.385,2.98],[0.412,3.091],[0.442,3.422],[0.459,2.98],[0.536,3.256],[0.732,3.311],[0.747,2.483],[0.78,2.98],[1.323,3.587],[1.365,2.815],[1.887,3.808],[1.974,3.256],[2.1,3.532],[2.227,3.201],[2.247,0]],"totImpulseNs":8.76,"totalWeightG":21,"type":"SU","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":7.56,"burnTimeS":1.32,"certOrg":"National Association of Rocketry","commonName":"C6","dataFiles":2,"delays":"4,7,10","designation":"C6","diameter":13,"impulseClass":"C","infoUrl":"http://nar.org/SandT/pdf/Apogee/C6.pdf","length":83,"manufacturer":"Apogee Components","manufacturerAbbrev":"Apogee","maxThrustN":21.1,"motorId":"5f4294d20002310000000018","propWeightG":7,"samples":[[0,0],[0.008,13.96],[0.016,21.1],[0.022,15.51],[0.03,12.83],[0.052,14.8],[0.081,15.93],[0.092,14.66],[0.114,16.07],[0.125,14.66],[0.136,15.37],[0.168,14.8],[0.214,13.82],[0.225,12.97],[0.247,13.96],[0.252,12.83],[0.285,12.55],[0.307,12.4],[0.317,12.83],[0.328,11.56],[0.347,11.99],[0.393,11.42],[0.442,10.72],[0.464,11.14],[0.488,9.164],[0.545,8.459],[0.624,7.754],[0.716,6.485],[0.838,5.075],[0.977,3.102],[1.096,1.833],[1.207,0.986],[1.32,0]],"totImpulseNs":9.98,"type":"SU","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":9.96,"burnTimeS":0.96,"certOrg":"National Association of Rocketry","commonName":"C10","dataFiles":2,"delays":"4,7,10","designation":"C10","diameter":18,"impulseClass":"C","infoUrl":"http://nar.org/SandT/pdf/Apogee/C10.pdf","length":50,"manufacturer":"Apogee Components","manufacturerAbbrev":"Apogee","maxThrustN":25.72,"motorId":"5f4294d20002310000000019","propWeightG":4.9,"samples":[[0,0],[0.01,2.712],[0.019,5.842],[0.029,17.12],[0.037,25.72],[0.051,22.54],[0.07,20.45],[0.106,18.98],[0.164,17.09],[0.188,17.09],[0.2,15.82],[0.216,16.04],[0.255,15.6],[0.293,14.35],[0.343,13.5],[0.394,12.65],[0.41,11.61],[0.434,11.61],[0.521,9.287],[0.631,6.34],[0.741,4.021],[0.851,2.119],[0.911,1.48],[0.945,1.264],[0.96,0]],"totImpulseNs":9.56,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":10.86,"burnTimeS":0.81,"certOrg":"National Association of Rocketry","commonName":"C11","dataFiles":2,"delays":"0,3,5,7","designation":"C11","diameter":24,"impulseClass":"C","infoUrl":"http://nar.org/SandT/pdf/Estes/C11.pdf","length":70,"manufacturer":"Estes Industries","manufacturerAbbrev":"Estes","maxThrustN":21.73,"motorId":"5f4294d2000231000000001a","propInfo":"black powder","propWeightG":12,"samples":[[0,0],[0.034,1.692],[0.066,3.782],[0.107,7.566],[0.145,10.95],[0.183,14.83],[0.214,17.62],[0.226,18.21],[0.256,20.11],[0.281,21.21],[0.298,21.73],[0.306,20.21],[0.323,17.32],[0.337,14.93],[0.358,13.24],[0.385,11.95],[0.413,11.65],[0.468,10.95],[0.539,10.45],[0.619,10.65],[0.683,10.65],[0.715,10.65],[0.726,10.05],[0.74,8.163],[0.758,5.773],[0.778,3.185],[0.795,1.394],[0.81,0]],"totImpulseNs":8.8,"totalWeightG":35.23,"type":"SU","updatedOn":"2019-10-05"},{"availability":"OOP","avgThrustN":2.87,"burnTimeS":6.39,"certOrg":"National Association of Rocketry","commonName":"D3","dataFiles":2,"delays":"3,5,7","designation":"D3","diameter":18,"impulseClass":"D","infoUrl":"http://nar.org/SandT/pdf/Apogee/D3.pdf","length":77,"manufacturer":"Apogee Components","manufacturerAbbrev":"Apogee","maxThrustN":10.64,"motorId":"5f4294d2000231000000001b","propWeightG":9.8,"samples":[[0,0],[0.05,6.79],[0.168,8.788],[0.318,10.46],[0.385,10.07],[0.402,7.909],[0.469,5.432],[0.486,3.914],[0.687,3.115],[1.122,2.876],[2.06,2.636],[3.349,2.397],[4.639,2.156],[5.727,1.997],[6.163,1.837],[6.263,3.994],[6.347,2.317],[6.364,0.719],[6.39,0]],"totImpulseNs":18.36,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":6.46,"burnTimeS":2.87,"caseInfo":"RMS-R/C-24/20-40","certOrg":"National Association of Rocketry","commonName":"D7","dataFiles":2,"delays":"P","designation":"D7-RCT","diameter":24,"impulseClass":"D","infoUrl":"http://nar.org/SandT/pdf/Aerotech/D7TRC.pdf","length":70,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":10.99,"motorId":"5f4294d2000231000000001c","propInfo":"Blue Thunder","propWeightG":10.5,"samples":[[0,0],[0.036,3.336],[0.084,9.326],[0.101,10.28],[0.143,10.83],[0.213,10.99],[0.271,10.89],[0.359,10.69],[0.471,10.13],[0.506,10.34],[0.535,9.929],[0.81,8.697],[1.226,6.713],[1.589,5.138],[1.8,4.861],[2.151,4.581],[2.649,4.57],[2.696,3.887],[2.748,2.388],[2.807,0.889],[2.842,0.207],[2.87,0]],"totImpulseNs":18.53,"totalWeightG":42.2,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":9.98,"burnTimeS":1.88,"caseInfo":"RMS-24/40","certOrg":"National Association of Rocketry","commonName":"D9","dataFiles":3,"delays":"4,5,7","designation":"D9W","diameter":24,"impulseClass":"D","infoUrl":"http://nar.org/SandT/pdf/Aerotech/D9.pdf","length":70,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":20,"motorId":"5f4294d2000231000000001d","propInfo":"White Lightning","propWeightG":10.1,"samples":[[0,0],[0.1,13.7],[0.15,15.4],[0.2,16.3],[0.25,16.8],[0.35,17.2],[0.4,17.2],[0.5,16.8],[0.65,15.9],[0.8,14.5],[1.1,9.2],[1.25,7],[1.4,4.8],[1.6,2.5],[1.9,0]],"totImpulseNs":18.76,"totalWeightG":47.4,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":13.39,"burnTimeS":1.4,"certOrg":"National Association of Rocketry","commonName":"D10","dataFiles":2,"delays":"3,5,7","designation":"D10","diameter":18,"impulseClass":"D","infoUrl":"http://nar.org/SandT/pdf/Apogee/D10.pdf","length":70,"manufacturer":"Apogee Components","manufacturerAbbrev":"Apogee","maxThrustN":25.13,"motorId":"5f4294d2000231000000001e","propWeightG":9.8,"samples":[[0,0],[0.011,14.51],[0.018,25.13],[0.032,20.94],[0.079,19.07],[0.122,21.14],[0.136,19.69],[0.169,21.14],[0.201,20.73],[0.223,21.76],[0.233,20.94],[0.255,21.97],[0.276,20.94],[0.352,20.73],[0.402,20.11],[0.42,20.73],[0.459,20.11],[0.488,20.52],[0.556,18.24],[0.671,15.96],[0.707,14.72],[0.729,15.13],[0.779,12.85],[0.793,13.47],[0.836,11.4],[0.904,10.16],[0.926,10.57],[0.99,8.083],[1.026,8.498],[1.123,6.011],[1.231,2.487],[1.342,0.829],[1.4,0]],"totImpulseNs":18.75,"type":"SU","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":9.4,"burnTimeS":1.86,"certOrg":"National Association of Rocketry","commonName":"D11","dataFiles":2,"designation":"D11","diameter":24,"impulseClass":"D","infoUrl":"http://nar.org/SandT/pdf/Estes/D11.pdf","length":70,"manufacturer":"Estes Industries","manufacturerAbbrev":"Estes","maxThrustN":26.01,"motorId":"5f4294d2000231000000001f","propInfo":"black powder","propWeightG":24.5,"samples":[[0,0],[0.033,2.393],[0.084,5.783],[0.144,12.17],[0.214,20.76],[0.261,24.35],[0.289,26.01],[0.311,23.33],[0.325,18.53],[0.338,14.54],[0.356,12.33],[0.398,10.72],[0.48,9.303],[0.618,8.676],[0.761,8.247],[0.955,8.209],[1.222,7.955],[1.402,8.319],[1.54,8.291],[1.701,8.459],[1.784,8.442],[1.803,6.239],[1.834,3.033],[1.86,0]],"totImpulseNs":17.49,"totalWeightG":44.8,"type":"SU","updatedOn":"2021-07-04"},{"availability":"regular","avgThrustN":10.21,"burnTimeS":1.65,"certOrg":"National Association of Rocketry","commonName":"D12","dataFiles":2,"delays":"0,3,5,7","designation":"D12","diameter":24,"impulseClass":"D","infoUrl":"http://nar.org/SandT/pdf/Estes/D12.pdf","length":70,"manufacturer":"Estes Industries","manufacturerAbbrev":"Estes","maxThrustN":29.73,"motorId":"5f4294d20002310000000020","propInfo":"black powder","propWeightG":21.1,"samples":[[0,0],[0.049,2.569],[0.116,9.369],[0.184,17.27],[0.237,24.26],[0.282,29.73],[0.297,27.01],[0.311,22.59],[0.322,17.99],[0.348,14.13],[0.386,12.1],[0.442,10.81],[0.546,9.876],[0.718,9.306],[0.879,9.105],[1.066,8.901],[1.257,8.698],[1.436,8.31],[1.59,8.294],[1.612,4.613],[1.65,0]],"totImpulseNs":16.84,"totalWeightG":44,"type":"SU","updatedOn":"2022-07-27"},{"availability":"regular","avgThrustN":12.67,"burnTimeS":1.52,"caseInfo":"RMS-18/20","certOrg":"National Association of Rocketry","commonName":"D13","dataFiles":2,"delays":"4,5,6,7,8,10","designation":"D13W","diameter":18,"impulseClass":"D","infoUrl":"http://nar.org/SandT/pdf/Aerotech/D13.pdf","length":70,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":23.61,"motorId":"5f4294d20002310000000021","propInfo":"White Lightning","propWeightG":9.8,"samples":[[0,0],[0.03,13.46],[0.061,21.17],[0.085,20.62],[0.127,21.61],[0.158,21.04],[0.182,22.31],[0.217,22.59],[0.227,23.61],[0.248,21.89],[0.279,23.16],[0.317,22.04],[0.366,21.34],[0.383,21.9],[0.449,20.65],[0.462,21.49],[0.48,19.95],[0.507,19.95],[0.521,20.51],[0.559,18.69],[0.58,19.12],[0.66,17.58],[0.743,15.34],[0.861,12.41],[0.947,9.329],[1.068,5.834],[1.155,4.158],[1.172,4.72],[1.231,2.762],[1.328,1.928],[1.404,1.093],[1.52,0]],"totImpulseNs":19.26,"totalWeightG":31.9,"type":"reload","updatedOn":"2022-03-20"},{"availability":"regular","avgThrustN":16.49,"burnTimeS":1.15,"caseInfo":"RMS-24/40","certOrg":"National Association of Rocketry","commonName":"D15","dataFiles":2,"delays":"4,5,7","designation":"D15T","diameter":24,"impulseClass":"D","infoUrl":"http://nar.org/SandT/pdf/Aerotech/D15.pdf","length":70,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":31.36,"motorId":"5f4294d20002310000000022","propInfo":"Blue Thunder","propWeightG":8.9,"samples":[[0,0],[0.014,11.48],[0.049,26.27],[0.081,30.09],[0.107,31.26],[0.121,31.25],[0.159,31.36],[0.208,31.25],[0.283,29.58],[0.439,23.35],[0.551,18.48],[0.675,13.43],[0.863,6.422],[0.938,3.892],[1.01,2.335],[1.085,0.778],[1.142,0.389],[1.15,0]],"totImpulseNs":18.96,"totalWeightG":46.9,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":20.84,"burnTimeS":0.94,"certOrg":"National Association of Rocketry","commonName":"D21","dataFiles":2,"delays":"4,7","designation":"D21T","diameter":18,"impulseClass":"D","infoUrl":"http://nar.org/SandT/pdf/Aerotech/D21.pdf","length":70,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":32.12,"motorId":"5f4294d20002310000000023","propInfo":"Blue Thunder","propWeightG":9.6,"samples":[[0,0],[0.01,1.367],[0.021,19.37],[0.029,32.12],[0.037,31.67],[0.051,30.53],[0.094,30.07],[0.115,31.21],[0.133,30.07],[0.177,30.76],[0.189,29.84],[0.203,30.53],[0.226,29.84],[0.275,28.93],[0.296,29.39],[0.331,28.03],[0.421,25.97],[0.478,24.15],[0.579,20.73],[0.659,17.77],[0.739,14.36],[0.799,9.569],[0.852,4.557],[0.899,1.139],[0.94,0]],"totImpulseNs":19.59,"totalWeightG":25,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":14.77,"burnTimeS":1.22,"caseInfo":"RMS-18/20","certOrg":"National Association of Rocketry","commonName":"D24","dataFiles":3,"delays":"4,5,6,7,8,10","designation":"D24T","diameter":18,"impulseClass":"D","infoUrl":"http://nar.org/SandT/pdf/Aerotech/D24.pdf","length":70,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":25.52,"motorId":"5f4294d20002310000000024","propInfo":"Blue Thunder","propWeightG":8.7,"samples":[[0,0],[0.008,10],[0.015,15],[0.035,25.52],[0.06,22.5],[0.1,21.8],[0.2,21],[0.4,20],[0.6,17.8],[0.8,14.3],[0.94,10],[1.03,5.2],[1.1,2.45],[1.15,1],[1.22,0]],"totImpulseNs":18.02,"totalWeightG":32,"type":"reload","updatedOn":"2022-03-20"},{"availability":"OOP","avgThrustN":6,"burnTimeS":6.67,"caseInfo":"RMS 24/20-40 R/C","certOrg":"National Association of Rocketry","commonName":"E6","dataFiles":1,"delays":"4,6,8,P","designation":"E6","diameter":24,"impulseClass":"E","infoUrl":"https://nar.org/SandT/pdf/Aerotech/E6.pdf","length":70,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d20002310000000025","propInfo":"Blue Thunder","propWeightG":21.5,"samples":[[0,0],[0.011,18.09],[0.109,19.68],[0.217,16.31],[0.315,13.47],[0.457,11.35],[0.63,9.043],[0.804,7.801],[0.989,6.738],[1.272,6.028],[2,5.851],[3,5.496],[4,5.496],[4.446,4.965],[5.011,4.965],[5.533,4.787],[5.609,6.56],[5.707,4.255],[6.033,0]],"totImpulseNs":40,"type":"SU","updatedOn":"2022-07-20"},{"availability":"regular","avgThrustN":5.27,"burnTimeS":7.12,"caseInfo":"RMS-R/C-24/20-40","certOrg":"National Association of Rocketry","commonName":"E6","dataFiles":1,"designation":"E6-RCT","diameter":24,"impulseClass":"E","infoUrl":"http://www.nar.org/SandT/pdf/Aerotech/E6TRC.pdf","length":70,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":11.9,"motorId":"5f4294d20002310000000026","propInfo":"Blue Thunder","propWeightG":21.5,"samples":[[0,0],[0.047,10.87],[0.127,11.69],[0.19,11.9],[0.316,11.62],[0.522,10.59],[0.743,9.287],[0.996,7.842],[1.249,6.19],[1.47,5.296],[1.787,4.747],[2.372,4.471],[3.02,4.403],[3.747,4.264],[4.49,4.403],[5.375,4.333],[6.087,4.264],[6.719,4.264],[6.877,4.196],[6.957,3.783],[7.004,2.614],[7.036,1.513],[7.083,0.55],[7.12,0]],"totImpulseNs":37.5,"totalWeightG":50,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":5.41,"burnTimeS":5.43,"caseInfo":"RMS-R/C-24/20-40","certOrg":"National Association of Rocketry","commonName":"E7","dataFiles":2,"designation":"E7-RCT","diameter":24,"impulseClass":"E","infoUrl":"http://nar.org/SandT/pdf/Aerotech/E7TRC.pdf","length":70,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":11.58,"motorId":"5f4294d20002310000000027","propInfo":"Blue Thunder","propWeightG":17.1,"samples":[[0,0],[0.038,6.636],[0.063,10.06],[0.087,11.02],[0.134,11.42],[0.206,11.58],[0.312,11.15],[0.466,10.74],[0.667,9.777],[0.94,8.132],[1.223,6.281],[1.484,5.182],[1.709,4.701],[2.112,4.423],[2.776,4.279],[3.31,4.205],[3.926,4.266],[4.401,4.192],[4.638,4.258],[4.744,4.119],[5.124,3.979],[5.219,3.977],[5.266,3.156],[5.313,1.992],[5.36,0.965],[5.43,0]],"totImpulseNs":29.35,"totalWeightG":48.4,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":9.02,"burnTimeS":3.09,"certOrg":"National Association of Rocketry","commonName":"E9","dataFiles":2,"delays":"4,6,8","designation":"E9","diameter":24,"impulseClass":"E","infoUrl":"http://www.nar.org/SandT/pdf/Estes/E9.pdf","length":95,"manufacturer":"Estes Industries","manufacturerAbbrev":"Estes","maxThrustN":19.47,"motorId":"5f4294d20002310000000028","propInfo":"black powder","propWeightG":35.8,"samples":[[0,0],[0.046,1.913],[0.235,16.7],[0.273,18.43],[0.326,14.96],[0.38,12.17],[0.44,10.44],[0.835,9.043],[1.093,8.87],[1.496,8.696],[1.997,8.696],[2.498,8.696],[3.014,9.217],[3.037,5.043],[3.067,1.217],[3.09,0]],"totImpulseNs":27.87,"totalWeightG":58,"type":"SU","updatedOn":"2021-07-31"},{"availability":"OOP","avgThrustN":12,"burnTimeS":2.983,"caseInfo":"SU 24x102","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"E12","dataFiles":1,"delays":"6,10","designation":"E12","diameter":24,"impulseClass":"E","length":102,"manufacturer":"Ellis Mountain","manufacturerAbbrev":"Ellis","motorId":"5f4294d2000231000000002b","propWeightG":28.3,"samples":[[0,0],[0.01,31.17],[0.13,24.43],[0.17,23.34],[1.5,14.83],[2,10.28],[2.5,4.8],[2.91,2.3],[2.92,0]],"totImpulseNs":35.8,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":11.22,"burnTimeS":3.05,"caseInfo":"RMS-R/C-24/20-40","certOrg":"National Association of Rocketry","commonName":"E12","dataFiles":2,"designation":"E12-RCJ","diameter":24,"impulseClass":"E","infoUrl":"http://nar.org/SandT/pdf/Aerotech/E12JRC.pdf","length":70,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":18.33,"motorId":"5f4294d2000231000000002c","propInfo":"Blackjack","propWeightG":30.3,"samples":[[0,0],[0.054,16.76],[0.095,18.33],[0.197,16.55],[0.313,16.65],[0.36,17.21],[0.401,16.32],[0.442,17.55],[0.476,16.21],[0.578,16.32],[0.666,16.76],[0.7,15.65],[0.768,16.32],[0.89,16.1],[1.019,15.65],[1.162,14.98],[1.23,14.98],[1.25,13.97],[1.291,14.75],[1.332,13.75],[1.373,14.2],[1.434,13.53],[1.488,13.75],[1.597,12.63],[1.726,11.4],[1.828,10.62],[1.889,9.613],[1.957,9.613],[1.998,8.495],[2.093,8.607],[2.277,7.042],[2.487,5.813],[3.05,0]],"totImpulseNs":34.22,"totalWeightG":59.4,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":21.8,"burnTimeS":1.6,"certOrg":"National Association of Rocketry","commonName":"E15","dataFiles":4,"delays":"4,6,7,8,10","designation":"E15W","diameter":24,"impulseClass":"E","infoUrl":"https://www.nar.org/SandT/pdf/Aerotech/E15.pdf","length":65,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":34.9,"motorId":"5f4294d2000231000000002d","propInfo":"White Lightning","propWeightG":16.2,"samples":[[0,0],[0.001,0.02904],[0.025,0.2276],[0.039,1.394],[0.049,2.672],[0.057,5.817],[0.061,7.769],[0.063,9.004],[0.065,10.72],[0.073,20.34],[0.075,22.41],[0.081,27.13],[0.085,28.99],[0.091,30.54],[0.105,32.95],[0.125,34.26],[0.139,34.68],[0.253,33.85],[0.361,32.08],[0.631,29.81],[0.673,28.83],[0.771,27.36],[0.801,26.39],[0.901,24.21],[1.085,18.07],[1.135,16.89],[1.161,15.87],[1.291,12.19],[1.373,9.381],[1.509,4.039],[1.553,2.722],[1.603,1.721],[1.759,0]],"totImpulseNs":35,"totalWeightG":49,"type":"SU","updatedOn":"2021-09-08"},{"availability":"OOP","avgThrustN":15.06,"burnTimeS":2.64,"caseInfo":"SU 24x70","certOrg":"National Association of Rocketry","commonName":"E15","dataFiles":1,"delays":"4,7","designation":"E15","diameter":24,"impulseClass":"E","infoUrl":"http://nar.org/SandT/pdf/RocketVision/E15.pdf","length":70,"manufacturer":"Rocketvision Flight-Star","manufacturerAbbrev":"RV","maxThrustN":28.84,"motorId":"5f4294d2000231000000002e","propWeightG":17.8,"samples":[[0,0],[0.02,23.33],[0.036,27.32],[0.058,28.84],[0.079,27.17],[0.139,25.64],[0.183,24.26],[0.237,24.11],[0.297,22.43],[0.373,21.96],[0.4,20.89],[0.443,21.36],[0.487,20.44],[0.617,19.83],[0.742,18.46],[0.812,20],[0.85,18.01],[0.899,18.47],[1.035,17.71],[1.1,16.95],[1.16,16.95],[1.377,15.74],[1.426,14.66],[1.436,16.2],[1.463,14.81],[1.55,14.36],[1.572,15.43],[1.61,13.75],[1.827,12.84],[2.126,10.1],[2.337,6.116],[2.538,1.369],[2.64,0]],"totImpulseNs":39.76,"totalWeightG":50.1,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":18.84,"burnTimeS":2,"caseInfo":"RMS-29/40-120","certOrg":"National Association of Rocketry","commonName":"E16","dataFiles":1,"delays":"4,5,7","designation":"E16W","diameter":29,"impulseClass":"E","infoUrl":"http://nar.org/SandT/pdf/Aerotech/E16.pdf","length":124,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":37.2,"motorId":"5f4294d20002310000000030","propInfo":"White Lightning","propWeightG":19,"samples":[[0,0],[0.132,32.22],[0.221,37.2],[0.255,36.7],[0.306,36.7],[0.371,35.36],[0.414,33.78],[0.437,34.91],[0.472,33.78],[0.53,32.89],[0.553,31.77],[0.576,32.44],[0.638,29.31],[0.72,27.3],[0.867,23.94],[1.083,19.25],[1.273,14.32],[1.458,9.397],[1.513,8.055],[1.524,8.279],[1.555,6.936],[1.656,4.474],[1.814,1.79],[2,0]],"totImpulseNs":37.67,"totalWeightG":109,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":17.07,"burnTimeS":2.14,"caseInfo":"RMS-24/40","certOrg":"National Association of Rocketry","commonName":"E18","dataFiles":2,"delays":"4,5,7","designation":"E18W","diameter":24,"impulseClass":"E","infoUrl":"http://nar.org/SandT/pdf/Aerotech/E18.pdf","length":70,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":30.08,"motorId":"5f4294d20002310000000031","propInfo":"White Lightning","propWeightG":20.7,"samples":[[0,0],[0.016,6.586],[0.042,18],[0.073,27.14],[0.098,29.82],[0.134,30.36],[0.17,30.35],[0.195,31.08],[0.236,30.35],[0.287,30.88],[0.338,30.34],[0.368,30.88],[0.404,29.8],[0.424,30.69],[0.465,29.98],[0.526,29.79],[0.592,29.06],[0.669,28.34],[0.786,26.91],[0.908,23.85],[1.025,21.16],[1.157,17.91],[1.284,14.86],[1.462,11.34],[1.66,7.106],[1.838,3.47],[2.006,1.309],[2.083,0.588],[2.14,0]],"totImpulseNs":36.54,"totalWeightG":59,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":22.5,"burnTimeS":1.57,"caseInfo":"RMS-29/40-120","certOrg":"National Association of Rocketry","commonName":"E23","dataFiles":2,"delays":"4,5,6,8","designation":"E23T","diameter":29,"impulseClass":"E","infoUrl":"http://nar.org/SandT/pdf/Aerotech/E23.pdf","length":124,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":38.22,"motorId":"5f4294d20002310000000032","propInfo":"Blue Thunder","propWeightG":17.4,"samples":[[0,0],[0.024,16.3],[0.035,21.96],[0.067,30.79],[0.09,35.77],[0.153,37.58],[0.2,38.22],[0.24,37.36],[0.322,37.58],[0.393,35.09],[0.534,32.38],[0.727,27.17],[0.766,26.94],[0.798,25.13],[0.908,21.73],[1.057,16.98],[1.187,12.68],[1.336,7.471],[1.45,3.169],[1.497,1.584],[1.532,0.679],[1.57,0]],"totImpulseNs":35.32,"totalWeightG":104,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":32.53,"burnTimeS":1.22,"caseInfo":"RMS-24/40","certOrg":"National Association of Rocketry","commonName":"E28","dataFiles":2,"delays":"4,5,7","designation":"E28T","diameter":24,"impulseClass":"E","infoUrl":"http://nar.org/SandT/pdf/Aerotech/E28.pdf","length":70,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":50.52,"motorId":"5f4294d20002310000000033","propInfo":"Blue Thunder","propWeightG":18.4,"samples":[[0,0],[0.01,29.86],[0.018,45.14],[0.038,47.56],[0.081,50.52],[0.106,48.95],[0.146,48.26],[0.161,48.95],[0.197,48.95],[0.242,47.56],[0.313,46.18],[0.411,43.06],[0.494,40.62],[0.527,39.58],[0.542,40.27],[0.562,38.54],[0.633,36.46],[0.683,34.38],[0.743,31.24],[0.799,29.16],[0.877,26.04],[0.97,20.83],[1.006,17.36],[1.046,11.46],[1.089,6.943],[1.132,3.819],[1.172,1.735],[1.22,0]],"totImpulseNs":39.69,"totalWeightG":55.3,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":32.38,"burnTimeS":1.02,"certOrg":"National Association of Rocketry","commonName":"E30","dataFiles":3,"delays":"4,7","designation":"E30T","diameter":24,"impulseClass":"E","infoUrl":"http://nar.org/SandT/pdf/Aerotech/E30.pdf","length":70,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":49.3,"motorId":"5f4294d20002310000000034","propInfo":"Blue Thunder","propWeightG":17.8,"samples":[[0,0],[0.006,49.3],[0.03,45.7],[0.038,47.18],[0.05,45.18],[0.062,43.7],[0.112,43.4],[0.138,42.82],[0.206,42.07],[0.238,43.37],[0.282,41.58],[0.324,41.09],[0.342,41.73],[0.362,40.17],[0.436,38.16],[0.524,36.4],[0.65,32.97],[0.712,31.05],[0.836,25.08],[0.874,22.48],[0.888,21.51],[0.9,20.01],[0.912,17.18],[0.924,13.3],[0.942,6.65],[0.962,2.755],[0.974,1.637],[0.988,0.781],[1,0.429],[1.01,0.141],[1.02,0]],"totImpulseNs":33.56,"totalWeightG":47,"type":"SU","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":10.71,"burnTimeS":7.13,"caseInfo":"SU 29x85","certOrg":"National Association of Rocketry","commonName":"F10","dataFiles":1,"delays":"4,6,8","designation":"F10","diameter":29,"impulseClass":"F","infoUrl":"http://nar.org/SandT/pdf/Aerotech/F10.pdf","length":85,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":28.22,"motorId":"5f4294d20002310000000035","propWeightG":40.7,"samples":[[0,0],[0.01,16.81],[0.03,22.34],[0.11,22.23],[0.26,21.49],[0.37,20],[0.47,20.21],[0.67,18.09],[0.99,15.74],[1.31,13.4],[1.81,10.85],[2.49,10.21],[3.13,8.94],[3.6,8.83],[4.11,8.62],[4.95,8.62],[5.45,8.62],[5.58,8.51],[5.88,8.72],[6.22,8.51],[6.46,8.51],[6.6,7.77],[6.71,7.02],[6.79,5.64],[6.91,3.83],[6.95,2.23],[7,0.96],[7.05,0]],"totImpulseNs":76.33,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":14.74,"burnTimeS":2.93,"caseInfo":"RMS-24/40","certOrg":"National Association of Rocketry","commonName":"F12","dataFiles":2,"delays":"3,5","designation":"F12J","diameter":24,"impulseClass":"F","infoUrl":"http://nar.org/SandT/pdf/Aerotech/F12.pdf","length":70,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":23.54,"motorId":"5f4294d20002310000000036","propInfo":"Blackjack","propWeightG":30.3,"samples":[[0,0],[0.037,20.89],[0.054,22.15],[0.101,22.15],[0.148,22.57],[0.165,23.41],[0.2,22.42],[0.281,22.14],[0.369,22.13],[0.474,22.27],[0.526,23.54],[0.549,21.98],[0.637,22.12],[0.724,21.84],[0.8,21.41],[0.823,22.25],[0.846,20.71],[0.881,21.55],[0.945,21.12],[1.021,20.7],[1.114,20.55],[1.213,19.3],[1.382,18.3],[1.481,18.02],[1.737,15.34],[1.79,17.3],[1.883,13.94],[2.051,11.26],[2.22,7.468],[2.447,3.671],[2.709,1.135],[2.93,0]],"totImpulseNs":43.2,"totalWeightG":68.6,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":12.17,"burnTimeS":5.1,"caseInfo":"RMS-R/C-32/60-100","certOrg":"National Association of Rocketry","commonName":"F13","dataFiles":2,"designation":"F13-RCT","diameter":32,"impulseClass":"F","infoUrl":"http://nar.org/SandT/pdf/Aerotech/F13RCT.pdf","length":107,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":19.98,"motorId":"5f4294d20002310000000037","propInfo":"Blue Thunder","propWeightG":32.3,"samples":[[0,0],[0.048,15.31],[0.084,18.63],[0.143,19.98],[0.311,18.97],[0.538,18.17],[0.729,17.14],[0.992,15.43],[1.279,13.83],[1.673,12.46],[1.984,11.88],[2.044,12.23],[2.139,11.31],[2.378,11.19],[2.51,11.08],[2.558,12.11],[2.641,10.86],[2.976,10.74],[3.49,10.63],[3.873,10.51],[3.992,10.96],[4.028,10.63],[4.41,10.51],[4.625,10.74],[4.769,9.941],[4.829,8.684],[4.865,6.742],[4.96,3.199],[5.02,1.485],[5.1,0]],"totImpulseNs":62.07,"totalWeightG":110.5,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":13.27,"burnTimeS":5.69,"caseInfo":"RMS-R/C-32/60-100","certOrg":"National Association of Rocketry","commonName":"F16","dataFiles":2,"designation":"F16-RCJ","diameter":32,"impulseClass":"F","infoUrl":"http://nar.org/SandT/pdf/Aerotech/F16RCJ.pdf","length":107,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":26.35,"motorId":"5f4294d20002310000000038","propInfo":"Blackjack","propWeightG":62.5,"samples":[[0,0],[0.046,26.35],[0.116,22.39],[0.139,21.37],[0.185,21.89],[0.22,20.54],[0.301,19.7],[0.498,18.35],[0.579,19.19],[0.637,16.49],[0.718,18.35],[0.834,18.35],[0.95,18.35],[1.054,19.19],[1.147,17.85],[1.181,18.85],[1.263,17.34],[1.436,18.01],[1.633,17.16],[1.784,17.34],[1.865,18.68],[1.934,16.83],[1.981,17.34],[2.178,16.33],[2.375,16.33],[2.502,18.18],[2.664,15.66],[2.896,15.49],[3.29,13.8],[3.718,11.61],[4.181,9.426],[4.888,5.891],[5.69,0]],"totImpulseNs":75.48,"totalWeightG":140.4,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":20.8,"burnTimeS":2.49,"certOrg":"National Association of Rocketry","commonName":"F20","dataFiles":3,"delays":"4,7","designation":"F20W/L","diameter":29,"impulseClass":"F","infoUrl":"http://www.nar.org/wp-content/uploads/2014/08/F20.pdf","length":83,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":40.33,"motorId":"5f4294d20002310000000039","propInfo":"White Lightning","propWeightG":30,"samples":[[0,0],[0.023,16.43],[0.043,28.54],[0.062,36.69],[0.078,40.33],[0.12,37.68],[0.167,36.93],[0.213,36.93],[0.298,36.43],[0.318,37.17],[0.333,35.69],[0.368,36.18],[0.395,35.19],[0.43,36.43],[0.446,37.17],[0.481,34.45],[0.554,34.44],[0.946,30.96],[0.965,29.48],[1.008,29.73],[1.062,27.75],[1.097,27.5],[1.136,26.26],[1.31,20.57],[1.36,19.82],[1.438,17.35],[1.465,17.35],[1.527,15.12],[1.597,13.88],[1.81,9.176],[1.969,6.203],[2.49,0]],"totImpulseNs":51.75,"totalWeightG":80.2,"type":"SU","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":21,"burnTimeS":2.5,"caseInfo":"SU 24x95","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"F21","dataFiles":2,"delays":"4,6,8","designation":"F21W","diameter":24,"impulseClass":"F","length":95,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":42,"motorId":"5f4294d2000231000000003a","propInfo":"White Lightning","propWeightG":30,"samples":[[0,0],[0.0045,37.23],[0.009,42.15],[0.018,42.5],[0.027,40.51],[0.0337,38.87],[0.0427,38.23],[0.0517,37.73],[0.0607,36.87],[0.072,36.44],[0.0877,36.44],[0.1102,35.37],[0.135,35.87],[0.1552,35.44],[0.1732,36.23],[0.2025,35.66],[0.2452,37.3],[0.2835,36.58],[0.3195,38.01],[0.3375,37.44],[0.3757,38.58],[0.396,38.23],[0.4297,39.37],[0.4454,38.01],[0.4747,38.72],[0.4882,37.8],[0.5084,38.15],[0.5354,38.51],[0.5647,37.94],[0.5849,37.23],[0.6007,37.87],[0.6389,36.87],[0.6704,37.16],[0.7649,35.94],[0.9201,32.95],[1.006,30.31],[1.071,29.74],[1.264,24.03],[1.287,24.03],[1.372,20.82],[1.393,20.82],[1.588,15.48],[1.611,15.48],[2.011,5.063],[2.119,3.423],[2.241,2.425],[2.378,1.498],[2.493,0.9271],[2.515,0]],"totImpulseNs":55,"totalWeightG":64,"type":"SU","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":19.64,"burnTimeS":3.31,"caseInfo":"RMS-29/40-120","certOrg":"National Association of Rocketry","commonName":"F22","dataFiles":2,"delays":"5,7","designation":"F22J","diameter":29,"impulseClass":"F","infoUrl":"http://nar.org/SandT/pdf/Aerotech/F22.pdf","length":124,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":31.15,"motorId":"5f4294d2000231000000003b","propInfo":"Blackjack","propWeightG":46.3,"samples":[[0,0],[0.014,11.53],[0.075,20.13],[0.157,26.57],[0.293,29.11],[0.382,30.28],[0.45,29.69],[0.539,30.67],[0.614,30.09],[0.662,31.15],[0.771,30.48],[0.948,29.89],[0.996,28.71],[1.078,28.14],[1.187,27.74],[1.289,26.76],[1.337,26.96],[1.412,25.98],[1.474,25.01],[1.515,26.17],[1.542,24.81],[1.706,22.86],[1.938,20.9],[2.101,18.17],[2.129,19.34],[2.251,16.21],[2.402,13.48],[2.64,8.791],[2.961,3.32],[3.31,0]],"totImpulseNs":65,"totalWeightG":135.6,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":18.58,"burnTimeS":2.21,"certOrg":"National Association of Rocketry","commonName":"F23","dataFiles":2,"delays":"4,7","designation":"F23FJ/L","diameter":29,"impulseClass":"F","infoUrl":"https://nar.org/SandT/pdf/Aerotech/F23FJ.pdf","length":83,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":29.8,"motorId":"5f4294d2000231000000003c","propInfo":"Black Max","propWeightG":30,"samples":[[0,0],[0.03,48.7],[0.05,43.11],[0.08,41.41],[0.1,42.26],[0.13,40.84],[0.17,39.42],[0.23,38.85],[0.27,38.85],[0.3,37.44],[0.31,38.57],[0.36,37.72],[0.43,36.59],[0.5,36.02],[0.56,36.02],[0.59,34.6],[0.69,33.18],[0.77,32.61],[0.85,31.2],[0.94,29.5],[1.04,27.79],[1.18,24.39],[1.2,25.24],[1.25,22.97],[1.37,20.98],[1.53,16.73],[1.69,12.48],[1.83,9.07],[1.95,5.11],[2.07,2.27],[2.22,0]],"totImpulseNs":41.2,"totalWeightG":82.3,"type":"SU","updatedOn":"2022-08-09"},{"availability":"regular","avgThrustN":23,"burnTimeS":3.47,"caseInfo":"RMS-R/C-32/60-100","certOrg":"National Association of Rocketry","commonName":"F23","dataFiles":2,"designation":"F23-RCW-SK","diameter":32,"impulseClass":"F","infoUrl":"https://nar.org/SandT/pdf/Aerotech/F23RCWSK.pdf","length":107,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":36,"motorId":"5f4294d2000231000000003d","propInfo":"White Lightning","propWeightG":37.8,"samples":[[0,0],[0.042,22.64],[0.133,28.19],[0.161,27.26],[0.189,29.57],[0.252,31.42],[0.343,32.58],[0.399,32.35],[0.441,33.74],[0.476,30.73],[0.539,33.51],[0.609,34.2],[0.777,34.89],[0.826,34.66],[0.896,36],[0.938,34.66],[1.015,34.66],[1.071,34.2],[1.12,33.04],[1.218,32.58],[1.267,29.81],[1.351,29.34],[1.393,27.73],[1.54,26.8],[1.645,24.26],[1.799,21.25],[1.862,19.87],[2.051,15.48],[2.317,11.55],[2.618,6.7],[2.884,3.234],[3.185,1.386],[3.47,0]],"totImpulseNs":70,"totalWeightG":128.7,"type":"reload","updatedOn":"2022-07-20"},{"availability":"OOP","avgThrustN":23,"burnTimeS":3.58,"caseInfo":"SU 24x140","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"F23","dataFiles":1,"delays":"6,10","designation":"F23","diameter":24,"impulseClass":"F","length":140,"manufacturer":"Ellis Mountain","manufacturerAbbrev":"Ellis","maxThrustN":39.2,"motorId":"5f4294d2000231000000003e","propWeightG":31.2,"samples":[[0,0],[0.01,24.19],[0.05,39],[0.07,39.14],[0.13,34.58],[1,26.94],[2,19.52],[2.4,14],[2.7,7.96],[3,4.46],[3.55,1.27],[3.58,0]],"totImpulseNs":67.9,"totalWeightG":76.5,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":22.21,"burnTimeS":2.13,"caseInfo":"RMS-24/40","certOrg":"National Association of Rocketry","commonName":"F24","dataFiles":2,"delays":"4,7","designation":"F24W","diameter":24,"impulseClass":"F","infoUrl":"http://nar.org/SandT/pdf/Aerotech/F24.pdf","length":70,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":40.95,"motorId":"5f4294d2000231000000003f","propInfo":"White Lightning","propWeightG":19,"samples":[[0,0],[0.033,16.44],[0.112,40.65],[0.125,41.45],[0.18,40.93],[0.245,40.63],[0.281,41.02],[0.355,40.02],[0.438,39.71],[0.543,38.23],[0.603,37.03],[0.658,33.78],[0.685,34.66],[0.726,29.93],[0.772,30.22],[0.951,26.95],[1.071,25.17],[1.107,23.09],[1.185,21.31],[1.383,17.14],[1.649,10.91],[1.828,5.869],[1.938,2.903],[1.988,2.306],[2.048,1.412],[2.13,0]],"totImpulseNs":47.31,"totalWeightG":62.9,"type":"reload","updatedOn":"2022-10-12"},{"availability":"regular","avgThrustN":25.55,"burnTimeS":3.05,"certOrg":"National Association of Rocketry","commonName":"F25","dataFiles":2,"delays":"4,6,7,9","designation":"F25W","diameter":29,"impulseClass":"F","infoUrl":"http://nar.org/SandT/pdf/Aerotech/F25W.pdf","length":98,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":46.79,"motorId":"5f4294d20002310000000040","propInfo":"White Lightning","propWeightG":35.6,"samples":[[0,0],[0.039,57.63],[0.187,53.49],[0.342,51.24],[0.5,47.86],[1,33.81],[1.5,22.94],[2,10.13],[2.207,4.504],[2.69,0]],"totImpulseNs":77.92,"totalWeightG":90,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":26,"burnTimeS":2.39,"certOrg":"National Association of Rocketry","commonName":"F26","dataFiles":2,"delays":"6,7,9","designation":"F26FJ","diameter":29,"impulseClass":"F","infoUrl":"https://nar.org/SandT/pdf/Aerotech/F26FJ.pdf","length":98,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":39.2,"motorId":"5f4294d20002310000000041","propInfo":"Black Max","propWeightG":43.1,"samples":[[0,0],[0.041,38.29],[0.114,36.32],[0.293,34.35],[0.497,32.94],[0.774,32.38],[1,31.25],[1.254,28.72],[1.498,25.34],[1.743,22.24],[2.003,17.74],[2.077,15.48],[2.304,5.349],[2.484,1.689],[2.61,0]],"totImpulseNs":62.2,"totalWeightG":101,"type":"SU","updatedOn":"2022-07-20"},{"availability":"OOP","avgThrustN":29.12,"burnTimeS":2.72,"caseInfo":"SU 24x95","certOrg":"National Association of Rocketry","commonName":"F32","dataFiles":2,"delays":"5,6,7,8,9,10,11,13,15","designation":"F32W","diameter":24,"impulseClass":"F","infoUrl":"http://nar.org/SandT/pdf/Aerotech/F32.pdf","length":95,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":55.64,"motorId":"5f4294d20002310000000042","propInfo":"White Lightning","propWeightG":37.7,"samples":[[0,0],[0.025,46.7],[0.031,51.85],[0.061,55.64],[0.085,52.87],[0.126,47.37],[0.245,45.64],[0.34,44.95],[0.394,42.87],[0.447,42.87],[0.572,41.14],[0.72,39.41],[0.744,40.78],[0.786,38.03],[1.041,35.59],[1.136,33.18],[1.177,34.54],[1.225,32.82],[1.379,31.44],[1.474,30.39],[1.635,28.31],[1.676,27.28],[1.694,29.68],[1.712,26.93],[1.854,25.54],[1.943,23.82],[2.092,21.05],[2.187,18.29],[2.276,13.82],[2.382,7.281],[2.525,2.457],[2.72,0]],"totImpulseNs":79.2,"type":"SU","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":29.12,"burnTimeS":2.72,"caseInfo":"SU 24x124","certOrg":"National Association of Rocketry","commonName":"F32","dataFiles":1,"delays":"5,10,15","designation":"F32","diameter":24,"impulseClass":"F","infoUrl":"http://nar.org/SandT/pdf/RocketVision/F32.pdf","length":124,"manufacturer":"Rocketvision Flight-Star","manufacturerAbbrev":"RV","maxThrustN":55.64,"motorId":"5f4294d20002310000000043","propWeightG":37.7,"samples":[[0,0],[0.01,50],[0.05,56],[0.1,48],[2,24],[2.2,19],[2.45,5],[2.72,0]],"totImpulseNs":79.2,"totalWeightG":69.5,"type":"SU","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":35,"burnTimeS":2.3,"caseInfo":"SU 29x112","certOrg":"National Association of Rocketry","commonName":"F35","dataFiles":2,"delays":"4,10","designation":"F35","diameter":29,"impulseClass":"F","length":112,"manufacturer":"Roadrunner Rocketry","manufacturerAbbrev":"Roadrunner","maxThrustN":50,"motorId":"5f4294d20002310000000044","propInfo":"Roadrunner propellant","propWeightG":40.1,"samples":[[0,0],[0.023,33.7],[0.04,44.46],[0.081,47.21],[0.121,48.58],[0.166,49.27],[0.242,49.55],[0.315,51.01],[0.411,50.11],[0.528,49.71],[0.664,48.21],[0.791,47.26],[0.896,46.99],[1,45.48],[1.097,44.94],[1.194,42.34],[1.277,40.4],[1.323,40.71],[1.356,37.69],[1.402,35.64],[1.451,32.75],[1.505,29.47],[1.578,25.49],[1.675,20.83],[1.75,17.14],[1.828,13.02],[1.907,8.638],[1.984,5.075],[2.049,2.61],[2.13,0]],"totImpulseNs":78,"totalWeightG":111,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":31.67,"burnTimeS":1.6,"caseInfo":"RMS-29/60","certOrg":"National Association of Rocketry","commonName":"F37","dataFiles":2,"delays":"4,6,8,10","designation":"F37W","diameter":29,"impulseClass":"F","infoUrl":"http://nar.org/SandT/pdf/Aerotech/F37.pdf","length":99,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":46.47,"motorId":"5f4294d20002310000000045","propInfo":"White Lightning","propWeightG":28.2,"samples":[[0,0],[0.018,7.251],[0.053,13.63],[0.088,22.33],[0.106,25.23],[0.141,26.39],[0.183,28.41],[0.26,37.69],[0.31,41.45],[0.422,44.03],[0.524,45.18],[0.59,46.47],[0.682,45.15],[0.864,43.39],[0.934,40.47],[1.042,35.23],[1.151,29.7],[1.246,25.04],[1.354,19.8],[1.445,13.4],[1.498,7.586],[1.54,3.226],[1.6,0]],"totImpulseNs":50.67,"totalWeightG":109.3,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":37.34,"burnTimeS":1.33,"caseInfo":"RMS-24/40","certOrg":"National Association of Rocketry","commonName":"F39","dataFiles":2,"delays":"4,5,6,7,9","designation":"F39T","diameter":24,"impulseClass":"F","infoUrl":"http://nar.org/SandT/pdf/Aerotech/F39.pdf","length":70,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":59.47,"motorId":"5f4294d20002310000000046","propInfo":"Blue Thunder","propWeightG":22.7,"samples":[[0,0],[0.01,45.06],[0.016,54.13],[0.046,58.32],[0.079,59.47],[0.103,58.31],[0.13,57.25],[0.172,55.49],[0.235,53.74],[0.321,51.27],[0.363,50.57],[0.387,49.51],[0.408,50.2],[0.426,48.8],[0.453,47.75],[0.48,47.04],[0.68,41.06],[0.716,39.65],[0.752,38.94],[0.809,36.49],[0.86,34.38],[0.893,33.32],[0.917,32.62],[1,28.75],[1.075,25.25],[1.105,22.09],[1.126,17.2],[1.144,13],[1.174,8.109],[1.219,4.606],[1.261,2.5],[1.33,0]],"totImpulseNs":49.66,"totalWeightG":60.6,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":37.91,"burnTimeS":2.06,"caseInfo":"RMS-29/40-120","certOrg":"National Association of Rocketry","commonName":"F40","dataFiles":2,"delays":"4,5,6,7,8,10","designation":"F40W","diameter":29,"impulseClass":"F","infoUrl":"http://nar.org/SandT/pdf/Aerotech/F40.pdf","length":124,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":68.07,"motorId":"5f4294d20002310000000047","propInfo":"White Lightning","propWeightG":40,"samples":[[0,0],[0.015,17.78],[0.049,41.02],[0.089,58.79],[0.124,62.9],[0.148,65.17],[0.183,62.44],[0.242,68.07],[0.292,60.62],[0.321,61.52],[0.415,60.62],[0.524,58.33],[0.741,52.41],[0.87,48.31],[0.889,49.22],[0.914,47.4],[1.102,40.11],[1.285,33.73],[1.492,25.06],[1.665,15.95],[1.808,8.659],[1.942,3.19],[2.06,0]],"totImpulseNs":78.09,"totalWeightG":126.2,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":42,"burnTimeS":1.26,"certOrg":"National Association of Rocketry","commonName":"F42","dataFiles":2,"delays":"4,6,8","designation":"F42T/L","diameter":29,"impulseClass":"F","infoUrl":"https://nar.org/SandT/pdf/Aerotech/F42.pdf","length":83,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":66,"motorId":"5f4294d20002310000000048","propInfo":"Blue Thunder","propWeightG":27,"samples":[[0,0],[0.01,68.69],[0.029,65.88],[0.202,62.5],[0.511,51.8],[0.739,43.36],[0.993,31.53],[1.02,29.28],[1.072,23.09],[1.199,9.572],[1.262,4.505],[1.319,2.815],[1.47,0]],"totImpulseNs":52.9,"totalWeightG":75.9,"type":"SU","updatedOn":"2022-08-09"},{"availability":"regular","avgThrustN":53.73,"burnTimeS":1.43,"certOrg":"National Association of Rocketry","commonName":"F50","dataFiles":2,"delays":"4,6,7,9","designation":"F50T","diameter":29,"impulseClass":"F","infoUrl":"http://nar.org/SandT/pdf/Aerotech/F50.pdf","length":98,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":79.59,"motorId":"5f4294d20002310000000049","propInfo":"Blue Thunder","propWeightG":37.9,"samples":[[0,0],[0.013,73.76],[0.0326,70.38],[0.267,69.82],[0.518,67],[0.792,56.87],[0.906,50.68],[1,44.48],[1.036,39.98],[1.107,23.65],[1.199,6.194],[1.316,1.126],[1.43,0]],"totImpulseNs":76.83,"totalWeightG":84.9,"type":"SU","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":53.73,"burnTimeS":1.43,"caseInfo":"SU 29x98","certOrg":"National Association of Rocketry","commonName":"F50","dataFiles":1,"designation":"F50T","diameter":29,"impulseClass":"F","infoUrl":"http://nar.org/SandT/pdf/PML/F50T.pdf","length":98,"manufacturer":"Public Missiles, Ltd.","manufacturerAbbrev":"PML","maxThrustN":79.59,"motorId":"5f4294d2000231000000004a","propWeightG":37.9,"samples":[[0,0],[0.01,37.97],[0.02,56.27],[0.03,65.08],[0.12,71.86],[0.23,75.25],[0.33,77.29],[0.35,77.7],[0.45,75.25],[0.59,71.86],[0.72,65.76],[0.83,58.98],[1.01,43.39],[1.19,25.76],[1.25,15.59],[1.3,8.81],[1.36,4.75],[1.42,0]],"totImpulseNs":76.83,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":51.37,"burnTimeS":1.42,"caseInfo":"RMS-29/40-120","certOrg":"National Association of Rocketry","commonName":"F52","dataFiles":2,"delays":"4,5,6,7,8,9,11","designation":"F52T","diameter":29,"impulseClass":"F","infoUrl":"http://nar.org/SandT/pdf/Aerotech/F52.pdf","length":124,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":78.95,"motorId":"5f4294d2000231000000004b","propInfo":"Blue Thunder","propWeightG":36.6,"samples":[[0,0],[0.012,46.9],[0.033,61.78],[0.056,69.44],[0.097,73.48],[0.115,76.64],[0.13,74.38],[0.153,74.82],[0.168,78.42],[0.182,78.95],[0.206,77.96],[0.238,77.5],[0.258,73.89],[0.314,72.97],[0.39,72.05],[0.428,70.68],[0.501,65.7],[0.565,62.98],[0.688,58.87],[0.749,56.15],[0.837,52.52],[0.901,49.79],[0.971,46.16],[1.088,39.37],[1.144,34.39],[1.173,29.42],[1.222,20.38],[1.275,13.15],[1.339,5.461],[1.389,1.838],[1.42,0]],"totImpulseNs":72.95,"totalWeightG":121.6,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":60,"burnTimeS":1.3,"caseInfo":"SU 29x112","certOrg":"National Association of Rocketry","commonName":"F60","dataFiles":2,"delays":"4,7,10","designation":"F60","diameter":29,"impulseClass":"F","length":112,"manufacturer":"Roadrunner Rocketry","manufacturerAbbrev":"Roadrunner","maxThrustN":90,"motorId":"5f4294d2000231000000004c","propInfo":"Rapid propellant","propWeightG":38.1,"samples":[[0,0],[0.013,45.86],[0.021,63.94],[0.029,72.29],[0.041,75.21],[0.061,74.37],[0.087,76.87],[0.155,83.12],[0.231,86.44],[0.309,88.09],[0.329,90.07],[0.345,88.33],[0.395,87.9],[0.454,87.21],[0.514,87.19],[0.616,82.14],[0.699,77.11],[0.765,70.4],[0.807,61.61],[0.859,51.98],[0.926,42.35],[0.978,33.56],[1.022,21.43],[1.061,13.06],[1.101,6.776],[1.133,3.423],[1.19,0]],"totImpulseNs":77,"totalWeightG":109,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":62,"burnTimeS":1.13,"caseInfo":"RMS-29/60","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"F62","dataFiles":2,"delays":"4,6,8,10","designation":"F62T","diameter":29,"impulseClass":"F","length":89,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":56.5,"motorId":"5f4294d2000231000000004d","propInfo":"Blue Thunder","propWeightG":30.5,"samples":[[0,0],[0.0046,53.64],[0.0416,55.27],[0.0909,58.36],[0.1356,61.64],[0.1649,64.91],[0.1864,67.64],[0.5085,67.64],[0.5701,64.73],[0.6687,60],[0.7427,55.09],[0.7982,49.64],[0.9029,48.73],[0.9492,24.73],[0.9661,20.18],[0.9985,0]],"totImpulseNs":51,"totalWeightG":109,"type":"reload","updatedOn":"2021-06-13"},{"availability":"OOP","avgThrustN":61.92,"burnTimeS":1.21,"caseInfo":"SU 24x124","certOrg":"National Association of Rocketry","commonName":"F72","dataFiles":2,"delays":"5,6,7,8,9,10,11,13,15","designation":"F72","diameter":24,"impulseClass":"F","infoUrl":"http://nar.org/SandT/pdf/Aerotech/F72.pdf","length":124,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":98.78,"motorId":"5f4294d2000231000000004e","propWeightG":36.8,"samples":[[0,0],[0.012,62.59],[0.017,84.99],[0.02,98.78],[0.03,94.75],[0.05,90.15],[0.069,82.69],[0.089,85.56],[0.104,80.39],[0.136,83.25],[0.146,80.96],[0.176,82.69],[0.198,78.67],[0.213,80.96],[0.253,80.39],[0.315,80.96],[0.38,79.82],[0.429,79.24],[0.489,78.09],[0.523,78.67],[0.536,75.22],[0.675,73.5],[0.699,67.18],[0.719,68.33],[0.747,64.88],[0.769,66.03],[0.858,60.87],[0.923,52.82],[0.98,40.2],[1.012,29.86],[1.034,20.09],[1.089,11.48],[1.21,0]],"totImpulseNs":74.92,"type":"SU","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":61.92,"burnTimeS":1.21,"caseInfo":"SU 24x124","certOrg":"National Association of Rocketry","commonName":"F72","dataFiles":1,"delays":"5,10,15","designation":"F72","diameter":24,"impulseClass":"F","infoUrl":"http://nar.org/SandT/pdf/RocketVision/F72.pdf","length":124,"manufacturer":"Rocketvision Flight-Star","manufacturerAbbrev":"RV","maxThrustN":98.78,"motorId":"5f4294d2000231000000004f","propWeightG":37.7,"samples":[[0,0],[0.004,37.67],[0.01,78.08],[0.017,97.26],[0.027,91.78],[0.043,89.73],[0.06,80.82],[0.087,84.93],[0.101,78.77],[0.132,81.51],[0.143,78.77],[0.171,81.51],[0.192,78.08],[0.215,80.82],[0.24,78.08],[0.264,81.51],[0.279,78.77],[0.298,80.14],[0.517,76.03],[0.68,70.55],[0.855,58.22],[0.934,49.31],[0.961,43.15],[0.996,31.51],[1.025,21.23],[1.054,14.38],[1.103,7.534],[1.147,3.425],[1.196,0]],"totImpulseNs":74.92,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":10.2,"burnTimeS":8.55,"caseInfo":"RMS-R/C-32/60-100","certOrg":"National Association of Rocketry","commonName":"G12","dataFiles":2,"designation":"G12-RCT","diameter":32,"impulseClass":"G","infoUrl":"http://nar.org/SandT/pdf/Aerotech/G12RC.pdf","length":107,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":20.64,"motorId":"5f4294d20002310000000050","propInfo":"Blue Thunder","propWeightG":51.1,"samples":[[0,0],[0.03,18.55],[0.117,19.96],[0.239,20.64],[0.362,20.11],[0.519,18.98],[0.694,17.14],[0.886,15.02],[1.131,13.19],[1.375,11.91],[1.689,11.07],[2.021,10.36],[2.422,10.23],[3.172,9.677],[4.114,9.267],[5.039,8.857],[6.137,8.733],[7.132,8.607],[7.795,8.335],[7.952,8.196],[8.074,8.055],[8.179,6.924],[8.319,4.661],[8.476,1.973],[8.55,0]],"totImpulseNs":87.22,"totalWeightG":131,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":20,"burnTimeS":5.47,"caseInfo":"SU 29x149","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G20","dataFiles":2,"designation":"G20","diameter":29,"impulseClass":"G","length":149,"manufacturer":"Ellis Mountain","manufacturerAbbrev":"Ellis","maxThrustN":46,"motorId":"5f4294d20002310000000051","propWeightG":62,"samples":[[0,0],[0.04637,46.68],[0.2782,30.39],[0.4791,26.87],[1.005,24.66],[3.478,22.02],[4.328,13.65],[5.116,3.083],[5.47,0]],"totImpulseNs":113.5,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":22.17,"burnTimeS":5.3,"caseInfo":"RMS-29/120","certOrg":"National Association of Rocketry","commonName":"G25","dataFiles":3,"delays":"4,6,8,10","designation":"G25W","diameter":29,"impulseClass":"G","infoUrl":"http://nar.org/SandT/pdf/Aerotech/G25.pdf","length":124,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":41.18,"motorId":"5f4294d20002310000000052","propInfo":"White Lightning","propWeightG":62.5,"samples":[[0,0],[0.01,38.05],[0.029,21.77],[0.11,30.48],[0.239,35.77],[0.496,40.7],[0.568,42.12],[0.592,45.43],[0.749,46.19],[0.997,45.71],[1.255,44.2],[1.498,39.94],[1.999,31.42],[2.501,23.09],[3.006,14.2],[3.503,7.288],[3.999,4.07],[4.371,1.988],[4.414,0]],"totImpulseNs":117.5,"totalWeightG":121,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":30.09,"burnTimeS":3.27,"caseInfo":"RMS-29/40-120","certOrg":"National Association of Rocketry","commonName":"G33","dataFiles":2,"delays":"5,7","designation":"G33","diameter":29,"impulseClass":"G","infoUrl":"http://nar.org/SandT/pdf/Aerotech/G33.pdf","length":124,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":50.92,"motorId":"5f4294d20002310000000053","propWeightG":72.2,"samples":[[0,0],[0.027,22.64],[0.061,42.2],[0.117,47.35],[0.243,46.68],[0.34,46.34],[0.438,47.38],[0.48,50.92],[0.508,46.36],[0.543,47.73],[0.662,45.69],[0.851,42.28],[1.039,41.27],[1.116,42.99],[1.193,39.23],[1.221,42.31],[1.312,38.89],[1.326,40.61],[1.479,38.22],[1.675,35.16],[1.843,32.77],[1.878,36.89],[1.899,32.09],[1.997,30.38],[2.13,26.62],[2.263,23.55],[2.444,19.11],[2.591,13.98],[2.752,8.502],[2.892,4.743],[3.053,2.014],[3.27,0]],"totImpulseNs":98.39,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":34.65,"burnTimeS":2.91,"caseInfo":"SU 29x98","certOrg":"National Association of Rocketry","commonName":"G35","dataFiles":2,"delays":"4,7","designation":"G35","diameter":29,"impulseClass":"G","infoUrl":"http://nar.org/SandT/pdf/Aerotech/G35.pdf","length":98,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":76.22,"motorId":"5f4294d20002310000000054","propWeightG":50,"samples":[[0,0],[0.01,39.14],[0.02,76.22],[0.05,64.46],[0.13,57.54],[0.21,57.53],[0.24,64.43],[0.25,57.06],[0.35,56.12],[0.43,55.2],[0.48,57.49],[0.51,52.41],[0.55,53.33],[0.76,50.54],[0.91,50.06],[1.11,44.96],[1.32,41.24],[1.55,35.68],[1.6,36.13],[1.63,33.36],[1.67,34.28],[1.8,30.12],[2,25.02],[2.14,21.32],[2.23,19.46],[2.3,15.77],[2.41,9.76],[2.53,6.52],[2.65,3.74],[2.74,1.88],[2.91,0]],"totImpulseNs":100.8,"type":"SU","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":35,"burnTimeS":3.9,"caseInfo":"SU 29x165","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G35","dataFiles":2,"delays":"6,10","designation":"G35","diameter":29,"impulseClass":"G","length":165,"manufacturer":"Ellis Mountain","manufacturerAbbrev":"Ellis","maxThrustN":56,"motorId":"5f4294d20002310000000055","propWeightG":62,"samples":[[0,0],[0.01,51.12],[0.04,57.55],[0.08,43.78],[2.73,28.16],[3.28,28.16],[3.78,6.73],[4,0]],"totImpulseNs":124,"type":"SU","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":37,"burnTimeS":3.1,"caseInfo":"SU 24x181","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G37","dataFiles":2,"delays":"6,10,P","designation":"G37","diameter":24,"impulseClass":"G","length":181,"manufacturer":"Ellis Mountain","manufacturerAbbrev":"Ellis","maxThrustN":68,"motorId":"5f4294d20002310000000056","propWeightG":62,"samples":[[0,0],[0.02318,69.59],[0.1623,55.93],[0.3323,48.01],[0.5023,44.92],[0.9969,40.96],[1.499,38.76],[2.002,34.35],[2.496,28.19],[2.751,18.5],[2.998,5.285],[3.1,0]],"totImpulseNs":110.5,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":40.22,"burnTimeS":2.18,"certOrg":"National Association of Rocketry","commonName":"G38","dataFiles":2,"delays":"4,7","designation":"G38FJ","diameter":29,"impulseClass":"G","infoUrl":"http://nar.org/SandT/pdf/Aerotech/G38.pdf","length":124,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":78.19,"motorId":"5f4294d20002310000000057","propInfo":"Black Max","propWeightG":55,"samples":[[0,0],[0.024,52.93],[0.171,48.42],[0.497,45.05],[1,42.23],[1.279,39.98],[1.498,36.6],[1.783,30.41],[2.011,23.09],[2.272,10.13],[2.467,3.941],[2.64,0]],"totImpulseNs":87.68,"totalWeightG":126,"type":"SU","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":37.17,"burnTimeS":3.06,"caseInfo":"SU 29x124","certOrg":"National Association of Rocketry","commonName":"G40","dataFiles":1,"delays":"4,7","designation":"G40W","diameter":29,"impulseClass":"G","infoUrl":"http://nar.org/SandT/pdf/PML/G40W.pdf","length":124,"manufacturer":"Public Missiles, Ltd.","manufacturerAbbrev":"PML","maxThrustN":66.85,"motorId":"5f4294d20002310000000058","propWeightG":62.4,"samples":[[0,0],[0.015,40],[0.037,66.48],[0.066,60.84],[0.161,55.77],[0.308,55.77],[0.447,54.09],[0.549,52.39],[0.637,51.27],[0.857,52.96],[1.018,52.39],[1.172,50.14],[1.362,46.76],[1.611,41.69],[1.691,41.13],[1.845,34.37],[1.999,30.42],[2.372,23.1],[2.585,13.52],[2.738,6.761],[3.039,0]],"totImpulseNs":113.7,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":40.88,"burnTimeS":2.38,"certOrg":"National Association of Rocketry","commonName":"G40","dataFiles":2,"delays":"4,6,7,8,10","designation":"G40W","diameter":29,"impulseClass":"G","infoUrl":"http://nar.org/SandT/pdf/Aerotech/G40.pdf","length":124,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":84.51,"motorId":"5f4294d20002310000000059","propInfo":"White Lightning","propWeightG":53.8,"samples":[[0,0],[0.024,74.33],[0.057,67],[0.252,65.88],[0.5,63.06],[0.765,60.25],[1,54.05],[1.25,47.3],[1.502,36.6],[1.751,25.34],[1.999,12.95],[2.121,3.941],[2.3,0]],"totImpulseNs":97.14,"totalWeightG":123,"type":"SU","updatedOn":"2022-01-22"},{"availability":"regular","avgThrustN":53.68,"burnTimeS":1.51,"caseInfo":"RMS-29/100","certOrg":"National Association of Rocketry","commonName":"G54","dataFiles":2,"delays":"4,6,8,10","designation":"G54W","diameter":29,"impulseClass":"G","infoUrl":"http://nar.org/SandT/pdf/Aerotech/G54.pdf","length":124,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":81.64,"motorId":"5f4294d2000231000000005a","propInfo":"White Lightning","propWeightG":46,"samples":[[0,0],[0.018,10.95],[0.042,39.22],[0.083,66.89],[0.14,72.08],[0.223,74.96],[0.25,76.69],[0.282,80.16],[0.315,79.58],[0.336,79.58],[0.354,81.64],[0.365,77.84],[0.374,80.72],[0.389,76.69],[0.455,76.12],[0.523,74.39],[0.639,70.93],[0.722,67.47],[0.82,64],[0.897,58.82],[0.992,51.89],[1.084,43.82],[1.197,34.02],[1.268,28.25],[1.283,29.99],[1.295,27.1],[1.328,23.64],[1.366,16.72],[1.399,9.803],[1.435,4.612],[1.51,0]],"totImpulseNs":81.05,"totalWeightG":136.5,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":49,"burnTimeS":2.44,"caseInfo":"SU 24x177","certOrg":"National Association of Rocketry","commonName":"G55","dataFiles":2,"delays":"5,6,7,8,9,10,11,13,15","designation":"G55","diameter":24,"impulseClass":"G","infoUrl":"http://nar.org/SandT/pdf/Aerotech/G55.pdf","length":177,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":84.65,"motorId":"5f4294d2000231000000005b","propWeightG":62.5,"samples":[[0,0],[0.009,81.14],[0.014,84.65],[0.034,80.56],[0.084,77.06],[0.13,71.82],[0.18,72.42],[0.206,68.92],[0.342,69.54],[0.483,68.99],[0.513,66.66],[0.543,68.42],[0.664,66.11],[0.876,66.16],[0.901,64.42],[0.997,65.03],[1.062,66.79],[1.088,63.88],[1.148,63.89],[1.158,66.81],[1.173,63.31],[1.209,62.74],[1.325,61.59],[1.395,59.28],[1.456,57.54],[1.486,58.13],[1.587,52.32],[1.708,40.09],[1.824,26.11],[1.95,15.63],[2.112,7.498],[2.258,3.446],[2.44,0]],"totImpulseNs":119.6,"type":"SU","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":49,"burnTimeS":2.44,"caseInfo":"SU 24x177","certOrg":"National Association of Rocketry","commonName":"G55","dataFiles":1,"delays":"5,10,15","designation":"G55","diameter":24,"impulseClass":"G","infoUrl":"http://nar.org/SandT/pdf/RocketVision/G55.pdf","length":177,"manufacturer":"Rocketvision Flight-Star","manufacturerAbbrev":"RV","maxThrustN":84.65,"motorId":"5f4294d2000231000000005c","propWeightG":62.5,"samples":[[0,0],[0.004,74.65],[0.012,85.21],[0.054,81.69],[0.128,73.24],[0.182,73.94],[0.231,69.72],[0.508,69.01],[0.868,67.61],[1.037,65.49],[1.07,67.61],[1.091,64.08],[1.14,63.38],[1.161,66.9],[1.19,62.68],[1.269,62.68],[1.397,59.16],[1.496,57.04],[1.583,52.11],[1.653,45.07],[1.719,38.03],[1.76,31.69],[1.831,24.65],[1.901,19.01],[1.988,12.68],[2.083,9.155],[2.169,5.634],[2.252,3.521],[2.36,0]],"totImpulseNs":119.6,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":60.3,"burnTimeS":2.23,"caseInfo":"Pro38-1G","certOrg":"Canadian Association of Rocketry","commonName":"G60","dataFiles":2,"delays":"5,7,9,11,14","designation":"134G60-14A","diameter":38,"impulseClass":"G","length":127,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":87.8,"motorId":"5f4294d2000231000000005d","propInfo":"Red Lightning","propWeightG":68.3,"samples":[[0,0],[0.043,65.22],[0.13,74.91],[0.218,84.6],[0.305,83.96],[0.393,81.98],[0.48,81.96],[0.568,81.14],[0.655,80.53],[0.743,79.92],[0.83,78.87],[0.918,76.67],[1.005,75.12],[1.094,73.73],[1.182,71.31],[1.27,68.78],[1.357,66.85],[1.445,65.11],[1.532,63.53],[1.62,61.23],[1.707,59.25],[1.795,57.11],[1.882,51.67],[1.97,18.56],[2.057,2.667],[2.146,1.47],[2.234,0]],"totImpulseNs":134.2,"totalWeightG":206,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":61,"burnTimeS":2.04,"caseInfo":"RMS-38/120","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G61","dataFiles":2,"delays":"4,6,8,10","designation":"G61W","diameter":38,"impulseClass":"G","length":106,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":63.2,"motorId":"5f4294d2000231000000005e","propInfo":"White Lightning","propWeightG":62.3,"samples":[[0,0],[0.008,3.083],[0.054,71.35],[0.089,72.23],[0.174,75.31],[0.216,78.39],[0.247,79.72],[0.502,81.04],[0.753,77.07],[1.001,72.67],[1.132,66.94],[1.252,55.93],[1.503,38.32],[1.754,10.13],[1.905,3.523],[2.04,0]],"totImpulseNs":110.5,"totalWeightG":194,"type":"reload","updatedOn":"2021-06-13"},{"availability":"OOP","avgThrustN":63,"burnTimeS":1.3,"caseInfo":"29X304.8MM (75CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G63","dataFiles":2,"designation":"G63","diameter":29,"impulseClass":"G","length":305,"manufacturer":"Sky Ripper Systems","manufacturerAbbrev":"SkyR","maxThrustN":157.6,"motorId":"5f4294d2000231000000005f","propWeightG":5,"samples":[[0,0],[0.01,121.9],[0.03,142.7],[0.07,156.6],[0.09,133.6],[0.13,100.6],[0.18,114.8],[0.2,105.2],[0.27,104.9],[0.35,93.38],[0.41,83.85],[0.5,67.95],[0.65,61.99],[0.83,61.99],[0.93,40.14],[1.09,17.09],[1.18,13.78],[1.29,5.56],[1.3,0]],"totImpulseNs":85,"totalWeightG":210,"type":"hybrid","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":56.84,"burnTimeS":2.09,"caseInfo":"RMS-29/40-120","certOrg":"National Association of Rocketry","commonName":"G64","dataFiles":1,"delays":"4,5,6,7,8,10","designation":"G64W","diameter":29,"impulseClass":"G","infoUrl":"http://nar.org/SandT/pdf/Aerotech/G64.pdf","length":124,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":98.31,"motorId":"5f4294d20002310000000060","propInfo":"White Lightning","propWeightG":62.5,"samples":[[0,0],[0.01,9.564],[0.02,60.05],[0.03,77.49],[0.04,90.32],[0.05,98.81],[0.06,103],[0.07,106],[0.08,108.1],[0.09,108.1],[0.1,106.4],[0.15,104.1],[0.25,103.3],[0.35,100.4],[0.45,95.44],[0.55,90.5],[0.65,85.05],[0.75,79.26],[0.95,67.66],[1.15,53.08],[1.35,38.15],[1.55,23.72],[1.75,11.46],[1.95,4.63],[2.15,1.452],[2.35,0.1101],[2.44,0]],"totImpulseNs":118.8,"totalWeightG":151,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":67,"burnTimeS":1.642,"caseInfo":"RMS-38/120","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G67","dataFiles":2,"delays":"4,6,8,10","designation":"G67R","diameter":38,"impulseClass":"G","length":106,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d20002310000000061","propInfo":"Redline","propWeightG":60,"samples":[[0,0],[0.04,4.92],[0.05,6.56],[0.06,9.84],[0.07,16.41],[0.08,32.81],[0.1,49.22],[0.13,68.08],[0.15,76.29],[0.18,80.39],[0.24,82.85],[0.26,85.31],[0.31,87.77],[0.51,89.41],[0.53,91.05],[0.56,87.77],[0.6,86.95],[0.61,88.59],[0.67,86.95],[0.69,85.31],[0.71,86.95],[0.72,85.31],[0.74,86.13],[0.77,85.31],[0.81,82.03],[0.95,78.75],[1.05,73.82],[1.43,53.32],[1.5,52.5],[1.52,50.86],[1.54,45.94],[1.62,11.48],[1.64,0]],"totImpulseNs":110,"totalWeightG":201,"type":"reload","updatedOn":"2021-06-13"},{"availability":"OOP","avgThrustN":69,"burnTimeS":1.8,"caseInfo":"29X406.4MM (125CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G69","dataFiles":2,"designation":"G69","diameter":29,"impulseClass":"G","length":406,"manufacturer":"Sky Ripper Systems","manufacturerAbbrev":"SkyR","maxThrustN":137.9,"motorId":"5f4294d20002310000000062","propWeightG":5,"samples":[[0,0],[0.01,99.8],[0.04,137.5],[0.07,103],[0.13,94.13],[0.3,80.09],[0.49,72.2],[0.57,70.72],[0.65,71.96],[0.74,80.83],[0.81,81.81],[0.94,73.43],[1.01,74.42],[1.06,85.02],[1.11,83.78],[1.19,62.1],[1.24,60.62],[1.32,65.3],[1.37,64.81],[1.43,52.98],[1.49,48.55],[1.55,44.85],[1.64,28.59],[1.85,17.74],[1.99,14.29],[2,0]],"totImpulseNs":128,"totalWeightG":236,"type":"hybrid","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":69.2,"burnTimeS":1.75,"caseInfo":"Pro38-1G","certOrg":"Canadian Association of Rocketry","commonName":"G69","dataFiles":4,"delays":"5,7,9,11,14","designation":"117G69-14A","diameter":38,"impulseClass":"G","length":127,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":103.9,"motorId":"5f4294d20002310000000063","propInfo":"Skidmark","propWeightG":61.5,"samples":[[0,0],[0.015,49.37],[0.023,79.41],[0.035,91.87],[0.064,82.61],[0.099,52.41],[0.166,57.04],[0.228,59.28],[0.375,64.23],[1.297,69.02],[1.453,68.86],[1.533,67.75],[1.589,65.19],[1.686,58.64],[1.735,42.82],[1.781,26.36],[1.816,13.9],[1.89,5.432],[1.954,1.278],[1.969,0]],"sparky":true,"totImpulseNs":121.1,"totalWeightG":197,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":75,"burnTimeS":2.43,"caseInfo":"RMS-29/180","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G75","dataFiles":3,"delays":"4,6,8,10","designation":"G75J","diameter":29,"impulseClass":"G","length":194,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":70.3,"motorId":"5f4294d20002310000000064","propInfo":"Blackjack","propWeightG":104.3,"samples":[[0,0],[0.047,65.7],[0.143,68.56],[0.239,72.14],[0.334,73.26],[0.43,73.96],[0.526,75.04],[0.622,75.7],[0.718,75.03],[0.814,77.89],[0.909,76.18],[1.005,76.85],[1.101,75.73],[1.197,78.85],[1.293,78.67],[1.389,76.46],[1.484,76.44],[1.58,74.98],[1.676,72.66],[1.772,69.46],[1.868,62.12],[1.964,39.09],[2.059,19.7],[2.155,7.554],[2.251,2.062],[2.347,0.382],[2.443,0]],"totImpulseNs":135.6,"totalWeightG":233,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":77,"burnTimeS":1.364,"caseInfo":"RMS-29/120","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G77","dataFiles":2,"delays":"4,6,8,10","designation":"G77R","diameter":29,"impulseClass":"G","length":150,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d20002310000000065","propInfo":"Redline","propWeightG":58,"samples":[[0,0],[0.0132,14.83],[0.0243,32.45],[0.0331,46.35],[0.0375,52.84],[0.0463,56.55],[0.0617,59.33],[0.258,73.24],[0.6548,87.15],[0.8709,89],[0.8885,85.29],[1.025,86.22],[1.047,84.36],[1.071,86.22],[1.1,84.36],[1.133,85.29],[1.195,76.95],[1.21,76.02],[1.237,65.82],[1.261,43.57],[1.29,27.81],[1.332,12.05],[1.363,4.635],[1.4,0]],"totImpulseNs":105,"totalWeightG":165,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":79.9,"burnTimeS":1.63,"caseInfo":"Pro38-1G","certOrg":"Canadian Association of Rocketry","commonName":"G79","dataFiles":3,"delays":"4,6,8,10,13","designation":"129G79-13A","diameter":38,"impulseClass":"G","length":125,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":95.85,"motorId":"5f4294d20002310000000066","propInfo":"Smoky Sam","propWeightG":82.7,"samples":[[0,0],[0.001,9.07],[0.031,54.45],[0.071,76.33],[0.091,70.95],[0.111,65.92],[0.171,68.59],[0.201,70.64],[0.301,74.89],[0.401,80.39],[0.501,83.76],[0.601,86.45],[0.701,88.65],[0.811,91.4],[0.901,93.06],[1.001,93.99],[1.101,95.81],[1.201,90.7],[1.301,86.92],[1.401,81.98],[1.501,76.54],[1.551,58.92],[1.601,16.41],[1.631,5.16],[1.631,0]],"totImpulseNs":129,"totalWeightG":226,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":79,"burnTimeS":1.42,"caseInfo":"RMS-29/120","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G79","dataFiles":2,"delays":"4,6,8,10","designation":"G79W","diameter":29,"impulseClass":"G","length":150,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":100.7,"motorId":"5f4294d20002310000000067","propInfo":"White Lightning","propWeightG":62,"samples":[[0,0],[0.015,7.157],[0.074,91.94],[0.09,91.39],[0.114,84.78],[0.145,84.23],[0.201,89.19],[0.291,94.69],[0.4,98.54],[0.6,99.64],[0.708,96.89],[0.8,93.04],[0.915,85.33],[1,77.62],[1.085,71.02],[1.175,68.27],[1.199,44.59],[1.28,22.02],[1.36,4.955],[1.42,0]],"totImpulseNs":108.6,"totalWeightG":157,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":77.6,"burnTimeS":1.7,"certOrg":"National Association of Rocketry","commonName":"G80","dataFiles":4,"delays":"6,7,8,9,10,11,12,13,14","designation":"G80T","diameter":29,"impulseClass":"G","infoUrl":"https://www.nar.org/SandT/pdf/Aerotech/G80-20071207.pdf","length":124,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":108.5,"motorId":"5f4294d20002310000000068","propInfo":"Blue Thunder","propWeightG":62.5,"samples":[[0,0],[0.013,89.05],[0.018,101.6],[0.029,105.4],[0.047,102.9],[0.104,100],[0.19,102.3],[0.268,104.9],[0.306,104.3],[0.352,105.8],[0.41,104.9],[0.432,106.7],[0.512,105.6],[0.563,107],[0.591,104.5],[0.62,106.3],[0.715,103.2],[0.76,103.4],[0.806,101.4],[0.848,102],[1.2,88.38],[1.243,77.87],[1.269,57.95],[1.302,44.08],[1.329,34.01],[1.367,26.4],[1.398,22.82],[1.433,20.59],[1.48,21.7],[1.508,20.81],[1.584,13.2],[1.604,11.63],[1.652,11.19],[1.683,5.37],[1.701,0]],"totImpulseNs":136.6,"totalWeightG":127.9,"type":"SU","updatedOn":"2021-01-19"},{"availability":"OOP","avgThrustN":77.5,"burnTimeS":1.5,"caseInfo":"SU 29x124","certOrg":"National Association of Rocketry","commonName":"G80","dataFiles":1,"delays":"4,7","designation":"G80T","diameter":29,"impulseClass":"G","infoUrl":"http://nar.org/SandT/pdf/PML/G80T.pdf","length":124,"manufacturer":"Public Missiles, Ltd.","manufacturerAbbrev":"PML","maxThrustN":105.2,"motorId":"5f4294d20002310000000069","propWeightG":57.4,"samples":[[0,0],[0.007,82.75],[0.018,104.8],[0.051,104.8],[0.095,97.71],[0.245,94.19],[0.458,95.07],[0.6,93.31],[0.86,84.51],[1.003,76.58],[1.139,69.54],[1.252,57.22],[1.303,51.06],[1.34,37.85],[1.38,19.37],[1.424,7.923],[1.461,2.641],[1.497,0]],"totImpulseNs":116.3,"type":"SU","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":80,"burnTimeS":1.4,"caseInfo":"SU 29x140","certOrg":"National Association of Rocketry","commonName":"G80","dataFiles":2,"delays":"4,7,10","designation":"G80","diameter":29,"impulseClass":"G","length":140,"manufacturer":"Roadrunner Rocketry","manufacturerAbbrev":"Roadrunner","maxThrustN":114,"motorId":"5f4294d2000231000000006a","propInfo":"Rapid propellant","propWeightG":54.7,"samples":[[0,0],[0.012,63.56],[0.028,84.08],[0.057,89.56],[0.119,96.03],[0.206,102.5],[0.242,104.4],[0.297,106.9],[0.356,109.8],[0.422,111.8],[0.483,111.3],[0.558,112.6],[0.622,112.8],[0.683,112.1],[0.739,109.1],[0.796,102],[0.863,90.49],[0.901,82.75],[0.935,72.41],[0.976,59.87],[1.018,49.83],[1.028,44.32],[1.042,39.8],[1.073,28.27],[1.113,18.23],[1.17,11.18],[1.218,4.636],[1.31,0]],"totImpulseNs":108,"totalWeightG":135,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":101,"burnTimeS":1.43,"caseInfo":"38 16 S PVC (140CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G100","dataFiles":2,"designation":"G100-PVC","diameter":38,"impulseClass":"G","length":406,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":230,"motorId":"5f4294d2000231000000006b","propWeightG":93,"samples":[[0,0],[0.001,182.8],[0.2001,177.6],[0.6073,132.8],[0.9876,53.45],[1.431,0]],"totImpulseNs":146,"totalWeightG":511,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":101,"burnTimeS":1,"caseInfo":"RMS-29/100","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G101","dataFiles":1,"delays":"4,6,8,10,12,14","designation":"G101T","diameter":29,"impulseClass":"G","length":125,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":102.3,"motorId":"5f4294d2000231000000006c","propInfo":"Blue Thunder","propWeightG":46,"samples":[[0,0],[0.01,35.29],[0.02,63.97],[0.02,78.09],[0.03,84.71],[0.04,89.96],[0.06,93.96],[0.12,97.26],[0.17,99.14],[0.21,101.7],[0.27,104.1],[0.31,104.6],[0.36,103.6],[0.4,103.4],[0.45,101],[0.51,99.27],[0.53,94.41],[0.56,93.09],[0.64,87.35],[0.76,78.53],[0.8,75.88],[0.88,68.82],[0.89,65.73],[0.9,61.32],[0.91,55.15],[0.93,35.73],[0.94,32.65],[0.95,22.5],[0.98,10.59],[1,5.29],[1.05,0]],"totImpulseNs":85,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":104,"burnTimeS":1,"caseInfo":"RMS-29/100","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G104","dataFiles":2,"delays":"4,6,8,10","designation":"G104T","diameter":29,"impulseClass":"G","length":125,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":113.8,"motorId":"5f4294d2000231000000006d","propInfo":"Blue Thunder","propWeightG":43.9,"samples":[[0,0],[0.0067,125.3],[0.0471,123.5],[0.0856,122],[0.1019,121.4],[0.1462,121.2],[0.1837,120.8],[0.2029,120.5],[0.2385,118.8],[0.2644,117.2],[0.2798,116.9],[0.3279,116.7],[0.3923,116.7],[0.4298,116.1],[0.4615,114.1],[0.5067,110.2],[0.5404,104.6],[0.576,96.2],[0.6067,89.56],[0.6817,78.87],[0.7692,67.96],[0.7865,64.92],[0.799,62.56],[0.8058,58.06],[0.8192,50.52],[0.8385,39.04],[0.8625,27.57],[0.8769,16.65],[0.9019,0]],"totImpulseNs":81.5,"totalWeightG":136,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":123,"burnTimeS":1.15,"caseInfo":"38 16 S HP (140CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G123","dataFiles":2,"designation":"G123-HP","diameter":38,"impulseClass":"G","length":406,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":413,"motorId":"5f4294d2000231000000006e","propWeightG":83,"samples":[[0,0],[0.002237,217.2],[0.006711,400],[0.02013,220.7],[0.915,72.41],[0.9553,37.93],[1.15,0]],"totImpulseNs":142,"totalWeightG":511,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":125,"burnTimeS":1.16,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G125","dataFiles":2,"designation":"G125","diameter":38,"impulseClass":"G","length":406,"manufacturer":"Sky Ripper Systems","manufacturerAbbrev":"SkyR","motorId":"5f4294d2000231000000006f","samples":[[0,0],[0.01,346.9],[0.04,325.7],[0.07,324.6],[0.08,415.6],[0.09,219.6],[0.13,194.8],[0.2,177.8],[0.4,157.1],[0.6,131.9],[0.8,88.31],[1,42.44],[1.09,14.64],[1.2,0]],"totImpulseNs":145,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":130,"burnTimeS":0.86,"caseInfo":"38 16 M PVC (140CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G130","dataFiles":2,"designation":"G130-PVC","diameter":38,"impulseClass":"G","length":406,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":706,"motorId":"5f4294d20002310000000070","propWeightG":93,"samples":[[0,0],[0.001,662.1],[0.01554,448.3],[0.02449,241.4],[0.6431,41.38],[0.861,0]],"totImpulseNs":100,"totalWeightG":516,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":221,"burnTimeS":0.53,"caseInfo":"38 16 F HP (90CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G234","dataFiles":2,"designation":"G234-HP","diameter":38,"impulseClass":"G","length":414,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":606.5,"motorId":"5f4294d20002310000000071","propWeightG":110,"samples":[[0,0],[0.001695,245.4],[0.09732,540.6],[0.1834,526.9],[0.2025,191.6],[0.2371,143.7],[0.2606,136.9],[0.533,0]],"totImpulseNs":118,"totalWeightG":544,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":288,"burnTimeS":0.25,"caseInfo":"38 16 F PVC (90CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G300","dataFiles":2,"designation":"G300-PVC","diameter":38,"impulseClass":"G","length":406,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":689,"motorId":"5f4294d20002310000000072","propWeightG":215,"samples":[[0,0],[0.001119,602.2],[0.04978,814.4],[0.1007,670.7],[0.1141,266.9],[0.1588,239.5],[0.25,0]],"totImpulseNs":100,"totalWeightG":535,"type":"hybrid","updatedOn":"2022-01-08"},{"availability":"OOP","avgThrustN":45,"burnTimeS":6,"caseInfo":"SU 38x194","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H45","dataFiles":2,"delays":"6,7,8,9,10,11,13,15","designation":"H45W","diameter":38,"impulseClass":"H","length":194,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":102,"motorId":"5f4294d20002310000000073","propInfo":"White Lightning","propWeightG":197.4,"samples":[[0,0],[0.141,62.55],[0.424,63.5],[0.707,65.91],[0.992,68.37],[1.276,69.31],[1.559,68.52],[1.843,67.23],[2.127,65.7],[2.411,63.15],[2.695,59.21],[2.979,55.6],[3.264,50.79],[3.547,45.24],[3.83,39.84],[4.115,34.56],[4.399,29.21],[4.682,24.72],[4.967,20.62],[5.251,17.48],[5.534,14.5],[5.818,12.7],[6.102,10.79],[6.386,9.229],[6.67,7.754],[6.954,6.075],[7.239,0]],"totImpulseNs":289,"totalWeightG":294.8,"type":"SU","updatedOn":"2021-06-13"},{"availability":"OOP","avgThrustN":48,"burnTimeS":4.4,"caseInfo":"SU 38x172","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H48","dataFiles":2,"delays":"8,P","designation":"H48","diameter":38,"impulseClass":"H","length":172,"manufacturer":"Ellis Mountain","manufacturerAbbrev":"Ellis","maxThrustN":101,"motorId":"5f4294d20002310000000074","propWeightG":145,"samples":[[0,0],[0.05,101.5],[0.1,101.5],[0.21,92.18],[0.46,86.48],[0.74,83.38],[1,80],[1.49,74.57],[1.99,68.36],[2.48,63.18],[2.99,56.45],[3.2,34.18],[3.5,18],[3.69,13.46],[4,11],[4.36,7.77],[4.4,0]],"totImpulseNs":249,"totalWeightG":292,"type":"SU","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":50,"burnTimeS":5,"caseInfo":"SU 29x279","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H50","dataFiles":2,"delays":"6,10","designation":"H50","diameter":29,"impulseClass":"H","length":279,"manufacturer":"Ellis Mountain","manufacturerAbbrev":"Ellis","maxThrustN":109,"motorId":"5f4294d20002310000000075","propWeightG":142,"samples":[[0,0],[0.01,63.67],[0.17,108.9],[0.27,94.9],[0.47,81.43],[0.79,71.02],[1.27,64.9],[1.97,60.61],[2.56,56.94],[3.01,52.04],[3.52,45.31],[3.97,34.9],[4.49,18.37],[4.97,4.9],[5.28,0]],"totImpulseNs":264,"type":"SU","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":55,"burnTimeS":2.45,"caseInfo":"SU 29x191","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H55","dataFiles":2,"delays":"6,8,10,12,14","designation":"H55W","diameter":29,"impulseClass":"H","length":191,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":113.3,"motorId":"5f4294d20002310000000076","propInfo":"White Lightning","propWeightG":99.7,"samples":[[0,0],[0.052,92.75],[0.159,98.02],[0.268,95.82],[0.375,96.16],[0.482,97.15],[0.591,96.93],[0.699,95.92],[0.806,94.45],[0.914,92],[1.022,88.76],[1.129,86.97],[1.236,84.07],[1.345,80.17],[1.453,74.34],[1.56,64.99],[1.668,46.38],[1.776,32.84],[1.883,25.73],[1.991,19.92],[2.099,16.23],[2.207,13.06],[2.315,10.45],[2.422,7.7],[2.53,5.696],[2.639,3.979],[2.747,0]],"totImpulseNs":162.3,"totalWeightG":188.2,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":70,"burnTimeS":3.6,"caseInfo":"29 h 136cc","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H70","dataFiles":1,"designation":"H70","diameter":29,"impulseClass":"H","length":457,"manufacturer":"R.A.T.T. Works","manufacturerAbbrev":"RATT","maxThrustN":204.3,"motorId":"5f4294d20002310000000077","propWeightG":145.2,"samples":[[0,0],[0.051,124.1],[0.156,134.9],[0.261,127],[0.367,115.9],[0.473,110.3],[0.578,108.6],[0.683,105.7],[0.789,104.1],[0.894,101.5],[1,98.47],[1.105,93.81],[1.21,90.54],[1.316,85.22],[1.421,74.35],[1.527,57.74],[1.632,44.02],[1.738,34.55],[1.843,27.99],[1.948,22.69],[2.054,19.06],[2.159,15.66],[2.265,12.9],[2.37,11.33],[2.475,10.11],[2.581,8.591],[2.688,0]],"totImpulseNs":207.5,"totalWeightG":352,"type":"hybrid","updatedOn":"2021-06-13"},{"availability":"OOP","avgThrustN":72,"burnTimeS":3.16,"certOrg":"Canadian Association of Rocketry","commonName":"H70","dataFiles":1,"designation":"240NS-H70","diameter":38,"impulseClass":"H","length":464,"manufacturer":"Propulsion Polymers","manufacturerAbbrev":"PP","maxThrustN":171,"motorId":"5f4294d20002310000000078","propWeightG":318.3,"samples":[[0,0],[0.05,170.9],[0.09,122.3],[0.37,106.8],[0.74,97.9],[1.11,93.4],[1.48,89],[1.84,84.5],[2.21,77.1],[2.33,74],[2.58,41.5],[2.95,23.7],[3.32,15.6],[3.69,0]],"totImpulseNs":237,"totalWeightG":626.6,"type":"hybrid","updatedOn":"2021-06-13"},{"availability":"OOP","avgThrustN":70,"burnTimeS":2,"caseInfo":"SU 29x229","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H70","dataFiles":2,"delays":"6,8,10,12,14","designation":"H70W","diameter":29,"impulseClass":"H","length":229,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":174,"motorId":"5f4294d20002310000000079","propInfo":"White Lightning","propWeightG":126,"samples":[[0,0],[0.055,114.8],[0.169,131.4],[0.283,126.9],[0.397,127.1],[0.51,127.3],[0.625,125.9],[0.739,124.9],[0.852,122],[0.967,119],[1.08,115.1],[1.194,108.4],[1.308,102.3],[1.422,96.1],[1.535,86.95],[1.65,75.7],[1.764,62.4],[1.877,48.13],[1.992,36.86],[2.105,28.07],[2.219,21.59],[2.333,16.89],[2.447,12.69],[2.56,9.681],[2.675,6.818],[2.79,4.488],[2.904,0]],"totImpulseNs":215,"totalWeightG":224,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":73,"burnTimeS":2.55,"caseInfo":"RMS-38/240","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H73","dataFiles":2,"delays":"4,6,8,10","designation":"H73J","diameter":38,"impulseClass":"H","length":152,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":97.1,"motorId":"5f4294d2000231000000007a","propInfo":"Blackjack","propWeightG":142.7,"samples":[[0,0],[0.056,49.25],[0.172,82],[0.287,82.13],[0.403,84.6],[0.52,86.88],[0.635,88.89],[0.751,89.65],[0.867,91.34],[0.982,92.98],[1.099,94.57],[1.215,94.64],[1.33,93.55],[1.446,91.45],[1.561,88.19],[1.678,82.44],[1.794,77.4],[1.909,70.77],[2.025,61.17],[2.141,51.16],[2.257,38.54],[2.373,21.56],[2.489,12.21],[2.604,7.327],[2.72,3.706],[2.836,1.777],[2.953,0]],"totImpulseNs":185.6,"totalWeightG":309.1,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":78,"burnTimeS":2.75,"caseInfo":"29X520MM","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H78","dataFiles":2,"designation":"H78","diameter":29,"impulseClass":"H","length":523,"manufacturer":"Sky Ripper Systems","manufacturerAbbrev":"SkyR","maxThrustN":150.4,"motorId":"5f4294d2000231000000007b","propWeightG":5,"samples":[[0,0],[0.01,138.2],[0.08,150.1],[0.12,142.7],[0.15,132.3],[0.22,130.5],[0.29,90.3],[0.34,88.27],[0.4,86.81],[0.61,86.52],[0.72,81.59],[0.76,71.72],[0.86,64.46],[1.01,63.3],[1.18,62.42],[1.28,60.39],[1.5,57.49],[1.8,58.36],[1.89,59.23],[2.01,55.46],[2.21,36.29],[2.36,22.94],[2.54,13.36],[2.72,9.58],[2.75,0]],"totImpulseNs":172.9,"totalWeightG":284,"type":"hybrid","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":97,"burnTimeS":2.23,"caseInfo":"RMS-29/240","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H97","dataFiles":2,"delays":"4,6,8,10","designation":"H97J","diameter":29,"impulseClass":"H","length":238,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":111.5,"motorId":"5f4294d2000231000000007c","propInfo":"Blackjack","propWeightG":137.1,"samples":[[0,0],[0.045,89.41],[0.136,100.3],[0.228,100.5],[0.32,102],[0.411,102.8],[0.503,103.5],[0.595,101.7],[0.686,103.1],[0.778,103.3],[0.87,102.6],[0.961,103.4],[1.053,101],[1.145,101.2],[1.236,99.86],[1.328,98.42],[1.42,96.83],[1.511,95.03],[1.603,93.24],[1.695,93.48],[1.786,88.07],[1.878,64.36],[1.97,30.26],[2.061,8.691],[2.153,1.399],[2.245,0.525],[2.336,0]],"totImpulseNs":177.3,"totalWeightG":277.8,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":96.9,"burnTimeS":2.56,"certOrg":"Canadian Association of Rocketry","commonName":"H100","dataFiles":1,"designation":"246H100-P","diameter":38,"impulseClass":"H","length":403,"manufacturer":"West Coast Hybrids","manufacturerAbbrev":"WCH","maxThrustN":174.9,"motorId":"5f4294d2000231000000007d","propWeightG":145.6,"samples":[[0,0],[0.017,32.44],[0.168,168],[0.206,169.3],[0.217,166.7],[0.324,139.7],[0.423,137.1],[0.484,134.6],[0.548,130.4],[0.582,127.2],[0.643,125.3],[1.002,115],[1.037,114.3],[1.092,114],[1.159,113.1],[1.243,108.6],[1.269,104.7],[1.335,96.67],[1.373,93.46],[1.408,91.86],[1.472,89.61],[1.512,86.39],[1.547,82.86],[1.582,77.72],[1.75,54.92],[1.868,41.43],[2.071,25.05],[2.5,0]],"totImpulseNs":266,"totalWeightG":450,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":112,"burnTimeS":2.92,"caseInfo":"RMS-38/360","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H112","dataFiles":2,"delays":"4,6,8,10","designation":"H112J","diameter":38,"impulseClass":"H","length":191,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":121.7,"motorId":"5f4294d2000231000000007e","propInfo":"Blackjack","propWeightG":191.2,"samples":[[0,0],[0.064,85.43],[0.194,101.9],[0.324,101.9],[0.454,102.8],[0.584,104.5],[0.715,103.8],[0.845,103.4],[0.975,104.3],[1.106,104.9],[1.236,104.4],[1.367,102.8],[1.497,102.2],[1.627,100],[1.757,98.34],[1.888,94.56],[2.018,89.02],[2.148,82.86],[2.279,77.69],[2.409,72.37],[2.54,67.04],[2.67,59.76],[2.8,37.62],[2.93,14.46],[3.06,4.642],[3.192,1.818],[3.323,0]],"totImpulseNs":261.1,"totalWeightG":379.5,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":121,"burnTimeS":1.85,"caseInfo":"38 20 S HP (185CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H121","dataFiles":2,"designation":"H121-HP","diameter":38,"impulseClass":"H","length":516,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":294,"motorId":"5f4294d2000231000000007f","propWeightG":110,"samples":[[0,0],[0.002237,251.7],[0.04027,265.5],[0.07383,203.4],[0.4004,179.3],[0.6018,134.5],[1.089,127.6],[1.403,93.1],[1.62,37.93],[1.85,0]],"totImpulseNs":225,"totalWeightG":612,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":123,"burnTimeS":1.76,"caseInfo":"RMS-38/240","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H123","dataFiles":1,"delays":"4,6,8,10","designation":"H123W","diameter":38,"impulseClass":"H","length":152,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":174.2,"motorId":"5f4294d20002310000000080","propInfo":"White Lightning","propWeightG":128.7,"samples":[[0,0],[0.047,96.76],[0.143,146.3],[0.239,150.7],[0.334,152.5],[0.43,151.2],[0.526,149.9],[0.622,150.2],[0.718,149.2],[0.814,144.9],[0.909,143.5],[1.005,141.4],[1.101,135.1],[1.198,125.3],[1.295,114],[1.391,101.6],[1.486,90.17],[1.582,78.69],[1.678,66.36],[1.774,54.26],[1.87,46.87],[1.966,38.19],[2.061,22.74],[2.157,13.48],[2.253,7.587],[2.35,5.252],[2.447,0]],"totImpulseNs":223.6,"totalWeightG":275,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":124,"burnTimeS":1.7,"caseInfo":"H 38/220","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H124","dataFiles":2,"designation":"H124","diameter":38,"impulseClass":"H","length":533,"manufacturer":"Sky Ripper Systems","manufacturerAbbrev":"SkyR","maxThrustN":335.3,"motorId":"5f4294d20002310000000081","propWeightG":142,"samples":[[0,0],[0.01,198.2],[0.02,300.8],[0.03,314.3],[0.03,316],[0.04,305.4],[0.08,280.4],[0.11,221.4],[0.69,168.4],[0.78,180.8],[0.81,158.6],[0.84,167.6],[0.89,152.3],[0.92,120.7],[0.95,123.5],[1.06,82.23],[1.35,48.36],[1.55,25.63],[1.6,21.88],[1.62,23.66],[1.66,18.58],[1.67,12.46],[1.68,0]],"totImpulseNs":224.5,"totalWeightG":664,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":125,"burnTimeS":2.6,"caseInfo":"SU 29x330","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H125","dataFiles":2,"delays":"6,8,10,12,14","designation":"H125W","diameter":29,"impulseClass":"H","length":330,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":307,"motorId":"5f4294d20002310000000082","propInfo":"White Lightning","propWeightG":187.9,"samples":[[0,0],[0.053,276],[0.161,241.5],[0.27,216.3],[0.378,199.5],[0.488,188.8],[0.597,182.3],[0.705,175.9],[0.814,169.4],[0.922,162.3],[1.031,154.3],[1.141,143.9],[1.249,133.5],[1.357,123],[1.466,113.1],[1.575,101.8],[1.684,88.42],[1.793,73.53],[1.901,60.42],[2.009,46.64],[2.119,36.78],[2.228,29.55],[2.336,23.64],[2.445,18.79],[2.553,14.73],[2.663,10.97],[2.772,0]],"totImpulseNs":299.4,"totalWeightG":322.6,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":128,"burnTimeS":1.27,"caseInfo":"RMS-29/180","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H128","dataFiles":2,"delays":"4,6,8,10","designation":"H128W","diameter":29,"impulseClass":"H","length":194,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":168.7,"motorId":"5f4294d20002310000000083","propInfo":"White Lightning","propWeightG":94.2,"samples":[[0,0],[0.024,102.4],[0.074,175.2],[0.125,181.4],[0.176,179.3],[0.226,181.4],[0.277,186.1],[0.328,190.5],[0.378,189.5],[0.429,186.2],[0.48,184.1],[0.53,180.3],[0.581,174.1],[0.632,172],[0.683,169.4],[0.734,166],[0.784,161.9],[0.835,157.3],[0.886,153.1],[0.936,152],[0.988,139.9],[1.039,87.86],[1.089,40.86],[1.14,14.33],[1.191,4.33],[1.242,1.55],[1.293,0]],"totImpulseNs":172.9,"totalWeightG":206,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":141,"burnTimeS":1.7,"caseInfo":"38 20 S PVC (185CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H141","dataFiles":2,"designation":"H141-PVC","diameter":38,"impulseClass":"H","length":508,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":297,"motorId":"5f4294d20002310000000084","propWeightG":125,"samples":[[0,0],[0.002237,265.5],[0.1119,262.1],[1.201,106.9],[1.26,55.17],[1.356,27.59],[1.7,0]],"totImpulseNs":247,"totalWeightG":612,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":142.4,"burnTimeS":1.73,"caseInfo":"Pro38-2G","certOrg":"Canadian Association of Rocketry","commonName":"H143","dataFiles":2,"delays":"4,6,8,10,13","designation":"247H143-13A","diameter":38,"impulseClass":"H","length":185,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":167,"motorId":"5f4294d20002310000000085","propInfo":"Smoky Sam","propWeightG":165.4,"samples":[[0,0],[0.06,114.7],[0.19,134.3],[0.4,149.6],[0.6,158.1],[0.8,163.8],[1,167],[1.21,160.9],[1.4,148.8],[1.6,128.6],[1.63,117.3],[1.65,106.3],[1.7,35.63],[1.73,0]],"totImpulseNs":247,"totalWeightG":347,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":155,"burnTimeS":1.53,"caseInfo":"38/240","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H144","dataFiles":2,"delays":"5,8,10,13,17","designation":"H144-LW","diameter":38,"impulseClass":"H","infoUrl":"https://www.lokiresearch.com/images/Documents/38mm%20White.pdf","length":190,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":254,"motorId":"5f4294d20002310000000086","propInfo":"Loki White","propWeightG":126,"samples":[[0,0],[0.02,209],[0.04,247.6],[0.05,241.2],[0.1,247.6],[0.15,244.4],[0.2,237.9],[0.25,231.5],[0.3,228.3],[0.4,215.3],[0.45,212.4],[0.5,204.5],[0.6,194.4],[0.7,189.7],[0.8,170.4],[0.9,154.3],[1,127.8],[1.1,109.3],[1.2,80.4],[1.3,64.6],[1.4,44.6],[1.5,32.1],[1.6,0]],"totImpulseNs":239.3,"totalWeightG":336,"type":"reload","updatedOn":"2021-07-24"},{"availability":"regular","avgThrustN":148,"burnTimeS":1.392,"caseInfo":"RMS-38/240","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H148","dataFiles":2,"delays":"4,6,8,10","designation":"H148R","diameter":38,"impulseClass":"H","length":152,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d20002310000000087","propInfo":"Redline","propWeightG":122,"samples":[[0,0],[0.027,77.23],[0.088,174.3],[0.148,185],[0.208,190.5],[0.268,192.5],[0.327,192],[0.388,188.8],[0.448,187.5],[0.509,182.7],[0.57,178.2],[0.63,172.9],[0.69,169.6],[0.75,164.5],[0.81,158.4],[0.87,153],[0.93,146.8],[0.991,139.4],[1.053,132],[1.112,123.3],[1.173,112.6],[1.233,104.7],[1.292,97.66],[1.353,94.93],[1.413,60.64],[1.474,13.01],[1.535,0]],"totImpulseNs":206,"totalWeightG":309.1,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":153,"burnTimeS":1.75,"caseInfo":"Pro38-2G","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H153","dataFiles":2,"designation":"H153","diameter":38,"impulseClass":"H","length":185,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":188.3,"motorId":"5f4294d20002310000000088","propWeightG":143.9,"samples":[[0,0],[0.13,149.4],[0.17,173.7],[0.23,171.8],[0.39,179.9],[0.6,188.3],[0.81,180.4],[1.01,168.3],[1.18,160.9],[1.29,149.6],[1.41,136.9],[1.6,105.4],[1.69,23.58],[1.75,0]],"totImpulseNs":258,"totalWeightG":303.9,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":155,"burnTimeS":1.69,"caseInfo":"H 38/220","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H155","dataFiles":2,"designation":"H155","diameter":38,"impulseClass":"H","length":533,"manufacturer":"Sky Ripper Systems","manufacturerAbbrev":"SkyR","maxThrustN":416.8,"motorId":"5f4294d20002310000000089","propWeightG":142,"samples":[[0,0],[0.03,308.8],[0.05,362.2],[0.09,252.4],[1.02,102.1],[1.08,120],[1.45,33.45],[1.66,19.06],[1.68,12.59],[1.69,0]],"totImpulseNs":228.7,"totalWeightG":664,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":165,"burnTimeS":1,"caseInfo":"RMS-29/180","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H165","dataFiles":2,"delays":"4,6,8,10","designation":"H165R","diameter":29,"impulseClass":"H","length":194,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d2000231000000008a","propInfo":"Redline","propWeightG":90,"samples":[[0,0],[0.018,55.05],[0.059,157.3],[0.101,168.5],[0.144,173.2],[0.186,179.2],[0.229,183.9],[0.271,187.9],[0.314,188.1],[0.356,188.9],[0.399,190.5],[0.441,187.3],[0.484,189.2],[0.525,186.5],[0.566,185.5],[0.609,180.8],[0.651,177.7],[0.694,170.6],[0.736,167.2],[0.779,158.8],[0.821,155.7],[0.864,153.3],[0.906,136.3],[0.949,73.53],[0.991,20.67],[1.034,4.448],[1.076,0]],"totImpulseNs":165,"totalWeightG":201.6,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":180,"burnTimeS":1.3,"caseInfo":"RMS-29/240","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H180","dataFiles":2,"delays":"4,6,8,10","designation":"H180W","diameter":29,"impulseClass":"H","length":238,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":228.5,"motorId":"5f4294d2000231000000008b","propInfo":"White Lightning","propWeightG":123.9,"samples":[[0,0],[0.024,149.4],[0.075,222.3],[0.127,222.3],[0.178,227.8],[0.229,235],[0.281,238.2],[0.333,240.3],[0.384,243.1],[0.435,240.8],[0.487,240.7],[0.539,236.3],[0.59,236.8],[0.642,234.9],[0.694,232.8],[0.745,229.2],[0.796,228.8],[0.848,231.9],[0.899,225.9],[0.95,188.3],[1.002,134.7],[1.054,78.94],[1.105,34.56],[1.156,15.48],[1.208,7.279],[1.26,3.585],[1.313,0]],"totImpulseNs":217.7,"totalWeightG":252,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":215.4,"burnTimeS":1,"caseInfo":"RMS-29/240","certOrg":"National Association of Rocketry","commonName":"H210","dataFiles":2,"delays":"4,6,8,10","designation":"H210R","diameter":29,"impulseClass":"H","infoUrl":"https://nar.org/SandT/pdf/Aerotech/H210.pdf","length":238,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":275.7,"motorId":"5f4294d2000231000000008c","propInfo":"Redline","propWeightG":106.4,"samples":[[0,0],[0.019,105.9],[0.059,211.3],[0.099,219.8],[0.139,229.6],[0.179,235.1],[0.22,241.6],[0.26,242.7],[0.3,245.3],[0.341,249.1],[0.381,253.4],[0.421,258.6],[0.461,260.2],[0.502,258],[0.543,259.2],[0.583,256.6],[0.623,252.4],[0.663,245.1],[0.704,219.9],[0.744,209.3],[0.784,200.6],[0.824,193.6],[0.865,184.3],[0.905,153.9],[0.945,58.24],[0.986,13.21],[1.027,0]],"totImpulseNs":215.4,"totalWeightG":246.4,"type":"reload","updatedOn":"2022-07-20"},{"availability":"regular","avgThrustN":211,"burnTimeS":0.97,"caseInfo":"38 20 M PVC (185CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H211","dataFiles":2,"designation":"H211-PVC","diameter":38,"impulseClass":"H","length":516,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":674,"motorId":"5f4294d2000231000000008d","propWeightG":125,"samples":[[0,0],[0.001119,531],[0.01902,634.5],[0.02237,593.1],[0.03356,544.8],[0.2964,317.2],[0.3132,186.2],[0.7438,96.55],[0.97,0]],"totImpulseNs":206,"totalWeightG":600,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":220,"burnTimeS":1,"caseInfo":"RMS-29/240","certOrg":"National Association of Rocketry","commonName":"H220","dataFiles":2,"delays":"4,6,8,10,12,14","designation":"H220T","diameter":29,"impulseClass":"H","infoUrl":"https://nar.org/SandT/pdf/Aerotech/H220.pdf","length":238,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":275.5,"motorId":"5f4294d2000231000000008e","propInfo":"Blue Thunder","propWeightG":106.4,"samples":[[0,0],[0.001,314.1],[0.101,236.6],[0.201,269.2],[0.301,261.1],[0.401,252.9],[0.721,252.9],[0.801,112.6],[0.901,9.78],[0.961,0]],"totImpulseNs":220,"totalWeightG":250,"type":"reload","updatedOn":"2022-07-20"},{"availability":"regular","avgThrustN":225,"burnTimeS":0.7,"caseInfo":"38 16 M HP (140CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H222","dataFiles":2,"designation":"H222-HP","diameter":38,"impulseClass":"H","length":407,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":619,"motorId":"5f4294d2000231000000008f","propWeightG":22,"samples":[[0,0],[0.001,684.3],[0.0312,657],[0.05357,574.8],[0.05917,349],[0.3478,260.1],[0.3657,191.6],[0.701,0]],"totImpulseNs":161,"totalWeightG":520,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":238,"burnTimeS":0.71,"caseInfo":"RMS-29/180","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H238","dataFiles":2,"delays":"4,6,8,10","designation":"H238T","diameter":29,"impulseClass":"H","length":194,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":263.4,"motorId":"5f4294d20002310000000090","propInfo":"Blue Thunder","propWeightG":83.4,"samples":[[0,0],[0.019,173.1],[0.059,206.9],[0.1,211],[0.141,214.4],[0.181,217.1],[0.222,219.3],[0.263,221],[0.303,225],[0.344,229.3],[0.384,229.3],[0.425,228.6],[0.466,226.6],[0.506,222.4],[0.547,219.2],[0.588,217.8],[0.628,213.3],[0.669,208.1],[0.709,201],[0.75,197],[0.791,151.4],[0.831,96.27],[0.872,59.48],[0.912,18.62],[0.953,7.986],[0.995,3.697],[1.036,0]],"totImpulseNs":165.5,"totalWeightG":196,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":242,"burnTimeS":1.06,"caseInfo":"RMS-38/240","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H242","dataFiles":3,"delays":"4,6,8,10","designation":"H242T","diameter":38,"impulseClass":"H","length":152,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":276.6,"motorId":"5f4294d20002310000000091","propInfo":"Blue Thunder","propWeightG":114.7,"samples":[[0,0],[0.03,164.1],[0.093,197.5],[0.155,204.3],[0.218,209],[0.28,211.5],[0.343,211.3],[0.405,209.3],[0.468,208.4],[0.531,206.7],[0.595,204],[0.657,198.2],[0.72,192.1],[0.782,186.8],[0.845,180.8],[0.907,174.6],[0.97,165.6],[1.033,159.7],[1.097,151.7],[1.159,144.2],[1.222,138.6],[1.284,119.1],[1.347,69.06],[1.409,21.4],[1.472,3.473],[1.535,0.594],[1.599,0]],"totImpulseNs":231.7,"totalWeightG":264,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":238,"burnTimeS":0.9,"caseInfo":"38 20 M HP (185CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H246","dataFiles":2,"designation":"H246-HP","diameter":38,"impulseClass":"H","length":508,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":653,"motorId":"5f4294d20002310000000092","propWeightG":110,"samples":[[0,0],[0.001119,609.1],[0.0123,499.6],[0.5022,253.2],[0.5145,157.4],[0.9,0]],"totImpulseNs":222,"totalWeightG":598,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":268,"burnTimeS":1.19,"caseInfo":"RMS-29/360","certOrg":"National Association of Rocketry","commonName":"H268","dataFiles":2,"delays":"4,6,8,10","designation":"H268R","diameter":29,"impulseClass":"H","infoUrl":"https://nar.org/SandT/pdf/Aerotech/H268.pdf","length":333,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d20002310000000093","propInfo":"Redline","propWeightG":166,"samples":[[0,0],[0.022,268.1],[0.069,332.4],[0.116,312.4],[0.164,306.8],[0.211,305.8],[0.259,306.6],[0.306,312.5],[0.354,319.7],[0.401,321.2],[0.448,321],[0.495,321.2],[0.542,321.8],[0.59,323.3],[0.638,322.8],[0.685,307],[0.732,291.6],[0.779,277.7],[0.826,267.1],[0.874,257.5],[0.921,252.8],[0.969,222.6],[1.016,159.7],[1.064,108.7],[1.111,52.09],[1.159,15.57],[1.207,0]],"totImpulseNs":320,"totalWeightG":358.4,"type":"reload","updatedOn":"2022-07-20"},{"availability":"OOP","avgThrustN":275,"burnTimeS":1.1,"caseInfo":"SU 29x275","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H275","dataFiles":2,"designation":"H275","diameter":29,"impulseClass":"H","length":275,"manufacturer":"Ellis Mountain","manufacturerAbbrev":"Ellis","maxThrustN":641.6,"motorId":"5f4294d20002310000000094","propWeightG":163,"samples":[[0,0],[0.01236,792.8],[0.01546,356.7],[0.1978,312.7],[0.7975,268.7],[0.9119,255.4],[0.9923,123.3],[1.042,39.64],[1.1,0]],"totImpulseNs":293.5,"totalWeightG":255,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":252,"burnTimeS":1.15,"caseInfo":"38 28 F HP (370CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H277","dataFiles":2,"designation":"H277-HP","diameter":38,"impulseClass":"H","length":719,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":793,"motorId":"5f4294d20002310000000095","propWeightG":110,"samples":[[0,0],[0.001,765.5],[0.07483,703.4],[0.1196,337.9],[0.9182,179.3],[0.9585,75.86],[0.9965,41.38],[1.03,48.28],[1.151,0]],"totImpulseNs":292,"totalWeightG":710,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":259,"burnTimeS":0.62,"caseInfo":"38 20 F HP (185CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H300","dataFiles":2,"designation":"H300-HP","diameter":38,"impulseClass":"H","length":508,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":710,"motorId":"5f4294d20002310000000096","propWeightG":110,"samples":[[0,0],[0.001,558.6],[0.1162,717.2],[0.1263,269],[0.2158,248.3],[0.2874,241.4],[0.3355,227.6],[0.621,0]],"totImpulseNs":161,"totalWeightG":612,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":283,"burnTimeS":0.6,"caseInfo":"48 20 F PVC (185CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H303","dataFiles":2,"designation":"H303-PVC","diameter":38,"impulseClass":"H","length":508,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":752,"motorId":"5f4294d20002310000000097","propWeightG":125,"samples":[[0,0],[0.001,663.8],[0.04574,780.1],[0.1095,704.9],[0.1129,342.2],[0.1777,328.5],[0.1979,308],[0.601,0]],"totImpulseNs":172,"totalWeightG":589,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":321,"burnTimeS":0.95,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H340","dataFiles":2,"designation":"H340-SP","diameter":38,"impulseClass":"H","length":719,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":966,"motorId":"5f4294d20002310000000098","samples":[[0,0],[0.001,920.3],[0.08575,715.8],[0.1027,345.1],[0.6841,332.3],[0.7417,255.6],[0.7671,153.4],[0.951,0]],"totImpulseNs":304.5,"totalWeightG":816,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":500,"burnTimeS":0.634,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H500","dataFiles":3,"designation":"H500-LW","diameter":38,"impulseClass":"H","length":295,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","motorId":"5f4294d20002310000000099","propInfo":"Loki White","propWeightG":160,"samples":[[0,0],[0.001,189.3],[0.0116,534.7],[0.09977,539.5],[0.1995,544.2],[0.3028,553.7],[0.4026,548.9],[0.5046,544.2],[0.5847,435.4],[0.6195,9.464],[0.62,0]],"totImpulseNs":317,"totalWeightG":460,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":565,"burnTimeS":0.566,"caseInfo":"Pro38-3G","certOrg":"Canadian Association of Rocketry","commonName":"H565","dataFiles":2,"delays":"5,7,9,11,14","designation":"320H565-14A","diameter":38,"impulseClass":"H","length":244,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","motorId":"5f4294d2000231000000009a","propInfo":"Vmax","propWeightG":165,"samples":[[0,0],[0.01,106.9],[0.02,479.8],[0.03471,528.9],[0.05151,553.7],[0.07615,578.5],[0.1008,586.8],[0.1501,611.6],[0.2,607.1],[0.3,614.7],[0.4,616.6],[0.5,622.4],[0.51,645.3],[0.52,629],[0.53,535.2],[0.54,327.4],[0.55,148],[0.56,60.36],[0.57,0]],"totImpulseNs":319.8,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":651.4,"burnTimeS":0.339,"caseInfo":"RMS-38/240","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H669","dataFiles":2,"delays":"P","designation":"H669N","diameter":38,"impulseClass":"H","length":152,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":961.5,"motorId":"5f4294d2000231000000009b","propInfo":"Warp 9","propWeightG":98,"samples":[[0,0],[0.003,141],[0.006,523],[0.009,934],[0.012,1178],[0.016,926],[0.019,684],[0.022,487],[0.025,415],[0.028,622],[0.031,801],[0.0325,906],[0.034,866],[0.037,755],[0.04,737],[0.043,666],[0.047,737],[0.0485,802],[0.05,755],[0.053,791],[0.056,765],[0.059,755],[0.062,747],[0.069,737],[0.075,761],[0.082,755],[0.088,729],[0.093,741],[0.1,751],[0.2,703],[0.25,640],[0.3,586],[0.306,584],[0.309,576],[0.312,506],[0.318,292],[0.325,93],[0.329,0]],"totImpulseNs":221,"totalWeightG":252,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":999,"burnTimeS":0.3202,"caseInfo":"RMS-38/360","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H999","dataFiles":2,"delays":"P","designation":"H999N","diameter":38,"impulseClass":"H","length":203,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1710,"motorId":"5f4294d2000231000000009c","propInfo":"Warp 9","propWeightG":147,"samples":[[0,0],[0.003,204],[0.006,757],[0.009,1357],[0.012,1710],[0.016,1345],[0.019,995],[0.022,710],[0.025,606],[0.028,905],[0.031,1165],[0.0325,1311],[0.034,1258],[0.037,1098],[0.04,1072],[0.043,969],[0.047,1072],[0.0485,1166],[0.05,1098],[0.053,1160],[0.056,1117],[0.059,1103],[0.062,1093],[0.069,1076],[0.075,1110],[0.082,1105],[0.088,1065],[0.093,1082],[0.1,1092],[0.2,1022],[0.25,931],[0.3,853],[0.306,850],[0.309,838],[0.312,735],[0.318,435],[0.325,161],[0.329,0]],"totImpulseNs":319.9,"totalWeightG":331,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":76.33,"burnTimeS":8.26,"caseInfo":"SU 54x235","certOrg":"National Association of Rocketry","commonName":"I65","dataFiles":2,"designation":"I65W","diameter":54,"impulseClass":"I","infoUrl":"http://nar.org/SandT/pdf/Aerotech/I65.pdf","length":235,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":150.1,"motorId":"5f4294d2000231000000009d","propInfo":"White Lightning","propWeightG":369.7,"samples":[[0,0],[0.18,125.4],[0.544,139.3],[0.908,145.4],[1.273,148.3],[1.638,146.7],[2.002,139],[2.367,131.2],[2.731,123.3],[3.096,113.5],[3.46,102.4],[3.825,90.21],[4.19,78.08],[4.554,66.81],[4.919,55.78],[5.283,47.28],[5.648,39.15],[6.012,32.53],[6.377,27.07],[6.742,22.1],[7.106,18.09],[7.471,14.82],[7.835,12.1],[8.2,9.763],[8.565,7.875],[8.929,5.999],[9.294,0]],"totImpulseNs":630.5,"totalWeightG":761.6,"type":"SU","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":69,"burnTimeS":5,"caseInfo":"SU 29x406","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I69","dataFiles":2,"designation":"I69","diameter":29,"impulseClass":"I","length":406,"manufacturer":"Ellis Mountain","manufacturerAbbrev":"Ellis","maxThrustN":149,"motorId":"5f4294d2000231000000009e","propWeightG":236,"samples":[[0,0],[0.05,78.67],[0.1,149.7],[0.25,133.5],[0.49,111.5],[0.75,100],[1.07,93.18],[1.48,87.83],[2,82.49],[2.5,78],[2.99,73.32],[3.5,64.5],[3.99,48.88],[4.5,29.79],[4.99,9.17],[5.28,0]],"totImpulseNs":369,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":80,"burnTimeS":5.8,"caseInfo":"H 276 cc","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I80","dataFiles":1,"designation":"I80","diameter":29,"impulseClass":"I","length":730,"manufacturer":"R.A.T.T. Works","manufacturerAbbrev":"RATT","maxThrustN":104.4,"motorId":"5f4294d2000231000000009f","propWeightG":221.8,"samples":[[0,0],[0.093,84.1],[0.28,102.1],[0.469,118.7],[0.657,117.1],[0.846,114.8],[1.034,112.2],[1.222,109.8],[1.41,107.6],[1.599,105.9],[1.787,102.2],[1.976,100.4],[2.164,99.27],[2.352,96.27],[2.541,91.95],[2.729,89.38],[2.918,86.43],[3.105,54.54],[3.294,41.9],[3.482,33.37],[3.671,26.52],[3.859,21.32],[4.047,16.95],[4.235,14.39],[4.424,13.46],[4.612,12.78],[4.801,0]],"totImpulseNs":359.5,"totalWeightG":553,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":80,"burnTimeS":5.75,"certOrg":"Canadian Association of Rocketry","commonName":"I80","dataFiles":1,"designation":"460NS-I80","diameter":38,"impulseClass":"I","length":646,"manufacturer":"Propulsion Polymers","manufacturerAbbrev":"PP","maxThrustN":198.8,"motorId":"5f4294d200023100000000a0","propWeightG":332.4,"samples":[[0,0],[0.04,198.7],[0.08,158.4],[0.57,133.4],[0.9,114.5],[1.15,110],[1.73,108],[2.3,106],[2.88,104],[3.45,96.3],[3.75,66.7],[4.03,50],[4.6,35.6],[5.18,22.2],[5.75,0]],"totImpulseNs":460,"totalWeightG":842.4,"type":"hybrid","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":90,"burnTimeS":5.391,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I90","dataFiles":1,"designation":"I90L","diameter":29,"impulseClass":"I","length":921,"manufacturer":"R.A.T.T. Works","manufacturerAbbrev":"RATT","motorId":"5f4294d200023100000000a1","propWeightG":289.3,"samples":[[0,0],[0.127,137.7],[0.383,121.4],[0.64,117],[0.897,121.4],[1.154,118.4],[1.41,116.5],[1.668,114.8],[1.925,112.4],[2.181,110.3],[2.439,107.8],[2.696,105.7],[2.952,104.7],[3.209,102.8],[3.467,95.41],[3.723,68.28],[3.98,55],[4.237,43.62],[4.494,33.78],[4.751,31.7],[5.008,27.71],[5.265,24.88],[5.522,22.93],[5.779,21.38],[6.035,20.88],[6.293,18.64],[6.55,0]],"totImpulseNs":485.2,"totalWeightG":684.5,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":108.5,"burnTimeS":4.64,"certOrg":"Canadian Association of Rocketry","commonName":"I110","dataFiles":2,"designation":"499I110-P","diameter":38,"impulseClass":"I","length":606,"manufacturer":"West Coast Hybrids","manufacturerAbbrev":"WCH","maxThrustN":162.6,"motorId":"5f4294d200023100000000a2","propWeightG":327,"samples":[[0,0],[0.05,240],[0.38,200],[0.76,182],[1.14,160],[1.52,142],[1.9,125],[2.23,113],[2.66,71],[3.04,44],[3.42,29],[3.78,22],[4,0]],"totImpulseNs":499.7,"totalWeightG":824,"type":"hybrid","updatedOn":"2021-06-13"},{"availability":"OOP","avgThrustN":117,"burnTimeS":4.4,"caseInfo":"38/580","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I117","dataFiles":2,"designation":"I117","diameter":38,"impulseClass":"I","length":914,"manufacturer":"Sky Ripper Systems","manufacturerAbbrev":"SkyR","maxThrustN":435.6,"motorId":"5f4294d200023100000000a3","propWeightG":370,"samples":[[0,0],[0.01,203.4],[0.02,339.9],[0.02,358.8],[0.03,367.9],[0.03,361.5],[0.06,277.4],[0.08,277.1],[0.15,251],[0.27,256.1],[0.3,248.6],[0.42,194.8],[0.47,222.6],[1.35,174.8],[1.39,184],[1.79,150.1],[2.12,156.6],[3.42,54.16],[3.8,40],[4.2,17.22],[4.23,0]],"totImpulseNs":591.6,"totalWeightG":1133,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":119,"burnTimeS":3,"caseInfo":"38/400","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I119","dataFiles":2,"designation":"I119","diameter":38,"impulseClass":"I","length":711,"manufacturer":"Sky Ripper Systems","manufacturerAbbrev":"SkyR","maxThrustN":454.4,"motorId":"5f4294d200023100000000a4","propWeightG":264,"samples":[[0,0],[0.001,192.1],[0.011,262.2],[0.021,341.5],[0.031,338.4],[0.061,221.3],[0.071,195.9],[0.111,189.2],[0.151,202.2],[0.181,233.4],[0.471,230.3],[0.991,200.9],[1.181,165.4],[1.271,172.1],[1.481,162.6],[2.181,74.18],[2.921,24.69],[2.971,10.98],[3.101,10.06],[3.121,0]],"totImpulseNs":407,"totalWeightG":967,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":130,"burnTimeS":3.62,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I130","dataFiles":1,"designation":"300CC098J-I130","diameter":54,"impulseClass":"I","length":546,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d200023100000000a5","propWeightG":298,"samples":[[0,0],[0.05,200],[0.1,223],[0.5,205],[1,187],[1.5,169],[2,151],[2.25,143],[2.4,89],[2.5,71],[3,40],[3.5,18],[4,0]],"totImpulseNs":470.6,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":130,"burnTimeS":4.43,"caseInfo":"SU 38x330","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I130","dataFiles":2,"designation":"I130","diameter":38,"impulseClass":"I","length":330,"manufacturer":"Ellis Mountain","manufacturerAbbrev":"Ellis","maxThrustN":258.7,"motorId":"5f4294d200023100000000a6","propWeightG":308,"samples":[[0,0],[0.01546,266.5],[0.0541,160.8],[0.5023,169.6],[2.233,180.6],[2.488,149.7],[2.991,136.5],[3.493,77.07],[4.011,26.43],[4.43,0]],"totImpulseNs":597.6,"type":"SU","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":132,"burnTimeS":4.83,"caseInfo":"SU 38x335","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I132","dataFiles":2,"delays":"6,8,10,12,14","designation":"I132W","diameter":38,"impulseClass":"I","length":335,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":512.9,"motorId":"5f4294d200023100000000a7","propInfo":"White Lightning","propWeightG":376.4,"samples":[[0,0],[0.096,204],[0.29,174.2],[0.484,168.9],[0.679,170.8],[0.874,173],[1.069,174.3],[1.264,174.6],[1.458,174.4],[1.652,174.6],[1.847,173],[2.042,169.2],[2.236,164.3],[2.431,157.1],[2.626,149.6],[2.821,138.4],[3.016,124.2],[3.21,107.6],[3.404,89.78],[3.599,71.75],[3.794,55.12],[3.989,42.26],[4.183,31.37],[4.378,21.98],[4.573,14.39],[4.768,8.794],[4.962,0]],"totImpulseNs":610.7,"totalWeightG":512.1,"type":"SU","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":134,"burnTimeS":5.15,"caseInfo":"SU 38x355","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I134","dataFiles":2,"designation":"I134","diameter":38,"impulseClass":"I","length":355,"manufacturer":"Ellis Mountain","manufacturerAbbrev":"Ellis","maxThrustN":268.8,"motorId":"5f4294d200023100000000a8","propWeightG":300.5,"samples":[[0,0],[0.1,268.8],[0.2,138],[1,116],[2,102],[3,85],[4,67],[4.65,16.46],[4.82,6.86],[5.07,6.86],[5.15,0]],"totImpulseNs":444.9,"totalWeightG":581,"type":"SU","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":136,"burnTimeS":3.728,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I136","dataFiles":1,"designation":"300CC098J2-I136","diameter":54,"impulseClass":"I","length":546,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d200023100000000a9","propWeightG":283,"samples":[[0,0],[0.155,256.2],[0.5,232.8],[1,212.8],[1.5,196],[2,175],[2.21,163.3],[2.4,100.9],[2.5,83.81],[3,42.47],[3.5,19.75],[3.7,15.26],[3.8,0]],"totImpulseNs":507,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":145,"burnTimeS":3.731,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I145","dataFiles":1,"designation":"300CC098JFX-I145FX","diameter":54,"impulseClass":"I","length":546,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d200023100000000aa","propWeightG":298,"samples":[[0,0],[0.057,256.2],[0.204,253.4],[0.497,236.5],[1.002,208.3],[1.205,199.9],[1.376,211.2],[1.482,197.1],[2.003,177.4],[2.125,168.9],[2.5,90.09],[2.997,45.05],[3.282,16.89],[3.7,0]],"totImpulseNs":541,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":147,"burnTimeS":3.5,"caseInfo":"38/400","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I147","dataFiles":2,"designation":"I147","diameter":38,"impulseClass":"I","length":711,"manufacturer":"Sky Ripper Systems","manufacturerAbbrev":"SkyR","maxThrustN":497.3,"motorId":"5f4294d200023100000000ab","propWeightG":264,"samples":[[0,0],[0.001,194.5],[0.021,366.7],[0.031,390.1],[0.031,392.3],[0.051,359],[0.071,217.4],[0.101,207.7],[0.381,241.5],[1.071,183.8],[2.331,141.3],[2.511,100],[2.751,71.51],[3.321,34.49],[3.891,17.18],[4.431,7.17],[4.451,0]],"totImpulseNs":519.5,"totalWeightG":967,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":150,"burnTimeS":2.75,"caseInfo":"38X285.7 38X314(D)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I150","dataFiles":2,"delays":"20,P","designation":"I150","diameter":38,"impulseClass":"I","length":229,"manufacturer":"Ellis Mountain","manufacturerAbbrev":"Ellis","maxThrustN":155.5,"motorId":"5f4294d200023100000000ac","propWeightG":171.8,"samples":[[0,0],[0.05,101.3],[0.152,159.2],[0.255,169.7],[0.358,179.6],[0.46,188.2],[0.564,193.4],[0.667,204.5],[0.769,212],[0.872,212.9],[0.975,208.1],[1.077,196.6],[1.18,191],[1.283,186.1],[1.386,181.8],[1.49,177.9],[1.592,175.9],[1.695,173.7],[1.798,170.7],[1.9,161.8],[2.003,149.1],[2.106,124.9],[2.208,68.39],[2.311,20.12],[2.415,7.794],[2.518,4.464],[2.621,0]],"totImpulseNs":346.2,"totalWeightG":422,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":154,"burnTimeS":2.99,"caseInfo":"RMS-38/480","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I154","dataFiles":2,"delays":"4,6,8,10","designation":"I154J","diameter":38,"impulseClass":"I","length":241,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":170.5,"motorId":"5f4294d200023100000000ad","propInfo":"Blackjack","propWeightG":252.8,"samples":[[0,0],[0.066,120.4],[0.199,150.6],[0.332,151.7],[0.466,156.8],[0.599,150.3],[0.732,150.6],[0.866,145.1],[0.999,144.5],[1.133,145.2],[1.268,145.9],[1.401,141.7],[1.534,142.8],[1.668,141.2],[1.801,141],[1.934,137.8],[2.068,128.4],[2.202,122.3],[2.336,112],[2.47,105.3],[2.603,96.6],[2.736,90.47],[2.87,57.43],[3.003,20.49],[3.136,4.707],[3.271,2.966],[3.405,0]],"totImpulseNs":378,"totalWeightG":491.9,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":155,"burnTimeS":3.5,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I155","dataFiles":2,"designation":"I155-HP","diameter":38,"impulseClass":"I","length":719,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":355,"motorId":"5f4294d200023100000000ae","propWeightG":110,"samples":[[0,0],[0.01119,222.4],[2.713,150.6],[2.83,82.12],[2.964,58.17],[3.5,0]],"totImpulseNs":541,"totalWeightG":725,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":155,"burnTimeS":3.13,"certOrg":"Canadian Association of Rocketry","commonName":"I160","dataFiles":1,"delays":"20,P","designation":"484NS-I160","diameter":38,"impulseClass":"I","length":646,"manufacturer":"Propulsion Polymers","manufacturerAbbrev":"PP","maxThrustN":299,"motorId":"5f4294d200023100000000af","propWeightG":307.7,"samples":[[0,0],[0.04,298.9],[0.08,272.5],[0.32,264.7],[0.65,241.3],[0.97,218],[1.29,194.6],[1.61,179],[2,163.5],[2.26,93.4],[2.58,62.3],[2.9,31.1],[3.23,0]],"totImpulseNs":484,"totalWeightG":856.4,"type":"hybrid","updatedOn":"2021-06-13"},{"availability":"OOP","avgThrustN":160,"burnTimeS":3.5,"caseInfo":"38X336.6 38X365(D)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I160","dataFiles":2,"designation":"I160","diameter":38,"impulseClass":"I","length":280,"manufacturer":"Ellis Mountain","manufacturerAbbrev":"Ellis","maxThrustN":265.3,"motorId":"5f4294d200023100000000b0","propWeightG":231.9,"samples":[[0,0],[0.068,169.4],[0.206,199.4],[0.346,205.1],[0.485,206.1],[0.624,205.8],[0.763,204.1],[0.902,200.8],[1.042,200.9],[1.18,203.1],[1.319,204.2],[1.458,206.4],[1.598,210.1],[1.736,212.8],[1.875,211.2],[2.015,207.5],[2.154,189.8],[2.293,136.1],[2.431,52.31],[2.571,42.84],[2.71,41.8],[2.849,33.04],[2.987,24.61],[3.127,17.15],[3.267,7.477],[3.406,1.777],[3.546,0]],"totImpulseNs":462.7,"totalWeightG":516,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":161,"burnTimeS":1.82,"caseInfo":"RMS-38/360","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I161","dataFiles":2,"delays":"6,8,10,12,14","designation":"I161W","diameter":38,"impulseClass":"I","length":191,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":266.6,"motorId":"5f4294d200023100000000b1","propInfo":"White Lightning","propWeightG":193.2,"samples":[[0,0],[0.043,178.9],[0.131,206.8],[0.221,206.1],[0.31,205.2],[0.4,206.9],[0.49,210.6],[0.579,210.5],[0.669,211.6],[0.758,212.4],[0.848,212.1],[0.938,209.1],[1.027,202.3],[1.116,192.4],[1.204,179.5],[1.294,162.2],[1.383,148.4],[1.473,135.2],[1.563,120.1],[1.652,104],[1.742,87.96],[1.831,74.79],[1.921,54.36],[2.01,23.39],[2.1,7.332],[2.19,5.171],[2.279,0]],"totImpulseNs":328.7,"totalWeightG":366,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":169.2,"burnTimeS":2.26,"caseInfo":"Pro38-3G","certOrg":"Canadian Association of Rocketry","commonName":"I170","dataFiles":2,"delays":"5,7,9,11,14","designation":"382I170-14A","diameter":38,"impulseClass":"I","length":245,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":260.6,"motorId":"5f4294d200023100000000b2","propInfo":"Classic","propWeightG":187.5,"samples":[[0,0],[0.044,133.3],[0.134,230.1],[0.226,224.1],[0.318,223.7],[0.409,223.9],[0.501,225.3],[0.593,226.7],[0.684,229.4],[0.775,232],[0.866,233],[0.957,233.1],[1.049,232.7],[1.141,231.6],[1.232,227.7],[1.324,225.8],[1.416,221.2],[1.506,217.4],[1.597,211.7],[1.689,205.7],[1.78,198],[1.872,125],[1.964,61.85],[2.055,23.28],[2.147,2.066],[2.239,0.799],[2.33,0]],"totImpulseNs":382,"totalWeightG":392,"type":"reload","updatedOn":"2021-06-13"},{"availability":"OOP","avgThrustN":170,"burnTimeS":2,"caseInfo":"38-390","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I170","dataFiles":2,"designation":"I170S","diameter":38,"impulseClass":"I","length":314,"manufacturer":"Kosdon by AeroTech","manufacturerAbbrev":"KBA","maxThrustN":211,"motorId":"5f4294d200023100000000b3","propWeightG":182,"samples":[[0,0],[0.019,194.9],[0.131,190.5],[0.255,191.6],[0.513,199.3],[0.641,204.8],[0.753,207],[0.88,209.2],[1,208.1],[1.051,208.1],[1.147,207],[1.24,201.5],[1.391,198.2],[1.537,190.5],[1.707,181.7],[1.746,178.4],[1.781,174],[1.808,168.5],[1.854,132.1],[1.939,53.95],[2.005,22.02],[2.059,9.909],[2.13,0]],"totImpulseNs":374,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":195,"burnTimeS":2.1,"caseInfo":"RMS-38/600","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I195","dataFiles":3,"delays":"4,6,8,10","designation":"I195J","diameter":38,"impulseClass":"I","length":299,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":216.3,"motorId":"5f4294d200023100000000b4","propInfo":"Blackjack","propWeightG":301,"samples":[[0,0],[0.033,190.1],[0.103,354],[0.173,393.5],[0.243,414.8],[0.314,379.7],[0.383,364.6],[0.453,364.8],[0.524,357.2],[0.594,355.8],[0.664,355.6],[0.734,353.6],[0.804,339.9],[0.874,309.8],[0.944,275],[1.014,243.7],[1.084,218.1],[1.154,197.3],[1.224,173.7],[1.295,147],[1.365,116.5],[1.434,83.11],[1.505,51.01],[1.575,26.48],[1.645,13.93],[1.716,7.273],[1.786,0]],"totImpulseNs":426.1,"totalWeightG":572,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":200,"burnTimeS":1.65,"caseInfo":"RMS-29/360","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I200","dataFiles":2,"delays":"4,6,8,10","designation":"I200W","diameter":29,"impulseClass":"I","length":333,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":463.3,"motorId":"5f4294d200023100000000b5","propInfo":"White Lightning","propWeightG":187.3,"samples":[[0,0],[0.033,304],[0.103,273.5],[0.174,276.1],[0.245,271.6],[0.316,268.2],[0.386,258.4],[0.457,252.5],[0.528,246.6],[0.599,242.3],[0.67,237.7],[0.741,234.8],[0.811,233.2],[0.882,230.7],[0.953,225],[1.024,221.7],[1.095,214.5],[1.166,177.4],[1.236,154.2],[1.307,119.1],[1.378,91.59],[1.449,65.33],[1.52,32.88],[1.591,28.7],[1.661,22.21],[1.732,15.56],[1.803,0]],"totImpulseNs":324.5,"totalWeightG":357.5,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":205,"burnTimeS":2.288,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I205","dataFiles":1,"designation":"300CC125J-I205","diameter":54,"impulseClass":"I","length":546,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d200023100000000b6","propWeightG":298,"samples":[[0,0],[0.05,312],[0.1,347],[0.5,312],[1,258],[1.35,223],[1.6,125],[1.75,80],[2,45],[2.25,22],[2.75,0]],"totImpulseNs":469,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":205,"burnTimeS":1.88,"caseInfo":"Pro38-3G","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I205","dataFiles":2,"designation":"I205","diameter":38,"impulseClass":"I","length":244,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":236,"motorId":"5f4294d200023100000000b7","propWeightG":206.1,"samples":[[0,0],[0.1,181.5],[0.13,213.3],[0.2,210.1],[0.4,226.6],[0.6,235.8],[0.8,234],[1,232.8],[1.2,227.7],[1.4,216.8],[1.6,197.2],[1.74,183.1],[1.8,87.3],[1.88,0]],"totImpulseNs":380.9,"totalWeightG":402.2,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":182,"burnTimeS":2.72,"caseInfo":"38 36 M PVC (550CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I210","dataFiles":2,"designation":"I210-PVC","diameter":38,"impulseClass":"I","length":922,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":648,"motorId":"5f4294d200023100000000b8","propWeightG":125,"samples":[[0,0],[0.001,469],[0.4652,386.2],[0.4988,206.9],[2.255,110.3],[2.35,41.38],[2.406,13.79],[2.721,0]],"totImpulseNs":497,"totalWeightG":870,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":211,"burnTimeS":1.72,"caseInfo":"RMS-38/480","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I211","dataFiles":2,"delays":"6,8,10,12,14","designation":"I211W","diameter":38,"impulseClass":"I","length":248,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":399.5,"motorId":"5f4294d200023100000000b9","propInfo":"White Lightning","propWeightG":251.3,"samples":[[0,0],[0.044,257.3],[0.134,295.5],[0.226,296.1],[0.318,298.2],[0.408,295.1],[0.499,287.7],[0.591,282.6],[0.682,272.9],[0.773,267],[0.864,257.6],[0.955,250.5],[1.047,238.6],[1.138,228.6],[1.228,215.1],[1.32,198],[1.411,180.6],[1.502,161.3],[1.593,146.7],[1.684,134.5],[1.776,101.2],[1.867,52.69],[1.957,35.46],[2.049,24.32],[2.141,11.16],[2.232,4.587],[2.324,0]],"totImpulseNs":441.6,"totalWeightG":455,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":212.7,"burnTimeS":1.71,"caseInfo":"Pro38-3G","certOrg":"Canadian Association of Rocketry","commonName":"I212","dataFiles":2,"delays":"5,7,9,11,14","designation":"364I212-14A","diameter":38,"impulseClass":"I","length":244,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":255.2,"motorId":"5f4294d200023100000000ba","propInfo":"Smoky Sam","propWeightG":248.1,"samples":[[0,0],[0.04,189.7],[0.2,207.1],[0.4,222.4],[0.6,236.6],[0.8,249.6],[0.95,255.2],[1.01,250.2],[1.21,233.5],[1.4,209],[1.55,184],[1.6,168.1],[1.63,134.6],[1.69,25.86],[1.71,0]],"totImpulseNs":364,"totalWeightG":475,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":218,"burnTimeS":1.51,"caseInfo":"RMS-38/360","certOrg":"National Association of Rocketry","commonName":"I218","dataFiles":2,"delays":"4,6,8,10","designation":"I218R","diameter":38,"impulseClass":"I","infoUrl":"https://nar.org/SandT/pdf/Aerotech/I218.pdf","length":203,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d200023100000000bb","propInfo":"Redline","propWeightG":172.7,"samples":[[0,0],[0.027,136.1],[0.088,275],[0.148,281],[0.208,284.4],[0.268,284],[0.327,279.3],[0.388,277.8],[0.448,276.3],[0.509,269.4],[0.57,266],[0.63,261.9],[0.69,256.4],[0.75,250.6],[0.81,242.2],[0.87,234.6],[0.93,225.5],[0.991,216.2],[1.053,205.4],[1.112,193.2],[1.173,177.2],[1.233,161.3],[1.292,139.1],[1.353,96.08],[1.413,38.85],[1.474,5.978],[1.535,0]],"totImpulseNs":330,"totalWeightG":371.8,"type":"reload","updatedOn":"2022-07-23"},{"availability":"regular","avgThrustN":203,"burnTimeS":1.74,"caseInfo":"38 28 M PVC (370CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I221","dataFiles":2,"designation":"I221-PVC","diameter":38,"impulseClass":"I","length":719,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":433,"motorId":"5f4294d200023100000000bc","propWeightG":125,"samples":[[0,0],[0.001,482.8],[0.5044,358.6],[0.52,179.3],[1.493,103.4],[1.538,27.59],[1.741,0]],"totImpulseNs":355,"totalWeightG":710,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":222,"burnTimeS":2.338,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I222","dataFiles":1,"designation":"300CC125J2-I222","diameter":54,"impulseClass":"I","length":546,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d200023100000000bd","propWeightG":275,"samples":[[0,0],[0.037,394.1],[0.065,439.2],[0.12,450.5],[0.24,436.7],[0.5,411.2],[0.66,392.5],[1,338.3],[1.348,292.6],[1.432,259.3],[1.5,193.7],[1.67,117.1],[2,57.36],[2.3,22.36],[2.4,0]],"totImpulseNs":519,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":225,"burnTimeS":2.344,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I225","dataFiles":1,"designation":"300CC125JFX-I225FX","diameter":54,"impulseClass":"I","length":546,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d200023100000000be","propWeightG":298,"samples":[[0,0],[0.012,309.7],[0.037,343.5],[0.106,351.9],[0.244,354.7],[0.497,337.8],[0.749,320.9],[0.998,298.4],[1.254,273.1],[1.433,239.3],[1.502,194.3],[1.755,101.4],[1.999,53.49],[2.211,11.26],[2.37,0]],"totImpulseNs":527.5,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":230,"burnTimeS":3.07,"caseInfo":"38X387.4 38X416(D)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I230","dataFiles":2,"delays":"20,P","designation":"I230","diameter":38,"impulseClass":"I","length":331,"manufacturer":"Ellis Mountain","manufacturerAbbrev":"Ellis","maxThrustN":359.2,"motorId":"5f4294d200023100000000bf","propWeightG":292,"samples":[[0,0],[0.058,292.6],[0.178,317.7],[0.298,309.9],[0.418,305.2],[0.537,299.7],[0.657,298.2],[0.777,294.6],[0.897,293.8],[1.018,289.7],[1.138,288.2],[1.257,284.6],[1.377,281.1],[1.497,274.9],[1.617,269.8],[1.736,258.9],[1.856,242.2],[1.976,207.6],[2.097,136.7],[2.217,86.51],[2.336,74.32],[2.456,51.25],[2.576,45.55],[2.696,27.05],[2.816,6.382],[2.936,1.423],[3.057,0]],"totImpulseNs":540,"totalWeightG":610,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":240,"burnTimeS":2,"caseInfo":"Pro38-4G","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I240","dataFiles":2,"designation":"I240","diameter":38,"impulseClass":"I","length":302,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":279,"motorId":"5f4294d200023100000000c0","propWeightG":279,"samples":[[0,0],[0.043,265.3],[0.131,320.9],[0.221,314.1],[0.31,312.4],[0.399,313.6],[0.488,314.3],[0.577,321.1],[0.667,325.9],[0.755,327],[0.844,326.8],[0.933,324.3],[1.023,321.1],[1.111,317.4],[1.2,308.3],[1.29,300.6],[1.379,293.5],[1.468,283.4],[1.556,273.8],[1.646,259.7],[1.735,190.7],[1.824,124.1],[1.912,60.88],[2.002,26.97],[2.092,7.636],[2.181,2.296],[2.271,0]],"totImpulseNs":556,"totalWeightG":503.6,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":260,"burnTimeS":2.194,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I260","dataFiles":1,"designation":"440CC172J-I260","diameter":54,"impulseClass":"I","length":614,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d200023100000000c2","propWeightG":382.8,"samples":[[0,0],[0.03,339],[0.041,425.1],[0.12,413.9],[0.216,394.1],[0.354,391.3],[0.497,368.8],[0.749,346.3],[1.002,306.9],[1.36,264.6],[1.454,228],[1.502,180.2],[1.686,109.8],[2.003,50.68],[2.2,27.48],[2.3,0]],"totImpulseNs":570.4,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":271,"burnTimeS":1.44,"caseInfo":"AMW 38-390","certOrg":"National Association of Rocketry","commonName":"I271","dataFiles":2,"designation":"BB-38-390","diameter":38,"impulseClass":"I","length":258,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d200023100000000c3","propInfo":"Blue Baboon","propWeightG":188.7,"samples":[[0,0],[0.011,119.5],[0.035,213.9],[0.05,245.9],[0.074,262.7],[0.115,269.4],[0.225,267.7],[0.346,282.9],[0.465,296.4],[0.584,303.2],[0.727,311.5],[0.916,318.2],[1.054,325],[1.162,331.4],[1.201,326.7],[1.225,313.2],[1.242,286.2],[1.268,241],[1.294,188.9],[1.323,136.8],[1.346,87.56],[1.368,45.47],[1.392,18.52],[1.43,0]],"totImpulseNs":390,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":280,"burnTimeS":1,"caseInfo":"38-390","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I280","dataFiles":2,"designation":"I280F","diameter":38,"impulseClass":"I","length":314,"manufacturer":"Kosdon by AeroTech","manufacturerAbbrev":"KBA","maxThrustN":334,"motorId":"5f4294d200023100000000c4","propWeightG":182,"samples":[[0,0],[0.009,253.2],[0.055,255.4],[0.219,277.5],[0.482,301.7],[0.67,323.7],[0.735,330.3],[0.797,323.7],[1.001,297.3],[1.162,266.5],[1.205,259.8],[1.236,237.8],[1.363,50.65],[1.428,26.43],[1.5,0]],"totImpulseNs":382,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":284,"burnTimeS":1.94,"caseInfo":"RMS-38/600","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I284","dataFiles":3,"delays":"4,6,8,10","designation":"I284W","diameter":38,"impulseClass":"I","length":299,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":570.6,"motorId":"5f4294d200023100000000c5","propInfo":"White Lightning","propWeightG":315.9,"samples":[[0,0],[0.041,422],[0.125,448.6],[0.21,459],[0.295,451.9],[0.379,439.6],[0.465,427.4],[0.549,407.6],[0.633,399.7],[0.719,380],[0.803,368],[0.887,352],[0.973,342.1],[1.057,325.8],[1.142,306.9],[1.227,292],[1.311,267.3],[1.396,251.8],[1.481,227.5],[1.566,210.5],[1.65,168.3],[1.735,110.8],[1.82,71.04],[1.904,32.51],[1.99,17.54],[2.075,7.317],[2.16,0]],"totImpulseNs":607.3,"totalWeightG":555.5,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":285,"burnTimeS":1.91,"caseInfo":"Pro38-4G","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I285","dataFiles":2,"delays":"6,8,10,12,15","designation":"512I285-15A","diameter":38,"impulseClass":"I","length":302,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":350.6,"motorId":"5f4294d200023100000000c6","propInfo":"Classic","propWeightG":272.4,"samples":[[0,0],[0.1,350.6],[0.15,318.7],[0.2,312.3],[0.4,322.4],[0.6,330.6],[0.8,329.4],[1,319.6],[1.2,294.1],[1.4,271.9],[1.6,239.9],[1.66,178.1],[1.8,44.8],[1.91,0]],"totImpulseNs":510.1,"totalWeightG":505.9,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":285,"burnTimeS":1.47,"caseInfo":"RMS-38/480","certOrg":"National Association of Rocketry","commonName":"I285","dataFiles":2,"delays":"4,6,8,10","designation":"I285R","diameter":38,"impulseClass":"I","infoUrl":"https://nar.org/SandT/pdf/Aerotech/I285R.pdf","length":250,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d200023100000000c7","propInfo":"Redline","propWeightG":230.2,"samples":[[0,0],[0.027,171.4],[0.088,325.6],[0.148,341.7],[0.208,358.9],[0.268,373.7],[0.327,374],[0.388,368.4],[0.448,367.5],[0.507,361.9],[0.568,351.9],[0.628,346.1],[0.687,341],[0.749,329.4],[0.81,321.6],[0.87,310.9],[0.93,296],[0.99,283.7],[1.05,269.7],[1.11,253.4],[1.17,240.2],[1.23,224.1],[1.29,204.1],[1.35,118.7],[1.41,23.48],[1.471,2.046],[1.532,0]],"totImpulseNs":420,"totalWeightG":492.8,"type":"reload","updatedOn":"2022-07-23"},{"availability":"OOP","avgThrustN":285,"burnTimeS":1.49,"caseInfo":"AMW 38-390","certOrg":"National Association of Rocketry","commonName":"I285","dataFiles":2,"designation":"GG-38-390","diameter":38,"impulseClass":"I","length":258,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d200023100000000c8","propInfo":"Green Gorilla","propWeightG":206.5,"samples":[[0,0],[0.013,61.58],[0.032,119.3],[0.055,164.6],[0.076,191],[0.094,201],[0.139,212.3],[0.232,231.2],[0.357,258.9],[0.456,267.7],[0.592,279],[0.716,289.4],[0.841,291.2],[0.936,290.3],[1.051,285.2],[1.139,277.7],[1.204,280.2],[1.243,279],[1.265,268.9],[1.286,242.6],[1.319,187.2],[1.359,134.4],[1.387,86.7],[1.407,52.78],[1.428,31.41],[1.448,16.34],[1.465,5.026],[1.48,0]],"totImpulseNs":353,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":286.2,"burnTimeS":1.7,"caseInfo":"Pro38-4G","certOrg":"Canadian Association of Rocketry","commonName":"I287","dataFiles":2,"delays":"6,8,10,12,15","designation":"486I287-15A","diameter":38,"impulseClass":"I","length":302,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":344.2,"motorId":"5f4294d200023100000000c9","propInfo":"Smoky Sam","propWeightG":330.8,"samples":[[0,0],[0.05,275.9],[0.2,292.5],[0.41,309.2],[0.61,327.5],[0.8,341.7],[0.9,344.2],[1.01,331.7],[1.2,311.7],[1.4,280],[1.53,245],[1.58,176.6],[1.6,141.8],[1.64,68.99],[1.7,17.48],[1.7,0]],"totImpulseNs":486,"totalWeightG":605,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":286.6,"burnTimeS":1.5,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I290","dataFiles":2,"designation":"I290-SP","diameter":38,"impulseClass":"I","length":922,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":635.5,"motorId":"5f4294d200023100000000ca","samples":[[0,0],[0.001,521.5],[0.08575,337.5],[0.14,357.9],[0.1976,398.8],[0.3095,490.8],[0.4044,449.9],[0.5908,357.9],[0.7637,419.3],[0.9332,265.9],[1.089,163.6],[1.242,81.81],[1.501,0]],"totImpulseNs":430,"totalWeightG":884.5,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":300.4,"burnTimeS":1.42,"caseInfo":"RMS-38/480","certOrg":"National Association of Rocketry","commonName":"I300","dataFiles":2,"delays":"4,6,8,10","designation":"I300T","diameter":38,"impulseClass":"I","infoUrl":"http://nar.org/SandT/pdf/Aerotech/I300.pdf","length":250,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":474.4,"motorId":"5f4294d200023100000000cb","propInfo":"Blue Thunder","propWeightG":221.6,"samples":[[0,0],[0.001,473.2],[0.101,395.7],[0.201,375.3],[0.301,367.1],[0.401,359],[0.501,346.7],[0.601,338.6],[0.701,318.2],[0.801,305.9],[0.901,295.4],[1.071,269.2],[1.101,258],[1.201,246.8],[1.301,179.5],[1.401,48.95],[1.501,13.91],[1.601,0]],"totImpulseNs":426.5,"totalWeightG":441,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":308,"burnTimeS":1.85,"caseInfo":"38 36 F HP (460CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I307","dataFiles":2,"designation":"I307-HP","diameter":38,"impulseClass":"I","length":922,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":777,"motorId":"5f4294d200023100000000cc","propWeightG":110,"samples":[[0,0],[0.002237,551.7],[0.1991,717.2],[0.2103,386.2],[0.7562,620.7],[0.8345,455.2],[0.9418,310.3],[1.092,200],[1.224,117.2],[1.85,0]],"totImpulseNs":573,"totalWeightG":810,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":310,"burnTimeS":1.853,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I310","dataFiles":1,"designation":"440CC172J-I310","diameter":54,"impulseClass":"I","length":645,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d200023100000000cd","propWeightG":401.2,"samples":[[0,0],[0.042,465.9],[0.128,450.8],[0.216,438.4],[0.303,443.2],[0.391,433.8],[0.478,416],[0.566,406.7],[0.653,380.4],[0.741,385.2],[0.828,372.5],[0.916,358.3],[1.003,348.6],[1.091,337.9],[1.178,333.9],[1.266,303.5],[1.353,301.6],[1.441,268.8],[1.528,222.7],[1.616,155.3],[1.703,112.2],[1.791,80.51],[1.878,58.56],[1.966,41.77],[2.053,30.24],[2.141,21.27],[2.228,0]],"totImpulseNs":574.5,"totalWeightG":1305,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":310,"burnTimeS":2.1,"caseInfo":"AMW 38-640","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I310","dataFiles":2,"designation":"I310S","diameter":38,"impulseClass":"I","length":368,"manufacturer":"Kosdon by AeroTech","manufacturerAbbrev":"KBA","maxThrustN":473.9,"motorId":"5f4294d200023100000000ce","propWeightG":316.3,"samples":[[0,0],[0.045,334.7],[0.136,314.4],[0.228,322.6],[0.32,326.9],[0.411,331.9],[0.503,335.9],[0.595,336.9],[0.686,340.2],[0.778,342.1],[0.87,344.7],[0.961,348.6],[1.053,349.5],[1.146,351.9],[1.239,347.9],[1.33,345.1],[1.422,337],[1.514,333.3],[1.605,323.8],[1.697,289],[1.789,215.1],[1.88,136.6],[1.972,83.86],[2.064,37.92],[2.155,20.74],[2.248,5.943],[2.341,0]],"totImpulseNs":633.8,"type":"reload","updatedOn":"2022-02-19"},{"availability":"OOP","avgThrustN":315,"burnTimeS":1.8,"caseInfo":"AMW 38-640","certOrg":"National Association of Rocketry","commonName":"I315","dataFiles":2,"designation":"SK-38-640","diameter":38,"impulseClass":"I","length":370,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d200023100000000cf","propInfo":"Skidmark","propWeightG":333.7,"samples":[[0,0],[0.011,314.6],[0.03,312.8],[0.066,300.8],[0.084,300.5],[0.12,304.1],[0.175,313],[0.266,324.1],[0.356,332.2],[0.447,347.9],[0.538,372],[0.629,382.8],[0.719,385.6],[0.81,385.6],[0.901,384.8],[0.992,382.3],[1.082,378.3],[1.173,370.8],[1.264,357.6],[1.355,347.1],[1.445,328.3],[1.536,202.7],[1.627,90.87],[1.718,35.43],[1.808,8.192],[1.815,0]],"sparky":true,"totImpulseNs":572,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":329,"burnTimeS":1.7,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I333","dataFiles":2,"designation":"I333-PVC","diameter":38,"impulseClass":"I","length":992,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":853,"motorId":"5f4294d200023100000000d0","propWeightG":184,"samples":[[0,0],[0.008949,855.4],[0.02908,881.1],[0.05369,504.7],[0.604,342.2],[0.7964,461.9],[1.7,0]],"totImpulseNs":556,"totalWeightG":929,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":352.1,"burnTimeS":1.71,"caseInfo":"Pro38-5G","certOrg":"Canadian Association of Rocketry","commonName":"I350","dataFiles":2,"delays":"7,9,11,13,16","designation":"601I350-16A","diameter":38,"impulseClass":"I","length":360,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":399.7,"motorId":"5f4294d200023100000000d1","propInfo":"Smoky Sam","propWeightG":413.5,"samples":[[0,0],[0.05,399.7],[0.13,390.1],[0.19,386.2],[0.4,388.1],[0.6,388.1],[0.8,388.1],[1,389.9],[1.2,387.4],[1.33,368.8],[1.44,350.4],[1.52,320.4],[1.6,164.8],[1.68,36.77],[1.71,0]],"totImpulseNs":601,"totalWeightG":782,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":357,"burnTimeS":1,"caseInfo":"RMS-38/360","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I357","dataFiles":2,"delays":"6,8,10,12,14","designation":"I357T","diameter":38,"impulseClass":"I","length":203,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":432.8,"motorId":"5f4294d200023100000000d3","propInfo":"Blue Thunder","propWeightG":174.4,"samples":[[0,0],[0.028,311.6],[0.087,351.8],[0.147,349.1],[0.206,346.2],[0.266,341.2],[0.325,336.9],[0.384,333.7],[0.444,327],[0.503,319.7],[0.563,312.5],[0.622,300.8],[0.681,292.8],[0.741,283.8],[0.8,274.6],[0.859,264.9],[0.919,254.3],[0.978,241.8],[1.037,229],[1.097,216.2],[1.156,187.8],[1.216,109.9],[1.275,56.46],[1.334,24.48],[1.394,10.98],[1.454,3.45],[1.515,0]],"totImpulseNs":342,"totalWeightG":343,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":360,"burnTimeS":1.77,"caseInfo":"Pro38-5G","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I360","dataFiles":2,"designation":"I360","diameter":38,"impulseClass":"I","length":360,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":555.5,"motorId":"5f4294d200023100000000d4","propWeightG":334.6,"samples":[[0,0],[0.08,555.5],[0.1,489.7],[0.13,448],[0.2,449],[0.4,483.7],[0.55,498],[0.6,494.9],[0.7,481.9],[0.8,457.9],[1,406.6],[1.2,344.4],[1.3,309.3],[1.4,182.2],[1.55,158.9],[1.6,101.8],[1.7,55.8],[1.77,0]],"totImpulseNs":625.5,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":355,"burnTimeS":1.52,"caseInfo":"RMS-38/600","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I366","dataFiles":2,"delays":"4,6,8,10","designation":"I366R","diameter":38,"impulseClass":"I","length":299,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":507,"motorId":"5f4294d200023100000000d5","propInfo":"Redline","propWeightG":300,"samples":[[0,0],[0.027,323.3],[0.088,485.4],[0.148,483.7],[0.208,479.9],[0.268,473.4],[0.327,466.2],[0.388,457.4],[0.448,448.8],[0.509,441.5],[0.57,430.2],[0.63,421.5],[0.69,411.8],[0.75,398.9],[0.81,387.5],[0.87,375.4],[0.93,361.3],[0.991,345.1],[1.053,330.4],[1.112,312.6],[1.173,293.5],[1.233,275.1],[1.292,262.4],[1.353,230.9],[1.413,118],[1.474,23.61],[1.535,0]],"totImpulseNs":539,"totalWeightG":555.5,"type":"reload","updatedOn":"2021-09-28"},{"availability":"OOP","avgThrustN":370,"burnTimeS":1.7,"caseInfo":"AMW 38-640","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I370","dataFiles":2,"designation":"I370F","diameter":38,"impulseClass":"I","length":368,"manufacturer":"Kosdon by AeroTech","manufacturerAbbrev":"KBA","maxThrustN":539.2,"motorId":"5f4294d200023100000000d6","propWeightG":316.9,"samples":[[0,0],[0.035,373.1],[0.109,389.9],[0.184,401.1],[0.259,416.6],[0.334,429.6],[0.409,438],[0.484,443.8],[0.559,447.3],[0.634,446.8],[0.709,447.3],[0.784,444.7],[0.859,441.3],[0.933,435.7],[1.007,425.3],[1.082,414.9],[1.157,404.2],[1.232,395.4],[1.307,382.1],[1.382,334.2],[1.457,276],[1.532,179.7],[1.607,83.02],[1.682,39.61],[1.757,16.11],[1.832,4.151],[1.907,0]],"totImpulseNs":634.3,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":375,"burnTimeS":1.57,"caseInfo":"AMW 38-640","certOrg":"National Association of Rocketry","commonName":"I375","dataFiles":2,"designation":"GG-38-640","diameter":38,"impulseClass":"I","length":370,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d200023100000000d7","propInfo":"Green Gorilla","propWeightG":340.2,"samples":[[0,0],[0.013,223.9],[0.045,273.9],[0.092,312.4],[0.14,334.4],[0.219,358],[0.298,382],[0.377,410.3],[0.457,431.1],[0.536,454.5],[0.615,476.8],[0.694,495.5],[0.773,504.7],[0.852,510.9],[0.931,512],[1.011,489.6],[1.09,441.4],[1.169,392.8],[1.248,354.8],[1.327,292.4],[1.406,177.3],[1.486,63.88],[1.565,14.9],[1.583,0]],"totImpulseNs":596,"totalWeightG":733.8,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":398,"burnTimeS":1,"caseInfo":"38 36 XF HP (460CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I400","dataFiles":2,"designation":"I400-HP","diameter":38,"impulseClass":"I","length":922,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":1006,"motorId":"5f4294d200023100000000d8","propWeightG":166,"samples":[[0,0],[0.004474,667.2],[0.0783,898.2],[0.1163,598.8],[0.2975,521.8],[0.4206,410.6],[0.5593,487.6],[0.7383,367.8],[1,0]],"totImpulseNs":432,"totalWeightG":925,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":405,"burnTimeS":1.2,"caseInfo":"38/480","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I405","dataFiles":2,"delays":"5,8,10,13,17","designation":"I405-LW","diameter":38,"impulseClass":"I","infoUrl":"https://www.lokiresearch.com/images/Documents/38mm%20White.pdf","length":305,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":787.8,"motorId":"5f4294d200023100000000d9","propInfo":"Loki White","propWeightG":252,"samples":[[0,0],[0.01,151.1],[0.03,781.4],[0.05,800.7],[0.06,755.7],[0.09,724.3],[0.12,697.7],[0.15,701],[0.17,675.3],[0.2,643.1],[0.3,607.7],[0.4,569.2],[0.5,517.7],[0.6,472.7],[0.7,392.3],[0.8,318.3],[0.9,241.2],[1,151.1],[1.1,93.3],[1.15,40],[1.2,0]],"totImpulseNs":493.2,"totalWeightG":543,"type":"reload","updatedOn":"2021-07-24"},{"availability":"regular","avgThrustN":435,"burnTimeS":1.1,"caseInfo":"RMS-38/600","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I435","dataFiles":3,"delays":"4,6,8,10","designation":"I435T","diameter":38,"impulseClass":"I","length":299,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":785.6,"motorId":"5f4294d200023100000000da","propInfo":"Blue Thunder","propWeightG":269.9,"samples":[[0,0],[0.024,808],[0.074,749.7],[0.124,709.2],[0.174,656.2],[0.224,636.6],[0.274,621.8],[0.324,592.3],[0.374,584.6],[0.424,573.3],[0.474,547.7],[0.524,540],[0.574,525.3],[0.624,500.5],[0.674,485],[0.724,464.3],[0.774,442.8],[0.824,424.5],[0.874,405.9],[0.924,393.4],[0.974,317.2],[1.024,217.6],[1.074,126.2],[1.124,74.39],[1.174,30.03],[1.224,9.38],[1.274,0]],"totImpulseNs":568.9,"totalWeightG":518,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":450,"burnTimeS":1,"caseInfo":"AMW 38-640","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I450","dataFiles":2,"designation":"I450F","diameter":38,"impulseClass":"I","length":368,"manufacturer":"Kosdon by AeroTech","manufacturerAbbrev":"KBA","maxThrustN":627,"motorId":"5f4294d200023100000000db","propWeightG":302,"samples":[[0,0],[0.012,634.2],[0.037,550.5],[0.108,519.7],[0.241,510.9],[0.639,550.5],[0.729,554.9],[0.809,546.1],[0.939,497.7],[1.072,471.2],[1.128,440.4],[1.165,387.6],[1.211,207],[1.295,88.08],[1.36,26.43],[1.41,0]],"totImpulseNs":633,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":479,"burnTimeS":0.7,"caseInfo":"38 28 XF HP (275CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I500","dataFiles":2,"designation":"I500-HP","diameter":38,"impulseClass":"I","length":719,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":1069,"motorId":"5f4294d200023100000000dc","propWeightG":166,"samples":[[0,0],[0.001119,1155],[0.02013,706.9],[0.03132,1000],[0.5749,103.4],[0.623,120.7],[0.7,0]],"totImpulseNs":336,"totalWeightG":800,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":725,"burnTimeS":0.84,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I727","dataFiles":2,"designation":"I727-HP","diameter":38,"impulseClass":"I","length":922,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":1662,"motorId":"5f4294d200023100000000dd","propWeightG":166,"samples":[[0,0],[0.008475,1278],[0.03559,1662],[0.09831,1508],[0.1441,1483],[0.1712,1176],[0.2186,1023],[0.422,792.5],[0.75,0]],"totImpulseNs":611,"totalWeightG":929,"type":"hybrid","updatedOn":"2020-10-28"},{"availability":"regular","avgThrustN":732,"burnTimeS":0.59,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I747","dataFiles":2,"designation":"I747-HP","diameter":38,"impulseClass":"I","length":719,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":464,"motorId":"5f4294d200023100000000de","propWeightG":166,"samples":[[0,0],[0.001,1917],[0.451,0]],"totImpulseNs":431,"totalWeightG":839,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":90,"burnTimeS":6.85,"caseInfo":"RMS-54/852","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J90","dataFiles":2,"delays":"6,8,10,12,14","designation":"J90W","diameter":54,"impulseClass":"J","length":243,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":188,"motorId":"5f4294d200023100000000df","propInfo":"White Lightning","propWeightG":426,"samples":[[0,0],[0.143,116.2],[0.43,165.4],[0.718,176.5],[1.005,184.6],[1.293,187.2],[1.58,183.7],[1.868,175.5],[2.155,167.7],[2.443,156.9],[2.73,143.5],[3.018,128.9],[3.305,110.9],[3.593,94],[3.88,79.66],[4.168,67.47],[4.455,57.27],[4.743,48.01],[5.03,40.52],[5.318,33.9],[5.605,28.25],[5.893,23.33],[6.18,19.27],[6.468,15.92],[6.755,12.73],[7.044,9.903],[7.332,0]],"totImpulseNs":707,"totalWeightG":852.5,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":110,"burnTimeS":6.8,"caseInfo":"SU 54x276","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J110","dataFiles":2,"designation":"J110","diameter":54,"impulseClass":"J","length":276,"manufacturer":"Ellis Mountain","manufacturerAbbrev":"Ellis","maxThrustN":222,"motorId":"5f4294d200023100000000e0","propWeightG":421,"samples":[[0,0],[0.1082,193.8],[0.3864,147.5],[1.005,139.8],[4.034,116.7],[5.008,94.69],[6.012,67.16],[6.538,37.44],[6.8,0]],"totImpulseNs":751.2,"totalWeightG":875,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":115,"burnTimeS":5.858,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J115","dataFiles":1,"designation":"440CC076J-J115","diameter":54,"impulseClass":"J","length":614,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d200023100000000e1","propWeightG":415.9,"samples":[[0,0],[0.129,218.3],[0.391,230.6],[0.653,216.2],[0.916,165.7],[1.178,158.8],[1.441,161.9],[1.703,158],[1.966,153],[2.228,148.3],[2.491,141.9],[2.753,137],[3.016,129.2],[3.278,121.8],[3.541,112],[3.803,79.16],[4.066,53.43],[4.328,42.98],[4.591,38.39],[4.853,33.42],[5.116,28.71],[5.378,23.89],[5.641,19.66],[5.903,15.89],[6.166,11.96],[6.428,9.151],[6.691,0]],"totImpulseNs":673.7,"totalWeightG":1282,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":120,"burnTimeS":6.313,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J120","dataFiles":1,"designation":"440CC076JFX-J120FX","diameter":54,"impulseClass":"J","length":614,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d200023100000000e2","propWeightG":446.2,"samples":[[0,0],[0.134,232.7],[0.405,264.1],[0.676,230.7],[0.948,186],[1.22,174.2],[1.491,173.9],[1.763,165.8],[2.034,158],[2.305,152.4],[2.577,143.4],[2.849,136],[3.12,129.5],[3.392,124.8],[3.664,118.9],[3.934,109.9],[4.206,69.78],[4.478,47.84],[4.749,40.18],[5.021,35.77],[5.293,31.27],[5.564,26.36],[5.835,21.21],[6.107,17.18],[6.378,12.93],[6.65,9.463],[6.922,0]],"totImpulseNs":757.5,"totalWeightG":1293,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":125,"burnTimeS":7.75,"caseInfo":"SU 54x368","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J125","dataFiles":2,"designation":"J125W","diameter":54,"impulseClass":"J","length":368,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":338.9,"motorId":"5f4294d200023100000000e3","propInfo":"White Lightning","propWeightG":638.7,"samples":[[0,0],[0.174,223.9],[0.525,254.8],[0.877,275.3],[1.229,285.2],[1.581,280.3],[1.933,264.5],[2.285,244.4],[2.638,223.8],[2.99,204.7],[3.342,185.4],[3.694,166.8],[4.046,147.7],[4.398,127.9],[4.75,108.5],[5.102,92.58],[5.454,77.82],[5.806,63.84],[6.158,53.02],[6.51,44.51],[6.862,37.54],[7.215,32.2],[7.567,27.21],[7.919,22.85],[8.271,18.6],[8.623,14.79],[8.975,0]],"totImpulseNs":1202,"totalWeightG":1288,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":157,"burnTimeS":6.83,"caseInfo":"RMS-54/1280","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J135","dataFiles":2,"delays":"6,8,10,12,14","designation":"J135W","diameter":54,"impulseClass":"J","length":368,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":274,"motorId":"5f4294d200023100000000e4","propInfo":"White Lightning","propWeightG":633,"samples":[[0,0],[0.147,226.3],[0.444,243.7],[0.742,250.9],[1.04,257.3],[1.338,259.3],[1.635,253.7],[1.933,246.1],[2.231,235.8],[2.529,221.8],[2.827,205.1],[3.125,183.6],[3.423,161.1],[3.72,141],[4.017,123],[4.315,106.6],[4.612,91.96],[4.91,77.69],[5.208,65.3],[5.506,54.35],[5.804,44.25],[6.102,35.4],[6.4,27.72],[6.698,21.12],[6.996,14.94],[7.294,9.737],[7.592,0]],"totImpulseNs":1069,"totalWeightG":1141,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":134,"burnTimeS":4.92,"certOrg":"Canadian Association of Rocketry","commonName":"J140","dataFiles":1,"designation":"664NS-J140","diameter":38,"impulseClass":"J","length":881,"manufacturer":"Propulsion Polymers","manufacturerAbbrev":"PP","maxThrustN":201.6,"motorId":"5f4294d200023100000000e5","propWeightG":538.5,"samples":[[0,0],[0.02,249],[0.2,320],[0.25,240],[0.3,236],[0.35,191],[0.45,236],[1.15,223],[1.6,178],[3.05,165],[3.4,102],[4.25,45],[4.95,22],[5,0]],"totImpulseNs":664,"totalWeightG":1166,"type":"hybrid","updatedOn":"2021-06-13"},{"availability":"OOP","avgThrustN":144,"burnTimeS":4.854,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J144","dataFiles":2,"designation":"J144","diameter":38,"impulseClass":"J","length":914,"manufacturer":"Sky Ripper Systems","manufacturerAbbrev":"SkyR","motorId":"5f4294d200023100000000e6","propWeightG":370,"samples":[[0,0],[0.01,301.3],[0.03,376.4],[0.03,376.9],[0.08,247.3],[0.22,273.4],[0.45,263.6],[0.79,232],[1.09,175.7],[1.21,185.7],[2.05,149.6],[2.86,127.6],[3.42,69.07],[3.88,42.69],[4.59,20.49],[5.2,10],[5.8,6.12],[5.8,0]],"totImpulseNs":699,"totalWeightG":1133,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":145,"burnTimeS":5.65,"caseInfo":"RMS-54/1280","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J145","dataFiles":2,"designation":"J145H_2JET_STD","diameter":54,"impulseClass":"J","length":709,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":303.3,"motorId":"5f4294d200023100000000e7","propWeightG":409.5,"samples":[[0,0],[0.113,253.1],[0.34,293.7],[0.567,300.1],[0.794,289.5],[1.021,253.4],[1.248,251.8],[1.476,246],[1.704,236.6],[1.931,229.9],[2.158,222.6],[2.385,211.1],[2.612,201.1],[2.841,191.1],[3.069,139.2],[3.296,79.89],[3.523,63.9],[3.75,51.05],[3.977,40.56],[4.205,31.71],[4.433,24.43],[4.66,19.95],[4.887,15.26],[5.115,12.41],[5.342,10.21],[5.57,9.135],[5.798,0]],"totImpulseNs":825.7,"totalWeightG":1797,"type":"hybrid","updatedOn":"2022-06-15"},{"availability":"OOP","avgThrustN":148,"burnTimeS":6.1,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J148","dataFiles":2,"designation":"J148","diameter":54,"impulseClass":"J","length":356,"manufacturer":"Ellis Mountain","manufacturerAbbrev":"Ellis","maxThrustN":182.3,"motorId":"5f4294d200023100000000e8","propWeightG":357.2,"samples":[[0,0],[0.1391,218],[0.2318,183.9],[0.4482,171.8],[1.005,170.7],[2.102,170.7],[5.023,147.5],[5.317,133.2],[5.672,49.55],[6.1,0]],"totImpulseNs":903.4,"totalWeightG":1179,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":155,"burnTimeS":4.1,"caseInfo":"38 36 S HP","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J150","dataFiles":2,"designation":"J150-HP","diameter":38,"impulseClass":"J","length":922,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":490,"motorId":"5f4294d200023100000000e9","propWeightG":110,"samples":[[0,0],[0.001,266.9],[2.003,184.8],[2.758,150.6],[3.01,92.39],[4.101,0]],"totImpulseNs":654,"totalWeightG":889,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":150,"burnTimeS":5.009,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J150","dataFiles":1,"designation":"440CC086J-J150","diameter":54,"impulseClass":"J","length":645,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d200023100000000ea","propWeightG":433.5,"samples":[[0,0],[0.111,177.5],[0.336,193.7],[0.561,200.1],[0.786,204],[1.011,200.5],[1.236,197.2],[1.461,192.7],[1.686,189.9],[1.911,185.9],[2.136,183.1],[2.361,179.3],[2.586,174.2],[2.813,171.1],[3.039,164.9],[3.264,160],[3.489,154.6],[3.714,148.7],[3.939,92.09],[4.164,55.33],[4.389,42.91],[4.614,32.9],[4.839,24.74],[5.064,16.45],[5.289,8.527],[5.515,4.923],[5.741,0]],"totImpulseNs":751.4,"totalWeightG":1306,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":160,"burnTimeS":5.1,"caseInfo":"h 490 cc","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J160","dataFiles":1,"designation":"J160","diameter":38,"impulseClass":"J","length":1219,"manufacturer":"R.A.T.T. Works","manufacturerAbbrev":"RATT","maxThrustN":410.7,"motorId":"5f4294d200023100000000eb","propWeightG":4.3,"samples":[[0,0],[0.01546,262],[0.1855,255.4],[0.2782,240],[0.2782,229],[0.3864,251],[0.51,242.2],[0.6492,213.6],[0.7883,189.4],[1.005,178.4],[1.453,160.8],[2.009,147.5],[2.442,129.9],[2.906,121.1],[2.968,163],[3.153,149.7],[3.323,125.5],[3.679,94.69],[3.972,74.87],[4.328,46.24],[4.699,19.82],[5.1,0]],"totImpulseNs":667.7,"totalWeightG":544,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":170,"burnTimeS":4.282,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J170","dataFiles":1,"designation":"440CC098J-J170","diameter":54,"impulseClass":"J","length":614,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d200023100000000ec","propWeightG":407.5,"samples":[[0,0],[0.092,315.2],[0.278,351.5],[0.466,314.2],[0.653,255.3],[0.841,235.4],[1.027,234.8],[1.214,230.9],[1.401,223.1],[1.589,217.7],[1.776,209.9],[1.962,203.8],[2.149,197.5],[2.336,191.2],[2.524,178.6],[2.711,129.8],[2.898,82.46],[3.084,71.69],[3.272,64.63],[3.459,54.02],[3.647,45.02],[3.833,36.37],[4.02,28.4],[4.207,21.52],[4.395,16.07],[4.582,11.71],[4.77,0]],"totImpulseNs":728,"totalWeightG":1282,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":170,"burnTimeS":4.4,"caseInfo":"RMS-54/1280","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J170","dataFiles":1,"designation":"J170H_3JET_STD","diameter":54,"impulseClass":"J","length":709,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d200023100000000ed","propWeightG":409.5,"samples":[[0,0],[0.005,432.1],[0.054,383.5],[0.114,334.1],[0.188,353.7],[0.316,362.1],[0.405,353.7],[0.508,348.1],[0.637,326.6],[0.721,313.6],[0.775,311.7],[0.903,294.9],[0.997,290.2],[1.111,300.5],[1.199,276.2],[1.397,268.8],[1.51,274.4],[1.594,261.3],[1.742,256.6],[1.91,248.2],[1.999,238.9],[2.098,210.9],[2.192,157.7],[2.305,139],[2.399,123.2],[2.601,105.5],[2.695,101.7],[2.887,85.85],[3.011,78.39],[3.1,63.46],[3.164,61.59],[3.302,50.39],[3.411,52.26],[3.519,47.59],[3.613,37.33],[3.82,38.26],[3.993,29.86],[4.107,29.86],[4.205,26.13],[4.294,16.8],[4.487,0]],"totImpulseNs":739,"type":"hybrid","updatedOn":"2022-06-15"},{"availability":"regular","avgThrustN":180,"burnTimeS":4.5,"caseInfo":"RMS-54/852","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J180","dataFiles":2,"delays":"6,8,10,12,14","designation":"J180T","diameter":54,"impulseClass":"J","length":230,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":392,"motorId":"5f4294d200023100000000ee","propInfo":"Blue Thunder","propWeightG":437.1,"samples":[[0,0],[0.093,301.6],[0.281,313.2],[0.47,313.7],[0.658,308.3],[0.847,300.1],[1.035,290.7],[1.224,278.9],[1.412,263.8],[1.601,246],[1.79,226.7],[1.978,207.3],[2.167,187.1],[2.355,168.3],[2.544,150],[2.732,133.1],[2.921,116.3],[3.109,100.1],[3.298,84.51],[3.486,70.45],[3.675,57.26],[3.864,44.45],[4.052,33.34],[4.241,24.65],[4.429,17.96],[4.619,12.39],[4.808,0]],"totImpulseNs":764,"totalWeightG":809.1,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":190,"burnTimeS":4.353,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J190","dataFiles":1,"designation":"440CC098JFX-J190FX","diameter":54,"impulseClass":"J","length":614,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d200023100000000ef","propWeightG":443.3,"samples":[[0,0],[0.095,338.6],[0.287,384.4],[0.481,341.5],[0.674,279.2],[0.867,267.5],[1.06,256.3],[1.254,250.1],[1.447,244.4],[1.64,238.8],[1.833,236.5],[2.026,232],[2.219,224],[2.413,213.2],[2.606,201.7],[2.799,150.5],[2.992,101.3],[3.185,84],[3.378,73.9],[3.571,60.22],[3.765,49.21],[3.958,39.1],[4.151,29.87],[4.344,22.6],[4.538,16.84],[4.731,11.96],[4.925,0]],"totImpulseNs":827,"totalWeightG":1293,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":210,"burnTimeS":3.99,"caseInfo":"Pro54-2G","certOrg":"Canadian Association of Rocketry","commonName":"J210","dataFiles":3,"delays":"6,7,8,9,10,11,12,13,14,15,16","designation":"836J210-16A","diameter":54,"impulseClass":"J","length":236,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":335,"motorId":"5f4294d200023100000000f0","propInfo":"Classic","propWeightG":396,"samples":[[0,0],[0.04,335],[0.16,270.9],[0.41,269.3],[0.8,268.5],[1.18,256.3],[1.62,236.8],[2.03,214.1],[2.38,193.9],[2.79,174.4],[3.2,163.8],[3.6,157.4],[3.75,135.5],[3.86,85.17],[3.99,0]],"totImpulseNs":836,"totalWeightG":842,"type":"reload","updatedOn":"2021-06-13"},{"availability":"OOP","avgThrustN":213.5,"burnTimeS":4,"caseInfo":"RMS-54/1280","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J210","dataFiles":2,"designation":"J210H_4JET_STD","diameter":54,"impulseClass":"J","length":709,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":651.8,"motorId":"5f4294d200023100000000f1","propWeightG":471,"samples":[[0,0],[0.007728,651.8],[0.06955,528.5],[0.2009,488.9],[0.5023,409.6],[0.9969,374.4],[1.492,312.7],[1.592,286.3],[2.009,167.4],[2.434,88.08],[2.504,101.3],[2.55,74.87],[3.022,57.25],[4,0]],"totImpulseNs":853.8,"totalWeightG":1497,"type":"hybrid","updatedOn":"2022-06-15"},{"availability":"OOP","avgThrustN":220,"burnTimeS":3.277,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J220","dataFiles":1,"designation":"440CC110J-J220","diameter":54,"impulseClass":"J","length":645,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d200023100000000f2","propWeightG":422.6,"samples":[[0,0],[0.071,278],[0.215,271.7],[0.358,289.9],[0.502,298.2],[0.647,293.8],[0.792,290.6],[0.935,283.2],[1.079,276],[1.223,271.8],[1.368,269.8],[1.513,263],[1.656,257.5],[1.8,253.3],[1.944,245.8],[2.089,239.7],[2.233,230.9],[2.377,220.2],[2.521,159.2],[2.665,97.18],[2.809,73.15],[2.954,58.77],[3.098,48.97],[3.242,37.55],[3.385,27.41],[3.53,19.27],[3.675,0]],"totImpulseNs":720.9,"totalWeightG":1305,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":216,"burnTimeS":4.3,"caseInfo":"38 48 M HP (830CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J222","dataFiles":2,"designation":"J222-HP","diameter":38,"impulseClass":"J","length":1227,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":786,"motorId":"5f4294d200023100000000f3","propWeightG":110,"samples":[[0,0],[0.005593,547.5],[0.1678,355.9],[2.864,191.6],[2.959,143.7],[3.087,130],[3.468,95.81],[4.3,0]],"totImpulseNs":928,"totalWeightG":1043,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":228,"burnTimeS":5,"caseInfo":"SU 38x562","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J228","dataFiles":2,"designation":"J228","diameter":38,"impulseClass":"J","length":562,"manufacturer":"Ellis Mountain","manufacturerAbbrev":"Ellis","maxThrustN":616,"motorId":"5f4294d200023100000000f4","propWeightG":569,"samples":[[0,0],[0.03091,665],[0.09274,444.8],[0.2628,356.7],[0.6646,343.5],[0.9892,317.1],[1.963,259.8],[2.998,193.8],[4.019,118.9],[4.992,35.23],[5.2,0]],"totImpulseNs":1115,"totalWeightG":839,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":240,"burnTimeS":4.3,"caseInfo":"54 36 S BG (910CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J234","dataFiles":2,"designation":"J234-BG","diameter":54,"impulseClass":"J","length":9122,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":567.6,"motorId":"5f4294d200023100000000f5","propWeightG":450,"samples":[[0,0],[0.005593,229.3],[0.5034,349],[3.479,208.7],[3.624,116.3],[3.758,78.7],[4.3,0]],"totImpulseNs":1033,"totalWeightG":1764,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":242,"burnTimeS":3.1,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J242","dataFiles":2,"designation":"J242-PVC","diameter":38,"impulseClass":"J","length":1227,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":875,"motorId":"5f4294d200023100000000f6","propWeightG":110,"samples":[[0,0],[0.01119,448.3],[1.739,269],[1.762,165.5],[2.975,48.28],[3.1,0]],"totImpulseNs":752,"totalWeightG":1065,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":245.3,"burnTimeS":2.62,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J245","dataFiles":2,"designation":"J245-BG","diameter":54,"impulseClass":"J","length":719,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":681.1,"motorId":"5f4294d200023100000000f7","propWeightG":450,"samples":[[0,0],[0.001,444.8],[0.1408,355.9],[1.052,308],[2.065,184.8],[2.16,102.7],[2.283,68.43],[2.621,0]],"totImpulseNs":643.5,"totalWeightG":1550,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":238,"burnTimeS":2.8,"caseInfo":"38 36 M HP (550CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J246","dataFiles":2,"designation":"J246-HP","diameter":38,"impulseClass":"J","length":922,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":490,"motorId":"5f4294d200023100000000f8","propWeightG":110,"samples":[[0,0],[0.01678,492.7],[0.02796,328.5],[0.1342,526.9],[0.3412,403.8],[0.5201,349],[2.002,191.6],[2.125,116.3],[2.8,0]],"totImpulseNs":673,"totalWeightG":861,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":255,"burnTimeS":1.7,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I250","dataFiles":1,"designation":"I250-HP","diameter":38,"impulseClass":"I","length":719,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":736,"motorId":"5f4294d200023100000000f9","propWeightG":110,"samples":[[0,0],[0.004474,622.8],[0.02461,438],[1.004,273.7],[1.022,171.1],[1.201,157.4],[1.239,136.9],[1.7,0]],"totImpulseNs":430,"totalWeightG":724,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":250,"burnTimeS":2.978,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J250","dataFiles":2,"designation":"440CC125J-J250","diameter":54,"impulseClass":"J","length":614,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d200023100000000fa","propWeightG":404.6,"samples":[[0,0],[0.064,409.7],[0.194,453.2],[0.324,416.5],[0.454,383.8],[0.584,359.2],[0.715,344],[0.845,336.3],[0.975,328.8],[1.105,318.6],[1.235,309.1],[1.366,306.2],[1.496,290.6],[1.626,283.2],[1.756,261.2],[1.886,200.2],[2.017,143.6],[2.147,126.5],[2.277,113.2],[2.407,91.31],[2.538,71.22],[2.668,54.18],[2.798,40.35],[2.928,29.06],[3.058,20.14],[3.19,13.79],[3.321,0]],"totImpulseNs":744.5,"totalWeightG":1292,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":260.1,"burnTimeS":4.5,"caseInfo":"RMS-54/1280","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J260","dataFiles":2,"designation":"J260HW_3JET_EFX","diameter":54,"impulseClass":"J","length":709,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":599,"motorId":"5f4294d200023100000000fb","propWeightG":558,"samples":[[0,0],[0.007728,599],[0.03864,475.7],[0.1082,506.5],[0.4637,493.3],[0.7805,475.7],[1.012,427.2],[2.002,330.3],[2.488,193.8],[2.991,114.5],[4.011,57.25],[4.5,0]],"totImpulseNs":1170,"totalWeightG":1574,"type":"hybrid","updatedOn":"2022-06-15"},{"availability":"OOP","avgThrustN":270,"burnTimeS":3.47,"caseInfo":"38X438.1 38X467(D)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J270","dataFiles":2,"delays":"20,P","designation":"J270","diameter":38,"impulseClass":"J","length":384,"manufacturer":"Ellis Mountain","manufacturerAbbrev":"Ellis","maxThrustN":427.6,"motorId":"5f4294d200023100000000fc","propWeightG":347.1,"samples":[[0,0],[0.057,357.6],[0.175,386.5],[0.294,368.1],[0.412,360.6],[0.53,356.1],[0.648,353.9],[0.767,351.9],[0.885,349.9],[1.003,348.7],[1.121,347.6],[1.24,343.1],[1.358,338],[1.476,330.6],[1.594,315.5],[1.712,293.3],[1.831,266.1],[1.949,184],[2.067,131.6],[2.185,109.2],[2.304,89.57],[2.422,74.94],[2.54,55.7],[2.658,31.86],[2.777,17.75],[2.896,10.11],[3.015,0]],"totImpulseNs":648.5,"totalWeightG":712,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":270,"burnTimeS":2.971,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J270","dataFiles":1,"designation":"440CC125JFX-J270FX","diameter":54,"impulseClass":"J","length":614,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d200023100000000fd","propWeightG":423.2,"samples":[[0,0],[0.064,438.6],[0.193,498.6],[0.322,468.9],[0.451,438.3],[0.581,412.7],[0.711,390.7],[0.841,376.2],[0.97,362.2],[1.1,347.6],[1.23,333.5],[1.359,324.4],[1.489,311.5],[1.619,298.1],[1.749,278.4],[1.878,220.2],[2.007,150.3],[2.137,125.6],[2.268,122],[2.397,91.4],[2.526,71.67],[2.656,55.78],[2.786,41.82],[2.916,30.46],[3.045,22.24],[3.175,16.42],[3.305,0]],"totImpulseNs":802.2,"totalWeightG":1296,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":276,"burnTimeS":3.86,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J272","dataFiles":2,"designation":"J272-SP","diameter":54,"impulseClass":"J","length":922,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":573,"motorId":"5f4294d200023100000000fe","samples":[[0,0],[0.008475,398.8],[0.1695,572.6],[0.5339,460.2],[0.8729,388.6],[1.059,357.9],[2.915,204.5],[3.195,71.58],[3.517,40.9],[3.636,51.13],[3.86,0]],"sparky":true,"totImpulseNs":1065,"totalWeightG":1746,"type":"hybrid","updatedOn":"2019-04-18"},{"availability":"regular","avgThrustN":275,"burnTimeS":3.3,"caseInfo":"RMS-54/852","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J275","dataFiles":2,"delays":"6,8,10,12,14","designation":"J275W","diameter":54,"impulseClass":"J","length":230,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":370,"motorId":"5f4294d200023100000000ff","propInfo":"White Lightning","propWeightG":472,"samples":[[0,0],[0.075,239.7],[0.227,289.1],[0.38,299.8],[0.533,312.7],[0.686,323.9],[0.84,332.2],[0.992,336.4],[1.145,335.1],[1.298,329.5],[1.451,325.3],[1.604,310],[1.756,292.9],[1.909,275.7],[2.063,257.3],[2.216,234.9],[2.369,213.1],[2.521,182.5],[2.674,167.9],[2.827,153],[2.98,138.1],[3.133,105.6],[3.285,67.37],[3.439,29.24],[3.592,14.6],[3.745,6.662],[3.898,0]],"totImpulseNs":774,"totalWeightG":864.2,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":280,"burnTimeS":2.559,"caseInfo":"Pro54-2G","certOrg":"Canadian Association of Rocketry","commonName":"J280","dataFiles":2,"delays":"6,7,8,9,10,11,12,13,14,15,16","designation":"716J280-16A","diameter":54,"impulseClass":"J","length":236,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","motorId":"5f4294d20002310000000100","propInfo":"Smoky Sam","propWeightG":512,"samples":[[0,0],[0.1,259.4],[0.3,278.9],[0.6,293.1],[0.9,306.9],[1.2,319.2],[1.5,321.1],[1.8,310.9],[2.11,279.9],[2.35,286.7],[2.4,269.2],[2.44,178.2],[2.49,42.8],[2.54,0]],"totImpulseNs":716.5,"totalWeightG":954,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":287.5,"burnTimeS":2.26,"caseInfo":"Pro38-5G","certOrg":"Canadian Association of Rocketry","commonName":"J285","dataFiles":2,"delays":"6,8,10,12,15","designation":"648J285-15A","diameter":38,"impulseClass":"J","length":360,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":369.3,"motorId":"5f4294d20002310000000101","propInfo":"Classic","propWeightG":312.5,"samples":[[0,0],[0.06,351],[0.15,346],[0.25,357.6],[0.5,363.9],[0.75,369.3],[1.03,343.3],[1.27,337.1],[1.51,317.4],[1.75,282.5],[1.93,127.9],[2.02,84.94],[2.25,11.02],[2.26,0]],"totImpulseNs":648,"totalWeightG":595,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":292,"burnTimeS":2.53,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J292","dataFiles":2,"designation":"J292-SP","diameter":54,"impulseClass":"J","length":719,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":627.8,"motorId":"5f4294d20002310000000102","samples":[[0,0],[0.008475,552.2],[0.2627,480.6],[0.4237,419.3],[0.7627,337.5],[1.975,245.4],[2.076,143.2],[2.53,0]],"sparky":true,"totImpulseNs":734,"totalWeightG":1542,"type":"hybrid","updatedOn":"2019-04-18"},{"availability":"regular","avgThrustN":298,"burnTimeS":4,"caseInfo":"Pro54-3G","certOrg":"Canadian Association of Rocketry","commonName":"J295","dataFiles":2,"delays":"6,7,8,9,10,11,12,13,14,15,16","designation":"1195J295-16A","diameter":54,"impulseClass":"J","length":320,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":450.5,"motorId":"5f4294d20002310000000103","propInfo":"Classic","propWeightG":594,"samples":[[0,0],[0.04,450.5],[0.28,428.7],[0.54,423.3],[1,391.6],[1.48,352.3],[1.99,304.4],[2.51,266.2],[3,243.3],[3.5,216.9],[3.67,126.5],[3.82,64.36],[4,0]],"totImpulseNs":1196,"totalWeightG":1119,"type":"reload","updatedOn":"2021-06-13"},{"availability":"OOP","avgThrustN":295,"burnTimeS":3.386,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J295","dataFiles":1,"designation":"440CC172JFX-J295FX","diameter":54,"impulseClass":"J","length":552,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d20002310000000104","propWeightG":711.9,"samples":[[0,0],[0.004,467.3],[0.244,461.7],[0.501,416.7],[1.002,377.3],[1.254,343.5],[1.364,315.3],[1.502,219.6],[1.751,112.6],[2.003,50.68],[2.2,0]],"totImpulseNs":998.8,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":300,"burnTimeS":2.05,"caseInfo":"Pro38-5G","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J300","dataFiles":2,"designation":"J300","diameter":38,"impulseClass":"J","length":360,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":552,"motorId":"5f4294d20002310000000105","propWeightG":345.4,"samples":[[0,0],[0.043,357],[0.131,436.6],[0.221,407.9],[0.31,399.5],[0.4,400.6],[0.49,406.7],[0.578,414.3],[0.667,417.1],[0.756,418.4],[0.846,421.3],[0.935,422.2],[1.025,416],[1.114,406.4],[1.202,395.2],[1.292,381.7],[1.381,369.9],[1.471,355.5],[1.56,331.7],[1.649,246.2],[1.738,161.8],[1.827,109.5],[1.917,71.41],[2.006,37.06],[2.096,13.88],[2.185,5.059],[2.275,0]],"totImpulseNs":694,"totalWeightG":606.6,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":315,"burnTimeS":2.423,"caseInfo":"RMS-54/852","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J315","dataFiles":2,"delays":"6,8,10,12,14","designation":"J315R","diameter":54,"impulseClass":"J","length":230,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d20002310000000106","propInfo":"Redline","propWeightG":438,"samples":[[0,0],[0.051,189.7],[0.154,337.5],[0.259,354.5],[0.363,364.1],[0.468,371.5],[0.572,373.2],[0.676,376.1],[0.78,373],[0.884,369],[0.989,367],[1.093,358.8],[1.197,351.3],[1.301,339.3],[1.406,325.2],[1.51,311.3],[1.614,300.5],[1.718,288.6],[1.822,278.3],[1.927,270.5],[2.031,262.1],[2.136,245],[2.239,236.2],[2.344,188.3],[2.448,63.67],[2.552,18.75],[2.657,0]],"totImpulseNs":763.3,"totalWeightG":851.2,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":317,"burnTimeS":3.151,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J317","dataFiles":1,"designation":"835CC172J-J317","diameter":81,"impulseClass":"J","length":552,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d20002310000000107","propWeightG":711.9,"samples":[[0,0],[0.071,438.5],[0.215,471],[0.358,459.7],[0.502,447.3],[0.647,431.7],[0.792,418.5],[0.935,407.8],[1.079,400.2],[1.223,395.8],[1.368,382.5],[1.513,372.9],[1.656,368],[1.8,349.3],[1.944,336.1],[2.089,324.5],[2.233,301.2],[2.377,233.6],[2.521,177],[2.665,132.5],[2.809,96.23],[2.954,69.72],[3.098,49.46],[3.242,33.98],[3.385,23.06],[3.53,16.52],[3.675,0]],"totImpulseNs":998.8,"totalWeightG":1758,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":325.3,"burnTimeS":2.26,"caseInfo":"Pro38-6G","certOrg":"Canadian Association of Rocketry","commonName":"J330","dataFiles":2,"delays":"7,9,11,13,16","designation":"765J330-16A","diameter":38,"impulseClass":"J","length":419,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":459.3,"motorId":"5f4294d20002310000000108","propInfo":"Classic","propWeightG":375,"samples":[[0,0],[0.05,459.3],[0.16,448.2],[0.27,440.4],[0.51,437.1],[0.75,427.1],[1.02,412.6],[1.26,387],[1.5,360.3],[1.69,321.4],[1.79,300.3],[1.91,126.8],[1.99,107.9],[2.23,22.56],[2.26,0]],"totImpulseNs":765,"totalWeightG":702,"type":"reload","updatedOn":"2021-06-13"},{"availability":"OOP","avgThrustN":330,"burnTimeS":3.64,"caseInfo":"38X488.9 38X517(D)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J330","dataFiles":2,"delays":"20,P","designation":"J330","diameter":38,"impulseClass":"J","length":433,"manufacturer":"Ellis Mountain","manufacturerAbbrev":"Ellis","maxThrustN":660.7,"motorId":"5f4294d20002310000000109","propWeightG":411.9,"samples":[[0,0],[0.055,482],[0.169,515.2],[0.283,510],[0.398,511.5],[0.512,509.2],[0.626,503.6],[0.74,495.5],[0.854,486.1],[0.969,477.8],[1.083,472.1],[1.197,455.9],[1.31,433.7],[1.425,407.5],[1.54,367.9],[1.654,271.2],[1.768,203.7],[1.881,152.8],[1.996,106.1],[2.11,91.4],[2.225,72.29],[2.339,63.98],[2.452,61.81],[2.567,42.01],[2.681,16.44],[2.796,4.496],[2.91,0]],"totImpulseNs":737.8,"totalWeightG":788,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":330,"burnTimeS":3.185,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J330","dataFiles":2,"designation":"835CC172JFX-J330FX","diameter":81,"impulseClass":"J","length":552,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d2000231000000010a","propWeightG":738,"samples":[[0,0],[0.068,453.5],[0.206,485.7],[0.345,476.9],[0.483,463.6],[0.623,440],[0.761,423.3],[0.9,426.4],[1.04,415.2],[1.178,443.4],[1.317,431.4],[1.456,407],[1.595,392.1],[1.733,390.3],[1.872,360.1],[2.01,334.2],[2.15,307.2],[2.289,225.6],[2.427,169.2],[2.567,126.6],[2.705,93.17],[2.844,68.29],[2.983,48.1],[3.122,32.86],[3.26,21.86],[3.4,15.19],[3.54,0]],"totImpulseNs":1051,"totalWeightG":1777,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":305,"burnTimeS":2.4,"caseInfo":"38 48 M PVC (830CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J333","dataFiles":2,"designation":"J333-HP","diameter":38,"impulseClass":"J","length":1227,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":1227,"motorId":"5f4294d2000231000000010b","propWeightG":110,"samples":[[0,0],[0.001,717.2],[0.2051,800],[0.7532,448.3],[0.7644,269],[2.165,62.07],[2.238,27.59],[2.401,0]],"totImpulseNs":733,"totalWeightG":1064,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":318,"burnTimeS":2.7,"caseInfo":"38 48 F PVC (735CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J345","dataFiles":2,"designation":"J345-PVC","diameter":38,"impulseClass":"J","length":1227,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":1222,"motorId":"5f4294d2000231000000010c","propWeightG":184,"samples":[[0,0],[0.005593,881.1],[0.0783,667.2],[1.219,376.4],[1.264,359.3],[2.7,0]],"totImpulseNs":891,"totalWeightG":1118,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":445,"burnTimeS":1.5,"caseInfo":"RMS-38/720","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J350","dataFiles":2,"delays":"4,6,8,10,12,14","designation":"J350W","diameter":38,"impulseClass":"J","length":337,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":822.5,"motorId":"5f4294d2000231000000010d","propInfo":"White Lightning","propWeightG":375.1,"samples":[[0,0],[0.041,841.4],[0.051,767.1],[0.088,698.2],[0.173,644.5],[0.256,621.1],[0.298,564.6],[0.547,544],[0.783,487.5],[0.989,418.7],[1.16,359.4],[1.192,340.2],[1.213,320.9],[1.287,216.2],[1.319,179],[1.342,126.7],[1.386,84.01],[1.427,53.71],[1.48,45.45],[1.591,20.66],[1.695,0]],"totImpulseNs":700,"totalWeightG":665,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":394.2,"burnTimeS":1.78,"caseInfo":"RMS-38/720","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J350","dataFiles":2,"delays":"4,6,8,10,12,14","designation":"J350W-OLD","diameter":38,"impulseClass":"J","length":337,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":890.4,"motorId":"5f4294d2000231000000010e","propInfo":"White Lightning","propWeightG":381.1,"samples":[[0,0],[0.038,706.8],[0.115,669.1],[0.192,602.5],[0.27,565.1],[0.348,539.1],[0.425,514.9],[0.503,483.1],[0.581,449.1],[0.658,437.3],[0.736,424.2],[0.815,414.5],[0.892,403],[0.97,393.6],[1.048,377.8],[1.125,359.8],[1.203,341.9],[1.281,324.7],[1.358,305.9],[1.436,264.3],[1.515,175.5],[1.592,110.9],[1.67,77.1],[1.748,55.47],[1.825,39.99],[1.903,26.28],[1.981,0]],"totImpulseNs":697.4,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":354.9,"burnTimeS":1.91,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J355","dataFiles":2,"designation":"J355-BG","diameter":54,"impulseClass":"J","length":719,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":803.1,"motorId":"5f4294d2000231000000010f","propWeightG":450,"samples":[[0,0],[0.001,562.4],[0.1773,501.1],[0.201,286.3],[0.4349,286.3],[0.6891,337.5],[0.7027,501.1],[0.8078,490.8],[1.004,521.5],[1.218,419.3],[1.313,429.5],[1.377,460.2],[1.499,429.5],[1.547,225],[1.642,122.7],[1.911,0]],"totImpulseNs":678.9,"totalWeightG":1564,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":338.7,"burnTimeS":2.95,"caseInfo":"AMW 54-1050","certOrg":"National Association of Rocketry","commonName":"J357","dataFiles":2,"designation":"WT-54-1050","diameter":54,"impulseClass":"J","infoUrl":"http://nar.org/SandT/pdf/Animal/J357.pdf","length":326,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":402.4,"motorId":"5f4294d20002310000000110","propInfo":"White Wolf","propWeightG":548.1,"samples":[[0,0],[0.02,129.6],[0.03,205.9],[0.05,265],[0.06,316.5],[0.09,326.1],[0.13,314.6],[0.18,301.3],[0.24,299.3],[0.35,312.7],[0.5,326.1],[0.66,333.7],[0.87,345.1],[1.07,358.5],[1.46,383.2],[1.77,398.4],[1.86,400.4],[1.98,402.4],[2.18,398.4],[2.29,390.8],[2.41,369.9],[2.51,354.7],[2.55,352.8],[2.6,347],[2.65,335.6],[2.69,310.8],[2.75,249.7],[2.81,175.4],[2.84,108.7],[2.9,53.38],[2.92,20.98],[2.95,0]],"totImpulseNs":998.4,"totalWeightG":1210,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":340.8,"burnTimeS":2.69,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J358","dataFiles":2,"designation":"J358-BG","diameter":54,"impulseClass":"J","length":922,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":1147,"motorId":"5f4294d20002310000000111","propWeightG":450,"samples":[[0,0],[0.008475,726],[0.09322,726],[0.1102,501.1],[0.4831,480.6],[0.5508,398.8],[2.237,286.3],[2.322,153.4],[2.449,112.5],[2.69,0]],"totImpulseNs":913.9,"totalWeightG":1743,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":360,"burnTimeS":1.9,"caseInfo":"Pro38-6G","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J360","dataFiles":2,"designation":"J360","diameter":38,"impulseClass":"J","length":419,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":828,"motorId":"5f4294d20002310000000112","propWeightG":413.1,"samples":[[0,0],[0.041,618.9],[0.124,616.6],[0.207,563.8],[0.291,557.7],[0.374,558.4],[0.457,562.1],[0.541,561.3],[0.624,563.2],[0.708,565.3],[0.793,566.6],[0.876,549.4],[0.959,529.6],[1.043,511.1],[1.126,483.3],[1.209,445.4],[1.293,421.7],[1.377,378.3],[1.461,261.6],[1.545,197.4],[1.628,146.6],[1.711,101.8],[1.795,78.04],[1.878,47.85],[1.961,31.86],[2.046,9.22],[2.13,0]],"totImpulseNs":826,"totalWeightG":709.2,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":365,"burnTimeS":3.16,"caseInfo":"AMW 54-1400","certOrg":"National Association of Rocketry","commonName":"J365","dataFiles":2,"designation":"SK-54-1400","diameter":54,"impulseClass":"J","length":403,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d20002310000000113","propInfo":"Skidmark","propWeightG":702.3,"samples":[[0,0],[0.029,389.7],[0.123,360.2],[0.218,334.2],[0.376,326.1],[0.534,334.2],[0.692,341.7],[0.85,347.7],[1.007,359.4],[1.165,370],[1.323,383.3],[1.481,399.2],[1.639,417.5],[1.797,443.7],[1.955,472.7],[2.112,501.7],[2.27,497.1],[2.428,425.4],[2.586,349],[2.744,262.1],[2.902,107.1],[3.06,41.82],[3.157,0]],"sparky":true,"totImpulseNs":1125,"totalWeightG":1459,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":365.6,"burnTimeS":2.82,"caseInfo":"AMW 54-1050","certOrg":"National Association of Rocketry","commonName":"J370","dataFiles":2,"designation":"GG-54-1050","diameter":54,"impulseClass":"J","infoUrl":"http://nar.org/SandT/pdf/Animal/J370.pdf","length":326,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":458.5,"motorId":"5f4294d20002310000000114","propInfo":"Green Gorilla","propWeightG":598.3,"samples":[[0,0],[0.008,185.5],[0.024,149.5],[0.063,225.3],[0.087,272.6],[0.122,304.8],[0.158,304.8],[0.273,335.2],[0.431,363.8],[0.573,390.4],[0.707,413.2],[0.877,428.5],[1.019,441.9],[1.126,441.9],[1.224,458.5],[1.284,444],[1.386,440.2],[1.572,438.5],[1.651,438.6],[1.813,417.8],[2.022,404.7],[2.141,385.9],[2.212,385.9],[2.255,374.6],[2.299,387.9],[2.362,357.6],[2.401,384.2],[2.421,348.2],[2.457,316.1],[2.559,251.8],[2.697,115.6],[2.753,45.62],[2.82,0]],"totImpulseNs":1031,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":382,"burnTimeS":2.73,"caseInfo":"Pro54-3G","certOrg":"Canadian Association of Rocketry","commonName":"J380","dataFiles":2,"delays":"6,7,8,9,10,11,12,13,14,15,16","designation":"1043J380-16A","diameter":54,"impulseClass":"J","length":320,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":434.6,"motorId":"5f4294d20002310000000115","propInfo":"Smoky Sam","propWeightG":769,"samples":[[0,0],[0.05,368.5],[0.3,348.3],[0.6,378.8],[0.9,400.9],[1.2,419.5],[1.5,433.1],[1.8,434.6],[2.1,408.8],[2.4,369.9],[2.56,410.6],[2.59,297.8],[2.71,45.25],[2.73,0]],"totImpulseNs":1043,"totalWeightG":1293,"type":"reload","updatedOn":"2021-06-13"},{"availability":"OOP","avgThrustN":390,"burnTimeS":3.28,"caseInfo":"RMS-54/1280","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J390","dataFiles":2,"designation":"J390H-TURBO","diameter":54,"impulseClass":"J","length":709,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d20002310000000116","propWeightG":391,"samples":[[0,0],[0.01546,440.4],[0.1005,550.5],[0.1932,546.1],[0.3014,656.2],[0.5023,647.4],[0.9737,581.4],[1.484,471.2],[1.986,378.8],[2.179,334.7],[2.303,255.4],[2.496,158.6],[3.014,57.25],[3.5,0]],"totImpulseNs":1280,"type":"hybrid","updatedOn":"2022-06-15"},{"availability":"OOP","avgThrustN":400,"burnTimeS":2.6,"caseInfo":"AMW 54-1050","certOrg":"National Association of Rocketry","commonName":"J400","dataFiles":2,"designation":"RR-54-1050","diameter":54,"impulseClass":"J","infoUrl":"http://nar.org/SandT/pdf/Animal/J400.pdf","length":326,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d20002310000000117","propInfo":"Red Rhino","propWeightG":558,"samples":[[0,0],[0.043,246.6],[0.06,317.4],[0.081,344.7],[0.107,358.4],[0.15,356.1],[0.201,365.2],[0.308,392.5],[0.568,435.7],[0.863,458.3],[1.094,469.2],[1.209,467.2],[1.466,460.1],[1.705,444],[1.923,423.3],[2.132,409.4],[2.303,413.8],[2.402,420.6],[2.47,413.8],[2.517,395.4],[2.543,347.4],[2.568,265.2],[2.598,128.2],[2.615,68.8],[2.632,25.4],[2.66,0]],"totImpulseNs":1100,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":402.1,"burnTimeS":1.75,"caseInfo":"Pro38-6G","certOrg":"Canadian Association of Rocketry","commonName":"J400","dataFiles":2,"delays":"7,9,11,13,16","designation":"700J400-16A","diameter":38,"impulseClass":"J","length":419,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":482.1,"motorId":"5f4294d20002310000000118","propInfo":"Smoky Sam","propWeightG":392,"samples":[[0,0],[0.05,451.8],[0.2,461.1],[0.31,465.8],[0.44,463.5],[0.6,477.5],[0.8,482.1],[1,461.3],[1.2,433.1],[1.35,402.8],[1.4,382.9],[1.47,321],[1.55,258],[1.6,178.6],[1.73,14.58],[1.75,0]],"totImpulseNs":700,"totalWeightG":702,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":405,"burnTimeS":1.93,"caseInfo":"38-800","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J405","dataFiles":2,"designation":"J405S","diameter":38,"impulseClass":"J","length":476,"manufacturer":"Kosdon by AeroTech","manufacturerAbbrev":"KBA","maxThrustN":518,"motorId":"5f4294d20002310000000119","propWeightG":367,"samples":[[0,0],[0.009,528.5],[0.024,488.9],[0.046,462.4],[0.136,462.4],[0.268,458],[0.986,453.6],[1.421,444.8],[1.523,255.4],[1.697,92.49],[1.93,0]],"totImpulseNs":722,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":415,"burnTimeS":2.88,"caseInfo":"RMS-54/1280","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J415","dataFiles":2,"delays":"6,8,10,12,14","designation":"J415W","diameter":54,"impulseClass":"J","length":314,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":732.8,"motorId":"5f4294d2000231000000011a","propInfo":"White Lightning","propWeightG":693.3,"samples":[[0,0],[0.065,431.3],[0.196,452.4],[0.327,489.9],[0.458,513.5],[0.591,523.2],[0.723,531.4],[0.854,542.2],[0.985,542.7],[1.118,549.8],[1.25,553.9],[1.381,537.3],[1.512,512.1],[1.645,517.3],[1.777,498.1],[1.908,473.4],[2.04,444.2],[2.172,413.2],[2.304,384.9],[2.435,360.6],[2.567,297.6],[2.699,178.3],[2.831,89.89],[2.962,43.07],[3.094,19.13],[3.226,8.995],[3.358,0]],"totImpulseNs":1232,"totalWeightG":1168,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":411,"burnTimeS":2.75,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J416","dataFiles":2,"designation":"J416-SP","diameter":54,"impulseClass":"J","length":922,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":1038,"motorId":"5f4294d2000231000000011b","samples":[[0,0],[0.001,787.4],[0.07727,777.2],[0.2129,572.6],[0.4332,531.7],[0.8654,511.3],[1.264,480.6],[1.823,470.4],[2.009,347.7],[2.137,276.1],[2.247,184.1],[2.408,81.81],[2.751,0]],"sparky":true,"totImpulseNs":1130,"totalWeightG":1700,"type":"hybrid","updatedOn":"2019-04-18"},{"availability":"regular","avgThrustN":420,"burnTimeS":1.567,"caseInfo":"RMS-38/720","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J420","dataFiles":2,"delays":"4,6,8,10","designation":"J420R","diameter":38,"impulseClass":"J","length":337,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d2000231000000011c","propInfo":"Redline","propWeightG":345,"samples":[[0,0],[0.031,61.08],[0.095,563.5],[0.16,525.3],[0.224,521.2],[0.288,527.4],[0.352,537.1],[0.418,535.1],[0.481,534.6],[0.545,530.2],[0.61,526.4],[0.674,517.2],[0.738,510.3],[0.802,500.9],[0.868,479.4],[0.931,460.7],[0.995,438.6],[1.06,409.6],[1.124,383.5],[1.188,361],[1.252,339.7],[1.318,319.2],[1.381,296.7],[1.445,195.2],[1.51,61.98],[1.575,7.22],[1.64,0]],"totImpulseNs":658,"totalWeightG":649.6,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":440,"burnTimeS":1.5,"caseInfo":"AMW 38-640","certOrg":"National Association of Rocketry","commonName":"J440","dataFiles":2,"designation":"BB-38-640","diameter":38,"impulseClass":"J","length":370,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d2000231000000011d","propInfo":"Blue Baboon","propWeightG":313.1,"samples":[[0,0],[0.007,468.5],[0.022,510],[0.037,527.7],[0.052,532.8],[0.082,530.2],[0.127,525.6],[0.202,521.6],[0.277,519.8],[0.352,521.5],[0.426,525.4],[0.501,531.2],[0.576,538.7],[0.651,541.8],[0.726,538.5],[0.801,531.1],[0.876,516.2],[0.95,494.9],[1.025,477.3],[1.1,433.3],[1.175,313.9],[1.25,187.5],[1.325,101.5],[1.4,45.75],[1.474,22.08],[1.497,0]],"totImpulseNs":653,"totalWeightG":698.5,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":459.1,"burnTimeS":2.33,"caseInfo":"AMW 54-1050","certOrg":"National Association of Rocketry","commonName":"J450","dataFiles":3,"designation":"ST-54-1050","diameter":54,"impulseClass":"J","infoUrl":"http://nar.org/SandT/pdf/Animal/J450.pdf","length":326,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":563.2,"motorId":"5f4294d2000231000000011e","propInfo":"Super Tiger","propWeightG":533.1,"samples":[[0,0],[0.009,251.6],[0.016,376.1],[0.03,413.4],[0.051,430.8],[0.094,423.3],[0.162,413.1],[0.262,395.6],[0.402,420.2],[0.495,444.9],[0.805,504.1],[1.048,536],[1.223,550.6],[1.299,563.2],[1.334,555.3],[1.47,560],[1.588,559.8],[1.764,547],[1.921,516.8],[1.993,496.7],[2.025,499.2],[2.047,479.2],[2.086,414.4],[2.115,344.5],[2.141,252.3],[2.177,140.2],[2.213,82.78],[2.239,50.35],[2.271,27.86],[2.296,12.86],[2.33,0]],"totImpulseNs":1070,"totalWeightG":1196,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":460,"burnTimeS":1.81,"caseInfo":"RMS-54/852","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J460","dataFiles":2,"delays":"6,8,10,12,14","designation":"J460T","diameter":54,"impulseClass":"J","length":230,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":870.5,"motorId":"5f4294d2000231000000011f","propInfo":"Blue Thunder","propWeightG":415.4,"samples":[[0,0],[0.041,500.9],[0.125,509.4],[0.209,516.4],[0.294,527.8],[0.379,535.1],[0.464,541.9],[0.548,545.8],[0.633,545.7],[0.718,544.8],[0.802,540.3],[0.887,533.7],[0.972,526.3],[1.056,511],[1.141,492.5],[1.225,475],[1.31,457],[1.395,437.2],[1.479,418.1],[1.565,403.2],[1.649,339.2],[1.733,203.9],[1.819,102.6],[1.903,49.3],[1.987,9.538],[2.073,2.155],[2.158,0]],"totImpulseNs":805.5,"totalWeightG":789,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":480,"burnTimeS":2.4,"caseInfo":"AMW 54-1050","certOrg":"National Association of Rocketry","commonName":"J480","dataFiles":2,"designation":"BB-54-1050","diameter":54,"impulseClass":"J","infoUrl":"http://nar.org/SandT/pdf/Animal/J480.pdf","length":326,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d20002310000000120","propInfo":"Blue Baboon","propWeightG":556,"samples":[[0,0],[0.015,225.4],[0.041,348.2],[0.071,388.1],[0.194,422.5],[0.385,459.5],[0.699,502.3],[0.968,528],[1.2,536.6],[1.454,543.1],[1.674,533.8],[1.887,522.3],[2.044,519.4],[2.108,525.1],[2.164,528],[2.197,488.1],[2.25,419.5],[2.283,333.9],[2.328,231.2],[2.354,176.9],[2.392,111.3],[2.418,68.5],[2.436,37.11],[2.49,0]],"totImpulseNs":1165,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":500,"burnTimeS":1.3,"caseInfo":"AMW 38-650","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J500","dataFiles":2,"designation":"J500ST","diameter":38,"impulseClass":"J","length":370,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":779,"motorId":"5f4294d20002310000000121","propWeightG":326.5,"samples":[[0,0],[0.006,444.8],[0.025,475.7],[0.04,418.4],[0.053,466.8],[0.059,409.6],[0.071,458],[0.077,409.6],[0.1,444.8],[0.127,506.5],[0.204,590.2],[0.25,645],[0.3,678.2],[0.34,709.1],[0.402,735.5],[0.445,766.3],[0.516,783.9],[0.6,787.3],[0.637,770.7],[0.68,744.3],[0.76,621],[0.859,475.7],[1.005,303.9],[1.122,171.8],[1.227,52.85],[1.3,0]],"totImpulseNs":660,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":525,"burnTimeS":2.1,"caseInfo":"54/1200","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J525","dataFiles":2,"designation":"J525-LW","diameter":54,"impulseClass":"J","length":330,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":640.8,"motorId":"5f4294d20002310000000122","propInfo":"Loki White","propWeightG":625,"samples":[[0,0],[0.01,210.9],[0.03,499.3],[0.05,628.5],[0.1,594],[0.13,568.2],[0.15,559.6],[0.2,555.3],[0.3,572.5],[0.4,589.7],[0.5,606.9],[0.6,624.2],[0.7,637.1],[0.8,645.7],[0.9,650],[1,658.6],[1.1,637.1],[1.2,628.5],[1.3,615.5],[1.41,586.3],[1.52,561.5],[1.67,536.8],[1.78,517.7],[1.85,485.4],[1.92,91.37],[2,0]],"totImpulseNs":1113,"totalWeightG":1240,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":528,"burnTimeS":1.2,"caseInfo":"38/740","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J528","dataFiles":2,"delays":"5,8,10,13,17","designation":"J528-LW","diameter":38,"impulseClass":"J","infoUrl":"https://www.lokiresearch.com/images/Documents/38mm%20White.pdf","length":419,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":896,"motorId":"5f4294d20002310000000123","propInfo":"Loki White","propWeightG":374,"samples":[[0,0],[0.01,704.2],[0.02,1019],[0.03,983.9],[0.05,881.1],[0.1,797.5],[0.15,771.7],[0.17,765.7],[0.21,765.7],[0.25,778.2],[0.42,789.3],[0.51,771.6],[0.6,756.9],[0.66,751],[0.71,762.8],[0.76,698],[0.8,665.6],[0.84,612.6],[0.92,488.9],[0.95,385.8],[1.02,282.7],[1.06,179.7],[1.14,53.01],[1.19,35.34],[1.23,32.2],[1.25,0]],"totImpulseNs":741,"totalWeightG":745,"type":"reload","updatedOn":"2021-07-24"},{"availability":"regular","avgThrustN":540,"burnTimeS":2.15,"caseInfo":"RMS-54/1280","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J540","dataFiles":2,"delays":"6,8,10,12,14","designation":"J540R","diameter":54,"impulseClass":"J","length":314,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d20002310000000124","propInfo":"Redline","propWeightG":679,"samples":[[0,0],[0.044,498.8],[0.134,639.6],[0.224,649.3],[0.314,658],[0.404,664],[0.494,666.9],[0.584,663.7],[0.675,658.4],[0.765,651.2],[0.855,638.5],[0.945,626.4],[1.035,612.6],[1.126,590.1],[1.216,562.4],[1.306,536.9],[1.396,511.6],[1.486,490.4],[1.576,469],[1.667,451.3],[1.758,430.2],[1.847,414.5],[1.937,398.1],[2.027,305.9],[2.118,55.54],[2.208,1.523],[2.299,0]],"totImpulseNs":1161,"totalWeightG":1084,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":497,"burnTimeS":1.6,"caseInfo":"38 48 XF HP (735CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J555","dataFiles":2,"designation":"J555-HP","diameter":38,"impulseClass":"J","length":1227,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":2500,"motorId":"5f4294d20002310000000125","propWeightG":166,"samples":[[0,0],[0.001,931],[0.05917,1345],[0.2784,810.3],[1.173,241.4],[1.278,68.96],[1.319,51.72],[1.601,0]],"totImpulseNs":795,"totalWeightG":1132,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":509.3,"burnTimeS":1.91,"caseInfo":"RMS-38/1080","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J570","dataFiles":2,"delays":"4,6,8,10","designation":"J570W","diameter":38,"impulseClass":"J","length":479,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1143,"motorId":"5f4294d20002310000000126","propInfo":"White Lightning","propWeightG":535.8,"samples":[[0,0],[0.039,1150],[0.119,1043],[0.199,960.9],[0.279,900],[0.36,837.8],[0.441,792.8],[0.521,735.5],[0.602,685.9],[0.682,649.6],[0.762,608.8],[0.844,597.4],[0.924,568.9],[1.004,548.6],[1.084,505.1],[1.165,484.6],[1.246,452.3],[1.326,362.4],[1.406,298],[1.487,262.4],[1.568,195.7],[1.648,156.7],[1.729,124.6],[1.809,113.7],[1.89,69.81],[1.971,46.02],[2.052,0]],"totImpulseNs":973.1,"totalWeightG":902,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":605,"burnTimeS":1.3,"caseInfo":"38-800","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J605","dataFiles":2,"designation":"J605F","diameter":38,"impulseClass":"J","length":476,"manufacturer":"Kosdon by AeroTech","manufacturerAbbrev":"KBA","maxThrustN":882,"motorId":"5f4294d20002310000000127","propWeightG":367,"samples":[[0,0],[0.024,886.3],[0.037,704.7],[0.077,660.6],[0.438,704.7],[0.506,715.7],[0.59,710.2],[0.853,655.1],[0.973,594.6],[1.041,412.9],[1.091,324.8],[1.177,132.1],[1.3,0]],"totImpulseNs":737,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":633.7,"burnTimeS":1.72,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J642","dataFiles":2,"designation":"J642-BG","diameter":54,"impulseClass":"J","length":922,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":1494,"motorId":"5f4294d20002310000000128","propWeightG":450,"samples":[[0,0],[0.00678,1483],[0.07797,997],[0.4712,1304],[0.5424,818.1],[0.6339,741.4],[0.7424,588],[1.251,485.7],[1.298,332.3],[1.397,179],[1.475,51.13],[1.72,0]],"totImpulseNs":1093,"totalWeightG":1791,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":696.5,"burnTimeS":1.76,"caseInfo":"RMS-54/1280","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J800","dataFiles":2,"delays":"6,8,10,12,14","designation":"J800T","diameter":54,"impulseClass":"J","length":316,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1001,"motorId":"5f4294d20002310000000129","propInfo":"Blue Thunder","propWeightG":618,"samples":[[0,0],[0.04,841.3],[0.121,818.5],[0.203,776.4],[0.285,784.3],[0.367,785.3],[0.449,783.3],[0.531,782.5],[0.612,780],[0.695,773.7],[0.777,765.3],[0.858,755.5],[0.941,744.8],[1.023,733.1],[1.105,719.9],[1.187,702.2],[1.269,685.4],[1.351,668.3],[1.433,650.3],[1.515,630.5],[1.597,615.5],[1.679,470.3],[1.76,256.6],[1.843,108.7],[1.925,15.01],[2.007,1.249],[2.09,0]],"totImpulseNs":1229,"totalWeightG":1086,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":758,"burnTimeS":1.2,"caseInfo":"38 48 XXF HP(685CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J800","dataFiles":2,"designation":"J800-HP","diameter":38,"impulseClass":"J","length":1227,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":4840,"motorId":"5f4294d2000231000000012a","propWeightG":166,"samples":[[0,0],[0.002237,1831],[0.5235,889.6],[0.6398,650.1],[0.7405,444.8],[0.8233,273.7],[0.906,154],[0.9978,136.9],[1.2,0]],"totImpulseNs":928,"totalWeightG":1148,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":185,"burnTimeS":6.87,"caseInfo":"RMS-54/1706","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K185","dataFiles":2,"delays":"6,8,10,12,14","designation":"K185W","diameter":54,"impulseClass":"K","length":437,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":404.7,"motorId":"5f4294d2000231000000012d","propInfo":"White Lightning","propWeightG":836.8,"samples":[[0,0],[0.15,279.1],[0.452,308.2],[0.754,328.4],[1.056,338.9],[1.359,339.7],[1.663,333.2],[1.965,321.9],[2.267,309.7],[2.57,293.3],[2.873,271.5],[3.175,247.2],[3.477,216.9],[3.78,187],[4.083,161.1],[4.385,138.1],[4.688,117.7],[4.991,99.37],[5.294,82.76],[5.596,68.43],[5.898,55.13],[6.201,44.16],[6.504,34.21],[6.806,25.06],[7.108,16.88],[7.411,9.2],[7.715,0]],"totImpulseNs":1417,"totalWeightG":1434,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":235,"burnTimeS":7.04,"caseInfo":"54 48 S BG","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K234","dataFiles":2,"designation":"K234-BG","diameter":54,"impulseClass":"K","length":1263,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":477.5,"motorId":"5f4294d2000231000000012e","propWeightG":450,"samples":[[0,0],[0.001,92.39],[0.2359,396.9],[0.9742,338.7],[5.974,171.1],[6.052,106.1],[6.198,78.7],[6.377,54.75],[7.051,0]],"totImpulseNs":1657,"totalWeightG":2063,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":240,"burnTimeS":5.383,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K240","dataFiles":2,"designation":"835CC125J-K240","diameter":81,"impulseClass":"K","length":552,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d2000231000000012f","propWeightG":799.2,"samples":[[0,0],[0.131,278],[0.396,329.6],[0.66,338],[0.925,334.1],[1.191,326.2],[1.456,319.7],[1.721,315.2],[1.985,311.2],[2.25,302.9],[2.516,305.9],[2.781,290],[3.046,281.8],[3.31,273.3],[3.575,268.9],[3.841,255.7],[4.106,251.1],[4.371,234.8],[4.635,160],[4.9,96.54],[5.166,73.37],[5.431,55.48],[5.696,40.93],[5.96,29.54],[6.225,21.25],[6.491,14.79],[6.756,0]],"totImpulseNs":1292,"totalWeightG":1807,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":240,"burnTimeS":7.686,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K240","dataFiles":1,"designation":"K240H","diameter":64,"impulseClass":"K","length":908,"manufacturer":"R.A.T.T. Works","manufacturerAbbrev":"RATT","motorId":"5f4294d20002310000000130","propWeightG":1292,"samples":[[0,0],[0.164,414],[0.493,393],[0.822,370.8],[1.151,362.1],[1.48,337.8],[1.809,321.4],[2.139,285.1],[2.468,280],[2.798,275.1],[3.128,278.4],[3.457,274.4],[3.786,252.3],[4.116,272.9],[4.445,264.7],[4.774,255.6],[5.103,210.3],[5.433,164],[5.764,126.2],[6.093,98.02],[6.422,74.49],[6.751,55.62],[7.08,40.78],[7.409,29.62],[7.739,21.91],[8.069,17.21],[8.399,0]],"totImpulseNs":1845,"totalWeightG":2814,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":250,"burnTimeS":6.48,"caseInfo":"54/2000","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K250","dataFiles":2,"designation":"K250-LW","diameter":54,"impulseClass":"K","length":499,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":728.3,"motorId":"5f4294d20002310000000131","propInfo":"Loki White","propWeightG":975,"samples":[[0,0],[0.03,800],[0.1,682],[0.125,574],[0.15,476],[0.175,447],[0.25,385],[0.45,340],[0.6,320],[1,313],[1.5,300],[2,297],[2.5,303],[3,294],[3.5,287],[4,248],[4.5,222],[5,187],[5.5,147],[6,114],[6.5,62],[7,0]],"totImpulseNs":1608,"totalWeightG":1791,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":250,"burnTimeS":9,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K250","dataFiles":2,"delays":"P","designation":"K250W","diameter":54,"impulseClass":"K","length":673,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":545.8,"motorId":"5f4294d20002310000000132","propInfo":"White Lightning","propWeightG":1434,"samples":[[0,0],[0.199,365.3],[0.599,403.3],[0.999,418.7],[1.4,409.8],[1.801,408.9],[2.201,412.1],[2.602,412],[3.003,409.5],[3.403,393.2],[3.804,373.6],[4.205,348.9],[4.605,328.5],[5.006,307.2],[5.407,281.5],[5.807,249],[6.208,217.2],[6.609,185.9],[7.009,149.2],[7.41,119.8],[7.811,92.1],[8.211,69.73],[8.613,52.61],[9.014,35.88],[9.414,16.73],[9.815,4.086],[10.22,0]],"totImpulseNs":2353,"totalWeightG":2211,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":268.9,"burnTimeS":6.22,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K265","dataFiles":2,"designation":"K265-SP","diameter":54,"impulseClass":"K","length":1219,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":777.1,"motorId":"5f4294d20002310000000134","samples":[[0,0],[0.001,470.4],[2.442,347.7],[3.916,225],[4.781,173.8],[5.137,112.5],[5.34,51.13],[6.261,0]],"sparky":true,"totImpulseNs":1684,"totalWeightG":1814,"type":"hybrid","updatedOn":"2019-04-18"},{"availability":"regular","avgThrustN":293,"burnTimeS":6.5,"caseInfo":"75 40 S BS (2050CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K300","dataFiles":2,"designation":"K300-BS","diameter":75,"impulseClass":"K","length":1016,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":690,"motorId":"5f4294d20002310000000135","propWeightG":580,"samples":[[0,0],[0.001,431.1],[0.3254,526.9],[0.9853,479],[1.175,369.5],[5.001,280.6],[5.191,171.1],[5.359,102.7],[5.627,54.75],[5.795,27.37],[6.501,0]],"totImpulseNs":1909,"totalWeightG":4059,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":320.5,"burnTimeS":4.89,"caseInfo":"54 48 M BG (1490CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K321","dataFiles":2,"designation":"K321-BG","diameter":54,"impulseClass":"K","length":1220,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":738,"motorId":"5f4294d20002310000000136","propWeightG":450,"samples":[[0,0],[0.005593,219],[0.2181,410.6],[0.9732,718.6],[0.9899,732.2],[1.057,444.8],[1.488,403.8],[3.971,232.7],[4.116,88.96],[4.234,54.75],[4.346,54.75],[4.9,0]],"totImpulseNs":1570,"totalWeightG":2043,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":350,"burnTimeS":6.36,"caseInfo":"54/2800","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K350","dataFiles":2,"designation":"K350-LW","diameter":54,"impulseClass":"K","length":736,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":1329,"motorId":"5f4294d20002310000000137","propInfo":"Loki White","propWeightG":1406,"samples":[[0,0],[0.025,1329],[0.0375,1061],[0.1,1006],[0.15,891],[0.2,768],[0.4,571],[0.5,542],[0.75,486],[1,486],[1.25,477],[1.5,481],[2.506,460],[3.005,427],[3.5,375],[4,333],[4.5,297],[5,249],[5.5,210],[6,164],[6.5,98],[7,0]],"totImpulseNs":2527,"totalWeightG":2540,"type":"reload","updatedOn":"2020-09-03"},{"availability":"OOP","avgThrustN":365,"burnTimeS":4.55,"caseInfo":"AMW 75-1700","certOrg":"National Association of Rocketry","commonName":"K365","dataFiles":2,"designation":"RR-75-1700","diameter":75,"impulseClass":"K","infoUrl":"http://nar.org/SandT/pdf/Animal/K365.pdf","length":244,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d20002310000000138","propInfo":"Red Rhino","propWeightG":946,"samples":[[0,0],[0.049,138.2],[0.068,381.2],[0.084,454.8],[0.106,481.5],[0.164,488.2],[0.291,514.9],[0.435,546],[0.666,561.5],[0.868,565.7],[1.082,565.5],[1.296,550.1],[1.591,529.9],[1.805,509.7],[1.828,536.5],[1.886,498.6],[2.124,467.2],[2.501,411.4],[2.924,328.7],[3.296,241.6],[3.638,172.3],[3.969,100.8],[4.195,56.1],[4.265,51.61],[4.346,35.96],[4.433,15.86],[4.51,0]],"totImpulseNs":1680,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":400,"burnTimeS":3.5,"caseInfo":"54X403(1400)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K400","dataFiles":2,"delays":"S,M,L","designation":"K400S","diameter":54,"impulseClass":"K","length":403,"manufacturer":"Kosdon by AeroTech","manufacturerAbbrev":"KBA","maxThrustN":578.2,"motorId":"5f4294d20002310000000139","propWeightG":721.8,"samples":[[0,0],[0.074,465.9],[0.225,441.9],[0.377,442.4],[0.529,445.5],[0.681,449],[0.833,451.9],[0.985,454.5],[1.138,456.9],[1.29,458.2],[1.442,457],[1.594,455.6],[1.746,451.8],[1.897,446.4],[2.048,438.8],[2.2,429.4],[2.352,419],[2.504,408.3],[2.656,397.6],[2.808,388],[2.96,367.1],[3.113,263.7],[3.265,114.4],[3.417,46.24],[3.569,8.62],[3.721,2.401],[3.873,0]],"totImpulseNs":1386,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":379,"burnTimeS":6.4,"caseInfo":"75 40 S SP (2050CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K404","dataFiles":2,"designation":"K404-SP","diameter":75,"impulseClass":"K","length":1016,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":1036,"motorId":"5f4294d2000231000000013a","propWeightG":703,"samples":[[0,0],[0.01119,670.7],[4.631,335.3],[4.81,205.3],[4.922,130],[5.078,82.12],[5.268,41.06],[6.4,0]],"totImpulseNs":2441,"totalWeightG":4150,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":445,"burnTimeS":3.67,"caseInfo":"Pro54-4G","certOrg":"Canadian Association of Rocketry","commonName":"K445","dataFiles":2,"delays":"7,8,9,10,11,12,13,14,15,16,17","designation":"1635K445-17A","diameter":54,"impulseClass":"K","length":404,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":664.8,"motorId":"5f4294d2000231000000013b","propInfo":"Classic","propWeightG":792,"samples":[[0,0],[0.05,664.8],[0.19,640.7],[0.48,623],[1,576.3],[1.51,515.1],[2,442.7],[2.5,392.3],[3.02,350.9],[3.13,339.7],[3.31,210.9],[3.47,78.88],[3.67,0]],"totImpulseNs":1636,"totalWeightG":1398,"type":"reload","updatedOn":"2021-06-13"},{"availability":"OOP","avgThrustN":450,"burnTimeS":4.07,"caseInfo":"AMW 75-1700","certOrg":"National Association of Rocketry","commonName":"K450","dataFiles":2,"designation":"BB-75-1700","diameter":75,"impulseClass":"K","length":244,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d2000231000000013c","propInfo":"Blue Baboon","propWeightG":881.6,"samples":[[0,0],[0.03,78.9],[0.045,227.9],[0.064,450],[0.069,508.4],[0.094,555.2],[0.151,564],[0.362,625.4],[0.562,651.9],[0.825,660.6],[1.134,652.3],[1.453,626.1],[1.793,594.3],[2.113,539],[2.458,469.1],[2.798,384.5],[3.165,276.7],[3.201,279.6],[3.325,232.9],[3.51,171.8],[3.732,107.7],[3.861,58.02],[3.959,40.55],[4.036,20.15],[4.11,0]],"totImpulseNs":1845,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":439,"burnTimeS":3.7,"caseInfo":"75 32 S BG (1400CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K456","dataFiles":2,"designation":"K456-BG","diameter":75,"impulseClass":"K","length":813,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":1422,"motorId":"5f4294d2000231000000013d","propWeightG":580,"samples":[[0,0],[0.005593,681],[0.2125,896.5],[0.5034,775.9],[1.365,577.6],[1.527,525.9],[2.511,370.7],[2.668,129.3],[3.7,0]],"totImpulseNs":1628,"totalWeightG":3704,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":458,"burnTimeS":6,"caseInfo":"RMS-98/2560","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K458","dataFiles":2,"delays":"P","designation":"K458W","diameter":98,"impulseClass":"K","length":275,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":585.8,"motorId":"5f4294d2000231000000013e","propInfo":"White Lightning","propWeightG":1425,"samples":[[0,0],[0.133,294.9],[0.403,404.8],[0.674,462],[0.944,515.9],[1.214,555.1],[1.484,583.2],[1.755,600.3],[2.025,610.3],[2.295,618.5],[2.566,623.2],[2.835,618.9],[3.105,589.1],[3.376,546.3],[3.647,505],[3.917,451.4],[4.186,391.7],[4.457,338.4],[4.727,288.4],[4.997,245.8],[5.268,208.2],[5.539,178.2],[5.808,149.8],[6.078,62.93],[6.349,8.427],[6.62,2.562],[6.891,0]],"totImpulseNs":2465,"totalWeightG":3164,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":470,"burnTimeS":3.7,"caseInfo":"AMW 75-1700","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K470","dataFiles":2,"designation":"ST-75-1700","diameter":75,"impulseClass":"K","length":302,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":804,"motorId":"5f4294d2000231000000013f","propInfo":"Super Tiger","propWeightG":826,"samples":[[0,0],[0.028,699.3],[0.039,799.3],[0.09,765.8],[0.157,770.3],[0.258,785.9],[0.41,804],[0.572,794.4],[0.707,794.4],[0.886,792.2],[0.998,783.3],[1.15,752],[1.318,709.6],[1.447,656],[1.593,595.7],[1.728,522],[1.885,444.1],[2.092,354.9],[2.356,270.2],[2.664,187.6],[2.945,131.7],[3.27,78.06],[3.433,55.69],[3.478,48.99],[3.556,28.91],[3.7,0]],"totImpulseNs":1679,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":475,"burnTimeS":5.1,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K475","dataFiles":2,"designation":"K475","diameter":54,"impulseClass":"K","length":664,"manufacturer":"Ellis Mountain","manufacturerAbbrev":"Ellis","maxThrustN":885.9,"motorId":"5f4294d20002310000000140","propWeightG":1133,"samples":[[0,0],[0.04637,797.2],[0.1546,616.6],[0.2782,585.8],[0.4791,568.1],[2.921,576.9],[3.292,568.1],[4.003,303.9],[4.513,224.6],[5.023,74.87],[5.5,0]],"totImpulseNs":2435,"totalWeightG":2168,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":474.1,"burnTimeS":2.94,"caseInfo":"AMW 54-1400","certOrg":"National Association of Rocketry","commonName":"K475","dataFiles":2,"designation":"WT-54-1400","diameter":54,"impulseClass":"K","infoUrl":"http://nar.org/SandT/pdf/Animal/K475.pdf","length":403,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":588.3,"motorId":"5f4294d20002310000000141","propInfo":"White Wolf","propWeightG":728.6,"samples":[[0,0],[0.022,127.8],[0.041,386],[0.063,548.3],[0.096,521.3],[0.134,499.1],[0.18,486.8],[0.285,486.8],[0.478,501.6],[0.731,523.7],[1.096,553.3],[1.433,578],[1.601,588.3],[1.756,582.7],[1.895,580.3],[1.958,575.3],[2.063,550.7],[2.209,518.8],[2.344,477.1],[2.495,418],[2.561,354.1],[2.582,334.4],[2.599,332],[2.62,297.5],[2.67,226.2],[2.707,157.4],[2.74,98.35],[2.799,49.18],[2.853,17.21],[2.94,0]],"totImpulseNs":1394,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":485,"burnTimeS":3.5,"caseInfo":"RMS-54/1280","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K485","dataFiles":2,"designation":"K485H-3JET","diameter":54,"impulseClass":"K","length":699,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":851.1,"motorId":"5f4294d20002310000000142","propWeightG":923.4,"samples":[[0,0],[0.075,454.5],[0.227,568.7],[0.38,831.3],[0.533,825.6],[0.686,795.9],[0.84,759.5],[0.992,727.2],[1.145,680.1],[1.298,653.1],[1.451,627.3],[1.604,601.5],[1.756,576.3],[1.909,542],[2.063,479.1],[2.216,394.2],[2.369,346.7],[2.521,307.4],[2.674,276.3],[2.827,216.6],[2.98,146],[3.133,106.8],[3.285,81.23],[3.439,52.1],[3.592,37.38],[3.745,29.46],[3.898,0]],"totImpulseNs":1687,"totalWeightG":2220,"type":"hybrid","updatedOn":"2022-06-15"},{"availability":"regular","avgThrustN":514,"burnTimeS":4.84,"caseInfo":"Pro75-2G","certOrg":"Canadian Association of Rocketry","commonName":"K510","dataFiles":3,"designation":"2486K510-P","diameter":75,"impulseClass":"K","length":350,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":689.8,"motorId":"5f4294d20002310000000143","propInfo":"Classic","propWeightG":1197,"samples":[[0,0],[0.04,394.4],[0.07,617.7],[0.1,645.2],[0.21,658.2],[0.35,669.2],[0.53,667.7],[0.82,661.6],[1.18,626.9],[1.72,588.5],[2.15,557.7],[2.39,542.3],[2.9,492.9],[3.07,470.3],[3.56,426.8],[3.98,399],[4.32,394],[4.48,380.6],[4.6,364.2],[4.65,290.9],[4.8,91.23],[4.84,45.82],[4.84,0]],"totImpulseNs":2486,"totalWeightG":2590,"type":"reload","updatedOn":"2021-06-13"},{"availability":"OOP","avgThrustN":526.9,"burnTimeS":2.66,"caseInfo":"AMW 54-1400","certOrg":"National Association of Rocketry","commonName":"K530","dataFiles":2,"designation":"GG-54-1400","diameter":54,"impulseClass":"K","infoUrl":"http://nar.org/SandT/pdf/Animal/K530.pdf","length":403,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":657.2,"motorId":"5f4294d20002310000000144","propInfo":"Green Gorilla","propWeightG":796.7,"samples":[[0,0],[0.013,129.8],[0.054,171.9],[0.096,284.1],[0.138,392.9],[0.171,456],[0.217,501.7],[0.238,498.1],[0.326,508.7],[0.542,564.7],[0.755,613.8],[1.01,645.4],[1.17,657.2],[1.273,648.9],[1.51,638.4],[1.656,634.9],[1.702,606.8],[1.803,606.8],[1.857,585.8],[1.936,589.3],[1.974,575.2],[2.015,589.3],[2.04,564.7],[2.132,536.7],[2.207,540.3],[2.291,522.7],[2.357,487.6],[2.42,375.3],[2.478,242],[2.529,140.4],[2.583,66.65],[2.66,0]],"totImpulseNs":1402,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":529,"burnTimeS":2.67,"caseInfo":"Pro54-4G","certOrg":"Canadian Association of Rocketry","commonName":"K530","dataFiles":2,"delays":"6,7,8,9,10,11,12,13,14,15,16","designation":"1412K530-16A","diameter":54,"impulseClass":"K","length":404,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":596.4,"motorId":"5f4294d20002310000000145","propInfo":"Smoky Sam","propWeightG":1025,"samples":[[0,0],[0.05,533.6],[0.09,504],[0.29,514.1],[0.6,534.3],[0.9,557.4],[1.2,577.6],[1.5,587.7],[1.8,596.4],[2.1,535.4],[2.31,502.5],[2.47,551.6],[2.56,393.9],[2.6,274.4],[2.64,137.2],[2.67,0]],"totImpulseNs":1412,"totalWeightG":1640,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":396.8,"burnTimeS":3.879,"caseInfo":"RMS-54/1706","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K550","dataFiles":2,"delays":"6,8,10,12,14","designation":"K550W","diameter":54,"impulseClass":"K","length":410,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":655.3,"motorId":"5f4294d20002310000000146","propInfo":"White Lightning","propWeightG":889.1,"samples":[[0,0],[0.065,604.3],[0.196,642.6],[0.327,682.2],[0.458,733],[0.591,758.2],[0.723,780.3],[0.854,794.5],[0.985,797.9],[1.117,797.6],[1.249,773.8],[1.381,711.6],[1.512,646.5],[1.644,590.7],[1.775,537.5],[1.907,491],[2.04,445.8],[2.171,401.5],[2.302,364.3],[2.433,319.6],[2.566,255.6],[2.698,172.6],[2.829,103.5],[2.96,51.8],[3.092,26.81],[3.224,15.2],[3.356,0]],"totImpulseNs":1539,"totalWeightG":1487,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":555,"burnTimeS":2.36,"caseInfo":"AMW 54-1750","certOrg":"National Association of Rocketry","commonName":"K555","dataFiles":2,"designation":"SK-54-1750","diameter":54,"impulseClass":"K","length":492,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d20002310000000147","propInfo":"Skidmark","propWeightG":862,"samples":[[0,0],[0.063,507.3],[0.144,535.2],[0.226,559.8],[0.308,585.8],[0.389,607.2],[0.471,629],[0.553,664.6],[0.634,683.7],[0.716,697.6],[0.798,719.6],[0.879,756.5],[0.961,777.7],[1.043,789],[1.124,797.9],[1.206,801.7],[1.288,804.3],[1.369,799.4],[1.451,768],[1.533,704.5],[1.614,641.7],[1.696,568.7],[1.778,481],[1.859,401.6],[1.941,333.9],[2.023,277.2],[2.104,205],[2.186,129.4],[2.268,73.72],[2.349,22.38],[2.368,0]],"sparky":true,"totImpulseNs":1300,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":560,"burnTimeS":2.6,"caseInfo":"AMW 54-1400","certOrg":"National Association of Rocketry","commonName":"K560","dataFiles":2,"designation":"RR-54-1400","diameter":54,"impulseClass":"K","infoUrl":"http://nar.org/SandT/pdf/Animal/K560.pdf","length":430,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d20002310000000148","propInfo":"Red Rhino","propWeightG":750,"samples":[[0,0],[0.023,229.1],[0.046,415.1],[0.059,485.3],[0.078,512.3],[0.106,525.7],[0.154,523],[0.211,528.4],[0.261,536.5],[0.369,560.7],[0.511,587.7],[0.657,603.9],[0.77,612],[1.096,625.8],[1.358,620.1],[1.627,612],[1.839,603.9],[2.057,590.5],[2.218,598.5],[2.335,609.3],[2.385,601.2],[2.407,585],[2.426,533.8],[2.467,385.5],[2.507,283],[2.542,164.4],[2.576,67.4],[2.595,29.65],[2.62,0]],"totImpulseNs":1480,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":560,"burnTimeS":4.09,"caseInfo":"RMS-75/2560","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K560","dataFiles":2,"delays":"P","designation":"K560W","diameter":75,"impulseClass":"K","length":396,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":753.7,"motorId":"5f4294d20002310000000149","propInfo":"White Lightning","propWeightG":1425,"samples":[[0,0],[0.096,552.1],[0.29,645.4],[0.484,681.1],[0.679,716.2],[0.874,742.7],[1.069,764.8],[1.264,775.7],[1.458,785.9],[1.653,789.3],[1.848,789.1],[2.043,744.6],[2.237,676.9],[2.432,614.7],[2.627,557.9],[2.822,503.6],[3.017,455.5],[3.211,412],[3.406,373],[3.601,336],[3.796,307.3],[3.991,279.9],[4.185,223.5],[4.38,70.44],[4.575,10.03],[4.77,2.445],[4.965,0]],"totImpulseNs":2417,"totalWeightG":2744,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":574,"burnTimeS":3.59,"caseInfo":"Pro54-5G","certOrg":"Canadian Association of Rocketry","commonName":"K570","dataFiles":2,"delays":"7,8,9,10,11,12,13,14,15,16,17","designation":"2060K570-17A","diameter":54,"impulseClass":"K","length":488,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":892.7,"motorId":"5f4294d2000231000000014a","propInfo":"Classic","propWeightG":990,"samples":[[0,0],[0.04,892.7],[0.5,798],[1,738.7],[1.5,659.4],[2,586],[2.5,512.9],[2.97,417.2],[3.2,224.8],[3.47,67],[3.59,0]],"totImpulseNs":2063,"totalWeightG":1685,"type":"reload","updatedOn":"2021-06-13"},{"availability":"OOP","avgThrustN":559.1,"burnTimeS":3.04,"caseInfo":"AMW 54-1750","certOrg":"National Association of Rocketry","commonName":"K570","dataFiles":2,"designation":"WT-54-1750","diameter":54,"impulseClass":"K","infoUrl":"http://nar.org/SandT/pdf/Animal/K570.pdf","length":492,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":751.5,"motorId":"5f4294d2000231000000014b","propInfo":"White Wolf","propWeightG":914.6,"samples":[[0,0],[0.02,364.4],[0.03,664.8],[0.051,751.5],[0.071,745.8],[0.096,705.3],[0.137,674.9],[0.284,661.4],[0.528,651.2],[0.913,644.5],[1.192,651.2],[1.43,651.2],[1.649,651.2],[1.872,644.5],[2.176,624.2],[2.318,600.6],[2.394,597.3],[2.455,546.6],[2.501,485.9],[2.562,421.8],[2.597,340.8],[2.638,266.5],[2.734,175.5],[2.836,97.86],[2.927,47.24],[3.04,0]],"totImpulseNs":1697,"totalWeightG":1815,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":578,"burnTimeS":4.31,"certOrg":"Canadian Association of Rocketry","commonName":"K575","dataFiles":2,"designation":"2493K575-P","diameter":75,"impulseClass":"K","length":395,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":667.3,"motorId":"5f4294d2000231000000014c","propWeightG":1720,"samples":[[0,0],[0.001,16],[0.111,664.5],[0.431,620.2],[0.871,629],[1.301,637.9],[1.731,637.9],[2.171,629],[2.601,615.8],[3.031,553.8],[3.471,518.3],[3.901,438.6],[4.181,79.74],[4.331,0]],"totImpulseNs":2493,"totalWeightG":3143,"type":"reload","updatedOn":"2021-06-13"},{"availability":"OOP","avgThrustN":600,"burnTimeS":2.38,"caseInfo":"54X403(1400)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K600","dataFiles":1,"delays":"S,M,L,P","designation":"K600F","diameter":54,"impulseClass":"K","length":403,"manufacturer":"Kosdon by AeroTech","manufacturerAbbrev":"KBA","maxThrustN":874,"motorId":"5f4294d2000231000000014d","propWeightG":724.3,"samples":[[0,0],[0.045,639.7],[0.148,711.3],[0.252,695.6],[0.358,696.3],[0.462,701.3],[0.568,703.2],[0.67,705.3],[0.772,704.3],[0.878,702.8],[0.982,701.3],[1.088,696.9],[1.192,689.3],[1.295,681.2],[1.398,668.9],[1.502,653.5],[1.608,637.4],[1.712,619.8],[1.818,599.5],[1.92,586.3],[2.022,510.7],[2.128,334.7],[2.232,125.4],[2.338,37.92],[2.442,17.16],[2.548,4.025],[2.653,0]],"totImpulseNs":1429,"totalWeightG":1416,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":614.1,"burnTimeS":4.07,"caseInfo":"AMW 75-2500","certOrg":"National Association of Rocketry","commonName":"K600","dataFiles":3,"designation":"WT-75-2500","diameter":75,"impulseClass":"K","infoUrl":"http://nar.org/SandT/pdf/Animal/K600.pdf","length":368,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":766.4,"motorId":"5f4294d2000231000000014e","propInfo":"White Wolf","propWeightG":1223,"samples":[[0,0],[0.01,412.2],[0.029,522.2],[0.059,547.2],[0.083,524.8],[0.122,497.3],[0.181,484.9],[0.333,495.1],[0.69,560.5],[1.195,643.5],[1.4,673.8],[1.42,708.8],[1.508,701.4],[1.591,721.6],[1.782,731.7],[2.017,752],[2.174,756.8],[2.257,765.2],[2.502,766.4],[2.727,752.9],[2.918,738.2],[3.143,705.9],[3.408,643.8],[3.603,569.1],[3.692,526.8],[3.745,439.4],[3.799,289.6],[3.883,112.3],[3.922,64.86],[3.971,37.44],[3.995,22.47],[4.07,0]],"totImpulseNs":2499,"totalWeightG":2913,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":605,"burnTimeS":3.97,"caseInfo":"AMW 75-2500","certOrg":"National Association of Rocketry","commonName":"K605","dataFiles":2,"designation":"RR-75-2500","diameter":75,"impulseClass":"K","infoUrl":"http://nar.org/SandT/pdf/Animal/K605.pdf","length":368,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d2000231000000014f","propInfo":"Red Rhino","propWeightG":1231,"samples":[[0,0],[0.03,165.8],[0.053,309.1],[0.077,361.9],[0.142,392],[0.527,501.4],[0.988,606.9],[1.515,682.4],[2.101,730.6],[2.355,737.6],[2.692,731.3],[3,712.5],[3.361,671],[3.503,663.5],[3.586,659.7],[3.645,633.4],[3.692,573],[3.734,444.8],[3.775,297.8],[3.828,162.1],[3.864,98.02],[3.905,41.47],[3.95,0]],"totImpulseNs":2410,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":609.4,"burnTimeS":2.2,"caseInfo":"75 32 M SP (1400CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K630","dataFiles":2,"designation":"K630-SP","diameter":75,"impulseClass":"K","length":813,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":973,"motorId":"5f4294d20002310000000150","propWeightG":515,"samples":[[0,0],[0.005593,308],[0.09787,573.1],[0.5006,889.6],[1.753,667.2],[1.854,410.6],[1.938,239.5],[2.05,128.3],[2.2,0]],"totImpulseNs":1341,"totalWeightG":3550,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":650,"burnTimeS":2.8,"caseInfo":"AMW 54-1750","certOrg":"National Association of Rocketry","commonName":"K650","dataFiles":2,"designation":"RR-54-1750","diameter":54,"impulseClass":"K","infoUrl":"http://nar.org/SandT/pdf/Animal/K650.pdf","length":492,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d20002310000000151","propInfo":"Red Rhino","propWeightG":931,"samples":[[0,0],[0.022,308.3],[0.045,566.5],[0.058,620.4],[0.081,639.7],[0.135,639.7],[0.229,643.5],[0.351,662.8],[0.594,701.4],[0.81,724.4],[0.999,743.8],[1.151,751.2],[1.381,747.6],[1.61,736],[1.835,709],[2.073,685.9],[2.244,674.4],[2.334,682.1],[2.429,685.9],[2.469,666.6],[2.528,597.3],[2.573,481.7],[2.609,358.4],[2.631,250.5],[2.681,146.5],[2.721,65.51],[2.748,23.12],[2.77,0]],"totImpulseNs":1840,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":656,"burnTimeS":2.66,"caseInfo":"Pro54-5G","certOrg":"Canadian Association of Rocketry","commonName":"K650","dataFiles":2,"delays":"6,7,8,9,10,11,12,13,14,15,16","designation":"1750K650-16A","diameter":54,"impulseClass":"K","length":488,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":728.7,"motorId":"5f4294d20002310000000152","propInfo":"Smoky Sam","propWeightG":1281,"samples":[[0,0],[0.04,664.5],[0.12,645.9],[0.31,642.2],[0.6,664.8],[0.91,684.6],[1.22,712.8],[1.5,723.4],[1.8,728.7],[2.1,664.5],[2.4,614.7],[2.51,680.5],[2.55,534.6],[2.61,268.2],[2.66,0]],"totImpulseNs":1750,"totalWeightG":1990,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":650,"burnTimeS":3.67,"caseInfo":"RMS-98/2560","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K650","dataFiles":2,"delays":"P","designation":"K650T","diameter":98,"impulseClass":"K","length":289,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":752.8,"motorId":"5f4294d20002310000000153","propInfo":"Blue Thunder","propWeightG":1280,"samples":[[0,0],[0.079,514.3],[0.24,594.3],[0.401,618.8],[0.563,641.7],[0.723,665.1],[0.884,686.5],[1.046,704.7],[1.206,720.2],[1.368,730.1],[1.529,736.9],[1.69,743.1],[1.851,747.5],[2.013,747.6],[2.174,744.1],[2.335,732.3],[2.496,710.4],[2.657,682.7],[2.819,653.2],[2.979,627],[3.141,595.5],[3.302,563.8],[3.463,551.1],[3.624,236.1],[3.785,1.383],[3.947,1.234],[4.108,0]],"totImpulseNs":2406,"totalWeightG":2935,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":659,"burnTimeS":3.69,"caseInfo":"Pro54-6G","certOrg":"Canadian Association of Rocketry","commonName":"K660","dataFiles":2,"delays":"7,8,9,10,11,12,13,14,15,16,17","designation":"2437K660-17A","diameter":54,"impulseClass":"K","length":572,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1079,"motorId":"5f4294d20002310000000154","propInfo":"Classic","propWeightG":1177,"samples":[[0,0],[0.07,1079],[0.23,1006],[0.4,966.8],[0.8,897.5],[1.2,842.7],[1.6,794.1],[2.01,744.5],[2.4,692.3],[2.54,671.4],[2.68,439.1],[2.8,400.7],[3.01,386.9],[3.2,234.3],[3.45,106.7],[3.6,44.03],[3.69,0]],"totImpulseNs":2437,"totalWeightG":1949,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":661,"burnTimeS":2.8,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K678","dataFiles":2,"designation":"K678-BG","diameter":75,"impulseClass":"K","length":1016,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":2342,"motorId":"5f4294d20002310000000155","propWeightG":580,"samples":[[0,0],[0.005593,1163],[2.215,444.8],[2.321,256.6],[2.388,102.7],[2.8,0]],"totImpulseNs":1847,"totalWeightG":4050,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":668.4,"burnTimeS":2.62,"caseInfo":"AMW 54-1750","certOrg":"National Association of Rocketry","commonName":"K670","dataFiles":3,"designation":"GG-54-1750","diameter":54,"impulseClass":"K","infoUrl":"http://nar.org/SandT/pdf/Animal/K670.pdf","length":492,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":804.6,"motorId":"5f4294d20002310000000156","propInfo":"Green Gorilla","propWeightG":1014,"samples":[[0,0],[0.016,294.1],[0.035,398.6],[0.086,506.3],[0.153,496.4],[0.264,506.1],[0.461,558.1],[0.722,629.6],[0.983,688],[1.116,714.1],[1.193,785.8],[1.409,788.8],[1.737,804.6],[2.074,781.4],[2.195,764.9],[2.226,781.2],[2.277,764.8],[2.398,751.5],[2.44,744.9],[2.468,718.8],[2.484,666.5],[2.525,418.1],[2.551,218.8],[2.573,120.8],[2.595,52.14],[2.62,0]],"totImpulseNs":1751,"totalWeightG":1915,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":680,"burnTimeS":3.49,"caseInfo":"RMS-98/2560","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K680","dataFiles":2,"delays":"P","designation":"K680R","diameter":98,"impulseClass":"K","length":289,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":835,"motorId":"5f4294d20002310000000157","propInfo":"Redline","propWeightG":1316,"samples":[[0,0],[0.085,629.8],[0.494,717.9],[0.996,797.2],[1.29,819.2],[1.506,819.2],[2.001,775.1],[2.519,673.8],[2.99,563.7],[3.137,541.7],[3.176,532.9],[3.238,563.7],[3.276,563.7],[3.408,52.85],[3.431,22.02],[3.49,0]],"totImpulseNs":2358,"totalWeightG":3035,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":695,"burnTimeS":2.178,"caseInfo":"RMS-54/1706","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K695","dataFiles":2,"delays":"6,8,10,12,14","designation":"K695R","diameter":54,"impulseClass":"K","length":410,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d20002310000000158","propInfo":"Redline","propWeightG":903,"samples":[[0,0],[0.044,618.6],[0.134,727.8],[0.224,752],[0.314,812.5],[0.404,900.1],[0.495,884.8],[0.585,873.5],[0.675,864.6],[0.765,849.7],[0.856,838.9],[0.946,822.5],[1.036,806.2],[1.126,781.3],[1.216,754],[1.307,728.5],[1.398,697.6],[1.487,673],[1.578,646.7],[1.667,620.9],[1.758,595.6],[1.849,571.7],[1.939,546.8],[2.029,272.8],[2.119,57.95],[2.209,4.509],[2.3,0]],"totImpulseNs":1514,"totalWeightG":1487,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":700,"burnTimeS":2.3,"caseInfo":"AMW 54-1400","certOrg":"National Association of Rocketry","commonName":"K700","dataFiles":2,"designation":"BB-54-1400","diameter":54,"impulseClass":"K","infoUrl":"http://nar.org/SandT/pdf/Animal/K700.pdf","length":430,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d20002310000000159","propInfo":"Blue Baboon","propWeightG":745,"samples":[[0,0],[0.014,359.6],[0.022,625.4],[0.03,737.8],[0.047,771.5],[0.082,786.5],[0.106,771.5],[0.144,775.2],[0.272,786.5],[0.477,812.7],[0.693,842.6],[0.97,847.1],[1.283,838.9],[1.516,816.4],[1.706,801.4],[1.779,794],[1.811,775.2],[1.841,726.6],[1.873,625.4],[1.909,509.4],[1.95,393.2],[1.982,337.1],[2.035,292.2],[2.073,228.5],[2.111,153.5],[2.155,86.14],[2.193,37.45],[2.24,0]],"totImpulseNs":1650,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":700,"burnTimeS":3.51,"caseInfo":"RMS-54/2560","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K700","dataFiles":2,"delays":"P","designation":"K700W","diameter":54,"impulseClass":"K","length":568,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1617,"motorId":"5f4294d2000231000000015a","propInfo":"White Lightning","propWeightG":1303,"samples":[[0,0],[0.069,1005],[0.209,1019],[0.35,1027],[0.491,1029],[0.632,1029],[0.773,1004],[0.914,970.7],[1.055,946.5],[1.196,918.4],[1.336,873.8],[1.478,821.3],[1.619,773.3],[1.759,735.6],[1.9,692.7],[2.041,659],[2.182,626.7],[2.323,591.4],[2.464,508.7],[2.605,420.2],[2.746,328.3],[2.886,202.4],[3.028,121.7],[3.169,80.45],[3.309,50.87],[3.451,31.55],[3.593,0]],"totImpulseNs":2261,"totalWeightG":2035,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":698,"burnTimeS":1.98,"caseInfo":"75 32 M BG (1400CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K707","dataFiles":2,"designation":"K707-BG","diameter":75,"impulseClass":"K","length":813,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":1486,"motorId":"5f4294d2000231000000015b","propWeightG":159,"samples":[[0,0],[0.04661,281.2],[0.1229,1278],[0.1653,894.8],[0.4958,1432],[0.6186,1150],[0.6949,945.9],[0.8347,920.3],[1.013,664.7],[1.508,536.9],[1.623,281.2],[1.729,127.8],[2,0]],"totImpulseNs":1386,"totalWeightG":3674,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":695,"burnTimeS":2.6,"caseInfo":"75 40 M SP (2050CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K777","dataFiles":2,"designation":"K777-SP","diameter":75,"impulseClass":"K","length":1016,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":1908,"motorId":"5f4294d2000231000000015c","propWeightG":645,"samples":[[0,0],[0.001,931],[0.09608,965.5],[0.1129,1793],[0.1688,1741],[0.2079,1345],[0.7281,1138],[1.002,810.3],[1.975,413.8],[2.048,172.4],[2.601,0]],"totImpulseNs":1833,"totalWeightG":4050,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":780,"burnTimeS":2.98,"caseInfo":"RMS-75/2560","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K780","dataFiles":2,"delays":"P","designation":"K780R","diameter":75,"impulseClass":"K","length":395,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":965,"motorId":"5f4294d2000231000000015d","propInfo":"Redline","propWeightG":1268,"samples":[[0,0],[0.053,383.3],[0.173,718.2],[0.292,849.3],[0.413,885.5],[0.533,903.2],[0.652,924.4],[0.772,938.8],[0.892,938.6],[1.013,947.1],[1.133,953.6],[1.253,944],[1.373,935.4],[1.495,929.4],[1.617,920.4],[1.737,897.3],[1.857,888.9],[1.977,861.1],[2.098,841],[2.217,812.4],[2.337,779.6],[2.457,747.9],[2.578,726.8],[2.697,729.3],[2.817,279.9],[2.94,10.97],[3.063,0]],"totImpulseNs":2371,"totalWeightG":2934,"type":"reload","updatedOn":"2021-06-13"},{"availability":"OOP","avgThrustN":800,"burnTimeS":2.3,"caseInfo":"AMW 54-1750","certOrg":"National Association of Rocketry","commonName":"K800","dataFiles":2,"designation":"BB-54-1750","diameter":54,"impulseClass":"K","infoUrl":"http://nar.org/SandT/pdf/Animal/K800.pdf","length":492,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d2000231000000015e","propInfo":"Blue Baboon","propWeightG":914,"samples":[[0,0],[0.017,516.3],[0.035,745.8],[0.046,817.6],[0.09,860.6],[0.191,889.3],[0.27,908.4],[0.438,918],[0.689,945.9],[0.996,955.1],[1.325,922.7],[1.557,894],[1.726,874.9],[1.849,884.5],[1.92,894],[1.954,894],[1.984,855.9],[2.011,741],[2.049,592.9],[2.079,492.4],[2.113,430.3],[2.154,377.7],[2.196,329.9],[2.237,243.8],[2.275,153],[2.309,71.72],[2.339,33.47],[2.38,0]],"totImpulseNs":1950,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":943.5,"burnTimeS":1.97,"caseInfo":"AMW 54-1750","certOrg":"National Association of Rocketry","commonName":"K950","dataFiles":3,"designation":"ST-54-1750","diameter":54,"impulseClass":"K","infoUrl":"http://nar.org/SandT/pdf/Animal/K950.pdf","length":492,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":1205,"motorId":"5f4294d2000231000000015f","propInfo":"Super Tiger","propWeightG":887.4,"samples":[[0,0],[0.011,771.8],[0.025,1205],[0.039,1083],[0.053,1158],[0.067,1036],[0.085,1110],[0.099,1022],[0.135,982.1],[0.22,968.8],[0.404,1010],[0.566,1044],[0.701,1079],[0.867,1106],[0.995,1134],[1.211,1114],[1.313,1101],[1.43,1067],[1.529,1020],[1.579,993.8],[1.642,892.4],[1.674,818.1],[1.717,757.3],[1.738,621.9],[1.766,466.3],[1.791,351.3],[1.823,249.9],[1.865,175.6],[1.908,87.7],[1.943,33.65],[1.97,0]],"totImpulseNs":1859,"totalWeightG":1795,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":960,"burnTimeS":1.98,"caseInfo":"54/2000","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K960","dataFiles":2,"designation":"K960-LW","diameter":54,"impulseClass":"K","length":499,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":1529,"motorId":"5f4294d20002310000000160","propInfo":"Loki White","propWeightG":930,"samples":[[0,0],[0.03,1210],[0.05,1512],[0.075,1535],[0.1,1502],[0.125,1437],[0.2,1237],[0.3,1175],[0.5,1139],[0.6,1130],[0.7,1156],[0.8,1182],[0.9,1192],[1,1166],[1.1,1139],[1.2,1101],[1.3,1091],[1.4,1026],[1.5,839],[1.6,790],[1.7,575],[1.8,284],[1.9,150],[2,0]],"totImpulseNs":1946,"totalWeightG":1746,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":976.4,"burnTimeS":2.51,"caseInfo":"AMW 54-2550","certOrg":"National Association of Rocketry","commonName":"K975","dataFiles":2,"designation":"WT-54-2550","diameter":54,"impulseClass":"K","infoUrl":"http://nar.org/SandT/pdf/Animal/K975.pdf","length":728,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":1291,"motorId":"5f4294d20002310000000161","propInfo":"White Wolf","propWeightG":1357,"samples":[[0,0],[0.017,526.6],[0.029,901.9],[0.038,1099],[0.046,1152],[0.076,1113],[0.13,1060],[0.219,1053],[0.336,1053],[0.479,1059],[0.609,1092],[0.866,1137],[1.046,1177],[1.164,1176],[1.202,1228],[1.239,1209],[1.315,1215],[1.353,1267],[1.387,1228],[1.487,1241],[1.538,1260],[1.634,1291],[1.723,1281],[1.794,1266],[1.836,1208],[1.933,1049],[1.992,851.4],[2.08,666.9],[2.118,640.5],[2.193,462.6],[2.269,212.3],[2.378,119.9],[2.51,0]],"totImpulseNs":2454,"totalWeightG":2599,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1000,"burnTimeS":2,"caseInfo":"AMW 54-2550","certOrg":"National Association of Rocketry","commonName":"K1000","dataFiles":2,"designation":"SK-54-2550","diameter":54,"impulseClass":"K","length":728,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d20002310000000162","propInfo":"Skidmark","propWeightG":1297,"samples":[[0,0],[0.019,1155],[0.045,1426],[0.094,1248],[0.161,1113],[0.239,1128],[0.343,1114],[0.377,1149],[0.44,1121],[0.544,1221],[0.633,1178],[0.674,1221],[0.737,1193],[0.883,1200],[1.009,1194],[1.057,1236],[1.188,1137],[1.299,1145],[1.396,1088],[1.516,954.1],[1.631,855.2],[1.717,827.1],[1.777,650.1],[1.848,465.9],[1.93,303.1],[2.023,147.5],[2.083,83.88],[2.132,41.48],[2.18,0]],"sparky":true,"totImpulseNs":2120,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1000,"burnTimeS":2.6,"caseInfo":"54X728","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K1000","dataFiles":0,"designation":"K1000S","diameter":54,"impulseClass":"K","length":728,"manufacturer":"Kosdon by AeroTech","manufacturerAbbrev":"KBA","maxThrustN":1738,"motorId":"5f4294d20002310000000163","propWeightG":1301,"totImpulseNs":2593,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1050,"burnTimeS":2.28,"caseInfo":"SU 54x676","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K1050","dataFiles":2,"designation":"K1050W-SU","diameter":54,"impulseClass":"K","length":676,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":2164,"motorId":"5f4294d20002310000000164","propInfo":"White Lightning","propWeightG":1362,"samples":[[0,0],[0.049,1306],[0.149,1270],[0.249,1289],[0.349,1327],[0.449,1346],[0.549,1360],[0.649,1364],[0.749,1365],[0.849,1377],[0.949,1380],[1.049,1347],[1.149,1287],[1.249,1232],[1.349,1186],[1.449,1157],[1.549,1120],[1.649,1099],[1.749,1070],[1.849,889.9],[1.949,646.7],[2.049,441.2],[2.149,302.2],[2.249,155],[2.349,52.19],[2.449,43.41],[2.549,0]],"totImpulseNs":2530,"totalWeightG":2128,"type":"SU","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":526.9,"burnTimeS":2.2,"caseInfo":"AMW 54-2550","certOrg":"National Association of Rocketry","commonName":"K1075","dataFiles":2,"designation":"GG-54-2550","diameter":54,"impulseClass":"K","infoUrl":"http://nar.org/SandT/pdf/Animal/K1075.pdf","length":728,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":1385,"motorId":"5f4294d20002310000000165","propInfo":"Green Gorilla","propWeightG":1400,"samples":[[0,0],[0.009,672.7],[0.015,963.5],[0.022,860.5],[0.047,987.9],[0.075,975.8],[0.106,921.3],[0.215,958],[0.529,1092],[0.878,1220],[1.077,1269],[1.158,1311],[1.235,1293],[1.448,1331],[1.577,1318],[1.672,1319],[1.721,1338],[1.759,1338],[1.805,1338],[1.829,1332],[1.856,1385],[1.889,1277],[1.906,1216],[1.938,1053],[1.96,871.3],[1.988,659.2],[2.027,453.4],[2.062,302],[2.115,138.5],[2.168,41.61],[2.2,0]],"totImpulseNs":2392,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1100,"burnTimeS":1.61,"caseInfo":"RMS-54/1706","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K1100","dataFiles":2,"delays":"6,8,10,12,14","designation":"K1100T","diameter":54,"impulseClass":"K","length":398,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":2004,"motorId":"5f4294d20002310000000166","propInfo":"Blue Thunder","propWeightG":773.3,"samples":[[0,0],[0.034,1235],[0.105,1233],[0.176,1192],[0.247,1163],[0.318,1148],[0.389,1146],[0.46,1141],[0.532,1133],[0.603,1124],[0.674,1109],[0.745,1091],[0.816,1074],[0.887,1049],[0.959,1021],[1.03,994.6],[1.101,966.6],[1.172,940.2],[1.243,909.8],[1.315,880.3],[1.386,844.5],[1.457,643.6],[1.528,401.9],[1.599,145.5],[1.67,28.37],[1.742,0]],"totImpulseNs":1472,"totalWeightG":1336,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1275,"burnTimeS":1.75,"caseInfo":"RMS-54/2560","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K1275","dataFiles":2,"delays":"P","designation":"K1275R","diameter":54,"impulseClass":"K","length":568,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1554,"motorId":"5f4294d20002310000000167","propInfo":"Redline","propWeightG":1222,"samples":[[0,0],[0.039,1283],[0.119,1558],[0.199,1540],[0.279,1527],[0.359,1501],[0.44,1457],[0.52,1426],[0.6,1390],[0.68,1355],[0.761,1323],[0.841,1283],[0.921,1248],[1.001,1194],[1.081,1151],[1.162,1108],[1.242,1069],[1.322,1037],[1.403,997.4],[1.482,964.6],[1.563,933.3],[1.644,890],[1.724,599.5],[1.804,134.6],[1.884,5.63],[1.964,0.205],[2.045,0]],"totImpulseNs":2225,"totalWeightG":1986,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1400,"burnTimeS":1.88,"caseInfo":"54 X 727","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K1400","dataFiles":0,"designation":"K1400F","diameter":54,"impulseClass":"K","length":728,"manufacturer":"Kosdon by AeroTech","manufacturerAbbrev":"KBA","maxThrustN":1989,"motorId":"5f4294d20002310000000168","propWeightG":1248,"totImpulseNs":2640,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":200,"burnTimeS":13.2,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L200","dataFiles":1,"designation":"1685CC098L-L200","diameter":75,"impulseClass":"L","length":1031,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d20002310000000169","propWeightG":1614,"samples":[[0,0],[0.292,310.9],[0.877,311.9],[1.464,284.6],[2.05,259.2],[2.636,245.1],[3.223,240.8],[3.809,246],[4.396,251.5],[4.981,255.6],[5.568,250],[6.154,242.3],[6.741,236.2],[7.327,230.5],[7.914,224.1],[8.5,218.2],[9.086,212.2],[9.673,189.7],[10.26,94.61],[10.85,67.13],[11.43,53.35],[12.02,41.55],[12.6,31.11],[13.19,22.45],[13.78,16.76],[14.36,10.89],[14.95,0]],"totImpulseNs":2639,"totalWeightG":3895,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":225,"burnTimeS":12.39,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L225","dataFiles":1,"designation":"1685CC098LFX-L225FX","diameter":75,"impulseClass":"L","length":1031,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d2000231000000016a","propWeightG":1688,"samples":[[0,0],[0.271,380.6],[0.815,364.1],[1.359,347.7],[1.904,312],[2.449,292.8],[2.994,284.6],[3.539,284.1],[4.083,295.8],[4.628,286.7],[5.173,271.8],[5.718,258.2],[6.263,249.4],[6.807,240.4],[7.352,232.7],[7.897,226.8],[8.442,217.6],[8.986,208.6],[9.531,122.7],[10.08,74.67],[10.62,60.93],[11.17,48.9],[11.71,39],[12.26,29.72],[12.8,21.93],[13.35,16.36],[13.89,0]],"totImpulseNs":2789,"totalWeightG":3948,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":2456,"burnTimeS":1.9,"caseInfo":"75x1524 (3200CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L2525","dataFiles":3,"designation":"L2525-GF","diameter":75,"impulseClass":"L","length":1524,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":4906,"motorId":"5f4294d2000231000000016b","propWeightG":1306,"samples":[[0,0],[0.001,4200],[0.7558,3295],[1.901,0]],"totImpulseNs":4677,"totalWeightG":5579,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":330,"burnTimeS":7.3,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L330","dataFiles":2,"designation":"L330","diameter":76,"impulseClass":"L","length":381,"manufacturer":"Ellis Mountain","manufacturerAbbrev":"Ellis","maxThrustN":484.6,"motorId":"5f4294d2000231000000016c","propWeightG":1490,"samples":[[0,0],[0.194,299],[0.584,378.8],[0.975,376.2],[1.366,382.5],[1.757,391.2],[2.148,399.4],[2.539,406],[2.93,407.7],[3.321,405.7],[3.711,400.6],[4.103,393.4],[4.494,384.5],[4.884,377],[5.275,368.4],[5.666,359],[6.057,350.1],[6.448,341.6],[6.839,337.1],[7.23,300],[7.621,194.6],[8.011,123.4],[8.403,66.94],[8.794,32.23],[9.184,8.248],[9.576,1.563],[9.968,0]],"totImpulseNs":2973,"totalWeightG":2670,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":350,"burnTimeS":8.694,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L350","dataFiles":1,"designation":"1685CC125L-L350","diameter":75,"impulseClass":"L","length":1031,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d2000231000000016d","propWeightG":1620,"samples":[[0,0],[0.188,592.2],[0.566,598],[0.945,479.8],[1.324,427.2],[1.702,406.6],[2.08,395.1],[2.459,393.3],[2.839,410.7],[3.217,517.3],[3.595,506.5],[3.974,439.5],[4.353,391.7],[4.731,463.4],[5.109,446.9],[5.489,436.2],[5.868,387.5],[6.246,247.3],[6.624,147.8],[7.003,117.5],[7.382,93.08],[7.76,73.03],[8.139,55.6],[8.518,40.85],[8.897,29.57],[9.276,21.63],[9.655,0]],"totImpulseNs":3043,"totalWeightG":3903,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":355,"burnTimeS":8.031,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L355","dataFiles":1,"designation":"1685CC125LFX-L355FX","diameter":75,"impulseClass":"L","length":1031,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d2000231000000016e","propWeightG":1638,"samples":[[0,0],[0.185,638.7],[0.559,623.8],[0.933,538.1],[1.307,493.2],[1.682,465.1],[2.056,432.7],[2.43,410.6],[2.804,388.9],[3.178,395.5],[3.553,384.9],[3.927,370.1],[4.301,356.5],[4.675,346.2],[5.049,342.7],[5.424,325.4],[5.798,317.8],[6.172,272.5],[6.546,156.2],[6.92,117.6],[7.295,93.2],[7.669,73.06],[8.043,57],[8.417,42.99],[8.791,30.34],[9.166,21.73],[9.541,0]],"totImpulseNs":2851,"totalWeightG":3954,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":361.7,"burnTimeS":10.58,"caseInfo":"75 52 S SP (3200CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L369","dataFiles":2,"designation":"L369-SP","diameter":75,"impulseClass":"L","length":813,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":651.9,"motorId":"5f4294d2000231000000016f","propWeightG":785,"samples":[[0,0],[0.02237,540.6],[1.454,533.8],[8.926,260.1],[9.083,130],[9.284,68.43],[10.6,0]],"totImpulseNs":3829,"totalWeightG":4800,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":475,"burnTimeS":5.841,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L475","dataFiles":1,"designation":"1685CC172L-L475","diameter":75,"impulseClass":"L","length":1031,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d20002310000000170","propWeightG":1543,"samples":[[0,0],[0.129,640.8],[0.391,638.1],[0.652,619],[0.914,609.7],[1.176,597.9],[1.437,596.3],[1.699,594],[1.961,572.2],[2.223,578.3],[2.484,589.2],[2.747,578.8],[3.008,612.4],[3.27,646.2],[3.531,674.6],[3.793,652.6],[4.055,555.4],[4.317,299.7],[4.578,220.3],[4.841,170],[5.102,127],[5.364,95],[5.626,70.21],[5.888,49.46],[6.149,32.1],[6.411,18.38],[6.674,0]],"totImpulseNs":2774,"totalWeightG":3898,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":535,"burnTimeS":5.597,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L535","dataFiles":1,"designation":"1685CC172LFX-L535FX","diameter":75,"impulseClass":"L","length":1031,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d20002310000000171","propWeightG":1616,"samples":[[0,0],[0.119,838.5],[0.358,768.7],[0.598,727.6],[0.838,745.2],[1.077,712.9],[1.317,694.6],[1.556,672.1],[1.796,656.7],[2.035,685.1],[2.275,808.7],[2.515,798.5],[2.754,755.3],[2.995,727],[3.235,699.3],[3.475,670],[3.715,515.3],[3.954,293.9],[4.194,227.9],[4.433,180.2],[4.673,140.7],[4.912,107.6],[5.152,80.91],[5.392,58.9],[5.631,39.78],[5.872,24.9],[6.113,0]],"totImpulseNs":2994,"totalWeightG":3948,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":540,"burnTimeS":8.546,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L540","dataFiles":2,"designation":"2800CC172L-L540","diameter":75,"impulseClass":"L","length":1387,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d20002310000000172","propWeightG":2559,"samples":[[0,0],[0.191,685.5],[0.574,665.2],[0.957,635.5],[1.341,634.1],[1.725,656.2],[2.109,706.9],[2.493,696.5],[2.876,777.7],[3.26,775.9],[3.645,781.6],[4.028,712.7],[4.411,695.6],[4.796,701.3],[5.18,646],[5.564,607.8],[5.947,546.4],[6.331,387.4],[6.716,234.2],[7.099,181.1],[7.482,139.3],[7.867,106.1],[8.251,78.29],[8.634,54.85],[9.018,36.38],[9.402,20.38],[9.786,0]],"totImpulseNs":4615,"totalWeightG":5656,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":550,"burnTimeS":5.627,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L550","dataFiles":1,"designation":"1685CCRGL-L550","diameter":75,"impulseClass":"L","length":1031,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d20002310000000173","propWeightG":1552,"samples":[[0,0],[0.124,816.8],[0.375,796],[0.626,781.9],[0.877,767.4],[1.129,759.6],[1.38,735.9],[1.631,714.5],[1.883,701.6],[2.134,674.7],[2.385,656.5],[2.637,636.1],[2.889,612.4],[3.14,587.8],[3.391,567.2],[3.642,560],[3.894,534.2],[4.145,444.6],[4.396,280.5],[4.648,216.7],[4.899,163.1],[5.15,120.6],[5.402,86.54],[5.653,59.99],[5.904,39.53],[6.156,25.91],[6.408,0]],"totImpulseNs":3095,"totalWeightG":3898,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":570,"burnTimeS":8.273,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L570","dataFiles":2,"designation":"2800CC172LFX-L570FX","diameter":75,"impulseClass":"L","length":1387,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d20002310000000174","propWeightG":2608,"samples":[[0,0],[0.181,793.9],[0.547,800],[0.914,811.8],[1.28,761.3],[1.647,725.7],[2.014,733.2],[2.38,783.2],[2.747,795.3],[3.112,823.2],[3.478,831.8],[3.845,805.6],[4.211,780.5],[4.578,741.9],[4.945,629],[5.311,547.9],[5.678,537.8],[6.044,330.9],[6.409,230.8],[6.776,180.5],[7.143,140.2],[7.509,108.3],[7.876,81.34],[8.243,59.61],[8.609,41.59],[8.976,25.54],[9.343,0]],"totImpulseNs":4716,"totalWeightG":5706,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":575,"burnTimeS":8.402,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L575","dataFiles":2,"designation":"2800CCRGL-L575","diameter":75,"impulseClass":"L","length":1387,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d20002310000000175","propWeightG":2553,"samples":[[0,0],[0.19,705.3],[0.572,723.4],[0.955,738.4],[1.337,749.4],[1.72,735.2],[2.103,725.1],[2.486,733.8],[2.869,700.5],[3.251,690.8],[3.634,682.9],[4.017,674.8],[4.399,687.5],[4.782,675.4],[5.166,645.7],[5.548,643.6],[5.93,634.7],[6.314,559.7],[6.696,304],[7.078,229.4],[7.461,167.6],[7.845,121],[8.227,83.67],[8.609,54.31],[8.993,33.03],[9.376,19.89],[9.759,0]],"totImpulseNs":4831,"totalWeightG":5653,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":600,"burnTimeS":7.1,"caseInfo":"h 1858 cc","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L600","dataFiles":1,"designation":"L600","diameter":64,"impulseClass":"L","length":1066,"manufacturer":"R.A.T.T. Works","manufacturerAbbrev":"RATT","maxThrustN":2072,"motorId":"5f4294d20002310000000176","propWeightG":2200,"samples":[[0,0],[0.001,88.62],[0.021,153.8],[0.191,158],[0.351,169.9],[0.401,1127],[0.781,1001],[2.231,778.1],[2.841,736.2],[3.071,704],[3.621,673.4],[3.811,435.3],[3.891,350.4],[4.141,240.1],[4.311,197.2],[4.491,165.4],[4.661,139.3],[4.821,119.2],[5.011,99.01],[5.341,70.99],[5.931,49.74],[6.491,38.96],[6.981,36.42],[7.101,0]],"totImpulseNs":3152,"totalWeightG":2200,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":600,"burnTimeS":8,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L600","dataFiles":2,"designation":"L600","diameter":76,"impulseClass":"L","length":584,"manufacturer":"Ellis Mountain","manufacturerAbbrev":"Ellis","maxThrustN":1056,"motorId":"5f4294d20002310000000177","propWeightG":2473,"samples":[[0,0],[0.186,829.7],[0.561,773.9],[0.936,767.8],[1.313,755],[1.689,736.5],[2.064,722.7],[2.44,706.2],[2.816,688.3],[3.191,673.5],[3.567,661],[3.943,648.1],[4.318,634.7],[4.694,622.1],[5.07,608],[5.445,594.9],[5.821,583],[6.197,573.1],[6.572,553.5],[6.948,399.4],[7.324,270.4],[7.699,211.4],[8.075,144.2],[8.451,74.23],[8.826,19.38],[9.202,4.274],[9.578,0]],"totImpulseNs":4995,"totalWeightG":4120,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":610,"burnTimeS":5.133,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L610","dataFiles":1,"designation":"1685CCRGLFX-L610FX","diameter":75,"impulseClass":"L","length":1031,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d20002310000000178","propWeightG":1603,"samples":[[0,0],[0.11,850.8],[0.333,837.7],[0.556,775.1],[0.779,739.7],[1.002,807.3],[1.225,809.5],[1.448,801.8],[1.671,789.5],[1.894,763.8],[2.117,858.1],[2.34,890.6],[2.563,837.6],[2.785,749.6],[3.008,649],[3.231,643.1],[3.454,637.4],[3.677,431.3],[3.9,276.2],[4.123,220.9],[4.346,166.6],[4.569,124],[4.792,89.72],[5.015,64.3],[5.237,45.36],[5.461,30.4],[5.685,0]],"totImpulseNs":3131,"totalWeightG":3951,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":625,"burnTimeS":7.921,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L625","dataFiles":2,"designation":"2800CCRGLFX-L625FX","diameter":75,"impulseClass":"L","length":1387,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d20002310000000179","propWeightG":2602,"samples":[[0,0],[0.169,855],[0.509,896.2],[0.851,905.9],[1.193,902.1],[1.534,853],[1.876,953.2],[2.218,904.2],[2.559,856.5],[2.901,743.5],[3.243,758.6],[3.584,751.6],[3.926,745.7],[4.267,751.9],[4.607,728.3],[4.949,691.7],[5.291,658.8],[5.632,504.4],[5.974,279.7],[6.316,216.7],[6.657,165],[6.999,123.4],[7.341,89.43],[7.682,62.95],[8.024,43.52],[8.366,27.96],[8.707,0]],"totImpulseNs":4951,"totalWeightG":5706,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":666,"burnTimeS":3.97,"caseInfo":"AMW 75-3500","certOrg":"National Association of Rocketry","commonName":"L666","dataFiles":2,"designation":"SK-75-3500","diameter":75,"impulseClass":"L","length":870,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d2000231000000017a","propInfo":"Skidmark","propWeightG":1647,"samples":[[0,0],[0.096,105.9],[0.175,509.8],[0.312,549.5],[0.449,577.3],[0.586,602.9],[0.722,615.6],[0.859,632.5],[0.996,652.1],[1.133,671.4],[1.27,685.7],[1.407,701.3],[1.543,718.1],[1.68,734.1],[1.817,753.3],[1.954,771.6],[2.091,790.5],[2.228,819.2],[2.364,846.7],[2.501,874.6],[2.638,890.1],[2.775,898.3],[2.912,899.3],[3.049,881.7],[3.185,845.2],[3.322,768.5],[3.459,672.8],[3.596,525.5],[3.733,304.7],[3.87,86.66],[3.968,0]],"sparky":true,"totImpulseNs":2700,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":700,"burnTimeS":3.27,"caseInfo":"AMW 75-2500","certOrg":"National Association of Rocketry","commonName":"L700","dataFiles":2,"designation":"BB-75-2500","diameter":75,"impulseClass":"L","length":368,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d2000231000000017b","propInfo":"Blue Baboon","propWeightG":1194,"samples":[[0,0],[0.02,221.9],[0.03,399.3],[0.05,467.6],[0.08,494.9],[0.13,498.4],[0.24,536],[0.48,614.7],[0.77,683.2],[1.23,755.3],[1.62,789.7],[1.92,810.4],[2.26,821.1],[2.58,817.9],[2.91,801.1],[3.14,773.9],[3.25,750.1],[3.32,743.4],[3.37,729.8],[3.42,688.8],[3.46,593.4],[3.5,484.1],[3.53,368.2],[3.57,248.8],[3.62,149.8],[3.66,61.13],[3.72,0]],"totImpulseNs":2590,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":733,"burnTimeS":3.77,"caseInfo":"Pro54-6GXL","certOrg":"Canadian Association of Rocketry","commonName":"L730","dataFiles":2,"delays":"P","designation":"2765L730-P","diameter":54,"impulseClass":"L","length":649,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1215,"motorId":"5f4294d2000231000000017c","propInfo":"Classic","propWeightG":1351,"samples":[[0,0],[0.001,81.36],[0.011,1080],[0.021,1217],[0.041,1155],[0.201,1128],[0.451,1055],[0.601,1028],[0.751,995.2],[1.001,959.3],[1.501,898.7],[2.001,830.7],[2.501,730.8],[2.601,592.5],[2.701,511],[2.901,487.9],[3.001,405.7],[3.101,299.8],[3.201,296.1],[3.301,251.8],[3.401,171.7],[3.501,165.3],[3.601,139.4],[3.651,117.8],[3.771,45.38],[3.771,0]],"totImpulseNs":2765,"totalWeightG":2247,"type":"reload","updatedOn":"2021-06-13"},{"availability":"OOP","avgThrustN":740,"burnTimeS":6.801,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L740","dataFiles":1,"designation":"2800CC200MFX-L740FX","diameter":75,"impulseClass":"L","length":1438,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d2000231000000017d","propWeightG":2598,"samples":[[0,0],[0.02,767.8],[0.05,1085],[0.07,1167],[0.09,1199],[0.12,1183],[0.38,1089],[0.63,1140],[0.89,1131],[1.15,1109],[1.4,1097],[1.66,1049],[1.92,1027],[2.18,980.7],[2.43,949.7],[2.69,909.6],[2.95,893.6],[3.21,866.6],[3.46,825.3],[3.72,820],[3.98,789.8],[4.24,874.1],[4.49,804.4],[4.75,738],[5.01,383.8],[5.38,255.8],[5.75,183.3],[6.13,130.5],[6.5,94.03],[6.8,0]],"totImpulseNs":5033,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":774.5,"burnTimeS":4.05,"caseInfo":"AMW 75-3500","certOrg":"National Association of Rocketry","commonName":"L777","dataFiles":3,"designation":"WT-75-3500","diameter":75,"impulseClass":"L","infoUrl":"http://nar.org/SandT/pdf/Animal/L777.pdf","length":497,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":1000,"motorId":"5f4294d2000231000000017e","propInfo":"White Wolf","propWeightG":1762,"samples":[[0,0],[0.025,140.9],[0.064,209.5],[0.108,360.1],[0.204,652.2],[0.36,641.5],[0.373,693.7],[0.418,683.3],[0.528,730.1],[0.67,761.3],[0.761,782],[0.787,802.8],[0.871,802.7],[1.065,854.8],[1.338,911.8],[1.668,963.6],[1.914,989.5],[2.115,1000],[2.368,962.8],[2.647,926],[2.985,878.6],[3.303,805.1],[3.472,752.8],[3.55,705.7],[3.602,648.3],[3.647,611.6],[3.693,512.4],[3.779,334.9],[3.857,178.2],[3.935,89.38],[3.981,26.69],[4.05,0]],"totImpulseNs":3137,"totalWeightG":3699,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":804,"burnTimeS":4.67,"caseInfo":"Pro75-3G","certOrg":"Canadian Association of Rocketry","commonName":"L800","dataFiles":3,"designation":"3757L800-P","diameter":75,"impulseClass":"L","length":486,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1286,"motorId":"5f4294d2000231000000017f","propInfo":"Classic","propWeightG":1795,"samples":[[0,0],[0.001,27.28],[0.011,402.4],[0.011,1286],[0.121,1057],[0.261,1042],[0.711,1027],[1.281,998.4],[2.051,901.4],[2.411,849.6],[2.831,763.5],[3.251,707.1],[3.651,655.1],[3.801,651.7],[4.001,624.1],[4.101,601.3],[4.191,536.2],[4.311,415.7],[4.411,270.2],[4.521,140.2],[4.601,76.92],[4.651,54.94],[4.671,40.16],[5.001,0]],"totImpulseNs":3757,"totalWeightG":3511,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":813,"burnTimeS":4.6,"caseInfo":"75 54 M BG (3200CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L800","dataFiles":2,"designation":"L800-BG","diameter":75,"impulseClass":"L","length":1372,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":1608,"motorId":"5f4294d20002310000000180","propWeightG":3200,"samples":[[0,0],[0.005593,1352],[0.1678,1129],[0.33,1266],[0.5537,1249],[0.6655,1129],[3.484,821.2],[3.596,496.1],[3.697,273.7],[3.837,154],[4.6,0]],"totImpulseNs":3759,"totalWeightG":4726,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":850,"burnTimeS":4.42,"caseInfo":"RMS-75/3840","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L850","dataFiles":2,"delays":"P","designation":"L850W","diameter":75,"impulseClass":"L","length":531,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1866,"motorId":"5f4294d20002310000000181","propInfo":"White Lightning","propWeightG":2095,"samples":[[0,0],[0.091,1016],[0.274,1065],[0.458,1101],[0.643,1143],[0.827,1171],[1.011,1185],[1.196,1178],[1.38,1178],[1.564,1175],[1.748,1170],[1.932,1114],[2.117,1043],[2.301,972.8],[2.485,908.1],[2.67,844.5],[2.854,773.6],[3.039,714],[3.222,649.1],[3.406,597.3],[3.591,557.4],[3.775,422.2],[3.959,200.7],[4.144,79.41],[4.328,43.96],[4.513,14.86],[4.697,0]],"totImpulseNs":3646,"totalWeightG":3742,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":890,"burnTimeS":4.22,"certOrg":"Canadian Association of Rocketry","commonName":"L890","dataFiles":2,"designation":"3762L890-P","diameter":75,"impulseClass":"L","length":530,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1228,"motorId":"5f4294d20002310000000182","propWeightG":2580,"samples":[[0,0],[0.001,20],[0.051,1152],[0.411,1054],[0.831,1045],[1.241,1037],[1.651,1028],[2.071,1019],[2.891,886],[3.311,775.3],[3.721,664.5],[3.981,177.2],[4.131,0]],"totImpulseNs":3762,"totalWeightG":4346,"type":"reload","updatedOn":"2021-06-13"},{"availability":"OOP","avgThrustN":900,"burnTimeS":3.78,"caseInfo":"AMW 75-3500","certOrg":"National Association of Rocketry","commonName":"L900","dataFiles":2,"designation":"RR-75-3500","diameter":75,"impulseClass":"L","infoUrl":"http://nar.org/SandT/pdf/Animal/L900.pdf","length":497,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d20002310000000183","propInfo":"Red Rhino","propWeightG":1771,"samples":[[0,0],[0.029,464.3],[0.053,630.9],[0.059,684.5],[0.096,702.3],[0.133,696.4],[0.201,714.3],[0.486,803.5],[0.777,910.7],[1.099,988.1],[1.26,1041],[1.284,1071],[1.378,1053],[1.607,1102],[1.917,1143],[2.208,1174],[2.413,1161],[2.624,1108],[2.866,976.2],[3.053,886.9],[3.208,839.3],[3.314,827.4],[3.382,809.5],[3.432,720.3],[3.495,547.6],[3.57,345.3],[3.627,214.3],[3.714,77.38],[3.79,0]],"totImpulseNs":3450,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":930,"burnTimeS":3.79,"caseInfo":"76/3600","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L930","dataFiles":2,"designation":"L930-LW","diameter":76,"impulseClass":"L","length":499,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":1137,"motorId":"5f4294d20002310000000184","propInfo":"Loki White","propWeightG":1905,"samples":[[0,0],[0.025,532],[0.05,1123],[0.075,1123],[0.125,1094],[0.2,930],[0.5,881],[0.6,878],[0.75,898],[1,921],[1.25,940],[1.5,1012],[1.75,1081],[2,1100],[2.25,1120],[2.5,1051],[2.75,980],[3,934],[3.25,826],[3.5,722],[3.75,280],[4,0]],"totImpulseNs":3587,"totalWeightG":3538,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":952,"burnTimeS":6.15,"caseInfo":"RMS-98/5120","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L952","dataFiles":2,"delays":"P","designation":"L952W","diameter":98,"impulseClass":"L","length":427,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1022,"motorId":"5f4294d20002310000000185","propInfo":"White Lightning","propWeightG":2750,"samples":[[0,0],[0.141,679.1],[0.425,801.6],[0.709,848.5],[0.994,913.3],[1.278,981.6],[1.562,1044],[1.847,1088],[2.131,1113],[2.416,1122],[2.7,1119],[2.984,1101],[3.269,1039],[3.553,965.8],[3.837,876.8],[4.122,780.7],[4.406,693.9],[4.691,608],[4.975,528.3],[5.259,463.5],[5.544,405.8],[5.828,358.4],[6.112,279],[6.397,99.9],[6.681,20.11],[6.967,3.317],[7.252,0]],"totImpulseNs":4656,"totalWeightG":5012,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":970,"burnTimeS":5.256,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L970","dataFiles":1,"designation":"2800CC300M-L970","diameter":75,"impulseClass":"L","length":1438,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d20002310000000186","propWeightG":2537,"samples":[[0,0],[0.01,534.3],[0.02,1008],[0.03,1321],[0.04,1463],[0.05,1482],[0.25,1316],[0.44,1363],[0.64,1441],[0.84,1453],[1.04,1418],[1.23,1404],[1.43,1338],[1.63,1311],[1.83,1257],[2.02,1279],[2.22,1230],[2.42,1174],[2.62,1163],[2.81,1122],[3.02,1109],[3.21,1058],[3.41,981.2],[3.61,959.4],[3.8,778.8],[4.09,437.6],[4.38,294.3],[4.66,194.7],[4.94,129.3],[5.23,86.31],[5.23,0]],"totImpulseNs":5098,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1000,"burnTimeS":2.6,"caseInfo":"54-2550 (K1100)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1000","dataFiles":2,"designation":"L1000S","diameter":54,"impulseClass":"L","length":728,"manufacturer":"Kosdon by AeroTech","manufacturerAbbrev":"KBA","maxThrustN":1738,"motorId":"5f4294d20002310000000187","propWeightG":1301,"samples":[[0,0],[0.055,795.3],[0.175,981.6],[0.295,989.2],[0.415,1009],[0.535,1029],[0.655,1048],[0.775,1068],[0.895,1087],[1.015,1109],[1.135,1132],[1.255,1157],[1.375,1177],[1.498,1200],[1.62,1213],[1.74,1227],[1.86,1232],[1.98,1250],[2.1,1026],[2.22,737.1],[2.34,565.9],[2.46,313.4],[2.58,89.71],[2.7,20.76],[2.82,8.526],[2.942,5.338],[3.065,0]],"totImpulseNs":2592,"totalWeightG":2325,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1065,"burnTimeS":3.4,"caseInfo":"AMW 75-3500","certOrg":"National Association of Rocketry","commonName":"L1060","dataFiles":3,"designation":"GG-75-3500","diameter":75,"impulseClass":"L","infoUrl":"http://nar.org/SandT/pdf/Animal/L1060.pdf","length":497,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":1298,"motorId":"5f4294d20002310000000188","propInfo":"Green Gorilla","propWeightG":1919,"samples":[[0,0],[0.02,258.8],[0.024,368.2],[0.032,328.4],[0.076,428],[0.1,567.3],[0.116,751.4],[0.128,791.2],[0.169,816.1],[0.225,816.1],[0.309,875.8],[0.518,985.3],[0.763,1080],[1.024,1175],[1.308,1229],[1.606,1288],[1.782,1298],[1.983,1293],[2.256,1239],[2.525,1185],[2.822,1130],[3.038,1070],[3.111,1045],[3.135,995.1],[3.183,835.9],[3.239,552.3],[3.299,268.7],[3.327,164.2],[3.339,84.59],[3.36,44.78],[3.4,0]],"totImpulseNs":3623,"totalWeightG":3939,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1080,"burnTimeS":3.37,"caseInfo":"AMW 75-3500","certOrg":"National Association of Rocketry","commonName":"L1080","dataFiles":2,"designation":"BB-75-3500","diameter":75,"impulseClass":"L","infoUrl":"http://nar.org/SandT/pdf/Animal/L1080.pdf","length":497,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d20002310000000189","propInfo":"Blue Baboon","propWeightG":1717,"samples":[[0,0],[0.024,406.3],[0.043,812.5],[0.052,895.2],[0.088,929.6],[0.314,991.5],[0.626,1088],[0.988,1163],[1.346,1219],[1.638,1246],[1.864,1258],[2.247,1255],[2.6,1219],[2.766,1212],[2.851,1198],[2.942,1205],[3.002,1226],[3.033,1205],[3.089,1040],[3.124,874.5],[3.15,661],[3.191,461.3],[3.232,275.4],[3.268,144.6],[3.303,75.74],[3.339,41.32],[3.39,0]],"totImpulseNs":3700,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1090,"burnTimeS":4.43,"caseInfo":"Pro75-4G","certOrg":"Canadian Association of Rocketry","commonName":"L1090","dataFiles":2,"designation":"4815L1090-P","diameter":75,"impulseClass":"L","length":665,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1702,"motorId":"5f4294d2000231000000018a","propWeightG":3440,"samples":[[0,0],[0.001,487.3],[0.111,1639],[0.221,1484],[0.441,1418],[0.871,1373],[1.311,1329],[1.741,1307],[2.181,1263],[2.611,1218],[3.051,1152],[3.211,775.3],[3.481,598],[3.921,553.8],[4.131,221.5],[4.351,0]],"totImpulseNs":4815,"totalWeightG":5461,"type":"reload","updatedOn":"2021-06-13"},{"availability":"OOP","avgThrustN":1100,"burnTimeS":2.3,"caseInfo":"AMW 54-2550","certOrg":"National Association of Rocketry","commonName":"L1100","dataFiles":2,"designation":"RR-54-2550","diameter":54,"impulseClass":"L","infoUrl":"http://nar.org/SandT/pdf/Animal/L1100.pdf","length":728,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d2000231000000018b","propInfo":"Red Rhino","propWeightG":1346,"samples":[[0,0],[0.013,681.5],[0.029,1117],[0.041,1196],[0.079,1210],[0.147,1203],[0.257,1218],[0.366,1225],[0.567,1255],[0.824,1283],[1.059,1312],[1.267,1340],[1.459,1312],[1.622,1298],[1.713,1291],[1.785,1269],[1.83,1218],[1.886,1081],[1.969,819.2],[2.048,558.2],[2.108,377],[2.156,246.5],[2.205,145],[2.269,72.5],[2.35,0]],"totImpulseNs":2600,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1111,"burnTimeS":3.14,"caseInfo":"AMW 75-3500","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1111","dataFiles":2,"designation":"ST-75-3500","diameter":75,"impulseClass":"L","length":497,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":1379,"motorId":"5f4294d2000231000000018c","propInfo":"Super Tiger","propWeightG":1642,"samples":[[0,0],[0.015,1024],[0.1,924.9],[0.147,902.9],[0.502,1035],[0.75,1156],[1.005,1266],[1.229,1354],[1.492,1398],[1.739,1398],[2.009,1354],[2.272,1244],[2.504,1123],[2.728,968.9],[2.782,902.9],[2.836,770.7],[2.98,363.3],[3.053,99.09],[3.083,22.02],[3.14,0]],"totImpulseNs":3480,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1119,"burnTimeS":4.48,"caseInfo":"Pro75-4G","certOrg":"Canadian Association of Rocketry","commonName":"L1115","dataFiles":3,"designation":"5015L1115-P","diameter":75,"impulseClass":"L","length":621,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1713,"motorId":"5f4294d2000231000000018d","propInfo":"Classic","propWeightG":2394,"samples":[[0,0],[0.1,1469],[0.3,1491],[0.8,1402],[1,1437],[1.5,1335],[2,1268],[2.2,1246],[2.5,1113],[3,1090],[3.3,979],[3.8,979],[4,623],[4.2,311.5],[4.4,35],[4.48,0]],"totImpulseNs":5015,"totalWeightG":4404,"type":"reload","updatedOn":"2021-06-13"},{"availability":"OOP","avgThrustN":1120,"burnTimeS":4.43,"caseInfo":"RMS-75/5120","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1120","dataFiles":2,"designation":"L1120W","diameter":75,"impulseClass":"L","length":665,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1794,"motorId":"5f4294d2000231000000018e","propInfo":"White Lightning","propWeightG":2778,"samples":[[0,0],[0.097,1377],[0.293,1443],[0.489,1497],[0.685,1537],[0.882,1555],[1.078,1554],[1.275,1548],[1.472,1533],[1.668,1510],[1.865,1472],[2.061,1363],[2.257,1245],[2.454,1149],[2.651,1063],[2.847,985],[3.044,916.2],[3.241,831.9],[3.436,766.5],[3.633,699],[3.83,563],[4.026,384.6],[4.223,227.7],[4.42,105.1],[4.616,56.34],[4.813,21.71],[5.009,0]],"totImpulseNs":4947,"totalWeightG":4658,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1150,"burnTimeS":3.07,"caseInfo":"RMS-75/3840","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1150","dataFiles":2,"delays":"P","designation":"L1150R","diameter":75,"impulseClass":"L","length":530,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1346,"motorId":"5f4294d2000231000000018f","propInfo":"Redline","propWeightG":1902,"samples":[[0,0],[0.053,935.9],[0.175,1293],[0.3,1261],[0.425,1241],[0.55,1257],[0.675,1272],[0.8,1288],[0.925,1301],[1.048,1310],[1.17,1308],[1.295,1305],[1.42,1285],[1.545,1268],[1.67,1256],[1.795,1227],[1.92,1202],[2.043,1183],[2.165,1151],[2.29,1118],[2.415,1082],[2.54,1038],[2.665,1007],[2.79,1009],[2.915,643.1],[3.04,64.37],[3.165,0]],"totImpulseNs":3517,"totalWeightG":3674,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":1173,"burnTimeS":3.1,"caseInfo":"75x1524 (3200CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1222","dataFiles":2,"designation":"L1222-SM","diameter":75,"impulseClass":"L","length":1371,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":2892,"motorId":"5f4294d20002310000000190","propWeightG":786,"samples":[[0,0],[0.001,455],[0.251,455],[0.501,2725],[0.751,1816],[2.751,680],[3.101,0]],"sparky":true,"totImpulseNs":3682,"totalWeightG":4989,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1300,"burnTimeS":2,"caseInfo":"AMW 54-2550","certOrg":"National Association of Rocketry","commonName":"L1300","dataFiles":2,"designation":"BB-54-2550","diameter":54,"impulseClass":"L","infoUrl":"http://nar.org/SandT/pdf/Animal/L1300.pdf","length":728,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d20002310000000191","propInfo":"Blue Baboon","propWeightG":1314,"samples":[[0,0],[0.014,710.5],[0.025,1248],[0.039,1384],[0.053,1448],[0.074,1421],[0.12,1448],[0.276,1474],[0.475,1520],[0.712,1555],[0.942,1587],[1.147,1562],[1.36,1535],[1.484,1552],[1.537,1552],[1.569,1497],[1.59,1406],[1.604,1452],[1.615,1334],[1.64,1169],[1.689,986.7],[1.753,767.7],[1.824,512.5],[1.891,275.5],[1.933,147.8],[1.987,74.74],[2.06,0]],"totImpulseNs":2675,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1300,"burnTimeS":3.513,"caseInfo":"RMS-98/5120","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1300","dataFiles":2,"delays":"P","designation":"L1300R","diameter":98,"impulseClass":"L","length":443,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1552,"motorId":"5f4294d20002310000000192","propInfo":"Redline","propWeightG":2632,"samples":[[0,0],[0.034,16.21],[0.039,275.6],[0.044,563.4],[0.054,1127],[0.058,591.7],[0.131,1188],[0.248,1256],[0.511,1370],[0.759,1435],[1.002,1496],[1.251,1532],[1.372,1536],[1.504,1528],[1.757,1516],[2.01,1487],[2.263,1423],[2.418,1402],[2.501,1350],[2.672,1297],[2.759,1265],[2.847,1208],[3.007,1123],[3.085,1094],[3.148,1050],[3.182,1034],[3.251,1038],[3.304,1062],[3.333,1106],[3.372,887.6],[3.382,672.8],[3.406,445.8],[3.411,316.1],[3.431,222.9],[3.455,141.9],[3.479,56.74],[3.552,0]],"totImpulseNs":4567,"totalWeightG":4884,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1400,"burnTimeS":2,"caseInfo":"54/2800","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1400","dataFiles":2,"designation":"L1400-LW","diameter":54,"impulseClass":"L","length":736,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":2711,"motorId":"5f4294d20002310000000193","propInfo":"Loki White","propWeightG":1400,"samples":[[0,0],[0.0058,1606],[0.1189,1536],[0.3277,1536],[0.4988,1589],[1.001,1783],[1.407,1906],[1.499,1377],[1.607,953.2],[1.746,547.2],[1.905,335.4],[1.998,211.8],[2,0]],"totImpulseNs":2851,"totalWeightG":2540,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1400,"burnTimeS":1.88,"caseInfo":"54-2550 (K1400)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1400","dataFiles":2,"designation":"L1400F","diameter":54,"impulseClass":"L","length":728,"manufacturer":"Kosdon by AeroTech","manufacturerAbbrev":"KBA","maxThrustN":1989,"motorId":"5f4294d20002310000000194","propWeightG":1248,"samples":[[0,0],[0.037,1541],[0.061,1453],[0.166,1354],[1.001,1773],[1.279,1784],[1.329,1883],[1.387,1993],[1.486,1387],[1.604,869.8],[1.65,748.7],[1.666,726.7],[1.69,924.9],[1.697,594.6],[1.758,319.3],[1.88,0]],"totImpulseNs":2640,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1420,"burnTimeS":3.24,"caseInfo":"RMS-75/5120","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1420","dataFiles":2,"delays":"P","designation":"L1420R","diameter":75,"impulseClass":"L","length":665,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1814,"motorId":"5f4294d20002310000000195","propInfo":"Redline","propWeightG":2560,"samples":[[0,0],[0.03864,1332],[0.1236,1563],[0.5023,1519],[0.9969,1574],[1.499,1663],[2.002,1574],[2.481,1409],[2.921,1299],[2.991,1167],[3.114,187.2],[3.24,0]],"totImpulseNs":4603,"totalWeightG":4562,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1500,"burnTimeS":3.47,"caseInfo":"RMS-98/5120","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1500","dataFiles":2,"delays":"P","designation":"L1500T","diameter":98,"impulseClass":"L","length":443,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1752,"motorId":"5f4294d20002310000000196","propInfo":"Blue Thunder","propWeightG":2491,"samples":[[0,0],[0.073,1320],[0.222,1455],[0.372,1509],[0.522,1557],[0.672,1602],[0.822,1642],[0.971,1670],[1.12,1695],[1.27,1701],[1.42,1704],[1.57,1701],[1.72,1695],[1.869,1684],[2.018,1660],[2.168,1620],[2.318,1570],[2.468,1518],[2.618,1463],[2.767,1401],[2.916,1331],[3.066,1279],[3.216,1109],[3.366,217.8],[3.516,10.58],[3.666,3.245],[3.816,0]],"totImpulseNs":5089,"totalWeightG":4659,"type":"reload","updatedOn":"2021-10-27"},{"availability":"regular","avgThrustN":542,"burnTimeS":13.81,"caseInfo":"Pro98-3G","certOrg":"Canadian Association of Rocketry","commonName":"M520","dataFiles":2,"designation":"7400M520-P","diameter":98,"impulseClass":"M","length":548,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1184,"motorId":"5f4294d20002310000000197","propInfo":"Classic","propWeightG":3658,"samples":[[0,0],[0.01,1077],[0.25,1063],[0.38,1066],[0.5,971],[0.71,938.1],[0.93,915.5],[1.23,878.6],[2.07,907],[2.61,901.3],[3.03,892.8],[3.5,872.9],[3.93,836.1],[4.96,756.7],[6.08,657.5],[7.05,549.8],[7.79,462],[8.39,391.1],[9.06,323.1],[10.01,243.7],[11.01,172.9],[12,116.2],[13.95,0]],"totImpulseNs":7441,"totalWeightG":6693,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":762.4,"burnTimeS":7.22,"caseInfo":"75mm X1371mm (3200 cc)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M711","dataFiles":2,"designation":"M711-BS","diameter":75,"impulseClass":"M","length":1371,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":1872,"motorId":"5f4294d20002310000000198","propWeightG":727,"samples":[[0,0],[0.001,1140],[1.468,1070],[4.001,680],[6.474,589.1],[6.675,279.1],[7.221,0]],"totImpulseNs":5507,"totalWeightG":4900,"type":"hybrid","updatedOn":"2021-06-13"},{"availability":"OOP","avgThrustN":740,"burnTimeS":6.95,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M740","dataFiles":1,"designation":"2800CC200M-M740","diameter":75,"impulseClass":"M","length":1438,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d20002310000000199","propWeightG":2589,"samples":[[0,0],[0.04,979.3],[0.08,1136],[0.12,1066],[0.16,1027],[0.2,1023],[0.44,982.9],[0.68,1066],[0.91,1101],[1.15,1067],[1.39,1073],[1.63,1013],[1.87,1017],[2.11,1012],[2.35,1007],[2.58,968.1],[2.82,948.7],[3.06,944],[3.3,905.5],[3.54,899.5],[3.77,866.2],[4.02,847.5],[4.25,822.7],[4.49,814],[4.73,789.3],[4.97,752.5],[5.21,344.8],[5.45,271.9],[5.84,195.2],[6.46,108.8],[6.97,0]],"totImpulseNs":5143,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":845,"burnTimeS":7.29,"caseInfo":"RMS-98/5120","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M845","dataFiles":2,"designation":"M845H","diameter":98,"impulseClass":"M","length":782,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d2000231000000019a","propWeightG":3433,"samples":[[0,0],[0.01546,1332],[0.04637,1707],[0.07728,1178],[0.1855,1310],[0.9737,1222],[1.515,1200],[1.978,1123],[3.972,1057],[4.204,880.8],[6.012,627.6],[6.495,418.4],[7.017,99.09],[7.5,0]],"totImpulseNs":6159,"type":"hybrid","updatedOn":"2022-06-15"},{"availability":"regular","avgThrustN":900,"burnTimeS":12.3,"caseInfo":"h 3716 cc (M700)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M900","dataFiles":1,"designation":"M900","diameter":64,"impulseClass":"M","length":1828,"manufacturer":"R.A.T.T. Works","manufacturerAbbrev":"RATT","maxThrustN":1945,"motorId":"5f4294d2000231000000019b","propWeightG":3288,"samples":[[0,0],[0.04,151.9],[0.43,241.8],[0.5,1055],[7.04,718.1],[7.22,346.4],[7.26,297.1],[7.35,241.2],[7.48,200.7],[7.66,164.8],[12.28,49.36],[12.3,0]],"totImpulseNs":6463,"totalWeightG":3288,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":956,"burnTimeS":6.717,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M956","dataFiles":1,"designation":"3500CCRGM-M956","diameter":98,"impulseClass":"M","length":1166,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d2000231000000019c","propWeightG":3162,"samples":[[0,0],[0.04,1325],[0.08,1335],[0.12,1274],[0.16,1246],[0.2,1261],[0.46,1284],[0.71,1340],[0.97,1333],[1.23,1323],[1.49,1330],[1.75,1295],[2.01,1272],[2.27,1246],[2.52,1233],[2.78,1214],[3.04,1199],[3.3,1152],[3.56,1128],[3.81,1119],[4.08,1099],[4.33,1054],[4.59,1032],[4.85,965],[5.11,548.4],[5.45,373.4],[5.79,248.1],[6.14,160.9],[6.48,109.1],[6.7,0]],"totImpulseNs":6421,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":960,"burnTimeS":5.34,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M960","dataFiles":1,"designation":"2800CC300MFX-M960FX","diameter":75,"impulseClass":"M","length":1438,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d2000231000000019d","propWeightG":2629,"samples":[[0,0],[0.01,508.3],[0.02,1058],[0.03,1394],[0.04,1535],[0.05,1585],[0.25,1375],[0.44,1355],[0.64,1365],[0.84,1385],[1.04,1418],[1.23,1359],[1.43,1348],[1.63,1291],[1.83,1241],[2.02,1236],[2.22,1222],[2.42,1182],[2.62,1151],[2.81,1106],[3.02,1040],[3.21,982.5],[3.41,999.6],[3.61,943.7],[3.8,871.9],[4.11,526.7],[4.42,331],[4.72,212.7],[5.03,135.8],[5.33,0]],"totImpulseNs":5126,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1000,"burnTimeS":9.155,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1000","dataFiles":2,"designation":"4630CCRGM-M1000","diameter":98,"impulseClass":"M","length":1405,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d2000231000000019e","propWeightG":4236,"samples":[[0,0],[0.197,1368],[0.593,1448],[0.989,1482],[1.384,1431],[1.78,1410],[2.176,1400],[2.573,1366],[2.97,1339],[3.366,1296],[3.761,1280],[4.157,1236],[4.553,1213],[4.95,1197],[5.347,1172],[5.743,1129],[6.139,1052],[6.534,635.3],[6.93,474.4],[7.327,360],[7.724,273],[8.12,205.2],[8.516,149.1],[8.911,103.6],[9.307,70.12],[9.704,48.71],[10.1,0]],"totImpulseNs":9155,"totalWeightG":8907,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1000,"burnTimeS":7,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1000","dataFiles":2,"designation":"M1000","diameter":76,"impulseClass":"M","length":787,"manufacturer":"Ellis Mountain","manufacturerAbbrev":"Ellis","maxThrustN":2425,"motorId":"5f4294d2000231000000019f","propWeightG":3511,"samples":[[0,0],[0.159,1897],[0.481,1606],[0.803,1442],[1.125,1360],[1.447,1300],[1.769,1259],[2.091,1231],[2.413,1203],[2.735,1180],[3.057,1155],[3.379,1109],[3.701,1075],[4.023,1045],[4.345,1010],[4.667,951.2],[4.989,860.5],[5.31,727.4],[5.633,595.7],[5.955,518.9],[6.277,439.9],[6.599,347.7],[6.921,239.4],[7.243,144.6],[7.565,75.11],[7.887,33.54],[8.21,0]],"totImpulseNs":7320,"totalWeightG":5578,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1001,"burnTimeS":9.825,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1001","dataFiles":1,"designation":"5478CCRGM-M1001","diameter":98,"impulseClass":"M","length":1438,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d200023100000001a0","propWeightG":5161,"samples":[[0,0],[0.04,1394],[0.08,1440],[0.12,1322],[0.16,1329],[0.2,1341],[0.57,1411],[0.95,1421],[1.32,1416],[1.69,1405],[2.07,1384],[2.44,1371],[2.82,1354],[3.19,1319],[3.57,1327],[3.94,1338],[4.32,1247],[4.69,1287],[5.07,1220],[5.44,1124],[5.82,1075],[6.19,1078],[6.56,996.4],[6.94,953.2],[7.31,676.7],[7.83,419.5],[8.35,285.8],[8.87,192.2],[9.39,128.7],[9.87,0]],"totImpulseNs":9835,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1010,"burnTimeS":9.024,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1010","dataFiles":2,"designation":"4630CCRGMFX-M1010FX","diameter":98,"impulseClass":"M","length":1405,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d200023100000001a1","propWeightG":4301,"samples":[[0,0],[0.199,1473],[0.599,1473],[0.999,1464],[1.399,1381],[1.799,1408],[2.199,1384],[2.599,1333],[2.999,1357],[3.399,1339],[3.799,1306],[4.199,1266],[4.599,1224],[4.999,1191],[5.399,1145],[5.799,1103],[6.199,1061],[6.599,696.8],[6.999,487.5],[7.399,377.9],[7.799,288.2],[8.199,221.4],[8.599,166.7],[8.999,123.7],[9.399,90.17],[9.8,64.57],[10.2,0]],"totImpulseNs":9114,"totalWeightG":9000,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1015,"burnTimeS":6.24,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1015","dataFiles":1,"designation":"3500CCRGMFX-M1015FX","diameter":98,"impulseClass":"M","length":1166,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d200023100000001a2","propWeightG":3250,"samples":[[0,0],[0.04,1515],[0.08,1634],[0.12,1567],[0.16,1507],[0.2,1477],[0.41,1418],[0.63,1420],[0.85,1436],[1.06,1405],[1.28,1371],[1.49,1355],[1.71,1320],[1.93,1287],[2.14,1269],[2.36,1268],[2.58,1281],[2.79,1249],[3.01,1268],[3.23,1273],[3.44,1298],[3.66,1214],[3.87,1167],[4.09,1135],[4.31,1121],[4.69,544.6],[5.07,363.6],[5.46,234.8],[5.84,149.4],[6.22,94.73],[6.23,0]],"totImpulseNs":6334,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1040,"burnTimeS":9.71,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1040","dataFiles":1,"designation":"4630CCRGMFX-M1040FX","diameter":98,"impulseClass":"M","length":1438,"manufacturer":"Hypertek","manufacturerAbbrev":"Hypertek","motorId":"5f4294d200023100000001a3","propWeightG":5293,"samples":[[0,0],[0.02,1288],[0.05,1545],[0.07,1584],[0.09,1531],[0.12,1498],[0.53,1422],[0.95,1430],[1.37,1412],[1.78,1399],[2.2,1372],[2.61,1383],[3.03,1406],[3.44,1479],[3.86,1421],[4.27,1378],[4.69,1334],[5.1,1289],[5.52,1275],[5.93,1176],[6.35,1152],[6.77,891.1],[7.18,582.2],[7.6,429],[8.01,320.7],[8.43,238.7],[8.84,175.9],[9.25,128.9],[9.66,92.08],[9.7,0]],"totImpulseNs":10100,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1297,"burnTimeS":4.17,"caseInfo":"RMS-75/5120","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1297","dataFiles":2,"delays":"P","designation":"M1297W","diameter":75,"impulseClass":"M","length":665,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":2049,"motorId":"5f4294d200023100000001a4","propInfo":"White Lightning","propWeightG":2722,"samples":[[0,0],[0.1,1433],[0.15,1789],[0.2,1923],[0.25,1869],[0.3,1856],[0.35,1834],[0.4,1767],[0.5,1723],[0.6,1709],[0.9,1700],[1,1688],[1.5,1679],[1.75,1635],[1.85,1622],[1.95,1573],[2,1554],[2.5,1347],[3,1136],[3.2,1053],[3.25,1044],[3.35,1032],[3.38,1020],[3.4,937],[3.5,738],[3.6,545],[3.75,393],[4,226],[4.25,94],[4.35,45],[4.4,0]],"totImpulseNs":5417,"totalWeightG":4637,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1248,"burnTimeS":5.4,"caseInfo":"RMS-75/6400","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1315","dataFiles":2,"delays":"P","designation":"M1315W","diameter":75,"impulseClass":"M","length":801,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":2362,"motorId":"5f4294d200023100000001a5","propInfo":"White Lightning","propWeightG":3499,"samples":[[0,0],[0.116,1729],[0.349,1673],[0.582,1687],[0.816,1696],[1.049,1663],[1.282,1631],[1.516,1620],[1.749,1620],[1.982,1621],[2.216,1615],[2.449,1567],[2.682,1494],[2.916,1420],[3.149,1359],[3.382,1293],[3.616,1225],[3.849,1172],[4.082,928.8],[4.316,577.9],[4.549,395.4],[4.782,314],[5.016,228.3],[5.249,159.8],[5.482,118.3],[5.716,109.8],[5.949,0]],"totImpulseNs":6714,"totalWeightG":5645,"type":"reload","updatedOn":"2023-03-11"},{"availability":"OOP","avgThrustN":1350,"burnTimeS":4.23,"caseInfo":"AMW 75-6000","certOrg":"National Association of Rocketry","commonName":"M1350","dataFiles":2,"designation":"WT-75-6000","diameter":75,"impulseClass":"M","infoUrl":"http://nar.org/SandT/pdf/Animal/M1350.pdf","length":785,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":1663,"motorId":"5f4294d200023100000001a6","propInfo":"White Wolf","propWeightG":2927,"samples":[[0,0],[0.03,1198],[0.04,1465],[0.07,1660],[0.09,1666],[0.16,1588],[0.45,1588],[0.61,1577],[1.86,1649],[2.27,1643],[2.64,1599],[3.18,1504],[3.29,1354],[3.41,991.6],[3.49,841.2],[3.62,646.2],[3.74,429],[3.9,373.3],[4.22,0]],"totImpulseNs":5711,"totalWeightG":5403,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1398,"burnTimeS":4.47,"caseInfo":"Pro75-5G","certOrg":"Canadian Association of Rocketry","commonName":"M1400","dataFiles":3,"designation":"6251M1400-P","diameter":75,"impulseClass":"M","length":757,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":2292,"motorId":"5f4294d200023100000001a7","propInfo":"Classic","propWeightG":2992,"samples":[[0,0],[0.02,991.6],[0.07,1940],[0.11,2292],[0.14,1976],[0.19,1962],[0.29,1936],[0.52,1881],[0.75,1833],[1,1778],[1.25,1739],[1.7,1655],[2.4,1502],[2.85,1389],[3.25,1283],[3.4,1232],[3.53,1200],[3.65,1084],[3.7,909.4],[3.9,641.5],[4,502.8],[4.03,463],[4.22,336.1],[4.43,138.7],[4.47,93.21],[5,0]],"totImpulseNs":6251,"totalWeightG":5302,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":1419,"burnTimeS":7.1,"caseInfo":"RMS-98/7680","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1419","dataFiles":2,"delays":"P","designation":"M1419W","diameter":98,"impulseClass":"M","length":579,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1591,"motorId":"5f4294d200023100000001a8","propInfo":"White Lightning","propWeightG":4077,"samples":[[0,0],[0.154,1155],[0.465,1241],[0.776,1300],[1.087,1358],[1.399,1411],[1.71,1461],[2.022,1486],[2.333,1504],[2.644,1513],[2.955,1512],[3.267,1492],[3.578,1418],[3.89,1327],[4.201,1219],[4.513,1088],[4.824,937.1],[5.135,810.1],[5.446,709.1],[5.757,624.7],[6.069,557.2],[6.38,437.8],[6.692,252.1],[7.003,107.7],[7.315,19.97],[7.626,0.515],[7.937,0]],"totImpulseNs":7756,"totalWeightG":6916,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1480,"burnTimeS":3.9,"caseInfo":"AMW 75-6000","certOrg":"National Association of Rocketry","commonName":"M1480","dataFiles":2,"designation":"RR-75-6000","diameter":75,"impulseClass":"M","infoUrl":"http://nar.org/SandT/pdf/Animal/M1480.pdf","length":785,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d200023100000001a9","propInfo":"Red Rhino","propWeightG":3000,"samples":[[0,0],[0.022,713],[0.032,1255],[0.055,1473],[0.078,1569],[0.156,1569],[0.352,1559],[0.642,1597],[0.974,1645],[1.289,1702],[1.52,1739],[1.918,1797],[2.279,1815],[2.481,1797],[2.707,1739],[2.968,1645],[3.058,1616],[3.135,1521],[3.218,1379],[3.284,1217],[3.332,1065],[3.344,1141],[3.368,1017],[3.41,741.5],[3.5,522.9],[3.613,275.7],[3.691,171.1],[3.768,66.55],[3.85,0]],"totImpulseNs":5800,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1550,"burnTimeS":3,"caseInfo":"RMS-75/6400","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1550","dataFiles":2,"delays":"P","designation":"M1550R","diameter":75,"impulseClass":"M","length":801,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":2180,"motorId":"5f4294d200023100000001aa","propInfo":"Redline","propWeightG":3170,"samples":[[0,0],[0.069,1721],[0.212,2125],[0.358,1996],[0.501,1908],[0.645,1869],[0.79,1836],[0.935,1809],[1.079,1796],[1.222,1785],[1.368,1773],[1.511,1747],[1.655,1716],[1.8,1690],[1.945,1661],[2.089,1633],[2.232,1606],[2.378,1570],[2.521,1535],[2.665,1503],[2.81,1461],[2.955,1428],[3.099,1393],[3.242,940],[3.388,268.5],[3.532,4.985],[3.677,0]],"totImpulseNs":5600,"totalWeightG":5645,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1556,"burnTimeS":4.2,"caseInfo":"98 60 M BG(5300CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1575","dataFiles":2,"designation":"M1575-BG","diameter":98,"impulseClass":"M","length":1524,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":2965,"motorId":"5f4294d200023100000001ab","propWeightG":2210,"samples":[[0,0],[0.1398,2429],[0.5034,2977],[2.953,1403],[3.065,923.9],[3.21,376.4],[3.311,205.3],[4.2,0]],"totImpulseNs":6547,"totalWeightG":10680,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1600,"burnTimeS":4,"caseInfo":"RMS-98/7680","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1600","dataFiles":2,"delays":"P","designation":"M1600R","diameter":98,"impulseClass":"M","length":579,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1917,"motorId":"5f4294d200023100000001ac","propInfo":"Redline","propWeightG":4026,"samples":[[0,0],[0.088,1370],[0.268,1627],[0.448,1673],[0.628,1721],[0.808,1763],[0.987,1801],[1.167,1830],[1.348,1845],[1.529,1856],[1.71,1850],[1.89,1847],[2.07,1829],[2.25,1811],[2.43,1785],[2.61,1754],[2.79,1727],[2.971,1689],[3.152,1642],[3.332,1582],[3.513,1511],[3.692,1431],[3.872,1361],[4.053,1235],[4.232,621.2],[4.414,42.47],[4.595,0]],"totImpulseNs":7084,"totalWeightG":6917,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1730,"burnTimeS":4.68,"caseInfo":"AMW 98-11000","certOrg":"National Association of Rocketry","commonName":"M1730","dataFiles":2,"designation":"SK-98-11000","diameter":98,"impulseClass":"M","length":870,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d200023100000001ad","propInfo":"Skidmark","propWeightG":4945,"samples":[[0,0],[0.04,682.6],[0.064,1153],[0.221,1355],[0.269,1415],[0.381,1458],[0.541,1527],[0.701,1589],[0.861,1675],[1.021,1733],[1.181,1802],[1.341,1887],[1.5,1974],[1.66,2071],[1.82,2184],[1.98,2299],[2.14,2434],[2.3,2568],[2.46,2679],[2.62,2638],[2.78,2484],[2.94,2306],[3.099,2174],[3.259,2075],[3.419,1961],[3.579,1808],[3.739,1640],[3.899,1303],[4.059,940.6],[4.219,567.2],[4.379,309.1],[4.539,189],[4.637,0]],"sparky":true,"totImpulseNs":8115,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1882,"burnTimeS":3,"caseInfo":"76/6000","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1882","dataFiles":2,"designation":"M1882-LW","diameter":76,"impulseClass":"M","length":787,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":2860,"motorId":"5f4294d200023100000001ae","propInfo":"Loki White","propWeightG":3130,"samples":[[0,0],[0.01,4.8],[0.0174,2579],[0.06961,2392],[0.232,2299],[0.5046,2261],[0.7715,2299],[0.9861,2411],[1.189,2579],[1.497,2598],[1.729,2486],[2.001,2355],[2.5,1645],[2.999,243],[3.25,0]],"totImpulseNs":6303,"totalWeightG":5534,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1850,"burnTimeS":3,"caseInfo":"AMW 75-6000","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1850","dataFiles":3,"designation":"GG-75-6000","diameter":75,"impulseClass":"M","length":781,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":2269,"motorId":"5f4294d200023100000001af","propInfo":"Green Gorilla","propWeightG":3375,"samples":[[0,0],[0.08,979],[0.13,1180],[0.28,1290],[0.33,1468],[0.73,1936],[1.33,2202],[1.73,2279],[2.58,2105],[2.83,2007],[2.88,1860],[3.08,538],[3.2,174],[3.3,0]],"totImpulseNs":5920,"totalWeightG":4500,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1900,"burnTimeS":2.85,"caseInfo":"AMW 75-6000","certOrg":"National Association of Rocketry","commonName":"M1900","dataFiles":2,"designation":"BB-75-6000","diameter":75,"impulseClass":"M","infoUrl":"http://nar.org/SandT/pdf/Animal/M1900.pdf","length":785,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d200023100000001b0","propInfo":"Blue Baboon","propWeightG":2733,"samples":[[0,0],[0.018,1109],[0.044,1762],[0.061,1911],[0.085,1939],[0.159,1930],[0.29,1957],[0.409,2032],[0.438,1975],[0.569,2012],[0.815,2105],[1.073,2197],[1.401,2280],[1.688,2325],[1.905,2297],[2.073,2241],[2.254,2138],[2.397,2064],[2.479,2017],[2.54,2026],[2.581,2007],[2.63,1886],[2.716,1494],[2.805,1120],[2.887,840.6],[2.972,570],[3.046,299.5],[3.119,150.2],[3.168,56.83],[3.23,0]],"totImpulseNs":6100,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1939,"burnTimeS":6.2,"caseInfo":"RMS-98/10240","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1939","dataFiles":2,"delays":"P","designation":"M1939W","diameter":98,"impulseClass":"M","length":732,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":2430,"motorId":"5f4294d200023100000001b1","propInfo":"White Lightning","propWeightG":5719,"samples":[[0,0],[0.134,1905],[0.406,2021],[0.679,2096],[0.952,2158],[1.225,2198],[1.498,2220],[1.77,2229],[2.042,2230],[2.315,2226],[2.587,2212],[2.86,2165],[3.133,2047],[3.405,1916],[3.677,1806],[3.95,1658],[4.223,1498],[4.496,1339],[4.769,1213],[5.041,1102],[5.313,966.5],[5.585,670.3],[5.858,444],[6.131,155.4],[6.404,41.36],[6.677,5.775],[6.95,0]],"totImpulseNs":10480,"totalWeightG":8988,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":2000,"burnTimeS":4,"caseInfo":"RMS-98/10240","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M2000","dataFiles":2,"delays":"P","designation":"M2000R","diameter":98,"impulseClass":"M","length":732,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":2327,"motorId":"5f4294d200023100000001b2","propInfo":"Redline","propWeightG":5368,"samples":[[0,0],[0.091,1531],[0.279,2186],[0.466,2167],[0.655,2187],[0.844,2219],[1.031,2248],[1.22,2274],[1.409,2298],[1.596,2310],[1.785,2316],[1.974,2316],[2.161,2306],[2.35,2282],[2.539,2252],[2.726,2210],[2.915,2169],[3.104,2117],[3.291,2068],[3.48,2005],[3.669,1934],[3.856,1831],[4.045,1746],[4.234,1504],[4.421,649.8],[4.61,58.18],[4.799,0]],"totImpulseNs":9218,"totalWeightG":8987,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":2020,"burnTimeS":4.998,"caseInfo":"AMW 98-11000","certOrg":"National Association of Rocketry","commonName":"N2020","dataFiles":2,"designation":"WT-98-11000","diameter":98,"impulseClass":"N","length":870,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d200023100000001b3","propInfo":"White Wolf","propWeightG":5161,"samples":[[0,0],[0.106,1941],[0.221,2151],[0.381,2253],[0.541,2341],[0.701,2401],[0.861,2454],[1.021,2506],[1.181,2556],[1.341,2607],[1.5,2653],[1.66,2689],[1.82,2711],[1.98,2730],[2.14,2734],[2.3,2704],[2.46,2635],[2.62,2532],[2.78,2433],[2.94,2330],[3.099,2234],[3.259,2166],[3.419,2100],[3.579,2028],[3.739,1951],[3.899,1871],[4.059,1558],[4.219,1053],[4.379,890.5],[4.539,636.7],[4.998,0]],"totImpulseNs":10280,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":2200,"burnTimeS":2.85,"caseInfo":"AMW 75-7600","certOrg":"National Association of Rocketry","commonName":"M2200","dataFiles":1,"designation":"SK-75-7600","diameter":75,"impulseClass":"M","infoUrl":"http://nar.org/SandT/pdf/Animal/M2200.pdf","length":1039,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d200023100000001b4","propInfo":"Skidmark","propWeightG":3766,"samples":[[0,0],[0.02,972.3],[0.049,1613],[0.101,1602],[0.243,1701],[0.482,1878],[0.571,1889],[0.802,2088],[0.997,2254],[1.073,2254],[1.227,2487],[1.426,2574],[1.616,2652],[1.681,2751],[1.782,2840],[1.831,2817],[1.961,2917],[2.07,2979],[2.155,2939],[2.196,2961],[2.256,2873],[2.321,2840],[2.374,2685],[2.422,2332],[2.483,1569],[2.524,1216],[2.584,1094],[2.674,1061],[2.747,961.3],[2.868,740.4],[2.953,464],[3.046,165.7],[3.11,0]],"sparky":true,"totImpulseNs":6350,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":2552,"burnTimeS":2.14,"caseInfo":"75x1753 (3200CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M2281","dataFiles":1,"designation":"M2281-BF","diameter":75,"impulseClass":"M","length":1524,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":6040,"motorId":"5f4294d200023100000001b5","propWeightG":1306,"samples":[[0,0],[0.001,2725],[0.201,4550],[0.601,4550],[0.801,4550],[0.901,4000],[0.951,2725],[1.989,116.3],[2.141,0]],"totImpulseNs":5482,"totalWeightG":5579,"type":"hybrid","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":2400,"burnTimeS":3.2,"caseInfo":"RMS-98/7680","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M2400","dataFiles":2,"delays":"P","designation":"M2400T","diameter":98,"impulseClass":"M","length":597,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":3402,"motorId":"5f4294d200023100000001b6","propInfo":"Blue Thunder","propWeightG":3693,"samples":[[0,0],[0.07,2442],[0.211,2495],[0.353,2556],[0.495,2602],[0.636,2638],[0.778,2661],[0.92,2676],[1.061,2687],[1.203,2696],[1.345,2694],[1.486,2684],[1.628,2667],[1.771,2630],[1.914,2579],[2.055,2522],[2.197,2462],[2.339,2394],[2.48,2304],[2.622,2202],[2.764,2097],[2.905,2010],[3.047,1276],[3.189,418.8],[3.33,17.59],[3.473,3.669],[3.616,0]],"totImpulseNs":7717,"totalWeightG":6451,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":2501,"burnTimeS":3.11,"caseInfo":"AMW 75-7600","certOrg":"National Association of Rocketry","commonName":"M2500","dataFiles":2,"designation":"GG-75-7600","diameter":75,"impulseClass":"M","infoUrl":"http://nar.org/SandT/pdf/Animal/M2500.pdf","length":1039,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":2996,"motorId":"5f4294d200023100000001b7","propInfo":"Green Gorilla","propWeightG":4248,"samples":[[0,0],[0.026,1289],[0.053,2021],[0.079,2140],[0.123,2105],[0.207,2117],[0.54,2309],[0.971,2561],[1.265,2727],[1.48,2837],[1.678,2920],[1.757,2980],[1.946,2996],[2.047,2959],[2.24,2890],[2.31,2855],[2.486,2821],[2.526,2881],[2.592,2774],[2.653,2822],[2.706,2752],[2.758,2752],[2.807,2764],[2.842,2505],[2.886,2115],[2.93,1631],[2.987,1052],[3.04,437.6],[3.057,284.1],[3.079,142.4],[3.11,0]],"totImpulseNs":7784,"totalWeightG":7552,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":2500,"burnTimeS":3.85,"caseInfo":"RMS-98/10240","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M2500","dataFiles":2,"delays":"P","designation":"M2500T","diameter":98,"impulseClass":"M","length":751,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":3711,"motorId":"5f4294d200023100000001b8","propInfo":"Blue Thunder","propWeightG":4711,"samples":[[0,0],[0.082,2652],[0.249,2780],[0.416,2821],[0.583,2843],[0.751,2848],[0.918,2851],[1.084,2855],[1.252,2862],[1.42,2858],[1.586,2851],[1.754,2845],[1.922,2831],[2.089,2805],[2.255,2766],[2.423,2711],[2.591,2648],[2.757,2587],[2.925,2521],[3.093,2462],[3.259,2420],[3.426,1895],[3.594,808],[3.761,282.4],[3.928,97.88],[4.096,24.49],[4.264,0]],"totImpulseNs":9671,"totalWeightG":8064,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":2491,"burnTimeS":3,"caseInfo":"Pro98-3G","certOrg":"Canadian Association of Rocketry","commonName":"M2505","dataFiles":2,"designation":"7450M2505-P","diameter":98,"impulseClass":"M","length":579,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":2953,"motorId":"5f4294d200023100000001b9","propInfo":"White Thunder","propWeightG":3339,"samples":[[0,0],[0.12,2600],[0.21,2482],[0.6,2715],[0.9,2876],[1.2,2938],[1.5,2889],[1.8,2785],[2.1,2573],[2.4,2349],[2.7,2182],[3,85],[3,0]],"totImpulseNs":7450,"totalWeightG":6250,"type":"reload","updatedOn":"2021-06-13"},{"availability":"OOP","avgThrustN":2600,"burnTimeS":4.03,"caseInfo":"AMW 98-11000","certOrg":"National Association of Rocketry","commonName":"N2600","dataFiles":2,"designation":"GG-98-11000","diameter":98,"impulseClass":"N","length":870,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d200023100000001ba","propInfo":"Green Gorilla","propWeightG":5591,"samples":[[0,0],[0.024,1674],[0.064,1950],[0.104,2040],[0.306,2190],[0.508,2334],[0.709,2491],[0.911,2669],[1.113,2875],[1.314,3039],[1.516,3191],[1.718,3266],[1.92,3319],[2.121,3336],[2.323,3229],[2.525,3090],[2.726,2944],[2.928,2848],[3.13,2752],[3.331,2682],[3.533,2463],[3.735,1340],[3.937,269.8],[4.034,0]],"totImpulseNs":10610,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":2700,"burnTimeS":4.16,"caseInfo":"AMW 98-11000","certOrg":"National Association of Rocketry","commonName":"N2700","dataFiles":2,"designation":"BB-98-11000","diameter":98,"impulseClass":"N","length":870,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d200023100000001bb","propInfo":"Blue Baboon","propWeightG":5147,"samples":[[0,0],[0.027,2230],[0.069,2476],[0.111,2540],[0.36,2723],[0.527,2864],[0.735,3016],[0.943,3141],[1.151,3242],[1.359,3336],[1.567,3520],[1.775,3426],[1.983,3421],[2.191,3356],[2.399,3270],[2.607,3183],[2.815,3098],[3.023,3003],[3.231,2889],[3.439,2267],[3.647,1498],[3.855,780],[4.063,233.5],[4.16,0]],"totImpulseNs":11450,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":2645,"burnTimeS":2.3,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M2700","dataFiles":2,"designation":"M2700-BS","diameter":98,"impulseClass":"M","length":1524,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":5484,"motorId":"5f4294d200023100000001bc","propWeightG":1730,"samples":[[0,0],[0.008475,2965],[0.05085,3272],[0.1059,5931],[0.3475,5829],[0.5042,6442],[0.5127,5726],[0.6017,5113],[0.7458,3681],[0.9025,3068],[1.064,2454],[1.186,1943],[1.343,1738],[1.75,715.8],[1.958,102.3],[2.3,0]],"totImpulseNs":6034,"totalWeightG":10430,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":2570,"burnTimeS":2.3,"caseInfo":"98 60 XF BG (5300CC)","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M2800","dataFiles":2,"designation":"M2800-BG","diameter":98,"impulseClass":"M","length":1524,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":4964,"motorId":"5f4294d200023100000001bd","propWeightG":2210,"samples":[[0,0],[0.008389,2395],[0.2517,2806],[0.5453,3695],[0.7578,5612],[0.9116,4311],[1.175,3559],[1.409,2258],[1.709,1506],[2.3,0]],"totImpulseNs":6060,"totalWeightG":10700,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":3000,"burnTimeS":2.49,"caseInfo":"AMW 75-7600","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M3000","dataFiles":2,"designation":"ST-75-7600","diameter":75,"impulseClass":"M","length":1039,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":4387,"motorId":"5f4294d200023100000001be","propInfo":"Super Tiger","propWeightG":3819,"samples":[[0,0],[0.032,2494],[0.113,2621],[0.242,2706],[0.355,2811],[0.435,2896],[0.5,2959],[0.645,3128],[0.75,3297],[0.871,3382],[0.968,3551],[1.032,3657],[1.145,3805],[1.355,3974],[1.452,4037],[1.629,4080],[1.742,4143],[1.903,4185],[1.935,3847],[2.081,3424],[2.129,2959],[2.177,2537],[2.194,2114],[2.226,1691],[2.274,1268],[2.323,845.5],[2.403,422.8],[2.5,0]],"totImpulseNs":7367,"totalWeightG":6720,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":2000,"burnTimeS":6.9,"caseInfo":"RMS-98/15360","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"N2000","dataFiles":2,"delays":"P","designation":"N2000W","diameter":98,"impulseClass":"N","length":1046,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":3141,"motorId":"5f4294d200023100000001bf","propInfo":"White Lightning","propWeightG":7753,"samples":[[0,0],[0.146,2775],[0.446,2832],[0.746,2834],[1.046,2830],[1.346,2778],[1.646,2688],[1.95,2598],[2.254,2501],[2.554,2416],[2.854,2344],[3.154,2263],[3.454,2178],[3.758,2104],[4.062,2024],[4.362,1936],[4.663,1840],[4.962,1757],[5.262,1352],[5.567,954.6],[5.871,681.8],[6.171,475.9],[6.471,361.1],[6.771,194.6],[7.071,44.94],[7.375,6.03],[7.679,0]],"totImpulseNs":13350,"totalWeightG":12280,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":2562,"burnTimeS":5.38,"caseInfo":"Pro98-6G","certOrg":"Canadian Association of Rocketry","commonName":"N2500","dataFiles":2,"designation":"13766N2500-P","diameter":98,"impulseClass":"N","length":1010,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":3876,"motorId":"5f4294d200023100000001c0","propInfo":"Classic","propWeightG":6778,"samples":[[0,0],[0.02,773.7],[0.05,3357],[0.06,3658],[0.1,3547],[0.25,3404],[0.4,3309],[0.8,3263],[1,3206],[1.5,3089],[2,2940],[2.5,2793],[3,2598],[3.5,2403],[4,2227],[4.25,2153],[4.4,2103],[4.5,2007],[4.6,1684],[4.75,1270],[5,767.3],[5.41,341.3],[5.42,0]],"totImpulseNs":13770,"totalWeightG":11670,"type":"reload","updatedOn":"2021-06-13"},{"availability":"OOP","avgThrustN":4000,"burnTimeS":4.2,"caseInfo":"AMW 98-17500","certOrg":"National Association of Rocketry","commonName":"N4000","dataFiles":2,"designation":"BB-98-17500","diameter":98,"impulseClass":"N","length":1213,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","motorId":"5f4294d200023100000001c1","propInfo":"Blue Baboon","propWeightG":7566,"samples":[[0,0],[0.029,4208],[0.071,4710],[0.113,4906],[0.155,5008],[0.239,5042],[0.323,4994],[0.534,5047],[0.744,5146],[0.954,5248],[1.165,5293],[1.375,5232],[1.585,5210],[1.796,5165],[2.006,5048],[2.216,4913],[2.427,4783],[2.637,4659],[2.847,4196],[3.058,2851],[3.268,1982],[3.478,1296],[3.689,907.7],[3.899,490.2],[4.11,316.3],[4.207,0]],"totImpulseNs":16460,"totalWeightG":13670,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":4800,"burnTimeS":4.44,"caseInfo":"RMS-98/18000","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"N4800","dataFiles":2,"designation":"N4800T","diameter":98,"impulseClass":"N","length":1201,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":6599,"motorId":"5f4294d200023100000001c2","propInfo":"Blue Thunder","propWeightG":9571,"samples":[[0,0],[0.098,4753],[0.301,6008],[0.506,5594],[0.71,5270],[0.914,5150],[1.119,5108],[1.324,5086],[1.528,5032],[1.731,4942],[1.936,4800],[2.14,4665],[2.344,4528],[2.549,4401],[2.754,4264],[2.958,4120],[3.161,3971],[3.366,3876],[3.57,3916],[3.774,3914],[3.979,3313],[4.184,1649],[4.388,523.4],[4.591,327.2],[4.796,251],[5.001,128.2],[5.206,0]],"totImpulseNs":19360,"totalWeightG":14780,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":5113,"burnTimeS":5.86,"certOrg":"Canadian Association of Rocketry","commonName":"O5100","dataFiles":2,"designation":"29990O5100-P","diameter":161,"impulseClass":"O","length":803,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":6562,"motorId":"5f4294d200023100000001c3","propWeightG":13250,"samples":[[0,0],[0.01,815.1],[0.02,1408],[0.03,2334],[0.04,3260],[0.05,4001],[0.07,4928],[0.07,5484],[0.09,5817],[0.13,6058],[0.2,6206],[0.3,6299],[0.43,6280],[0.6,6262],[0.78,6299],[0.97,6354],[1.05,6428],[1.12,6391],[1.34,6465],[1.49,6503],[1.75,6540],[1.88,6558],[2.16,6521],[2.36,6465],[2.58,6373],[2.96,6113],[3.56,5558],[4.13,4909],[4.72,4261],[4.83,4150],[4.93,3038],[5,2612],[5.1,2112],[5.23,1741],[5.32,1538],[5.52,1223],[5.8,907.7],[5.85,666.9],[5.89,333.4],[5.9,0]],"totImpulseNs":29990,"totalWeightG":23580,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":6354,"burnTimeS":4.29,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"O6300","dataFiles":2,"designation":"O6300-BS","diameter":152,"impulseClass":"O","length":1829,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":12730,"motorId":"5f4294d200023100000001c4","propWeightG":5216,"samples":[[0,0],[0.0339,12270],[0.7288,9715],[1.653,9203],[2.373,8948],[2.517,6647],[2.788,4602],[2.992,4857],[3.28,3579],[3.61,1278],[4.29,0]],"totImpulseNs":27240,"totalWeightG":28580,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1335,"burnTimeS":0.316,"caseInfo":"RMS-38/480","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I1299","dataFiles":2,"delays":"P","designation":"I1299N","diameter":38,"impulseClass":"I","length":249,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1851,"motorId":"5f4294d200023100000001c5","propInfo":"Warp 9","propWeightG":192,"samples":[[0,0],[0.001,15.72],[0.00461,222.5],[0.0125,1112],[0.01442,1237],[0.021,1287],[0.041,1359],[0.101,1451],[0.121,1470],[0.181,1491],[0.201,1483],[0.221,1462],[0.241,1399],[0.281,1208],[0.2957,1132],[0.301,1065],[0.3053,974.5],[0.321,305],[0.3315,55.01],[0.3349,11.79],[0.341,0]],"totImpulseNs":422.9,"totalWeightG":422,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1500,"burnTimeS":0.88,"caseInfo":"RMS-75/1280","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K1499","dataFiles":2,"delays":"P","designation":"K1499N","diameter":75,"impulseClass":"K","length":260,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1720,"motorId":"5f4294d200023100000001c6","propInfo":"Warp 9","propWeightG":604,"samples":[[0,0],[0.01,1450],[0.2,1720],[0.35,1700],[0.5,1600],[0.6,1575],[0.7,1500],[0.82,1400],[0.84,250],[0.88,0]],"totImpulseNs":1322,"totalWeightG":1741,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":373.8,"burnTimeS":1.52,"caseInfo":"RMS-38/720","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I364","dataFiles":2,"delays":"4,6,8,10","designation":"I364FJ","diameter":38,"impulseClass":"I","length":335,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":487.3,"motorId":"5f4294d200023100000001c7","propInfo":"Black Max","propWeightG":396,"samples":[[0,0],[0.02,356],[0.1,373.8],[0.2,387.2],[0.3,400.5],[0.4,400.5],[0.5,409.4],[0.6,413.9],[0.7,409.4],[0.8,382.7],[0.9,373.8],[1,351.6],[1.1,333.8],[1.2,320.4],[1.3,311.5],[1.4,244.8],[1.5,178],[1.6,80.1],[1.7,0]],"totImpulseNs":570.1,"totalWeightG":678,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":230.5,"burnTimeS":1.59,"caseInfo":"RMS-38/480","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I225","dataFiles":2,"delays":"4,6,8,10","designation":"I225FJ","diameter":38,"impulseClass":"I","length":240,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":276.6,"motorId":"5f4294d200023100000001c8","propInfo":"Black Max","propWeightG":264,"samples":[[0,0],[0.04,213.6],[0.1,213.6],[0.2,218.1],[0.28,235.9],[0.3,249.2],[0.4,262.6],[0.5,267],[0.6,271.5],[0.7,275.9],[0.8,275.9],[0.87,271.5],[0.9,258.1],[1,240.3],[1.1,218.1],[1.2,200.3],[1.3,178],[1.4,160.2],[1.5,97.9],[1.6,40.1],[1.7,13.4],[1.8,0]],"totImpulseNs":367.9,"totalWeightG":486,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":313.5,"burnTimeS":1.44,"caseInfo":"RMS-38/600","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I305","dataFiles":2,"delays":"4,6,8,10","designation":"I305FJ","diameter":38,"impulseClass":"I","length":288,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":418.2,"motorId":"5f4294d200023100000001c9","propInfo":"Black Max","propWeightG":330,"samples":[[0,0],[0.02,341.4],[0.1,365.5],[0.2,383.6],[0.3,403.7],[0.4,405.7],[0.5,405.7],[0.6,404.7],[0.7,374.5],[0.8,342.4],[0.9,309.3],[1,272.1],[1.1,239],[1.15,224.9],[1.2,194.8],[1.3,119.5],[1.4,62.26],[1.45,33.14],[1.5,23.09],[1.6,0]],"totImpulseNs":452.1,"totalWeightG":581,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1887,"burnTimeS":1.34,"caseInfo":"RMS-98/2560","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K1999","dataFiles":2,"delays":"P","designation":"K1999N","diameter":98,"impulseClass":"K","length":289,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":2160,"motorId":"5f4294d200023100000001ca","propInfo":"Warp 9","propWeightG":1225,"samples":[[0,0],[0.019,2337],[0.026,717],[0.036,2131],[0.064,1507],[0.093,1945],[0.107,1766],[0.153,1819],[0.205,1866],[0.294,1985],[0.399,2051],[0.602,2091],[0.8,2078],[1.001,1965],[1.06,1912],[1.196,1726],[1.213,1700],[1.266,1799],[1.287,1593],[1.294,1328],[1.311,883],[1.328,444.8],[1.333,239],[1.347,192.5],[1.359,0]],"totImpulseNs":2540,"totalWeightG":2989,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":307.5,"burnTimeS":0.35,"caseInfo":"RMS-38/120","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G339","dataFiles":2,"delays":"P","designation":"G339N","diameter":38,"impulseClass":"G","length":97,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":503.5,"motorId":"5f4294d200023100000001cb","propInfo":"Warp 9","propWeightG":49,"samples":[[0,0],[0.009,371],[0.05,375],[0.1,375],[0.15,364],[0.2,349],[0.25,310],[0.3,264],[0.324,257],[0.342,39],[0.359,0]],"totImpulseNs":108.9,"totalWeightG":181,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":594,"burnTimeS":1.34,"caseInfo":"RMS-38/1080","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J575","dataFiles":2,"delays":"4,6,8,10","designation":"J575FJ","diameter":38,"impulseClass":"J","length":478,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":839.5,"motorId":"5f4294d200023100000001cc","propInfo":"Black Max","propWeightG":576,"samples":[[0,0],[0.01566,656.7],[0.01957,840.7],[0.05502,878.8],[0.09078,880.6],[0.1541,882.4],[0.2091,884.2],[0.2613,880.6],[0.3411,878.8],[0.3906,873.4],[0.4512,862.6],[0.5254,821.2],[0.5997,783.4],[0.7978,669.9],[0.8363,639.3],[1.001,340.4],[1.073,205.3],[1.15,108.1],[1.21,72.04],[1.285,32.42],[1.34,0]],"totImpulseNs":798.1,"totalWeightG":914,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1910,"burnTimeS":4.01,"caseInfo":"RMS-75/7680","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1850","dataFiles":2,"delays":"P","designation":"M1850W","diameter":75,"impulseClass":"M","length":923,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":4489,"motorId":"5f4294d200023100000001cd","propInfo":"White Lightning","propWeightG":3951,"samples":[[0,0],[0.1,2411],[0.2,2135],[0.3,2015],[0.4,2000],[0.5,2055],[1,2098],[1.5,1860],[2,1788],[2.5,1659],[3,1468],[3.25,1423],[3.35,1334],[3.5,1201],[3.75,934],[3.8,930],[4,881],[4.25,600],[4.5,468],[4.75,400],[5,290],[5.5,85],[6,23],[6.5,0]],"totImpulseNs":7659,"totalWeightG":6693,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1292,"burnTimeS":0.653,"caseInfo":"RMS-54/852","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J1299","dataFiles":2,"delays":"P","designation":"J1299N","diameter":54,"impulseClass":"J","length":231,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1468,"motorId":"5f4294d200023100000001ce","propInfo":"Warp 9","propWeightG":371.6,"samples":[[0,0],[0.01,548],[0.02,1152],[0.03,1232],[0.04,1277],[0.05,1272],[0.06,1288],[0.07,1333],[0.08,1347],[0.09,1378],[0.1,1383],[0.12,1405],[0.14,1410],[0.16,1440],[0.18,1444],[0.2,1446],[0.25,1449],[0.3,1452],[0.35,1448],[0.4,1440],[0.45,1405],[0.5,1320],[0.55,1248],[0.57,1224],[0.59,1210],[0.6,1180],[0.61,1188],[0.615,1195],[0.62,1188],[0.63,510],[0.64,220],[0.65,96],[0.66,46],[0.67,26],[0.678,0]],"totImpulseNs":843.4,"totalWeightG":834,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1963,"burnTimeS":0.61,"caseInfo":"RMS-54/1280","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J1799","dataFiles":2,"delays":"P","designation":"J1799N","diameter":54,"impulseClass":"J","length":330,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":2966,"motorId":"5f4294d200023100000001cf","propInfo":"Warp 9","propWeightG":591,"samples":[[0,0],[0.004,665],[0.007,1339],[0.009,1625],[0.014,1497],[0.02,2022],[0.026,1572],[0.042,1797],[0.051,1731],[0.062,1850],[0.075,1788],[0.083,1898],[0.096,1832],[0.104,1911],[0.138,1955],[0.144,2114],[0.154,2008],[0.176,2008],[0.18,1964],[0.207,1973],[0.258,2026],[0.325,1977],[0.362,1938],[0.399,1951],[0.428,1933],[0.44,1859],[0.499,1696],[0.527,1634],[0.553,1524],[0.564,1431],[0.572,1114],[0.581,665],[0.587,409.6],[0.595,220.2],[0.604,96.89],[0.615,26.43],[0.633,39.64],[0.652,0]],"totImpulseNs":1215,"totalWeightG":1111,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":71,"burnTimeS":1.51,"caseInfo":"RMS-29/40-120","certOrg":"National Association of Rocketry","commonName":"G71","dataFiles":3,"delays":"4,5,6,7,8,10","designation":"G71R","diameter":29,"impulseClass":"G","infoUrl":"https://nar.org/SandT/pdf/Aerotech/G71R.pdf","length":124,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":117,"motorId":"5f4294d200023100000001d0","propInfo":"Redline","propWeightG":64,"samples":[[0,0],[0.008,46.66],[0.015,74.25],[0.023,85.79],[0.031,100.3],[0.05,110.9],[0.062,116.9],[0.085,120.4],[0.116,119.9],[0.139,118.9],[0.158,116.9],[0.181,115.4],[0.216,114.4],[0.251,113.4],[0.278,111.4],[0.297,111.4],[0.309,114.4],[0.328,112.4],[0.355,109.4],[0.39,107.4],[0.432,104.9],[0.463,103.8],[0.494,100.8],[0.525,98.83],[0.552,95.82],[0.583,94.32],[0.606,92.31],[0.633,89.3],[0.653,87.29],[0.676,85.79],[0.699,81.27],[0.714,84.28],[0.734,81.27],[0.749,88.8],[0.772,80.27],[0.799,76.25],[0.826,73.75],[0.861,70.74],[0.876,73.75],[0.892,69.23],[0.915,69.73],[0.923,65.72],[0.942,63.71],[0.977,60.7],[1.008,58.2],[1.039,54.18],[1.077,50.17],[1.108,46.15],[1.12,50.17],[1.127,46.15],[1.143,43.14],[1.178,37.63],[1.212,32.61],[1.232,30.1],[1.255,26.59],[1.274,23.58],[1.301,20.57],[1.317,18.06],[1.344,15.55],[1.382,11.54],[1.417,10.03],[1.448,7.024],[1.486,6.02],[1.517,3.512],[1.552,3.01],[1.587,2.508],[1.618,1.003],[1.668,0.502],[1.707,0.502],[1.734,0]],"totImpulseNs":107,"totalWeightG":147,"type":"reload","updatedOn":"2022-07-20"},{"availability":"OOP","avgThrustN":200,"burnTimeS":1.8,"caseInfo":"AMW 38-390","certOrg":"National Association of Rocketry","commonName":"I195","dataFiles":2,"designation":"WW-38-390","diameter":38,"impulseClass":"I","infoUrl":"https://nar.org/SandT/pdf/Animal/I195WW.pdf","length":249,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":238,"motorId":"5f4294d200023100000001d1","propInfo":"White Wolf","propWeightG":192.2,"samples":[[0,0],[0.002,10.55],[0.018,42.65],[0.046,136.2],[0.064,179.8],[0.072,191.2],[0.078,197.2],[0.088,198.6],[0.126,198.6],[0.175,207.8],[0.217,211.9],[0.349,216.9],[0.401,221.1],[0.554,225.6],[0.586,228.9],[0.626,228.5],[0.65,230.2],[1.013,231.6],[1.105,230.7],[1.2,225.2],[1.356,210.5],[1.392,207.8],[1.441,206.8],[1.457,205],[1.519,181.2],[1.563,155.9],[1.693,49.99],[1.727,28.43],[1.756,16.51],[1.798,7.338],[1.86,1.376],[1.89,0]],"totImpulseNs":358,"type":"reload","updatedOn":"2022-07-24"},{"availability":"OOP","avgThrustN":223,"burnTimeS":1.61,"caseInfo":"AMW 38-390","certOrg":"National Association of Rocketry","commonName":"I220","dataFiles":2,"designation":"SK-38-390","diameter":38,"impulseClass":"I","length":249,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":312,"motorId":"5f4294d200023100000001d2","propInfo":"Skidmark","propWeightG":201.9,"samples":[[0,0],[0.005,12.75],[0.019,45.25],[0.036,79.67],[0.052,125.6],[0.069,162.5],[0.076,169.5],[0.095,174.6],[0.167,176.5],[0.229,191.2],[0.447,235.2],[0.602,260.7],[0.733,288.1],[0.85,302.1],[0.974,301.5],[1.094,290],[1.184,269],[1.268,240.3],[1.302,219.9],[1.388,177.2],[1.418,147.2],[1.435,127.5],[1.473,91.14],[1.504,65.64],[1.543,40.79],[1.593,19.12],[1.622,10.2],[1.65,0]],"sparky":true,"totImpulseNs":358,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":328,"burnTimeS":1.81,"caseInfo":"AMW 38-640","certOrg":"National Association of Rocketry","commonName":"I325","dataFiles":2,"designation":"WW-38-640","diameter":38,"impulseClass":"I","length":370,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":402,"motorId":"5f4294d200023100000001d3","propInfo":"White Wolf","propWeightG":316.8,"samples":[[0,0],[0.014,68.71],[0.022,113],[0.026,153.7],[0.037,244.5],[0.045,299.2],[0.055,330.2],[0.065,350.2],[0.079,365.7],[0.094,376.8],[0.124,382],[0.185,373.8],[0.252,373.8],[0.35,381.2],[0.47,382.7],[0.622,388.6],[1.102,384.2],[1.366,365],[1.379,360.5],[1.415,331.7],[1.49,223.1],[1.505,211.3],[1.551,187.7],[1.592,162.5],[1.688,80.53],[1.726,50.98],[1.775,27.34],[1.806,16.99],[1.834,9.605],[1.901,0]],"totImpulseNs":594,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":24.4,"burnTimeS":2.03,"certOrg":"National Association of Rocketry","commonName":"F27","dataFiles":2,"delays":"4,6,8","designation":"F27R/L","diameter":29,"impulseClass":"F","infoUrl":"https://nar.org/SandT/pdf/Aerotech/F27.pdf","length":83,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":37.7,"motorId":"5f4294d200023100000001d4","propInfo":"Redline","propWeightG":28.4,"samples":[[0,0],[0.0125,15.54],[0.0175,18.82],[0.025,22.53],[0.0325,25.25],[0.04,27.32],[0.0575,30.37],[0.0725,31.46],[0.0975,32.25],[0.265,35.02],[0.295,35.92],[0.4675,35.97],[0.59,35.06],[0.8,32.01],[0.825,31.28],[0.8575,31.11],[0.9025,29.93],[0.955,29.72],[1.045,27.3],[1.085,27.27],[1.117,25.99],[1.147,26],[1.235,23.29],[1.28,22.9],[1.343,21.08],[1.52,17.26],[1.808,6.855],[1.917,4.164],[2.05,1.784],[2.178,0.488],[2.422,0.4439],[2.425,0]],"totImpulseNs":49.6,"totalWeightG":80,"type":"SU","updatedOn":"2022-08-09"},{"availability":"regular","avgThrustN":72.3,"burnTimeS":1.88,"caseInfo":"RMS-38/120","certOrg":"National Association of Rocketry","commonName":"G69","dataFiles":2,"delays":"P","designation":"G69N","diameter":38,"impulseClass":"G","infoUrl":"https://nar.org/SandT/pdf/Aerotech/G69.pdf","length":106,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":87.3,"motorId":"5f4294d200023100000001d5","propInfo":"Warp 9","propWeightG":62.2,"samples":[[0,0],[0.001,1.043],[0.005,1.496],[0.009,3.992],[0.011,7.188],[0.015,31.79],[0.017,38.67],[0.019,43.51],[0.027,55.36],[0.033,58.47],[0.039,63.35],[0.041,66.46],[0.053,74.01],[0.065,76.23],[0.123,75.79],[0.169,77.56],[0.667,82],[0.719,83.78],[1.123,86.44],[1.415,86],[1.461,84.22],[1.495,80.23],[1.543,71.79],[1.705,29.83],[1.747,20.73],[1.825,9.231],[1.901,4.214],[1.999,0]],"totImpulseNs":136.7,"totalWeightG":201,"type":"reload","updatedOn":"2022-07-20"},{"availability":"regular","avgThrustN":892.9,"burnTimeS":1.15,"caseInfo":"RMS-38/1080","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J825","dataFiles":2,"delays":"4,6,8,10","designation":"J825R","diameter":38,"impulseClass":"J","length":478,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1244,"motorId":"5f4294d200023100000001d6","propInfo":"Redline","propWeightG":500,"samples":[[0,0],[0.006,444.8],[0.014,889.6],[0.015,1060],[0.018,1203],[0.029,1041],[0.039,1111],[0.047,1071],[0.056,1091],[0.08,1077],[0.104,1069],[0.134,1063],[0.17,1063],[0.202,1069],[0.303,1055],[0.401,1021],[0.497,996],[0.603,948.4],[0.702,909.2],[0.8,842.1],[0.906,772.1],[0.933,749.8],[0.952,671.4],[0.98,579.1],[1.005,470],[1.01,405.7],[1.019,405.7],[1.034,226.6],[1.055,123.1],[1.07,50.36],[1.093,22.38],[1.115,0]],"totImpulseNs":974.9,"totalWeightG":875,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":656,"burnTimeS":9.13,"caseInfo":"RMS-75/6400","certOrg":"National Association of Rocketry","commonName":"M650","dataFiles":2,"delays":"P","designation":"M650W","diameter":75,"impulseClass":"M","infoUrl":"https://nar.org/SandT/pdf/Aerotech/M650W.pdf","length":801,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1475,"motorId":"5f4294d200023100000001d7","propInfo":"White Lightning","propWeightG":3351,"samples":[[0,0],[0.08,1240],[0.12,1328],[0.25,1230],[0.5,1142],[1,1071],[1.5,1048],[2,1018],[2.5,982],[3,950],[3.5,853],[4,781],[5,595],[6,443],[7,297],[8,155],[9,88],[10,32],[10.5,12],[11,4],[11.5,0]],"totImpulseNs":5964,"totalWeightG":5125,"type":"reload","updatedOn":"2022-07-23"},{"availability":"regular","avgThrustN":744,"burnTimeS":12.65,"caseInfo":"RMS-98/10240","certOrg":"National Association of Rocketry","commonName":"M750","dataFiles":2,"delays":"P","designation":"M750W","diameter":98,"impulseClass":"M","infoUrl":"https://nar.org/SandT/pdf/Aerotech/M750W.pdf","length":732,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1454,"motorId":"5f4294d200023100000001d8","propInfo":"White Lightning","propWeightG":5540,"samples":[[0,0],[0.1,1032],[0.2,992],[0.3,974],[0.48,966],[1,1055],[1.5,1152],[2,1192],[2.5,1218],[4,1103],[6,818],[8,561],[10,318],[11,216],[12,125],[13,76],[14,47],[15,23],[15.5,9],[16,0]],"totImpulseNs":9325,"totalWeightG":8776,"type":"reload","updatedOn":"2022-07-23"},{"availability":"OOP","avgThrustN":1391,"burnTimeS":3.41,"caseInfo":"AMW 75-6000","certOrg":"National Association of Rocketry","commonName":"L1400","dataFiles":2,"designation":"SK-75-6000","diameter":75,"impulseClass":"L","length":785,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":1963,"motorId":"5f4294d200023100000001d9","propInfo":"Skidmark","propWeightG":2829,"samples":[[0,0],[0.001,68.12],[0.005,193.8],[0.017,690.3],[0.022,814.6],[0.028,900.7],[0.046,997.5],[0.077,1251],[0.093,1355],[0.108,1406],[0.133,1440],[0.17,1454],[0.369,1397],[0.526,1412],[0.706,1488],[1.083,1734],[1.415,1907],[1.557,1875],[1.767,1882],[1.9,1803],[2.143,1745],[2.341,1659],[2.505,1522],[2.581,1402],[2.82,844.8],[2.848,841.7],[2.894,730.8],[3.069,406.5],[3.177,265.8],[3.426,94.96],[3.609,0.8745],[3.61,0]],"sparky":true,"totImpulseNs":4744,"totalWeightG":5204,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":2764,"burnTimeS":5.36,"caseInfo":"AMW 98-17500","certOrg":"National Association of Rocketry","commonName":"N2800","dataFiles":2,"designation":"WW-98-17500","diameter":98,"impulseClass":"N","length":1213,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":3654,"motorId":"5f4294d200023100000001da","propInfo":"White Wolf","propWeightG":7695,"samples":[[0,0],[0.001,93.09],[0.003,168.3],[0.007,387.8],[0.02,1271],[0.03,1776],[0.044,2299],[0.063,2841],[0.073,3021],[0.085,3129],[0.141,3296],[0.278,3483],[0.294,3432],[0.37,3496],[0.979,3599],[1.974,3655],[2.978,3535],[3.301,3437],[3.498,3308],[3.584,3194],[3.652,3016],[3.749,2548],[3.837,2224],[4.11,1644],[4.246,1444],[4.273,1447],[4.398,1164],[4.49,1023],[4.517,1057],[4.575,883.9],[4.648,776.4],[5.57,0]],"totImpulseNs":14800,"totalWeightG":13810,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":302,"burnTimeS":1.84,"caseInfo":"AMW 38-640","certOrg":"National Association of Rocketry","commonName":"I301","dataFiles":2,"delays":"18","designation":"I301W","diameter":38,"impulseClass":"I","length":370,"manufacturer":"Kosdon by AeroTech","manufacturerAbbrev":"KBA","maxThrustN":433,"motorId":"5f4294d200023100000001db","propInfo":"White Lightning","propWeightG":310,"samples":[[0,0],[0.008,266.1],[0.014,327.1],[0.03,354.1],[0.058,350.1],[0.107,335.1],[0.133,326.1],[0.189,326.1],[0.217,333.1],[0.237,383.1],[0.253,402.1],[0.287,395.1],[0.33,381.1],[0.72,381.1],[1.035,341.1],[1.437,317.1],[1.57,262.1],[1.698,130],[1.789,83.03],[1.833,74.03],[1.867,53.02],[1.893,23.01],[1.916,13.01],[1.952,0]],"totImpulseNs":554,"totalWeightG":725.5,"type":"reload","updatedOn":"2020-01-27"},{"availability":"OOP","avgThrustN":587,"burnTimeS":0.98,"caseInfo":"AMW 38-640","certOrg":"National Association of Rocketry","commonName":"I550","dataFiles":2,"delays":"20","designation":"I550R","diameter":38,"impulseClass":"I","length":370,"manufacturer":"Kosdon by AeroTech","manufacturerAbbrev":"KBA","maxThrustN":689,"motorId":"5f4294d200023100000001dc","propInfo":"Redline","propWeightG":295,"samples":[[0,0],[0.016,156.1],[0.028,278.1],[0.04,427.1],[0.054,550.2],[0.08,542.2],[0.245,588.2],[0.332,611.2],[0.424,631.2],[0.496,638.2],[0.613,644.2],[0.71,643.2],[0.758,631.2],[0.846,603.2],[0.894,613.2],[0.915,611.2],[0.939,586.2],[0.949,546.2],[0.959,505.2],[0.969,469.2],[0.983,381.1],[0.999,278.1],[1.011,200.1],[1.029,112],[1.053,42.02],[1.069,15.01],[1.089,0]],"totImpulseNs":575,"totalWeightG":711.6,"type":"reload","updatedOn":"2020-01-27"},{"availability":"OOP","avgThrustN":752,"burnTimeS":3.29,"caseInfo":"AMW 54-2550","certOrg":"National Association of Rocketry","commonName":"K750","dataFiles":2,"delays":"P","designation":"K750W","diameter":54,"impulseClass":"K","length":727,"manufacturer":"Kosdon by AeroTech","manufacturerAbbrev":"KBA","maxThrustN":1188,"motorId":"5f4294d200023100000001dd","propInfo":"White Lightning","propWeightG":1499,"samples":[[0,0],[0.008,266.1],[0.012,457.1],[0.02,750.5],[0.032,999.5],[0.044,1112],[0.06,1180],[0.095,1098],[0.127,1057],[0.163,1040],[0.334,1051],[0.62,1054],[0.998,975.6],[1.324,907.4],[1.69,904],[2.06,886.9],[2.184,828.9],[2.299,757.3],[2.394,651.5],[2.502,556],[2.609,450.3],[2.784,327.5],[2.999,245.6],[3.039,201.3],[3.134,92.1],[3.206,40.94],[3.337,6.822],[3.468,0]],"totImpulseNs":2468,"totalWeightG":2636,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1751,"burnTimeS":1.38,"caseInfo":"AMW 54-2550","certOrg":"National Association of Rocketry","commonName":"K1750","dataFiles":2,"delays":"P","designation":"K1750R","diameter":54,"impulseClass":"K","length":727,"manufacturer":"Kosdon by AeroTech","manufacturerAbbrev":"KBA","maxThrustN":2070,"motorId":"5f4294d200023100000001de","propInfo":"Redline","propWeightG":1441,"samples":[[0,0],[0.02,1309],[0.03,1680],[0.05,1737],[0.11,1690],[0.26,1800],[0.4,1914],[0.46,1897],[0.68,2024],[0.9,2134],[0.95,2097],[1,2050],[1.05,1920],[1.1,1793],[1.16,1676],[1.21,1720],[1.25,1526],[1.27,1302],[1.32,875],[1.35,454.2],[1.36,317.3],[1.37,200.4],[1.4,90.17],[1.46,0]],"totImpulseNs":2423,"totalWeightG":2564,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1432,"burnTimeS":5.46,"caseInfo":"AMW 75-7600","certOrg":"National Association of Rocketry","commonName":"M1450","dataFiles":2,"delays":"P","designation":"M1450W","diameter":75,"impulseClass":"M","length":1039,"manufacturer":"Kosdon by AeroTech","manufacturerAbbrev":"KBA","maxThrustN":2134,"motorId":"5f4294d200023100000001df","propInfo":"White Lightning","propWeightG":4150,"samples":[[0,0],[0.035,1843],[0.076,2287],[0.146,1969],[0.215,1883],[0.291,1836],[0.499,1863],[1.005,1936],[1.559,1889],[2.155,1816],[2.862,1750],[3.493,1664],[3.853,1359],[4.221,1061],[4.484,788.9],[4.761,523.7],[4.942,258.5],[5.323,258.5],[5.6,172.4],[5.801,119.3],[5.96,0]],"totImpulseNs":7813,"totalWeightG":7615,"type":"reload","updatedOn":"2020-01-27"},{"availability":"OOP","avgThrustN":2558,"burnTimeS":2.07,"caseInfo":"AMW 75-7600","certOrg":"National Association of Rocketry","commonName":"M2900","dataFiles":1,"designation":"M2900R","diameter":75,"impulseClass":"M","length":1039,"manufacturer":"Kosdon by AeroTech","manufacturerAbbrev":"KBA","maxThrustN":2979,"motorId":"5f4294d200023100000001e0","propInfo":"Redline","propWeightG":4265,"samples":[[0,0],[0.034,19.47],[0.05,69.69],[0.052,166.1],[0.056,534],[0.06,1067],[0.064,1683],[0.066,1898],[0.072,2295],[0.082,2496],[0.102,2708],[0.108,2735],[0.204,2697],[0.438,2690],[0.726,2745],[0.824,2794],[1.116,3042],[1.318,3102],[1.566,3016],[1.816,2846],[1.864,2744],[1.898,2565],[1.908,2456],[1.96,1357],[1.988,857.2],[2.006,603.3],[2.026,417.6],[2.044,303.9],[2.09,150.6],[2.142,73.22],[2.226,25.61],[2.412,0]],"totImpulseNs":5290,"totalWeightG":7195,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":45,"burnTimeS":1.4,"caseInfo":"SU 29x93","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"F45","dataFiles":2,"delays":"5,8,P","designation":"F45","diameter":29,"impulseClass":"F","length":93,"manufacturer":"Roadrunner Rocketry","manufacturerAbbrev":"Roadrunner","maxThrustN":62,"motorId":"5f4294d200023100000001e1","propInfo":"Rapid propellant","propWeightG":30,"samples":[[0,0],[0.001,4.197],[0.02,45.5],[0.039,53.07],[0.058,52.4],[0.096,54.74],[0.114,55.3],[0.133,56.74],[0.152,57.19],[0.228,60.42],[0.285,61.75],[0.417,62.42],[0.492,60.75],[0.511,61.42],[0.568,60.31],[0.625,58.41],[0.663,58.08],[0.738,55.3],[0.776,52.96],[0.814,51.51],[0.889,46.17],[0.984,34.7],[1.003,31.81],[1.097,23.9],[1.135,21.45],[1.211,14.11],[1.23,12.99],[1.286,8.428],[1.343,5.533],[1.362,5.422],[1.419,2.972],[1.421,0]],"totImpulseNs":61,"totalWeightG":93,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":53.1,"burnTimeS":1.71,"caseInfo":"RMS-29/40-120","certOrg":"National Association of Rocketry","commonName":"G53","dataFiles":2,"delays":"4,5,6,7,8,10","designation":"G53FJ","diameter":29,"impulseClass":"G","infoUrl":"https://nar.org/SandT/pdf/Aerotech/G53FJ.pdf","length":124,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":87.3,"motorId":"5f4294d200023100000001e2","propInfo":"Black Max","propWeightG":60,"samples":[[0,0],[0.084,0.1734],[0.098,0.8755],[0.102,1.976],[0.104,3.287],[0.106,5.663],[0.108,10],[0.112,26.81],[0.114,36.51],[0.118,51.19],[0.12,56.71],[0.124,64.86],[0.128,70.22],[0.134,74.24],[0.146,78.9],[0.152,79.8],[0.164,83.1],[0.188,85.65],[0.234,85.45],[0.298,82.02],[0.354,79.77],[0.748,69.42],[1.024,56.74],[1.16,48.35],[1.344,35.29],[1.56,22.1],[1.6,19.25],[1.698,11],[1.77,6.589],[1.818,4.265],[1.918,1.115],[2,0]],"totImpulseNs":90.9,"totalWeightG":146,"type":"reload","updatedOn":"2022-07-20"},{"availability":"regular","avgThrustN":250,"burnTimeS":0.9,"caseInfo":"RMS-29/240","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H250","dataFiles":2,"delays":"4,6,8,10","designation":"H250G","diameter":29,"impulseClass":"H","length":238,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d200023100000001e3","propInfo":"Mojave Green","propWeightG":116.3,"samples":[[0,0],[0.002506,88.69],[0.01253,177.4],[0.03008,279.7],[0.07268,311.1],[0.1454,320.7],[0.2481,311.1],[0.3083,297.5],[0.3985,282.4],[0.4561,270.2],[0.594,238.8],[0.6917,221],[0.7995,218.3],[0.8321,210.1],[0.8446,189.7],[0.9073,13.64],[0.92,0]],"totImpulseNs":231,"totalWeightG":256,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":245,"burnTimeS":1.4,"caseInfo":"RMS-38/360","certOrg":"Unknown","commonName":"I245","dataFiles":2,"delays":"4,6,8,10","designation":"I245G","diameter":38,"impulseClass":"I","length":202,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d200023100000001e4","propInfo":"Mojave Green","propWeightG":181.3,"samples":[[0,0],[0.0245,234.1],[0.05502,257.9],[0.08686,368.6],[0.1069,382.3],[0.1336,390.8],[0.2004,405.6],[0.2628,410.9],[0.3029,412],[0.363,408.8],[0.4013,398.4],[0.5011,363.3],[0.5947,320.9],[0.6893,278.4],[0.7973,212.9],[0.8932,181.5],[1.006,154.2],[1.091,133.7],[1.16,120.7],[1.18,122.9],[1.236,106.4],[1.304,75.05],[1.361,36.01],[1.403,19.06],[1.439,5.295],[1.463,0]],"totImpulseNs":351,"totalWeightG":365,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":500,"burnTimeS":1.4,"caseInfo":"RMS-38/720","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J500","dataFiles":2,"delays":"4,6,8,10","designation":"J500G","diameter":38,"impulseClass":"J","length":345,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d200023100000001e5","propInfo":"Mojave Green","propWeightG":362.6,"samples":[[0,0],[0.01344,40.25],[0.03359,724.4],[0.04031,781.6],[0.06047,788],[0.08959,711.7],[0.1344,686.3],[0.3942,637.6],[0.5756,588.9],[0.6069,622.8],[0.6338,620.6],[1.2,360.1],[1.241,345.3],[1.31,182.2],[1.382,65.66],[1.433,23.3],[1.45,0]],"totImpulseNs":723,"totalWeightG":654,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":249.8,"burnTimeS":7.87,"caseInfo":"RMS-54/2560","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K270","dataFiles":2,"delays":"P","designation":"K270W","diameter":54,"impulseClass":"K","length":579,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":438.4,"motorId":"5f4294d200023100000001e6","propInfo":"White Lightning","propWeightG":1188,"samples":[[0,0],[0.046,177.1],[0.062,177.1],[0.092,292.9],[0.154,425.7],[0.277,414],[0.446,389.3],[0.585,377.6],[0.738,381.5],[1,372.3],[1.154,377.6],[1.231,376.3],[1.308,378.9],[1.4,395.8],[1.569,380.2],[1.615,399.7],[1.846,381.5],[2.369,381.5],[2.415,368.4],[2.554,381.5],[3.015,360.6],[3.354,350.2],[3.723,328.1],[4,300.7],[4.6,273.4],[5.262,225.2],[5.677,175.8],[6,144.5],[6.538,125],[7.015,89.83],[8,66.4],[8.323,22.13],[8.508,10.41],[8.692,0],[8.692,5.208]],"totImpulseNs":1968,"totalWeightG":2100,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":115,"burnTimeS":3.583,"caseInfo":"RMS-54/426","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I115","dataFiles":1,"delays":"4,6,8,10","designation":"I115W","diameter":54,"impulseClass":"I","length":156,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d200023100000001e7","propInfo":"White Lightning","propWeightG":219,"samples":[[0,0],[0.034,12.1],[0.177,105.2],[0.206,113.1],[1.017,163.3],[1.166,161.5],[1.257,162.7],[1.343,166.9],[1.417,160.9],[1.514,162.7],[1.617,163.9],[1.686,160.3],[1.977,142.7],[2.497,106.4],[2.68,91.32],[2.994,72.57],[3.103,67.13],[3.189,65.92],[3.24,59.27],[3.291,42.94],[3.331,30.24],[3.377,20.56],[3.429,12.7],[3.491,7.257],[3.514,0]],"totImpulseNs":412,"totalWeightG":545,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":229,"burnTimeS":1.777,"caseInfo":"RMS-54/426","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I229","dataFiles":2,"delays":"4,6,8,10","designation":"I229T","diameter":54,"impulseClass":"I","length":156,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d200023100000001e8","propInfo":"Blue Thunder","propWeightG":196,"samples":[[0,0],[0.01,44.73],[0.02,216.7],[0.19,244.7],[0.4,266.6],[0.49,266.6],[0.52,273.7],[0.59,271.9],[0.75,272.8],[0.84,268.4],[0.88,271.9],[0.97,262.3],[1,265.8],[1.07,255.2],[1.21,249.1],[1.51,219.3],[1.6,230.7],[1.63,191.2],[1.64,132.4],[1.66,86.83],[1.7,44.73],[1.71,21.05],[1.73,0]],"totImpulseNs":407,"totalWeightG":514,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":215,"burnTimeS":1.856,"caseInfo":"RMS-54/426","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I215","dataFiles":2,"delays":"4,6,8,10","designation":"I215R","diameter":54,"impulseClass":"I","length":156,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d200023100000001e9","propInfo":"Redline","propWeightG":208,"samples":[[0,0],[0.049,88.39],[0.089,154.7],[0.094,206.9],[0.178,245.1],[0.251,255.1],[0.325,259.1],[0.404,249.1],[0.582,257.1],[0.631,253.1],[0.7,253.1],[0.774,245.1],[1.001,239.1],[1.509,192.9],[1.681,178.8],[1.716,180.8],[1.746,190.8],[1.775,178.8],[1.8,90.4],[1.82,34.15],[1.859,0]],"totImpulseNs":399,"totalWeightG":527,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":667.8,"burnTimeS":0.6,"caseInfo":"RMS-54/426","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I599","dataFiles":2,"delays":"P","designation":"I599N","diameter":54,"impulseClass":"I","length":156,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":763.5,"motorId":"5f4294d200023100000001ea","propInfo":"Warp 9","propWeightG":195,"samples":[[0,0],[0.007,179.4],[0.01,495.9],[0.012,578.1],[0.014,647.9],[0.017,797.4],[0.024,593.1],[0.032,647.9],[0.045,677.8],[0.051,702.7],[0.055,677.8],[0.062,720.2],[0.076,707.7],[0.12,752.6],[0.202,757.6],[0.225,755.1],[0.241,735.1],[0.25,720.2],[0.263,730.2],[0.329,722.7],[0.399,697.8],[0.45,667.9],[0.501,618],[0.536,585.6],[0.55,580.6],[0.564,585.6],[0.578,633],[0.581,555.7],[0.584,426.1],[0.589,299],[0.595,176.9],[0.598,112.1],[0.604,57.32],[0.608,24.92],[0.619,12.46],[0.623,0]],"totImpulseNs":404.9,"totalWeightG":512,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":117,"burnTimeS":3.1,"caseInfo":"RMS-54/426","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I117","dataFiles":2,"delays":"4,6,8,10","designation":"I117FJ","diameter":54,"impulseClass":"I","length":156,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d200023100000001eb","propInfo":"Black Max","propWeightG":243,"samples":[[0,0],[0.014,65.9],[0.021,94.46],[0.055,120.8],[0.089,107.6],[0.179,107.6],[0.344,124.1],[0.385,134],[0.447,123],[0.509,138.4],[0.564,131.8],[0.646,146.1],[0.708,145],[0.736,127.4],[0.75,149.4],[0.798,141.7],[0.825,164.7],[0.866,152.7],[1.004,158.2],[1.141,156],[1.224,154.9],[1.492,156],[2.304,121.9],[2.407,118.6],[2.482,117.5],[2.544,128.5],[2.599,112],[2.654,75.78],[2.695,45.03],[2.75,16.48],[2.771,8.787],[2.806,0]],"totImpulseNs":361,"totalWeightG":566,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":250,"burnTimeS":2.9,"caseInfo":"RMS-54/852","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J250","dataFiles":2,"delays":"6,8,10,12,14","designation":"J250FJ","diameter":54,"impulseClass":"J","length":241,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d200023100000001ec","propInfo":"Black Max","propWeightG":487,"samples":[[0,0],[0.011,132.2],[0.021,263.3],[0.084,236.9],[0.168,252.2],[0.294,238.9],[0.494,261.3],[0.715,285.7],[0.993,295.9],[1.177,306],[1.267,305],[1.498,302],[1.64,292.8],[2.002,253.2],[2.344,224.7],[2.391,225.7],[2.502,233.8],[2.57,185],[2.659,116.9],[2.685,76.25],[2.738,32.54],[2.77,17.29],[2.796,0]],"totImpulseNs":731,"totalWeightG":907,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":556.8,"burnTimeS":2.79,"caseInfo":"RMS-54/1706","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K513","dataFiles":2,"delays":"6,8,10,12,14","designation":"K513FJ","diameter":54,"impulseClass":"K","length":410,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":658.3,"motorId":"5f4294d200023100000001ee","propInfo":"Black Max","propWeightG":974,"samples":[[0,0],[0.007,555.1],[0.015,652.7],[0.041,551.7],[0.059,592.1],[0.074,551.7],[0.2,575.3],[0.282,582],[0.412,605.6],[0.519,615.6],[0.679,635.8],[0.823,642.6],[0.986,649.3],[1.12,652.7],[1.328,656],[1.48,649.3],[1.602,629.1],[1.854,585.4],[1.999,555.1],[2.054,545],[2.08,545],[2.114,528.2],[2.184,524.8],[2.229,521.5],[2.258,504.6],[2.295,474.4],[2.325,437.3],[2.358,380.2],[2.37,349.9],[2.399,312.9],[2.451,272.5],[2.492,238.9],[2.529,161.5],[2.57,84.11],[2.592,43.73],[2.618,26.91],[2.655,13.46],[2.692,6.728],[2.726,0]],"totImpulseNs":1496,"totalWeightG":1647,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":828,"burnTimeS":2.5,"caseInfo":"RMS-54/2560","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K828","dataFiles":2,"delays":"P","designation":"K828FJ","diameter":54,"impulseClass":"K","length":579,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d200023100000001ef","propInfo":"Black Max","propWeightG":1373,"samples":[[0,0],[0.01,1112],[0.02,1112],[0.04,1239],[0.06,1304],[0.08,1135],[0.13,1078],[0.2,1032],[0.5,1016],[0.65,993.2],[1,1005],[1.08,985.5],[1.19,974],[1.42,974],[1.51,954.8],[1.69,935.7],[1.75,912.6],[1.83,885.8],[1.89,893.5],[1.95,843.6],[2,774.6],[2.15,667.2],[2.2,444.8],[2.23,364.3],[2.27,260.8],[2.33,184.1],[2.39,111.2],[2.5,0],[2.5,49.85]],"totImpulseNs":2120,"totalWeightG":2223,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":763.6,"burnTimeS":2.27,"caseInfo":"54/1750","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K763","dataFiles":1,"designation":"K763GT","diameter":54,"impulseClass":"K","length":491,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":894.7,"motorId":"5f4294d200023100000001f0","propInfo":"Green Tornado","propWeightG":975,"samples":[[0,0],[0.05,498.4],[0.07,565.1],[0.08,623],[0.1,689.8],[0.12,720.9],[0.25,801],[0.38,845.5],[0.65,867.8],[0.83,854.4],[1.95,778.8],[2.1,712],[2.15,400.5],[2.25,44.5],[2.27,0]],"totImpulseNs":1740,"totalWeightG":1792,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":556,"burnTimeS":2.51,"caseInfo":"54/1400","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K555","dataFiles":1,"designation":"K555GT","diameter":54,"impulseClass":"K","length":401,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":665.5,"motorId":"5f4294d200023100000001f1","propInfo":"Green Tornado","propWeightG":780,"samples":[[0,0],[0.025,267],[0.05,338.2],[0.1,471.7],[0.12,498.4],[0.15,511.8],[0.18,522.9],[0.2,534],[0.7,631.9],[0.75,636.4],[0.9,645.3],[1.15,636.4],[1.57,623],[1.87,614.1],[2.17,600.8],[2.25,578.5],[2.27,480.6],[2.3,356],[2.35,178],[2.45,66.75],[2.51,0]],"totImpulseNs":1397,"totalWeightG":1577,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":467,"burnTimeS":2.24,"caseInfo":"54/1050","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J465","dataFiles":1,"designation":"J465GT","diameter":54,"impulseClass":"J","length":326,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":662.7,"motorId":"5f4294d200023100000001f2","propInfo":"Green Tornado","propWeightG":566,"samples":[[0,0],[0.09,364.9],[0.1,382.7],[0.14,400.5],[1.16,662.6],[1.27,650],[2,338.2],[2.05,231.4],[2.1,124.6],[2.24,0]],"totImpulseNs":1023,"totalWeightG":1182,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":221.6,"burnTimeS":5.938,"caseInfo":"54/1400","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K222","dataFiles":1,"designation":"K222WC","diameter":54,"impulseClass":"K","length":402,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":444.4,"motorId":"5f4294d200023100000001f3","propInfo":"White Cloud","propWeightG":800,"samples":[[0,0],[0.1,400.5],[0.15,378.3],[0.4,422.8],[0.5,347.1],[1.15,289.3],[2.25,267],[3,231.4],[4,169.1],[5.938,44.5],[6.2,22.25],[6.6,0]],"totImpulseNs":1314,"totalWeightG":1597,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":167.3,"burnTimeS":5.68,"caseInfo":"54/1050","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J167","dataFiles":1,"designation":"J167WC","diameter":54,"impulseClass":"J","length":326,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":366.5,"motorId":"5f4294d200023100000001f4","propInfo":"White Cloud","propWeightG":600,"samples":[[0,0],[0.1,307.1],[0.2,298.1],[0.4,369.4],[0.5,311.5],[0.6,267],[1.5,235.8],[5.85,17.8],[6.1,0]],"totImpulseNs":950,"totalWeightG":1216,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":442.5,"burnTimeS":2.57,"caseInfo":"54/1400","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J450","dataFiles":1,"designation":"J450BL","diameter":54,"impulseClass":"J","length":402,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":601.8,"motorId":"5f4294d200023100000001f5","propInfo":"Black Lightning","propWeightG":658,"samples":[[0,0],[0.08,124.6],[0.19,333.8],[0.3,413.9],[0.68,556.3],[0.8,578.5],[1.05,601],[1.49,547.4],[2.2,409.4],[2.3,267],[2.4,84.55],[2.57,0]],"sparky":true,"totImpulseNs":1121,"totalWeightG":1455,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":364.9,"burnTimeS":2.38,"caseInfo":"54/1050","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J365","dataFiles":1,"designation":"J365BL","diameter":54,"impulseClass":"J","length":326,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":498.7,"motorId":"5f4294d200023100000001f6","propInfo":"Black Lightning","propWeightG":498,"samples":[[0,0],[0.04,102.3],[0.06,155.8],[0.1,192.8],[0.1596,242.3],[0.4,315.9],[0.6,400.5],[0.7,436.1],[0.88,480.6],[1.18,498.4],[1.6,445],[2.05,378.3],[2.14,213.6],[2.2,102.3],[2.3,22.25],[2.38,0]],"sparky":true,"totImpulseNs":852.5,"totalWeightG":1204,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":326.5,"burnTimeS":5.18,"caseInfo":"54/1750","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K327","dataFiles":1,"designation":"K327WC","diameter":54,"impulseClass":"K","length":491,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":684.5,"motorId":"5f4294d200023100000001f7","propInfo":"White Cloud","propWeightG":1000,"samples":[[0,0],[0.05,556.3],[0.15,520.6],[0.5,684.5],[0.65,534],[5.18,22.25],[5.5,0]],"totImpulseNs":1616,"totalWeightG":1817,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":533.4,"burnTimeS":2.66,"caseInfo":"54/1750","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K533","dataFiles":1,"designation":"K533BL","diameter":54,"impulseClass":"K","length":491,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":699.5,"motorId":"5f4294d200023100000001f8","propInfo":"Black Lightning","propWeightG":900,"samples":[[0,0],[0.1,467.3],[0.75,694.2],[1.2,680.9],[1.55,631.9],[2.25,489.5],[2.65,17.8],[2.7,0]],"sparky":true,"totImpulseNs":1420,"totalWeightG":1717,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":11.57,"burnTimeS":2.83,"caseInfo":"RMS-24/40","certOrg":"National Association of Rocketry","commonName":"E11","dataFiles":2,"delays":"3","designation":"E11J","diameter":24,"impulseClass":"E","infoUrl":"https://nar.org/SandT/pdf/Aerotech/E11.pdf","length":70,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":19.85,"motorId":"5f4294d200023100000001f9","propInfo":"Blackjack","propWeightG":25,"samples":[[0,0],[0.07254,14.37],[0.1618,17.63],[0.2065,18.37],[0.4185,19.26],[0.731,18.37],[1.317,14.22],[1.92,9.037],[2.511,2.222],[2.83,0]],"totImpulseNs":32.74,"totalWeightG":62.4,"type":"reload","updatedOn":"2022-07-20"},{"availability":"regular","avgThrustN":612,"burnTimeS":1.09,"caseInfo":"RMS-38/720","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I600","dataFiles":2,"delays":"4,6,8,10","designation":"I600R","diameter":38,"impulseClass":"I","length":345.4,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":811.7,"motorId":"5f4294d200023100000001fa","propInfo":"Redline","propWeightG":324,"samples":[[0,0],[0.005,40.44],[0.046,817.8],[0.059,813.3],[0.1,772.8],[0.2,736.9],[0.4,696.4],[0.5,669.5],[0.6,620.1],[0.796,539.2],[0.894,485.3],[0.951,453.8],[0.964,435.8],[1,274.1],[1.052,152.8],[1.106,62.9],[1.144,13.48],[1.18,0]],"totImpulseNs":597.3,"totalWeightG":602,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":540,"burnTimeS":1.18,"caseInfo":"Pro38-5G","certOrg":"Canadian Association of Rocketry","commonName":"I540","dataFiles":2,"delays":"7,9,11,13,16","designation":"634I540-16A","diameter":38,"impulseClass":"I","infoUrl":"https://www.csrocketry.com/rocket-motors/cesaroni/motors/pro-38/5g-reloads/cesaroni-i540-16a-white-thunder-rocket-motor.html","length":367,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","motorId":"5f4294d200023100000001fb","propInfo":"White Thunder","propWeightG":309,"samples":[[0,0],[0.03,597.9],[0.04,611.3],[0.06,605.6],[0.12,612.4],[0.24,624.5],[0.36,626],[0.48,623.6],[0.6,616.4],[0.72,598.1],[0.84,583.2],[0.95,568.9],[0.96,558.5],[0.98,533.5],[1.02,436.5],[1.06,303.1],[1.09,184.9],[1.13,74.27],[1.18,0]],"totImpulseNs":634.6,"totalWeightG":598.2,"type":"reload","updatedOn":"2022-04-29"},{"availability":"regular","avgThrustN":613,"burnTimeS":8.13,"caseInfo":"Pro98-2G","certOrg":"Canadian Association of Rocketry","commonName":"L610","dataFiles":2,"designation":"4842L610-P","diameter":98,"impulseClass":"L","length":394,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":930,"motorId":"5f4294d200023100000001fc","propInfo":"Classic","propWeightG":2415,"samples":[[0,0],[0.06,262.5],[0.12,667.2],[0.25,929.7],[0.39,871.2],[0.65,849.8],[1.05,823.1],[1.5,785.7],[2,747.3],[2.5,707.3],[3,667.2],[3.48,641.4],[4,593.3],[4.47,561.2],[5,523.8],[5.44,502.4],[5.68,491.7],[6,475.7],[6.5,459.7],[7.01,443.6],[7.5,413.7],[8,284.7],[8.12,53.3],[8.13,0]],"totImpulseNs":4842,"totalWeightG":4975,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":794,"burnTimeS":12.76,"caseInfo":"Pro98-4G","certOrg":"Canadian Association of Rocketry","commonName":"M795","dataFiles":2,"designation":"10133M795-P","diameter":98,"impulseClass":"M","length":702,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":794,"motorId":"5f4294d200023100000001fd","propInfo":"Classic","propWeightG":4892,"samples":[[0,0],[0.15,612.3],[0.21,1533],[0.245,1722],[0.43,1718],[0.5,1543],[0.62,1430],[0.8,1390],[1,1374],[1.5,1339],[2,1305],[3,1272],[4,1204],[5,1078],[6,928],[7,743],[8,563],[9,424.9],[10,299.7],[11,196.2],[12,116.8],[12.7,65.43],[12.76,0]],"totImpulseNs":10130,"totalWeightG":8492,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1057,"burnTimeS":7.23,"caseInfo":"Pro98-3G","certOrg":"Canadian Association of Rocketry","commonName":"M1060","dataFiles":2,"designation":"7441M1060-P","diameter":98,"impulseClass":"M","length":548,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1495,"motorId":"5f4294d200023100000001fe","propInfo":"Classic","propWeightG":3622,"samples":[[0,0],[0.07,131],[0.1,594],[0.2,1453],[0.238,1494],[0.378,1450],[0.5,1423],[1,1462],[1.5,1456],[2,1430],[2.5,1376],[3,1280],[3.5,1190],[4,1051],[4.5,976],[5,883],[5.5,835],[6,793],[6.5,321],[7,13],[7.229,7],[7.23,0]],"totImpulseNs":7441,"totalWeightG":6673,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1456,"burnTimeS":6.87,"caseInfo":"Pro98-4G","certOrg":"Canadian Association of Rocketry","commonName":"M1450","dataFiles":2,"designation":"9955M1450-P","diameter":98,"impulseClass":"M","length":702,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":2416,"motorId":"5f4294d200023100000001ff","propInfo":"Classic","propWeightG":4830,"samples":[[0,0],[0.01,60],[0.06,524],[0.1,2164],[0.151,2416],[0.25,2162],[0.5,2037],[0.75,2022],[1,2009],[1.5,2006],[2,1968],[2.5,1895],[3,1770],[3.5,1673],[4,1517],[4.5,1337],[5,1166],[5.5,954],[5.8,687],[6.2,360],[6.86,79],[6.87,0]],"totImpulseNs":9955,"totalWeightG":8578,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1120,"burnTimeS":12.49,"caseInfo":"Pro98-6G","certOrg":"Canadian Association of Rocketry","commonName":"N1100","dataFiles":2,"designation":"14005N1100-P","diameter":98,"impulseClass":"N","length":1046,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1120,"motorId":"5f4294d20002310000000200","propInfo":"Classic","propWeightG":6790,"samples":[[0,0],[0.16,2624],[0.33,2708],[0.91,2055],[1.22,1896],[2.44,1793],[3.66,1625],[4.88,1402],[6.12,1158],[7.41,854],[9.77,494],[12.18,111.2],[12.19,0]],"totImpulseNs":14010,"totalWeightG":11590,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":54.78,"burnTimeS":2.79,"certOrg":"Canadian Association of Rocketry","commonName":"G55","dataFiles":1,"designation":"150G55-P","diameter":38,"impulseClass":"G","length":308,"manufacturer":"West Coast Hybrids","manufacturerAbbrev":"WCH","maxThrustN":256.4,"motorId":"5f4294d20002310000000201","samples":[[0,0],[0.053,144.1],[0.124,75.17],[0.212,73.42],[0.313,70.98],[0.649,62.94],[0.879,57.34],[1.02,55.24],[1.162,54.19],[1.239,56.99],[1.498,54.19],[1.539,51.4],[1.634,50],[1.693,52.1],[1.822,51.75],[1.899,50],[2.047,48.25],[2.094,46.15],[2.17,39.86],[2.247,36.36],[2.577,22.38],[2.955,15.38],[3.138,0]],"totImpulseNs":150.6,"totalWeightG":465.8,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":460,"burnTimeS":4.33,"certOrg":"Canadian Association of Rocketry","commonName":"K460","dataFiles":1,"designation":"1988K460-P","diameter":75,"impulseClass":"K","length":762,"manufacturer":"West Coast Hybrids","manufacturerAbbrev":"WCH","maxThrustN":768,"motorId":"5f4294d20002310000000202","samples":[[0,0],[0.048,263.8],[0.181,789.8],[0.21,769.5],[0.229,728.9],[0.31,711.7],[0.344,694.5],[0.368,672.7],[0.411,658.6],[0.477,638.4],[0.535,625.9],[0.573,618.1],[0.601,607.1],[0.764,496.3],[0.792,483.8],[0.826,477.6],[0.964,458.9],[1.093,429.2],[1.232,533.8],[1.27,563.4],[1.298,602.5],[1.356,613.4],[1.432,630.6],[1.489,629],[1.551,619.6],[1.599,614.9],[1.642,616.5],[1.718,633.7],[1.8,643],[1.857,657.1],[1.895,654],[1.957,669.6],[2.019,677.4],[2.081,677.4],[2.153,652.4],[2.277,607.1],[2.396,575.9],[2.477,558.8],[2.525,549.4],[2.597,510.4],[2.678,437],[2.764,363.7],[2.883,285.6],[3.141,181.1],[3.341,124.9],[3.728,63.99],[4,0]],"totImpulseNs":1988,"totalWeightG":3650,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":598.8,"burnTimeS":5.33,"certOrg":"Canadian Association of Rocketry","commonName":"L600","dataFiles":1,"designation":"3161L600-P","diameter":75,"impulseClass":"L","length":1016,"manufacturer":"West Coast Hybrids","manufacturerAbbrev":"WCH","maxThrustN":1647,"motorId":"5f4294d20002310000000203","samples":[[0,0],[0.072,871.3],[0.119,580.9],[0.215,674.3],[0.263,564.2],[0.31,704.4],[0.43,831.2],[0.477,787.8],[0.561,1148],[0.633,1098],[0.752,1125],[0.883,1102],[0.979,804.5],[1.134,761.1],[1.241,847.9],[1.337,767.8],[1.42,754.4],[1.468,774.5],[1.552,744.4],[1.946,711],[2.626,684.3],[3.056,674.3],[3.39,614.2],[3.473,630.9],[3.593,627.6],[3.724,610.9],[3.796,574.2],[3.927,450.7],[4.058,380.6],[4.393,257],[4.727,166.9],[5.168,63.43],[5.443,0]],"totImpulseNs":3161,"totalWeightG":5134,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":660,"burnTimeS":8.47,"certOrg":"Canadian Association of Rocketry","commonName":"M700","dataFiles":1,"designation":"5592M700-P","diameter":75,"impulseClass":"M","length":1473,"manufacturer":"West Coast Hybrids","manufacturerAbbrev":"WCH","maxThrustN":1928,"motorId":"5f4294d20002310000000204","samples":[[0,0],[0.06,387.3],[0.12,931.7],[0.215,1005],[0.251,1257],[0.394,1253],[0.49,1023],[0.645,869.6],[0.765,964.6],[0.813,825.8],[1.028,781.9],[1.183,898.9],[1.41,902.5],[1.924,909.8],[2.295,858.7],[2.51,855],[2.773,869.6],[2.976,898.9],[3.43,880.6],[4.231,829.4],[5.187,760],[5.378,738.1],[5.558,712.5],[5.677,679.6],[5.833,595.6],[5.952,526.2],[6.263,405.6],[6.884,270.4],[7.542,153.5],[8.438,0]],"totImpulseNs":5592,"totalWeightG":7268,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":136,"burnTimeS":3.55,"caseInfo":"38/480","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I110","dataFiles":2,"designation":"I110-LW","diameter":38,"impulseClass":"I","length":298,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":284,"motorId":"5f4294d20002310000000205","propInfo":"Loki White","samples":[[0,0],[0.001,282.4],[0.0358,218.7],[0.1228,170.9],[0.2156,163.6],[0.4012,169.1],[1.503,176.5],[2.002,152.6],[2.501,108.4],[3,64.33],[4.001,0]],"totImpulseNs":487.8,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":215,"burnTimeS":5.3,"caseInfo":"54/1200","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J175","dataFiles":2,"designation":"J175-LW","diameter":54,"impulseClass":"J","length":330,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":478,"motorId":"5f4294d20002310000000206","propInfo":"Loki White","propWeightG":654,"samples":[[0,0],[0.01,4.8],[0.1,420.4],[0.2,347.5],[0.3,349.9],[0.4,364.5],[0.5,320.7],[1,296.4],[1.5,279.4],[2,260],[2.5,238.1],[3,209],[3.5,172],[4,133.6],[4.5,102],[5,75.3],[5.5,46.2],[6,17],[6.5,0]],"totImpulseNs":1146,"totalWeightG":1250,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":840,"burnTimeS":1.3,"caseInfo":"54/1200","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J820","dataFiles":2,"designation":"J820-LW","diameter":54,"impulseClass":"J","length":330,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":1281,"motorId":"5f4294d20002310000000207","propInfo":"Loki White","propWeightG":643,"samples":[[0,0],[0.01,4.8],[0.02,982.4],[0.07,1033],[0.11,982.4],[0.2,959.9],[0.3,943],[0.4,947],[0.5,972.8],[0.6,981.4],[0.7,990],[0.8,990],[0.9,981.4],[0.95,1033],[1,981.4],[1.1,641.4],[1.2,353],[1.3,206.6],[1.4,120.5],[1.5,0]],"totImpulseNs":1108,"totalWeightG":1210,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":554.5,"burnTimeS":3.04,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K555","dataFiles":1,"designation":"K555-BG","diameter":54,"impulseClass":"K","length":1220,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":1200,"motorId":"5f4294d20002310000000208","propWeightG":450,"samples":[[0,0],[0.05034,769.9],[0.3356,889.6],[0.5593,1386],[0.8445,872.5],[1.012,581.7],[2.489,342.2],[2.567,222.4],[2.64,136.9],[2.74,51.33],[2.813,17.11],[3.04,0]],"totImpulseNs":1686,"totalWeightG":2038,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":586,"burnTimeS":3.6,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K543","dataFiles":1,"designation":"K543-BS","diameter":76,"impulseClass":"K","length":813,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":2129,"motorId":"5f4294d20002310000000209","propWeightG":500,"samples":[[0,0],[0.001,900],[2.991,472.9],[3.125,108.5],[3.601,0]],"totImpulseNs":2096,"totalWeightG":3606,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":896,"burnTimeS":2.67,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K888","dataFiles":1,"designation":"K888-BM","diameter":76,"impulseClass":"K","length":1016,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":3025,"motorId":"5f4294d2000231000000020a","propWeightG":625,"samples":[[0,0],[0.001,1365],[0.501,1365],[1.042,1070],[2.498,434.1],[2.543,124],[2.701,0]],"totImpulseNs":2400,"totalWeightG":4173,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1531,"burnTimeS":3.1,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1428","dataFiles":1,"designation":"L1428-SF","diameter":76,"impulseClass":"L","length":1753,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":3064,"motorId":"5f4294d2000231000000020b","propWeightG":1150,"samples":[[0,0],[0.001,1425],[0.4041,2752],[0.801,2725],[1.21,1512],[2.651,800],[3.001,800],[3.101,0]],"sparky":true,"totImpulseNs":4733,"totalWeightG":5738,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1693,"burnTimeS":3.35,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1491","dataFiles":1,"designation":"M1491-BM","diameter":76,"impulseClass":"M","length":1372,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":5706,"motorId":"5f4294d2000231000000020c","propWeightG":664,"samples":[[0,0],[0.001,2725],[0.4825,2636],[0.8129,2287],[1.334,1860],[3.001,900],[3.092,503.9],[3.351,0]],"totImpulseNs":5676,"totalWeightG":4876,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":245,"burnTimeS":1.06,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H248","dataFiles":1,"designation":"H248-PVC","diameter":38,"impulseClass":"H","length":719,"manufacturer":"Contrail Rockets","manufacturerAbbrev":"Contrail","maxThrustN":746,"motorId":"5f4294d2000231000000020d","propWeightG":184,"samples":[[0,0],[0.002237,465.4],[0.08277,698],[0.1119,342.2],[0.5369,266.9],[0.6398,191.6],[0.7002,184.8],[0.7383,164.2],[1.1,0]],"totImpulseNs":261.5,"totalWeightG":793.8,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":10.58,"burnTimeS":7.02,"certOrg":"National Association of Rocketry","commonName":"F10","dataFiles":2,"delays":"4,6,8","designation":"F10","diameter":29,"impulseClass":"F","infoUrl":"http://www.nar.org/SandT/pdf/Apogee/F10.pdf","length":92,"manufacturer":"Apogee Components","manufacturerAbbrev":"Apogee","maxThrustN":22.69,"motorId":"5f4294d2000231000000020e","propWeightG":40,"samples":[[0,0],[0.015,28.22],[0.077,26.08],[0.201,24.93],[0.31,22.81],[0.464,20.18],[0.573,17.89],[0.789,16.07],[1.068,13.95],[1.393,12.63],[1.718,11.15],[2.166,9.844],[2.677,9.515],[3.311,9.187],[3.683,8.859],[3.791,9.679],[4.101,9.679],[4.658,9.515],[5.168,9.023],[5.725,9.023],[6.112,8.531],[6.329,8.859],[6.499,7.546],[6.685,5.742],[6.778,4.921],[6.917,2.625],[7.025,1.312],[7.13,0]],"totImpulseNs":74.26,"totalWeightG":82.5,"type":"SU","updatedOn":"2020-09-01"},{"availability":"regular","avgThrustN":6.47,"burnTimeS":5.84,"certOrg":"National Association of Rocketry","commonName":"E6","dataFiles":2,"delays":"4,6,8","designation":"E6","diameter":24,"impulseClass":"E","infoUrl":"http://www.nar.org/SandT/pdf/Apogee/E6.pdf","length":77,"manufacturer":"Apogee Components","manufacturerAbbrev":"Apogee","maxThrustN":16.56,"motorId":"5f4294d2000231000000020f","propWeightG":22,"samples":[[0,0],[0.056,18.59],[0.112,20.12],[0.168,17.57],[0.307,14.38],[0.531,10.45],[0.894,7.696],[1.146,6.244],[1.691,5.808],[2.836,5.663],[3.898,5.517],[4.275,5.227],[4.415,4.937],[5.058,5.082],[5.519,5.227],[5.603,6.679],[5.729,3.921],[5.882,2.323],[5.966,1.016],[6.06,0]],"totImpulseNs":37.8,"totalWeightG":46,"type":"SU","updatedOn":"2020-09-01"},{"availability":"regular","avgThrustN":4.93,"burnTimeS":3.98,"certOrg":"National Association of Rocketry","commonName":"D5","dataFiles":2,"designation":"D5-P","diameter":20,"impulseClass":"D","infoUrl":"http://www.nar.org/SandT/pdf/Quest/D5_cn.pdf","length":88,"manufacturer":"Quest Aerospace","manufacturerAbbrev":"Quest","maxThrustN":11.49,"motorId":"5f4294d20002310000000210","propInfo":"black powder","propWeightG":25,"samples":[[0,0],[0.096,1.241],[0.252,5.897],[0.304,8.586],[0.357,10.55],[0.391,11.48],[0.435,9.828],[0.557,6.103],[0.583,5.172],[0.67,5.172],[1.078,4.966],[1.2,4.345],[1.73,4.759],[1.8,4.759],[1.887,4.138],[2.391,5.069],[2.626,4.966],[3.009,5.379],[3.357,5.276],[3.661,5.69],[3.835,3.103],[3.887,1.655],[3.983,0]],"totImpulseNs":19.61,"totalWeightG":38,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":805,"burnTimeS":2.2,"caseInfo":"RMS-54/1706","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K805","dataFiles":2,"delays":"P","designation":"K805G","diameter":54,"impulseClass":"K","length":401,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d20002310000000211","propInfo":"Mojave Green","propWeightG":871.1,"samples":[[0,0],[0.001,7.669],[0.004882,437.2],[0.0437,797.6],[0.07864,828.3],[0.1019,774.6],[0.1602,736.3],[0.199,743.9],[0.2999,774.6],[0.4008,789.9],[0.5018,797.6],[0.6027,813],[0.6998,813],[0.8007,813],[0.9016,813],[1.003,813],[1.1,782.3],[1.201,766.9],[1.298,759.3],[1.402,759.3],[1.499,743.9],[1.6,720.9],[1.697,697.9],[1.802,682.6],[1.899,659.6],[2,644.2],[2.101,628.9],[2.202,644.2],[2.303,544.5],[2.401,0]],"totImpulseNs":1762,"totalWeightG":1543,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":2030,"burnTimeS":2.6,"caseInfo":"RMS-75/5120","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M2030","dataFiles":1,"designation":"M2030G-P","diameter":75,"impulseClass":"M","length":653,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d20002310000000212","propInfo":"Mojave Green","propWeightG":2663,"samples":[[0,0],[0.007764,1342],[0.07764,2147],[0.1553,1841],[0.4969,2224],[0.7842,2608],[1.002,2646],[1.359,2531],[1.491,2416],[1.995,1802],[2.391,1419],[2.5,805.3],[2.562,191.7],[2.675,0]],"totImpulseNs":5485,"totalWeightG":4906,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":2100,"burnTimeS":3.7,"caseInfo":"RMS-98/7680","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M2100","dataFiles":2,"delays":"P","designation":"M2100G","diameter":98,"impulseClass":"M","length":598,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d20002310000000213","propInfo":"Mojave Green","propWeightG":3948,"samples":[[0,0],[0.014,72.79],[0.017,1148],[0.021,1553],[0.038,1593],[0.042,1909],[0.052,2062],[0.077,2151],[0.115,2208],[0.167,2240],[0.223,2256],[0.272,2256],[0.31,2232],[0.415,2281],[0.59,2386],[0.701,2410],[0.876,2507],[0.959,2556],[1.043,2588],[1.176,2677],[1.263,2782],[1.333,2831],[1.437,2847],[1.517,2879],[1.608,2968],[1.667,2944],[1.81,2936],[1.926,2895],[1.999,2847],[2.041,2782],[2.152,2531],[2.393,1949],[2.484,1787],[2.56,1674],[2.738,1504],[2.836,1440],[2.958,1367],[3.091,1286],[3.178,1229],[3.23,1197],[3.283,1181],[3.401,1189],[3.447,1140],[3.478,1035],[3.513,913.9],[3.516,541.9],[3.527,444.8],[3.541,0]],"totImpulseNs":7802,"totalWeightG":6918,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":76,"burnTimeS":1.5,"caseInfo":"RMS-29/40-120","certOrg":"National Association of Rocketry","commonName":"G76","dataFiles":3,"delays":"4,5,6,7,8,10","designation":"G76G","diameter":29,"impulseClass":"G","infoUrl":"https://nar.org/SandT/pdf/Aerotech/G76G.pdf","length":124,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":196,"motorId":"5f4294d20002310000000214","propInfo":"Mojave Green","propWeightG":60,"samples":[[0,0],[0.004,4.24],[0.006,9.683],[0.016,54.4],[0.03,98.17],[0.034,108.5],[0.04,121.2],[0.048,133],[0.058,142.3],[0.068,147.2],[0.082,149.4],[0.112,146.9],[0.15,138.8],[0.17,136],[0.376,112.2],[0.466,103.1],[0.482,104.4],[0.56,92.65],[0.606,92.87],[0.644,84.21],[0.748,73.94],[0.76,74.28],[0.79,69.7],[0.804,70.6],[0.822,66.76],[0.856,62.69],[1.154,40],[1.374,19.91],[1.474,12.52],[1.574,7.418],[1.78,1.19],[2,0]],"totImpulseNs":118,"totalWeightG":147,"type":"reload","updatedOn":"2022-07-20"},{"availability":"regular","avgThrustN":8035,"burnTimeS":5.1,"caseInfo":"Pro150-40k","certOrg":"Canadian Association of Rocketry","commonName":"O8000","dataFiles":2,"designation":"40960O8000-P","diameter":161,"impulseClass":"O","length":957,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":8605,"motorId":"5f4294d20002310000000215","propInfo":"White Thunder","propWeightG":18610,"samples":[[0,0],[0.045,3965],[0.046,6743],[0.047,8624],[0.125,7929],[0.239,8161],[0.364,8392],[0.489,8508],[0.614,8537],[0.773,8392],[0.989,8421],[1.273,8479],[1.602,8624],[2.011,8566],[2.33,8566],[2.682,8479],[3.102,8277],[3.568,8045],[3.886,7900],[4.239,7669],[4.591,7524],[4.739,7524],[4.909,7264],[4.955,7003],[4.977,6540],[4.989,5846],[5,5006],[5.023,4051],[5.034,3068],[5.045,1997],[5.08,1013],[5.114,318.3],[5.17,0]],"totImpulseNs":40960,"totalWeightG":32670,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":5787,"burnTimeS":5.23,"caseInfo":"Pro150-30K","certOrg":"Canadian Association of Rocketry","commonName":"O5800","dataFiles":2,"designation":"30600O5800-P","diameter":161,"impulseClass":"O","length":754,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":6339,"motorId":"5f4294d20002310000000216","propInfo":"White Thunder","propWeightG":13950,"samples":[[0,0],[0.069,6338],[0.103,5701],[0.218,5875],[0.378,6135],[0.561,6338],[0.745,6222],[0.985,6222],[1.18,6193],[1.455,6309],[1.753,6367],[1.994,6338],[2.269,6395],[2.509,6309],[2.83,6193],[3.14,6048],[3.426,5875],[3.69,5730],[3.965,5585],[4.263,5383],[4.572,5296],[4.939,5180],[5.053,5035],[5.11,4717],[5.133,4225],[5.145,3675],[5.156,3039],[5.179,2344],[5.214,1476],[5.259,607.7],[5.294,57.88],[5.295,0]],"totImpulseNs":30610,"totalWeightG":26370,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":113.5,"burnTimeS":1.24,"caseInfo":"Pro38-1G","certOrg":"Canadian Association of Rocketry","commonName":"G115","dataFiles":1,"delays":"4,6,8,10,13","designation":"141G115-13A","diameter":38,"impulseClass":"G","length":127,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":134.4,"motorId":"5f4294d20002310000000217","propInfo":"White Thunder","propWeightG":61.8,"samples":[[0,0],[0.007874,10.34],[0.01837,117.7],[0.021,128.4],[0.04462,131.9],[0.05774,125.9],[0.06299,119.4],[0.07874,113.8],[0.1076,115.9],[0.1496,119],[0.189,119.4],[0.2336,122],[0.2782,122.4],[0.3228,122.8],[0.3806,123.3],[0.4409,122.8],[0.4803,123.3],[0.5407,122.8],[0.5906,122.4],[0.622,120.7],[0.6798,120.3],[0.7349,119.4],[0.79,117.7],[0.8451,116.8],[0.8819,116.4],[0.9291,113.4],[0.979,113.4],[1.032,111.2],[1.071,108.2],[1.113,108.2],[1.165,106],[1.184,112.5],[1.186,96.55],[1.197,81.03],[1.202,51.72],[1.213,30.17],[1.215,16.81],[1.218,7.759],[1.24,0]],"totImpulseNs":140.6,"totalWeightG":195,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":121.4,"burnTimeS":2.15,"caseInfo":"Pro38-2G","certOrg":"Canadian Association of Rocketry","commonName":"H120","dataFiles":2,"delays":"5,7,9,11,14","designation":"261H120-14A","diameter":38,"impulseClass":"H","length":186,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":149.4,"motorId":"5f4294d20002310000000218","propInfo":"Red Lightning","propWeightG":136,"samples":[[0,0],[0.016,53.02],[0.029,107.1],[0.036,124.5],[0.049,129.5],[0.062,117.8],[0.072,98.22],[0.131,123.8],[0.199,136.6],[0.258,144.1],[0.313,147.7],[0.369,146.3],[0.441,145.2],[0.558,143.4],[0.683,141.6],[0.777,140.9],[0.859,139.1],[0.98,136.3],[1.097,133.1],[1.251,128.8],[1.434,122.8],[1.558,118.9],[1.639,117.1],[1.731,117.1],[1.884,117.1],[1.927,105.3],[1.959,88.96],[1.995,68.33],[2.031,41.99],[2.083,18.5],[2.142,6.761],[2.181,2.135],[2.24,0]],"totImpulseNs":260.7,"totalWeightG":295,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":226.3,"burnTimeS":1.21,"caseInfo":"Pro38-2G","certOrg":"Canadian Association of Rocketry","commonName":"H225","dataFiles":1,"delays":"5,7,9,11,14","designation":"273H225-14A","diameter":38,"impulseClass":"H","length":186,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":254.1,"motorId":"5f4294d20002310000000219","propInfo":"White Thunder","propWeightG":123.6,"samples":[[0,0],[0.002625,263.8],[0.02362,246.5],[0.03412,234.5],[0.04199,219.8],[0.09711,237.1],[0.1365,242.2],[0.2021,242.2],[0.273,242.2],[0.3307,241.4],[0.378,243.1],[0.4436,243.1],[0.5039,242.2],[0.5696,241.4],[0.6352,240.5],[0.7218,238.8],[0.8215,237.1],[0.9003,234.5],[0.9685,227.6],[1.037,221.5],[1.068,217.2],[1.118,206],[1.131,196.5],[1.142,216.4],[1.152,153.4],[1.16,103.4],[1.171,52.59],[1.189,19.83],[1.21,0]],"totImpulseNs":273.2,"totalWeightG":193,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":345.1,"burnTimeS":1.18,"caseInfo":"Pro38-3G","certOrg":"Canadian Association of Rocketry","commonName":"I345","dataFiles":1,"delays":"6,8,10,12,15","designation":"408I345-15A","diameter":38,"impulseClass":"I","length":245,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":402.6,"motorId":"5f4294d2000231000000021a","propInfo":"White Thunder","propWeightG":185.4,"samples":[[0,0],[0.0105,398.3],[0.03412,376.7],[0.04462,358.6],[0.07874,358.6],[0.1286,360.3],[0.1811,362.9],[0.252,363.8],[0.3228,365.5],[0.3963,362.9],[0.4541,361.2],[0.5249,359.5],[0.6037,356],[0.6903,352.6],[0.7638,348.3],[0.8136,348.3],[0.8583,345.7],[0.916,344],[1.005,339.7],[1.05,336.2],[1.081,338.8],[1.1,302.6],[1.121,225],[1.136,141.4],[1.147,83.62],[1.152,23.28],[1.18,0]],"totImpulseNs":407.6,"totalWeightG":395,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":253,"burnTimeS":2.04,"caseInfo":"Pro38-4G","certOrg":"Canadian Association of Rocketry","commonName":"I255","dataFiles":1,"delays":"7,9,11,13,16","designation":"517I255-16A","diameter":38,"impulseClass":"I","length":303,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":313.9,"motorId":"5f4294d2000231000000021b","propInfo":"Red Lightning","propWeightG":273.2,"samples":[[0,0],[0.016,105.8],[0.029,213.8],[0.036,248.6],[0.037,272],[0.065,252.2],[0.108,278.4],[0.173,298.3],[0.248,308.3],[0.34,313.9],[0.467,311.1],[0.585,304],[0.66,298.3],[0.761,294.8],[0.882,287.7],[0.996,278.4],[1.104,272.8],[1.248,258.5],[1.421,249.3],[1.568,250],[1.649,245.1],[1.734,243.6],[1.8,207.4],[1.881,114.4],[1.953,55.4],[2.022,20.6],[2.025,0]],"totImpulseNs":517.3,"totalWeightG":516,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":472.2,"burnTimeS":1.14,"caseInfo":"Pro38-4G","certOrg":"Canadian Association of Rocketry","commonName":"I470","dataFiles":1,"delays":"6,8,10,12,15","designation":"540I470-15A","diameter":38,"impulseClass":"I","length":303,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":555.2,"motorId":"5f4294d2000231000000021c","propInfo":"White Thunder","propWeightG":247.2,"samples":[[0,0],[0.005249,517.2],[0.01312,563.8],[0.03675,537.9],[0.03937,506.9],[0.06824,519],[0.09449,519],[0.1312,520.7],[0.1785,524.1],[0.2178,525.9],[0.2677,525.9],[0.2992,527.6],[0.3465,522.4],[0.3885,520.7],[0.4226,522.4],[0.4593,525.9],[0.5092,522.4],[0.5538,517.2],[0.5853,515.5],[0.6378,515.5],[0.6877,508.6],[0.7297,505.2],[0.7717,508.6],[0.8241,503.4],[0.8609,496.5],[0.9003,494.8],[0.9265,491.4],[0.9738,482.8],[0.9974,415.5],[1.005,374.1],[1.024,337.9],[1.05,282.8],[1.066,231],[1.076,181],[1.087,134.5],[1.1,86.21],[1.11,32.76],[1.14,0]],"totImpulseNs":540.1,"totalWeightG":495,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":335.5,"burnTimeS":1.93,"caseInfo":"Pro38-5G","certOrg":"Canadian Association of Rocketry","commonName":"J335","dataFiles":1,"delays":"6,8,10,12,15","designation":"649J335-15A","diameter":38,"impulseClass":"J","length":367,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":410.6,"motorId":"5f4294d2000231000000021d","propInfo":"Red Lightning","propWeightG":341.5,"samples":[[0,0],[0.013,313.7],[0.025,364.3],[0.038,409.5],[0.091,409.5],[0.148,405.7],[0.242,402.6],[0.374,405.7],[0.515,401.1],[0.735,387.3],[0.892,378.9],[1.108,360.5],[1.25,349.7],[1.366,346.7],[1.504,344.4],[1.551,334.4],[1.607,320.6],[1.667,257.7],[1.708,179.5],[1.777,95.87],[1.833,44.48],[1.925,14.57],[1.987,0.767],[2.012,0]],"totImpulseNs":649.2,"totalWeightG":627,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":408.9,"burnTimeS":1.89,"caseInfo":"Pro38-6G","certOrg":"Canadian Association of Rocketry","commonName":"J410","dataFiles":2,"delays":"7,9,11,13,16","designation":"774J410-16A","diameter":38,"impulseClass":"J","length":421,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":512.1,"motorId":"5f4294d2000231000000021e","propInfo":"Red Lightning","propWeightG":409.8,"samples":[[0,0],[0.023,375.4],[0.029,446.2],[0.042,511],[0.11,499],[0.22,495.4],[0.442,491.8],[0.675,475],[0.901,464.2],[1.092,448.6],[1.221,437.8],[1.34,429.4],[1.492,419.8],[1.553,389.8],[1.592,349.1],[1.65,273.5],[1.689,196.7],[1.75,122.4],[1.809,64.77],[1.889,28.79],[1.941,13.2],[1.989,0]],"totImpulseNs":773.8,"totalWeightG":735,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":324,"burnTimeS":2.2,"caseInfo":"54/550","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J348","dataFiles":1,"designation":"J348B","diameter":54,"impulseClass":"J","length":609,"manufacturer":"Sky Ripper Systems","manufacturerAbbrev":"SkyR","maxThrustN":1553,"motorId":"5f4294d2000231000000021f","propInfo":"ABS/B, 550cc nitrous","propWeightG":91,"samples":[[0,0],[0.001,8.88],[0.021,451.8],[0.131,557.6],[0.141,1204],[0.201,617.6],[0.401,549],[0.601,494.7],[0.791,406.1],[1.011,354.6],[1.201,334.6],[1.311,303.1],[1.401,237.3],[1.601,148.7],[1.801,82.92],[2.001,37.17],[2.201,0]],"totImpulseNs":716,"totalWeightG":1224,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":323,"burnTimeS":3.5,"caseInfo":"54/550","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J263","dataFiles":1,"designation":"J263G","diameter":54,"impulseClass":"J","length":749,"manufacturer":"Sky Ripper Systems","manufacturerAbbrev":"SkyR","maxThrustN":2354,"motorId":"5f4294d20002310000000220","propInfo":"ABS/G, 830cc nitrous","propWeightG":89,"samples":[[0,0],[0.01,1359],[0.09,794.3],[0.15,559.9],[0.21,419.3],[0.4,296.9],[0.61,286.5],[0.81,265.6],[1.01,244.8],[1.2,247.4],[1.4,244.8],[1.6,231.8],[1.81,200.5],[2.01,205.7],[2.21,205.7],[2.41,195.3],[2.6,174.5],[2.8,166.7],[2.91,161.5],[3,138],[3.08,98.96],[3.21,62.5],[3.41,28.74],[3.6,0]],"totImpulseNs":1248,"totalWeightG":1338,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":347,"burnTimeS":3,"caseInfo":"54/830","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J337","dataFiles":1,"designation":"J337B","diameter":54,"impulseClass":"J","length":749,"manufacturer":"Sky Ripper Systems","manufacturerAbbrev":"SkyR","maxThrustN":1876,"motorId":"5f4294d20002310000000221","propInfo":"ABS/B, 830cc nitrous","propWeightG":91,"samples":[[0,0],[0.001,8.88],[0.011,1521],[0.101,585.3],[0.201,651.3],[0.411,589.5],[0.501,548.2],[0.601,540],[0.991,461.7],[1.401,416.3],[1.601,391.6],[1.801,387.5],[1.911,364.9],[2.011,239.4],[2.201,171],[2.401,119.7],[2.601,72.68],[2.801,42.76],[3.001,21.68],[3.101,0]],"totImpulseNs":1073,"totalWeightG":1338,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":262,"burnTimeS":4.9,"caseInfo":"54/830","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J261","dataFiles":1,"designation":"J261G","diameter":54,"impulseClass":"J","length":749,"manufacturer":"Sky Ripper Systems","manufacturerAbbrev":"SkyR","maxThrustN":2354,"motorId":"5f4294d20002310000000222","propInfo":"ABS/G, 830cc nitrous","propWeightG":91,"samples":[[0,0],[0.02,1303],[0.09,903.9],[0.21,591.2],[0.42,349.6],[0.61,304.6],[0.81,329.6],[1.01,277.2],[1.21,294.6],[1.39,232.2],[1.61,197.3],[1.82,256],[2,274.7],[2.2,269.7],[2.41,189.8],[2.61,294.6],[2.82,212.2],[3.01,254.7],[3.21,225.3],[3.41,194.8],[3.59,156.3],[3.74,229.7],[3.85,237.7],[3.9,156.3],[4,112.8],[4.2,140.2],[4.4,192.3],[4.48,106.7],[4.61,54.86],[4.76,33.52],[4.95,0]],"totImpulseNs":1248,"totalWeightG":1338,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":388,"burnTimeS":3.57,"caseInfo":"54/1130","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K347","dataFiles":1,"designation":"K347B","diameter":54,"impulseClass":"K","length":911,"manufacturer":"Sky Ripper Systems","manufacturerAbbrev":"SkyR","maxThrustN":1901,"motorId":"5f4294d20002310000000223","propInfo":"ABS/B, 1130cc nitrous","propWeightG":91,"samples":[[0,0],[0.001,8.88],[0.031,1475],[0.111,972.2],[0.191,737.3],[0.401,697.2],[0.611,673.9],[0.811,653.9],[1.011,600.4],[1.201,550.4],[1.401,530.4],[1.601,533.8],[1.801,517.1],[1.891,397],[1.951,493.2],[2.061,393.6],[2.131,443.7],[2.301,365.4],[2.301,292.3],[2.401,257.9],[2.601,184.8],[2.791,124.7],[3.001,81.67],[3.211,51.58],[3.411,21.49],[3.581,0]],"totImpulseNs":1529,"totalWeightG":1542,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":282,"burnTimeS":6.1,"caseInfo":"54/1130","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K257","dataFiles":1,"designation":"K257G","diameter":54,"impulseClass":"K","length":914,"manufacturer":"Sky Ripper Systems","manufacturerAbbrev":"SkyR","maxThrustN":2461,"motorId":"5f4294d20002310000000224","propInfo":"ABS/G, 1130cc nitrous","propWeightG":90,"samples":[[0,0],[0.07,1133],[0.2,530],[0.4,333.7],[0.59,363.1],[0.8,347.2],[0.98,366.4],[1.2,356.6],[1.4,310.8],[1.6,274.8],[1.81,337.7],[2,356.6],[2.2,294.4],[2.4,314.1],[2.6,294.4],[2.81,333.7],[3,340.2],[3.22,319.8],[3.41,292.7],[3.59,249.3],[3.79,278.1],[4,243.9],[4.21,281.4],[4.41,235.5],[4.6,251.9],[4.81,211.4],[5.01,222.2],[5.2,189.7],[5.41,153.2],[5.6,81.4],[5.8,23.94],[6.1,0]],"totImpulseNs":1733,"totalWeightG":1541,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":240.8,"burnTimeS":3.35,"caseInfo":"Pro54-2G","certOrg":"Canadian Association of Rocketry","commonName":"J240","dataFiles":1,"delays":"6,7,8,9,10,11,12,13,14,15,16","designation":"806J240-16A","diameter":54,"impulseClass":"J","length":236,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":299.4,"motorId":"5f4294d20002310000000225","propInfo":"Red Lightning","propWeightG":446,"samples":[[0,0],[0.01,13.16],[0.02,24.09],[0.03,94.03],[0.04,187.4],[0.05,242.4],[0.06,257.9],[0.07,263.6],[0.08,269.1],[0.09,273.4],[0.1,268.8],[0.2,247.2],[0.3,277.1],[0.4,282.4],[0.5,288.5],[0.6,287.9],[0.7,289.1],[0.8,291.3],[0.9,287.7],[1,292.6],[1.1,292.6],[1.2,284.6],[1.3,287.3],[1.4,280.3],[1.5,274.9],[1.6,273.6],[1.7,266.1],[1.8,263.5],[1.9,262.4],[2,258],[2.1,250.5],[2.2,258.4],[2.3,240.8],[2.4,236.5],[2.5,228.5],[2.6,230.9],[2.7,221.3],[2.8,218.4],[2.9,218.4],[3,205.1],[3.1,130.8],[3.2,42.1],[3.348,0]],"totImpulseNs":806,"totalWeightG":875,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":353.3,"burnTimeS":3.37,"caseInfo":"Pro54-3G","certOrg":"Canadian Association of Rocketry","commonName":"J355","dataFiles":1,"delays":"7,8,9,10,11,12,13,14,15,16,17","designation":"1190J355-17A","diameter":54,"impulseClass":"J","length":329,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":434.3,"motorId":"5f4294d20002310000000226","propInfo":"Red Lightning","propWeightG":669,"samples":[[0,0],[0.01,12.67],[0.02,7.51],[0.03,99.23],[0.04,265.9],[0.05,366.8],[0.06,390.5],[0.07,391.2],[0.08,392.5],[0.09,391.9],[0.1,386.5],[0.2,394.9],[0.3,413.2],[0.4,422.6],[0.5,430.8],[0.6,428.6],[0.7,430.9],[0.8,426.2],[0.9,422.7],[1,416.4],[1.1,410.7],[1.2,409.3],[1.3,403.3],[1.4,398.9],[1.5,394],[1.6,389.4],[1.7,383.5],[1.8,375.3],[1.9,369.2],[2,365.7],[2.1,359],[2.2,352],[2.3,345.3],[2.4,342],[2.5,340],[2.6,329.3],[2.7,314.5],[2.8,309.3],[2.9,302.8],[3,274.4],[3.1,238.4],[3.2,136],[3.3,46.35],[3.369,0]],"totImpulseNs":1190,"totalWeightG":1175,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":498.2,"burnTimeS":3.2,"caseInfo":"Pro54-4G","certOrg":"Canadian Association of Rocketry","commonName":"K500","dataFiles":1,"delays":"8,9,10,11,12,13,14,15,16,17,18","designation":"1596K500-18A","diameter":54,"impulseClass":"K","length":404,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":607.9,"motorId":"5f4294d20002310000000227","propInfo":"Red Lightning","propWeightG":892,"samples":[[0,0],[0.01,11.87],[0.02,0.001],[0.03,292.3],[0.04,374.7],[0.05,432.9],[0.06,479.8],[0.07,505.5],[0.08,509.5],[0.09,584.9],[0.1,499],[0.2,546.6],[0.3,579.9],[0.4,588.1],[0.5,595.3],[0.6,594.6],[0.7,594.5],[0.8,593.8],[0.9,584.9],[1,583.3],[1.1,575.3],[1.2,568.1],[1.3,564.3],[1.4,560.3],[1.5,540.3],[1.6,543.1],[1.7,532.6],[1.8,532.5],[1.9,508.6],[2,505.4],[2.1,496.3],[2.2,483.9],[2.3,476.3],[2.4,467],[2.5,454.8],[2.6,454.3],[2.7,437.9],[2.8,436.1],[2.9,415.7],[3,327.7],[3.1,133.2],[3.203,0]],"totImpulseNs":1596,"totalWeightG":1476,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":637.3,"burnTimeS":3.13,"caseInfo":"Pro54-5G","certOrg":"Canadian Association of Rocketry","commonName":"K635","dataFiles":1,"delays":"7,8,9,10,11,12,13,14,15,16,17","designation":"1994K635-17A","diameter":54,"impulseClass":"K","length":488,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":778.7,"motorId":"5f4294d20002310000000228","propInfo":"Red Lightning","propWeightG":1115,"samples":[[0,0],[0.01,0.872],[0.02,3.983],[0.03,312.7],[0.04,629.5],[0.05,633.1],[0.06,659.5],[0.07,680.5],[0.08,689.5],[0.09,694.1],[0.1,698.7],[0.2,735.3],[0.3,759.8],[0.4,757],[0.5,760.2],[0.6,760.8],[0.7,756.5],[0.8,754.1],[0.9,741.6],[1,741.6],[1.1,727.9],[1.2,724],[1.3,713.5],[1.4,708.6],[1.5,704.8],[1.6,688.4],[1.7,677.7],[1.8,661.6],[1.9,647],[2,637.3],[2.1,635.9],[2.2,623.9],[2.3,619.7],[2.4,594],[2.5,576.9],[2.6,559.6],[2.7,562.1],[2.8,497.6],[2.9,352.1],[3,187.3],[3.1,77.42],[3.129,0]],"totImpulseNs":1994,"totalWeightG":1768,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":749.8,"burnTimeS":3.14,"caseInfo":"Pro54-6G","certOrg":"Canadian Association of Rocketry","commonName":"K750","dataFiles":1,"delays":"8,9,10,11,12,13,14,15,16,17,18","designation":"2352K750-18A","diameter":54,"impulseClass":"K","length":572,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":946.3,"motorId":"5f4294d20002310000000229","propInfo":"Red Lightning","propWeightG":1321,"samples":[[0,0],[0.019,796.4],[0.084,846.6],[0.233,904],[0.434,947],[0.817,932.7],[1.549,846.6],[1.854,817.9],[2.113,796.4],[2.294,760.5],[2.398,674.4],[2.521,516.6],[2.599,509.4],[2.878,243.9],[2.962,122],[3.059,50.22],[3.144,7.175],[3.189,0]],"totImpulseNs":2353,"totalWeightG":2057,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1031,"burnTimeS":2.7,"caseInfo":"Pro54-6GXL","certOrg":"Canadian Association of Rocketry","commonName":"L1030","dataFiles":1,"delays":"P","designation":"2788L1030-P","diameter":54,"impulseClass":"L","length":649,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1223,"motorId":"5f4294d2000231000000022a","propInfo":"Red Lightning","propWeightG":1516,"samples":[[0,0],[0.01,5.768],[0.02,8.076],[0.03,1539],[0.04,1197],[0.05,1219],[0.06,1123],[0.07,1077],[0.08,1060],[0.09,1046],[0.1,1076],[0.2,1175],[0.3,1206],[0.4,1219],[0.5,1208],[0.6,1216],[0.7,1222],[0.8,1199],[0.9,1202],[1,1198],[1.1,1184],[1.2,1179],[1.3,1174],[1.4,1158],[1.5,1164],[1.6,1157],[1.7,1173],[1.8,1162],[1.9,1158],[2,1132],[2.1,940.7],[2.2,794.5],[2.3,759.9],[2.4,640.7],[2.5,469.2],[2.6,258.4],[2.7,79.61],[2.704,0]],"totImpulseNs":2788,"totalWeightG":2338,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1620,"burnTimeS":1.51,"caseInfo":"Pro98-1G","certOrg":"Canadian Association of Rocketry","commonName":"K1620","dataFiles":1,"designation":"2440K1620-P","diameter":98,"impulseClass":"K","length":240,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1851,"motorId":"5f4294d2000231000000022b","propInfo":"Vmax","propWeightG":1193,"samples":[[0,0],[0.01,29.61],[0.02,199.2],[0.03,1108],[0.04,1272],[0.05,1403],[0.06,1328],[0.07,1440],[0.08,1436],[0.08,1827],[0.09,1419],[0.1,1474],[0.2,1570],[0.3,1661],[0.4,1742],[0.5,1782],[0.6,1816],[0.7,1845],[0.9,1796],[1,1779],[1.1,1723],[1.2,1652],[1.3,1533],[1.35,1487],[1.4,1451],[1.45,1262],[1.46,1111],[1.47,929.5],[1.48,628],[1.49,382.3],[1.5,223.4],[1.531,0]],"totImpulseNs":2440,"totalWeightG":3077,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":3137,"burnTimeS":1.53,"caseInfo":"Pro98-2G","certOrg":"Canadian Association of Rocketry","commonName":"L3150","dataFiles":1,"designation":"4807L3150-P","diameter":98,"impulseClass":"L","length":394,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":3670,"motorId":"5f4294d2000231000000022c","propInfo":"Vmax","propWeightG":2386,"samples":[[0,0],[0.01,140.8],[0.02,2283],[0.03,3657],[0.04,2890],[0.05,3078],[0.06,3168],[0.07,3075],[0.08,2825],[0.09,2960],[0.1,2984],[0.2,3110],[0.3,3283],[0.4,3420],[0.5,3517],[0.6,3605],[0.7,3610],[0.8,3559],[0.9,3487],[1,3402],[1.1,3297],[1.2,3155],[1.3,2925],[1.4,2766],[1.45,2346],[1.47,1629],[1.5,883.4],[1.52,411.9],[1.55,65.38],[1.569,0]],"totImpulseNs":4808,"totalWeightG":4731,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":4770,"burnTimeS":1.53,"caseInfo":"Pro98-3G","certOrg":"Canadian Association of Rocketry","commonName":"M4770","dataFiles":1,"designation":"7312M4770-P","diameter":98,"impulseClass":"M","length":548,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":6053,"motorId":"5f4294d2000231000000022d","propInfo":"Vmax","propWeightG":3579,"samples":[[0,0],[0.01,15.38],[0.02,89.99],[0.03,3053],[0.04,5854],[0.05,4311],[0.06,4754],[0.07,4889],[0.08,4443],[0.09,4331],[0.1,4188],[0.2,4606],[0.3,4900],[0.4,5061],[0.5,5197],[0.6,5391],[0.7,5393],[0.8,5366],[0.9,5311],[1,5219],[1.1,5064],[1.2,4849],[1.4,4558],[1.45,3979],[1.5,3119],[1.52,1765],[1.55,216.5],[1.6,17.31],[1.617,0]],"totImpulseNs":7312,"totalWeightG":6503,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1889,"burnTimeS":5.25,"caseInfo":"Pro98-4G","certOrg":"Canadian Association of Rocketry","commonName":"M1890","dataFiles":1,"designation":"9876M1890-P","diameter":98,"impulseClass":"M","length":702,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":2402,"motorId":"5f4294d2000231000000022e","propInfo":"Red Lightning","propWeightG":5280,"samples":[[0,0],[0.01,63.45],[0.02,360],[0.03,580.3],[0.04,763.8],[0.05,1020],[0.06,1255],[0.07,1439],[0.08,1571],[0.09,1651],[0.1,1679],[0.2,1950],[0.3,1947],[0.4,1985],[0.5,2014],[0.6,2106],[0.7,2056],[0.8,2078],[0.9,2095],[1,2124],[1.1,2127],[1.2,2130],[1.3,2162],[1.4,2187],[1.5,2199],[1.6,2227],[1.7,2240],[1.8,2234],[1.9,2224],[2,2226],[2.1,2226],[2.2,2197],[2.3,2207],[2.4,2176],[2.6,2168],[2.8,2124],[3,2064],[3.2,2030],[3.4,1909],[3.6,1834],[3.8,1765],[4,1702],[4.2,1619],[4.4,1572],[4.6,1505],[4.8,1517],[4.9,1477],[5,1213],[5.1,624.2],[5.2,266.9],[5.3,94.99],[5.365,0]],"totImpulseNs":9876,"totalWeightG":8823,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":34.9,"burnTimeS":1.63,"caseInfo":"RMS-24/60","certOrg":"National Association of Rocketry","commonName":"F35","dataFiles":2,"delays":"4,5,6,7,8,9,11","designation":"F35W","diameter":24,"impulseClass":"F","infoUrl":"https://nar.org/SandT/pdf/Aerotech/F35W.pdf","length":95,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":55.2,"motorId":"5f4294d2000231000000022f","propInfo":"White Lightning","propWeightG":30,"samples":[[0,0],[0.007,39.45],[0.012,51.84],[0.019,49.88],[0.034,57.87],[0.048,58.36],[0.058,57.22],[0.077,54.45],[0.098,54.94],[0.106,53.96],[0.201,53.47],[0.299,53.31],[0.398,52.01],[0.498,52.01],[0.549,49.56],[0.601,48.91],[0.653,47.28],[0.702,45.65],[0.752,44.67],[0.802,43.2],[0.898,39.78],[0.946,39.62],[0.984,36.84],[1.003,37.33],[1.102,33.58],[1.144,30.16],[1.2,22.33],[1.298,10.92],[1.346,6.521],[1.398,3.26],[1.448,1.793],[1.497,0.978],[1.6,0]],"totImpulseNs":57.1,"totalWeightG":85,"type":"reload","updatedOn":"2022-07-20"},{"availability":"regular","avgThrustN":79.9,"burnTimeS":1.38,"certOrg":"National Association of Rocketry","commonName":"G78","dataFiles":3,"delays":"4,6,7,8,10","designation":"G78G/L","diameter":29,"impulseClass":"G","infoUrl":"https://nar.org/SandT/pdf/Aerotech/G78G.pdf","length":124,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":101.9,"motorId":"5f4294d20002310000000230","propInfo":"Mojave Green","propWeightG":59.7,"samples":[[0,0],[0.006,1.158],[0.008,7.49],[0.01,33.76],[0.012,64.6],[0.014,62.93],[0.016,58.83],[0.018,74.91],[0.02,85.01],[0.022,91.11],[0.026,93.99],[0.028,98.43],[0.032,97.65],[0.038,102.2],[0.074,97.32],[0.124,95.43],[0.376,99.32],[0.68,99.43],[0.994,91.66],[1.246,83.01],[1.282,77.35],[1.316,61.93],[1.36,44.63],[1.424,29.1],[1.504,21.22],[1.598,19.34],[1.656,16.34],[1.676,13.9],[1.678,11.79],[1.714,5.094],[1.734,1.389],[1.808,0]],"totImpulseNs":109.9,"totalWeightG":125,"type":"SU","updatedOn":"2022-07-20"},{"availability":"regular","avgThrustN":1520,"burnTimeS":0.71,"caseInfo":"Pro54-3G","certOrg":"Canadian Association of Rocketry","commonName":"J1520","dataFiles":1,"delays":"7,8,9,10,11,12,13,14,15,16,17","designation":"1092J1520-17A","diameter":54,"impulseClass":"J","length":329,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1687,"motorId":"5f4294d20002310000000231","propInfo":"Vmax","propWeightG":537,"samples":[[0,0],[0.01,216.5],[0.02,1199],[0.03,1183],[0.04,1265],[0.05,1373],[0.06,1505],[0.07,1549],[0.08,1516],[0.09,1499],[0.1,1484],[0.15,1570],[0.2,1591],[0.3,1618],[0.4,1624],[0.5,1662],[0.6,1599],[0.67,1467],[0.68,1293],[0.69,920.7],[0.7,537.6],[0.71,213.1],[0.72,68.07],[0.737,0]],"totImpulseNs":1093,"totalWeightG":1026,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":2045,"burnTimeS":0.69,"caseInfo":"Pro54-4G","certOrg":"Canadian Association of Rocketry","commonName":"K2045","dataFiles":2,"delays":"7,8,9,10,11,12,13,14,15,16,17","designation":"1408K2045-17A","diameter":54,"impulseClass":"K","length":404,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":2231,"motorId":"5f4294d20002310000000232","propInfo":"Vmax","propWeightG":716,"samples":[[0,0],[0.01,1165],[0.02,1855],[0.03,1907],[0.04,1947],[0.05,1945],[0.06,1970],[0.07,1995],[0.08,1999],[0.09,2018],[0.1,2035],[0.15,2042],[0.2,2139],[0.3,2184],[0.4,2165],[0.5,2149],[0.6,2155],[0.62,2121],[0.63,2107],[0.65,2092],[0.655,2039],[0.67,1508],[0.68,982.6],[0.69,481.9],[0.7,184.6],[0.72,36.15],[0.734,0]],"totImpulseNs":1408,"totalWeightG":1290,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1057,"burnTimeS":0.7,"caseInfo":"Pro54-2G","certOrg":"Canadian Association of Rocketry","commonName":"J1055","dataFiles":1,"delays":"7,8,9,10,11,12,13,14,15,16,17","designation":"747J1055-17A","diameter":54,"impulseClass":"J","length":236,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1162,"motorId":"5f4294d20002310000000233","propInfo":"Vmax","propWeightG":358,"samples":[[0,0],[0.01,412.3],[0.02,896.4],[0.03,1057],[0.04,1100],[0.05,1066],[0.06,1041],[0.07,1011],[0.08,998.7],[0.09,1028],[0.1,1051],[0.15,1086],[0.2,1102],[0.3,1118],[0.4,1110],[0.5,1104],[0.6,1113],[0.67,1046],[0.68,748.4],[0.69,382.6],[0.7,172.7],[0.71,80.38],[0.72,39.23],[0.733,0]],"totImpulseNs":746.6,"totalWeightG":772,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":80.46,"burnTimeS":1.52,"caseInfo":"38/120","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G80","dataFiles":2,"delays":"5,8,10,13,17","designation":"G80-LW","diameter":38,"impulseClass":"G","infoUrl":"https://www.lokiresearch.com/images/Documents/38mm%20White.pdf","length":127,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":129.4,"motorId":"5f4294d20002310000000234","propInfo":"Loki White","propWeightG":60,"samples":[[0,0],[0.009317,112.1],[0.4161,112.1],[0.8768,89.68],[1.5,0]],"totImpulseNs":122.5,"totalWeightG":255,"type":"reload","updatedOn":"2021-07-24"},{"availability":"regular","avgThrustN":46.2,"burnTimeS":2.76,"caseInfo":"Pro38-1G","certOrg":"Canadian Association of Rocketry","commonName":"G46","dataFiles":1,"delays":"2,4,6,8,11","designation":"127G46-11A","diameter":38,"impulseClass":"G","length":127,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":112.7,"motorId":"5f4294d20002310000000235","propInfo":"Classic","propWeightG":62.5,"samples":[[0,0],[0.01,3.945],[0.02,26.59],[0.03,61.3],[0.04,78.59],[0.05,88.04],[0.06,57.05],[0.07,48.21],[0.08,45.63],[0.09,47.68],[0.1,49.42],[0.2,58.49],[0.3,60.35],[0.4,59.36],[0.5,59.74],[0.6,57.05],[0.7,56.18],[0.8,53.83],[0.9,53.6],[1,51.78],[1.1,50.79],[1.2,47.49],[1.3,46.77],[1.4,45.9],[1.5,44.68],[1.6,45.02],[1.7,44.57],[1.8,43.28],[1.9,42.33],[2,41.95],[2.1,42.45],[2.2,40.13],[2.3,39.68],[2.4,36.41],[2.5,29.63],[2.6,13.62],[2.7,3.945],[2.76,0]],"totImpulseNs":127.3,"totalWeightG":197,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":125.1,"burnTimeS":2.15,"caseInfo":"Pro38-2G","certOrg":"Canadian Association of Rocketry","commonName":"H125","dataFiles":2,"delays":"3,5,7,9,12","designation":"266H125-12A","diameter":38,"impulseClass":"H","length":186,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":152.9,"motorId":"5f4294d20002310000000236","propInfo":"Classic","propWeightG":125,"samples":[[0,0],[0.01,1.252],[0.02,2.921],[0.03,9.635],[0.04,78.03],[0.05,128],[0.06,139.1],[0.07,98.55],[0.08,93.12],[0.09,98.02],[0.1,102.9],[0.2,128.4],[0.3,135.9],[0.4,140.3],[0.5,146],[0.6,148.6],[0.7,149.9],[0.8,150.6],[0.9,152.7],[1,154.1],[1.1,153.5],[1.2,152],[1.3,151.5],[1.4,146.8],[1.5,146],[1.6,141.4],[1.7,139.2],[1.8,133.6],[1.9,70.78],[2,18.47],[2.1,4.59],[2.15,0]],"totImpulseNs":285.6,"totalWeightG":293,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":590.5,"burnTimeS":4.059,"caseInfo":"Pro54-6G","certOrg":"Canadian Association of Rocketry","commonName":"K590","dataFiles":1,"delays":"6,7,8,9,10,11,12,13,14,15","designation":"2398K590-15A","diameter":54,"impulseClass":"K","length":572,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1498,"motorId":"5f4294d20002310000000237","propInfo":"Classic/Dual Thrust","propWeightG":1169,"samples":[[0,0],[0.01,2.69],[0.02,1589],[0.03,1588],[0.04,1812],[0.05,1717],[0.06,1666],[0.07,1487],[0.08,1465],[0.09,1411],[0.2,1419],[0.4,1393],[0.5,1374],[0.6,1354],[0.7,961.8],[0.8,514.6],[0.9,525.3],[1,526.1],[1.1,516.9],[1.2,520.3],[1.4,518],[1.6,505.3],[1.8,488.8],[2,471.1],[2.2,471.5],[2.4,481.5],[2.6,461.5],[2.8,454.9],[3,450.3],[3.3,429.2],[3.4,389.9],[3.5,315],[3.7,204.6],[3.9,118.8],[4,89.22],[4.1,68.07],[4.2,34.61],[4.301,0]],"totImpulseNs":2398,"totalWeightG":1994,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":3179,"burnTimeS":4.47,"caseInfo":"Pro98-6G","certOrg":"Canadian Association of Rocketry","commonName":"N3180","dataFiles":1,"designation":"14200N3180-P","diameter":98,"impulseClass":"N","length":1010,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":3770,"motorId":"5f4294d20002310000000238","propInfo":"Red Lightning","propWeightG":7460,"samples":[[0,0],[0.01,96.91],[0.02,72.3],[0.03,349.6],[0.04,698.4],[0.05,1353],[0.06,1866],[0.07,2431],[0.08,2995],[0.09,3257],[0.1,3388],[0.2,3461],[0.3,3453],[0.4,3468],[0.5,3476],[0.6,3479],[0.7,3484],[0.8,3528],[0.9,3534],[1,3556],[1.1,3563],[1.2,3582],[1.4,3685],[1.6,3738],[1.8,3714],[2,3660],[2.2,3594],[2.4,3513],[2.6,3376],[2.8,3309],[3,3207],[3.2,3125],[3.4,3081],[3.6,3029],[3.8,2969],[4,2960],[4.1,2753],[4.2,2027],[4.3,1133],[4.4,509.6],[4.5,154.6],[4.6,25],[4.611,0]],"totImpulseNs":14200,"totalWeightG":12200,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":122.5,"burnTimeS":1.9,"caseInfo":"Pro38-2G","certOrg":"Canadian Association of Rocketry","commonName":"H123","dataFiles":3,"delays":"5,7,9,11,14","designation":"232H123-14A","diameter":38,"impulseClass":"H","length":186,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":153.3,"motorId":"5f4294d20002310000000239","propInfo":"Skidmark","propWeightG":123,"samples":[[0,0],[0.01849,130.6],[0.03328,151.1],[0.05178,142.3],[0.06186,131.1],[0.07027,111],[0.08506,94.38],[0.1331,117.8],[0.2404,128.1],[0.3772,136.4],[0.4438,139.9],[0.5067,141.8],[0.6287,148.2],[0.7396,152.6],[0.8506,153.1],[1.028,152.1],[1.183,148.2],[1.294,142.8],[1.372,139.4],[1.431,135],[1.52,131.5],[1.616,135.3],[1.663,130.2],[1.672,95.35],[1.683,68.95],[1.709,45.48],[1.738,22.98],[1.801,11.25],[1.871,4.401],[1.938,2.746],[1.998,0]],"sparky":true,"totImpulseNs":232.4,"totalWeightG":297,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":641,"burnTimeS":1.17,"caseInfo":"38/740","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J712","dataFiles":2,"delays":"7,9,12,15","designation":"J712-LB","diameter":38,"impulseClass":"J","infoUrl":"https://www.lokiresearch.com/images/Documents/38mm%20Blue.pdf","length":406,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":1278,"motorId":"5f4294d2000231000000023a","propInfo":"Loki Blue","propWeightG":372,"samples":[[0,0],[0.01006,892.9],[0.03688,789.7],[0.399,746],[0.8013,698.4],[1.003,662.7],[1.062,172.4],[1.2,0]],"totImpulseNs":751.9,"totalWeightG":752,"type":"reload","updatedOn":"2021-07-24"},{"availability":"regular","avgThrustN":1511,"burnTimeS":2.56,"caseInfo":"76/3600","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1482","dataFiles":2,"designation":"L1482-LB","diameter":76,"impulseClass":"L","length":497,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":1813,"motorId":"5f4294d2000231000000023b","propInfo":"Loki Blue","propWeightG":1839,"samples":[[0,0],[0.007764,1345],[0.04658,1241],[0.4891,1552],[1.017,1569],[1.995,1603],[2.391,1586],[2.484,1759],[2.508,103.4],[2.6,0]],"totImpulseNs":3882,"totalWeightG":3538,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":89.28,"burnTimeS":2.56,"caseInfo":"38/240","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H90","dataFiles":2,"delays":"5,8,10,14","designation":"H90-LR","diameter":38,"impulseClass":"H","infoUrl":"https://www.lokiresearch.com/images/Documents/38mm%20Red.pdf","length":117,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":157.6,"motorId":"5f4294d2000231000000023c","propInfo":"Loki Red","propWeightG":120,"samples":[[0,0],[0.05435,146.6],[1.514,94.83],[2.197,44.83],[2.609,0]],"totImpulseNs":234.4,"totalWeightG":335,"type":"reload","updatedOn":"2021-07-24"},{"availability":"regular","avgThrustN":234.6,"burnTimeS":2.08,"caseInfo":"38/480","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I210","dataFiles":2,"delays":"5,8,10,14","designation":"I210-LR","diameter":38,"impulseClass":"I","infoUrl":"https://www.lokiresearch.com/images/Documents/38mm%20Red.pdf","length":292,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":422.8,"motorId":"5f4294d2000231000000023d","propInfo":"Loki Red","propWeightG":240,"samples":[[0,0],[0.003882,452.6],[0.0427,387.9],[1.002,271.6],[1.809,77.59],[2.3,0]],"totImpulseNs":489.8,"totalWeightG":540,"type":"reload","updatedOn":"2021-07-24"},{"availability":"OOP","avgThrustN":335,"burnTimeS":2.15,"caseInfo":"38/740","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J320","dataFiles":2,"delays":"5,8,10,14","designation":"J320-LR","diameter":38,"impulseClass":"J","infoUrl":"https://www.lokiresearch.com/images/Documents/38mm%20Red.pdf","length":406,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":550.9,"motorId":"5f4294d2000231000000023e","propInfo":"Loki Red","propWeightG":372,"samples":[[0,0],[0.01553,534],[0.1009,439.8],[1.002,377],[1.941,319.4],[2.189,78.53],[2.6,0]],"totImpulseNs":720.9,"totalWeightG":752,"type":"reload","updatedOn":"2021-07-24"},{"availability":"regular","avgThrustN":169.2,"burnTimeS":1.53,"caseInfo":"38/240","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H160","dataFiles":2,"delays":"7,9,12,15","designation":"H160-LB","diameter":38,"impulseClass":"H","infoUrl":"https://www.lokiresearch.com/images/Documents/38mm%20Blue.pdf","length":117,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":377.2,"motorId":"5f4294d2000231000000023f","propInfo":"Loki Blue","propWeightG":120,"samples":[[0,0],[0.01553,288.8],[0.5994,237.1],[1.031,107.8],[1.5,0]],"totImpulseNs":260.1,"totalWeightG":335,"type":"reload","updatedOn":"2021-07-24"},{"availability":"regular","avgThrustN":437,"burnTimeS":1.21,"caseInfo":"38/480","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I430","dataFiles":2,"delays":"7,9,12,15","designation":"I430-LB","diameter":38,"impulseClass":"I","infoUrl":"https://www.lokiresearch.com/images/Documents/38mm%20Blue.pdf","length":292,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":639.5,"motorId":"5f4294d20002310000000240","propInfo":"Loki Blue","propWeightG":240,"samples":[[0,0],[0.009317,534.5],[0.03106,448.3],[0.09627,465.5],[0.3727,456.9],[0.7484,439.7],[1.149,422.4],[1.2,0]],"totImpulseNs":532.5,"totalWeightG":540,"type":"reload","updatedOn":"2021-07-24"},{"availability":"OOP","avgThrustN":25,"burnTimeS":1.5,"caseInfo":"SU 29x76","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"E25","dataFiles":2,"delays":"4,7,P","designation":"E25","diameter":29,"impulseClass":"E","length":76,"manufacturer":"Roadrunner Rocketry","manufacturerAbbrev":"Roadrunner","maxThrustN":40,"motorId":"5f4294d20002310000000241","propInfo":"Rapid propellant","propWeightG":20.6,"samples":[[0,0],[0.001,1.16],[0.001,4.09],[0.011,13.92],[0.021,24.48],[0.026,28.33],[0.041,33.03],[0.046,33.64],[0.071,33.52],[0.121,35.29],[0.196,36.57],[0.246,38.28],[0.281,37.67],[0.316,38.66],[0.351,37.73],[0.386,37.97],[0.451,36.69],[0.561,36.57],[0.731,32.3],[0.821,29.49],[0.901,26.07],[0.921,25.82],[0.946,24.18],[0.996,22.77],[1.036,20.02],[1.081,18.56],[1.166,14.22],[1.191,13.61],[1.311,7.204],[1.396,4.274],[1.446,3.602],[1.491,2.198],[1.506,0.7936],[1.507,0]],"totImpulseNs":39,"totalWeightG":78,"type":"SU","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":3469,"burnTimeS":2.11,"caseInfo":"AMW 75-7600","certOrg":"National Association of Rocketry","commonName":"M3500","dataFiles":2,"designation":"M3500R","diameter":75,"impulseClass":"M","length":1039,"manufacturer":"Kosdon by AeroTech","manufacturerAbbrev":"KBA","maxThrustN":4076,"motorId":"5f4294d20002310000000242","propInfo":"Redline","propWeightG":4341,"samples":[[0,0],[0.106,8.867],[0.122,135.6],[0.13,670.9],[0.14,1588],[0.156,2300],[0.178,2751],[0.188,2731],[0.196,2914],[0.2,2843],[0.208,2985],[0.21,2904],[0.248,3028],[0.932,3723],[1.588,4059],[1.986,3901],[2.028,3760],[2.04,3496],[2.054,3523],[2.074,3313],[2.082,2962],[2.09,2965],[2.104,2485],[2.164,1016],[2.188,602.4],[2.198,218.8],[2.206,440.9],[2.212,274.6],[2.22,474.1],[2.222,353.7],[2.24,180.1],[2.35,0]],"totImpulseNs":7310,"totalWeightG":7173,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":815,"burnTimeS":0.9,"caseInfo":"AMW 38-640","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J740","dataFiles":1,"delays":"P","designation":"J740G","diameter":38,"impulseClass":"J","length":370,"manufacturer":"Kosdon by AeroTech","manufacturerAbbrev":"KBA","maxThrustN":956,"motorId":"5f4294d20002310000000243","propInfo":"Mojave Green","propWeightG":308,"samples":[[0,0],[0.003,84.03],[0.009,94.76],[0.015,459.5],[0.026,661.5],[0.039,740.2],[0.044,763.4],[0.054,775.9],[0.07,783.1],[0.078,792],[0.087,827.8],[0.119,856.4],[0.167,885],[0.241,902.9],[0.323,919],[0.421,919],[0.464,915.4],[0.495,911.8],[0.546,908.2],[0.568,915.4],[0.589,920.8],[0.616,938.6],[0.634,947.6],[0.649,956.5],[0.659,949.4],[0.681,913.6],[0.7,870.7],[0.715,831.4],[0.727,781.3],[0.736,693.7],[0.751,548.9],[0.765,362.9],[0.772,185.9],[0.78,286.1],[0.788,173.4],[0.793,116.2],[0.807,59],[0.828,28.61],[0.844,0]],"totImpulseNs":682,"totalWeightG":724,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":2435,"burnTimeS":1.25,"caseInfo":"AMW 54-2550","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L2300","dataFiles":2,"delays":"P","designation":"L2300G","diameter":54,"impulseClass":"L","length":728,"manufacturer":"Kosdon by AeroTech","manufacturerAbbrev":"KBA","maxThrustN":2943,"motorId":"5f4294d20002310000000244","propInfo":"Mojave Green","propWeightG":1310,"samples":[[0,0],[0.013,2930],[0.019,2243],[0.029,2277],[0.033,2500],[0.043,2480],[0.054,2534],[0.07,2505],[0.088,2471],[0.11,2451],[0.151,2447],[0.207,2480],[0.277,2534],[0.443,2654],[0.503,2717],[0.528,2741],[0.575,2795],[0.603,2824],[0.636,2843],[0.651,2916],[0.664,2891],[0.686,2872],[0.729,2858],[0.757,2833],[0.772,2795],[0.794,2780],[0.804,2853],[0.812,2790],[0.83,2722],[0.855,2630],[0.874,2577],[0.912,2509],[0.93,2519],[0.943,2461],[0.977,2355],[0.991,2224],[0.997,2355],[1.013,1886],[1.042,1426],[1.061,938],[1.074,498],[1.096,246.6],[1.117,149.9],[1.136,106.4],[1.172,48.35],[1.249,0]],"totImpulseNs":2756,"totalWeightG":2630,"type":"reload","updatedOn":"2020-01-27"},{"availability":"regular","avgThrustN":72.6,"burnTimeS":1.5,"certOrg":"National Association of Rocketry","commonName":"G79","dataFiles":1,"delays":"4,6,7,8,10","designation":"G79W/L","diameter":29,"impulseClass":"G","infoUrl":"https://nar.org/SandT/pdf/Aerotech/G79.pdf","length":124,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":93.9,"motorId":"5f4294d20002310000000245","propInfo":"White Lightning","propWeightG":65,"samples":[[0,0],[0.014,1.138],[0.018,3.213],[0.022,6.202],[0.034,27.37],[0.04,33.58],[0.044,34.85],[0.062,33.52],[0.096,39.92],[0.128,56.98],[0.138,60.09],[0.182,59.62],[0.23,68.89],[0.266,71.34],[0.3,71.62],[0.36,75.82],[0.484,79.62],[0.516,78.63],[0.678,82.11],[0.7,78.84],[0.72,78.18],[0.772,79.56],[1.054,73.72],[1.086,71.15],[1.182,68.86],[1.42,57.25],[1.52,40.76],[1.562,30.58],[1.628,11.8],[1.652,7.171],[1.68,3.96],[1.738,1.676],[1.928,0]],"totImpulseNs":108.3,"totalWeightG":124,"type":"SU","updatedOn":"2022-07-20"},{"availability":"regular","avgThrustN":80.12,"burnTimeS":1.28,"certOrg":"National Association of Rocketry","commonName":"G77","dataFiles":2,"delays":"4,6,7,8,10","designation":"G77R/L","diameter":29,"impulseClass":"G","infoUrl":"https://nar.org/SandT/pdf/Aerotech/G77.pdf","length":124,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":100.5,"motorId":"5f4294d20002310000000246","propInfo":"Redline","propWeightG":64,"samples":[[0,0],[0.01,19.12],[0.018,15.67],[0.059,66.59],[0.084,72.35],[0.122,75.11],[0.151,77.42],[0.173,77.65],[0.271,85.94],[0.337,88.02],[0.424,91.94],[0.475,93.32],[0.523,94.93],[0.57,96.31],[0.61,96.31],[0.644,99.31],[0.656,96.77],[0.728,95.62],[0.792,94.24],[0.902,91.01],[0.961,88.48],[1.017,88.02],[1.047,84.56],[1.071,81.11],[1.099,76.04],[1.127,69.36],[1.158,61.06],[1.188,44.93],[1.213,30.18],[1.231,18.2],[1.277,0]],"totImpulseNs":102.9,"totalWeightG":122.5,"type":"SU","updatedOn":"2022-07-20"},{"availability":"OOP","avgThrustN":135.9,"burnTimeS":0.62,"certOrg":"National Association of Rocketry","commonName":"G142","dataFiles":1,"delays":"6,8,10,12,14","designation":"G142T","diameter":29,"impulseClass":"G","infoUrl":"https://nar.org/SandT/pdf/Aerotech/G142.pdf","length":113,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":173.9,"motorId":"5f4294d20002310000000247","propInfo":"8222ALF","propWeightG":44,"samples":[[0,0],[0.016,4.061],[0.018,6.538],[0.02,13.44],[0.022,24.42],[0.024,43.74],[0.026,72.85],[0.028,106.9],[0.03,132],[0.032,141.5],[0.034,147.7],[0.038,154.1],[0.054,165.6],[0.076,166.3],[0.084,168.8],[0.118,172.9],[0.15,173.4],[0.224,171.8],[0.3,164.8],[0.372,156.7],[0.418,149],[0.432,145],[0.452,137.1],[0.518,96.88],[0.568,69.39],[0.576,63.16],[0.618,21.48],[0.628,13.57],[0.64,7.985],[0.652,2.922],[0.672,0.9663],[0.9,0.6876],[0.901,0]],"totImpulseNs":84.3,"totalWeightG":98,"type":"SU","updatedOn":"2022-07-20"},{"availability":"regular","avgThrustN":1833,"burnTimeS":4.5,"caseInfo":"RMS-98/10240","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1800","dataFiles":2,"delays":"P","designation":"M1800FJ","diameter":98,"impulseClass":"M","length":751,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":3956,"motorId":"5f4294d20002310000000248","propInfo":"Black Max","propWeightG":5599,"samples":[[0,0],[0.021,3007],[0.043,1965],[0.059,1858],[0.069,1766],[0.134,1830],[0.192,1823],[0.267,1823],[0.363,1865],[0.502,1936],[0.582,1922],[0.684,1965],[1.132,2071],[1.581,2149],[1.923,2199],[2.142,2220],[2.393,2220],[2.463,2199],[2.655,2107],[2.831,2007],[2.922,1979],[3.029,1915],[3.21,1809],[3.349,1695],[3.526,1589],[3.723,1440],[3.851,1397],[3.921,1362],[4.017,1255],[4.097,1121],[4.167,978.8],[4.263,780.2],[4.327,624.2],[4.402,453.9],[4.428,375.9],[4.482,276.6],[4.53,177.3],[4.583,99.3],[4.653,42.56],[4.76,21.28],[4.952,0]],"totImpulseNs":8208,"totalWeightG":9162,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":459.1,"burnTimeS":3.95,"caseInfo":"AMW 75-2500","certOrg":"National Association of Rocketry","commonName":"K500","dataFiles":2,"designation":"K500SK","diameter":75,"impulseClass":"K","length":368,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":841.3,"motorId":"5f4294d20002310000000249","propInfo":"Skidmark","propWeightG":1124,"samples":[[0,0],[0.018,194.4],[0.031,207.2],[0.036,268.5],[0.103,319.7],[0.138,322.3],[0.17,314.6],[0.67,309.5],[0.692,322.3],[0.902,319.7],[0.929,332.5],[1.263,355.5],[1.585,383.6],[1.969,411.8],[2.112,416.9],[2.272,447.6],[2.415,488.5],[2.46,485.9],[2.634,534.5],[2.83,618.9],[3.018,711],[3.143,767.3],[3.228,815.9],[3.339,841.4],[3.402,826.1],[3.504,785.2],[3.585,718.7],[3.661,631.7],[3.728,519.2],[3.772,365.7],[3.826,181.6],[3.862,99.74],[3.893,43.48],[3.946,0]],"sparky":true,"totImpulseNs":1812,"totalWeightG":2713,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":408.9,"burnTimeS":2.8,"caseInfo":"RMS-54/1280","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J401","dataFiles":2,"delays":"6,8,10,12,14","designation":"J401FJ","diameter":54,"impulseClass":"J","length":325,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":480,"motorId":"5f4294d2000231000000024a","propInfo":"Black Max","propWeightG":511,"samples":[[0,0],[0.011,440.4],[0.022,488.1],[0.075,427.8],[0.116,422.2],[0.191,446],[0.277,453],[0.382,462.9],[0.513,468.5],[0.712,472.7],[0.775,471.3],[0.948,471.3],[1.06,472.7],[1.281,469.9],[1.431,462.9],[1.607,453],[1.858,426.4],[2.034,403.9],[2.135,384.3],[2.202,378.7],[2.258,374.5],[2.277,374.5],[2.3,380.1],[2.322,380.1],[2.345,370.3],[2.367,359.1],[2.408,314.2],[2.461,244.1],[2.502,186.5],[2.566,103.8],[2.607,64.52],[2.652,42.08],[2.704,18.23],[2.783,0]],"totImpulseNs":1115,"totalWeightG":912,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":2200,"burnTimeS":2.32,"caseInfo":"RMS-75/5120","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L2200","dataFiles":2,"delays":"P","designation":"L2200G","diameter":75,"impulseClass":"L","length":681,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d2000231000000024b","propInfo":"Mojave Green","propWeightG":2518,"samples":[[0,0],[0.011,1195],[0.024,2030],[0.037,2381],[0.05,2542],[0.1,2571],[0.15,2561],[0.2,2523],[0.25,2485],[0.3,2523],[0.35,2571],[0.4,2675],[0.5,2912],[0.6,3073],[0.7,3073],[0.8,3102],[0.9,3092],[1,3092],[1.1,2959],[1.186,2808],[1.227,2438],[1.27,2258],[1.3,2163],[1.4,1992],[1.5,1878],[1.6,1793],[1.7,1688],[1.8,1613],[1.9,1584],[2,1537],[2.048,1499],[2.084,1404],[2.102,1167],[2.134,796.8],[2.186,455.3],[2.237,237.1],[2.3,94.86],[2.4,0]],"totImpulseNs":5104,"totalWeightG":4783,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1509,"burnTimeS":3.46,"caseInfo":"RMS-75/5120","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1500","dataFiles":2,"delays":"P","designation":"M1500G","diameter":75,"impulseClass":"M","length":681,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d2000231000000024c","propInfo":"Mojave Green","propWeightG":2631,"samples":[[0,0],[0.012,1184],[0.023,1614],[0.05,1695],[0.1,1717],[0.15,1695],[0.2,1604],[0.25,1517],[0.3,1491],[0.4,1474],[0.5,1485],[0.6,1512],[0.7,1534],[0.8,1571],[0.9,1609],[1,1630],[1.1,1657],[1.2,1684],[1.3,1695],[1.4,1695],[1.5,1700],[1.6,1700],[1.7,1706],[1.8,1690],[1.9,1663],[2,1657],[2.1,1609],[2.2,1582],[2.3,1555],[2.4,1523],[2.5,1491],[2.6,1464],[2.7,1431],[2.8,1415],[2.9,1388],[3,1361],[3.1,1372],[3.2,1286],[3.25,1227],[3.3,973.9],[3.4,478.9],[3.45,220.6],[3.5,80.71],[3.6,0]],"totImpulseNs":5220,"totalWeightG":4896,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":316.5,"burnTimeS":8.82,"caseInfo":"RMS-98/2560","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L339","dataFiles":3,"delays":"P","designation":"L339N","diameter":98,"impulseClass":"L","length":302,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":445.5,"motorId":"5f4294d2000231000000024d","propInfo":"Warp 9","propWeightG":1796,"samples":[[0,0],[0.049,2.884],[0.074,373.4],[0.123,399.4],[0.156,408.1],[0.279,416],[0.427,417.4],[0.476,421],[0.509,416.7],[0.632,416],[0.837,414.5],[0.894,418.9],[0.943,405.2],[1.026,400.1],[1.124,402.3],[1.255,398],[1.362,392.9],[1.51,391.5],[1.575,394.4],[1.592,385.7],[1.657,387.1],[1.838,385],[2.026,382.8],[2.174,379.9],[2.404,377.1],[2.478,378.5],[2.552,377.1],[2.617,378.5],[2.683,367],[2.773,359.8],[2.806,363.4],[2.937,359.8],[3.232,351.1],[3.314,355.4],[3.356,351.1],[3.815,345.3],[3.979,340.3],[4.233,336.7],[4.414,333.8],[4.668,330.9],[4.996,329.5],[5.39,323.7],[5.686,320.1],[5.989,314.3],[6.178,310.7],[6.325,306.4],[6.514,302.1],[6.621,302.1],[6.851,297.8],[7.195,290.5],[7.277,293.4],[7.326,287.7],[7.441,283.3],[7.49,286.2],[7.54,283.3],[7.696,275.4],[7.81,274],[7.884,276.8],[7.942,278.3],[8.015,276.1],[8.073,270.4],[8.188,155],[8.212,119],[8.278,54.07],[8.311,26.68],[8.352,7.93],[8.426,0]],"totImpulseNs":3043,"totalWeightG":3210,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1133,"burnTimeS":2.14,"caseInfo":"RMS-54/2800","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K1050","dataFiles":1,"delays":"P","designation":"K1050W","diameter":54,"impulseClass":"K","length":627,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":2172,"motorId":"5f4294d2000231000000024e","propInfo":"White Lightning","propWeightG":1265,"samples":[[0,0],[0.001,934.5],[0.051,1469],[0.101,1335],[0.151,1291],[0.251,1246],[0.751,1246],[1.251,1202],[1.501,1157],[1.651,1157],[1.751,1246],[1.901,890],[2.101,578.5],[2.201,222.5],[2.461,0]],"totImpulseNs":2426,"totalWeightG":2203,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":2550,"burnTimeS":2.5,"caseInfo":"76/6000","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M2550","dataFiles":2,"delays":"P","designation":"M2550-LB","diameter":76,"impulseClass":"M","length":785,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","motorId":"5f4294d2000231000000024f","propInfo":"Loki Blue","propWeightG":3130,"samples":[[0,0],[0.007764,2974],[0.06211,2888],[0.427,2888],[0.8618,3017],[1.498,2974],[2.12,2414],[2.453,474.1],[2.6,0]],"totImpulseNs":6502,"totalWeightG":5530,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":100,"burnTimeS":2,"caseInfo":"38/240","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H100","dataFiles":2,"delays":"5,8,10,13,17","designation":"H100-SF","diameter":38,"impulseClass":"H","infoUrl":"https://www.lokiresearch.com/images/Documents/38mm%20Spitfire.pdf","length":177,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","motorId":"5f4294d20002310000000250","propInfo":"Spitfire","propWeightG":120,"samples":[[0,0],[0.01553,127.6],[0.1514,127.6],[0.4775,139.7],[0.7415,146.6],[1.005,150],[1.137,122.4],[1.308,86.21],[1.599,39.66],[2,0]],"sparky":true,"totImpulseNs":200,"totalWeightG":335,"type":"reload","updatedOn":"2021-07-24"},{"availability":"regular","avgThrustN":34.1,"burnTimeS":1.66,"certOrg":"National Association of Rocketry","commonName":"F32","dataFiles":2,"delays":"4,6,8","designation":"F32T","diameter":24,"impulseClass":"F","infoUrl":"https://nar.org/SandT/pdf/Aerotech/F32T.pdf","length":95,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":61.3,"motorId":"5f4294d20002310000000251","propInfo":"Blue Thunder","propWeightG":31,"samples":[[0,0],[0.17,0.2367],[0.192,0.7941],[0.202,2.686],[0.204,3.571],[0.208,7.969],[0.21,11.79],[0.212,16.83],[0.22,39.23],[0.224,46.78],[0.228,51.9],[0.232,55.3],[0.236,56.96],[0.258,58.4],[0.288,55.24],[0.316,53.47],[0.394,49.59],[0.458,47.4],[0.73,41.22],[0.904,39.38],[1.11,35.67],[1.198,35.09],[1.22,33.83],[1.26,33.5],[1.478,27.38],[1.49,27.75],[1.51,25.44],[1.676,11.27],[1.768,5.947],[1.852,2.914],[1.952,0.7458],[2.064,0]],"totImpulseNs":56.9,"totalWeightG":64,"type":"SU","updatedOn":"2022-07-20"},{"availability":"OOP","avgThrustN":79.9,"burnTimeS":1.78,"caseInfo":"Kosdon 29-150","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G82","dataFiles":1,"delays":"M","designation":"G82W","diameter":29,"impulseClass":"G","length":206,"manufacturer":"Kosdon by AeroTech","manufacturerAbbrev":"KBA","maxThrustN":103.7,"motorId":"5f4294d20002310000000252","propInfo":"White Lightning","propWeightG":90,"samples":[[0,0],[0.011,50.34],[0.028,53.5],[0.055,76.3],[0.068,80.16],[0.111,74.02],[0.134,74.02],[0.216,79.46],[0.295,83.67],[0.374,89.98],[0.406,91.91],[0.431,89.63],[0.453,92.44],[0.474,93.84],[0.489,91.39],[0.519,93.31],[0.551,90.33],[0.604,91.91],[0.642,92.26],[0.728,94.37],[0.79,96.65],[0.85,98.4],[0.905,99.45],[0.954,101.7],[0.995,103],[1.025,103.8],[1.076,102.4],[1.112,102.4],[1.142,102.3],[1.174,98.58],[1.221,95.24],[1.238,93.49],[1.274,98.23],[1.287,89.63],[1.317,87.88],[1.351,85.6],[1.434,81.91],[1.479,78.58],[1.503,73.84],[1.533,65.08],[1.565,50.52],[1.594,36.84],[1.62,28.59],[1.65,21.05],[1.701,14.21],[1.737,8.946],[1.829,5.613],[1.883,4.385],[1.959,0]],"totImpulseNs":142.7,"totalWeightG":231,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":137,"burnTimeS":1.03,"caseInfo":"Kosdon 29-150","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G135","dataFiles":1,"delays":"M","designation":"G135R","diameter":29,"impulseClass":"G","length":206,"manufacturer":"Kosdon by AeroTech","manufacturerAbbrev":"KBA","maxThrustN":158.8,"motorId":"5f4294d20002310000000253","propInfo":"Redline","propWeightG":80,"samples":[[0,0],[0.011,156.9],[0.016,63.46],[0.027,98.19],[0.061,109.9],[0.094,111.1],[0.14,116.2],[0.197,127.6],[0.26,135.1],[0.316,139.2],[0.354,141.4],[0.408,147.1],[0.459,149],[0.502,153.4],[0.546,156.6],[0.6,158.2],[0.684,156],[0.743,152.8],[0.816,150],[0.875,148.1],[0.91,146.8],[0.963,151.2],[0.981,152.2],[0.993,149],[1.014,103.6],[1.02,61.25],[1.034,22.73],[1.039,7.893],[1.049,0]],"totImpulseNs":143,"totalWeightG":226,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":133,"burnTimeS":1.85,"caseInfo":"Kosdon 29-250","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H130","dataFiles":1,"delays":"M","designation":"H130W","diameter":29,"impulseClass":"H","length":291,"manufacturer":"Kosdon by AeroTech","manufacturerAbbrev":"KBA","maxThrustN":223.2,"motorId":"5f4294d20002310000000254","propInfo":"White Lightning","propWeightG":140,"samples":[[0,0],[0.016,154.8],[0.024,194.7],[0.055,224.1],[0.071,201.8],[0.078,227],[0.089,183.4],[0.123,172.1],[0.196,172.1],[0.254,176.7],[0.348,179.6],[0.426,180.9],[0.481,179.2],[0.554,178.3],[0.649,166.2],[0.672,165.3],[0.777,172.5],[0.86,172.9],[0.947,171.6],[1.038,167],[1.138,161.1],[1.185,157.4],[1.232,152.8],[1.266,143.1],[1.294,119.6],[1.326,101.1],[1.412,70.08],[1.53,46.58],[1.647,32.73],[1.674,29.38],[1.718,17.63],[1.838,12.17],[1.909,0]],"totImpulseNs":246.3,"totalWeightG":709,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":221.8,"burnTimeS":1.08,"caseInfo":"Kosdon 29-250","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H225","dataFiles":1,"delays":"M","designation":"H225R","diameter":29,"impulseClass":"H","length":291,"manufacturer":"Kosdon by AeroTech","manufacturerAbbrev":"KBA","maxThrustN":281,"motorId":"5f4294d20002310000000255","propInfo":"Redline","propWeightG":133,"samples":[[0,0],[0.025,104.6],[0.039,112.5],[0.053,123.8],[0.091,141.9],[0.104,177.3],[0.131,189.6],[0.16,196],[0.26,219.5],[0.336,229.8],[0.345,225.9],[0.385,237.7],[0.43,251.9],[0.491,260.8],[0.527,264.7],[0.562,267.2],[0.623,271.1],[0.668,268.2],[0.713,269.6],[0.742,268.2],[0.794,262.8],[0.818,262.3],[0.855,259.3],[0.891,258.8],[0.927,263.7],[0.957,272.6],[0.971,275.5],[0.982,271.6],[0.991,230.3],[1.008,185.6],[1.025,162.1],[1.055,72.69],[1.078,32.41],[1.121,0]],"totImpulseNs":241.2,"totalWeightG":316,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":525.5,"burnTimeS":1.22,"caseInfo":"Kosdon 38-640","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J520","dataFiles":1,"delays":"14","designation":"J520F","diameter":38,"impulseClass":"J","length":368,"manufacturer":"Kosdon by AeroTech","manufacturerAbbrev":"KBA","maxThrustN":683.6,"motorId":"5f4294d20002310000000256","propInfo":"Kosdon Fast","propWeightG":327,"samples":[[0,0],[0.018,696.9],[0.024,547.6],[0.031,737.1],[0.039,529.5],[0.051,524.3],[0.054,415.3],[0.063,547.6],[0.079,613.8],[0.094,543.7],[0.106,533.4],[0.127,546.3],[0.146,546.3],[0.191,548.9],[0.28,547.6],[0.379,560.6],[0.473,577.5],[0.558,591.8],[0.629,599.5],[0.689,598.2],[0.787,596.9],[0.827,593],[0.892,587.9],[0.947,574.9],[0.971,572.3],[0.997,576.2],[1.015,582.7],[1.026,582.7],[1.039,552.8],[1.069,443.8],[1.1,330.9],[1.12,275.1],[1.145,254.3],[1.161,224.5],[1.193,135],[1.209,77.86],[1.227,32.44],[1.255,0]],"totImpulseNs":645.9,"totalWeightG":722,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":776.1,"burnTimeS":1.84,"caseInfo":"Kosdon 54-1400","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K700","dataFiles":1,"delays":"14","designation":"K700F","diameter":54,"impulseClass":"K","length":406,"manufacturer":"Kosdon by AeroTech","manufacturerAbbrev":"KBA","maxThrustN":909,"motorId":"5f4294d20002310000000257","propInfo":"Kosdon Fast","propWeightG":734,"samples":[[0,0],[0.011,790],[0.029,815.1],[0.045,831.3],[0.057,754],[0.084,746.8],[0.118,741.4],[0.184,757.6],[0.422,800.8],[0.454,818.7],[0.748,872.7],[0.798,870.9],[0.853,890.7],[0.923,903.3],[1,912.3],[1.084,908.7],[1.209,897.9],[1.315,872.7],[1.395,843.9],[1.454,815.1],[1.517,786.4],[1.565,777.4],[1.587,775.6],[1.61,786.4],[1.635,754],[1.658,656.8],[1.678,543.4],[1.694,494.8],[1.71,446.3],[1.753,300.5],[1.773,208.7],[1.796,131.4],[1.814,50.38],[1.85,0]],"totImpulseNs":1434,"totalWeightG":1503,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1390,"burnTimeS":2.63,"caseInfo":"RMS-75/3840","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1390","dataFiles":2,"delays":"P","designation":"L1390G","diameter":75,"impulseClass":"L","length":530,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d20002310000000258","propInfo":"Mojave Green","propWeightG":1973,"samples":[[0,0],[0.018,906.2],[0.041,1249],[0.055,1337],[0.099,1370],[0.173,1403],[0.236,1412],[0.284,1412],[0.678,1587],[0.869,1650],[0.939,1641],[1.102,1626],[1.197,1629],[1.293,1620],[1.374,1608],[1.455,1602],[1.518,1590],[1.592,1550],[1.691,1499],[1.838,1424],[1.96,1367],[2.1,1313],[2.225,1261],[2.343,1228],[2.417,1213],[2.479,1204],[2.524,1198],[2.564,1198],[2.601,1165],[2.638,1075],[2.66,957.4],[2.689,840],[2.712,713.5],[2.737,590.1],[2.763,427.5],[2.8,295],[2.844,153.5],[2.877,69.25],[2.911,0]],"totImpulseNs":3949,"totalWeightG":3879,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":396,"burnTimeS":1.65,"caseInfo":"38/740","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J396","dataFiles":2,"delays":"5,8,10,13,17","designation":"J396-SF","diameter":38,"impulseClass":"J","infoUrl":"https://www.lokiresearch.com/images/Documents/38mm%20Spitfire.pdf","length":406,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","motorId":"5f4294d20002310000000259","propInfo":"Spitfire","propWeightG":372,"samples":[[0,0],[0.006211,396.6],[0.2019,413.8],[0.4006,439.7],[0.5932,491.4],[0.7174,543.1],[0.8012,508.6],[0.9938,491.4],[1.202,448.3],[1.401,250],[1.6,0]],"sparky":true,"totImpulseNs":650,"totalWeightG":752,"type":"reload","updatedOn":"2021-07-24"},{"availability":"regular","avgThrustN":183.3,"burnTimeS":0.69,"caseInfo":"Pro38-1G","certOrg":"Canadian Association of Rocketry","commonName":"G185","dataFiles":1,"delays":"3,5,7,9,12","designation":"128G185-12A","diameter":38,"impulseClass":"G","length":127,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":212.2,"motorId":"5f4294d2000231000000025a","propInfo":"Vmax","propWeightG":62.1,"samples":[[0,0],[0.01,108.7],[0.02,131.2],[0.05,153.1],[0.1,169],[0.2,189.9],[0.3,199.9],[0.35,203.6],[0.4,205],[0.45,202.6],[0.5,203.1],[0.55,199.3],[0.6,194.7],[0.61,194.1],[0.63,193.5],[0.64,193.7],[0.65,202.9],[0.67,163.4],[0.68,80.44],[0.69,0]],"totImpulseNs":128,"totalWeightG":188.4,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":396,"burnTimeS":0.64,"caseInfo":"Pro38-2G","certOrg":"Canadian Association of Rocketry","commonName":"H400","dataFiles":1,"delays":"4,6,8,10,13","designation":"255H400-13A","diameter":38,"impulseClass":"H","length":186,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":448,"motorId":"5f4294d2000231000000025b","propInfo":"Vmax","propWeightG":122.4,"samples":[[0,0],[0.01,222.2],[0.02,305.3],[0.03,314.5],[0.05,342.5],[0.1,382.5],[0.15,407.4],[0.2,420.8],[0.25,433.4],[0.3,439.2],[0.4,436.4],[0.5,422.7],[0.6,423.1],[0.62,364.9],[0.63,117.6],[0.64,0]],"totImpulseNs":255,"totalWeightG":283.6,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":196,"burnTimeS":2.02,"caseInfo":"Pro38-3G","certOrg":"Canadian Association of Rocketry","commonName":"I195","dataFiles":1,"delays":"7,9,11,13,16","designation":"396I195-16A","diameter":38,"impulseClass":"I","length":245,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":241.5,"motorId":"5f4294d2000231000000025c","propInfo":"Red Lightning","propWeightG":204.9,"samples":[[0,0],[0.001,10.17],[0.011,67.55],[0.021,179.7],[0.031,203.4],[0.041,206.1],[0.051,192.2],[0.061,195.7],[0.071,177.7],[0.081,181.7],[0.091,186.8],[0.101,195.7],[0.201,226.6],[0.301,235.4],[0.401,231],[0.501,231.7],[0.601,226],[0.701,222.6],[0.801,223.7],[0.901,210.6],[1.001,208.5],[1.101,205.5],[1.201,204],[1.301,196.6],[1.401,191.5],[1.501,188.6],[1.601,183.5],[1.701,186.4],[1.801,181.7],[1.901,113.7],[2.001,29.6],[2.021,0]],"totImpulseNs":369.2,"totalWeightG":417,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":566,"burnTimeS":0.65,"caseInfo":"Pro38-3G","certOrg":"Canadian Association of Rocketry","commonName":"I566","dataFiles":1,"delays":"6,8,10,12,15","designation":"370I566-15A","diameter":38,"impulseClass":"I","length":245,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":640.9,"motorId":"5f4294d2000231000000025d","propInfo":"Vmax","propWeightG":183.5,"samples":[[0,0],[0.01,396.8],[0.02,462.7],[0.04,473.2],[0.07,512.1],[0.1,537.9],[0.15,572.9],[0.2,587.7],[0.25,600.4],[0.3,609.8],[0.4,611.4],[0.5,602.6],[0.6,600.3],[0.61,607.5],[0.62,628.6],[0.63,612.2],[0.64,388.7],[0.65,0]],"totImpulseNs":370,"totalWeightG":384.2,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":805.3,"burnTimeS":0.52,"caseInfo":"Pro38-4G","certOrg":"Canadian Association of Rocketry","commonName":"I800","dataFiles":1,"delays":"6,8,10,12,15","designation":"419I800-15A","diameter":38,"impulseClass":"I","length":303,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":932.5,"motorId":"5f4294d2000231000000025e","propInfo":"Vmax","propWeightG":221,"samples":[[0,0],[0.01,276.1],[0.02,680.5],[0.05,741],[0.1,791.4],[0.2,830.9],[0.3,851.5],[0.4,853.8],[0.5,888.7],[0.51,760.6],[0.52,0]],"totImpulseNs":419.2,"totalWeightG":457,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1113,"burnTimeS":2.12,"caseInfo":"Pro75-2G","certOrg":"Canadian Association of Rocketry","commonName":"K1085","dataFiles":1,"designation":"2412K1085-P","diameter":75,"impulseClass":"K","length":350,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1204,"motorId":"5f4294d2000231000000025f","propInfo":"White Thunder","propWeightG":1199,"samples":[[0,0],[0.01,52.67],[0.02,656.8],[0.03,979.4],[0.04,1059],[0.05,983.7],[0.06,948.4],[0.07,939.6],[0.08,938.8],[0.09,957.2],[0.1,950.2],[0.2,1003],[0.3,1046],[0.4,1069],[0.5,1085],[0.6,1104],[0.7,1139],[0.8,1149],[0.9,1161],[1,1174],[1.1,1162],[1.2,1149],[1.3,1138],[1.4,1123],[1.5,1113],[1.6,1087],[1.7,1072],[1.8,1052],[1.9,1044],[2,1032],[2.02,1036],[2.04,1034],[2.06,1037],[2.1,1025],[2.12,1026],[2.2,663.9],[2.22,422.1],[2.25,136.6],[2.27,40.83],[2.281,0]],"totImpulseNs":2412,"totalWeightG":2430,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1194,"burnTimeS":1.69,"caseInfo":"Pro54-5G","certOrg":"Canadian Association of Rocketry","commonName":"K1200","dataFiles":1,"delays":"6,7,8,9,10,11,12,13,14,15,16","designation":"2014K1200-16A","diameter":54,"impulseClass":"K","length":404,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1364,"motorId":"5f4294d20002310000000260","propInfo":"White Thunder","propWeightG":960,"samples":[[0,0],[0.01,492.3],[0.02,1369],[0.05,1236],[0.1,1279],[0.2,1311],[0.3,1320],[0.4,1331],[0.5,1325],[0.7,1323],[0.8,1304],[0.9,1281],[1,1250],[1.1,1218],[1.2,1199],[1.3,1159],[1.4,1113],[1.5,1100],[1.55,941.8],[1.6,726.1],[1.62,559.2],[1.64,399.9],[1.66,317.7],[1.67,247.3],[1.68,198.1],[1.69,67.3],[1.7,0]],"totImpulseNs":2014,"totalWeightG":1632,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1437,"burnTimeS":1.65,"caseInfo":"Pro54-6G","certOrg":"Canadian Association of Rocketry","commonName":"K1440","dataFiles":2,"delays":"7,8,9,10,11,12,13,14,15,16,17","designation":"2372K1440-17A","diameter":54,"impulseClass":"K","length":572,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1829,"motorId":"5f4294d20002310000000261","propInfo":"White Thunder","propWeightG":1129,"samples":[[0,0],[0.01,1062],[0.01,2168],[0.02,2036],[0.07,1692],[0.1,1805],[0.2,1747],[0.3,1722],[0.4,1712],[0.5,1709],[0.6,1682],[0.7,1679],[0.8,1638],[0.9,1601],[1.01,1540],[1.11,1463],[1.21,1398],[1.3,1111],[1.4,1040],[1.45,922.2],[1.5,701.1],[1.55,556.5],[1.6,272.7],[1.65,66.53],[1.66,0]],"totImpulseNs":2372,"totalWeightG":1893,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1771,"burnTimeS":2,"caseInfo":"Pro75-3G","certOrg":"Canadian Association of Rocketry","commonName":"L1720","dataFiles":1,"designation":"3660L1720-P","diameter":75,"impulseClass":"L","length":486,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1946,"motorId":"5f4294d20002310000000262","propInfo":"White Thunder","propWeightG":1755,"samples":[[0,0],[0.01,25.46],[0.02,1041],[0.03,1841],[0.04,1947],[0.05,1836],[0.06,1754],[0.07,1728],[0.08,1668],[0.09,1618],[0.1,1597],[0.2,1741],[0.3,1728],[0.4,1770],[0.5,1826],[0.6,1864],[0.7,1903],[0.8,1931],[0.9,1926],[1,1917],[1.1,1873],[1.2,1830],[1.3,1836],[1.4,1806],[1.5,1788],[1.6,1756],[1.7,1727],[1.8,1695],[1.9,1698],[2,1727],[2.02,1739],[2.04,1641],[2.05,1504],[2.08,557.2],[2.1,179.2],[2.12,84.93],[2.129,0]],"totImpulseNs":3660,"totalWeightG":3341,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":2451,"burnTimeS":1.9,"caseInfo":"Pro75-4G","certOrg":"Canadian Association of Rocketry","commonName":"L2375","dataFiles":2,"designation":"4864L2375-P","diameter":75,"impulseClass":"L","length":621,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":2798,"motorId":"5f4294d20002310000000263","propInfo":"White Thunder","propWeightG":2322,"samples":[[0,0],[0.01,18.15],[0.02,1195],[0.03,2264],[0.04,2354],[0.05,2301],[0.06,2230],[0.07,2219],[0.08,2194],[0.09,2195],[0.1,2221],[0.2,2464],[0.3,2416],[0.4,2459],[0.5,2482],[0.6,2557],[0.7,2560],[0.8,2589],[0.9,2608],[1,2600],[1.1,2567],[1.2,2552],[1.3,2513],[1.4,2465],[1.5,2407],[1.6,2366],[1.7,2339],[1.8,2323],[1.9,2311],[1.95,2285],[1.97,2113],[2,1550],[2.02,1116],[2.04,591.8],[2.05,408],[2.06,243.7],[2.08,103.3],[2.1,38.56],[2.108,0]],"totImpulseNs":4864,"totalWeightG":4161,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":231.8,"burnTimeS":4.08,"certOrg":"National Association of Rocketry","commonName":"J230","dataFiles":2,"designation":"J230SK-P","diameter":54,"impulseClass":"J","infoUrl":"http://www.nar.org/SandT/pdf/Animal/J230SK.pdf","length":326,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":276.7,"motorId":"5f4294d20002310000000264","propWeightG":525.7,"samples":[[0,0],[0.026,147],[0.039,214.2],[0.076,239.4],[0.161,247.8],[0.306,247.7],[0.488,249.7],[0.754,260.1],[0.948,268.4],[1.227,274.6],[1.59,276.7],[1.905,270.1],[2.195,267.9],[2.498,259.4],[2.643,253],[2.824,248.8],[3.115,242.3],[3.369,229.7],[3.478,221.1],[3.55,204.3],[3.61,170.7],[3.658,126.5],[3.718,82.44],[3.79,61.42],[3.899,40.37],[3.983,17.23],[4.08,0]],"sparky":true,"totImpulseNs":945.9,"totalWeightG":1169,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":326.1,"burnTimeS":3.37,"caseInfo":"AMW 54-1050","certOrg":"Canadian Association of Rocketry","commonName":"J325","dataFiles":1,"delays":"P","designation":"1099J325-P","diameter":54,"impulseClass":"J","length":326,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":540.3,"motorId":"5f4294d20002310000000265","propInfo":"Tamed Tiger","propWeightG":537,"samples":[[0,0],[0.013,334.7],[0.034,534.2],[0.046,523.5],[0.072,540.7],[0.084,474.1],[0.156,474.1],[0.215,474.1],[0.342,463.4],[0.519,454.8],[1.004,414.1],[1.286,392.6],[1.78,328.3],[2.222,274.6],[2.458,251],[2.555,240.3],[2.606,233.9],[2.766,216.7],[2.863,206],[2.922,199.5],[2.964,188.8],[3.011,173.8],[3.057,150.2],[3.104,124.4],[3.15,98.69],[3.243,57.93],[3.289,34.33],[3.369,0]],"totImpulseNs":1099,"totalWeightG":1230,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":392.5,"burnTimeS":2.74,"caseInfo":"AMW 54-1050","certOrg":"Canadian Association of Rocketry","commonName":"J395","dataFiles":1,"delays":"P","designation":"1079J395-P","diameter":54,"impulseClass":"J","length":326,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":470.2,"motorId":"5f4294d20002310000000266","propInfo":"Red Rhino","propWeightG":573,"samples":[[0,0],[0.032,336.1],[0.036,390.5],[0.068,417.6],[0.079,420.1],[0.093,417.6],[0.108,412.7],[0.172,432.5],[0.219,447.3],[0.265,454.7],[0.308,459.6],[0.391,462.1],[0.441,467.1],[0.484,459.6],[0.527,462.1],[0.606,459.6],[0.753,454.7],[1.025,437.4],[1.215,422.6],[1.247,432.5],[1.298,432.5],[1.376,425.1],[1.566,417.6],[1.706,417.6],[1.753,417.6],[1.771,412.7],[1.814,412.7],[1.882,397.9],[1.9,402.8],[1.928,397.9],[1.961,397.9],[1.989,392.9],[2.04,392.9],[2.075,390.5],[2.129,397.9],[2.151,385.5],[2.179,375.6],[2.215,365.7],[2.244,378.1],[2.262,373.2],[2.29,368.2],[2.319,363.3],[2.366,353.4],[2.394,358.3],[2.416,350.9],[2.43,343.5],[2.452,326.2],[2.484,313.8],[2.556,227.4],[2.624,135.9],[2.76,0]],"totImpulseNs":1079,"totalWeightG":1268,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":403.6,"burnTimeS":2.42,"caseInfo":"AMW 54-1050","certOrg":"Canadian Association of Rocketry","commonName":"J400","dataFiles":1,"designation":"977J400-P","diameter":54,"impulseClass":"J","length":326,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":499.4,"motorId":"5f4294d20002310000000267","propInfo":"Black Bear","propWeightG":723,"samples":[[0,0],[0.018,298.4],[0.025,343.2],[0.033,381.1],[0.048,364.3],[0.058,397.9],[0.071,364.3],[0.084,386.7],[0.099,365.7],[0.106,390.9],[0.119,334.8],[0.137,353.1],[0.218,368.5],[0.316,385.3],[0.428,402.1],[0.562,417.5],[0.709,431.5],[0.77,437.1],[0.886,451.1],[0.975,455.3],[1.033,456.7],[1.122,462.3],[1.21,469.3],[1.284,470.7],[1.365,480.5],[1.428,473.5],[1.504,469.3],[1.577,466.5],[1.658,455.3],[1.798,435.7],[1.909,404.9],[1.998,381.1],[2.069,361.5],[2.109,351.7],[2.124,336.2],[2.15,341.8],[2.182,348.9],[2.188,355.9],[2.205,340.4],[2.233,320.8],[2.286,243.8],[2.319,197.5],[2.355,138.7],[2.408,65.85],[2.458,0]],"totImpulseNs":976.9,"totalWeightG":1382,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":476,"burnTimeS":2.15,"caseInfo":"AMW 54-1050","certOrg":"Canadian Association of Rocketry","commonName":"J475","dataFiles":1,"delays":"P","designation":"1025J475-P","diameter":54,"impulseClass":"J","length":326,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":597.7,"motorId":"5f4294d20002310000000268","propInfo":"Black Bear","propWeightG":723,"samples":[[0,0],[0.008,250.2],[0.032,402.1],[0.037,458.7],[0.045,449.8],[0.056,464.7],[0.077,458.7],[0.08,464.7],[0.099,455.7],[0.117,455.7],[0.128,449.8],[0.141,455.7],[0.155,443.8],[0.165,455.7],[0.197,464.7],[0.232,473.6],[0.256,482.6],[0.261,491.5],[0.267,482.6],[0.299,494.5],[0.36,515.3],[0.459,536.2],[0.594,566],[0.714,580.9],[0.826,598.7],[0.93,607.7],[1.005,613.6],[1.074,607.7],[1.112,601.7],[1.176,598.7],[1.25,589.8],[1.304,574.9],[1.32,580.9],[1.333,574.9],[1.368,568.9],[1.466,533.2],[1.568,491.5],[1.65,455.7],[1.703,428.9],[1.741,402.1],[1.765,399.1],[1.802,387.2],[1.818,390.2],[1.826,387.2],[1.845,387.2],[1.869,390.2],[1.879,387.2],[1.901,375.3],[1.906,354.5],[1.938,294.9],[1.981,214.5],[2.015,148.9],[2.061,83.4],[2.101,17.87],[2.117,0]],"totImpulseNs":1025,"totalWeightG":1410,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":742.8,"burnTimeS":1.61,"caseInfo":"AMW 54-1050","certOrg":"Canadian Association of Rocketry","commonName":"J745","dataFiles":1,"delays":"P","designation":"1196J745-P","diameter":54,"impulseClass":"J","length":326,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":864.2,"motorId":"5f4294d20002310000000269","propInfo":"Wild Wolf","propWeightG":549,"samples":[[0,0],[0.016,666.5],[0.019,715.3],[0.029,744.8],[0.04,746.3],[0.053,768.5],[0.063,778.8],[0.075,812.8],[0.087,823.1],[0.112,839.4],[0.127,835],[0.144,846.8],[0.156,846.8],[0.173,848.3],[0.205,848.3],[0.213,848.3],[0.221,858.6],[0.242,858.6],[0.269,860.1],[0.279,863],[0.3,860.1],[0.322,864.5],[0.34,861.6],[0.348,858.6],[0.362,861.6],[0.385,860.1],[0.414,858.6],[0.443,855.7],[0.459,861.6],[0.47,858.6],[0.478,861.6],[0.489,855.7],[0.528,849.7],[0.55,855.7],[0.585,848.3],[0.619,849.7],[0.637,846.8],[0.661,846.8],[0.736,835],[0.826,817.2],[0.92,795.1],[1.057,755.2],[1.156,722.7],[1.228,707.9],[1.305,693.1],[1.347,679.8],[1.392,666.5],[1.416,666.5],[1.426,666.5],[1.448,666.5],[1.477,666.5],[1.48,665],[1.485,634],[1.493,561.6],[1.515,366.5],[1.533,257.1],[1.555,162.6],[1.583,81.28],[1.61,0]],"totImpulseNs":1196,"totalWeightG":1220,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":1365,"burnTimeS":0.68,"caseInfo":"AMW 54-1050","certOrg":"Canadian Association of Rocketry","commonName":"J1365","dataFiles":1,"delays":"P","designation":"932J1365-P","diameter":54,"impulseClass":"J","length":326,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":1568,"motorId":"5f4294d2000231000000026a","propInfo":"Scalded Tiger","propWeightG":444,"samples":[[0,0],[0.007,1577],[0.011,1084],[0.014,1402],[0.019,1084],[0.023,1402],[0.027,1197],[0.03,1267],[0.049,1312],[0.078,1380],[0.124,1447],[0.164,1484],[0.219,1515],[0.267,1523],[0.311,1532],[0.361,1526],[0.391,1506],[0.455,1447],[0.489,1419],[0.526,1394],[0.564,1371],[0.595,1354],[0.612,1343],[0.62,1334],[0.624,1301],[0.633,1185],[0.643,881.2],[0.649,661.6],[0.655,458.9],[0.663,290],[0.676,135.1],[0.687,0]],"totImpulseNs":932.4,"totalWeightG":1119,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":457.1,"burnTimeS":3.24,"caseInfo":"AMW 54-1400","certOrg":"Canadian Association of Rocketry","commonName":"K455","dataFiles":1,"delays":"P","designation":"1483K455-P","diameter":54,"impulseClass":"K","length":403,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":787.1,"motorId":"5f4294d2000231000000026b","propInfo":"Tamed Tiger","propWeightG":716,"samples":[[0,0],[0.021,715.7],[0.035,789],[0.052,735.9],[0.069,689.9],[0.09,684.1],[0.114,681.2],[0.138,691.3],[0.19,682.7],[0.345,664],[0.528,645.3],[0.583,641],[0.735,625.2],[0.835,616.6],[0.983,589.3],[1.163,567.7],[1.304,544.7],[1.598,493],[1.663,480],[1.932,434],[1.984,426.9],[2.019,426.9],[2.077,408.2],[2.119,405.3],[2.157,399.5],[2.205,388.1],[2.232,386.6],[2.315,369.4],[2.364,363.6],[2.398,360.7],[2.433,346.4],[2.481,340.6],[2.522,333.4],[2.636,306.1],[2.705,286],[2.753,267.3],[2.802,240],[2.85,207],[2.916,159.5],[3.012,106.4],[3.081,79.05],[3.164,40.24],[3.24,0]],"totImpulseNs":1483,"totalWeightG":1504,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":532.6,"burnTimeS":2.71,"caseInfo":"AMW 54-1400","certOrg":"Canadian Association of Rocketry","commonName":"K535","dataFiles":1,"delays":"P","designation":"1422K535-P","diameter":54,"impulseClass":"K","length":403,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":633.6,"motorId":"5f4294d2000231000000026c","propInfo":"Red Rhino","propWeightG":764,"samples":[[0,0],[0.023,447.7],[0.04,534.4],[0.049,547.4],[0.078,569],[0.092,564.7],[0.116,553.1],[0.139,574.8],[0.173,589.2],[0.199,606.6],[0.222,605.1],[0.246,616.7],[0.277,619.6],[0.298,625.4],[0.318,621],[0.35,623.9],[0.378,626.8],[0.402,623.9],[0.439,626.8],[0.462,628.2],[0.517,623.9],[0.572,623.9],[0.592,629.7],[0.612,622.5],[0.647,625.4],[0.691,618.1],[0.722,613.8],[0.743,621],[0.771,621],[0.826,613.8],[0.861,608],[0.919,602.2],[0.988,603.7],[1.034,596.5],[1.101,599.4],[1.147,584.9],[1.19,583.5],[1.219,586.4],[1.265,576.2],[1.326,576.2],[1.346,570.5],[1.375,569],[1.416,566.1],[1.485,571.9],[1.531,567.6],[1.56,550.3],[1.58,557.5],[1.673,547.4],[1.725,554.6],[1.754,547.4],[1.783,540.1],[1.811,543],[1.936,532.9],[2.109,519.9],[2.184,511.3],[2.236,502.6],[2.262,501.1],[2.288,502.6],[2.317,491],[2.355,467.9],[2.395,447.7],[2.444,407.3],[2.473,382.7],[2.511,322.1],[2.542,252.7],[2.574,195],[2.612,125.6],[2.652,70.77],[2.71,0]],"totImpulseNs":1442,"totalWeightG":1559,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":664.1,"burnTimeS":2.06,"caseInfo":"AMW 54-1400","certOrg":"Canadian Association of Rocketry","commonName":"K665","dataFiles":1,"delays":"P","designation":"1379K665-P","diameter":54,"impulseClass":"K","length":403,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":830.1,"motorId":"5f4294d2000231000000026d","propInfo":"Black Bear","propWeightG":964,"samples":[[0,0],[0.011,429.8],[0.036,591.3],[0.042,620],[0.063,636.4],[0.076,636.4],[0.097,624.1],[0.109,624.1],[0.137,635.1],[0.21,658.3],[0.341,695.3],[0.413,724],[0.497,740.5],[0.714,781.5],[0.825,803.4],[0.937,810.3],[0.972,818.5],[1.029,819.8],[1.101,817.1],[1.16,808.9],[1.273,773.3],[1.337,755.5],[1.396,729.5],[1.469,689.8],[1.551,636.4],[1.625,589.9],[1.694,548.8],[1.745,521.5],[1.77,509.1],[1.791,509.1],[1.806,506.4],[1.829,494.1],[1.863,446.2],[1.89,396.9],[1.913,342.2],[1.928,290.2],[1.947,231.3],[1.972,164.2],[1.985,131.4],[2.006,95.81],[2.027,61.59],[2.046,0]],"totImpulseNs":1379,"totalWeightG":1737,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":672.4,"burnTimeS":2.68,"caseInfo":"AMW 54-1750","certOrg":"Canadian Association of Rocketry","commonName":"K670","dataFiles":1,"delays":"P","designation":"1806K670-P","diameter":54,"impulseClass":"K","length":491,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":820.7,"motorId":"5f4294d2000231000000026e","propInfo":"Red Rhino","propWeightG":955,"samples":[[0,0],[0.033,610.4],[0.052,752.1],[0.06,776],[0.076,785.8],[0.098,813.9],[0.109,822.3],[0.133,818.1],[0.166,825.1],[0.185,820.9],[0.21,813.9],[0.226,825.1],[0.253,818.1],[0.286,820.9],[0.321,818.1],[0.457,809.7],[0.593,805.5],[0.688,802.6],[0.729,791.4],[0.803,792.8],[0.86,780.2],[0.925,778.8],[0.988,770.4],[1.061,760.5],[1.116,759.1],[1.176,752.1],[1.271,735.3],[1.309,738.1],[1.344,735.3],[1.363,731.1],[1.41,735.3],[1.448,735.3],[1.494,731.1],[1.524,735.3],[1.557,731.1],[1.616,721.3],[1.654,714.2],[1.682,721.3],[1.728,705.8],[1.766,705.8],[1.799,705.8],[1.826,698.8],[1.856,690.4],[1.889,687.6],[1.921,689],[1.946,684.8],[1.976,684.8],[2,675],[2.014,682],[2.049,669.3],[2.063,659.5],[2.106,649.7],[2.136,651.1],[2.163,655.3],[2.177,648.3],[2.199,651.1],[2.212,646.9],[2.22,638.5],[2.248,617.4],[2.267,600.6],[2.283,599.2],[2.316,568.3],[2.359,516.4],[2.384,464.5],[2.4,425.2],[2.444,327],[2.474,259.6],[2.52,171.2],[2.563,112.3],[2.61,63.15],[2.645,0]],"totImpulseNs":1806,"totalWeightG":1885,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":700.1,"burnTimeS":2.37,"caseInfo":"AMW 54-1750","certOrg":"Canadian Association of Rocketry","commonName":"K700","dataFiles":1,"designation":"1660K700-P","diameter":54,"impulseClass":"K","length":491,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":867.1,"motorId":"5f4294d2000231000000026f","propInfo":"Black Bear","propWeightG":1205,"samples":[[0,0],[0.015,605.7],[0.02,693.8],[0.037,714.8],[0.056,744.2],[0.073,712],[0.1,695.2],[0.132,685.4],[0.157,691],[0.235,710.6],[0.333,731.6],[0.428,749.8],[0.531,762.4],[0.617,774.9],[0.69,781.9],[0.764,790.3],[0.876,802.9],[0.957,812.7],[1.023,819.7],[1.084,826.7],[1.192,832.3],[1.246,840.7],[1.307,833.7],[1.393,826.7],[1.444,821.1],[1.508,811.3],[1.574,794.5],[1.633,776.3],[1.713,744.2],[1.777,709.2],[1.853,668.6],[1.916,640.7],[1.956,615.5],[2.012,602.9],[2.044,588.9],[2.083,553.9],[2.115,519],[2.146,484],[2.169,463],[2.186,426.6],[2.222,328.7],[2.249,253.2],[2.279,179],[2.306,123.1],[2.352,58.75],[2.379,0]],"totImpulseNs":1660,"totalWeightG":2088,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":854.1,"burnTimeS":2.02,"caseInfo":"AMW 54-1750","certOrg":"Canadian Association of Rocketry","commonName":"K855","dataFiles":1,"delays":"P","designation":"1725K855-P","diameter":54,"impulseClass":"K","length":491,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":1035,"motorId":"5f4294d20002310000000270","propInfo":"Black Bear","propWeightG":1205,"samples":[[0,0],[0.008,864],[0.023,756.8],[0.027,899.7],[0.042,857.7],[0.046,916.6],[0.058,880.8],[0.073,868.2],[0.088,851.4],[0.098,855.6],[0.123,872.4],[0.177,889.2],[0.281,920.8],[0.402,943.9],[0.494,962.8],[0.559,973.3],[0.636,985.9],[0.711,990.1],[0.784,1003],[0.859,1011],[0.932,1013],[1.017,1022],[1.08,1011],[1.136,1001],[1.246,977.5],[1.303,967],[1.374,935.5],[1.455,891.3],[1.505,855.6],[1.584,798.8],[1.64,750.5],[1.688,727.4],[1.726,714.7],[1.745,712.6],[1.757,689.5],[1.782,668.5],[1.826,626.5],[1.845,590.7],[1.87,498.2],[1.901,353.2],[1.928,239.6],[1.951,159.8],[1.972,100.9],[1.997,69.37],[2.018,0]],"totImpulseNs":1725,"totalWeightG":2121,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":1722,"burnTimeS":0.68,"caseInfo":"AMW 54-1400","certOrg":"Canadian Association of Rocketry","commonName":"K1720","dataFiles":1,"designation":"1176K1720-P","diameter":54,"impulseClass":"K","length":403,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":2007,"motorId":"5f4294d20002310000000271","propInfo":"Scalded Tiger","propWeightG":592,"samples":[[0,0],[0.007,1806],[0.011,1608],[0.016,1702],[0.02,1514],[0.024,1744],[0.029,1542],[0.032,1751],[0.039,1598],[0.042,1737],[0.047,1692],[0.05,1747],[0.054,1716],[0.058,1737],[0.065,1772],[0.072,1765],[0.081,1824],[0.09,1827],[0.115,1859],[0.137,1880],[0.144,1869],[0.148,1824],[0.15,1845],[0.17,1866],[0.201,1886],[0.234,1911],[0.276,1918],[0.312,1928],[0.345,1921],[0.384,1914],[0.426,1886],[0.487,1827],[0.526,1793],[0.555,1758],[0.575,1751],[0.593,1737],[0.604,1737],[0.615,1726],[0.621,1702],[0.624,1650],[0.628,1591],[0.631,1549],[0.643,964.1],[0.655,518.6],[0.666,268],[0.674,181],[0.684,0]],"totImpulseNs":1176,"totalWeightG":1351,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":986.2,"burnTimeS":2.7,"caseInfo":"AMW 54-2550","certOrg":"Canadian Association of Rocketry","commonName":"L985","dataFiles":1,"delays":"P","designation":"2665L985-P","diameter":54,"impulseClass":"L","length":728,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":1541,"motorId":"5f4294d20002310000000272","propInfo":"Tamed Tiger","propWeightG":1295,"samples":[[0,0],[0.017,1484],[0.033,1394],[0.061,1316],[0.081,1251],[0.103,1290],[0.134,1307],[0.17,1310],[0.27,1288],[0.396,1271],[0.485,1262],[0.56,1231],[0.618,1254],[0.699,1243],[0.827,1220],[1.087,1178],[1.273,1159],[1.443,1136],[1.619,1119],[1.755,1097],[1.83,1091],[1.878,1086],[1.917,1083],[1.942,1060],[1.972,1021],[2.034,906.1],[2.07,813.5],[2.12,701.3],[2.162,634],[2.195,594.7],[2.246,530.2],[2.298,451.6],[2.34,395.5],[2.407,328.2],[2.454,272.1],[2.53,210.4],[2.56,187.9],[2.602,162.7],[2.649,115],[2.688,0]],"totImpulseNs":2665,"totalWeightG":2572,"type":"reload","updatedOn":"2021-06-13"},{"availability":"OOP","avgThrustN":225,"burnTimeS":1.2,"caseInfo":"38/390","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H225","dataFiles":1,"designation":"H225BL","diameter":38,"impulseClass":"H","length":249,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":240.3,"motorId":"5f4294d20002310000000273","propInfo":"Black Lightning","propWeightG":173,"samples":[[0,0],[0.01507,113.8],[0.03264,193.1],[0.04896,172.4],[0.167,256.9],[0.3101,296.5],[0.5122,303.4],[0.6177,305.2],[0.8387,298.3],[0.8989,291.4],[0.98,266.9],[1.02,244.7],[1.05,222.4],[1.263,10.34],[1.3,0]],"sparky":true,"totImpulseNs":226,"totalWeightG":466,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":235,"burnTimeS":1.4,"caseInfo":"38/390","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I223","dataFiles":1,"designation":"I223GT","diameter":38,"impulseClass":"I","length":249,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":240.3,"motorId":"5f4294d20002310000000274","propInfo":"Green Tornado","propWeightG":181,"samples":[[0,0],[0.02,170],[0.05,190],[0.141,225],[0.4623,255],[0.6817,258],[0.8874,260],[1.148,255],[1.324,224.1],[1.405,129.3],[1.48,0]],"totImpulseNs":327.9,"totalWeightG":466,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":186,"burnTimeS":1.69,"caseInfo":"38/390","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H186","dataFiles":1,"designation":"H186RT","diameter":38,"impulseClass":"H","length":249,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":220.3,"motorId":"5f4294d20002310000000275","propInfo":"Red Twister","propWeightG":178,"samples":[[0,0],[0.008,40.18],[0.042,133.6],[0.058,178],[0.1,196.9],[0.192,204],[0.483,215],[0.842,220.3],[1.075,219],[1.267,219],[1.35,207],[1.42,165],[1.48,118.9],[1.542,75],[1.69,0]],"totImpulseNs":312.1,"totalWeightG":472,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":389,"burnTimeS":1.42,"caseInfo":"38/640","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I389","dataFiles":1,"designation":"I389GT","diameter":38,"impulseClass":"I","length":370,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":454.9,"motorId":"5f4294d20002310000000276","propInfo":"Green Tornado","propWeightG":303,"samples":[[0,0],[0.016,182],[0.025,277.1],[0.045,379.7],[0.065,413.4],[0.366,450],[0.683,454.9],[1.066,443.3],[1.144,421],[1.183,385],[1.241,280.8],[1.35,92.87],[1.42,0]],"totImpulseNs":553.1,"totalWeightG":693,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":324,"burnTimeS":1.65,"caseInfo":"38/640","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I324","dataFiles":1,"designation":"I324RT","diameter":38,"impulseClass":"I","length":370,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":369.2,"motorId":"5f4294d20002310000000277","propInfo":"Red Twister","propWeightG":299,"samples":[[0,0],[0.015,238.5],[0.09,310],[0.25,360],[0.65,365],[1.068,369.2],[1.256,365],[1.35,340],[1.487,195.4],[1.65,0]],"totImpulseNs":526.5,"totalWeightG":688,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":395,"burnTimeS":2.59,"caseInfo":"54/1050","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J395","dataFiles":1,"designation":"J395RT","diameter":54,"impulseClass":"J","length":326,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":460.2,"motorId":"5f4294d20002310000000278","propInfo":"Red Twister","propWeightG":524,"samples":[[0,0],[0.06,267],[0.1,333.8],[0.16,356],[0.21,360.4],[0.33,387.1],[1,460.2],[1.5,453.9],[2.2,409.4],[2.4,360.4],[2.48,267],[2.57,44.5],[2.59,0]],"totImpulseNs":1026,"totalWeightG":1160,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":520,"burnTimeS":2.61,"caseInfo":"54/1400","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K520","dataFiles":1,"designation":"K520RT","diameter":54,"impulseClass":"K","length":401,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":593.1,"motorId":"5f4294d20002310000000279","propInfo":"Red Twister","propWeightG":698,"samples":[[0,0],[0.05,400.5],[0.07,471.7],[0.16,502.9],[0.23,498.4],[0.35,529.5],[0.87,593.1],[1.2,605.2],[1.55,578.5],[1.85,569.6],[2.32,511.8],[2.45,387.1],[2.58,26.7],[2.61,0]],"totImpulseNs":1356,"totalWeightG":1442,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":700,"burnTimeS":2.41,"caseInfo":"54/1750","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K700","dataFiles":1,"designation":"K700RT","diameter":54,"impulseClass":"K","length":492,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":788.2,"motorId":"5f4294d2000231000000027a","propInfo":"Red Twister","propWeightG":856,"samples":[[0,0],[0.12,534],[0.18,658.6],[0.2,725.4],[0.24,747.6],[0.28,747.6],[0.4,783.2],[0.65,788.2],[1,787.6],[1.65,769.9],[2,729.8],[2.1,712],[2.2,645.3],[2.38,115.7],[2.41,0]],"totImpulseNs":1691,"totalWeightG":1716,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1185,"burnTimeS":2.1,"caseInfo":"54/2550","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K1185","dataFiles":1,"designation":"K1185GT","diameter":54,"impulseClass":"K","length":728,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":1380,"motorId":"5f4294d2000231000000027b","propInfo":"Green Tornado","propWeightG":1314,"samples":[[0,0],[0.01,575],[0.06,810],[0.12,1050],[0.17,1175],[0.68,1345],[0.82,1366],[0.92,1379],[1.65,1291],[1.8,1268],[1.85,1224],[1.87,1068],[1.92,801],[2.05,222.5],[2.1,0]],"totImpulseNs":2460,"totalWeightG":2541,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":985,"burnTimeS":3.6,"caseInfo":"75/3500","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L985","dataFiles":1,"designation":"L985GT","diameter":75,"impulseClass":"L","length":498,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":1202,"motorId":"5f4294d2000231000000027c","propInfo":"Green Tornado","propWeightG":1875,"samples":[[0,0],[0.2,725],[0.3,795.5],[0.75,950],[1.5,1120],[2,1120],[3.4,1113],[3.6,0]],"totImpulseNs":3580,"totalWeightG":3632,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":789,"burnTimeS":4.17,"caseInfo":"75/3500","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L789","dataFiles":1,"designation":"L789RT","diameter":75,"impulseClass":"L","length":497,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":996.3,"motorId":"5f4294d2000231000000027d","propInfo":"Red Twister","propWeightG":1796,"samples":[[0,0],[0.05,600],[0.1,650],[0.2,712],[0.7542,850],[1.5,900],[2,906],[3.413,867.8],[3.55,833.3],[3.928,344.8],[4.17,0]],"totImpulseNs":3252,"totalWeightG":3378,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1079,"burnTimeS":13.05,"caseInfo":"RMS-98/15360","certOrg":"National Association of Rocketry","commonName":"N1000","dataFiles":1,"delays":"P","designation":"N1000W","diameter":98,"impulseClass":"N","infoUrl":"http://www.nar.org/SandT/pdf/Aerotech/N1000W.pdf","length":1046,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":2262,"motorId":"5f4294d2000231000000027e","propInfo":"White Lightning","propWeightG":8293,"samples":[[0,0],[0.01,40.21],[0.012,148.4],[0.016,598.9],[0.02,890.1],[0.024,995.1],[0.026,1158],[0.03,1342],[0.038,1557],[0.07,1960],[0.082,2051],[0.102,2111],[0.156,2120],[0.204,2073],[0.318,2091],[0.376,1990],[0.43,1826],[0.496,1734],[0.63,1658],[0.74,1702],[0.762,1633],[0.814,1670],[1.632,1594],[1.672,1551],[3.048,1533],[5.302,1379],[6.806,1171],[10.77,424.7],[13.44,106],[14.52,12.61],[15.98,0]],"totImpulseNs":14130,"totalWeightG":12770,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":2776,"burnTimeS":5.2,"caseInfo":"AMW 98-17500","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"N2801","dataFiles":1,"designation":"SK-98-17500","diameter":98,"impulseClass":"N","length":1213,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":4199,"motorId":"5f4294d2000231000000027f","propInfo":"Skidmark","samples":[[0,0],[0.08,2768],[0.111,3226],[0.234,3410],[0.475,3522],[0.685,3532],[1.073,3603],[1.573,3664],[2.301,3664],[2.943,3532],[3.362,3379],[3.498,3216],[3.603,2962],[3.665,2606],[3.72,2300],[3.905,1883],[4.393,1048],[4.535,783.7],[4.868,519.1],[5.417,0]],"sparky":true,"totImpulseNs":11940,"totalWeightG":13680,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1666,"burnTimeS":3.42,"caseInfo":"75/6000","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1665","dataFiles":1,"designation":"M1665WC","diameter":75,"impulseClass":"M","length":787,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":2299,"motorId":"5f4294d20002310000000280","propInfo":"White Cloud","propWeightG":2950,"samples":[[0,0],[0.075,2068],[0.125,2002],[0.7,2224],[0.85,2269],[1.6,2269],[2.12,1802],[2.65,1179],[3.22,444.8],[3.42,0]],"totImpulseNs":5705,"totalWeightG":5620,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1354,"burnTimeS":3.82,"caseInfo":"75/6000","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1355","dataFiles":1,"designation":"M1355RT","diameter":75,"impulseClass":"M","length":787,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":1981,"motorId":"5f4294d20002310000000281","propInfo":"Red Twister","propWeightG":2831,"samples":[[0,0],[0.05,1334],[0.85,1779],[1.35,1868],[1.7,1890],[2.15,1859],[3.5,489.3],[3.81,0]],"totImpulseNs":5165,"totalWeightG":5501,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1065,"burnTimeS":3.95,"caseInfo":"75/6000","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1065","dataFiles":1,"designation":"L1065BL","diameter":75,"impulseClass":"L","length":787,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":1932,"motorId":"5f4294d20002310000000282","propInfo":"Black Lightning","propWeightG":2693,"samples":[[0,0],[0.02,1334],[0.1,1312],[0.65,1779],[1.75,1757],[2.2,1246],[2.75,667.2],[3.5,222.4],[3.95,0]],"sparky":true,"totImpulseNs":4210,"totalWeightG":5363,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":180.9,"burnTimeS":1.873,"caseInfo":"Pro38-3G","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I180","dataFiles":2,"delays":"5,7,9,11,14","designation":"338I180-14A","diameter":38,"impulseClass":"I","length":243,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":213,"motorId":"5f4294d20002310000000284","propInfo":"Skidmark","propWeightG":200,"samples":[[0,0],[0.003,130.4],[0.028,173.4],[0.062,156.1],[0.197,180.9],[0.644,206.6],[0.962,214.9],[1.336,205.1],[1.482,199],[1.585,196.8],[1.638,171.1],[1.7,91.23],[1.795,24.88],[1.962,0]],"sparky":true,"totImpulseNs":338.4,"totalWeightG":394,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":223.4,"burnTimeS":1.946,"caseInfo":"Pro38-4G","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I223","dataFiles":2,"delays":"5,7,9,11,14","designation":"434I223-14A","diameter":38,"impulseClass":"I","length":302,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":259.6,"motorId":"5f4294d20002310000000285","propInfo":"Skidmark","propWeightG":266,"samples":[[0,0],[0.016,199.2],[0.024,260.2],[0.07,207.3],[0.148,227.6],[0.425,244.7],[0.721,254.5],[1.015,256.9],[1.3,248.8],[1.459,240.6],[1.615,235],[1.712,195.9],[1.782,119.5],[1.9,24.39],[1.984,0]],"sparky":true,"totImpulseNs":434.1,"totalWeightG":494,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":296.7,"burnTimeS":1.813,"caseInfo":"Pro38-5G","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I297","dataFiles":2,"delays":"6,8,10,12,15","designation":"543I297-15A","diameter":38,"impulseClass":"I","length":360,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":375.9,"motorId":"5f4294d20002310000000286","propInfo":"Skidmark","propWeightG":329,"samples":[[0,0],[0.013,340.9],[0.036,375.1],[0.069,354.8],[0.129,335.8],[0.281,338.4],[0.662,344.7],[0.855,344.7],[1.084,329.5],[1.295,319.4],[1.359,313],[1.447,314.3],[1.534,269.9],[1.637,119.1],[1.681,69.7],[1.74,40.55],[1.846,12.67],[1.943,0]],"sparky":true,"totImpulseNs":542.8,"totalWeightG":591,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":380.6,"burnTimeS":1.63,"caseInfo":"Pro38-6G","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J381","dataFiles":2,"delays":"6,8,10,12,15","designation":"660J381-15A","diameter":38,"impulseClass":"J","length":419,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":503.1,"motorId":"5f4294d20002310000000287","propInfo":"Skidmark","propWeightG":396,"samples":[[0,0],[0.048,505],[0.111,473.2],[0.294,461.5],[0.968,436.8],[1.353,392],[1.385,366.1],[1.556,137.7],[1.662,47.09],[1.706,22.37],[1.874,0]],"sparky":true,"totImpulseNs":659.9,"totalWeightG":688,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":441.7,"burnTimeS":2.48,"caseInfo":"AMW 54-1050","certOrg":"Canadian Association of Rocketry","commonName":"J440","dataFiles":2,"delays":"P","designation":"1109J440-P","diameter":54,"impulseClass":"J","length":326,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":662.1,"motorId":"5f4294d20002310000000288","propInfo":"Blue Baboon","propWeightG":528.4,"samples":[[0,0],[0.01,30],[0.02,700],[0.06,790],[0.1,800],[0.2,760],[0.4,725],[0.6,695],[0.8,680],[1,658],[1.32,600],[1.55,400],[1.7,180],[1.87,175],[2,75],[2.1,0]],"totImpulseNs":1109,"totalWeightG":1229,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":475.4,"burnTimeS":2.6,"caseInfo":"AMW 54-1400","certOrg":"Canadian Association of Rocketry","commonName":"J475","dataFiles":2,"delays":"P","designation":"1233J475-P","diameter":54,"impulseClass":"J","length":403,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":627.5,"motorId":"5f4294d20002310000000289","propInfo":"Blue Baboon","propWeightG":704.5,"samples":[[0,0],[0.03,30],[0.04,500],[0.075,600],[0.1,515],[0.2,530],[0.4,540],[0.6,535],[0.8,535],[1,530],[1.2,520],[1.4,510],[1.6,500],[1.8,490],[2,480],[2.2,490],[2.28,450],[2.43,180],[2.5,100],[2.6,60],[2.8,28],[3,10],[3.2,0]],"totImpulseNs":1233,"totalWeightG":1493,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":712.2,"burnTimeS":2.51,"caseInfo":"AMW 54-1750","certOrg":"Canadian Association of Rocketry","commonName":"K710","dataFiles":2,"delays":"P","designation":"1791K710-P","diameter":54,"impulseClass":"K","length":491,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":766.8,"motorId":"5f4294d2000231000000028a","propInfo":"Blue Baboon","propWeightG":880.7,"samples":[[0,0],[0.01,500],[0.02,850],[0.025,910],[0.03,840],[0.06,860],[0.12,875],[0.2,875],[0.3,872],[1.1,815],[1.85,740],[1.95,720],[2.2,295],[2.37,280],[2.5,90],[2.6,20],[2.8,0]],"totImpulseNs":1791,"totalWeightG":1812,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1128,"burnTimeS":2.27,"caseInfo":"AMW 54-2550","certOrg":"Canadian Association of Rocketry","commonName":"K1130","dataFiles":3,"delays":"P","designation":"2551K1130-P","diameter":54,"impulseClass":"K","length":728,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":1549,"motorId":"5f4294d2000231000000028b","propInfo":"Blue Baboon","propWeightG":1334,"samples":[[0,0],[0.01,1000],[0.013,1490],[0.02,1548],[0.04,1500],[0.09,1335],[0.2,1325],[1,1325],[1.5,1325],[1.63,1345],[1.7,1155],[1.8,805],[1.9,685],[2,475],[2.1,315],[2.2,145],[2.3,0]],"totImpulseNs":2551,"totalWeightG":2574,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":4891,"burnTimeS":7.6,"caseInfo":"Pro150-40k","certOrg":"Canadian Association of Rocketry","commonName":"O4900","dataFiles":2,"delays":"P","designation":"37148O4900-P","diameter":161,"impulseClass":"O","length":957,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":5587,"motorId":"5f4294d2000231000000028c","propInfo":"Blue Streak","propWeightG":17700,"samples":[[0,0],[0.06,800],[0.1,4000],[0.15,5500],[0.25,5160],[0.45,5130],[0.8,5400],[1,5300],[2,5450],[3,5347],[4,5160],[5,4950],[6,4700],[6.8,4400],[7.05,4400],[7.3,3800],[7.6,300],[7.8,0]],"totImpulseNs":37150,"totalWeightG":32650,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":36.4,"burnTimeS":1.42,"caseInfo":"Pro29-1G","certOrg":"Canadian Association of Rocketry","commonName":"F36","dataFiles":2,"delays":"5,7,9,11,14","designation":"51F36-14A","diameter":29,"impulseClass":"F","length":98,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":46.3,"motorId":"5f4294d2000231000000028d","propInfo":"Blue Streak","propWeightG":25.6,"samples":[[0,0],[0.01,12],[0.02,25],[0.03,41],[0.04,42],[0.05,42],[0.06,40],[0.07,34],[0.08,34],[0.09,35],[0.1,36],[0.2,40],[0.3,42],[0.4,43],[0.5,43],[0.6,43],[0.7,43],[0.8,42],[0.9,41],[1,40],[1.1,38],[1.24,37],[1.3,12],[1.4,2],[1.5,0]],"totImpulseNs":51.5,"totalWeightG":101,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":83.1,"burnTimeS":1.29,"caseInfo":"Pro29-2G","certOrg":"Canadian Association of Rocketry","commonName":"G83","dataFiles":2,"delays":"5,7,9,11,14","designation":"107G83-14A","diameter":29,"impulseClass":"G","length":142,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":99,"motorId":"5f4294d2000231000000028e","propInfo":"Blue Streak","propWeightG":51.1,"samples":[[0,0],[0.01,13],[0.02,82],[0.03,98],[0.04,100],[0.05,90],[0.06,86],[0.12,93],[0.2,96],[0.3,96],[0.7,92],[0.9,88],[1.07,83],[1.1,80],[1.2,30],[1.3,4],[1.33,0]],"totImpulseNs":107.4,"totalWeightG":145,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":133.1,"burnTimeS":1.23,"caseInfo":"Pro29-3G","certOrg":"Canadian Association of Rocketry","commonName":"H133","dataFiles":2,"delays":"5,7,9,11,14","designation":"163H133-14A","diameter":29,"impulseClass":"H","length":187,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":191.1,"motorId":"5f4294d2000231000000028f","propInfo":"Blue Streak","propWeightG":76.7,"samples":[[0,0],[0.01,10],[0.017,100],[0.023,190],[0.028,200],[0.042,140],[0.05,135],[0.12,152],[0.35,154],[1,135],[1.065,110],[1.2,25],[1.28,0]],"totImpulseNs":163.3,"totalWeightG":190,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":171.3,"burnTimeS":1.27,"caseInfo":"Pro29-4G","certOrg":"Canadian Association of Rocketry","commonName":"H170","dataFiles":2,"delays":"5,7,9,11,14","designation":"217H170-14A","diameter":29,"impulseClass":"H","length":231,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":243.8,"motorId":"5f4294d20002310000000290","propInfo":"Blue Streak","propWeightG":102.3,"samples":[[0,0],[0.01,150],[0.015,200],[0.025,240],[0.075,210],[0.13,205],[0.35,204],[0.7,205],[0.8,190],[0.9,185],[0.99,173],[1.1,60],[1.22,25],[1.34,0]],"totImpulseNs":217.1,"totalWeightG":232,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":201.7,"burnTimeS":1.29,"caseInfo":"Pro29-5G","certOrg":"Canadian Association of Rocketry","commonName":"H200","dataFiles":2,"delays":"5,7,9,11,14","designation":"261H200-14A","diameter":29,"impulseClass":"H","length":276,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":303.2,"motorId":"5f4294d20002310000000291","propInfo":"Blue Streak","propWeightG":127.9,"samples":[[0,0],[0.01,40],[0.018,280],[0.026,295],[0.06,250],[0.15,236],[0.65,235],[0.8,227],[0.9,212],[0.98,205],[1.09,135],[1.2,68],[1.3,20],[1.4,0]],"totImpulseNs":260.8,"totalWeightG":274,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":254.2,"burnTimeS":1.24,"caseInfo":"Pro29-6G","certOrg":"Canadian Association of Rocketry","commonName":"H255","dataFiles":2,"delays":"5,7,9,11,14","designation":"315H255-14A","diameter":29,"impulseClass":"H","length":320,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":411.1,"motorId":"5f4294d20002310000000292","propInfo":"Blue Streak","propWeightG":153.4,"samples":[[0,0],[0.015,10],[0.018,260],[0.024,404],[0.03,412],[0.047,375],[0.08,340],[0.2,316],[0.4,303],[0.6,295],[0.87,285],[0.93,273],[1,200],[1.1,80],[1.252,0]],"totImpulseNs":315.4,"totalWeightG":318,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":821.6,"burnTimeS":2.9,"caseInfo":"Pro54-6G","certOrg":"Canadian Association of Rocketry","commonName":"K820","dataFiles":2,"delays":"7,8,9,10,11,12,13,14,15,16,17","designation":"2383K820-17A","diameter":54,"impulseClass":"K","length":572,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1471,"motorId":"5f4294d20002310000000293","propInfo":"Blue Streak","propWeightG":1164,"samples":[[0,0],[0.01,800],[0.02,1400],[0.029,1720],[0.04,960],[0.1,1050],[0.2,1060],[0.4,1040],[0.6,1030],[1,1020],[1.5,980],[2,880],[2.1,800],[2.2,640],[2.3,520],[2.4,410],[2.5,390],[2.6,280],[2.7,180],[2.8,110],[2.9,50],[3,0]],"totImpulseNs":2383,"totalWeightG":1982,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":991,"burnTimeS":2.8,"caseInfo":"Pro54-6GXL","certOrg":"Canadian Association of Rocketry","commonName":"L990","dataFiles":2,"delays":"P","designation":"2771L990-P","diameter":54,"impulseClass":"L","length":649,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1703,"motorId":"5f4294d20002310000000294","propInfo":"Blue Streak","propWeightG":1369,"samples":[[0,0],[0.01,800],[0.012,1450],[0.02,1625],[0.05,1320],[0.15,1230],[1.8,1150],[1.88,1105],[2,845],[2.203,825],[2.41,355],[2.6,320],[2.9,0]],"totImpulseNs":2771,"totalWeightG":2236,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1396,"burnTimeS":3.51,"caseInfo":"Pro75-4G","certOrg":"Canadian Association of Rocketry","commonName":"L1395","dataFiles":2,"delays":"P","designation":"4895L1395-P","diameter":75,"impulseClass":"L","length":621,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1780,"motorId":"5f4294d20002310000000295","propInfo":"Blue Streak","propWeightG":2365,"samples":[[0,0],[0.02,100],[0.04,1400],[0.1,1800],[0.2,1500],[0.4,1540],[0.8,1591],[1.1,1641],[2.4,1481],[2.8,1446],[3,1500],[3.18,830],[3.35,100],[3.45,0]],"totImpulseNs":4895,"totalWeightG":4323,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1668,"burnTimeS":3.63,"caseInfo":"Pro75-5G","certOrg":"Canadian Association of Rocketry","commonName":"M1670","dataFiles":2,"delays":"P","designation":"6026M1670-P","diameter":75,"impulseClass":"M","length":757,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":2232,"motorId":"5f4294d20002310000000296","propInfo":"Blue Streak","propWeightG":2130,"samples":[[0,0],[0.055,100],[0.092,1500],[0.1,2000],[0.15,2200],[0.2,1800],[0.5,1950],[1,2034],[1.5,2000],[2,1900],[2.5,1760],[2.9,1700],[3,1650],[3.3,530],[3.4,350],[3.9,0]],"totImpulseNs":6042,"totalWeightG":5231,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":117.8,"burnTimeS":1.35,"caseInfo":"Pro29-3G","certOrg":"Canadian Association of Rocketry","commonName":"G118","dataFiles":2,"delays":"6,8,10,12,15","designation":"159G118-15A","diameter":29,"impulseClass":"G","length":187,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":157.3,"motorId":"5f4294d20002310000000297","propInfo":"Blue Streak","propWeightG":76.7,"samples":[[0,0],[0.005,1.3],[0.012,80],[0.02,156],[0.04,148],[0.05,105],[0.11,121],[0.3,131],[0.5,134],[0.7,130],[0.95,126],[1.13,126],[1.18,115],[1.27,40],[1.31,20],[1.35,6],[1.37,0]],"totImpulseNs":159.1,"totalWeightG":188,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":57.2,"burnTimeS":1.89,"caseInfo":"Pro29-2G","certOrg":"Canadian Association of Rocketry","commonName":"G57","dataFiles":2,"delays":"3,5,7,9,12","designation":"108G57-12A","diameter":29,"impulseClass":"G","length":142,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":85.4,"motorId":"5f4294d20002310000000298","propInfo":"Classic","propWeightG":51.4,"samples":[[0,0],[0.01,8],[0.02,70],[0.04,88],[0.05,80],[0.06,71],[0.08,76],[0.11,79],[0.2,81],[0.6,72],[1,56],[1.5,47],[1.6,48],[1.7,28],[1.8,14],[1.9,3],[1.93,0]],"totImpulseNs":107.8,"totalWeightG":146,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":90.3,"burnTimeS":1.82,"caseInfo":"Pro29-3G","certOrg":"Canadian Association of Rocketry","commonName":"H90","dataFiles":2,"delays":"3,5,7,9,12","designation":"164H90-12A","diameter":29,"impulseClass":"H","length":187,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":154.1,"motorId":"5f4294d20002310000000299","propInfo":"Classic","propWeightG":77.1,"samples":[[0,0],[0.021,10],[0.028,154],[0.055,155],[0.075,108],[0.13,120],[0.35,115],[1.4,83],[1.48,84],[1.56,73],[1.69,22],[1.76,8],[1.85,0]],"totImpulseNs":164.2,"totalWeightG":163,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":118.4,"burnTimeS":1.83,"caseInfo":"Pro29-4G","certOrg":"Canadian Association of Rocketry","commonName":"H118","dataFiles":2,"delays":"3,5,7,9,12","designation":"216H118-12A","diameter":29,"impulseClass":"H","length":231,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":191.3,"motorId":"5f4294d2000231000000029a","propInfo":"Classic","propWeightG":102.8,"samples":[[0,0],[0.01,7],[0.02,144],[0.04,183],[0.06,182],[0.08,176],[0.09,173],[0.1,172],[0.2,160],[0.4,147],[0.5,142],[0.7,134],[0.8,127],[1,121],[1.1,118],[1.2,115],[1.4,109],[1.5,104],[1.6,75],[1.7,31],[1.8,13],[1.9,0]],"totImpulseNs":216.2,"totalWeightG":232,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":141.8,"burnTimeS":1.89,"caseInfo":"Pro29-5G","certOrg":"Canadian Association of Rocketry","commonName":"H140","dataFiles":2,"delays":"2,4,6,8,11","designation":"268H140-11A","diameter":29,"impulseClass":"H","length":276,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":247.8,"motorId":"5f4294d2000231000000029b","propInfo":"Classic","propWeightG":128.5,"samples":[[0,0],[0.015,30],[0.025,240],[0.04,245],[0.09,220],[0.2,200],[0.4,185],[0.8,160],[1.4,140],[1.49,100],[1.63,50],[1.75,35],[1.9,12],[2.05,0]],"totImpulseNs":268,"totalWeightG":277,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":161.5,"burnTimeS":1.93,"caseInfo":"Pro29-6G","certOrg":"Canadian Association of Rocketry","commonName":"H160","dataFiles":2,"delays":"3,5,7,9,12","designation":"312H160-12A","diameter":29,"impulseClass":"H","length":320,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":334.8,"motorId":"5f4294d2000231000000029c","propInfo":"Classic","propWeightG":154.2,"samples":[[0,0],[0.015,10],[0.022,260],[0.04,316],[0.1,280],[0.25,241],[0.6,201],[1,175],[1.27,165],[1.35,140],[1.45,100],[1.65,48],[1.85,25],[2.2,0]],"totImpulseNs":311.7,"totalWeightG":319,"type":"reload","updatedOn":"2022-07-21"},{"availability":"regular","avgThrustN":419.9,"burnTimeS":2.4,"caseInfo":"Pro38-6GXL","certOrg":"Canadian Association of Rocketry","commonName":"J420","dataFiles":2,"delays":"6,8,10,12,15","designation":"1008J420-15A","diameter":38,"impulseClass":"J","length":500,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":783.1,"motorId":"5f4294d2000231000000029d","propInfo":"Classic","propWeightG":479.4,"samples":[[0,0],[0.015,360],[0.02,660],[0.035,800],[0.075,660],[0.25,625],[0.7,560],[1.45,495],[1.51,480],[1.62,350],[1.8,220],[1.9,150],[2,120],[2.25,48],[2.62,0]],"totImpulseNs":1008,"totalWeightG":874,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":204.2,"burnTimeS":1.7,"caseInfo":"Pro29-6G","certOrg":"Canadian Association of Rocketry","commonName":"I204","dataFiles":2,"delays":"4,6,8,10,13","designation":"348I204-13A","diameter":29,"impulseClass":"I","length":320,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":356.8,"motorId":"5f4294d2000231000000029e","propInfo":"Imax","propWeightG":185.4,"samples":[[0,0],[0.01,100],[0.012,395],[0.03,310],[0.3,286],[0.5,270],[0.7,251],[1,228],[1.1,215],[1.2,165],[1.3,125],[1.4,95],[1.5,52],[1.6,36],[1.72,0]],"totImpulseNs":347.7,"totalWeightG":349,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":531.2,"burnTimeS":2.1,"caseInfo":"Pro38-6GXL","certOrg":"Canadian Association of Rocketry","commonName":"J530","dataFiles":2,"delays":"6,8,10,12,15","designation":"1115J530-15A","diameter":38,"impulseClass":"J","length":500,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":828.8,"motorId":"5f4294d2000231000000029f","propInfo":"Imax","propWeightG":576.5,"samples":[[0,0],[0.01,30],[0.02,700],[0.06,790],[0.1,800],[0.2,760],[0.4,725],[0.6,695],[0.8,680],[1,658],[1.32,600],[1.55,400],[1.7,180],[1.87,175],[2,75],[2.1,0]],"totImpulseNs":1116,"totalWeightG":977,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":583.8,"burnTimeS":4.55,"caseInfo":"Pro75-2G","certOrg":"Canadian Association of Rocketry","commonName":"L585","dataFiles":2,"delays":"P","designation":"2653L585-P","diameter":75,"impulseClass":"L","length":350,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":679.8,"motorId":"5f4294d200023100000002a0","propInfo":"Imax","propWeightG":1450,"samples":[[0,0],[0.01,200],[0.02,300],[0.04,500],[0.08,630],[0.1,650],[0.25,629],[0.4,639],[0.8,648],[1.2,654],[1.6,659],[2,653],[2.4,640],[2.8,610],[3.2,580],[3.6,550],[4,515],[4.2,510],[4.45,110],[4.57,0]],"totImpulseNs":2653,"totalWeightG":2784,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1537,"burnTimeS":4.44,"caseInfo":"Pro75-5G","certOrg":"Canadian Association of Rocketry","commonName":"M1540","dataFiles":2,"delays":"P","designation":"6819M1540-P","diameter":75,"impulseClass":"M","length":757,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":2329,"motorId":"5f4294d200023100000002a1","propInfo":"Imax","propWeightG":3624,"samples":[[0,0],[0.02,800],[0.04,1250],[0.06,1800],[0.08,2400],[0.15,2060],[0.2,2000],[0.35,2100],[0.55,1940],[0.7,1900],[1.7,1830],[2.5,1720],[3.38,1550],[3.83,680],[4,530],[4.5,0]],"totImpulseNs":6819,"totalWeightG":5906,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":996.5,"burnTimeS":3.63,"caseInfo":"Pro75-3G","certOrg":"Canadian Association of Rocketry","commonName":"L995","dataFiles":2,"delays":"P","designation":"3618L995-P","diameter":75,"impulseClass":"L","length":486,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1405,"motorId":"5f4294d200023100000002a2","propInfo":"Red Lightning","propWeightG":1913,"samples":[[0,0],[0.02,50],[0.05,200],[0.09,1110],[0.14,1250],[0.25,1211],[0.9,1220],[1.2,1280],[1.4,1245],[2.4,940],[3.1,745],[3.32,740],[3.6,110],[3.8,0]],"totImpulseNs":3618,"totalWeightG":3591,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1811,"burnTimeS":3.39,"caseInfo":"Pro75-5G","certOrg":"Canadian Association of Rocketry","commonName":"M1810","dataFiles":2,"delays":"P","designation":"6128M1810-P","diameter":75,"impulseClass":"M","length":757,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":2159,"motorId":"5f4294d200023100000002a3","propInfo":"Red Lightning","propWeightG":3196,"samples":[[0,0],[0.01,30],[0.03,120],[0.065,1000],[0.093,1500],[0.11,1950],[0.16,1850],[0.35,1915],[0.6,1965],[1.15,2085],[1.35,2080],[2.15,1970],[2.6,1820],[2.95,1810],[3.06,1715],[3.15,1185],[3.32,240],[3.4,90],[3.58,0]],"totImpulseNs":6132,"totalWeightG":5416,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":612.1,"burnTimeS":2.5,"caseInfo":"AMW 54-1750","certOrg":"Canadian Association of Rocketry","commonName":"K610","dataFiles":2,"delays":"P","designation":"1531K610-P","diameter":54,"impulseClass":"K","length":491,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":730.6,"motorId":"5f4294d200023100000002a4","propInfo":"Skidmark","propWeightG":861,"samples":[[0,0],[0.01,300],[0.02,745],[0.035,650],[0.06,560],[0.12,635],[0.21,670],[0.4,695],[0.7,700],[1,690],[1.35,665],[1.7,630],[2.05,585],[2.19,590],[2.24,500],[2.3,350],[2.4,205],[2.5,60],[2.6,15],[2.7,0]],"sparky":true,"totImpulseNs":1531,"totalWeightG":1765,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":106,"burnTimeS":1.31,"caseInfo":"Pro29-3G","certOrg":"Canadian Association of Rocketry","commonName":"G106","dataFiles":2,"delays":"5,7,9,11,14","designation":"138G106-14A","diameter":29,"impulseClass":"G","length":187,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":128.7,"motorId":"5f4294d200023100000002a5","propInfo":"Skidmark","propWeightG":75,"samples":[[0,0],[0.018,20],[0.023,80],[0.03,131],[0.05,105],[0.065,75],[0.1,94],[0.25,104],[0.4,111],[0.65,120],[0.86,123],[1.05,124],[1.13,121],[1.17,110],[1.2,85],[1.23,40],[1.25,20],[1.3,5],[1.36,0]],"sparky":true,"totImpulseNs":138.3,"totalWeightG":187,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":123,"burnTimeS":1.44,"caseInfo":"Pro29-4G","certOrg":"Canadian Association of Rocketry","commonName":"H123","dataFiles":2,"delays":"3,5,7,9,12","designation":"176H123-12A","diameter":29,"impulseClass":"H","length":231,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":149.8,"motorId":"5f4294d200023100000002a6","propInfo":"Skidmark","propWeightG":100,"samples":[[0,0],[0.021,10],[0.028,139],[0.055,139],[0.075,108],[0.13,120],[0.35,132],[0.65,140],[1,144],[1.15,143],[1.22,145],[1.35,23],[1.53,0]],"sparky":true,"totImpulseNs":176.5,"totalWeightG":228,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":159,"burnTimeS":1.4,"caseInfo":"Pro29-5G","certOrg":"Canadian Association of Rocketry","commonName":"H160","dataFiles":1,"delays":"5,7,9,11,14","designation":"220H160-14A","diameter":29,"impulseClass":"H","length":276,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":191.9,"motorId":"5f4294d200023100000002a7","propInfo":"Skidmark","propWeightG":125,"samples":[[0,0],[0.01,10],[0.02,160],[0.03,185],[0.09,170],[0.25,168],[0.5,176],[0.9,184],[1.1,185],[1.16,180],[1.31,28],[1.383,0]],"sparky":true,"totImpulseNs":220.5,"totalWeightG":272,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":179.6,"burnTimeS":1.44,"caseInfo":"Pro29-6G","certOrg":"Canadian Association of Rocketry","commonName":"H180","dataFiles":2,"delays":"5,7,9,11,14","designation":"258H180-14A","diameter":29,"impulseClass":"H","length":320,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":266.1,"motorId":"5f4294d200023100000002a8","propInfo":"Skidmark","propWeightG":150,"samples":[[0,0],[0.01,10],[0.02,250],[0.03,270],[0.07,239],[0.13,227],[0.35,218],[0.6,216],[0.8,207],[0.98,208],[1.06,204],[1.15,135],[1.23,65],[1.4,12],[1.56,0]],"sparky":true,"totImpulseNs":258,"totalWeightG":314,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":454.1,"burnTimeS":3,"caseInfo":"Pro54-4G","certOrg":"Canadian Association of Rocketry","commonName":"K454","dataFiles":2,"delays":"10,11,12,13,14,15,16,17,18,19","designation":"1364K454-19A","diameter":54,"impulseClass":"K","length":404,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":620,"motorId":"5f4294d200023100000002a9","propInfo":"Skidmark","propWeightG":769.2,"samples":[[0,0],[0.021,10],[0.028,421],[0.032,586],[0.069,405],[0.2,475],[0.4,510],[0.6,530],[0.9,532],[1.2,525],[1.6,505],[2,470],[2.4,415],[2.55,410],[2.69,430],[2.93,70],[3,27],[3.15,0]],"sparky":true,"totImpulseNs":1364,"totalWeightG":1391,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":513.4,"burnTimeS":3.22,"caseInfo":"Pro54-5G","certOrg":"Canadian Association of Rocketry","commonName":"K515","dataFiles":2,"delays":"6,7,8,9,10,11,12,13,14,15,16","designation":"1654K515-16A","diameter":54,"impulseClass":"K","length":500,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":718.5,"motorId":"5f4294d200023100000002aa","propInfo":"Skidmark","propWeightG":961.5,"samples":[[0,0],[0.01,10],[0.02,250],[0.028,550],[0.035,710],[0.06,540],[0.065,530],[0.1,560],[0.25,600],[0.5,612],[0.75,612],[1.1,602],[1.5,578],[2,531],[2.6,460],[2.78,458],[2.85,450],[2.95,300],[3.03,200],[3.18,40],[3.35,0]],"sparky":true,"totImpulseNs":1654,"totalWeightG":1654,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":231,"burnTimeS":2.32,"certOrg":"National Association of Rocketry","commonName":"I250","dataFiles":1,"designation":"I250","diameter":54,"impulseClass":"I","infoUrl":"https://nar.org/SandT/pdf/Alpha/I250.pdf","length":711,"manufacturer":"Alpha Hybrids","manufacturerAbbrev":"Alpha","maxThrustN":375,"motorId":"5f4294d200023100000002ab","propWeightG":353.8,"samples":[[0,0],[0.002,78.7],[0.004,84.88],[0.006,131.6],[0.01,285.7],[0.012,299.1],[0.016,253.2],[0.022,294.5],[0.042,282.7],[0.056,314.2],[0.116,345],[0.136,317.5],[0.196,344.4],[0.21,325.1],[0.298,342],[0.312,321.2],[0.316,341.7],[0.33,322.6],[0.334,345.5],[0.348,319],[0.362,339.9],[0.366,318.9],[0.4779,307.2],[0.5719,330.3],[0.5839,308],[0.5879,326.3],[0.7919,294.5],[1.462,268.7],[1.6,228.3],[1.808,92.62],[2.34,16.84],[2.77,0]],"totImpulseNs":540,"totalWeightG":1854,"type":"hybrid","updatedOn":"2022-07-24"},{"availability":"regular","avgThrustN":316,"burnTimeS":1.5,"caseInfo":"38/480","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I316","dataFiles":2,"delays":"5,8,10,13,17","designation":"I316-SF","diameter":38,"impulseClass":"I","infoUrl":"https://www.lokiresearch.com/images/Documents/38mm%20Spitfire.pdf","length":292,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","motorId":"5f4294d200023100000002ac","propInfo":"Spitfire","propWeightG":240,"samples":[[0,0],[0.009317,448.3],[0.1273,491.4],[0.2422,500],[0.3478,482.8],[0.4845,439.7],[1,258.6],[1.5,0]],"sparky":true,"totImpulseNs":408.6,"totalWeightG":540,"type":"reload","updatedOn":"2021-07-24"},{"availability":"regular","avgThrustN":1242,"burnTimeS":4.485,"caseInfo":"76/6000","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1200","dataFiles":2,"designation":"M1200-SF","diameter":76,"impulseClass":"M","length":785,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":1550,"motorId":"5f4294d200023100000002ad","propInfo":"Spitfire","propWeightG":2968,"samples":[[0,0],[0.02,1018],[0.5,1203],[1,1303],[1.5,1398],[2,1515],[2.5,1499],[3,1409],[3.5,1203],[4,411.6],[4.25,89.71],[4.5,0]],"sparky":true,"totImpulseNs":5123,"totalWeightG":5368,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":783.3,"burnTimeS":3.83,"caseInfo":"76/3600","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L780","dataFiles":2,"designation":"L780-SF","diameter":76,"impulseClass":"L","length":498,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":995,"motorId":"5f4294d200023100000002ae","propInfo":"Spitfire","propWeightG":1800,"samples":[[0,0],[0.02,506.6],[0.5,696.6],[1,844.3],[1.5,897.1],[2,934],[2.5,918.2],[3,865.4],[3.5,802.1],[3.8,0]],"sparky":true,"totImpulseNs":3006,"totalWeightG":3500,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":835,"burnTimeS":2.73,"caseInfo":"54/2800","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K830","dataFiles":2,"designation":"K830-SF","diameter":54,"impulseClass":"K","length":726,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":1174,"motorId":"5f4294d200023100000002af","propInfo":"Spitfire","propWeightG":1400,"samples":[[0,0],[0.02,670.2],[0.5034,739.3],[0.9983,840.5],[1.502,918.3],[1.997,980.5],[2.496,1136],[2.7,0]],"sparky":true,"totImpulseNs":2287,"totalWeightG":2400,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":687,"burnTimeS":2.35,"caseInfo":"54/2000","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K690","dataFiles":2,"designation":"K690-SF","diameter":54,"impulseClass":"K","length":498,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":910,"motorId":"5f4294d200023100000002b0","propInfo":"Spitfire","propWeightG":1400,"samples":[[0,0],[0.01,643.8],[0.25,688.7],[0.5,730.9],[0.7496,770.4],[1,807.4],[1.25,796.8],[1.5,762.5],[1.75,733.5],[2,696.6],[2.25,659.6],[2.35,0]],"sparky":true,"totImpulseNs":1616,"totalWeightG":2400,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":350,"burnTimeS":2.67,"caseInfo":"54/1200","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J350","dataFiles":2,"designation":"J350-SF","diameter":54,"impulseClass":"J","length":327,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":448,"motorId":"5f4294d200023100000002b1","propInfo":"Spitfire","propWeightG":590,"samples":[[0,0],[0.02,325.9],[0.4992,377.4],[1.003,445.5],[1.502,437.7],[2.001,404.7],[2.202,383.3],[2.5,48.81],[2.7,0]],"sparky":true,"totImpulseNs":931,"totalWeightG":1260,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":648,"burnTimeS":1.45,"caseInfo":"38/1200","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J650","dataFiles":2,"designation":"J650-SF","diameter":38,"impulseClass":"J","length":625,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":974,"motorId":"5f4294d200023100000002b2","propInfo":"Spitfire","propWeightG":573,"samples":[[0,0],[0.01,744.1],[0.2,754.6],[0.4,770.4],[0.6,833.8],[0.8,876],[1,923.5],[1.1,401.1],[1.2,295.5],[1.45,0]],"sparky":true,"totImpulseNs":942,"totalWeightG":1143,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":484,"burnTimeS":2.19,"caseInfo":"54/1050","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J485","dataFiles":1,"designation":"J485WC","diameter":54,"impulseClass":"J","length":326,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":600,"motorId":"5f4294d200023100000002b3","propInfo":"White Cloud","propWeightG":575,"samples":[[0,0],[0.05,263.9],[0.095,401.8],[0.15,444.8],[0.5032,544.3],[0.8,573.8],[1.075,569.4],[1.5,542.7],[2,444.8],[2.1,311.4],[2.19,0]],"totImpulseNs":1060,"totalWeightG":1190,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":631,"burnTimeS":2.24,"caseInfo":"54/1400","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K630","dataFiles":1,"designation":"K630WC","diameter":54,"impulseClass":"K","length":402,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":827,"motorId":"5f4294d200023100000002b4","propInfo":"White Cloud","propWeightG":765,"samples":[[0,0],[0.042,359.5],[0.05,440.9],[0.075,556],[0.15,622.8],[0.217,667.2],[0.9,800.7],[1.159,796.2],[1.339,778.4],[1.517,720.6],[1.9,556],[2.1,133.4],[2.24,0]],"totImpulseNs":1415,"totalWeightG":1560,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":805.6,"burnTimeS":2.19,"caseInfo":"54/1750","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K805","dataFiles":1,"designation":"K805WC","diameter":54,"impulseClass":"K","length":491,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":1103,"motorId":"5f4294d200023100000002b5","propInfo":"White Cloud","propWeightG":950,"samples":[[0,0],[0.025,423.5],[0.04032,667.2],[0.067,702.8],[0.095,747.3],[0.5516,1001],[0.8,1090],[1.25,1068],[1.75,667.2],[2.19,0]],"totImpulseNs":1765,"totalWeightG":1775,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":673.8,"burnTimeS":2.98,"caseInfo":"Pro54-6G","certOrg":"Canadian Association of Rocketry","commonName":"K675","dataFiles":2,"delays":"8,9,10,11,12,13,14,15,16,17,18","designation":"2010K675-18A","diameter":54,"impulseClass":"K","length":572,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":991.6,"motorId":"5f4294d200023100000002b6","propInfo":"Skidmark","propWeightG":1141,"samples":[[0,0],[0.01,10],[0.02,154],[0.025,930],[0.04,850],[0.05,800],[0.07,680],[0.1,700],[0.2,750],[0.3,780],[0.5,795],[1,808],[1.5,795],[1.9,751],[2.26,700],[2.43,450],[2.6,440],[2.68,400],[2.96,40],[3.09,0]],"sparky":true,"totImpulseNs":2010,"totalWeightG":1940,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":814.9,"burnTimeS":2.83,"caseInfo":"Pro54-6GXL","certOrg":"Canadian Association of Rocketry","commonName":"K815","dataFiles":2,"delays":"P","designation":"2304K815-P","diameter":54,"impulseClass":"K","length":649,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1247,"motorId":"5f4294d200023100000002b7","propInfo":"Skidmark","propWeightG":1342,"samples":[[0,0],[0.01,400],[0.015,600],[0.02,1200],[0.05,620],[0.07,720],[0.1,825],[0.3,910],[1,945],[1.5,970],[1.8,970],[2.12,930],[2.3,650],[2.43,640],[2.58,300],[2.7,150],[2.85,0]],"sparky":true,"totImpulseNs":2304,"totalWeightG":2197,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":38.5,"burnTimeS":1.07,"caseInfo":"Pro29-1G","certOrg":"Canadian Association of Rocketry","commonName":"F36","dataFiles":2,"delays":"2,4,6,8,11","designation":"41F36-11A","diameter":29,"impulseClass":"F","length":98,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":72.7,"motorId":"5f4294d200023100000002b8","propInfo":"Smoky Sam","propWeightG":69,"samples":[[0,0],[0.01,12],[0.02,46],[0.03,75],[0.04,79],[0.06,77],[0.07,62],[0.08,32],[0.1,35],[0.2,38],[0.3,39],[0.4,41],[0.5,43],[0.6,43],[0.7,43],[0.8,43],[0.85,47],[0.92,54],[0.95,32],[0.99,8],[1.05,0]],"totImpulseNs":41.2,"totalWeightG":104,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":87.7,"burnTimeS":0.96,"caseInfo":"Pro29-2G","certOrg":"Canadian Association of Rocketry","commonName":"G88","dataFiles":2,"delays":"2,4,6,8,11","designation":"84G88-11A","diameter":29,"impulseClass":"G","length":142,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":123.6,"motorId":"5f4294d200023100000002b9","propInfo":"Smoky Sam","propWeightG":59,"samples":[[0,0],[0.03,7],[0.04,60],[0.05,90],[0.06,113],[0.07,116],[0.08,113],[0.1,86],[0.12,81],[0.15,86],[0.3,92],[0.4,95],[0.5,97],[0.75,100],[0.82,108],[0.84,106],[0.9,56],[0.93,25],[1,0]],"totImpulseNs":84.3,"totalWeightG":152,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":130.8,"burnTimeS":0.96,"caseInfo":"Pro29-3G","certOrg":"Canadian Association of Rocketry","commonName":"G131","dataFiles":2,"delays":"5,7,9,11,14","designation":"125G131-14A","diameter":29,"impulseClass":"G","length":187,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":182.6,"motorId":"5f4294d200023100000002ba","propInfo":"Smoky Sam","propWeightG":88.6,"samples":[[0,0],[0.01,6],[0.02,40],[0.03,116],[0.04,131],[0.05,146],[0.06,147],[0.07,140],[0.08,136],[0.09,130],[0.1,126],[0.2,129],[0.3,132],[0.4,137],[0.5,139],[0.6,141],[0.7,142],[0.8,145],[0.85,150],[0.87,155],[0.9,116],[0.93,60],[0.95,30],[1,3],[1.1,0]],"totImpulseNs":125.2,"totalWeightG":200,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":175.1,"burnTimeS":0.95,"caseInfo":"Pro29-4G","certOrg":"Canadian Association of Rocketry","commonName":"H175","dataFiles":2,"delays":"5,7,9,11,14","designation":"166H175-14A","diameter":29,"impulseClass":"H","length":231,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":221.6,"motorId":"5f4294d200023100000002bb","propInfo":"Smoky Sam","propWeightG":118.1,"samples":[[0,0],[0.021,13],[0.032,175],[0.057,215],[0.08,180],[0.13,175],[0.4,185],[0.6,190],[0.76,195],[0.84,236],[0.88,150],[0.92,30],[1,0]],"totImpulseNs":166,"totalWeightG":247,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":237.2,"burnTimeS":0.88,"caseInfo":"Pro29-5G","certOrg":"Canadian Association of Rocketry","commonName":"H237","dataFiles":2,"delays":"4,6,8,10,13","designation":"206H237-13A","diameter":29,"impulseClass":"H","length":276,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":295.9,"motorId":"5f4294d200023100000002bc","propInfo":"Smoky Sam","propWeightG":147.6,"samples":[[0,0],[0.026,10],[0.028,154],[0.033,238],[0.055,270],[0.07,234],[0.71,259],[0.78,296],[0.8,280],[0.87,50],[0.9,10],[0.937,0]],"totImpulseNs":206.2,"totalWeightG":294,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":296,"burnTimeS":0.85,"caseInfo":"Pro29-6G","certOrg":"Canadian Association of Rocketry","commonName":"H295","dataFiles":2,"delays":"4,6,8,10,13","designation":"253H295-13A","diameter":29,"impulseClass":"H","length":320,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":359.5,"motorId":"5f4294d200023100000002bd","propInfo":"Smoky Sam","propWeightG":177.1,"samples":[[0,0],[0.03,15],[0.031,320],[0.05,355],[0.075,325],[0.13,312],[0.35,315],[0.66,327],[0.72,368],[0.75,370],[0.78,290],[0.8,150],[0.85,25],[0.925,0]],"totImpulseNs":252.7,"totalWeightG":342,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1356,"burnTimeS":2.97,"caseInfo":"Pro75-4G","certOrg":"Canadian Association of Rocketry","commonName":"L1355","dataFiles":2,"designation":"4025L1355-P","diameter":75,"impulseClass":"L","length":621,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1792,"motorId":"5f4294d200023100000002be","propInfo":"Smoky Sam","propWeightG":3012,"samples":[[0,0],[0.1,80],[0.12,1300],[0.15,1600],[0.2,1500],[0.3,1540],[0.4,1560],[1.05,1660],[1.3,1750],[1.4,1750],[1.8,1590],[2.2,1270],[2.6,860],[2.82,680],[3.05,83],[3.25,0]],"totImpulseNs":4026,"totalWeightG":4962,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1686,"burnTimeS":3.01,"caseInfo":"Pro75-5G","certOrg":"Canadian Association of Rocketry","commonName":"L1685","dataFiles":2,"designation":"5069L1685-P","diameter":75,"impulseClass":"L","length":757,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":2570,"motorId":"5f4294d200023100000002bf","propInfo":"Smoky Sam","propWeightG":3773,"samples":[[0,0],[0.055,100],[0.07,1000],[0.092,2300],[0.12,2150],[0.4,2150],[0.9,2050],[1.1,2060],[1.3,2150],[1.6,1900],[2.1,1600],[2.5,1150],[2.7,1000],[2.85,750],[3.02,200],[3.18,0]],"totImpulseNs":5069,"totalWeightG":6051,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":442.7,"burnTimeS":1.07,"caseInfo":"Pro54-1G","certOrg":"Canadian Association of Rocketry","commonName":"I445","dataFiles":2,"delays":"6,7,8,9,10,11,12,13,14,15,16","designation":"475I445-16A","diameter":54,"impulseClass":"I","length":143,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":526.2,"motorId":"5f4294d200023100000002c0","propInfo":"Vmax","propWeightG":212.7,"samples":[[0,0],[0.02,315],[0.04,380],[0.054,365],[0.15,440],[0.25,493],[0.4,528],[0.55,529],[0.7,502],[0.8,485],[0.9,460],[0.95,430],[0.99,300],[1.02,100],[1.05,44],[1.1,0]],"totImpulseNs":474.9,"totalWeightG":575,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":58.9,"burnTimeS":0.96,"caseInfo":"Pro29-1G","certOrg":"Canadian Association of Rocketry","commonName":"F59","dataFiles":2,"delays":"3,5,7,9,12","designation":"57F59-12A","diameter":29,"impulseClass":"F","length":98,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":70.9,"motorId":"5f4294d200023100000002c1","propInfo":"White Thunder","propWeightG":26.1,"samples":[[0,0],[0.01,16],[0.02,62],[0.03,67],[0.04,71],[0.07,58],[0.1,63],[0.2,67],[0.3,69],[0.4,67],[0.5,65],[0.6,63],[0.7,61],[0.87,60],[0.9,23],[0.97,0]],"totImpulseNs":57,"totalWeightG":99,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":125.8,"burnTimeS":0.93,"caseInfo":"Pro29-2G","certOrg":"Canadian Association of Rocketry","commonName":"G126","dataFiles":2,"delays":"4,6,8,10,13","designation":"116G126-13A","diameter":29,"impulseClass":"G","length":142,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":167.4,"motorId":"5f4294d200023100000002c2","propInfo":"White Thunder","propWeightG":52.1,"samples":[[0,0],[0.01,55],[0.02,168],[0.03,157],[0.04,148],[0.05,125],[0.1,135],[0.2,141],[0.3,142],[0.4,141],[0.6,133],[0.75,127],[0.81,128],[0.86,60],[0.9,15],[0.95,0]],"totImpulseNs":116,"totalWeightG":145,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":162.7,"burnTimeS":1.02,"caseInfo":"Pro29-3G","certOrg":"Canadian Association of Rocketry","commonName":"H163","dataFiles":2,"delays":"5,7,9,11,14","designation":"166H163-14A","diameter":29,"impulseClass":"H","length":187,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":216.9,"motorId":"5f4294d200023100000002c3","propInfo":"White Thunder","propWeightG":78.2,"samples":[[0,0],[0.018,10],[0.026,225],[0.055,165],[0.1,170],[0.2,175],[0.35,180],[0.9,175],[0.95,100],[0.98,45],[1.062,0]],"totImpulseNs":166.3,"totalWeightG":187,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":254.3,"burnTimeS":0.9,"caseInfo":"Pro29-4G","certOrg":"Canadian Association of Rocketry","commonName":"H255","dataFiles":2,"delays":"5,7,9,11,14","designation":"229H255-14A","diameter":29,"impulseClass":"H","length":231,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":363,"motorId":"5f4294d200023100000002c4","propInfo":"White Thunder","propWeightG":104.3,"samples":[[0,0],[0.018,10],[0.023,345],[0.039,325],[0.05,276],[0.13,287],[0.35,292],[0.75,259],[0.78,265],[0.87,40],[0.936,0]],"totImpulseNs":229.3,"totalWeightG":232,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":399.3,"burnTimeS":0.71,"caseInfo":"Pro29-6G","certOrg":"Canadian Association of Rocketry","commonName":"H399","dataFiles":2,"delays":"3,5,7,9,12","designation":"282H399-12A","diameter":29,"impulseClass":"H","length":320,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":545.8,"motorId":"5f4294d200023100000002c5","propInfo":"White Thunder","propWeightG":132.6,"samples":[[0,0],[0.015,10],[0.02,320],[0.024,555],[0.05,490],[0.075,475],[0.1,468],[0.2,463],[0.53,451],[0.55,460],[0.575,400],[0.64,200],[0.685,25],[0.71,0]],"totImpulseNs":282.2,"totalWeightG":294,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1252,"burnTimeS":1.56,"caseInfo":"AMW 54-1750","certOrg":"Canadian Association of Rocketry","commonName":"K1250","dataFiles":2,"delays":"P","designation":"1951K1250-P","diameter":54,"impulseClass":"K","length":491,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":1661,"motorId":"5f4294d200023100000002c6","propInfo":"Wild Wolf","propWeightG":915,"samples":[[0,0],[0.01,600],[0.02,1400],[0.03,1610],[0.05,1360],[0.07,1410],[0.1,1440],[0.15,1470],[0.2,1480],[0.4,1480],[0.8,1395],[1.28,1185],[1.36,985],[1.4,680],[1.45,570],[1.5,210],[1.6,60],[1.7,0]],"totImpulseNs":1951,"totalWeightG":1815,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":86.7,"burnTimeS":1.94,"caseInfo":"Pro29-3G","certOrg":"Canadian Association of Rocketry","commonName":"H87","dataFiles":2,"delays":"3,5,7,9,12","designation":"168H87-12A","diameter":29,"impulseClass":"H","length":187,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":139.2,"motorId":"5f4294d200023100000002c7","propInfo":"Imax","propWeightG":92.7,"samples":[[0,0],[0.018,5],[0.027,73],[0.032,139.2],[0.048,117],[0.056,87],[0.081,95],[0.147,101],[0.336,103],[0.52,101],[1.6,83],[1.686,81],[1.72,79],[1.778,60],[1.82,38],[1.94,0]],"totImpulseNs":167.9,"totalWeightG":205,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":225.6,"burnTimeS":1.35,"caseInfo":"Pro29-6GXL","certOrg":"Canadian Association of Rocketry","commonName":"H226","dataFiles":2,"delays":"5,7,9,11,14","designation":"305H226-14A","diameter":29,"impulseClass":"H","length":365,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":362.3,"motorId":"5f4294d200023100000002c8","propInfo":"Skidmark","propWeightG":175,"samples":[[0,0],[0.007,9],[0.012,178],[0.017,320],[0.023,362],[0.047,319],[0.08,302],[0.14,291],[0.615,276],[0.95,257.5],[1,215],[1.077,105],[1.18,81],[1.29,31],[1.34,16],[1.5,0]],"sparky":true,"totImpulseNs":305,"totalWeightG":360,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":340.6,"burnTimeS":0.84,"caseInfo":"Pro29-6GXL","certOrg":"Canadian Association of Rocketry","commonName":"H340","dataFiles":2,"delays":"5,7,9,11,14","designation":"287H340-14A","diameter":29,"impulseClass":"H","length":365,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":447.5,"motorId":"5f4294d200023100000002c9","propInfo":"Smoky Sam","propWeightG":206.7,"samples":[[0,0],[0.017,6],[0.024,255],[0.0311,395],[0.035,423],[0.043,447.5],[0.06,398],[0.064,389],[0.075,397.5],[0.25,388],[0.4,382],[0.542,376],[0.62,379],[0.66,400],[0.68,407],[0.705,398],[0.74,248],[0.8,59.5],[0.85,8],[0.9,0]],"totImpulseNs":287.3,"totalWeightG":391,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":52.5,"burnTimeS":2.87,"caseInfo":"Pro38-1G","certOrg":"Canadian Association of Rocketry","commonName":"G50","dataFiles":2,"delays":"6,8,10,12,15","designation":"150G50-15A","diameter":38,"impulseClass":"G","length":127,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":78.8,"motorId":"5f4294d200023100000002ca","propInfo":"Imax","propWeightG":77.7,"samples":[[0,0],[0.02,10],[0.04,58],[0.052,72],[0.07,65],[0.106,43],[0.23,51],[0.4,55],[0.85,57],[1.5,55],[2,51],[2.5,44.5],[2.78,44],[2.86,37],[2.93,20],[3.02,0]],"totImpulseNs":150,"totalWeightG":218,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":101.7,"burnTimeS":2.82,"caseInfo":"Pro38-2G","certOrg":"Canadian Association of Rocketry","commonName":"H100","dataFiles":2,"delays":"6,8,10,12,15","designation":"286H100-15A","diameter":38,"impulseClass":"H","length":186,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":117.9,"motorId":"5f4294d200023100000002cb","propInfo":"Imax","propWeightG":154.4,"samples":[[0,0],[0.016,68],[0.056,116],[0.09,118],[0.14,115],[0.5,116],[0.6,114],[1.25,113],[2.32,99],[2.44,100],[2.55,89],[2.77,0]],"totImpulseNs":286.4,"totalWeightG":327,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":216.1,"burnTimeS":2.94,"caseInfo":"Pro38-5G","certOrg":"Canadian Association of Rocketry","commonName":"I216","dataFiles":2,"delays":"5,7,9,11,14","designation":"636I216-14A","diameter":38,"impulseClass":"I","length":367,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":379.5,"motorId":"5f4294d200023100000002cc","propInfo":"Classic","propWeightG":312.5,"samples":[[0,0],[0.017,35],[0.03,300],[0.035,345],[0.05,325],[0.07,275],[0.14,292],[0.26,296],[0.8,280],[1.1,280.4],[1.62,255],[1.8,226],[2.105,210],[2.2,195],[2.45,80],[2.75,36],[3.1,0]],"totImpulseNs":636.1,"totalWeightG":601,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":638.4,"burnTimeS":4.28,"caseInfo":"Pro54-6GXL","certOrg":"Canadian Association of Rocketry","commonName":"L640","dataFiles":2,"delays":"P","designation":"2772L640-P","diameter":54,"impulseClass":"L","length":649,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1590,"motorId":"5f4294d200023100000002cd","propInfo":"Classic/Dual Thrust","propWeightG":1293,"samples":[[0,0],[0.02,1200],[0.034,1540],[0.07,1300],[0.15,1460],[0.35,1510],[0.65,1540],[0.7,1510],[0.79,800],[0.86,570.3],[3.26,518],[3.55,330],[3.65,318],[4.15,102],[4.5,30],[5,0]],"totImpulseNs":2772,"totalWeightG":2244,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1409,"burnTimeS":3.43,"caseInfo":"Pro75-5G","certOrg":"Canadian Association of Rocketry","commonName":"L1410","dataFiles":2,"delays":"P","designation":"4828L1410-P","diameter":75,"impulseClass":"L","length":757,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1670,"motorId":"5f4294d200023100000002ce","propInfo":"Skidmark","propWeightG":2875,"samples":[[0,0],[0.04,133],[0.065,1200],[0.077,1510],[0.13,1250],[0.35,1400],[1,1530],[1.5,1595],[2,1630],[2.3,1600],[2.6,1510],[2.9,1350],[3.25,1032],[3.4,120],[3.48,0]],"sparky":true,"totImpulseNs":4828,"totalWeightG":5115,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":49.4,"burnTimeS":7.68,"caseInfo":"RMS-38/360","certOrg":"National Association of Rocketry","commonName":"I49","dataFiles":2,"delays":"P","designation":"I49N","diameter":38,"impulseClass":"I","infoUrl":"https://nar.org/SandT/pdf/Aerotech/I49N.pdf","length":184,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":63.7,"motorId":"5f4294d200023100000002cf","propInfo":"Warp 9","propWeightG":205,"samples":[[0,0],[0.008,1.406],[0.025,48.59],[0.093,52.03],[0.429,57.34],[0.665,60.31],[0.841,60.63],[1.06,62.34],[1.295,63.44],[1.556,62.34],[1.825,62.34],[1.994,60.63],[2.212,60.16],[3.003,56.72],[3.785,52.34],[4.349,49.38],[4.997,46.56],[5.998,43.44],[6.393,42.03],[6.831,41.56],[6.999,36.88],[7.083,33.13],[7.184,31.41],[7.369,23.13],[7.495,16.41],[7.764,4.219],[7.882,1.875],[7.941,0]],"totImpulseNs":383,"totalWeightG":398,"type":"reload","updatedOn":"2022-07-23"},{"availability":"regular","avgThrustN":60.8,"burnTimeS":7.99,"caseInfo":"RMS-38/480","certOrg":"National Association of Rocketry","commonName":"I59","dataFiles":2,"delays":"P","designation":"I59WN","diameter":38,"impulseClass":"I","infoUrl":"https://nar.org/SandT/pdf/Aerotech/I59WN.pdf","length":232,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":172.9,"motorId":"5f4294d200023100000002d0","propInfo":"White Lightning/Warp 9","propWeightG":272,"samples":[[0,0],[0.009,0.357],[0.046,138.6],[0.12,150],[0.193,147.9],[0.368,157.9],[0.506,167.9],[0.699,171.1],[0.791,171.8],[0.893,168.6],[1.058,158.2],[1.233,146.4],[1.417,132.1],[1.509,125.7],[1.61,100.4],[1.675,80.36],[1.785,60.36],[1.96,53.57],[2.209,48.57],[2.531,45.36],[2.669,43.21],[3.009,40.71],[3.387,40.71],[4.021,38.93],[4.261,37.5],[4.997,36.43],[6,33.93],[6.883,31.43],[7.003,33.57],[7.187,30.71],[7.334,27.5],[7.574,22.5],[7.96,17.5],[8.117,9.643],[8.319,4.643],[8.604,0]],"totImpulseNs":486,"totalWeightG":487,"type":"reload","updatedOn":"2022-07-23"},{"availability":"regular","avgThrustN":125.3,"burnTimeS":1.27,"caseInfo":"Pro29-3G","certOrg":"Canadian Association of Rocketry","commonName":"G125","dataFiles":2,"delays":"5,7,9,11,14","designation":"159G125-14A","diameter":29,"impulseClass":"G","length":187,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":171.8,"motorId":"5f4294d200023100000002d1","propInfo":"Red Lightning","propWeightG":81.9,"samples":[[0,0],[0.004,15.68],[0.022,170.8],[0.039,116.9],[0.122,142.6],[0.236,149.7],[0.589,142.6],[0.801,131.3],[1.068,122.1],[1.118,107.9],[1.145,78.42],[1.174,43.13],[1.211,21.47],[1.247,8.775],[1.299,0]],"totImpulseNs":159.6,"totalWeightG":194.5,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":233.5,"burnTimeS":1.33,"caseInfo":"Pro29-6G","certOrg":"Canadian Association of Rocketry","commonName":"H233","dataFiles":2,"delays":"7,9,11,14","designation":"311H233-14A","diameter":29,"impulseClass":"H","length":320,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":354.7,"motorId":"5f4294d200023100000002d2","propInfo":"Red Lightning","propWeightG":163.7,"samples":[[0,0],[0.004,98.64],[0.01,263.8],[0.018,348],[0.051,263.8],[0.156,299.2],[0.82,262.4],[0.988,228.5],[1.05,214.5],[1.111,142.4],[1.17,84.22],[1.242,49.32],[1.331,17.68],[1.399,0]],"totImpulseNs":311.5,"totalWeightG":327.6,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1777,"burnTimeS":3.34,"caseInfo":"Pro75-6G","certOrg":"Canadian Association of Rocketry","commonName":"M1770","dataFiles":2,"delays":"P","designation":"5933M1770-P","diameter":75,"impulseClass":"M","length":893,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":2195,"motorId":"5f4294d200023100000002d3","propInfo":"Skidmark","propWeightG":3520,"samples":[[0,0],[0.035,182],[0.05,1005],[0.06,1505],[0.07,1865],[0.108,1765],[0.215,1865],[0.3,1865],[0.4,1845],[0.6,1870],[1,1945],[1.3,1982],[2,1970],[2.7,1800],[2.9,1870],[2.97,1865],[3.1,1350],[3.2,700],[3.26,300],[3.32,100],[3.36,60],[3.48,0]],"sparky":true,"totImpulseNs":5933,"totalWeightG":5993,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1276,"burnTimeS":2.077,"caseInfo":"AMW 54-2550","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1276","dataFiles":2,"delays":"P","designation":"2730L1276-P","diameter":54,"impulseClass":"L","length":728,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":1496,"motorId":"5f4294d200023100000002d4","propInfo":"Red Rhino","propWeightG":1475,"samples":[[0,0],[0.015,76.92],[0.017,692.3],[0.026,1495],[0.037,1244],[0.052,1401],[0.084,1308],[0.127,1308],[0.181,1368],[0.289,1401],[0.384,1408],[0.807,1421],[0.993,1462],[1.215,1492],[1.673,1475],[1.727,1385],[1.798,1084],[1.947,531.8],[1.986,351.2],[2.047,177.3],[2.092,93.65],[2.144,33.45],[2.185,0]],"totImpulseNs":2729,"totalWeightG":2960,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":779.9,"burnTimeS":2.696,"caseInfo":"Pro54-5G","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K780","dataFiles":2,"delays":"5,6,7,8,9,10,11,12,13,14,15","designation":"2108K780-15A","diameter":54,"impulseClass":"K","length":489,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1016,"motorId":"5f4294d200023100000002d5","propInfo":"Blue Streak","propWeightG":1140,"samples":[[0,0],[0.008,15.97],[0.016,511.1],[0.017,1014],[0.039,892.4],[0.065,936.4],[0.094,942.4],[0.153,916.4],[0.205,906.4],[0.294,914.4],[0.455,900.4],[0.718,896.4],[1.016,886.5],[1.38,858.5],[1.799,818.6],[1.913,804.6],[2.072,798.6],[2.225,788.6],[2.272,758.7],[2.34,606.9],[2.379,561],[2.412,495.1],[2.558,211.6],[2.628,141.8],[2.711,77.86],[2.756,0]],"totImpulseNs":2108,"totalWeightG":1700,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":629.1,"burnTimeS":2.677,"caseInfo":"Pro54-4G","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K630","dataFiles":2,"delays":"5,6,7,8,9,10,11,12,13,14,15","designation":"1679K630-15A","diameter":54,"impulseClass":"K","length":405,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":787.3,"motorId":"5f4294d200023100000002d6","propInfo":"Blue Streak","propWeightG":912,"samples":[[0,0],[0.014,164.4],[0.025,676.3],[0.034,791.4],[0.059,781.1],[0.074,674.2],[0.102,705.1],[0.212,713.3],[0.696,715.3],[0.974,721.5],[1.143,709.2],[1.489,680.4],[2.055,629],[2.284,612.6],[2.318,587.9],[2.355,518],[2.389,427.6],[2.417,382.3],[2.471,349.4],[2.51,265.2],[2.57,127.4],[2.598,76.06],[2.646,49.33],[2.816,0]],"totImpulseNs":1679,"totalWeightG":1410,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":448.5,"burnTimeS":2.754,"caseInfo":"Pro54-3G","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J449","dataFiles":2,"delays":"5,6,7,8,9,10,11,12,13,14,15","designation":"1261J449-15A","diameter":54,"impulseClass":"J","length":321,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":589.5,"motorId":"5f4294d200023100000002d7","propInfo":"Blue Streak","propWeightG":624,"samples":[[0,0],[0.012,16.22],[0.021,330.3],[0.027,504.3],[0.046,586.9],[0.055,508.7],[0.07,440.9],[0.137,477.8],[0.241,495.4],[0.348,505.8],[0.69,514.6],[1.153,504.3],[1.938,468.9],[2.292,452.7],[2.417,455.6],[2.475,446.8],[2.505,440.9],[2.52,408.4],[2.566,293.4],[2.612,157.8],[2.688,69.3],[2.771,28.02],[2.847,0]],"totImpulseNs":1261,"totalWeightG":1122,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":292.7,"burnTimeS":2.848,"caseInfo":"Pro54-2G","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J293","dataFiles":2,"delays":"3,4,5,6,7,8,9,10,11,12,13","designation":"838J293-13A","diameter":54,"impulseClass":"J","length":237,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":386.1,"motorId":"5f4294d200023100000002d8","propInfo":"Blue Streak","propWeightG":416,"samples":[[0,0],[0.019,22.85],[0.032,250.3],[0.044,386.3],[0.06,302.2],[0.073,256.5],[0.13,285.6],[0.266,309.5],[0.487,318.8],[0.734,325],[1.432,324],[1.786,309.5],[2.074,294.9],[2.33,280.4],[2.488,273.1],[2.58,272.1],[2.634,258.6],[2.713,163],[2.795,70.62],[2.852,20.77],[2.896,0]],"totImpulseNs":837.9,"totalWeightG":840,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":149.5,"burnTimeS":3.175,"caseInfo":"Pro54-1G","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I150","dataFiles":2,"delays":"1,2,3,4,5,6,7,8,9,10,11","designation":"465I150-11A","diameter":54,"impulseClass":"I","length":153,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":179.2,"motorId":"5f4294d200023100000002d9","propInfo":"Blue Streak","propWeightG":226,"samples":[[0,0],[0.017,11.04],[0.039,103.4],[0.045,164.8],[0.065,179.9],[0.09,153.4],[0.166,162.6],[0.194,161.9],[0.303,169.3],[0.483,171.8],[0.666,173.3],[0.834,171.5],[1.275,168.5],[1.725,156],[2.559,128.1],[2.77,122.5],[2.899,118.9],[2.978,119.2],[3.003,99.35],[3.034,82.79],[3.087,66.23],[3.16,19.5],[3.208,0]],"totImpulseNs":465.1,"totalWeightG":570,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":218.3,"burnTimeS":2.251,"caseInfo":"Pro54-1G","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I218","dataFiles":2,"delays":"4,5,6,7,8,9,10,11,12,13,14","designation":"491I218-14A","diameter":54,"impulseClass":"I","length":153,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":294.2,"motorId":"5f4294d200023100000002da","propInfo":"White Thunder","propWeightG":230,"samples":[[0,0],[0.01,12.22],[0.022,129.8],[0.047,215.9],[0.072,250.8],[0.079,208.4],[0.11,234],[0.188,249.1],[0.436,263.7],[0.783,259],[1.195,235.7],[1.614,201.4],[1.834,191.5],[1.964,183.9],[2.074,178.1],[2.143,179.8],[2.172,87.88],[2.188,50.05],[2.217,18.62],[2.252,0]],"totImpulseNs":491.2,"totalWeightG":580,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":250,"burnTimeS":2.732,"caseInfo":"Pro54-2G","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J250","dataFiles":2,"delays":"6,7,8,9,10,11,12,13,14,15","designation":"683J250-15A","diameter":54,"impulseClass":"J","length":237,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":337.6,"motorId":"5f4294d200023100000002db","propInfo":"Skidmark","propWeightG":406,"samples":[[0,0],[0.031,191.5],[0.051,271.1],[0.082,161.1],[0.148,206.7],[0.3,234.4],[0.413,244.3],[0.635,264.8],[0.849,270.2],[1.06,276.5],[1.449,283.6],[1.644,277.4],[1.8,279.2],[1.932,272.9],[2.135,261.3],[2.291,249.6],[2.447,247],[2.525,251.4],[2.579,227.3],[2.614,157.5],[2.665,51.9],[2.727,14.32],[2.825,6.263],[2.965,0]],"sparky":true,"totImpulseNs":682.8,"totalWeightG":830,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":577.4,"burnTimeS":1.553,"caseInfo":"Pro38-6GXL","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J580","dataFiles":2,"delays":"8,10,12,14,17","designation":"896J580-17A","diameter":38,"impulseClass":"J","length":510,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":691.5,"motorId":"5f4294d200023100000002dc","propInfo":"Smoky Sam","propWeightG":588,"samples":[[0,0],[0.006,82.31],[0.013,461],[0.016,692.9],[0.031,600.1],[0.041,634.6],[0.058,624.1],[0.243,621.1],[0.405,621.1],[0.511,631.6],[0.632,646.5],[0.898,672],[1.019,686.9],[1.098,691.4],[1.163,675],[1.229,514.8],[1.325,496.9],[1.36,446],[1.405,332.2],[1.461,221.5],[1.518,71.84],[1.559,28.43],[1.59,8.98],[1.613,0]],"totImpulseNs":896.4,"totalWeightG":1044,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":603.5,"burnTimeS":1.655,"caseInfo":"Pro38-6GXL","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J600","dataFiles":2,"delays":"7,9,11,13,16","designation":"999J600-16A","diameter":38,"impulseClass":"J","length":510,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":721,"motorId":"5f4294d200023100000002dd","propInfo":"Red Lightning","propWeightG":551,"samples":[[0,0],[0.011,533.3],[0.023,683.3],[0.029,721.9],[0.051,721.9],[0.091,701.2],[0.202,701.2],[0.376,696.7],[0.572,698.2],[0.72,696.7],[0.847,698.2],[0.963,711.5],[1.028,720.5],[1.109,710.1],[1.19,698.2],[1.245,681.8],[1.304,610.5],[1.385,420.4],[1.408,371.4],[1.515,147.1],[1.61,62.39],[1.716,0]],"totImpulseNs":998.6,"totalWeightG":906,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":150.8,"burnTimeS":1.38,"caseInfo":"Pro29-4G","certOrg":"Canadian Association of Rocketry","commonName":"H151","dataFiles":2,"delays":"6,8,10,12,15","designation":"207H151-15A","diameter":29,"impulseClass":"H","length":231,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":214.8,"motorId":"5f4294d200023100000002de","propInfo":"Red Lightning","propWeightG":109.1,"samples":[[0,0],[0.008,125.3],[0.021,209.6],[0.052,160.9],[0.118,186.8],[0.293,190.7],[0.465,183.5],[0.683,171.6],[0.988,145.6],[1.133,134.1],[1.221,74.29],[1.293,29.81],[1.372,10.01],[1.398,6.521],[1.4,0]],"totImpulseNs":207.2,"totalWeightG":238,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":194.3,"burnTimeS":1.34,"caseInfo":"Pro29-5G","certOrg":"Canadian Association of Rocketry","commonName":"H194","dataFiles":2,"delays":"7,9,11,14","designation":"260H194-14A","diameter":29,"impulseClass":"H","length":276,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":292,"motorId":"5f4294d200023100000002df","propInfo":"Red Lightning","propWeightG":136.4,"samples":[[0,0],[0.006,179.8],[0.011,244.1],[0.021,286],[0.049,204.9],[0.117,233.8],[0.181,241.3],[0.386,236.2],[0.98,193.8],[1.075,170.5],[1.136,144.4],[1.19,80.58],[1.285,22.82],[1.347,0]],"totImpulseNs":260.3,"totalWeightG":284,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1304,"burnTimeS":4.94,"caseInfo":"Pro75-5G","certOrg":"Canadian Association of Rocketry","commonName":"M1300","dataFiles":2,"delays":"P","designation":"6438M1300-P","diameter":75,"impulseClass":"M","length":757,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":2827,"motorId":"5f4294d200023100000002e0","propInfo":"Imax/Dual Thrust","propWeightG":3437,"samples":[[0,0],[0.009,394.1],[0.057,934.8],[0.086,2146],[0.154,2615],[0.314,2827],[0.671,2759],[0.97,2752],[1.082,1173],[1.187,1120],[2.14,1173],[2.7,1140],[3.884,915.2],[4.372,771.9],[4.6,400.6],[4.697,335.5],[4.9,120.5],[4.901,0]],"totImpulseNs":6738,"totalWeightG":5657,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":4127,"burnTimeS":4.31,"caseInfo":"Pro98-6GXL","certOrg":"Canadian Association of Rocketry","commonName":"N4100","dataFiles":2,"delays":"P","designation":"17790N4100-P","diameter":98,"impulseClass":"N","length":1239,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":4797,"motorId":"5f4294d200023100000002e1","propInfo":"Red Lightning","propWeightG":9101,"samples":[[0,0],[0.003,203.9],[0.05,2363],[0.078,3947],[0.121,4281],[0.652,4370],[1.123,4454],[1.655,4773],[2.353,4621],[3.035,4511],[3.7,4376],[3.733,4182],[3.887,2969],[4.036,1589],[4.197,533.2],[4.262,240.5],[4.3,0]],"totImpulseNs":17790,"totalWeightG":14750,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1633,"burnTimeS":5.03,"caseInfo":"ABC 75-7600","certOrg":"Canadian Association of Rocketry","commonName":"M1630","dataFiles":2,"delays":"P","designation":"8212M1630-P","diameter":75,"impulseClass":"M","length":1039,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":6805,"motorId":"5f4294d200023100000002e2","propInfo":"Tamed Tiger","propWeightG":3948,"samples":[[0,0],[0.003,147.5],[0.032,2041],[0.078,3235],[0.158,3368],[0.463,3259],[0.647,2992],[0.949,2697],[1.052,2041],[1.101,1884],[1.392,1908],[1.786,1813],[3.6,1327],[3.899,875.4],[4.595,347.3],[4.857,195.1],[4.891,166.5],[4.9,0]],"totImpulseNs":8212,"totalWeightG":7237,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":13.39,"burnTimeS":1.4,"certOrg":"National Association of Rocketry","commonName":"D10","dataFiles":2,"delays":"3,5,7","designation":"D10W","diameter":18,"impulseClass":"D","infoUrl":"https://nar.org/SandT/pdf/Aerotech/D10.pdf","length":70,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":25.13,"motorId":"5f4294d200023100000002e3","propInfo":"White Lightning","propWeightG":9.8,"samples":[[0,0],[0.007,23],[0.018,25],[0.027,20.25],[0.066,20.25],[0.073,18.5],[0.094,20.25],[0.112,20.75],[0.137,19.75],[0.163,21.5],[0.202,20.75],[0.231,20.75],[0.254,22.75],[0.27,20.75],[0.504,20],[0.536,18.25],[0.607,17],[0.687,14.75],[0.751,14.25],[0.84,11.25],[0.998,8.25],[1.024,8.25],[1.248,2.5],[1.385,0]],"totImpulseNs":18.75,"totalWeightG":25.9,"type":"SU","updatedOn":"2022-07-20"},{"availability":"regular","avgThrustN":1141,"burnTimeS":3.7,"caseInfo":"RMS-75/5120","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1170","dataFiles":2,"delays":"P","designation":"L1170FJ","diameter":75,"impulseClass":"L","length":665,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1489,"motorId":"5f4294d200023100000002e4","propInfo":"Black Max","propWeightG":2800,"samples":[[0,0],[0.031,992.6],[0.072,1400],[0.113,1473],[0.144,1390],[0.351,1285],[1.495,1431],[1.856,1431],[2.227,1358],[2.753,1202],[2.928,1170],[3,1066],[3.113,679.2],[3.247,355.3],[3.361,177.6],[3.464,83.59],[3.67,0]],"totImpulseNs":4232,"totalWeightG":4990,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":362.3,"burnTimeS":2.804,"caseInfo":"Pro54-3G","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J360","dataFiles":2,"delays":"5,6,7,8,9,10,11,12,13,14,15","designation":"1016J360-15A","diameter":54,"impulseClass":"J","length":321,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":559.3,"motorId":"5f4294d200023100000002e5","propInfo":"Skidmark","propWeightG":606,"samples":[[0,0],[0.017,560.7],[0.058,287.4],[0.167,328.2],[0.358,363.7],[0.538,374.4],[0.85,397.4],[1.163,401],[1.458,401],[1.733,395.7],[1.983,381.5],[2.271,356.6],[2.496,340.6],[2.592,351.3],[2.646,289.2],[2.679,172.1],[2.725,86.94],[2.804,19.52],[2.904,5.323],[2.975,0]],"sparky":true,"totImpulseNs":1016,"totalWeightG":1104,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":595.4,"burnTimeS":1.654,"caseInfo":"Pro38-6GXL","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J595","dataFiles":2,"delays":"7,9,11,13,16","designation":"985J595-16A","diameter":38,"impulseClass":"J","length":510,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":925.4,"motorId":"5f4294d200023100000002e6","propInfo":"Blue Streak","propWeightG":511,"samples":[[0,0],[0.009,644.4],[0.015,925],[0.032,868.9],[0.075,752.5],[0.168,729.6],[0.315,719.2],[0.475,713],[0.632,713],[0.775,704.6],[0.897,702.6],[0.979,700.5],[1.109,683.9],[1.178,600.7],[1.226,507.2],[1.293,411.6],[1.451,270.2],[1.529,205.8],[1.614,112.2],[1.644,58.2],[1.707,0]],"totImpulseNs":985,"totalWeightG":866,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":426.9,"burnTimeS":1.837,"caseInfo":"Pro38-6G","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J425","dataFiles":1,"delays":"7,9,11,13,16","designation":"784J425-16A","diameter":38,"impulseClass":"J","length":419,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":631,"motorId":"5f4294d200023100000002e7","propInfo":"Blue Streak","propWeightG":405,"samples":[[0,0],[0.006,4.399],[0.01,92.39],[0.011,272.8],[0.012,434.1],[0.013,507.4],[0.016,589.5],[0.02,668.7],[0.021,720],[0.027,659.9],[0.037,632],[0.053,589.5],[0.069,566],[0.098,554.3],[0.135,552.9],[0.167,548.5],[0.206,547],[0.251,542.6],[0.289,542.6],[0.326,538.2],[0.369,533.8],[0.41,526.5],[0.455,527.9],[0.489,523.5],[0.508,520.6],[0.524,520.6],[0.561,517.7],[0.589,522.1],[0.62,517.7],[0.656,513.3],[0.687,510.3],[0.72,505.9],[0.75,507.4],[0.787,505.9],[0.818,504.5],[0.856,500.1],[0.887,495.7],[0.919,494.2],[0.952,492.7],[0.987,489.8],[1.017,489.8],[1.05,485.4],[1.078,482.5],[1.113,482.5],[1.146,479.5],[1.18,479.5],[1.217,472.2],[1.252,473.7],[1.288,470.7],[1.321,464.9],[1.348,451.7],[1.366,431.1],[1.382,401.8],[1.395,378.3],[1.407,357.8],[1.421,338.7],[1.445,325.6],[1.476,313.8],[1.498,300.6],[1.521,278.6],[1.541,249.3],[1.556,224.4],[1.568,206.8],[1.58,184.8],[1.596,161.3],[1.607,140.8],[1.625,117.3],[1.641,93.85],[1.67,73.32],[1.69,63.06],[1.717,52.79],[1.745,48.39],[1.772,45.46],[1.796,42.53],[1.821,42.53],[1.849,38.13],[1.884,29.33],[1.906,26.4],[1.929,19.06],[1.955,16.13],[1.978,10.27],[1.996,0]],"totImpulseNs":783.9,"totalWeightG":700,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":357,"burnTimeS":1.845,"caseInfo":"Pro38-5G","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J357","dataFiles":2,"delays":"8,10,12,14,17","designation":"658J357-17A","diameter":38,"impulseClass":"J","length":260,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":512.3,"motorId":"5f4294d200023100000002e8","propInfo":"Blue Streak","propWeightG":337,"samples":[[0,0],[0.019,514.4],[0.042,502.8],[0.054,446.5],[0.073,434.9],[0.122,433.5],[0.258,430.6],[0.474,427.7],[0.952,404.6],[1.236,381.5],[1.386,372.8],[1.454,367],[1.487,345.3],[1.515,317.9],[1.552,268.8],[1.615,196.5],[1.655,134.4],[1.721,49.13],[1.758,26.01],[1.824,0]],"totImpulseNs":657.6,"totalWeightG":601,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":303.2,"burnTimeS":1.774,"caseInfo":"Pro38-4G","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I303","dataFiles":2,"delays":"7,9,11,13,16","designation":"538I303-16A","diameter":38,"impulseClass":"I","length":302,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":415.6,"motorId":"5f4294d200023100000002e9","propInfo":"Blue Streak","propWeightG":270,"samples":[[0,0],[0.035,415.8],[0.053,402.4],[0.054,329.7],[0.072,324.1],[0.109,348.7],[0.18,353.2],[0.28,357.6],[0.432,354.3],[0.557,353.2],[0.684,348.7],[0.886,337.5],[1.054,325.2],[1.212,310.7],[1.371,299.5],[1.475,292.8],[1.519,277.2],[1.542,245.9],[1.568,204.5],[1.609,149.8],[1.639,108.4],[1.757,50.29],[1.827,22.35],[1.887,0]],"totImpulseNs":537.6,"totalWeightG":500,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":236.3,"burnTimeS":1.753,"caseInfo":"Pro38-3G","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I236","dataFiles":2,"delays":"8,10,12,14,17","designation":"413I236-17A","diameter":38,"impulseClass":"I","length":243,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":313.7,"motorId":"5f4294d200023100000002ea","propInfo":"Blue Streak","propWeightG":204,"samples":[[0,0],[0.028,290.8],[0.042,313.6],[0.049,267.9],[0.053,253.6],[0.072,246],[0.095,257],[0.127,262],[0.153,266.3],[0.243,268.8],[0.338,269.6],[0.454,270.5],[0.633,266.3],[0.753,262.9],[0.89,256.1],[1.01,251.9],[1.119,247.7],[1.277,236.7],[1.353,231.6],[1.453,227.4],[1.525,225.7],[1.555,195.3],[1.581,158.9],[1.618,119.2],[1.685,89.6],[1.729,56.63],[1.743,36.35],[1.766,21.98],[1.81,0]],"totImpulseNs":413,"totalWeightG":400,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":152.4,"burnTimeS":1.914,"caseInfo":"Pro38-2G","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H152","dataFiles":2,"delays":"6,8,10,12,15","designation":"276H152-15A","diameter":38,"impulseClass":"H","length":185,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":212.4,"motorId":"5f4294d200023100000002eb","propInfo":"Blue Streak","propWeightG":138,"samples":[[0,0],[0.018,212.5],[0.051,207.4],[0.059,153.1],[0.077,153.1],[0.099,163.2],[0.139,167],[0.168,174.6],[0.223,173.3],[0.256,175.8],[0.304,175.8],[0.396,179.6],[0.538,175.8],[0.659,174.6],[0.714,174.6],[0.758,174.6],[0.802,170.8],[0.89,172],[0.974,165.7],[1.022,168.2],[1.084,163.2],[1.212,155.6],[1.293,151.8],[1.385,146.7],[1.447,149.3],[1.484,144.2],[1.531,145.5],[1.575,144.2],[1.601,137.9],[1.615,134.1],[1.623,120.2],[1.663,82.22],[1.714,46.8],[1.766,34.15],[1.788,30.36],[1.821,26.56],[1.828,0]],"totImpulseNs":275.9,"totalWeightG":298,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":78.41,"burnTimeS":1.801,"caseInfo":"Pro38-1G","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G78","dataFiles":1,"delays":"6,8,10,12,15","designation":"141G78-15A","diameter":38,"impulseClass":"G","length":126,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":137.3,"motorId":"5f4294d200023100000002ec","propInfo":"Blue Streak","propWeightG":69,"samples":[[0,0],[0.006,104.1],[0.018,137.9],[0.036,70.71],[0.047,62.24],[0.084,73.69],[0.135,78.18],[0.238,84.15],[0.438,89.63],[0.63,88.14],[0.859,87.14],[1.283,77.18],[1.447,70.71],[1.643,67.72],[1.713,64.23],[1.743,54.27],[1.79,18.42],[1.818,6.473],[1.852,0]],"totImpulseNs":140.9,"totalWeightG":197,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":519.4,"burnTimeS":1.634,"caseInfo":"Pro38-6GXL","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J520","dataFiles":2,"delays":"7,9,11,13,16","designation":"848J520-16A","diameter":38,"impulseClass":"J","length":510,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":658.2,"motorId":"5f4294d200023100000002ed","propInfo":"Skidmark","propWeightG":498,"samples":[[0,0],[0.034,658.7],[0.076,615],[0.12,585.8],[0.225,580.5],[0.533,622.9],[0.724,626.9],[0.83,612.3],[0.982,607],[1.17,595.1],[1.259,569.9],[1.296,458.6],[1.329,405.6],[1.378,388.3],[1.418,302.2],[1.461,197.5],[1.493,135.2],[1.529,87.47],[1.587,45.06],[1.756,0]],"sparky":true,"totImpulseNs":848.4,"totalWeightG":850,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":976,"burnTimeS":1.25,"caseInfo":"38/1200","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J1000","dataFiles":2,"delays":"7,9,12,15","designation":"J1000-LW","diameter":38,"impulseClass":"J","length":625,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":1400,"motorId":"5f4294d200023100000002ee","propInfo":"Loki White","propWeightG":573,"samples":[[0,0],[0.01456,1400],[0.1,1350],[0.2,1300],[0.4,1300],[0.6,1335],[0.7,1272],[0.8,1135],[1,395.8],[1.1,105.5],[1.25,0]],"totImpulseNs":1220,"totalWeightG":1143,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":500,"burnTimeS":6.4,"caseInfo":"76/3600","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L480","dataFiles":2,"delays":"P","designation":"L480-LR","diameter":76,"impulseClass":"L","length":498,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":567,"motorId":"5f4294d200023100000002ef","propInfo":"Loki Red","propWeightG":1814,"samples":[[0,0],[0.02,419.5],[1,509.2],[2,551.5],[3,567.3],[4,564.6],[5,522.4],[6,401.1],[6.4,0]],"totImpulseNs":3200,"totalWeightG":3538,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":920,"burnTimeS":6,"caseInfo":"76/6000","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M900","dataFiles":2,"delays":"P","designation":"M900-LR","diameter":76,"impulseClass":"M","length":785,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":1060,"motorId":"5f4294d200023100000002f0","propInfo":"Loki Red","propWeightG":3130,"samples":[[0,0],[0.02,807.4],[1,992.1],[2,1050],[3,1061],[4,992.1],[5,923.5],[5.5,591],[6,0]],"totImpulseNs":5477,"totalWeightG":5530,"type":"reload","updatedOn":"2019-11-22"},{"availability":"regular","avgThrustN":2946,"burnTimeS":3,"caseInfo":"76/8000","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M3000","dataFiles":2,"delays":"P","designation":"M3000-LW","diameter":76,"impulseClass":"M","length":1038,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":4780,"motorId":"5f4294d200023100000002f1","propInfo":"Loki White","propWeightG":4350,"samples":[[0,0],[0.01,4781],[0.5,3857],[1.25,3984],[2,2644],[2.5,1224],[3,0]],"totImpulseNs":8838,"totalWeightG":7160,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":3851,"burnTimeS":3.25,"caseInfo":"98/12500","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"N3800","dataFiles":2,"delays":"P","designation":"N3800-LW","diameter":98,"impulseClass":"N","length":1016,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":4965,"motorId":"5f4294d200023100000002f2","propInfo":"Loki White","propWeightG":6125,"samples":[[0,0],[0.01,4781],[0.5,4573],[1,4688],[1.5,4965],[2,3972],[2.5,3002],[3,1986],[3.25,0]],"totImpulseNs":12500,"totalWeightG":11600,"type":"reload","updatedOn":"2021-07-04"},{"availability":"regular","avgThrustN":69,"burnTimeS":1.6,"caseInfo":"38/120","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G69","dataFiles":2,"delays":"5,8,10,13,17","designation":"HP-G69-SF","diameter":38,"impulseClass":"G","infoUrl":"https://www.lokiresearch.com/images/Documents/38mm%20Spitfire.pdf","length":127,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":97,"motorId":"5f4294d200023100000002f3","propInfo":"Spitfire","propWeightG":63,"samples":[[0,0],[0.01,97.92],[0.2,96.54],[0.4,94.23],[0.7995,76.67],[1.2,58.2],[1.6,0]],"sparky":true,"totImpulseNs":110,"totalWeightG":240,"type":"reload","updatedOn":"2021-07-24"},{"availability":"regular","avgThrustN":28.9,"burnTimeS":1.9,"caseInfo":"Pro29-1G","certOrg":"Canadian Association of Rocketry","commonName":"F29","dataFiles":2,"delays":"3,5,7,9,12","designation":"55F29-12A","diameter":29,"impulseClass":"F","length":98,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":36,"motorId":"5f4294d200023100000002f4","propInfo":"Imax","propWeightG":30.9,"samples":[[0,0],[0.006,5.661],[0.038,23.31],[0.05,26.31],[0.229,30.26],[0.327,32.21],[0.485,33.16],[1.031,31.78],[1.516,27.07],[1.688,24.83],[1.765,20.17],[1.852,9.467],[1.963,2.093],[2,0]],"totImpulseNs":54.8,"totalWeightG":105.8,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":223.8,"burnTimeS":1.7,"caseInfo":"Pro29-6GXL","certOrg":"Canadian Association of Rocketry","commonName":"I224","dataFiles":2,"delays":"6,8,10,12,15","designation":"381I224-15A","diameter":29,"impulseClass":"I","length":365,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":454.4,"motorId":"5f4294d200023100000002f5","propInfo":"Classic","propWeightG":182.5,"samples":[[0,0],[0.008,357.5],[0.02,433.1],[0.111,343.8],[0.229,318.9],[0.479,295.9],[0.836,277.1],[1.022,269.6],[1.097,233.9],[1.233,117.9],[1.294,93],[1.39,62],[1.667,26.77],[1.692,17.38],[1.7,0]],"totImpulseNs":381.5,"totalWeightG":370,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":933.8,"burnTimeS":3.371,"caseInfo":"Pro54-6GXL","certOrg":"Canadian Association of Rocketry","commonName":"L935","dataFiles":2,"delays":"P","designation":"3147L935-P","diameter":54,"impulseClass":"L","length":649,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1586,"motorId":"5f4294d200023100000002f6","propInfo":"Imax","propWeightG":1567,"samples":[[0,0],[0.012,1583],[0.052,1366],[0.159,1278],[2.198,990.3],[2.514,719.4],[3.021,239.8],[3.104,160.8],[3.273,107.2],[3.3,0]],"totImpulseNs":3147,"totalWeightG":2542,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":1786,"burnTimeS":4.53,"caseInfo":"Pro98-4G","certOrg":"Canadian Association of Rocketry","commonName":"M1790","dataFiles":2,"designation":"8088M1790-P","diameter":98,"impulseClass":"M","length":702,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":2093,"motorId":"5f4294d200023100000002f7","propInfo":"Skidmark","propWeightG":4706,"samples":[[0,0],[0.059,1792],[0.199,1596],[0.6,1782],[1.215,1914],[1.973,2022],[2.742,1970],[3.387,1834],[3.812,1653],[4.28,1556],[4.385,1295],[4.476,355],[4.541,91.69],[4.597,0]],"sparky":true,"totImpulseNs":8089,"totalWeightG":8273,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":2586,"burnTimeS":4.28,"caseInfo":"Pro98-6G","certOrg":"Canadian Association of Rocketry","commonName":"N2600","dataFiles":2,"designation":"11077N2600-P","diameter":98,"impulseClass":"N","length":1010,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":3048,"motorId":"5f4294d200023100000002f8","propInfo":"Skidmark","propWeightG":6618,"samples":[[0,0],[0.063,2794],[0.199,2498],[0.485,2620],[0.907,2778],[1.367,2903],[1.749,2949],[2.051,2972],[2.764,2817],[3.549,2392],[3.767,2310],[3.958,2386],[4.177,639.2],[4.265,138.4],[4.297,0]],"sparky":true,"totImpulseNs":11080,"totalWeightG":11480,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":3403,"burnTimeS":4.19,"caseInfo":"Pro98-6GXL","certOrg":"Canadian Association of Rocketry","commonName":"N3400","dataFiles":2,"designation":"14263N3400-P","diameter":98,"impulseClass":"N","length":1239,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":3742,"motorId":"5f4294d200023100000002f9","propInfo":"Skidmark","propWeightG":8282,"samples":[[0,0],[0.055,3602],[0.177,3060],[0.608,3397],[1.537,3811],[2.252,3974],[2.86,3760],[3.152,3598],[3.545,3346],[3.71,3628],[3.837,2868],[3.884,1908],[3.999,1511],[4.188,273.2],[4.28,81.09],[4.3,0]],"sparky":true,"totImpulseNs":14260,"totalWeightG":13970,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":1526,"burnTimeS":4.97,"caseInfo":"Pro98-3G","certOrg":"Canadian Association of Rocketry","commonName":"M1520","dataFiles":2,"designation":"7579M1520-P","diameter":98,"impulseClass":"M","length":548,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1825,"motorId":"5f4294d200023100000002fa","propInfo":"Blue Streak","propWeightG":2981,"samples":[[0,0],[0.04,1428],[0.082,1706],[0.176,1620],[0.748,1734],[1.652,1827],[2.676,1716],[3.89,1423],[4.399,1405],[4.616,661.7],[4.877,69.65],[4.897,0]],"totImpulseNs":7579,"totalWeightG":6718,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":1797,"burnTimeS":5.49,"caseInfo":"Pro98-4G","certOrg":"Canadian Association of Rocketry","commonName":"M1800","dataFiles":2,"designation":"9870M1800-P","diameter":98,"impulseClass":"M","length":702,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":2241,"motorId":"5f4294d200023100000002fb","propInfo":"Blue Streak","propWeightG":4802,"samples":[[0,0],[0.02,1873],[0.059,2177],[0.265,1933],[1.312,2078],[1.826,2109],[3.07,2010],[4.468,1751],[4.674,1737],[4.89,1023],[5.178,451.9],[5.384,318.3],[5.548,99.48],[5.6,0]],"totImpulseNs":9870,"totalWeightG":8342,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":2836,"burnTimeS":4.85,"caseInfo":"Pro98-6G","certOrg":"Canadian Association of Rocketry","commonName":"N2850","dataFiles":2,"designation":"13767N2850-P","diameter":98,"impulseClass":"N","length":1010,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":3377,"motorId":"5f4294d200023100000002fc","propInfo":"Blue Streak","propWeightG":6759,"samples":[[0,0],[0.003,286.9],[0.085,3152],[0.185,3104],[0.322,3078],[0.945,3212],[1.725,3313],[2.819,3119],[4.163,2776],[4.376,1982],[4.538,845.9],[4.763,436],[4.849,149.1],[4.9,0]],"totImpulseNs":13770,"totalWeightG":11690,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":2868,"burnTimeS":6.14,"caseInfo":"Pro98-6GXL","certOrg":"Canadian Association of Rocketry","commonName":"N2900","dataFiles":2,"designation":"17613N2900-P","diameter":98,"impulseClass":"N","length":1239,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":4165,"motorId":"5f4294d200023100000002fd","propInfo":"Classic","propWeightG":8449,"samples":[[0,0],[0.026,1864],[0.074,3605],[0.122,4022],[0.361,3619],[1.18,3498],[1.981,3587],[3.493,3156],[4.648,2875],[4.939,2322],[5.205,1648],[5.629,945.8],[5.972,430.8],[6.219,206],[6.278,149.8],[6.296,0]],"totImpulseNs":17610,"totalWeightG":14170,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":1230,"burnTimeS":4.48,"caseInfo":"Pro75-4G","certOrg":"Canadian Association of Rocketry","commonName":"M1230","dataFiles":2,"designation":"5506M1230-P","diameter":75,"impulseClass":"M","length":621,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1587,"motorId":"5f4294d200023100000002fe","propInfo":"Imax","propWeightG":2900,"samples":[[0,0],[0.117,270.3],[0.144,912.8],[0.212,1296],[0.408,1444],[1.087,1498],[1.767,1507],[2.403,1435],[2.949,1315],[3.352,1209],[3.648,1118],[3.909,868.4],[4.409,201.8],[4.586,111.1],[4.67,79.61],[4.7,0]],"totImpulseNs":5507,"totalWeightG":4844,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":2147,"burnTimeS":3.47,"caseInfo":"Pro75-6G","certOrg":"Canadian Association of Rocketry","commonName":"M2150","dataFiles":2,"designation":"7455M2150-P","diameter":75,"impulseClass":"M","length":893,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":2614,"motorId":"5f4294d200023100000002ff","propInfo":"Red Lightning","propWeightG":3835,"samples":[[0,0],[0.027,999.5],[0.067,1877],[0.135,2287],[0.239,2414],[0.451,2345],[0.796,2425],[1.193,2611],[1.75,2381],[2.33,2229],[2.908,2190],[3.316,703.2],[3.461,138.4],[3.49,74.75],[3.5,0]],"totImpulseNs":7455,"totalWeightG":6324,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":2047,"burnTimeS":3.61,"caseInfo":"Pro75-6G","certOrg":"Canadian Association of Rocketry","commonName":"M2045","dataFiles":2,"designation":"7388M2045-P","diameter":75,"impulseClass":"M","length":893,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":2952,"motorId":"5f4294d20002310000000300","propInfo":"Blue Streak","propWeightG":3547,"samples":[[0,0],[0.004,556.9],[0.019,1690],[0.063,2359],[0.153,2339],[0.182,2570],[0.247,2471],[0.616,2498],[1.028,2547],[2.111,2316],[2.551,2274],[2.635,2254],[2.796,1697],[3.009,1473],[3.349,247.1],[3.541,108.7],[3.587,0]],"totImpulseNs":7388,"totalWeightG":6071,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":2050,"burnTimeS":3.31,"caseInfo":"ABC 75-7600","certOrg":"Canadian Association of Rocketry","commonName":"M2050","dataFiles":2,"designation":"6774M2050-P","diameter":75,"impulseClass":"M","length":1039,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":2554,"motorId":"5f4294d20002310000000301","propInfo":"Skidmark","propWeightG":3870,"samples":[[0,0],[0.038,2153],[0.833,2506],[1.189,2539],[1.546,2501],[1.775,2415],[1.907,2280],[2.168,2087],[2.401,1973],[2.616,1910],[2.776,1871],[2.918,1203],[3.056,706.6],[3.309,135.2],[3.4,0]],"sparky":true,"totImpulseNs":6775,"totalWeightG":7129,"type":"reload","updatedOn":"2021-06-13"},{"availability":"OOP","avgThrustN":981,"burnTimeS":2.17,"caseInfo":"54/2550","certOrg":"National Association of Rocketry","commonName":"K980","dataFiles":1,"delays":"P","designation":"K980BL","diameter":54,"impulseClass":"K","length":728,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":1297,"motorId":"5f4294d20002310000000302","propInfo":"Black Lightning","propWeightG":1230,"samples":[[0,0],[0.05,1186],[0.07,1022],[0.25,1135],[0.35,1200],[0.5,1225],[0.75,1297],[0.91,1266],[1.1,1202],[1.58,1046],[1.65,1068],[1.7,1001],[1.8,495],[2,222.5],[2.17,0]],"sparky":true,"totImpulseNs":2123,"totalWeightG":2457,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":464,"burnTimeS":5.28,"caseInfo":"54/2550","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K470","dataFiles":1,"delays":"P","designation":"K470WC","diameter":54,"impulseClass":"K","length":728,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":1050,"motorId":"5f4294d20002310000000303","propInfo":"White Cloud","propWeightG":1400,"samples":[[0,0],[0.025,1001],[0.175,905],[0.45,1050],[0.65,827.7],[1.091,716.5],[1.633,623],[5.275,0]],"totImpulseNs":2450,"totalWeightG":2327,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1075,"burnTimeS":2.24,"caseInfo":"54/2550","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K1075","dataFiles":1,"delays":"P","designation":"K1075RT","diameter":54,"impulseClass":"K","length":728,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":1247,"motorId":"5f4294d20002310000000304","propInfo":"Red Twister","propWeightG":1314,"samples":[[0,0],[0.017,687.7],[0.042,1027],[0.134,1121],[0.242,1171],[0.325,1204],[1.225,1247],[1.659,1239],[1.742,1223],[1.8,1123],[2.24,0]],"totImpulseNs":2413,"totalWeightG":2541,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":699,"burnTimeS":3.84,"caseInfo":"75/3500","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L695","dataFiles":1,"delays":"P","designation":"L695BL","diameter":75,"impulseClass":"L","length":497,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":1064,"motorId":"5f4294d20002310000000305","propInfo":"Black Lightning","propWeightG":1650,"samples":[[0,0],[0.01,333.6],[0.05,378.1],[0.4959,560.3],[0.995,724.1],[1.497,883.6],[1.99,1043],[2.131,1065],[2.269,1065],[2.505,1065],[2.64,1043],[2.762,965.5],[2.954,797.4],[3.176,512.9],[3.365,288.8],[3.691,38.79],[3.84,0]],"sparky":true,"totImpulseNs":2669,"totalWeightG":3402,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":424,"burnTimeS":7.95,"caseInfo":"75/3500","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L425","dataFiles":1,"delays":"P","designation":"L425WC","diameter":75,"impulseClass":"L","length":497,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":756,"motorId":"5f4294d20002310000000306","propInfo":"White Cloud","propWeightG":1750,"samples":[[0,0],[0.02,756.2],[0.05,711.7],[0.125,756.2],[0.1808,689.6],[0.3616,662.1],[0.5141,644.8],[0.9548,631],[1.282,620.7],[2.006,586.2],[2.963,524.1],[4.426,427.6],[5.461,341.4],[6.572,224.1],[7.376,110.3],[7.95,0]],"totImpulseNs":3372,"totalWeightG":3502,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1149,"burnTimeS":3.11,"caseInfo":"75/3500","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1150","dataFiles":1,"delays":"P","designation":"L1150WC","diameter":75,"impulseClass":"L","length":497,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":1757,"motorId":"5f4294d20002310000000307","propInfo":"White Cloud","propWeightG":1750,"samples":[[0,0],[0.1,1001],[0.2,1068],[0.5,1179],[1.25,1668],[1.5,1757],[1.7,1735],[2,1334],[2.25,982.7],[2.5,711.7],[2.75,556],[3,266.9],[3.11,0]],"totImpulseNs":3575,"totalWeightG":3502,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1613,"burnTimeS":3.71,"caseInfo":"75/7600","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1610","dataFiles":1,"delays":"P","designation":"M1610BL","diameter":75,"impulseClass":"M","length":1039,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":2206,"motorId":"5f4294d20002310000000308","propInfo":"Black Lightning","propWeightG":3674,"samples":[[0,0],[0.06277,1560],[1.3,2135],[1.648,2207],[1.795,2207],[1.899,2190],[1.99,2155],[2.502,1716],[2.825,1474],[2.994,1241],[3.293,594.8],[3.5,355.9],[3.71,0]],"sparky":true,"totImpulseNs":5973,"totalWeightG":6918,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":92.4,"burnTimeS":10.2,"caseInfo":"RMS-54/852","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J99","dataFiles":1,"delays":"P","designation":"J99N","diameter":54,"impulseClass":"J","length":231,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":151.9,"motorId":"5f4294d20002310000000309","propInfo":"Warp 9","propWeightG":556,"samples":[[0,0],[0.031,117.3],[0.078,135],[0.242,144.3],[0.828,131.4],[2.539,110.7],[3.594,102.1],[4.82,94.15],[5.938,86.04],[7.523,81.22],[8.984,76.98],[9.047,74.08],[9.547,16.01],[9.711,5.209],[9.82,1.929],[10,0]],"totImpulseNs":945.2,"totalWeightG":899,"type":"reload","updatedOn":"2020-11-07"},{"availability":"regular","avgThrustN":509.9,"burnTimeS":2.27,"caseInfo":"RMS-38/1320","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J510","dataFiles":2,"delays":"6,8,10,12,14","designation":"J510W","diameter":38,"impulseClass":"J","length":584.2,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1042,"motorId":"5f4294d2000231000000030a","propInfo":"White Lightning","propWeightG":662,"samples":[[0,0],[0.032,1056],[0.11,865.5],[0.161,829.9],[0.267,794.3],[0.351,780.6],[0.512,705.3],[0.682,654.6],[1.318,624.5],[1.461,475.2],[1.623,345.1],[1.934,153.4],[2.039,115],[2.177,41.09],[2.317,5.478],[2.5,0]],"totImpulseNs":1162,"totalWeightG":1080,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1859,"burnTimeS":3.1,"caseInfo":"RMS-75/5120","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1780","dataFiles":3,"delays":"P","designation":"M1780NT","diameter":75,"impulseClass":"M","length":665,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":3056,"motorId":"5f4294d2000231000000030b","propInfo":"New Blue Thunder","propWeightG":2560,"samples":[[0,0],[0.028,2204],[0.118,2566],[0.173,2566],[0.341,2214],[0.44,2144],[0.636,2115],[1.34,2134],[1.395,2204],[1.648,2121],[1.841,2042],[1.874,1895],[2.127,1643],[2.353,1517],[2.584,1461],[2.672,1348],[2.763,1069],[2.829,723.7],[2.939,438.2],[2.999,292.1],[3.101,172.6],[3.272,36.52],[3.5,0]],"totImpulseNs":5783,"totalWeightG":4715,"type":"reload","updatedOn":"2020-11-26"},{"availability":"regular","avgThrustN":1875,"burnTimeS":4.43,"caseInfo":"RMS-98/7680","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1845","dataFiles":2,"delays":"P","designation":"M1845NT","diameter":98,"impulseClass":"M","length":597,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":3081,"motorId":"5f4294d2000231000000030c","propInfo":"Blue Thunder","propWeightG":3772,"samples":[[0,0],[0.024,2262],[0.067,2116],[1.032,2268],[1.354,2434],[2.253,2288],[2.406,2149],[2.578,1821],[3.065,1580],[3.583,1411],[3.838,1364],[3.913,1219],[3.995,685.4],[4.109,400.7],[4.352,248.3],[4.498,33.11],[4.729,0]],"totImpulseNs":8307,"totalWeightG":6682,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":3168,"burnTimeS":4.37,"caseInfo":"RMS-98/15360","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"N3300","dataFiles":2,"delays":"P","designation":"N3300R","diameter":98,"impulseClass":"N","length":1046,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":4301,"motorId":"5f4294d2000231000000030d","propInfo":"Redline","propWeightG":7512,"samples":[[0,0],[0.036,40.17],[0.078,2888],[0.125,3776],[0.157,3628],[0.2,3535],[0.417,3597],[0.666,3628],[0.962,3669],[1.197,3664],[1.507,3655],[1.9,3620],[2.206,3570],[2.423,3530],[2.637,3423],[3.008,3209],[3.318,3026],[3.617,2821],[3.86,2647],[3.963,2598],[4.024,2468],[4.091,2267],[4.163,1897],[4.284,1125],[4.394,343.7],[4.455,129.4],[4.519,0]],"totImpulseNs":14040,"totalWeightG":12050,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":21.8,"burnTimeS":1.6,"certOrg":"National Association of Rocketry","commonName":"E20","dataFiles":1,"delays":"4,7","designation":"E20W","diameter":24,"impulseClass":"E","infoUrl":"https://nar.org/SandT/pdf/Aerotech/E20.pdf","length":70,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":34.9,"motorId":"5f4294d2000231000000030e","propInfo":"White Lightning","propWeightG":16.2,"samples":[[0,0],[0.001,0.02904],[0.025,0.2276],[0.039,1.394],[0.049,2.672],[0.057,5.817],[0.061,7.769],[0.063,9.004],[0.065,10.72],[0.073,20.34],[0.075,22.41],[0.081,27.13],[0.085,28.99],[0.091,30.54],[0.105,32.95],[0.125,34.26],[0.139,34.68],[0.253,33.85],[0.361,32.08],[0.631,29.81],[0.673,28.83],[0.771,27.36],[0.801,26.39],[0.901,24.21],[1.085,18.07],[1.135,16.89],[1.161,15.87],[1.291,12.19],[1.373,9.381],[1.509,4.039],[1.553,2.722],[1.603,1.721],[1.759,0]],"totImpulseNs":35,"totalWeightG":49,"type":"SU","updatedOn":"2022-07-20"},{"availability":"OOP","avgThrustN":4.84,"burnTimeS":0.38,"certOrg":"National Association of Rocketry","commonName":"A8","dataFiles":1,"delays":"3","designation":"A8-3","diameter":18,"impulseClass":"A","length":70,"manufacturer":"Quest Aerospace","manufacturerAbbrev":"Quest","maxThrustN":11.14,"motorId":"5f4294d2000231000000030f","propInfo":"black powder","propWeightG":6.3,"samples":[[0,0],[0.073,2.139],[0.085,2.599],[0.097,3.317],[0.11,4.035],[0.122,4.34],[0.135,4.955],[0.147,5.569],[0.16,6.132],[0.173,6.85],[0.185,7.361],[0.197,7.976],[0.21,8.281],[0.222,8.741],[0.235,9.407],[0.247,9.712],[0.26,11.14],[0.273,10.06],[0.285,8.768],[0.297,6.647],[0.31,5.042],[0.322,3.953],[0.335,3.019],[0.347,2.136],[0.36,1.512],[0.372,1.043],[0.38,0]],"totImpulseNs":1.86,"totalWeightG":13.1,"type":"SU","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":4.22,"burnTimeS":0.91,"certOrg":"National Association of Rocketry","commonName":"B4","dataFiles":1,"delays":"4","designation":"B4-4","diameter":18,"impulseClass":"B","length":70,"manufacturer":"Quest Aerospace","manufacturerAbbrev":"Quest","maxThrustN":12.81,"motorId":"5f4294d20002310000000310","propInfo":"black powder","propWeightG":10.4,"samples":[[0,0],[0.033,1.091],[0.061,2.25],[0.104,4.228],[0.138,6.002],[0.184,8.457],[0.222,10.5],[0.258,12.81],[0.275,9.412],[0.289,6.07],[0.298,4.842],[0.309,4.228],[0.329,3.751],[0.359,3.546],[0.444,3.41],[0.55,3.274],[0.646,3.478],[0.723,3.615],[0.787,3.751],[0.814,3.751],[0.831,3.478],[0.843,2.796],[0.862,1.773],[0.882,0.818],[0.904,0.136],[0.91,0]],"totImpulseNs":3.84,"totalWeightG":16.6,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":80.5,"burnTimeS":1.15,"caseInfo":"Pro29-2G","certOrg":"Canadian Association of Rocketry","commonName":"G80","dataFiles":2,"delays":"5,7,9,11,14","designation":"93G80-14A","diameter":29,"impulseClass":"G","length":142,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":112.2,"motorId":"5f4294d20002310000000311","propInfo":"Skidmark","propWeightG":50,"samples":[[0,0],[0.007,51.31],[0.025,108.1],[0.047,65.31],[0.122,78.03],[0.307,89.06],[0.446,93.86],[0.581,95.14],[0.75,91.89],[0.924,84.25],[0.972,83.4],[1.038,88.35],[1.064,67.15],[1.08,40.43],[1.093,21.63],[1.11,9.754],[1.131,2.545],[1.178,0]],"sparky":true,"totImpulseNs":92.9,"totalWeightG":143.2,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":122.2,"burnTimeS":4.12,"caseInfo":"Pro54-1G","certOrg":"Canadian Association of Rocketry","commonName":"I120","dataFiles":2,"delays":"5,6,7,8,9,10,11,12,13,14,15","designation":"502I120-15A","diameter":54,"impulseClass":"I","length":143,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":152,"motorId":"5f4294d20002310000000312","propInfo":"Imax","propWeightG":263.1,"samples":[[0,0],[0.035,13.69],[0.047,87.18],[0.067,148.5],[0.096,129.7],[0.212,141.9],[0.385,142.1],[0.671,141.7],[1.032,139.7],[1.545,136.9],[2.15,127.9],[3.757,92.43],[4.031,89.06],[4.122,67.12],[4.216,23.44],[4.283,5.25],[4.3,0]],"totImpulseNs":501.8,"totalWeightG":623.2,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":3075,"burnTimeS":1.99,"caseInfo":"Pro75-5G","certOrg":"Canadian Association of Rocketry","commonName":"M3100","dataFiles":2,"designation":"6118M3100-P","diameter":75,"impulseClass":"M","length":757,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":3709,"motorId":"5f4294d20002310000000313","propInfo":"White Thunder","propWeightG":2903,"samples":[[0,0],[0.02,3118],[0.057,2977],[0.148,3186],[0.496,3392],[0.817,3666],[0.936,3533],[1.173,3358],[1.501,3199],[1.717,3139],[1.78,2412],[1.812,2130],[1.832,2032],[1.937,346.4],[1.985,81.27],[2,0]],"totImpulseNs":6118,"totalWeightG":5018,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1674,"burnTimeS":3.68,"caseInfo":"Pro75-5G","certOrg":"Canadian Association of Rocketry","commonName":"M1675","dataFiles":2,"designation":"6162M1675-P","diameter":75,"impulseClass":"M","length":757,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":2499,"motorId":"5f4294d20002310000000314","propInfo":"Pink","propWeightG":3019,"samples":[[0,0],[0.04,1351],[0.077,1719],[0.166,1877],[0.307,2012],[0.49,2028],[0.616,2028],[1.018,2073],[1.594,1993],[2.246,1861],[2.762,1754],[2.908,1738],[3.023,1563],[3.206,909],[3.409,377.8],[3.493,278.6],[3.577,259.7],[3.69,113.3],[3.796,0]],"totImpulseNs":6162,"totalWeightG":5223,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1592,"burnTimeS":4.74,"caseInfo":"Pro75-6G","certOrg":"Canadian Association of Rocketry","commonName":"M1590","dataFiles":2,"designation":"7545M1590-P","diameter":75,"impulseClass":"M","length":893,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":2499,"motorId":"5f4294d20002310000000315","propInfo":"Classic","propWeightG":3590,"samples":[[0,0],[0.028,1211],[0.059,2024],[0.163,2235],[0.214,2303],[0.492,2154],[0.767,2092],[1.015,2103],[1.335,2083],[1.571,2030],[2.366,1779],[3.488,1534],[3.755,1030],[3.895,960],[4.12,650.3],[4.207,591.2],[4.44,340.7],[4.665,199.9],[4.778,90.09],[4.8,0]],"totImpulseNs":7545,"totalWeightG":6076,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":2268,"burnTimeS":2.41,"caseInfo":"Pro75-4G","certOrg":"Canadian Association of Rocketry","commonName":"M2250","dataFiles":2,"designation":"5472M2250-P","diameter":75,"impulseClass":"M","length":621,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":2960,"motorId":"5f4294d20002310000000316","propInfo":"C-Star","propWeightG":2489,"samples":[[0,0],[0.016,2542],[0.051,2391],[0.139,2582],[0.259,2599],[0.877,2663],[1.388,2556],[1.823,2458],[1.86,2303],[1.891,1927],[1.997,1453],[2.195,1453],[2.244,1207],[2.276,645.6],[2.336,517.8],[2.414,144.6],[2.456,40.35],[2.497,0]],"totImpulseNs":5472,"totalWeightG":4415,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1562,"burnTimeS":3.42,"caseInfo":"Pro98-2G","certOrg":"Canadian Association of Rocketry","commonName":"M1560","dataFiles":2,"designation":"5342M1560-P","diameter":98,"impulseClass":"M","length":394,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1805,"motorId":"5f4294d20002310000000317","propInfo":"White Thunder","propWeightG":2452,"samples":[[0,0],[0.037,1474],[0.121,1437],[0.328,1523],[1.299,1775],[1.545,1808],[1.797,1808],[1.998,1787],[2.208,1737],[2.462,1573],[2.782,1415],[3.086,1310],[3.213,1291],[3.258,1310],[3.328,679.5],[3.383,174],[3.428,68.18],[3.5,0]],"totImpulseNs":5342,"totalWeightG":4977,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":3421,"burnTimeS":2.92,"caseInfo":"Pro98-4G","certOrg":"Canadian Association of Rocketry","commonName":"M3400","dataFiles":2,"designation":"9994M3400-P","diameter":98,"impulseClass":"M","length":702,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":3983,"motorId":"5f4294d20002310000000318","propInfo":"White Thunder","propWeightG":4452,"samples":[[0,0],[0.021,3639],[0.049,3360],[0.111,3301],[0.374,3479],[0.909,3775],[1.059,3898],[1.208,3885],[1.571,3788],[2.168,3402],[2.467,3246],[2.709,3292],[2.734,3254],[2.821,1033],[2.876,550.1],[2.93,165],[2.99,0]],"totImpulseNs":9995,"totalWeightG":8108,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":3787,"burnTimeS":4.65,"caseInfo":"Pro98-6GXL","certOrg":"Canadian Association of Rocketry","commonName":"N3800","dataFiles":2,"designation":"17631N3800-P","diameter":98,"impulseClass":"N","length":1239,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":5097,"motorId":"5f4294d20002310000000319","propInfo":"Blue Streak","propWeightG":8449,"samples":[[0,0],[0.016,2672],[0.069,4632],[0.159,4361],[0.293,4356],[1.11,4591],[1.48,4704],[1.847,4729],[2.384,4683],[2.628,4550],[3.141,4136],[3.343,4043],[3.434,4023],[3.497,3788],[3.582,3204],[3.681,2810],[3.853,2385],[4.042,1459],[4.198,972.5],[4.338,946.9],[4.401,865],[4.604,378.8],[4.673,230.3],[4.7,0]],"totImpulseNs":17630,"totalWeightG":14260,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":5774,"burnTimeS":3.49,"caseInfo":"Pro98-6GXL","certOrg":"Canadian Association of Rocketry","commonName":"N5800","dataFiles":2,"designation":"20146N5800-P","diameter":98,"impulseClass":"N","length":1239,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":8035,"motorId":"5f4294d2000231000000031a","propInfo":"C-Star","propWeightG":9021,"samples":[[0,0],[0.019,6695],[0.049,6720],[0.103,6593],[0.384,6678],[1.109,6957],[1.569,6940],[1.991,6720],[2.622,6009],[3.011,3276],[3.192,2607],[3.334,1600],[3.423,1041],[3.513,389.3],[3.581,220.1],[3.594,0]],"totImpulseNs":20150,"totalWeightG":14830,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1291,"burnTimeS":3.64,"caseInfo":"ABC 75-6000","certOrg":"Canadian Association of Rocketry","commonName":"L1290","dataFiles":2,"designation":"4701L1290-P","diameter":76,"impulseClass":"L","length":785,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":1588,"motorId":"5f4294d2000231000000031b","propInfo":"Skidmark","propWeightG":2705,"samples":[[0,0],[0.022,117.6],[0.081,786],[0.11,797.2],[0.176,1227],[0.691,1357],[1.231,1462],[1.761,1477],[2.008,1467],[2.311,1417],[2.835,1299],[3.101,1236],[3.167,1230],[3.34,1322],[3.373,1286],[3.532,365.9],[3.602,201.6],[3.734,91.48],[3.782,69.08],[3.8,0]],"sparky":true,"totImpulseNs":4701,"totalWeightG":5399,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":207.4,"burnTimeS":1.2,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H200","dataFiles":0,"delays":"13","designation":"H200S","diameter":24,"impulseClass":"H","length":383,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d20002310000000346","propInfo":"Slow","propWeightG":117.8,"totImpulseNs":247.4,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":381.7,"burnTimeS":0.7,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H365","dataFiles":0,"delays":"15","designation":"H365F","diameter":24,"impulseClass":"H","length":383,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d20002310000000347","propInfo":"Fast","propWeightG":122.3,"totImpulseNs":259.1,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":511.2,"burnTimeS":0.57,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H470","dataFiles":0,"designation":"H470F","diameter":24,"impulseClass":"H","length":489,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d20002310000000348","propInfo":"Fast","propWeightG":151,"totImpulseNs":293.7,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":171.9,"burnTimeS":0.97,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H155","dataFiles":1,"delays":"7","designation":"H155F","diameter":29,"impulseClass":"H","length":203,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d20002310000000349","propInfo":"Fast","propWeightG":80,"samples":[[0,0],[0.005,39.95],[0.009,78.25],[0.025,121.8],[0.032,123.9],[0.057,123.4],[0.081,123.9],[0.121,124.2],[0.172,129.4],[0.201,131.9],[0.296,135.4],[0.337,137.9],[0.397,138.7],[0.436,134.6],[0.493,139.3],[0.552,135.4],[0.599,139],[0.691,137.6],[0.796,135.4],[0.888,133],[0.935,129.1],[0.971,130.8],[0.991,128.6],[1.015,112.2],[1.057,89.2],[1.093,67.31],[1.152,44.6],[1.192,32.56],[1.236,21.34],[1.264,16.42],[1.291,12.59],[1.312,10.12],[1.352,5.746],[1.393,2.736],[1.465,0]],"totImpulseNs":160.8,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":71.6,"burnTimeS":1.9,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G65","dataFiles":1,"delays":"11","designation":"G65DH","diameter":29,"impulseClass":"G","length":206,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d2000231000000034a","propInfo":"Dirty Harry","propWeightG":93.6,"samples":[[0,0],[0.028,31.8],[0.049,70.29],[0.082,58.74],[0.142,64.41],[0.716,79.61],[1.179,88.72],[1.568,75.35],[1.606,74.34],[1.611,68.06],[1.704,57.12],[1.773,45.98],[1.812,30.18],[1.853,18.84],[1.894,11.34],[1.936,5.469],[2.026,0]],"totImpulseNs":136.6,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":116.1,"burnTimeS":1.87,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H105","dataFiles":0,"designation":"H105DH","diameter":29,"impulseClass":"H","length":289,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d2000231000000034b","propInfo":"Dirty Harry","propWeightG":143.5,"totImpulseNs":216.3,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":260.5,"burnTimeS":1.03,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H255","dataFiles":0,"delays":"9","designation":"H255F","diameter":29,"impulseClass":"H","length":292,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d2000231000000034c","propInfo":"Fast","propWeightG":125.3,"totImpulseNs":266,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":438.5,"burnTimeS":0.77,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I385","dataFiles":0,"delays":"12","designation":"I385F","diameter":29,"impulseClass":"I","length":384,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d2000231000000034d","propInfo":"Fast","propWeightG":154,"totImpulseNs":326.3,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":550.9,"burnTimeS":0.73,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I560","dataFiles":1,"delays":"20","designation":"I560F","diameter":29,"impulseClass":"I","length":597,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d2000231000000034e","propInfo":"Fast","propWeightG":246.1,"samples":[[0,0],[0.01,589.5],[0.05,867.3],[0.08,850.4],[0.11,858.5],[0.14,870.5],[0.17,884.5],[0.2,899.9],[0.23,917.5],[0.27,932.4],[0.3,948.2],[0.33,963.3],[0.36,973.9],[0.39,943],[0.42,678.7],[0.45,237.1],[0.48,221.4],[0.52,212.5],[0.55,202.7],[0.58,200],[0.61,188.2],[0.64,145.2],[0.68,96.66],[0.71,60.02],[0.74,32.13],[0.77,10.5],[0.8,0]],"totImpulseNs":404.2,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":318.8,"burnTimeS":1.2,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I300","dataFiles":0,"designation":"I300F","diameter":38,"impulseClass":"I","length":254,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d2000231000000034f","propInfo":"Fast","propWeightG":181.2,"totImpulseNs":390.7,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":167.3,"burnTimeS":2.59,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I170","dataFiles":0,"delays":"11","designation":"I170DH","diameter":38,"impulseClass":"I","length":314,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d20002310000000350","propInfo":"Dirty Harry","propWeightG":287,"totImpulseNs":433.2,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":224.3,"burnTimeS":2.4,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I220","dataFiles":0,"delays":"9","designation":"I220S","diameter":38,"impulseClass":"I","length":314,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d20002310000000351","propInfo":"Slow","propWeightG":253.7,"totImpulseNs":534.4,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":437.7,"burnTimeS":1.2,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I420","dataFiles":0,"delays":"12","designation":"I420F","diameter":38,"impulseClass":"I","length":314,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d20002310000000352","propInfo":"Fast","propWeightG":244.6,"totImpulseNs":532.9,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":296.5,"burnTimeS":2.27,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J280","dataFiles":0,"delays":"11","designation":"J280S","diameter":38,"impulseClass":"J","length":368,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d20002310000000353","propInfo":"Slow","propWeightG":314.1,"totImpulseNs":671.1,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":273.4,"burnTimeS":2.2,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I255","dataFiles":0,"delays":"10","designation":"I255DH","diameter":38,"impulseClass":"I","length":368,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d20002310000000354","propInfo":"Dirty Harry","propWeightG":353.3,"totImpulseNs":602.8,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":619.4,"burnTimeS":1.1,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J450","dataFiles":0,"delays":"10","designation":"J450F","diameter":38,"impulseClass":"J","length":368,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d20002310000000355","propInfo":"Fast","propWeightG":308,"totImpulseNs":673.3,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":361.8,"burnTimeS":2.1,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J345","dataFiles":0,"delays":"18","designation":"J345S","diameter":38,"impulseClass":"J","length":476,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d20002310000000356","propInfo":"Slow","propWeightG":380.5,"totImpulseNs":761.2,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":659.5,"burnTimeS":1.17,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J630","dataFiles":0,"delays":"20","designation":"J630F","diameter":38,"impulseClass":"J","length":476,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d20002310000000357","propInfo":"Fast","propWeightG":374.5,"totImpulseNs":787.4,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":710.5,"burnTimeS":1.17,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J675","dataFiles":0,"delays":"20","designation":"J675F","diameter":38,"impulseClass":"J","length":476,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d20002310000000358","propInfo":"Fast","propWeightG":386.6,"totImpulseNs":814.5,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":883.8,"burnTimeS":1,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J850","dataFiles":0,"delays":"21","designation":"J850F","diameter":38,"impulseClass":"J","length":576,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d20002310000000359","propInfo":"Fast","propWeightG":450,"totImpulseNs":899.9,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":549.4,"burnTimeS":1.8,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J530","dataFiles":0,"delays":"10","designation":"J530S","diameter":38,"impulseClass":"J","length":737,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d2000231000000035a","propInfo":"Slow","propWeightG":561.7,"totImpulseNs":991.7,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1019,"burnTimeS":1.03,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J975","dataFiles":0,"delays":"23,P","designation":"J975F","diameter":38,"impulseClass":"J","length":740,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d2000231000000035b","propInfo":"Fast","propWeightG":552.7,"totImpulseNs":1033,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":432.8,"burnTimeS":1.88,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J340","dataFiles":0,"delays":"10","designation":"J340F","diameter":54,"impulseClass":"J","length":251,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d2000231000000035c","propInfo":"Fast","propWeightG":361.3,"totImpulseNs":787.3,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":193.4,"burnTimeS":4.57,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J180","dataFiles":0,"delays":"13","designation":"J180DH","diameter":54,"impulseClass":"J","length":326,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d2000231000000035d","propInfo":"Dirty Harry","propWeightG":605.5,"totImpulseNs":884.2,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":523.2,"burnTimeS":2.2,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J480","dataFiles":0,"delays":"17","designation":"J480F","diameter":54,"impulseClass":"J","length":326,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d2000231000000035e","propInfo":"Fast","propWeightG":522.5,"totImpulseNs":1144,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":306,"burnTimeS":4.03,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J295","dataFiles":0,"delays":"17","designation":"J295DH","diameter":54,"impulseClass":"J","length":403,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d2000231000000035f","propInfo":"Dirty Harry","propWeightG":792.8,"totImpulseNs":1243,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":950.7,"burnTimeS":2.8,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L850","dataFiles":0,"delays":"12","designation":"L850S","diameter":54,"impulseClass":"L","length":727,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d20002310000000360","propInfo":"Slow","propWeightG":1265,"totImpulseNs":2643,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":2018,"burnTimeS":1.3,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1860","dataFiles":0,"delays":"23","designation":"L1860F","diameter":54,"impulseClass":"L","length":727,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d20002310000000361","propInfo":"Fast","propWeightG":1255,"totImpulseNs":2643,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":161.8,"burnTimeS":6.9,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J130","dataFiles":0,"delays":"15","designation":"J130S","diameter":76,"impulseClass":"J","length":244,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d20002310000000362","propInfo":"Slow","propWeightG":610,"totImpulseNs":1118,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":274.4,"burnTimeS":4.27,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J250","dataFiles":0,"delays":"7","designation":"J250F","diameter":76,"impulseClass":"J","length":244,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d20002310000000363","propInfo":"Fast","propWeightG":596.5,"totImpulseNs":1167,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":424.5,"burnTimeS":5.7,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K410","dataFiles":0,"delays":"13","designation":"K410S","diameter":76,"impulseClass":"K","length":368,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d20002310000000364","propInfo":"Slow","propWeightG":1196,"totImpulseNs":2420,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":809.3,"burnTimeS":3.13,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K777","dataFiles":0,"delays":"10","designation":"K777F","diameter":76,"impulseClass":"K","length":368,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d20002310000000365","propInfo":"Fast","propWeightG":1169,"totImpulseNs":2525,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":608.6,"burnTimeS":5.1,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L585","dataFiles":0,"delays":"8","designation":"L585DH","diameter":76,"impulseClass":"L","length":495,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d20002310000000366","propInfo":"Dirty Harry","propWeightG":1930,"totImpulseNs":3094,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":643.6,"burnTimeS":5.33,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L630","dataFiles":0,"delays":"7","designation":"L630S","diameter":76,"impulseClass":"L","length":495,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d20002310000000367","propInfo":"Slow","propWeightG":1661,"totImpulseNs":3430,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1205,"burnTimeS":2.97,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1175","dataFiles":0,"delays":"30","designation":"L1175F","diameter":76,"impulseClass":"L","length":495,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d20002310000000368","propInfo":"Fast","propWeightG":1667,"totImpulseNs":3567,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1548,"burnTimeS":3.07,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1500","dataFiles":0,"delays":"11","designation":"L1500F","diameter":76,"impulseClass":"L","length":622,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d20002310000000369","propInfo":"Fast","propWeightG":2223,"totImpulseNs":4731,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":845.2,"burnTimeS":5.27,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L820","dataFiles":0,"delays":"15","designation":"L820S","diameter":76,"impulseClass":"L","length":623,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d2000231000000036a","propInfo":"Slow","propWeightG":2223,"totImpulseNs":4470,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1170,"burnTimeS":4.9,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1130","dataFiles":0,"designation":"M1130S","diameter":76,"impulseClass":"M","length":775,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d2000231000000036b","propInfo":"Slow","propWeightG":3069,"totImpulseNs":5764,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":2350,"burnTimeS":2.55,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M2240","dataFiles":0,"designation":"M2240F","diameter":76,"impulseClass":"M","length":775,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d2000231000000036c","propInfo":"Fast","propWeightG":3058,"totImpulseNs":5947,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1059,"burnTimeS":5,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1015","dataFiles":0,"designation":"M1015DH","diameter":76,"impulseClass":"M","length":781,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d2000231000000036d","propInfo":"Dirty Harry","propWeightG":3547,"totImpulseNs":5283,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1952,"burnTimeS":3.83,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1845","dataFiles":0,"designation":"M1845S","diameter":76,"impulseClass":"M","length":1038,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d2000231000000036e","propInfo":"Slow","propWeightG":3882,"totImpulseNs":7513,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":3202,"burnTimeS":2.35,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M3200","dataFiles":0,"designation":"M3200F","diameter":76,"impulseClass":"M","length":1041,"manufacturer":"Kosdon TRM","manufacturerAbbrev":"Kosdon","motorId":"5f4294d2000231000000036f","propInfo":"Fast","propWeightG":3896,"totImpulseNs":7566,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":53.6,"burnTimeS":2.97,"caseInfo":"Pro29-3G","certOrg":"Canadian Association of Rocketry","commonName":"G54","dataFiles":2,"delays":"3,5,7,9,12","designation":"159G54-12A","diameter":29,"impulseClass":"G","length":187,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":119.2,"motorId":"5f4294d20002310000000370","propInfo":"Red Lightning","propWeightG":86.5,"samples":[[0,0],[0.018,107.3],[0.031,113.6],[0.059,103.5],[0.135,121.7],[0.22,104.6],[0.299,95.53],[0.432,88.31],[0.959,69.66],[1.757,43.48],[2.418,20.76],[2.851,9.478],[3.013,5.567],[3.026,0]],"totImpulseNs":159.1,"totalWeightG":192.8,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":158.9,"burnTimeS":1.88,"caseInfo":"Pro29-6G","certOrg":"Canadian Association of Rocketry","commonName":"H159","dataFiles":2,"delays":"6,8,10,12,15","designation":"298H159-15A","diameter":29,"impulseClass":"H","length":320,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":199.7,"motorId":"5f4294d20002310000000371","propInfo":"Green3","propWeightG":176.6,"samples":[[0,0],[0.012,117.3],[0.032,158.6],[0.103,177.8],[0.171,184.9],[0.299,185.4],[0.511,178.1],[0.717,179.3],[1.272,162.9],[1.424,159.6],[1.519,152.6],[1.584,149.8],[1.632,146.3],[1.727,89.28],[1.768,110],[1.834,25.98],[1.865,10.59],[1.887,0]],"totImpulseNs":298.2,"totalWeightG":342.8,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":485.5,"burnTimeS":4.08,"caseInfo":"Pro54-5G","certOrg":"Canadian Association of Rocketry","commonName":"K490","dataFiles":2,"delays":"6,7,8,9,10,11,12,13,14,15,16","designation":"1990K490-16A","diameter":54,"impulseClass":"K","length":488,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":590.9,"motorId":"5f4294d20002310000000372","propInfo":"Green3","propWeightG":1155,"samples":[[0,0],[0.013,445.8],[0.024,376.7],[0.083,559.2],[0.121,584],[0.316,573.4],[0.727,569.9],[1.116,553.9],[1.875,522],[1.893,593.8],[1.944,519.4],[2.658,479.5],[3.063,473.3],[3.358,444],[3.618,448.4],[3.894,240.2],[4.055,31.02],[4.066,0]],"totImpulseNs":1978,"totalWeightG":1854,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":3710,"burnTimeS":1.83,"caseInfo":"Pro75-6G","certOrg":"Canadian Association of Rocketry","commonName":"M3700","dataFiles":2,"delays":"P","designation":"6800M3700-P","diameter":75,"impulseClass":"M","length":803,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":4158,"motorId":"5f4294d20002310000000373","propInfo":"White Thunder","propWeightG":3019,"samples":[[0,0],[0.017,3816],[0.04,3970],[0.099,3914],[0.245,3958],[0.563,3951],[0.727,4105],[0.959,4032],[1.25,3982],[1.511,3995],[1.595,3995],[1.739,1307],[1.772,1110],[1.83,221.9],[1.835,0]],"totImpulseNs":6800,"totalWeightG":5779,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":2075,"burnTimeS":3.03,"caseInfo":"Pro75-6G","certOrg":"Canadian Association of Rocketry","commonName":"M2075","dataFiles":2,"delays":"P","designation":"6287M2075-P","diameter":75,"impulseClass":"M","length":893,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":3453,"motorId":"5f4294d20002310000000374","propInfo":"Smoky Sam","propWeightG":3982,"samples":[[0,0],[0.034,2351],[0.18,2652],[0.243,2932],[0.303,2734],[0.453,2625],[0.552,2564],[0.813,2488],[1.172,2499],[2.028,2038],[2.415,1611],[2.567,1507],[2.69,1386],[3.01,224.7],[3.029,0]],"totImpulseNs":6287,"totalWeightG":7191,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":8.44,"burnTimeS":2.2,"certOrg":"National Association of Rocketry","commonName":"D8","dataFiles":1,"delays":"0,3,5","designation":"D8","diameter":24,"impulseClass":"D","length":70,"manufacturer":"Quest Aerospace","manufacturerAbbrev":"Quest","maxThrustN":28.88,"motorId":"5f4294d20002310000000375","propInfo":"black powder","propWeightG":22,"samples":[[0,0],[0.002,1.014],[0.01,1.565],[0.13,5.178],[0.217,8.911],[0.298,14.81],[0.351,20.23],[0.414,25.29],[0.442,28.88],[0.47,23.84],[0.487,17.46],[0.508,13.37],[0.537,10.96],[0.6,9.152],[0.673,8.791],[0.828,8.309],[0.933,8.068],[1.136,7.105],[1.35,6.743],[1.48,6.623],[1.602,6.502],[1.648,7.105],[1.683,6.382],[1.743,6.262],[1.865,6.141],[1.974,6.141],[2.104,6.262],[2.132,5.419],[2.17,3.492],[2.191,1.926],[2.2,0]],"totImpulseNs":18.59,"totalWeightG":45.6,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":3.82,"burnTimeS":4.61,"certOrg":"National Association of Rocketry","commonName":"D5","dataFiles":3,"delays":"4,6","designation":"D5","diameter":20,"impulseClass":"D","length":96,"manufacturer":"Quest Aerospace","manufacturerAbbrev":"Quest","maxThrustN":16.8,"motorId":"5f4294d20002310000000376","propInfo":"black powder","propWeightG":24,"samples":[[0,0],[0.01,1.014],[0.122,2.652],[0.172,4.836],[0.273,7.723],[0.331,10.61],[0.39,13.81],[0.448,16.8],[0.48,12.4],[0.484,8.266],[0.517,5.221],[0.713,4.125],[0.974,4.121],[1.135,3.338],[1.324,3.101],[1.55,3.254],[1.971,3.169],[2.393,3.162],[2.752,3.391],[3.069,3.386],[3.547,3.301],[3.694,3.064],[3.948,3.294],[4.215,3.29],[4.412,3.287],[4.496,2.505],[4.586,1.801],[4.61,0]],"totImpulseNs":17.61,"totalWeightG":44.1,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1066,"burnTimeS":2.35,"caseInfo":"RMS-75/2560","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K1000","dataFiles":2,"delays":"P","designation":"K1000T","diameter":75,"impulseClass":"K","length":382.9,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1674,"motorId":"5f4294d20002310000000377","propInfo":"Blue Thunder","propWeightG":1234,"samples":[[0,0],[0.004,895.1],[0.015,1120],[0.025,1093],[0.095,1097],[0.2,1110],[0.3,1116],[0.4,1123],[0.5,1133],[0.6,1140],[0.7,1136],[0.8,1136],[0.9,1136],[1,1140],[1.1,1133],[1.2,1130],[1.3,1126],[1.4,1120],[1.5,1110],[1.6,1097],[1.7,1064],[1.8,1017],[1.9,971.1],[2,915],[2.1,868.7],[2.18,865.4],[2.2,878.6],[2.218,858.8],[2.269,670.5],[2.3,578],[2.332,445.9],[2.356,336.9],[2.389,224.6],[2.436,105.7],[2.5,0]],"totImpulseNs":2512,"totalWeightG":2602,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":123.4,"burnTimeS":0.45,"caseInfo":"Pro29-1G","certOrg":"Canadian Association of Rocketry","commonName":"F120","dataFiles":2,"delays":"5,7,9,11,14","designation":"56F120-14A","diameter":29,"impulseClass":"F","length":98,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":143.6,"motorId":"5f4294d20002310000000378","propInfo":"Vmax","propWeightG":25.3,"samples":[[0,0],[0.013,79.24],[0.017,90.43],[0.04,101.4],[0.125,127.6],[0.179,136.1],[0.222,139.9],[0.289,143.5],[0.354,138.6],[0.394,125.5],[0.406,123.6],[0.416,125.1],[0.423,130],[0.431,120.6],[0.447,25.59],[0.453,8.72],[0.455,0]],"totImpulseNs":56,"totalWeightG":106.2,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":243.7,"burnTimeS":0.45,"caseInfo":"Pro29-2G","certOrg":"Canadian Association of Rocketry","commonName":"G250","dataFiles":2,"delays":"5,7,9,11,14","designation":"110G250-14A","diameter":29,"impulseClass":"G","length":142,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":288.3,"motorId":"5f4294d20002310000000379","propInfo":"Vmax","propWeightG":50.6,"samples":[[0,0],[0.006,151.6],[0.011,198.1],[0.016,203.1],[0.031,201.7],[0.075,226.2],[0.122,250.3],[0.216,280.2],[0.25,287],[0.287,284.9],[0.354,269.7],[0.374,258.6],[0.4,233.4],[0.413,234.1],[0.42,227.6],[0.433,137.9],[0.445,33.85],[0.454,0]],"totImpulseNs":110,"totalWeightG":141.3,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":409,"burnTimeS":0.41,"caseInfo":"Pro29-3G","certOrg":"Canadian Association of Rocketry","commonName":"H410","dataFiles":2,"delays":"5,7,9,11,14","designation":"168H410-14A","diameter":29,"impulseClass":"H","length":187,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":522.8,"motorId":"5f4294d2000231000000037a","propInfo":"Vmax","propWeightG":75.9,"samples":[[0,0],[0.004,152.8],[0.009,341.4],[0.013,368],[0.019,368],[0.046,385.9],[0.074,416.5],[0.143,471.6],[0.21,517.5],[0.253,500.8],[0.287,460.3],[0.338,383.3],[0.357,343.4],[0.361,293.6],[0.369,263],[0.378,253.7],[0.4,62.44],[0.414,0]],"totImpulseNs":167.7,"totalWeightG":182.5,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":137.1,"burnTimeS":1.89,"caseInfo":"Pro54-1G","certOrg":"Canadian Association of Rocketry","commonName":"I140","dataFiles":2,"delays":"4,5,6,7,8,9,10,11,12,13,14","designation":"396I140-14A","diameter":54,"impulseClass":"I","length":143,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":164,"motorId":"5f4294d2000231000000037b","propInfo":"Skidmark","propWeightG":210.4,"samples":[[0,0],[0.008,81.3],[0.02,137.2],[0.043,157.2],[0.065,121.1],[0.16,136.1],[0.353,150.7],[0.54,156.3],[0.702,160.2],[0.976,157],[1.298,151.3],[1.619,146.1],[2.057,136.3],[2.489,121.5],[2.604,119.3],[2.671,122.2],[2.708,111.7],[2.779,61.3],[2.84,25.22],[2.901,8.478],[2.902,0]],"sparky":true,"totImpulseNs":395.6,"totalWeightG":564.3,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":398.6,"burnTimeS":4.01,"caseInfo":"Pro54-4G","certOrg":"Canadian Association of Rocketry","commonName":"K400","dataFiles":2,"delays":"4,5,6,7,8,9,10,11,12,13,14","designation":"1597K400-14A","diameter":54,"impulseClass":"K","length":404,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":484.5,"motorId":"5f4294d2000231000000037c","propInfo":"Green3","propWeightG":924.3,"samples":[[0,0],[0.014,359.2],[0.102,475.4],[1.193,444.6],[2.807,385],[3.364,370.2],[3.599,363.5],[3.693,329],[3.859,169.7],[3.967,57.2],[4.017,0]],"totImpulseNs":1597,"totalWeightG":1551,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":157.9,"burnTimeS":9.66,"caseInfo":"Pro54-4G","certOrg":"Canadian Association of Rocketry","commonName":"K160","dataFiles":2,"delays":"6","designation":"1526K160-6","diameter":54,"impulseClass":"K","length":404,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":282.5,"motorId":"5f4294d2000231000000037d","propInfo":"Classic","propWeightG":772,"samples":[[0,0],[0.027,160.2],[0.08,242],[0.321,260.7],[0.455,259.6],[0.957,270.5],[1.593,272.2],[2.102,265.2],[2.564,254.3],[2.925,239.6],[3.956,190],[5.301,138.8],[7.617,67.8],[9.19,25.64],[9.572,15.81],[9.679,0]],"totImpulseNs":1526,"totalWeightG":1472,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":263.3,"burnTimeS":8.68,"caseInfo":"Pro54-6G","certOrg":"Canadian Association of Rocketry","commonName":"K260","dataFiles":2,"delays":"P","designation":"2285K260-P","diameter":54,"impulseClass":"K","length":572,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":438.1,"motorId":"5f4294d2000231000000037e","propInfo":"Classic","propWeightG":1149,"samples":[[0,0],[0.042,325.7],[0.101,430.4],[0.422,422.8],[0.773,426.9],[1.178,429.8],[1.517,425.7],[2.011,413.4],[3.195,356.7],[4.51,289.5],[6.015,174.3],[6.997,91.23],[7.366,66.67],[7.902,43.27],[8.479,25.73],[8.687,0]],"totImpulseNs":2285,"totalWeightG":2047,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":304,"burnTimeS":8.38,"caseInfo":"Pro54-6GXL","certOrg":"Canadian Association of Rocketry","commonName":"K300","dataFiles":2,"delays":"P","designation":"2546K300-P","diameter":54,"impulseClass":"K","length":649,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":561.8,"motorId":"5f4294d2000231000000037f","propInfo":"Classic","propWeightG":1266,"samples":[[0,0],[0.036,495.3],[0.132,543.3],[0.265,506.9],[0.734,493.1],[1.258,489.5],[1.811,482.9],[2.467,453.8],[3.737,375.3],[4.705,299.6],[6.047,165.1],[6.474,120.7],[6.829,90.18],[7.323,63.27],[7.72,46.55],[8.309,30.55],[8.37,0]],"totImpulseNs":2546,"totalWeightG":2270,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":1975,"burnTimeS":7.23,"caseInfo":"Pro98-6G","certOrg":"Canadian Association of Rocketry","commonName":"N1975","dataFiles":2,"designation":"14272N1975-P","diameter":98,"impulseClass":"N","length":1010,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":2568,"motorId":"5f4294d20002310000000380","propInfo":"Green3","propWeightG":8560,"samples":[[0,0],[0.04,1382],[0.08,1699],[0.201,1781],[0.447,1794],[0.678,1821],[0.758,1928],[0.853,1842],[2.425,2089],[2.52,2180],[2.761,2199],[3.434,2214],[3.715,2269],[4.077,2299],[4.96,2238],[5.492,2162],[6.105,2025],[6.446,1879],[6.647,1669],[7.074,602.9],[7.239,140.1],[7.254,0]],"totImpulseNs":14270,"totalWeightG":13250,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":10220,"burnTimeS":1.01,"caseInfo":"Pro98-6G","certOrg":"Canadian Association of Rocketry","commonName":"N10000","dataFiles":2,"designation":"10347N10000-P","diameter":98,"impulseClass":"N","length":1010,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":11560,"motorId":"5f4294d20002310000000381","propInfo":"Vmax","propWeightG":5200,"samples":[[0,0],[0.009,8954],[0.027,10260],[0.074,10750],[0.125,11040],[0.212,11110],[0.358,11280],[0.457,11480],[0.548,11460],[0.599,11280],[0.663,10870],[0.766,9988],[0.837,9351],[0.888,8996],[0.908,8968],[0.923,8586],[0.942,7821],[0.961,6276],[0.976,4491],[0.988,3358],[1.004,1658],[1.008,0]],"totImpulseNs":10350,"totalWeightG":9919,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":430.6,"burnTimeS":5.78,"caseInfo":"RMS-54/2560","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K375","dataFiles":2,"delays":"P","designation":"K375NW","diameter":54,"impulseClass":"K","length":579,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1372,"motorId":"5f4294d20002310000000382","propInfo":"White Lightning/Warp 9","propWeightG":1318,"samples":[[0,0],[0.027,887],[0.036,1115],[0.054,1269],[0.135,1280],[0.197,1314],[0.292,1317],[0.422,1344],[0.444,1302],[0.489,1336],[0.552,452.8],[0.574,396.7],[0.718,452.8],[0.794,460.3],[0.902,437.9],[0.992,411.7],[1.189,404.2],[1.4,366.8],[1.575,381.7],[1.791,370.5],[4,366.8],[4.165,344.3],[4.29,239.5],[4.398,239.5],[4.537,183.4],[4.645,183.4],[4.761,93.56],[5,93.56],[5.2,63.62],[5.4,44.91],[5.6,33.68],[5.8,0]],"totImpulseNs":2228,"totalWeightG":2106,"type":"reload","updatedOn":"2020-11-12"},{"availability":"regular","avgThrustN":545.3,"burnTimeS":4.26,"caseInfo":"RMS-54/2560","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K480","dataFiles":2,"delays":"P","designation":"K480W","diameter":54,"impulseClass":"K","length":579,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1018,"motorId":"5f4294d20002310000000383","propInfo":"White Lightning","propWeightG":1292,"samples":[[0,0],[0.03,535.7],[0.045,860.3],[0.057,916],[0.098,830.2],[0.159,832.5],[0.246,795.4],[0.307,811.6],[0.398,793.1],[0.492,809.3],[0.557,823.2],[0.621,811.6],[0.689,779.2],[0.735,795.4],[0.845,767.6],[0.989,718.9],[1.091,707.3],[1.25,684.1],[1.307,667.9],[1.5,654],[1.606,656.3],[1.742,651.6],[1.909,628.4],[2,605.3],[2.25,586.7],[2.5,565.8],[2.75,547.3],[2.886,545],[3,524.1],[3.064,491.6],[3.144,417.4],[3.25,394.2],[3.292,338.6],[3.451,271.3],[3.5,231.9],[3.625,178.6],[3.7,143.8],[3.871,132.2],[4,88.12],[4.133,41.74],[4.246,23.19],[4.5,18.55],[4.8,0]],"totImpulseNs":2273,"totalWeightG":2078,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":411.9,"burnTimeS":4.33,"caseInfo":"75/2500","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K411","dataFiles":0,"designation":"K411BL","diameter":75,"impulseClass":"K","length":728,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":596.2,"motorId":"5f4294d20002310000000384","propInfo":"Black Lightning","propWeightG":1132,"sparky":true,"totImpulseNs":1786,"totalWeightG":2656,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":670,"burnTimeS":3.52,"caseInfo":"75/2500","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K670","dataFiles":0,"designation":"K670WC","diameter":75,"impulseClass":"K","length":728,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":859.1,"motorId":"5f4294d20002310000000385","propInfo":"White Cloud","propWeightG":1184,"totImpulseNs":2365,"totalWeightG":2706,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":74.74,"burnTimeS":1.61,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G75","dataFiles":1,"delays":"4,6,7,8,10","designation":"HP-G75M","diameter":29,"impulseClass":"G","length":123.9,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":102,"motorId":"5f4294d20002310000000386","propInfo":"Metalstorm","propWeightG":66.8,"samples":[[0,0],[0.01,81.49],[0.013,94.73],[0.021,101.5],[0.037,87.96],[0.068,86.2],[0.154,87.67],[0.188,90.91],[0.211,90.02],[0.31,95.61],[0.357,91.49],[0.464,93.85],[0.696,92.08],[0.879,84.73],[0.907,85.61],[0.92,92.97],[0.939,77.67],[1.014,72.96],[1.027,78.55],[1.053,71.49],[1.171,64.13],[1.304,52.37],[1.312,56.78],[1.325,52.66],[1.374,48.54],[1.411,44.13],[1.442,36.19],[1.492,22.36],[1.538,14.12],[1.585,7.649],[1.643,3.825],[1.7,2.648],[1.802,1.471],[1.971,0]],"sparky":true,"totImpulseNs":120.4,"totalWeightG":131,"type":"SU","updatedOn":"2020-05-01"},{"availability":"regular","avgThrustN":166.8,"burnTimeS":1.91,"caseInfo":"RMS-38/360","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H170","dataFiles":1,"delays":"6,8,10,12,14","designation":"H170M","diameter":38,"impulseClass":"H","length":191,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":208,"motorId":"5f4294d20002310000000387","propInfo":"Metalstorm","propWeightG":182.5,"samples":[[0,0],[0.017,182.5],[0.032,199.6],[0.104,196],[0.205,180.9],[0.292,188.7],[0.314,198.6],[0.324,187.2],[0.364,180.9],[0.423,192.9],[0.458,189.2],[0.574,197.5],[0.616,205.8],[0.663,190.3],[0.71,190.3],[0.735,197.5],[0.876,188.7],[0.963,193.9],[1.22,176.8],[1.245,185.1],[1.279,172.1],[1.46,152.4],[1.47,159.7],[1.515,147.2],[1.591,136.3],[1.7,131.2],[1.73,114.6],[1.782,67.4],[1.824,39.4],[1.886,18.14],[1.93,8.813],[2,3.111],[2.138,0]],"sparky":true,"totImpulseNs":319.9,"totalWeightG":330,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":354.1,"burnTimeS":1.836,"caseInfo":"RMS-38/720","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J340","dataFiles":1,"delays":"6,8,10,12,14","designation":"J340M","diameter":38,"impulseClass":"J","length":337,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":605,"motorId":"5f4294d20002310000000388","propInfo":"Metalstorm","propWeightG":365,"samples":[[0,0],[0.005,361.6],[0.008,501.7],[0.026,606.5],[0.096,491.4],[0.214,453],[0.485,439.8],[0.772,435.3],[0.826,426.5],[0.891,423.5],[1.048,383.7],[1.389,311.4],[1.425,308.4],[1.459,309.9],[1.554,183],[1.611,103.3],[1.699,57.55],[1.841,11.81],[1.898,8.854],[2.19,0]],"sparky":true,"totImpulseNs":651.7,"totalWeightG":577.3,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":557.4,"burnTimeS":2.85,"caseInfo":"RMS-54/1706","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K540","dataFiles":1,"delays":"6,8,10,12,14","designation":"K540M","diameter":54,"impulseClass":"K","length":401,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":854,"motorId":"5f4294d20002310000000389","propInfo":"Metalstorm","propWeightG":876.7,"samples":[[0,0],[0.013,625.7],[0.014,791.8],[0.03,855.5],[0.073,764.5],[0.146,719],[0.33,712.2],[0.394,734.9],[0.622,705.3],[0.866,678],[1.059,655.3],[1.406,648.5],[1.445,596.1],[1.544,605.2],[1.668,582.5],[1.689,625.7],[1.741,566.6],[2.032,498.3],[2.088,480.1],[2.118,511.9],[2.174,436.9],[2.324,395.9],[2.435,357.2],[2.525,304.9],[2.542,329.9],[2.65,175.2],[2.774,88.74],[2.89,36.41],[3.006,13.65],[3.289,0]],"sparky":true,"totImpulseNs":1596,"totalWeightG":1275,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":0.82,"burnTimeS":2.09,"certOrg":"National Association of Rocketry","commonName":"A3","dataFiles":1,"delays":"2,4","designation":"A3T","diameter":13,"impulseClass":"A","length":55,"manufacturer":"Quest Aerospace","manufacturerAbbrev":"Quest","maxThrustN":2.79,"motorId":"5f4294d2000231000000038a","propInfo":"black powder","propWeightG":3.6,"samples":[[0,0],[0.09259,0.4942],[0.1235,0.9884],[0.1929,2.733],[0.2431,1.512],[0.2546,1.294],[0.2816,1.134],[0.3202,1.032],[0.3704,0.9012],[0.4012,0.7994],[0.4552,0.843],[0.5054,0.7994],[0.7485,0.7849],[0.841,0.7994],[0.9144,0.6541],[1.003,0.7122],[1.254,0.625],[1.501,0.6977],[1.755,0.7413],[2.002,0.7703],[2.056,0.7413],[2.076,0.5669],[2.1,0]],"totImpulseNs":1.71,"totalWeightG":8.8,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":463,"burnTimeS":3.89,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K350","dataFiles":1,"designation":"K350TR-P","diameter":64,"impulseClass":"K","length":908,"manufacturer":"R.A.T.T. Works","manufacturerAbbrev":"RATT","maxThrustN":853,"motorId":"5f4294d2000231000000038b","propInfo":"Tribrid: ABS/Alcohol/Nitrous","propWeightG":1672,"samples":[[0,0],[0.077,8.027],[0.095,596],[0.136,282.9],[0.16,293],[0.166,361.2],[0.207,266.9],[0.237,289],[0.332,289],[0.379,274.9],[0.734,274.9],[0.764,539.8],[0.817,461.5],[1.037,427.4],[1.208,465.6],[1.309,421.4],[1.333,399.3],[1.475,441.5],[1.558,429.4],[1.694,499.7],[1.812,489.6],[1.925,501.7],[2.067,481.6],[2.138,491.6],[2.571,457.5],[2.92,423.4],[3.175,401.3],[3.435,395.3],[3.749,373.2],[3.773,218.7],[3.803,202.7],[3.808,158.5],[3.844,202.7],[4.087,188.6],[4.199,104.3],[4.584,90.3],[5.177,44.15],[5.271,46.15],[5.544,20.07],[5.994,0]],"totImpulseNs":1861,"totalWeightG":11660,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":561,"burnTimeS":3.67,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K600","dataFiles":0,"designation":"K600TR-P","diameter":64,"impulseClass":"K","length":908,"manufacturer":"R.A.T.T. Works","manufacturerAbbrev":"RATT","maxThrustN":1223,"motorId":"5f4294d2000231000000038c","propInfo":"Tribrid: ABS/Alcohol/Nitrous","propWeightG":2266,"totImpulseNs":2170,"totalWeightG":14410,"type":"hybrid","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":379.1,"burnTimeS":12.24,"caseInfo":"RMS-98/5120","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L400","dataFiles":2,"delays":"P","designation":"L400W","diameter":98,"impulseClass":"L","length":443.9,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":770.2,"motorId":"5f4294d2000231000000038d","propInfo":"White Lightning","propWeightG":2696,"samples":[[0,0],[0.031,436.7],[0.062,493.9],[0.063,587],[0.108,634.7],[0.154,606.1],[0.277,622.8],[0.4,639.5],[0.508,610.9],[0.538,601.3],[0.908,665.7],[1.092,684.8],[1.631,720.6],[1.954,706.3],[2.385,703.9],[2.6,701.5],[2.769,689.6],[3.2,656.2],[3.754,587],[4.354,527.3],[5.262,434.3],[5.815,386.6],[6.477,336.4],[7.354,276.8],[8.046,217.1],[8.846,167],[9.862,107.4],[10.97,64.43],[11.97,40.56],[12.97,26.25],[13.98,14.32],[14.94,7.158],[15.46,2.386],[15.94,0]],"totImpulseNs":4642,"totalWeightG":5170,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1568,"burnTimeS":2.36,"caseInfo":"RMS-75/3840","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1520","dataFiles":2,"delays":"P","designation":"L1520T","diameter":75,"impulseClass":"L","length":517.9,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1765,"motorId":"5f4294d2000231000000038e","propInfo":"Blue Thunder","propWeightG":1854,"samples":[[0,0],[0.011,1485],[0.055,1506],[0.089,1468],[0.155,1561],[0.2,1572],[0.3,1582],[0.4,1599],[0.5,1621],[0.6,1642],[0.7,1653],[0.8,1675],[0.9,1691],[1,1686],[1.1,1697],[1.2,1691],[1.3,1691],[1.4,1680],[1.5,1664],[1.6,1637],[1.7,1621],[1.8,1604],[1.9,1577],[2,1561],[2.1,1539],[2.2,1501],[2.227,1436],[2.25,1126],[2.29,832],[2.366,647.1],[2.4,456.8],[2.44,244.7],[2.5,59.82],[2.6,0]],"totImpulseNs":3716,"totalWeightG":3651,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":171.8,"burnTimeS":2.4,"caseInfo":"RMS-54/426","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I170","dataFiles":1,"delays":"4,6,8,10","designation":"I170G","diameter":54,"impulseClass":"I","length":147.1,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":207.3,"motorId":"5f4294d2000231000000038f","propInfo":"Mojave Green","propWeightG":227,"samples":[[0,0],[0.06,89],[0.16,169],[0.25,184.6],[0.5,202.4],[0.75,207.3],[1,202.4],[1.5,177.9],[2.18,137.9],[2.25,139.7],[2.3,131.2],[2.35,22.2],[2.4,0]],"totImpulseNs":418.5,"totalWeightG":528,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":146.7,"burnTimeS":0.97,"caseInfo":"Pro24-6G","certOrg":"Canadian Association of Rocketry","commonName":"G150","dataFiles":2,"delays":"4,6,8,10,13","designation":"143G150-13A","diameter":24,"impulseClass":"G","length":228,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":247.4,"motorId":"5f4294d20002310000000390","propInfo":"Blue Streak","propWeightG":65.9,"samples":[[0,0],[0.005,114.8],[0.006,177.4],[0.01,222.6],[0.016,243.4],[0.019,247],[0.037,215.4],[0.077,206.1],[0.12,204.5],[0.163,200.2],[0.204,195.9],[0.249,192.9],[0.316,186.7],[0.387,180.4],[0.444,176.1],[0.536,168.2],[0.616,160.6],[0.639,156.7],[0.676,142.5],[0.715,114.8],[0.75,93.01],[0.784,72.23],[0.831,49.8],[0.889,31.66],[0.923,21.77],[0.953,14.84],[0.996,8.245],[1.03,5.937],[1.061,2.309],[1.099,0]],"totImpulseNs":142.5,"totalWeightG":159.9,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":106.9,"burnTimeS":1.3,"caseInfo":"Pro24-6G","certOrg":"Canadian Association of Rocketry","commonName":"G107","dataFiles":2,"delays":"3,5,7,9,12","designation":"139G107-12A","diameter":24,"impulseClass":"G","length":228,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":230.7,"motorId":"5f4294d20002310000000391","propInfo":"White Thunder","propWeightG":75.7,"samples":[[0,0],[0.006,133.2],[0.011,198.4],[0.022,221.8],[0.046,212.7],[0.081,218.4],[0.125,214.9],[0.168,210.4],[0.219,204.4],[0.253,195.9],[0.274,183.5],[0.305,88.29],[0.412,93.67],[0.529,93.99],[0.663,94.3],[0.789,93.99],[0.899,91.14],[0.953,89.87],[0.999,87.03],[1.03,81.33],[1.057,69.94],[1.102,54.11],[1.154,42.41],[1.197,31.65],[1.277,17.09],[1.335,9.81],[1.398,3.165],[1.451,0]],"totImpulseNs":139.1,"totalWeightG":169.8,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":236.2,"burnTimeS":0.29,"caseInfo":"Pro24-3G","certOrg":"Canadian Association of Rocketry","commonName":"F240","dataFiles":2,"delays":"8,10,12,15","designation":"68F240-15A","diameter":24,"impulseClass":"F","length":133,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":285.9,"motorId":"5f4294d20002310000000392","propInfo":"Vmax","propWeightG":30.3,"samples":[[0,0],[0.004,100.5],[0.007,197.5],[0.01,222],[0.022,241.4],[0.028,237.9],[0.041,239.4],[0.058,252.5],[0.077,264],[0.089,275.5],[0.097,271.5],[0.104,273.9],[0.119,278.6],[0.147,281.4],[0.177,272.3],[0.207,258.4],[0.246,226.4],[0.253,218.5],[0.259,188.8],[0.266,127],[0.272,74.8],[0.28,31.27],[0.286,15.83],[0.294,8.707],[0.31,3.562],[0.328,0]],"totImpulseNs":68.3,"totalWeightG":91.8,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":116.8,"burnTimeS":1.22,"caseInfo":"Pro24-6G","certOrg":"Canadian Association of Rocketry","commonName":"G117","dataFiles":2,"delays":"4,6,8,11","designation":"142G117-11A","diameter":24,"impulseClass":"G","length":228,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":181.2,"motorId":"5f4294d20002310000000393","propInfo":"White","propWeightG":79.1,"samples":[[0,0],[0.008,168.6],[0.013,177.3],[0.022,177.9],[0.035,171.3],[0.063,157.8],[0.103,154.9],[0.151,151.5],[0.196,148.9],[0.246,147.6],[0.311,144.1],[0.391,140.7],[0.474,138.1],[0.564,135.7],[0.662,131.2],[0.762,126],[0.858,116.7],[0.928,101.7],[0.973,83],[1.038,57.44],[1.08,42.69],[1.131,31.88],[1.185,17.66],[1.224,9.486],[1.258,5.27],[1.322,2.372],[1.4,0.791],[1.441,0]],"totImpulseNs":142.3,"totalWeightG":172.5,"type":"reload","updatedOn":"2022-08-24"},{"availability":"regular","avgThrustN":31,"burnTimeS":2.36,"caseInfo":"Pro24-3G","certOrg":"Canadian Association of Rocketry","commonName":"F30","dataFiles":2,"delays":"3,6","designation":"73F30-6A","diameter":24,"impulseClass":"F","length":133,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":56.8,"motorId":"5f4294d20002310000000394","propInfo":"White Thunder","propWeightG":40,"samples":[[0,0],[0.014,54.22],[0.056,43.46],[0.092,50.19],[0.16,54.06],[0.232,48.36],[0.363,45.75],[0.499,43.14],[0.655,40.29],[0.843,37.84],[1.216,32.61],[1.368,30.32],[1.54,26.36],[1.675,23.51],[1.861,19.08],[2.013,14.56],[2.159,10.05],[2.302,4.828],[2.462,1.504],[2.598,0]],"totImpulseNs":73.1,"totalWeightG":102.2,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":64.7,"burnTimeS":2.23,"caseInfo":"Pro24-6G","certOrg":"Canadian Association of Rocketry","commonName":"G65","dataFiles":2,"delays":"3,5,8","designation":"144G65-8A","diameter":24,"impulseClass":"G","length":228,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":159.7,"motorId":"5f4294d20002310000000395","propInfo":"White Thunder","propWeightG":80,"samples":[[0,0],[0.011,157.9],[0.024,149.5],[0.042,132.1],[0.057,125.5],[0.094,134],[0.122,131.2],[0.175,106.4],[0.269,94.05],[0.376,87.38],[0.54,82.14],[0.707,78.33],[0.845,74.76],[1.002,71.19],[1.206,65.48],[1.376,57.86],[1.553,48.33],[1.726,39.05],[1.914,28.33],[2.061,18.09],[2.205,8.571],[2.299,3.095],[2.398,0]],"totImpulseNs":144.3,"totalWeightG":174,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":84.2,"burnTimeS":1.56,"caseInfo":"Pro24-6G","certOrg":"Canadian Association of Rocketry","commonName":"G84","dataFiles":2,"delays":"3,5,7,10","designation":"131G84-10A","diameter":24,"impulseClass":"G","length":228,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":132.3,"motorId":"5f4294d20002310000000396","propInfo":"Green3","propWeightG":77.3,"samples":[[0,0],[0.005,80.26],[0.017,94.69],[0.023,108.7],[0.031,124.8],[0.044,129.8],[0.081,124.3],[0.149,116.5],[0.224,111.1],[0.301,107.6],[0.386,103.4],[0.506,98.2],[0.623,94.14],[0.759,89.7],[0.849,86],[0.974,81.37],[1.09,77.86],[1.149,74.72],[1.171,78.97],[1.202,70.83],[1.244,69.17],[1.3,68.24],[1.326,56.78],[1.373,52.52],[1.403,40.69],[1.447,29.04],[1.515,14.43],[1.562,6.103],[1.597,2.034],[1.641,0]],"totImpulseNs":131,"totalWeightG":172,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":78.8,"burnTimeS":0.86,"caseInfo":"Pro24-3G","certOrg":"Canadian Association of Rocketry","commonName":"F79","dataFiles":2,"delays":"4,6,8,10,13","designation":"68F79-13A","diameter":24,"impulseClass":"F","length":133,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":98.3,"motorId":"5f4294d20002310000000397","propInfo":"Smoky Sam","propWeightG":40.1,"samples":[[0,0],[0.005,60],[0.013,89.01],[0.022,96.29],[0.043,81.72],[0.119,85.56],[0.198,87.95],[0.267,89.27],[0.343,89.93],[0.404,90.86],[0.498,91.52],[0.555,89.67],[0.622,83.97],[0.663,80.53],[0.704,78.94],[0.729,74.17],[0.747,66.89],[0.768,53.77],[0.793,36.56],[0.821,18.54],[0.852,7.815],[0.892,2.119],[0.928,0.795],[0.997,0]],"totImpulseNs":67.8,"totalWeightG":107.5,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":53.8,"burnTimeS":3.12,"caseInfo":"Pro29-3G","certOrg":"Canadian Association of Rocketry","commonName":"H54","dataFiles":2,"delays":"3,5,7,10","designation":"168H54-10A","diameter":29,"impulseClass":"H","length":187,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":105,"motorId":"5f4294d20002310000000398","propInfo":"White","propWeightG":96.6,"samples":[[0,0],[0.017,103.1],[0.047,83.27],[0.088,91.82],[0.155,97.84],[0.199,89.29],[0.271,80.26],[0.406,76.62],[0.599,73.77],[0.898,69.02],[1.182,66.02],[1.475,60.48],[1.785,53.83],[2.099,44.8],[2.296,38.95],[2.577,27.55],[2.845,16.15],[3.097,6.491],[3.199,2.058],[3.298,1.108],[3.5,0]],"totImpulseNs":167.7,"totalWeightG":209,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":67,"burnTimeS":1.61,"caseInfo":"Pro29-2G","certOrg":"Canadian Association of Rocketry","commonName":"G68","dataFiles":2,"delays":"4,6,8,10,13","designation":"108G68-13A","diameter":29,"impulseClass":"G","length":142,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":94.1,"motorId":"5f4294d20002310000000399","propInfo":"White","propWeightG":59.9,"samples":[[0,0],[0.012,50.33],[0.017,79.31],[0.019,86.69],[0.03,91.83],[0.047,73.39],[0.048,81.69],[0.049,65.88],[0.061,58.23],[0.088,66.8],[0.12,70.88],[0.2,72.99],[0.307,75.1],[0.38,75.63],[0.487,76.42],[0.614,76.55],[0.726,75.63],[0.818,73.52],[0.987,70.49],[1.096,68.12],[1.269,63.51],[1.388,61.53],[1.446,57.44],[1.483,49.14],[1.537,29.38],[1.569,18.05],[1.613,5.665],[1.638,2.899],[1.676,1.449],[1.723,0.395],[1.759,0]],"totImpulseNs":107.8,"totalWeightG":155.9,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":135.1,"burnTimeS":1.6,"caseInfo":"Pro29-4G","certOrg":"Canadian Association of Rocketry","commonName":"H135","dataFiles":2,"delays":"3,5,7,9,12","designation":"217H135-12A","diameter":29,"impulseClass":"H","length":231,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":171.8,"motorId":"5f4294d2000231000000039a","propInfo":"White","propWeightG":119.8,"samples":[[0,0],[0.012,166.8],[0.054,158.6],[0.101,155.7],[0.156,153.1],[0.223,151.5],[0.312,150.4],[0.566,151],[0.706,149.1],[0.946,143.8],[1.121,140.4],[1.222,136.5],[1.278,137],[1.341,131.4],[1.374,126.7],[1.4,117.2],[1.431,100],[1.482,71.26],[1.535,49.35],[1.558,30.88],[1.598,11.88],[1.62,5.015],[1.644,2.375],[1.676,0]],"totImpulseNs":216.7,"totalWeightG":251.2,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":242.7,"burnTimeS":1.57,"caseInfo":"Pro29-6GXL","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I243","dataFiles":2,"delays":"4,6,8,10,13","designation":"382I243-13A","diameter":29,"impulseClass":"I","length":365,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":445.8,"motorId":"5f4294d2000231000000039b","propInfo":"White","propWeightG":212.1,"samples":[[0,0],[0.016,443.4],[0.03,416.3],[0.061,365.4],[0.082,331.7],[0.122,317.2],[0.174,303.3],[0.268,298],[0.367,295.4],[0.514,294.7],[0.701,290.7],[0.808,280.8],[0.968,267],[1.058,247.8],[1.105,224],[1.155,207.5],[1.178,202.2],[1.206,167.2],[1.254,158.6],[1.297,154.6],[1.336,132.8],[1.395,109.7],[1.486,69.38],[1.574,25.77],[1.649,6.608],[1.692,0]],"totImpulseNs":381.7,"totalWeightG":398.6,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":270.8,"burnTimeS":2.4,"caseInfo":"Pro38-5G","certOrg":"Canadian Association of Rocketry","commonName":"J270","dataFiles":2,"delays":"4,6,8,10,13","designation":"650J270-13A","diameter":38,"impulseClass":"J","length":367,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":238.3,"motorId":"5f4294d2000231000000039c","propInfo":"Green3","propWeightG":376,"samples":[[0,0],[0.008,194.1],[0.022,192.7],[0.061,279.5],[0.114,287.5],[0.229,289.3],[0.311,289.3],[0.382,292],[0.478,294.3],[0.587,296.5],[0.701,297.9],[0.828,301.9],[0.981,300.1],[1.116,299.7],[1.233,296.1],[1.323,293.4],[1.488,289.8],[1.594,287.1],[1.676,287.5],[1.701,293.8],[1.75,286.6],[1.797,290.2],[1.868,280.4],[1.956,275.9],[2.052,276.3],[2.126,266],[2.181,224.2],[2.234,163.1],[2.292,97.95],[2.359,49.87],[2.428,15.28],[2.5,0]],"totImpulseNs":650.3,"totalWeightG":654.8,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":394.1,"burnTimeS":2.46,"caseInfo":"Pro38-6GXL","certOrg":"Canadian Association of Rocketry","commonName":"J394","dataFiles":2,"delays":"4,6,8,10,13","designation":"970J394-13A","diameter":38,"impulseClass":"J","length":500,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":515.7,"motorId":"5f4294d2000231000000039d","propInfo":"Green3","propWeightG":572.1,"samples":[[0,0],[0.014,331.7],[0.038,359.2],[0.046,406.6],[0.08,441.6],[0.219,426.5],[0.331,421.7],[0.486,422.4],[0.657,423.8],[0.795,430.6],[0.936,436.8],[1.12,439.6],[1.297,445.7],[1.329,440.2],[1.381,449.2],[1.425,448.5],[1.472,448.5],[1.512,458.8],[1.544,447.8],[1.572,462.2],[1.624,456.7],[1.731,445.7],[1.801,456.7],[1.853,456.7],[1.873,474.6],[1.885,491.8],[1.952,451.9],[2.008,416.9],[2.034,385.3],[2.078,376.4],[2.152,296.7],[2.229,203.3],[2.305,133.2],[2.395,65.93],[2.48,19.23],[2.518,7.555],[2.55,0]],"totImpulseNs":970.4,"totalWeightG":938.9,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":57.9,"burnTimeS":2.36,"caseInfo":"Pro38-1G","certOrg":"Canadian Association of Rocketry","commonName":"G58","dataFiles":2,"delays":"4,6,8,10,13","designation":"137G58-13A","diameter":38,"impulseClass":"G","length":127,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":97.7,"motorId":"5f4294d2000231000000039e","propInfo":"White","propWeightG":76.3,"samples":[[0,0],[0.029,90.25],[0.046,69.17],[0.058,59.95],[0.084,47.17],[0.171,57.97],[0.28,59.55],[0.455,61.27],[0.586,61.66],[0.741,62.32],[0.952,63.77],[1.217,64.69],[1.43,63.77],[1.626,61.27],[1.807,58.1],[1.959,53.89],[2.104,48.35],[2.168,47.56],[2.21,44.01],[2.247,37.29],[2.329,22.27],[2.375,10.28],[2.414,2.767],[2.442,1.186],[2.5,0]],"totImpulseNs":136.8,"totalWeightG":212.5,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":109.3,"burnTimeS":2.47,"caseInfo":"Pro38-2G","certOrg":"Canadian Association of Rocketry","commonName":"H110","dataFiles":2,"delays":"5,7,9,11,14","designation":"269H110-14A","diameter":38,"impulseClass":"H","length":186,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":127.5,"motorId":"5f4294d2000231000000039f","propInfo":"White","propWeightG":152.6,"samples":[[0,0],[0.029,93.73],[0.052,118.1],[0.093,98.53],[0.153,109.3],[0.238,113.4],[0.461,118.9],[0.592,121],[0.72,122.7],[0.896,124.4],[1.15,124.9],[1.246,122.5],[1.461,119.6],[1.622,117.4],[1.79,115.7],[1.922,112.6],[2.114,112.8],[2.174,111.7],[2.21,98.87],[2.259,69.4],[2.319,47.47],[2.365,28.96],[2.441,12.17],[2.526,7.368],[2.597,2.228],[2.692,0]],"totImpulseNs":269.1,"totalWeightG":325.3,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":174.4,"burnTimeS":2.36,"caseInfo":"Pro38-3G","certOrg":"Canadian Association of Rocketry","commonName":"I175","dataFiles":2,"delays":"5,7,9,11,14","designation":"411I175-14A","diameter":38,"impulseClass":"I","length":245,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":197.9,"motorId":"5f4294d200023100000003a0","propInfo":"White","propWeightG":228.9,"samples":[[0,0],[0.019,149.4],[0.038,180.3],[0.052,166.8],[0.106,185],[0.148,187.6],[0.232,187.9],[0.338,189],[0.518,190.8],[0.604,192.2],[0.733,193.4],[0.877,195.1],[1.005,193.9],[1.128,193.4],[1.333,193.1],[1.495,190.8],[1.648,188.2],[1.79,183.5],[1.921,178],[2.001,178.3],[2.043,176.6],[2.089,151.2],[2.147,115.3],[2.212,70.23],[2.274,47.11],[2.32,22.83],[2.368,8.671],[2.396,3.757],[2.435,3.179],[2.5,0]],"totImpulseNs":411.4,"totalWeightG":437.5,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":242.1,"burnTimeS":2.264,"caseInfo":"Pro38-4G","certOrg":"Canadian Association of Rocketry","commonName":"I242","dataFiles":2,"delays":"6,8,10,12,15","designation":"548I242-15A","diameter":38,"impulseClass":"I","length":303,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":284.7,"motorId":"5f4294d200023100000003a1","propInfo":"White","propWeightG":305.2,"samples":[[0,0],[0.015,241],[0.035,272.7],[0.063,286.1],[0.094,277],[0.184,265.6],[0.299,262.8],[0.403,262.8],[0.537,266.4],[0.734,269.9],[0.884,271.5],[1.049,269.9],[1.223,265.6],[1.384,260.4],[1.61,249.3],[1.727,243],[1.865,235.1],[1.954,231.1],[2,220.8],[2.088,155.5],[2.164,93.01],[2.211,43.54],[2.278,10.29],[2.345,3.958],[2.402,0]],"totImpulseNs":548.2,"totalWeightG":549.9,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":295.4,"burnTimeS":2.31,"caseInfo":"Pro38-5G","certOrg":"Canadian Association of Rocketry","commonName":"J290","dataFiles":2,"delays":"6,8,10,12,15","designation":"684J290-15A","diameter":38,"impulseClass":"J","length":367,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":391.6,"motorId":"5f4294d200023100000003a2","propInfo":"White","propWeightG":381.5,"samples":[[0,0],[0.015,334.6],[0.028,364.1],[0.037,379.4],[0.061,391.6],[0.083,379.4],[0.107,372.6],[0.169,355.1],[0.289,343.5],[0.381,341.4],[0.588,337.2],[0.803,334.6],[1.011,330.9],[1.256,324.5],[1.498,321.4],[1.684,312.9],[1.805,306.1],[1.844,301.3],[1.89,269.1],[1.942,243.3],[1.979,223.7],[2.043,156.2],[2.128,118.7],[2.192,86.02],[2.279,35.36],[2.334,15.83],[2.402,0]],"totImpulseNs":683.6,"totalWeightG":659.8,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":354.7,"burnTimeS":2.31,"caseInfo":"Pro38-6G","certOrg":"Canadian Association of Rocketry","commonName":"J354","dataFiles":2,"delays":"7,9,11,13,16","designation":"819J354-16A","diameter":38,"impulseClass":"J","length":421,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":521.8,"motorId":"5f4294d200023100000003a3","propInfo":"White","propWeightG":457.8,"samples":[[0,0],[0.016,472.7],[0.024,487.7],[0.04,519.7],[0.08,499.1],[0.124,476.3],[0.167,457.1],[0.223,447.2],[0.357,430.8],[0.508,423.7],[0.612,418.7],[0.845,413],[1.038,406.6],[1.307,390.3],[1.422,382.5],[1.532,372.5],[1.624,369],[1.687,364.7],[1.763,317.8],[1.837,280.8],[1.94,220.4],[2.054,171.3],[2.143,128.7],[2.177,95.26],[2.235,62.56],[2.321,24.17],[2.359,12.09],[2.402,4.976],[2.5,0]],"totImpulseNs":818.7,"totalWeightG":778.2,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":98.5,"burnTimeS":6.23,"caseInfo":"Pro54-2G","certOrg":"Canadian Association of Rocketry","commonName":"I100","dataFiles":2,"delays":"7,8,9,10,11,12,13,14,15,16,17","designation":"614I100-17A","diameter":54,"impulseClass":"I","length":236,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":358.4,"motorId":"5f4294d200023100000003a4","propInfo":"Red Lightning","propWeightG":350.1,"samples":[[0,0],[0.042,269.3],[0.043,332.4],[0.07,225.1],[0.091,202.3],[0.14,234.1],[0.202,245.5],[0.349,220.8],[0.523,202.3],[0.837,183.3],[1.186,164.3],[1.681,139.6],[2.358,110.7],[3.321,76.46],[4.095,55.56],[4.919,37.04],[5.944,21.37],[6.726,12.35],[7.437,6.174],[8.142,2.849],[8.735,0.95],[8.993,0]],"totImpulseNs":613.6,"totalWeightG":807,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":142.9,"burnTimeS":8.47,"caseInfo":"Pro54-3G","certOrg":"Canadian Association of Rocketry","commonName":"J140","dataFiles":2,"delays":"P","designation":"1211J140-P","diameter":54,"impulseClass":"J","length":329,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":221.8,"motorId":"5f4294d200023100000003a5","propInfo":"White","propWeightG":680,"samples":[[0,0],[0.073,191.2],[0.109,196.1],[0.219,193.4],[0.51,211.3],[0.801,216.2],[0.991,216.2],[1.195,212.5],[1.53,209.5],[2.521,198.2],[3.096,188.2],[3.781,174.5],[4.174,165],[4.794,146.5],[5.464,125.5],[6.207,98.36],[7.001,65.16],[7.781,36.84],[8.444,11.27],[8.771,4.568],[9.158,1.218],[9.464,0]],"totImpulseNs":1211,"totalWeightG":1280,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":259.8,"burnTimeS":7.78,"caseInfo":"Pro54-5G","certOrg":"Canadian Association of Rocketry","commonName":"K261","dataFiles":2,"delays":"P","designation":"2021K261-P","diameter":54,"impulseClass":"K","length":488,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":370.1,"motorId":"5f4294d200023100000003a6","propInfo":"White","propWeightG":1152,"samples":[[0,0],[0.035,283.1],[0.069,321.7],[0.124,345.8],[0.228,336.8],[0.525,347.3],[0.85,359.3],[1.334,356.3],[1.79,359.3],[2.039,354.3],[2.412,353.3],[2.793,349.8],[3.131,344.3],[3.774,323.7],[4.652,278.5],[5.281,230.9],[5.571,206.8],[5.993,166.6],[6.325,137.5],[6.615,102.4],[7.085,55.21],[7.362,35.63],[7.694,20.58],[8.129,9.536],[8.502,2.509],[8.979,0]],"totImpulseNs":2021,"totalWeightG":1932,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":432.4,"burnTimeS":1.9,"caseInfo":"Pro54-2G","certOrg":"Canadian Association of Rocketry","commonName":"J430","dataFiles":2,"delays":"8,9,10,11,12,13,14,15,16,17,18","designation":"821J430-18A","diameter":54,"impulseClass":"J","length":236,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":546.8,"motorId":"5f4294d200023100000003a7","propInfo":"White Thunder","propWeightG":384,"samples":[[0,0],[0.017,400],[0.025,501.1],[0.034,538.7],[0.069,432.5],[0.111,440.6],[0.192,458.3],[0.328,469.4],[0.508,473.8],[0.697,473.8],[0.899,468.6],[0.996,461.3],[1.2,446.5],[1.401,429.5],[1.593,415.5],[1.696,410.3],[1.739,414.8],[1.785,354.2],[1.807,277.5],[1.83,180.1],[1.839,145.4],[1.853,107.7],[1.885,49.45],[1.914,19.19],[1.943,2.952],[1.963,0]],"totImpulseNs":821.1,"totalWeightG":799.8,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":757.7,"burnTimeS":1.67,"caseInfo":"Pro54-3G","certOrg":"Canadian Association of Rocketry","commonName":"J760","dataFiles":2,"delays":"9,10,11,12,13,14,15,16,17,18,19","designation":"1266J760-19A","diameter":54,"impulseClass":"J","length":329,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":937.3,"motorId":"5f4294d200023100000003a8","propInfo":"White Thunder","propWeightG":576,"samples":[[0,0],[0.012,600.3],[0.019,833.3],[0.026,938.6],[0.04,794.5],[0.054,756.9],[0.094,778.2],[0.129,800.8],[0.165,813.3],[0.218,825.8],[0.279,830.8],[0.377,835.8],[0.496,837.1],[0.617,829.6],[0.709,819.5],[0.811,802],[0.917,785.7],[1.041,764.4],[1.201,750.6],[1.331,741.9],[1.455,729.3],[1.488,729.3],[1.514,735.6],[1.556,749.4],[1.568,729.3],[1.575,665.4],[1.589,533.8],[1.616,327.1],[1.646,122.8],[1.659,72.68],[1.681,30.07],[1.713,6.266],[1.731,0]],"totImpulseNs":1266,"totalWeightG":1077,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":934.8,"burnTimeS":1.75,"caseInfo":"Pro54-4G","certOrg":"Canadian Association of Rocketry","commonName":"K940","dataFiles":2,"delays":"8,9,10,11,12,13,14,15,16,17,18","designation":"1633K940-18A","diameter":54,"impulseClass":"K","length":404,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1121,"motorId":"5f4294d200023100000003a9","propInfo":"White Thunder","propWeightG":768,"samples":[[0,0],[0.01,885.7],[0.011,1006],[0.021,1116],[0.035,1087],[0.053,963.9],[0.061,957.9],[0.094,975.9],[0.183,998.5],[0.321,1023],[0.394,1038],[0.515,1047],[0.626,1047],[0.769,1033],[0.929,1014],[1.089,982],[1.24,942.9],[1.343,912.8],[1.426,894.7],[1.474,881.2],[1.533,875.2],[1.575,873.7],[1.596,845.1],[1.606,800],[1.642,615],[1.661,479.7],[1.683,320.3],[1.703,200],[1.735,76.69],[1.753,45.11],[1.776,22.56],[1.797,0]],"totImpulseNs":1633,"totalWeightG":1367,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":2022,"burnTimeS":4.17,"caseInfo":"Pro75-6G","certOrg":"Canadian Association of Rocketry","commonName":"M2020","dataFiles":2,"delays":"P","designation":"8429M2020-P","diameter":75,"impulseClass":"M","length":893,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":2680,"motorId":"5f4294d200023100000003aa","propInfo":"Imax","propWeightG":4349,"samples":[[0,0],[0.023,2070],[0.036,1930],[0.053,2148],[0.073,2369],[0.089,2506],[0.136,2649],[0.182,2627],[0.262,2609],[0.364,2616],[0.566,2624],[1.387,2576],[1.639,2539],[1.986,2450],[2.198,2395],[2.457,2295],[2.708,2207],[2.831,2162],[2.933,2089],[3.036,1989],[3.109,1801],[3.175,1594],[3.307,1336],[3.45,1015],[3.589,708.5],[3.698,601.5],[3.814,461.3],[3.996,339.5],[4.115,203],[4.201,88.56],[4.301,0]],"totImpulseNs":8429,"totalWeightG":7032,"type":"reload","updatedOn":"2021-03-16"},{"availability":"regular","avgThrustN":819.9,"burnTimeS":3.59,"caseInfo":"Pro75-3G","certOrg":"Canadian Association of Rocketry","commonName":"L820","dataFiles":2,"delays":"P","designation":"2946L820-P","diameter":75,"impulseClass":"L","length":486,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":984.8,"motorId":"5f4294d200023100000003ab","propInfo":"Skidmark","propWeightG":1760,"samples":[[0,0],[0.026,497.4],[0.038,662.3],[0.058,738.8],[0.079,750.7],[0.114,721.6],[0.152,697.9],[0.213,679.4],[0.377,719],[0.547,754.6],[0.743,792.9],[0.962,839],[1.067,860.2],[1.629,957.8],[1.81,957.8],[2.044,942],[2.249,923.5],[2.462,902.4],[2.994,808.7],[3.064,816.6],[3.149,794.2],[3.213,800.8],[3.266,831.1],[3.339,866.8],[3.386,832.5],[3.415,725.6],[3.509,221.6],[3.526,141.2],[3.591,47.49],[3.632,27.7],[3.699,6.596],[3.801,0]],"sparky":true,"totImpulseNs":2946,"totalWeightG":3420,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":2082,"burnTimeS":3.28,"caseInfo":"Pro75-6GXL","certOrg":"Canadian Association of Rocketry","commonName":"M2080","dataFiles":2,"delays":"P","designation":"6827M2080-P","diameter":75,"impulseClass":"M","length":1025,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":2611,"motorId":"5f4294d200023100000003ac","propInfo":"Skidmark","propWeightG":4107,"samples":[[0,0],[0.027,1814],[0.04,2084],[0.067,2344],[0.097,2277],[0.132,2262],[0.172,2270],[0.218,2319],[0.323,2416],[0.447,2491],[0.541,2523],[0.676,2548],[0.816,2555],[1.026,2523],[1.23,2519],[1.459,2462],[1.669,2369],[1.987,2241],[2.21,2134],[2.539,2002],[2.63,1992],[2.7,1942],[2.746,1842],[2.784,1692],[2.811,1543],[2.843,1340],[2.999,883.6],[3.083,520.2],[3.177,277.9],[3.271,128.3],[3.365,53.44],[3.443,24.94],[3.5,0]],"sparky":true,"totImpulseNs":6827,"totalWeightG":7040,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1547,"burnTimeS":5.29,"caseInfo":"Pro75-6GXL","certOrg":"Canadian Association of Rocketry","commonName":"M1545","dataFiles":2,"delays":"P","designation":"8187M1545-P","diameter":75,"impulseClass":"M","length":1025,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1840,"motorId":"5f4294d200023100000003ad","propInfo":"Green3","propWeightG":4835,"samples":[[0,0],[0.038,1517],[0.063,1077],[0.068,1282],[0.076,1509],[0.144,1741],[0.207,1765],[0.334,1749],[0.537,1792],[0.753,1794],[1.053,1776],[1.383,1789],[1.704,1821],[1.856,1828],[2.013,1799],[2.601,1686],[2.905,1641],[3.188,1617],[3.472,1599],[3.738,1583],[3.958,1565],[4.14,1544],[4.216,1544],[4.33,1483],[4.453,1359],[4.55,1187],[4.723,1053],[4.876,891.8],[4.969,783.6],[5.028,643.8],[5.231,184.7],[5.303,68.6],[5.396,0]],"totImpulseNs":8187,"totalWeightG":7878,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":3654,"burnTimeS":8.19,"caseInfo":"Pro150-40k","certOrg":"Canadian Association of Rocketry","commonName":"O3700","dataFiles":2,"delays":"P","designation":"29920O3700-P","diameter":161,"impulseClass":"O","length":957,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":4082,"motorId":"5f4294d200023100000003ae","propInfo":"Skidmark","propWeightG":17160,"samples":[[0,0],[0.052,1009],[0.071,1647],[0.084,2505],[0.09,3184],[0.116,3410],[0.187,3114],[0.245,3050],[0.316,3108],[0.445,3242],[0.594,3462],[0.819,3653],[1.155,3677],[1.503,3775],[2.471,3932],[3.277,4013],[4.213,4030],[4.787,3984],[5.206,3926],[5.671,3868],[5.981,3851],[6.413,3752],[6.923,3619],[7.387,3497],[7.645,3363],[7.819,3102],[7.903,2905],[7.942,2383],[7.981,1948],[8.026,1311],[8.084,695.9],[8.135,359.5],[8.187,162.4],[8.277,81.19],[8.387,0]],"sparky":true,"totImpulseNs":29920,"totalWeightG":31350,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1073,"burnTimeS":2.09,"caseInfo":"AMW 54-2550","certOrg":"Canadian Association of Rocketry","commonName":"K1075","dataFiles":2,"delays":"P","designation":"2245K1075-P","diameter":54,"impulseClass":"K","length":728,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":1607,"motorId":"5f4294d200023100000003af","propInfo":"Skidmark","propWeightG":1259,"samples":[[0,0],[0.007,1574],[0.012,1038],[0.017,1476],[0.024,1083],[0.029,1365],[0.034,1117],[0.041,1267],[0.046,1162],[0.049,1226],[0.069,1160],[0.107,1130],[0.151,1109],[0.21,1100],[0.274,1102],[0.332,1102],[0.432,1115],[0.523,1119],[0.611,1132],[0.674,1141],[0.766,1149],[0.881,1160],[0.979,1179],[1.141,1192],[1.257,1190],[1.379,1192],[1.504,1203],[1.599,1211],[1.67,1233],[1.744,1250],[1.772,1226],[1.802,1156],[1.841,993.3],[1.888,737],[1.944,455],[2.002,267],[2.065,128.2],[2.11,68.36],[2.149,34.18],[2.198,0]],"sparky":true,"totImpulseNs":2245,"totalWeightG":2639,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":30.4,"burnTimeS":1.55,"certOrg":"National Association of Rocketry","commonName":"F30","dataFiles":2,"delays":"4,6,8","designation":"F30FJ","diameter":24,"impulseClass":"F","infoUrl":"https://nar.org/SandT/pdf/Aerotech/F30FJ.pdf","length":95,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":40.6,"motorId":"5f4294d200023100000003b0","propInfo":"Black Max","propWeightG":31.2,"samples":[[0,0],[0.056,22.71],[0.102,34.31],[0.134,36.36],[0.2,36.88],[0.3,36.7],[0.4,37.22],[0.5,38.24],[0.6,37.9],[0.7,37.9],[0.8,37.22],[0.9,36.36],[1,35.17],[1.1,33.29],[1.175,32.61],[1.2,31.41],[1.26,26.97],[1.3,22.71],[1.4,9.219],[1.453,5.805],[1.5,4.097],[1.6,0]],"totImpulseNs":47,"totalWeightG":70.6,"type":"SU","updatedOn":"2022-07-20"},{"availability":"regular","avgThrustN":138,"burnTimeS":1.14,"caseInfo":"RMS-29/40-120","certOrg":"National Association of Rocketry","commonName":"G138","dataFiles":1,"delays":"6,8,10,12,14","designation":"HP-G138T","diameter":29,"impulseClass":"G","infoUrl":"https://nar.org/SandT/pdf/Aerotech/G138T.pdf","length":124,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":190.1,"motorId":"5f4294d200023100000003b1","propInfo":"Blue Thunder","propWeightG":70,"samples":[[0,0],[0.002,113.5],[0.043,118.7],[0.098,125.1],[0.138,126.2],[0.198,133.6],[0.251,141],[0.293,146],[0.347,148.9],[0.398,156.9],[0.447,160.9],[0.5,165.9],[0.548,169.6],[0.601,173.7],[0.646,177.4],[0.697,183.1],[0.739,182],[0.798,182.5],[0.839,181.2],[0.901,182.5],[0.947,194.7],[0.972,185.3],[0.986,174.6],[0.998,161.5],[1,156.7],[1.012,143.6],[1.018,133.8],[1.026,120.3],[1.031,112],[1.036,98.44],[1.041,89.05],[1.044,77.48],[1.049,67.66],[1.054,54.78],[1.059,46.71],[1.064,33.18],[1.073,23.14],[1.082,12.66],[1.098,0.873],[1.099,0]],"totImpulseNs":157.1,"totalWeightG":148,"type":"reload","updatedOn":"2022-07-20"},{"availability":"regular","avgThrustN":1288,"burnTimeS":5.94,"caseInfo":"Pro98-3G","certOrg":"Canadian Association of Rocketry","commonName":"M1290","dataFiles":2,"delays":"P","designation":"7649M1290-P","diameter":98,"impulseClass":"M","length":548,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1562,"motorId":"5f4294d200023100000003b2","propInfo":"White","propWeightG":4295,"samples":[[0,0],[0.024,227.1],[0.063,873.4],[0.107,1162],[0.166,1400],[0.292,1358],[0.892,1435],[1.398,1513],[2.484,1559],[2.748,1550],[3.009,1507],[4.091,1282],[5.347,1026],[5.473,984.7],[5.596,718.3],[5.663,469.4],[5.789,214],[5.856,192.1],[6.046,0]],"totImpulseNs":7649,"totalWeightG":7411,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1760,"burnTimeS":5.89,"caseInfo":"Pro98-4G","certOrg":"Canadian Association of Rocketry","commonName":"N1800","dataFiles":2,"delays":"P","designation":"10367N1800-P","diameter":98,"impulseClass":"N","length":702,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":2216,"motorId":"5f4294d200023100000003b3","propInfo":"White","propWeightG":5727,"samples":[[0,0],[0.077,1769],[0.123,2206],[0.193,2042],[0.339,1989],[0.744,1994],[2.398,2144],[2.726,2119],[2.977,2078],[3.933,1786],[4.643,1525],[4.986,1444],[5.152,1353],[5.225,1261],[5.348,994.4],[5.437,738.9],[5.541,622.2],[5.73,355.6],[5.915,75],[5.931,0]],"totImpulseNs":10370,"totalWeightG":9180,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":2502,"burnTimeS":6.09,"caseInfo":"Pro98-6G","certOrg":"Canadian Association of Rocketry","commonName":"N2501","dataFiles":2,"delays":"P","designation":"15227N2501-P","diameter":98,"impulseClass":"N","length":1010,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":3892,"motorId":"5f4294d200023100000003b4","propInfo":"White","propWeightG":8496,"samples":[[0,0],[0.039,1716],[0.059,2836],[0.141,3488],[0.224,3189],[0.373,3136],[2.237,2999],[2.905,2928],[3.45,2770],[3.462,2787],[4.537,2408],[4.804,1949],[5.165,1685],[5.511,1182],[6.013,313.1],[6.088,0]],"totImpulseNs":15230,"totalWeightG":13310,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":933.2,"burnTimeS":1.7,"caseInfo":"AMW 54-1400","certOrg":"Canadian Association of Rocketry","commonName":"K935","dataFiles":1,"delays":"P","designation":"1581K935-P","diameter":54,"impulseClass":"K","length":403,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":1073,"motorId":"5f4294d200023100000003b5","propInfo":"Wild Wolf","propWeightG":732,"samples":[[0,0],[0.01,1073],[0.02,1044],[0.04,974.2],[0.07,1016],[0.1,1029],[0.14,1041],[0.17,1050],[0.22,1060],[0.25,1064],[0.29,1070],[0.34,1073],[0.39,1072],[0.42,1070],[0.45,1073],[0.49,1070],[0.52,1070],[0.58,1064],[0.64,1060],[0.7,1055],[0.76,1045],[0.81,1035],[0.85,1029],[0.88,1022],[0.91,1018],[0.94,1015],[0.97,1009],[1,1003],[1.06,985.7],[1.12,965.9],[1.16,950.9],[1.21,936.7],[1.26,919],[1.3,903.3],[1.34,890],[1.38,876.2],[1.43,861.1],[1.48,847],[1.51,719.7],[1.54,619.6],[1.56,510.3],[1.58,415.1],[1.6,295.7],[1.63,181.5],[1.66,66.76],[1.7,0]],"totImpulseNs":1581,"totalWeightG":1508,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":579,"burnTimeS":3.19,"caseInfo":"AMW 54-1750","certOrg":"Canadian Association of Rocketry","commonName":"K580","dataFiles":1,"delays":"P","designation":"1852K580-P","diameter":54,"impulseClass":"K","length":491,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":1077,"motorId":"5f4294d200023100000003b6","propInfo":"Tamed Tiger","propWeightG":895,"samples":[[0,0],[0.02,624.9],[0.03,1077],[0.07,846.7],[0.12,884.6],[0.2,855.5],[0.29,840.9],[0.39,835.1],[0.48,822.6],[0.56,808.6],[0.66,800.6],[0.74,784.6],[0.83,776.7],[0.9,762.7],[0.96,760.7],[1.03,748.7],[1.1,734.3],[1.14,713.2],[1.18,720.8],[1.27,704.8],[1.35,682.8],[1.43,666.9],[1.51,650.9],[1.59,632.9],[1.67,622.9],[1.73,605],[1.79,599],[1.86,579],[1.94,561],[1.99,559],[2.03,539.1],[2.09,533.1],[2.16,517.1],[2.24,507.1],[2.31,491.1],[2.39,477.2],[2.45,463.2],[2.51,442.3],[2.55,407.4],[2.6,360.8],[2.65,320.1],[2.69,276.4],[2.76,232.8],[2.82,194.9],[2.96,122.2],[3.2,0]],"totImpulseNs":1852,"totalWeightG":1823,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":340,"burnTimeS":1.86,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I350","dataFiles":2,"delays":"6,8,10","designation":"I350R","diameter":38,"impulseClass":"I","length":355.6,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":473,"motorId":"5f4294d200023100000003b7","propInfo":"Redline","propWeightG":348,"samples":[[0,0],[0.004,2.809],[0.008,207.9],[0.031,272.5],[0.035,359.6],[0.046,407.4],[0.081,432.6],[0.104,435.5],[0.127,427],[0.184,435.5],[0.223,443.9],[0.299,469.2],[0.399,480.4],[0.503,486],[0.603,474.8],[0.702,469.2],[0.802,457.9],[0.906,443.9],[1.002,432.6],[1.098,415.8],[1.205,390.5],[1.298,368],[1.401,345.6],[1.443,325.9],[1.497,216.3],[1.532,101.1],[1.57,33.71],[1.605,0]],"totImpulseNs":634.6,"totalWeightG":616,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":74.3,"burnTimeS":0.33,"caseInfo":"Pro24-1G","certOrg":"Canadian Association of Rocketry","commonName":"E75","dataFiles":2,"delays":"8,10,12,14,17","designation":"25E75-17A","diameter":24,"impulseClass":"E","length":69,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":99.9,"motorId":"5f4294d200023100000003b8","propInfo":"Vmax","propWeightG":104,"samples":[[0,0],[0.009,84.21],[0.012,95.1],[0.023,77.08],[0.027,68.7],[0.047,73.45],[0.092,81.83],[0.118,83.84],[0.141,86.47],[0.192,86.97],[0.222,85.34],[0.25,80.08],[0.26,78.33],[0.281,82.96],[0.287,78.21],[0.306,24.78],[0.314,14.14],[0.326,8.509],[0.329,0]],"totImpulseNs":24.8,"totalWeightG":52,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":98.1,"burnTimeS":1.17,"caseInfo":"Pro24-6G","certOrg":"Canadian Association of Rocketry","commonName":"G100","dataFiles":2,"delays":"5,7,9,11,14","designation":"114G100-14A","diameter":24,"impulseClass":"G","length":228,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":178.8,"motorId":"5f4294d200023100000003b9","propInfo":"Skidmark","propWeightG":63.3,"samples":[[0,0],[0.009,148.5],[0.024,178.2],[0.061,145.3],[0.475,117.4],[0.63,106.2],[0.833,85.13],[0.961,51.76],[1.024,29.97],[1.125,13.85],[1.186,0]],"sparky":true,"totImpulseNs":114.5,"totalWeightG":159,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":127.4,"burnTimeS":1.08,"caseInfo":"Pro24-6G","certOrg":"Canadian Association of Rocketry","commonName":"G127","dataFiles":2,"delays":"5,7,9,11,14","designation":"137G127-14A","diameter":24,"impulseClass":"G","length":228,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":182.1,"motorId":"5f4294d200023100000003ba","propInfo":"Red Lightning","propWeightG":70.5,"samples":[[0,0],[0.018,164.5],[0.029,175.5],[0.042,172.1],[0.14,179.8],[0.378,158.8],[0.578,138.6],[0.763,121.5],[0.838,97.64],[0.9,62.32],[0.966,32.62],[1.056,13.05],[1.081,0]],"totImpulseNs":137.3,"totalWeightG":166,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":85,"burnTimeS":0.87,"caseInfo":"Pro24-3G","certOrg":"Canadian Association of Rocketry","commonName":"F85","dataFiles":2,"delays":"6,8,10,12,15","designation":"74F85-15A","diameter":24,"impulseClass":"F","length":133,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":105.6,"motorId":"5f4294d200023100000003bb","propInfo":"White Thunder","propWeightG":33.7,"samples":[[0,0],[0.01,76.07],[0.023,100.2],[0.04,92.42],[0.118,100.9],[0.283,102.4],[0.51,96.44],[0.688,87.44],[0.787,25.91],[0.852,7.206],[0.873,0]],"totImpulseNs":73.6,"totalWeightG":96,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":740.1,"burnTimeS":2.53,"caseInfo":"Pro54-4G","certOrg":"Canadian Association of Rocketry","commonName":"K740","dataFiles":2,"delays":"8,9,10,11,12,13,14,15,16,17,18","designation":"1874K740-18A","diameter":54,"impulseClass":"K","length":404,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":883.9,"motorId":"5f4294d200023100000003bc","propInfo":"C-Star","propWeightG":846.2,"samples":[[0,0],[0.02,735.2],[0.052,853.4],[0.486,869.3],[0.893,848.9],[1.903,735.2],[2.131,722.7],[2.32,330.7],[2.462,101.1],[2.5,0]],"totImpulseNs":1874,"totalWeightG":1469,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":244.3,"burnTimeS":3.55,"caseInfo":"Pro54-2G","certOrg":"Canadian Association of Rocketry","commonName":"J244","dataFiles":2,"delays":"4,5,6,7,8,9,10,11,12,13,14","designation":"867J244-14A","diameter":54,"impulseClass":"J","length":236,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":270.3,"motorId":"5f4294d200023100000003bd","propInfo":"White","propWeightG":472.1,"samples":[[0,0],[0.029,154.1],[0.1,262.5],[0.161,235.7],[0.484,256.6],[0.853,261.2],[1.348,266.5],[1.904,262.5],[2.422,251.9],[2.855,235.7],[3.176,223.1],[3.252,221.8],[3.362,185],[3.5,0]],"totImpulseNs":867.2,"totalWeightG":911,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":363.6,"burnTimeS":3.52,"caseInfo":"Pro54-3G","certOrg":"Canadian Association of Rocketry","commonName":"K360","dataFiles":2,"delays":"3,4,5,6,7,8,9,10,11,12,13","designation":"1281K360-13A","diameter":54,"impulseClass":"K","length":329,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":405.5,"motorId":"5f4294d200023100000003be","propInfo":"White","propWeightG":708.2,"samples":[[0,0],[0.034,289.3],[0.077,362.3],[0.463,387.5],[1.106,398.6],[1.564,405.2],[2.063,398.6],[2.57,383.5],[3.101,354.8],[3.18,343.7],[3.417,105.3],[3.5,0]],"totImpulseNs":1281,"totalWeightG":1232,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":837.9,"burnTimeS":9,"caseInfo":"Pro75-6G","certOrg":"Canadian Association of Rocketry","commonName":"M840","dataFiles":2,"delays":"P","designation":"7521M840-P","diameter":75,"impulseClass":"M","length":879.3,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":2043,"motorId":"5f4294d200023100000003bf","propInfo":"White","propWeightG":4249,"samples":[[0,0],[0.072,1980],[0.246,1447],[0.835,1121],[2.132,1094],[3.922,1003],[5.441,810.2],[6.559,621.5],[7.357,472.8],[8.547,199.8],[8.973,97.67],[9.009,0]],"totImpulseNs":7521,"totalWeightG":6954,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":555.1,"burnTimeS":4.33,"caseInfo":"Pro75-2G","certOrg":"Canadian Association of Rocketry","commonName":"K555","dataFiles":2,"delays":"P","designation":"2406K555-P","diameter":75,"impulseClass":"K","length":350,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":646.7,"motorId":"5f4294d200023100000003c0","propInfo":"White","propWeightG":1407,"samples":[[0,0],[0.038,426.1],[0.07,585.3],[0.137,522.4],[0.751,543.9],[1.732,629.1],[2.057,639.5],[3.221,571.8],[3.84,516],[4.091,472.2],[4.163,399],[4.274,148.9],[4.314,0]],"totImpulseNs":2406,"totalWeightG":2759,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":849.1,"burnTimeS":4.34,"caseInfo":"Pro75-3G","certOrg":"Canadian Association of Rocketry","commonName":"L851","dataFiles":2,"delays":"P","designation":"3683L851-P","diameter":75,"impulseClass":"L","length":486,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":989.9,"motorId":"5f4294d200023100000003c1","propInfo":"White","propWeightG":2110,"samples":[[0,0],[0.059,971.3],[0.102,855.2],[0.485,838.7],[1.353,911.6],[1.824,980.1],[3.107,884],[3.68,816.6],[4.031,732.6],[4.128,579],[4.256,246.4],[4.339,0]],"totImpulseNs":3683,"totalWeightG":3789,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":3294,"burnTimeS":5.86,"caseInfo":"Pro98-6GXL","certOrg":"Canadian Association of Rocketry","commonName":"N3301","dataFiles":2,"delays":"P","designation":"19318N3301-P","diameter":98,"impulseClass":"N","length":1239,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":5076,"motorId":"5f4294d200023100000003c2","propInfo":"White","propWeightG":10660,"samples":[[0,0],[0.027,5000],[0.074,4201],[0.114,4416],[0.325,4091],[1.438,3993],[2.391,3964],[3.139,3843],[4.033,3524],[4.425,2558],[4.774,2315],[5.318,1117],[5.793,329.9],[5.875,0]],"totImpulseNs":19320,"totalWeightG":16530,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":162.6,"burnTimeS":3.19,"caseInfo":"Pro54-1G","certOrg":"Canadian Association of Rocketry","commonName":"I165","dataFiles":1,"delays":"7,8,9,10,11,12,13,14,15,16,17","designation":"518I165-17A","diameter":54,"impulseClass":"I","length":69,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":190.5,"motorId":"5f4294d200023100000003c3","propInfo":"C-Star","propWeightG":230.1,"samples":[[0,0],[0.027,133.4],[0.056,174.8],[0.067,180],[0.497,188.6],[1.018,184],[1.704,170],[2.95,129.4],[3.05,130.7],[3.168,44.66],[3.213,17.86],[3.271,3.518],[3.5,0]],"totImpulseNs":512.2,"totalWeightG":594,"type":"reload","updatedOn":"2021-06-13"},{"availability":"regular","avgThrustN":23510,"burnTimeS":1.31,"caseInfo":"Pro130-","certOrg":"Canadian Association of Rocketry","commonName":"O25000","dataFiles":2,"delays":"P","designation":"30795O25000-P","diameter":132,"impulseClass":"O","infoUrl":"http://www.pro38.com/products/pro130/motor/MotorData.php?prodid=30795O25000-P","length":1407,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":29280,"motorId":"5f4294d200023100000003c4","propInfo":"Vmax","propWeightG":14470,"samples":[[0,0],[0.008,21110],[0.022,24710],[0.042,26280],[0.067,24390],[0.201,24040],[0.56,25050],[0.927,24080],[1.202,22820],[1.25,23600],[1.297,4853],[1.32,0]],"totImpulseNs":30790,"totalWeightG":23560,"type":"SU","updatedOn":"2021-07-04"},{"availability":"regular","avgThrustN":162,"burnTimeS":1.74,"caseInfo":"RMS-38/360","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H178","dataFiles":2,"delays":"6,8,10,12,14","designation":"H178DM","diameter":38,"impulseClass":"H","length":191,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":202,"motorId":"5f4294d200023100000003c5","propInfo":"Dark Matter","propWeightG":177,"samples":[[0,0],[0.016,132.7],[0.099,165.7],[0.146,163],[0.201,163.4],[0.256,164.9],[0.301,168.5],[0.358,173.2],[0.401,176.4],[0.457,177.9],[0.498,183],[0.6,198.8],[0.635,204.3],[0.703,204.3],[0.799,215.7],[0.901,210.6],[0.999,211.8],[1.049,205.1],[1.098,206.3],[1.202,196.8],[1.297,178.3],[1.351,172.8],[1.404,178.3],[1.434,186.2],[1.499,125.6],[1.539,71.25],[1.566,44.88],[1.582,31.49],[1.601,27.95],[1.606,16.53],[1.617,18.89],[1.644,8.66],[1.684,4.33],[1.735,0]],"sparky":true,"totImpulseNs":283,"totalWeightG":324,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":327,"burnTimeS":1.72,"caseInfo":"RMS-38/720","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I327","dataFiles":2,"delays":"6,8,10,12,14","designation":"I327DM","diameter":38,"impulseClass":"I","length":337,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":400,"motorId":"5f4294d200023100000003c6","propInfo":"Dark Matter","propWeightG":354,"samples":[[0,0],[0.009,393.7],[0.026,432.6],[0.161,387.1],[0.245,382.7],[0.303,371],[0.601,372.5],[0.702,371],[0.798,375.4],[0.983,371.7],[1.04,370.3],[1.104,371.7],[1.199,343.1],[1.3,335.8],[1.335,357.8],[1.365,327.8],[1.399,265.4],[1.428,185.5],[1.451,156.9],[1.493,112.2],[1.553,68.19],[1.601,32.26],[1.656,11.73],[1.723,0]],"sparky":true,"totImpulseNs":539,"totalWeightG":628,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":438,"burnTimeS":2.89,"caseInfo":"RMS-54/1706","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K456","dataFiles":2,"delays":"6,8,10,12,14","designation":"K456DM","diameter":54,"impulseClass":"K","length":401,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":534,"motorId":"5f4294d200023100000003c7","propInfo":"Dark Matter","propWeightG":866,"samples":[[0,0],[0.027,444.1],[0.038,519.6],[0.066,482.9],[0.129,461.3],[0.302,468],[0.389,468.7],[0.499,477],[0.655,476.2],[0.798,483.7],[0.946,488.9],[1.096,499.4],[1.401,500.9],[1.603,503.9],[1.801,501.6],[1.905,498.6],[2.1,485.9],[2.302,456],[2.404,435.9],[2.505,420.2],[2.574,398.5],[2.607,373.1],[2.645,356.6],[2.703,289.3],[2.768,178.7],[2.804,123.4],[2.837,88.96],[2.875,50.84],[2.908,24.67],[2.957,10.47],[3.037,0]],"sparky":true,"totImpulseNs":1281,"totalWeightG":1484,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":900,"burnTimeS":4.4,"caseInfo":"RMS-75/5120","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L900","dataFiles":2,"delays":"P","designation":"L900DM","diameter":75,"impulseClass":"L","length":665,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","motorId":"5f4294d200023100000003c8","propInfo":"Dark Matter","propWeightG":2472,"samples":[[0,0],[0.016,578],[0.041,870.4],[0.086,851.8],[0.303,931.2],[0.417,944.7],[0.515,910.9],[0.998,936.3],[1.272,976.9],[1.501,992.1],[1.747,1019],[2,1029],[2.205,1055],[2.495,1048],[2.77,1034],[3.003,998.8],[3.166,981.9],[3.498,909.2],[3.592,880.5],[3.702,890.7],[3.768,856.9],[3.862,672.6],[3.964,442.8],[4.021,353.2],[4.111,285.6],[4.242,104.8],[4.3,50.7],[4.369,21.97],[4.484,0]],"sparky":true,"totImpulseNs":3868,"totalWeightG":4724,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1103,"burnTimeS":1.6,"caseInfo":"RMS-54/1706","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K1103","dataFiles":2,"delays":"6,8,10,12,14","designation":"K1103X","diameter":54,"impulseClass":"K","length":401,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1780,"motorId":"5f4294d200023100000003c9","propInfo":"Propellant X","propWeightG":830,"samples":[[0,0],[0.012,1336],[0.016,1505],[0.028,1620],[0.045,1500],[0.081,1393],[0.151,1331],[0.201,1306],[0.399,1281],[0.602,1244],[0.803,1196],[1.001,1144],[1.203,1074],[1.296,1042],[1.384,1032],[1.408,1004],[1.423,961.9],[1.438,839.8],[1.46,737.6],[1.49,510.9],[1.505,446.1],[1.603,176.9],[1.608,209.3],[1.638,97.19],[1.688,0]],"totImpulseNs":1789,"totalWeightG":1459,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1465,"burnTimeS":5.11,"caseInfo":"98/11000","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1465","dataFiles":1,"delays":"P","designation":"M1465BL","diameter":98,"impulseClass":"M","length":870,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":2219,"motorId":"5f4294d200023100000003ca","propInfo":"Black Lightning","propWeightG":4992,"samples":[[0,0],[0.33,1113],[1.65,1752],[3,2219],[3.513,2100],[3.983,1824],[4.3,1335],[4.453,334],[5.2,0]],"sparky":true,"totImpulseNs":7532,"totalWeightG":9801,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1025,"burnTimeS":9.36,"caseInfo":"98/11000","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1025","dataFiles":1,"delays":"P","designation":"M1025WC","diameter":98,"impulseClass":"M","length":870,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":1852,"motorId":"5f4294d200023100000003cb","propInfo":"White Cloud","propWeightG":5329,"samples":[[0,0],[0.1,1780],[0.5,1558],[3.256,1500],[6.179,795.1],[9.363,0]],"totImpulseNs":9580,"totalWeightG":10140,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1406,"burnTimeS":4.8,"caseInfo":"RMS-98/7680","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1305","dataFiles":2,"delays":"P","designation":"M1305M","diameter":98,"impulseClass":"M","length":597,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":2098,"motorId":"5f4294d200023100000003cc","propInfo":"Metalstorm","propWeightG":4080,"samples":[[0,0],[0.016,1288],[0.043,1463],[0.08,1371],[0.407,1623],[0.535,1640],[0.787,1706],[0.985,1694],[1.13,1717],[1.328,1694],[1.349,1928],[1.397,1726],[1.751,1712],[2.018,1688],[2.275,1691],[2.297,1892],[2.318,1679],[2.929,1412],[3.748,1113],[4.24,906.1],[4.503,802.5],[4.717,663.3],[4.813,538.9],[4.92,387.9],[5.027,245.8],[5.166,145.1],[5.263,79.95],[5.386,32.57],[5.498,23.69],[5.707,0]],"sparky":true,"totImpulseNs":6891,"totalWeightG":7098,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1070,"burnTimeS":5.2,"caseInfo":"RMS-98/7680","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1075","dataFiles":2,"delays":"P","designation":"M1075DM","diameter":98,"impulseClass":"M","length":597,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1330,"motorId":"5f4294d200023100000003cd","propInfo":"Dark Matter","propWeightG":3846,"samples":[[0,0],[0.02,927.5],[0.112,988.1],[0.26,1034],[0.53,1081],[0.897,1124],[1.509,1198],[1.998,1240],[2.355,1261],[2.503,1264],[2.773,1238],[2.997,1223],[3.502,1162],[4.001,1064],[4.501,906.7],[4.741,834.8],[4.878,742],[4.96,664.4],[5.062,448.6],[5.164,223.4],[5.26,79.5],[5.352,30.29],[5.5,0]],"sparky":true,"totImpulseNs":5571,"totalWeightG":6971,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":992,"burnTimeS":3.79,"caseInfo":"RMS-75/5120","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1040","dataFiles":2,"delays":"P","designation":"L1040DM","diameter":75,"impulseClass":"L","length":681,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1255,"motorId":"5f4294d200023100000003ce","propInfo":"Dark Matter","propWeightG":2602,"samples":[[0,0],[0.018,1126],[0.042,1036],[0.053,1003],[0.116,989],[0.504,1050],[0.794,1096],[1.002,1146],[1.252,1192],[1.499,1238],[1.753,1262],[1.912,1268],[2.095,1255],[2.511,1135],[2.772,1057],[3.012,967],[3.153,933.1],[3.217,863.7],[3.291,818],[3.34,758.7],[3.488,438.6],[3.552,284.5],[3.598,220.2],[3.657,167.7],[3.746,118.5],[3.88,42.34],[3.996,6.774],[4.127,0]],"sparky":true,"totImpulseNs":3769,"totalWeightG":4717,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":30.8,"burnTimeS":0.85,"caseInfo":"Pro24-1G","certOrg":"Canadian Association of Rocketry","commonName":"E31","dataFiles":2,"delays":"6,8,10,12,15","designation":"26E31-15A","diameter":24,"impulseClass":"E","length":69,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":52.6,"motorId":"5f4294d200023100000003cf","propInfo":"White Thunder","propWeightG":11.1,"samples":[[0,0],[0.02,43.82],[0.027,39.96],[0.049,26.78],[0.113,32.6],[0.193,34.74],[0.282,35.81],[0.5,34.44],[0.727,29.28],[0.771,22.74],[0.807,9.561],[0.84,3.563],[0.87,0]],"totImpulseNs":26.1,"totalWeightG":52,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":23.4,"burnTimeS":1.03,"caseInfo":"Pro24-1G","certOrg":"Canadian Association of Rocketry","commonName":"E22","dataFiles":2,"delays":"4,6,8,10,13","designation":"24E22-13A","diameter":24,"impulseClass":"E","length":69,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":34.4,"motorId":"5f4294d200023100000003d0","propInfo":"Smoky Sam","propWeightG":13.4,"samples":[[0,0],[0.008,18.29],[0.026,30],[0.038,30.79],[0.067,18.71],[0.101,21.88],[0.33,26.08],[0.528,28.04],[0.716,27.88],[0.841,23.54],[0.912,17.83],[0.987,7],[1.016,3.333],[1.065,1.083],[1.087,0]],"totImpulseNs":24.2,"totalWeightG":56.5,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":50,"burnTimeS":1.19,"caseInfo":"Pro24-3G","certOrg":"Canadian Association of Rocketry","commonName":"F50","dataFiles":2,"delays":"4,6,8,10,13","designation":"60F50-13A","diameter":24,"impulseClass":"F","length":133,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":69.9,"motorId":"5f4294d200023100000003d1","propInfo":"Skidmark","propWeightG":31.7,"samples":[[0,0],[0.015,64.98],[0.022,69.52],[0.064,55.54],[0.118,62.81],[0.342,62.15],[0.536,59.41],[0.743,53.84],[0.884,46.94],[0.976,40.05],[1.096,12.56],[1.246,2.078],[1.298,0]],"sparky":true,"totImpulseNs":59.7,"totalWeightG":93.9,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":50,"burnTimeS":1.5,"caseInfo":"Pro24-3G","certOrg":"Canadian Association of Rocketry","commonName":"F51","dataFiles":2,"delays":"3,5,7,9,12","designation":"75F51-12A","diameter":24,"impulseClass":"F","length":133,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":85.1,"motorId":"5f4294d200023100000003d2","propInfo":"Classic","propWeightG":33,"samples":[[0,0],[0.02,75.92],[0.031,84.15],[0.062,70.44],[0.117,73.66],[1.211,38.74],[1.376,14.78],[1.456,7.271],[1.532,3.337],[1.577,0]],"totImpulseNs":75,"totalWeightG":95,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":452.7,"burnTimeS":2.24,"caseInfo":"Pro38-6GXL","certOrg":"Canadian Association of Rocketry","commonName":"J453","dataFiles":2,"delays":"7,9,11,13,16","designation":"1013J453-16A","diameter":38,"impulseClass":"J","length":500,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":725.3,"motorId":"5f4294d200023100000003d3","propInfo":"White","propWeightG":585.5,"samples":[[0,0],[0.018,663.8],[0.04,725.2],[0.105,630.2],[0.23,578.4],[0.451,543.9],[1.454,535.3],[1.797,291.6],[1.91,189],[2.088,128.5],[2.276,19.18],[2.364,0]],"totImpulseNs":1013,"totalWeightG":964.3,"type":"reload","updatedOn":"2021-02-26"},{"availability":"regular","avgThrustN":315.1,"burnTimeS":2.08,"caseInfo":"Pro38-5G","certOrg":"Canadian Association of Rocketry","commonName":"J316","dataFiles":2,"delays":"8,10,12,14,17","designation":"654J316-17A","diameter":38,"impulseClass":"J","length":367,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":448.7,"motorId":"5f4294d200023100000003d4","propInfo":"Pink","propWeightG":256.3,"samples":[[0,0],[0.017,393.1],[0.026,443.3],[0.064,381.1],[0.223,393.1],[0.503,379.3],[1.029,354.2],[1.52,320.8],[1.672,313],[1.695,296.3],[1.816,145.8],[1.901,88.41],[2.043,32.85],[2.184,0]],"totImpulseNs":654.3,"totalWeightG":607.1,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":804.5,"burnTimeS":3.52,"caseInfo":"Pro54-6GXL","certOrg":"Canadian Association of Rocketry","commonName":"L805","dataFiles":2,"delays":"P","designation":"2833L805-P","diameter":54,"impulseClass":"L","length":649,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1634,"motorId":"5f4294d200023100000003d5","propInfo":"White","propWeightG":1640,"samples":[[0,0],[0.012,1618],[0.037,1172],[0.173,1028],[0.388,994.1],[0.626,985.7],[2.318,886.3],[3.054,448.4],[3.464,126.9],[3.608,40.19],[3.827,0]],"totImpulseNs":2833,"totalWeightG":2503,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":651.5,"burnTimeS":3.07,"caseInfo":"Pro54-5G","certOrg":"Canadian Association of Rocketry","commonName":"K650","dataFiles":2,"delays":"11,12,13,14,15,16,17,18,19,20,21","designation":"1997K650-21A","diameter":54,"impulseClass":"K","length":488,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1355,"motorId":"5f4294d200023100000003d6","propInfo":"Pink","propWeightG":1135,"samples":[[0,0],[0.011,1354],[0.028,793.8],[0.186,815.4],[2.578,601.2],[2.689,480],[2.855,189.3],[3.086,43.18],[3.451,0]],"totImpulseNs":1997,"totalWeightG":1710,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":2036,"burnTimeS":1.14,"caseInfo":"Pro75-2G","certOrg":"Canadian Association of Rocketry","commonName":"K2000","dataFiles":2,"designation":"2330K2000-P","diameter":75,"impulseClass":"K","length":350,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":2481,"motorId":"5f4294d200023100000003d7","propInfo":"Vmax","propWeightG":1102,"samples":[[0,0],[0.01,1980],[0.029,1635],[0.161,1947],[0.321,2190],[0.457,2398],[0.548,2474],[0.678,2383],[0.768,2263],[0.977,1924],[1.027,1883],[1.104,859.6],[1.149,87.72],[1.191,0]],"totImpulseNs":2330,"totalWeightG":2465,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":3209,"burnTimeS":1.03,"caseInfo":"Pro75-3G","certOrg":"Canadian Association of Rocketry","commonName":"L3200","dataFiles":2,"designation":"3300L3200-P","diameter":75,"impulseClass":"L","length":486,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":3723,"motorId":"5f4294d200023100000003d8","propInfo":"Vmax","propWeightG":1555,"samples":[[0,0],[0.008,3315],[0.024,2673],[0.108,2975],[0.415,3669],[0.524,3712],[0.644,3669],[0.819,3226],[0.911,3022],[0.937,3051],[0.957,2900],[1.022,288.1],[1.039,51.95],[1.055,0]],"totImpulseNs":3300,"totalWeightG":3264,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":644.8,"burnTimeS":5.3,"caseInfo":"Pro75-3G","certOrg":"Canadian Association of Rocketry","commonName":"L645","dataFiles":2,"designation":"3419L645-P","diameter":75,"impulseClass":"L","length":486,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":776.6,"motorId":"5f4294d200023100000003d9","propInfo":"Green3","propWeightG":2072,"samples":[[0,0],[0.05,511.2],[0.12,647.6],[0.256,689.2],[0.425,684.5],[1.554,736.6],[2.043,765],[3.075,687.3],[4.557,601.2],[4.756,550.1],[4.985,412.8],[5.281,69.11],[5.39,0]],"totImpulseNs":3420,"totalWeightG":3752,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":735.7,"burnTimeS":2.66,"caseInfo":"Pro75-2G","certOrg":"Canadian Association of Rocketry","commonName":"K735","dataFiles":2,"designation":"1955K735-P","diameter":75,"impulseClass":"K","length":350,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":911,"motorId":"5f4294d200023100000003da","propInfo":"Skidmark","propWeightG":1173,"samples":[[0,0],[0.053,683.2],[0.142,593.6],[0.408,697.3],[0.893,848.1],[1.109,886.9],[1.24,882.2],[1.362,889.3],[2,783.3],[2.346,706.7],[2.439,649],[2.612,123.7],[2.676,36.51],[2.754,12.96],[2.831,0]],"sparky":true,"totImpulseNs":1955,"totalWeightG":2509,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":907.1,"burnTimeS":3.15,"caseInfo":"Pro75-2G","certOrg":"Canadian Association of Rocketry","commonName":"L910","dataFiles":2,"designation":"2856L910-P","diameter":75,"impulseClass":"L","length":350,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1086,"motorId":"5f4294d200023100000003db","propInfo":"C-Star","propWeightG":1270,"samples":[[0,0],[0.034,858.7],[0.056,921.7],[0.305,952.4],[0.718,983.2],[1.221,1048],[1.642,1006],[1.842,973.4],[2.951,773.4],[3.035,584.6],[3.108,169.2],[3.152,72.73],[3.182,27.97],[3.262,0]],"totImpulseNs":2856,"totalWeightG":2616,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1350,"burnTimeS":3.16,"caseInfo":"Pro75-3G","certOrg":"Canadian Association of Rocketry","commonName":"L1350","dataFiles":2,"designation":"4263L1350-P","diameter":75,"impulseClass":"L","length":486,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1673,"motorId":"5f4294d200023100000003dc","propInfo":"C-Star","propWeightG":1905,"samples":[[0,0],[0.016,1422],[0.034,1345],[0.049,1502],[0.081,1415],[0.21,1432],[0.453,1432],[0.809,1462],[1.07,1534],[1.28,1541],[2.661,1284],[2.843,1277],[2.932,1116],[3.037,488.8],[3.163,82.88],[3.284,0]],"totImpulseNs":4263,"totalWeightG":3571,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":660.5,"burnTimeS":3.68,"caseInfo":"Pro75-2G","certOrg":"Canadian Association of Rocketry","commonName":"K661","dataFiles":2,"designation":"2430K661-P","diameter":75,"impulseClass":"K","length":350,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":761.3,"motorId":"5f4294d200023100000003dd","propInfo":"Blue Streak","propWeightG":1182,"samples":[[0,0],[0.041,588.6],[0.073,659.4],[0.122,635.2],[0.225,634.2],[0.679,713.4],[1.039,751.6],[1.241,758.1],[1.832,727.4],[2.298,687.3],[2.729,667.8],[3.195,645.4],[3.367,670.5],[3.584,182.5],[3.672,55.88],[3.72,18.63],[3.798,0]],"totImpulseNs":2430,"totalWeightG":2528,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1046,"burnTimeS":3.56,"caseInfo":"Pro75-3G","certOrg":"Canadian Association of Rocketry","commonName":"L1050","dataFiles":2,"designation":"3727L1050-P","diameter":75,"impulseClass":"L","length":486,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1208,"motorId":"5f4294d200023100000003de","propInfo":"Blue Streak","propWeightG":1774,"samples":[[0,0],[0.035,721.4],[0.081,1110],[0.131,1057],[0.249,1100],[0.913,1194],[1.125,1207],[2.271,1100],[2.797,1056],[3.076,1043],[3.122,996.5],[3.23,807.1],[3.452,289.9],[3.544,123.5],[3.685,36.23],[3.731,0]],"totImpulseNs":3727,"totalWeightG":3448,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":2543,"burnTimeS":7.04,"caseInfo":"Pro98-6GXL","certOrg":"Canadian Association of Rocketry","commonName":"N2540","dataFiles":2,"designation":"17907N2540-P","diameter":98,"impulseClass":"N","length":1239,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":2915,"motorId":"5f4294d200023100000003df","propInfo":"Green3","propWeightG":10700,"samples":[[0,0],[0.073,2587],[0.11,2790],[0.398,2762],[1.14,2762],[1.73,2828],[2.613,2895],[4.16,2748],[5.666,2566],[5.972,2415],[6.338,1953],[6.819,745.6],[7.061,101.5],[7.222,0]],"totImpulseNs":17910,"totalWeightG":16280,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1827,"burnTimeS":3.07,"caseInfo":"Pro75-4G","certOrg":"Canadian Association of Rocketry","commonName":"M1830","dataFiles":2,"designation":"5604M1830-P","diameter":75,"impulseClass":"M","infoUrl":"http://pro38.com/products/pro75/motor/MotorData.php?prodid=5604M1830-P","length":621,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":2342,"motorId":"5f4294d200023100000003e0","propInfo":"C-Star","propWeightG":2542,"samples":[[0,0],[0.018,2301],[0.028,1953],[0.155,2009],[1.111,2121],[1.452,2054],[1.782,1958],[2.608,1695],[2.677,1546],[3.06,115],[3.165,0]],"totImpulseNs":5604,"totalWeightG":4524,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1396,"burnTimeS":4.49,"caseInfo":"Pro75-5G","certOrg":"Canadian Association of Rocketry","commonName":"M1401","dataFiles":1,"designation":"6268M1401-P","diameter":75,"impulseClass":"M","infoUrl":"http://pro38.com/products/pro75/motor/MotorData.php?prodid=6268M1401-P","length":757,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1670,"motorId":"5f4294d200023100000003e1","propInfo":"White","propWeightG":3508,"samples":[[0,0],[0.079,1669],[0.134,1562],[0.189,1513],[0.512,1507],[1.009,1519],[1.506,1574],[1.679,1598],[1.861,1604],[2.003,1574],[2.5,1513],[2.981,1483],[3.501,1471],[3.722,1434],[3.785,1404],[3.911,1191],[4.053,1009],[4.116,808],[4.235,595],[4.345,407],[4.447,200],[4.589,30],[4.794,60],[4.99,0]],"totImpulseNs":6268,"totalWeightG":5774,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1160,"burnTimeS":5.07,"caseInfo":"Pro75-5G","certOrg":"Canadian Association of Rocketry","commonName":"M1160","dataFiles":2,"designation":"5880M1160-P","diameter":75,"impulseClass":"M","infoUrl":"http://pro38.com/products/pro75/motor/MotorData.php?prodid=5880M1160-P","length":757,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1382,"motorId":"5f4294d200023100000003e2","propInfo":"Green3","propWeightG":3454,"samples":[[0,0],[0.038,929.5],[0.061,745.2],[0.093,1073],[0.189,1183],[0.619,1272],[1.382,1311],[1.824,1382],[2.424,1270],[3.668,1165],[3.68,1166],[4.334,1110],[4.527,1040],[4.735,763.3],[5.049,102],[5.136,0]],"totImpulseNs":5880,"totalWeightG":5698,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":11.17,"burnTimeS":2.44,"certOrg":"National Association of Rocketry","commonName":"E12","dataFiles":2,"delays":"0,4,6,8","designation":"E12","diameter":24,"impulseClass":"E","infoUrl":"http://www.nar.org/SandT/pdf/Estes/E12.pdf","length":95,"manufacturer":"Estes Industries","manufacturerAbbrev":"Estes","maxThrustN":33.29,"motorId":"5f4294d200023100000003e3","propInfo":"black powder","propWeightG":35.9,"samples":[[0,0],[0.052,5.045],[0.096,9.91],[0.196,24.14],[0.251,31.35],[0.287,32.97],[0.3,29.91],[0.344,17.12],[0.37,14.41],[0.4,12.97],[0.5,11.71],[0.6,11.17],[0.7,10.63],[0.8,10.09],[0.9,9.73],[1,9.55],[1.101,9.91],[1.2,9.55],[1.3,9.73],[1.4,9.73],[1.5,9.73],[1.6,9.73],[1.7,9.55],[1.8,9.73],[1.9,9.73],[2,9.55],[2.1,9.55],[2.2,9.73],[2.3,9.19],[2.375,9.37],[2.4,5.95],[2.44,0]],"totImpulseNs":27.24,"totalWeightG":58.7,"type":"SU","updatedOn":"2019-10-05"},{"availability":"OOP","avgThrustN":32.95,"burnTimeS":1.02,"certOrg":"National Association of Rocketry","commonName":"E30","dataFiles":2,"delays":"4,7","designation":"E30","diameter":24,"impulseClass":"E","infoUrl":"http://www.nar.org/SandT/pdf/Estes/E30.pdf","length":70,"manufacturer":"Estes Industries","manufacturerAbbrev":"Estes","maxThrustN":49.3,"motorId":"5f4294d200023100000003e4","propInfo":"black powder","propWeightG":17.8,"samples":[[0,0],[0.01,49],[0.02,49],[0.05,46],[0.1,44],[0.2,43],[0.25,42],[0.3,41],[0.35,40],[0.4,39],[0.45,38],[0.5,37],[0.55,35],[0.6,33],[0.65,32],[0.7,31],[0.75,30],[0.8,27],[0.85,25],[0.9,20],[0.91,19],[0.93,12],[0.95,5],[0.97,1],[1,0]],"totImpulseNs":33.56,"totalWeightG":47,"type":"SU","updatedOn":"2020-12-02"},{"availability":"regular","avgThrustN":26.96,"burnTimeS":2.31,"certOrg":"National Association of Rocketry","commonName":"F26","dataFiles":2,"delays":"6","designation":"F26","diameter":29,"impulseClass":"F","infoUrl":"http://www.nar.org/SandT/pdf/Estes/F26FJ.pdf","length":98,"manufacturer":"Estes Industries","manufacturerAbbrev":"Estes","maxThrustN":39.16,"motorId":"5f4294d200023100000003e5","propWeightG":43.1,"samples":[[0,0],[0.041,38.29],[0.114,36.32],[0.293,34.35],[0.497,32.94],[0.774,32.38],[1,31.25],[1.254,28.72],[1.498,25.34],[1.743,22.24],[2.003,17.74],[2.077,15.48],[2.304,5.349],[2.484,1.689],[2.61,0]],"totImpulseNs":62.19,"totalWeightG":100.8,"type":"SU","updatedOn":"2019-10-05"},{"availability":"regular","avgThrustN":53.73,"burnTimeS":1.43,"certOrg":"National Association of Rocketry","commonName":"F50","dataFiles":1,"delays":"6","designation":"F50","diameter":29,"impulseClass":"F","infoUrl":"http://www.nar.org/SandT/pdf/Estes/F50T.pdf","length":98,"manufacturer":"Estes Industries","manufacturerAbbrev":"Estes","maxThrustN":79.59,"motorId":"5f4294d200023100000003e6","propWeightG":37.9,"samples":[[0,0],[0.012,51.38],[0.023,61.2],[0.026,66.12],[0.044,66.56],[0.082,69.69],[0.152,73.26],[0.208,75.05],[0.237,77.28],[0.254,76.83],[0.272,77.73],[0.307,77.73],[0.33,76.83],[0.336,78.62],[0.342,76.83],[0.354,79.59],[0.363,76.39],[0.371,77.76],[0.395,76.39],[0.447,75.94],[0.523,73.71],[0.652,68.34],[0.81,60.3],[0.828,62.54],[0.836,58.08],[0.901,53.6],[1.079,37.07],[1.158,29.48],[1.196,25.46],[1.246,16.98],[1.301,9.38],[1.43,0]],"totImpulseNs":76.83,"totalWeightG":84.4,"type":"SU","updatedOn":"2020-12-01"},{"availability":"regular","avgThrustN":40.88,"burnTimeS":2.38,"certOrg":"National Association of Rocketry","commonName":"G40","dataFiles":2,"delays":"4,7","designation":"G40","diameter":29,"impulseClass":"G","infoUrl":"https://nar.org/SandT/pdf/Estes/G40.pdf","length":124,"manufacturer":"Estes Industries","manufacturerAbbrev":"Estes","maxThrustN":84.51,"motorId":"5f4294d200023100000003e7","propWeightG":55.1,"samples":[[0,0],[0.024,74.33],[0.057,67],[0.252,65.88],[0.5,63.06],[0.765,60.25],[1,54.05],[1.25,47.3],[1.502,36.6],[1.751,25.34],[1.999,12.95],[2.121,3.941],[2.3,0]],"totImpulseNs":97.14,"totalWeightG":122.9,"type":"SU","updatedOn":"2022-07-17"},{"availability":"OOP","avgThrustN":77.6,"burnTimeS":1.7,"certOrg":"National Association of Rocketry","commonName":"G80","dataFiles":0,"delays":"7,10","designation":"G80","diameter":29,"impulseClass":"G","infoUrl":"http://www.nar.org/SandT/pdf/Estes/G80T.pdf","length":128,"manufacturer":"Estes Industries","manufacturerAbbrev":"Estes","maxThrustN":108.5,"motorId":"5f4294d200023100000003e8","propWeightG":62.5,"totImpulseNs":136.6,"totalWeightG":128.3,"type":"SU","updatedOn":"2022-07-27"},{"availability":"regular","avgThrustN":2326,"burnTimeS":4.29,"caseInfo":"Pro75-6GXL","certOrg":"Canadian Association of Rocketry","commonName":"M2245","dataFiles":2,"designation":"9977M2245-P","diameter":75,"impulseClass":"M","length":1025,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":3357,"motorId":"5f4294d200023100000003e9","propInfo":"Imax","propWeightG":5074,"samples":[[0,0],[0.043,3046],[0.136,2630],[1.393,3003],[2.168,3007],[2.708,2972],[2.837,2884],[3.152,1956],[3.397,1409],[3.878,562.2],[4.371,0]],"totImpulseNs":9977,"totalWeightG":8182,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":145.2,"burnTimeS":0.96,"caseInfo":"Pro24-6G","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G145","dataFiles":2,"delays":"6,8,10,12,15","designation":"140G145-15A","diameter":24,"impulseClass":"G","length":228,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":346.9,"motorId":"5f4294d200023100000003ea","propInfo":"Pink","propWeightG":66.7,"samples":[[0,0],[0.007,286.7],[0.013,346],[0.022,310.6],[0.039,227],[0.066,203.1],[0.343,174.8],[0.672,138.5],[0.775,75.66],[0.899,29.2],[0.982,13.27],[1.015,0]],"totImpulseNs":139.7,"totalWeightG":161.9,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":2174,"burnTimeS":5.55,"caseInfo":"Pro98-5G","certOrg":"Canadian Association of Rocketry","commonName":"N2200","dataFiles":2,"delays":"P","designation":"12066N2200-P","diameter":98,"impulseClass":"N","length":1010,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":2879,"motorId":"5f4294d200023100000003eb","propInfo":"Pink","propWeightG":6122,"samples":[[0,0],[0.033,2756],[0.143,2435],[0.624,2555],[1.814,2602],[2.67,2462],[4.186,2130],[4.66,2064],[4.796,1853],[5.067,775.9],[5.236,474.9],[5.497,180.6],[5.86,0]],"totImpulseNs":12070,"totalWeightG":11360,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":128.5,"burnTimeS":4.41,"caseInfo":"Pro38-5G","certOrg":"Canadian Association of Rocketry","commonName":"I125","dataFiles":2,"delays":"3,5,7,10","designation":"567I125-10A","diameter":38,"impulseClass":"I","length":367,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":294.3,"motorId":"5f4294d200023100000003ec","propInfo":"White","propWeightG":335,"samples":[[0,0],[0.046,174.7],[0.089,267.8],[0.135,236],[0.258,193.8],[0.35,182],[0.553,174.7],[1.124,176.1],[1.502,173],[1.806,162.3],[2.439,136],[3.372,84.78],[4.005,36.68],[4.395,14.88],[4.585,0]],"totImpulseNs":566.6,"totalWeightG":647,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":6365,"burnTimeS":1.36,"caseInfo":"Pro98-4G","certOrg":"Canadian Association of Rocketry","commonName":"M6400","dataFiles":2,"delays":"P","designation":"8634M6400-P","diameter":98,"impulseClass":"M","length":702,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":7238,"motorId":"5f4294d200023100000003ed","propInfo":"Vmax","propWeightG":4175,"samples":[[0,0],[0.011,6080],[0.135,6598],[0.354,7081],[0.503,7245],[0.713,7163],[0.954,6708],[1.183,5688],[1.233,5461],[1.26,4915],[1.288,3395],[1.331,800.9],[1.383,0]],"totImpulseNs":8634,"totalWeightG":7919,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":3417,"burnTimeS":6.16,"caseInfo":"Pro98-6GXL","certOrg":"Canadian Association of Rocketry","commonName":"O3400","dataFiles":2,"delays":"P","designation":"21062O3400-P","diameter":98,"impulseClass":"O","length":1239,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":4750,"motorId":"5f4294d200023100000003ee","propInfo":"Imax","propWeightG":10930,"samples":[[0,0],[0.04,3960],[0.052,4433],[0.101,4515],[0.19,4421],[0.38,4391],[0.965,4444],[2.176,4699],[2.887,4592],[3.658,4226],[4.17,2855],[4.493,2559],[4.881,1619],[5.483,868.8],[6.137,248.2],[6.322,0]],"totImpulseNs":21060,"totalWeightG":16840,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":657,"burnTimeS":11.5,"caseInfo":"RMS-75/7680","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M685","dataFiles":2,"delays":"P","designation":"M685W","diameter":75,"impulseClass":"M","length":935.9,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1517,"motorId":"5f4294d200023100000003f0","propInfo":"White Lightning","propWeightG":4320,"samples":[[0,0],[0.083,1333],[0.13,1368],[0.249,1361],[0.308,1380],[0.403,1359],[0.675,1185],[1.018,1073],[1.456,996],[1.977,958.8],[2.995,914.6],[3.99,856.4],[4.985,781.9],[5.494,730.7],[5.991,679.5],[7.258,542.2],[7.862,463.1],[8.015,456.1],[8.998,330.5],[9.993,207.1],[10.51,137.3],[11.5,34.91],[11.99,0]],"totImpulseNs":7561,"totalWeightG":7008,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":115.9,"burnTimeS":1.95,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H135","dataFiles":2,"delays":"6,8,10,12,14","designation":"HP-H135W","diameter":29,"impulseClass":"H","length":216,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":159.9,"motorId":"5f4294d200023100000003f1","propInfo":"White Lightning","propWeightG":82,"samples":[[0,0],[0.014,159.8],[0.045,110.9],[0.104,144.4],[0.131,135.6],[0.252,154.3],[0.293,130.7],[0.387,149.9],[1.005,140],[1.261,119.2],[1.297,142.2],[1.324,109.8],[1.387,120.3],[1.518,110.4],[1.595,80.73],[1.685,60.41],[1.797,33.5],[1.896,14.28],[2.072,0]],"totImpulseNs":225.8,"totalWeightG":212,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":14.38,"burnTimeS":3.45,"certOrg":"National Association of Rocketry","commonName":"F15","dataFiles":3,"delays":"0,4,6,8","designation":"F15","diameter":29,"impulseClass":"F","infoUrl":"http://www.nar.org/SandT/pdf/Estes/F15.pdf","length":114,"manufacturer":"Estes Industries","manufacturerAbbrev":"Estes","maxThrustN":25.26,"motorId":"5f4294d200023100000003f2","propInfo":"black powder","propWeightG":60,"samples":[[0,0],[0.148,7.638],[0.228,12.25],[0.294,16.39],[0.353,20.21],[0.382,22.76],[0.419,25.26],[0.477,23.07],[0.52,20.84],[0.593,19.09],[0.688,17.5],[0.855,16.23],[1.037,15.43],[1.205,14.95],[1.423,14.63],[1.452,15.74],[1.503,14.79],[1.736,14.62],[1.955,14.3],[2.21,14.14],[2.494,13.82],[2.763,13.34],[3.12,13.33],[3.382,13.01],[3.404,9.352],[3.418,4.895],[3.45,0]],"totImpulseNs":49.61,"totalWeightG":102,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":206.7,"burnTimeS":1.14,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H195","dataFiles":2,"delays":"6,8,10,12,14","designation":"HP-H195NT","diameter":29,"impulseClass":"H","length":203,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":247.2,"motorId":"5f4294d200023100000003f3","propInfo":"New Blue Thunder","propWeightG":115,"samples":[[0,0],[0.003,178.1],[0.005,224.1],[0.013,252.5],[0.019,256.6],[0.022,248.5],[0.058,239.6],[0.1,240.4],[0.199,235.6],[0.255,228.6],[0.285,227.4],[0.301,230.8],[0.399,223],[0.5,223],[0.603,220.4],[0.774,217.1],[0.802,211.6],[0.899,201.6],[0.961,180.6],[0.999,169.9],[1.023,161.1],[1.054,155.2],[1.101,69.3],[1.169,0]],"totImpulseNs":236.1,"totalWeightG":197,"type":"SU","updatedOn":"2020-11-26"},{"availability":"regular","avgThrustN":5636,"burnTimeS":2.42,"caseInfo":"Pro98-6G","certOrg":"Canadian Association of Rocketry","commonName":"N5600","dataFiles":2,"delays":"P","designation":"13628N5600-P","diameter":98,"impulseClass":"N","length":1010,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":6789,"motorId":"5f4294d200023100000003f4","propInfo":"White Thunder","propWeightG":6363,"samples":[[0,0],[0.024,6593],[0.064,5986],[0.309,6214],[0.806,6376],[0.921,6452],[2.14,5131],[2.186,5110],[2.215,4850],[2.38,844.4],[2.462,0]],"totImpulseNs":13630,"totalWeightG":11280,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":140,"burnTimeS":2.4,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I140","dataFiles":2,"delays":"6,8,10,12,14","designation":"HP-I140W","diameter":38,"impulseClass":"I","length":202.7,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":181,"motorId":"5f4294d200023100000003f5","propInfo":"White Lightning","propWeightG":183,"samples":[[0,0],[0.011,96.26],[0.024,80.21],[0.049,160.4],[0.062,144],[0.114,160.4],[0.159,164.1],[0.238,174.6],[0.314,173.9],[0.419,179],[0.627,178.3],[0.835,176.8],[0.943,177.2],[1.146,164.8],[1.349,148.8],[1.459,141.1],[1.562,131.3],[1.773,113.4],[2.192,83.86],[2.295,67.09],[2.395,37.55],[2.435,31.36],[2.47,20.42],[2.478,0]],"totImpulseNs":336,"totalWeightG":356,"type":"SU","updatedOn":"2022-01-10"},{"availability":"regular","avgThrustN":280,"burnTimeS":1.9,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I280","dataFiles":2,"delays":"6,8,10,12,14","designation":"HP-I280DM","diameter":38,"impulseClass":"I","length":356.4,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":386,"motorId":"5f4294d200023100000003f6","propInfo":"Dark Matter","propWeightG":355,"samples":[[0,0],[0.016,342.4],[0.048,297],[0.111,316.2],[0.173,328.2],[0.202,327.5],[0.261,322.5],[0.334,311.9],[0.498,310.5],[0.602,308.4],[0.705,307.7],[0.802,310.5],[0.902,310.5],[1,306.2],[1.025,316.9],[1.057,309.1],[1.1,308.4],[1.139,317.6],[1.205,307.7],[1.298,304.1],[1.336,316.2],[1.4,299.9],[1.5,296.3],[1.55,298.4],[1.595,306.9],[1.634,295.6],[1.652,280.7],[1.716,253.1],[1.743,224],[1.8,153.8],[1.9,62.38],[1.97,20.56],[1.971,0]],"sparky":true,"totImpulseNs":561,"totalWeightG":616,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":270,"burnTimeS":2.6,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J270","dataFiles":2,"delays":"6,8,10,12,14","designation":"HP-J270W","diameter":38,"impulseClass":"J","length":356.4,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":356,"motorId":"5f4294d200023100000003f7","propInfo":"White Lightning","propWeightG":381,"samples":[[0,0],[0.007,367.6],[0.02,325.1],[0.074,353],[0.136,330],[0.176,343.9],[0.273,324.5],[0.33,342.7],[0.357,326.3],[0.399,330.6],[0.473,310.6],[0.553,325.7],[0.734,340.9],[0.744,357.3],[0.761,315.4],[0.788,337.3],[0.897,340.9],[1.009,333.6],[1.053,354.2],[1.105,320.9],[1.18,345.7],[1.214,321.5],[1.249,345.7],[1.274,314.2],[1.5,316],[1.601,310],[1.916,303.9],[1.956,265.1],[2,214.1],[2.052,179.5],[2.102,158.9],[2.201,117.7],[2.268,106.2],[2.303,87.95],[2.369,55.8],[2.407,49.74],[2.486,39.43],[2.558,21.84],[2.563,0]],"totImpulseNs":703,"totalWeightG":642,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":15.97,"burnTimeS":2.09,"certOrg":"National Association of Rocketry","commonName":"E16","dataFiles":2,"delays":"0,4,6,8","designation":"E16","diameter":29,"impulseClass":"E","infoUrl":"http://www.nar.org/SandT/pdf/Estes/E16.pdf","length":114,"manufacturer":"Estes Industries","manufacturerAbbrev":"Estes","maxThrustN":26.44,"motorId":"5f4294d200023100000003f8","propInfo":"black powder","propWeightG":40,"samples":[[0,0],[0.15,1.371],[0.186,1.92],[0.206,3.387],[0.242,5.587],[0.252,7.422],[0.277,8.705],[0.333,13.47],[0.359,15.86],[0.374,16.59],[0.394,18.61],[0.435,21.54],[0.476,24.66],[0.521,26.44],[0.643,21.72],[0.725,20.43],[0.821,19.51],[0.898,18.96],[1.025,18.22],[1.142,18.03],[1.259,17.84],[1.396,17.47],[1.569,17.28],[1.757,17.27],[1.895,17.09],[2.027,17.82],[2.042,12.49],[2.052,8.457],[2.063,4.97],[2.09,0]],"totImpulseNs":33.38,"totalWeightG":84,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":125,"burnTimeS":0.95,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G125","dataFiles":2,"delays":"6,8,10,12,14","designation":"G125T","diameter":29,"impulseClass":"G","length":124,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":160,"motorId":"5f4294d200023100000003f9","propInfo":"Blue Thunder","propWeightG":59.6,"samples":[[0,0],[0.008,89.65],[0.017,117.2],[0.027,119.7],[0.047,111],[0.115,124.8],[0.2,134.1],[0.399,149.3],[0.601,155.2],[0.8,138.3],[0.824,133.8],[0.878,88.96],[0.914,44.48],[0.933,22.41],[0.974,2.069],[1.001,0]],"totImpulseNs":128,"totalWeightG":125,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":115,"burnTimeS":1.5,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H115","dataFiles":2,"delays":"6,8,10,12,14","designation":"HP-H115DM","diameter":29,"impulseClass":"H","length":203,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":126,"motorId":"5f4294d200023100000003fa","propInfo":"Dark Matter","propWeightG":113,"samples":[[0,0],[0.014,89.27],[0.024,130.7],[0.036,108.2],[0.048,101.6],[0.081,111.2],[0.202,121.1],[0.405,123.2],[0.598,123.8],[0.8,123.5],[1.002,122.3],[1.2,114.2],[1.269,111.8],[1.293,111.5],[1.35,119.3],[1.367,117.8],[1.393,111.8],[1.429,88.96],[1.467,67.02],[1.524,44.18],[1.562,22.84],[1.583,13.22],[1.6,6.913],[1.626,3.306],[1.662,1.202],[1.693,0]],"sparky":true,"totImpulseNs":172,"totalWeightG":205,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":500,"burnTimeS":1.24,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I500","dataFiles":2,"delays":"6,8,10,12,14","designation":"HP-I500T","diameter":38,"impulseClass":"I","length":356,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":613,"motorId":"5f4294d200023100000003fb","propInfo":"Blue Thunder","propWeightG":312,"samples":[[0,0],[0.008,447.1],[0.014,534.3],[0.028,581.6],[0.052,504],[0.09,514.9],[0.11,533.1],[0.131,524.6],[0.177,551.3],[0.202,540.4],[0.23,552.5],[0.29,544],[0.399,552.5],[0.481,553.7],[0.526,563.4],[0.565,554.9],[0.6,564.6],[0.638,558.5],[0.728,567],[0.8,561],[0.922,537.9],[0.979,535.5],[0.999,546.4],[1.02,550.1],[1.043,535.5],[1.064,444.6],[1.091,322.3],[1.11,267.8],[1.141,225.4],[1.152,181.7],[1.16,238.7],[1.163,149],[1.174,118.7],[1.2,118.7],[1.255,86.02],[1.312,46.04],[1.335,0]],"totImpulseNs":620,"totalWeightG":576,"type":"SU","updatedOn":"2021-12-08"},{"availability":"regular","avgThrustN":1365,"burnTimeS":3.5,"caseInfo":"RMS-75/5120","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1365","dataFiles":2,"delays":"P","designation":"L1365M","diameter":75,"impulseClass":"L","length":665,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1735,"motorId":"5f4294d200023100000003fc","propInfo":"Metalstorm","propWeightG":2648,"samples":[[0,0],[0.009,166.8],[0.013,618.3],[0.022,940.8],[0.03,1019],[0.046,1161],[0.059,1357],[0.063,1497],[0.076,1617],[0.102,1435],[0.15,1430],[0.193,1472],[0.245,1519],[0.258,1541],[0.282,1592],[0.347,1624],[0.393,1610],[0.486,1575],[0.556,1555],[0.627,1539],[0.673,1512],[0.747,1479],[0.779,1481],[0.831,1497],[0.885,1506],[0.94,1524],[0.987,1466],[1.009,1532],[1.026,1495],[1.098,1535],[1.142,1463],[1.185,1506],[1.224,1477],[1.246,1524],[1.296,1483],[1.322,1517],[1.346,1472],[1.441,1501],[1.504,1508],[1.528,1601],[1.589,1510],[1.699,1512],[1.732,1512],[1.801,1463],[1.864,1497],[1.964,1521],[2.007,1510],[2.068,1450],[2.129,1443],[2.201,1510],[2.237,1463],[2.374,1475],[2.457,1417],[2.546,1428],[2.632,1368],[2.687,1403],[2.776,1343],[2.834,1426],[2.897,1308],[2.93,1348],[2.947,1317],[2.982,1361],[3.051,1354],[3.071,1330],[3.14,1130],[3.175,1030],[3.227,842.9],[3.277,582.7],[3.307,449.3],[3.353,329.2],[3.414,184.6],[3.479,88.96],[3.527,48.93],[3.587,20.02],[3.663,17.79],[3.711,8.896],[3.752,0]],"sparky":true,"totImpulseNs":4780,"totalWeightG":4908,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1254,"burnTimeS":3.7,"caseInfo":"RMS-75/6400","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1250","dataFiles":2,"delays":"P","designation":"L1250DM","diameter":75,"impulseClass":"L","length":801,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":2042,"motorId":"5f4294d200023100000003fd","propInfo":"Dark Matter","propWeightG":2565,"samples":[[0,0],[0.032,1511],[0.049,1295],[0.211,1334],[0.247,1397],[0.256,1554],[0.284,1380],[0.491,1354],[1.493,1449],[1.72,1469],[1.862,1478],[2.008,1459],[2.499,1334],[3.002,1174],[3.108,889.6],[3.156,667.2],[3.245,444.8],[3.42,225.7],[3.505,94.85],[3.529,62.14],[3.574,39.25],[3.663,16.35],[3.785,6.541],[3.842,0]],"sparky":true,"totImpulseNs":4374,"totalWeightG":5647,"type":"reload","updatedOn":"2020-08-13"},{"availability":"regular","avgThrustN":2199,"burnTimeS":5.4,"caseInfo":"RMS-98/15360","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"N2220","dataFiles":2,"delays":"P","designation":"N2220DM","diameter":98,"impulseClass":"N","length":1046,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":4472,"motorId":"5f4294d200023100000003fe","propInfo":"Dark Matter","propWeightG":7183,"samples":[[0,0],[0.045,2638],[0.067,2529],[0.084,3063],[0.124,2426],[0.186,2548],[0.231,2600],[0.298,2555],[0.371,2645],[0.534,2638],[0.979,2561],[1.142,2606],[2.002,2638],[2.289,2638],[2.761,2580],[3.121,2497],[3.436,2336],[3.678,2214],[3.79,2130],[4.004,1654],[4.415,888],[4.538,630.6],[4.656,450.5],[4.82,289.6],[5.005,135.1],[5.219,25.74],[5.371,0]],"sparky":true,"totImpulseNs":10660,"totalWeightG":12000,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":44,"burnTimeS":1,"certOrg":"National Association of Rocketry","commonName":"F44","dataFiles":2,"delays":"4,6,8","designation":"F44W","diameter":24,"impulseClass":"F","infoUrl":"https://nar.org/SandT/pdf/Aerotech/F44W.pdf","length":70,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":50,"motorId":"5f4294d200023100000003ff","propInfo":"White Lightning","propWeightG":19.7,"samples":[[0,0],[0.02,2.676],[0.026,6.02],[0.034,11.2],[0.063,24.92],[0.135,59.03],[0.15,61.37],[0.2,63.21],[0.299,65.22],[0.4,65.05],[0.5,63.38],[0.6,58.53],[0.668,55.02],[0.686,53.68],[0.687,54.01],[0.7,49.16],[0.719,43.81],[0.774,22.07],[0.795,13.21],[0.812,7.86],[0.825,4.515],[0.854,2.007],[0.899,0.167],[0.998,0]],"totImpulseNs":41.5,"totalWeightG":48,"type":"SU","updatedOn":"2022-07-20"},{"availability":"regular","avgThrustN":74,"burnTimeS":1.1,"certOrg":"National Association of Rocketry","commonName":"G74","dataFiles":2,"delays":"6,8","designation":"G74W","diameter":29,"impulseClass":"G","infoUrl":"https://nar.org/SandT/pdf/Aerotech/G74W.pdf","length":93,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":95,"motorId":"5f4294d20002310000000400","propInfo":"White Lightning","propWeightG":39.3,"samples":[[0,0],[0.023,6.551],[0.05,21.84],[0.088,44.85],[0.124,67.36],[0.135,71.56],[0.148,74.42],[0.197,80.13],[0.248,85],[0.298,87.52],[0.397,89.7],[0.499,91.22],[0.6,90.38],[0.699,90.38],[0.751,89.54],[0.8,87.86],[0.9,84.5],[0.954,82.14],[0.971,81.81],[0.987,79.96],[1.002,76.43],[1.023,67.19],[1.065,44.52],[1.094,22.17],[1.107,15.29],[1.126,6.887],[1.138,3.36],[1.157,1.344],[1.18,0.168],[1.192,0]],"totImpulseNs":82.75,"totalWeightG":87,"type":"SU","updatedOn":"2022-07-20"},{"availability":"OOP","avgThrustN":2645,"burnTimeS":9.2,"caseInfo":"152/35000","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"O2700","dataFiles":1,"delays":"P","designation":"O2700BL","diameter":152,"impulseClass":"O","length":1206,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":3920,"motorId":"5f4294d20002310000000401","propInfo":"Black Lightning","propWeightG":15150,"samples":[[0,0],[0.037,446.3],[0.056,612.8],[0.121,627.9],[0.26,1210],[0.261,1331],[0.501,1740],[0.734,2322],[0.994,2595],[2.006,3147],[3.008,3646],[3.519,3805],[4.318,3888],[4.494,3851],[4.995,3692],[5.478,3578],[6.193,3162],[6.249,3245],[6.314,3102],[7.001,2345],[7.456,1778],[7.864,1210],[7.994,1052],[8.208,839.7],[8.431,605.2],[8.598,506.9],[8.821,355.6],[9.044,234.5],[9.331,143.7],[9.443,121],[9.499,0]],"sparky":true,"totImpulseNs":24330,"totalWeightG":33340,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":3.83,"burnTimeS":1.26,"certOrg":"Austrialian Model Rocket Society Inc.","commonName":"B6","dataFiles":1,"designation":"SCR-B6","diameter":18,"impulseClass":"B","length":70,"manufacturer":"Southern Cross Rocketry","manufacturerAbbrev":"SCR","maxThrustN":12.98,"motorId":"5f4294d20002310000000402","propInfo":"black powder","propWeightG":6,"samples":[[0,0],[0.3545,12.2],[0.4782,3.63],[0.5113,2.79],[0.55,2.353],[1.006,2.286],[1.111,1.815],[1.182,0.1008],[1.207,0.06723]],"totImpulseNs":4.84,"totalWeightG":19,"type":"SU","updatedOn":"2022-07-13"},{"availability":"regular","avgThrustN":3.06,"burnTimeS":2.89,"certOrg":"Austrialian Model Rocket Society Inc.","commonName":"C6","dataFiles":1,"delays":"0,3,5","designation":"SCR-C6","diameter":18,"impulseClass":"C","length":70,"manufacturer":"Southern Cross Rocketry","manufacturerAbbrev":"SCR","maxThrustN":12.31,"motorId":"5f4294d20002310000000403","propInfo":"black powder","propWeightG":12,"samples":[[0,0],[0.09939,1.884],[0.4583,12.28],[0.5163,4.964],[0.5991,3.429],[0.7703,3.227],[0.8669,2.857],[1.502,3.092],[2.054,2.891],[2.631,2.428],[2.9,0]],"totImpulseNs":8.83,"totalWeightG":25,"type":"SU","updatedOn":"2022-07-13"},{"availability":"regular","avgThrustN":3.17,"burnTimeS":0.75,"certOrg":"Austrialian Model Rocket Society Inc.","commonName":"A8","dataFiles":1,"delays":"3,5","designation":"SCR-A8","diameter":18,"impulseClass":"A","length":70,"manufacturer":"Southern Cross Rocketry","manufacturerAbbrev":"SCR","maxThrustN":7.18,"motorId":"5f4294d20002310000000404","propInfo":"black powder","propWeightG":3,"samples":[[0,0],[0.08062,0.4034],[0.1391,1.311],[0.2137,3.042],[0.3998,8.706],[0.582,2.303],[0.6311,1.16],[0.6853,0.3529],[0.7372,0.01681]],"totImpulseNs":2.38,"totalWeightG":15,"type":"SU","updatedOn":"2022-07-13"},{"availability":"regular","avgThrustN":182,"burnTimeS":1.2,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H182","dataFiles":2,"delays":"6,8,10,12,14","designation":"HP-H182R","diameter":29,"impulseClass":"H","length":203,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":192,"motorId":"5f4294d20002310000000405","propInfo":"Redline","propWeightG":115,"samples":[[0,0],[0.007,82.4],[0.031,159.2],[0.091,158.4],[0.186,182.4],[0.5,192],[0.904,188.8],[1.054,175.2],[1.106,180.8],[1.144,200.8],[1.163,162.4],[1.201,36.8],[1.212,16.8],[1.235,0]],"totImpulseNs":218,"totalWeightG":207,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":205,"burnTimeS":1.7,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I205","dataFiles":2,"delays":"6,8,10,12,14","designation":"HP-I205W","diameter":29,"impulseClass":"I","length":305,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":253,"motorId":"5f4294d20002310000000406","propInfo":"White Lightning","propWeightG":188,"samples":[[0,0],[0.008,377.3],[0.028,241.9],[0.36,256.3],[0.711,246.3],[0.861,233.3],[1.121,230.4],[1.146,214.6],[1.242,211.7],[1.349,141.1],[1.404,125.3],[1.489,72],[1.602,41.76],[1.712,11.52],[1.787,12.96],[1.892,0]],"totImpulseNs":345,"totalWeightG":315,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":45,"burnTimeS":6,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H45","dataFiles":2,"delays":"P","designation":"HP-H45W","diameter":38,"impulseClass":"H","length":203,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":87,"motorId":"5f4294d20002310000000407","propInfo":"White Lightning","propWeightG":180,"samples":[[0,0],[0.04,84],[0.854,86],[1.377,84.8],[2.046,79.2],[2.69,66],[3.286,51.6],[4.414,28.4],[5.042,16],[5.429,9.2],[6.113,6.4],[6.186,0]],"totImpulseNs":320,"totalWeightG":365,"type":"SU","updatedOn":"2022-03-11"},{"availability":"regular","avgThrustN":417.6,"burnTimeS":1.629,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J425","dataFiles":2,"delays":"6,8,10,12,14","designation":"HP-J425R","diameter":38,"impulseClass":"J","length":356,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":473.3,"motorId":"5f4294d20002310000000408","propInfo":"Redline","propWeightG":364,"samples":[[0,0],[0.018,267.9],[0.062,368.1],[0.242,420.1],[0.524,443.2],[0.902,452.9],[1.225,449],[1.389,433.6],[1.502,452.9],[1.53,420.1],[1.542,356.5],[1.599,67.45],[1.618,28.91],[1.648,0]],"totImpulseNs":680.3,"totalWeightG":631,"type":"SU","updatedOn":"2020-02-17"},{"availability":"regular","avgThrustN":80.16,"burnTimeS":7.92,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I65","dataFiles":2,"delays":"P","designation":"HP-I65W","diameter":54,"impulseClass":"I","length":218,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":145,"motorId":"5f4294d20002310000000409","propInfo":"White Lightning","propWeightG":377,"samples":[[0,0],[0.023,148.3],[0.211,196.3],[0.398,167.8],[0.797,149.9],[1.395,135.2],[2.238,122.2],[3.199,99.39],[4.711,69.25],[5.367,48.88],[6.246,29.33],[6.926,15.48],[7.395,11.41],[8.496,0]],"totImpulseNs":635,"totalWeightG":752,"type":"SU","updatedOn":"2022-08-31"},{"availability":"regular","avgThrustN":535,"burnTimeS":2.8,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K535","dataFiles":2,"delays":"6,8,10,12,14","designation":"HP-K535W","diameter":54,"impulseClass":"K","length":358,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":655,"motorId":"5f4294d2000231000000040a","propInfo":"White Lightning","propWeightG":745,"samples":[[0,0],[0.015,467.3],[0.063,642.2],[0.104,613.5],[0.23,627.8],[0.419,620.7],[0.883,623],[1.335,599.1],[1.646,556],[1.843,500.8],[2.017,450.5],[2.258,405],[2.488,366.6],[2.6,230],[2.611,172.5],[2.648,124.6],[2.696,81.48],[2.789,40.74],[2.837,9.585],[2.952,0]],"totImpulseNs":1434,"totalWeightG":1264,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1000,"burnTimeS":2.7,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1000","dataFiles":2,"delays":"10,12,14,16,18","designation":"HP-L1000W","diameter":54,"impulseClass":"L","length":635,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1261,"motorId":"5f4294d2000231000000040b","propInfo":"White Lightning","propWeightG":1400,"samples":[[0,0],[0.004,10.66],[0.011,1269],[0.04,1322],[0.195,1226],[0.249,1269],[0.296,1242],[0.372,1253],[0.416,1216],[0.6,1226],[0.788,1216],[1.066,1184],[1.261,1168],[1.507,1125],[1.746,1088],[1.865,1050],[1.995,1045],[2.093,911.7],[2.158,746.4],[2.263,554.5],[2.389,405.2],[2.577,191.9],[2.693,85.31],[2.761,42.65],[3,0]],"totImpulseNs":2714,"totalWeightG":2194,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":3.14,"burnTimeS":2.86,"caseInfo":"RMS-18/20","certOrg":"National Association of Rocketry","commonName":"C3","dataFiles":2,"delays":"P","designation":"C3.4T","diameter":18,"impulseClass":"C","infoUrl":"https://nar.org/SandT/pdf/Aerotech/AT_C3.4_2015.pdf","length":72,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":9.08,"motorId":"5f4294d2000231000000040c","propInfo":"Blue Thunder","propWeightG":5.2,"samples":[[0,0],[0.023,3.188],[0.028,5.669],[0.093,9.08],[0.235,8.208],[0.427,6.881],[0.513,6.188],[0.6,5.438],[0.666,4.803],[0.762,3.649],[0.838,2.668],[0.97,2.149],[1.228,1.918],[1.522,1.918],[1.8,1.86],[2.013,1.745],[2.068,2.034],[2.134,1.803],[2.326,1.803],[2.509,1.745],[2.645,1.687],[2.721,1.457],[2.807,0.879],[2.86,0]],"totImpulseNs":8.96,"totalWeightG":23.9,"type":"reload","updatedOn":"2022-07-20"},{"availability":"regular","avgThrustN":2.12,"burnTimeS":8.14,"caseInfo":"RMS-18/20","certOrg":"National Association of Rocketry","commonName":"D2","dataFiles":2,"delays":"P","designation":"D2.3T","diameter":18,"impulseClass":"D","infoUrl":"http://www.nar.org/SandT/pdf/Aerotech/D2.3.pdf","length":72,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":10.14,"motorId":"5f4294d2000231000000040d","propInfo":"Blue Thunder","propWeightG":10.7,"samples":[[0,0],[0.02,5.071],[0.039,9.478],[0.093,10.14],[0.184,9.478],[0.275,8.429],[0.438,6.82],[0.657,4.372],[0.747,3.392],[0.838,2.413],[1.056,2.064],[1.365,1.923],[1.892,1.783],[2.528,1.713],[2.946,1.713],[3.219,1.643],[4.091,1.573],[4.727,1.573],[5.218,1.573],[5.636,1.573],[6.217,1.573],[6.726,1.433],[7.199,1.503],[7.635,1.363],[7.907,1.224],[8.016,0.734],[8.14,0]],"totImpulseNs":17.21,"totalWeightG":29.3,"type":"reload","updatedOn":"2022-03-20"},{"availability":"regular","avgThrustN":69.1,"burnTimeS":0.77,"caseInfo":"Pro24-2G","certOrg":"Canadian Association of Rocketry","commonName":"F70","dataFiles":2,"delays":"5,7,9,11,14","designation":"53F70-14A","diameter":24,"impulseClass":"F","length":101,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":97,"motorId":"5f4294d2000231000000040e","propInfo":"White Thunder","propWeightG":22.5,"samples":[[0,0],[0.001,8.303],[0.013,85.68],[0.023,96.15],[0.052,78.82],[0.1,83.63],[0.379,77.86],[0.641,62.58],[0.665,55.72],[0.706,23.95],[0.744,9.146],[0.787,2.768],[0.816,0]],"totImpulseNs":52.9,"totalWeightG":73,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":49.6,"burnTimeS":1,"caseInfo":"Pro24-2G","certOrg":"Canadian Association of Rocketry","commonName":"F51","dataFiles":2,"delays":"4,6,8,10,13","designation":"50F51-13A","diameter":24,"impulseClass":"F","length":101,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":69.4,"motorId":"5f4294d2000231000000040f","propInfo":"Blue Streak","propWeightG":22,"samples":[[0,0],[0.001,5.145],[0.027,67.98],[0.051,53.81],[0.06,52.88],[0.092,55.92],[0.119,57.94],[0.17,59.71],[0.3,61.15],[0.462,58.95],[0.569,55.58],[0.675,52.2],[0.778,46.39],[0.846,38.12],[0.917,20.32],[1.009,3.542],[1.032,1.602],[1.045,0]],"totImpulseNs":49.9,"totalWeightG":73,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":31.6,"burnTimeS":1.67,"caseInfo":"Pro29-1G","certOrg":"Canadian Association of Rocketry","commonName":"F32","dataFiles":2,"delays":"3,5,7,9,12","designation":"53F32-12A","diameter":29,"impulseClass":"F","length":98,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":49.3,"motorId":"5f4294d20002310000000410","propInfo":"White","propWeightG":29.9,"samples":[[0,0],[0.002,2.999],[0.035,48.04],[0.065,24.05],[0.111,31.03],[0.162,32.79],[0.36,34.81],[0.521,35.59],[0.665,36.7],[0.787,35.98],[1.436,29.2],[1.513,27.25],[1.576,21.58],[1.641,7.171],[1.726,0]],"totImpulseNs":52.8,"totalWeightG":107,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":31.1,"burnTimeS":1.78,"caseInfo":"Pro29-1G","certOrg":"Canadian Association of Rocketry","commonName":"F31","dataFiles":2,"delays":"3,5,7,9,12","designation":"56F31-12A","diameter":29,"impulseClass":"F","length":98,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":65,"motorId":"5f4294d20002310000000411","propInfo":"Classic","propWeightG":70,"samples":[[0,0],[0.001,3.483],[0.023,64.05],[0.05,31.35],[0.059,28.46],[0.095,32.03],[0.212,36.19],[0.344,37.55],[1.567,26.16],[1.631,26.93],[1.663,25.32],[1.785,3.653],[1.828,0]],"totImpulseNs":55.5,"totalWeightG":102,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":32.7,"burnTimeS":4.38,"caseInfo":"Pro29-3G","certOrg":"Canadian Association of Rocketry","commonName":"G33","dataFiles":2,"delays":"2,4,6,9","designation":"143G33-9A","diameter":29,"impulseClass":"G","length":187,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":66.1,"motorId":"5f4294d20002310000000412","propInfo":"Mellow","propWeightG":79.1,"samples":[[0,0],[0.009,5.657],[0.035,62.82],[0.07,27.44],[0.143,34.79],[0.228,38.59],[0.568,39.77],[1.358,37.66],[3.126,36.14],[3.405,31.58],[3.762,21.62],[4.224,6.671],[4.461,0]],"totImpulseNs":143.1,"totalWeightG":197,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":42.2,"burnTimeS":4.41,"caseInfo":"Pro29-4G","certOrg":"Canadian Association of Rocketry","commonName":"H42","dataFiles":1,"delays":"1,3,5,7,10","designation":"186H42-10A","diameter":29,"impulseClass":"H","length":231,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":83.5,"motorId":"5f4294d20002310000000413","propInfo":"Mellow","propWeightG":105.5,"samples":[[0,0],[0.015,8.71],[0.035,82.8],[0.059,43.55],[0.118,48.39],[0.261,54.95],[0.391,55.48],[1.21,51.29],[2.797,49.46],[3.029,45.16],[3.757,20.54],[4.374,4.409],[4.448,0]],"totImpulseNs":186,"totalWeightG":242,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":52.7,"burnTimeS":4.44,"caseInfo":"Pro29-5G","certOrg":"Canadian Association of Rocketry","commonName":"H53","dataFiles":1,"delays":"3,5,7,9,12","designation":"234H53-12A","diameter":29,"impulseClass":"H","length":276,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":101.8,"motorId":"5f4294d20002310000000414","propInfo":"Mellow","propWeightG":131.9,"samples":[[0,0],[0.006,8.958],[0.027,101],[0.042,63.23],[0.102,71.01],[0.2,77.99],[0.362,79.83],[0.98,71.14],[2.561,65.34],[2.663,60.86],[3.661,16.73],[4.011,9.353],[4.316,4.347],[4.447,0]],"totImpulseNs":234.2,"totalWeightG":286,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":55.2,"burnTimeS":7.51,"caseInfo":"Pro38-3G","certOrg":"Canadian Association of Rocketry","commonName":"I55","dataFiles":1,"delays":"2,4,6,9","designation":"395I55-9A","diameter":38,"impulseClass":"I","length":245,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":94.5,"motorId":"5f4294d20002310000000415","propInfo":"Mellow","propWeightG":223.8,"samples":[[0,0],[0.009,10.02],[0.033,92.3],[0.066,57.67],[0.094,55.33],[0.222,64.31],[0.471,67.95],[2.088,63.27],[3.753,61.7],[5.195,62.23],[5.789,43.87],[6.105,40.09],[6.765,13.67],[7.085,6.639],[7.246,0]],"totImpulseNs":394.6,"totalWeightG":437,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":94.4,"burnTimeS":6.82,"caseInfo":"Pro38-5G","certOrg":"Canadian Association of Rocketry","commonName":"J94","dataFiles":1,"delays":"P","designation":"644J94-P","diameter":38,"impulseClass":"J","length":367,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":172.5,"motorId":"5f4294d20002310000000416","propInfo":"Mellow","propWeightG":372.9,"samples":[[0,0],[0.005,19.48],[0.014,168.6],[0.05,134],[0.113,134],[0.203,146.1],[0.752,134],[1.787,116.9],[3.075,110.5],[4.236,108.3],[4.803,77.67],[5.474,56.3],[6.375,17.58],[6.879,6.413],[6.928,0]],"totImpulseNs":644,"totalWeightG":660,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":148.4,"burnTimeS":6.4,"caseInfo":"Pro38-6GXL","certOrg":"Canadian Association of Rocketry","commonName":"J150","dataFiles":1,"delays":"P","designation":"949J150-P","diameter":38,"impulseClass":"J","length":500,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":343.2,"motorId":"5f4294d20002310000000417","propInfo":"Mellow","propWeightG":567.7,"samples":[[0,0],[0.004,33.05],[0.03,324.6],[0.12,248.7],[0.617,225],[1.385,201.3],[2.306,183.5],[3.425,177.1],[4.149,123.7],[4.934,79.66],[5.59,42.37],[6.318,19.49],[6.434,0]],"totImpulseNs":949.2,"totalWeightG":951,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":266.8,"burnTimeS":9.91,"caseInfo":"Pro54-6GXL","certOrg":"Canadian Association of Rocketry","commonName":"L265","dataFiles":2,"delays":"P","designation":"2645L265-P","diameter":54,"impulseClass":"L","length":649,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":471.1,"motorId":"5f4294d20002310000000418","propInfo":"Mellow","propWeightG":1603,"samples":[[0,0],[0.007,30.04],[0.021,461.1],[0.188,425.2],[0.607,399.9],[1.353,354.5],[1.939,336.3],[3.592,319.2],[6.053,312.1],[8.09,133.1],[8.508,96],[9.485,47.11],[9.882,0]],"totImpulseNs":2645,"totalWeightG":2481,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":520.2,"burnTimeS":3.29,"caseInfo":"Pro54-4G","certOrg":"Canadian Association of Rocketry","commonName":"K520","dataFiles":1,"delays":"7,8,9,10,11,12,13,14,15,16,17","designation":"1711K520-17A","diameter":54,"impulseClass":"K","length":404,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":619.2,"motorId":"5f4294d20002310000000419","propInfo":"White","propWeightG":944,"samples":[[0,0],[0.007,121.7],[0.023,591.8],[0.075,615.5],[0.151,580.8],[1.629,568.1],[2.177,535.1],[2.903,476.8],[2.993,414.3],[3.242,97.22],[3.34,0]],"totImpulseNs":1711,"totalWeightG":1576,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":600.3,"burnTimeS":3.55,"caseInfo":"Pro54-5G","certOrg":"Canadian Association of Rocketry","commonName":"K600","dataFiles":1,"delays":"7,8,9,10,11,12,13,14,15,16,17","designation":"2130K600-17A","diameter":54,"impulseClass":"K","length":488,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":799.7,"motorId":"5f4294d2000231000000041a","propInfo":"White","propWeightG":1180,"samples":[[0,0],[0.002,97.24],[0.007,785.1],[0.03,741.9],[0.101,745.5],[0.148,731.1],[0.455,699.9],[1.711,669.9],[2.313,619.4],[2.911,559.4],[3.093,420.2],[3.513,60.02],[3.535,0]],"totImpulseNs":2130,"totalWeightG":1892,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":710.4,"burnTimeS":3.35,"caseInfo":"Pro54-6G","certOrg":"Canadian Association of Rocketry","commonName":"K711","dataFiles":1,"delays":"8,9,10,11,12,13,14,15,16,17,18","designation":"2377K711-18A","diameter":54,"impulseClass":"K","length":572,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1701,"motorId":"5f4294d2000231000000041b","propInfo":"White","propWeightG":1398,"samples":[[0,0],[0.002,239.9],[0.003,1703],[0.03,976.7],[0.149,903.2],[0.474,855.7],[1.791,780.1],[2.397,721.7],[2.65,546.7],[2.976,395.4],[3.343,105.9],[3.359,0]],"totImpulseNs":2377,"totalWeightG":2198,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":143.7,"burnTimeS":4.87,"caseInfo":"Pro54-2G","certOrg":"Canadian Association of Rocketry","commonName":"J145","dataFiles":1,"delays":"9,10,11,12,13,14,15,16,17,18,19","designation":"699J145-19A","diameter":54,"impulseClass":"J","length":236,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":505.3,"motorId":"5f4294d2000231000000041c","propInfo":"Skidmark","propWeightG":417,"samples":[[0,0],[0.011,39.12],[0.018,498.2],[0.059,224.9],[0.154,257.3],[0.488,235.3],[1.881,180.3],[3.612,78.85],[4.669,31.17],[4.896,22.62],[4.944,0]],"sparky":true,"totImpulseNs":699.1,"totalWeightG":837,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1111,"burnTimeS":4.68,"caseInfo":"Pro75-4G","certOrg":"Canadian Association of Rocketry","commonName":"M1101","dataFiles":2,"delays":"P","designation":"5198M1101-P","diameter":75,"impulseClass":"M","length":621,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":1475,"motorId":"5f4294d2000231000000041d","propInfo":"White","propWeightG":2993,"samples":[[0,0],[0.003,281.7],[0.05,1437],[0.121,1363],[0.366,1264],[0.59,1230],[1.745,1322],[2.835,1166],[4,974.6],[4.158,839.4],[4.668,82.63],[4.736,0]],"totImpulseNs":5198,"totalWeightG":4938,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":393.7,"burnTimeS":12.52,"caseInfo":"Pro75-5G","certOrg":"Canadian Association of Rocketry","commonName":"L395","dataFiles":2,"delays":"P","designation":"4937L395-P","diameter":75,"impulseClass":"L","infoUrl":"http://www.pro38.com/products/pro75/motor/MotorData.php?prodid=4937L395-P","length":757,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":587.5,"motorId":"5f4294d2000231000000041e","propInfo":"Mellow","propWeightG":3423,"samples":[[0,0],[0.04,91.16],[0.129,484.2],[0.209,578.7],[0.547,553.6],[2.043,511.8],[7.329,439.1],[8.632,424],[9.573,297.7],[11.4,100.4],[12.45,30.11],[12.5,0]],"totImpulseNs":4937,"totalWeightG":5706,"type":"reload","updatedOn":"2021-12-10"},{"availability":"regular","avgThrustN":1561,"burnTimeS":10.76,"caseInfo":"Pro98-6GXL","certOrg":"Canadian Association of Rocketry","commonName":"N1560","dataFiles":2,"delays":"P","designation":"16803N1560-P","diameter":98,"impulseClass":"N","length":1239,"manufacturer":"Cesaroni Technology","manufacturerAbbrev":"Cesaroni","maxThrustN":3216,"motorId":"5f4294d2000231000000041f","propInfo":"White","propWeightG":9946,"samples":[[0,0],[0.007,260.3],[0.067,2888],[0.171,3198],[0.291,2826],[0.894,2421],[2.503,2231],[3.866,2041],[5.333,1723],[9.244,570.2],[10.71,165.3],[10.82,0]],"totImpulseNs":16800,"totalWeightG":15860,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":591.2,"burnTimeS":2.26,"caseInfo":"AMW 54-1400","certOrg":"Canadian Association of Rocketry","commonName":"K590","dataFiles":0,"designation":"1337K590-P","diameter":54,"impulseClass":"K","length":403,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":723.9,"motorId":"5f4294d20002310000000420","propInfo":"Black Bear","propWeightG":964,"totImpulseNs":1337,"totalWeightG":1717,"type":"reload","updatedOn":"2021-06-13"},{"availability":"OOP","avgThrustN":235,"burnTimeS":1.4,"caseInfo":"38/390","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I235","dataFiles":0,"designation":"I235WC","diameter":38,"impulseClass":"I","length":249,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":291.3,"motorId":"5f4294d20002310000000421","propInfo":"White Cloud","propWeightG":173,"totImpulseNs":324,"totalWeightG":466,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":392,"burnTimeS":1.2,"caseInfo":"38/640","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I392","dataFiles":0,"designation":"I392BL","diameter":38,"impulseClass":"I","length":370,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":508.2,"motorId":"5f4294d20002310000000422","propInfo":"Black Lightning","propWeightG":270,"sparky":true,"totImpulseNs":416.1,"totalWeightG":657,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":462,"burnTimeS":1.2,"caseInfo":"38/640","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I462","dataFiles":0,"designation":"I462WC","diameter":38,"impulseClass":"I","length":370,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":557.1,"motorId":"5f4294d20002310000000423","propInfo":"White Cloud","propWeightG":288,"totImpulseNs":556.7,"totalWeightG":678,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":607,"burnTimeS":1.15,"caseInfo":"38/780","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J607","dataFiles":0,"designation":"J607WC","diameter":38,"impulseClass":"J","length":370,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":803.6,"motorId":"5f4294d20002310000000424","propInfo":"White Cloud","propWeightG":370,"totImpulseNs":677.9,"totalWeightG":824,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":695,"burnTimeS":2.11,"caseInfo":"54/1400","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K695","dataFiles":0,"designation":"K695BT","diameter":54,"impulseClass":"K","length":402,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":922.3,"motorId":"5f4294d20002310000000425","propInfo":"Blue Typhoon","propWeightG":816,"totImpulseNs":1463,"totalWeightG":1497,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":828,"burnTimeS":2.16,"caseInfo":"54/1750","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K828","dataFiles":0,"designation":"K828BT","diameter":54,"impulseClass":"K","length":491,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":1301,"motorId":"5f4294d20002310000000426","propInfo":"Blue Typhoon","propWeightG":870,"totImpulseNs":1786,"totalWeightG":1836,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":235,"burnTimeS":9.1,"caseInfo":"75/2500","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K235","dataFiles":0,"designation":"K235WC","diameter":75,"impulseClass":"K","length":728,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":428.2,"motorId":"5f4294d20002310000000427","propInfo":"White Cloud","propWeightG":1180,"totImpulseNs":2074,"totalWeightG":2770,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":745,"burnTimeS":7.75,"caseInfo":"75/6000","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M745","dataFiles":1,"designation":"M745WC","diameter":75,"impulseClass":"M","length":787,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":1424,"motorId":"5f4294d20002310000000428","propInfo":"White Cloud","propWeightG":2950,"samples":[[0,0],[0.1,1112],[0.15,1246],[0.3,1446],[0.6,1548],[0.7,1557],[0.75,1334],[7.25,0]],"totImpulseNs":5368,"totalWeightG":5620,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1085,"burnTimeS":7,"caseInfo":"75/7600","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1085","dataFiles":1,"designation":"M1085WC","diameter":75,"impulseClass":"M","length":1039,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":2267,"motorId":"5f4294d20002310000000429","propInfo":"White Cloud","propWeightG":3810,"samples":[[0,0],[0.01,2002],[0.05,1935],[0.25,2113],[0.4,2224],[0.45,2269],[0.5,2291],[0.55,2291],[0.6,2224],[0.9,1846],[1.1,1690],[1.45,1535],[3.65,978.6],[4.65,667.2],[6.7,88.96],[7.2,0]],"totImpulseNs":6958,"totalWeightG":7058,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":2925,"burnTimeS":2.71,"caseInfo":"75/7600","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M2925","dataFiles":1,"designation":"M2925WC","diameter":75,"impulseClass":"M","length":1039,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":4532,"motorId":"5f4294d2000231000000042a","propInfo":"White Cloud","propWeightG":3810,"samples":[[0,0],[0.02,2580],[0.05,3025],[0.1,3292],[0.5,3870],[1,4448],[1.35,4537],[1.5,4226],[1.85,2447],[2.1,1334],[2.32,778.4],[2.75,0]],"totImpulseNs":7898,"totalWeightG":7058,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1565,"burnTimeS":5.11,"caseInfo":"98/11000","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1565","dataFiles":0,"designation":"M1565BL","diameter":98,"impulseClass":"M","length":870,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":2219,"motorId":"5f4294d2000231000000042b","propInfo":"Black Lightning","propWeightG":4992,"sparky":true,"totImpulseNs":7533,"totalWeightG":9801,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":2717,"burnTimeS":4.1,"caseInfo":"98/11000","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"N2717","dataFiles":1,"designation":"N2717WC","diameter":98,"impulseClass":"N","length":870,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":4200,"motorId":"5f4294d2000231000000042c","propInfo":"White Cloud","propWeightG":5328,"samples":[[0,0],[0.047,165],[0.063,377.1],[0.071,907.3],[0.075,1650],[0.08475,2241],[0.2417,2465],[0.5964,2965],[0.8914,3379],[1.128,3688],[1.329,3947],[1.522,4101],[1.723,4195],[1.841,4195],[1.901,4195],[1.936,4136],[2.009,4034],[2.191,3707],[2.379,3345],[2.608,2931],[2.808,2569],[2.991,2207],[3.208,1810],[3.428,1397],[3.525,1207],[3.671,883.8],[3.841,459.6],[3.927,282.8],[4.014,200.3],[4.271,58.92],[4.393,0]],"totImpulseNs":10810,"totalWeightG":10140,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1720,"burnTimeS":8.3,"caseInfo":"98/17500","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"N1720","dataFiles":1,"designation":"N1720WC","diameter":98,"impulseClass":"N","length":1213,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":3613,"motorId":"5f4294d2000231000000042d","propInfo":"White Cloud","propWeightG":7380,"samples":[[0,0],[0.033,3572],[0.06,3290],[0.067,3101],[0.113,3245],[0.2073,3276],[0.293,3303],[0.42,3474],[0.54,3591],[0.607,3591],[0.673,3585],[0.72,3506],[0.773,3428],[0.82,3336],[0.867,3251],[0.893,3205],[1.14,3101],[1.467,2898],[2.153,2610],[2.587,2447],[3,2276],[4.013,1812],[4.993,1341],[6.013,804.6],[6.647,510.2],[6.847,431],[6.991,379.3],[7.155,310.3],[7.431,258.6],[7.682,189.7],[7.889,120.7],[8.053,51.72],[8.253,0]],"totImpulseNs":14240,"totalWeightG":15420,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":2645,"burnTimeS":9.18,"caseInfo":"152/35000","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"O2645","dataFiles":1,"designation":"O2645BL","diameter":152,"impulseClass":"O","length":1203,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":3920,"motorId":"5f4294d2000231000000042e","propInfo":"Black Lightning","propWeightG":15150,"samples":[[0,0],[0.037,446.3],[0.056,612.8],[0.121,627.9],[0.26,1210],[0.261,1331],[0.501,1740],[0.734,2322],[0.994,2595],[2.006,3147],[3.008,3646],[3.519,3805],[4.318,3888],[4.494,3851],[4.995,3692],[5.478,3578],[6.193,3162],[6.249,3245],[6.314,3102],[7.001,2345],[7.456,1778],[7.864,1210],[7.994,1052],[8.208,839.7],[8.431,605.2],[8.598,506.9],[8.821,355.6],[9.044,234.5],[9.331,143.7],[9.443,121],[9.499,0]],"sparky":true,"totImpulseNs":24330,"totalWeightG":33340,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":4925,"burnTimeS":6.71,"caseInfo":"152/35000","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"O4925","dataFiles":0,"designation":"O4925WC","diameter":152,"impulseClass":"O","length":1203,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":6827,"motorId":"5f4294d2000231000000042f","propInfo":"White Cloud","propWeightG":17420,"totImpulseNs":33010,"totalWeightG":33880,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":535,"burnTimeS":2.07,"caseInfo":"54/1050","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J535","dataFiles":1,"designation":"J535BT","diameter":54,"impulseClass":"J","length":326,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":662.4,"motorId":"5f4294d20002310000000430","propInfo":"Blue Typhoon","propWeightG":635,"samples":[[0,0],[0.014,243.1],[0.019,621],[0.029,684.4],[0.04,599.8],[0.06,669.9],[0.069,630.2],[0.088,673.8],[0.095,646.1],[0.164,652.7],[0.176,625],[0.236,605.1],[0.319,607.8],[0.498,628.9],[0.736,644.8],[1,643.5],[1.164,636.8],[1.35,611.7],[1.502,581.4],[1.652,552.3],[1.698,529.8],[1.752,445.3],[1.776,358.1],[1.8,268.2],[1.831,177],[1.883,104.4],[1.979,44.92],[2.021,26.43],[2.145,0]],"totImpulseNs":1114,"totalWeightG":1225,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1357,"burnTimeS":3.817,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1350","dataFiles":2,"delays":"P","designation":"M1350W","diameter":75,"impulseClass":"M","length":622,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1765,"motorId":"5f4294d20002310000000431","propInfo":"White Lightning","propWeightG":2690,"samples":[[0,0],[0.03,1429],[0.044,1725],[0.056,1548],[0.078,1621],[0.115,1589],[0.178,1643],[0.455,1750],[0.496,1725],[0.54,1737],[1.132,1747],[1.499,1731],[1.639,1715],[2.505,1334],[3.086,1051],[3.179,985.1],[3.227,928.5],[3.315,670.4],[3.419,446.9],[3.46,396.6],[3.545,299],[3.697,173.1],[3.737,173.1],[3.845,81.83],[3.996,0]],"totImpulseNs":5178,"totalWeightG":4808,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":552,"burnTimeS":0.56,"caseInfo":"38 DMS","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H550","dataFiles":2,"delays":"6,8,10,12,14","designation":"HP-H550ST","diameter":38,"impulseClass":"H","length":206,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":640,"motorId":"5f4294d20002310000000432","propInfo":"Super Thunder","propWeightG":176,"samples":[[0,0],[0.008,445.4],[0.009,533.8],[0.01,565.6],[0.013,586.8],[0.015,623.3],[0.021,639.8],[0.036,606.8],[0.045,629.2],[0.057,615.1],[0.061,635.1],[0.067,619.8],[0.101,637.5],[0.116,622.2],[0.157,643.4],[0.174,623.3],[0.196,623.3],[0.205,639.8],[0.231,631.6],[0.234,618.6],[0.255,611.6],[0.268,628.1],[0.314,595.1],[0.334,601],[0.362,571.5],[0.386,565.6],[0.401,556.2],[0.426,518.5],[0.445,503.1],[0.493,447.8],[0.505,447.8],[0.511,456],[0.519,451.3],[0.535,357],[0.545,266.3],[0.551,179.1],[0.559,91.91],[0.565,42.42],[0.572,12.96],[0.579,0]],"totImpulseNs":312,"totalWeightG":316,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":297,"burnTimeS":4.1,"caseInfo":"54/1200","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J300","dataFiles":2,"delays":"P","designation":"J300LR","diameter":54,"impulseClass":"J","length":327,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":401,"motorId":"5f4294d20002310000000433","propInfo":"Loki Red","propWeightG":620,"samples":[[0,0],[0.015,78.25],[0.025,89.31],[0.06,358.1],[0.076,395.5],[0.111,403.1],[0.176,381],[0.287,365.7],[0.504,363.2],[0.998,361.5],[1.497,363.2],[2.001,344.5],[2.227,331.7],[2.504,310.4],[2.993,270.5],[3.255,242.4],[3.502,222.8],[3.578,222.8],[3.643,190.5],[3.699,134.4],[3.724,118.2],[3.8,106.3],[3.926,44.23],[3.996,29.77],[4.278,0]],"totImpulseNs":1208,"totalWeightG":1315,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":526,"burnTimeS":3.9,"caseInfo":"54/2000","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K527","dataFiles":2,"delays":"P","designation":"K527LR","diameter":54,"impulseClass":"K","length":492,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":754,"motorId":"5f4294d20002310000000434","propInfo":"Loki Red","propWeightG":1015,"samples":[[0,0],[0.023,87.87],[0.051,624.5],[0.06,701.4],[0.079,759.4],[0.125,707.6],[0.176,682.5],[0.269,654.3],[0.501,649.6],[1.01,644.9],[1.265,640.2],[1.52,646.4],[1.701,643.3],[2.035,618.2],[2.526,568],[2.827,539.7],[2.943,530.3],[2.999,513.1],[3.04,442.5],[3.115,356.2],[3.309,219.7],[3.481,91],[3.546,59.62],[3.652,43.93],[3.791,37.66],[3.967,10.98],[4.129,0]],"totImpulseNs":1983,"totalWeightG":1973,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1648,"burnTimeS":4,"caseInfo":"76/6000","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1650","dataFiles":2,"delays":"P","designation":"M1650LC","diameter":76,"impulseClass":"M","length":784,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":3719,"motorId":"5f4294d20002310000000435","propInfo":"Cocktail","propWeightG":3230,"samples":[[0,0],[0.015,1913],[0.046,3780],[0.097,3150],[0.132,2866],[0.183,2643],[0.295,2458],[0.407,2351],[0.509,2297],[0.91,2097],[1.495,1921],[1.612,1882],[2.772,1337],[3.266,1045],[3.342,960.3],[3.398,860.5],[3.505,799],[3.606,630],[3.81,361.1],[3.901,238.2],[4.008,153.7],[4.613,0]],"totImpulseNs":6535,"totalWeightG":5630,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":3464,"burnTimeS":2.7,"caseInfo":"76/8000","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M3464","dataFiles":2,"delays":"P","designation":"M3464LB","diameter":76,"impulseClass":"M","length":1038,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":4328,"motorId":"5f4294d20002310000000436","propInfo":"Loki Blue","propWeightG":4464,"samples":[[0,0],[0.007,4907],[0.02,4008],[0.047,3867],[0.35,3867],[0.502,3867],[0.579,3893],[1.239,4278],[1.808,4304],[1.886,4304],[1.919,4188],[2,3404],[2.064,2916],[2.152,2569],[2.242,2569],[2.283,2441],[2.347,1966],[2.384,1542],[2.434,1105],[2.485,835],[2.545,719.4],[2.596,475.3],[2.717,205.6],[2.862,51.39],[2.976,0]],"totImpulseNs":9395,"totalWeightG":7597,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1127,"burnTimeS":3.29,"caseInfo":"75/3500","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1112","dataFiles":1,"delays":"P","designation":"L1112BT","diameter":75,"impulseClass":"L","length":498,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":1297,"motorId":"5f4294d20002310000000437","propInfo":"Blue Typhoon","propWeightG":1800,"samples":[[0,0],[0.05,1132],[0.071,1174],[0.113,1177],[0.176,1211],[0.263,1294],[0.397,1145],[0.493,1129],[0.786,1182],[1.062,1254],[1.078,1233],[1.229,1275],[1.308,1254],[1.492,1283],[2.002,1294],[2.236,1299],[2.345,1283],[2.545,1227],[2.608,1198],[2.688,1190],[2.759,1206],[2.809,1169],[2.884,892.7],[2.922,672.2],[3.009,504.8],[3.223,225.8],[3.26,108.9],[3.331,37.2],[3.44,5.314],[3.595,0]],"totImpulseNs":3709,"totalWeightG":3628,"type":"reload","updatedOn":"2019-04-17"},{"availability":"OOP","avgThrustN":1952,"burnTimeS":3.09,"caseInfo":"75/6000","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1952","dataFiles":1,"delays":"P","designation":"M1952BT","diameter":75,"impulseClass":"M","length":785,"manufacturer":"Gorilla Rocket Motors","manufacturerAbbrev":"Gorilla","maxThrustN":2692,"motorId":"5f4294d20002310000000438","propInfo":"Blue Typhoon","propWeightG":2970,"samples":[[0,0],[0.025,1639],[0.033,2398],[0.046,2101],[0.075,2520],[0.096,2599],[0.104,2689],[0.187,2689],[0.228,2620],[0.274,2445],[0.316,2329],[0.403,2276],[0.523,2292],[1.001,2339],[1.188,2345],[1.499,2329],[1.637,2302],[1.794,2270],[2.093,2239],[2.193,2207],[2.243,2143],[2.368,1777],[2.505,1310],[2.525,1241],[2.584,1220],[2.609,1119],[2.663,960.1],[2.733,763.9],[2.8,567.6],[2.87,413.8],[2.987,238.7],[3.178,63.65],[3.41,0]],"totImpulseNs":6032,"totalWeightG":5443,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1026,"burnTimeS":1.2,"caseInfo":"38/1200","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J1026","dataFiles":2,"delays":"P","designation":"J1026CT","diameter":38,"impulseClass":"J","length":625.5,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":1212,"motorId":"5f4294d20002310000000439","propInfo":"Cocktail","propWeightG":616,"samples":[[0,0],[0.019,62.8],[0.034,795.4],[0.045,1167],[0.07,1183],[0.149,1154],[0.249,1146],[0.4,1162],[0.49,1185],[0.6,1193],[0.8,1180],[0.851,1172],[0.899,1170],[0.922,1159],[0.947,1167],[0.979,1128],[1.009,1068],[1.089,669.9],[1.13,486.7],[1.142,468.4],[1.151,408.2],[1.161,316.6],[1.176,222.4],[1.201,128.2],[1.227,65.42],[1.264,26.17],[1.297,0]],"totImpulseNs":1267,"totalWeightG":1172,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1029,"burnTimeS":1.24,"caseInfo":"38/1200","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K1127","dataFiles":2,"delays":"5,7,11,14","designation":"K1127-LB","diameter":38,"impulseClass":"K","infoUrl":"https://www.lokiresearch.com/images/Documents/38mm%20Blue%201200%20case.pdf","length":625.5,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":1428,"motorId":"5f4294d2000231000000043a","propInfo":"Loki Blue","propWeightG":624,"samples":[[0,0],[0.009,77.98],[0.021,1003],[0.033,1369],[0.045,1210],[0.058,1366],[0.067,1264],[0.08,1361],[0.092,1256],[0.105,1331],[0.117,1242],[0.13,1312],[0.142,1261],[0.155,1304],[0.167,1261],[0.218,1291],[0.395,1326],[0.542,1369],[0.689,1393],[0.726,1382],[0.755,1344],[0.814,1111],[0.867,949.2],[0.874,1100],[0.883,962.6],[0.908,847],[0.989,548.5],[0.997,363],[1.003,715.2],[1.014,494.8],[1.048,406],[1.091,352.2],[1.152,228.6],[1.198,158.6],[1.244,69.91],[1.286,32.27],[1.37,0]],"totImpulseNs":1285,"totalWeightG":1172,"type":"reload","updatedOn":"2021-07-24"},{"availability":"regular","avgThrustN":834,"burnTimeS":4.6,"caseInfo":"76/3600","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L840","dataFiles":2,"delays":"P","designation":"L840CT","diameter":76,"impulseClass":"L","length":498,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":1170,"motorId":"5f4294d2000231000000043b","propInfo":"Cocktail","propWeightG":2074,"samples":[[0,0],[0.021,889.6],[0.046,1182],[0.077,1082],[0.139,978.6],[0.303,971.2],[0.662,1016],[1.011,1108],[1.33,1149],[1.689,1190],[1.971,1164],[2.089,1145],[2.3,1034],[2.633,893.4],[2.823,822.9],[3.455,656.1],[3.737,596.8],[3.891,585.7],[3.984,385.5],[4.112,355.9],[4.215,203.9],[4.292,140.9],[4.384,103.8],[4.589,63.02],[4.8,0]],"totImpulseNs":3889,"totalWeightG":3748,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1966,"burnTimeS":3.7,"caseInfo":"76/8000","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1969","dataFiles":2,"delays":"P","designation":"M1969SF","diameter":76,"impulseClass":"M","length":1038,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":2447,"motorId":"5f4294d2000231000000043c","propInfo":"Spitfire","propWeightG":4266,"samples":[[0,0],[0.036,263.3],[0.044,1504],[0.075,2205],[0.087,2357],[0.186,2205],[0.23,2281],[0.274,2240],[0.503,2348],[1.003,2432],[1.058,2455],[1.495,2307],[2.002,2236],[2.315,2187],[2.501,2182],[2.628,2169],[2.815,2245],[2.882,2191],[3.045,1339],[3.096,1143],[3.164,1044],[3.267,964],[3.378,807.8],[3.5,504.3],[3.639,267.8],[3.77,102.7],[3.881,22.32],[3.96,0]],"sparky":true,"totImpulseNs":7296,"totalWeightG":7189,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1036,"burnTimeS":3.57,"caseInfo":"54/2800","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1040","dataFiles":2,"delays":"P","designation":"L1040LR","diameter":54,"impulseClass":"L","length":736,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":1422,"motorId":"5f4294d2000231000000043d","propInfo":"Loki Red","propWeightG":1684,"samples":[[0,0],[0.015,1021],[0.03,1238],[0.074,1289],[0.115,1325],[0.218,1232],[0.392,1189],[0.514,1197],[0.744,1232],[1.032,1297],[1.251,1341],[1.517,1392],[2.013,1395],[2.161,1387],[2.257,1343],[2.416,1067],[2.453,999.5],[2.512,961.6],[2.612,939.9],[2.735,755.7],[2.838,604],[2.897,509.2],[3.012,474],[3.212,257.3],[3.297,170.6],[3.404,119.2],[3.475,113.8],[3.549,92.09],[3.619,54.17],[3.7,0]],"totImpulseNs":3707,"totalWeightG":2962,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":2052,"burnTimeS":2.34,"caseInfo":"54/4000","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L2050","dataFiles":2,"delays":"P","designation":"L2050LW","diameter":54,"impulseClass":"L","length":1114,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":3331,"motorId":"5f4294d2000231000000043e","propInfo":"Loki White","propWeightG":2388,"samples":[[0,0],[0.027,366.3],[0.028,137.4],[0.043,2237],[0.053,2702],[0.074,2787],[0.133,2682],[0.218,2610],[0.324,2708],[0.495,2859],[0.691,3061],[0.87,3173],[0.968,3330],[1.066,3251],[1.125,3140],[1.157,2859],[1.181,2702],[1.213,2617],[1.306,2479],[1.338,2172],[1.41,1962],[1.503,1871],[1.614,1426],[1.753,1020],[1.859,870],[1.997,628],[2,667.2],[2.125,431.7],[2.316,235.5],[2.521,0]],"totImpulseNs":4802,"totalWeightG":4056,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":260,"burnTimeS":2.7,"caseInfo":"DMS","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J250","dataFiles":2,"delays":"6,8,10,12,14","designation":"J250W","diameter":54,"impulseClass":"J","length":218.2,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":338,"motorId":"5f4294d2000231000000043f","propInfo":"White Lightning","propWeightG":363,"samples":[[0,0],[0.005,149.9],[0.016,124.4],[0.048,224],[0.051,290.7],[0.077,309.8],[0.221,324.1],[0.269,316.1],[0.497,335.7],[0.997,324.1],[1.497,288.6],[1.713,266.9],[2.003,210.2],[2.162,176.9],[2.487,119.7],[2.516,125.5],[2.718,91.61],[2.766,45.54],[2.814,18],[2.867,7.943],[2.902,0]],"totImpulseNs":704,"totalWeightG":708,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":97.7,"burnTimeS":2.32,"caseInfo":"DMS","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H100","dataFiles":2,"delays":"6,8,10","designation":"H100W_DMS","diameter":38,"impulseClass":"H","length":153.1,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":137.8,"motorId":"5f4294d20002310000000440","propInfo":"White Lightning","propWeightG":121,"samples":[[0,0],[0.004,46.92],[0.031,66.29],[0.047,97.33],[0.096,109],[0.193,116.5],[0.302,124.9],[0.391,123],[0.498,127.9],[0.604,128.8],[0.696,130.2],[0.798,128.6],[0.902,128.8],[0.998,127.4],[1.098,126.5],[1.2,116.9],[1.3,114.6],[1.4,110.2],[1.5,98.27],[1.6,90.8],[1.7,80.06],[1.802,68.62],[1.9,65.36],[2,56.95],[2.1,49.48],[2.202,25.21],[2.298,5.135],[2.398,0]],"totImpulseNs":226.8,"totalWeightG":261,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1090,"burnTimeS":2.45,"caseInfo":"RMS-54/2800","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1090","dataFiles":2,"delays":"P","designation":"L1090W","diameter":54,"impulseClass":"L","length":625.8,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1487,"motorId":"5f4294d20002310000000441","propInfo":"White Lightning","propWeightG":1400,"samples":[[0,0],[0.009,1115],[0.012,1253],[0.052,1322],[0.116,1253],[0.205,1218],[0.252,1269],[0.295,1240],[0.347,1264],[0.393,1251],[0.417,1220],[0.527,1216],[0.631,1229],[0.793,1209],[0.813,1249],[0.827,1203],[1.007,1192],[1.25,1165],[1.499,1130],[1.718,1084],[1.747,1099],[1.776,1062],[2.008,1045],[2.095,886.2],[2.199,664.1],[2.271,540.9],[2.346,446.4],[2.39,404.6],[2.404,380.4],[2.439,382.6],[2.5,274.9],[2.554,222.1],[2.598,162.7],[2.624,147.3],[2.688,79.16],[2.754,32.98],[2.962,0]],"totImpulseNs":2671,"totalWeightG":2432,"type":"reload","updatedOn":"2020-11-25"},{"availability":"regular","avgThrustN":130,"burnTimeS":1.65,"caseInfo":"RMS-38/240","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H130","dataFiles":2,"delays":"4,6,8,10,12,14","designation":"H130W","diameter":38,"impulseClass":"H","length":152,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":260,"motorId":"5f4294d20002310000000442","propInfo":"White Lightning","propWeightG":120,"samples":[[0,0],[0.011,90.91],[0.029,180.7],[0.04,208],[0.055,235.2],[0.086,260.2],[0.11,250.6],[0.147,246.6],[0.19,252.8],[0.226,242.6],[0.266,235.2],[0.304,238.6],[0.348,226.7],[0.4,215.3],[0.419,220.5],[0.432,208],[0.531,177.3],[0.601,151.7],[1.184,69.32],[1.216,69.32],[1.351,46.59],[1.402,40.34],[1.633,0]],"totImpulseNs":210,"totalWeightG":237,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":180,"burnTimeS":1.8,"caseInfo":"RMS-38/360","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I180","dataFiles":2,"delays":"4,6,8,10,12,14","designation":"I180W","diameter":38,"impulseClass":"I","length":191,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":362,"motorId":"5f4294d20002310000000443","propInfo":"White Lightning","propWeightG":180,"samples":[[0,0],[0.027,133.7],[0.029,224.5],[0.033,328.7],[0.042,338.3],[0.061,327.2],[0.082,337.6],[0.088,347.2],[0.117,361.2],[0.203,360.5],[0.243,350.9],[0.289,350.9],[0.358,313.2],[0.368,303.6],[0.387,312.4],[0.446,278.5],[0.502,260],[0.634,223.1],[0.762,195.7],[0.998,151.4],[1.5,68.69],[1.736,26.59],[1.845,9.602],[1.956,0]],"totImpulseNs":326,"totalWeightG":385,"type":"reload","updatedOn":"2020-11-25"},{"availability":"regular","avgThrustN":2504,"burnTimeS":1.86,"caseInfo":"RMS-98/5120","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L2500","dataFiles":2,"delays":"P","designation":"L2500ST","diameter":98,"impulseClass":"L","length":443,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":2830,"motorId":"5f4294d20002310000000444","propInfo":"Super Thunder","propWeightG":2313,"samples":[[0,0],[0.016,24.71],[0.027,449.8],[0.03,1330],[0.039,1784],[0.043,2041],[0.08,2224],[0.118,2358],[0.198,2476],[0.399,2679],[0.495,2748],[0.601,2788],[0.701,2822],[0.799,2822],[1.001,2807],[1.199,2758],[1.399,2669],[1.501,2565],[1.6,2402],[1.675,2234],[1.752,2007],[1.777,1819],[1.805,1334],[1.827,884.7],[1.852,434.9],[1.87,242.2],[1.895,88.96],[1.923,0]],"totImpulseNs":4668,"totalWeightG":4989,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":4533,"burnTimeS":1.6,"caseInfo":"RMS-98/7680","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M4500","dataFiles":1,"delays":"P","designation":"M4500ST","diameter":98,"impulseClass":"M","length":597,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":5549,"motorId":"5f4294d20002310000000445","propInfo":"Super Thunder","propWeightG":3425,"samples":[[0,0],[0.014,2656],[0.016,3935],[0.025,4162],[0.032,4004],[0.033,4102],[0.098,4565],[0.199,4840],[0.4,5224],[0.506,5440],[0.536,5421],[0.597,5490],[0.798,5549],[0.904,5460],[1,5263],[1.08,5096],[1.112,4968],[1.201,4545],[1.341,3561],[1.449,2676],[1.492,2302],[1.52,1987],[1.535,1712],[1.572,905.1],[1.593,511.6],[1.625,186.9],[1.65,59.03],[1.675,19.68],[1.691,0]],"totImpulseNs":7301,"totalWeightG":6622,"type":"reload","updatedOn":"2020-11-25"},{"availability":"regular","avgThrustN":627,"burnTimeS":2.42,"caseInfo":"38/1200","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K627","dataFiles":1,"delays":"5,7,11,14","designation":"K627LR","diameter":38,"impulseClass":"K","length":625.5,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":987,"motorId":"5f4294d20002310000000446","propInfo":"Loki Red","propWeightG":688,"samples":[[0,0],[0.014,735],[0.034,989.3],[0.073,983.1],[0.166,905.6],[0.298,840.5],[0.501,806.4],[0.746,815.7],[1.002,825],[1.193,843.6],[1.258,849.8],[1.303,831.2],[1.348,784.6],[1.5,669.9],[1.756,437.3],[1.951,276],[2.004,245],[2.086,210.9],[2.142,183],[2.252,105.4],[2.322,74.43],[2.443,49.62],[2.499,27.91],[2.564,0]],"totImpulseNs":1519,"totalWeightG":1236,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":124,"burnTimeS":1.94,"caseInfo":"38/240","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H125","dataFiles":1,"delays":"8,10,12,14,18","designation":"H125-CT","diameter":38,"impulseClass":"H","infoUrl":"https://www.lokiresearch.com/images/Documents/38mm%20cocktail.pdf","length":177.8,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":206,"motorId":"5f4294d20002310000000447","propInfo":"Cocktail","propWeightG":122,"samples":[[0,0],[0.031,15.69],[0.043,51.39],[0.058,133.4],[0.059,156.9],[0.08,197.3],[0.096,205.9],[0.14,191.8],[0.325,190.2],[0.501,182.8],[0.779,164.7],[0.89,153.8],[1.003,139.6],[1.21,113.8],[1.5,72.57],[1.721,43.93],[1.784,34.13],[1.844,29.81],[1.876,25.5],[1.909,20],[2.001,0]],"totImpulseNs":240,"totalWeightG":342,"type":"reload","updatedOn":"2021-07-24"},{"availability":"regular","avgThrustN":377,"burnTimeS":1.38,"caseInfo":"38/480","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I377","dataFiles":1,"delays":"8,10,12,14,18","designation":"I377-CT","diameter":38,"impulseClass":"I","infoUrl":"https://www.lokiresearch.com/images/Documents/38mm%20cocktail.pdf","length":292.1,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":659,"motorId":"5f4294d20002310000000448","propInfo":"Cocktail","propWeightG":250,"samples":[[0,0],[0.012,178.2],[0.015,501.6],[0.023,609.9],[0.032,646.8],[0.052,657],[0.068,625.1],[0.118,581.8],[0.199,558.9],[0.399,502.9],[0.602,444.3],[0.691,411.2],[0.823,356.5],[0.924,313.2],[1.021,264.8],[1.19,179.5],[1.258,138.8],[1.327,90.4],[1.382,43.29],[1.43,0]],"totImpulseNs":522,"totalWeightG":560,"type":"reload","updatedOn":"2021-07-24"},{"availability":"regular","avgThrustN":69,"burnTimeS":1.94,"caseInfo":"38/120","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G66","dataFiles":1,"delays":"5,8,11,15","designation":"G66-LR","diameter":38,"impulseClass":"G","infoUrl":"https://www.lokiresearch.com/images/Documents/38mm%20Red.pdf","length":122.2,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":115,"motorId":"5f4294d20002310000000449","propWeightG":72,"samples":[[0,0],[0.01,4.448],[0.027,3.14],[0.051,12.3],[0.07,22.76],[0.092,45.01],[0.104,66.72],[0.111,80.07],[0.13,89.49],[0.145,97.86],[0.176,106.5],[0.21,112.3],[0.246,114.6],[0.287,115.7],[0.359,113.3],[0.506,106.8],[0.598,102.6],[0.757,94.72],[1.006,80.85],[1.196,66.46],[1.473,44.48],[1.51,41.08],[1.691,26.43],[1.763,21.46],[1.823,16.75],[1.879,14.13],[2.016,7.326],[2.091,4.448],[2.117,4.71],[2.129,0]],"totImpulseNs":134,"totalWeightG":250,"type":"reload","updatedOn":"2021-07-24"},{"availability":"regular","avgThrustN":70,"burnTimeS":1.7,"caseInfo":"38/120","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G70","dataFiles":1,"delays":"8,10,12,14,18","designation":"G70-CT","diameter":38,"impulseClass":"G","infoUrl":"https://www.lokiresearch.com/images/Documents/38mm%20cocktail.pdf","length":122.2,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":101,"motorId":"5f4294d2000231000000044a","propInfo":"Cocktail","propWeightG":64,"samples":[[0,0],[0.021,3.271],[0.034,10.2],[0.057,14.81],[0.069,22.13],[0.084,44.25],[0.092,66.95],[0.103,85.42],[0.111,91.2],[0.157,95.43],[0.199,97.93],[0.3,99.85],[0.34,101],[0.4,100.4],[0.495,99.28],[0.6,95.81],[0.614,96.2],[0.7,93.31],[0.799,88.12],[0.904,82.35],[1.004,75.42],[1.199,59.64],[1.398,42.71],[1.484,35.79],[1.545,30.78],[1.6,24.43],[1.637,19.82],[1.681,12.7],[1.723,6.926],[1.799,0]],"totImpulseNs":119,"totalWeightG":242,"type":"reload","updatedOn":"2021-07-24"},{"availability":"regular","avgThrustN":94,"burnTimeS":1.29,"caseInfo":"38/120","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G94","dataFiles":1,"delays":"5,8,11,14,18","designation":"HP-G94-IB","diameter":38,"impulseClass":"G","infoUrl":"http://www.lokiresearch.com/images/Documents/38mm%20Ice%20Blue.pdf","length":122,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":131,"motorId":"5f4294d2000231000000044b","propInfo":"Ice Blue","propWeightG":62,"samples":[[0,0],[0.006,14.03],[0.03,67.19],[0.04,96.6],[0.049,111.2],[0.058,118.7],[0.075,125.7],[0.141,124.1],[0.206,126.5],[0.344,131.7],[0.37,129.8],[0.403,129.5],[0.458,127.1],[0.507,126],[0.609,121.4],[0.69,115.5],[0.75,109],[0.816,100.9],[0.887,88.77],[0.992,67.19],[1.055,53.7],[1.111,42.9],[1.157,33.46],[1.214,22.66],[1.257,14.03],[1.314,6.476],[1.345,4.587],[1.382,2.159],[1.411,1.619],[1.424,0]],"totImpulseNs":121,"totalWeightG":240,"type":"reload","updatedOn":"2021-07-24"},{"availability":"regular","avgThrustN":1378,"burnTimeS":3.88,"caseInfo":"54/4000","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1378","dataFiles":1,"delays":"P","designation":"M1378LR","diameter":54,"impulseClass":"M","length":1108,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":2270,"motorId":"5f4294d2000231000000044c","propInfo":"Loki Red","propWeightG":2600,"samples":[[0,0],[0.033,880.4],[0.034,1332],[0.035,1784],[0.049,2217],[0.05,2319],[0.065,2240],[0.175,2254],[0.252,2166],[0.386,2097],[0.512,2051],[0.776,2047],[0.939,2065],[0.991,2070],[1.503,2176],[1.568,2208],[1.702,1908],[1.719,1867],[1.788,1858],[1.824,1830],[1.877,1742],[1.902,1747],[1.946,1609],[2.015,1493],[2.076,1447],[2.137,1443],[2.194,1438],[2.239,1406],[2.288,1337],[2.393,1143],[2.499,981.8],[2.58,871.2],[2.706,742.1],[2.775,719.1],[2.856,686.8],[3.007,562.4],[3.202,401],[3.405,267.4],[3.466,235.1],[3.527,230.5],[3.608,184.4],[3.681,175.2],[3.783,170.6],[3.868,129.1],[3.953,96.8],[4.022,73.75],[4.079,0]],"totImpulseNs":5363,"totalWeightG":4331,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":5959,"burnTimeS":1.38,"caseInfo":"RMS-98/10240","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M6000","dataFiles":2,"delays":"P","designation":"M6000ST","diameter":98,"impulseClass":"M","length":808,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":6789,"motorId":"5f4294d2000231000000044d","propInfo":"Super Thunder","propWeightG":3868,"samples":[[0,0],[0.025,115.2],[0.031,2679],[0.037,4349],[0.039,4968],[0.043,5083],[0.052,4939],[0.072,5011],[0.116,5429],[0.153,5616],[0.178,5775],[0.202,5818],[0.399,6293],[0.599,6624],[0.8,6956],[0.928,7085],[1.002,7100],[1.093,7071],[1.143,7013],[1.198,6826],[1.302,6466],[1.37,6120],[1.405,5976],[1.438,5890],[1.457,5775],[1.469,5443],[1.492,4450],[1.506,3557],[1.521,2736],[1.541,1757],[1.556,1210],[1.576,748.8],[1.595,446.4],[1.622,187.2],[1.651,72],[1.736,0]],"totImpulseNs":8247,"totalWeightG":8030,"type":"reload","updatedOn":"2022-05-11"},{"availability":"regular","avgThrustN":222,"burnTimeS":1.05,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H219","dataFiles":2,"delays":"6,8,10,12,14","designation":"H219T","diameter":38,"impulseClass":"H","length":155,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":279,"motorId":"5f4294d2000231000000044e","propInfo":"Blue Thunder","propWeightG":109,"samples":[[0,0],[0.009,88.8],[0.012,133.2],[0.017,221.3],[0.019,243.5],[0.04,257],[0.104,278.5],[0.112,296],[0.124,275.8],[0.203,276.5],[0.294,273.1],[0.4,264.4],[0.499,254.3],[0.6,241.5],[0.65,234.8],[0.698,226],[0.74,213.9],[0.8,191.7],[0.842,177.6],[0.891,161.4],[0.937,150.7],[0.957,151.4],[0.971,133.9],[0.999,91.49],[1.024,44.4],[1.04,21.53],[1.055,8.072],[1.081,0]],"totImpulseNs":233,"totalWeightG":261,"type":"SU","updatedOn":"2020-10-16"},{"availability":"regular","avgThrustN":465,"burnTimeS":2.27,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J450","dataFiles":2,"delays":"6,8,10,12,14","designation":"J450DM","diameter":54,"impulseClass":"J","length":359,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":558,"motorId":"5f4294d2000231000000044f","propInfo":"Dark Matter","propWeightG":510,"samples":[[0,0],[0.012,270.7],[0.018,356.9],[0.024,392.1],[0.033,377.5],[0.062,371.5],[0.121,414],[0.263,449.2],[0.453,467.4],[0.527,492.9],[0.627,501.4],[0.701,505],[0.787,509.9],[0.802,541.4],[0.834,526.9],[0.941,528.1],[1.047,541.4],[1.083,532.9],[1.142,537.8],[1.293,537.8],[1.396,519.6],[1.494,520.8],[1.633,512.3],[1.666,495.3],[1.725,491.6],[1.814,474.6],[1.899,455.2],[1.97,439.4],[2.03,437],[2.071,433.4],[2.089,415.2],[2.133,356.9],[2.169,267.1],[2.21,179.7],[2.249,88.62],[2.266,41.27],[2.311,0]],"sparky":true,"totImpulseNs":1055,"totalWeightG":1223,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":409,"burnTimeS":3.2,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K400","dataFiles":2,"delays":"6,8,10,12,14","designation":"K400C","diameter":54,"impulseClass":"K","length":359,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":546,"motorId":"5f4294d20002310000000450","propInfo":"Classic","propWeightG":493,"samples":[[0,0],[0.008,376.4],[0.025,526.2],[0.034,548.5],[0.063,500.2],[0.178,527.4],[0.394,522.5],[0.69,502.7],[1.003,487.8],[1.494,446.9],[2.002,402.4],[2.243,377.6],[2.501,364],[2.658,354.1],[2.772,338],[2.844,304.6],[2.882,268.7],[2.929,177],[2.963,116.4],[3.001,99.05],[3.064,94.09],[3.123,61.9],[3.208,18.57],[3.259,0]],"totImpulseNs":1304,"totalWeightG":1194,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":922,"burnTimeS":2,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K850","dataFiles":2,"delays":"8,10,12,14,16","designation":"K850DM","diameter":54,"impulseClass":"K","length":635,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1094,"motorId":"5f4294d20002310000000451","propInfo":"Dark Matter","propWeightG":1224,"samples":[[0,0],[0.02,50.82],[0.032,236.4],[0.034,450.7],[0.04,1049],[0.044,810.8],[0.048,901.4],[0.05,859.4],[0.066,848.4],[0.158,914.7],[0.326,961.1],[0.615,1030],[0.923,1065],[1.075,1061],[1.233,1041],[1.369,994.2],[1.407,1019],[1.483,978.8],[1.545,974.3],[1.567,985.4],[1.591,963.3],[1.673,947.8],[1.712,952.2],[1.76,910.3],[1.854,702.6],[1.926,444.1],[1.978,225.4],[2.028,79.54],[2.07,24.3],[2.118,0]],"sparky":true,"totImpulseNs":1869,"totalWeightG":2041,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":931,"burnTimeS":2.04,"caseInfo":"RMS-54/2800","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K990","dataFiles":2,"delays":"6,8,10,12,14","designation":"K990DM","diameter":54,"impulseClass":"K","length":598,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1075,"motorId":"5f4294d20002310000000452","propInfo":"Dark Matter","propWeightG":1224,"samples":[[0,0],[0.016,35.56],[0.024,223.8],[0.028,868],[0.036,1069],[0.044,895.2],[0.048,863.8],[0.06,840.8],[0.228,966.3],[0.286,953.8],[0.369,964.2],[0.407,993.5],[0.423,976.8],[0.498,989.3],[0.694,1025],[0.865,1044],[0.962,1054],[1.117,1054],[1.282,1029],[1.51,983.1],[1.589,960.1],[1.688,953.8],[1.732,968.4],[1.748,1002],[1.778,958],[1.802,891],[1.857,671.4],[1.913,447.6],[1.97,223.8],[2.006,129.7],[2.063,46.02],[2.097,14.64],[2.137,0]],"sparky":true,"totImpulseNs":1867,"totalWeightG":2109,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1874,"burnTimeS":0.73,"caseInfo":"RMS-54/1706","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K2050","dataFiles":3,"delays":"P","designation":"K2050ST","diameter":54,"impulseClass":"K","length":383,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":2086,"motorId":"5f4294d20002310000000453","propInfo":"Super Thunder","propWeightG":674,"samples":[[0,0],[0.006,31.77],[0.011,388.3],[0.012,886.1],[0.015,1783],[0.02,2005],[0.023,2048],[0.036,1988],[0.056,1981],[0.095,2044],[0.108,2030],[0.184,2065],[0.198,2048],[0.3,2058],[0.345,2062],[0.364,2037],[0.402,2026],[0.499,1988],[0.543,1956],[0.575,1913],[0.602,1857],[0.644,1822],[0.668,1790],[0.686,1680],[0.693,1560],[0.701,1334],[0.727,448.4],[0.739,162.4],[0.744,257.7],[0.749,141.2],[0.755,42.36],[0.767,0]],"totImpulseNs":1384,"totalWeightG":1292,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":1340,"burnTimeS":5.5,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M1340","dataFiles":2,"delays":"P","designation":"M1340W","diameter":98,"impulseClass":"M","length":557,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1865,"motorId":"5f4294d20002310000000454","propInfo":"White Lightning","propWeightG":4036,"samples":[[0,0],[0.016,42.43],[0.027,1054],[0.043,862.8],[0.076,1330],[0.098,1404],[0.152,1425],[0.986,1729],[1.154,1810],[1.518,1874],[1.642,1842],[2,1888],[2.558,1892],[2.775,1782],[2.818,1708],[2.894,1616],[2.997,1520],[4,1011],[4.509,763.8],[4.862,608.2],[4.981,583.4],[5.062,526.9],[5.149,438.5],[5.322,226.3],[5.458,99.01],[5.577,28.29],[5.642,0]],"totImpulseNs":7369,"totalWeightG":6998,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":283,"burnTimeS":0.7,"caseInfo":"DMS","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H283","dataFiles":2,"delays":"7,9,11,13,15","designation":"H283ST","diameter":38,"impulseClass":"H","length":155,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":327,"motorId":"5f4294d20002310000000455","propInfo":"Super Thunder","samples":[[0,0],[0.003,133],[0.005,223.2],[0.007,267.3],[0.009,285.7],[0.017,296.7],[0.045,300.4],[0.049,310.8],[0.052,301.6],[0.066,304.7],[0.081,312.7],[0.094,308.4],[0.108,315.1],[0.222,331.1],[0.225,337.2],[0.229,332.9],[0.336,316.3],[0.371,312.7],[0.404,300.4],[0.435,290],[0.449,290.6],[0.47,278.3],[0.499,274],[0.538,257.5],[0.572,239.1],[0.593,239.7],[0.606,226.8],[0.636,225.6],[0.644,221.9],[0.658,178.4],[0.67,130],[0.677,121.4],[0.688,91.96],[0.691,98.09],[0.722,41.69],[0.738,23.3],[0.74,0]],"totImpulseNs":201,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":550,"burnTimeS":0.57,"caseInfo":"RMS-38/360","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H550","dataFiles":1,"delays":"6,8,10,12,14","designation":"H550ST","diameter":38,"impulseClass":"H","length":213,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":667,"motorId":"5f4294d20002310000000456","propInfo":"Super Thunder","propWeightG":145,"samples":[[0,0],[0.008,445.4],[0.009,533.8],[0.01,565.6],[0.013,586.8],[0.015,623.3],[0.021,639.8],[0.036,606.8],[0.045,629.2],[0.057,615.1],[0.061,635.1],[0.067,619.8],[0.101,637.5],[0.116,622.2],[0.157,643.4],[0.174,623.3],[0.196,623.3],[0.205,639.8],[0.231,631.6],[0.234,618.6],[0.255,611.6],[0.268,628.1],[0.314,595.1],[0.334,601],[0.362,571.5],[0.386,565.6],[0.401,556.2],[0.426,518.5],[0.445,503.1],[0.493,447.8],[0.505,447.8],[0.511,456],[0.519,451.3],[0.535,357],[0.545,266.3],[0.551,179.1],[0.559,91.91],[0.565,42.42],[0.572,12.96],[0.579,0]],"totImpulseNs":320,"totalWeightG":323,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":875,"burnTimeS":4.44,"caseInfo":"DMS","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L875","dataFiles":2,"delays":"P","designation":"L875DM","diameter":75,"impulseClass":"L","length":638,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1355,"motorId":"5f4294d20002310000000457","propInfo":"Dark Matter","propWeightG":2472,"samples":[[0,0],[0.023,444.1],[0.028,853.3],[0.074,814.8],[0.148,793.8],[0.158,874.3],[0.241,902.2],[0.287,928.5],[0.422,911],[0.528,904],[0.992,918],[1.497,956.4],[2.007,1000],[2.489,1033],[2.619,1039],[2.827,1032],[3.115,989.7],[3.495,912.7],[3.606,907.5],[3.843,671.4],[3.935,606.7],[4,442.4],[4.097,220.3],[4.195,103.2],[4.315,31.47],[4.478,10.49],[4.64,0]],"sparky":true,"totImpulseNs":3887,"totalWeightG":4577,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":465.7,"burnTimeS":1.66,"caseInfo":"DMS","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J435","dataFiles":2,"delays":"6,8,10,12,14","designation":"J435WS","diameter":38,"impulseClass":"J","length":365.9,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":696.1,"motorId":"5f4294d20002310000000458","propInfo":"Super White Lightning","propWeightG":352,"samples":[[0,0],[0.029,11.08],[0.03,41.14],[0.031,212],[0.036,528.5],[0.038,378.2],[0.048,694.7],[0.067,625],[0.071,688.3],[0.083,631.4],[0.095,651.9],[0.105,610.8],[0.116,629.8],[0.135,610.8],[0.145,621.9],[0.166,655.1],[0.171,625],[0.304,601.3],[0.399,564.9],[0.456,558.6],[0.504,547.5],[0.549,549.1],[0.613,538],[0.672,531.7],[0.701,525.3],[0.762,525.3],[0.803,515.9],[0.848,506.4],[0.903,501.6],[0.983,492.1],[1.017,485.8],[1.059,479.5],[1.152,470],[1.261,449.4],[1.276,454.1],[1.316,441.5],[1.366,425.7],[1.387,401.9],[1.409,343.4],[1.42,375],[1.428,340.2],[1.435,229.4],[1.451,242.1],[1.499,212],[1.508,188.3],[1.527,215.2],[1.532,118.7],[1.544,63.3],[1.558,132.9],[1.575,87.03],[1.587,125],[1.601,83.87],[1.618,115.5],[1.632,72.79],[1.648,87.03],[1.667,47.47],[1.686,45.89],[1.717,18.99],[1.781,0]],"totImpulseNs":774,"totalWeightG":624,"type":"SU","updatedOn":"2020-01-27"},{"availability":"regular","avgThrustN":487.4,"burnTimeS":1.28,"caseInfo":"RMS-38/1080","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J520","dataFiles":2,"delays":"5,7,9,11,13","designation":"J520W","diameter":38,"impulseClass":"J","length":502,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":902.6,"motorId":"5f4294d20002310000000459","propInfo":"White Lightning","propWeightG":381,"samples":[[0,0],[0.024,15.52],[0.034,131.9],[0.039,318.1],[0.046,659.5],[0.049,752.6],[0.051,799.1],[0.066,756.5],[0.071,791.4],[0.098,892.2],[0.137,861.2],[0.168,837.9],[0.195,810.8],[0.234,783.6],[0.4,706],[0.598,593.5],[0.798,477.1],[0.998,376.3],[1.056,333.6],[1.102,298.7],[1.198,170.7],[1.302,100.9],[1.4,46.55],[1.478,0]],"totImpulseNs":671,"totalWeightG":757.4,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":69,"burnTimeS":0.88,"certOrg":"National Association of Rocketry","commonName":"F67","dataFiles":2,"delays":"4,6,7,9","designation":"F67W","diameter":29,"impulseClass":"F","infoUrl":"https://www.nar.org/SandT/pdf/Aerotech/AT_F67W_2017.pdf","length":83,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":86,"motorId":"5f4294d2000231000000045a","propWeightG":30,"samples":[[0,0],[0.002,66.66],[0.008,71.44],[0.016,74.5],[0.039,77.94],[0.068,80.63],[0.099,82.59],[0.148,84.43],[0.201,85.53],[0.257,86.15],[0.298,86.02],[0.399,84.19],[0.483,82.96],[0.499,82.35],[0.568,80.02],[0.601,78.79],[0.625,77.94],[0.654,78.06],[0.672,75.85],[0.687,71.07],[0.7,67.52],[0.714,62.01],[0.731,53.06],[0.748,44.48],[0.764,35.66],[0.778,26.84],[0.789,20.95],[0.797,18.01],[0.812,12.5],[0.832,7.107],[0.849,3.676],[0.87,1.225],[0.898,0.368],[0.92,0]],"totImpulseNs":61.1,"totalWeightG":80.8,"type":"SU","updatedOn":"2020-09-01"},{"availability":"regular","avgThrustN":3.4,"burnTimeS":0.84,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"A3","dataFiles":2,"delays":"4,6","designation":"A3","diameter":18,"impulseClass":"A","length":80,"manufacturer":"Quest Aerospace","manufacturerAbbrev":"Quest","maxThrustN":7,"motorId":"5f4294d2000231000000045b","propInfo":"Black Max","propWeightG":2.1,"samples":[[0,0],[0.006,0.153],[0.024,0.429],[0.03,0.889],[0.04,2.574],[0.049,5.854],[0.053,7.11],[0.062,6.528],[0.082,6.16],[0.129,6.129],[0.159,5.302],[0.177,5.087],[0.237,4.474],[0.274,4.352],[0.313,3.892],[0.337,3.586],[0.368,3.494],[0.499,2.329],[0.577,1.655],[0.666,1.103],[0.742,0.736],[0.835,0.398],[0.887,0.245],[0.917,0]],"totImpulseNs":2.5,"totalWeightG":17.9,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":4.4,"burnTimeS":1.1,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"B4","dataFiles":2,"delays":"4,6","designation":"B4","diameter":18,"impulseClass":"B","length":80,"manufacturer":"Quest Aerospace","manufacturerAbbrev":"Quest","maxThrustN":7,"motorId":"5f4294d2000231000000045c","propInfo":"Black Max","propWeightG":3.6,"samples":[[0,0],[0.011,0.102],[0.024,0.622],[0.036,3.81],[0.043,3.886],[0.074,5.93],[0.099,7.061],[0.138,6.819],[0.204,6.883],[0.236,7.099],[0.263,7.035],[0.273,6.883],[0.298,7.2],[0.348,6.667],[0.404,5.994],[0.452,5.867],[0.472,5.651],[0.493,5.321],[0.533,5.168],[0.579,4.762],[0.606,4.686],[0.651,4.381],[0.771,3.251],[0.79,3.289],[0.822,2.921],[0.852,2.857],[0.894,2.451],[0.952,2.095],[0.981,1.676],[1.041,0.965],[1.089,0.559],[1.177,0.114],[1.184,0]],"totImpulseNs":4.86,"totalWeightG":19.8,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":55.89,"burnTimeS":0.99,"caseInfo":"RMS-24/60","certOrg":"National Association of Rocketry","commonName":"F51","dataFiles":2,"delays":"5,7,9","designation":"F51NT","diameter":24,"impulseClass":"F","infoUrl":"http://www.nar.org/SandT/pdf/Aerotech/AT_F51NT_2017.pdf","length":95,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":76.53,"motorId":"5f4294d2000231000000045d","propInfo":"New Blue Thunder","propWeightG":26.5,"samples":[[0,0],[0.004,68.78],[0.013,69.03],[0.018,70.32],[0.027,71.34],[0.06,71.34],[0.1,70.83],[0.2,68.52],[0.3,66.72],[0.4,64.41],[0.5,62.36],[0.6,59.28],[0.7,54.92],[0.722,53.63],[0.738,52.35],[0.757,48.76],[0.775,44.4],[0.8,36.44],[0.85,18.48],[0.875,12.32],[0.9,8.982],[0.95,4.876],[1,3.08],[1.05,0]],"totImpulseNs":55.11,"totalWeightG":81,"type":"reload","updatedOn":"2022-07-16"},{"availability":"regular","avgThrustN":11.7,"burnTimeS":0.84,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"C12","dataFiles":2,"delays":"4,6,8","designation":"C12","diameter":18,"impulseClass":"C","length":78.5,"manufacturer":"Quest Aerospace","manufacturerAbbrev":"Quest","maxThrustN":17.5,"motorId":"5f4294d2000231000000045e","propInfo":"Black Max","propWeightG":10.4,"samples":[[0,0],[0.012,0.342],[0.023,1.796],[0.036,5.218],[0.05,8.127],[0.051,9.41],[0.061,10.35],[0.088,9.752],[0.099,9.752],[0.144,10.27],[0.165,10.86],[0.183,11.63],[0.334,13.69],[0.501,14.63],[0.552,15.06],[0.582,14.63],[0.593,15.23],[0.618,15.06],[0.664,15.74],[0.702,17.54],[0.711,17.71],[0.721,16.85],[0.727,14.8],[0.739,11.04],[0.754,7.271],[0.765,5.304],[0.782,3.336],[0.8,2.053],[0.823,1.283],[0.848,0.77],[0.889,0]],"totImpulseNs":9.8,"totalWeightG":23.7,"type":"SU","updatedOn":"2020-11-25"},{"availability":"regular","avgThrustN":15.7,"burnTimeS":0.79,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"D16","dataFiles":2,"delays":"4,6,8","designation":"D16","diameter":18,"impulseClass":"D","length":78.5,"manufacturer":"Quest Aerospace","manufacturerAbbrev":"Quest","maxThrustN":22.3,"motorId":"5f4294d2000231000000045f","propInfo":"Black Max","propWeightG":12.5,"samples":[[0,0],[0.007,0.411],[0.021,1.745],[0.028,8.828],[0.031,11.5],[0.04,12.11],[0.051,13.76],[0.079,13.04],[0.167,14.78],[0.203,16.12],[0.221,16.01],[0.271,17.55],[0.284,18.17],[0.296,17.55],[0.334,18.48],[0.397,19.5],[0.501,20.74],[0.618,22.27],[0.636,22.07],[0.656,20.94],[0.673,17.76],[0.689,13.35],[0.707,9.033],[0.724,6.159],[0.742,3.798],[0.77,1.95],[0.803,0.821],[0.838,0]],"totImpulseNs":12.4,"totalWeightG":25.7,"type":"SU","updatedOn":"2020-11-25"},{"availability":"regular","avgThrustN":56.91,"burnTimeS":0.84,"caseInfo":"RMS-24/60","certOrg":"National Association of Rocketry","commonName":"F62","dataFiles":2,"delays":"4,6,8,10","designation":"F62FJ","diameter":24,"impulseClass":"F","infoUrl":"http://www.nar.org/SandT/pdf/Aerotech/AT_F62FJ_2017.pdf","length":95,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":73.1,"motorId":"5f4294d20002310000000460","propInfo":"Black Max","propWeightG":32.2,"samples":[[0,0],[0.002,52.85],[0.018,54.43],[0.035,55.55],[0.059,56.9],[0.1,59.15],[0.2,63.65],[0.3,68.15],[0.4,71.52],[0.459,72.2],[0.5,72.2],[0.541,70.62],[0.584,68.15],[0.6,67.92],[0.618,67.25],[0.634,65.67],[0.654,60.73],[0.7,40.03],[0.78,0]],"totImpulseNs":47.57,"totalWeightG":88.1,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":58.06,"burnTimeS":0.85,"caseInfo":"RMS-24/60","certOrg":"National Association of Rocketry","commonName":"F63","dataFiles":2,"delays":"4,6,8,10","designation":"F63R","diameter":24,"impulseClass":"F","infoUrl":"http://www.nar.org/SandT/pdf/Aerotech/AT_F63R_2017.pdf","length":95,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":69.94,"motorId":"5f4294d20002310000000461","propInfo":"Redline","propWeightG":27.6,"samples":[[0,0],[0.002,52.19],[0.018,59.1],[0.035,63.34],[0.063,66.69],[0.1,68.92],[0.2,72.48],[0.3,72.93],[0.35,71.82],[0.4,70.48],[0.5,67.58],[0.6,63.12],[0.65,60.66],[0.665,58.66],[0.685,53.08],[0.7,48.17],[0.8,0]],"totImpulseNs":49.5,"totalWeightG":82.2,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":6.56,"burnTimeS":19.81,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G8","dataFiles":3,"delays":"P","designation":"G8ST","diameter":29,"impulseClass":"G","length":156,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":7.85,"motorId":"5f4294d20002310000000462","propInfo":"Super Thunder","propWeightG":83.4,"samples":[[0,0],[0.024,0.3704],[0.066,0.8746],[0.138,4.504],[0.246,6.621],[0.426,6.735],[1.218,7.323],[2.082,7.423],[3.306,7.183],[5.322,6.838],[6.978,6.719],[8.632,6.551],[10.14,6.479],[12.09,6.425],[15.47,6.333],[17.63,6.13],[19.11,6.038],[19.51,5.961],[19.8,4.429],[19.87,1.669],[19.94,0.3341],[19.96,0]],"totImpulseNs":130,"totalWeightG":157.1,"type":"SU","updatedOn":"2021-01-30"},{"availability":"regular","avgThrustN":10.2,"burnTimeS":13.6,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G11","dataFiles":2,"delays":"P","designation":"G11","diameter":29,"impulseClass":"G","length":152.4,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":28.9,"motorId":"5f4294d20002310000000463","propInfo":"Super Thunder","propWeightG":82,"samples":[[0,0],[0.084,30.44],[0.105,28.41],[0.209,27.74],[0.419,24.09],[0.753,18.4],[0.9,14.75],[1.046,11.91],[1.444,10.01],[2.051,9.742],[3.034,9.201],[4.018,9.471],[5.483,9.201],[5.713,8.93],[9.375,9.742],[9.501,8.93],[11.05,9.742],[12.26,9.336],[13.29,8.66],[13.46,7.307],[13.6,4.6],[13.77,1.624],[13.94,0]],"totImpulseNs":139,"totalWeightG":153.7,"type":"SU","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":11.31,"burnTimeS":12.7,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G12","dataFiles":4,"delays":"P","designation":"G12ST","diameter":29,"impulseClass":"G","length":156,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":30.88,"motorId":"5f4294d20002310000000464","propInfo":"Super Thunder","propWeightG":82,"samples":[[0,0],[0.005,0.1561],[0.032,1.672],[0.043,5.258],[0.078,21.94],[0.15,24],[0.33,28.21],[0.478,31],[0.502,31.26],[0.644,15.24],[0.876,12.27],[1.164,11.45],[1.755,10.68],[3.003,10.16],[4.025,9.87],[5.141,9.955],[6.725,10.91],[8.856,12.02],[11.23,12.71],[12.01,11.34],[12.19,9.21],[12.26,6.912],[12.34,4.543],[12.47,1.552],[12.57,0.2906],[12.6,0]],"totImpulseNs":144,"totalWeightG":150.3,"type":"SU","updatedOn":"2021-01-30"},{"availability":"regular","avgThrustN":326.2,"burnTimeS":2.25,"caseInfo":"38/740","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J326","dataFiles":1,"delays":"8,11,15","designation":"J-326-LR","diameter":38,"impulseClass":"J","length":417,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":925.8,"motorId":"5f4294d20002310000000465","propInfo":"Loki Red","propWeightG":360,"samples":[[0,0],[0.012,2.182],[0.024,61.58],[0.052,936.9],[0.061,975.8],[0.1,615.7],[0.287,498.2],[0.467,455.7],[0.683,416.3],[0.971,362],[1.259,308.9],[1.547,256.5],[1.836,191.4],[2.123,74.02],[2.279,37.62],[2.371,24.45],[2.5,0]],"totImpulseNs":732.9,"totalWeightG":766,"type":"reload","updatedOn":"2019-04-17"},{"availability":"regular","avgThrustN":474,"burnTimeS":1.49,"caseInfo":"38/740","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J474","dataFiles":1,"delays":"18","designation":"J474-CT","diameter":38,"impulseClass":"J","length":416.9,"manufacturer":"Loki Research","manufacturerAbbrev":"Loki","maxThrustN":1243,"motorId":"5f4294d20002310000000466","propInfo":"Cocktail","propWeightG":360,"samples":[[0,0],[0.018,21.9],[0.04,716.6],[0.054,1223],[0.057,1221],[0.085,936.5],[0.133,808.5],[0.247,732.8],[0.39,685.4],[0.502,646.9],[0.647,568.7],[0.826,442.7],[1.006,327.4],[1.15,241.9],[1.296,179.4],[1.474,85.33],[1.611,21.27],[1.65,0]],"totImpulseNs":709.1,"totalWeightG":755.6,"type":"reload","updatedOn":"2019-04-28"},{"availability":"regular","avgThrustN":80.78,"burnTimeS":1.3,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G72","dataFiles":2,"delays":"6,8,10,12,14","designation":"G72DM-14A","diameter":29,"impulseClass":"G","length":156.4,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":105.6,"motorId":"5f4294d20002310000000467","propInfo":"Dark Matter","propWeightG":62.5,"samples":[[0,0],[0.001,0.1874],[0.025,5.288],[0.038,13.59],[0.055,38.13],[0.097,59.74],[0.207,73.12],[0.319,83.64],[0.427,93.75],[0.64,97.64],[0.75,103.7],[0.968,93.15],[1.137,92.35],[1.245,31.16],[1.344,4.883],[1.4,0.4773],[1.41,0]],"sparky":true,"totImpulseNs":105,"totalWeightG":131.6,"type":"SU","updatedOn":"2019-05-21"},{"availability":"regular","avgThrustN":168.8,"burnTimeS":1.38,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H169","dataFiles":2,"delays":"5,7,9,11,13","designation":"H169WS-13","diameter":29,"impulseClass":"H","length":220.7,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":231.4,"motorId":"5f4294d20002310000000468","propInfo":"Super White Lightning","propWeightG":112,"samples":[[0,0],[0.021,3.917],[0.034,138.5],[0.053,216.8],[0.08,231.3],[0.22,233.5],[0.299,228.9],[0.489,221.6],[0.653,214],[0.819,178.6],[0.945,148],[1.132,115.3],[1.286,55.19],[1.35,30.5],[1.366,12.36],[1.444,4.642],[1.53,0]],"totImpulseNs":232.9,"totalWeightG":202.2,"type":"SU","updatedOn":"2019-12-12"},{"availability":"regular","avgThrustN":455.4,"burnTimeS":5.09,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K455","dataFiles":2,"delays":"7,9,11,13,15,17","designation":"K455NW-17","diameter":54,"impulseClass":"K","length":674.9,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1308,"motorId":"5f4294d20002310000000469","propInfo":"White Lightning/Warp 9","propWeightG":1456,"samples":[[0,0],[0.014,12.18],[0.034,263.2],[0.062,1219],[0.111,1229],[0.2,1288],[0.409,1300],[0.505,1234],[0.548,1083],[0.587,395.8],[0.62,445],[0.85,476.4],[1.23,447.1],[1.725,437.5],[2.22,428.6],[2.714,414.9],[3.208,401.8],[3.664,395.3],[3.941,399.6],[4.12,294.9],[4.5,164.8],[4.881,101.9],[5.147,62.23],[5.329,28.83],[5.4,0]],"totImpulseNs":2328,"totalWeightG":2286,"type":"SU","updatedOn":"2020-11-07"},{"availability":"regular","avgThrustN":1257,"burnTimeS":3.01,"caseInfo":"RMS-75/3840","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1256","dataFiles":2,"designation":"L1256WS","diameter":75,"impulseClass":"L","length":560.8,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1509,"motorId":"5f4294d2000231000000046a","propInfo":"Super White Lightning","propWeightG":1964,"samples":[[0,0],[0.017,13.87],[0.045,1220],[0.19,1400],[0.465,1439],[0.77,1470],[1.076,1466],[1.381,1445],[1.723,1341],[2.029,1231],[2.485,1098],[2.71,1064],[2.788,829.7],[2.939,376],[3.023,55.77],[3.041,28.07],[3.059,0]],"totImpulseNs":3785,"totalWeightG":3756,"type":"reload","updatedOn":"2019-12-12"},{"availability":"regular","avgThrustN":2048,"burnTimeS":2.7,"caseInfo":"RMS-75/5120","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M2050","dataFiles":2,"designation":"M2050X-P","diameter":75,"impulseClass":"M","length":699.7,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":2544,"motorId":"5f4294d2000231000000046b","propInfo":"Propellant X","propWeightG":2268,"samples":[[0,0],[0.028,417.2],[0.067,2562],[0.151,2409],[0.261,2392],[0.372,2298],[0.557,2265],[0.779,2242],[0.965,2220],[1.15,2189],[1.372,2146],[1.816,2060],[2.149,2028],[2.325,2021],[2.419,1865],[2.495,1462],[2.611,804.8],[2.697,307.6],[2.736,91.61],[2.764,0]],"totImpulseNs":5493,"totalWeightG":4559,"type":"reload","updatedOn":"2021-02-14"},{"availability":"regular","avgThrustN":5515,"burnTimeS":4.03,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"O5500","dataFiles":3,"delays":"P","designation":"O5500X-PS","diameter":98,"impulseClass":"O","length":1507,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":7552,"motorId":"5f4294d2000231000000046c","propInfo":"Propellant X","propWeightG":9779,"samples":[[0,0],[0.009,20.41],[0.044,7112],[0.063,6735],[0.078,6898],[0.094,6612],[0.109,6765],[0.125,6541],[0.147,6582],[0.194,6520],[0.35,6796],[0.428,7092],[0.563,7286],[0.694,7408],[0.988,7582],[1.266,7622],[1.491,7724],[1.581,7653],[1.641,7541],[1.684,7500],[1.716,7337],[1.784,7224],[1.938,6786],[2.138,6327],[2.491,5898],[2.6,5704],[2.919,3541],[3.022,3408],[3.138,2888],[3.3,2235],[3.388,1673],[3.441,1490],[3.544,1418],[3.609,1296],[3.688,816.3],[3.778,653.1],[3.819,581.6],[3.853,489.8],[3.897,285.7],[3.981,20.41],[3.997,0]],"totImpulseNs":21380,"totalWeightG":16780,"type":"SU","updatedOn":"2023-01-11"},{"availability":"regular","avgThrustN":474.1,"burnTimeS":2.94,"caseInfo":"54-1400","certOrg":"National Association of Rocketry","commonName":"K475","dataFiles":2,"designation":"K475","diameter":54,"impulseClass":"K","length":403,"manufacturer":"Animal Motor Works","manufacturerAbbrev":"AMW","maxThrustN":588.3,"motorId":"5f4294d2000231000000046d","propInfo":"White Wolf","propWeightG":728.6,"samples":[[0,0],[0.022,127.8],[0.041,386],[0.063,548.3],[0.096,521.3],[0.134,499.1],[0.18,486.8],[0.285,486.8],[0.478,501.6],[0.731,523.7],[1.096,553.3],[1.433,578],[1.601,588.3],[1.756,582.7],[1.895,580.3],[1.958,575.3],[2.063,550.7],[2.209,518.8],[2.344,477.1],[2.495,418],[2.561,354.1],[2.582,334.4],[2.599,332],[2.62,297.5],[2.67,226.2],[2.707,157.4],[2.74,98.35],[2.799,49.18],[2.853,17.21],[2.94,0]],"totImpulseNs":1394,"totalWeightG":1493,"type":"reload","updatedOn":"2020-02-25"},{"availability":"regular","avgThrustN":87.54,"burnTimeS":1.31,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"G75","dataFiles":2,"delays":"7,9,11,13","designation":"G75M","diameter":29,"impulseClass":"G","length":157,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":110.7,"motorId":"5f4294d2000231000000046e","propInfo":"Metalstorm","propWeightG":67,"samples":[[0,0],[0.021,1.11],[0.027,16.73],[0.032,42.59],[0.071,76.46],[0.098,89.43],[0.146,95.76],[0.208,100.7],[0.282,103.4],[0.345,100.3],[0.467,99.99],[0.619,103.4],[0.732,100.7],[0.916,95.36],[1.048,86.1],[1.121,77.1],[1.211,68.24],[1.258,34.37],[1.304,10.55],[1.347,4.14],[1.398,0]],"sparky":true,"totImpulseNs":115.2,"totalWeightG":133,"type":"SU","updatedOn":"2020-09-23"},{"availability":"regular","avgThrustN":176.4,"burnTimeS":1.886,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I175","dataFiles":2,"delays":"5,7,9,11,13","designation":"I175WS","diameter":38,"impulseClass":"I","length":214,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":260.4,"motorId":"5f4294d2000231000000046f","propInfo":"Super White Lightning","samples":[[0,0],[0.022,2.71],[0.028,93.62],[0.06,219.8],[0.097,244.9],[0.209,252.6],[0.299,249.2],[0.581,227],[0.97,190.3],[1.381,136.1],[1.749,109],[1.802,65.53],[1.857,24.89],[1.908,10.42],[1.97,0]],"totImpulseNs":333,"totalWeightG":348,"type":"SU","updatedOn":"2020-04-30"},{"availability":"regular","avgThrustN":52.65,"burnTimeS":1.26,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"F52","dataFiles":2,"delays":"5,6,8,10,12","designation":"F52C","diameter":29,"impulseClass":"F","length":111.4,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":64.33,"motorId":"5f5e57811e865c0004c955d8","propInfo":"Classic","propWeightG":30,"samples":[[0,0],[0.02,0.267],[0.024,3.465],[0.038,38.82],[0.073,53.88],[0.143,56.49],[0.323,61.32],[0.826,57.35],[1.141,51.07],[1.17,35.61],[1.225,11.76],[1.266,4.559],[1.291,1.512],[1.32,0.133],[1.329,0]],"totImpulseNs":66.2,"totalWeightG":81.4,"type":"SU","updatedOn":"2021-07-03"},{"availability":"regular","avgThrustN":13.89,"burnTimeS":15.22,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H13","dataFiles":2,"delays":"P","designation":"H13ST","diameter":29,"impulseClass":"H","length":213.4,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":43.51,"motorId":"5f5e58171e865c0004c955f8","propInfo":"Super Thunder","propWeightG":116.4,"samples":[[0,0],[0.005,0.107],[0.024,2.636],[0.035,18.98],[0.081,32.72],[0.147,36.42],[0.379,44.53],[0.452,23.85],[0.566,18.89],[0.818,16.73],[1.286,15.68],[2.114,14.75],[3.23,14.03],[4.382,13.93],[5.786,13.47],[7.082,13.12],[8.666,12.92],[10.29,12.82],[12.09,12.61],[13.6,12.33],[14.75,11.91],[15.23,11.08],[15.3,6.048],[15.43,0]],"totImpulseNs":211.2,"totalWeightG":203.4,"type":"SU","updatedOn":"2020-09-13"},{"availability":"regular","avgThrustN":6,"burnTimeS":0.6,"certOrg":"Uncertified","commonName":"A6","dataFiles":2,"delays":"4","designation":"A6","diameter":18,"impulseClass":"A","infoUrl":"https://www.raketenmodellbau-klima.de/Raketenmodellbau/Motoren-Treibsaetze/Motor-A6-4-6-Stueck-.htm?shop=raketenklima&SessionId=&a=article&ProdNr=0164&t=23&c=712&p=712","length":70,"manufacturer":"Raketenmodellbau Klima","manufacturerAbbrev":"Klima","maxThrustN":10.5,"motorId":"5f76951c9503a10004898852","propInfo":"black powder","propWeightG":3.5,"samples":[[0,0],[0.088,0.502],[0.186,4.601],[0.232,7.089],[0.314,10.48],[0.418,6.713],[0.467,3.011],[0.501,0.418],[0.71,0]],"totImpulseNs":2.5,"totalWeightG":14.5,"type":"SU","updatedOn":"2020-10-17"},{"availability":"regular","avgThrustN":2,"burnTimeS":2.5,"certOrg":"Uncertified","commonName":"B2","dataFiles":1,"delays":"0,4,P","designation":"B2","diameter":18,"impulseClass":"B","infoUrl":"https://www.raketenmodellbau-klima.de/Raketenmodellbau/Motoren-Treibsaetze/Motor-B2-0-6-Stueck-.htm?shop=raketenklima&SessionId=&a=article&ProdNr=0220&t=23&c=712&p=712","length":70,"manufacturer":"Raketenmodellbau Klima","manufacturerAbbrev":"Klima","motorId":"5f7695bd9503a10004898855","propInfo":"black powder","samples":[[0,0],[0.256,1.578],[0.31,2.042],[0.361,2.568],[0.395,3.063],[0.433,3.62],[0.453,4.115],[0.484,4.765],[0.501,4.92],[0.515,5.105],[0.532,5.012],[0.545,4.796],[0.566,4.455],[0.583,3.929],[0.596,3.434],[0.627,2.97],[0.661,2.63],[0.719,2.166],[0.801,1.949],[2.256,1.949],[2.314,1.825],[2.361,1.423],[2.505,0]],"totImpulseNs":5,"type":"SU","updatedOn":"2020-10-02"},{"availability":"regular","avgThrustN":2,"burnTimeS":5,"certOrg":"Uncertified","commonName":"C2","dataFiles":2,"delays":"0,P","designation":"C2","diameter":18,"impulseClass":"C","infoUrl":"https://www.raketenmodellbau-klima.de/Raketenmodellbau/Motoren-Treibsaetze/Motor-C2-0-6-Stueck-.htm?shop=raketenklima&SessionId=&a=article&ProdNr=0320&t=23&c=712&p=712","length":70,"manufacturer":"Raketenmodellbau Klima","manufacturerAbbrev":"Klima","maxThrustN":5,"motorId":"5f7696fb9503a10004898857","propInfo":"black powder","propWeightG":11.3,"samples":[[0,0],[0.04,0.229],[0.12,0.658],[0.211,1.144],[0.291,1.831],[0.385,2.86],[0.447,3.833],[0.505,5.001],[0.567,3.89],[0.615,3.146],[0.665,2.66],[0.735,2.203],[0.815,2.088],[0.93,1.98],[4.589,1.96],[4.729,1.888],[4.815,1.602],[4.873,1.259],[4.969,0.658],[5.083,0]],"totImpulseNs":9.8,"totalWeightG":22.4,"type":"SU","updatedOn":"2020-10-17"},{"availability":"regular","avgThrustN":6,"burnTimeS":1.6,"certOrg":"Uncertified","commonName":"C6","dataFiles":2,"delays":"0,3,5,7,P","designation":"C6","diameter":18,"impulseClass":"C","infoUrl":"https://www.raketenmodellbau-klima.de/Raketenmodellbau/Motoren-Treibsaetze/Motor-C6-0-6-Stueck-.htm?shop=raketenklima&SessionId=&a=article&ProdNr=0360&t=23&c=712&p=712","length":70,"manufacturer":"Raketenmodellbau Klima","manufacturerAbbrev":"Klima","maxThrustN":15,"motorId":"5f76974c9503a10004898858","propInfo":"black powder","propWeightG":9.6,"samples":[[0,0],[0.046,0.953],[0.168,5.259],[0.235,10.02],[0.291,15],[0.418,9.87],[0.505,7.546],[0.582,6.631],[0.679,6.136],[0.786,5.716],[1.26,5.678],[1.357,5.488],[1.423,4.992],[1.469,4.116],[1.618,1.22],[1.701,0]],"totImpulseNs":10,"totalWeightG":20.5,"type":"SU","updatedOn":"2020-10-17"},{"availability":"regular","avgThrustN":9,"burnTimeS":2.1,"certOrg":"Uncertified","commonName":"D9","dataFiles":2,"delays":"0,3,5,7,P","designation":"D9","diameter":18,"impulseClass":"D","infoUrl":"https://www.raketenmodellbau-klima.de/Raketenmodellbau/Motoren-Treibsaetze/Motor-D9-0-inkl-Elektrozuender-6-Stueck-.htm?shop=raketenklima&SessionId=&a=article&ProdNr=0400&t=23&c=712&p=712","length":70,"manufacturer":"Raketenmodellbau Klima","manufacturerAbbrev":"Klima","maxThrustN":25,"motorId":"5f7697979503a10004898859","propInfo":"black powder","propWeightG":16.1,"samples":[[0,0],[0.04,2.111],[0.116,9.685],[0.213,25],[0.286,15.74],[0.329,12.47],[0.369,10.67],[0.42,9.713],[0.495,9.178],[0.597,8.896],[1.711,8.925],[1.826,8.699],[1.917,8.052],[1.975,6.954],[2.206,1.07],[2.242,0]],"totImpulseNs":20,"totalWeightG":27.1,"type":"SU","updatedOn":"2020-12-06"},{"availability":"regular","avgThrustN":66.76,"burnTimeS":20.22,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K76","dataFiles":2,"delays":"P","designation":"K76WN-P","diameter":54,"impulseClass":"K","length":368,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":299.7,"motorId":"5f7d2b90606b5d00041d9ab1","propInfo":"White Lightning/Warp 9","propWeightG":840,"samples":[[0,0],[0.002,0.89],[0.024,14.56],[0.03,103.8],[0.046,251.3],[0.122,277.1],[0.834,279.8],[1.266,284.1],[2.13,273.3],[2.886,256.7],[3.084,151.9],[3.278,49.95],[3.71,39.6],[4.862,36.31],[9.686,30.08],[12.96,28.25],[15.66,26.82],[18.51,25.91],[19.95,24.61],[20.13,22.17],[20.29,14.57],[20.44,6.13],[20.58,0]],"totImpulseNs":1350,"totalWeightG":1278,"type":"SU","updatedOn":"2020-10-07"},{"availability":"regular","avgThrustN":19.1,"burnTimeS":0.52,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"C18","dataFiles":2,"delays":"4,6,8","designation":"C18W","diameter":18,"impulseClass":"C","length":81,"manufacturer":"Quest Aerospace","manufacturerAbbrev":"Quest","maxThrustN":23.6,"motorId":"5f7d2f71606b5d00041d9aba","propInfo":"Fast White Lightning","propWeightG":5.6,"samples":[[0,0],[0.013,0.043],[0.022,0.937],[0.03,2.428],[0.039,6.218],[0.044,12.44],[0.052,20.06],[0.059,21.72],[0.071,22.02],[0.08,21.85],[0.088,22.19],[0.122,21.38],[0.132,21.42],[0.143,21.08],[0.152,21.55],[0.167,21.68],[0.177,21.72],[0.187,21.93],[0.197,21.21],[0.218,21.25],[0.225,21.98],[0.232,22.06],[0.241,21.08],[0.247,20.95],[0.261,21.34],[0.268,21.38],[0.277,20.91],[0.294,21.08],[0.313,21.17],[0.324,21.38],[0.331,21.38],[0.34,21.12],[0.347,21.12],[0.356,21.04],[0.363,21.12],[0.377,21.55],[0.384,21.68],[0.396,22.15],[0.404,22.79],[0.414,22.91],[0.424,22.79],[0.436,22.06],[0.443,21.34],[0.454,20.78],[0.461,20.14],[0.468,19.46],[0.477,17.97],[0.482,15.93],[0.49,13.03],[0.5,9.114],[0.509,6.133],[0.52,3.279],[0.532,0.894],[0.539,0.256],[0.543,0]],"totImpulseNs":9.83,"totalWeightG":20.9,"type":"SU","updatedOn":"2020-10-07"},{"availability":"regular","avgThrustN":18.25,"burnTimeS":0.76,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"D20","dataFiles":2,"delays":"4,6,8","designation":"D20W","diameter":18,"impulseClass":"D","length":81,"manufacturer":"Quest Aerospace","manufacturerAbbrev":"Quest","maxThrustN":24.34,"motorId":"5f7d30aa606b5d00041d9abc","propInfo":"Fast White Lightning","propWeightG":8.7,"samples":[[0,0],[0.001,1.96],[0.013,17.06],[0.026,24.7],[0.07,19.17],[0.116,17.55],[0.181,16.99],[0.285,18.24],[0.426,19.5],[0.564,19.81],[0.626,21.26],[0.667,19.48],[0.68,17.19],[0.695,13.68],[0.713,8.351],[0.745,2.124],[0.764,0.669],[0.799,0.04719],[0.8,0]],"totImpulseNs":13.83,"totalWeightG":24.1,"type":"SU","updatedOn":"2020-10-07"},{"availability":"OOP","avgThrustN":42,"burnTimeS":2.56,"certOrg":"National Association of Rocketry","commonName":"G42","dataFiles":1,"delays":"4,6,8,10,12","designation":"G42","diameter":24,"impulseClass":"G","length":144,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":58.63,"motorId":"5f7d3c0f606b5d00041d9f9b","propWeightG":48.8,"samples":[[0,0],[0.005,22.79],[0.015,32.15],[0.024,29.11],[0.04,31.77],[0.043,36.81],[0.048,42.16],[0.053,46.94],[0.06,51.01],[0.088,54.73],[0.134,56.67],[0.192,55.29],[0.253,54.75],[0.312,54.11],[0.369,54.45],[0.43,54.21],[0.487,53.85],[0.548,53.67],[0.605,53.96],[0.665,53.72],[0.731,53.28],[0.787,52.59],[0.846,51.96],[0.906,51.35],[0.965,50.77],[1.026,49.24],[1.081,48.62],[1.142,47.27],[1.213,45.73],[1.264,43.8],[1.321,42.33],[1.382,40.39],[1.442,38.48],[1.502,36.75],[1.561,33.9],[1.621,31.98],[1.679,29.13],[1.729,25.86],[1.784,22.24],[1.837,18.93],[1.895,15.86],[1.953,13.19],[2.014,10.81],[2.076,8.833],[2.131,7.109],[2.199,5.416],[2.275,3.67],[2.333,2.581],[2.404,1.791],[2.479,0.407],[2.519,0.231]],"totImpulseNs":89.16,"totalWeightG":95,"type":"SU","updatedOn":"2020-10-07"},{"availability":"regular","avgThrustN":4,"burnTimeS":1.2,"certOrg":"Uncertified","commonName":"B4","dataFiles":2,"delays":"0,4,P","designation":"B4","diameter":18,"impulseClass":"B","infoUrl":"https://www.raketenmodellbau-klima.de/Raketenmodellbau/Motoren-Treibsaetze/Motor-B4-0-6-Stueck-.htm?shop=raketenklima&SessionId=&a=article&ProdNr=0240&t=23&c=712&p=712","length":70,"manufacturer":"Raketenmodellbau Klima","manufacturerAbbrev":"Klima","maxThrustN":8,"motorId":"5f8b05a5d5fa3b000447e825","propInfo":"black powder","propWeightG":5.4,"samples":[[0,0],[0.049,0.83],[0.096,1.745],[0.157,2.946],[0.209,3.89],[0.273,4.977],[0.335,6.093],[0.38,7.122],[0.411,8.001],[0.436,7.065],[0.465,6.236],[0.516,5.063],[0.564,4.462],[0.607,4.205],[0.669,4.09],[0.9,4.09],[0.966,3.976],[1.025,3.719],[1.084,3.261],[1.145,2.546],[1.212,1.745],[1.295,0.772],[1.364,0]],"totImpulseNs":5,"totalWeightG":16.3,"type":"SU","updatedOn":"2020-10-17"},{"availability":"regular","avgThrustN":3,"burnTimeS":5.5,"certOrg":"Uncertified","commonName":"D3","dataFiles":2,"delays":"0,P","designation":"D3","diameter":18,"impulseClass":"D","infoUrl":"https://www.raketenmodellbau-klima.de/Raketenmodellbau/Motoren-Treibsaetze/Motor-D3-0-6-Stueck-.htm?shop=raketenklima&SessionId=&a=article&ProdNr=0430&t=23&c=712&p=712","length":70,"manufacturer":"Raketenmodellbau Klima","manufacturerAbbrev":"Klima","maxThrustN":9.01,"motorId":"5f8b0753d5fa3b000447e835","propInfo":"black powder","propWeightG":17,"samples":[[0,0],[0.073,0.229],[0.178,0.686],[0.251,1.287],[0.313,2.203],[0.375,3.633],[0.425,5.006],[0.473,6.465],[0.556,8.181],[0.603,9.01],[0.655,6.922],[0.698,5.463],[0.782,4.291],[0.873,3.576],[1.024,3.146],[1.176,2.946],[5.282,2.918],[5.491,2.832],[5.59,2.517],[5.782,1.859],[5.924,1.287],[6.061,0.715],[6.17,0.286],[6.26,0]],"totImpulseNs":17.4,"totalWeightG":27.9,"type":"SU","updatedOn":"2020-10-27"},{"availability":"regular","avgThrustN":21.66,"burnTimeS":0.89,"caseInfo":"White Lightning","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"D22","dataFiles":2,"delays":"4,6,7,8,10","designation":"D22W","diameter":24,"impulseClass":"D","length":86.7,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":27.58,"motorId":"60159ce4b94d0e00040a8402","propWeightG":12,"samples":[[0,0],[0.021,1.39],[0.057,21.6],[0.1,25.01],[0.172,27.69],[0.316,24.7],[0.46,22.47],[0.64,21.81],[0.859,16.23],[0.895,6.84],[0.934,1.087],[0.972,0.1795],[1.008,0]],"totImpulseNs":19.33,"totalWeightG":37.5,"type":"SU","updatedOn":"2021-01-30"},{"availability":"regular","avgThrustN":23.5,"burnTimeS":1.18,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"E26","dataFiles":2,"delays":"4,6,7,8,10","designation":"E26W","diameter":24,"impulseClass":"E","length":87.7,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":27.89,"motorId":"60159d7db94d0e00040a8404","propInfo":"White Lightning","propWeightG":18.3,"samples":[[0,0],[0.019,2.037],[0.058,16.93],[0.161,22.15],[0.413,26.96],[0.667,25.86],[0.923,25.63],[1.08,26.22],[1.138,16.76],[1.166,6.116],[1.192,0.5682],[1.217,0]],"totImpulseNs":27.85,"totalWeightG":44,"type":"SU","updatedOn":"2021-01-30"},{"availability":"regular","avgThrustN":1939,"burnTimeS":2.23,"caseInfo":"RMS-75/3840","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"L1940","dataFiles":1,"delays":"P","designation":"L1940X","diameter":75,"impulseClass":"L","length":560,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":2319,"motorId":"60ac748b8dc4640004c24d85","propInfo":"Propellant X","propWeightG":1825,"samples":[[0,0],[0.02,48.14],[0.04,2107],[0.055,2289],[0.073,2150],[0.156,2102],[0.397,2150],[0.691,2155],[0.982,2118],[1.41,2000],[1.696,1899],[1.935,1840],[2.06,1819],[2.103,1653],[2.116,1375],[2.133,936],[2.163,534.9],[2.214,240.7],[2.244,112.3],[2.296,5.349],[2.309,0]],"totImpulseNs":4329,"totalWeightG":3856,"type":"reload","updatedOn":"2021-05-25"},{"availability":"regular","avgThrustN":4.22,"burnTimeS":1.17,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"B6","dataFiles":2,"delays":"4,6","designation":"B6W","diameter":18,"impulseClass":"B","length":79.2,"manufacturer":"Quest Aerospace","manufacturerAbbrev":"Quest","maxThrustN":9.13,"motorId":"60ac76068dc4640004c24d93","propInfo":"White Lightning","propWeightG":2.8,"samples":[[0,0],[0.01,0.157],[0.029,0.677],[0.045,2.643],[0.058,0.966],[0.09,2.048],[0.127,6.545],[0.174,9.296],[0.214,9.045],[0.269,9.01],[0.324,8.039],[0.47,6.334],[0.615,4.492],[0.795,2.904],[0.975,1.412],[1.148,0.536],[1.211,0]],"totImpulseNs":4.87,"totalWeightG":19.3,"type":"SU","updatedOn":"2021-05-25"},{"availability":"regular","avgThrustN":37.73,"burnTimeS":9.95,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"I40","dataFiles":1,"delays":"P","designation":"I40N-P","diameter":38,"impulseClass":"I","length":203,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":101.7,"motorId":"616e6152763045000425980a","propInfo":"Warp 9","propWeightG":197,"samples":[[0,0],[0.021,58.16],[0.134,95.02],[0.289,94.59],[0.371,89.48],[0.485,51.55],[1.072,41.12],[2.155,38.56],[2.845,38.35],[3.619,37.28],[4.433,36.43],[5.474,35.15],[6.144,34.73],[6.794,34.73],[7.433,34.3],[7.969,33.66],[8.794,32.38],[9.546,31.74],[9.979,0]],"totImpulseNs":374.9,"totalWeightG":359.9,"type":"SU","updatedOn":"2021-10-19"},{"availability":"regular","avgThrustN":615.1,"burnTimeS":1.2,"caseInfo":"RMS-54/852","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J615","dataFiles":2,"delays":"4,8,12,16,20","designation":"J615ST-20A","diameter":54,"impulseClass":"J","length":240.4,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":933.9,"motorId":"616e62f1763045000425980d","propInfo":"Super Thunder","propWeightG":370.5,"samples":[[0,0],[0.003,2.405],[0.025,21.64],[0.037,829.7],[0.052,726.3],[0.093,668.5],[0.174,680.6],[0.369,719],[0.532,728.7],[0.688,704.6],[0.851,649.3],[0.953,589.2],[1.031,531.5],[1.113,478.6],[1.166,387.2],[1.198,254.9],[1.212,122.6],[1.243,0]],"totImpulseNs":745.5,"totalWeightG":801.7,"type":"reload","updatedOn":"2021-10-19"},{"availability":"regular","avgThrustN":1971,"burnTimeS":7.04,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"N1975","dataFiles":1,"delays":"P","designation":"N1975W-PS","diameter":98,"impulseClass":"N","length":1110,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":2903,"motorId":"616e64637630450004259814","propInfo":"White Lightning","propWeightG":7676,"samples":[[0,0],[0.08,1985],[0.217,2638],[0.819,2700],[1.237,2769],[1.663,2817],[2.137,2803],[2.651,2672],[3.245,2404],[4.032,2054],[4.602,1855],[5.229,1532],[5.39,1353],[5.566,1072],[5.863,796.9],[6.161,604.5],[6.297,563.3],[6.763,316],[6.996,199.2],[7.333,0]],"totImpulseNs":13890,"totalWeightG":12210,"type":"SU","updatedOn":"2021-10-19"},{"availability":"regular","avgThrustN":2129,"burnTimeS":1.82,"certOrg":"National Association of Rocketry","commonName":"L2350","dataFiles":1,"delays":"P","designation":"L2350","diameter":152,"impulseClass":"L","length":210,"manufacturer":"Estes Industries","manufacturerAbbrev":"Estes","maxThrustN":2585,"motorId":"61ec46faa1cd0a000491cf48","propWeightG":1680,"samples":[[0,0],[0.086,17.85],[0.098,50.7],[0.1061,128.9],[0.1124,259],[0.1196,514.3],[0.1256,807.7],[0.1392,1569],[0.1476,1942],[0.1512,2059],[0.156,2172],[0.1656,2271],[0.2036,2213],[0.378,2390],[0.5616,2529],[0.6447,2575],[0.7668,2584],[0.992,2541],[1.168,2420],[1.603,1862],[1.664,1762],[1.714,1627],[1.75,1458],[1.783,1205],[1.832,638.3],[1.853,457.9],[1.892,238.8],[1.934,129],[1.98,61.91],[2.047,39.04],[3,43.09],[3.001,0]],"totImpulseNs":3886,"totalWeightG":5550,"type":"SU","updatedOn":"2022-01-22"},{"availability":"regular","avgThrustN":746.6,"burnTimeS":1.74,"caseInfo":"RMS-75/1280","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K750","dataFiles":1,"delays":"P","designation":"K750ST","diameter":75,"impulseClass":"K","length":267,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":835.7,"motorId":"627bbef01b11ab0004a4bb20","propInfo":"Super Thunder","propWeightG":595,"samples":[[0,0],[0.014,4.867],[0.018,10.18],[0.044,659.3],[0.068,606.6],[0.118,632.3],[0.17,658],[0.22,681],[0.263,703.1],[0.334,727.9],[0.483,772.1],[0.577,792.5],[0.663,805.8],[0.723,809.3],[0.778,814.6],[0.886,811.9],[0.975,807.5],[1.065,796.9],[1.148,788.9],[1.234,779.2],[1.352,763.7],[1.456,749.1],[1.559,738.5],[1.625,737.6],[1.664,744.7],[1.704,768.6],[1.715,759.7],[1.755,128.8],[1.767,41.15],[1.783,0]],"totImpulseNs":1299,"totalWeightG":1948,"type":"reload","updatedOn":"2022-05-11"},{"availability":"regular","avgThrustN":33.81,"burnTimeS":1.08,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"E35","dataFiles":2,"delays":"5,8,11","designation":"E35W","diameter":24,"impulseClass":"E","length":113,"manufacturer":"Quest Aerospace","manufacturerAbbrev":"Quest","maxThrustN":43.96,"motorId":"629ee7b1e0d0450004036826","propInfo":"White Lightning","propWeightG":25.4,"samples":[[0,0],[0.001,0.626],[0.028,3.962],[0.04,13.14],[0.051,29.61],[0.178,34.82],[0.321,36.49],[0.516,37.74],[0.712,40.24],[0.854,41.91],[0.947,43.58],[0.979,46.5],[0.999,41.91],[1.018,33.78],[1.04,26.48],[1.069,19.6],[1.104,9.383],[1.122,3.128],[1.141,0]],"totImpulseNs":39.38,"totalWeightG":55,"type":"SU","updatedOn":"2022-06-07"},{"availability":"regular","avgThrustN":40.26,"burnTimeS":1.12,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"F41","dataFiles":2,"delays":"5,8,11","designation":"F41W","diameter":24,"impulseClass":"F","length":114,"manufacturer":"Quest Aerospace","manufacturerAbbrev":"Quest","maxThrustN":49.94,"motorId":"629ee8bae0d045000403682e","propInfo":"White Lightning","propWeightG":30,"samples":[[0,0],[0.018,0.679],[0.031,8.821],[0.048,25.56],[0.07,30.31],[0.099,33.25],[0.145,34.83],[0.231,36.64],[0.409,41.84],[0.647,45.24],[0.884,47.5],[0.947,47.72],[0.995,51.57],[1.032,51.34],[1.049,49.08],[1.059,44.56],[1.077,35.96],[1.1,26.69],[1.167,9.273],[1.2,0]],"totImpulseNs":45.4,"totalWeightG":60.7,"type":"SU","updatedOn":"2022-06-07"},{"availability":"regular","avgThrustN":1777,"burnTimeS":1.37,"caseInfo":"RMS-75/2560","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K1800","dataFiles":1,"delays":"P","designation":"K1800ST-P","diameter":75,"impulseClass":"K","length":492,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":2082,"motorId":"62f9c49d6ae9e200040442ab","propInfo":"Super Thunder","propWeightG":1113,"samples":[[0,0],[0.012,9.756],[0.018,19.51],[0.022,39.02],[0.025,180.5],[0.029,578],[0.035,1298],[0.038,1720],[0.042,1924],[0.046,1868],[0.05,1780],[0.052,1698],[0.056,1639],[0.06,1683],[0.065,1734],[0.071,1695],[0.077,1668],[0.084,1717],[0.093,1693],[0.102,1732],[0.114,1744],[0.134,1759],[0.163,1793],[0.212,1851],[0.262,1900],[0.363,1983],[0.447,2029],[0.524,2056],[0.621,2076],[0.695,2071],[0.769,2037],[0.81,1993],[0.852,1946],[0.891,1910],[0.947,1861],[0.997,1798],[1.045,1732],[1.086,1671],[1.143,1593],[1.205,1507],[1.249,1456],[1.287,1424],[1.307,1434],[1.322,1432],[1.332,1361],[1.34,1244],[1.346,1105],[1.349,1010],[1.353,912.2],[1.357,785.4],[1.364,612.2],[1.374,434.1],[1.386,253.7],[1.401,104.9],[1.414,31.71],[1.424,0]],"totImpulseNs":2444,"totalWeightG":2772,"type":"reload","updatedOn":"2022-08-15"},{"availability":"regular","avgThrustN":22.35,"burnTimeS":1.64,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"E24","dataFiles":1,"delays":"4,7,10","designation":"E24C","diameter":29,"impulseClass":"E","length":110,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":33,"motorId":"63628c12a244550004a0cf01","propInfo":"Classic","propWeightG":18.4,"samples":[[0,0],[0.025,2.452],[0.055,13.64],[0.09,24.06],[0.122,27.43],[0.23,31.57],[0.297,33.41],[0.322,32.8],[0.345,34.18],[0.414,34.64],[0.492,33.1],[0.612,30.65],[0.767,27.89],[0.959,23.6],[1.288,15.33],[1.451,13.03],[1.483,13.33],[1.605,5.211],[1.635,2.605],[1.693,0]],"totImpulseNs":36.32,"totalWeightG":70.7,"type":"SU","updatedOn":"2022-11-02"},{"availability":"regular","avgThrustN":55.22,"burnTimeS":1.41,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"F67","dataFiles":1,"delays":"6,9,14","designation":"F67C","diameter":29,"impulseClass":"F","length":112,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":72.79,"motorId":"63628d72a244550004a0cf0a","propInfo":"Classic","propWeightG":36.8,"samples":[[0,0],[0.009,0.892],[0.024,3.569],[0.033,20.22],[0.042,43.72],[0.055,57.1],[0.075,61.56],[0.104,58.88],[0.126,60.07],[0.157,58.88],[0.261,60.67],[0.402,61.56],[0.544,61.26],[0.659,60.67],[0.683,63.64],[0.692,68.7],[0.703,60.07],[0.776,59.78],[0.91,58.88],[1.006,58.29],[1.096,57.1],[1.167,57.1],[1.211,56.8],[1.269,51.15],[1.308,44.02],[1.333,33.9],[1.344,22.3],[1.364,13.09],[1.406,5.353],[1.456,0]],"totImpulseNs":77.46,"totalWeightG":85.7,"type":"SU","updatedOn":"2022-11-03"},{"availability":"regular","avgThrustN":62.54,"burnTimeS":23.1,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"K62","dataFiles":1,"delays":"P","designation":"K62N","diameter":54,"impulseClass":"K","length":274,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":258.7,"motorId":"63bb643e1d26f30004b4b077","propInfo":"Warp 9","propWeightG":831,"samples":[[0,0],[0.05,11.39],[0.126,215.9],[0.353,252],[0.505,235.2],[0.681,104.5],[1.236,83.68],[4.087,67.84],[6.534,65.36],[8.401,64.87],[11.63,60.91],[15.29,54.96],[19.4,48.03],[21.24,45.55],[21.47,20.3],[21.87,0]],"totImpulseNs":1439,"totalWeightG":1277,"type":"SU","updatedOn":"2023-01-09"},{"availability":"regular","avgThrustN":1261,"burnTimeS":0.85,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"J1265","dataFiles":1,"delays":"6,8,10,12,14","designation":"J1265T","diameter":54,"impulseClass":"J","length":397,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":1745,"motorId":"63bb65281d26f30004b4b07b","propInfo":"Super Thunder","propWeightG":507,"samples":[[0,0],[0.021,33.53],[0.026,223.5],[0.031,652],[0.04,1568],[0.053,1412],[0.07,1330],[0.092,1308],[0.201,1349],[0.332,1382],[0.444,1397],[0.556,1367],[0.644,1267],[0.715,1177],[0.739,1174],[0.76,1196],[0.779,1270],[0.799,1282],[0.812,1159],[0.827,853.1],[0.844,499.2],[0.853,316.7],[0.868,130.4],[0.885,40.98],[0.902,0]],"totImpulseNs":1073,"totalWeightG":1095,"type":"SU","updatedOn":"2023-01-09"},{"availability":"regular","avgThrustN":2239,"burnTimeS":2.32,"caseInfo":"RMS-75/5120","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"M2225","dataFiles":1,"delays":"P","designation":"M2225WS","diameter":75,"impulseClass":"M","length":692,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":2418,"motorId":"63bb66061d26f30004b4b07e","propInfo":"Super White Lightning","propWeightG":2331,"samples":[[0,0],[0.018,39.69],[0.037,1359],[0.05,2143],[0.089,2257],[0.129,2351],[0.176,2014],[0.205,2004],[0.265,2262],[0.756,2371],[1.333,2391],[1.797,2327],[2.03,2292],[2.164,2282],[2.272,1161],[2.303,580.4],[2.335,208.4],[2.356,94.26],[2.385,9.922],[2.408,0]],"totImpulseNs":5205,"totalWeightG":4695,"type":"reload","updatedOn":"2023-01-09"},{"availability":"regular","avgThrustN":3906,"burnTimeS":4.65,"caseInfo":"RMS-98/20480","certOrg":"Tripoli Rocketry Association, Inc.","commonName":"N4000","dataFiles":1,"delays":"P","designation":"N4000W-PS","diameter":98,"impulseClass":"N","length":1433,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":5398,"motorId":"645072a02cdedd00028df82d","propInfo":"White Lightning","propWeightG":9800,"samples":[[0,0],[0.01,39.37],[0.029,393.7],[0.03,1742],[0.031,2210],[0.039,2874],[0.049,2534],[0.05,3469],[0.06,3809],[0.07,4080],[0.078,4242],[0.088,4385],[0.12,4331],[0.148,4227],[0.247,4242],[0.398,4296],[0.577,4350],[0.774,4439],[0.964,4513],[1.172,4567],[1.341,4621],[1.51,4621],[1.661,4656],[1.837,4675],[2.027,4710],[2.157,4729],[2.295,4749],[2.336,4749],[2.505,4695],[2.633,4656],[2.794,4547],[2.97,4478],[3.131,4385],[3.3,4316],[3.449,4262],[3.547,4262],[3.607,4208],[3.708,3720],[3.825,2894],[3.927,2446],[4.054,2156],[4.205,1850],[4.314,1471],[4.394,1097],[4.462,841.5],[4.511,698.8],[4.631,521.7],[4.761,265.7],[4.854,123],[4.906,0]],"totImpulseNs":18180,"totalWeightG":16380,"type":"reload","updatedOn":"2023-05-02"},{"availability":"regular","avgThrustN":13.21,"burnTimeS":18.26,"certOrg":"Tripoli Rocketry Association, Inc.","commonName":"H14","dataFiles":1,"delays":"P","designation":"H14ST","diameter":29,"impulseClass":"H","length":240,"manufacturer":"AeroTech","manufacturerAbbrev":"AeroTech","maxThrustN":42.13,"motorId":"6457b5ce8cd35f00024615fc","propInfo":"Super Thunder","propWeightG":134,"samples":[[0,0],[0.045,32.28],[0.253,37.1],[0.343,40.25],[0.417,19.5],[0.625,16.95],[1.787,14.54],[3.946,13.66],[7.029,13],[11.84,12.78],[15.44,12.34],[16.37,12.05],[16.52,11.76],[16.57,10.66],[16.83,10.96],[17.23,11.32],[17.59,12.2],[17.74,10.59],[17.96,0]],"totImpulseNs":240.1,"totalWeightG":230,"type":"SU","updatedOn":"2023-05-07"}]');





parcelRequire("8T3gX");


parcelRequire("8T3gX");


var $8T3gX = parcelRequire("8T3gX");

var $4920d08df73f1c44$exports = {};
"use strict";
Object.defineProperty($4920d08df73f1c44$exports, "__esModule", {
    value: true
});
Object.defineProperty($4920d08df73f1c44$exports, "LinkContainer", {
    enumerable: true,
    get: function get() {
        return $4920d08df73f1c44$var$_LinkContainer["default"];
    }
});

var $4920d08df73f1c44$var$_LinkContainer = $4920d08df73f1c44$var$_interopRequireDefault((parcelRequire("8Gg0l")));
function $4920d08df73f1c44$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}



var $fIsAN = parcelRequire("fIsAN");
function $a147a5343133f2a5$export$5cae361ad82dce8b(value) {
    const ref = (0, $8T3gX.useRef)();
    (0, $8T3gX.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}
function $a147a5343133f2a5$export$1343a74baacb0543(...args) {
    const classes = new Set();
    for (const arg of args){
        if (!arg) continue;
        else if (typeof arg === "string") for (const cn of arg.split(/\s+/g))classes.add(cn);
        else if (typeof arg === "object") {
            for (const [k, v] of Object.entries(arg))if (v) classes.add(k);
            else classes.delete(k);
        }
    }
    return Array.from(classes).join(" ");
}
function $a147a5343133f2a5$export$669f6ea7d267feaf({ wat: wat , ...props }) {
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
        className: "busy",
        style: {
            fontSize: "1.3rem",
            fontWeight: "bold",
            opacity: 0.3,
            textAlign: "center"
        },
        ...props,
        children: [
            "Loading ",
            wat
        ]
    });
}
function $a147a5343133f2a5$export$a2a4245643e0242b({ launchId: launchId  }) {
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $fIsAN.Link), {
        to: `/launches/${launchId}/profile`,
        children: "Profile Page"
    });
}
function $a147a5343133f2a5$export$29d11c0fe2fc51d8({ to: to , isActive: isActive , children: children , ...props }) {
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $4920d08df73f1c44$exports.LinkContainer), {
        to: to,
        isActive: isActive,
        children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
            ...props,
            children: children
        })
    });
}
function $a147a5343133f2a5$export$95dc765ca5d5cc35(target, p) {
    // Allow null targets because refs can be undefined and it's annoying having to check for that case
    if (target) {
        const busyId = Math.random();
        target._busyId = busyId;
        // Start busy animation
        target.classList.toggle("busy", true);
        // Stop busy animation when promise settles
        p.finally(()=>{
            if (target?._busyId !== busyId) return;
            target.classList.toggle("busy", false);
        });
    }
    return p;
}
function $a147a5343133f2a5$export$a81eda11c790c16(val, digits = 3) {
    if (!isFinite(val)) return String(val);
    if (val === 0) return "0";
    const isNegative = val < 0;
    if (isNegative) val = -val;
    const man = digits - Math.ceil(Math.log10(val));
    if (man > 0) val = Math.round(val * 10 ** man) / 10 ** man;
    else val = Math.round(val);
    return String(isNegative ? -val : val);
}


var $5d0f971b61a5e3de$exports = {};

$parcel$export($5d0f971b61a5e3de$exports, "root", () => $5d0f971b61a5e3de$export$e8e78c978b129247, (v) => $5d0f971b61a5e3de$export$e8e78c978b129247 = v);
$parcel$export($5d0f971b61a5e3de$exports, "textBottom", () => $5d0f971b61a5e3de$export$1d1fd657949651e, (v) => $5d0f971b61a5e3de$export$1d1fd657949651e = v);
$parcel$export($5d0f971b61a5e3de$exports, "textTop", () => $5d0f971b61a5e3de$export$10808a42a8bcfff0, (v) => $5d0f971b61a5e3de$export$10808a42a8bcfff0 = v);
var $5d0f971b61a5e3de$export$e8e78c978b129247;
var $5d0f971b61a5e3de$export$1d1fd657949651e;
var $5d0f971b61a5e3de$export$10808a42a8bcfff0;
$5d0f971b61a5e3de$export$e8e78c978b129247 = `AvXmQW_root`;
$5d0f971b61a5e3de$export$1d1fd657949651e = `AvXmQW_textBottom`;
$5d0f971b61a5e3de$export$10808a42a8bcfff0 = `AvXmQW_textTop`;


var $e5134f87d92b196b$exports = {};

$e5134f87d92b196b$exports = new URL((parcelRequire("bCIFA")).resolve("iib0x"), import.meta.url).toString();


var $34d01c052e43b9cc$exports = {};

$34d01c052e43b9cc$exports = new URL((parcelRequire("bCIFA")).resolve("eieXy"), import.meta.url).toString();


var $7c0789c43eea654c$exports = {};

$7c0789c43eea654c$exports = new URL((parcelRequire("bCIFA")).resolve("dBCrV"), import.meta.url).toString();


function $de9ec3fa47e50b10$export$aefd2927936d3a35({ meme: meme , topText: topText , bottomText: bottomText , className: className , ...props }) {
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
        className: (0, $a147a5343133f2a5$export$1343a74baacb0543)((0, (/*@__PURE__*/$parcel$interopDefault($5d0f971b61a5e3de$exports))).root, className),
        ...props,
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("img", {
                src: meme
            }),
            topText ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                className: (0, $a147a5343133f2a5$export$1343a74baacb0543)((0, (/*@__PURE__*/$parcel$interopDefault($5d0f971b61a5e3de$exports))).textTop, "no-invert"),
                children: topText
            }) : null,
            bottomText ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                className: (0, $a147a5343133f2a5$export$1343a74baacb0543)((0, (/*@__PURE__*/$parcel$interopDefault($5d0f971b61a5e3de$exports))).textBottom, "no-invert"),
                children: bottomText
            }) : null
        ]
    });
}



var $8T3gX = parcelRequire("8T3gX");



var $8T3gX = parcelRequire("8T3gX");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");




var $8T3gX = parcelRequire("8T3gX");


var $3T949 = parcelRequire("3T949");






var $8T3gX = parcelRequire("8T3gX");


var $fdGrT = parcelRequire("fdGrT");

var $8T3gX = parcelRequire("8T3gX");


var $8T3gX = parcelRequire("8T3gX");


var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

const $a97ca13c649814b9$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
};
const $a97ca13c649814b9$var$Feedback = /*#__PURE__*/ $8T3gX.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ as: Component = "div" , className: className , type: type = "valid" , tooltip: tooltip = false , ...props }, ref)=>/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, `${type}-${tooltip ? "tooltip" : "feedback"}`)
    }));
$a97ca13c649814b9$var$Feedback.displayName = "Feedback";
$a97ca13c649814b9$var$Feedback.propTypes = $a97ca13c649814b9$var$propTypes;
var $a97ca13c649814b9$export$2e2bcd8739ae039 = $a97ca13c649814b9$var$Feedback;




var $8T3gX = parcelRequire("8T3gX");

var $8T3gX = parcelRequire("8T3gX");
// TODO
const $a68f7ccb6a484b38$var$FormContext = /*#__PURE__*/ $8T3gX.createContext({});
var $a68f7ccb6a484b38$export$2e2bcd8739ae039 = $a68f7ccb6a484b38$var$FormContext;




const $2c3d5fdd53da47aa$var$FormCheckInput = /*#__PURE__*/ $8T3gX.forwardRef(({ id: id , bsPrefix: bsPrefix , className: className , type: type = "checkbox" , isValid: isValid = false , isInvalid: isInvalid = false , // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "input" , ...props }, ref)=>{
    const { controlId: controlId  } = (0, $8T3gX.useContext)((0, $a68f7ccb6a484b38$export$2e2bcd8739ae039));
    bsPrefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, "form-check-input");
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(Component, {
        ...props,
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, bsPrefix, isValid && "is-valid", isInvalid && "is-invalid")
    });
});
$2c3d5fdd53da47aa$var$FormCheckInput.displayName = "FormCheckInput";
var $2c3d5fdd53da47aa$export$2e2bcd8739ae039 = $2c3d5fdd53da47aa$var$FormCheckInput;




var $8T3gX = parcelRequire("8T3gX");



const $0d5bf5d912ac7f01$var$FormCheckLabel = /*#__PURE__*/ $8T3gX.forwardRef(({ bsPrefix: bsPrefix , className: className , htmlFor: htmlFor , ...props }, ref)=>{
    const { controlId: controlId  } = (0, $8T3gX.useContext)((0, $a68f7ccb6a484b38$export$2e2bcd8739ae039));
    bsPrefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, "form-check-label");
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("label", {
        ...props,
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, bsPrefix)
    });
});
$0d5bf5d912ac7f01$var$FormCheckLabel.displayName = "FormCheckLabel";
var $0d5bf5d912ac7f01$export$2e2bcd8739ae039 = $0d5bf5d912ac7f01$var$FormCheckLabel;





var $8T3gX = parcelRequire("8T3gX");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $12dab14d68f3cfa3$export$871de8747c9eaa88(children, func) {
    let index = 0;
    return $8T3gX.Children.map(children, (child)=>/*#__PURE__*/ $8T3gX.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $12dab14d68f3cfa3$export$4b80e395e36b5a56(children, func) {
    let index = 0;
    $8T3gX.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ $8T3gX.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $12dab14d68f3cfa3$export$500fd6099226ffae(children, type) {
    return $8T3gX.Children.toArray(children).some((child)=>/*#__PURE__*/ $8T3gX.isValidElement(child) && child.type === type);
}



const $83308372aa460c63$var$FormCheck = /*#__PURE__*/ $8T3gX.forwardRef(({ id: id , bsPrefix: bsPrefix , bsSwitchPrefix: bsSwitchPrefix , inline: inline = false , reverse: reverse = false , disabled: disabled = false , isValid: isValid = false , isInvalid: isInvalid = false , feedbackTooltip: feedbackTooltip = false , feedback: feedback , feedbackType: feedbackType , className: className , style: style , title: title = "" , type: type = "checkbox" , label: label , children: children , as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as = "input" , ...props }, ref)=>{
    bsPrefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, "form-check");
    bsSwitchPrefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsSwitchPrefix, "form-switch");
    const { controlId: controlId  } = (0, $8T3gX.useContext)((0, $a68f7ccb6a484b38$export$2e2bcd8739ae039));
    const innerFormContext = (0, $8T3gX.useMemo)(()=>({
            controlId: id || controlId
        }), [
        controlId,
        id
    ]);
    const hasLabel = !children && label != null && label !== false || (0, $12dab14d68f3cfa3$export$500fd6099226ffae)(children, (0, $0d5bf5d912ac7f01$export$2e2bcd8739ae039));
    const input = /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $2c3d5fdd53da47aa$export$2e2bcd8739ae039), {
        ...props,
        type: type === "switch" ? "checkbox" : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    });
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a68f7ccb6a484b38$export$2e2bcd8739ae039).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
            style: style,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, reverse && `${bsPrefix}-reverse`, type === "switch" && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $0d5bf5d912ac7f01$export$2e2bcd8739ae039), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a97ca13c649814b9$export$2e2bcd8739ae039), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
$83308372aa460c63$var$FormCheck.displayName = "FormCheck";
var $83308372aa460c63$export$2e2bcd8739ae039 = Object.assign($83308372aa460c63$var$FormCheck, {
    Input: (0, $2c3d5fdd53da47aa$export$2e2bcd8739ae039),
    Label: (0, $0d5bf5d912ac7f01$export$2e2bcd8739ae039)
});




var $8T3gX = parcelRequire("8T3gX");
var $92516aba702b0605$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $92516aba702b0605$var$__DEV__ = false;
var $92516aba702b0605$var$warning = function() {};
if ($92516aba702b0605$var$__DEV__) {
    var $92516aba702b0605$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $92516aba702b0605$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $92516aba702b0605$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$92516aba702b0605$exports = $92516aba702b0605$var$warning;






const $3cbbbccf21b5ea21$var$FormControl = /*#__PURE__*/ $8T3gX.forwardRef(({ bsPrefix: bsPrefix , type: type , size: size , htmlSize: htmlSize , id: id , className: className , isValid: isValid = false , isInvalid: isInvalid = false , plaintext: plaintext , readOnly: readOnly , // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "input" , ...props }, ref)=>{
    const { controlId: controlId  } = (0, $8T3gX.useContext)((0, $a68f7ccb6a484b38$export$2e2bcd8739ae039));
    bsPrefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, "form-control");
    let classes;
    if (plaintext) classes = {
        [`${bsPrefix}-plaintext`]: true
    };
    else classes = {
        [bsPrefix]: true,
        [`${bsPrefix}-${size}`]: size
    };
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(Component, {
        ...props,
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, classes, isValid && `is-valid`, isInvalid && `is-invalid`, type === "color" && `${bsPrefix}-color`)
    });
});
$3cbbbccf21b5ea21$var$FormControl.displayName = "FormControl";
var $3cbbbccf21b5ea21$export$2e2bcd8739ae039 = Object.assign($3cbbbccf21b5ea21$var$FormControl, {
    Feedback: $a97ca13c649814b9$export$2e2bcd8739ae039
});



var $d2e39a113fa6c5b5$export$2e2bcd8739ae039 = (0, $94fe4a2899ec2691$export$2e2bcd8739ae039)("form-floating");



var $8T3gX = parcelRequire("8T3gX");


const $b92e551353436a73$var$FormGroup = /*#__PURE__*/ $8T3gX.forwardRef(({ controlId: controlId , // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div" , ...props }, ref)=>{
    const context = (0, $8T3gX.useMemo)(()=>({
            controlId: controlId
        }), [
        controlId
    ]);
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a68f7ccb6a484b38$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(Component, {
            ...props,
            ref: ref
        })
    });
});
$b92e551353436a73$var$FormGroup.displayName = "FormGroup";
var $b92e551353436a73$export$2e2bcd8739ae039 = $b92e551353436a73$var$FormGroup;




var $8T3gX = parcelRequire("8T3gX");



var $8T3gX = parcelRequire("8T3gX");


function $f6309ee0ca91acef$export$2ed43d61a0a9f5a3({ as: as , bsPrefix: bsPrefix , className: className , ...props }) {
    bsPrefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, "col");
    const breakpoints = (0, $fa98af941750c85d$export$8970c8db816a5863)();
    const minBreakpoint = (0, $fa98af941750c85d$export$d926d6ef38f3fd32)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === "object" && propValue != null) ({ span: span , offset: offset , order: order  } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : "";
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        {
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, ...spans, ...classes)
        },
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
const $f6309ee0ca91acef$var$Col = /*#__PURE__*/ $8T3gX.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const [{ className: className , ...colProps }, { as: Component = "div" , bsPrefix: bsPrefix , spans: spans  }] = $f6309ee0ca91acef$export$2ed43d61a0a9f5a3(props);
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(Component, {
        ...colProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, !spans.length && bsPrefix)
    });
});
$f6309ee0ca91acef$var$Col.displayName = "Col";
var $f6309ee0ca91acef$export$2e2bcd8739ae039 = $f6309ee0ca91acef$var$Col;





const $ce8531036202e828$var$FormLabel = /*#__PURE__*/ $8T3gX.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "label" , bsPrefix: bsPrefix , column: column = false , visuallyHidden: visuallyHidden = false , className: className , htmlFor: htmlFor , ...props }, ref)=>{
    const { controlId: controlId  } = (0, $8T3gX.useContext)((0, $a68f7ccb6a484b38$export$2e2bcd8739ae039));
    bsPrefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, "form-label");
    let columnClass = "col-form-label";
    if (typeof column === "string") columnClass = `${columnClass} ${columnClass}-${column}`;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, bsPrefix, visuallyHidden && "visually-hidden", column && columnClass);
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $f6309ee0ca91acef$export$2e2bcd8739ae039), {
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
    (0, $e9bc3aadba8432ee$exports.jsx)(Component, {
        ref: ref,
        className: classes,
        htmlFor: htmlFor,
        ...props
    }));
});
$ce8531036202e828$var$FormLabel.displayName = "FormLabel";
var $ce8531036202e828$export$2e2bcd8739ae039 = $ce8531036202e828$var$FormLabel;




var $8T3gX = parcelRequire("8T3gX");



const $14b15a2844c8ff66$var$FormRange = /*#__PURE__*/ $8T3gX.forwardRef(({ bsPrefix: bsPrefix , className: className , id: id , ...props }, ref)=>{
    const { controlId: controlId  } = (0, $8T3gX.useContext)((0, $a68f7ccb6a484b38$export$2e2bcd8739ae039));
    bsPrefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, "form-range");
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("input", {
        ...props,
        type: "range",
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, bsPrefix),
        id: id || controlId
    });
});
$14b15a2844c8ff66$var$FormRange.displayName = "FormRange";
var $14b15a2844c8ff66$export$2e2bcd8739ae039 = $14b15a2844c8ff66$var$FormRange;




var $8T3gX = parcelRequire("8T3gX");



const $e2399cea1a8ec78e$var$FormSelect = /*#__PURE__*/ $8T3gX.forwardRef(({ bsPrefix: bsPrefix , size: size , htmlSize: htmlSize , className: className , isValid: isValid = false , isInvalid: isInvalid = false , id: id , ...props }, ref)=>{
    const { controlId: controlId  } = (0, $8T3gX.useContext)((0, $a68f7ccb6a484b38$export$2e2bcd8739ae039));
    bsPrefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, "form-select");
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("select", {
        ...props,
        size: htmlSize,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
        id: id || controlId
    });
});
$e2399cea1a8ec78e$var$FormSelect.displayName = "FormSelect";
var $e2399cea1a8ec78e$export$2e2bcd8739ae039 = $e2399cea1a8ec78e$var$FormSelect;




var $8T3gX = parcelRequire("8T3gX");


const $f24fb156c4554e06$var$FormText = /*#__PURE__*/ $8T3gX.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix , className: className , as: Component = "small" , muted: muted , ...props }, ref)=>{
    bsPrefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, "form-text");
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, bsPrefix, muted && "text-muted")
    });
});
$f24fb156c4554e06$var$FormText.displayName = "FormText";
var $f24fb156c4554e06$export$2e2bcd8739ae039 = $f24fb156c4554e06$var$FormText;



var $8T3gX = parcelRequire("8T3gX");


const $c46a48026e4ee985$var$Switch = /*#__PURE__*/ $8T3gX.forwardRef((props, ref)=>/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $83308372aa460c63$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        type: "switch"
    }));
$c46a48026e4ee985$var$Switch.displayName = "Switch";
var $c46a48026e4ee985$export$2e2bcd8739ae039 = Object.assign($c46a48026e4ee985$var$Switch, {
    Input: (0, $83308372aa460c63$export$2e2bcd8739ae039).Input,
    Label: (0, $83308372aa460c63$export$2e2bcd8739ae039).Label
});




var $8T3gX = parcelRequire("8T3gX");



const $be4ca9442e43e12e$var$FloatingLabel = /*#__PURE__*/ $8T3gX.forwardRef(({ bsPrefix: bsPrefix , className: className , children: children , controlId: controlId , label: label , ...props }, ref)=>{
    bsPrefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, "form-floating");
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $b92e551353436a73$export$2e2bcd8739ae039), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, bsPrefix),
        controlId: controlId,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    });
});
$be4ca9442e43e12e$var$FloatingLabel.displayName = "FloatingLabel";
var $be4ca9442e43e12e$export$2e2bcd8739ae039 = $be4ca9442e43e12e$var$FloatingLabel;



const $82743675752b4983$var$propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
};
const $82743675752b4983$var$Form = /*#__PURE__*/ $8T3gX.forwardRef(({ className: className , validated: validated , // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "form" , ...props }, ref)=>/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, validated && "was-validated")
    }));
$82743675752b4983$var$Form.displayName = "Form";
$82743675752b4983$var$Form.propTypes = $82743675752b4983$var$propTypes;
var $82743675752b4983$export$2e2bcd8739ae039 = Object.assign($82743675752b4983$var$Form, {
    Group: (0, $b92e551353436a73$export$2e2bcd8739ae039),
    Control: (0, $3cbbbccf21b5ea21$export$2e2bcd8739ae039),
    Floating: (0, $d2e39a113fa6c5b5$export$2e2bcd8739ae039),
    Check: (0, $83308372aa460c63$export$2e2bcd8739ae039),
    Switch: $c46a48026e4ee985$export$2e2bcd8739ae039,
    Label: (0, $ce8531036202e828$export$2e2bcd8739ae039),
    Text: (0, $f24fb156c4554e06$export$2e2bcd8739ae039),
    Range: (0, $14b15a2844c8ff66$export$2e2bcd8739ae039),
    Select: (0, $e2399cea1a8ec78e$export$2e2bcd8739ae039),
    FloatingLabel: $be4ca9442e43e12e$export$2e2bcd8739ae039
});







var $395af1e4f91abdee$var$size;
function $395af1e4f91abdee$export$2e2bcd8739ae039(recalc) {
    if (!$395af1e4f91abdee$var$size && $395af1e4f91abdee$var$size !== 0 || recalc) {
        if (0, $5d1f306240459aa4$export$2e2bcd8739ae039) {
            var scrollDiv = document.createElement("div");
            scrollDiv.style.position = "absolute";
            scrollDiv.style.top = "-9999px";
            scrollDiv.style.width = "50px";
            scrollDiv.style.height = "50px";
            scrollDiv.style.overflow = "scroll";
            document.body.appendChild(scrollDiv);
            $395af1e4f91abdee$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $395af1e4f91abdee$var$size;
}






var $8T3gX = parcelRequire("8T3gX");
function $09997b88f810936f$export$2e2bcd8739ae039(value) {
    var valueRef = (0, $8T3gX.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $8T3gX = parcelRequire("8T3gX");
function $8dfbb7dc191a638c$export$2e2bcd8739ae039(fn) {
    var onUnmount = (0, $09997b88f810936f$export$2e2bcd8739ae039)(fn);
    (0, $8T3gX.useEffect)(function() {
        return function() {
            return onUnmount.current();
        };
    }, []);
}




var $8T3gX = parcelRequire("8T3gX");

function $8ff1df79ce818238$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $c65895a0e633f08a$export$2e2bcd8739ae039)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $71197f4b39f3f1c6$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}





var $8T3gX = parcelRequire("8T3gX");






const $a963951f5e3bf39d$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $a963951f5e3bf39d$export$635202801f9383a0 = `rrUi`;
function $a963951f5e3bf39d$export$5cc3b7b83e34ade7(property) {
    return `${$a963951f5e3bf39d$export$fd7bcb7e9bef4e8a}${property}`;
}
function $a963951f5e3bf39d$export$7776c0a7cd2eb3e0(property) {
    return `${$a963951f5e3bf39d$export$635202801f9383a0}${property}`;
}


/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $7034e4a3583633db$export$2e2bcd8739ae039(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}


const $600aa6b5809a412d$export$1a88c12b8b979fa0 = (0, $a963951f5e3bf39d$export$5cc3b7b83e34ade7)("modal-open");
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class $600aa6b5809a412d$var$ModalManager {
    constructor({ ownerDocument: ownerDocument , handleContainerOverflow: handleContainerOverflow = true , isRTL: isRTL = false  } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
    getScrollbarWidth() {
        return (0, $7034e4a3583633db$export$2e2bcd8739ae039)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: "hidden"
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, $cefc685938ef1085$export$2e2bcd8739ae039)(container, paddingProp) || "0", 10) + containerState.scrollBarWidth}px`;
        container.setAttribute($600aa6b5809a412d$export$1a88c12b8b979fa0, "");
        (0, $cefc685938ef1085$export$2e2bcd8739ae039)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute($600aa6b5809a412d$export$1a88c12b8b979fa0);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
}
var $600aa6b5809a412d$export$2e2bcd8739ae039 = $600aa6b5809a412d$var$ModalManager;





var $8T3gX = parcelRequire("8T3gX");

var $8T3gX = parcelRequire("8T3gX");

const $bf212d0c8c14474d$var$Context = /*#__PURE__*/ (0, $8T3gX.createContext)((0, $5d1f306240459aa4$export$2e2bcd8739ae039) ? window : undefined);
const $bf212d0c8c14474d$export$f7d306aeb1cf5fbc = $bf212d0c8c14474d$var$Context.Provider;
function $bf212d0c8c14474d$export$2e2bcd8739ae039() {
    return (0, $8T3gX.useContext)($bf212d0c8c14474d$var$Context);
}


const $05dd3be43cf33371$export$c91fd81e6d65f84a = (ref, document)=>{
    if (!(0, $5d1f306240459aa4$export$2e2bcd8739ae039)) return null;
    if (ref == null) return (document || (0, $c65895a0e633f08a$export$2e2bcd8739ae039)()).body;
    if (typeof ref === "function") ref = ref();
    if (ref && "current" in ref) ref = ref.current;
    if (ref && ("nodeType" in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $05dd3be43cf33371$export$2e2bcd8739ae039(ref, onResolved) {
    const window = (0, $bf212d0c8c14474d$export$2e2bcd8739ae039)();
    const [resolvedRef, setRef] = (0, $8T3gX.useState)(()=>$05dd3be43cf33371$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = $05dd3be43cf33371$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $8T3gX.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $8T3gX.useEffect)(()=>{
        const nextRef = $05dd3be43cf33371$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}







var $8T3gX = parcelRequire("8T3gX");



var $8T3gX = parcelRequire("8T3gX");
function $a77217c687a4b5e8$var$NoopTransition({ children: children , in: inProp , onExited: onExited , mountOnEnter: mountOnEnter , unmountOnExit: unmountOnExit  }) {
    const ref = (0, $8T3gX.useRef)(null);
    const hasEnteredRef = (0, $8T3gX.useRef)(inProp);
    const handleExited = (0, $47b6b666cdb493de$export$2e2bcd8739ae039)(onExited);
    (0, $8T3gX.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, $3334d009365bf881$export$2e2bcd8739ae039)(ref, children.ref);
    const child = /*#__PURE__*/ (0, $8T3gX.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $a77217c687a4b5e8$export$2e2bcd8739ae039 = $a77217c687a4b5e8$var$NoopTransition;



function $49c5b0ce18499838$export$7b286972b8d8ccbf({ in: inProp , onTransition: onTransition  }) {
    const ref = (0, $8T3gX.useRef)(null);
    const isInitialRef = (0, $8T3gX.useRef)(true);
    const handleTransition = (0, $47b6b666cdb493de$export$2e2bcd8739ae039)(onTransition);
    (0, $92e18d6cf48ef440$export$2e2bcd8739ae039)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $92e18d6cf48ef440$export$2e2bcd8739ae039)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $49c5b0ce18499838$export$2e2bcd8739ae039({ children: children , in: inProp , onExited: onExited , onEntered: onEntered , transition: transition  }) {
    const [exited, setExited] = (0, $8T3gX.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = $49c5b0ce18499838$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, $3334d009365bf881$export$2e2bcd8739ae039)(ref, children.ref);
    return exited && !inProp ? null : /*#__PURE__*/ (0, $8T3gX.cloneElement)(children, {
        ref: combinedRef
    });
}
function $49c5b0ce18499838$export$f41d64aae6d6dba5(Component, runTransition, props) {
    if (Component) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(Component, Object.assign({}, props));
    if (runTransition) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)($49c5b0ce18499838$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a77217c687a4b5e8$export$2e2bcd8739ae039), Object.assign({}, props));
}


/* eslint-disable import/prefer-default-export */ function $182f794ec21d2701$export$806fcc22e55e107d(e) {
    return e.code === "Escape" || e.keyCode === 27;
}



const $9e490e809df060ee$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $9e490e809df060ee$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
let $9e490e809df060ee$var$manager;
function $9e490e809df060ee$var$getManager(window) {
    if (!$9e490e809df060ee$var$manager) $9e490e809df060ee$var$manager = new (0, $600aa6b5809a412d$export$2e2bcd8739ae039)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $9e490e809df060ee$var$manager;
}
function $9e490e809df060ee$var$useModalManager(provided) {
    const window = (0, $bf212d0c8c14474d$export$2e2bcd8739ae039)();
    const modalManager = provided || $9e490e809df060ee$var$getManager(window);
    const modal = (0, $8T3gX.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, $8T3gX.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $8T3gX.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const $9e490e809df060ee$var$Modal = /*#__PURE__*/ (0, $8T3gX.forwardRef)((_ref, ref)=>{
    let { show: show = false , role: role = "dialog" , className: className , style: style , children: children , backdrop: backdrop = true , keyboard: keyboard = true , onBackdropClick: onBackdropClick , onEscapeKeyDown: onEscapeKeyDown , transition: transition , runTransition: runTransition , backdropTransition: backdropTransition , runBackdropTransition: runBackdropTransition , autoFocus: autoFocus = true , enforceFocus: enforceFocus = true , restoreFocus: restoreFocus = true , restoreFocusOptions: restoreFocusOptions , renderDialog: renderDialog , renderBackdrop: renderBackdrop = (props)=>/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", Object.assign({}, props)) , manager: providedManager , container: containerRef , onShow: onShow , onHide: onHide = ()=>{} , onExit: onExit , onExited: onExited , onExiting: onExiting , onEnter: onEnter , onEntering: onEntering , onEntered: onEntered  } = _ref, rest = $9e490e809df060ee$var$_objectWithoutPropertiesLoose(_ref, $9e490e809df060ee$var$_excluded);
    const ownerWindow = (0, $bf212d0c8c14474d$export$2e2bcd8739ae039)();
    const container = (0, $05dd3be43cf33371$export$2e2bcd8739ae039)(containerRef);
    const modal = $9e490e809df060ee$var$useModalManager(providedManager);
    const isMounted = (0, $53f0b42aae35fa6f$export$2e2bcd8739ae039)();
    const prevShow = (0, $9a92a54037561a3a$export$2e2bcd8739ae039)(show);
    const [exited, setExited] = (0, $8T3gX.useState)(!show);
    const lastFocusRef = (0, $8T3gX.useRef)(null);
    (0, $8T3gX.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, $5d1f306240459aa4$export$2e2bcd8739ae039) && !prevShow && show) lastFocusRef.current = (0, $8ff1df79ce818238$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, $47b6b666cdb493de$export$2e2bcd8739ae039)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, $79ee32458d0e6378$export$2e2bcd8739ae039)(document, "keydown", handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $79ee32458d0e6378$export$2e2bcd8739ae039)(document, "focus", // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            const currentActiveElement = (0, $8ff1df79ce818238$export$2e2bcd8739ae039)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, $71197f4b39f3f1c6$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, $47b6b666cdb493de$export$2e2bcd8739ae039)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $8T3gX.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $8T3gX.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $8dfbb7dc191a638c$export$2e2bcd8739ae039)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, $47b6b666cdb493de$export$2e2bcd8739ae039)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, $8ff1df79ce818238$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, $71197f4b39f3f1c6$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, $47b6b666cdb493de$export$2e2bcd8739ae039)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, $47b6b666cdb493de$export$2e2bcd8739ae039)((e)=>{
        if (keyboard && (0, $182f794ec21d2701$export$806fcc22e55e107d)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, $8T3gX.useRef)();
    const removeKeydownListenerRef = (0, $8T3gX.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        "aria-modal": role === "dialog" ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $8T3gX.cloneElement(children, {
            role: "document"
        })
    }));
    dialog = (0, $49c5b0ce18499838$export$f41d64aae6d6dba5)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $49c5b0ce18499838$export$f41d64aae6d6dba5)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $e9bc3aadba8432ee$exports.Fragment), {
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($680cb73086b60533$exports))).createPortal(/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$9e490e809df060ee$var$Modal.displayName = "Modal";
var $9e490e809df060ee$export$2e2bcd8739ae039 = Object.assign($9e490e809df060ee$var$Modal, {
    Manager: (0, $600aa6b5809a412d$export$2e2bcd8739ae039)
});


/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $fbb8aa1191db27dc$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $f578d18afcfa4e57$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $fbb8aa1191db27dc$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}



var $a6d31758637e51b3$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $a6d31758637e51b3$export$2e2bcd8739ae039(element, selector) {
    return $a6d31758637e51b3$var$toArray(element.querySelectorAll(selector));
}


function $beeac6f743a527fd$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $beeac6f743a527fd$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $beeac6f743a527fd$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $beeac6f743a527fd$var$replaceClassName(element.className && element.className.baseVal || "", className));
}



const $a5528457b47db029$var$Selector = {
    FIXED_CONTENT: ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",
    STICKY_CONTENT: ".sticky-top",
    NAVBAR_TOGGLER: ".navbar-toggler"
};
class $a5528457b47db029$var$BootstrapModalManager extends (0, $600aa6b5809a412d$export$2e2bcd8739ae039) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        // @ts-ignore
        element.dataset[prop] = actual;
        (0, $cefc685938ef1085$export$2e2bcd8739ae039)(element, {
            [prop]: `${parseFloat((0, $cefc685938ef1085$export$2e2bcd8739ae039)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, $cefc685938ef1085$export$2e2bcd8739ae039)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, $f578d18afcfa4e57$export$2e2bcd8739ae039)(container, "modal-open");
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
        const marginProp = this.isRTL ? "marginLeft" : "marginRight";
        (0, $a6d31758637e51b3$export$2e2bcd8739ae039)(container, $a5528457b47db029$var$Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, $a6d31758637e51b3$export$2e2bcd8739ae039)(container, $a5528457b47db029$var$Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, $a6d31758637e51b3$export$2e2bcd8739ae039)(container, $a5528457b47db029$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, $beeac6f743a527fd$export$2e2bcd8739ae039)(container, "modal-open");
        const paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
        const marginProp = this.isRTL ? "marginLeft" : "marginRight";
        (0, $a6d31758637e51b3$export$2e2bcd8739ae039)(container, $a5528457b47db029$var$Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, $a6d31758637e51b3$export$2e2bcd8739ae039)(container, $a5528457b47db029$var$Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, $a6d31758637e51b3$export$2e2bcd8739ae039)(container, $a5528457b47db029$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let $a5528457b47db029$var$sharedManager;
function $a5528457b47db029$export$a03641438014b436(options) {
    if (!$a5528457b47db029$var$sharedManager) $a5528457b47db029$var$sharedManager = new $a5528457b47db029$var$BootstrapModalManager(options);
    return $a5528457b47db029$var$sharedManager;
}
var $a5528457b47db029$export$2e2bcd8739ae039 = $a5528457b47db029$var$BootstrapModalManager;




var $5add438351379290$export$2e2bcd8739ae039 = (0, $94fe4a2899ec2691$export$2e2bcd8739ae039)("modal-body");



var $8T3gX = parcelRequire("8T3gX");
const $b373b5e0423f0924$var$ModalContext = /*#__PURE__*/ $8T3gX.createContext({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onHide () {}
});
var $b373b5e0423f0924$export$2e2bcd8739ae039 = $b373b5e0423f0924$var$ModalContext;




var $8T3gX = parcelRequire("8T3gX");


const $ec1d1702b246874a$var$ModalDialog = /*#__PURE__*/ $8T3gX.forwardRef(({ bsPrefix: bsPrefix , className: className , contentClassName: contentClassName , centered: centered , size: size , fullscreen: fullscreen , children: children , scrollable: scrollable , ...props }, ref)=>{
    bsPrefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, "modal");
    const dialogClass = `${bsPrefix}-dialog`;
    const fullScreenClass = typeof fullscreen === "string" ? `${bsPrefix}-fullscreen-${fullscreen}` : `${bsPrefix}-fullscreen`;
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(dialogClass, className, size && `${bsPrefix}-${size}`, centered && `${dialogClass}-centered`, scrollable && `${dialogClass}-scrollable`, fullscreen && fullScreenClass),
        children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(`${bsPrefix}-content`, contentClassName),
            children: children
        })
    });
});
$ec1d1702b246874a$var$ModalDialog.displayName = "ModalDialog";
var $ec1d1702b246874a$export$2e2bcd8739ae039 = $ec1d1702b246874a$var$ModalDialog;



var $bd98f9adf3eb6452$export$2e2bcd8739ae039 = (0, $94fe4a2899ec2691$export$2e2bcd8739ae039)("modal-footer");




var $8T3gX = parcelRequire("8T3gX");


var $8T3gX = parcelRequire("8T3gX");




const $12e6cf7b31b2a1d0$var$AbstractModalHeader = /*#__PURE__*/ $8T3gX.forwardRef(({ closeLabel: closeLabel = "Close" , closeVariant: closeVariant , closeButton: closeButton = false , onHide: onHide , children: children , ...props }, ref)=>{
    const context = (0, $8T3gX.useContext)((0, $b373b5e0423f0924$export$2e2bcd8739ae039));
    const handleClick = (0, $47b6b666cdb493de$export$2e2bcd8739ae039)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
        ref: ref,
        ...props,
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $8dfc29fc92784a3c$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    });
});
var $12e6cf7b31b2a1d0$export$2e2bcd8739ae039 = $12e6cf7b31b2a1d0$var$AbstractModalHeader;



const $f1176ffd272d42c9$var$ModalHeader = /*#__PURE__*/ $8T3gX.forwardRef(({ bsPrefix: bsPrefix , className: className , closeLabel: closeLabel = "Close" , closeButton: closeButton = false , ...props }, ref)=>{
    bsPrefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, "modal-header");
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $12e6cf7b31b2a1d0$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$f1176ffd272d42c9$var$ModalHeader.displayName = "ModalHeader";
var $f1176ffd272d42c9$export$2e2bcd8739ae039 = $f1176ffd272d42c9$var$ModalHeader;




const $cdbbd1435d7aa227$var$DivStyledAsH4 = (0, $87aacb5e98a57b39$export$2e2bcd8739ae039)("h4");
var $cdbbd1435d7aa227$export$2e2bcd8739ae039 = (0, $94fe4a2899ec2691$export$2e2bcd8739ae039)("modal-title", {
    Component: $cdbbd1435d7aa227$var$DivStyledAsH4
});




/* eslint-disable no-use-before-define, react/no-multi-comp */ function $dcbe90c8bc15d3fe$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $e996a38072c77732$export$2e2bcd8739ae039), {
        ...props,
        timeout: null
    });
}
function $dcbe90c8bc15d3fe$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $e996a38072c77732$export$2e2bcd8739ae039), {
        ...props,
        timeout: null
    });
}
/* eslint-enable no-use-before-define */ const $dcbe90c8bc15d3fe$var$Modal = /*#__PURE__*/ $8T3gX.forwardRef(({ bsPrefix: bsPrefix , className: className , style: style , dialogClassName: dialogClassName , contentClassName: contentClassName , children: children , dialogAs: Dialog = (0, $ec1d1702b246874a$export$2e2bcd8739ae039) , "aria-labelledby": ariaLabelledby , "aria-describedby": ariaDescribedby , "aria-label": ariaLabel , show: /* BaseModal props */ show = false , animation: animation = true , backdrop: backdrop = true , keyboard: keyboard = true , onEscapeKeyDown: onEscapeKeyDown , onShow: onShow , onHide: onHide , container: container , autoFocus: autoFocus = true , enforceFocus: enforceFocus = true , restoreFocus: restoreFocus = true , restoreFocusOptions: restoreFocusOptions , onEntered: onEntered , onExit: onExit , onExiting: onExiting , onEnter: onEnter , onEntering: onEntering , onExited: onExited , backdropClassName: backdropClassName , manager: propsManager , ...props }, ref)=>{
    const [modalStyle, setStyle] = (0, $8T3gX.useState)({});
    const [animateStaticModal, setAnimateStaticModal] = (0, $8T3gX.useState)(false);
    const waitingForMouseUpRef = (0, $8T3gX.useRef)(false);
    const ignoreBackdropClickRef = (0, $8T3gX.useRef)(false);
    const removeStaticModalAnimationRef = (0, $8T3gX.useRef)(null);
    const [modal, setModalRef] = (0, $a20f7a0618b40b39$export$2e2bcd8739ae039)();
    const mergedRef = (0, $3334d009365bf881$export$2e2bcd8739ae039)(ref, setModalRef);
    const handleHide = (0, $47b6b666cdb493de$export$2e2bcd8739ae039)(onHide);
    const isRTL = (0, $fa98af941750c85d$export$35e511eefa30ac5a)();
    bsPrefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, "modal");
    const modalContext = (0, $8T3gX.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        return (0, $a5528457b47db029$export$a03641438014b436)({
            isRTL: isRTL
        });
    }
    function updateDialogStyle(node) {
        if (!(0, $5d1f306240459aa4$export$2e2bcd8739ae039)) return;
        const containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
        const modalIsOverflowing = node.scrollHeight > (0, $c65895a0e633f08a$export$2e2bcd8739ae039)(node).documentElement.clientHeight;
        setStyle({
            paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, $395af1e4f91abdee$export$2e2bcd8739ae039)() : undefined,
            paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, $395af1e4f91abdee$export$2e2bcd8739ae039)() : undefined
        });
    }
    const handleWindowResize = (0, $47b6b666cdb493de$export$2e2bcd8739ae039)(()=>{
        if (modal) updateDialogStyle(modal.dialog);
    });
    (0, $8dfbb7dc191a638c$export$2e2bcd8739ae039)(()=>{
        (0, $76865a0011944031$export$2e2bcd8739ae039)(window, "resize", handleWindowResize);
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
    });
    // We prevent the modal from closing during a drag by detecting where the
    // click originates from. If it starts in the modal and then ends outside
    // don't close.
    const handleDialogMouseDown = ()=>{
        waitingForMouseUpRef.current = true;
    };
    const handleMouseUp = (e)=>{
        if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) ignoreBackdropClickRef.current = true;
        waitingForMouseUpRef.current = false;
    };
    const handleStaticModalAnimation = ()=>{
        setAnimateStaticModal(true);
        removeStaticModalAnimationRef.current = (0, $3e2975719edb44ef$export$2e2bcd8739ae039)(modal.dialog, ()=>{
            setAnimateStaticModal(false);
        });
    };
    const handleStaticBackdropClick = (e)=>{
        if (e.target !== e.currentTarget) return;
        handleStaticModalAnimation();
    };
    const handleClick = (e)=>{
        if (backdrop === "static") {
            handleStaticBackdropClick(e);
            return;
        }
        if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
            ignoreBackdropClickRef.current = false;
            return;
        }
        onHide == null || onHide();
    };
    const handleEscapeKeyDown = (e)=>{
        if (keyboard) onEscapeKeyDown == null || onEscapeKeyDown(e);
        else {
            // Call preventDefault to stop modal from closing in @restart/ui.
            e.preventDefault();
            if (backdrop === "static") // Play static modal animation.
            handleStaticModalAnimation();
        }
    };
    const handleEnter = (node, isAppearing)=>{
        if (node) updateDialogStyle(node);
        onEnter == null || onEnter(node, isAppearing);
    };
    const handleExit = (node)=>{
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
        onExit == null || onExit(node);
    };
    const handleEntering = (node, isAppearing)=>{
        onEntering == null || onEntering(node, isAppearing);
        // FIXME: This should work even when animation is disabled.
        (0, $e7cff1023d0c73c4$export$2e2bcd8739ae039)(window, "resize", handleWindowResize);
    };
    const handleExited = (node)=>{
        if (node) node.style.display = ""; // RHL removes it sometimes
        onExited == null || onExited(node);
        // FIXME: This should work even when animation is disabled.
        (0, $76865a0011944031$export$2e2bcd8739ae039)(window, "resize", handleWindowResize);
    };
    const renderBackdrop = (0, $8T3gX.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(`${bsPrefix}-backdrop`, backdropClassName, !animation && "show")
        }), [
        animation,
        backdropClassName,
        bsPrefix
    ]);
    const baseModalStyle = {
        ...style,
        ...modalStyle
    };
    // If `display` is not set to block, autoFocus inside the modal fails
    // https://github.com/react-bootstrap/react-bootstrap/issues/5102
    baseModalStyle.display = "block";
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
            role: "dialog",
            ...dialogProps,
            style: baseModalStyle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, bsPrefix, animateStaticModal && `${bsPrefix}-static`, !animation && "show"),
            onClick: backdrop ? handleClick : undefined,
            onMouseUp: handleMouseUp,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby,
            children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(Dialog, {
                ...props,
                onMouseDown: handleDialogMouseDown,
                className: dialogClassName,
                contentClassName: contentClassName,
                children: children
            })
        });
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $b373b5e0423f0924$export$2e2bcd8739ae039).Provider, {
        value: modalContext,
        children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $9e490e809df060ee$export$2e2bcd8739ae039), {
            show: show,
            ref: mergedRef,
            backdrop: backdrop,
            container: container,
            keyboard: true // Always set true - see handleEscapeKeyDown
            ,
            autoFocus: autoFocus,
            enforceFocus: enforceFocus,
            restoreFocus: restoreFocus,
            restoreFocusOptions: restoreFocusOptions,
            onEscapeKeyDown: handleEscapeKeyDown,
            onShow: onShow,
            onHide: onHide,
            onEnter: handleEnter,
            onEntering: handleEntering,
            onEntered: onEntered,
            onExit: handleExit,
            onExiting: onExiting,
            onExited: handleExited,
            manager: getModalManager(),
            transition: animation ? $dcbe90c8bc15d3fe$var$DialogTransition : undefined,
            backdropTransition: animation ? $dcbe90c8bc15d3fe$var$BackdropTransition : undefined,
            renderBackdrop: renderBackdrop,
            renderDialog: renderDialog
        })
    });
});
$dcbe90c8bc15d3fe$var$Modal.displayName = "Modal";
var $dcbe90c8bc15d3fe$export$2e2bcd8739ae039 = Object.assign($dcbe90c8bc15d3fe$var$Modal, {
    Body: (0, $5add438351379290$export$2e2bcd8739ae039),
    Header: (0, $f1176ffd272d42c9$export$2e2bcd8739ae039),
    Title: (0, $cdbbd1435d7aa227$export$2e2bcd8739ae039),
    Footer: (0, $bd98f9adf3eb6452$export$2e2bcd8739ae039),
    Dialog: (0, $ec1d1702b246874a$export$2e2bcd8739ae039),
    TRANSITION_DURATION: 300,
    BACKDROP_TRANSITION_DURATION: 150
});







function $fa1cc170ff1d743d$export$78be7503da332a4b({ from: from , ...props }) {
    const [email, setEmail] = (0, $8T3gX.useState)(localStorage.getItem((0, $f5e4100d4916d807$export$8174500baa6eca79)) ?? "");
    const [emailSent, setEmailSent] = (0, $8T3gX.useState)(false);
    const sendRef = (0, $8T3gX.useRef)(null);
    async function sendLink() {
        const redirectUrl = new URL(String(location));
        redirectUrl.pathname = from;
        try {
            await (0, $a147a5343133f2a5$export$95dc765ca5d5cc35)(sendRef.current, (0, $8dac729f232ba11e$export$7910e0436ed8d1de)((0, $febfa929b76327ac$export$73693bad9f5880b0), email, {
                url: String(redirectUrl),
                handleCodeInApp: true
            }));
            // Stash email address in localStorage so user doesn't have to re-enter it
            localStorage.setItem((0, $f5e4100d4916d807$export$8174500baa6eca79), email);
        } catch (err) {
            console.error("Email login failed", err);
            (0, $3eda0b7570ee1d13$export$fff9462e59a6c087)(/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $1d0a237fe4c0025c$export$2e2bcd8739ae039), {
                variant: "warning",
                children: "Hmm... something appears to have gone wrong."
            }));
            props.onHide?.();
        }
        setEmailSent(true);
    }
    let title, body, footer;
    if (emailSent) {
        // UI after email is sent
        title = "Check Your Email";
        body = /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("p", {
                    children: [
                        "You should have a message from",
                        " ",
                        /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("strong", {
                            children: "noreply@flightcard-63595.firebaseapp.com"
                        }),
                        '. (Be sure to check your "Spam" folder as well.)'
                    ]
                }),
                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("p", {
                    children: "Follow the instructions in that email to finish logging in."
                })
            ]
        });
        footer = /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
            variant: "secondary",
            onClick: props.onHide,
            children: "Close"
        });
    } else {
        // Initial UI, getting user's email address
        title = "Password-less Email Login";
        body = /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("p", {
                    children: [
                        'Please provide your email, then click "Send Login Link". You\'ll receive an email with a link that will log you into ',
                        (0, $5c148f2ca1c26c40$export$1d977c709458e273),
                        "."
                    ]
                }),
                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("label", {
                    children: "Your Email Address"
                }),
                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $82743675752b4983$export$2e2bcd8739ae039).Control, {
                    type: "email",
                    value: email ?? "",
                    onChange: (e)=>setEmail(e.target.value),
                    placeholder: "E.g. rory.marshall@example.com",
                    required: true
                })
            ]
        });
        footer = /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                    ref: sendRef ?? undefined,
                    onClick: sendLink,
                    children: "Send Login Link"
                }),
                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                    className: "flex-grow-1"
                }),
                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                    variant: "secondary",
                    onClick: props.onHide,
                    children: "Cancel"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $dcbe90c8bc15d3fe$export$2e2bcd8739ae039), {
        show: true,
        ...props,
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $dcbe90c8bc15d3fe$export$2e2bcd8739ae039).Title, {
                className: "mx-3 mt-3",
                children: title
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $dcbe90c8bc15d3fe$export$2e2bcd8739ae039).Body, {
                children: body
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $dcbe90c8bc15d3fe$export$2e2bcd8739ae039).Footer, {
                className: "d-flex justify-content-between",
                children: footer
            })
        ]
    });
}




const $f5e4100d4916d807$export$8174500baa6eca79 = "fcEmail";
function $f5e4100d4916d807$export$2e2bcd8739ae039() {
    const location = (0, $3T949.useLocation)();
    const [showEmailModal, setShowEmailModal] = (0, $8T3gX.useState)(false);
    const busyRef = (0, $8T3gX.useRef)(null);
    const from = location.state?.from?.pathname || "/";
    const navigate = (0, $3T949.useNavigate)();
    async function loginWithGoogle() {
        // REF: https://firebase.google.com/docs/auth/web/google-signin
        const provider = new (0, $8dac729f232ba11e$export$e7c866399fa523f5)();
        try {
            const result = await (0, $8dac729f232ba11e$export$db3b6bfb95261072)((0, $febfa929b76327ac$export$73693bad9f5880b0), provider);
            await (0, $99363374ad4a13cf$export$b7f48d2fe9159f71)(result.user);
            navigate(from);
        } catch (err) {
            (0, $3eda0b7570ee1d13$export$fff9462e59a6c087)(err);
        }
    }
    function doEmailLogin() {
        setShowEmailModal(true);
    }
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
        id: "login_page",
        className: "text-center",
        children: [
            showEmailModal ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $fa1cc170ff1d743d$export$78be7503da332a4b), {
                from: from,
                onHide: ()=>setShowEmailModal(false)
            }) : null,
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("h2", {
                className: "my-5",
                children: [
                    "Welcome to ",
                    (0, $5c148f2ca1c26c40$export$1d977c709458e273)
                ]
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                onClick: loginWithGoogle,
                children: "Login with Google"
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                className: "my-3",
                children: "Or..."
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                ref: busyRef,
                onClick: doEmailLogin,
                children: "Login with Email"
            })
        ]
    });
}



async function $889723b8a1c00c4b$export$a1791510aae923e() {
    const { href: href  } = window.location;
    // Is this is a signin request?
    if (!(0, $8dac729f232ba11e$export$555508cbc6add439)((0, $febfa929b76327ac$export$73693bad9f5880b0), href)) return;
    let email = localStorage.getItem((0, $f5e4100d4916d807$export$8174500baa6eca79));
    if (!email) email = window.prompt("To finish signing in, please confirm the email you used to sign up:");
    return await (0, $8dac729f232ba11e$export$2219238a014317b0)((0, $febfa929b76327ac$export$73693bad9f5880b0), email ?? "", href);
}





const $99363374ad4a13cf$var$authUserContext = /*#__PURE__*/ (0, $8T3gX.createContext)([
    undefined,
    true,
    undefined
]);
function $99363374ad4a13cf$export$7bff60a5db1bae35() {
    return (0, $8T3gX.useContext)($99363374ad4a13cf$var$authUserContext);
}
async function $99363374ad4a13cf$export$b7f48d2fe9159f71(user) {
    const rtpath = (0, $71b3f0397fe2ca79$export$1ba679a5cc178147).with({
        authId: user.uid
    });
    let currentUser = await (0, $febfa929b76327ac$export$c10e31973268dac4)(rtpath).catch(console.error);
    if (!currentUser) currentUser = {
        id: user.uid
    };
    if (user.displayName) currentUser.name ||= user.displayName;
    if (user.photoURL) currentUser.photoURL = user.photoURL;
    await (0, $febfa929b76327ac$export$78d8dceb730843fa)(rtpath, currentUser).catch(console.error);
}
function $99363374ad4a13cf$export$5600659300053830({ children: children  }) {
    const { Provider: Provider  } = $99363374ad4a13cf$var$authUserContext;
    const [authUser, setAuthUser] = (0, $8T3gX.useState)();
    const [loading, setLoading] = (0, $8T3gX.useState)(true);
    const [error, setError] = (0, $8T3gX.useState)();
    const navigate = (0, $3T949.useNavigate)();
    async function onAuth(user) {
        setAuthUser(user ?? undefined);
        setError(undefined);
        setLoading(false);
    }
    function onError(err) {
        setAuthUser(undefined);
        setError(err);
        setLoading(false);
    }
    // Check href to see if this is a login via email-link
    (0, $8T3gX.useEffect)(()=>{
        (async function() {
            let userCredential;
            try {
                userCredential = await (0, $889723b8a1c00c4b$export$a1791510aae923e)();
            } catch (err) {
                switch(err?.code){
                    case "auth/invalid-action-code":
                        (0, $3eda0b7570ee1d13$export$fff9462e59a6c087)(new Error("Sorry, that login link is no longer valid. Please try logging in again."));
                        break;
                    case "auth/invalid-email":
                    default:
                        (0, $3eda0b7570ee1d13$export$fff9462e59a6c087)(err);
                        break;
                }
            }
            // Only defined if user landed on page via email-link
            if (userCredential) {
                const userInfo = (0, $8dac729f232ba11e$export$7a38258bbe170828)(userCredential);
                if (userInfo?.isNewUser) (0, $3eda0b7570ee1d13$export$fff9462e59a6c087)("Welcome to FlightCard!");
                const { user: user  } = userCredential;
                await $99363374ad4a13cf$export$b7f48d2fe9159f71(user);
                navigate(userInfo?.isNewUser ? "/" : "/launches");
            }
            // Sign up for auth changes
            (0, $febfa929b76327ac$export$73693bad9f5880b0).onAuthStateChanged(onAuth, onError);
        })();
    }, []);
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(Provider, {
        value: [
            authUser,
            loading,
            error
        ],
        children: children
    });
}




var $8T3gX = parcelRequire("8T3gX");


const $5d52285becd1fc5d$export$c684d6a80543761b = /*#__PURE__*/ (0, $8T3gX.createContext)({
    launch: [
        undefined,
        true,
        undefined
    ],
    attendees: [
        undefined,
        true,
        undefined
    ],
    officers: [
        undefined,
        true,
        undefined
    ],
    cards: [
        undefined,
        true,
        undefined
    ],
    pads: [
        undefined,
        true,
        undefined
    ]
});
function $5d52285becd1fc5d$export$8cb21553fa7d1d8a({ launchId: launchId , children: children  }) {
    const { Provider: Provider  } = $5d52285becd1fc5d$export$c684d6a80543761b;
    const launchFields = launchId ? {
        launchId: launchId
    } : undefined;
    const launch = (0, $febfa929b76327ac$export$fe4c1a3a7af84c36)((0, $71b3f0397fe2ca79$export$90058626e653e0cd).with(launchFields));
    const attendees = (0, $febfa929b76327ac$export$fe4c1a3a7af84c36)((0, $71b3f0397fe2ca79$export$ac9b3f0445b3a6da).with(launchFields));
    const officers = (0, $febfa929b76327ac$export$fe4c1a3a7af84c36)((0, $71b3f0397fe2ca79$export$50e9aca848382ff9).with(launchFields));
    const cards = (0, $febfa929b76327ac$export$fe4c1a3a7af84c36)((0, $71b3f0397fe2ca79$export$d7220bf6225e19b7).with(launchFields));
    const pads = (0, $febfa929b76327ac$export$fe4c1a3a7af84c36)((0, $71b3f0397fe2ca79$export$83289c7452cd8ea9).with(launchFields));
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(Provider, {
        value: {
            launch: launch,
            attendees: attendees,
            officers: officers,
            cards: cards,
            pads: pads
        },
        children: children
    });
}




//
// Unit conversion utility
//
const $a53c6536bb8a7347$export$dc8ef91cafc34879 = {
    lengthSmall: "cm",
    length: "m",
    speed: "km/h",
    speedSmall: "m/s",
    mass: "kg",
    force: "n",
    impulse: "n-s"
};
const $a53c6536bb8a7347$export$ee3c116a5df36536 = {
    lengthSmall: "in",
    length: "ft",
    speed: "mph",
    speedSmall: "ft/s",
    mass: "lb",
    force: "lbf",
    impulse: "lbf-s"
};
// Map of maps of conversion factors ([from][to] = conversion value)
const $a53c6536bb8a7347$var$_FACTORS = new Map();
// Define a conversion factor between `from` and `to` units.
//
// This method defines the inverse conversion as well as any implied
// conversions.  For example...
//
// define('m', 'mm', 1000); define('in', mm', 25.4);
//
// ... enables conversions to and from any combination of 'm', 'mm', and 'in'
// units.
//
// Note: The _FACTORS data structure grows as O(N * (N-1)) for N related units.
// Something to keep an eye on.
function $a53c6536bb8a7347$var$define(from, to, factor) {
    if (from === to) return;
    // Define the conversion and inverse conversion
    let fromFactors = $a53c6536bb8a7347$var$_FACTORS.get(from);
    if (!fromFactors) {
        fromFactors = new Map();
        $a53c6536bb8a7347$var$_FACTORS.set(from, fromFactors);
    } else if (fromFactors.has(to)) // Conversion is already defined
    return;
    // Set conversion factor
    fromFactors.set(to, factor);
    // Define inverse conversion
    $a53c6536bb8a7347$var$define(to, from, 1 / factor);
    // Define conversions for all units that `to` can convert to.  This results in
    // a fully populated conversion table for all related units.
    const toFactors = $a53c6536bb8a7347$var$_FACTORS.get(to);
    if (toFactors) for (const [toto, toFactor] of toFactors)// https://www.youtube.com/watch?v=FTQbiNvZqaY
    $a53c6536bb8a7347$var$define(from, toto, factor * toFactor);
}
// Length
$a53c6536bb8a7347$var$define("ft", "in", 12);
$a53c6536bb8a7347$var$define("m", "cm", 100);
$a53c6536bb8a7347$var$define("cm", "mm", 10);
$a53c6536bb8a7347$var$define("km", "m", 1000);
$a53c6536bb8a7347$var$define("in", "mm", 25.4); // Connect MKS <-> USCS lengths
// Speed
$a53c6536bb8a7347$var$define("m/s", "km/h", 3.6);
$a53c6536bb8a7347$var$define("m/s", "km/s", 0.001);
$a53c6536bb8a7347$var$define("ft/s", "mph", 3600 / 5280);
$a53c6536bb8a7347$var$define("m/s", "ft/s", 1000 / (25.4 * 12)); // Connect MKS <-> USCS speeds
// Mass
$a53c6536bb8a7347$var$define("kg", "g", 1000);
$a53c6536bb8a7347$var$define("g", "mg", 1000);
$a53c6536bb8a7347$var$define("lb", "oz", 16);
$a53c6536bb8a7347$var$define("kg", "lb", 2.20462262); // Connect MKS <-> USCS mass
// Force (thrust)
$a53c6536bb8a7347$var$define("lbf", "n", 4.44822);
// Impulse
$a53c6536bb8a7347$var$define("lbf-s", "n-s", 4.44822);
function $a53c6536bb8a7347$export$51bc4f4f84f52eab(val, from, to) {
    const factor = to === from ? 1 : $a53c6536bb8a7347$var$_FACTORS?.get(from)?.get(to);
    if (factor == null) return NaN;
    return Number(val) * factor;
}
function $a53c6536bb8a7347$export$26c3d0b70508b36c(val, defaultUnit, toUnit = defaultUnit) {
    val = typeof val == "number" ? String(val) : val.trim();
    let v, unit;
    if (/^([\d-.]+)\s*(?:ft|')$/i.test(val)) {
        // feet
        v = Number(RegExp.$1);
        unit = "ft";
    } else if (/^([\d-.]+)\s*(?:in|")$/i.test(val)) {
        // inches
        v = Number(RegExp.$1) / 12;
        unit = "ft";
    } else if (/^([\d-.]+)\s*(?:ft|')\s*([\d-.]+)\s*(?:in|")$/i.test(val)) {
        // feet-inches
        v = Number(RegExp.$1) + Number(RegExp.$2) / 12;
        unit = "ft";
    } else if (/^([\d-.]+)\s*cm$/i.test(val)) {
        // centimeters
        v = Number(RegExp.$1) / 100;
        unit = "m";
    } else if (/^([\d-.]+)\s*mm$/i.test(val)) {
        // millimeters
        v = Number(RegExp.$1) / 1000;
        unit = "m";
    } else if (/^([\d-.]+)\s*(?:lb)$/i.test(val)) {
        // pounds (mass)
        v = Number(RegExp.$1);
        unit = "lb";
    } else if (/^([\d-.]+)\s*(?:oz)$/i.test(val)) {
        // ounces
        v = Number(RegExp.$1) / 16;
        unit = "lb";
    } else if (/^([\d-.]+)\s*(?:lb)\s*([\d-.]+)\s*(?:oz)$/i.test(val)) {
        // pound - ounces;
        v = Number(RegExp.$1) + Number(RegExp.$2) / 16;
        unit = "lb";
    } else if (/^([\d-.]+)\s*(?:gm?)$/i.test(val)) {
        // grams
        v = Number(RegExp.$1) / 1000;
        unit = "kg";
    } else if (/^([\d-.]+)\s*(?:lbf)$/i.test(val)) {
        // lbf
        v = Number(RegExp.$1);
        unit = "lbf";
    } else if (/^([\d-.]+)\s*(?:lbf-s|lbf-sec)$/i.test(val)) {
        // lbf-seconds
        v = Number(RegExp.$1);
        unit = "lbf-s";
    } else if (/^([\d-.]+)\s*(?:m)$/i.test(val)) {
        // m
        v = Number(RegExp.$1);
        unit = "m";
    } else if (/^([\d-.]+)\s*(?:kg)$/i.test(val)) {
        // kg
        v = Number(RegExp.$1);
        unit = "kg";
    } else if (/^([\d-.]+)\s*(?:n)$/i.test(val)) {
        // newton
        v = Number(RegExp.$1);
        unit = "n";
    } else if (/^([\d-.]+)\s*(?:n-s|n-sec)$/i.test(val)) {
        // newton-sec
        v = Number(RegExp.$1);
        unit = "n-s";
    } else {
        v = Number(val);
        unit = defaultUnit;
    }
    if (isNaN(v)) return NaN;
    v = $a53c6536bb8a7347$export$51bc4f4f84f52eab(v, unit, toUnit);
    if (v === undefined) throw Error("");
    return v;
}


function $de6e1888d0a1ea86$export$3901076af3749fa9() {
    const [authUser, authLoading, authError] = (0, $99363374ad4a13cf$export$7bff60a5db1bae35)();
    const authFields = authUser ? {
        authId: authUser.uid
    } : undefined;
    const rtpath = (0, $71b3f0397fe2ca79$export$1ba679a5cc178147).with(authFields);
    const userState = (0, $febfa929b76327ac$export$fe4c1a3a7af84c36)(rtpath);
    if (authLoading) return [
        undefined,
        true,
        undefined
    ];
    else if (authError) return [
        undefined,
        false,
        authError
    ];
    if (!userState) console.error("User authed, but no user found");
    return userState;
}
function $de6e1888d0a1ea86$export$84bb215878bdb6d8() {
    return (0, $febfa929b76327ac$export$fe4c1a3a7af84c36)((0, $71b3f0397fe2ca79$export$d6be259d96b74ffe));
}
function $de6e1888d0a1ea86$export$75eeb04b2db35f42() {
    return (0, $8T3gX.useContext)((0, $5d52285becd1fc5d$export$c684d6a80543761b)).launch;
}
function $de6e1888d0a1ea86$export$f755a54f5b6ffe30() {
    return (0, $8T3gX.useContext)((0, $5d52285becd1fc5d$export$c684d6a80543761b)).attendees;
}
function $de6e1888d0a1ea86$export$67c1131f3997904d() {
    const userState = $de6e1888d0a1ea86$export$3901076af3749fa9();
    return $de6e1888d0a1ea86$export$577414e83e777f79(userState[0]?.id ?? "");
}
function $de6e1888d0a1ea86$export$577414e83e777f79(attendeeId) {
    const [attendees, loading, error] = (0, $8T3gX.useContext)((0, $5d52285becd1fc5d$export$c684d6a80543761b)).attendees;
    return [
        attendees?.[attendeeId],
        loading,
        error
    ];
}
function $de6e1888d0a1ea86$export$6563e0c59fe67e2() {
    return (0, $8T3gX.useContext)((0, $5d52285becd1fc5d$export$c684d6a80543761b)).officers;
}
function $de6e1888d0a1ea86$export$5fe928848609fec7() {
    return (0, $8T3gX.useContext)((0, $5d52285becd1fc5d$export$c684d6a80543761b)).cards;
}
function $de6e1888d0a1ea86$export$5a0763f6a9ca51f0(cardId) {
    const [cards, loading, error] = (0, $8T3gX.useContext)((0, $5d52285becd1fc5d$export$c684d6a80543761b)).cards;
    return [
        cards?.[cardId],
        loading,
        error
    ];
}
function $de6e1888d0a1ea86$export$5b051e2383c8638d() {
    return (0, $8T3gX.useContext)((0, $5d52285becd1fc5d$export$c684d6a80543761b)).pads;
}
function $de6e1888d0a1ea86$export$6bd5211fd2e82d10() {
    const [currentUser, loading, err] = $de6e1888d0a1ea86$export$3901076af3749fa9();
    return [
        currentUser?.units == "uscs" ? (0, $a53c6536bb8a7347$export$ee3c116a5df36536) : (0, $a53c6536bb8a7347$export$dc8ef91cafc34879),
        loading,
        err
    ];
}






// Init motor impulse class information structure
let $0e759b381c300a7c$var$_impulse;
const $0e759b381c300a7c$export$f0f2cabfa1c044ac = [
    {
        name: "⅛A",
        min: 0,
        max: $0e759b381c300a7c$var$_impulse = 0.3125
    },
    {
        name: "⅜A",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "⅝A",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "A",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "B",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "C",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "D",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "E",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "F",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "G",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "H",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "I",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "J",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "K",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "L",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "M",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "N",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "O",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "P",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "Q",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "R",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "S",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "T",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "U",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "V",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "W",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "X",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "Y",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "Z",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "AA",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "AB",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "AC",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "AD",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "AE",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "AF",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "AG",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "AH",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "AI",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    },
    {
        name: "AJ",
        min: $0e759b381c300a7c$var$_impulse,
        max: $0e759b381c300a7c$var$_impulse *= 2
    }
];
const $0e759b381c300a7c$var$motorIndex = new Map();
const $0e759b381c300a7c$var$motorNameIndex = new Map();
// We don't want this being modified
Object.freeze((0, (/*@__PURE__*/$parcel$interopDefault($fa64700f0ee1e308$exports))));
// Build indexes
for (const motor of (0, (/*@__PURE__*/$parcel$interopDefault($fa64700f0ee1e308$exports)))){
    // ... or this
    Object.freeze(motor);
    $0e759b381c300a7c$var$motorIndex.set(motor.motorId, motor);
    $0e759b381c300a7c$var$motorNameIndex.set($0e759b381c300a7c$export$4ca4191dc95399e3(motor).toLowerCase(), motor);
}
function $0e759b381c300a7c$export$6ef5e39af8f569c9(motorId) {
    return $0e759b381c300a7c$var$motorIndex.get(motorId);
}
function $0e759b381c300a7c$export$100d0ae4aabba252(name) {
    return $0e759b381c300a7c$var$motorNameIndex.get(name?.toLowerCase() ?? "");
}
function $0e759b381c300a7c$export$40a60c142742ca02(q) {
    if (!q) return [];
    const terms = q.trim().toLowerCase().split(/\s+/);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fa64700f0ee1e308$exports))).map((motor)=>{
        let score = 0;
        let { impulseClass: impulseClass = "" , designation: designation = "" , commonName: commonName = "" , manufacturerAbbrev: manufacturerAbbrev = "" , propInfo: propInfo = ""  } = motor;
        const { sparky: sparky , availability: availability  } = motor;
        impulseClass = impulseClass.toLowerCase();
        designation = designation.toLowerCase();
        commonName = commonName.toLowerCase();
        propInfo = propInfo.toLowerCase();
        manufacturerAbbrev = manufacturerAbbrev.toLowerCase();
        for (const term of terms){
            let termScore = 0;
            if (term === impulseClass) termScore += 1;
            if (commonName.startsWith(term)) termScore += 1;
            if (designation.includes(term)) termScore += 0.5;
            if (manufacturerAbbrev.includes(term)) termScore += 0.25;
            if (propInfo.includes(term)) termScore += 0.5;
            if (sparky && "sparky".startsWith(term)) termScore += 0.1;
            if (termScore <= 0) {
                score = 0;
                break;
            }
            score += termScore;
        }
        if (availability === "OOP") score /= 10;
        return {
            motor: motor,
            score: score
        };
    }).filter(({ score: score  })=>score > 0).sort((a, b)=>b.score - a.score).map(({ motor: motor  })=>motor);
}
function $0e759b381c300a7c$export$4ca4191dc95399e3(motor) {
    const { manufacturerAbbrev: manufacturerAbbrev , designation: designation , commonName: commonName , availability: availability  } = motor;
    return manufacturerAbbrev + " " + (designation.indexOf(commonName) >= 0 ? designation : commonName) + (availability === "OOP" ? " (discontinued)" : "");
}
function $0e759b381c300a7c$export$e4aa3cd81dd49981(cardMotors) {
    if (!cardMotors) return NaN;
    const motors = Object.values(cardMotors).filter((m)=>(m.stage ?? 1) === 1);
    if (!motors?.length) return NaN;
    return motors.reduce((acc, motor)=>{
        let thrust;
        if (motor.tcMotorId) // Use thrust from thrustcurve data if available
        thrust = $0e759b381c300a7c$export$6ef5e39af8f569c9(motor.tcMotorId)?.avgThrustN ?? NaN;
        else if (motor.name) {
            // Scrape from motor name
            const match = motor.name.match(/[a-z]([\d.]+)/i)?.[1];
            thrust = match ? parseInt(match) : NaN;
        } else // No thrust data available
        thrust = NaN;
        return acc + thrust;
    }, 0);
}
function $0e759b381c300a7c$export$e5d022af76390349(impulse) {
    if (impulse === undefined) return undefined;
    if (isNaN(impulse)) return undefined;
    for (const { name: name , min: min , max: max  } of $0e759b381c300a7c$export$f0f2cabfa1c044ac){
        // Note: Using min(exclusive), max(inclusive) here, as that's how NFPA 1125
        // interprets impulse range limits
        if (impulse > min && impulse <= max) return name;
    }
}
function $0e759b381c300a7c$export$6f335bde3fedcd2e(motors) {
    if (!motors) return undefined;
    const impulse = Object.entries(motors).reduce((acc, [, m])=>acc + (m.impulse ?? NaN), 0);
    return $0e759b381c300a7c$export$e5d022af76390349(impulse);
}



const $046ff7a4ddd7a466$export$5b411de2d35a1dd4 = 9.807;
// Minimum velocity needed for rocket to be aerodynamically stable (m/s)
const $046ff7a4ddd7a466$var$STABLE_SPEED = 13.89;
const $046ff7a4ddd7a466$var$THRUST_RATIO_MIN = 3;
const $046ff7a4ddd7a466$var$THRUST_RATIO_GOOD = 5;
function $046ff7a4ddd7a466$export$2e2bcd8739ae039({ rtFields: rtFields  }) {
    const [userUnits = (0, $a53c6536bb8a7347$export$dc8ef91cafc34879)] = (0, $de6e1888d0a1ea86$export$6bd5211fd2e82d10)();
    const [mass] = (0, $febfa929b76327ac$export$fe4c1a3a7af84c36)((0, $71b3f0397fe2ca79$export$fed7e30935905c1).with(rtFields));
    const [motors] = (0, $febfa929b76327ac$export$fe4c1a3a7af84c36)((0, $71b3f0397fe2ca79$export$8d9b735d66078003).with(rtFields));
    // Don't show if there's no motors
    if (!motors || !Object.entries(motors).length) return null;
    const stage1Motors = Object.values(motors).filter((m)=>(m.stage ?? 1) === 1);
    // There should be at least one stage 1 motor
    if (!stage1Motors.length) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $de9ec3fa47e50b10$export$aefd2927936d3a35), {
        className: "mt-3 p-2",
        meme: (0, $7c0789c43eea654c$exports),
        style: {
            height: "50cqmin",
            width: "20em"
        },
        topText: "No Stage 1 motors?",
        bottomText: "... very interesting"
    });
    // Analysis requires rocket mass
    if (mass == null) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $1d0a237fe4c0025c$export$2e2bcd8739ae039), {
        className: "mt-3 p-2",
        variant: "warning",
        children: "Enter rocket mass to enable thrust analysis"
    });
    // Compute total thrust of all stage 1 motors
    const stage1Thrust = stage1Motors.reduce((acc, motor)=>{
        let thrust = (0, $0e759b381c300a7c$export$6ef5e39af8f569c9)(motor.tcMotorId ?? "")?.avgThrustN ?? NaN;
        // Scrape thrust from motor name
        if (isNaN(thrust)) {
            const match = motor.name?.match(/\b[a-q]-?([\d.]+)\b/i)?.[1];
            thrust = match ? parseInt(match) : NaN;
        }
        return acc + thrust;
    }, 0);
    if (isNaN(stage1Thrust)) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $1d0a237fe4c0025c$export$2e2bcd8739ae039), {
        className: "mt-3 p-2",
        variant: "warning",
        children: [
            "Unable to compute total thrust. Make sure the average thrust is mentioned in each motor name using ",
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("code", {
                children: "letter-thrust"
            }),
            ' notation. (E.g. "D12" or "J-350")'
        ]
    });
    const thrustToWeightRatio = stage1Thrust / (mass * $046ff7a4ddd7a466$export$5b411de2d35a1dd4);
    // Compute rail travel needed for safe flight (meters)
    const acc = stage1Thrust / mass - $046ff7a4ddd7a466$export$5b411de2d35a1dd4;
    const time = $046ff7a4ddd7a466$var$STABLE_SPEED / acc; // 50km/h = 45.6 ft/s = 13.89m/s
    const railTravel = 0.5 * acc * time ** 2;
    let alertVariant = "danger";
    let thrustResult = null;
    let railResult = null;
    if (thrustToWeightRatio <= 1) thrustResult = /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
        children: [
            "Hmm... Check your mass and motor. A stage-1 thrust:weight ratio of",
            " ",
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("strong", {
                children: [
                    (0, $a147a5343133f2a5$export$a81eda11c790c16)(thrustToWeightRatio, 2),
                    " : 1"
                ]
            }),
            " means this rocket probably isn't leaving the pad, let alone achieving stable flight.",
            " ",
            "\uD83D\uDE2D"
        ]
    });
    else {
        alertVariant = thrustToWeightRatio < $046ff7a4ddd7a466$var$THRUST_RATIO_MIN ? "danger" : thrustToWeightRatio < $046ff7a4ddd7a466$var$THRUST_RATIO_GOOD ? "warning" : "success";
        thrustResult = /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
            children: [
                "Thrust",
                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("span", {
                    style: {
                        fontSize: "80%",
                        verticalAlign: "sub"
                    },
                    children: "avg"
                }),
                " ",
                ": Weight ratio (stage 1 motors only):",
                " ",
                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("strong", {
                    children: [
                        (0, $a147a5343133f2a5$export$a81eda11c790c16)(thrustToWeightRatio, 2),
                        " : 1"
                    ]
                })
            ]
        });
        railResult = /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
            className: "mt-2",
            children: [
                "Distance needed to reach stable flight speed (",
                (0, $a147a5343133f2a5$export$a81eda11c790c16)((0, $a53c6536bb8a7347$export$51bc4f4f84f52eab)($046ff7a4ddd7a466$var$STABLE_SPEED, (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).speedSmall, userUnits.speed), 2),
                " ",
                userUnits.speed,
                "):",
                " ",
                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("strong", {
                    children: [
                        (0, $a147a5343133f2a5$export$a81eda11c790c16)((0, $a53c6536bb8a7347$export$51bc4f4f84f52eab)(railTravel, (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).length, userUnits.length), 2),
                        " ",
                        userUnits.length
                    ]
                }),
                " "
            ]
        });
    }
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $1d0a237fe4c0025c$export$2e2bcd8739ae039), {
        className: "mt-3 p-0",
        variant: alertVariant,
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                className: "p-2",
                children: [
                    thrustResult,
                    railResult
                ]
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("details", {
                className: "m-1 p-1 rounded bg-light",
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("summary", {
                        className: "p-1 small fst-italic",
                        style: {
                            listStyleType: '"\\26a0"'
                        },
                        children: [
                            "",
                            " Experimental feature (click for disclaimer …)"
                        ]
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("strong", {
                                children: "DO NOT ASSUME THIS ANALYSIS MEANS YOUR ROCKET CAN BE FLOWN SAFELY."
                            }),
                            " ",
                            "This is an experimental feature based on crude approximations, potentially flawed assumptions, and limited data. It is not a substitute for a proper flight simulation. At most, it should be used as a sanity check of your own, independent analysis."
                        ]
                    })
                ]
            })
        ]
    });
}



parcelRequire("8T3gX");

const $42a584c902e2bfd5$export$56d196d2844d1ca1 = new Set([
    "aqua",
    "aquamarine",
    "azure",
    "beige",
    "bisque",
    "black",
    "blue",
    "brown",
    "chartreuse",
    "chocolate",
    "coral",
    "crimson",
    "cyan",
    "fuchsia",
    "gainsboro",
    "gold",
    "goldenrod",
    "gray",
    "green",
    "grey",
    "honeydew",
    "hotpink",
    "indigo",
    "ivory",
    "khaki",
    "lavender",
    "lime",
    "linen",
    "magenta",
    "maroon",
    "navy",
    "olive",
    "orange",
    "pink",
    "plum",
    "purple",
    "red",
    "salmon",
    "sienna",
    "silver",
    "snow",
    "tan",
    "teal",
    "thistle",
    "tomato",
    "turquoise",
    "violet",
    "wheat",
    "white",
    "yellow"
]);
function $42a584c902e2bfd5$export$2e2bcd8739ae039({ colors: colors , className: className , ...props }) {
    if (/rainbow/i.test(colors)) colors = "red orange yellow green turquoise blue violet";
    const match = colors?.match(/\w+/g)?.map((v)=>v.toLowerCase());
    if (!match) return null;
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $e9bc3aadba8432ee$exports.Fragment), {
        children: match.map((color, i)=>$42a584c902e2bfd5$export$56d196d2844d1ca1.has(color) ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                className: (0, $a147a5343133f2a5$export$1343a74baacb0543)(className, "no-invert"),
                style: {
                    backgroundColor: color
                },
                ...props
            }, `chit-${i}`) : null)
    });
}



const $543e439f036f1dfe$export$776a922db93662cb = [
    "Shirley Baker",
    "Tomas Wood",
    "Herbert Moran",
    "Lucy Johnson",
    "Patricia Maxwell",
    "Kent Ross",
    "Julie Valdez",
    "Patty Curry",
    "Shawna Watkins",
    "Lillian Webb",
    "Darren Reese",
    "Maggie Becker",
    "Krista Perez",
    "Sam Butler",
    "Natasha Gilbert",
    "Irving Campbell",
    "Adrienne Palmer",
    "Marianne Horton",
    "Woodrow Murphy",
    "Pearl Higgins",
    "Arlene Kennedy",
    "Nick Hamilton",
    "Wilson Garrett",
    "Domingo Riley",
    "Doyle Fuller",
    "Mathew Davidson",
    "Tricia Hansen",
    "Tamara Floyd",
    "Jack Klein",
    "Tommy Hampton",
    "Shelia Howard",
    "Johanna Owens",
    "Harvey Tucker",
    "Earl Lambert",
    "Cody Gutierrez",
    "Mildred Banks",
    "Desiree Glover",
    "Jared Arnold",
    "Maureen Bennett",
    "Rachael Summers",
    "Jon Walters",
    "Pauline Walsh",
    "Melvin Curtis",
    "Misty Gill",
    "Melody Holmes",
    "Brandi Pena",
    "Alvin Jensen",
    "Theodore Washington",
    "Laurie Fowler",
    "Lynn Gonzalez",
    "Nina Barton",
    "Jasmine Romero",
    "Armando Strickland",
    "Clarence Sparks",
    "Beatrice Hicks",
    "Barbara Bryan",
    "Yolanda Nunez",
    "Cesar Brewer",
    "Irvin Cohen",
    "Tracey Saunders",
    "Levi Buchanan",
    "Virgil Ortiz",
    "June Barnett",
    "Edna Sims",
    "Greg Wheeler",
    "Javier Medina",
    "Lyle Coleman",
    "Raul Guerrero",
    "Willard Bates",
    "Roman Farmer",
    "Norma Peterson",
    "Lillie Bush",
    "Lydia Little",
    "Edgar Bridges",
    "Cheryl Olson",
    "Stacey Burton",
    "Kenny Jimenez",
    "Genevieve Simpson",
    "Debbie Diaz",
    "Guy Murray",
    "Hannah Graham",
    "Marian Hawkins",
    "Arthur Perry",
    "Otis Mclaughlin",
    "Jenna Cooper",
    "Roberta Lynch",
    "Roderick Silva",
    "Brendan Harvey",
    "Constance Maldonado",
    "Franklin Ramos",
    "Adrian Meyer",
    "Fred Porter",
    "Jamie Hayes",
    "Pete Townsend",
    "Tanya Neal",
    "Ron French",
    "Yvonne Wilkins",
    "Jodi Brock"
];
const $543e439f036f1dfe$var$ROCKET_NAMES = [
    "220 Swift",
    "3 Bandits",
    "AGM-57X Heatseeker",
    "Alpha III",
    "Altimeter",
    "Apollo Little Joe II",
    "Apollo 11 Saturn V",
    "Argent",
    "Asteroid Hunter",
    "Astron Skydart II",
    "Astron Sprint XL",
    "Atomic Aqua",
    "Baby Bertha",
    "Bandito",
    "Banshee",
    "Big Bertha",
    "Big Daddy",
    "Black Diamond",
    "Black Hole",
    "Black Star Voyager",
    "Blast-off Blue",
    "Blenders",
    "Booster-55",
    "Booster-60",
    "Bull Pup 12D",
    "Centuri",
    "Chiller",
    "Chuter-Two",
    "Cobra",
    "Code Red",
    "Comanche-3",
    "Conquest",
    "Cosmic Interceptor",
    "Crossbow SST",
    "Crossfire ISX",
    "Curvilinear",
    "Dark Silver",
    "Dark Zero",
    "Dazzler",
    "Der Red Max",
    "Designer Special",
    "Dragonite",
    "Drifter",
    "Eggscaliber",
    "EPM-010",
    "Estes Jetliner",
    "Estes SLV",
    "Estes Shuttle",
    "Extreme 12",
    "Fat Jax",
    "Fig Plucker",
    "Finky Starts",
    "Firehawk",
    "Firebolt",
    "Firestreak SST",
    "Firestorm",
    "Flip Flyer",
    "Flutter-By",
    "Flying Colors",
    "Fractured",
    "Freefall",
    "Galaxy Gold",
    "Generic E2X",
    "Goblin",
    "Helios",
    "Hi-Flier",
    "Hi-Flier XL",
    "Honest John",
    "Hornet",
    "Humdinger",
    "Hyper Bat",
    "Hyper Dart",
    "Indicator",
    "Journey",
    "L.G.M. 0095",
    "LoadStar II",
    "Lynx",
    "Magician",
    "Majestic",
    "Mammoth",
    "Mega Der Red Max",
    "Mercury Redstone",
    "Metalizer",
    "Meteorite White",
    "Mini Blaster Air",
    "Mini Comanche-3",
    "Mini Fat Boy",
    "Mini Honest John",
    "Mini Max",
    "MIRV",
    "Mix-n-Match-50",
    "Mix-n-Match-55",
    "Mix-n-Match-60",
    "Mongoose",
    "Mosquito",
    "Nike Smoke",
    "Nike Smoke",
    "Nitro",
    "No. 2 Estes Sky Writer",
    "Nova",
    "Odyssey",
    "Orange Crush",
    "Outer-space Orange",
    "Partizon",
    "Phantom Blue",
    "Pheasant Plucker",
    "Phoenix Bird",
    "Photon Probe",
    "Plaster Man",
    "Power Patrol",
    "Prospector",
    "QCC Explorer",
    "Quinstar",
    "Red Flare",
    "Red Rider",
    "Rogue Voyager",
    "Rookie",
    "Satellite Silver",
    "Savage",
    "Scorpion",
    "Sequoia",
    "Shattered",
    "Tooting Shtar",
    "Show Stopper",
    "Shuttle Xpress",
    "Shining Wit",
    "Sizzler",
    "Sky Cruiser",
    "Sky Duster",
    "Sky Hawker",
    "Sky Shark",
    "Sky Twister",
    "Sky Warrior",
    "Solar Warrior",
    "Solaris",
    "Spectra",
    "Spirit",
    "Star Orbiter",
    "Star Trooper",
    "STM-012",
    "Super Neon",
    "Super Neon XL",
    "Supernova",
    "Taser Twin",
    "Trajector",
    "Tercel Boost Glider",
    "Top Shot",
    "U.S. Army Patriot M-104",
    "UP Aerospace SpaceLoft",
    "V2",
    "Vagabond",
    "Ventris",
    "Viking",
    "Whirlwind",
    "Wild Flyer",
    "Wizard",
    "Xarconian Cruiser",
    "Yankee",
    "Yellow Star",
    "Zinger",
    "40"
];
const $543e439f036f1dfe$var$MOTOR_SIZES = [
    // min/max impulse (MKS units)
    {
        name: "A",
        min: 1.25,
        max: 2.5
    },
    {
        name: "B",
        min: 2.5,
        max: 5
    },
    {
        name: "C",
        min: 5,
        max: 10
    },
    {
        name: "D",
        min: 10,
        max: 20
    },
    {
        name: "E",
        min: 20,
        max: 40
    },
    {
        name: "F",
        min: 40,
        max: 80
    },
    {
        name: "G",
        min: 80,
        max: 160
    },
    {
        name: "H",
        min: 160,
        max: 320
    },
    {
        name: "I",
        min: 320,
        max: 640
    },
    {
        name: "J",
        min: 640,
        max: 1280
    },
    {
        name: "K",
        min: 1280,
        max: 2560
    },
    {
        name: "L",
        min: 2560,
        max: 5120
    },
    {
        name: "M",
        min: 5120,
        max: 10240
    },
    {
        name: "N",
        min: 10240,
        max: 20480
    },
    {
        name: "O",
        min: 20480,
        max: 40960
    }
];
const $543e439f036f1dfe$var$ROCKET_VENDORS = [
    "Estes",
    "Mad Cow",
    "SBR",
    "LOC",
    "Dynasoar"
];
function $543e439f036f1dfe$export$be19d2d9cc68114b(min, max) {
    return max == null ? Math.random() * min : min + Math.random() * (max - min);
}
function $543e439f036f1dfe$export$e87bfa2a4c6bccb0(min, max) {
    return Math.floor($543e439f036f1dfe$export$be19d2d9cc68114b(min, max));
}
function $543e439f036f1dfe$export$902f197adee116a0(arr) {
    if (arr instanceof Set) arr = Array.from(arr);
    else if (arr.constructor === Object) arr = Object.values(arr);
    return arr[$543e439f036f1dfe$export$e87bfa2a4c6bccb0(arr.length)];
}
function $543e439f036f1dfe$export$33af164380fc4c08() {
    const tcMotor = $543e439f036f1dfe$export$902f197adee116a0((0, (/*@__PURE__*/$parcel$interopDefault($fa64700f0ee1e308$exports))));
    // weight should be < thrust * 5, but we generate some underpowered rockets to
    // test thrust:weight ratio UI
    const mass = tcMotor.avgThrustN / $543e439f036f1dfe$export$be19d2d9cc68114b(2, $543e439f036f1dfe$export$be19d2d9cc68114b(4, 20)) / (0, $046ff7a4ddd7a466$export$5b411de2d35a1dd4);
    const aspectRatio = $543e439f036f1dfe$export$be19d2d9cc68114b($543e439f036f1dfe$export$be19d2d9cc68114b(5, 30), $543e439f036f1dfe$export$be19d2d9cc68114b(10, 40));
    const length = Math.pow(mass * 2, 1 / 3);
    const diameter = Math.pow(mass * 5, 1 / 3) / aspectRatio;
    const motor = {
        id: (0, $40b0ef4339cb3cfb$export$ac4959f4f1338dfc)(),
        name: (0, $0e759b381c300a7c$export$4ca4191dc95399e3)(tcMotor),
        stage: 1,
        impulse: tcMotor.totImpulseNs,
        tcMotorId: tcMotor.motorId
    };
    const delays = tcMotor.delays?.split(",");
    const delay = parseInt($543e439f036f1dfe$export$902f197adee116a0(delays ?? []));
    if (!isNaN(delay)) motor.delay = delay;
    const color = [
        $543e439f036f1dfe$export$902f197adee116a0((0, $42a584c902e2bfd5$export$56d196d2844d1ca1)),
        $543e439f036f1dfe$export$902f197adee116a0((0, $42a584c902e2bfd5$export$56d196d2844d1ca1)),
        $543e439f036f1dfe$export$902f197adee116a0((0, $42a584c902e2bfd5$export$56d196d2844d1ca1)),
        $543e439f036f1dfe$export$902f197adee116a0((0, $42a584c902e2bfd5$export$56d196d2844d1ca1))
    ].slice($543e439f036f1dfe$export$e87bfa2a4c6bccb0(4)).join();
    const rocket = {
        name: $543e439f036f1dfe$export$902f197adee116a0($543e439f036f1dfe$var$ROCKET_NAMES),
        manufacturer: $543e439f036f1dfe$export$902f197adee116a0($543e439f036f1dfe$var$ROCKET_VENDORS),
        color: color,
        diameter: diameter,
        length: length,
        mass: mass,
        _motor: motor
    };
    return rocket;
}





var $aaa72a458935fe7a$export$490c7ce941281ba8;
(function(CardStatus) {
    CardStatus["DRAFT"] = "draft";
    CardStatus["REVIEW"] = "review";
    CardStatus["FLY"] = "fly";
    CardStatus["DONE"] = "done";
})($aaa72a458935fe7a$export$490c7ce941281ba8 || ($aaa72a458935fe7a$export$490c7ce941281ba8 = {}));
var $aaa72a458935fe7a$export$7945d2ac175424cc;
(function(CertLevel) {
    CertLevel[CertLevel["NONE"] = 0] = "NONE";
    CertLevel[CertLevel["L1"] = 1] = "L1";
    CertLevel[CertLevel["L2"] = 2] = "L2";
    CertLevel[CertLevel["L3"] = 3] = "L3";
})($aaa72a458935fe7a$export$7945d2ac175424cc || ($aaa72a458935fe7a$export$7945d2ac175424cc = {}));
var $aaa72a458935fe7a$export$67788f4001cebb21;
(function(CertOrg) {
    CertOrg["NAR"] = "NAR";
    CertOrg["TRA"] = "TRA";
})($aaa72a458935fe7a$export$67788f4001cebb21 || ($aaa72a458935fe7a$export$67788f4001cebb21 = {}));
var $aaa72a458935fe7a$export$5cfb7a58c44e97d1;
(function(Recovery) {
    Recovery["CHUTE"] = "chute";
    Recovery["STREAMER"] = "streamer";
    Recovery["DUAL_DEPLOY"] = "dual-deploy";
    Recovery["TUMBLE"] = "tumble";
    Recovery["GLIDE"] = "glide";
    Recovery["HELICOPTER"] = "helicopter";
})($aaa72a458935fe7a$export$5cfb7a58c44e97d1 || ($aaa72a458935fe7a$export$5cfb7a58c44e97d1 = {}));


const $f31a31c32b1a153a$var$MOCK_ID_PREFIX = "FC_";
const $f31a31c32b1a153a$var$LAUNCH_NAMES = [
    // 'AP Showers',
    // 'Spring Thunder',
    // 'NXRS',
    // 'Summer Skies',
    // 'Sod Blaster (TCR)',
    // 'Rocketober',
    // "Fillible's Folly",
    "Arbuckle Classic",
    "Tsiolkovsky Jamboree"
];
const $f31a31c32b1a153a$var$PADS = [
    {
        name: "1-1",
        group: "Low-Power"
    },
    {
        name: "1-2",
        group: "Low-Power"
    },
    {
        name: "1-3",
        group: "Low-Power"
    },
    {
        name: "1-4",
        group: "Low-Power"
    },
    {
        name: "2-1",
        group: "Mid-Power"
    },
    {
        name: "2-2",
        group: "Mid-Power"
    },
    {
        name: "2-3",
        group: "Mid-Power"
    },
    {
        name: "2-4",
        group: "Mid-Power"
    },
    {
        name: "3-1",
        group: "High-Power (west)"
    },
    {
        name: "3-2",
        group: "High-Power (west)"
    },
    {
        name: "3-3",
        group: "High-Power (west)"
    },
    {
        name: "3-4",
        group: "High-Power (west)"
    },
    {
        name: "4-1",
        group: "High-Power (east)"
    },
    {
        name: "4-2",
        group: "High-Power (east)"
    },
    {
        name: "4-3",
        group: "High-Power (east)"
    },
    {
        name: "4-4",
        group: "High-Power (east)"
    },
    {
        name: "Away Cell"
    },
    {
        name: "Hilltop"
    }
];
let $f31a31c32b1a153a$var$seedIds = {};
function $f31a31c32b1a153a$var$genId(idType = "id") {
    const id = $f31a31c32b1a153a$var$seedIds[idType] = ($f31a31c32b1a153a$var$seedIds[idType] ?? 0) + 1;
    return `${$f31a31c32b1a153a$var$MOCK_ID_PREFIX}${idType}_${String(id).padStart(2, "0")}`;
}
function $f31a31c32b1a153a$var$genReset() {
    $f31a31c32b1a153a$var$seedIds = {};
}
function $f31a31c32b1a153a$export$e27e8a613b80545b(id) {
    id = typeof id === "string" ? id : id.id;
    return id.startsWith($f31a31c32b1a153a$var$MOCK_ID_PREFIX);
}
// Save in-memory model to the database
async function $f31a31c32b1a153a$var$persistRoot(root) {
    // Users
    const transaction = (0, $febfa929b76327ac$export$bc6fa55e832fa0cb)();
    for (const [authId, user] of Object.entries(root.users))transaction.update((0, $71b3f0397fe2ca79$export$1ba679a5cc178147).with({
        authId: authId
    }), user);
    for (const [launchId, launch] of Object.entries(root.launches))transaction.update((0, $71b3f0397fe2ca79$export$90058626e653e0cd).with({
        launchId: launchId
    }), launch);
    for (const [launchId, pads] of Object.entries(root.pads))transaction.update((0, $71b3f0397fe2ca79$export$83289c7452cd8ea9).with({
        launchId: launchId
    }), pads);
    for (const [launchId, cards] of Object.entries(root.cards))transaction.update((0, $71b3f0397fe2ca79$export$d7220bf6225e19b7).with({
        launchId: launchId
    }), cards);
    for (const [launchId, attendees] of Object.entries(root.attendees))transaction.update((0, $71b3f0397fe2ca79$export$ac9b3f0445b3a6da).with({
        launchId: launchId
    }), attendees);
    for (const [launchId, officers] of Object.entries(root.officers))transaction.update((0, $71b3f0397fe2ca79$export$50e9aca848382ff9).with({
        launchId: launchId
    }), officers);
    // Log actions to be taken
    for (const [path, state] of Object.entries(transaction.updates))(0, $11e801b827ed84d2$export$bef1f36f5486a6a3)(String(path), state);
    await transaction.commit();
}
function $f31a31c32b1a153a$var$mockRoot() {
    return {
        attendees: {},
        cards: {},
        launches: {},
        officers: {},
        pads: {},
        users: {}
    };
}
async function $f31a31c32b1a153a$var$mockUsers(root) {
    const names = new Set();
    while(names.size < 20)names.add((0, $543e439f036f1dfe$export$902f197adee116a0)((0, $543e439f036f1dfe$export$776a922db93662cb)));
    for (const name of names){
        const n = Math.random();
        let photoURL = (0, $febfa929b76327ac$export$4bd2facc4a3e6aa1);
        if (n < 0.3) photoURL = `https://randomuser.me/api/portraits/men/${(0, $543e439f036f1dfe$export$e87bfa2a4c6bccb0)(100)}.jpg`;
        else if (n < 0.6) photoURL = `https://randomuser.me/api/portraits/women/${(0, $543e439f036f1dfe$export$e87bfa2a4c6bccb0)(100)}.jpg`;
        else if (n < 0.7) photoURL = `https://randomuser.me/api/portraits/lego/${(0, $543e439f036f1dfe$export$e87bfa2a4c6bccb0)(10)}.jpg`;
        const id = $f31a31c32b1a153a$var$genId("user");
        root.users[id] = {
            id: id,
            name: name,
            photoURL: photoURL
        };
    }
    return root;
}
function $f31a31c32b1a153a$var$mockLaunches(root) {
    for (const [i, name] of $f31a31c32b1a153a$var$LAUNCH_NAMES.entries()){
        const host = (0, $543e439f036f1dfe$export$902f197adee116a0)([
            {
                host: "OROC",
                location: "Brothers, OR"
            },
            {
                host: "TCR",
                location: "Pasco, WA"
            }
        ]);
        const startDate = new Date(Date.now() + (i - 2) * 2592000000);
        const endDate = new Date(startDate.getTime() + 259200000);
        const id = $f31a31c32b1a153a$var$genId("launch");
        root.launches[id] = {
            id: id,
            name: name,
            ...host,
            startDate: startDate.toISOString().replace(/T.*/, ""),
            endDate: endDate.toISOString().replace(/T.*/, "")
        };
    }
}
function $f31a31c32b1a153a$var$mockCerts(name = "") {
    const [firstName, lastName] = (name ?? "").split(" ");
    const certs = {};
    for (const organization of [
        (0, $aaa72a458935fe7a$export$67788f4001cebb21).NAR,
        (0, $aaa72a458935fe7a$export$67788f4001cebb21).TRA
    ]){
        if (!(0, $543e439f036f1dfe$export$e87bfa2a4c6bccb0)(2)) continue;
        certs[organization] = {
            firstName: firstName,
            lastName: lastName,
            level: (0, $543e439f036f1dfe$export$902f197adee116a0)([
                0,
                0,
                1,
                1,
                1,
                2,
                2,
                2,
                3
            ]),
            organization: organization,
            memberId: 3000 + (0, $543e439f036f1dfe$export$e87bfa2a4c6bccb0)(15000),
            expires: Date.now() + (0, $543e439f036f1dfe$export$e87bfa2a4c6bccb0)(31536000000)
        };
    }
    return Object.keys(certs).length ? certs : (0, $febfa929b76327ac$export$4bd2facc4a3e6aa1);
}
function $f31a31c32b1a153a$var$mockAttendees(root, launchId) {
    if (!launchId) {
        for (const launchId of Object.keys(root.launches))$f31a31c32b1a153a$var$mockAttendees(root, launchId);
        return;
    }
    if (!(launchId in root.launches)) throw Error(`No launch ${launchId}`);
    root.attendees[launchId] = {};
    const uid = (0, $febfa929b76327ac$export$73693bad9f5880b0).currentUser?.uid;
    if (uid) root.attendees[launchId][uid] = {
        id: uid,
        name: "You!",
        waiverTime: Date.now()
    };
    for (const user of Object.values(root.users).slice(0, 20)){
        const attendee = {
            ...user,
            certs: $f31a31c32b1a153a$var$mockCerts(user.name),
            waiverTime: Math.random() < 0.95 ? Date.now() - Math.random() * 31536000000 : (0, $febfa929b76327ac$export$4bd2facc4a3e6aa1)
        };
        root.attendees[launchId][attendee.id] = attendee;
    }
    return root;
}
function $f31a31c32b1a153a$var$mockOfficers(root, launchId) {
    if (!launchId) {
        for (const launchId of Object.keys(root.launches))$f31a31c32b1a153a$var$mockOfficers(root, launchId);
        return;
    }
    const attendees = Object.values(root.attendees[launchId]);
    root.officers[launchId] = {};
    // Designate officers
    for(let i = 0; i < attendees.length / 5; i++)root.officers[launchId][(0, $543e439f036f1dfe$export$902f197adee116a0)(attendees).id] = true;
    // Current user should be an officer
    if ((0, $febfa929b76327ac$export$73693bad9f5880b0).currentUser?.uid) root.officers[launchId][(0, $febfa929b76327ac$export$73693bad9f5880b0).currentUser.uid] = true;
    for (const attendee of attendees){
        if (!attendee.certs) continue;
        for (const cert of Object.values(attendee.certs)){
            if (cert.level <= 0 || Math.random() < 0.5) continue;
            cert.verifiedId = (0, $543e439f036f1dfe$export$902f197adee116a0)(Object.keys(root.officers[launchId]));
            cert.verifiedTime = Date.now() - (0, $543e439f036f1dfe$export$e87bfa2a4c6bccb0)(31536000000);
        }
    }
}
function $f31a31c32b1a153a$var$mockPads(root, launchId) {
    if (!launchId) {
        for (const launchId of Object.keys(root.launches))$f31a31c32b1a153a$var$mockPads(root, launchId);
        return;
    }
    root.pads[launchId] = {};
    // Seed pads
    for (const pad of $f31a31c32b1a153a$var$PADS){
        const id = $f31a31c32b1a153a$var$genId("pad");
        root.pads[launchId][id] = {
            id: id,
            ...pad
        };
    }
}
function $f31a31c32b1a153a$var$_mockCard(props) {
    const id = $f31a31c32b1a153a$var$genId("card");
    const rocket = (0, $543e439f036f1dfe$export$33af164380fc4c08)();
    const { _motor: motor  } = rocket;
    delete rocket._motor;
    if (motor) motor.id = $f31a31c32b1a153a$var$genId("motor");
    return {
        id: id,
        firstFlight: Math.random() < 0.2 || (0, $febfa929b76327ac$export$4bd2facc4a3e6aa1),
        headsUp: Math.random() < 0.2 || (0, $febfa929b76327ac$export$4bd2facc4a3e6aa1),
        notes: "Randomly generated flight card",
        rocket: rocket,
        motors: motor ? {
            [motor.id]: motor
        } : (0, $febfa929b76327ac$export$4bd2facc4a3e6aa1),
        ...props
    };
}
async function $f31a31c32b1a153a$var$mockCards(root, launchId) {
    if (!launchId) {
        for (const launchId of Object.keys(root.launches))$f31a31c32b1a153a$var$mockCards(root, launchId);
        return;
    }
    const padIds = Object.keys(root.pads[launchId]);
    const officers = Object.keys(root.officers[launchId]);
    root.cards[launchId] = {};
    // Number of cards to create for this user
    const cardDistributions = [
        [
            (0, $aaa72a458935fe7a$export$490c7ce941281ba8).DRAFT,
            2
        ],
        [
            (0, $aaa72a458935fe7a$export$490c7ce941281ba8).REVIEW,
            3
        ],
        [
            (0, $aaa72a458935fe7a$export$490c7ce941281ba8).FLY,
            3
        ],
        [
            (0, $aaa72a458935fe7a$export$490c7ce941281ba8).DONE,
            5
        ]
    ];
    // Seed cards for each user
    let nCards = 0;
    for (const userId of Object.keys(root.attendees[launchId])){
        for (const [status, n] of cardDistributions)for(let i = 0; i < n; i++){
            let rsoId = (0, $febfa929b76327ac$export$4bd2facc4a3e6aa1);
            let padId = (0, $febfa929b76327ac$export$4bd2facc4a3e6aa1);
            let lcoId = (0, $febfa929b76327ac$export$4bd2facc4a3e6aa1);
            if (status === (0, $aaa72a458935fe7a$export$490c7ce941281ba8).DRAFT) // Mark some cards as ready for RSO review
            {
                if (nCards % 2) rsoId = (0, $543e439f036f1dfe$export$902f197adee116a0)(officers);
            } else if (status === (0, $aaa72a458935fe7a$export$490c7ce941281ba8).FLY) {
                // FLY requires RSO sign-off
                rsoId = (0, $543e439f036f1dfe$export$902f197adee116a0)(officers);
                // Assign some cards to pads
                if (nCards % 3) padId = (0, $543e439f036f1dfe$export$902f197adee116a0)(padIds);
            } else if (status === (0, $aaa72a458935fe7a$export$490c7ce941281ba8).DONE) {
                // Completed flights
                lcoId = (0, $543e439f036f1dfe$export$902f197adee116a0)(officers);
                rsoId = (0, $543e439f036f1dfe$export$902f197adee116a0)(officers);
                padId = (0, $543e439f036f1dfe$export$902f197adee116a0)(padIds);
            }
            const card = $f31a31c32b1a153a$var$_mockCard({
                launchId: launchId,
                userId: userId,
                rsoId: rsoId,
                lcoId: lcoId,
                status: status,
                padId: padId
            });
            root.cards[launchId][card.id] = card;
            nCards++;
        }
    }
    return root;
}
async function $f31a31c32b1a153a$var$unseedDB() {
    for (const collection of [
        "attendees",
        "cards",
        "launches",
        "officers",
        "pads",
        "users"
    ]){
        (0, $11e801b827ed84d2$export$bef1f36f5486a6a3)("Purging", collection);
        const collectionPath = new (0, $ada1a645c4c4dba1$export$adde49a0578c7691)(":collection", {
            collection: collection
        });
        const obj = await (0, $febfa929b76327ac$export$c10e31973268dac4)(collectionPath.with({
            collection: collection
        }));
        if (!obj) return;
        await Promise.all(Object.keys(obj).filter((key)=>key.startsWith($f31a31c32b1a153a$var$MOCK_ID_PREFIX)).map((key)=>{
            const itemPath = collectionPath.append(":key", {
                key: key
            });
            (0, $11e801b827ed84d2$export$bef1f36f5486a6a3)("Removing", itemPath);
            return (0, $febfa929b76327ac$export$3f3cbd6c9a0055d0)(itemPath);
        }));
    }
}
async function $f31a31c32b1a153a$var$seedDB() {
    await $f31a31c32b1a153a$var$unseedDB();
    $f31a31c32b1a153a$var$genReset();
    const root = $f31a31c32b1a153a$var$mockRoot();
    $f31a31c32b1a153a$var$mockUsers(root);
    $f31a31c32b1a153a$var$mockLaunches(root);
    $f31a31c32b1a153a$var$mockAttendees(root);
    $f31a31c32b1a153a$var$mockOfficers(root);
    $f31a31c32b1a153a$var$mockPads(root);
    $f31a31c32b1a153a$var$mockCards(root);
    await $f31a31c32b1a153a$var$persistRoot(root);
    (0, $11e801b827ed84d2$export$bef1f36f5486a6a3)("-- Fin --");
}
function $f31a31c32b1a153a$export$2e2bcd8739ae039() {
    const [running, setRunning] = (0, $8T3gX.useState)(false);
    function onSeedClick() {
        if (!confirm("Really regenerate all mocked data?")) return;
        (0, $11e801b827ed84d2$export$42ffd38884aecdac)();
        setRunning(true);
        $f31a31c32b1a153a$var$seedDB().finally(()=>setRunning(false));
    }
    function onUnseedClick() {
        if (!confirm("Really remove all mocked data?")) return;
        (0, $11e801b827ed84d2$export$42ffd38884aecdac)();
        setRunning(true);
        $f31a31c32b1a153a$var$unseedDB().finally(()=>setRunning(false));
    }
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                disabled: running,
                variant: "warning",
                onClick: onSeedClick,
                children: "Mock: Generate"
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                disabled: running,
                variant: "warning",
                onClick: onUnseedClick,
                children: "Mock: Clear"
            })
        ]
    });
}



parcelRequire("8T3gX");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2914d071bbef92ec$export$7a7adbcc2fafd347(arr, extract) {
    let extractor;
    if (typeof extract === "string") {
        const prop = extract;
        extractor = function(item) {
            return item[prop];
        };
    } else extractor = extract;
    function comparator(a, b) {
        const av = extractor(a);
        const bv = extractor(b);
        return av < bv ? -1 : av > bv ? 1 : 0;
    }
    arr.sort(comparator);
    return arr;
}
function $2914d071bbef92ec$var$_arrayGroupPush(groups, key, item) {
    let group = groups.get(key);
    if (group == null) groups.set(key, group = []);
    group.push(item);
}
function $2914d071bbef92ec$export$ab5e74a2c43c30ea(arr, extract) {
    const itemsByGroup = new Map();
    if (typeof extract === "string") return $2914d071bbef92ec$export$ab5e74a2c43c30ea(arr, (item)=>item[extract]);
    for (const v of arr){
        const keys = extract(v);
        if (keys == null) throw Error("Null or undefined group key");
        if (!Array.isArray(keys)) $2914d071bbef92ec$var$_arrayGroupPush(itemsByGroup, keys, v);
        else for (const key of keys)$2914d071bbef92ec$var$_arrayGroupPush(itemsByGroup, key, v);
    }
    return itemsByGroup;
}






async function $1bd9d913308319b7$var$handleClick() {
    (0, $11e801b827ed84d2$export$42ffd38884aecdac)();
    (0, $11e801b827ed84d2$export$bef1f36f5486a6a3)(/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h3", {
        children: "Fetching cards..."
    }));
    const allCards = await (0, $febfa929b76327ac$export$c10e31973268dac4)((0, $71b3f0397fe2ca79$export$24d8af51036a7c7));
    const motorCounts = {};
    for (const [launchId, cards] of Object.entries(allCards)){
        (0, $11e801b827ed84d2$export$bef1f36f5486a6a3)(/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("h4", {
            children: [
                "Launch ",
                launchId
            ]
        }));
        for (const card of Object.values(cards)){
            if (!card.motors) continue;
            for (const { tcMotorId: tcMotorId  } of Object.values(card.motors)){
                if (!tcMotorId) continue;
                motorCounts[tcMotorId] = (motorCounts[tcMotorId] ?? 0) + 1;
            }
        }
    }
    const counts = (0, $2914d071bbef92ec$export$7a7adbcc2fafd347)(Object.entries(motorCounts), ([, count])=>count).reverse();
    for (const [tcMotorId, count] of counts){
        const tcMotor = (0, $0e759b381c300a7c$export$6ef5e39af8f569c9)(tcMotorId);
        (0, $11e801b827ed84d2$export$bef1f36f5486a6a3)(count, tcMotor?.manufacturerAbbrev, tcMotor?.commonName);
    }
}
function $1bd9d913308319b7$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
        variant: "info",
        onClick: ()=>{
            $1bd9d913308319b7$var$handleClick().catch((err)=>{
                (0, $11e801b827ed84d2$export$bef1f36f5486a6a3)(err);
                console.error(err);
            });
        },
        children: "Motor Stats"
    });
}



parcelRequire("8T3gX");




async function $2531980d0cb3a2d2$var$handleClick() {
    const user = (0, $febfa929b76327ac$export$73693bad9f5880b0).currentUser;
    const uid = user?.uid;
    (0, $11e801b827ed84d2$export$42ffd38884aecdac)();
    async function testAccess(path) {
        const rtpath = new (0, $ada1a645c4c4dba1$export$adde49a0578c7691)(path);
        let canRead, canWrite;
        try {
            await (0, $febfa929b76327ac$export$c10e31973268dac4)(rtpath);
            canRead = true;
        } catch (err) {}
        try {
            await (0, $febfa929b76327ac$export$78d8dceb730843fa)(rtpath, {
                _temp: true
            });
            await (0, $febfa929b76327ac$export$78d8dceb730843fa)(rtpath, {
                _temp: null
            });
            canWrite = true;
        } catch (err) {}
        return `${canRead ? "✅" : "❌"} ${canWrite ? "✅" : "❌"} ${path}`;
    }
    await Promise.all([
        testAccess("test/foo"),
        "---",
        testAccess("users"),
        testAccess("users/otherUser"),
        testAccess(`users/${uid}`),
        "---",
        testAccess("attendees"),
        testAccess("attendees/otherLaunch"),
        testAccess("attendees/otherLaunch/otherUser"),
        testAccess(`attendees/fc_launch098/${uid}`),
        "---",
        testAccess("officers"),
        testAccess("officers/testLaunch"),
        testAccess("officers/testLaunch/testUser"),
        testAccess(`officers/testLaunch/${uid}`),
        "---",
        testAccess("cards"),
        testAccess("cards/testLaunch"),
        testAccess("cards/testLaunch/testCard")
    ]).then((results)=>results.forEach((v)=>(0, $11e801b827ed84d2$export$bef1f36f5486a6a3)(v)));
}
function $2531980d0cb3a2d2$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
        variant: "info",
        onClick: $2531980d0cb3a2d2$var$handleClick,
        children: "Test Database Access"
    });
}



parcelRequire("8T3gX");



async function $c4ee24be6ed32629$var$handleClick() {
    (0, $11e801b827ed84d2$export$42ffd38884aecdac)();
    (0, $11e801b827ed84d2$export$bef1f36f5486a6a3)("Starting tests");
    function expectUnit(v, unit, expected) {
        const actual = parseFloat((0, $a53c6536bb8a7347$export$26c3d0b70508b36c)(v, unit).toPrecision(4));
        if (isNaN(actual) && isNaN(expected) || actual === expected) (0, $11e801b827ed84d2$export$bef1f36f5486a6a3)("✅", v, "to", unit, "=", expected);
        else (0, $11e801b827ed84d2$export$bef1f36f5486a6a3)("❌", v, "to", unit, "=", String(actual), `(expected ${expected})`);
    }
    // Misc
    expectUnit("1.23", (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).mass, 1.23); // unitless
    expectUnit("-1.23", (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).mass, -1.23); // negative
    expectUnit("1ft", (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).mass, NaN); // incompatible units
    // Incompatible units
    // Metric units
    expectUnit("1m", (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).length, 1);
    expectUnit("1kg", (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).mass, 1);
    expectUnit("1n", (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).force, 1);
    expectUnit("1n-s", (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).impulse, 1);
    expectUnit("1n-sec", (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).impulse, 1);
    // US length
    expectUnit("1ft", (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).length, 0.3048);
    expectUnit("1 ft", (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).length, 0.3048);
    expectUnit("1 FT", (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).length, 0.3048);
    expectUnit("1'", (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).length, 0.3048);
    expectUnit("1in", (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).length, 0.0254);
    expectUnit('1"', (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).length, 0.0254);
    expectUnit("1ft1in", (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).length, 0.3302);
    expectUnit("1 ft 1 in", (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).length, 0.3302);
    expectUnit("1ft 1in", (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).length, 0.3302);
    expectUnit("1cm", (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).length, 0.01);
    expectUnit("1mm", (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).length, 0.001);
    // test mass
    expectUnit("1lb", (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).mass, 0.4536);
    expectUnit("1oz", (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).mass, 0.02835);
    expectUnit("1lb1oz", (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).mass, 0.4819);
    expectUnit("1g", (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).mass, 0.001);
    // test force
    expectUnit("1lbf", (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).force, 4.448);
    // test impulse
    expectUnit("1lbf-s", (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).impulse, 4.448);
    expectUnit("1lbf-sec", (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).impulse, 4.448);
}
function $c4ee24be6ed32629$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
        variant: "info",
        onClick: $c4ee24be6ed32629$var$handleClick,
        children: "Test Units"
    });
}


function $edcfd3fe3755e00b$export$2e2bcd8739ae039() {
    const log = (0, $11e801b827ed84d2$export$d05b0649e996f88)();
    const logList = (0, $8T3gX.useRef)(null);
    (0, $8T3gX.useEffect)(()=>{
        const logEl = logList.current;
        if (!logEl) return;
        // @ts-ignore - typescript doesn't know about scrollTo
        logEl.lastChild?.scrollIntoView({
            behavior: "smooth"
        });
    }, [
        log
    ]);
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h2", {
                children: "Probably-Safe Zone"
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("section", {
                className: "deck",
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $2531980d0cb3a2d2$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $c4ee24be6ed32629$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $1bd9d913308319b7$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h2", {
                children: "Danger Zone"
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("section", {
                className: "deck",
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $f31a31c32b1a153a$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $8611998942a98b80$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                ref: logList,
                className: "mt-4 text-dark font-monospace",
                style: {
                    fontSize: "9pt"
                },
                children: log.map((args, i)=>{
                    if (/*#__PURE__*/ (0, $8T3gX.isValidElement)(args[0])) return /*#__PURE__*/ (0, $8T3gX.cloneElement)(args[0], {
                        key: i
                    });
                    const err = args.find((v)=>v instanceof Error);
                    args = args.map((v)=>{
                        if (v === undefined) return "undefined";
                        const cons = Object.getPrototypeOf(v)?.constructor;
                        if (cons === Object || cons === Array) return JSON.stringify(v);
                        return v;
                    });
                    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                        className: err ? "text-danger" : "",
                        children: args.join(" ")
                    }, i);
                })
            })
        ]
    });
}







var $8T3gX = parcelRequire("8T3gX");


var $3T949 = parcelRequire("3T949");parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

parcelRequire("8T3gX");

var $3T949 = parcelRequire("3T949");



var $8b442f6bb87f057c$exports = {};
$8b442f6bb87f057c$exports = function(strings, ...exps) {
    const result = [];
    const { isArray: isArray  } = Array;
    // Convert quantity expressions to [quantity, quantity string] tuples
    exps.forEach((v, i)=>{
        if (typeof v == "number") exps[i] = [
            v,
            v
        ];
        else if (isArray(v)) {
            if (typeof v[0] == "number") exps[i] = [
                v[0],
                typeof v[1] == "function" ? v[1](v[0]) : null
            ];
            else // Edge case where the caller injects an Array but doesn't intend for it
            // to be treated as a quantity.  Not worth solving at present.
            throw TypeError("First item in array must be a Number");
        }
    });
    // Initialize the quantity to use for pluralization
    let qty = exps.find(isArray);
    let last;
    for (let s of strings){
        // Trim leading whitespace hidden quantities
        if (isArray(last) && last[1] == null) s = s.replace(/^\s+/, "");
        // Push current string, pluralizing if we have a valid quantity
        if (qty) result.push(s.replace(/\[([^|]*)\|([^\]]*)\]/g, qty[0] == 1 ? "$1" : "$2"));
        else result.push(s);
        if (!exps.length) break;
        // Locate next quantity
        qty = exps.find(isArray) || qty;
        // Push quantity string
        last = exps.shift();
        result.push(last === qty ? qty[1] : last);
    }
    return result.join("");
};





parcelRequire("8T3gX");

parcelRequire("8T3gX");


var $8T3gX = parcelRequire("8T3gX");



const $bf2b0d5c4b4f72cf$var$noop = ()=>undefined;
const $bf2b0d5c4b4f72cf$var$ToggleButton = /*#__PURE__*/ $8T3gX.forwardRef(({ bsPrefix: bsPrefix , name: name , className: className , checked: checked , type: type , onChange: onChange , value: value , disabled: disabled , id: id , inputRef: inputRef , ...props }, ref)=>{
    bsPrefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, "btn-check");
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("input", {
                className: bsPrefix,
                name: name,
                type: type,
                value: value,
                ref: inputRef,
                autoComplete: "off",
                checked: !!checked,
                disabled: !!disabled,
                onChange: onChange || $bf2b0d5c4b4f72cf$var$noop,
                id: id
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                ...props,
                ref: ref,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, disabled && "disabled"),
                type: undefined,
                role: undefined,
                as: "label",
                htmlFor: id
            })
        ]
    });
});
$bf2b0d5c4b4f72cf$var$ToggleButton.displayName = "ToggleButton";
var $bf2b0d5c4b4f72cf$export$2e2bcd8739ae039 = $bf2b0d5c4b4f72cf$var$ToggleButton;


var $8T3gX = parcelRequire("8T3gX");


/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $198ccd59a96f9030$var$createChainedFunction(...funcs) {
    return funcs.filter((f)=>f != null).reduce((acc, f)=>{
        if (typeof f !== "function") throw new Error("Invalid Argument Type, must only provide functions, undefined, or null.");
        if (acc === null) return f;
        return function chainedFunction(...args) {
            // @ts-ignore
            acc.apply(this, args);
            // @ts-ignore
            f.apply(this, args);
        };
    }, null);
}
var $198ccd59a96f9030$export$2e2bcd8739ae039 = $198ccd59a96f9030$var$createChainedFunction;





var $8T3gX = parcelRequire("8T3gX");


const $6cb1eff92841402c$var$ButtonGroup = /*#__PURE__*/ $8T3gX.forwardRef(({ bsPrefix: bsPrefix , size: size , vertical: vertical = false , className: className , role: role = "group" , // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div" , ...rest }, ref)=>{
    const prefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, "btn-group");
    let baseClass = prefix;
    if (vertical) baseClass = `${prefix}-vertical`;
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(Component, {
        ...rest,
        ref: ref,
        role: role,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, baseClass, size && `${prefix}-${size}`)
    });
});
$6cb1eff92841402c$var$ButtonGroup.displayName = "ButtonGroup";
var $6cb1eff92841402c$export$2e2bcd8739ae039 = $6cb1eff92841402c$var$ButtonGroup;




const $48662f9e660678c6$var$ToggleButtonGroup = /*#__PURE__*/ $8T3gX.forwardRef((props, ref)=>{
    const { children: children , type: type = "radio" , name: name , value: value , onChange: onChange , vertical: vertical = false , ...controlledProps } = (0, $43a5c6b75c3b0a1f$export$2e2bcd8739ae039)(props, {
        value: "onChange"
    });
    const getValues = ()=>value == null ? [] : [].concat(value);
    const handleToggle = (inputVal, event)=>{
        if (!onChange) return;
        const values = getValues();
        const isActive = values.indexOf(inputVal) !== -1;
        if (type === "radio") {
            if (!isActive) onChange(inputVal, event);
            return;
        }
        if (isActive) onChange(values.filter((n)=>n !== inputVal), event);
        else onChange([
            ...values,
            inputVal
        ], event);
    };
    !(type !== "radio" || !!name) && (0, (/*@__PURE__*/$parcel$interopDefault($e72804049adef0ff$exports)))(false);
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $6cb1eff92841402c$export$2e2bcd8739ae039), {
        ...controlledProps,
        ref: ref,
        vertical: vertical,
        children: (0, $12dab14d68f3cfa3$export$871de8747c9eaa88)(children, (child)=>{
            const values = getValues();
            const { value: childVal , onChange: childOnChange  } = child.props;
            const handler = (e)=>handleToggle(childVal, e);
            return /*#__PURE__*/ $8T3gX.cloneElement(child, {
                type: type,
                name: child.name || name,
                checked: values.indexOf(childVal) !== -1,
                onChange: (0, $198ccd59a96f9030$export$2e2bcd8739ae039)(childOnChange, handler)
            });
        })
    });
});
var $48662f9e660678c6$export$2e2bcd8739ae039 = Object.assign($48662f9e660678c6$var$ToggleButtonGroup, {
    Button: (0, $bf2b0d5c4b4f72cf$export$2e2bcd8739ae039)
});




function $2b27acfe5408b34d$export$2e2bcd8739ae039({ authId: authId , ...props }) {
    const rtpath = (0, $71b3f0397fe2ca79$export$e718fbba97c40982).with({
        authId: authId
    });
    const [units] = (0, $febfa929b76327ac$export$fe4c1a3a7af84c36)(rtpath);
    function setUnits(unitsName) {
        (0, $febfa929b76327ac$export$2ef6846d36515d5)(rtpath, unitsName);
    }
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $48662f9e660678c6$export$2e2bcd8739ae039), {
        ...props,
        name: "units",
        value: units,
        type: "radio",
        onChange: (val)=>{
            setUnits(val);
        },
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $bf2b0d5c4b4f72cf$export$2e2bcd8739ae039), {
                variant: "outline-primary",
                size: "sm",
                id: "unit-mks",
                value: "mks",
                style: {
                    fontSize: "1.4em",
                    lineHeight: "1.4em",
                    padding: "0 0.5em"
                },
                children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("span", {
                    className: "no-invert",
                    children: "\uD83C\uDF0E"
                })
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $bf2b0d5c4b4f72cf$export$2e2bcd8739ae039), {
                variant: "outline-primary",
                size: "sm",
                id: "unit-uscs",
                value: "uscs",
                style: {
                    fontSize: "2em",
                    lineHeight: "0.9em",
                    padding: "0 0.2em"
                },
                children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("span", {
                    className: "no-invert",
                    children: "\uD83C\uDDFA\uD83C\uDDF8"
                })
            })
        ]
    });
}



function $4beabeb039e49562$export$d7fd01694c28dc31() {
    const [attendee] = (0, $de6e1888d0a1ea86$export$67c1131f3997904d)();
    if (!attendee) return null;
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
        style: {
            width: "6em"
        },
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $2b27acfe5408b34d$export$2e2bcd8739ae039), {
                authId: attendee.id,
                className: "mt-1 me-1"
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                style: {
                    fontSize: "9pt",
                    textAlign: "center",
                    color: "gray"
                },
                children: "Units"
            })
        ]
    });
}


var $fa48cfc9bb1a0ff0$exports = {};

$parcel$export($fa48cfc9bb1a0ff0$exports, "manufacturer", () => $fa48cfc9bb1a0ff0$export$87207bc1e5a2da39, (v) => $fa48cfc9bb1a0ff0$export$87207bc1e5a2da39 = v);
$parcel$export($fa48cfc9bb1a0ff0$exports, "notes", () => $fa48cfc9bb1a0ff0$export$fff9cb9cb797a870, (v) => $fa48cfc9bb1a0ff0$export$fff9cb9cb797a870 = v);
$parcel$export($fa48cfc9bb1a0ff0$exports, "special", () => $fa48cfc9bb1a0ff0$export$83aa05add7fe0e17, (v) => $fa48cfc9bb1a0ff0$export$83aa05add7fe0e17 = v);
var $fa48cfc9bb1a0ff0$export$87207bc1e5a2da39;
var $fa48cfc9bb1a0ff0$export$fff9cb9cb797a870;
var $fa48cfc9bb1a0ff0$export$83aa05add7fe0e17;
$fa48cfc9bb1a0ff0$export$87207bc1e5a2da39 = `_08ZLAG_manufacturer`;
$fa48cfc9bb1a0ff0$export$fff9cb9cb797a870 = `_08ZLAG_notes`;
$fa48cfc9bb1a0ff0$export$83aa05add7fe0e17 = `_08ZLAG_special`;



parcelRequire("8T3gX");
var $14a31e0d70f5283a$exports = {};

$parcel$export($14a31e0d70f5283a$exports, "officerStar", () => $14a31e0d70f5283a$export$c2f50f684176172d, (v) => $14a31e0d70f5283a$export$c2f50f684176172d = v);
$parcel$export($14a31e0d70f5283a$exports, "role", () => $14a31e0d70f5283a$export$3100efae45e879, (v) => $14a31e0d70f5283a$export$3100efae45e879 = v);
$parcel$export($14a31e0d70f5283a$exports, "root", () => $14a31e0d70f5283a$export$e8e78c978b129247, (v) => $14a31e0d70f5283a$export$e8e78c978b129247 = v);
var $14a31e0d70f5283a$export$c2f50f684176172d;
var $14a31e0d70f5283a$export$3100efae45e879;
var $14a31e0d70f5283a$export$e8e78c978b129247;
$14a31e0d70f5283a$export$c2f50f684176172d = `ooZJJW_officerStar`;
$14a31e0d70f5283a$export$3100efae45e879 = `ooZJJW_role`;
$14a31e0d70f5283a$export$e8e78c978b129247 = `ooZJJW_root`;


var $2a7ab24620fae6be$exports = {};

$2a7ab24620fae6be$exports = new URL((parcelRequire("bCIFA")).resolve("4Njdi"), import.meta.url).toString();




parcelRequire("8T3gX");

parcelRequire("8T3gX");


function $3fa1314cc730edf3$export$c688898c4e3580ee({ className: className , children: children , ...props }) {
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("span", {
        className: (0, $a147a5343133f2a5$export$1343a74baacb0543)(className, `warning`),
        ...props,
        children: [
            "⚠",
            " ",
            children
        ]
    });
}



function $d5b1995fb206c61d$export$e070336f589a23cb(attendee) {
    const cert = $d5b1995fb206c61d$export$50b721ec3c718009(attendee);
    if (!cert?.organization) return "none";
    return `${cert.organization}${cert.level}`;
}
function $d5b1995fb206c61d$export$50b721ec3c718009(attendee, isVerified = false) {
    if (!attendee?.certs) return;
    const certs = Object.values(attendee.certs).filter((c)=>!isVerified || c.verifiedTime);
    return certs.reduce((a, b)=>(a?.level ?? -1) > (b?.level ?? -1) ? a : b, certs[0]);
}
function $d5b1995fb206c61d$export$ce1ea330f9f0869(attendee, isVerified = false) {
    return $d5b1995fb206c61d$export$50b721ec3c718009(attendee, isVerified)?.level ?? 0;
}
function $d5b1995fb206c61d$export$f9610ead7d6f0608(attendee) {
    return $d5b1995fb206c61d$export$50b721ec3c718009(attendee, true) ? true : false;
}


var $09927adbb2249f7e$exports = {};

$parcel$export($09927adbb2249f7e$exports, "orgNAR", () => $09927adbb2249f7e$export$4d9e1272ea818c63, (v) => $09927adbb2249f7e$export$4d9e1272ea818c63 = v);
$parcel$export($09927adbb2249f7e$exports, "orgTRA", () => $09927adbb2249f7e$export$f709da03955bfe47, (v) => $09927adbb2249f7e$export$f709da03955bfe47 = v);
$parcel$export($09927adbb2249f7e$exports, "warning", () => $09927adbb2249f7e$export$491112666e282270, (v) => $09927adbb2249f7e$export$491112666e282270 = v);
var $09927adbb2249f7e$export$4d9e1272ea818c63;
var $09927adbb2249f7e$export$f709da03955bfe47;
var $09927adbb2249f7e$export$491112666e282270;
$09927adbb2249f7e$export$4d9e1272ea818c63 = `lKeiFG_orgNAR`;
$09927adbb2249f7e$export$f709da03955bfe47 = `lKeiFG_orgTRA`;
$09927adbb2249f7e$export$491112666e282270 = `lKeiFG_warning`;


function $a277ed32ec660ce2$export$47e36462d8c4e267({ attendee: attendee , showType: showType = false , className: className , ...props }) {
    const cert = (0, $d5b1995fb206c61d$export$50b721ec3c718009)(attendee);
    const verifiedCert = (0, $d5b1995fb206c61d$export$50b721ec3c718009)(attendee, true);
    if (!cert || (cert?.level ?? 0) <= 0) return null;
    let org = cert?.organization;
    let level = cert?.level;
    if (verifiedCert) {
        org = verifiedCert.organization;
        level = verifiedCert.level;
    }
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("span", {
        className: (0, $a147a5343133f2a5$export$1343a74baacb0543)((0, (/*@__PURE__*/$parcel$interopDefault($09927adbb2249f7e$exports))).root, className, "certDot text-uppercase text-nowrap my-auto", `org-${org}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("span", {
                className: (0, $a147a5343133f2a5$export$1343a74baacb0543)((0, (/*@__PURE__*/$parcel$interopDefault($09927adbb2249f7e$exports)))[`l${level}`]),
                children: [
                    "L",
                    level
                ]
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("span", {
                className: (0, $a147a5343133f2a5$export$1343a74baacb0543)("ps-1", (0, (/*@__PURE__*/$parcel$interopDefault($09927adbb2249f7e$exports)))[`org${org}`]),
                children: [
                    "(",
                    org,
                    ")"
                ]
            }),
            cert && !verifiedCert && level > 0 ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3fa1314cc730edf3$export$c688898c4e3580ee), {
                className: "ps-1"
            }) : null
        ]
    });
}




function $65c18c84559ec290$export$bb4710074625bd7e() {
    const [currentAttendee] = (0, $de6e1888d0a1ea86$export$67c1131f3997904d)();
    const [officers] = (0, $de6e1888d0a1ea86$export$6563e0c59fe67e2)();
    return officers?.[currentAttendee?.id ?? ""] ? true : false;
}
function $65c18c84559ec290$export$42f63dcbdf962527() {
    const [officers] = (0, $de6e1888d0a1ea86$export$6563e0c59fe67e2)();
    return {
        isOfficer (attendee) {
            return !!officers?.[attendee?.id ?? attendee];
        },
        isRSO (attendee) {
            return !!(officers?.[attendee?.id ?? ""] && attendee?.role === "rso");
        },
        isLCO (attendee) {
            return !!(officers?.[attendee?.id ?? ""] && attendee?.role === "lco");
        },
        getRole (attendee) {
            return officers?.[attendee?.id ?? ""] && attendee?.role || undefined;
        }
    };
}


function $9548d15ba50fa792$export$19f442a6794aa329({ attendee: attendee , className: className , ...props }) {
    const roleApi = (0, $65c18c84559ec290$export$42f63dcbdf962527)();
    const photoUrl = attendee.photoURL ?? (0, (/*@__PURE__*/$parcel$interopDefault($2a7ab24620fae6be$exports)));
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
        className: (0, $a147a5343133f2a5$export$1343a74baacb0543)((0, (/*@__PURE__*/$parcel$interopDefault($14a31e0d70f5283a$exports))).root, className, `d-flex align-items-center`),
        ...props,
        children: [
            roleApi.isOfficer(attendee) ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($14a31e0d70f5283a$exports))).officerStar,
                children: "★"
            }) : null,
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("img", {
                className: "flex-grow-0 me-2",
                src: photoUrl
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                className: "flex-grow-1 flex-column",
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                        children: attendee?.name ?? (0, $5c148f2ca1c26c40$export$d64425f8a23d9468)
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a277ed32ec660ce2$export$47e36462d8c4e267), {
                                showType: true,
                                className: "flex-grow-0",
                                attendee: attendee
                            }),
                            attendee.role ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("span", {
                                className: (0, $a147a5343133f2a5$export$1343a74baacb0543)((0, (/*@__PURE__*/$parcel$interopDefault($14a31e0d70f5283a$exports))).role, "ms-2 me-2 px-1 bg-info text-white"),
                                children: attendee.role?.toUpperCase()
                            }) : null
                        ]
                    })
                ]
            })
        ]
    });
}




parcelRequire("8T3gX");

parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
function $98f5e3369323c0ef$export$c5c6c16075fd4665({ to: to , children: children , ...props }) {
    const navigate = (0, $3T949.useNavigate)();
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
        onClick: ()=>navigate(to),
        ...props,
        children: children
    });
}



parcelRequire("8T3gX");
function $e576e18ceea528e3$export$2e2bcd8739ae039({ name: name , size: size = "1em" , color: color = "currentColor" , ...props }) {
    let path;
    switch(name){
        case "card-fill":
            path = /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $e9bc3aadba8432ee$exports.Fragment), {
                children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("path", {
                    d: "M 1.5,2 C 0.75,2 0,2.75 0,3.5 v 9 C 0,13.25 0.75,14 1.5,14 h 13 c 0.75,0 1.5,-0.75 1.5,-1.5 v -9 C 16,2.75 15.25,2 14.5,2 Z m 1,2 v 0 h 11 C 13.823223,4 14,4.25 14,4.5 v 2 C 14,6.8232233 13.75,7 13.5,7 H 2.5 C 2.25,7 2,6.75 2,6.5 v -2 C 2,4.25 2.25,4 2.5,4 Z m 0,4.5 v 0 h 11 C 13.75,8.5 14,8.75 14,9 14,9.25 13.75,9.5 13.5,9.5 H 2.5 C 2.25,9.5 2,9.25 2,9 2,8.75 2.25,8.5 2.5,8.5 Z m 0,2.5 v 0 h 7 C 9.75,11 10,11.25 10,11.5 10,11.75 9.75,12 9.5,12 h -7 C 2.25,12 2,11.75 2,11.5 2,11.25 2.25,11 2.5,11 Z"
                })
            });
            break;
        case "card-heading":
            path = /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("path", {
                        d: "M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("path", {
                        d: "M3 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm0-5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-1z"
                    })
                ]
            });
            break;
        case "officer":
            path = /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("path", {
                d: "m 13,2 0.77,2.32 2.22,-0.03 -1.86,1.49 0.71,2.21 -1.92,-1.4 -1.78,1.4 L 11.81,5.64 10,4.29 12.34,4.23 Z M 1,14 c 0,0 -1,0 -1,-1 0,-1 1,-4 6,-4 5,0 6,3 6,4 0,1 -1,1 -1,1 z M 6,8 C 10,8 10,2 6,2 2,2 2,8 6,8 Z"
            });
            break;
        case "house-fill":
            path = /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("path", {
                        fillRule: "evenodd",
                        d: "m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6zm5-.793V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("path", {
                        fillRule: "evenodd",
                        d: "M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"
                    })
                ]
            });
            break;
        case "gear-fill":
            path = /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("path", {
                d: "M 4.7,13 2.95,14.15 1.85,13.05 3,11.3 2.15,9.2 0.05,8.75 V 7.25 L 2.15,6.8 3,4.7 1.85,2.95 2.95,1.85 4.7,3 6.8,2.15 7.25,0.05 h 1.5 L 9.2,2.15 11.3,3 13.05,1.85 14.15,2.95 13,4.7 l 0.85,2.1 2.1,0.45 v 1.5 l -2.1,0.45 -0.85,2.1 1.15,1.75 -1.1,1.1 L 11.3,13 9.2,13.85 8.75,15.95 H 7.25 L 6.8,13.85 Z M 8,5 C 6.33,4.99 5,6.34 5,8 5,9.66 6.34,11 8,11 9.66,11 11,9.65 11,8 11,6.35 9.67,5.01 8,5 Z"
            });
            break;
        case "pencil-fill":
            path = /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $e9bc3aadba8432ee$exports.Fragment), {
                children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("path", {
                    d: "M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"
                })
            });
            break;
        case "person-square":
            path = /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("path", {
                        d: "M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("path", {
                        d: "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm12 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1v-1c0-1-1-4-6-4s-6 3-6 4v1a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12z"
                    })
                ]
            });
            break;
        case "people-fill":
            path = /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("path", {
                        d: "M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("path", {
                        d: "M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("path", {
                        d: "M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
                    })
                ]
            });
            break;
        case "ui-checks":
            path = /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("path", {
                d: "M7 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1zM2 1a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2zm0 8a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2H2zm.854-3.646a.5.5 0 0 1-.708 0l-1-1a.5.5 0 1 1 .708-.708l.646.647 1.646-1.647a.5.5 0 1 1 .708.708l-2 2zm0 8a.5.5 0 0 1-.708 0l-1-1a.5.5 0 0 1 .708-.708l.646.647 1.646-1.647a.5.5 0 0 1 .708.708l-2 2zM7 10.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1zm0-5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 8a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"
            });
            break;
        case "rocket":
            path = /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("path", {
                d: "M 16,0 C 14,0 13,1 12,2 L 6,8 H 3 l -2,2 h 3 l 2,2 v 3 L 8,13 V 10 L 14,4 C 15,3 16,2 16,0 Z M 2.972,10.5 C 2.851,10.5 2.737,10.555 2.65,10.642 L 1,12.287 c -0.193,0.192 -0.193,0.51 0,0.7 0.192,0.189 0.5,0.189 0.699,0 l 1.65,-1.645 c 0.193,-0.193 0.193,-0.51 0,-0.7 C 3.251,10.544 3.116,10.492 2.972,10.5 Z m 1.012,0.998 c -0.129,0 -0.249,0.055 -0.34,0.146 L 0.423,14.82 c -0.192,0.193 -0.192,0.5 0,0.7 0.193,0.189 0.5,0.189 0.7,0 l 3.232,-3.178 c 0.189,-0.193 0.189,-0.5 0,-0.699 C 4.276,11.565 4.162,11.513 4.044,11.5 4.026,11.5 4,11.5 3.988,11.5 Z m 0.986,0.998 c -0.011,0 -0.026,-0 -0.041,0 -0.1,0.011 -0.2,0.061 -0.287,0.136 l -1.644,1.657 c -0.193,0.192 -0.193,0.51 0,0.7 0.192,0.189 0.5,0.189 0.699,0 l 1.652,-1.649 c 0.193,-0.193 0.193,-0.51 0,-0.7 C 5.251,12.544 5.114,12.494 4.974,12.498 Z"
            });
            break;
    }
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("svg", {
        width: size,
        height: size,
        fill: color,
        viewBox: "0 0 16 16",
        ...props,
        children: path
    });
}


function $6c8d476d6469cc07$var$RocketDimensions({ rocket: rocket  }) {
    const [userUnits = (0, $a53c6536bb8a7347$export$dc8ef91cafc34879)] = (0, $de6e1888d0a1ea86$export$6bd5211fd2e82d10)();
    if (!rocket) return null;
    let { diameter: diameter , length: length  } = rocket;
    const text = [];
    if (diameter != null) {
        if (length != null) {
            length = (0, $a53c6536bb8a7347$export$51bc4f4f84f52eab)(length, (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).length, userUnits.length);
            text.push(`${(0, $a147a5343133f2a5$export$a81eda11c790c16)(length)} ${userUnits.length}`);
        }
        diameter = (0, $a53c6536bb8a7347$export$51bc4f4f84f52eab)(diameter, (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).length, userUnits.lengthSmall);
        text.push(`${(0, $a147a5343133f2a5$export$a81eda11c790c16)(diameter)} ${userUnits.lengthSmall}`);
    }
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("span", {
        children: text.join(" x ")
    });
}
function $6c8d476d6469cc07$var$MotorsList({ motors: motors  }) {
    if (!motors) return "(no motors)";
    const byStage = (0, $2914d071bbef92ec$export$ab5e74a2c43c30ea)(Object.values(motors), (motor)=>motor.stage ?? 0);
    const parts = [];
    const stages = [
        ...byStage.keys()
    ].sort();
    for (const stage of stages){
        const motors = byStage.get(stage);
        if (!motors) continue;
        parts.push(/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
            children: [
                stages.length === 1 && stages[0] === 1 ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("strong", {
                    className: "me-2",
                    children: [
                        "Stage ",
                        stage,
                        ":"
                    ]
                }) : null,
                motors.map((motor, i)=>/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("span", {
                        children: [
                            i > 0 ? ", " : "",
                            motor.name
                        ]
                    }, motor.id))
            ]
        }, stage));
    }
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
        children: parts
    });
}
function $6c8d476d6469cc07$export$2e2bcd8739ae039() {
    const [userUnits = (0, $a53c6536bb8a7347$export$dc8ef91cafc34879)] = (0, $de6e1888d0a1ea86$export$6bd5211fd2e82d10)();
    const match = (0, $3T949.useMatch)("launches/:launchId/cards/:cardId/summary");
    const launchId = match?.params.launchId ?? "";
    const cardId = match?.params.cardId ?? "";
    const [card] = (0, $de6e1888d0a1ea86$export$5a0763f6a9ca51f0)(cardId);
    const [flier] = (0, $de6e1888d0a1ea86$export$577414e83e777f79)(card?.userId ?? "");
    if (!card) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Card"
    });
    if (!flier) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Flier"
    });
    const specials = [];
    if (card.firstFlight) specials.push(/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fa48cfc9bb1a0ff0$exports))).special,
        children: [
            "This is a ",
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("strong", {
                children: "First Flight"
            })
        ]
    }, specials.length));
    if (card.headsUp) specials.push(/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fa48cfc9bb1a0ff0$exports))).special,
        children: [
            "This is a ",
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("strong", {
                children: "Heads Up"
            }),
            " flight"
        ]
    }, specials.length));
    if (card.notes) {
        if (specials.length > 0) specials.push(/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("hr", {}, "hr"));
        specials.push(/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fa48cfc9bb1a0ff0$exports))).notes,
            children: card.notes
        }, specials.length));
    }
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $9548d15ba50fa792$export$19f442a6794aa329), {
                className: "h2 mb-3 me-2 flex-grow-1 p-1 bg-light border border-dark rounded",
                attendee: flier
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                    className: "d-grid",
                    style: {
                        gridTemplateColumns: "max-content 1fr",
                        gap: ".5em 1em"
                    },
                    children: [
                        /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                            className: "text-muted",
                            children: "Name (Mfg.)"
                        }),
                        /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("span", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($fa48cfc9bb1a0ff0$exports))).name,
                                    children: card.rocket?.name ? `"${card.rocket.name}"` : "(unnamed )"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("span", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($fa48cfc9bb1a0ff0$exports))).manufacturer,
                                    children: card.rocket?.manufacturer ? `(${card.rocket?.manufacturer})` : null
                                })
                            ]
                        }),
                        card.rocket?.color ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                                    className: "text-muted",
                                    children: "Color(s)"
                                }),
                                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                                    className: "d-flex",
                                    children: [
                                        /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("span", {
                                            className: "flex-grow-0",
                                            children: card.rocket?.color
                                        }),
                                        /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                                            className: "d-flex flex-row ms-2 my-1 border border-dark",
                                            style: {
                                                flexBasis: "3em"
                                            },
                                            children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $42a584c902e2bfd5$export$2e2bcd8739ae039), {
                                                className: "flex-grow-1",
                                                colors: card.rocket?.color
                                            })
                                        })
                                    ]
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                            className: "text-muted",
                            children: "Len. x Diam."
                        }),
                        /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)($6c8d476d6469cc07$var$RocketDimensions, {
                            rocket: card.rocket
                        }),
                        card.rocket?.mass ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                                    className: "text-muted",
                                    children: "Mass"
                                }),
                                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                                    children: [
                                        (0, $a147a5343133f2a5$export$a81eda11c790c16)((0, $a53c6536bb8a7347$export$51bc4f4f84f52eab)(card.rocket.mass, (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).mass, userUnits.mass)),
                                        " ",
                                        userUnits.mass
                                    ]
                                })
                            ]
                        }) : null,
                        card.rocket?.recovery ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                                    className: "text-muted",
                                    children: "Recovery(s)"
                                }),
                                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                                    className: "text-capitalize",
                                    children: card?.rocket?.recovery
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                            className: "text-muted",
                            children: (0, (/*@__PURE__*/$parcel$interopDefault($8b442f6bb87f057c$exports)))`${[
                                card?.motors?.length ?? 0
                            ]}Motor[s|]`
                        }),
                        /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)($6c8d476d6469cc07$var$MotorsList, {
                            motors: card.motors
                        })
                    ]
                })
            }),
            specials.length ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $e9bc3aadba8432ee$exports.Fragment), {
                children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $1d0a237fe4c0025c$export$2e2bcd8739ae039), {
                    className: "mt-2",
                    variant: "warning",
                    children: specials
                })
            }) : null,
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                className: "d-flex justify-content-between align-items-start",
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $4beabeb039e49562$export$d7fd01694c28dc31), {}),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $98f5e3369323c0ef$export$c5c6c16075fd4665), {
                        className: "text-nowrap my-auto",
                        to: `/launches/${launchId}/cards/${cardId}`,
                        children: [
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $e576e18ceea528e3$export$2e2bcd8739ae039), {
                                name: "pencil-fill"
                            }),
                            " Edit"
                        ]
                    })
                ]
            })
        ]
    });
}




var $8T3gX = parcelRequire("8T3gX");


var $3T949 = parcelRequire("3T949");


parcelRequire("8T3gX");



parcelRequire("8T3gX");

parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");







const { DRAFT: $2d3a5d8ba313b43b$var$DRAFT , REVIEW: $2d3a5d8ba313b43b$var$REVIEW , FLY: $2d3a5d8ba313b43b$var$FLY , DONE: $2d3a5d8ba313b43b$var$DONE  } = (0, $aaa72a458935fe7a$export$490c7ce941281ba8);
function $2d3a5d8ba313b43b$export$e4a86e161e7d0df2(status) {
    return ({
        draft: 0,
        review: 1,
        fly: 2,
        done: 3
    })[String(status)] ?? 0;
}
async function $2d3a5d8ba313b43b$var$updateCard(card, update) {
    const rtPath = (0, $71b3f0397fe2ca79$export$c180d6f0b8dacb9f).with({
        launchId: card.launchId,
        cardId: card.id
    });
    return (0, $febfa929b76327ac$export$78d8dceb730843fa)(rtPath, update);
}
function $2d3a5d8ba313b43b$export$cac327f70be731f8(card, user, isOfficer) {
    const status = card.status ?? $2d3a5d8ba313b43b$var$DRAFT;
    const notes = [];
    const warnings = [];
    switch(status){
        case $2d3a5d8ba313b43b$var$DRAFT:
            if (card.padId) warnings.push("Draft cards should not have a pad assigned.  Clear your pad assignment if you're not actively launching.");
            if (!card.rsoId) ;
            else if (!card.padId) notes.push('Talk to Launch Control about how pads are assigned.  Once you have a pad assignment and are ready to launch, click "Submit to LCO".');
            break;
        case $2d3a5d8ba313b43b$var$REVIEW:
        case $2d3a5d8ba313b43b$var$FLY:
            if (!card.rsoId) {
                warnings.unshift("Present rocket to the Range Safety Officer.");
                if (isOfficer && user.id === card.userId) notes.push("Note: Officers may not RSO their own rockets");
            } else if (!card.padId) notes.push("After you have your rocket racked, specify which pad it's on");
            else notes.push("Looks like you're ready to go!");
            notes.push('Note: Cards waiting for safety review or launch may not be edited. Click "Withdraw" to make changes.');
            break;
        case $2d3a5d8ba313b43b$var$DONE:
            notes.push("This card has been flown and is no longer editable.");
            break;
    }
    // // Uncomment to show all buttons
    // if (window as unknown) {
    //   return {
    //     notes,
    //     warnings,
    //     canWithdraw: true,
    //     userCanWithdraw: true,
    //     canSubmitToRSO: true,
    //     userCanSubmitToRSO: true,
    //     canApprove: true,
    //     userCanApprove: true,
    //     canReject: true,
    //     userCanReject: true,
    //     canAssignPad: true,
    //     userCanAssignPad: true,
    //     canSubmitToLCO: true,
    //     userCanSubmitToLCO: true,
    //     canMarkDone: true,
    //     userCanMarkDone: true,
    //     canDelete: true,
    //     userCanDelete: true,
    //   };
    // }
    return {
        notes: notes,
        warnings: warnings,
        canWithdraw: status !== $2d3a5d8ba313b43b$var$DRAFT && status !== $2d3a5d8ba313b43b$var$DONE,
        userCanWithdraw: isOfficer || user.id === card.userId,
        canSubmitToRSO: !card.rsoId && status !== $2d3a5d8ba313b43b$var$REVIEW && status !== $2d3a5d8ba313b43b$var$DONE,
        userCanSubmitToRSO: isOfficer || user.id === card.userId,
        canApprove: !card.rsoId && status === $2d3a5d8ba313b43b$var$REVIEW,
        userCanApprove: isOfficer && user.id != card.userId,
        canReject: !!card.rsoId && status != $2d3a5d8ba313b43b$var$DONE,
        userCanReject: isOfficer,
        canAssignPad: !!card.rsoId && status === $2d3a5d8ba313b43b$var$REVIEW || status === $2d3a5d8ba313b43b$var$FLY,
        userCanAssignPad: isOfficer || user.id === card.userId,
        canSubmitToLCO: !!card.rsoId && status !== $2d3a5d8ba313b43b$var$FLY && status !== $2d3a5d8ba313b43b$var$DONE,
        userCanSubmitToLCO: isOfficer || user.id === card.userId,
        canMarkDone: card.status === $2d3a5d8ba313b43b$var$FLY && !!card.rsoId,
        userCanMarkDone: isOfficer,
        canDelete: card.status !== $2d3a5d8ba313b43b$var$DONE,
        userCanDelete: user.id === card.userId
    };
}
function $2d3a5d8ba313b43b$export$761be6a7b42241b3({ card: card , ...props }) {
    const [pads] = (0, $de6e1888d0a1ea86$export$5b051e2383c8638d)();
    if (!pads) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "pads"
    });
    // Group pads by group
    const padGroupEntries = [
        ...(0, $2914d071bbef92ec$export$ab5e74a2c43c30ea)(Object.values(pads), (pad)=>pad.group ?? "")
    ];
    // Sort by group name
    (0, $2914d071bbef92ec$export$7a7adbcc2fafd347)(padGroupEntries, "0");
    // Sort w/in each group
    for (const [, pads] of padGroupEntries)(0, $2914d071bbef92ec$export$7a7adbcc2fafd347)(pads, "name");
    function setPad(e) {
        const padId = e.currentTarget.value;
        (0, $a147a5343133f2a5$export$95dc765ca5d5cc35)(e.currentTarget, $2d3a5d8ba313b43b$var$updateCard(card, {
            padId: padId
        }));
    }
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
        className: "d-flex flex-column text-center",
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e2399cea1a8ec78e$export$2e2bcd8739ae039), {
                ...props,
                value: card.padId ?? "",
                onChange: setPad,
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("option", {
                        value: "",
                        children: "No Pad Selected"
                    }),
                    padGroupEntries.map(([group, pads])=>/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("optgroup", {
                            label: group,
                            children: pads.map((pad)=>/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("option", {
                                    value: pad.id,
                                    children: pad.name
                                }, pad.id))
                        }, group))
                ]
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                className: "text-tip",
                children: "Select Launch Pad"
            })
        ]
    });
}
function $2d3a5d8ba313b43b$export$46c0a5548508b0e0({ card: card , children: children , ...props }) {
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
        className: "d-flex flex-column text-center",
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                onClick: ()=>$2d3a5d8ba313b43b$var$updateCard(card, {
                        status: $2d3a5d8ba313b43b$var$DRAFT
                    }),
                ...props,
                children: children
            }),
            " ",
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                className: "text-tip",
                children: "Temporarily withdraw from safety review and/or launch"
            })
        ]
    });
}
function $2d3a5d8ba313b43b$export$19da34f18abd7e92({ card: card , children: children , ...props }) {
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
        className: "d-flex flex-column text-center",
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                onClick: ()=>$2d3a5d8ba313b43b$var$updateCard(card, {
                        status: $2d3a5d8ba313b43b$var$REVIEW
                    }),
                ...props,
                children: children
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                className: "text-tip",
                children: "Request safety review"
            })
        ]
    });
}
function $2d3a5d8ba313b43b$export$b8bfb95665e00005({ card: card , children: children , ...props }) {
    const [rso] = (0, $de6e1888d0a1ea86$export$67c1131f3997904d)();
    if (!rso) return null;
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
        className: "d-flex flex-column text-center",
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                onClick: ()=>$2d3a5d8ba313b43b$var$updateCard(card, {
                        status: $2d3a5d8ba313b43b$var$DRAFT,
                        rsoId: rso.id
                    }),
                ...props,
                children: children
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                className: "text-tip",
                children: "Approve for launch"
            })
        ]
    });
}
function $2d3a5d8ba313b43b$export$8d2d07880871825a({ card: card , children: children , ...props }) {
    const [rso] = (0, $de6e1888d0a1ea86$export$67c1131f3997904d)();
    if (!rso) return null;
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
        className: "d-flex flex-column text-center",
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                onClick: ()=>$2d3a5d8ba313b43b$var$updateCard(card, {
                        status: $2d3a5d8ba313b43b$var$DRAFT,
                        rsoId: (0, $febfa929b76327ac$export$4bd2facc4a3e6aa1)
                    }),
                ...props,
                children: children
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                className: "text-tip",
                children: "Revoke RSO approval"
            })
        ]
    });
}
function $2d3a5d8ba313b43b$export$e3a727250aba483a({ card: card , children: children , ...props }) {
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
        className: "d-flex flex-column text-center",
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                onClick: ()=>$2d3a5d8ba313b43b$var$updateCard(card, {
                        status: $2d3a5d8ba313b43b$var$FLY
                    }),
                ...props,
                children: children
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                className: "text-tip",
                children: "Ready for launch!"
            })
        ]
    });
}
function $2d3a5d8ba313b43b$export$19cb79a309ec12d4({ card: card , children: children , ...props }) {
    const [attendee] = (0, $de6e1888d0a1ea86$export$67c1131f3997904d)();
    if (!attendee) return null;
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
        className: "d-flex flex-column text-center",
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                onClick: ()=>$2d3a5d8ba313b43b$var$updateCard(card, {
                        status: $2d3a5d8ba313b43b$var$DONE,
                        lcoId: attendee.id
                    }),
                ...props,
                children: children
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                className: "text-tip",
                children: "Flight complete (locks card!)"
            })
        ]
    });
}
function $2d3a5d8ba313b43b$export$d6f68d0fe29f8050({ card: card , children: children , ...props }) {
    const [attendee] = (0, $de6e1888d0a1ea86$export$67c1131f3997904d)();
    const navigate = (0, $3T949.useNavigate)();
    if (!attendee) return null;
    async function deleteCard() {
        const reallyMsg = `Delete flight card for '${card.rocket?.name ?? "(unnamed rocket)"}'? (This cannot be undone!)`;
        if (!confirm(reallyMsg)) return;
        const rtPath = (0, $71b3f0397fe2ca79$export$c180d6f0b8dacb9f).with({
            launchId: card.launchId,
            cardId: card.id
        });
        await (0, $febfa929b76327ac$export$3f3cbd6c9a0055d0)(rtPath);
        (0, $3eda0b7570ee1d13$export$fff9462e59a6c087)("Flight card deleted");
        navigate(-1);
    }
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
        className: "d-flex flex-column text-center",
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                onClick: deleteCard,
                ...props,
                children: children
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                className: "text-tip",
                children: "Are you sure?!?"
            })
        ]
    });
}


function $00a0d9503d98b74d$export$9b6a647253f61c5f({ card: card , ...props }) {
    const [attendee] = (0, $de6e1888d0a1ea86$export$67c1131f3997904d)();
    const isOfficer = (0, $65c18c84559ec290$export$bb4710074625bd7e)();
    if (!attendee) return null;
    const perms = (0, $2d3a5d8ba313b43b$export$cac327f70be731f8)(card, attendee, isOfficer);
    // Comment out to see buttons a user *might* be able to click
    perms.userCanApprove &&= perms.canApprove;
    perms.userCanAssignPad &&= perms.canAssignPad;
    perms.userCanMarkDone &&= perms.canMarkDone;
    perms.userCanReject &&= perms.canReject;
    perms.userCanSubmitToLCO &&= perms.canSubmitToLCO;
    perms.userCanSubmitToRSO &&= perms.canSubmitToRSO;
    perms.userCanWithdraw &&= perms.canWithdraw;
    perms.userCanDelete &&= perms.canDelete;
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("ul", {
                children: [
                    ...perms.notes,
                    ...perms.warnings
                ].map((note, i)=>/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("li", {
                        children: note
                    }, `note-${i}`))
            }),
            " ",
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                className: "d-grid",
                style: {
                    gap: ".5em 1em",
                    gridTemplateColumns: "repeat(auto-fit, minmax(12em, 1fr)"
                },
                children: [
                    perms.userCanWithdraw ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $2d3a5d8ba313b43b$export$46c0a5548508b0e0), {
                        disabled: !perms.canWithdraw,
                        card: card,
                        children: "Withdraw"
                    }) : null,
                    perms.userCanAssignPad ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $2d3a5d8ba313b43b$export$761be6a7b42241b3), {
                        disabled: !perms.canWithdraw,
                        card: card
                    }) : null,
                    perms.userCanSubmitToRSO ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $2d3a5d8ba313b43b$export$19da34f18abd7e92), {
                        disabled: !perms.canSubmitToRSO,
                        card: card,
                        children: "Submit to RSO"
                    }) : null,
                    perms.userCanApprove ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $2d3a5d8ba313b43b$export$b8bfb95665e00005), {
                        disabled: !perms.canApprove,
                        card: card,
                        children: "Approve"
                    }) : null,
                    perms.userCanReject ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $2d3a5d8ba313b43b$export$8d2d07880871825a), {
                        variant: "warning",
                        disabled: !perms.canReject,
                        card: card,
                        children: "Reject"
                    }) : null,
                    perms.userCanSubmitToLCO ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $2d3a5d8ba313b43b$export$e3a727250aba483a), {
                        disabled: !perms.canSubmitToLCO,
                        card: card,
                        children: "Submit to LCO"
                    }) : null,
                    perms.userCanMarkDone ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $2d3a5d8ba313b43b$export$19cb79a309ec12d4), {
                        disabled: !perms.canMarkDone,
                        card: card,
                        children: "All Done"
                    }) : null,
                    perms.userCanDelete ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $2d3a5d8ba313b43b$export$d6f68d0fe29f8050), {
                        className: "mx-5",
                        disabled: !perms.canDelete,
                        variant: "danger",
                        card: card,
                        children: "Delete"
                    }) : null
                ]
            })
        ]
    });
}




parcelRequire("8T3gX");


parcelRequire("8T3gX");


var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");


const $9120aa6ad028731b$export$513805011eaa4892 = {
    /**
   * @default 'img'
   */ bsPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Sets image as fluid image.
   */ fluid: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Sets image shape as rounded.
   */ rounded: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Sets image shape as circle.
   */ roundedCircle: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Sets image shape as thumbnail.
   */ thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
};
const $9120aa6ad028731b$var$Image = /*#__PURE__*/ $8T3gX.forwardRef(({ bsPrefix: bsPrefix , className: className , fluid: fluid = false , rounded: rounded = false , roundedCircle: roundedCircle = false , thumbnail: thumbnail = false , ...props }, ref)=>{
    bsPrefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, "img");
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("img", {
        // eslint-disable-line jsx-a11y/alt-text
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, fluid && `${bsPrefix}-fluid`, rounded && `rounded`, roundedCircle && `rounded-circle`, thumbnail && `${bsPrefix}-thumbnail`)
    });
});
$9120aa6ad028731b$var$Image.displayName = "Image";
var $9120aa6ad028731b$export$2e2bcd8739ae039 = $9120aa6ad028731b$var$Image;


var $839c64deffb3eac9$exports = {};

$839c64deffb3eac9$exports = new URL((parcelRequire("bCIFA")).resolve("6RJLX"), import.meta.url).toString();


function $1b53192dbdafd48c$export$c2773a963dc630cb(props) {
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $9120aa6ad028731b$export$2e2bcd8739ae039), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($839c64deffb3eac9$exports))),
        ...props
    });
}



parcelRequire("8T3gX");



function $7be070a8aab20cef$export$95fe46c2ffc3c286({ value: value , type: type , long: long  }) {
    const [userUnits = (0, $a53c6536bb8a7347$export$dc8ef91cafc34879)] = (0, $de6e1888d0a1ea86$export$6bd5211fd2e82d10)();
    const fromUnit = (0, $a53c6536bb8a7347$export$dc8ef91cafc34879)[type];
    const toUnit = userUnits[type];
    const converted = (0, $a53c6536bb8a7347$export$51bc4f4f84f52eab)(value, fromUnit, toUnit);
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $e9bc3aadba8432ee$exports.Fragment), {
        children: isNaN(converted) ? "?" : `${(0, $a147a5343133f2a5$export$a81eda11c790c16)(converted)} ${long ? " " + userUnits[type] : null}`
    });
}




function $9dbccb978f1dbbfe$export$26d326d0f3da87fc({ motor: motor , ...props }) {
    let graph;
    const { samples: samples  } = motor;
    if (samples) {
        const W = 400;
        const H = 100;
        const tMax = samples[samples.length - 1][0];
        const vMax = samples.map(([, v])=>v).reduce((a, b)=>Math.max(a, b), 0);
        const yAvg = H * (1 - 0.9 * motor.avgThrustN / vMax);
        const points = samples.map(([t, v])=>`${(0, $a147a5343133f2a5$export$a81eda11c790c16)(W * (t / tMax))},${(0, $a147a5343133f2a5$export$a81eda11c790c16)(H * (1 - 0.9 * v / vMax))}`);
        graph = /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("svg", {
            className: "border border-secondary rounded",
            width: "100%",
            viewBox: `0 0 ${W} ${H}`,
            strokeWidth: "2",
            height: "10%",
            preserveAspectRatio: "none",
            children: [
                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("polyline", {
                    stroke: "black",
                    strokeWidth: "1",
                    fill: "lightgrey",
                    points: points.join(" ")
                }),
                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("line", {
                    x1: "0",
                    y1: yAvg,
                    x2: W,
                    y2: yAvg,
                    strokeWidth: "2",
                    strokeDasharray: "10 4",
                    stroke: "green"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $dcbe90c8bc15d3fe$export$2e2bcd8739ae039), {
        show: true,
        ...props,
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $dcbe90c8bc15d3fe$export$2e2bcd8739ae039).Header, {
                closeButton: true,
                className: "fw-bold",
                children: (0, $0e759b381c300a7c$export$4ca4191dc95399e3)(motor)
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $dcbe90c8bc15d3fe$export$2e2bcd8739ae039).Body, {
                children: [
                    graph,
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                        className: "d-flex",
                        children: [
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                                className: "text-start small",
                                children: "0 sec"
                            }),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                                className: "text-end small flex-grow-1",
                                children: [
                                    motor.burnTimeS,
                                    " sec"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                        className: "d-grid",
                        style: {
                            gridTemplateColumns: "max-content 1fr",
                            gap: "0.5em 1em"
                        },
                        children: [
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                                children: "Total Impulse"
                            }),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $7be070a8aab20cef$export$95fe46c2ffc3c286), {
                                    value: motor.totImpulseNs,
                                    type: "impulse",
                                    long: true
                                })
                            }),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                                children: "Max Thrust"
                            }),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $7be070a8aab20cef$export$95fe46c2ffc3c286), {
                                    value: motor.maxThrustN,
                                    type: "force",
                                    long: true
                                })
                            }),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                                children: "Average Thrust"
                            }),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $7be070a8aab20cef$export$95fe46c2ffc3c286), {
                                    value: motor.avgThrustN,
                                    type: "force",
                                    long: true
                                })
                            }),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                                children: "Propellent"
                            }),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                                    children: motor.propInfo
                                })
                            })
                        ]
                    }),
                    motor.sparky ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $1d0a237fe4c0025c$export$2e2bcd8739ae039), {
                        variant: "warning",
                        className: "d-flex",
                        children: [
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $1b53192dbdafd48c$export$c2773a963dc630cb), {
                                className: "m-auto"
                            }),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                                className: "flex-grow-1",
                                children: "Heads up! Sparky motors may not be allowed at some launches. Check with the RSO."
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
}





var $8T3gX = parcelRequire("8T3gX");


var $8T3gX = parcelRequire("8T3gX");


const $7ddf01765e1670f5$var$Badge = /*#__PURE__*/ $8T3gX.forwardRef(({ bsPrefix: bsPrefix , bg: bg = "primary" , pill: pill = false , text: text , className: className , as: Component = "span" , ...props }, ref)=>{
    const prefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, "badge");
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, prefix, pill && `rounded-pill`, text && `text-${text}`, bg && `bg-${bg}`)
    });
});
$7ddf01765e1670f5$var$Badge.displayName = "Badge";
var $7ddf01765e1670f5$export$2e2bcd8739ae039 = $7ddf01765e1670f5$var$Badge;









const $560977bbc8fcfb6d$var$MAX_SUGGESTIONS = 12;
function $560977bbc8fcfb6d$export$29f0693f0cda1871({ motor: motor , rtFields: rtFields , onHide: onHide  }) {
    const [delayListId] = (0, $8T3gX.useState)((0, $40b0ef4339cb3cfb$export$ac4959f4f1338dfc)()); // 'Just need a unique ID of some sort here
    const [userUnits = (0, $a53c6536bb8a7347$export$dc8ef91cafc34879)] = (0, $de6e1888d0a1ea86$export$6bd5211fd2e82d10)();
    const [suggestions, setSuggestions] = (0, $8T3gX.useState)([]);
    const saveButton = (0, $8T3gX.useRef)(null);
    const deleteButton = (0, $8T3gX.useRef)(null);
    const [name, setName] = (0, $8T3gX.useState)(motor.name);
    const [stage, setStage] = (0, $8T3gX.useState)(String(motor?.stage ?? "1"));
    const [delay, setDelay] = (0, $8T3gX.useState)(String(motor?.delay ?? ""));
    const tcMotor = (0, $0e759b381c300a7c$export$100d0ae4aabba252)(name);
    const [impulse, setImpulse] = (0, $8T3gX.useState)("");
    function onNameChange(e) {
        const newName = e.target.value;
        setSuggestions((0, $0e759b381c300a7c$export$40a60c142742ca02)(newName));
        setName(newName);
    }
    function onDelayChange(e) {
        setDelay(e.target.value);
    }
    function onStageChange(e) {
        setStage(e.target.value);
    }
    function onImpulseChange(e) {
        setImpulse(e.target.value);
    }
    function onSave() {
        const _stage = parseInt(stage ?? "");
        const _delay = parseInt(delay ?? "");
        const _impulse = tcMotor?.totImpulseNs ?? (0, $a53c6536bb8a7347$export$26c3d0b70508b36c)(impulse, userUnits.impulse);
        const _newMotor = {
            ...motor,
            id: motor.id || (0, $40b0ef4339cb3cfb$export$ac4959f4f1338dfc)(),
            name: name,
            tcMotorId: tcMotor?.motorId ?? (0, $febfa929b76327ac$export$4bd2facc4a3e6aa1),
            stage: isNaN(_stage) ? (0, $febfa929b76327ac$export$4bd2facc4a3e6aa1) : _stage,
            delay: isNaN(_delay) ? (0, $febfa929b76327ac$export$4bd2facc4a3e6aa1) : _delay,
            impulse: isNaN(_impulse) ? (0, $febfa929b76327ac$export$4bd2facc4a3e6aa1) : _impulse
        };
        (0, $a147a5343133f2a5$export$95dc765ca5d5cc35)(saveButton.current, (0, $febfa929b76327ac$export$2ef6846d36515d5)((0, $71b3f0397fe2ca79$export$c86ca1e8f0edf269).with({
            ...rtFields,
            motorId: _newMotor.id
        }), _newMotor)).then(onHide);
    }
    function onDelete() {
        (0, $a147a5343133f2a5$export$95dc765ca5d5cc35)(deleteButton.current, (0, $febfa929b76327ac$export$3f3cbd6c9a0055d0)((0, $71b3f0397fe2ca79$export$c86ca1e8f0edf269).with({
            ...rtFields,
            motorId: motor.id
        }))).then(onHide);
    }
    const displayImpulse = tcMotor ? (0, $a147a5343133f2a5$export$a81eda11c790c16)((0, $a53c6536bb8a7347$export$51bc4f4f84f52eab)(tcMotor?.totImpulseNs, (0, $a53c6536bb8a7347$export$dc8ef91cafc34879).impulse, userUnits.impulse), 3) : impulse;
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $dcbe90c8bc15d3fe$export$2e2bcd8739ae039), {
        size: "lg",
        show: true,
        onHide: onHide,
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $dcbe90c8bc15d3fe$export$2e2bcd8739ae039).Header, {
                closeButton: true,
                children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $dcbe90c8bc15d3fe$export$2e2bcd8739ae039).Title, {
                    children: !motor.id ? "Add Motor" : "Edit Motor"
                })
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $dcbe90c8bc15d3fe$export$2e2bcd8739ae039).Body, {
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("datalist", {
                        id: delayListId,
                        children: tcMotor?.delays?.split(",")?.map((d)=>/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("option", {
                                value: String(d)
                            }, String(d)))
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $82743675752b4983$export$2e2bcd8739ae039).Control, {
                        autoFocus: true,
                        className: "flex-grow-1",
                        onChange: onNameChange,
                        value: name,
                        placeholder: "Motor name"
                    }),
                    suggestions.length ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                                className: "motor-suggestions",
                                children: suggestions.slice(0, $560977bbc8fcfb6d$var$MAX_SUGGESTIONS).map((motor)=>/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $7ddf01765e1670f5$export$2e2bcd8739ae039), {
                                        bg: "secondary",
                                        className: "suggestion",
                                        onClick: ()=>{
                                            setName((0, $0e759b381c300a7c$export$4ca4191dc95399e3)(motor));
                                            setSuggestions([]);
                                        },
                                        children: (0, $0e759b381c300a7c$export$4ca4191dc95399e3)(motor)
                                    }, motor.motorId))
                            }),
                            suggestions.length > $560977bbc8fcfb6d$var$MAX_SUGGESTIONS ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("span", {
                                style: {
                                    fontSize: "0.8em"
                                },
                                children: [
                                    "(",
                                    suggestions.length - $560977bbc8fcfb6d$var$MAX_SUGGESTIONS,
                                    " more not shown)"
                                ]
                            }) : null
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                        className: "d-grid mt-3",
                        style: {
                            gap: ".5em 1em",
                            gridTemplateColumns: "max-content 1fr"
                        },
                        children: [
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("label", {
                                className: "mx-2",
                                children: [
                                    "Impulse",
                                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("sub", {
                                        children: " total"
                                    }),
                                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("span", {
                                        className: "text-info ms-2",
                                        children: [
                                            "(",
                                            userUnits.impulse,
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $82743675752b4983$export$2e2bcd8739ae039).Control, {
                                className: "ms-sm-2",
                                disabled: !!tcMotor,
                                value: displayImpulse,
                                onChange: onImpulseChange
                            }),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("label", {
                                className: "mx-2",
                                children: [
                                    "Delay",
                                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("span", {
                                        className: "text-info ms-2",
                                        children: "(secs)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $82743675752b4983$export$2e2bcd8739ae039).Control, {
                                className: "flex-grow-1 ms-sm-2",
                                list: delayListId,
                                value: delay,
                                onChange: onDelayChange
                            }),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("label", {
                                className: "mx-2",
                                children: "Stage"
                            }),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e2399cea1a8ec78e$export$2e2bcd8739ae039), {
                                className: "flex-grow-1 ms-sm-2",
                                value: stage,
                                onChange: onStageChange,
                                children: [
                                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("option", {
                                        value: "1",
                                        children: "1"
                                    }),
                                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("option", {
                                        value: "2",
                                        children: "2"
                                    }),
                                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("option", {
                                        value: "3",
                                        children: "3"
                                    }),
                                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("option", {
                                        value: "4",
                                        children: "4"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $dcbe90c8bc15d3fe$export$2e2bcd8739ae039).Footer, {
                className: "d-flex",
                children: [
                    motor.id ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                        ref: deleteButton,
                        onClick: onDelete,
                        tabIndex: -1,
                        variant: "danger",
                        children: [
                            "✕",
                            " Delete"
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                        className: "flex-grow-1"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                        variant: "secondary",
                        onClick: onHide,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                        ref: saveButton,
                        style: {
                            minWidth: "6em"
                        },
                        onClick: onSave,
                        children: motor.id ? "Update" : "Add"
                    })
                ]
            })
        ]
    });
}



parcelRequire("8T3gX");






var $eaa3f09b4751c125$exports = {};

$eaa3f09b4751c125$exports = new URL((parcelRequire("bCIFA")).resolve("3VOCa"), import.meta.url).toString();


function $82606860a6f601ba$var$MotorButton({ motor: motor , disabled: disabled , setEditMotor: setEditMotor , setDetailMotor: setDetailMotor  }) {
    const tcMotor = (0, $0e759b381c300a7c$export$6ef5e39af8f569c9)(motor.tcMotorId ?? "");
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $6cb1eff92841402c$export$2e2bcd8739ae039), {
        className: "d-flex",
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                disabled: disabled,
                className: "flex-grow-1",
                variant: "outline-dark",
                onClick: ()=>setEditMotor(motor),
                children: motor.name
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                onClick: ()=>setDetailMotor(tcMotor),
                className: "flex-grow-0 p-0",
                disabled: !motor.tcMotorId,
                style: {
                    backgroundColor: "#0793d6",
                    filter: tcMotor ? "" : "grayscale(1)"
                },
                children: tcMotor?.sparky ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $1b53192dbdafd48c$export$c2773a963dc630cb), {
                    style: {
                        width: "40px"
                    }
                }) : /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $9120aa6ad028731b$export$2e2bcd8739ae039), {
                    src: String((0, (/*@__PURE__*/$parcel$interopDefault($eaa3f09b4751c125$exports)))),
                    style: {
                        height: "2.5em"
                    }
                })
            })
        ]
    }, motor.id);
}
function $82606860a6f601ba$export$f38900f779f45ac4({ disabled: disabled , rtFields: rtFields , setEditMotor: setEditMotor , setDetailMotor: setDetailMotor  }) {
    const [motors] = (0, $febfa929b76327ac$export$fe4c1a3a7af84c36)((0, $71b3f0397fe2ca79$export$8d9b735d66078003).with(rtFields));
    // We need an ordered array of motors
    const motorItems = motors ? Object.values(motors) : [];
    const stageGroupEntries = [
        ...(0, $2914d071bbef92ec$export$ab5e74a2c43c30ea)(motorItems, (motor)=>motor.stage ?? 1)
    ];
    // Sort by stage
    const stageGroups = (0, $2914d071bbef92ec$export$7a7adbcc2fafd347)(stageGroupEntries, "0");
    const motorList = [];
    for (const [stage, stageMotors] of stageGroups){
        if (stageGroups.length > 1 || !stageGroups["1"]) motorList.push(/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("h3", {
            children: [
                "Stage ",
                stage
            ]
        }, `stage-${stage}-label`));
        motorList.push(/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
            className: "deck",
            children: stageMotors.map((motor)=>/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)($82606860a6f601ba$var$MotorButton, {
                    disabled: disabled,
                    motor: motor,
                    setEditMotor: setEditMotor,
                    setDetailMotor: setDetailMotor
                }, motor.id))
        }, `stage-${stage}`));
    }
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $e9bc3aadba8432ee$exports.Fragment), {
        children: motorList
    });
}



parcelRequire("8T3gX");
function $119599695d52dc74$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("details", {
        className: "bg-light rounded mb-2 px-2 flex-grow-1",
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("summary", {
                className: "text-tip flex-grow-1",
                children: "FAQ: How do I enter values with different units?"
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("p", {
                className: "mt-3",
                children: "Units may be specified as follows:"
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("dl", {
                style: {
                    display: "grid",
                    gridTemplateColumns: "auto 1fr",
                    gap: ".2em 1em"
                },
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                        className: "fw-normal text-end",
                        children: "Length (metric)"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("code", {
                                children: "1m"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("code", {
                                children: "1cm"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("code", {
                                children: "1mm"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                        className: "fw-normal text-end",
                        children: "Length (english)"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("code", {
                                children: "1ft"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("code", {
                                children: "1'"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("code", {
                                children: "1in"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("code", {
                                children: '1"'
                            }),
                            ",",
                            " ",
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("code", {
                                children: "1'1\""
                            }),
                            ", ",
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("code", {
                                children: "1ft 1in"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                        className: "fw-normal text-end",
                        children: "Mass (metric)"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("code", {
                                children: "1kg"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("code", {
                                children: "1g"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                        className: "fw-normal text-end",
                        children: "Mass (english)"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("code", {
                                children: "1lb"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("code", {
                                children: "1oz"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("code", {
                                children: "1lb 1oz"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                        className: "fw-normal text-end",
                        children: "Thrust/force (metric)"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("code", {
                            children: "1n"
                        })
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                        className: "fw-normal text-end",
                        children: "Thrust/force (english)"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("code", {
                            children: "1lbf"
                        })
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                        className: "fw-normal text-end",
                        children: "Impulse (metric)"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("code", {
                                children: "1n-s"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("code", {
                                children: "1n-sec"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                        className: "fw-normal text-end",
                        children: "Impulse (english)"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("code", {
                                children: "1lbf-s"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("code", {
                                children: "1lbf-sec"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}







// RTUI = RealTime UI for Controls that connect to the realtime DB



var $8T3gX = parcelRequire("8T3gX");




const $1323e57a6b627168$export$f4fa1ee095760378 = {
    fromRT (v) {
        return v ?? "";
    },
    toRT (v) {
        return v.trim() || (0, $febfa929b76327ac$export$4bd2facc4a3e6aa1);
    }
};
const $1323e57a6b627168$export$bd0e52ed4d3f9e12 = {
    fromRT (v) {
        return !!v;
    },
    toRT (v) {
        return v ? true : (0, $febfa929b76327ac$export$4bd2facc4a3e6aa1);
    }
};
// ALL THE HOOKZ for RTUI controls
function $1323e57a6b627168$var$useRealtimeField(path, defaultValue, adapter) {
    // Control value
    const [val, setVal] = (0, $8T3gX.useState)(defaultValue);
    // Promise when value is being saved to the db
    const [saveAction, setSaveAction] = (0, $8T3gX.useState)();
    // Identifier for connecting label and control
    const [id] = (0, $8T3gX.useState)((0, $40b0ef4339cb3cfb$export$ac4959f4f1338dfc)());
    (0, $febfa929b76327ac$export$fe4c1a3a7af84c36)(path, (0, $8T3gX.useCallback)((v)=>setVal(adapter.fromRT(v)), [
        adapter
    ]));
    // Function to save current control value to db.  This also updates the
    // isSaving property used by controls to indicate the value is being saved.
    //
    // Calling with no args saves the current `val`, or pass an arg to explicitely
    // specify the RT value to save.
    function save(override) {
        if (saveAction) return;
        const v = adapter.toRT(override ?? val);
        setVal(adapter.fromRT(v));
        const saving = (0, $febfa929b76327ac$export$2ef6846d36515d5)(path, v ?? (0, $febfa929b76327ac$export$4bd2facc4a3e6aa1));
        saving.finally(()=>setSaveAction(undefined));
        setSaveAction(saving);
    }
    return {
        val: val,
        setVal: setVal,
        save: save,
        isSaving: !!saveAction,
        id: id
    };
}
function $1323e57a6b627168$export$fd869eba2656ca90(rtpath, userUnits = (0, $a53c6536bb8a7347$export$dc8ef91cafc34879)) {
    return {
        StringInput ({ label: label , field: field , className: className , ...props }) {
            const { val: val , setVal: setVal , save: save , isSaving: isSaving , id: id  } = $1323e57a6b627168$var$useRealtimeField(rtpath.append(field, {}), "", $1323e57a6b627168$export$f4fa1ee095760378);
            return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                className: (0, $a147a5343133f2a5$export$1343a74baacb0543)(className, `form-floating`),
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("input", {
                        id: id,
                        placeholder: id,
                        value: String(val),
                        className: `form-control ${isSaving ? "busy" : ""} ${className ?? ""}`,
                        ...props,
                        onChange: (e)=>setVal(e.target.value),
                        onBlur: ()=>save()
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("label", {
                        htmlFor: id,
                        children: label
                    })
                ]
            });
        },
        TextArea ({ label: label , field: field , className: className , ...props }) {
            const { val: val , setVal: setVal , save: save , isSaving: isSaving , id: id  } = $1323e57a6b627168$var$useRealtimeField(rtpath.append(field, {}), "", $1323e57a6b627168$export$f4fa1ee095760378);
            return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                className: "form-floating",
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("textarea", {
                        id: id,
                        placeholder: id,
                        value: val ?? "",
                        className: `form-control ${isSaving ? "busy" : ""} ${className ?? ""}`,
                        ...props,
                        onChange: (e)=>setVal(e.target.value),
                        onBlur: ()=>save()
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("label", {
                        htmlFor: id,
                        children: label
                    })
                ]
            });
        },
        Check ({ field: field , ...props }) {
            const { val: val , save: save , isSaving: isSaving , id: id  } = $1323e57a6b627168$var$useRealtimeField(rtpath.append(field, {}), false, $1323e57a6b627168$export$bd0e52ed4d3f9e12);
            return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $82743675752b4983$export$2e2bcd8739ae039).Check, {
                id: id,
                placeholder: id,
                type: "switch",
                checked: val ?? false,
                className: isSaving ? "busy" : "",
                ...props,
                onChange: (e)=>{
                    save(e.target.checked);
                }
            });
        },
        Radio ({ field: field , label: label , value: value , ...props }) {
            const { val: val , save: save , isSaving: isSaving , id: id  } = $1323e57a6b627168$var$useRealtimeField(rtpath.append(field, {}), "", $1323e57a6b627168$export$f4fa1ee095760378);
            return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $82743675752b4983$export$2e2bcd8739ae039).Check, {
                id: id,
                placeholder: id,
                label: label,
                type: "radio",
                checked: val === value,
                className: isSaving ? "busy" : "",
                ...props,
                onChange: ()=>save(value)
            });
        },
        Select ({ field: field , label: label , children: children , ...props }) {
            const { val: val , save: save , isSaving: isSaving , id: id  } = $1323e57a6b627168$var$useRealtimeField(rtpath.append(field, {}), "", $1323e57a6b627168$export$f4fa1ee095760378);
            return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                className: "form-floating",
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("select", {
                        id: id,
                        value: val,
                        className: `form-select ${isSaving ? "busy" : ""}`,
                        ...props,
                        onChange: (e)=>save(e.target.value),
                        children: children
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("label", {
                        htmlFor: id,
                        children: label
                    })
                ]
            });
        },
        UnitField ({ label: label , field: field , unitType: unitType , className: className , ...props }) {
            const fromType = unitType == "lengthSmall" ? "length" : unitType;
            // Need to memoize the adapter because useRealtimeField's useEffect hook is
            // constrained by it
            const adapter = (0, $8T3gX.useMemo)(()=>{
                return {
                    fromRT (v) {
                        if ((v ?? 0) === 0) return "";
                        return String((0, $a147a5343133f2a5$export$a81eda11c790c16)((0, $a53c6536bb8a7347$export$51bc4f4f84f52eab)(v, (0, $a53c6536bb8a7347$export$dc8ef91cafc34879)[fromType], userUnits[unitType])));
                    },
                    toRT (v) {
                        const val = (0, $a53c6536bb8a7347$export$26c3d0b70508b36c)(v, userUnits[unitType], (0, $a53c6536bb8a7347$export$dc8ef91cafc34879)[fromType]);
                        if (val === 0 || isNaN(val)) return 0, $febfa929b76327ac$export$4bd2facc4a3e6aa1;
                        return (0, $a53c6536bb8a7347$export$26c3d0b70508b36c)(v, userUnits[unitType], (0, $a53c6536bb8a7347$export$dc8ef91cafc34879)[fromType]);
                    }
                };
            }, [
                unitType,
                fromType
            ]);
            const { val: val , setVal: setVal , save: save , isSaving: isSaving , id: id  } = $1323e57a6b627168$var$useRealtimeField(rtpath.append(field, {}), "", adapter);
            return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                className: "form-floating",
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("input", {
                        id: id,
                        placeholder: id,
                        value: val,
                        className: `form-control ${isSaving ? "busy" : ""} ${className ?? ""}`,
                        ...props,
                        onChange: (e)=>{
                            setVal(e.target.value);
                        },
                        onBlur: ()=>save()
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("label", {
                        htmlFor: id,
                        children: label
                    })
                ]
            });
        }
    };
}






function $6c14caa5b06d34a6$var$FormSection({ className: className , children: children , ...props }) {
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
        className: (0, $a147a5343133f2a5$export$1343a74baacb0543)(className, `text-muted h2 mt-3`),
        ...props,
        children: children
    });
}
function $6c14caa5b06d34a6$export$2e2bcd8739ae039() {
    const [userUnits = (0, $a53c6536bb8a7347$export$dc8ef91cafc34879)] = (0, $de6e1888d0a1ea86$export$6bd5211fd2e82d10)();
    const [attendee] = (0, $de6e1888d0a1ea86$export$67c1131f3997904d)();
    const [detailMotor, setDetailMotor] = (0, $8T3gX.useState)();
    const [editMotor, setEditMotor] = (0, $8T3gX.useState)();
    const match = (0, $3T949.useMatch)("launches/:launchId/cards/:cardId");
    const isOfficer = (0, $65c18c84559ec290$export$bb4710074625bd7e)();
    const cardFields = {
        launchId: match?.params.launchId ?? "",
        cardId: match?.params.cardId ?? ""
    };
    const [card] = (0, $febfa929b76327ac$export$fe4c1a3a7af84c36)((0, $71b3f0397fe2ca79$export$c180d6f0b8dacb9f).with(cardFields));
    const cardPath = (0, $71b3f0397fe2ca79$export$c180d6f0b8dacb9f).with(cardFields);
    const flierFields = {
        launchId: match?.params.launchId ?? "",
        userId: card?.userId ?? ""
    };
    const flierPath = (0, $71b3f0397fe2ca79$export$9b60127abde046a1).with(flierFields);
    const [flier] = (0, $febfa929b76327ac$export$fe4c1a3a7af84c36)(flierPath);
    const disabled = attendee?.id !== flier?.id;
    const colorsPath = (0, $71b3f0397fe2ca79$export$dd27bd64c4016e52).append("color").with(cardFields);
    const [colors] = (0, $febfa929b76327ac$export$fe4c1a3a7af84c36)(colorsPath);
    const rtui = (0, $8T3gX.useMemo)(()=>{
        return (0, $1323e57a6b627168$export$fd869eba2656ca90)(cardPath, userUnits);
    }, [
        cardPath,
        userUnits
    ]);
    if (!card) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Card"
    });
    if (!attendee) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Current user"
    });
    const isOwner = attendee?.id == card?.userId;
    const isDraft = card?.status === (0, $aaa72a458935fe7a$export$490c7ce941281ba8).DRAFT;
    const isReadOnly = !isDraft && !isOfficer;
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
        children: [
            flier && !isOwner ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $e9bc3aadba8432ee$exports.Fragment), {
                children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $9548d15ba50fa792$export$19f442a6794aa329), {
                    className: "me-3 h2",
                    attendee: flier
                })
            }) : null,
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)($6c14caa5b06d34a6$var$FormSection, {
                className: "d-flex",
                children: "Rocket"
            }),
            isReadOnly ? null : /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $119599695d52dc74$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                className: "d-grid deck",
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(rtui.StringInput, {
                        disabled: isReadOnly,
                        field: "rocket/name",
                        label: "Rocket Name"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(rtui.StringInput, {
                        disabled: isReadOnly,
                        field: "rocket/manufacturer",
                        label: "Manufacturer"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(rtui.UnitField, {
                        disabled: isReadOnly,
                        field: "rocket/length",
                        unitType: "length",
                        label: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
                            children: [
                                "Length",
                                " ",
                                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("span", {
                                    className: "text-info ms-2",
                                    children: [
                                        "(",
                                        userUnits.length,
                                        ")"
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(rtui.UnitField, {
                        disabled: isReadOnly,
                        field: "rocket/diameter",
                        unitType: "lengthSmall",
                        label: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
                            children: [
                                "Diameter",
                                " ",
                                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("span", {
                                    className: "text-info ms-2",
                                    children: [
                                        "(",
                                        userUnits.lengthSmall,
                                        ")"
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(rtui.UnitField, {
                        disabled: isReadOnly,
                        field: "rocket/mass",
                        unitType: "mass",
                        label: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
                            children: [
                                "Mass",
                                " ",
                                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("span", {
                                    className: "text-info ms-2",
                                    children: [
                                        " ",
                                        "(",
                                        userUnits.mass,
                                        ", incl. motors)"
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                        className: "d-flex flex-grow-1",
                        children: [
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(rtui.StringInput, {
                                disabled: isReadOnly,
                                field: "rocket/color",
                                label: "Colors",
                                className: "flex-grow-1"
                            }),
                            colors && /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                                className: "d-flex flex-column ms-1 border border-dark",
                                style: {
                                    width: "35px"
                                },
                                children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $42a584c902e2bfd5$export$2e2bcd8739ae039), {
                                    colors: colors,
                                    className: "flex-grow-1"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)(rtui.Select, {
                        disabled: isReadOnly,
                        label: "Recovery",
                        field: "rocket/recovery",
                        children: [
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("option", {
                                value: "",
                                children: "Unspecified"
                            }),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("option", {
                                value: (0, $aaa72a458935fe7a$export$5cfb7a58c44e97d1).CHUTE,
                                children: "Chute"
                            }),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("option", {
                                value: (0, $aaa72a458935fe7a$export$5cfb7a58c44e97d1).STREAMER,
                                children: "Streamer"
                            }),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("option", {
                                value: (0, $aaa72a458935fe7a$export$5cfb7a58c44e97d1).DUAL_DEPLOY,
                                children: "Dual-Deploy"
                            }),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("option", {
                                value: (0, $aaa72a458935fe7a$export$5cfb7a58c44e97d1).TUMBLE,
                                children: "Tumble"
                            }),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("option", {
                                value: (0, $aaa72a458935fe7a$export$5cfb7a58c44e97d1).GLIDE,
                                children: "Glide"
                            }),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("option", {
                                value: (0, $aaa72a458935fe7a$export$5cfb7a58c44e97d1).HELICOPTER,
                                children: "Helicopter"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)($6c14caa5b06d34a6$var$FormSection, {
                className: "d-flex justify-content-between",
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                        children: "Motors"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                        disabled: isReadOnly,
                        onClick: ()=>setEditMotor({
                                id: ""
                            }),
                        children: "Add Motor..."
                    })
                ]
            }),
            cardFields && /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $82606860a6f601ba$export$f38900f779f45ac4), {
                disabled: isReadOnly,
                rtFields: cardFields,
                setEditMotor: setEditMotor,
                setDetailMotor: setDetailMotor
            }),
            cardFields && /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $046ff7a4ddd7a466$export$2e2bcd8739ae039), {
                rtFields: cardFields
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)($6c14caa5b06d34a6$var$FormSection, {
                children: "Special"
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                className: "d-flex rounded border my-3 py-2 px-3",
                style: {
                    borderColor: "#ced4da",
                    backgroundColor: disabled ? "#e9ecef" : "inherit"
                },
                children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                    className: "flex-grow-1 d-grid",
                    style: {
                        gap: ".5em 1em",
                        gridTemplateColumns: "repeat(auto-fit, minmax(8em, 1fr)"
                    },
                    children: [
                        /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(rtui.Check, {
                            disabled: isReadOnly,
                            field: "firstFlight",
                            label: "1st Flight"
                        }),
                        /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(rtui.Check, {
                            disabled: isReadOnly,
                            field: "headsUp",
                            label: "Heads Up"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(rtui.TextArea, {
                disabled: isReadOnly,
                field: "notes",
                label: "Notes"
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)($6c14caa5b06d34a6$var$FormSection, {
                children: "Next Steps …"
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $00a0d9503d98b74d$export$9b6a647253f61c5f), {
                card: card
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $4beabeb039e49562$export$d7fd01694c28dc31), {}),
            editMotor && cardFields ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $560977bbc8fcfb6d$export$29f0693f0cda1871), {
                rtFields: cardFields,
                motor: editMotor,
                onHide: ()=>setEditMotor(undefined)
            }) : null,
            detailMotor ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $9dbccb978f1dbbfe$export$26d326d0f3da87fc), {
                motor: detailMotor,
                onHide: ()=>setDetailMotor(undefined)
            }) : null
        ]
    });
}



parcelRequire("8T3gX");



parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");




function $72515a87b1746ba0$export$392f9c076db9c98e() {
    const [launch] = (0, $de6e1888d0a1ea86$export$75eeb04b2db35f42)();
    const [currentUser] = (0, $de6e1888d0a1ea86$export$3901076af3749fa9)();
    const navigate = (0, $3T949.useNavigate)();
    const launchId = launch?.id;
    const userId = currentUser?.id;
    function gotoNewCard() {
        // Launch or user hasn't loaded yet?
        if (!launchId || !userId) return;
        const card = {
            id: (0, $40b0ef4339cb3cfb$export$ac4959f4f1338dfc)(),
            status: (0, $aaa72a458935fe7a$export$490c7ce941281ba8).DRAFT,
            launchId: launchId,
            userId: userId
        };
        const rtpath = (0, $71b3f0397fe2ca79$export$c180d6f0b8dacb9f).with({
            launchId: card.launchId,
            cardId: card.id
        });
        return (0, $febfa929b76327ac$export$2ef6846d36515d5)(rtpath, card).then(()=>navigate(`/launches/${card.launchId}/cards/${card.id}`));
    }
    return gotoNewCard;
}






function $8a68470a9a873614$export$c17ac35ce77f7737() {
    const [launch] = (0, $de6e1888d0a1ea86$export$75eeb04b2db35f42)();
    const [currentUser] = (0, $de6e1888d0a1ea86$export$3901076af3749fa9)();
    const [cards] = (0, $de6e1888d0a1ea86$export$5fe928848609fec7)();
    const { DRAFT: DRAFT , REVIEW: REVIEW , FLY: FLY , DONE: DONE  } = (0, $aaa72a458935fe7a$export$490c7ce941281ba8);
    const makeNewCard = (0, $72515a87b1746ba0$export$392f9c076db9c98e)();
    if (!launch) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Launch"
    });
    if (!currentUser) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "User"
    });
    const userCards = Object.values(cards || {}).filter((c)=>c.userId == currentUser.id);
    const cardGroups = (0, $2914d071bbef92ec$export$ab5e74a2c43c30ea)(userCards, (c)=>c.status ?? DRAFT);
    const draftCards = userCards.filter((c)=>c.status == DRAFT);
    const reviewCards = userCards.filter((c)=>c.status == REVIEW);
    const readyCards = userCards.filter((c)=>c.status == FLY);
    const doneCards = userCards.filter((c)=>c.status == DONE);
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                className: "d-flex my-2 gap-3",
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h2", {
                        className: "flex-grow-1",
                        children: "Drafts"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                        onClick: makeNewCard,
                        className: "my-1",
                        children: "New Flight Card …"
                    })
                ]
            }),
            draftCards.length ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $4cafc1ae92bff46f$export$bb29c16f5612603e), {
                cards: cardGroups.get(DRAFT)
            }) : /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("p", {
                className: "text-secondary",
                children: "Nothing here"
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h2", {
                children: "Review"
            }),
            reviewCards.length ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $4cafc1ae92bff46f$export$bb29c16f5612603e), {
                cards: cardGroups.get(REVIEW)
            }) : /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("p", {
                className: "text-secondary",
                children: "Nothing here"
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h2", {
                children: "Ready to Launch"
            }),
            readyCards.length ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $4cafc1ae92bff46f$export$bb29c16f5612603e), {
                cards: cardGroups.get(FLY)
            }) : /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("p", {
                className: "text-secondary",
                children: "Nothing here"
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h2", {
                children: "Completed"
            }),
            doneCards.length ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $4cafc1ae92bff46f$export$bb29c16f5612603e), {
                cards: cardGroups.get(DONE)
            }) : /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("p", {
                className: "text-secondary",
                children: "Nothing here"
            })
        ]
    });
}



parcelRequire("8T3gX");



parcelRequire("8T3gX");



function $3c3fc1049d138b82$export$2e2bcd8739ae039({ launchId: launchId , userId: userId , ...props }) {
    const rtpath = (0, $71b3f0397fe2ca79$export$44a4a6081810942c).with({
        launchId: launchId,
        userId: userId
    });
    const [role] = (0, $febfa929b76327ac$export$fe4c1a3a7af84c36)(rtpath);
    function setRole(role) {
        (0, $febfa929b76327ac$export$2ef6846d36515d5)(rtpath, role || (0, $febfa929b76327ac$export$4bd2facc4a3e6aa1));
    }
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $48662f9e660678c6$export$2e2bcd8739ae039), {
        name: "role-pref",
        value: role ?? "",
        type: "radio",
        onChange: (val)=>{
            setRole(val);
        },
        ...props,
        children: [
            [
                "Off Duty",
                ""
            ],
            [
                "RSO",
                "rso"
            ],
            [
                "LCO",
                "lco"
            ]
        ].map(([name, value])=>/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $bf2b0d5c4b4f72cf$export$2e2bcd8739ae039), {
                variant: "outline-primary",
                className: "flex-fill",
                size: "sm",
                id: `role-pref-${value}`,
                value: value,
                style: {
                    minWidth: "6em"
                },
                children: name
            }, `role-${value}`))
    });
}





parcelRequire("8T3gX");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");







function $71a39fa71327480b$export$1c9fa03e23146e86({ card: card , summary: summary  }) {
    const motors = Object.values(card?.motors ?? {});
    const navigate = (0, $3T949.useNavigate)();
    const [attendees] = (0, $de6e1888d0a1ea86$export$f755a54f5b6ffe30)();
    if (!attendees) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Attendees"
    });
    const user = attendees[card.userId ?? ""];
    const impulseClass = (0, $0e759b381c300a7c$export$6f335bde3fedcd2e)(motors);
    const warnings = [];
    const isVerified = (0, $d5b1995fb206c61d$export$f9610ead7d6f0608)(user);
    const certLevel = (0, $d5b1995fb206c61d$export$ce1ea330f9f0869)(user, true);
    if (isVerified) {
        if (!impulseClass) warnings.push("Unknown rocket impulse (Is flier certified for this flight?)");
        else if (impulseClass > "L" && certLevel < 3) warnings.push(`Flier not L3 certified`);
        else if (impulseClass > "I" && certLevel < 2) warnings.push(`Flier not L2 certified`);
        else if (impulseClass > "H" && certLevel < 1) warnings.push(`Flier not L1 certified`);
    } else if (!impulseClass || impulseClass > "H" && !isVerified) warnings.push("Verify flier cert");
    let launchcardUrl = `/launches/${card.launchId}/cards/${card.id}`;
    if (summary) launchcardUrl += "/summary";
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
        className: "d-flex flex-grow-1 launch-card rounded border border-dark m-2 ps-2 cursor-pointer",
        onClick: ()=>navigate(launchcardUrl),
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                className: "flex-grow-1  align-self-center",
                children: [
                    user.name,
                    ' — "',
                    card?.rocket?.name ?? "(unnamed)",
                    '"',
                    warnings.length ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                        children: warnings.map((w)=>/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3fa1314cc730edf3$export$c688898c4e3580ee), {
                                children: w
                            }, w))
                    }) : null
                ]
            }),
            card.rocket?.color ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                className: "d-flex flex-column flex-grow-0 flex-shrink-0  border-start border-light",
                style: {
                    flexBasis: "20px"
                },
                children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $42a584c902e2bfd5$export$2e2bcd8739ae039), {
                    className: "flex-grow-1",
                    colors: card.rocket?.color
                })
            }) : /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                className: "flex-grow-0 flex-shrink-0"
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                className: "flex-grow-0 text-center fs-3 align-self-stretch",
                style: {
                    flexBasis: "2em",
                    backgroundColor: "rgba(0, 0, 0, .15)"
                },
                children: impulseClass ?? "-"
            })
        ]
    });
}






function $3e4428930bc62d59$var$PadCard({ pad: pad , cards: cards , ...props }) {
    let content;
    const isOfficer = (0, $65c18c84559ec290$export$bb4710074625bd7e)();
    if (cards.length > 1) content = /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
        className: "flex-grow-1",
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("strong", {
                className: "text-warning me-2",
                children: [
                    "⚠",
                    " Pad Conflict"
                ]
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                className: "deck",
                children: cards.map((card)=>{
                    const rtFields = {
                        launchId: card.launchId,
                        cardId: card.id
                    };
                    const unrack = async function(e) {
                        const path = (0, $71b3f0397fe2ca79$export$c180d6f0b8dacb9f).append("padId").with(rtFields);
                        (0, $a147a5343133f2a5$export$95dc765ca5d5cc35)(e.currentTarget, (0, $febfa929b76327ac$export$3f3cbd6c9a0055d0)(path));
                    };
                    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                        className: "d-flex",
                        children: [
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $71a39fa71327480b$export$1c9fa03e23146e86), {
                                className: "mt-2",
                                card: card,
                                summary: true
                            }),
                            isOfficer ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                                variant: "warning",
                                className: "flex-grow-0 align-self-center",
                                onClick: unrack,
                                children: "Unrack"
                            }) : null
                        ]
                    }, card.id);
                })
            })
        ]
    });
    else content = /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $71a39fa71327480b$export$1c9fa03e23146e86), {
        className: "mt-2",
        card: cards[0],
        summary: true
    });
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
        ...props,
        className: "d-flex",
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                className: "fw-bold me-3 text-nowrap",
                children: pad.name
            }),
            content
        ]
    });
}
function $3e4428930bc62d59$export$7cf1a375f6043cd1() {
    const [pads] = (0, $de6e1888d0a1ea86$export$5b051e2383c8638d)();
    const [launch] = (0, $de6e1888d0a1ea86$export$75eeb04b2db35f42)();
    const [currentAttendee] = (0, $de6e1888d0a1ea86$export$67c1131f3997904d)();
    const [attendees] = (0, $de6e1888d0a1ea86$export$f755a54f5b6ffe30)();
    const [allCards = []] = (0, $de6e1888d0a1ea86$export$5fe928848609fec7)();
    const isOfficer = (0, $65c18c84559ec290$export$bb4710074625bd7e)();
    if (!pads) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Pads"
    });
    if (!attendees) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Attendees"
    });
    if (!allCards) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Cards"
    });
    const readyCards = Object.values(allCards).filter((card)=>card.status === (0, $aaa72a458935fe7a$export$490c7ce941281ba8).FLY);
    const padsBygroup = (0, $2914d071bbef92ec$export$ab5e74a2c43c30ea)(Object.values(pads), (pad)=>pad.group ?? "");
    const cardsByPad = (0, $2914d071bbef92ec$export$ab5e74a2c43c30ea)(readyCards, (card)=>card.padId ?? "");
    const unrackedCards = cardsByPad.get("");
    cardsByPad.delete("");
    const groupNames = [
        ...padsBygroup.keys()
    ].sort();
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
        children: [
            isOfficer ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                className: "d-flex justify-content-center align-items-baseline mb-3",
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                        className: "me-2",
                        children: "My Status: "
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3c3fc1049d138b82$export$2e2bcd8739ae039), {
                        launchId: launch?.id ?? "",
                        userId: currentAttendee?.id ?? ""
                    })
                ]
            }) : null,
            groupNames.map((groupName)=>{
                const pads = padsBygroup.get(groupName);
                if (!pads) return null;
                (0, $2914d071bbef92ec$export$7a7adbcc2fafd347)(pads, (pad)=>pad.name ?? "");
                return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h2", {
                            className: "mt-3",
                            children: groupName
                        }),
                        pads.map((pad)=>{
                            const cards = cardsByPad.get(pad.id);
                            if (!cards) return null;
                            return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)($3e4428930bc62d59$var$PadCard, {
                                pad: pad,
                                cards: cards
                            }, pad.id);
                        })
                    ]
                }, groupName);
            }),
            unrackedCards?.length ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("hr", {}),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h2", {
                        children: "RSO Approved (waiting for pad)"
                    }),
                    unrackedCards.map((card)=>/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $71a39fa71327480b$export$1c9fa03e23146e86), {
                            card: card
                        }, card.id))
                ]
            }) : null
        ]
    });
}





parcelRequire("8T3gX");








function $ee866c7918c934e6$export$73cbf78008b0464() {
    const [launch] = (0, $de6e1888d0a1ea86$export$75eeb04b2db35f42)();
    const [user] = (0, $de6e1888d0a1ea86$export$67c1131f3997904d)();
    const [cards] = (0, $de6e1888d0a1ea86$export$5fe928848609fec7)();
    const [attendees] = (0, $de6e1888d0a1ea86$export$f755a54f5b6ffe30)();
    const isOfficer = (0, $65c18c84559ec290$export$bb4710074625bd7e)();
    if (!attendees) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Users"
    });
    const rsoCards = Object.values(cards || {}).filter((c)=>c.status === (0, $aaa72a458935fe7a$export$490c7ce941281ba8).REVIEW);
    (0, $2914d071bbef92ec$export$7a7adbcc2fafd347)(rsoCards, (card)=>attendees[card.userId].name ?? "");
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
        children: [
            isOfficer ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                className: "d-flex justify-content-center align-items-baseline mb-3",
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                        className: "me-2",
                        children: "My Status: "
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3c3fc1049d138b82$export$2e2bcd8739ae039), {
                        launchId: launch?.id ?? "",
                        userId: user?.id ?? ""
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h2", {
                children: "RSO Requests"
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                children: rsoCards.length ? rsoCards.map((card)=>/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $71a39fa71327480b$export$1c9fa03e23146e86), {
                        className: "mt-2",
                        card: card,
                        attendee: attendees?.[card.userId],
                        summary: true
                    }, card.id)) : /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $1d0a237fe4c0025c$export$2e2bcd8739ae039), {
                    variant: "secondary",
                    children: "No RSO requests at this time."
                })
            })
        ]
    });
}



parcelRequire("8T3gX");


var $3T949 = parcelRequire("3T949");



var $8T3gX = parcelRequire("8T3gX");












function $963abfab9ce8e83f$var$UserEditor({ launchId: launchId , userId: userId , onHide: onHide  }) {
    const [currentUser] = (0, $de6e1888d0a1ea86$export$3901076af3749fa9)();
    const roleApi = (0, $65c18c84559ec290$export$42f63dcbdf962527)();
    const isOfficer = roleApi.isOfficer(userId);
    const rtFields = {
        launchId: launchId,
        userId: userId
    };
    const [attendee] = (0, $febfa929b76327ac$export$fe4c1a3a7af84c36)((0, $71b3f0397fe2ca79$export$9b60127abde046a1).with(rtFields));
    if (!attendee) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "User"
    });
    if (!currentUser) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Current user"
    });
    const onVerify = function(organization, verified) {
        const rtPath = organization === "TRA" ? (0, $71b3f0397fe2ca79$export$fcb89df7dbf28b19).with(rtFields) : (0, $71b3f0397fe2ca79$export$7bb590570d143469).with(rtFields);
        const cert = {
            verifiedId: verified ? currentUser.id : (0, $febfa929b76327ac$export$4bd2facc4a3e6aa1),
            verifiedTime: verified ? Date.now() : (0, $febfa929b76327ac$export$4bd2facc4a3e6aa1)
        };
        return (0, $febfa929b76327ac$export$78d8dceb730843fa)(rtPath, cert);
    };
    const onOfficerToggle = async function(e) {
        if (e.target.checked) await (0, $febfa929b76327ac$export$2ef6846d36515d5)((0, $71b3f0397fe2ca79$export$63aafa5cd2e21081).with(rtFields), true);
        else await (0, $febfa929b76327ac$export$3f3cbd6c9a0055d0)((0, $71b3f0397fe2ca79$export$63aafa5cd2e21081).with(rtFields));
    };
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $dcbe90c8bc15d3fe$export$2e2bcd8739ae039), {
        size: "lg",
        show: true,
        onHide: onHide,
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $dcbe90c8bc15d3fe$export$2e2bcd8739ae039).Header, {
                closeButton: true,
                children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $dcbe90c8bc15d3fe$export$2e2bcd8739ae039).Title, {
                    children: [
                        attendee.name || (0, $5c148f2ca1c26c40$export$d64425f8a23d9468),
                        " "
                    ]
                })
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $dcbe90c8bc15d3fe$export$2e2bcd8739ae039).Body, {
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h3", {
                        children: "Certifications"
                    }),
                    Object.values(attendee.certs ?? []).map((cert)=>{
                        const certLevel = cert.level;
                        const certVerified = !!cert.verifiedId;
                        return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                            className: "card p-2 mb-2 ms-2",
                            style: {
                                maxWidth: "25em"
                            },
                            children: [
                                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                                    className: "d-flex",
                                    children: [
                                        /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                                            className: "d-flex flex-grow-1",
                                            children: [
                                                cert.organization,
                                                " #",
                                                cert.memberId
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                                            children: [
                                                "Level ",
                                                certLevel
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                                    className: "d-flex",
                                    children: [
                                        /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                                            className: "flex-grow-1",
                                            children: [
                                                cert.firstName,
                                                " ",
                                                cert.lastName
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                                            children: [
                                                "Expires ",
                                                new Date(cert.expires ?? 0).toLocaleDateString()
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                                    className: "d-flex",
                                    children: [
                                        /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $82743675752b4983$export$2e2bcd8739ae039).Check, {
                                            inline: true,
                                            id: `verified-${cert.organization}`,
                                            className: "flex-grow-1",
                                            label: `Verified`,
                                            onChange: ()=>onVerify(cert.organization ?? (0, $aaa72a458935fe7a$export$67788f4001cebb21).TRA, !certVerified),
                                            checked: certVerified
                                        }),
                                        /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("span", {
                                            children: cert.verifiedId ? "" : /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3fa1314cc730edf3$export$c688898c4e3580ee), {
                                                children: "Needs Verification"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, cert.organization);
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h3", {
                        children: "Role"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $82743675752b4983$export$2e2bcd8739ae039).Switch, {
                        id: "officer",
                        className: "ms-2",
                        label: "Club officer (RSO / LCO qualified)",
                        onChange: onOfficerToggle,
                        checked: isOfficer ?? false
                    })
                ]
            })
        ]
    });
}
function $963abfab9ce8e83f$export$21b6143e6c635cfa({ launchId: launchId , filter: filter , children: children , ...props }) {
    const [editUserId, setEditUserId] = (0, $8T3gX.useState)();
    const [launch] = (0, $de6e1888d0a1ea86$export$75eeb04b2db35f42)();
    const [attendees] = (0, $de6e1888d0a1ea86$export$f755a54f5b6ffe30)();
    const isOfficer = (0, $65c18c84559ec290$export$bb4710074625bd7e)();
    const roleApi = (0, $65c18c84559ec290$export$42f63dcbdf962527)();
    if (!launch) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "User launch"
    });
    if (!attendees) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Attendees"
    });
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h2", {
                className: "my-3 d-flex",
                children: children
            }),
            editUserId ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)($963abfab9ce8e83f$var$UserEditor, {
                launchId: launchId,
                userId: editUserId,
                onHide: ()=>setEditUserId(undefined)
            }) : null,
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                className: "deck",
                style: {
                    gridTemplateColumns: "repeat(auto-fit, minmax(12em, 1fr))"
                },
                ...props,
                children: (0, $2914d071bbef92ec$export$7a7adbcc2fafd347)(Object.values(attendees), "name").map((attendee)=>{
                    if (filter && !filter(attendee, roleApi.isOfficer(attendee))) return null;
                    const { id: id  } = attendee;
                    const attendeeInfo = /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $9548d15ba50fa792$export$19f442a6794aa329), {
                        attendee: attendee,
                        className: "flex-grow-1"
                    });
                    return isOfficer ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                        variant: "light",
                        className: (0, $a147a5343133f2a5$export$1343a74baacb0543)(`d-flex flex-grow-1 p-1 align-items-center text-start`, {
                            "mock-badge": (0, $f31a31c32b1a153a$export$e27e8a613b80545b)(attendee)
                        }),
                        onClick: ()=>setEditUserId(attendee.id),
                        children: attendeeInfo
                    }, id) : /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                        className: `p-2 bg-light rounded border border-light d-flex flex-grow-1 align-items-center text-start ${attendee.photoURL ? "ps-0 py-0" : ""}`,
                        children: attendeeInfo
                    }, id);
                })
            })
        ]
    });
}




const $4f1825c325b077e3$var$OFFICERS = "officers";
const $4f1825c325b077e3$var$LOW_POWER = "low";
const $4f1825c325b077e3$var$HIGH_POWER = "high";
const $4f1825c325b077e3$var$ALL = "all";
function $4f1825c325b077e3$var$officerUsers(user, isOfficer) {
    return isOfficer ?? false;
}
function $4f1825c325b077e3$var$lowPowerUsers(user) {
    return (0, $d5b1995fb206c61d$export$ce1ea330f9f0869)(user) == 0;
}
function $4f1825c325b077e3$var$highPowerUsers(user) {
    return (0, $d5b1995fb206c61d$export$ce1ea330f9f0869)(user) > 0;
}
function $4f1825c325b077e3$export$289b7ec390c4c77f() {
    let { filter: filter  } = (0, $3T949.useParams)();
    const [launch] = (0, $de6e1888d0a1ea86$export$75eeb04b2db35f42)();
    if (!launch) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Launch"
    });
    let title, userFilter;
    switch(filter){
        case $4f1825c325b077e3$var$OFFICERS:
            title = "Officers";
            userFilter = $4f1825c325b077e3$var$officerUsers;
            break;
        case $4f1825c325b077e3$var$LOW_POWER:
            title = "Low Power Attendees";
            userFilter = $4f1825c325b077e3$var$lowPowerUsers;
            break;
        case $4f1825c325b077e3$var$HIGH_POWER:
            title = "High Power Attendees";
            userFilter = $4f1825c325b077e3$var$highPowerUsers;
            break;
        default:
            filter = $4f1825c325b077e3$var$ALL;
            title = "Everyone";
            break;
    }
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $6cb1eff92841402c$export$2e2bcd8739ae039), {
                className: "mt-2",
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$29d11c0fe2fc51d8), {
                        isActive: ()=>filter === $4f1825c325b077e3$var$ALL,
                        to: `/launches/${launch.id}/users/all`,
                        children: "All"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$29d11c0fe2fc51d8), {
                        isActive: ()=>filter === $4f1825c325b077e3$var$OFFICERS,
                        to: `/launches/${launch.id}/users/${$4f1825c325b077e3$var$OFFICERS}`,
                        children: "★"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$29d11c0fe2fc51d8), {
                        isActive: ()=>filter === $4f1825c325b077e3$var$LOW_POWER,
                        to: `/launches/${launch.id}/users/${$4f1825c325b077e3$var$LOW_POWER}`,
                        children: "LP"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$29d11c0fe2fc51d8), {
                        isActive: ()=>filter === $4f1825c325b077e3$var$HIGH_POWER,
                        to: `/launches/${launch.id}/users/${$4f1825c325b077e3$var$HIGH_POWER}`,
                        children: "HP"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $963abfab9ce8e83f$export$21b6143e6c635cfa), {
                launchId: launch.id,
                filter: userFilter,
                children: title
            })
        ]
    });
}




var $8T3gX = parcelRequire("8T3gX");


var $3T949 = parcelRequire("3T949");






var $8T3gX = parcelRequire("8T3gX");




var $8T3gX = parcelRequire("8T3gX");

function $191c7221506aa247$var$FloatingInput({ className: className , style: style , children: children , ...props }, ref) {
    const label = children;
    let id = label.props.children;
    if (Array.isArray(id)) id = id.find((v)=>typeof v == "string");
    id = id.replace(/\s+/g, "_").toLowerCase();
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
        style: style,
        className: (0, $a147a5343133f2a5$export$1343a74baacb0543)(className, `form-floating`),
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("input", {
                ref: ref,
                id: id,
                placeholder: id,
                className: "form-control",
                ...props
            }),
            /*#__PURE__*/ (0, $8T3gX.cloneElement)(label, {
                htmlFor: id,
                style: {
                    whiteSpace: "nowrap"
                }
            })
        ]
    });
}
var $191c7221506aa247$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).forwardRef($191c7221506aa247$var$FloatingInput);





function $5a76555e9297a1c3$export$b8be822412cfb328({ pad: pad , groups: groups , ...props }) {
    const nameRef = (0, $8T3gX.useRef)(null);
    const groupRef = (0, $8T3gX.useRef)(null);
    const [launch] = (0, $de6e1888d0a1ea86$export$75eeb04b2db35f42)();
    if (!launch) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Launch"
    });
    const { id: launchId  } = launch;
    const { onHide: onHide  } = props;
    const handleSave = function(e) {
        const target = e.target;
        target.classList.toggle("busy", true);
        const name = nameRef.current?.value ?? "";
        const group = groupRef.current?.value || (0, $febfa929b76327ac$export$4bd2facc4a3e6aa1);
        let action;
        if (pad.id) action = (0, $febfa929b76327ac$export$78d8dceb730843fa)((0, $71b3f0397fe2ca79$export$beff8d4a9be6e9d7).with({
            launchId: launchId,
            padId: pad.id
        }), {
            name: name.trim(),
            group: group
        });
        else {
            const names = name.split(",").filter((v)=>v);
            action = Promise.all(names.map((padName)=>{
                const id = (0, $40b0ef4339cb3cfb$export$ac4959f4f1338dfc)();
                return (0, $febfa929b76327ac$export$2ef6846d36515d5)((0, $71b3f0397fe2ca79$export$beff8d4a9be6e9d7).with({
                    launchId: launchId,
                    padId: id
                }), {
                    id: id,
                    name: padName.trim(),
                    group: group
                });
            }));
        }
        (0, $a147a5343133f2a5$export$95dc765ca5d5cc35)(e.target, action).then(onHide);
    };
    const handleDelete = function(e) {
        if (!confirm(`Permanently delete the "${pad.name ?? "(unnamed pad)"}" pad?  This can not be undone, and may affect users with cards assigned to this pad.`)) return;
        const action = (0, $febfa929b76327ac$export$3f3cbd6c9a0055d0)((0, $71b3f0397fe2ca79$export$beff8d4a9be6e9d7).with({
            launchId: launchId,
            padId: pad.id
        }));
        (0, $a147a5343133f2a5$export$95dc765ca5d5cc35)(e.target, action).then(onHide);
    };
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $dcbe90c8bc15d3fe$export$2e2bcd8739ae039), {
        show: true,
        ...props,
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $dcbe90c8bc15d3fe$export$2e2bcd8739ae039).Title, {
                className: "p-2",
                children: pad.id ? "Edit Pad" : "New Pad"
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $dcbe90c8bc15d3fe$export$2e2bcd8739ae039).Body, {
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                        className: "d-flex gap-4",
                        children: [
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $191c7221506aa247$export$2e2bcd8739ae039), {
                                autoFocus: true,
                                ref: nameRef,
                                className: "flex-grow-1",
                                defaultValue: pad.name,
                                children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("label", {
                                    children: "Pad Name"
                                })
                            }),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $191c7221506aa247$export$2e2bcd8739ae039), {
                                ref: groupRef,
                                list: "group-names",
                                className: "flex-grow-1",
                                defaultValue: pad.group ?? "",
                                children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("label", {
                                    children: [
                                        "Pad Group ",
                                        /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("span", {
                                            className: "text-info",
                                            children: "(optional)"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("datalist", {
                                id: "group-names",
                                children: groups?.filter((v)=>v).map((group)=>/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("option", {
                                        value: group
                                    }, group))
                            })
                        ]
                    }),
                    pad.id ? null : /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("small", {
                        className: "text-secondary text-center mt-3 font-small display-block",
                        children: 'To create multiple pads at once, separate names with a comma (",")'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $dcbe90c8bc15d3fe$export$2e2bcd8739ae039).Footer, {
                className: "d-flex",
                children: [
                    pad.id ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                        onClick: handleDelete,
                        tabIndex: -1,
                        variant: "danger",
                        children: [
                            "✕",
                            " Delete"
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                        className: "flex-grow-1"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                        className: "ms-5",
                        variant: "secondary",
                        onClick: props.onHide,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                        onClick: handleSave,
                        children: pad.id ? "Update" : "Create"
                    })
                ]
            })
        ]
    });
}






var $8T3gX = parcelRequire("8T3gX");


function $4434787c63dd47a9$export$8d5bd6735343c6be({ launchId: launchId , padGroup: groupName , ...props }) {
    const [newName, setNewName] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(groupName);
    const rtPath = (0, $71b3f0397fe2ca79$export$83289c7452cd8ea9).with({
        launchId: launchId
    });
    async function onSave() {
        if (newName?.trim() !== groupName?.trim()) {
            const pads = await (0, $febfa929b76327ac$export$c10e31973268dac4)(rtPath);
            // We have the realtime db set up to disallow bulk edits of the entire pads
            // collection for a launch, so we have to iterate through each one
            // individually
            await Promise.all(Object.values(pads).map(async (pad)=>{
                if ((pad.group ?? "") !== groupName) return;
                pad.group = newName?.trim();
                return await (0, $febfa929b76327ac$export$2ef6846d36515d5)((0, $71b3f0397fe2ca79$export$beff8d4a9be6e9d7).with({
                    launchId: launchId,
                    padId: pad.id
                }), pad);
            }));
        }
    }
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
        className: "d-grid mb-2  align-items-stretch",
        style: {
            width: "20em",
            gridTemplateColumns: "1fr 0fr"
        },
        ...props,
        children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("input", {
            autoFocus: true,
            type: "text",
            value: newName,
            placeholder: "(default group)",
            onChange: (e)=>setNewName(e.target.value),
            onBlur: onSave
        })
    });
}






function $44a4895b71a1d3ae$export$2e2bcd8739ae039() {
    const [launch] = (0, $de6e1888d0a1ea86$export$75eeb04b2db35f42)();
    const [pads] = (0, $de6e1888d0a1ea86$export$5b051e2383c8638d)();
    const [cards] = (0, $de6e1888d0a1ea86$export$5fe928848609fec7)();
    const [attendees] = (0, $de6e1888d0a1ea86$export$f755a54f5b6ffe30)();
    const [editPad, setEditPad] = (0, $8T3gX.useState)();
    const navigate = (0, $3T949.useNavigate)();
    if (!launch) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Launch"
    });
    const padGroups = pads ? Array.from(new Set(Object.values(pads).map((pad)=>pad.group ?? ""))).sort() : [];
    function launchInputProps(field) {
        return {
            className: "flex-grow-1",
            defaultValue: String(launch?.[field] ?? ""),
            onBlur (e) {
                if (!launch?.id) throw Error("Launch has no id");
                const target = e.target;
                let value = target.value;
                if (value == null || value === "") value = (0, $febfa929b76327ac$export$4bd2facc4a3e6aa1);
                if (value == launch?.[field]) return;
                (0, $febfa929b76327ac$export$78d8dceb730843fa)((0, $71b3f0397fe2ca79$export$90058626e653e0cd).with({
                    launchId: launch.id
                }), {
                    [field]: value
                });
            }
        };
    }
    async function deleteLaunch() {
        const nAttendees = attendees ? Object.keys(attendees).length : 0;
        const nCards = cards ? Object.keys(cards).length : 0;
        if (!launch) return;
        // Verify delete request
        const response = prompt((0, (/*@__PURE__*/$parcel$interopDefault($8b442f6bb87f057c$exports)))`This will permanently DELETE this launch and all activity associated with it, including ${nAttendees} attendee[|s] and ${nCards} flightcard[|s].\n\nYou will not be able to undo this!\n\nTo proceed type the name of the launch here ("${launch.name}") and click OK.`);
        if (response != launch.name) return;
        const rtFields = {
            launchId: launch.id
        };
        // TODO: This should really be done using rtTransaction, but it appears that
        // requires giving the current user write permissions at the very top level
        // of the RTDB, which we're not going to do.  So, instead, we delete the
        // collections individually and just pray they don't fail.
        // Delete launch first (required by RTDB rules before deleting other
        // collections)
        await (0, $febfa929b76327ac$export$3f3cbd6c9a0055d0)((0, $71b3f0397fe2ca79$export$90058626e653e0cd).with(rtFields));
        // Everything else can be removed in parallel
        await Promise.all([
            (0, $febfa929b76327ac$export$3f3cbd6c9a0055d0)((0, $71b3f0397fe2ca79$export$50e9aca848382ff9).with(rtFields)),
            (0, $febfa929b76327ac$export$3f3cbd6c9a0055d0)((0, $71b3f0397fe2ca79$export$d7220bf6225e19b7).with(rtFields)),
            (0, $febfa929b76327ac$export$3f3cbd6c9a0055d0)((0, $71b3f0397fe2ca79$export$83289c7452cd8ea9).with(rtFields)),
            (0, $febfa929b76327ac$export$3f3cbd6c9a0055d0)((0, $71b3f0397fe2ca79$export$ac9b3f0445b3a6da).with(rtFields))
        ]);
        (0, $3eda0b7570ee1d13$export$fff9462e59a6c087)("Launch deleted");
        navigate("/launches");
    }
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h1", {
                children: "Edit Launch"
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                className: "d-flex flex-wrap gap-3",
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $191c7221506aa247$export$2e2bcd8739ae039), {
                        ...launchInputProps("name"),
                        children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("label", {
                            children: "Name"
                        })
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $191c7221506aa247$export$2e2bcd8739ae039), {
                        ...launchInputProps("host"),
                        children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("label", {
                            children: "Host"
                        })
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $191c7221506aa247$export$2e2bcd8739ae039), {
                        ...launchInputProps("location"),
                        children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("label", {
                            children: "Location"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                className: "d-flex flex-wrap gap-3 mt-3",
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $191c7221506aa247$export$2e2bcd8739ae039), {
                        type: "date",
                        ...launchInputProps("startDate"),
                        children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("label", {
                            children: "Start Date"
                        })
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $191c7221506aa247$export$2e2bcd8739ae039), {
                        type: "date",
                        ...launchInputProps("endDate"),
                        children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("label", {
                            children: "End Date"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                className: "d-flex align-items-baseline mt-4 pt-2 border-top",
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h2", {
                        className: "flex-grow-1 m-0 p-0",
                        children: "Pads"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                        onClick: ()=>setEditPad({
                                id: undefined,
                                launchId: launch.id
                            }),
                        children: "New Pad..."
                    })
                ]
            }),
            padGroups.map((group)=>/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $4434787c63dd47a9$export$8d5bd6735343c6be), {
                            launchId: launch.id,
                            padGroup: group
                        }),
                        /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                            className: "d-flex flex-wrap gap-3 mb-4",
                            children: pads ? (0, $2914d071bbef92ec$export$7a7adbcc2fafd347)(Object.values(pads).filter((pad)=>(pad.group ?? "") === group), "name").map((pad)=>/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                                    variant: "outline-primary",
                                    style: {
                                        minWidth: "5em",
                                        maxWidth: "max-content"
                                    },
                                    onClick: ()=>setEditPad(pad),
                                    children: pad.name ?? "(unnamed pad)"
                                }, pad.id)) : null
                        })
                    ]
                }, group)),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                className: "d-flex justify-content-between mt-5 gap-3",
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                        variant: "danger",
                        onClick: deleteLaunch,
                        tabIndex: -1,
                        children: "Delete This Launch"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $98f5e3369323c0ef$export$c5c6c16075fd4665), {
                        variant: "secondary",
                        to: -1,
                        children: "Close"
                    })
                ]
            }),
            editPad ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $5a76555e9297a1c3$export$b8be822412cfb328), {
                onHide: ()=>setEditPad(undefined),
                pad: editPad,
                groups: padGroups
            }) : null
        ]
    });
}



parcelRequire("8T3gX");



var $8T3gX = parcelRequire("8T3gX");


class $4428d58364bc1631$export$7dd9847450395928 extends Error {
    constructor(message, response){
        super();
        this.message = message;
        this.response = response;
    }
}
function $4428d58364bc1631$export$f0f97065c7f07b72(url, { setData: setData , setError: setError , setLoading: setLoading , ...options }) {
    const controller = new AbortController();
    setLoading?.(url ? true : false);
    setError?.(undefined);
    if (url) fetch(url, {
        ...options,
        signal: controller.signal
    }).then((res)=>{
        if (!res.ok) throw new $4428d58364bc1631$export$7dd9847450395928(res.statusText, res);
        return res.json();
    }).then((json)=>setData?.(json)).catch((err)=>{
        setError?.(err);
    }).finally(()=>setLoading?.(false));
    return ()=>{
        controller.abort();
        setLoading?.(false);
        setError?.(undefined);
    };
}







var $8T3gX = parcelRequire("8T3gX");
function $b95cacaa717a8338$export$2e2bcd8739ae039(value, delay) {
    const [debouncedValue, setDebouncedValue] = (0, $8T3gX.useState)(value);
    const [isDebouncing, setIsDebouncing] = (0, $8T3gX.useState)(false);
    (0, $8T3gX.useEffect)(()=>{
        setIsDebouncing(true);
        const handler = setTimeout(()=>{
            setDebouncedValue(value);
            setIsDebouncing(false);
        }, delay);
        return ()=>{
            clearTimeout(handler);
            setIsDebouncing(false);
        };
    }, [
        value,
        delay
    ]);
    return [
        debouncedValue,
        isDebouncing
    ];
}


function $79008fc09d81c898$var$Emoji({ code: code , ...props }) {
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("span", {
        ...props,
        style: {
            fontSize: "2em",
            top: ".1em",
            left: ".1em",
            width: 0,
            display: "inline-block",
            position: "relative",
            lineHeight: "0em"
        },
        children: String.fromCodePoint(code)
    });
}
const $79008fc09d81c898$var$MEMBER_API_ENDPOINT = "https://club-members.robert4852.workers.dev";
function $79008fc09d81c898$export$2e2bcd8739ae039({ attendeeFields: attendeeFields , org: org , className: className , ...props }) {
    const rtPath = org === (0, $aaa72a458935fe7a$export$67788f4001cebb21).TRA ? (0, $71b3f0397fe2ca79$export$fcb89df7dbf28b19).with(attendeeFields) : (0, $71b3f0397fe2ca79$export$7bb590570d143469).with(attendeeFields);
    const [isChanged, setIsChanged] = (0, $8T3gX.useState)(false);
    const [memberId, setMemberId] = (0, $8T3gX.useState)("");
    const [dbCert, dbCertLoading] = (0, $febfa929b76327ac$export$fe4c1a3a7af84c36)(rtPath, (0, $8T3gX.useCallback)((cert)=>{
        // Set member id field if it hasn't been changed yet
        if (!isChanged) setMemberId(String(cert?.memberId));
    }, [
        isChanged
    ]));
    const [fetchLoading, setFetchLoading] = (0, $8T3gX.useState)(false);
    const [fetchError, setFetchError] = (0, $8T3gX.useState)();
    const [debouncedMemberId, isDebouncing] = (0, $b95cacaa717a8338$export$2e2bcd8739ae039)(memberId, 500);
    const memberNum = parseInt(debouncedMemberId ?? "");
    const memberInfoUrl = isChanged && !isDebouncing && !isNaN(memberNum) ? `${$79008fc09d81c898$var$MEMBER_API_ENDPOINT}?org=${org}&id=${memberNum}` : undefined;
    function handleMemberIdChange(e) {
        setMemberId(e.target.value);
        setIsChanged(true);
        setFetchError(undefined);
    }
    // Effect to clear loading/error state when user is typing
    (0, $8T3gX.useEffect)(()=>{
        if (!isDebouncing) return;
        setFetchLoading(false);
        setFetchError(undefined);
    }, [
        isDebouncing
    ]);
    // Effect to fetch member info once user has stopped typing
    (0, $8T3gX.useEffect)(()=>{
        if (!memberInfoUrl) return;
        const fetchAbort = (0, $4428d58364bc1631$export$f0f97065c7f07b72)(memberInfoUrl, {
            setData (cert) {
                (0, $4ac80628868fb8a2$export$3efb1a4ef0888a13)((0, $febfa929b76327ac$export$2ef6846d36515d5)(rtPath, cert ?? (0, $febfa929b76327ac$export$4bd2facc4a3e6aa1)));
            },
            setLoading: setFetchLoading,
            setError (err) {
                setFetchError(err);
                if (err) (0, $4ac80628868fb8a2$export$3efb1a4ef0888a13)((0, $febfa929b76327ac$export$2ef6846d36515d5)(rtPath, (0, $febfa929b76327ac$export$4bd2facc4a3e6aa1)));
            }
        });
        return fetchAbort;
    }, [
        memberInfoUrl,
        rtPath
    ]);
    if (dbCertLoading) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "certification"
    });
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
        className: (0, $a147a5343133f2a5$export$1343a74baacb0543)(className, `d-flex flex-column flex-sm-row`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $be4ca9442e43e12e$export$2e2bcd8739ae039), {
                label: `${org == (0, $aaa72a458935fe7a$export$67788f4001cebb21).TRA ? "Tripoli" : "NAR"} member #`,
                className: "flex-shrink-0 me-2 mb-2",
                children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $82743675752b4983$export$2e2bcd8739ae039).Control, {
                    className: (0, $a147a5343133f2a5$export$1343a74baacb0543)({
                        busy: fetchLoading
                    }),
                    type: "number",
                    placeholder: "e.g. 12345",
                    value: memberId,
                    onChange: handleMemberIdChange
                })
            }),
            org === (0, $aaa72a458935fe7a$export$67788f4001cebb21).NAR && fetchLoading ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                className: "text-tip",
                children: [
                    "One moment, please. NAR's site usually takes 10-20 seconds to respond.",
                    " ",
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)($79008fc09d81c898$var$Emoji, {
                        code: 0x1f914
                    })
                ]
            }) : null,
            fetchError && !isDebouncing ? fetchError.response?.status === 408 ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $1d0a237fe4c0025c$export$2e2bcd8739ae039), {
                variant: "warning",
                children: [
                    org,
                    "'s site is not responding. Try again later, perhaps?",
                    " ",
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)($79008fc09d81c898$var$Emoji, {
                        code: 0x1f9a5
                    })
                ]
            }) : /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $1d0a237fe4c0025c$export$2e2bcd8739ae039), {
                variant: "warning",
                children: [
                    "Couldn't find certification info for member #",
                    memberId,
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("p", {
                        className: "text-tip",
                        children: "Make sure your membership is current."
                    })
                ]
            }) : null,
            dbCert && !dbCertLoading && !fetchLoading ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                className: "flex-grow-1 ms-3",
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("strong", {
                        children: [
                            dbCert.firstName,
                            " ",
                            dbCert.lastName
                        ]
                    }),
                    " ",
                    "is",
                    " ",
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("strong", {
                        children: [
                            org,
                            " L-",
                            dbCert.level
                        ]
                    }),
                    " ",
                    "certified thru ",
                    new Date(dbCert.expires ?? 0).toLocaleDateString(),
                    dbCert?.verifiedTime ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("p", {
                        className: "text-tip text-success",
                        children: "Nice, you've been verified! (Don't change this, otherwise you'll have to reverify!)"
                    }) : /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("p", {
                        className: "text-tip text-warning",
                        children: "Please see one of the club officers so they can verify this information."
                    })
                ]
            }) : null
        ]
    });
}



parcelRequire("8T3gX");


function $93bb41ab6836e9eb$export$2e2bcd8739ae039({ attendeeFields: attendeeFields , ...props }) {
    const rtui = (0, $1323e57a6b627168$export$fd869eba2656ca90)((0, $71b3f0397fe2ca79$export$9b60127abde046a1).with(attendeeFields));
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h2", {
                children: "Name"
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(rtui.StringInput, {
                label: "Name",
                field: "name",
                ...props
            })
        ]
    });
}






function $d090a7b2f8ec46c6$export$2e2bcd8739ae039() {
    const [launch] = (0, $de6e1888d0a1ea86$export$75eeb04b2db35f42)();
    const [attendee] = (0, $de6e1888d0a1ea86$export$67c1131f3997904d)();
    if (!attendee) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Attendee"
    });
    if (!launch) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Launch"
    });
    const isVerified = (0, $d5b1995fb206c61d$export$f9610ead7d6f0608)(attendee);
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("h1", {
                children: [
                    "Settings for ",
                    attendee?.name ?? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("i", {
                        children: "(unnamed user)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $93bb41ab6836e9eb$export$2e2bcd8739ae039), {
                style: {
                    width: "15em"
                },
                attendeeFields: {
                    launchId: launch.id,
                    userId: attendee.id
                }
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h2", {
                children: "Certifications"
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $79008fc09d81c898$export$2e2bcd8739ae039), {
                attendeeFields: {
                    launchId: launch.id,
                    userId: attendee.id
                },
                org: (0, $aaa72a458935fe7a$export$67788f4001cebb21).TRA,
                className: "mt-2"
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $79008fc09d81c898$export$2e2bcd8739ae039), {
                attendeeFields: {
                    launchId: launch.id,
                    userId: attendee.id
                },
                org: (0, $aaa72a458935fe7a$export$67788f4001cebb21).NAR,
                className: "mt-2"
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h2", {
                children: "Units of Measure"
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $2b27acfe5408b34d$export$2e2bcd8739ae039), {
                authId: attendee.id
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h2", {
                children: "Actions"
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                className: "d-flex flex-wrap gap-3 mb-3",
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$29d11c0fe2fc51d8), {
                        to: "/launches",
                        children: "Other Launches…"
                    }),
                    attendee?.id == "ToMOmSnv7XVtygKOF9jjtwz0Kzs2" ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$29d11c0fe2fc51d8), {
                        to: "/admin",
                        children: "Admin"
                    }) : null,
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                        className: "flex-grow-1"
                    })
                ]
            })
        ]
    });
}



parcelRequire("8T3gX");



parcelRequire("8T3gX");


var $8T3gX = parcelRequire("8T3gX");





var $8T3gX = parcelRequire("8T3gX");


const $a48df2b6f0117ca3$var$CardImg = /*#__PURE__*/ $8T3gX.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix , className: className , variant: variant , as: Component = "img" , ...props }, ref)=>{
    const prefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, "card-img");
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(variant ? `${prefix}-${variant}` : prefix, className),
        ...props
    });
});
$a48df2b6f0117ca3$var$CardImg.displayName = "CardImg";
var $a48df2b6f0117ca3$export$2e2bcd8739ae039 = $a48df2b6f0117ca3$var$CardImg;




var $8T3gX = parcelRequire("8T3gX");


var $8T3gX = parcelRequire("8T3gX");
const $d603951200a4e5d9$var$context = /*#__PURE__*/ $8T3gX.createContext(null);
$d603951200a4e5d9$var$context.displayName = "CardHeaderContext";
var $d603951200a4e5d9$export$2e2bcd8739ae039 = $d603951200a4e5d9$var$context;



const $e0d626f9da1e56be$var$CardHeader = /*#__PURE__*/ $8T3gX.forwardRef(({ bsPrefix: bsPrefix , className: className , // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div" , ...props }, ref)=>{
    const prefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, "card-header");
    const contextValue = (0, $8T3gX.useMemo)(()=>({
            cardHeaderBsPrefix: prefix
        }), [
        prefix
    ]);
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $d603951200a4e5d9$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, prefix)
        })
    });
});
$e0d626f9da1e56be$var$CardHeader.displayName = "CardHeader";
var $e0d626f9da1e56be$export$2e2bcd8739ae039 = $e0d626f9da1e56be$var$CardHeader;



const $641d70d805eb1289$var$DivStyledAsH5 = (0, $87aacb5e98a57b39$export$2e2bcd8739ae039)("h5");
const $641d70d805eb1289$var$DivStyledAsH6 = (0, $87aacb5e98a57b39$export$2e2bcd8739ae039)("h6");
const $641d70d805eb1289$var$CardBody = (0, $94fe4a2899ec2691$export$2e2bcd8739ae039)("card-body");
const $641d70d805eb1289$var$CardTitle = (0, $94fe4a2899ec2691$export$2e2bcd8739ae039)("card-title", {
    Component: $641d70d805eb1289$var$DivStyledAsH5
});
const $641d70d805eb1289$var$CardSubtitle = (0, $94fe4a2899ec2691$export$2e2bcd8739ae039)("card-subtitle", {
    Component: $641d70d805eb1289$var$DivStyledAsH6
});
const $641d70d805eb1289$var$CardLink = (0, $94fe4a2899ec2691$export$2e2bcd8739ae039)("card-link", {
    Component: "a"
});
const $641d70d805eb1289$var$CardText = (0, $94fe4a2899ec2691$export$2e2bcd8739ae039)("card-text", {
    Component: "p"
});
const $641d70d805eb1289$var$CardFooter = (0, $94fe4a2899ec2691$export$2e2bcd8739ae039)("card-footer");
const $641d70d805eb1289$var$CardImgOverlay = (0, $94fe4a2899ec2691$export$2e2bcd8739ae039)("card-img-overlay");
const $641d70d805eb1289$var$Card = /*#__PURE__*/ $8T3gX.forwardRef(({ bsPrefix: bsPrefix , className: className , bg: bg , text: text , border: border , body: body = false , children: children , // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div" , ...props }, ref)=>{
    const prefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, "card");
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
        children: body ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)($641d70d805eb1289$var$CardBody, {
            children: children
        }) : children
    });
});
$641d70d805eb1289$var$Card.displayName = "Card";
var $641d70d805eb1289$export$2e2bcd8739ae039 = Object.assign($641d70d805eb1289$var$Card, {
    Img: (0, $a48df2b6f0117ca3$export$2e2bcd8739ae039),
    Title: $641d70d805eb1289$var$CardTitle,
    Subtitle: $641d70d805eb1289$var$CardSubtitle,
    Body: $641d70d805eb1289$var$CardBody,
    Link: $641d70d805eb1289$var$CardLink,
    Text: $641d70d805eb1289$var$CardText,
    Header: (0, $e0d626f9da1e56be$export$2e2bcd8739ae039),
    Footer: $641d70d805eb1289$var$CardFooter,
    ImgOverlay: $641d70d805eb1289$var$CardImgOverlay
});


var $1ee3d57e58d770bc$exports = {};
var $86f21484742bec95$exports = {};
var $5cd807a6ad780171$exports = {};
var $38fd38fdd95df333$exports = {};
var $7899283e38926019$exports = {};
var $073976792844c8a5$exports = {};
var $cd41833a2a331f63$exports = {};
var $4003a8f3ae86bec1$exports = {};
var $29a029238437d6de$exports = {};

var $yRFSk = parcelRequire("yRFSk");
/** Built-in value references. */ var $29a029238437d6de$var$Symbol = $yRFSk.Symbol;
$29a029238437d6de$exports = $29a029238437d6de$var$Symbol;


var $00046f8171ed0f0c$exports = {};

/** Used for built-in method references. */ var $00046f8171ed0f0c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $00046f8171ed0f0c$var$hasOwnProperty = $00046f8171ed0f0c$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $00046f8171ed0f0c$var$nativeObjectToString = $00046f8171ed0f0c$var$objectProto.toString;
/** Built-in value references. */ var $00046f8171ed0f0c$var$symToStringTag = $29a029238437d6de$exports ? $29a029238437d6de$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $00046f8171ed0f0c$var$getRawTag(value) {
    var isOwn = $00046f8171ed0f0c$var$hasOwnProperty.call(value, $00046f8171ed0f0c$var$symToStringTag), tag = value[$00046f8171ed0f0c$var$symToStringTag];
    try {
        value[$00046f8171ed0f0c$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $00046f8171ed0f0c$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$00046f8171ed0f0c$var$symToStringTag] = tag;
        else delete value[$00046f8171ed0f0c$var$symToStringTag];
    }
    return result;
}
$00046f8171ed0f0c$exports = $00046f8171ed0f0c$var$getRawTag;


var $0928a1a9fd840c4c$exports = {};
/** Used for built-in method references. */ var $0928a1a9fd840c4c$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $0928a1a9fd840c4c$var$nativeObjectToString = $0928a1a9fd840c4c$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $0928a1a9fd840c4c$var$objectToString(value) {
    return $0928a1a9fd840c4c$var$nativeObjectToString.call(value);
}
$0928a1a9fd840c4c$exports = $0928a1a9fd840c4c$var$objectToString;


/** `Object#toString` result references. */ var $4003a8f3ae86bec1$var$nullTag = "[object Null]", $4003a8f3ae86bec1$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $4003a8f3ae86bec1$var$symToStringTag = $29a029238437d6de$exports ? $29a029238437d6de$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $4003a8f3ae86bec1$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $4003a8f3ae86bec1$var$undefinedTag : $4003a8f3ae86bec1$var$nullTag;
    return $4003a8f3ae86bec1$var$symToStringTag && $4003a8f3ae86bec1$var$symToStringTag in Object(value) ? $00046f8171ed0f0c$exports(value) : $0928a1a9fd840c4c$exports(value);
}
$4003a8f3ae86bec1$exports = $4003a8f3ae86bec1$var$baseGetTag;


var $cd2b0b1294af0960$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $cd2b0b1294af0960$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$cd2b0b1294af0960$exports = $cd2b0b1294af0960$var$isObject;


/** `Object#toString` result references. */ var $cd41833a2a331f63$var$asyncTag = "[object AsyncFunction]", $cd41833a2a331f63$var$funcTag = "[object Function]", $cd41833a2a331f63$var$genTag = "[object GeneratorFunction]", $cd41833a2a331f63$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $cd41833a2a331f63$var$isFunction(value) {
    if (!$cd2b0b1294af0960$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $4003a8f3ae86bec1$exports(value);
    return tag == $cd41833a2a331f63$var$funcTag || tag == $cd41833a2a331f63$var$genTag || tag == $cd41833a2a331f63$var$asyncTag || tag == $cd41833a2a331f63$var$proxyTag;
}
$cd41833a2a331f63$exports = $cd41833a2a331f63$var$isFunction;


var $13ca6f8ce4d26492$exports = {};
var $602aa9999b550509$exports = {};

var $yRFSk = parcelRequire("yRFSk");
/** Used to detect overreaching core-js shims. */ var $602aa9999b550509$var$coreJsData = $yRFSk["__core-js_shared__"];
$602aa9999b550509$exports = $602aa9999b550509$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $13ca6f8ce4d26492$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($602aa9999b550509$exports && $602aa9999b550509$exports.keys && $602aa9999b550509$exports.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $13ca6f8ce4d26492$var$isMasked(func) {
    return !!$13ca6f8ce4d26492$var$maskSrcKey && $13ca6f8ce4d26492$var$maskSrcKey in func;
}
$13ca6f8ce4d26492$exports = $13ca6f8ce4d26492$var$isMasked;



var $b15df2ee81e34172$exports = {};
/** Used for built-in method references. */ var $b15df2ee81e34172$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $b15df2ee81e34172$var$funcToString = $b15df2ee81e34172$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $b15df2ee81e34172$var$toSource(func) {
    if (func != null) {
        try {
            return $b15df2ee81e34172$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
$b15df2ee81e34172$exports = $b15df2ee81e34172$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $073976792844c8a5$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $073976792844c8a5$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $073976792844c8a5$var$funcProto = Function.prototype, $073976792844c8a5$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $073976792844c8a5$var$funcToString = $073976792844c8a5$var$funcProto.toString;
/** Used to check objects for own properties. */ var $073976792844c8a5$var$hasOwnProperty = $073976792844c8a5$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $073976792844c8a5$var$reIsNative = RegExp("^" + $073976792844c8a5$var$funcToString.call($073976792844c8a5$var$hasOwnProperty).replace($073976792844c8a5$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $073976792844c8a5$var$baseIsNative(value) {
    if (!$cd2b0b1294af0960$exports(value) || $13ca6f8ce4d26492$exports(value)) return false;
    var pattern = $cd41833a2a331f63$exports(value) ? $073976792844c8a5$var$reIsNative : $073976792844c8a5$var$reIsHostCtor;
    return pattern.test($b15df2ee81e34172$exports(value));
}
$073976792844c8a5$exports = $073976792844c8a5$var$baseIsNative;


var $a7e0be82f624d54f$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $a7e0be82f624d54f$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$a7e0be82f624d54f$exports = $a7e0be82f624d54f$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $7899283e38926019$var$getNative(object, key) {
    var value = $a7e0be82f624d54f$exports(object, key);
    return $073976792844c8a5$exports(value) ? value : undefined;
}
$7899283e38926019$exports = $7899283e38926019$var$getNative;


var $38fd38fdd95df333$var$defineProperty = function() {
    try {
        var func = $7899283e38926019$exports(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
$38fd38fdd95df333$exports = $38fd38fdd95df333$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $5cd807a6ad780171$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $38fd38fdd95df333$exports) $38fd38fdd95df333$exports(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
$5cd807a6ad780171$exports = $5cd807a6ad780171$var$baseAssignValue;


var $ba1c04d40f072e77$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $ba1c04d40f072e77$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$ba1c04d40f072e77$exports = $ba1c04d40f072e77$var$eq;


/** Used for built-in method references. */ var $86f21484742bec95$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $86f21484742bec95$var$hasOwnProperty = $86f21484742bec95$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $86f21484742bec95$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($86f21484742bec95$var$hasOwnProperty.call(object, key) && $ba1c04d40f072e77$exports(objValue, value)) || value === undefined && !(key in object)) $5cd807a6ad780171$exports(object, key, value);
}
$86f21484742bec95$exports = $86f21484742bec95$var$assignValue;


var $9fe2a59e0a9c0b6a$exports = {};


/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $9fe2a59e0a9c0b6a$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $5cd807a6ad780171$exports(object, key, newValue);
        else $86f21484742bec95$exports(object, key, newValue);
    }
    return object;
}
$9fe2a59e0a9c0b6a$exports = $9fe2a59e0a9c0b6a$var$copyObject;


var $01ffaae1b33bf27d$exports = {};
var $3432652d35d8dc24$exports = {};
var $30121ce9c4b4eb3d$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $30121ce9c4b4eb3d$var$identity(value) {
    return value;
}
$30121ce9c4b4eb3d$exports = $30121ce9c4b4eb3d$var$identity;


var $8f23d6c287483fb1$exports = {};
var $255ecd28778da441$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $255ecd28778da441$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$255ecd28778da441$exports = $255ecd28778da441$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $8f23d6c287483fb1$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $8f23d6c287483fb1$var$overRest(func, start, transform) {
    start = $8f23d6c287483fb1$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $8f23d6c287483fb1$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $255ecd28778da441$exports(func, this, otherArgs);
    };
}
$8f23d6c287483fb1$exports = $8f23d6c287483fb1$var$overRest;


var $734501f4df78661a$exports = {};
var $4a28569ea83baadb$exports = {};
var $8c05603d1b1154c7$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $8c05603d1b1154c7$var$constant(value) {
    return function() {
        return value;
    };
}
$8c05603d1b1154c7$exports = $8c05603d1b1154c7$var$constant;




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $4a28569ea83baadb$var$baseSetToString = !$38fd38fdd95df333$exports ? $30121ce9c4b4eb3d$exports : function(func, string) {
    return $38fd38fdd95df333$exports(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $8c05603d1b1154c7$exports(string),
        "writable": true
    });
};
$4a28569ea83baadb$exports = $4a28569ea83baadb$var$baseSetToString;


var $48dec04e06444fc8$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $48dec04e06444fc8$var$HOT_COUNT = 800, $48dec04e06444fc8$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $48dec04e06444fc8$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $48dec04e06444fc8$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $48dec04e06444fc8$var$nativeNow(), remaining = $48dec04e06444fc8$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $48dec04e06444fc8$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$48dec04e06444fc8$exports = $48dec04e06444fc8$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $734501f4df78661a$var$setToString = $48dec04e06444fc8$exports($4a28569ea83baadb$exports);
$734501f4df78661a$exports = $734501f4df78661a$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $3432652d35d8dc24$var$baseRest(func, start) {
    return $734501f4df78661a$exports($8f23d6c287483fb1$exports(func, start, $30121ce9c4b4eb3d$exports), func + "");
}
$3432652d35d8dc24$exports = $3432652d35d8dc24$var$baseRest;


var $f5d86346a533d383$exports = {};

var $edace719698f1e70$exports = {};

var $27f0a97b97c49daa$exports = {};
/** Used as references for various `Number` constants. */ var $27f0a97b97c49daa$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $27f0a97b97c49daa$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $27f0a97b97c49daa$var$MAX_SAFE_INTEGER;
}
$27f0a97b97c49daa$exports = $27f0a97b97c49daa$var$isLength;


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $edace719698f1e70$var$isArrayLike(value) {
    return value != null && $27f0a97b97c49daa$exports(value.length) && !$cd41833a2a331f63$exports(value);
}
$edace719698f1e70$exports = $edace719698f1e70$var$isArrayLike;


var $c60ce55ccfd38e2a$exports = {};
/** Used as references for various `Number` constants. */ var $c60ce55ccfd38e2a$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $c60ce55ccfd38e2a$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $c60ce55ccfd38e2a$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $c60ce55ccfd38e2a$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $c60ce55ccfd38e2a$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$c60ce55ccfd38e2a$exports = $c60ce55ccfd38e2a$var$isIndex;



/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $f5d86346a533d383$var$isIterateeCall(value, index, object) {
    if (!$cd2b0b1294af0960$exports(object)) return false;
    var type = typeof index;
    if (type == "number" ? $edace719698f1e70$exports(object) && $c60ce55ccfd38e2a$exports(index, object.length) : type == "string" && index in object) return $ba1c04d40f072e77$exports(object[index], value);
    return false;
}
$f5d86346a533d383$exports = $f5d86346a533d383$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $01ffaae1b33bf27d$var$createAssigner(assigner) {
    return $3432652d35d8dc24$exports(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && $f5d86346a533d383$exports(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
$01ffaae1b33bf27d$exports = $01ffaae1b33bf27d$var$createAssigner;



var $0d327a1cf9457c9f$exports = {};
/** Used for built-in method references. */ var $0d327a1cf9457c9f$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $0d327a1cf9457c9f$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $0d327a1cf9457c9f$var$objectProto;
    return value === proto;
}
$0d327a1cf9457c9f$exports = $0d327a1cf9457c9f$var$isPrototype;


var $9c7d1fa85e24a67e$exports = {};
var $c8166565a24fe234$exports = {};
var $e2c9b661c7956192$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $e2c9b661c7956192$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$e2c9b661c7956192$exports = $e2c9b661c7956192$var$baseTimes;


var $343d561a7d6a3b42$exports = {};
var $3b156beb9c94911a$exports = {};

var $65ef2014975340ff$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $65ef2014975340ff$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$65ef2014975340ff$exports = $65ef2014975340ff$var$isObjectLike;


/** `Object#toString` result references. */ var $3b156beb9c94911a$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $3b156beb9c94911a$var$baseIsArguments(value) {
    return $65ef2014975340ff$exports(value) && $4003a8f3ae86bec1$exports(value) == $3b156beb9c94911a$var$argsTag;
}
$3b156beb9c94911a$exports = $3b156beb9c94911a$var$baseIsArguments;



/** Used for built-in method references. */ var $343d561a7d6a3b42$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $343d561a7d6a3b42$var$hasOwnProperty = $343d561a7d6a3b42$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $343d561a7d6a3b42$var$propertyIsEnumerable = $343d561a7d6a3b42$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $343d561a7d6a3b42$var$isArguments = $3b156beb9c94911a$exports(function() {
    return arguments;
}()) ? $3b156beb9c94911a$exports : function(value) {
    return $65ef2014975340ff$exports(value) && $343d561a7d6a3b42$var$hasOwnProperty.call(value, "callee") && !$343d561a7d6a3b42$var$propertyIsEnumerable.call(value, "callee");
};
$343d561a7d6a3b42$exports = $343d561a7d6a3b42$var$isArguments;


var $b47d971f66a6f054$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $b47d971f66a6f054$var$isArray = Array.isArray;
$b47d971f66a6f054$exports = $b47d971f66a6f054$var$isArray;



var $hAe8M = parcelRequire("hAe8M");

var $f88c9406e419272a$exports = {};
var $3d06ad770a2684eb$exports = {};



/** `Object#toString` result references. */ var $3d06ad770a2684eb$var$argsTag = "[object Arguments]", $3d06ad770a2684eb$var$arrayTag = "[object Array]", $3d06ad770a2684eb$var$boolTag = "[object Boolean]", $3d06ad770a2684eb$var$dateTag = "[object Date]", $3d06ad770a2684eb$var$errorTag = "[object Error]", $3d06ad770a2684eb$var$funcTag = "[object Function]", $3d06ad770a2684eb$var$mapTag = "[object Map]", $3d06ad770a2684eb$var$numberTag = "[object Number]", $3d06ad770a2684eb$var$objectTag = "[object Object]", $3d06ad770a2684eb$var$regexpTag = "[object RegExp]", $3d06ad770a2684eb$var$setTag = "[object Set]", $3d06ad770a2684eb$var$stringTag = "[object String]", $3d06ad770a2684eb$var$weakMapTag = "[object WeakMap]";
var $3d06ad770a2684eb$var$arrayBufferTag = "[object ArrayBuffer]", $3d06ad770a2684eb$var$dataViewTag = "[object DataView]", $3d06ad770a2684eb$var$float32Tag = "[object Float32Array]", $3d06ad770a2684eb$var$float64Tag = "[object Float64Array]", $3d06ad770a2684eb$var$int8Tag = "[object Int8Array]", $3d06ad770a2684eb$var$int16Tag = "[object Int16Array]", $3d06ad770a2684eb$var$int32Tag = "[object Int32Array]", $3d06ad770a2684eb$var$uint8Tag = "[object Uint8Array]", $3d06ad770a2684eb$var$uint8ClampedTag = "[object Uint8ClampedArray]", $3d06ad770a2684eb$var$uint16Tag = "[object Uint16Array]", $3d06ad770a2684eb$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $3d06ad770a2684eb$var$typedArrayTags = {};
$3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$float32Tag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$float64Tag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$int8Tag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$int16Tag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$int32Tag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$uint8Tag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$uint8ClampedTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$uint16Tag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$uint32Tag] = true;
$3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$argsTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$arrayTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$arrayBufferTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$boolTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$dataViewTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$dateTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$errorTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$funcTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$mapTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$numberTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$objectTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$regexpTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$setTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$stringTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $3d06ad770a2684eb$var$baseIsTypedArray(value) {
    return $65ef2014975340ff$exports(value) && $27f0a97b97c49daa$exports(value.length) && !!$3d06ad770a2684eb$var$typedArrayTags[$4003a8f3ae86bec1$exports(value)];
}
$3d06ad770a2684eb$exports = $3d06ad770a2684eb$var$baseIsTypedArray;


var $259a13e6311f4b7a$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $259a13e6311f4b7a$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$259a13e6311f4b7a$exports = $259a13e6311f4b7a$var$baseUnary;



var $3TIQ3 = parcelRequire("3TIQ3");
/* Node.js helper references. */ var $f88c9406e419272a$var$nodeIsTypedArray = $3TIQ3 && $3TIQ3.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $f88c9406e419272a$var$isTypedArray = $f88c9406e419272a$var$nodeIsTypedArray ? $259a13e6311f4b7a$exports($f88c9406e419272a$var$nodeIsTypedArray) : $3d06ad770a2684eb$exports;
$f88c9406e419272a$exports = $f88c9406e419272a$var$isTypedArray;


/** Used for built-in method references. */ var $c8166565a24fe234$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c8166565a24fe234$var$hasOwnProperty = $c8166565a24fe234$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $c8166565a24fe234$var$arrayLikeKeys(value, inherited) {
    var isArr = $b47d971f66a6f054$exports(value), isArg = !isArr && $343d561a7d6a3b42$exports(value), isBuff = !isArr && !isArg && $hAe8M(value), isType = !isArr && !isArg && !isBuff && $f88c9406e419272a$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $e2c9b661c7956192$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $c8166565a24fe234$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $c60ce55ccfd38e2a$exports(key, length)))) result.push(key);
    return result;
}
$c8166565a24fe234$exports = $c8166565a24fe234$var$arrayLikeKeys;


var $32f67937b014759c$exports = {};

var $8c0152eef7f984bf$exports = {};
var $ea458d5b09fec244$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ea458d5b09fec244$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$ea458d5b09fec244$exports = $ea458d5b09fec244$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $8c0152eef7f984bf$var$nativeKeys = $ea458d5b09fec244$exports(Object.keys, Object);
$8c0152eef7f984bf$exports = $8c0152eef7f984bf$var$nativeKeys;


/** Used for built-in method references. */ var $32f67937b014759c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $32f67937b014759c$var$hasOwnProperty = $32f67937b014759c$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $32f67937b014759c$var$baseKeys(object) {
    if (!$0d327a1cf9457c9f$exports(object)) return $8c0152eef7f984bf$exports(object);
    var result = [];
    for(var key in Object(object))if ($32f67937b014759c$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
$32f67937b014759c$exports = $32f67937b014759c$var$baseKeys;



/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $9c7d1fa85e24a67e$var$keys(object) {
    return $edace719698f1e70$exports(object) ? $c8166565a24fe234$exports(object) : $32f67937b014759c$exports(object);
}
$9c7d1fa85e24a67e$exports = $9c7d1fa85e24a67e$var$keys;


/** Used for built-in method references. */ var $1ee3d57e58d770bc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1ee3d57e58d770bc$var$hasOwnProperty = $1ee3d57e58d770bc$var$objectProto.hasOwnProperty;
/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */ var $1ee3d57e58d770bc$var$assign = $01ffaae1b33bf27d$exports(function(object, source) {
    if ($0d327a1cf9457c9f$exports(source) || $edace719698f1e70$exports(source)) {
        $9fe2a59e0a9c0b6a$exports(source, $9c7d1fa85e24a67e$exports(source), object);
        return;
    }
    for(var key in source)if ($1ee3d57e58d770bc$var$hasOwnProperty.call(source, key)) $86f21484742bec95$exports(object, key, source[key]);
});
$1ee3d57e58d770bc$exports = $1ee3d57e58d770bc$var$assign;



var $fdGrT = parcelRequire("fdGrT");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");
var $9dba2b2bbfc485d5$exports = {};

$parcel$export($9dba2b2bbfc485d5$exports, "deprecated", () => $9dba2b2bbfc485d5$export$cdd73fc4100a6ef4);
$parcel$export($9dba2b2bbfc485d5$exports, "allOfType", () => $9dba2b2bbfc485d5$export$ba7c675f29992b42);
$parcel$export($9dba2b2bbfc485d5$exports, "nonNegative", () => $9dba2b2bbfc485d5$export$1832c645056d4ce2);
$parcel$export($9dba2b2bbfc485d5$exports, "integer", () => $9dba2b2bbfc485d5$export$32744b5b3bba4764);
$parcel$export($9dba2b2bbfc485d5$exports, "greaterThanZero", () => $9dba2b2bbfc485d5$export$e83db190a13b5ae1);
$parcel$export($9dba2b2bbfc485d5$exports, "domain", () => $9dba2b2bbfc485d5$export$21779e503be4cd98);
$parcel$export($9dba2b2bbfc485d5$exports, "scale", () => $9dba2b2bbfc485d5$export$dcdf75081b88279d);
$parcel$export($9dba2b2bbfc485d5$exports, "homogeneousArray", () => $9dba2b2bbfc485d5$export$bf99cf46c730dbb3);
$parcel$export($9dba2b2bbfc485d5$exports, "matchDataLength", () => $9dba2b2bbfc485d5$export$d53326403afe7b9c);
$parcel$export($9dba2b2bbfc485d5$exports, "regExp", () => $9dba2b2bbfc485d5$export$8f50e1bab370eb17);
var $d5024b7f03082f06$exports = {};
var $0021415eeed2c6c8$exports = {};


/** `Object#toString` result references. */ var $0021415eeed2c6c8$var$regexpTag = "[object RegExp]";
/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */ function $0021415eeed2c6c8$var$baseIsRegExp(value) {
    return $65ef2014975340ff$exports(value) && $4003a8f3ae86bec1$exports(value) == $0021415eeed2c6c8$var$regexpTag;
}
$0021415eeed2c6c8$exports = $0021415eeed2c6c8$var$baseIsRegExp;




var $3TIQ3 = parcelRequire("3TIQ3");
/* Node.js helper references. */ var $d5024b7f03082f06$var$nodeIsRegExp = $3TIQ3 && $3TIQ3.isRegExp;
/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */ var $d5024b7f03082f06$var$isRegExp = $d5024b7f03082f06$var$nodeIsRegExp ? $259a13e6311f4b7a$exports($d5024b7f03082f06$var$nodeIsRegExp) : $0021415eeed2c6c8$exports;
$d5024b7f03082f06$exports = $d5024b7f03082f06$var$isRegExp;


var $9f60e838fdb2edf2$exports = {};
var $01f07113cfe93416$exports = {};
var $9dd1d38dfe69ddcf$exports = {};
var $5d8d0bf2708d1398$exports = {};
var $2d9d6e3f255e1c55$exports = {};
var $861d1b63d8478a81$exports = {};
var $6dd6695614025177$exports = {};
var $b96ab4311dcfa352$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $b96ab4311dcfa352$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$b96ab4311dcfa352$exports = $b96ab4311dcfa352$var$listCacheClear;


var $466bbec72aba2505$exports = {};
var $50cb19614cb34eb7$exports = {};

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $50cb19614cb34eb7$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($ba1c04d40f072e77$exports(array[length][0], key)) return length;
    }
    return -1;
}
$50cb19614cb34eb7$exports = $50cb19614cb34eb7$var$assocIndexOf;


/** Used for built-in method references. */ var $466bbec72aba2505$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $466bbec72aba2505$var$splice = $466bbec72aba2505$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $466bbec72aba2505$var$listCacheDelete(key) {
    var data = this.__data__, index = $50cb19614cb34eb7$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $466bbec72aba2505$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$466bbec72aba2505$exports = $466bbec72aba2505$var$listCacheDelete;


var $e5d142a7b1ecdf41$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e5d142a7b1ecdf41$var$listCacheGet(key) {
    var data = this.__data__, index = $50cb19614cb34eb7$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$e5d142a7b1ecdf41$exports = $e5d142a7b1ecdf41$var$listCacheGet;


var $be9285f32253522a$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $be9285f32253522a$var$listCacheHas(key) {
    return $50cb19614cb34eb7$exports(this.__data__, key) > -1;
}
$be9285f32253522a$exports = $be9285f32253522a$var$listCacheHas;


var $981099f55d831c25$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $981099f55d831c25$var$listCacheSet(key, value) {
    var data = this.__data__, index = $50cb19614cb34eb7$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$981099f55d831c25$exports = $981099f55d831c25$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $6dd6695614025177$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$6dd6695614025177$var$ListCache.prototype.clear = $b96ab4311dcfa352$exports;
$6dd6695614025177$var$ListCache.prototype["delete"] = $466bbec72aba2505$exports;
$6dd6695614025177$var$ListCache.prototype.get = $e5d142a7b1ecdf41$exports;
$6dd6695614025177$var$ListCache.prototype.has = $be9285f32253522a$exports;
$6dd6695614025177$var$ListCache.prototype.set = $981099f55d831c25$exports;
$6dd6695614025177$exports = $6dd6695614025177$var$ListCache;


var $251d14789fe83bed$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $251d14789fe83bed$var$stackClear() {
    this.__data__ = new $6dd6695614025177$exports;
    this.size = 0;
}
$251d14789fe83bed$exports = $251d14789fe83bed$var$stackClear;


var $a54eae6a59036bad$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $a54eae6a59036bad$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
$a54eae6a59036bad$exports = $a54eae6a59036bad$var$stackDelete;


var $551ce2e9d4884d48$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $551ce2e9d4884d48$var$stackGet(key) {
    return this.__data__.get(key);
}
$551ce2e9d4884d48$exports = $551ce2e9d4884d48$var$stackGet;


var $06ec3213039408a4$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $06ec3213039408a4$var$stackHas(key) {
    return this.__data__.has(key);
}
$06ec3213039408a4$exports = $06ec3213039408a4$var$stackHas;


var $63efddd99fc6b52e$exports = {};

var $17cc21fdf5acfaaf$exports = {};


var $yRFSk = parcelRequire("yRFSk");
/* Built-in method references that are verified to be native. */ var $17cc21fdf5acfaaf$var$Map = $7899283e38926019$exports($yRFSk, "Map");
$17cc21fdf5acfaaf$exports = $17cc21fdf5acfaaf$var$Map;


var $f0e334302b29cec1$exports = {};
var $337091f917dedcda$exports = {};
var $cddfb4317dbcd3e4$exports = {};
var $8b7b2c23cf80529c$exports = {};
var $6003b8e84d843fe2$exports = {};

/* Built-in method references that are verified to be native. */ var $6003b8e84d843fe2$var$nativeCreate = $7899283e38926019$exports(Object, "create");
$6003b8e84d843fe2$exports = $6003b8e84d843fe2$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $8b7b2c23cf80529c$var$hashClear() {
    this.__data__ = $6003b8e84d843fe2$exports ? $6003b8e84d843fe2$exports(null) : {};
    this.size = 0;
}
$8b7b2c23cf80529c$exports = $8b7b2c23cf80529c$var$hashClear;


var $a4cb96ed0124daef$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $a4cb96ed0124daef$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$a4cb96ed0124daef$exports = $a4cb96ed0124daef$var$hashDelete;


var $72050bf5e34e224c$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $72050bf5e34e224c$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $72050bf5e34e224c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $72050bf5e34e224c$var$hasOwnProperty = $72050bf5e34e224c$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $72050bf5e34e224c$var$hashGet(key) {
    var data = this.__data__;
    if ($6003b8e84d843fe2$exports) {
        var result = data[key];
        return result === $72050bf5e34e224c$var$HASH_UNDEFINED ? undefined : result;
    }
    return $72050bf5e34e224c$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$72050bf5e34e224c$exports = $72050bf5e34e224c$var$hashGet;


var $fa6aed7f39c0961d$exports = {};

/** Used for built-in method references. */ var $fa6aed7f39c0961d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fa6aed7f39c0961d$var$hasOwnProperty = $fa6aed7f39c0961d$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fa6aed7f39c0961d$var$hashHas(key) {
    var data = this.__data__;
    return $6003b8e84d843fe2$exports ? data[key] !== undefined : $fa6aed7f39c0961d$var$hasOwnProperty.call(data, key);
}
$fa6aed7f39c0961d$exports = $fa6aed7f39c0961d$var$hashHas;


var $ef4be21c342ab041$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $ef4be21c342ab041$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $ef4be21c342ab041$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $6003b8e84d843fe2$exports && value === undefined ? $ef4be21c342ab041$var$HASH_UNDEFINED : value;
    return this;
}
$ef4be21c342ab041$exports = $ef4be21c342ab041$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $cddfb4317dbcd3e4$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$cddfb4317dbcd3e4$var$Hash.prototype.clear = $8b7b2c23cf80529c$exports;
$cddfb4317dbcd3e4$var$Hash.prototype["delete"] = $a4cb96ed0124daef$exports;
$cddfb4317dbcd3e4$var$Hash.prototype.get = $72050bf5e34e224c$exports;
$cddfb4317dbcd3e4$var$Hash.prototype.has = $fa6aed7f39c0961d$exports;
$cddfb4317dbcd3e4$var$Hash.prototype.set = $ef4be21c342ab041$exports;
$cddfb4317dbcd3e4$exports = $cddfb4317dbcd3e4$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $337091f917dedcda$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $cddfb4317dbcd3e4$exports,
        "map": new ($17cc21fdf5acfaaf$exports || $6dd6695614025177$exports),
        "string": new $cddfb4317dbcd3e4$exports
    };
}
$337091f917dedcda$exports = $337091f917dedcda$var$mapCacheClear;


var $b849d43a090134cb$exports = {};
var $f97ff534a0efc75f$exports = {};
var $ff1c3374e65a1ef6$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $ff1c3374e65a1ef6$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
$ff1c3374e65a1ef6$exports = $ff1c3374e65a1ef6$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $f97ff534a0efc75f$var$getMapData(map, key) {
    var data = map.__data__;
    return $ff1c3374e65a1ef6$exports(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
$f97ff534a0efc75f$exports = $f97ff534a0efc75f$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b849d43a090134cb$var$mapCacheDelete(key) {
    var result = $f97ff534a0efc75f$exports(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
$b849d43a090134cb$exports = $b849d43a090134cb$var$mapCacheDelete;


var $818885dbfe5034e3$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $818885dbfe5034e3$var$mapCacheGet(key) {
    return $f97ff534a0efc75f$exports(this, key).get(key);
}
$818885dbfe5034e3$exports = $818885dbfe5034e3$var$mapCacheGet;


var $27bc6c99d62317f3$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $27bc6c99d62317f3$var$mapCacheHas(key) {
    return $f97ff534a0efc75f$exports(this, key).has(key);
}
$27bc6c99d62317f3$exports = $27bc6c99d62317f3$var$mapCacheHas;


var $a9ae7446e772b13e$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $a9ae7446e772b13e$var$mapCacheSet(key, value) {
    var data = $f97ff534a0efc75f$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$a9ae7446e772b13e$exports = $a9ae7446e772b13e$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f0e334302b29cec1$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$f0e334302b29cec1$var$MapCache.prototype.clear = $337091f917dedcda$exports;
$f0e334302b29cec1$var$MapCache.prototype["delete"] = $b849d43a090134cb$exports;
$f0e334302b29cec1$var$MapCache.prototype.get = $818885dbfe5034e3$exports;
$f0e334302b29cec1$var$MapCache.prototype.has = $27bc6c99d62317f3$exports;
$f0e334302b29cec1$var$MapCache.prototype.set = $a9ae7446e772b13e$exports;
$f0e334302b29cec1$exports = $f0e334302b29cec1$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $63efddd99fc6b52e$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $63efddd99fc6b52e$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $6dd6695614025177$exports) {
        var pairs = data.__data__;
        if (!$17cc21fdf5acfaaf$exports || pairs.length < $63efddd99fc6b52e$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $f0e334302b29cec1$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$63efddd99fc6b52e$exports = $63efddd99fc6b52e$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $861d1b63d8478a81$var$Stack(entries) {
    var data = this.__data__ = new $6dd6695614025177$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$861d1b63d8478a81$var$Stack.prototype.clear = $251d14789fe83bed$exports;
$861d1b63d8478a81$var$Stack.prototype["delete"] = $a54eae6a59036bad$exports;
$861d1b63d8478a81$var$Stack.prototype.get = $551ce2e9d4884d48$exports;
$861d1b63d8478a81$var$Stack.prototype.has = $06ec3213039408a4$exports;
$861d1b63d8478a81$var$Stack.prototype.set = $63efddd99fc6b52e$exports;
$861d1b63d8478a81$exports = $861d1b63d8478a81$var$Stack;


var $8ad758ceb849e9eb$exports = {};
var $e4f52da9bede4538$exports = {};

var $e746817bf72f1621$exports = {};
var $0caf93a6e311dd5e$exports = {};

var $f17e25f845dd7c71$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $f17e25f845dd7c71$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $f17e25f845dd7c71$var$setCacheAdd(value) {
    this.__data__.set(value, $f17e25f845dd7c71$var$HASH_UNDEFINED);
    return this;
}
$f17e25f845dd7c71$exports = $f17e25f845dd7c71$var$setCacheAdd;


var $fc28c343c6be2769$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $fc28c343c6be2769$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$fc28c343c6be2769$exports = $fc28c343c6be2769$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $0caf93a6e311dd5e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $f0e334302b29cec1$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$0caf93a6e311dd5e$var$SetCache.prototype.add = $0caf93a6e311dd5e$var$SetCache.prototype.push = $f17e25f845dd7c71$exports;
$0caf93a6e311dd5e$var$SetCache.prototype.has = $fc28c343c6be2769$exports;
$0caf93a6e311dd5e$exports = $0caf93a6e311dd5e$var$SetCache;


var $a56761d28df36f98$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $a56761d28df36f98$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$a56761d28df36f98$exports = $a56761d28df36f98$var$arraySome;


var $fcea3308b25e2289$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fcea3308b25e2289$var$cacheHas(cache, key) {
    return cache.has(key);
}
$fcea3308b25e2289$exports = $fcea3308b25e2289$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $e746817bf72f1621$var$COMPARE_PARTIAL_FLAG = 1, $e746817bf72f1621$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $e746817bf72f1621$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $e746817bf72f1621$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $e746817bf72f1621$var$COMPARE_UNORDERED_FLAG ? new $0caf93a6e311dd5e$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$a56761d28df36f98$exports(other, function(othValue, othIndex) {
                if (!$fcea3308b25e2289$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
$e746817bf72f1621$exports = $e746817bf72f1621$var$equalArrays;


var $e058699895282cc5$exports = {};

var $894004397dec7019$exports = {};

var $yRFSk = parcelRequire("yRFSk");
/** Built-in value references. */ var $894004397dec7019$var$Uint8Array = $yRFSk.Uint8Array;
$894004397dec7019$exports = $894004397dec7019$var$Uint8Array;




var $443284b5df2a6873$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $443284b5df2a6873$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$443284b5df2a6873$exports = $443284b5df2a6873$var$mapToArray;


var $2923149d82fb4e32$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $2923149d82fb4e32$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$2923149d82fb4e32$exports = $2923149d82fb4e32$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $e058699895282cc5$var$COMPARE_PARTIAL_FLAG = 1, $e058699895282cc5$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $e058699895282cc5$var$boolTag = "[object Boolean]", $e058699895282cc5$var$dateTag = "[object Date]", $e058699895282cc5$var$errorTag = "[object Error]", $e058699895282cc5$var$mapTag = "[object Map]", $e058699895282cc5$var$numberTag = "[object Number]", $e058699895282cc5$var$regexpTag = "[object RegExp]", $e058699895282cc5$var$setTag = "[object Set]", $e058699895282cc5$var$stringTag = "[object String]", $e058699895282cc5$var$symbolTag = "[object Symbol]";
var $e058699895282cc5$var$arrayBufferTag = "[object ArrayBuffer]", $e058699895282cc5$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $e058699895282cc5$var$symbolProto = $29a029238437d6de$exports ? $29a029238437d6de$exports.prototype : undefined, $e058699895282cc5$var$symbolValueOf = $e058699895282cc5$var$symbolProto ? $e058699895282cc5$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $e058699895282cc5$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $e058699895282cc5$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $e058699895282cc5$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $894004397dec7019$exports(object), new $894004397dec7019$exports(other))) return false;
            return true;
        case $e058699895282cc5$var$boolTag:
        case $e058699895282cc5$var$dateTag:
        case $e058699895282cc5$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $ba1c04d40f072e77$exports(+object, +other);
        case $e058699895282cc5$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $e058699895282cc5$var$regexpTag:
        case $e058699895282cc5$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $e058699895282cc5$var$mapTag:
            var convert = $443284b5df2a6873$exports;
        case $e058699895282cc5$var$setTag:
            var isPartial = bitmask & $e058699895282cc5$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $2923149d82fb4e32$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $e058699895282cc5$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $e746817bf72f1621$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $e058699895282cc5$var$symbolTag:
            if ($e058699895282cc5$var$symbolValueOf) return $e058699895282cc5$var$symbolValueOf.call(object) == $e058699895282cc5$var$symbolValueOf.call(other);
    }
    return false;
}
$e058699895282cc5$exports = $e058699895282cc5$var$equalByTag;


var $f135f267fd805d15$exports = {};
var $6a2e5419fb614e31$exports = {};
var $c29475283cf67e7d$exports = {};
var $3bf95b782724c68c$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $3bf95b782724c68c$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$3bf95b782724c68c$exports = $3bf95b782724c68c$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $c29475283cf67e7d$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $b47d971f66a6f054$exports(object) ? result : $3bf95b782724c68c$exports(result, symbolsFunc(object));
}
$c29475283cf67e7d$exports = $c29475283cf67e7d$var$baseGetAllKeys;


var $75381d22f22a25de$exports = {};
var $35a63e38c03b8c57$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $35a63e38c03b8c57$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$35a63e38c03b8c57$exports = $35a63e38c03b8c57$var$arrayFilter;


var $f109fd11e633354b$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $f109fd11e633354b$var$stubArray() {
    return [];
}
$f109fd11e633354b$exports = $f109fd11e633354b$var$stubArray;


/** Used for built-in method references. */ var $75381d22f22a25de$var$objectProto = Object.prototype;
/** Built-in value references. */ var $75381d22f22a25de$var$propertyIsEnumerable = $75381d22f22a25de$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $75381d22f22a25de$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $75381d22f22a25de$var$getSymbols = !$75381d22f22a25de$var$nativeGetSymbols ? $f109fd11e633354b$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $35a63e38c03b8c57$exports($75381d22f22a25de$var$nativeGetSymbols(object), function(symbol) {
        return $75381d22f22a25de$var$propertyIsEnumerable.call(object, symbol);
    });
};
$75381d22f22a25de$exports = $75381d22f22a25de$var$getSymbols;



/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $6a2e5419fb614e31$var$getAllKeys(object) {
    return $c29475283cf67e7d$exports(object, $9c7d1fa85e24a67e$exports, $75381d22f22a25de$exports);
}
$6a2e5419fb614e31$exports = $6a2e5419fb614e31$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $f135f267fd805d15$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $f135f267fd805d15$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f135f267fd805d15$var$hasOwnProperty = $f135f267fd805d15$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $f135f267fd805d15$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $f135f267fd805d15$var$COMPARE_PARTIAL_FLAG, objProps = $6a2e5419fb614e31$exports(object), objLength = objProps.length, othProps = $6a2e5419fb614e31$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $f135f267fd805d15$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
$f135f267fd805d15$exports = $f135f267fd805d15$var$equalObjects;


var $8d5c6ea4cc5d862e$exports = {};
var $8191d20b90474416$exports = {};


var $yRFSk = parcelRequire("yRFSk");
/* Built-in method references that are verified to be native. */ var $8191d20b90474416$var$DataView = $7899283e38926019$exports($yRFSk, "DataView");
$8191d20b90474416$exports = $8191d20b90474416$var$DataView;



var $fdb3487977023d82$exports = {};


var $yRFSk = parcelRequire("yRFSk");
/* Built-in method references that are verified to be native. */ var $fdb3487977023d82$var$Promise = $7899283e38926019$exports($yRFSk, "Promise");
$fdb3487977023d82$exports = $fdb3487977023d82$var$Promise;


var $f7e45b5ac0aba58a$exports = {};


var $yRFSk = parcelRequire("yRFSk");
/* Built-in method references that are verified to be native. */ var $f7e45b5ac0aba58a$var$Set = $7899283e38926019$exports($yRFSk, "Set");
$f7e45b5ac0aba58a$exports = $f7e45b5ac0aba58a$var$Set;


var $ae0df087007bfc5b$exports = {};


var $yRFSk = parcelRequire("yRFSk");
/* Built-in method references that are verified to be native. */ var $ae0df087007bfc5b$var$WeakMap = $7899283e38926019$exports($yRFSk, "WeakMap");
$ae0df087007bfc5b$exports = $ae0df087007bfc5b$var$WeakMap;




/** `Object#toString` result references. */ var $8d5c6ea4cc5d862e$var$mapTag = "[object Map]", $8d5c6ea4cc5d862e$var$objectTag = "[object Object]", $8d5c6ea4cc5d862e$var$promiseTag = "[object Promise]", $8d5c6ea4cc5d862e$var$setTag = "[object Set]", $8d5c6ea4cc5d862e$var$weakMapTag = "[object WeakMap]";
var $8d5c6ea4cc5d862e$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $8d5c6ea4cc5d862e$var$dataViewCtorString = $b15df2ee81e34172$exports($8191d20b90474416$exports), $8d5c6ea4cc5d862e$var$mapCtorString = $b15df2ee81e34172$exports($17cc21fdf5acfaaf$exports), $8d5c6ea4cc5d862e$var$promiseCtorString = $b15df2ee81e34172$exports($fdb3487977023d82$exports), $8d5c6ea4cc5d862e$var$setCtorString = $b15df2ee81e34172$exports($f7e45b5ac0aba58a$exports), $8d5c6ea4cc5d862e$var$weakMapCtorString = $b15df2ee81e34172$exports($ae0df087007bfc5b$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $8d5c6ea4cc5d862e$var$getTag = $4003a8f3ae86bec1$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($8191d20b90474416$exports && $8d5c6ea4cc5d862e$var$getTag(new $8191d20b90474416$exports(new ArrayBuffer(1))) != $8d5c6ea4cc5d862e$var$dataViewTag || $17cc21fdf5acfaaf$exports && $8d5c6ea4cc5d862e$var$getTag(new $17cc21fdf5acfaaf$exports) != $8d5c6ea4cc5d862e$var$mapTag || $fdb3487977023d82$exports && $8d5c6ea4cc5d862e$var$getTag($fdb3487977023d82$exports.resolve()) != $8d5c6ea4cc5d862e$var$promiseTag || $f7e45b5ac0aba58a$exports && $8d5c6ea4cc5d862e$var$getTag(new $f7e45b5ac0aba58a$exports) != $8d5c6ea4cc5d862e$var$setTag || $ae0df087007bfc5b$exports && $8d5c6ea4cc5d862e$var$getTag(new $ae0df087007bfc5b$exports) != $8d5c6ea4cc5d862e$var$weakMapTag) $8d5c6ea4cc5d862e$var$getTag = function(value) {
    var result = $4003a8f3ae86bec1$exports(value), Ctor = result == $8d5c6ea4cc5d862e$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $b15df2ee81e34172$exports(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $8d5c6ea4cc5d862e$var$dataViewCtorString:
            return $8d5c6ea4cc5d862e$var$dataViewTag;
        case $8d5c6ea4cc5d862e$var$mapCtorString:
            return $8d5c6ea4cc5d862e$var$mapTag;
        case $8d5c6ea4cc5d862e$var$promiseCtorString:
            return $8d5c6ea4cc5d862e$var$promiseTag;
        case $8d5c6ea4cc5d862e$var$setCtorString:
            return $8d5c6ea4cc5d862e$var$setTag;
        case $8d5c6ea4cc5d862e$var$weakMapCtorString:
            return $8d5c6ea4cc5d862e$var$weakMapTag;
    }
    return result;
};
$8d5c6ea4cc5d862e$exports = $8d5c6ea4cc5d862e$var$getTag;




var $hAe8M = parcelRequire("hAe8M");

/** Used to compose bitmasks for value comparisons. */ var $e4f52da9bede4538$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $e4f52da9bede4538$var$argsTag = "[object Arguments]", $e4f52da9bede4538$var$arrayTag = "[object Array]", $e4f52da9bede4538$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $e4f52da9bede4538$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e4f52da9bede4538$var$hasOwnProperty = $e4f52da9bede4538$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $e4f52da9bede4538$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $b47d971f66a6f054$exports(object), othIsArr = $b47d971f66a6f054$exports(other), objTag = objIsArr ? $e4f52da9bede4538$var$arrayTag : $8d5c6ea4cc5d862e$exports(object), othTag = othIsArr ? $e4f52da9bede4538$var$arrayTag : $8d5c6ea4cc5d862e$exports(other);
    objTag = objTag == $e4f52da9bede4538$var$argsTag ? $e4f52da9bede4538$var$objectTag : objTag;
    othTag = othTag == $e4f52da9bede4538$var$argsTag ? $e4f52da9bede4538$var$objectTag : othTag;
    var objIsObj = objTag == $e4f52da9bede4538$var$objectTag, othIsObj = othTag == $e4f52da9bede4538$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $hAe8M(object)) {
        if (!$hAe8M(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $861d1b63d8478a81$exports);
        return objIsArr || $f88c9406e419272a$exports(object) ? $e746817bf72f1621$exports(object, other, bitmask, customizer, equalFunc, stack) : $e058699895282cc5$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $e4f52da9bede4538$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $e4f52da9bede4538$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $e4f52da9bede4538$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $861d1b63d8478a81$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $861d1b63d8478a81$exports);
    return $f135f267fd805d15$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$e4f52da9bede4538$exports = $e4f52da9bede4538$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $8ad758ceb849e9eb$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$65ef2014975340ff$exports(value) && !$65ef2014975340ff$exports(other)) return value !== value && other !== other;
    return $e4f52da9bede4538$exports(value, other, bitmask, customizer, $8ad758ceb849e9eb$var$baseIsEqual, stack);
}
$8ad758ceb849e9eb$exports = $8ad758ceb849e9eb$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $2d9d6e3f255e1c55$var$COMPARE_PARTIAL_FLAG = 1, $2d9d6e3f255e1c55$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $2d9d6e3f255e1c55$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $861d1b63d8478a81$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $8ad758ceb849e9eb$exports(srcValue, objValue, $2d9d6e3f255e1c55$var$COMPARE_PARTIAL_FLAG | $2d9d6e3f255e1c55$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$2d9d6e3f255e1c55$exports = $2d9d6e3f255e1c55$var$baseIsMatch;


var $408a77f431c35515$exports = {};
var $24ee6f8381d21d53$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $24ee6f8381d21d53$var$isStrictComparable(value) {
    return value === value && !$cd2b0b1294af0960$exports(value);
}
$24ee6f8381d21d53$exports = $24ee6f8381d21d53$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $408a77f431c35515$var$getMatchData(object) {
    var result = $9c7d1fa85e24a67e$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $24ee6f8381d21d53$exports(value)
        ];
    }
    return result;
}
$408a77f431c35515$exports = $408a77f431c35515$var$getMatchData;


var $d36ae16033f20bf3$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $d36ae16033f20bf3$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$d36ae16033f20bf3$exports = $d36ae16033f20bf3$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $5d8d0bf2708d1398$var$baseMatches(source) {
    var matchData = $408a77f431c35515$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $d36ae16033f20bf3$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $2d9d6e3f255e1c55$exports(object, source, matchData);
    };
}
$5d8d0bf2708d1398$exports = $5d8d0bf2708d1398$var$baseMatches;


var $69125bc30b33891f$exports = {};

var $eb02300d30d6bdcb$exports = {};
var $7bff94b74b05cdba$exports = {};
var $5f248967e32df0c1$exports = {};

var $32fa1f4d8228ffde$exports = {};

var $193702f8737ef12b$exports = {};


/** `Object#toString` result references. */ var $193702f8737ef12b$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $193702f8737ef12b$var$isSymbol(value) {
    return typeof value == "symbol" || $65ef2014975340ff$exports(value) && $4003a8f3ae86bec1$exports(value) == $193702f8737ef12b$var$symbolTag;
}
$193702f8737ef12b$exports = $193702f8737ef12b$var$isSymbol;


/** Used to match property names within property paths. */ var $32fa1f4d8228ffde$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $32fa1f4d8228ffde$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $32fa1f4d8228ffde$var$isKey(value, object) {
    if ($b47d971f66a6f054$exports(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $193702f8737ef12b$exports(value)) return true;
    return $32fa1f4d8228ffde$var$reIsPlainProp.test(value) || !$32fa1f4d8228ffde$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$32fa1f4d8228ffde$exports = $32fa1f4d8228ffde$var$isKey;


var $b3bb2312c416cd11$exports = {};
var $b16a399366d4e11c$exports = {};
var $5659748bd598a7eb$exports = {};

/** Error message constants. */ var $5659748bd598a7eb$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $5659748bd598a7eb$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($5659748bd598a7eb$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($5659748bd598a7eb$var$memoize.Cache || $f0e334302b29cec1$exports);
    return memoized;
}
// Expose `MapCache`.
$5659748bd598a7eb$var$memoize.Cache = $f0e334302b29cec1$exports;
$5659748bd598a7eb$exports = $5659748bd598a7eb$var$memoize;


/** Used as the maximum memoize cache size. */ var $b16a399366d4e11c$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $b16a399366d4e11c$var$memoizeCapped(func) {
    var result = $5659748bd598a7eb$exports(func, function(key) {
        if (cache.size === $b16a399366d4e11c$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$b16a399366d4e11c$exports = $b16a399366d4e11c$var$memoizeCapped;


/** Used to match property names within property paths. */ var $b3bb2312c416cd11$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $b3bb2312c416cd11$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $b3bb2312c416cd11$var$stringToPath = $b16a399366d4e11c$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($b3bb2312c416cd11$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($b3bb2312c416cd11$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
$b3bb2312c416cd11$exports = $b3bb2312c416cd11$var$stringToPath;


var $4360b921cc50ac20$exports = {};
var $94e29f736f5ee1b8$exports = {};

var $95a41775a4f282b8$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $95a41775a4f282b8$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$95a41775a4f282b8$exports = $95a41775a4f282b8$var$arrayMap;




/** Used as references for various `Number` constants. */ var $94e29f736f5ee1b8$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $94e29f736f5ee1b8$var$symbolProto = $29a029238437d6de$exports ? $29a029238437d6de$exports.prototype : undefined, $94e29f736f5ee1b8$var$symbolToString = $94e29f736f5ee1b8$var$symbolProto ? $94e29f736f5ee1b8$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $94e29f736f5ee1b8$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($b47d971f66a6f054$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $95a41775a4f282b8$exports(value, $94e29f736f5ee1b8$var$baseToString) + "";
    if ($193702f8737ef12b$exports(value)) return $94e29f736f5ee1b8$var$symbolToString ? $94e29f736f5ee1b8$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$94e29f736f5ee1b8$var$INFINITY ? "-0" : result;
}
$94e29f736f5ee1b8$exports = $94e29f736f5ee1b8$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $4360b921cc50ac20$var$toString(value) {
    return value == null ? "" : $94e29f736f5ee1b8$exports(value);
}
$4360b921cc50ac20$exports = $4360b921cc50ac20$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $5f248967e32df0c1$var$castPath(value, object) {
    if ($b47d971f66a6f054$exports(value)) return value;
    return $32fa1f4d8228ffde$exports(value, object) ? [
        value
    ] : $b3bb2312c416cd11$exports($4360b921cc50ac20$exports(value));
}
$5f248967e32df0c1$exports = $5f248967e32df0c1$var$castPath;


var $4bf6972158fbafc8$exports = {};

/** Used as references for various `Number` constants. */ var $4bf6972158fbafc8$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $4bf6972158fbafc8$var$toKey(value) {
    if (typeof value == "string" || $193702f8737ef12b$exports(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$4bf6972158fbafc8$var$INFINITY ? "-0" : result;
}
$4bf6972158fbafc8$exports = $4bf6972158fbafc8$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $7bff94b74b05cdba$var$baseGet(object, path) {
    path = $5f248967e32df0c1$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$4bf6972158fbafc8$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$7bff94b74b05cdba$exports = $7bff94b74b05cdba$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $eb02300d30d6bdcb$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $7bff94b74b05cdba$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$eb02300d30d6bdcb$exports = $eb02300d30d6bdcb$var$get;


var $029d15c9e3b4deab$exports = {};
var $ae1d3982bc9cc8a8$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $ae1d3982bc9cc8a8$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$ae1d3982bc9cc8a8$exports = $ae1d3982bc9cc8a8$var$baseHasIn;


var $eb3af6a59d7130a0$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $eb3af6a59d7130a0$var$hasPath(object, path, hasFunc) {
    path = $5f248967e32df0c1$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $4bf6972158fbafc8$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $27f0a97b97c49daa$exports(length) && $c60ce55ccfd38e2a$exports(key, length) && ($b47d971f66a6f054$exports(object) || $343d561a7d6a3b42$exports(object));
}
$eb3af6a59d7130a0$exports = $eb3af6a59d7130a0$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $029d15c9e3b4deab$var$hasIn(object, path) {
    return object != null && $eb3af6a59d7130a0$exports(object, path, $ae1d3982bc9cc8a8$exports);
}
$029d15c9e3b4deab$exports = $029d15c9e3b4deab$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $69125bc30b33891f$var$COMPARE_PARTIAL_FLAG = 1, $69125bc30b33891f$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $69125bc30b33891f$var$baseMatchesProperty(path, srcValue) {
    if ($32fa1f4d8228ffde$exports(path) && $24ee6f8381d21d53$exports(srcValue)) return $d36ae16033f20bf3$exports($4bf6972158fbafc8$exports(path), srcValue);
    return function(object) {
        var objValue = $eb02300d30d6bdcb$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $029d15c9e3b4deab$exports(object, path) : $8ad758ceb849e9eb$exports(srcValue, objValue, $69125bc30b33891f$var$COMPARE_PARTIAL_FLAG | $69125bc30b33891f$var$COMPARE_UNORDERED_FLAG);
    };
}
$69125bc30b33891f$exports = $69125bc30b33891f$var$baseMatchesProperty;




var $bd112cd1a4525cec$exports = {};
var $989c41a7f058035c$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $989c41a7f058035c$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$989c41a7f058035c$exports = $989c41a7f058035c$var$baseProperty;


var $2b33052c26df4562$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $2b33052c26df4562$var$basePropertyDeep(path) {
    return function(object) {
        return $7bff94b74b05cdba$exports(object, path);
    };
}
$2b33052c26df4562$exports = $2b33052c26df4562$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $bd112cd1a4525cec$var$property(path) {
    return $32fa1f4d8228ffde$exports(path) ? $989c41a7f058035c$exports($4bf6972158fbafc8$exports(path)) : $2b33052c26df4562$exports(path);
}
$bd112cd1a4525cec$exports = $bd112cd1a4525cec$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $9dd1d38dfe69ddcf$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $30121ce9c4b4eb3d$exports;
    if (typeof value == "object") return $b47d971f66a6f054$exports(value) ? $69125bc30b33891f$exports(value[0], value[1]) : $5d8d0bf2708d1398$exports(value);
    return $bd112cd1a4525cec$exports(value);
}
$9dd1d38dfe69ddcf$exports = $9dd1d38dfe69ddcf$var$baseIteratee;




/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $01f07113cfe93416$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$edace719698f1e70$exports(collection)) {
            var iteratee = $9dd1d38dfe69ddcf$exports(predicate, 3);
            collection = $9c7d1fa85e24a67e$exports(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
$01f07113cfe93416$exports = $01f07113cfe93416$var$createFind;


var $b06cdbd0cbf9caa7$exports = {};
var $97e784a8512e4a9d$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $97e784a8512e4a9d$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$97e784a8512e4a9d$exports = $97e784a8512e4a9d$var$baseFindIndex;



var $da5fff48ccc726db$exports = {};
var $420360e96c86f53d$exports = {};
var $f038f60db3b99cd9$exports = {};
var $0d102123d2b2ab0b$exports = {};
var $7895653026268022$exports = {};
/** Used to match a single whitespace character. */ var $7895653026268022$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $7895653026268022$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $7895653026268022$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$7895653026268022$exports = $7895653026268022$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $0d102123d2b2ab0b$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $0d102123d2b2ab0b$var$baseTrim(string) {
    return string ? string.slice(0, $7895653026268022$exports(string) + 1).replace($0d102123d2b2ab0b$var$reTrimStart, "") : string;
}
$0d102123d2b2ab0b$exports = $0d102123d2b2ab0b$var$baseTrim;




/** Used as references for various `Number` constants. */ var $f038f60db3b99cd9$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $f038f60db3b99cd9$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $f038f60db3b99cd9$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $f038f60db3b99cd9$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $f038f60db3b99cd9$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $f038f60db3b99cd9$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($193702f8737ef12b$exports(value)) return $f038f60db3b99cd9$var$NAN;
    if ($cd2b0b1294af0960$exports(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $cd2b0b1294af0960$exports(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $0d102123d2b2ab0b$exports(value);
    var isBinary = $f038f60db3b99cd9$var$reIsBinary.test(value);
    return isBinary || $f038f60db3b99cd9$var$reIsOctal.test(value) ? $f038f60db3b99cd9$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $f038f60db3b99cd9$var$reIsBadHex.test(value) ? $f038f60db3b99cd9$var$NAN : +value;
}
$f038f60db3b99cd9$exports = $f038f60db3b99cd9$var$toNumber;


/** Used as references for various `Number` constants. */ var $420360e96c86f53d$var$INFINITY = 1 / 0, $420360e96c86f53d$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $420360e96c86f53d$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $f038f60db3b99cd9$exports(value);
    if (value === $420360e96c86f53d$var$INFINITY || value === -$420360e96c86f53d$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $420360e96c86f53d$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
$420360e96c86f53d$exports = $420360e96c86f53d$var$toFinite;


/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $da5fff48ccc726db$var$toInteger(value) {
    var result = $420360e96c86f53d$exports(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$da5fff48ccc726db$exports = $da5fff48ccc726db$var$toInteger;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $b06cdbd0cbf9caa7$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $b06cdbd0cbf9caa7$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $da5fff48ccc726db$exports(fromIndex);
    if (index < 0) index = $b06cdbd0cbf9caa7$var$nativeMax(length + index, 0);
    return $97e784a8512e4a9d$exports(array, $9dd1d38dfe69ddcf$exports(predicate, 3), index);
}
$b06cdbd0cbf9caa7$exports = $b06cdbd0cbf9caa7$var$findIndex;


/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $9f60e838fdb2edf2$var$find = $01f07113cfe93416$exports($b06cdbd0cbf9caa7$exports);
$9f60e838fdb2edf2$exports = $9f60e838fdb2edf2$var$find;


/* global console */ /* eslint-disable no-console */ // TODO: Use "warning" npm module like React is switching to.
function $8590ed3b940180fa$export$c106dd0671a0fc2d(message) {}



var $fdGrT = parcelRequire("fdGrT");
var $bf1178a7a28a9ee4$exports = {};

$parcel$export($bf1178a7a28a9ee4$exports, "validScale", () => $bf1178a7a28a9ee4$export$e88dde4d94c18054);
$parcel$export($bf1178a7a28a9ee4$exports, "getType", () => $bf1178a7a28a9ee4$export$e2b5c5db9e2009fd);
$parcel$export($bf1178a7a28a9ee4$exports, "getScaleFromName", () => $bf1178a7a28a9ee4$export$f8a8079677dfe10e);
$parcel$export($bf1178a7a28a9ee4$exports, "getBaseScale", () => $bf1178a7a28a9ee4$export$cc504192b2543d0c);
$parcel$export($bf1178a7a28a9ee4$exports, "getScaleFromProps", () => $bf1178a7a28a9ee4$export$e32c9cfc9124038e);
$parcel$export($bf1178a7a28a9ee4$exports, "getDefaultScale", () => $bf1178a7a28a9ee4$export$88309260a893db31);
$parcel$export($bf1178a7a28a9ee4$exports, "getScaleType", () => $bf1178a7a28a9ee4$export$ff60de4f71778a2c);
var $2537df67cd52c170$exports = {};

var $35bf467654165918$exports = {};

/** Built-in value references. */ var $35bf467654165918$var$getPrototype = $ea458d5b09fec244$exports(Object.getPrototypeOf, Object);
$35bf467654165918$exports = $35bf467654165918$var$getPrototype;



/** `Object#toString` result references. */ var $2537df67cd52c170$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $2537df67cd52c170$var$funcProto = Function.prototype, $2537df67cd52c170$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $2537df67cd52c170$var$funcToString = $2537df67cd52c170$var$funcProto.toString;
/** Used to check objects for own properties. */ var $2537df67cd52c170$var$hasOwnProperty = $2537df67cd52c170$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $2537df67cd52c170$var$objectCtorString = $2537df67cd52c170$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $2537df67cd52c170$var$isPlainObject(value) {
    if (!$65ef2014975340ff$exports(value) || $4003a8f3ae86bec1$exports(value) != $2537df67cd52c170$var$objectTag) return false;
    var proto = $35bf467654165918$exports(value);
    if (proto === null) return true;
    var Ctor = $2537df67cd52c170$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $2537df67cd52c170$var$funcToString.call(Ctor) == $2537df67cd52c170$var$objectCtorString;
}
$2537df67cd52c170$exports = $2537df67cd52c170$var$isPlainObject;



var $8ba9a2795a3c2065$exports = {};
var $90ff81eaf0557cbd$exports = {};

var $8b2390ea294cba45$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $8b2390ea294cba45$var$baseIsNaN(value) {
    return value !== value;
}
$8b2390ea294cba45$exports = $8b2390ea294cba45$var$baseIsNaN;


var $3b49aa4d5d9ee37d$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $3b49aa4d5d9ee37d$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$3b49aa4d5d9ee37d$exports = $3b49aa4d5d9ee37d$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $90ff81eaf0557cbd$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $3b49aa4d5d9ee37d$exports(array, value, fromIndex) : $97e784a8512e4a9d$exports(array, $8b2390ea294cba45$exports, fromIndex);
}
$90ff81eaf0557cbd$exports = $90ff81eaf0557cbd$var$baseIndexOf;



var $b674a8a9f1dd7eca$exports = {};



/** `Object#toString` result references. */ var $b674a8a9f1dd7eca$var$stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $b674a8a9f1dd7eca$var$isString(value) {
    return typeof value == "string" || !$b47d971f66a6f054$exports(value) && $65ef2014975340ff$exports(value) && $4003a8f3ae86bec1$exports(value) == $b674a8a9f1dd7eca$var$stringTag;
}
$b674a8a9f1dd7eca$exports = $b674a8a9f1dd7eca$var$isString;



var $0f1b14d3de521ffa$exports = {};
var $9a66664bccc046c9$exports = {};

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $9a66664bccc046c9$var$baseValues(object, props) {
    return $95a41775a4f282b8$exports(props, function(key) {
        return object[key];
    });
}
$9a66664bccc046c9$exports = $9a66664bccc046c9$var$baseValues;



/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $0f1b14d3de521ffa$var$values(object) {
    return object == null ? [] : $9a66664bccc046c9$exports(object, $9c7d1fa85e24a67e$exports(object));
}
$0f1b14d3de521ffa$exports = $0f1b14d3de521ffa$var$values;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $8ba9a2795a3c2065$var$nativeMax = Math.max;
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function $8ba9a2795a3c2065$var$includes(collection, value, fromIndex, guard) {
    collection = $edace719698f1e70$exports(collection) ? collection : $0f1b14d3de521ffa$exports(collection);
    fromIndex = fromIndex && !guard ? $da5fff48ccc726db$exports(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = $8ba9a2795a3c2065$var$nativeMax(length + fromIndex, 0);
    return $b674a8a9f1dd7eca$exports(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && $90ff81eaf0557cbd$exports(collection, value, fromIndex) > -1;
}
$8ba9a2795a3c2065$exports = $8ba9a2795a3c2065$var$includes;


var $0a5de8228869aa1e$exports = {};

$parcel$export($0a5de8228869aa1e$exports, "getPadding", () => $0a5de8228869aa1e$export$d7501e6bee71bfee);
$parcel$export($0a5de8228869aa1e$exports, "degreesToRadians", () => $0a5de8228869aa1e$export$c9fcf1a7df975d78);
$parcel$export($0a5de8228869aa1e$exports, "getRadius", () => $0a5de8228869aa1e$export$35724d9c2979edc5);
$parcel$export($0a5de8228869aa1e$exports, "omit", () => $0a5de8228869aa1e$export$30a06c8d3562193f);
$parcel$export($0a5de8228869aa1e$exports, "getPoint", () => $0a5de8228869aa1e$export$92d53b972f97f55a);
$parcel$export($0a5de8228869aa1e$exports, "scalePoint", () => $0a5de8228869aa1e$export$2290ec7febe36dd6);
$parcel$export($0a5de8228869aa1e$exports, "isTooltip", () => $0a5de8228869aa1e$export$682a6f6bf6d26974);
$parcel$export($0a5de8228869aa1e$exports, "getDefaultStyles", () => $0a5de8228869aa1e$export$5de07126d06163d6);
$parcel$export($0a5de8228869aa1e$exports, "getStyles", () => $0a5de8228869aa1e$export$ffd58b7f6f099a57);
$parcel$export($0a5de8228869aa1e$exports, "evaluateProp", () => $0a5de8228869aa1e$export$1e9fd61bf4a24ae1);
$parcel$export($0a5de8228869aa1e$exports, "evaluateStyle", () => $0a5de8228869aa1e$export$b94dbb3a3654958c);
$parcel$export($0a5de8228869aa1e$exports, "radiansToDegrees", () => $0a5de8228869aa1e$export$c41dd2a8460d3196);
$parcel$export($0a5de8228869aa1e$exports, "getPolarOrigin", () => $0a5de8228869aa1e$export$557acdb671688361);
$parcel$export($0a5de8228869aa1e$exports, "getRange", () => $0a5de8228869aa1e$export$fef151b94550e9f5);
$parcel$export($0a5de8228869aa1e$exports, "createAccessor", () => $0a5de8228869aa1e$export$f5ddff6606408ce8);
$parcel$export($0a5de8228869aa1e$exports, "modifyProps", () => $0a5de8228869aa1e$export$9c2da7bc2aacbf9b);
$parcel$export($0a5de8228869aa1e$exports, "isHorizontal", () => $0a5de8228869aa1e$export$2a62b49acb270576);
$parcel$export($0a5de8228869aa1e$exports, "getCurrentAxis", () => $0a5de8228869aa1e$export$54b2c1a7f28c35a0);
$parcel$export($0a5de8228869aa1e$exports, "reduceChildren", () => $0a5de8228869aa1e$export$8d02402a54f5e88d);


var $205d4e9b2dc98184$exports = {};
var $56c2a1a8b8d7d947$exports = {};
var $d0fa1d29a0bc834e$exports = {};

var $45f84e936c634dd6$exports = {};





/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $45f84e936c634dd6$var$baseSet(object, path, value, customizer) {
    if (!$cd2b0b1294af0960$exports(object)) return object;
    path = $5f248967e32df0c1$exports(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $4bf6972158fbafc8$exports(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $cd2b0b1294af0960$exports(objValue) ? objValue : $c60ce55ccfd38e2a$exports(path[index + 1]) ? [] : {};
        }
        $86f21484742bec95$exports(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
$45f84e936c634dd6$exports = $45f84e936c634dd6$var$baseSet;



/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $d0fa1d29a0bc834e$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $7bff94b74b05cdba$exports(object, path);
        if (predicate(value, path)) $45f84e936c634dd6$exports(result, $5f248967e32df0c1$exports(path, object), value);
    }
    return result;
}
$d0fa1d29a0bc834e$exports = $d0fa1d29a0bc834e$var$basePickBy;



/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $56c2a1a8b8d7d947$var$basePick(object, paths) {
    return $d0fa1d29a0bc834e$exports(object, paths, function(value, path) {
        return $029d15c9e3b4deab$exports(object, path);
    });
}
$56c2a1a8b8d7d947$exports = $56c2a1a8b8d7d947$var$basePick;


var $816417e5f04bd4e5$exports = {};
var $c287c7303a1fc294$exports = {};
var $f9578710aaa0eee6$exports = {};

var $e799fb37cc1f1ae8$exports = {};



/** Built-in value references. */ var $e799fb37cc1f1ae8$var$spreadableSymbol = $29a029238437d6de$exports ? $29a029238437d6de$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $e799fb37cc1f1ae8$var$isFlattenable(value) {
    return $b47d971f66a6f054$exports(value) || $343d561a7d6a3b42$exports(value) || !!($e799fb37cc1f1ae8$var$spreadableSymbol && value && value[$e799fb37cc1f1ae8$var$spreadableSymbol]);
}
$e799fb37cc1f1ae8$exports = $e799fb37cc1f1ae8$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $f9578710aaa0eee6$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $e799fb37cc1f1ae8$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $f9578710aaa0eee6$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $3bf95b782724c68c$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$f9578710aaa0eee6$exports = $f9578710aaa0eee6$var$baseFlatten;


/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $c287c7303a1fc294$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $f9578710aaa0eee6$exports(array, 1) : [];
}
$c287c7303a1fc294$exports = $c287c7303a1fc294$var$flatten;




/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $816417e5f04bd4e5$var$flatRest(func) {
    return $734501f4df78661a$exports($8f23d6c287483fb1$exports(func, undefined, $c287c7303a1fc294$exports), func + "");
}
$816417e5f04bd4e5$exports = $816417e5f04bd4e5$var$flatRest;


/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $205d4e9b2dc98184$var$pick = $816417e5f04bd4e5$exports(function(object, paths) {
    return object == null ? {} : $56c2a1a8b8d7d947$exports(object, paths);
});
$205d4e9b2dc98184$exports = $205d4e9b2dc98184$var$pick;




var $d1c8f644a77a8c56$exports = {};



var $17219b84c0d2d911$exports = {};

var $f6a4c7be86be9308$exports = {};


var $6087d26828b88f69$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $6087d26828b88f69$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$6087d26828b88f69$exports = $6087d26828b88f69$var$nativeKeysIn;


/** Used for built-in method references. */ var $f6a4c7be86be9308$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f6a4c7be86be9308$var$hasOwnProperty = $f6a4c7be86be9308$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $f6a4c7be86be9308$var$baseKeysIn(object) {
    if (!$cd2b0b1294af0960$exports(object)) return $6087d26828b88f69$exports(object);
    var isProto = $0d327a1cf9457c9f$exports(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$f6a4c7be86be9308$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$f6a4c7be86be9308$exports = $f6a4c7be86be9308$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $17219b84c0d2d911$var$keysIn(object) {
    return $edace719698f1e70$exports(object) ? $c8166565a24fe234$exports(object, true) : $f6a4c7be86be9308$exports(object);
}
$17219b84c0d2d911$exports = $17219b84c0d2d911$var$keysIn;


/** Used for built-in method references. */ var $d1c8f644a77a8c56$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d1c8f644a77a8c56$var$hasOwnProperty = $d1c8f644a77a8c56$var$objectProto.hasOwnProperty;
/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */ var $d1c8f644a77a8c56$var$defaults = $3432652d35d8dc24$exports(function(object, sources) {
    object = Object(object);
    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : undefined;
    if (guard && $f5d86346a533d383$exports(sources[0], sources[1], guard)) length = 1;
    while(++index < length){
        var source = sources[index];
        var props = $17219b84c0d2d911$exports(source);
        var propsIndex = -1;
        var propsLength = props.length;
        while(++propsIndex < propsLength){
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined || $ba1c04d40f072e77$exports(value, $d1c8f644a77a8c56$var$objectProto[key]) && !$d1c8f644a77a8c56$var$hasOwnProperty.call(object, key)) object[key] = source[key];
        }
    }
    return object;
});
$d1c8f644a77a8c56$exports = $d1c8f644a77a8c56$var$defaults;



var $8T3gX = parcelRequire("8T3gX");
// Private Functions
function $0a5de8228869aa1e$var$getCartesianRange(props, axis) {
    // determine how to lay the axis and what direction positive and negative are
    var vertical = axis !== "x";
    var padding = $0a5de8228869aa1e$export$d7501e6bee71bfee(props);
    if (vertical) return [
        props.height - padding.bottom,
        padding.top
    ];
    return [
        padding.left,
        props.width - padding.right
    ];
}
function $0a5de8228869aa1e$var$getPolarRange(props, axis) {
    if (axis === "x") {
        var startAngle = $0a5de8228869aa1e$export$c9fcf1a7df975d78(props.startAngle || 0);
        var endAngle = $0a5de8228869aa1e$export$c9fcf1a7df975d78(props.endAngle || 360);
        return [
            startAngle,
            endAngle
        ];
    }
    return [
        props.innerRadius || 0,
        $0a5de8228869aa1e$export$35724d9c2979edc5(props)
    ];
} // Exported Functions
function $0a5de8228869aa1e$export$30a06c8d3562193f(originalObject) {
    var ks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    // code based on babel's _objectWithoutProperties
    var newObject = {};
    for(var key in originalObject){
        // @ts-expect-error String is not assignable to Key
        if (ks.indexOf(key) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(originalObject, key)) continue;
        newObject[key] = originalObject[key];
    }
    return newObject;
}
function $0a5de8228869aa1e$export$92d53b972f97f55a(datum) {
    var exists = function(val) {
        return val !== undefined;
    };
    var _x = datum._x, _x1 = datum._x1, _x0 = datum._x0, _voronoiX = datum._voronoiX, _y = datum._y, _y1 = datum._y1, _y0 = datum._y0, _voronoiY = datum._voronoiY;
    var defaultX = exists(_x1) ? _x1 : _x;
    var defaultY = exists(_y1) ? _y1 : _y;
    var point = {
        x: exists(_voronoiX) ? _voronoiX : defaultX,
        x0: exists(_x0) ? _x0 : _x,
        y: exists(_voronoiY) ? _voronoiY : defaultY,
        y0: exists(_y0) ? _y0 : _y
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, point, datum);
}
function $0a5de8228869aa1e$export$2290ec7febe36dd6(props, datum) {
    var scale = props.scale, polar = props.polar, horizontal = props.horizontal;
    var d = $0a5de8228869aa1e$export$92d53b972f97f55a(datum);
    var origin = props.origin || {
        x: 0,
        y: 0
    };
    var x = horizontal ? scale.y(d.y) : scale.x(d.x);
    var x0 = horizontal ? scale.y(d.y0) : scale.x(d.x0);
    var y = horizontal ? scale.x(d.x) : scale.y(d.y);
    var y0 = horizontal ? scale.x(d.x0) : scale.y(d.y0);
    return {
        x: polar ? y * Math.cos(x) + origin.x : x,
        x0: polar ? y0 * Math.cos(x0) + origin.x : x0,
        y: polar ? -y * Math.sin(x) + origin.y : y,
        y0: polar ? -y0 * Math.sin(x0) + origin.x : y0
    };
}
function $0a5de8228869aa1e$export$d7501e6bee71bfee(props) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "padding";
    var padding = props[name];
    var paddingVal = typeof padding === "number" ? padding : 0;
    var paddingObj = typeof padding === "object" ? padding : {};
    return {
        top: paddingObj.top || paddingVal,
        bottom: paddingObj.bottom || paddingVal,
        left: paddingObj.left || paddingVal,
        right: paddingObj.right || paddingVal
    };
}
function $0a5de8228869aa1e$export$682a6f6bf6d26974(component) {
    var labelRole = component && component.type && component.type.role;
    return labelRole === "tooltip";
}
function $0a5de8228869aa1e$export$5de07126d06163d6(props, role) {
    var _props$theme = props.theme, theme = _props$theme === void 0 ? {} : _props$theme, labelComponent = props.labelComponent;
    var defaultStyles = theme[role] && theme[role].style || {};
    if (!$0a5de8228869aa1e$export$682a6f6bf6d26974(labelComponent)) return defaultStyles;
    var tooltipStyle = theme.tooltip && theme.tooltip.style || {};
    var labelStyle = (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, tooltipStyle, defaultStyles.labels);
    return (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, {
        labels: labelStyle
    }, defaultStyles);
}
function $0a5de8228869aa1e$export$ffd58b7f6f099a57(style, defaultStyles) {
    var width = "100%";
    var height = "100%";
    if (!style) return (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({
        parent: {
            height: height,
            width: width
        }
    }, defaultStyles);
    var data = style.data, labels = style.labels, parent = style.parent;
    var defaultParent = defaultStyles && defaultStyles.parent || {};
    var defaultLabels = defaultStyles && defaultStyles.labels || {};
    var defaultData = defaultStyles && defaultStyles.data || {};
    return {
        parent: (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, parent, defaultParent, {
            width: width,
            height: height
        }),
        labels: (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, labels, defaultLabels),
        data: (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, data, defaultData)
    };
}
function $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(prop, props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(prop) ? prop(props) : prop;
}
function $0a5de8228869aa1e$export$b94dbb3a3654958c(style, props) {
    if (props.disableInlineStyles) return {};
    if (!style || !(0, (/*@__PURE__*/$parcel$interopDefault($9c7d1fa85e24a67e$exports)))(style).some(function(value) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(style[value]);
    })) return style;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9c7d1fa85e24a67e$exports)))(style).reduce(function(prev, curr) {
        prev[curr] = $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(style[curr], props);
        return prev;
    }, {});
}
function $0a5de8228869aa1e$export$c9fcf1a7df975d78(degrees) {
    return typeof degrees === "number" ? degrees * (Math.PI / 180) : degrees;
}
function $0a5de8228869aa1e$export$c41dd2a8460d3196(radians) {
    return typeof radians === "number" ? radians / (Math.PI / 180) : radians;
}
function $0a5de8228869aa1e$export$35724d9c2979edc5(props) {
    var _getPadding = $0a5de8228869aa1e$export$d7501e6bee71bfee(props), left = _getPadding.left, right = _getPadding.right, top = _getPadding.top, bottom = _getPadding.bottom;
    var width = props.width, height = props.height;
    return Math.min(width - left - right, height - top - bottom) / 2;
}
function $0a5de8228869aa1e$export$557acdb671688361(props) {
    var width = props.width, height = props.height;
    var _getPadding2 = $0a5de8228869aa1e$export$d7501e6bee71bfee(props), top = _getPadding2.top, bottom = _getPadding2.bottom, left = _getPadding2.left, right = _getPadding2.right;
    var radius = Math.min(width - left - right, height - top - bottom) / 2;
    var offsetWidth = width / 2 + left - right;
    var offsetHeight = height / 2 + top - bottom;
    return {
        x: offsetWidth + radius > width ? radius + left - right : offsetWidth,
        y: offsetHeight + radius > height ? radius + top - bottom : offsetHeight
    };
}
function $0a5de8228869aa1e$export$fef151b94550e9f5(props, axis) {
    if (props.range && props.range[axis]) return props.range[axis];
    else if (props.range && Array.isArray(props.range)) return props.range;
    return props.polar ? $0a5de8228869aa1e$var$getPolarRange(props, axis) : $0a5de8228869aa1e$var$getCartesianRange(props, axis);
}
function $0a5de8228869aa1e$export$f5ddff6606408ce8(key) {
    // creates a data accessor function
    // given a property key, path, array index, or null for identity.
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(key)) return key;
    else if (key === null || key === undefined) // null/undefined means "return the data item itself"
    return function(x) {
        return x;
    };
     // otherwise, assume it is an array index, property key or path (_.property handles all three)
    return (0, (/*@__PURE__*/$parcel$interopDefault($bd112cd1a4525cec$exports)))(key);
}
function $0a5de8228869aa1e$export$9c2da7bc2aacbf9b(props, fallbackProps, role) {
    var theme = props.theme && props.theme[role] ? props.theme[role] : {};
    var themeProps = $0a5de8228869aa1e$export$30a06c8d3562193f(theme, [
        "style"
    ]);
    var horizontal = $0a5de8228869aa1e$export$2a62b49acb270576(props);
    var defaultObject = horizontal === undefined ? {} : {
        horizontal: horizontal
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))(defaultObject, props, themeProps, fallbackProps);
}
function $0a5de8228869aa1e$export$54b2c1a7f28c35a0(axis, horizontal) {
    var otherAxis = axis === "x" ? "y" : "x";
    return horizontal ? otherAxis : axis;
}
function $0a5de8228869aa1e$export$8d02402a54f5e88d(children, iteratee) {
    var parentProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var initialMemo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var combine = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function(memo, item) {
        return memo.concat(item);
    };
    var sharedProps = [
        "data",
        "domain",
        "categories",
        "polar",
        "startAngle",
        "endAngle",
        "minDomain",
        "maxDomain",
        "horizontal"
    ];
    var traverseChildren = function(childArray, names, parent) {
        return childArray.reduce(function(memo, child, index) {
            var childRole = child.type && child.type.role;
            var childName = child.props.name || "".concat(childRole, "-").concat(names[index]);
            if (child.props && child.props.children) {
                var childProps = (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, child.props, (0, (/*@__PURE__*/$parcel$interopDefault($205d4e9b2dc98184$exports)))(parentProps, sharedProps));
                var nestedChildren = child.type && child.type.role === "stack" && (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(child.type.getChildren) ? child.type.getChildren(childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(child.props.children).map(function(c) {
                    var nestedChildProps = (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, c.props, (0, (/*@__PURE__*/$parcel$interopDefault($205d4e9b2dc98184$exports)))(childProps, sharedProps));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(c, nestedChildProps);
                });
                var _childNames = nestedChildren.map(function(c, i) {
                    return "".concat(childName, "-").concat(i);
                });
                var nestedResults = traverseChildren(nestedChildren, _childNames, child);
                memo = combine(memo, nestedResults);
            } else {
                var result = iteratee(child, childName, parent);
                if (result) memo = combine(memo, result);
            }
            return memo;
        }, initialMemo);
    };
    var childNames = children.map(function(c, i) {
        return i;
    });
    return traverseChildren(children, childNames);
}
function $0a5de8228869aa1e$export$2a62b49acb270576(props) {
    if (props.horizontal !== undefined || !props.children) return props.horizontal;
    var traverseChildren = function(childArray) {
        return childArray.reduce(function(memo, child) {
            var childProps = child.props || {};
            if (memo || childProps.horizontal || !childProps.children) {
                memo = memo || childProps.horizontal;
                return memo;
            }
            return traverseChildren((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(childProps.children));
        }, false);
    };
    return traverseChildren((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(props.children));
}


var $9373b80aaace1e85$exports = {};

$parcel$export($9373b80aaace1e85$exports, "containsStrings", () => $9373b80aaace1e85$export$37b75fcede59d7ed);
$parcel$export($9373b80aaace1e85$exports, "containsDates", () => $9373b80aaace1e85$export$b492f6d933283c58);
$parcel$export($9373b80aaace1e85$exports, "containsNumbers", () => $9373b80aaace1e85$export$b7c0cf22947c26da);
$parcel$export($9373b80aaace1e85$exports, "containsOnlyStrings", () => $9373b80aaace1e85$export$8d027a851e7abfc8);
$parcel$export($9373b80aaace1e85$exports, "isArrayOfArrays", () => $9373b80aaace1e85$export$e3f2d7f0b529e664);
$parcel$export($9373b80aaace1e85$exports, "removeUndefined", () => $9373b80aaace1e85$export$c499305a875a8ee9);
$parcel$export($9373b80aaace1e85$exports, "getMaxValue", () => $9373b80aaace1e85$export$a8f783d9de5392f5);
$parcel$export($9373b80aaace1e85$exports, "getMinValue", () => $9373b80aaace1e85$export$df8687355ccb4d94);
function $9373b80aaace1e85$var$_toConsumableArray(arr) {
    return $9373b80aaace1e85$var$_arrayWithoutHoles(arr) || $9373b80aaace1e85$var$_iterableToArray(arr) || $9373b80aaace1e85$var$_unsupportedIterableToArray(arr) || $9373b80aaace1e85$var$_nonIterableSpread();
}
function $9373b80aaace1e85$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9373b80aaace1e85$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9373b80aaace1e85$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9373b80aaace1e85$var$_arrayLikeToArray(o, minLen);
}
function $9373b80aaace1e85$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $9373b80aaace1e85$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $9373b80aaace1e85$var$_arrayLikeToArray(arr);
}
function $9373b80aaace1e85$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9373b80aaace1e85$var$isNonEmptyArray(collection) {
    return Array.isArray(collection) && collection.length > 0;
}
function $9373b80aaace1e85$export$37b75fcede59d7ed(collection) {
    return Array.isArray(collection) && collection.some(function(value) {
        return typeof value === "string";
    });
}
function $9373b80aaace1e85$export$b492f6d933283c58(collection) {
    return Array.isArray(collection) && collection.some(function(value) {
        return value instanceof Date;
    });
}
function $9373b80aaace1e85$export$b7c0cf22947c26da(collection) {
    return Array.isArray(collection) && collection.some(function(value) {
        return typeof value === "number";
    });
}
function $9373b80aaace1e85$export$8d027a851e7abfc8(collection) {
    return $9373b80aaace1e85$var$isNonEmptyArray(collection) && collection.every(function(value) {
        return typeof value === "string";
    });
}
function $9373b80aaace1e85$export$e3f2d7f0b529e664(collection) {
    return $9373b80aaace1e85$var$isNonEmptyArray(collection) && collection.every(Array.isArray);
}
function $9373b80aaace1e85$export$c499305a875a8ee9(arr) {
    return arr.filter(function(el) {
        return el !== undefined;
    });
}
function $9373b80aaace1e85$export$a8f783d9de5392f5(arr) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    var array = arr.concat(values);
    return $9373b80aaace1e85$export$b492f6d933283c58(array) ? new Date(Math.max.apply(Math, $9373b80aaace1e85$var$_toConsumableArray(array))) // Dates will be coerced to numbers
     : Math.max.apply(Math, $9373b80aaace1e85$var$_toConsumableArray(array));
}
function $9373b80aaace1e85$export$df8687355ccb4d94(arr) {
    for(var _len2 = arguments.length, values = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)values[_key2 - 1] = arguments[_key2];
    var array = arr.concat(values);
    return $9373b80aaace1e85$export$b492f6d933283c58(array) ? new Date(Math.min.apply(Math, $9373b80aaace1e85$var$_toConsumableArray(array))) // Dates will be coerced to numbers
     : Math.min.apply(Math, $9373b80aaace1e85$var$_toConsumableArray(array));
}


var $56a5f1c61b5282e1$exports = {};
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$56a5f1c61b5282e1$exports = (parcelRequire("hK0qV"));


var $bf1178a7a28a9ee4$var$supportedScaleStrings = [
    "linear",
    "time",
    "log",
    "sqrt"
];
// Private Functions
function $bf1178a7a28a9ee4$var$toNewName(scale) {
    // d3 scale changed the naming scheme for scale from "linear" -> "scaleLinear" etc.
    var capitalize = function(s) {
        return s && s[0].toUpperCase() + s.slice(1);
    };
    return "scale".concat(capitalize(scale));
}
function $bf1178a7a28a9ee4$export$e88dde4d94c18054(scale) {
    if (typeof scale === "function") return (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(scale.copy) && (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(scale.domain) && (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(scale.range);
    else if (typeof scale === "string") return (0, (/*@__PURE__*/$parcel$interopDefault($8ba9a2795a3c2065$exports)))($bf1178a7a28a9ee4$var$supportedScaleStrings, scale);
    return false;
}
function $bf1178a7a28a9ee4$var$isScaleDefined(props, axis) {
    if (!props.scale) return false;
    else if (props.scale.x || props.scale.y) return !!props.scale[axis];
    return true;
}
function $bf1178a7a28a9ee4$var$getScaleTypeFromProps(props, axis) {
    if (!$bf1178a7a28a9ee4$var$isScaleDefined(props, axis)) return undefined;
    var scale = props.scale[axis] || props.scale;
    return typeof scale === "string" ? scale : $bf1178a7a28a9ee4$export$e2b5c5db9e2009fd(scale);
}
function $bf1178a7a28a9ee4$var$getScaleFromDomain(props, axis) {
    var domain;
    if (props.domain && props.domain[axis]) domain = props.domain[axis];
    else if (props.domain && Array.isArray(props.domain)) domain = props.domain;
    if (!domain) return undefined;
    return $9373b80aaace1e85$export$b492f6d933283c58(domain) ? "time" : "linear";
}
function $bf1178a7a28a9ee4$var$getScaleTypeFromData(props, axis) {
    if (!props.data) return "linear";
    var accessor = $0a5de8228869aa1e$export$f5ddff6606408ce8(props[axis]);
    var axisData = props.data.map(function(datum) {
        var processedData = (0, (/*@__PURE__*/$parcel$interopDefault($2537df67cd52c170$exports)))(accessor(datum)) ? accessor(datum)[axis] : accessor(datum);
        return processedData !== undefined ? processedData : datum[axis];
    });
    return $9373b80aaace1e85$export$b492f6d933283c58(axisData) ? "time" : "linear";
} // Exported Functions
function $bf1178a7a28a9ee4$export$f8a8079677dfe10e(name) {
    if ($bf1178a7a28a9ee4$export$e88dde4d94c18054(name)) {
        var methodName = $bf1178a7a28a9ee4$var$toNewName(name); // @ts-expect-error scaleTime is not directly compatible with our D3Scale definition
        return $56a5f1c61b5282e1$exports[methodName]();
    }
    return $56a5f1c61b5282e1$exports.scaleLinear();
}
function $bf1178a7a28a9ee4$export$cc504192b2543d0c(props, axis) {
    var scale = $bf1178a7a28a9ee4$export$e32c9cfc9124038e(props, axis);
    if (scale) return typeof scale === "string" ? $bf1178a7a28a9ee4$export$f8a8079677dfe10e(scale) : scale;
    var defaultScale = $bf1178a7a28a9ee4$var$getScaleFromDomain(props, axis) || $bf1178a7a28a9ee4$var$getScaleTypeFromData(props, axis);
    return $bf1178a7a28a9ee4$export$f8a8079677dfe10e(defaultScale);
}
function $bf1178a7a28a9ee4$export$88309260a893db31() {
    return $56a5f1c61b5282e1$exports.scaleLinear();
}
function $bf1178a7a28a9ee4$export$e32c9cfc9124038e(props, axis) {
    if (!$bf1178a7a28a9ee4$var$isScaleDefined(props, axis)) return undefined;
    var scale = props.scale[axis] || props.scale;
    if ($bf1178a7a28a9ee4$export$e88dde4d94c18054(scale)) return (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(scale) ? scale : $bf1178a7a28a9ee4$export$f8a8079677dfe10e(scale);
    return undefined;
}
function $bf1178a7a28a9ee4$export$ff60de4f71778a2c(props, axis) {
    // if the scale was not given in props, it will be set to linear or time depending on data
    return $bf1178a7a28a9ee4$var$getScaleTypeFromProps(props, axis) || $bf1178a7a28a9ee4$var$getScaleTypeFromData(props, axis);
} // Ordered type inference off of function fields.
// **Note**: Brittle because reliant on d3 internals.
var $bf1178a7a28a9ee4$var$DUCK_TYPES = [
    {
        name: "quantile",
        method: "quantiles"
    },
    {
        name: "log",
        method: "base"
    } // TODO(2214): Re-evaluate (1) duck typing approach, and (2) if duck typing,
];
function $bf1178a7a28a9ee4$export$e2b5c5db9e2009fd(scale) {
    if (typeof scale === "string") return scale;
    var scaleType = $bf1178a7a28a9ee4$var$DUCK_TYPES.filter(function(type) {
        return scale[type.method] !== undefined;
    })[0];
    return scaleType ? scaleType.name : undefined;
}


function $9dba2b2bbfc485d5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * Return a new validator based on `validator` but with the option to chain
 * `isRequired` onto the validation. This is nearly identical to how React
 * does it internally, but they don't expose their helper for us to use.
 * @param {Function} validator Validation function.
 * @returns {Function} Validator with `isRequired` option.
 */ var $9dba2b2bbfc485d5$var$makeChainable = function(validator) {
    var createChainable = function(isRequired) {
        return function(props, propName, componentName) {
            var value = props[propName];
            if (value === undefined || value === null) {
                if (isRequired) return new Error("Required `".concat(propName, "` was not specified in `").concat(componentName, "`."));
                return null;
            }
            for(var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)rest[_key - 3] = arguments[_key];
            return validator.apply(void 0, [
                props,
                propName,
                componentName
            ].concat(rest));
        };
    };
    var chainable = Object.assign(createChainable(false), {
        isRequired: createChainable(true)
    });
    return chainable;
};
var $9dba2b2bbfc485d5$var$nullConstructor = function() {
    return null;
};
var $9dba2b2bbfc485d5$var$undefinedConstructor = function() {
    return undefined;
};
/**
 * Get the constructor of `value`. If `value` is null or undefined, return the
 * special singletons `nullConstructor` or `undefinedConstructor`, respectively.
 * @param {*} value Instance to return the constructor of.
 * @returns {Function} Constructor of `value`.
 */ var $9dba2b2bbfc485d5$var$getConstructor = function(value) {
    if (value === undefined) return $9dba2b2bbfc485d5$var$undefinedConstructor;
    else if (value === null) return $9dba2b2bbfc485d5$var$nullConstructor;
    return value.constructor;
};
/**
 * Get the name of the constructor used to create `value`, using
 * `Object.prototype.toString`. If the value is null or undefined, return
 * "null" or "undefined", respectively.
 * @param {*} value Instance to return the constructor name of.
 * @returns {String} Name of the constructor.
 */ var $9dba2b2bbfc485d5$var$getConstructorName = function(value) {
    if (value === undefined) return "undefined";
    else if (value === null) return "null";
    return Object.prototype.toString.call(value).slice(8, -1); // eslint-disable-line no-magic-numbers
};
function $9dba2b2bbfc485d5$export$cdd73fc4100a6ef4(propType, explanation) {
    return function(props, propName, componentName) {
        var value = props[propName];
        if (value !== null && value !== undefined) $8590ed3b940180fa$export$c106dd0671a0fc2d('"'.concat(propName, '" property of "').concat(componentName, '" has been deprecated ').concat(explanation));
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).checkPropTypes($9dba2b2bbfc485d5$var$_defineProperty({}, propName, propType), props, propName, componentName);
        return null;
    };
}
function $9dba2b2bbfc485d5$export$ba7c675f29992b42(validators) {
    return $9dba2b2bbfc485d5$var$makeChainable(function(props, propName, componentName) {
        for(var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++)rest[_key2 - 3] = arguments[_key2];
        return validators.reduce(function(result, validator) {
            return result || validator.apply(void 0, [
                props,
                propName,
                componentName
            ].concat(rest));
        }, null);
    });
}
var $9dba2b2bbfc485d5$export$1832c645056d4ce2 = $9dba2b2bbfc485d5$var$makeChainable(function(props, propName, componentName) {
    var value = props[propName];
    if (typeof value !== "number" || value < 0) return new Error("`".concat(propName, "` in `").concat(componentName, "` must be a non-negative number."));
    return null;
});
var $9dba2b2bbfc485d5$export$32744b5b3bba4764 = $9dba2b2bbfc485d5$var$makeChainable(function(props, propName, componentName) {
    var value = props[propName];
    if (typeof value !== "number" || value % 1 !== 0) return new Error("`".concat(propName, "` in `").concat(componentName, "` must be an integer."));
    return null;
});
var $9dba2b2bbfc485d5$export$e83db190a13b5ae1 = $9dba2b2bbfc485d5$var$makeChainable(function(props, propName, componentName) {
    var value = props[propName];
    if (typeof value !== "number" || value <= 0) return new Error("`".concat(propName, "` in `").concat(componentName, "` must be a number greater than zero."));
    return null;
});
var $9dba2b2bbfc485d5$export$21779e503be4cd98 = $9dba2b2bbfc485d5$var$makeChainable(function(props, propName, componentName) {
    var value = props[propName];
    if (!Array.isArray(value) || value.length !== 2 || value[1] === value[0]) return new Error("`".concat(propName, "` in `").concat(componentName, "` must be an array of two unique numeric values."));
    return null;
});
var $9dba2b2bbfc485d5$export$dcdf75081b88279d = $9dba2b2bbfc485d5$var$makeChainable(function(props, propName, componentName) {
    var value = props[propName];
    if (!$bf1178a7a28a9ee4$export$e88dde4d94c18054(value)) return new Error("`".concat(propName, "` in `").concat(componentName, "` must be a d3 scale."));
    return null;
});
var $9dba2b2bbfc485d5$export$bf99cf46c730dbb3 = $9dba2b2bbfc485d5$var$makeChainable(function(props, propName, componentName) {
    var values = props[propName];
    if (!Array.isArray(values)) return new Error("`".concat(propName, "` in `").concat(componentName, "` must be an array."));
    if (values.length < 2) return null;
    var comparisonConstructor = $9dba2b2bbfc485d5$var$getConstructor(values[0]);
    var typeMismatchedValue = (0, (/*@__PURE__*/$parcel$interopDefault($9f60e838fdb2edf2$exports)))(values, function(value) {
        return comparisonConstructor !== $9dba2b2bbfc485d5$var$getConstructor(value);
    });
    if (typeMismatchedValue) {
        var constructorName = $9dba2b2bbfc485d5$var$getConstructorName(values[0]);
        var otherConstructorName = $9dba2b2bbfc485d5$var$getConstructorName(typeMismatchedValue);
        return new Error("Expected `".concat(propName, "` in `").concat(componentName, "` to be a ") + "homogeneous array, but found types `".concat(constructorName, "` and ") + "`".concat(otherConstructorName, "`."));
    }
    return null;
});
var $9dba2b2bbfc485d5$export$d53326403afe7b9c = $9dba2b2bbfc485d5$var$makeChainable(function(props, propName) {
    if (props[propName] && Array.isArray(props[propName]) && props[propName].length !== props.data.length) return new Error("Length of data and ".concat(propName, " arrays must match."));
    return null;
});
var $9dba2b2bbfc485d5$export$8f50e1bab370eb17 = $9dba2b2bbfc485d5$var$makeChainable(function(props, propName, componentName) {
    if (props[propName] && !(0, (/*@__PURE__*/$parcel$interopDefault($d5024b7f03082f06$exports)))(props[propName])) return new Error("`".concat(propName, "` in `").concat(componentName, "` must be a regular expression."));
    return null;
});


var $70dbe1f62d5c55ed$var$dataProps = {
    // @ts-expect-error TODO: synchronize the type with this PropTypes
    categories: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            x: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string),
            y: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string)
        })
    ]),
    // @ts-expect-error TODO: synchronize the type with this PropTypes
    data: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    dataComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    disableInlineStyles: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    labelComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    labels: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array
    ]),
    samples: $9dba2b2bbfc485d5$export$1832c645056d4ce2,
    sortKey: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        $9dba2b2bbfc485d5$export$ba7c675f29992b42([
            $9dba2b2bbfc485d5$export$32744b5b3bba4764,
            $9dba2b2bbfc485d5$export$1832c645056d4ce2
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string.isRequired)
    ]),
    sortOrder: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        "ascending",
        "descending"
    ]),
    style: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        parent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        data: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        labels: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    }),
    x: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        $9dba2b2bbfc485d5$export$ba7c675f29992b42([
            $9dba2b2bbfc485d5$export$32744b5b3bba4764,
            $9dba2b2bbfc485d5$export$1832c645056d4ce2
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string.isRequired)
    ]),
    y: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        $9dba2b2bbfc485d5$export$ba7c675f29992b42([
            $9dba2b2bbfc485d5$export$32744b5b3bba4764,
            $9dba2b2bbfc485d5$export$1832c645056d4ce2
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string.isRequired)
    ]),
    y0: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        $9dba2b2bbfc485d5$export$ba7c675f29992b42([
            $9dba2b2bbfc485d5$export$32744b5b3bba4764,
            $9dba2b2bbfc485d5$export$1832c645056d4ce2
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string.isRequired)
    ])
};
var $70dbe1f62d5c55ed$var$baseProps = {
    animate: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    containerComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    domain: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        $9dba2b2bbfc485d5$export$21779e503be4cd98,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            x: $9dba2b2bbfc485d5$export$21779e503be4cd98,
            y: $9dba2b2bbfc485d5$export$21779e503be4cd98
        })
    ]),
    // @ts-expect-error TODO: synchronize the type with this PropTypes
    maxDomain: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).instanceOf(Date),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            x: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).instanceOf(Date)
            ]),
            y: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).instanceOf(Date)
            ])
        })
    ]),
    // @ts-expect-error TODO: synchronize the type with this PropTypes
    minDomain: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).instanceOf(Date),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            x: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).instanceOf(Date)
            ]),
            y: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).instanceOf(Date)
            ])
        })
    ]),
    // @ts-expect-error TODO: synchronize the type with this PropTypes
    domainPadding: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            x: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number)
            ]),
            y: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number)
            ])
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number)
    ]),
    eventKey: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        $9dba2b2bbfc485d5$export$ba7c675f29992b42([
            $9dba2b2bbfc485d5$export$32744b5b3bba4764,
            $9dba2b2bbfc485d5$export$1832c645056d4ce2
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    events: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        target: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            "data",
            "labels",
            "parent"
        ]),
        eventKey: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array,
            $9dba2b2bbfc485d5$export$ba7c675f29992b42([
                $9dba2b2bbfc485d5$export$32744b5b3bba4764,
                $9dba2b2bbfc485d5$export$1832c645056d4ce2
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
        ]),
        eventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    })),
    // @ts-expect-error TODO: synchronize the type with this PropTypes
    externalEventMutations: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        callback: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        childName: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array
        ]),
        eventKey: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array,
            $9dba2b2bbfc485d5$export$ba7c675f29992b42([
                $9dba2b2bbfc485d5$export$32744b5b3bba4764,
                $9dba2b2bbfc485d5$export$1832c645056d4ce2
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
        ]),
        mutation: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        target: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array
        ])
    })),
    groupComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    height: $9dba2b2bbfc485d5$export$1832c645056d4ce2,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    // @ts-expect-error TODO: synchronize the type with this PropTypes
    origin: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        x: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        y: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number
    }),
    // @ts-expect-error TODO: synchronize the type with this PropTypes
    padding: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            top: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
            bottom: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
            left: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
            right: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number
        })
    ]),
    polar: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    range: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        $9dba2b2bbfc485d5$export$21779e503be4cd98,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            x: $9dba2b2bbfc485d5$export$21779e503be4cd98.isRequired,
            y: $9dba2b2bbfc485d5$export$21779e503be4cd98.isRequired
        })
    ]),
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        $9dba2b2bbfc485d5$export$dcdf75081b88279d,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            x: $9dba2b2bbfc485d5$export$dcdf75081b88279d.isRequired,
            y: $9dba2b2bbfc485d5$export$dcdf75081b88279d.isRequired
        })
    ]),
    // @ts-expect-error TODO: synchronize the type with this PropTypes
    sharedEvents: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        events: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array,
        getEventState: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    }),
    // @ts-expect-error TODO: synchronize the type with this PropTypes
    singleQuadrantDomainPadding: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            x: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
            ]),
            y: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
            ])
        })
    ]),
    standalone: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    theme: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    width: $9dba2b2bbfc485d5$export$1832c645056d4ce2
};
var $70dbe1f62d5c55ed$var$primitiveProps = {
    active: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    ariaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    clipPath: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    data: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    desc: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]),
    disableInlineStyles: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    events: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]),
    index: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    // @ts-expect-error TODO: synchronize the type with this PropTypes
    origin: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        x: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        y: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number
    }),
    polar: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    role: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        $9dba2b2bbfc485d5$export$dcdf75081b88279d,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            x: $9dba2b2bbfc485d5$export$dcdf75081b88279d,
            y: $9dba2b2bbfc485d5$export$dcdf75081b88279d
        })
    ]),
    shapeRendering: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    tabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]),
    transform: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
};
var $70dbe1f62d5c55ed$export$fe6a43517f1f6b90 = {
    dataProps: $70dbe1f62d5c55ed$var$dataProps,
    baseProps: $70dbe1f62d5c55ed$var$baseProps,
    primitiveProps: $70dbe1f62d5c55ed$var$primitiveProps
};


var $8T3gX = parcelRequire("8T3gX");
var $32ee7a22ce6f8360$var$_excluded = [
    "desc"
];
function $32ee7a22ce6f8360$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $32ee7a22ce6f8360$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $32ee7a22ce6f8360$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $32ee7a22ce6f8360$export$4b2950bdac9b6ee9 = function(props) {
    // eslint-disable-next-line react/prop-types
    var desc = props.desc, rest = $32ee7a22ce6f8360$var$_objectWithoutProperties(props, $32ee7a22ce6f8360$var$_excluded);
    return desc ? /*#__PURE__*/ // @ts-expect-error FIXME: "id cannot be a number"
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("path", rest, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("desc", null, desc)) : /*#__PURE__*/ // @ts-expect-error FIXME: "id cannot be a number"
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("path", rest);
};



var $39cd5f6f9b941b5d$exports = {};
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $39cd5f6f9b941b5d$var$isNil(value) {
    return value == null;
}
$39cd5f6f9b941b5d$exports = $39cd5f6f9b941b5d$var$isNil;




var $fc1e72cc50e4be34$export$55382f732810ce34 = function(barWidth, props) {
    var scale = props.scale, data = props.data, defaultBarWidth = props.defaultBarWidth, style = props.style;
    if (barWidth) return (0, $0a5de8228869aa1e$exports).evaluateProp(barWidth, props);
    else if (style.width) return style.width;
    var range = scale.x.range();
    var extent = Math.abs(range[1] - range[0]);
    var bars = data.length + 2;
    var barRatio = props.barRatio || 0.5;
    var defaultWidth = barRatio * (data.length < 2 ? defaultBarWidth : extent / bars);
    return Math.max(1, defaultWidth);
};
var $fc1e72cc50e4be34$var$getCornerRadiusFromObject = function(cornerRadius, props) {
    var realCornerRadius = {
        topLeft: 0,
        topRight: 0,
        bottomLeft: 0,
        bottomRight: 0
    };
    var updateCornerRadius = function(corner, fallback) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(cornerRadius[corner])) realCornerRadius[corner] = (0, $0a5de8228869aa1e$exports).evaluateProp(cornerRadius[corner], props);
        else if (!(0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(cornerRadius[fallback])) realCornerRadius[corner] = (0, $0a5de8228869aa1e$exports).evaluateProp(cornerRadius[fallback], props);
    };
    updateCornerRadius("topLeft", "top");
    updateCornerRadius("topRight", "top");
    updateCornerRadius("bottomLeft", "bottom");
    updateCornerRadius("bottomRight", "bottom");
    return realCornerRadius;
};
var $fc1e72cc50e4be34$export$635516faf7b51af4 = function(cornerRadius, props) {
    var realCornerRadius = {
        topLeft: 0,
        topRight: 0,
        bottomLeft: 0,
        bottomRight: 0
    };
    if (!cornerRadius) return realCornerRadius;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($2537df67cd52c170$exports)))(cornerRadius)) return $fc1e72cc50e4be34$var$getCornerRadiusFromObject(cornerRadius, props);
    realCornerRadius.topLeft = (0, $0a5de8228869aa1e$exports).evaluateProp(cornerRadius, props);
    realCornerRadius.topRight = (0, $0a5de8228869aa1e$exports).evaluateProp(cornerRadius, props);
    return realCornerRadius;
};
var $fc1e72cc50e4be34$export$3d2f074408bd1b82 = function() {
    var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var props = arguments.length > 1 ? arguments[1] : undefined;
    if (props.disableInlineStyles) return {};
    var stroke = style.fill || "black";
    var baseStyle = {
        fill: "black",
        stroke: stroke
    };
    return (0, $0a5de8228869aa1e$exports).evaluateStyle((0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))(baseStyle, style), props);
};


var $40ccc67e29ee0e40$exports = {};
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$40ccc67e29ee0e40$exports = (parcelRequire("3kTGk"));


/**
 * A point in the 2d plane
 * @param {number} x - x coordinate
 * @param {number} y - y coordinate
 * @returns {object} - point object
 */ var $159a38dfd7370cf9$export$105684a3041cb6f3 = function(x, y) {
    return {
        x: x,
        y: y,
        distance: function(p1) {
            return Math.sqrt(Math.pow(this.x - p1.x, 2) + Math.pow(this.y - p1.y, 2));
        },
        // vector addition in 2d plane
        add: function(p1) {
            return $159a38dfd7370cf9$export$105684a3041cb6f3(this.x + p1.x, this.y + p1.y);
        },
        // vector subtraction in 2d
        // returns p0 - p1
        subtract: function(p1) {
            return $159a38dfd7370cf9$export$105684a3041cb6f3(this.x - p1.x, this.y - p1.y);
        },
        // multiply a 2d point by a scalar
        scalarMult: function(n) {
            return $159a38dfd7370cf9$export$105684a3041cb6f3(this.x * n, this.y * n);
        },
        scalarDivide: function(n) {
            if (n === 0) throw new Error("Division by 0 error");
            return $159a38dfd7370cf9$export$105684a3041cb6f3(this.x / n, this.y / n);
        },
        equals: function(p1) {
            return this.x === p1.x && this.y === p1.y;
        }
    };
};
/**
 * A circle in the 2d plane
 * @param {point} center - center of circle
 * @param {number} radius - radius of circle
 * @returns {object} - point object
 */ var $159a38dfd7370cf9$export$e1d786d2f707b414 = function(center, radius) {
    return {
        center: center,
        radius: radius,
        hasIntersection: function(circle1) {
            var P0 = this.center;
            var P1 = circle1.center;
            var r0 = this.radius;
            var r1 = circle1.radius;
            var d = P0.distance(P1);
            if (d > r0 + r1) return false; // separate circles
            if (d < Math.abs(r0 - r1)) return false; // one circle contains another
            return true;
        },
        equals: function(circle1) {
            var P0 = this.center;
            var P1 = circle1.center;
            var r0 = this.radius;
            var r1 = circle1.radius;
            return r0 === r1 && P0.equals(P1);
        },
        // Source: http://paulbourke.net/geometry/circlesphere/
        // "Intersection of two circles" by Paul Bourke
        // Left-most point is returned as 0th element of array
        // Right-most point is returned as 1st elemennt of array
        intersection: function(circle1) {
            // eslint-disable-line max-statements
            var P0 = this.center;
            var P1 = circle1.center;
            var r0 = this.radius;
            var r1 = circle1.radius;
            var d = P0.distance(P1);
            if (!this.hasIntersection(circle1) || this.equals(circle1)) return [];
            var a = (Math.pow(r0, 2) - Math.pow(r1, 2) + Math.pow(d, 2)) / (2 * d);
            var h = Math.sqrt(Math.pow(r0, 2) - Math.pow(a, 2));
            var P2 = P0.add(P1.subtract(P0).scalarMult(a).scalarDivide(d));
            var x0 = P0.x, y0 = P0.y;
            var x1 = P1.x, y1 = P1.y;
            var x2 = P2.x, y2 = P2.y;
            var P3s = [
                $159a38dfd7370cf9$export$105684a3041cb6f3(x2 - h * (y1 - y0) / d, y2 + h * (x1 - x0) / d),
                $159a38dfd7370cf9$export$105684a3041cb6f3(x2 + h * (y1 - y0) / d, y2 - h * (x1 - x0) / d)
            ];
            P3s.sort(function(Point1, Point2) {
                return Point1.x - Point2.x;
            });
            return P3s;
        },
        solveX: function(y) {
            var sqrt = Math.sqrt(Math.pow(this.radius, 2) - Math.pow(y - this.center.y, 2));
            return [
                this.center.x - sqrt,
                this.center.x + sqrt
            ];
        },
        solveY: function(x) {
            var sqrt = Math.sqrt(Math.pow(this.radius, 2) - Math.pow(x - this.center.x, 2));
            return [
                this.center.y - sqrt,
                this.center.y + sqrt
            ];
        }
    };
};


function $6ba27aed5eba44ca$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6ba27aed5eba44ca$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6ba27aed5eba44ca$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6ba27aed5eba44ca$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6ba27aed5eba44ca$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6ba27aed5eba44ca$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6ba27aed5eba44ca$var$_toConsumableArray(arr) {
    return $6ba27aed5eba44ca$var$_arrayWithoutHoles(arr) || $6ba27aed5eba44ca$var$_iterableToArray(arr) || $6ba27aed5eba44ca$var$_unsupportedIterableToArray(arr) || $6ba27aed5eba44ca$var$_nonIterableSpread();
}
function $6ba27aed5eba44ca$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6ba27aed5eba44ca$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6ba27aed5eba44ca$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6ba27aed5eba44ca$var$_arrayLikeToArray(o, minLen);
}
function $6ba27aed5eba44ca$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $6ba27aed5eba44ca$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $6ba27aed5eba44ca$var$_arrayLikeToArray(arr);
}
function $6ba27aed5eba44ca$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $6ba27aed5eba44ca$var$getPosition = function(props, width) {
    var x = props.x, x0 = props.x0, y = props.y, y0 = props.y0, horizontal = props.horizontal;
    var alignment = props.alignment || "middle";
    var size = alignment === "middle" ? width / 2 : width;
    var sign = horizontal ? -1 : 1;
    if (horizontal) return {
        x0: x0,
        x1: x,
        y0: alignment === "start" ? y : y - sign * size,
        y1: alignment === "end" ? y : y + sign * size
    };
    return {
        x0: alignment === "start" ? x : x - sign * size,
        x1: alignment === "end" ? x : x + sign * size,
        y0: y0,
        y1: y
    };
};
var $6ba27aed5eba44ca$var$getAngle = function(props, index) {
    var data = props.data, scale = props.scale;
    var x = data[index]._x1 === undefined ? "_x" : "_x1";
    return scale.x(data[index][x]);
};
var $6ba27aed5eba44ca$var$getAngularWidth = function(props, width) {
    var scale = props.scale;
    var range = scale.y.range();
    var r = Math.max.apply(Math, $6ba27aed5eba44ca$var$_toConsumableArray(range));
    var angularRange = Math.abs(scale.x.range()[1] - scale.x.range()[0]);
    return width / (2 * Math.PI * r) * angularRange;
};
var $6ba27aed5eba44ca$var$transformAngle = function(angle) {
    return -1 * angle + Math.PI / 2;
};
var $6ba27aed5eba44ca$export$9826e8dcdc3e9b21 = function(props, width) {
    var getPath = props.getPath;
    var propsWithCalculatedValues = $6ba27aed5eba44ca$var$_objectSpread($6ba27aed5eba44ca$var$_objectSpread({}, props), $6ba27aed5eba44ca$var$getPosition(props, width));
    return getPath(propsWithCalculatedValues);
};
var $6ba27aed5eba44ca$var$getStartAngle = function(props, index) {
    var data = props.data, scale = props.scale, alignment = props.alignment;
    var currentAngle = $6ba27aed5eba44ca$var$getAngle(props, index);
    var angularRange = Math.abs(scale.x.range()[1] - scale.x.range()[0]);
    var previousAngle = index === 0 ? $6ba27aed5eba44ca$var$getAngle(props, data.length - 1) - Math.PI * 2 : $6ba27aed5eba44ca$var$getAngle(props, index - 1);
    if (index === 0 && angularRange < 2 * Math.PI) return scale.x.range()[0];
    else if (alignment === "start" || alignment === "end") return alignment === "start" ? previousAngle : currentAngle;
    return (currentAngle + previousAngle) / 2;
};
var $6ba27aed5eba44ca$var$getEndAngle = function(props, index) {
    var data = props.data, scale = props.scale, alignment = props.alignment;
    var currentAngle = $6ba27aed5eba44ca$var$getAngle(props, index);
    var angularRange = Math.abs(scale.x.range()[1] - scale.x.range()[0]);
    var lastAngle = scale.x.range()[1] === 2 * Math.PI ? $6ba27aed5eba44ca$var$getAngle(props, 0) + Math.PI * 2 : scale.x.range()[1];
    var nextAngle = index === data.length - 1 ? $6ba27aed5eba44ca$var$getAngle(props, 0) + Math.PI * 2 : $6ba27aed5eba44ca$var$getAngle(props, index + 1);
    if (index === data.length - 1 && angularRange < 2 * Math.PI) return lastAngle;
    else if (alignment === "start" || alignment === "end") return alignment === "start" ? currentAngle : nextAngle;
    return (currentAngle + nextAngle) / 2;
};
var $6ba27aed5eba44ca$var$mapPointsToPath = function(coords, cornerRadius, direction) {
    var topLeftPath = "".concat(cornerRadius.topLeft, " ").concat(cornerRadius.topLeft, " ").concat(direction);
    var topRightPath = "".concat(cornerRadius.topRight, " ").concat(cornerRadius.topRight, " ").concat(direction);
    var bottomLeftPath = "".concat(cornerRadius.bottomLeft, " ").concat(cornerRadius.bottomLeft, " ").concat(direction);
    var bottomRightPath = "".concat(cornerRadius.bottomRight, " ").concat(cornerRadius.bottomRight, " ").concat(direction);
    var commands = [
        "M",
        "A ".concat(bottomLeftPath, ","),
        "L",
        "A ".concat(topLeftPath, ","),
        "L",
        "A ".concat(topRightPath, ","),
        "L",
        "A ".concat(bottomRightPath, ",")
    ];
    var path = commands.reduce(function(acc, command, i) {
        acc += "".concat(command, " ").concat(coords[i].x, ", ").concat(coords[i].y, " \n");
        return acc;
    }, "");
    return "".concat(path, " z");
};
var $6ba27aed5eba44ca$var$getVerticalBarPoints = function(position, sign, cr) {
    var x0 = position.x0, x1 = position.x1, y0 = position.y0, y1 = position.y1; // eslint-disable-next-line max-statements, max-len
    var getHalfPoints = function(side) {
        var isLeft = side === "Left";
        var signL = isLeft ? 1 : -1;
        var x = isLeft ? x0 : x1;
        var bottomPoint = {
            x: x + signL * cr["bottom".concat(side)],
            y: y0
        };
        var bottomMiddlePoint = {
            x: x,
            y: y0 - sign * cr["bottom".concat(side)]
        };
        var topMiddlePoint = {
            x: x,
            y: y1 + sign * cr["top".concat(side)]
        };
        var topPoint = {
            x: x + signL * cr["top".concat(side)],
            y: y1
        };
        var hasIntersection = sign === 1 ? y0 - cr["bottom".concat(side)] < y1 + cr["top".concat(side)] : y0 + cr["bottom".concat(side)] > y1 - cr["top".concat(side)];
        if (hasIntersection) {
            var topCenter = (0, $159a38dfd7370cf9$export$105684a3041cb6f3)(x + signL * cr["top".concat(side)], y1 + sign * cr["top".concat(side)]);
            var topCircle = (0, $159a38dfd7370cf9$export$e1d786d2f707b414)(topCenter, cr["top".concat(side)]);
            var bottomCenter = (0, $159a38dfd7370cf9$export$105684a3041cb6f3)(x + signL * cr["bottom".concat(side)], y0 - sign * cr["bottom".concat(side)]);
            var bottomCircle = (0, $159a38dfd7370cf9$export$e1d786d2f707b414)(bottomCenter, cr["bottom".concat(side)]);
            var circleIntersection = topCircle.intersection(bottomCircle);
            var hasArcIntersection = circleIntersection.length > 0;
            if (hasArcIntersection) {
                var arcIntersection = circleIntersection[isLeft ? 0 : 1];
                bottomMiddlePoint = {
                    x: arcIntersection.x,
                    y: arcIntersection.y
                };
                topMiddlePoint = {
                    x: arcIntersection.x,
                    y: arcIntersection.y
                };
            } else {
                var hasBottomLineTopArcIntersection = cr["top".concat(side)] > cr["bottom".concat(side)];
                if (hasBottomLineTopArcIntersection) {
                    var newX = topCircle.solveX(y0)[isLeft ? 0 : 1];
                    bottomPoint = {
                        x: newX,
                        y: y0
                    };
                    bottomMiddlePoint = {
                        x: newX,
                        y: y0
                    };
                    topMiddlePoint = {
                        x: newX,
                        y: y0
                    };
                } else {
                    var _newX = bottomCircle.solveX(y1)[isLeft ? 0 : 1];
                    bottomMiddlePoint = {
                        x: _newX,
                        y: y1
                    };
                    topMiddlePoint = {
                        x: _newX,
                        y: y1
                    };
                    topPoint = {
                        x: _newX,
                        y: y1
                    };
                }
            }
        }
        var points = [
            bottomPoint,
            bottomMiddlePoint,
            topMiddlePoint,
            topPoint
        ];
        return isLeft ? points : points.reverse();
    };
    return getHalfPoints("Left").concat(getHalfPoints("Right"));
};
var $6ba27aed5eba44ca$var$getHorizontalBarPoints = function(position, sign, cr) {
    var y0 = position.y0, y1 = position.y1;
    var x0 = position.x0 < position.x1 ? position.x0 : position.x1;
    var x1 = position.x0 < position.x1 ? position.x1 : position.x0; // eslint-disable-next-line max-statements, max-len
    var getHalfPoints = function(side) {
        var isTop = side === "top";
        var signL = isTop ? -1 : 1;
        var y = isTop ? y1 : y0;
        var leftPoint = {
            x: x0,
            y: y - signL * cr["".concat(side, "Left")]
        };
        var leftMiddlePoint = {
            x: x0 + cr["".concat(side, "Left")],
            y: y
        };
        var rightMiddlePoint = {
            x: x1 - cr["".concat(side, "Right")],
            y: y
        };
        var rightPoint = {
            x: x1,
            y: y - signL * cr["".concat(side, "Right")]
        };
        var hasIntersection = leftMiddlePoint.x > rightMiddlePoint.x;
        if (hasIntersection) {
            var leftCenter = (0, $159a38dfd7370cf9$export$105684a3041cb6f3)(x0 + cr["".concat(side, "Left")], y - signL * cr["".concat(side, "Left")]);
            var leftCircle = (0, $159a38dfd7370cf9$export$e1d786d2f707b414)(leftCenter, cr["".concat(side, "Left")]);
            var rightCenter = (0, $159a38dfd7370cf9$export$105684a3041cb6f3)(x1 - cr["".concat(side, "Right")], y - signL * cr["".concat(side, "Right")]);
            var rightCircle = (0, $159a38dfd7370cf9$export$e1d786d2f707b414)(rightCenter, cr["".concat(side, "Right")]);
            var circleIntersection = leftCircle.intersection(rightCircle);
            var hasArcIntersection = circleIntersection.length > 0;
            if (hasArcIntersection) {
                var arcIntersection = circleIntersection[sign > 0 ? 1 : 0];
                leftMiddlePoint = {
                    x: arcIntersection.x,
                    y: arcIntersection.y
                };
                rightMiddlePoint = {
                    x: arcIntersection.x,
                    y: arcIntersection.y
                };
            } else {
                var hasLeftLineRightArcIntersection = cr["".concat(side, "Right")] > cr["".concat(side, "Left")];
                if (hasLeftLineRightArcIntersection) {
                    var newY = rightCircle.solveY(x0)[isTop ? 0 : 1];
                    leftPoint = {
                        x: x0,
                        y: newY
                    };
                    leftMiddlePoint = {
                        x: x0,
                        y: newY
                    };
                    rightMiddlePoint = {
                        x: x0,
                        y: newY
                    };
                } else {
                    var _newY = leftCircle.solveY(x1)[isTop ? 0 : 1];
                    rightPoint = {
                        x: x1,
                        y: _newY
                    };
                    rightMiddlePoint = {
                        x: x1,
                        y: _newY
                    };
                    leftMiddlePoint = {
                        x: x1,
                        y: _newY
                    };
                }
            }
        }
        return [
            leftPoint,
            leftMiddlePoint,
            rightMiddlePoint,
            rightPoint
        ];
    };
    var topPoints = getHalfPoints("top");
    var bottomPoints = getHalfPoints("bottom");
    return [
        bottomPoints[1],
        bottomPoints[0]
    ].concat($6ba27aed5eba44ca$var$_toConsumableArray(topPoints), [
        bottomPoints[3],
        bottomPoints[2]
    ]);
}; // eslint-disable-next-line max-params
var $6ba27aed5eba44ca$export$9e44069935bf1b59 = function(props, width, cornerRadius) {
    var position = $6ba27aed5eba44ca$var$getPosition(props, width);
    var sign = position.y0 > position.y1 ? 1 : -1;
    var direction = sign > 0 ? "0 0 1" : "0 0 0";
    var points = $6ba27aed5eba44ca$var$getVerticalBarPoints(position, sign, cornerRadius);
    return $6ba27aed5eba44ca$var$mapPointsToPath(points, cornerRadius, direction);
}; // eslint-disable-next-line max-params
var $6ba27aed5eba44ca$export$c9cb14b1dfcc5f14 = function(props, width, cornerRadius) {
    var position = $6ba27aed5eba44ca$var$getPosition(props, width);
    var sign = position.x0 < position.x1 ? 1 : -1;
    var direction = "0 0 1";
    var cr = {
        topRight: sign > 0 ? cornerRadius.topLeft : cornerRadius.bottomLeft,
        bottomRight: sign > 0 ? cornerRadius.topRight : cornerRadius.bottomRight,
        bottomLeft: sign > 0 ? cornerRadius.bottomRight : cornerRadius.topRight,
        topLeft: sign > 0 ? cornerRadius.bottomLeft : cornerRadius.topLeft
    };
    var points = $6ba27aed5eba44ca$var$getHorizontalBarPoints(position, sign, cr);
    return $6ba27aed5eba44ca$var$mapPointsToPath(points, cr, direction);
};
var $6ba27aed5eba44ca$export$5dd4c752e48e3ab4 = function(props, cornerRadius) {
    var datum = props.datum, scale = props.scale, index = props.index, alignment = props.alignment, style = props.style;
    var r1 = scale.y(datum._y0 || 0);
    var r2 = scale.y(datum._y1 !== undefined ? datum._y1 : datum._y);
    var currentAngle = scale.x(datum._x1 !== undefined ? datum._x1 : datum._x);
    var start;
    var end;
    if (style.width) {
        var width = $6ba27aed5eba44ca$var$getAngularWidth(props, style.width);
        var size = alignment === "middle" ? width / 2 : width;
        start = alignment === "start" ? currentAngle : currentAngle - size;
        end = alignment === "end" ? currentAngle : currentAngle + size;
    } else {
        start = $6ba27aed5eba44ca$var$getStartAngle(props, index);
        end = $6ba27aed5eba44ca$var$getEndAngle(props, index);
    }
    var getPath = function(edge) {
        var pathFunction = $40ccc67e29ee0e40$exports.arc().innerRadius(r1).outerRadius(r2).startAngle($6ba27aed5eba44ca$var$transformAngle(start)).endAngle($6ba27aed5eba44ca$var$transformAngle(end)).cornerRadius(cornerRadius[edge]);
        return pathFunction();
    };
    var getPathData = function(edge) {
        var rightPath = getPath("".concat(edge, "Right"));
        var rightMoves = rightPath.match(/[A-Z]/g);
        var rightCoords = rightPath.split(/[A-Z]/).slice(1);
        var rightMiddle = rightMoves.indexOf("L");
        var leftPath = getPath("".concat(edge, "Left"));
        var leftMoves = leftPath.match(/[A-Z]/g);
        var leftCoords = leftPath.split(/[A-Z]/).slice(1);
        var leftMiddle = leftMoves.indexOf("L");
        return {
            rightMoves: rightMoves,
            rightCoords: rightCoords,
            rightMiddle: rightMiddle,
            leftMoves: leftMoves,
            leftCoords: leftCoords,
            leftMiddle: leftMiddle
        };
    }; // eslint-disable-next-line max-statements
    var getTopPath = function() {
        var topRight = cornerRadius.topRight, topLeft = cornerRadius.topLeft;
        var arcLength = r2 * Math.abs(end - start);
        var _getPathData = getPathData("top"), rightMoves = _getPathData.rightMoves, rightCoords = _getPathData.rightCoords, rightMiddle = _getPathData.rightMiddle, leftMoves = _getPathData.leftMoves, leftCoords = _getPathData.leftCoords, leftMiddle = _getPathData.leftMiddle;
        var moves;
        var coords;
        if (topRight === topLeft || arcLength < 2 * topRight + 2 * topLeft) {
            moves = topRight > topLeft ? rightMoves : leftMoves;
            coords = topRight > topLeft ? rightCoords : leftCoords;
        } else {
            // eslint-disable-next-line no-magic-numbers
            var isShort = function(middle) {
                return middle < 3;
            };
            var rightOffset = topLeft > topRight && isShort(rightMiddle) ? 1 : 2;
            var leftOffset;
            if (topRight > topLeft) {
                var defaultOffset = isShort(rightMiddle) ? leftMiddle : leftMiddle - 2;
                leftOffset = isShort(leftMiddle) ? leftMiddle - 1 : defaultOffset;
            } else {
                var _defaultOffset = isShort(leftMiddle) ? 1 : 2;
                leftOffset = isShort(rightMiddle) ? _defaultOffset : leftMiddle - 2;
            }
            moves = [].concat($6ba27aed5eba44ca$var$_toConsumableArray(rightMoves.slice(0, rightOffset)), $6ba27aed5eba44ca$var$_toConsumableArray(leftMoves.slice(leftOffset)));
            coords = [].concat($6ba27aed5eba44ca$var$_toConsumableArray(rightCoords.slice(0, rightOffset)), $6ba27aed5eba44ca$var$_toConsumableArray(leftCoords.slice(leftOffset)));
        }
        var middle = moves.indexOf("L");
        var subMoves = moves.slice(0, middle);
        var subCoords = coords.slice(0, middle);
        return subMoves.map(function(m, i) {
            return {
                command: m,
                coords: subCoords[i].split(",")
            };
        });
    }; // eslint-disable-next-line max-statements
    var getBottomPath = function() {
        var bottomRight = cornerRadius.bottomRight, bottomLeft = cornerRadius.bottomLeft;
        var arcLength = r1 * Math.abs(end - start);
        var _getPathData2 = getPathData("bottom"), rightMoves = _getPathData2.rightMoves, rightCoords = _getPathData2.rightCoords, rightMiddle = _getPathData2.rightMiddle, leftMoves = _getPathData2.leftMoves, leftCoords = _getPathData2.leftCoords, leftMiddle = _getPathData2.leftMiddle;
        var moves;
        var coords;
        if (bottomRight === bottomLeft || arcLength < 2 * bottomRight + 2 * bottomLeft) {
            moves = bottomRight > bottomLeft ? rightMoves : leftMoves;
            coords = bottomRight > bottomLeft ? rightCoords : leftCoords;
        } else {
            // eslint-disable-next-line no-magic-numbers
            var isShort = function(m, middle) {
                return m.length - middle < 4;
            };
            var shortPath = bottomRight > bottomLeft ? isShort(rightMoves, rightMiddle) : isShort(leftMoves, leftMiddle); // eslint-disable-next-line no-magic-numbers
            var rightOffset = shortPath ? -1 : -3;
            moves = [].concat($6ba27aed5eba44ca$var$_toConsumableArray(leftMoves.slice(0, leftMiddle + 2)), $6ba27aed5eba44ca$var$_toConsumableArray(rightMoves.slice(rightOffset)));
            coords = [].concat($6ba27aed5eba44ca$var$_toConsumableArray(leftCoords.slice(0, leftMiddle + 2)), $6ba27aed5eba44ca$var$_toConsumableArray(rightCoords.slice(rightOffset)));
        }
        var middle = moves.indexOf("L");
        var subMoves = moves.slice(middle, -1);
        var subCoords = coords.slice(middle, -1);
        return subMoves.map(function(m, i) {
            return {
                command: m,
                coords: subCoords[i].split(",")
            };
        });
    };
    var topPath = getTopPath();
    var bottomPath = getBottomPath();
    var moves = [].concat($6ba27aed5eba44ca$var$_toConsumableArray(topPath), $6ba27aed5eba44ca$var$_toConsumableArray(bottomPath));
    var path = moves.reduce(function(memo, move) {
        memo += "".concat(move.command, " ").concat(move.coords.join());
        return memo;
    }, "");
    return "".concat(path, " z");
};
var $6ba27aed5eba44ca$export$2848276a2b699f0f = function(props, width, cornerRadius) {
    if (props.getPath) return $6ba27aed5eba44ca$export$9826e8dcdc3e9b21(props, width);
    return props.horizontal ? $6ba27aed5eba44ca$export$c9cb14b1dfcc5f14(props, width, cornerRadius) : $6ba27aed5eba44ca$export$9e44069935bf1b59(props, width, cornerRadius);
};
var $6ba27aed5eba44ca$export$335699138afa1fa0 = function(props, cornerRadius) {
    // TODO Radial bars
    return $6ba27aed5eba44ca$export$5dd4c752e48e3ab4(props, cornerRadius);
};


function $27000e11d83e1f32$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $27000e11d83e1f32$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $27000e11d83e1f32$var$ownKeys(Object(source), !0).forEach(function(key) {
            $27000e11d83e1f32$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $27000e11d83e1f32$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $27000e11d83e1f32$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $27000e11d83e1f32$var$evaluateProps = function(props) {
    /**
   * Potential evaluated props of following must be evaluated in this order:
   * 1) `style`
   * 2) `barWidth`
   * 3) `cornerRadius`
   *
   * Everything else does not have to be evaluated in a particular order:
   * `ariaLabel`
   * `desc`
   * `id`
   * `tabIndex`
   */ var style = (0, $fc1e72cc50e4be34$export$3d2f074408bd1b82)(props.style, props);
    var barWidth = (0, $fc1e72cc50e4be34$export$55382f732810ce34)(props.barWidth, (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, props, {
        style: style
    }));
    var cornerRadius = (0, $fc1e72cc50e4be34$export$635516faf7b51af4)(props.cornerRadius, (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, props, {
        style: style,
        barWidth: barWidth
    }));
    var ariaLabel = (0, $0a5de8228869aa1e$exports).evaluateProp(props.ariaLabel, props);
    var desc = (0, $0a5de8228869aa1e$exports).evaluateProp(props.desc, props);
    var id = (0, $0a5de8228869aa1e$exports).evaluateProp(props.id, props);
    var tabIndex = (0, $0a5de8228869aa1e$exports).evaluateProp(props.tabIndex, props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, props, {
        ariaLabel: ariaLabel,
        style: style,
        barWidth: barWidth,
        cornerRadius: cornerRadius,
        desc: desc,
        id: id,
        tabIndex: tabIndex
    });
};
var $27000e11d83e1f32$var$Bar = function(props) {
    props = $27000e11d83e1f32$var$evaluateProps(props);
    var _props = props, polar = _props.polar, origin = _props.origin, style = _props.style, barWidth = _props.barWidth, cornerRadius = _props.cornerRadius;
    var path = polar ? (0, $6ba27aed5eba44ca$export$335699138afa1fa0)(props, cornerRadius) : (0, $6ba27aed5eba44ca$export$2848276a2b699f0f)(props, barWidth, cornerRadius);
    var defaultTransform = polar && origin ? "translate(".concat(origin.x, ", ").concat(origin.y, ")") : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(props.pathComponent, $27000e11d83e1f32$var$_objectSpread($27000e11d83e1f32$var$_objectSpread({}, props.events), {}, {
        "aria-label": props.ariaLabel,
        style: style,
        d: path,
        className: props.className,
        clipPath: props.clipPath,
        desc: props.desc,
        index: props.index,
        role: props.role,
        shapeRendering: props.shapeRendering,
        transform: props.transform || defaultTransform,
        tabIndex: props.tabIndex
    }));
};
$27000e11d83e1f32$var$Bar.propTypes = $27000e11d83e1f32$var$_objectSpread($27000e11d83e1f32$var$_objectSpread({}, (0, $70dbe1f62d5c55ed$export$fe6a43517f1f6b90).primitiveProps), {}, {
    alignment: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        "start",
        "middle",
        "end"
    ]),
    barRatio: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    barWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]),
    cornerRadius: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            top: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
            ]),
            topLeft: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
            ]),
            topRight: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
            ]),
            bottom: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
            ]),
            bottomLeft: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
            ]),
            bottomRight: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
            ])
        })
    ]),
    datum: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    getPath: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    pathComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    x: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    y: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    y0: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number
});
$27000e11d83e1f32$var$Bar.defaultProps = {
    defaultBarWidth: 8,
    pathComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $32ee7a22ce6f8360$export$4b2950bdac9b6ee9), null),
    role: "presentation",
    shapeRendering: "auto"
};
var $27000e11d83e1f32$export$2e2bcd8739ae039 = $27000e11d83e1f32$var$Bar;


var $fdGrT = parcelRequire("fdGrT");

var $8T3gX = parcelRequire("8T3gX");


var $ce15a7815a86f8a8$exports = {};

$parcel$export($ce15a7815a86f8a8$exports, "formatDataFromDomain", () => $ce15a7815a86f8a8$export$e149e382c31f67b7);
$parcel$export($ce15a7815a86f8a8$exports, "createStringMap", () => $ce15a7815a86f8a8$export$6c187811ab8c2bee);
$parcel$export($ce15a7815a86f8a8$exports, "getStringsFromAxes", () => $ce15a7815a86f8a8$export$5bbc662142373468);
$parcel$export($ce15a7815a86f8a8$exports, "getStringsFromCategories", () => $ce15a7815a86f8a8$export$92915b258f643ac6);
$parcel$export($ce15a7815a86f8a8$exports, "getStringsFromData", () => $ce15a7815a86f8a8$export$d76e4ab22a13df1);
$parcel$export($ce15a7815a86f8a8$exports, "downsample", () => $ce15a7815a86f8a8$export$58027e4ee4386cae);
$parcel$export($ce15a7815a86f8a8$exports, "formatData", () => $ce15a7815a86f8a8$export$1f26277db27165ba);
$parcel$export($ce15a7815a86f8a8$exports, "generateData", () => $ce15a7815a86f8a8$export$c878bd9c55130e21);
$parcel$export($ce15a7815a86f8a8$exports, "getCategories", () => $ce15a7815a86f8a8$export$7a0f33e8df10bd94);
$parcel$export($ce15a7815a86f8a8$exports, "getData", () => $ce15a7815a86f8a8$export$7a171f172be0782e);
$parcel$export($ce15a7815a86f8a8$exports, "isDataComponent", () => $ce15a7815a86f8a8$export$959c1930e1bd68c1);
var $c60a3b6699f7fa00$exports = {};

var $a2018025215af2a4$exports = {};
/** Error message constants. */ var $a2018025215af2a4$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */ function $a2018025215af2a4$var$negate(predicate) {
    if (typeof predicate != "function") throw new TypeError($a2018025215af2a4$var$FUNC_ERROR_TEXT);
    return function() {
        var args = arguments;
        switch(args.length){
            case 0:
                return !predicate.call(this);
            case 1:
                return !predicate.call(this, args[0]);
            case 2:
                return !predicate.call(this, args[0], args[1]);
            case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
    };
}
$a2018025215af2a4$exports = $a2018025215af2a4$var$negate;


var $258ba1ea2dabbe4b$exports = {};



var $f6f10bd850c2a5f0$exports = {};

var $f1a2c416feac625f$exports = {};




/* Built-in method references for those with the same name as other `lodash` methods. */ var $f1a2c416feac625f$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $f1a2c416feac625f$var$getSymbolsIn = !$f1a2c416feac625f$var$nativeGetSymbols ? $f109fd11e633354b$exports : function(object) {
    var result = [];
    while(object){
        $3bf95b782724c68c$exports(result, $75381d22f22a25de$exports(object));
        object = $35bf467654165918$exports(object);
    }
    return result;
};
$f1a2c416feac625f$exports = $f1a2c416feac625f$var$getSymbolsIn;



/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $f6f10bd850c2a5f0$var$getAllKeysIn(object) {
    return $c29475283cf67e7d$exports(object, $17219b84c0d2d911$exports, $f1a2c416feac625f$exports);
}
$f6f10bd850c2a5f0$exports = $f6f10bd850c2a5f0$var$getAllKeysIn;


/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */ function $258ba1ea2dabbe4b$var$pickBy(object, predicate) {
    if (object == null) return {};
    var props = $95a41775a4f282b8$exports($f6f10bd850c2a5f0$exports(object), function(prop) {
        return [
            prop
        ];
    });
    predicate = $9dd1d38dfe69ddcf$exports(predicate);
    return $d0fa1d29a0bc834e$exports(object, props, function(value, path) {
        return predicate(value, path[0]);
    });
}
$258ba1ea2dabbe4b$exports = $258ba1ea2dabbe4b$var$pickBy;


/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */ function $c60a3b6699f7fa00$var$omitBy(object, predicate) {
    return $258ba1ea2dabbe4b$exports(object, $a2018025215af2a4$exports($9dd1d38dfe69ddcf$exports(predicate)));
}
$c60a3b6699f7fa00$exports = $c60a3b6699f7fa00$var$omitBy;


var $724072bbece9ed79$exports = {};
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $724072bbece9ed79$var$isUndefined(value) {
    return value === undefined;
}
$724072bbece9ed79$exports = $724072bbece9ed79$var$isUndefined;



var $c9cb355ea2786d76$exports = {};

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $c9cb355ea2786d76$var$isEqual(value, other) {
    return $8ad758ceb849e9eb$exports(value, other);
}
$c9cb355ea2786d76$exports = $c9cb355ea2786d76$var$isEqual;


var $1331767f05251f48$exports = {};






var $hAe8M = parcelRequire("hAe8M");


/** `Object#toString` result references. */ var $1331767f05251f48$var$mapTag = "[object Map]", $1331767f05251f48$var$setTag = "[object Set]";
/** Used for built-in method references. */ var $1331767f05251f48$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1331767f05251f48$var$hasOwnProperty = $1331767f05251f48$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $1331767f05251f48$var$isEmpty(value) {
    if (value == null) return true;
    if ($edace719698f1e70$exports(value) && ($b47d971f66a6f054$exports(value) || typeof value == "string" || typeof value.splice == "function" || $hAe8M(value) || $f88c9406e419272a$exports(value) || $343d561a7d6a3b42$exports(value))) return !value.length;
    var tag = $8d5c6ea4cc5d862e$exports(value);
    if (tag == $1331767f05251f48$var$mapTag || tag == $1331767f05251f48$var$setTag) return !value.size;
    if ($0d327a1cf9457c9f$exports(value)) return !$32f67937b014759c$exports(value).length;
    for(var key in value){
        if ($1331767f05251f48$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
$1331767f05251f48$exports = $1331767f05251f48$var$isEmpty;


var $b863eb497ad75781$exports = {};
var $c94e7b06b8e313f6$exports = {};



var $de0a1f9ad102f4c6$exports = {};
var $fc4011160035cb96$exports = {};
var $b8b184dbd2d79b13$exports = {};
var $e9e0f6175c094900$exports = {};
var $dd860dd02794d46b$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $dd860dd02794d46b$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$dd860dd02794d46b$exports = $dd860dd02794d46b$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $e9e0f6175c094900$var$baseFor = $dd860dd02794d46b$exports();
$e9e0f6175c094900$exports = $e9e0f6175c094900$var$baseFor;



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $b8b184dbd2d79b13$var$baseForOwn(object, iteratee) {
    return object && $e9e0f6175c094900$exports(object, iteratee, $9c7d1fa85e24a67e$exports);
}
$b8b184dbd2d79b13$exports = $b8b184dbd2d79b13$var$baseForOwn;


var $d1a8b7ac9f09109f$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $d1a8b7ac9f09109f$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$edace719698f1e70$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$d1a8b7ac9f09109f$exports = $d1a8b7ac9f09109f$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $fc4011160035cb96$var$baseEach = $d1a8b7ac9f09109f$exports($b8b184dbd2d79b13$exports);
$fc4011160035cb96$exports = $fc4011160035cb96$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $de0a1f9ad102f4c6$var$baseMap(collection, iteratee) {
    var index = -1, result = $edace719698f1e70$exports(collection) ? Array(collection.length) : [];
    $fc4011160035cb96$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$de0a1f9ad102f4c6$exports = $de0a1f9ad102f4c6$var$baseMap;


var $b9b9dff48b295ca5$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $b9b9dff48b295ca5$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$b9b9dff48b295ca5$exports = $b9b9dff48b295ca5$var$baseSortBy;



var $88e08f958f59c713$exports = {};
var $70789da24f6478d5$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $70789da24f6478d5$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $193702f8737ef12b$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $193702f8737ef12b$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$70789da24f6478d5$exports = $70789da24f6478d5$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $88e08f958f59c713$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $70789da24f6478d5$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == "desc" ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$88e08f958f59c713$exports = $88e08f958f59c713$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $c94e7b06b8e313f6$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $95a41775a4f282b8$exports(iteratees, function(iteratee) {
        if ($b47d971f66a6f054$exports(iteratee)) return function(value) {
            return $7bff94b74b05cdba$exports(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $30121ce9c4b4eb3d$exports
    ];
    var index = -1;
    iteratees = $95a41775a4f282b8$exports(iteratees, $259a13e6311f4b7a$exports($9dd1d38dfe69ddcf$exports));
    var result = $de0a1f9ad102f4c6$exports(collection, function(value, key, collection) {
        var criteria = $95a41775a4f282b8$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            "criteria": criteria,
            "index": ++index,
            "value": value
        };
    });
    return $b9b9dff48b295ca5$exports(result, function(object, other) {
        return $88e08f958f59c713$exports(object, other, orders);
    });
}
$c94e7b06b8e313f6$exports = $c94e7b06b8e313f6$var$baseOrderBy;



/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */ function $b863eb497ad75781$var$orderBy(collection, iteratees, orders, guard) {
    if (collection == null) return [];
    if (!$b47d971f66a6f054$exports(iteratees)) iteratees = iteratees == null ? [] : [
        iteratees
    ];
    orders = guard ? undefined : orders;
    if (!$b47d971f66a6f054$exports(orders)) orders = orders == null ? [] : [
        orders
    ];
    return $c94e7b06b8e313f6$exports(collection, iteratees, orders);
}
$b863eb497ad75781$exports = $b863eb497ad75781$var$orderBy;





var $c8275cc063b9781c$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $c8275cc063b9781c$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$c8275cc063b9781c$exports = $c8275cc063b9781c$var$last;


var $a2e6c83a615b2213$exports = {};
var $c62fa601898fb5f9$exports = {};
var $3a4f0e262c548c9e$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3a4f0e262c548c9e$var$nativeCeil = Math.ceil, $3a4f0e262c548c9e$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $3a4f0e262c548c9e$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $3a4f0e262c548c9e$var$nativeMax($3a4f0e262c548c9e$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
$3a4f0e262c548c9e$exports = $3a4f0e262c548c9e$var$baseRange;




/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $c62fa601898fb5f9$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != "number" && $f5d86346a533d383$exports(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $420360e96c86f53d$exports(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $420360e96c86f53d$exports(end);
        step = step === undefined ? start < end ? 1 : -1 : $420360e96c86f53d$exports(step);
        return $3a4f0e262c548c9e$exports(start, end, step, fromRight);
    };
}
$c62fa601898fb5f9$exports = $c62fa601898fb5f9$var$createRange;


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $a2e6c83a615b2213$var$range = $c62fa601898fb5f9$exports();
$a2e6c83a615b2213$exports = $a2e6c83a615b2213$var$range;


var $bd8625fe3238ec95$exports = {};
var $6d06713981607225$exports = {};

var $75e039934c534e29$exports = {};

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $75e039934c534e29$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $90ff81eaf0557cbd$exports(array, value, 0) > -1;
}
$75e039934c534e29$exports = $75e039934c534e29$var$arrayIncludes;


var $872519cf5d897167$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $872519cf5d897167$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$872519cf5d897167$exports = $872519cf5d897167$var$arrayIncludesWith;



var $946538378bdd1c68$exports = {};

var $64dbcb14cdcbd774$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $64dbcb14cdcbd774$var$noop() {
// No operation performed.
}
$64dbcb14cdcbd774$exports = $64dbcb14cdcbd774$var$noop;



/** Used as references for various `Number` constants. */ var $946538378bdd1c68$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $946538378bdd1c68$var$createSet = !($f7e45b5ac0aba58a$exports && 1 / $2923149d82fb4e32$exports(new $f7e45b5ac0aba58a$exports([
    ,
    -0
]))[1] == $946538378bdd1c68$var$INFINITY) ? $64dbcb14cdcbd774$exports : function(values) {
    return new $f7e45b5ac0aba58a$exports(values);
};
$946538378bdd1c68$exports = $946538378bdd1c68$var$createSet;



/** Used as the size to enable large array optimizations. */ var $6d06713981607225$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $6d06713981607225$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $75e039934c534e29$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $872519cf5d897167$exports;
    } else if (length >= $6d06713981607225$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $946538378bdd1c68$exports(array);
        if (set) return $2923149d82fb4e32$exports(set);
        isCommon = false;
        includes = $fcea3308b25e2289$exports;
        seen = new $0caf93a6e311dd5e$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$6d06713981607225$exports = $6d06713981607225$var$baseUniq;


/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $bd8625fe3238ec95$var$uniq(array) {
    return array && array.length ? $6d06713981607225$exports(array) : [];
}
$bd8625fe3238ec95$exports = $bd8625fe3238ec95$var$uniq;




var $8T3gX = parcelRequire("8T3gX");



var $ffba7dcc498032f7$export$e9ce57a22591250 = "@@__IMMUTABLE_ITERABLE__@@";
var $ffba7dcc498032f7$export$bc93a25498d4731a = "@@__IMMUTABLE_RECORD__@@";
var $ffba7dcc498032f7$export$9de0e792c6f2f128 = "@@__IMMUTABLE_LIST__@@";
var $ffba7dcc498032f7$export$36e541b65d50df19 = "@@__IMMUTABLE_MAP__@@";
function $ffba7dcc498032f7$export$9652023d9040757(x) {
    return !!(x && x[$ffba7dcc498032f7$export$e9ce57a22591250]);
}
function $ffba7dcc498032f7$export$6ba840931da50680(x) {
    return !!(x && x[$ffba7dcc498032f7$export$bc93a25498d4731a]);
}
function $ffba7dcc498032f7$export$f8647edfbac13b4f(x) {
    return $ffba7dcc498032f7$export$9652023d9040757(x) || $ffba7dcc498032f7$export$6ba840931da50680(x);
}
function $ffba7dcc498032f7$export$ead95ff48ba53ffd(x) {
    return !!(x && x[$ffba7dcc498032f7$export$9de0e792c6f2f128]);
}
function $ffba7dcc498032f7$export$5c90113a285f2241(x) {
    return !!(x && x[$ffba7dcc498032f7$export$36e541b65d50df19]);
}
function $ffba7dcc498032f7$export$9292d26345e308d0(x, whitelist) {
    return $ffba7dcc498032f7$export$9652023d9040757(x) ? x.reduce(function(result, curr, key) {
        if (whitelist && whitelist[key]) curr = $ffba7dcc498032f7$export$9292d26345e308d0(curr);
        result[key] = curr;
        return result;
    }, $ffba7dcc498032f7$export$ead95ff48ba53ffd(x) ? [] : {}) : x;
}


function $ce15a7815a86f8a8$var$_toConsumableArray(arr) {
    return $ce15a7815a86f8a8$var$_arrayWithoutHoles(arr) || $ce15a7815a86f8a8$var$_iterableToArray(arr) || $ce15a7815a86f8a8$var$_unsupportedIterableToArray(arr) || $ce15a7815a86f8a8$var$_nonIterableSpread();
}
function $ce15a7815a86f8a8$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ce15a7815a86f8a8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ce15a7815a86f8a8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ce15a7815a86f8a8$var$_arrayLikeToArray(o, minLen);
}
function $ce15a7815a86f8a8$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $ce15a7815a86f8a8$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ce15a7815a86f8a8$var$_arrayLikeToArray(arr);
}
function $ce15a7815a86f8a8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ce15a7815a86f8a8$var$parseDatum(datum) {
    var immutableDatumWhitelist = {
        errorX: true,
        errorY: true
    };
    return $ffba7dcc498032f7$export$f8647edfbac13b4f(datum) ? $ffba7dcc498032f7$export$9292d26345e308d0(datum, immutableDatumWhitelist) : datum;
}
function $ce15a7815a86f8a8$var$getLength(data) {
    return $ffba7dcc498032f7$export$9652023d9040757(data) ? data.size : data.length;
} // Returns generated data for a given axis based on domain and sample from props
function $ce15a7815a86f8a8$var$generateDataArray(props, axis) {
    var propsDomain = (0, (/*@__PURE__*/$parcel$interopDefault($2537df67cd52c170$exports)))(props.domain) ? props.domain[axis] : props.domain;
    var domain = propsDomain || $bf1178a7a28a9ee4$export$cc504192b2543d0c(props, axis).domain();
    var samples = props.samples || 1;
    var domainMax = Math.max.apply(Math, $ce15a7815a86f8a8$var$_toConsumableArray(domain));
    var domainMin = Math.min.apply(Math, $ce15a7815a86f8a8$var$_toConsumableArray(domain));
    var step = (domainMax - domainMin) / samples;
    var values = (0, (/*@__PURE__*/$parcel$interopDefault($a2e6c83a615b2213$exports)))(domainMin, domainMax, step);
    return (0, (/*@__PURE__*/$parcel$interopDefault($c8275cc063b9781c$exports)))(values) === domainMax ? values : values.concat(domainMax);
} // Returns sorted data. If no sort keys are provided, data is returned unaltered.
function $ce15a7815a86f8a8$var$sortData(dataset, sortKey) {
    var sortOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "ascending";
    if (!sortKey) return dataset;
     // Ensures previous VictoryLine api for sortKey prop stays consistent
    if (sortKey === "x" || sortKey === "y") sortKey = "_".concat(sortKey);
    var order = sortOrder === "ascending" ? "asc" : "desc";
    return (0, (/*@__PURE__*/$parcel$interopDefault($b863eb497ad75781$exports)))(dataset, sortKey, order);
} // This method will remove data points that break certain scales. (log scale only)
function $ce15a7815a86f8a8$var$cleanData(dataset, props) {
    var smallNumber = 1 / Number.MAX_SAFE_INTEGER;
    var scaleType = {
        x: $bf1178a7a28a9ee4$export$ff60de4f71778a2c(props, "x"),
        y: $bf1178a7a28a9ee4$export$ff60de4f71778a2c(props, "y")
    };
    if (scaleType.x !== "log" && scaleType.y !== "log") return dataset;
    var rules = function(datum, axis) {
        return scaleType[axis] === "log" ? datum["_".concat(axis)] !== 0 : true;
    };
    var sanitize = function(datum) {
        var _x = rules(datum, "x") ? datum._x : smallNumber;
        var _y = rules(datum, "y") ? datum._y : smallNumber;
        var _y0 = rules(datum, "y0") ? datum._y0 : smallNumber;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, datum, {
            _x: _x,
            _y: _y,
            _y0: _y0
        });
    };
    return dataset.map(function(datum) {
        if (rules(datum, "x") && rules(datum, "y") && rules(datum, "y0")) return datum;
        return sanitize(datum);
    });
} // Returns a data accessor given an eventKey prop
function $ce15a7815a86f8a8$var$getEventKey(key) {
    // creates a data accessor function
    // given a property key, path, array index, or null for identity.
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(key)) return key;
    else if (key === null || key === undefined) return function() {
        return undefined;
    };
     // otherwise, assume it is an array index, property key or path (_.property handles all three)
    return (0, (/*@__PURE__*/$parcel$interopDefault($bd112cd1a4525cec$exports)))(key);
} // Returns data with an eventKey prop added to each datum
function $ce15a7815a86f8a8$var$addEventKeys(props, data) {
    var hasEventKeyAccessor = !!props.eventKey;
    var eventKeyAccessor = $ce15a7815a86f8a8$var$getEventKey(props.eventKey);
    return data.map(function(datum, index) {
        if (datum.eventKey !== undefined) return datum;
        else if (hasEventKeyAccessor) {
            var eventKey = eventKeyAccessor(datum, index);
            return eventKey !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
                eventKey: eventKey
            }, datum) : datum;
        }
        return datum;
    });
} // Exported Functions
function $ce15a7815a86f8a8$export$e149e382c31f67b7(dataset, domain, defaultBaseline) {
    var exists = function(val) {
        return val !== undefined;
    };
    var minDomainX = $9373b80aaace1e85$export$df8687355ccb4d94(domain.x);
    var maxDomainX = $9373b80aaace1e85$export$a8f783d9de5392f5(domain.x);
    var minDomainY = $9373b80aaace1e85$export$df8687355ccb4d94(domain.y);
    var maxDomainY = $9373b80aaace1e85$export$a8f783d9de5392f5(domain.y);
    var underMin = function(min) {
        return function(val) {
            return exists(val) && val < min;
        };
    };
    var overMax = function(max) {
        return function(val) {
            return exists(val) && val > max;
        };
    };
    var isUnderMinX = underMin(minDomainX);
    var isUnderMinY = underMin(minDomainY);
    var isOverMaxX = overMax(maxDomainX);
    var isOverMaxY = overMax(maxDomainY); // eslint-disable-next-line complexity
    return dataset.map(function(datum) {
        var _x = datum._x, _y = datum._y, _y0 = datum._y0, _y1 = datum._y1; // single x point less than min domain
        if (isUnderMinX(_x) || isOverMaxX(_x)) _x = null;
        var baseline = exists(_y0) ? _y0 : defaultBaseline;
        var value = exists(_y1) ? _y1 : _y;
        if (!exists(value)) return datum; // value only and less than min domain or greater than max domain
        if (!exists(baseline) && (isUnderMinY(value) || isOverMaxY(value))) _y = null; // baseline and value are both less than min domain or both greater than max domain
        if (isUnderMinY(baseline) && isUnderMinY(value) || isOverMaxY(baseline) && isOverMaxY(value)) _y = _y0 = _y1 = null; // baseline and value with only baseline below min, set baseline to minDomainY
        if (isUnderMinY(baseline) && !isUnderMinY(value)) _y0 = minDomainY; // baseline and value with only baseline above max, set baseline to maxDomainY
        if (isOverMaxY(baseline) && !isOverMaxY(value)) _y0 = maxDomainY;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, datum, (0, (/*@__PURE__*/$parcel$interopDefault($c60a3b6699f7fa00$exports)))({
            _x: _x,
            _y: _y,
            _y0: _y0,
            _y1: _y1
        }, (0, (/*@__PURE__*/$parcel$interopDefault($724072bbece9ed79$exports)))));
    });
}
function $ce15a7815a86f8a8$export$6c187811ab8c2bee(props, axis) {
    var stringsFromAxes = $ce15a7815a86f8a8$export$5bbc662142373468(props, axis);
    var stringsFromCategories = $ce15a7815a86f8a8$export$92915b258f643ac6(props, axis);
    var stringsFromData = $ce15a7815a86f8a8$export$d76e4ab22a13df1(props, axis);
    var allStrings = (0, (/*@__PURE__*/$parcel$interopDefault($bd8625fe3238ec95$exports)))([].concat($ce15a7815a86f8a8$var$_toConsumableArray(stringsFromAxes), $ce15a7815a86f8a8$var$_toConsumableArray(stringsFromCategories), $ce15a7815a86f8a8$var$_toConsumableArray(stringsFromData)));
    return allStrings.length === 0 ? null : allStrings.reduce(function(memo, string, index) {
        memo[string] = index + 1;
        return memo;
    }, {});
}
function $ce15a7815a86f8a8$export$58027e4ee4386cae(data, maxPoints) {
    var startingIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    // ensures that the downampling of data while zooming looks good.
    var dataLength = $ce15a7815a86f8a8$var$getLength(data);
    if (dataLength > maxPoints) {
        // limit k to powers of 2, e.g. 64, 128, 256
        // so that the same points will be chosen reliably, reducing flicker on zoom
        var k = Math.pow(2, Math.ceil(Math.log2(dataLength / maxPoints)));
        return data.filter(function(d, i) {
            return (i + startingIndex) % k === 0;
        });
    }
    return data;
}
function $ce15a7815a86f8a8$export$1f26277db27165ba(dataset, props, expectedKeys) {
    var isArrayOrIterable = Array.isArray(dataset) || $ffba7dcc498032f7$export$9652023d9040757(dataset);
    if (!isArrayOrIterable || $ce15a7815a86f8a8$var$getLength(dataset) < 1) return [];
    var defaultKeys = [
        "x",
        "y",
        "y0"
    ];
    expectedKeys = Array.isArray(expectedKeys) ? expectedKeys : defaultKeys;
    var createAccessor = function(name) {
        return $0a5de8228869aa1e$export$f5ddff6606408ce8(props[name] !== undefined ? props[name] : name);
    };
    var accessor = expectedKeys.reduce(function(memo, type) {
        memo[type] = createAccessor(type);
        return memo;
    }, {});
    var preformattedData = (0, (/*@__PURE__*/$parcel$interopDefault($c9cb355ea2786d76$exports)))(expectedKeys, defaultKeys) && props.x === "_x" && props.y === "_y" && props.y0 === "_y0";
    var stringMap;
    if (preformattedData === false) // stringMap is not required if the data is preformatted
    stringMap = {
        x: expectedKeys.indexOf("x") !== -1 ? $ce15a7815a86f8a8$export$6c187811ab8c2bee(props, "x") : undefined,
        y: expectedKeys.indexOf("y") !== -1 ? $ce15a7815a86f8a8$export$6c187811ab8c2bee(props, "y") : undefined,
        y0: expectedKeys.indexOf("y0") !== -1 ? $ce15a7815a86f8a8$export$6c187811ab8c2bee(props, "y") : undefined
    };
    var data = preformattedData ? dataset : dataset.reduce(function(dataArr, datum, index) {
        // eslint-disable-line complexity
        datum = $ce15a7815a86f8a8$var$parseDatum(datum);
        var fallbackValues = {
            x: index,
            y: datum
        };
        var processedValues = expectedKeys.reduce(function(memo, type) {
            var processedValue = accessor[type](datum);
            var value = processedValue !== undefined ? processedValue : fallbackValues[type];
            if (value !== undefined) {
                if (typeof value === "string" && stringMap[type]) {
                    memo["".concat(type, "Name")] = value;
                    memo["_".concat(type)] = stringMap[type][value];
                } else memo["_".concat(type)] = value;
            }
            return memo;
        }, {});
        var formattedDatum = (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, processedValues, datum);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($1331767f05251f48$exports)))(formattedDatum)) dataArr.push(formattedDatum);
        return dataArr;
    }, []);
    var sortedData = $ce15a7815a86f8a8$var$sortData(data, props.sortKey, props.sortOrder);
    var cleanedData = $ce15a7815a86f8a8$var$cleanData(sortedData, props);
    return $ce15a7815a86f8a8$var$addEventKeys(props, cleanedData);
}
function $ce15a7815a86f8a8$export$c878bd9c55130e21(props) {
    var xValues = $ce15a7815a86f8a8$var$generateDataArray(props, "x");
    var yValues = $ce15a7815a86f8a8$var$generateDataArray(props, "y");
    var values = xValues.map(function(x, i) {
        return {
            x: x,
            y: yValues[i]
        };
    });
    return values;
}
function $ce15a7815a86f8a8$export$7a0f33e8df10bd94(props, axis) {
    return props.categories && !Array.isArray(props.categories) ? props.categories[axis] : props.categories;
}
function $ce15a7815a86f8a8$export$7a171f172be0782e(props) {
    return props.data ? $ce15a7815a86f8a8$export$1f26277db27165ba(props.data, props) : $ce15a7815a86f8a8$export$1f26277db27165ba($ce15a7815a86f8a8$export$c878bd9c55130e21(props), props);
}
function $ce15a7815a86f8a8$export$5bbc662142373468(props, axis) {
    var tickValues = props.tickValues, tickFormat = props.tickFormat;
    var tickValueArray;
    if (!tickValues || !Array.isArray(tickValues) && !tickValues[axis]) tickValueArray = tickFormat && Array.isArray(tickFormat) ? tickFormat : [];
    else tickValueArray = tickValues[axis] || tickValues;
    return tickValueArray.filter(function(val) {
        return typeof val === "string";
    });
}
function $ce15a7815a86f8a8$export$92915b258f643ac6(props, axis) {
    if (!props.categories) return [];
    var categories = $ce15a7815a86f8a8$export$7a0f33e8df10bd94(props, axis);
    var categoryStrings = categories && categories.filter(function(val) {
        return typeof val === "string";
    });
    return categoryStrings ? $9373b80aaace1e85$export$c499305a875a8ee9(categoryStrings) : [];
}
function $ce15a7815a86f8a8$export$d76e4ab22a13df1(props, axis) {
    var isArrayOrIterable = Array.isArray(props.data) || $ffba7dcc498032f7$export$9652023d9040757(props.data);
    if (!isArrayOrIterable) return [];
    var key = props[axis] === undefined ? axis : props[axis];
    var accessor = $0a5de8228869aa1e$export$f5ddff6606408ce8(key); // support immutable data
    var data = props.data.reduce(function(memo, d) {
        memo.push($ce15a7815a86f8a8$var$parseDatum(d));
        return memo;
    }, []);
    var sortedData = $ce15a7815a86f8a8$var$sortData(data, props.sortKey, props.sortOrder);
    var dataStrings = sortedData.reduce(function(dataArr, datum) {
        datum = $ce15a7815a86f8a8$var$parseDatum(datum);
        dataArr.push(accessor(datum));
        return dataArr;
    }, []).filter(function(datum) {
        return typeof datum === "string";
    }); // return a unique set of strings
    return dataStrings.reduce(function(prev, curr) {
        if (curr !== undefined && curr !== null && prev.indexOf(curr) === -1) prev.push(curr);
        return prev;
    }, []);
}
function $ce15a7815a86f8a8$export$959c1930e1bd68c1(component) {
    var getRole = function(child) {
        return child && child.type ? child.type.role : "";
    };
    var role = getRole(component);
    if (role === "portal") {
        var children = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(component.props.children);
        role = children.length ? getRole(children[0]) : "";
    }
    var whitelist = [
        "area",
        "bar",
        "boxplot",
        "candlestick",
        "errorbar",
        "group",
        "histogram",
        "line",
        "pie",
        "scatter",
        "stack",
        "voronoi"
    ];
    return (0, (/*@__PURE__*/$parcel$interopDefault($8ba9a2795a3c2065$exports)))(whitelist, role);
}

var $91b6bedde0b7fe96$exports = {};

$parcel$export($91b6bedde0b7fe96$exports, "getMinFromProps", () => $91b6bedde0b7fe96$export$385f5052ad9e995e);
$parcel$export($91b6bedde0b7fe96$exports, "getMaxFromProps", () => $91b6bedde0b7fe96$export$de470f0b6b2c75e9);
$parcel$export($91b6bedde0b7fe96$exports, "getDomainFromMinMax", () => $91b6bedde0b7fe96$export$aafa8294ef4dae28);
$parcel$export($91b6bedde0b7fe96$exports, "createDomainFunction", () => $91b6bedde0b7fe96$export$a486abbfbc863f25);
$parcel$export($91b6bedde0b7fe96$exports, "getDomainFromData", () => $91b6bedde0b7fe96$export$d41344f8a7de2b5c);
$parcel$export($91b6bedde0b7fe96$exports, "formatDomain", () => $91b6bedde0b7fe96$export$510ae4770a7da719);
$parcel$export($91b6bedde0b7fe96$exports, "getDomainFromProps", () => $91b6bedde0b7fe96$export$2e477808c106ba09);
$parcel$export($91b6bedde0b7fe96$exports, "getDomainFromCategories", () => $91b6bedde0b7fe96$export$8f5c9d733277c7dd);
$parcel$export($91b6bedde0b7fe96$exports, "getDomain", () => $91b6bedde0b7fe96$export$3e8733322718eb9);
$parcel$export($91b6bedde0b7fe96$exports, "getSymmetricDomain", () => $91b6bedde0b7fe96$export$55b0a14e0335d29c);
$parcel$export($91b6bedde0b7fe96$exports, "getDomainWithZero", () => $91b6bedde0b7fe96$export$7876380f503a53f9);
$parcel$export($91b6bedde0b7fe96$exports, "isDomainComponent", () => $91b6bedde0b7fe96$export$9b264bdd6864cf49);
var $7efc23a8c3e6ff33$exports = {};
var $d92a1474600326d9$exports = {};


/** `Object#toString` result references. */ var $d92a1474600326d9$var$dateTag = "[object Date]";
/**
 * The base implementation of `_.isDate` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 */ function $d92a1474600326d9$var$baseIsDate(value) {
    return $65ef2014975340ff$exports(value) && $4003a8f3ae86bec1$exports(value) == $d92a1474600326d9$var$dateTag;
}
$d92a1474600326d9$exports = $d92a1474600326d9$var$baseIsDate;




var $3TIQ3 = parcelRequire("3TIQ3");
/* Node.js helper references. */ var $7efc23a8c3e6ff33$var$nodeIsDate = $3TIQ3 && $3TIQ3.isDate;
/**
 * Checks if `value` is classified as a `Date` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 * @example
 *
 * _.isDate(new Date);
 * // => true
 *
 * _.isDate('Mon April 23 2012');
 * // => false
 */ var $7efc23a8c3e6ff33$var$isDate = $7efc23a8c3e6ff33$var$nodeIsDate ? $259a13e6311f4b7a$exports($7efc23a8c3e6ff33$var$nodeIsDate) : $d92a1474600326d9$exports;
$7efc23a8c3e6ff33$exports = $7efc23a8c3e6ff33$var$isDate;




var $e6a7f3b0a1ae9978$exports = {};
var $631c952b5c23bb1b$exports = {};

/**
 * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $631c952b5c23bb1b$var$baseSortedUniq(array, iteratee) {
    var index = -1, length = array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        if (!index || !$ba1c04d40f072e77$exports(computed, seen)) {
            var seen = computed;
            result[resIndex++] = value === 0 ? 0 : value;
        }
    }
    return result;
}
$631c952b5c23bb1b$exports = $631c952b5c23bb1b$var$baseSortedUniq;


/**
 * This method is like `_.uniq` except that it's designed and optimized
 * for sorted arrays.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.sortedUniq([1, 1, 2]);
 * // => [1, 2]
 */ function $e6a7f3b0a1ae9978$var$sortedUniq(array) {
    return array && array.length ? $631c952b5c23bb1b$exports(array) : [];
}
$e6a7f3b0a1ae9978$exports = $e6a7f3b0a1ae9978$var$sortedUniq;





var $8T3gX = parcelRequire("8T3gX");




function $91b6bedde0b7fe96$var$_toConsumableArray(arr) {
    return $91b6bedde0b7fe96$var$_arrayWithoutHoles(arr) || $91b6bedde0b7fe96$var$_iterableToArray(arr) || $91b6bedde0b7fe96$var$_unsupportedIterableToArray(arr) || $91b6bedde0b7fe96$var$_nonIterableSpread();
}
function $91b6bedde0b7fe96$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $91b6bedde0b7fe96$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $91b6bedde0b7fe96$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $91b6bedde0b7fe96$var$_arrayLikeToArray(o, minLen);
}
function $91b6bedde0b7fe96$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $91b6bedde0b7fe96$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $91b6bedde0b7fe96$var$_arrayLikeToArray(arr);
}
function $91b6bedde0b7fe96$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $91b6bedde0b7fe96$var$cleanDomain(domain, props, axis) {
    var scaleType = $bf1178a7a28a9ee4$export$ff60de4f71778a2c(props, axis);
    if (scaleType !== "log") return domain;
    var rules = function(dom) {
        var almostZero = dom[0] < 0 || dom[1] < 0 ? -1 / Number.MAX_SAFE_INTEGER : 1 / Number.MAX_SAFE_INTEGER;
        var domainOne = dom[0] === 0 ? almostZero : dom[0];
        var domainTwo = dom[1] === 0 ? almostZero : dom[1];
        return [
            domainOne,
            domainTwo
        ];
    };
    return rules(domain);
}
function $91b6bedde0b7fe96$var$getDomainPadding(props, axis) {
    var formatPadding = function(padding) {
        return Array.isArray(padding) ? {
            left: padding[0],
            right: padding[1]
        } : {
            left: padding,
            right: padding
        };
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($2537df67cd52c170$exports)))(props.domainPadding) ? formatPadding(props.domainPadding[axis]) : formatPadding(props.domainPadding);
}
function $91b6bedde0b7fe96$var$getFlatData(dataset, axis) {
    var axisKey = "_".concat(axis);
    return (0, (/*@__PURE__*/$parcel$interopDefault($c287c7303a1fc294$exports)))(dataset).map(function(datum) {
        return datum[axisKey] && datum[axisKey][1] !== undefined ? datum[axisKey][1] : datum[axisKey];
    });
}
function $91b6bedde0b7fe96$var$getExtremeFromData(dataset, axis) {
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "min";
    var getExtreme = function(arr) {
        return type === "max" ? Math.max.apply(Math, $91b6bedde0b7fe96$var$_toConsumableArray(arr)) : Math.min.apply(Math, $91b6bedde0b7fe96$var$_toConsumableArray(arr));
    };
    var initialValue = type === "max" ? -Infinity : Infinity;
    var containsDate = false;
    var result = (0, (/*@__PURE__*/$parcel$interopDefault($c287c7303a1fc294$exports)))(dataset).reduce(function(memo, datum) {
        var current0 = datum["_".concat(axis, "0")] !== undefined ? datum["_".concat(axis, "0")] : datum["_".concat(axis)];
        var current1 = datum["_".concat(axis, "1")] !== undefined ? datum["_".concat(axis, "1")] : datum["_".concat(axis)];
        var current = getExtreme([
            current0,
            current1
        ]);
        containsDate = containsDate || current0 instanceof Date || current1 instanceof Date;
        return getExtreme([
            memo,
            current
        ]);
    }, initialValue);
    return containsDate ? new Date(result) : result;
} // eslint-disable-next-line max-statements
function $91b6bedde0b7fe96$var$padDomain(domain, props, axis) {
    if (!props.domainPadding) return domain;
    var minDomain = $91b6bedde0b7fe96$export$385f5052ad9e995e(props, axis);
    var maxDomain = $91b6bedde0b7fe96$export$de470f0b6b2c75e9(props, axis);
    var padding = $91b6bedde0b7fe96$var$getDomainPadding(props, axis);
    if (!padding.left && !padding.right) return domain;
    var min = $9373b80aaace1e85$export$df8687355ccb4d94(domain);
    var max = $9373b80aaace1e85$export$a8f783d9de5392f5(domain);
    var currentAxis = $0a5de8228869aa1e$export$54b2c1a7f28c35a0(axis, props.horizontal);
    var range = $0a5de8228869aa1e$export$fef151b94550e9f5(props, currentAxis);
    var rangeExtent = Math.abs(range[0] - range[1]);
    var paddedRangeExtent = Math.max(rangeExtent - padding.left - padding.right, 1);
    var paddedDomainExtent = Math.abs(max.valueOf() - min.valueOf()) / paddedRangeExtent * rangeExtent;
    var simplePadding = {
        left: paddedDomainExtent * padding.left / rangeExtent,
        right: paddedDomainExtent * padding.right / rangeExtent
    };
    var paddedDomain = {
        min: min.valueOf() - simplePadding.left,
        max: max.valueOf() + simplePadding.right
    };
    var singleQuadrantDomainPadding = (0, (/*@__PURE__*/$parcel$interopDefault($2537df67cd52c170$exports)))(props.singleQuadrantDomainPadding) ? props.singleQuadrantDomainPadding[axis] : props.singleQuadrantDomainPadding;
    var addsQuadrants = min >= 0 && paddedDomain.min <= 0 || max <= 0 && paddedDomain.max >= 0;
    var adjust = function(val, type) {
        var coerce = type === "min" && min >= 0 && val <= 0 || type === "max" && max <= 0 && val >= 0;
        return coerce ? 0 : val;
    };
    if (addsQuadrants && singleQuadrantDomainPadding !== false) {
        // Naive initial padding calculation
        var initialPadding = {
            // @ts-expect-error `max/min` might be dates
            left: Math.abs(max - min) * padding.left / rangeExtent,
            // @ts-expect-error `max/min` might be dates
            right: Math.abs(max - min) * padding.right / rangeExtent
        }; // Adjust the domain by the initial padding
        var adjustedDomain = {
            min: adjust(min.valueOf() - initialPadding.left, "min"),
            max: adjust(max.valueOf() + initialPadding.right, "max")
        }; // re-calculate padding, taking the adjusted domain into account
        var finalPadding = {
            left: Math.abs(adjustedDomain.max - adjustedDomain.min) * padding.left / rangeExtent,
            right: Math.abs(adjustedDomain.max - adjustedDomain.min) * padding.right / rangeExtent
        }; // Adjust the domain by the final padding
        paddedDomain = {
            min: adjust(min.valueOf() - finalPadding.left, "min"),
            max: adjust(max.valueOf() + finalPadding.right, "max")
        };
    } // default to minDomain / maxDomain if they exist
    var finalDomain = {
        min: minDomain !== undefined ? minDomain : paddedDomain.min,
        max: maxDomain !== undefined ? maxDomain : paddedDomain.max
    };
    return min instanceof Date || max instanceof Date ? $91b6bedde0b7fe96$export$aafa8294ef4dae28(new Date(finalDomain.min), new Date(finalDomain.max)) : $91b6bedde0b7fe96$export$aafa8294ef4dae28(finalDomain.min, finalDomain.max);
} // Public Methods
function $91b6bedde0b7fe96$export$a486abbfbc863f25(getDomainFromDataFunction, formatDomainFunction) {
    getDomainFromDataFunction = (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(getDomainFromDataFunction) ? getDomainFromDataFunction : $91b6bedde0b7fe96$export$d41344f8a7de2b5c;
    formatDomainFunction = (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(formatDomainFunction) ? formatDomainFunction : $91b6bedde0b7fe96$export$510ae4770a7da719;
    return function(props, axis) {
        var propsDomain = $91b6bedde0b7fe96$export$2e477808c106ba09(props, axis);
        if (propsDomain) return formatDomainFunction(propsDomain, props, axis);
        var categories = $ce15a7815a86f8a8$export$7a0f33e8df10bd94(props, axis);
        var domain = categories ? $91b6bedde0b7fe96$export$8f5c9d733277c7dd(props, axis, categories) : getDomainFromDataFunction(props, axis);
        return domain ? formatDomainFunction(domain, props, axis) : undefined;
    };
}
function $91b6bedde0b7fe96$export$510ae4770a7da719(domain, props, axis) {
    return $91b6bedde0b7fe96$var$cleanDomain($91b6bedde0b7fe96$var$padDomain(domain, props, axis), props, axis);
}
function $91b6bedde0b7fe96$export$3e8733322718eb9(props, axis) {
    return $91b6bedde0b7fe96$export$a486abbfbc863f25()(props, axis);
}
function $91b6bedde0b7fe96$export$8f5c9d733277c7dd(props, axis, categories) {
    categories = categories || $ce15a7815a86f8a8$export$7a0f33e8df10bd94(props, axis);
    var polar = props.polar, _props$startAngle = props.startAngle, startAngle = _props$startAngle === void 0 ? 0 : _props$startAngle, _props$endAngle = props.endAngle, endAngle = _props$endAngle === void 0 ? 360 : _props$endAngle;
    if (!categories) return undefined;
    var minDomain = $91b6bedde0b7fe96$export$385f5052ad9e995e(props, axis);
    var maxDomain = $91b6bedde0b7fe96$export$de470f0b6b2c75e9(props, axis);
    var stringArray = $9373b80aaace1e85$export$37b75fcede59d7ed(categories) ? $ce15a7815a86f8a8$export$92915b258f643ac6(props, axis) : [];
    var stringMap = stringArray.length === 0 ? null : stringArray.reduce(function(memo, string, index) {
        memo[string] = index + 1;
        return memo;
    }, {});
    var categoryValues = stringMap ? categories.map(function(value) {
        return stringMap[value];
    }) : categories;
    var min = minDomain !== undefined ? minDomain : $9373b80aaace1e85$export$df8687355ccb4d94(categoryValues);
    var max = maxDomain !== undefined ? maxDomain : $9373b80aaace1e85$export$a8f783d9de5392f5(categoryValues);
    var categoryDomain = $91b6bedde0b7fe96$export$aafa8294ef4dae28(min, max);
    return polar && axis === "x" && Math.abs(startAngle - endAngle) === 360 ? $91b6bedde0b7fe96$export$55b0a14e0335d29c(categoryDomain, categoryValues) : categoryDomain;
}
function $91b6bedde0b7fe96$export$d41344f8a7de2b5c(props, axis, dataset) {
    dataset = dataset || $ce15a7815a86f8a8$export$7a171f172be0782e(props);
    var polar = props.polar, _props$startAngle2 = props.startAngle, startAngle = _props$startAngle2 === void 0 ? 0 : _props$startAngle2, _props$endAngle2 = props.endAngle, endAngle = _props$endAngle2 === void 0 ? 360 : _props$endAngle2;
    var minDomain = $91b6bedde0b7fe96$export$385f5052ad9e995e(props, axis);
    var maxDomain = $91b6bedde0b7fe96$export$de470f0b6b2c75e9(props, axis);
    if (dataset.length < 1) return minDomain !== undefined && maxDomain !== undefined ? $91b6bedde0b7fe96$export$aafa8294ef4dae28(minDomain, maxDomain) : undefined;
    var min = minDomain !== undefined ? minDomain : $91b6bedde0b7fe96$var$getExtremeFromData(dataset, axis, "min");
    var max = maxDomain !== undefined ? maxDomain : $91b6bedde0b7fe96$var$getExtremeFromData(dataset, axis, "max");
    var domain = $91b6bedde0b7fe96$export$aafa8294ef4dae28(min, max);
    return polar && axis === "x" && Math.abs(startAngle - endAngle) === 360 ? $91b6bedde0b7fe96$export$55b0a14e0335d29c(domain, $91b6bedde0b7fe96$var$getFlatData(dataset, axis)) : domain;
}
function $91b6bedde0b7fe96$export$aafa8294ef4dae28(min, max) {
    var getSinglePointDomain = function(val) {
        // d3-scale does not properly resolve very small differences.
        var verySmallNumber = val === 0 ? 2 * Math.pow(10, -10) : Math.pow(10, -10);
        var verySmallDate = 1;
        var minVal = val instanceof Date ? new Date(Number(val) - verySmallDate) : Number(val) - verySmallNumber;
        var maxVal = val instanceof Date ? new Date(Number(val) + verySmallDate) : Number(val) + verySmallNumber;
        return val === 0 ? [
            0,
            maxVal
        ] : [
            minVal,
            maxVal
        ];
    };
    return Number(min) === Number(max) ? getSinglePointDomain(max) : [
        min,
        max
    ];
}
function $91b6bedde0b7fe96$export$2e477808c106ba09(props, axis) {
    var minDomain = $91b6bedde0b7fe96$export$385f5052ad9e995e(props, axis);
    var maxDomain = $91b6bedde0b7fe96$export$de470f0b6b2c75e9(props, axis);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($2537df67cd52c170$exports)))(props.domain) && props.domain[axis]) return props.domain[axis];
    else if (Array.isArray(props.domain)) return props.domain;
    else if (minDomain !== undefined && maxDomain !== undefined) return $91b6bedde0b7fe96$export$aafa8294ef4dae28(minDomain, maxDomain);
    return undefined;
}
function $91b6bedde0b7fe96$export$7876380f503a53f9(props, axis) {
    var propsDomain = $91b6bedde0b7fe96$export$2e477808c106ba09(props, axis);
    if (propsDomain) return propsDomain;
    var dataset = $ce15a7815a86f8a8$export$7a171f172be0782e(props);
    var y0Min = dataset.reduce(function(min, datum) {
        return datum._y0 < min ? datum._y0 : min;
    }, Infinity);
    var ensureZero = function(domain) {
        if (axis === "x") return domain;
        var defaultMin = y0Min !== Infinity ? y0Min : 0;
        var maxDomainProp = $91b6bedde0b7fe96$export$de470f0b6b2c75e9(props, axis);
        var minDomainProp = $91b6bedde0b7fe96$export$385f5052ad9e995e(props, axis);
        var max = maxDomainProp !== undefined ? maxDomainProp : $9373b80aaace1e85$export$a8f783d9de5392f5(domain, defaultMin);
        var min = minDomainProp !== undefined ? minDomainProp : $9373b80aaace1e85$export$df8687355ccb4d94(domain, defaultMin);
        return $91b6bedde0b7fe96$export$aafa8294ef4dae28(min, max);
    };
    var getDomainFunction = function() {
        return $91b6bedde0b7fe96$export$d41344f8a7de2b5c(props, axis, dataset);
    };
    var formatDomainFunction = function(domain) {
        return $91b6bedde0b7fe96$export$510ae4770a7da719(ensureZero(domain), props, axis);
    };
    return $91b6bedde0b7fe96$export$a486abbfbc863f25(getDomainFunction, formatDomainFunction)(props, axis);
}
function $91b6bedde0b7fe96$export$de470f0b6b2c75e9(props, axis) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($2537df67cd52c170$exports)))(props.maxDomain) && props.maxDomain[axis] !== undefined) return props.maxDomain[axis];
    return typeof props.maxDomain === "number" || (0, (/*@__PURE__*/$parcel$interopDefault($7efc23a8c3e6ff33$exports)))(props.maxDomain) ? props.maxDomain : undefined;
}
function $91b6bedde0b7fe96$export$385f5052ad9e995e(props, axis) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($2537df67cd52c170$exports)))(props.minDomain) && props.minDomain[axis] !== undefined) return props.minDomain[axis];
    return typeof props.minDomain === "number" || (0, (/*@__PURE__*/$parcel$interopDefault($7efc23a8c3e6ff33$exports)))(props.minDomain) ? props.minDomain : undefined;
}
function $91b6bedde0b7fe96$export$55b0a14e0335d29c(domain, values) {
    var processedData = (0, (/*@__PURE__*/$parcel$interopDefault($e6a7f3b0a1ae9978$exports)))(values.sort(function(a, b) {
        return a - b;
    }));
    var step = processedData[1] - processedData[0];
    return [
        domain[0],
        domain[1] + step
    ];
}
function $91b6bedde0b7fe96$export$9b264bdd6864cf49(component) {
    var getRole = function(child) {
        return child && child.type ? child.type.role : "";
    };
    var role = getRole(component);
    if (role === "portal") {
        var children = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(component.props.children);
        role = children.length ? getRole(children[0]) : "";
    }
    var whitelist = [
        "area",
        "axis",
        "bar",
        "boxplot",
        "candlestick",
        "errorbar",
        "group",
        "histogram",
        "line",
        "pie",
        "scatter",
        "stack",
        "voronoi"
    ];
    return (0, (/*@__PURE__*/$parcel$interopDefault($8ba9a2795a3c2065$exports)))(whitelist, role);
}

var $e6236e426b53ba14$exports = {};

$parcel$export($e6236e426b53ba14$exports, "getDegrees", () => $e6236e426b53ba14$export$3e481d889db54798);
$parcel$export($e6236e426b53ba14$exports, "getText", () => $e6236e426b53ba14$export$c72d34660a162238);
$parcel$export($e6236e426b53ba14$exports, "getPolarTextAnchor", () => $e6236e426b53ba14$export$5a2163272b3ea6d2);
$parcel$export($e6236e426b53ba14$exports, "getPolarVerticalAnchor", () => $e6236e426b53ba14$export$38a2e80b8b673651);
$parcel$export($e6236e426b53ba14$exports, "getPolarAngle", () => $e6236e426b53ba14$export$c5bce4840d298b9b);
$parcel$export($e6236e426b53ba14$exports, "getProps", () => $e6236e426b53ba14$export$75fe5f91d452f94b);


// Private Functions
function $e6236e426b53ba14$var$getVerticalAnchor(props, datum) {
    datum = datum || {};
    var sign = datum._y >= 0 ? 1 : -1;
    var labelStyle = props.style && props.style.labels || {};
    if (datum.verticalAnchor || labelStyle.verticalAnchor) return datum.verticalAnchor || labelStyle.verticalAnchor;
    else if (!props.horizontal) return sign >= 0 ? "end" : "start";
    return "middle";
}
function $e6236e426b53ba14$var$getTextAnchor(props, datum) {
    datum = datum || {};
    var style = props.style, horizontal = props.horizontal;
    var sign = datum._y >= 0 ? 1 : -1;
    var labelStyle = style && style.labels || {};
    if (datum.verticalAnchor || labelStyle.verticalAnchor) return datum.verticalAnchor || labelStyle.verticalAnchor;
    else if (!horizontal) return "middle";
    return sign >= 0 ? "start" : "end";
}
function $e6236e426b53ba14$var$getAngle(props, datum) {
    datum = datum || {};
    var labelStyle = props.style && props.style.labels || {};
    return datum.angle === undefined ? labelStyle.angle : datum.angle;
}
function $e6236e426b53ba14$var$getPadding(props, datum) {
    datum = datum || {};
    var horizontal = props.horizontal, style = props.style;
    var labelStyle = style.labels || {};
    var defaultPadding = $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(labelStyle.padding, props) || 0;
    var sign = datum._y < 0 ? -1 : 1;
    return {
        x: horizontal ? sign * defaultPadding : 0,
        y: horizontal ? 0 : -1 * sign * defaultPadding
    };
}
function $e6236e426b53ba14$var$getOffset(props, datum) {
    if (props.polar) return {};
    var padding = $e6236e426b53ba14$var$getPadding(props, datum);
    return {
        dx: padding.x,
        dy: padding.y
    };
}
function $e6236e426b53ba14$var$getPosition(props, datum) {
    var polar = props.polar;
    var _Helpers$scalePoint = $0a5de8228869aa1e$export$2290ec7febe36dd6(props, datum), x = _Helpers$scalePoint.x, y = _Helpers$scalePoint.y;
    if (!polar) return {
        x: x,
        y: y
    };
    var polarPadding = $e6236e426b53ba14$var$getPolarPadding(props, datum);
    return {
        x: x + polarPadding.x,
        y: y + polarPadding.y
    };
}
function $e6236e426b53ba14$var$getPolarPadding(props, datum) {
    var style = props.style;
    var degrees = $e6236e426b53ba14$export$3e481d889db54798(props, datum);
    var labelStyle = style.labels || {};
    var padding = $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(labelStyle.padding, props) || 0;
    var angle = $0a5de8228869aa1e$export$c9fcf1a7df975d78(degrees);
    return {
        x: padding * Math.cos(angle),
        y: -padding * Math.sin(angle)
    };
}
function $e6236e426b53ba14$var$getLabelPlacement(props) {
    var labelComponent = props.labelComponent, labelPlacement = props.labelPlacement, polar = props.polar;
    var defaultLabelPlacement = polar ? "perpendicular" : "vertical";
    return labelPlacement ? labelPlacement : labelComponent.props && labelComponent.props.labelPlacement || defaultLabelPlacement;
}
function $e6236e426b53ba14$var$getPolarOrientation(degrees) {
    // eslint-disable-next-line no-magic-numbers
    if (degrees < 45 || degrees > 315) return "right"; // eslint-disable-next-line no-magic-numbers
    else if (degrees >= 45 && degrees <= 135) return "top"; // eslint-disable-next-line no-magic-numbers
    else if (degrees > 135 && degrees < 225) return "left";
    return "bottom";
} // Exported Functions
function $e6236e426b53ba14$export$c72d34660a162238(props, datum, index) {
    datum = datum || {};
    if (datum.label !== undefined) return datum.label;
    return Array.isArray(props.labels) ? props.labels[index] : props.labels;
}
function $e6236e426b53ba14$export$5a2163272b3ea6d2(props, degrees) {
    var labelPlacement = $e6236e426b53ba14$var$getLabelPlacement(props);
    if (labelPlacement === "perpendicular" || labelPlacement === "vertical" && (degrees === 90 || degrees === 270)) return "middle";
    return degrees <= 90 || degrees > 270 ? "start" : "end";
}
function $e6236e426b53ba14$export$38a2e80b8b673651(props, degrees) {
    var labelPlacement = $e6236e426b53ba14$var$getLabelPlacement(props);
    var orientation = $e6236e426b53ba14$var$getPolarOrientation(degrees);
    if (labelPlacement === "parallel" || orientation === "left" || orientation === "right") return "middle";
    return orientation === "top" ? "end" : "start";
}
function $e6236e426b53ba14$export$c5bce4840d298b9b(props, baseAngle) {
    var labelPlacement = props.labelPlacement, datum = props.datum;
    if (!labelPlacement || labelPlacement === "vertical") return 0;
    var degrees = baseAngle !== undefined ? baseAngle % 360 : $e6236e426b53ba14$export$3e481d889db54798(props, datum);
    var sign = degrees > 90 && degrees < 180 || degrees > 270 ? 1 : -1;
    var angle = 0;
    if (degrees === 0 || degrees === 180) angle = 90;
    else if (degrees > 0 && degrees < 180) angle = 90 - degrees;
    else if (degrees > 180 && degrees < 360) angle = 270 - degrees;
    var labelRotation = labelPlacement === "perpendicular" ? 0 : 90;
    return angle + sign * labelRotation;
}
function $e6236e426b53ba14$export$3e481d889db54798(props, datum) {
    var _Helpers$getPoint = $0a5de8228869aa1e$export$92d53b972f97f55a(datum), x = _Helpers$getPoint.x;
    return $0a5de8228869aa1e$export$c41dd2a8460d3196(props.scale.x(x)) % 360;
}
function $e6236e426b53ba14$export$75fe5f91d452f94b(props, index) {
    var scale = props.scale, data = props.data, style = props.style, horizontal = props.horizontal, polar = props.polar, width = props.width, height = props.height, theme = props.theme, labelComponent = props.labelComponent, disableInlineStyles = props.disableInlineStyles;
    var datum = data[index];
    var degrees = $e6236e426b53ba14$export$3e481d889db54798(props, datum);
    var textAnchor = polar ? $e6236e426b53ba14$export$5a2163272b3ea6d2(props, degrees) : $e6236e426b53ba14$var$getTextAnchor(props, datum);
    var verticalAnchor = polar ? $e6236e426b53ba14$export$38a2e80b8b673651(props, degrees) : $e6236e426b53ba14$var$getVerticalAnchor(props, datum);
    var angle = $e6236e426b53ba14$var$getAngle(props, datum);
    var text = $e6236e426b53ba14$export$c72d34660a162238(props, datum, index);
    var labelPlacement = $e6236e426b53ba14$var$getLabelPlacement(props);
    var _getPosition = $e6236e426b53ba14$var$getPosition(props, datum), x = _getPosition.x, y = _getPosition.y;
    var _getOffset = $e6236e426b53ba14$var$getOffset(props, datum), dx = _getOffset.dx, dy = _getOffset.dy;
    var labelProps = {
        angle: angle,
        data: data,
        datum: datum,
        disableInlineStyles: disableInlineStyles,
        horizontal: horizontal,
        index: index,
        polar: polar,
        scale: scale,
        labelPlacement: labelPlacement,
        text: text,
        textAnchor: textAnchor,
        verticalAnchor: verticalAnchor,
        x: x,
        y: y,
        dx: dx,
        dy: dy,
        width: width,
        height: height,
        style: style.labels
    };
    if (!$0a5de8228869aa1e$export$682a6f6bf6d26974(labelComponent)) return labelProps;
    var tooltipTheme = theme && theme.tooltip || {};
    return (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, labelProps, $0a5de8228869aa1e$export$30a06c8d3562193f(tooltipTheme, [
        "style"
    ]));
}


var $2bf684df5f83713c$export$d36834ecd87f906b = function(props, datum) {
    var getDefaultMin = function(axis) {
        var defaultZero = (0, $bf1178a7a28a9ee4$exports).getType(props.scale[axis]) === "log" ? 1 / Number.MAX_SAFE_INTEGER : 0;
        var defaultMin = defaultZero;
        var minY = (0, $9373b80aaace1e85$exports).getMinValue(props.domain[axis]);
        var maxY = (0, $9373b80aaace1e85$exports).getMaxValue(props.domain[axis]);
        if (minY < 0 && maxY <= 0) defaultMin = maxY;
        else if (minY >= 0 && maxY > 0) defaultMin = minY;
        return datum["_".concat(axis)] instanceof Date ? new Date(defaultMin) : defaultMin;
    };
    var _y0 = datum._y0 !== undefined ? datum._y0 : getDefaultMin("y");
    var _x0 = datum._x0 !== undefined ? datum._x0 : getDefaultMin("x");
    return (0, $0a5de8228869aa1e$exports).scalePoint(props, (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, datum, {
        _y0: _y0,
        _x0: _x0
    }));
};
var $2bf684df5f83713c$var$getCalculatedValues = function(props) {
    var polar = props.polar;
    var defaultStyles = (0, $0a5de8228869aa1e$exports).getDefaultStyles(props, "bar");
    var style = !props.disableInlineStyles ? (0, $0a5de8228869aa1e$exports).getStyles(props.style, defaultStyles) : {};
    var range = props.range || {
        x: (0, $0a5de8228869aa1e$exports).getRange(props, "x"),
        y: (0, $0a5de8228869aa1e$exports).getRange(props, "y")
    };
    var domain = {
        x: (0, $91b6bedde0b7fe96$exports).getDomainWithZero(props, "x"),
        y: (0, $91b6bedde0b7fe96$exports).getDomainWithZero(props, "y")
    };
    var scale = {
        x: (0, $bf1178a7a28a9ee4$exports).getBaseScale(props, "x").domain(domain.x).range(props.horizontal ? range.y : range.x),
        y: (0, $bf1178a7a28a9ee4$exports).getBaseScale(props, "y").domain(domain.y).range(props.horizontal ? range.x : range.y)
    };
    var origin = polar ? props.origin || (0, $0a5de8228869aa1e$exports).getPolarOrigin(props) : undefined;
    var data = (0, $ce15a7815a86f8a8$exports).getData(props);
    data = (0, $ce15a7815a86f8a8$exports).formatDataFromDomain(data, domain, 0);
    return {
        style: style,
        data: data,
        scale: scale,
        domain: domain,
        origin: origin
    };
};
var $2bf684df5f83713c$export$a7ec8144096537e7 = function(props, fallbackProps) {
    var modifiedProps = (0, $0a5de8228869aa1e$exports).modifyProps(props, fallbackProps, "bar");
    props = (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, modifiedProps, $2bf684df5f83713c$var$getCalculatedValues(modifiedProps));
    var _props = props, alignment = _props.alignment, barRatio = _props.barRatio, cornerRadius = _props.cornerRadius, data = _props.data, disableInlineStyles = _props.disableInlineStyles, domain = _props.domain, events = _props.events, height = _props.height, horizontal = _props.horizontal, origin = _props.origin, padding = _props.padding, polar = _props.polar, scale = _props.scale, sharedEvents = _props.sharedEvents, standalone = _props.standalone, style = _props.style, theme = _props.theme, width = _props.width, labels = _props.labels, name = _props.name, barWidth = _props.barWidth, getPath = _props.getPath;
    var initialChildProps = {
        parent: {
            horizontal: horizontal,
            domain: domain,
            scale: scale,
            width: width,
            height: height,
            data: data,
            standalone: standalone,
            name: name,
            theme: theme,
            polar: polar,
            origin: origin,
            padding: padding,
            style: style.parent
        }
    };
    return data.reduce(function(childProps, datum, index) {
        var eventKey = !(0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(datum.eventKey) ? datum.eventKey : index;
        var _getBarPosition = $2bf684df5f83713c$export$d36834ecd87f906b(props, datum), x = _getBarPosition.x, y = _getBarPosition.y, y0 = _getBarPosition.y0, x0 = _getBarPosition.x0;
        var dataProps = {
            alignment: alignment,
            barRatio: barRatio,
            barWidth: barWidth,
            cornerRadius: cornerRadius,
            data: data,
            datum: datum,
            disableInlineStyles: disableInlineStyles,
            getPath: getPath,
            horizontal: horizontal,
            index: index,
            polar: polar,
            origin: origin,
            scale: scale,
            style: style.data,
            width: width,
            height: height,
            x: x,
            y: y,
            y0: y0,
            x0: x0
        };
        childProps[eventKey] = {
            data: dataProps
        };
        var text = (0, $e6236e426b53ba14$exports).getText(props, datum, index);
        if (text !== undefined && text !== null || labels && (events || sharedEvents)) childProps[eventKey].labels = (0, $e6236e426b53ba14$exports).getProps(props, index);
        return childProps;
    }, initialChildProps);
};



var $a58ee22f5be18a99$exports = {};
var $c4348ef9176a1809$exports = {};






/** Used as the size to enable large array optimizations. */ var $c4348ef9176a1809$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $c4348ef9176a1809$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $75e039934c534e29$exports, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $95a41775a4f282b8$exports(values, $259a13e6311f4b7a$exports(iteratee));
    if (comparator) {
        includes = $872519cf5d897167$exports;
        isCommon = false;
    } else if (values.length >= $c4348ef9176a1809$var$LARGE_ARRAY_SIZE) {
        includes = $fcea3308b25e2289$exports;
        isCommon = false;
        values = new $0caf93a6e311dd5e$exports(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
$c4348ef9176a1809$exports = $c4348ef9176a1809$var$baseDifference;



var $7da4ad3d933c254f$exports = {};


/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $7da4ad3d933c254f$var$isArrayLikeObject(value) {
    return $65ef2014975340ff$exports(value) && $edace719698f1e70$exports(value);
}
$7da4ad3d933c254f$exports = $7da4ad3d933c254f$var$isArrayLikeObject;


/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $a58ee22f5be18a99$var$without = $3432652d35d8dc24$exports(function(array, values) {
    return $7da4ad3d933c254f$exports(array) ? $c4348ef9176a1809$exports(array, values) : [];
});
$a58ee22f5be18a99$exports = $a58ee22f5be18a99$var$without;







var $faa0050d5f48da66$exports = {};




/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */ var $faa0050d5f48da66$var$difference = $3432652d35d8dc24$exports(function(array, values) {
    return $7da4ad3d933c254f$exports(array) ? $c4348ef9176a1809$exports(array, $f9578710aaa0eee6$exports(values, 1, $7da4ad3d933c254f$exports, true)) : [];
});
$faa0050d5f48da66$exports = $faa0050d5f48da66$var$difference;





var $8T3gX = parcelRequire("8T3gX");
var $617aed0754382a89$exports = {};

$parcel$export($617aed0754382a89$exports, "getEvents", () => $617aed0754382a89$export$3f41ece7d7128238);
$parcel$export($617aed0754382a89$exports, "getScopedEvents", () => $617aed0754382a89$export$83e2385a599c58a3);
$parcel$export($617aed0754382a89$exports, "getPartialEvents", () => $617aed0754382a89$export$19e5623225f61ca7);
$parcel$export($617aed0754382a89$exports, "getEventState", () => $617aed0754382a89$export$de3835329292aa32);
$parcel$export($617aed0754382a89$exports, "getExternalMutationsWithChildren", () => $617aed0754382a89$export$a277902c1a978d53);
$parcel$export($617aed0754382a89$exports, "getExternalMutations", () => $617aed0754382a89$export$569063dd8d69bab3);
$parcel$export($617aed0754382a89$exports, "getExternalMutation", () => $617aed0754382a89$export$45321828b0348a28);
$parcel$export($617aed0754382a89$exports, "getComponentEvents", () => $617aed0754382a89$export$553d7b5edf647c91);
$parcel$export($617aed0754382a89$exports, "getGlobalEventNameFromKey", () => $617aed0754382a89$export$a32dcb4e36259a4e);
$parcel$export($617aed0754382a89$exports, "getGlobalEvents", () => $617aed0754382a89$export$1e2d2a8dd008ed46);
$parcel$export($617aed0754382a89$exports, "omitGlobalEvents", () => $617aed0754382a89$export$3e07820b9c881f93);
$parcel$export($617aed0754382a89$exports, "emulateReactEvent", () => $617aed0754382a89$export$f67e4e0bc709377c);









function $617aed0754382a89$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $617aed0754382a89$var$_toConsumableArray(arr) {
    return $617aed0754382a89$var$_arrayWithoutHoles(arr) || $617aed0754382a89$var$_iterableToArray(arr) || $617aed0754382a89$var$_unsupportedIterableToArray(arr) || $617aed0754382a89$var$_nonIterableSpread();
}
function $617aed0754382a89$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $617aed0754382a89$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $617aed0754382a89$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $617aed0754382a89$var$_arrayLikeToArray(o, minLen);
}
function $617aed0754382a89$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $617aed0754382a89$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $617aed0754382a89$var$_arrayLikeToArray(arr);
}
function $617aed0754382a89$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $617aed0754382a89$var$GLOBAL_EVENT_REGEX = /^onGlobal(.*)$/;
function $617aed0754382a89$export$3f41ece7d7128238(props, target, eventKey, getScopedEvents) {
    var _this = this;
    // Returns all events that apply to a particular target element
    var getEventsByTarget = function(events) {
        var getSelectedEvents = function() {
            var targetEvents = events.reduce(function(memo, event) {
                if (event.target !== undefined) {
                    var matchesTarget = Array.isArray(event.target) ? (0, (/*@__PURE__*/$parcel$interopDefault($8ba9a2795a3c2065$exports)))(event.target, target) : "".concat(event.target) === "".concat(target);
                    return matchesTarget ? memo.concat(event) : memo;
                }
                return memo.concat(event);
            }, []);
            if (eventKey !== undefined && target !== "parent") return targetEvents.filter(function(obj) {
                var targetKeys = obj.eventKey;
                var useKey = function(key) {
                    return key ? "".concat(key) === "".concat(eventKey) : true;
                };
                return Array.isArray(targetKeys) ? targetKeys.some(function(k) {
                    return useKey(k);
                }) : useKey(targetKeys);
            });
            return targetEvents;
        };
        var selectedEvents = getSelectedEvents();
        return Array.isArray(selectedEvents) && selectedEvents.reduce(function(memo, event) {
            return event ? (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))(memo, event.eventHandlers) : memo;
        }, {});
    };
    /* Returns all events from props and defaultEvents from components. Events handlers
   * specified in props will override handlers for the same event if they are also
   * specified in defaultEvents of a sub-component
   */ var getAllEvents = function() {
        // Mandatory usage: `getEvents.bind(this)`
        /* eslint-disable no-invalid-this */ if (Array.isArray(_this.componentEvents)) {
            var _this$componentEvents;
            return Array.isArray(props.events) ? (_this$componentEvents = _this.componentEvents).concat.apply(_this$componentEvents, $617aed0754382a89$var$_toConsumableArray(props.events)) : _this.componentEvents;
        }
        /* eslint-enable no-invalid-this */ return props.events;
    };
    var allEvents = getAllEvents();
    var ownEvents = allEvents && (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(getScopedEvents) ? getScopedEvents(getEventsByTarget(allEvents), target) : undefined;
    if (!props.sharedEvents) return ownEvents;
    var getSharedEvents = props.sharedEvents.getEvents;
    var sharedEvents = props.sharedEvents.events && getSharedEvents(getEventsByTarget(props.sharedEvents.events), target);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, sharedEvents, ownEvents);
}
function $617aed0754382a89$export$83e2385a599c58a3(events, namespace, childType, baseProps) {
    var _this2 = this;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($1331767f05251f48$exports)))(events)) return {};
     // Mandatory usage: `getScopedEvents.bind(this)`
    // eslint-disable-next-line no-invalid-this
    baseProps = baseProps || this.baseProps; // returns the original base props or base state of a given target element
    var getTargetProps = function(identifier, type) {
        var childName = identifier.childName, target = identifier.target, key = identifier.key; // eslint-disable-next-line no-invalid-this
        var baseType = type === "props" ? baseProps : _this2.state || {};
        var base = childName === undefined || childName === null || !baseType[childName] ? baseType : baseType[childName];
        return key === "parent" ? base.parent : base[key] && base[key][target];
    }; // Returns the state object with the mutation caused by a given eventReturn
    // applied to the appropriate property on the state object
    var parseEvent = function(eventReturn, eventKey) {
        var childNames = namespace === "parent" ? eventReturn.childName : eventReturn.childName || childType;
        var target = eventReturn.target || namespace; // returns all eventKeys to modify for a targeted childName
        var getKeys = function(childName) {
            if (target === "parent") return "parent";
            if (eventReturn.eventKey === "all") return baseProps[childName] ? (0, (/*@__PURE__*/$parcel$interopDefault($a58ee22f5be18a99$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($9c7d1fa85e24a67e$exports)))(baseProps[childName]), "parent") : (0, (/*@__PURE__*/$parcel$interopDefault($a58ee22f5be18a99$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($9c7d1fa85e24a67e$exports)))(baseProps), "parent");
            else if (eventReturn.eventKey === undefined && eventKey === "parent") return baseProps[childName] ? (0, (/*@__PURE__*/$parcel$interopDefault($9c7d1fa85e24a67e$exports)))(baseProps[childName]) : (0, (/*@__PURE__*/$parcel$interopDefault($9c7d1fa85e24a67e$exports)))(baseProps);
            return eventReturn.eventKey !== undefined ? eventReturn.eventKey : eventKey;
        }; // returns the state object with mutated props applied for a single key
        var getMutationObject = function(key, childName) {
            // eslint-disable-next-line no-invalid-this
            var baseState = _this2.state || {};
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(eventReturn.mutation)) return baseState;
            var mutationTargetProps = getTargetProps({
                childName: childName,
                key: key,
                target: target
            }, "props");
            var mutationTargetState = getTargetProps({
                childName: childName,
                key: key,
                target: target
            }, "state");
            var mutatedProps = eventReturn.mutation((0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, mutationTargetProps, mutationTargetState), baseProps);
            var childState = baseState[childName] || {};
            var filterState = function(state) {
                if (state[key] && state[key][target]) delete state[key][target];
                if (state[key] && !(0, (/*@__PURE__*/$parcel$interopDefault($9c7d1fa85e24a67e$exports)))(state[key]).length) delete state[key];
                return state;
            };
            var extendState = function(state) {
                return target === "parent" ? (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))(state, $617aed0754382a89$var$_defineProperty({}, key, (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))(state[key], mutatedProps))) : (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))(state, $617aed0754382a89$var$_defineProperty({}, key, (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))(state[key], $617aed0754382a89$var$_defineProperty({}, target, mutatedProps))));
            };
            var updateState = function(state) {
                return mutatedProps ? extendState(state) : filterState(state);
            };
            return childName !== undefined && childName !== null ? (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))(baseState, $617aed0754382a89$var$_defineProperty({}, childName, updateState(childState))) : updateState(baseState);
        }; // returns entire mutated state for a given childName
        var getReturnByChild = function(childName) {
            var mutationKeys = getKeys(childName);
            return Array.isArray(mutationKeys) ? mutationKeys.reduce(function(memo, key) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))(memo, getMutationObject(key, childName));
            }, {}) : getMutationObject(mutationKeys, childName);
        }; // returns an entire mutated state for all children
        var allChildNames = childNames === "all" ? (0, (/*@__PURE__*/$parcel$interopDefault($a58ee22f5be18a99$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($9c7d1fa85e24a67e$exports)))(baseProps), "parent") : childNames;
        return Array.isArray(allChildNames) ? allChildNames.reduce(function(memo, childName) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))(memo, getReturnByChild(childName));
        }, {}) : getReturnByChild(allChildNames);
    }; // Parses an array of event returns into a single state mutation
    var parseEventReturn = function(eventReturn, eventKey) {
        return Array.isArray(eventReturn) ? eventReturn.reduce(function(memo, props) {
            memo = (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, memo, parseEvent(props, eventKey));
            return memo;
        }, {}) : parseEvent(eventReturn, eventKey);
    };
    var compileCallbacks = function(eventReturn) {
        var getCallback = function(obj) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(obj.callback) && obj.callback;
        };
        var callbacks = Array.isArray(eventReturn) ? eventReturn.map(function(evtObj) {
            return getCallback(evtObj);
        }) : [
            getCallback(eventReturn)
        ];
        var callbackArray = callbacks.filter(function(callback) {
            return callback !== false;
        });
        return callbackArray.length ? function() {
            return callbackArray.forEach(function(callback) {
                return callback();
            });
        } : undefined;
    }; // A function that calls a particular event handler, parses its return
    // into a state mutation, and calls setState
    // eslint-disable-next-line max-params
    var onEvent = function(evt, childProps, eventKey, eventName) {
        // eslint-disable-next-line no-invalid-this
        var eventReturn = events[eventName](evt, childProps, eventKey, _this2);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($1331767f05251f48$exports)))(eventReturn)) {
            var callbacks = compileCallbacks(eventReturn); // eslint-disable-next-line no-invalid-this
            _this2.setState(parseEventReturn(eventReturn, eventKey), callbacks);
        }
    }; // returns a new events object with enhanced event handlers
    return (0, (/*@__PURE__*/$parcel$interopDefault($9c7d1fa85e24a67e$exports)))(events).reduce(function(memo, event) {
        memo[event] = onEvent;
        return memo;
    }, {});
}
function $617aed0754382a89$export$19e5623225f61ca7(events, eventKey, childProps) {
    if (!events) return {};
    return (0, (/*@__PURE__*/$parcel$interopDefault($9c7d1fa85e24a67e$exports)))(events).reduce(function(memo, eventName) {
        var appliedEvent = function(evt) {
            return events[eventName](evt, childProps, eventKey, eventName);
        };
        memo[eventName] = appliedEvent;
        return memo;
    }, {});
}
function $617aed0754382a89$export$de3835329292aa32(eventKey, namespace, childType) {
    // Mandatory usage: `getEventState.bind(this)`
    // eslint-disable-next-line no-invalid-this
    var state = this.state || {};
    if (!childType) return eventKey === "parent" ? state[eventKey] && state[eventKey][namespace] || state[eventKey] : state[eventKey] && state[eventKey][namespace];
    return state[childType] && state[childType][eventKey] && state[childType][eventKey][namespace];
}
function $617aed0754382a89$export$a277902c1a978d53(mutations, baseProps, baseState, childNames) {
    baseProps = baseProps || {};
    baseState = baseState || {};
    return childNames.reduce(function(memo, childName) {
        var childState = baseState[childName];
        var mutation = $617aed0754382a89$export$569063dd8d69bab3(mutations, baseProps[childName], baseState[childName], childName);
        memo[childName] = mutation ? mutation : childState;
        return (0, (/*@__PURE__*/$parcel$interopDefault($258ba1ea2dabbe4b$exports)))(memo, function(v) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($1331767f05251f48$exports)))(v);
        });
    }, {});
}
function $617aed0754382a89$export$569063dd8d69bab3(mutations, baseProps, baseState, childName) {
    baseProps = baseProps || {};
    baseState = baseState || {};
    var eventKeys = (0, (/*@__PURE__*/$parcel$interopDefault($9c7d1fa85e24a67e$exports)))(baseProps);
    return eventKeys.reduce(function(memo, eventKey) {
        var keyState = baseState[eventKey] || {};
        var keyProps = baseProps[eventKey] || {};
        if (eventKey === "parent") {
            var identifier = {
                eventKey: eventKey,
                target: "parent"
            };
            var mutation = $617aed0754382a89$export$45321828b0348a28(mutations, keyProps, keyState, identifier);
            memo[eventKey] = mutation !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, keyState, mutation) : keyState;
        } else {
            // use keys from both state and props so that elements not intially included in baseProps
            // will be used. (i.e. labels)
            var targets = (0, (/*@__PURE__*/$parcel$interopDefault($bd8625fe3238ec95$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($9c7d1fa85e24a67e$exports)))(keyProps).concat((0, (/*@__PURE__*/$parcel$interopDefault($9c7d1fa85e24a67e$exports)))(keyState)));
            memo[eventKey] = targets.reduce(function(m, target) {
                var identifier = {
                    eventKey: eventKey,
                    target: target,
                    childName: childName
                };
                var mutation = $617aed0754382a89$export$45321828b0348a28(mutations, keyProps[target], keyState[target], identifier);
                m[target] = mutation !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, keyState[target], mutation) : keyState[target];
                return (0, (/*@__PURE__*/$parcel$interopDefault($258ba1ea2dabbe4b$exports)))(m, function(v) {
                    return !(0, (/*@__PURE__*/$parcel$interopDefault($1331767f05251f48$exports)))(v);
                });
            }, {});
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($258ba1ea2dabbe4b$exports)))(memo, function(v) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($1331767f05251f48$exports)))(v);
        });
    }, {});
}
function $617aed0754382a89$export$45321828b0348a28(mutations, baseProps, baseState, identifier) {
    var filterMutations = function(mutation, type) {
        if (typeof mutation[type] === "string") return mutation[type] === "all" || mutation[type] === identifier[type];
        else if (Array.isArray(mutation[type])) {
            // coerce arrays to strings before matching
            var stringArray = mutation[type].map(function(m) {
                return "".concat(m);
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($8ba9a2795a3c2065$exports)))(stringArray, identifier[type]);
        }
        return false;
    };
    mutations = Array.isArray(mutations) ? mutations : [
        mutations
    ];
    var scopedMutations = mutations;
    if (identifier.childName) scopedMutations = mutations.filter(function(m) {
        return filterMutations(m, "childName");
    });
     // find any mutation objects that match the target
    var targetMutations = scopedMutations.filter(function(m) {
        return filterMutations(m, "target");
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($1331767f05251f48$exports)))(targetMutations)) return undefined;
    var keyMutations = targetMutations.filter(function(m) {
        return filterMutations(m, "eventKey");
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($1331767f05251f48$exports)))(keyMutations)) return undefined;
    return keyMutations.reduce(function(memo, curr) {
        var mutationFunction = curr && (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(curr.mutation) ? curr.mutation : function() {
            return undefined;
        };
        var currentMutation = mutationFunction((0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, baseProps, baseState));
        return (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, memo, currentMutation);
    }, {});
}
function $617aed0754382a89$export$553d7b5edf647c91(props, components) {
    var events = Array.isArray(components) && components.reduce(function(memo, componentName) {
        var _memo;
        var component = props[componentName];
        var defaultEvents = component && component.type && component.type.defaultEvents;
        var componentEvents = (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(defaultEvents) ? defaultEvents(component.props) : defaultEvents;
        memo = Array.isArray(componentEvents) ? (_memo = memo).concat.apply(_memo, $617aed0754382a89$var$_toConsumableArray(componentEvents)) : memo;
        return memo;
    }, []);
    return events && events.length ? events : undefined;
}
function $617aed0754382a89$export$a32dcb4e36259a4e(key) {
    var match = key.match($617aed0754382a89$var$GLOBAL_EVENT_REGEX);
    return match && match[1] && match[1].toLowerCase();
}
var $617aed0754382a89$export$1e2d2a8dd008ed46 = function(events) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($258ba1ea2dabbe4b$exports)))(events, function(_, key) {
        return $617aed0754382a89$var$GLOBAL_EVENT_REGEX.test(key);
    });
};
var $617aed0754382a89$export$3e07820b9c881f93 = function(events) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($c60a3b6699f7fa00$exports)))(events, function(_, key) {
        return $617aed0754382a89$var$GLOBAL_EVENT_REGEX.test(key);
    });
};
var $617aed0754382a89$export$f67e4e0bc709377c = function(event) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))(event, {
        nativeEvent: event
    });
};


var $15022e88a09b93ad$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $15022e88a09b93ad$var$hasElementType = typeof Element !== "undefined";
var $15022e88a09b93ad$var$hasMap = typeof Map === "function";
var $15022e88a09b93ad$var$hasSet = typeof Set === "function";
var $15022e88a09b93ad$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $15022e88a09b93ad$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$15022e88a09b93ad$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($15022e88a09b93ad$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$15022e88a09b93ad$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($15022e88a09b93ad$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($15022e88a09b93ad$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($15022e88a09b93ad$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$15022e88a09b93ad$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$15022e88a09b93ad$exports = function isEqual(a, b) {
    try {
        return $15022e88a09b93ad$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};






var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");
var $b5f8c2bb790c7af7$exports = {};
// `victory-vendor/d3-ease` (CommonJS)
// See upstream license: https://github.com/d3/d3-ease/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$b5f8c2bb790c7af7$exports = (parcelRequire("9E7Nf"));




var $5f4f26258a43ff44$exports = {};
// `victory-vendor/d3-interpolate` (CommonJS)
// See upstream license: https://github.com/d3/d3-interpolate/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$5f4f26258a43ff44$exports = (parcelRequire("dup5t"));


var $4fb45c62278ecbaa$export$cba20409e1d05b93 = function(obj) {
    // d3 turns null into 0 and undefined into NaN, which we don't want.
    if (obj !== null) switch(typeof obj){
        case "undefined":
            return false;
        case "number":
            // The standard `isNaN` is fine in this case since we already know the
            // type is number.
            return !isNaN(obj) && obj !== Number.POSITIVE_INFINITY && obj !== Number.NEGATIVE_INFINITY;
        case "string":
            // d3 might not *actually* be able to interpolate the string, but it
            // won't cause any issues to let it try.
            return true;
        case "boolean":
            // d3 turns Booleans into integers, which we don't want. Sure, we could
            // interpolate from 0 -> 1, but we'd be sending a non-Boolean to
            // something expecting a Boolean.
            return false;
        case "object":
            // Don't try to interpolate class instances (except Date or Array).
            return obj instanceof Date || Array.isArray(obj) || (0, (/*@__PURE__*/$parcel$interopDefault($2537df67cd52c170$exports)))(obj);
        case "function":
            // Careful! There may be extra properties on function objects that the
            // component expects to access - for instance, it may be a `d3.scale()`
            // function, which has its own methods attached. We don't know if the
            // component is only going to call the function (in which case it's
            // safely interpolatable) or if it's going to access special properties
            // (in which case our function generated from `interpolateFunction` will
            // most likely cause an error). We could check for enumerable properties
            // on the function object here to see if it's a "plain" function, but
            // let's just require that components prevent such function props from
            // being animated in the first place.
            return true;
    }
    return false;
};
var $4fb45c62278ecbaa$export$f76954aac51af8c5 = function(a, b) {
    var when = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    return function(t) {
        return t < when ? a : b;
    };
};
var $4fb45c62278ecbaa$export$2fc95e9ab031fc07 = function(a, b) {
    return function(t) {
        if (t >= 1) return b;
        return function() {
            /* eslint-disable no-invalid-this, prefer-rest-params */ var aval = typeof a === "function" ? a.apply(this, arguments) : a;
            var bval = typeof b === "function" ? b.apply(this, arguments) : b;
            return (0, $5f4f26258a43ff44$exports.interpolate)(aval, bval)(t);
        };
    };
};
var $4fb45c62278ecbaa$export$519591f2c2d9d471 = function(a, b) {
    var interpolateTypes = function(x, y) {
        if (x === y || !$4fb45c62278ecbaa$export$cba20409e1d05b93(x) || !$4fb45c62278ecbaa$export$cba20409e1d05b93(y)) return $4fb45c62278ecbaa$export$f76954aac51af8c5(x, y);
        if (typeof x === "function" || typeof y === "function") return $4fb45c62278ecbaa$export$2fc95e9ab031fc07(x, y);
        if (typeof x === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($2537df67cd52c170$exports)))(x) || typeof y === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($2537df67cd52c170$exports)))(y)) return $4fb45c62278ecbaa$export$519591f2c2d9d471(x, y);
        return (0, $5f4f26258a43ff44$exports.interpolate)(x, y);
    }; // When the value is an array, attempt to sort by "key" so that animating nodes may be identified
    // based on "key" instead of index
    var keyData = function(val) {
        return Array.isArray(val) ? (0, (/*@__PURE__*/$parcel$interopDefault($b863eb497ad75781$exports)))(val, "key") : val;
    };
    var i = {};
    var c = {};
    var k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = interpolateTypes(keyData(a[k]), keyData(b[k]));
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
};
var $4fb45c62278ecbaa$export$de0eccd23789e6b9 = function(a, b) {
    var format = function(val) {
        return typeof val === "string" ? val.replace(/,/g, "") : val;
    };
    return (0, $5f4f26258a43ff44$exports.interpolate)(format(a), format(b));
};
var $4fb45c62278ecbaa$export$2e56577c05769b16 = function(a, b) {
    // If the values are strictly equal, or either value is not interpolatable,
    // just use either the start value `a` or end value `b` at every step, as
    // there is no reasonable in-between value.
    if (a === b || !$4fb45c62278ecbaa$export$cba20409e1d05b93(a) || !$4fb45c62278ecbaa$export$cba20409e1d05b93(b)) return $4fb45c62278ecbaa$export$f76954aac51af8c5(a, b);
    if (typeof a === "function" || typeof b === "function") return $4fb45c62278ecbaa$export$2fc95e9ab031fc07(a, b);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($2537df67cd52c170$exports)))(a) || (0, (/*@__PURE__*/$parcel$interopDefault($2537df67cd52c170$exports)))(b)) // @ts-expect-error These generics are tough, but they work :)
    return $4fb45c62278ecbaa$export$519591f2c2d9d471(a, b);
    if (typeof a === "string" || typeof b === "string") return $4fb45c62278ecbaa$export$de0eccd23789e6b9(a, b);
     // @ts-expect-error These generics are tough, but they work :)
    return (0, $5f4f26258a43ff44$exports.interpolate)(a, b);
};



var $8T3gX = parcelRequire("8T3gX");
var $2754ee372409b260$exports = {};
// `victory-vendor/d3-timer` (CommonJS)
// See upstream license: https://github.com/d3/d3-timer/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$2754ee372409b260$exports = (parcelRequire("iCY1N"));


function $660582e7f0fa66d1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $660582e7f0fa66d1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $660582e7f0fa66d1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $660582e7f0fa66d1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $660582e7f0fa66d1$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $660582e7f0fa66d1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Timer() {
        var _this = this;
        $660582e7f0fa66d1$var$_classCallCheck(this, Timer);
        this.shouldAnimate = void 0;
        this.subscribers = void 0;
        this.activeSubscriptions = void 0;
        this.timer = void 0;
        this.loop = function() {
            _this.subscribers.forEach(function(s) {
                s.callback((0, $2754ee372409b260$exports.now)() - s.startTime, s.duration);
            });
        };
        this.shouldAnimate = true;
        this.subscribers = [];
        this.timer = null;
        this.activeSubscriptions = 0;
    }
    $660582e7f0fa66d1$var$_createClass(Timer, [
        {
            key: "bypassAnimation",
            value: function bypassAnimation() {
                this.shouldAnimate = false;
            }
        },
        {
            key: "resumeAnimation",
            value: function resumeAnimation() {
                this.shouldAnimate = true;
            }
        },
        {
            key: "start",
            value: function start() {
                if (!this.timer) this.timer = (0, $2754ee372409b260$exports.timer)(this.loop);
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.timer) {
                    this.timer.stop();
                    this.timer = null;
                }
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback, duration) {
                duration = this.shouldAnimate ? duration : 0;
                var subscriptionID = this.subscribers.push({
                    startTime: (0, $2754ee372409b260$exports.now)(),
                    callback: callback,
                    duration: duration
                });
                this.activeSubscriptions++;
                this.start();
                return subscriptionID;
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(id) {
                if (id !== null && this.subscribers[id - 1]) {
                    delete this.subscribers[id - 1];
                    this.activeSubscriptions--;
                }
                if (this.activeSubscriptions === 0) this.stop();
            }
        }
    ]);
    return Timer;
}();


/**
 * The React context object consumers may use to access or override the global
 * timer.
 */ var $fb8bdbdaa14fb6cc$var$TimerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createContext({
    transitionTimer: new (0, $660582e7f0fa66d1$export$2e2bcd8739ae039)(),
    animationTimer: new (0, $660582e7f0fa66d1$export$2e2bcd8739ae039)()
});
$fb8bdbdaa14fb6cc$var$TimerContext.displayName = "TimerContext";
var $fb8bdbdaa14fb6cc$export$2e2bcd8739ae039 = $fb8bdbdaa14fb6cc$var$TimerContext;



function $a937487f633fa03a$var$_toConsumableArray(arr) {
    return $a937487f633fa03a$var$_arrayWithoutHoles(arr) || $a937487f633fa03a$var$_iterableToArray(arr) || $a937487f633fa03a$var$_unsupportedIterableToArray(arr) || $a937487f633fa03a$var$_nonIterableSpread();
}
function $a937487f633fa03a$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a937487f633fa03a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a937487f633fa03a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a937487f633fa03a$var$_arrayLikeToArray(o, minLen);
}
function $a937487f633fa03a$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $a937487f633fa03a$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $a937487f633fa03a$var$_arrayLikeToArray(arr);
}
function $a937487f633fa03a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a937487f633fa03a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a937487f633fa03a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a937487f633fa03a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a937487f633fa03a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a937487f633fa03a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $a937487f633fa03a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $a937487f633fa03a$var$_setPrototypeOf(subClass, superClass);
}
function $a937487f633fa03a$var$_setPrototypeOf(o, p) {
    $a937487f633fa03a$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a937487f633fa03a$var$_setPrototypeOf(o, p);
}
function $a937487f633fa03a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a937487f633fa03a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $a937487f633fa03a$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $a937487f633fa03a$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $a937487f633fa03a$var$_possibleConstructorReturn(this, result);
    };
}
function $a937487f633fa03a$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $a937487f633fa03a$var$_assertThisInitialized(self);
}
function $a937487f633fa03a$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a937487f633fa03a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $a937487f633fa03a$var$_getPrototypeOf(o) {
    $a937487f633fa03a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a937487f633fa03a$var$_getPrototypeOf(o);
}
var $a937487f633fa03a$export$11422af84eae8331 = /*#__PURE__*/ function(_React$Component) {
    $a937487f633fa03a$var$_inherits(VictoryAnimation, _React$Component);
    var _super = $a937487f633fa03a$var$_createSuper(VictoryAnimation);
    function VictoryAnimation(props, context) {
        var _this;
        $a937487f633fa03a$var$_classCallCheck(this, VictoryAnimation);
        _this = _super.call(this, props, context);
        /* defaults */ _this.interpolator = void 0;
        _this.queue = void 0;
        _this.ease = void 0;
        _this.timer = void 0;
        _this.loopID = void 0;
        _this.functionToBeRunEachFrame = function(elapsed, duration) {
            /*
        step can generate imprecise values, sometimes greater than 1
        if this happens set the state to 1 and return, cancelling the timer
      */ duration = duration !== undefined ? duration : _this.props.duration;
            var step = duration ? elapsed / duration : 1;
            if (step >= 1) {
                _this.setState({
                    data: _this.interpolator(1),
                    animationInfo: {
                        progress: 1,
                        animating: false,
                        terminating: true
                    }
                });
                if (_this.loopID) _this.timer.unsubscribe(_this.loopID);
                _this.queue.shift();
                _this.traverseQueue();
                return;
            }
            /*
        if we're not at the end of the timer, set the state by passing
        current step value that's transformed by the ease function to the
        interpolator, which is cached for performance whenever props are received
      */ _this.setState({
                data: _this.interpolator(_this.ease(step)),
                animationInfo: {
                    progress: step,
                    animating: step < 1
                }
            });
        };
        _this.state = {
            data: Array.isArray(_this.props.data) ? _this.props.data[0] : _this.props.data,
            animationInfo: {
                progress: 0,
                animating: false
            }
        };
        _this.interpolator = null;
        _this.queue = Array.isArray(_this.props.data) ? _this.props.data.slice(1) : [];
        /* build easing function */ _this.ease = $b5f8c2bb790c7af7$exports[_this.toNewName(_this.props.easing)];
        _this.timer = _this.context.animationTimer;
        return _this;
    }
    $a937487f633fa03a$var$_createClass(VictoryAnimation, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                // Length check prevents us from triggering `onEnd` in `traverseQueue`.
                if (this.queue.length) this.traverseQueue();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var equalProps = (0, (/*@__PURE__*/$parcel$interopDefault($15022e88a09b93ad$exports)))(this.props, prevProps);
                if (!equalProps) {
                    /* If the previous animation didn't finish, force it to complete before starting a new one */ if (this.interpolator && this.state.animationInfo && this.state.animationInfo.progress < 1) // eslint-disable-next-line react/no-did-update-set-state
                    this.setState({
                        data: this.interpolator(1),
                        animationInfo: {
                            progress: 1,
                            animating: false,
                            terminating: true
                        }
                    });
                    else {
                        /* cancel existing loop if it exists */ this.timer.unsubscribe(this.loopID);
                        /* If an object was supplied */ if (!Array.isArray(this.props.data)) {
                            // Replace the tween queue. Could set `this.queue = [nextProps.data]`,
                            // but let's reuse the same array.
                            this.queue.length = 0;
                            this.queue.push(this.props.data);
                        /* If an array was supplied */ } else {
                            var _this$queue;
                            /* Extend the tween queue */ (_this$queue = this.queue).push.apply(_this$queue, $a937487f633fa03a$var$_toConsumableArray(this.props.data));
                        }
                        /* Start traversing the tween queue */ this.traverseQueue();
                    }
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.loopID) this.timer.unsubscribe(this.loopID);
                else this.timer.stop();
            }
        },
        {
            key: "toNewName",
            value: function toNewName(ease) {
                // d3-ease changed the naming scheme for ease from "linear" -> "easeLinear" etc.
                var capitalize = function(s) {
                    return s && s[0].toUpperCase() + s.slice(1);
                };
                return "ease".concat(capitalize(ease));
            }
        },
        {
            key: "traverseQueue",
            value: function traverseQueue() {
                var _this2 = this;
                if (this.queue.length) {
                    /* Get the next index */ var data = this.queue[0];
                    /* compare cached version to next props */ this.interpolator = (0, $4fb45c62278ecbaa$export$2e56577c05769b16)(this.state.data, data);
                    /* reset step to zero */ if (this.props.delay) setTimeout(function() {
                        _this2.loopID = _this2.timer.subscribe(_this2.functionToBeRunEachFrame, _this2.props.duration);
                    }, this.props.delay);
                    else this.loopID = this.timer.subscribe(this.functionToBeRunEachFrame, this.props.duration);
                } else if (this.props.onEnd) this.props.onEnd();
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children(this.state.data, this.state.animationInfo);
            }
        }
    ]);
    return VictoryAnimation;
}((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Component);
$a937487f633fa03a$export$11422af84eae8331.displayName = "VictoryAnimation";
$a937487f633fa03a$export$11422af84eae8331.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    data: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array
    ]),
    delay: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    duration: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    easing: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        "back",
        "backIn",
        "backOut",
        "backInOut",
        "bounce",
        "bounceIn",
        "bounceOut",
        "bounceInOut",
        "circle",
        "circleIn",
        "circleOut",
        "circleInOut",
        "linear",
        "linearIn",
        "linearOut",
        "linearInOut",
        "cubic",
        "cubicIn",
        "cubicOut",
        "cubicInOut",
        "elastic",
        "elasticIn",
        "elasticOut",
        "elasticInOut",
        "exp",
        "expIn",
        "expOut",
        "expInOut",
        "poly",
        "polyIn",
        "polyOut",
        "polyInOut",
        "quad",
        "quadIn",
        "quadOut",
        "quadInOut",
        "sin",
        "sinIn",
        "sinOut",
        "sinInOut"
    ]),
    onEnd: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
};
$a937487f633fa03a$export$11422af84eae8331.defaultProps = {
    data: {},
    delay: 0,
    duration: 1000,
    easing: "quadInOut"
};
$a937487f633fa03a$export$11422af84eae8331.contextType = (0, $fb8bdbdaa14fb6cc$export$2e2bcd8739ae039);










var $8T3gX = parcelRequire("8T3gX");
function $524d0cfad536a1ac$var$getDatumKey(datum, idx) {
    return (datum.key || idx).toString();
}
function $524d0cfad536a1ac$var$getKeyedData(data) {
    return data.reduce(function(keyedData, datum, idx) {
        var key = $524d0cfad536a1ac$var$getDatumKey(datum, idx);
        keyedData[key] = datum;
        return keyedData;
    }, {});
}
function $524d0cfad536a1ac$var$getKeyedDataDifference(a, b) {
    var hasDifference = false;
    var difference = (0, (/*@__PURE__*/$parcel$interopDefault($9c7d1fa85e24a67e$exports)))(a).reduce(function(_difference, key) {
        if (!(key in b)) {
            hasDifference = true;
            _difference[key] = true;
        }
        return _difference;
    }, {});
    return hasDifference && difference;
}
/**
 * Calculate which data-points exist in oldData and not nextData -
 * these are the `exiting` data-points.  Also calculate which
 * data-points exist in nextData and not oldData - these are the
 * `entering` data-points.
 *
 * @param  {Array} oldData   this.props.data Array
 * @param  {Array} nextData  this.props.data Array
 *
 * @return {Object}          Object with `entering` and `exiting` properties.
 *                           entering[datum.key] will be true if the data is
 *                           entering, and similarly for `exiting`.
 */ function $524d0cfad536a1ac$var$getNodeTransitions(oldData, nextData) {
    var oldDataKeyed = oldData && $524d0cfad536a1ac$var$getKeyedData(oldData);
    var nextDataKeyed = nextData && $524d0cfad536a1ac$var$getKeyedData(nextData);
    return {
        entering: oldDataKeyed && $524d0cfad536a1ac$var$getKeyedDataDifference(nextDataKeyed, oldDataKeyed),
        exiting: nextDataKeyed && $524d0cfad536a1ac$var$getKeyedDataDifference(oldDataKeyed, nextDataKeyed)
    };
}
function $524d0cfad536a1ac$var$getChildData(child) {
    if (child.type && child.type.getData) return child.type.getData(child.props);
    return child.props && child.props.data || false;
}
function $524d0cfad536a1ac$export$bb6f0ae72af8f4e4(oldChildren, nextChildren) {
    var nodesWillExit = false;
    var nodesWillEnter = false;
    var getTransition = function(oldChild, newChild) {
        if (!newChild || oldChild.type !== newChild.type) return {};
        var _ref = $524d0cfad536a1ac$var$getNodeTransitions($524d0cfad536a1ac$var$getChildData(oldChild), $524d0cfad536a1ac$var$getChildData(newChild)) || {}, entering = _ref.entering, exiting = _ref.exiting;
        nodesWillExit = nodesWillExit || !!exiting;
        nodesWillEnter = nodesWillEnter || !!entering;
        return {
            entering: entering || false,
            exiting: exiting || false
        };
    };
    var getTransitionsFromChildren = function(old, next) {
        return old.map(function(child, idx) {
            if (child && child.props && child.props.children && next[idx]) return getTransitionsFromChildren((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(old[idx].props.children), (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(next[idx].props.children));
             // get Transition entering and exiting nodes
            return getTransition(child, next[idx]);
        });
    };
    var childrenTransitions = getTransitionsFromChildren((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(oldChildren), (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(nextChildren));
    return {
        nodesWillExit: nodesWillExit,
        nodesWillEnter: nodesWillEnter,
        childrenTransitions: childrenTransitions,
        // TODO: This may need to be refactored for the following situation.
        //       The component receives new props, and the data provided
        //       is a perfect match for the previous data and domain except
        //       for new nodes. In this case, we wouldn't want a delay before
        //       the new nodes appear.
        nodesShouldEnter: false
    };
}
function $524d0cfad536a1ac$var$getInitialChildProps(animate, data) {
    var after = animate.onEnter && animate.onEnter.after ? animate.onEnter.after : (0, (/*@__PURE__*/$parcel$interopDefault($30121ce9c4b4eb3d$exports)));
    return {
        data: data.map(function(datum, idx) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, datum, after(datum, idx, data));
        })
    };
} // eslint-disable-next-line max-params
function $524d0cfad536a1ac$var$getChildBeforeLoad(animate, child, data, cb) {
    animate = (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, animate, {
        onEnd: cb
    });
    if (animate && animate.onLoad && !animate.onLoad.duration) return {
        animate: animate,
        data: data
    };
    var before = animate.onLoad && animate.onLoad.before ? animate.onLoad.before : (0, (/*@__PURE__*/$parcel$interopDefault($30121ce9c4b4eb3d$exports))); // If nodes need to exit, transform them with the provided onLoad.before function.
    data = data.map(function(datum, idx) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, datum, before(datum, idx, data));
    });
    return {
        animate: animate,
        data: data,
        clipWidth: 0
    };
} // eslint-disable-next-line max-params
function $524d0cfad536a1ac$var$getChildOnLoad(animate, data, cb) {
    animate = (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, animate, {
        onEnd: cb
    });
    if (animate && animate.onLoad && !animate.onLoad.duration) return {
        animate: animate,
        data: data
    };
    var after = animate.onLoad && animate.onLoad.after ? animate.onLoad.after : (0, (/*@__PURE__*/$parcel$interopDefault($30121ce9c4b4eb3d$exports))); // If nodes need to exit, transform them with the provided onLoad.after function.
    data = data.map(function(datum, idx) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, datum, after(datum, idx, data));
    });
    return {
        animate: animate,
        data: data
    };
} // eslint-disable-next-line max-params, max-len
function $524d0cfad536a1ac$var$getChildPropsOnExit(animate, child, data, exitingNodes, cb) {
    // Whether or not _this_ child has exiting nodes, we want the exit-
    // transition for all children to have the same duration, delay, etc.
    var onExit = animate && animate.onExit;
    animate = (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, animate, onExit);
    if (exitingNodes) {
        // After the exit transition occurs, trigger the animations for
        // nodes that are neither exiting nor entering.
        animate.onEnd = cb;
        var before = animate.onExit && animate.onExit.before ? animate.onExit.before : (0, (/*@__PURE__*/$parcel$interopDefault($30121ce9c4b4eb3d$exports))); // If nodes need to exit, transform them with the provided onExit.before function.
        data = data.map(function(datum, idx) {
            var key = (datum.key || idx).toString();
            return exitingNodes[key] ? (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, datum, before(datum, idx, data)) : datum;
        });
    }
    return {
        animate: animate,
        data: data
    };
} // eslint-disable-next-line max-params,max-len
function $524d0cfad536a1ac$var$getChildPropsBeforeEnter(animate, child, data, enteringNodes, cb) {
    if (enteringNodes) {
        // Perform a normal animation here, except - when it finishes - trigger
        // the transition for entering nodes.
        animate = (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, animate, {
            onEnd: cb
        });
        var before = animate.onEnter && animate.onEnter.before ? animate.onEnter.before : (0, (/*@__PURE__*/$parcel$interopDefault($30121ce9c4b4eb3d$exports))); // We want the entering nodes to be included in the transition target
        // domain.  However, we may not want these nodes to be displayed initially,
        // so perform the `onEnter.before` transformation on each node.
        data = data.map(function(datum, idx) {
            var key = (datum.key || idx).toString();
            return enteringNodes[key] ? (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, datum, before(datum, idx, data)) : datum;
        });
    }
    return {
        animate: animate,
        data: data
    };
} // eslint-disable-next-line max-params, max-len
function $524d0cfad536a1ac$var$getChildPropsOnEnter(animate, data, enteringNodes, cb) {
    // Whether or not _this_ child has entering nodes, we want the entering-
    // transition for all children to have the same duration, delay, etc.
    var onEnter = animate && animate.onEnter;
    animate = (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, animate, onEnter);
    if (enteringNodes) {
        // Old nodes have been transitioned to their new values, and the
        // domain should encompass the nodes that will now enter. So perform
        // the `onEnter.after` transformation on each node.
        animate.onEnd = cb;
        var after = animate.onEnter && animate.onEnter.after ? animate.onEnter.after : (0, (/*@__PURE__*/$parcel$interopDefault($30121ce9c4b4eb3d$exports)));
        data = data.map(function(datum, idx) {
            var key = $524d0cfad536a1ac$var$getDatumKey(datum, idx);
            return enteringNodes[key] ? (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, datum, after(datum, idx, data)) : datum;
        });
    }
    return {
        animate: animate,
        data: data
    };
}
function $524d0cfad536a1ac$export$6b6ada6937a70120(props, state, setState) {
    var nodesWillExit = state && state.nodesWillExit;
    var nodesWillEnter = state && state.nodesWillEnter;
    var nodesShouldEnter = state && state.nodesShouldEnter;
    var nodesShouldLoad = state && state.nodesShouldLoad;
    var nodesDoneLoad = state && state.nodesDoneLoad;
    var childrenTransitions = state && state.childrenTransitions || [];
    var transitionDurations = {
        enter: props.animate && props.animate.onEnter && props.animate.onEnter.duration,
        exit: props.animate && props.animate.onExit && props.animate.onExit.duration,
        load: props.animate && props.animate.onLoad && props.animate.onLoad.duration,
        move: props.animate && props.animate.duration
    };
    var onLoad = function(child, data, animate) {
        if (nodesShouldLoad) return $524d0cfad536a1ac$var$getChildOnLoad(animate, data, function() {
            setState({
                nodesShouldLoad: false,
                nodesDoneLoad: true
            });
        });
        return $524d0cfad536a1ac$var$getChildBeforeLoad(animate, child, data, function() {
            setState({
                nodesDoneLoad: true
            });
        });
    }; // eslint-disable-next-line max-params
    var onExit = function(nodes, child, data, animate) {
        return $524d0cfad536a1ac$var$getChildPropsOnExit(animate, child, data, nodes, function() {
            setState({
                nodesWillExit: false
            });
        });
    }; // eslint-disable-next-line max-params
    var onEnter = function(nodes, child, data, animate) {
        if (nodesShouldEnter) return $524d0cfad536a1ac$var$getChildPropsOnEnter(animate, data, nodes, function() {
            setState({
                nodesWillEnter: false
            });
        });
        return $524d0cfad536a1ac$var$getChildPropsBeforeEnter(animate, child, data, nodes, function() {
            setState({
                nodesShouldEnter: true
            });
        });
    };
    var getChildTransitionDuration = function(child, type) {
        var animate = child.props.animate;
        if (!child.type) return {};
        var defaultTransitions = child.props && child.props.polar ? child.type.defaultPolarTransitions || child.type.defaultTransitions : child.type.defaultTransitions;
        if (defaultTransitions) {
            var animationDuration = animate[type] && animate[type].duration;
            return animationDuration !== undefined ? animationDuration : defaultTransitions[type] && defaultTransitions[type].duration;
        }
        return {};
    }; // eslint-disable-next-line max-statements, complexity, max-len
    return function getTransitionProps(child, index) {
        var data = $524d0cfad536a1ac$var$getChildData(child) || [];
        var animate = (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, props.animate, child.props.animate);
        var defaultTransitions = child.props.polar ? child.type.defaultPolarTransitions || child.type.defaultTransitions : child.type.defaultTransitions;
        animate.onExit = (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, animate.onExit, defaultTransitions && defaultTransitions.onExit);
        animate.onEnter = (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, animate.onEnter, defaultTransitions && defaultTransitions.onEnter);
        animate.onLoad = (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, animate.onLoad, defaultTransitions && defaultTransitions.onLoad);
        var childTransitions = childrenTransitions[index] || childrenTransitions[0];
        if (!nodesDoneLoad) {
            // should do onLoad animation
            var load = transitionDurations.load !== undefined ? transitionDurations.load : getChildTransitionDuration(child, "onLoad");
            var animation = {
                duration: load
            };
            return onLoad(child, data, (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, animate, animation));
        } else if (nodesWillExit) {
            var exitingNodes = childTransitions && childTransitions.exiting;
            var exit = transitionDurations.exit !== undefined ? transitionDurations.exit : getChildTransitionDuration(child, "onExit"); // if nodesWillExit, but this child has no exiting nodes, set a delay instead of a duration
            var _animation = exitingNodes ? {
                duration: exit
            } : {
                delay: exit
            };
            return onExit(exitingNodes, child, data, (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, animate, _animation));
        } else if (nodesWillEnter) {
            var enteringNodes = childTransitions && childTransitions.entering;
            var enter = transitionDurations.enter !== undefined ? transitionDurations.enter : getChildTransitionDuration(child, "onEnter");
            var move = transitionDurations.move !== undefined ? transitionDurations.move : child.props.animate && child.props.animate.duration;
            var _animation2 = {
                duration: nodesShouldEnter && enteringNodes ? enter : move
            };
            return onEnter(enteringNodes, child, data, (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, animate, _animation2));
        } else if (!state && animate && animate.onExit) // This is the initial render, and nodes may enter when props change. Because
        // animation interpolation is determined by old- and next- props, data may need
        // to be augmented with certain properties.
        //
        // For example, it may be desired that exiting nodes go from `opacity: 1` to
        // `opacity: 0`. Without setting this on a per-datum basis, the interpolation
        // might go from `opacity: undefined` to `opacity: 0`, which would result in
        // interpolated `opacity: NaN` values.
        //
        return $524d0cfad536a1ac$var$getInitialChildProps(animate, data);
        return {
            animate: animate,
            data: data
        };
    };
}



function $da20f519b879985c$var$_extends() {
    $da20f519b879985c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $da20f519b879985c$var$_extends.apply(this, arguments);
}
function $da20f519b879985c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $da20f519b879985c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $da20f519b879985c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $da20f519b879985c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $da20f519b879985c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $da20f519b879985c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $da20f519b879985c$var$_setPrototypeOf(subClass, superClass);
}
function $da20f519b879985c$var$_setPrototypeOf(o, p) {
    $da20f519b879985c$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $da20f519b879985c$var$_setPrototypeOf(o, p);
}
function $da20f519b879985c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $da20f519b879985c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $da20f519b879985c$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $da20f519b879985c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $da20f519b879985c$var$_possibleConstructorReturn(this, result);
    };
}
function $da20f519b879985c$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $da20f519b879985c$var$_assertThisInitialized(self);
}
function $da20f519b879985c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $da20f519b879985c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $da20f519b879985c$var$_getPrototypeOf(o) {
    $da20f519b879985c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $da20f519b879985c$var$_getPrototypeOf(o);
}
var $da20f519b879985c$export$f4670afbcd6d45ab = /*#__PURE__*/ function(_React$Component) {
    $da20f519b879985c$var$_inherits(VictoryTransition, _React$Component);
    var _super = $da20f519b879985c$var$_createSuper(VictoryTransition);
    function VictoryTransition(props, context) {
        var _this;
        $da20f519b879985c$var$_classCallCheck(this, VictoryTransition);
        _this = _super.call(this, props, context);
        _this.continuous = void 0;
        _this.timer = void 0;
        _this.transitionProps = void 0;
        _this.state = {
            nodesShouldLoad: false,
            nodesDoneLoad: false
        };
        var child = _this.props.children;
        var polar = child.props.polar;
        _this.continuous = !polar && child.type && child.type.continuous === true;
        _this.timer = _this.context.transitionTimer;
        return _this;
    }
    $da20f519b879985c$var$_createClass(VictoryTransition, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.setState({
                    nodesShouldLoad: true
                }); // eslint-disable-line react/no-did-mount-set-state
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var _this2 = this;
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($15022e88a09b93ad$exports)))(this.props, nextProps)) {
                    this.timer.bypassAnimation();
                    this.setState(this.getTransitionState(this.props, nextProps), function() {
                        return _this2.timer.resumeAnimation();
                    });
                }
                return true;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.timer.stop();
            }
        },
        {
            key: "getTransitionState",
            value: function getTransitionState(props, nextProps) {
                var animate = props.animate;
                if (!animate) return {};
                else if (animate.parentState) {
                    var state = animate.parentState;
                    var oldProps = state.nodesWillExit ? props : null;
                    return {
                        oldProps: oldProps,
                        nextProps: nextProps
                    };
                }
                var oldChildren = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(props.children);
                var nextChildren = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(nextProps.children);
                var _Transitions$getIniti = $524d0cfad536a1ac$export$bb6f0ae72af8f4e4(oldChildren, nextChildren), nodesWillExit = _Transitions$getIniti.nodesWillExit, nodesWillEnter = _Transitions$getIniti.nodesWillEnter, childrenTransitions = _Transitions$getIniti.childrenTransitions, nodesShouldEnter = _Transitions$getIniti.nodesShouldEnter;
                return {
                    nodesWillExit: nodesWillExit,
                    nodesWillEnter: nodesWillEnter,
                    childrenTransitions: childrenTransitions,
                    nodesShouldEnter: nodesShouldEnter,
                    oldProps: nodesWillExit ? props : null,
                    nextProps: nextProps
                };
            }
        },
        {
            key: "getDomainFromChildren",
            value: function getDomainFromChildren(props, axis) {
                var getChildDomains = function(children) {
                    return children.reduce(function(memo, child) {
                        if (child.type && (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(child.type.getDomain)) {
                            var childDomain = child.props && child.type.getDomain(child.props, axis);
                            return childDomain ? memo.concat(childDomain) : memo;
                        } else if (child.props && child.props.children) return memo.concat(getChildDomains((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(child.props.children)));
                        return memo;
                    }, []);
                };
                var child = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(props.children)[0];
                var childProps = child.props || {};
                var domain = Array.isArray(childProps.domain) ? childProps.domain : childProps.domain && childProps.domain[axis];
                if (!childProps.children && domain) return domain;
                var childDomains = getChildDomains([
                    child
                ]);
                return childDomains.length === 0 ? [
                    0,
                    1
                ] : [
                    $9373b80aaace1e85$export$df8687355ccb4d94(childDomains),
                    $9373b80aaace1e85$export$a8f783d9de5392f5(childDomains)
                ];
            }
        },
        {
            key: "pickProps",
            value: function pickProps() {
                if (!this.state) return this.props;
                return this.state.nodesWillExit ? this.state.oldProps || this.props : this.props;
            }
        },
        {
            key: "pickDomainProps",
            value: function pickDomainProps(props) {
                var _props$animate;
                var parentState = (_props$animate = props.animate) === null || _props$animate === void 0 ? void 0 : _props$animate.parentState;
                if (parentState && parentState.nodesWillExit) return this.continuous || parentState.continuous ? parentState.nextProps || this.state.nextProps || props : props;
                return this.continuous && this.state.nodesWillExit ? this.state.nextProps || props : props;
            }
        },
        {
            key: "getClipWidth",
            value: function getClipWidth(props, child) {
                var getDefaultClipWidth = function() {
                    var range = $0a5de8228869aa1e$export$fef151b94550e9f5(child.props, "x");
                    return range ? Math.abs(range[1] - range[0]) : props.width;
                };
                var clipWidth = this.transitionProps ? this.transitionProps.clipWidth : undefined;
                return clipWidth !== undefined ? clipWidth : getDefaultClipWidth();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props$animate, _this3 = this;
                var props = this.pickProps();
                var getTransitionProps = (_this$props$animate = this.props.animate) !== null && _this$props$animate !== void 0 && _this$props$animate.getTransitions ? this.props.animate.getTransitions : $524d0cfad536a1ac$export$6b6ada6937a70120(props, this.state, function(newState) {
                    return _this3.setState(newState);
                });
                var child = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(props.children)[0];
                var transitionProps = getTransitionProps(child);
                this.transitionProps = transitionProps;
                var domain = {
                    x: this.getDomainFromChildren(this.pickDomainProps(props), "x"),
                    y: this.getDomainFromChildren(props, "y")
                };
                var clipWidth = this.getClipWidth(props, child);
                var combinedProps = (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({
                    domain: domain,
                    clipWidth: clipWidth
                }, transitionProps, child.props);
                var animationWhitelist = props.animationWhitelist || [];
                var whitelist = animationWhitelist.concat([
                    "clipWidth"
                ]);
                var propsToAnimate = whitelist.length ? (0, (/*@__PURE__*/$parcel$interopDefault($205d4e9b2dc98184$exports)))(combinedProps, whitelist) : combinedProps;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $a937487f633fa03a$export$11422af84eae8331), $da20f519b879985c$var$_extends({}, combinedProps.animate, {
                    data: propsToAnimate
                }), function(newProps) {
                    if (child.props.groupComponent) {
                        var groupComponent = _this3.continuous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(child.props.groupComponent, {
                            clipWidth: newProps.clipWidth || 0
                        }) : child.props.groupComponent;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(child, (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({
                            animate: null,
                            animating: true,
                            groupComponent: groupComponent
                        }, newProps, combinedProps));
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(child, (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({
                        animate: null,
                        animating: true
                    }, newProps, combinedProps));
                });
            }
        }
    ]);
    return VictoryTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Component);
$da20f519b879985c$export$f4670afbcd6d45ab.displayName = "VictoryTransition";
$da20f519b879985c$export$f4670afbcd6d45ab.propTypes = {
    animate: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    animationWhitelist: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node
};
$da20f519b879985c$export$f4670afbcd6d45ab.contextType = (0, $fb8bdbdaa14fb6cc$export$2e2bcd8739ae039);


function $93ca7d87628fcb54$var$_toConsumableArray(arr) {
    return $93ca7d87628fcb54$var$_arrayWithoutHoles(arr) || $93ca7d87628fcb54$var$_iterableToArray(arr) || $93ca7d87628fcb54$var$_unsupportedIterableToArray(arr) || $93ca7d87628fcb54$var$_nonIterableSpread();
}
function $93ca7d87628fcb54$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $93ca7d87628fcb54$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $93ca7d87628fcb54$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $93ca7d87628fcb54$var$_arrayLikeToArray(o, minLen);
}
function $93ca7d87628fcb54$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $93ca7d87628fcb54$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $93ca7d87628fcb54$var$_arrayLikeToArray(arr);
}
function $93ca7d87628fcb54$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $93ca7d87628fcb54$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $93ca7d87628fcb54$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $93ca7d87628fcb54$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $93ca7d87628fcb54$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $93ca7d87628fcb54$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $93ca7d87628fcb54$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $93ca7d87628fcb54$var$_setPrototypeOf(subClass, superClass);
}
function $93ca7d87628fcb54$var$_setPrototypeOf(o, p) {
    $93ca7d87628fcb54$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $93ca7d87628fcb54$var$_setPrototypeOf(o, p);
}
function $93ca7d87628fcb54$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $93ca7d87628fcb54$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $93ca7d87628fcb54$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $93ca7d87628fcb54$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $93ca7d87628fcb54$var$_possibleConstructorReturn(this, result);
    };
}
function $93ca7d87628fcb54$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $93ca7d87628fcb54$var$_assertThisInitialized(self);
}
function $93ca7d87628fcb54$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $93ca7d87628fcb54$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $93ca7d87628fcb54$var$_getPrototypeOf(o) {
    $93ca7d87628fcb54$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $93ca7d87628fcb54$var$_getPrototypeOf(o);
}
// DISCLAIMER:
// This file is not currently tested, and it is first on the list of files
// to refactor in our current refactoring effort. Please do not make changes
// to this file without manual testing and/or refactoring and adding tests.
var $93ca7d87628fcb54$var$datumHasXandY = function(datum) {
    return !(0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(datum._x) && !(0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(datum._y);
}; //  used for checking state changes. Expected components can be passed in via options
var $93ca7d87628fcb54$var$defaultComponents = [
    {
        name: "parent",
        index: "parent"
    },
    {
        name: "data"
    },
    {
        name: "labels"
    }
];
function $93ca7d87628fcb54$export$aadfb65bee660f96(WrappedComponent) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // @ts-expect-error "TS2545: A mixin class must have a constructor with a single rest parameter of type 'any[]'."
    var AddEventsMixin = /*#__PURE__*/ function(_WrappedComponent) {
        $93ca7d87628fcb54$var$_inherits(AddEventsMixin, _WrappedComponent);
        var _super = $93ca7d87628fcb54$var$_createSuper(AddEventsMixin);
        function AddEventsMixin(props) {
            var _this;
            $93ca7d87628fcb54$var$_classCallCheck(this, AddEventsMixin);
            _this = _super.call(this, props);
            _this.state = {};
            _this.getEventState = $617aed0754382a89$export$de3835329292aa32.bind($93ca7d87628fcb54$var$_assertThisInitialized(_this));
            _this.getScopedEvents = $617aed0754382a89$export$83e2385a599c58a3.bind($93ca7d87628fcb54$var$_assertThisInitialized(_this));
            _this.getEvents = function(p, target, eventKey) {
                return $617aed0754382a89$export$3f41ece7d7128238.call($93ca7d87628fcb54$var$_assertThisInitialized(_this), p, target, eventKey, _this.getScopedEvents);
            };
            _this.externalMutations = _this.getExternalMutations(_this.props);
            _this.calculatedState = _this.getStateChanges(_this.props);
            _this.globalEvents = {};
            _this.prevGlobalEventKeys = [];
            _this.boundGlobalEvents = {};
            _this.cacheValues(_this.getCalculatedValues(props));
            return _this;
        }
        $93ca7d87628fcb54$var$_createClass(AddEventsMixin, [
            {
                key: "shouldComponentUpdate",
                value: function shouldComponentUpdate(nextProps) {
                    var externalMutations = this.getExternalMutations(nextProps); // @ts-expect-error "Property 'animating' does not exist on type EventMixinCommonProps"
                    var animating = this.props.animating || this.props.animate;
                    var newMutation = !(0, (/*@__PURE__*/$parcel$interopDefault($15022e88a09b93ad$exports)))(externalMutations, this.externalMutations);
                    if (animating || newMutation) {
                        this.cacheValues(this.getCalculatedValues(nextProps));
                        this.externalMutations = externalMutations;
                        this.applyExternalMutations(nextProps, externalMutations);
                        return true;
                    }
                    var calculatedState = this.getStateChanges(nextProps);
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($15022e88a09b93ad$exports)))(this.calculatedState, calculatedState)) {
                        this.cacheValues(this.getCalculatedValues(nextProps));
                        return true;
                    }
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($15022e88a09b93ad$exports)))(this.props, nextProps)) {
                        this.cacheValues(this.getCalculatedValues(nextProps));
                        return true;
                    }
                    return false;
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this2 = this;
                    var globalEventKeys = (0, (/*@__PURE__*/$parcel$interopDefault($9c7d1fa85e24a67e$exports)))(this.globalEvents);
                    globalEventKeys.forEach(function(key) {
                        return _this2.addGlobalListener(key);
                    });
                    this.prevGlobalEventKeys = globalEventKeys;
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    var _this3 = this;
                    var calculatedState = this.getStateChanges(prevProps);
                    this.calculatedState = calculatedState;
                    var globalEventKeys = (0, (/*@__PURE__*/$parcel$interopDefault($9c7d1fa85e24a67e$exports)))(this.globalEvents);
                    var removedGlobalEventKeys = (0, (/*@__PURE__*/$parcel$interopDefault($faa0050d5f48da66$exports)))(this.prevGlobalEventKeys, globalEventKeys);
                    removedGlobalEventKeys.forEach(function(key) {
                        return _this3.removeGlobalListener(key);
                    });
                    var addedGlobalEventKeys = (0, (/*@__PURE__*/$parcel$interopDefault($faa0050d5f48da66$exports)))(globalEventKeys, this.prevGlobalEventKeys);
                    addedGlobalEventKeys.forEach(function(key) {
                        return _this3.addGlobalListener(key);
                    });
                    this.prevGlobalEventKeys = globalEventKeys;
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    var _this4 = this;
                    this.prevGlobalEventKeys.forEach(function(key) {
                        return _this4.removeGlobalListener(key);
                    });
                }
            },
            {
                key: "addGlobalListener",
                value: function addGlobalListener(key) {
                    var _this5 = this;
                    var boundListener = function(event) {
                        var listener = _this5.globalEvents[key];
                        return listener && listener($617aed0754382a89$export$f67e4e0bc709377c(event));
                    };
                    this.boundGlobalEvents[key] = boundListener;
                    window.addEventListener($617aed0754382a89$export$a32dcb4e36259a4e(key), boundListener);
                }
            },
            {
                key: "removeGlobalListener",
                value: function removeGlobalListener(key) {
                    window.removeEventListener($617aed0754382a89$export$a32dcb4e36259a4e(key), this.boundGlobalEvents[key]);
                } // compile all state changes from own and parent state. Order doesn't matter, as any state
            },
            {
                key: "getStateChanges",
                value: function getStateChanges(props) {
                    var _this6 = this;
                    if (!this.hasEvents) return {};
                    var getState = function(key, type) {
                        var result = (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, _this6.getEventState(key, type), _this6.getSharedEventState(key, type));
                        return (0, (/*@__PURE__*/$parcel$interopDefault($1331767f05251f48$exports)))(result) ? undefined : result;
                    };
                    var components = options.components || $93ca7d87628fcb54$var$defaultComponents;
                    var stateChanges = components.map(function(component) {
                        if (!props.standalone && component.name === "parent") // don't check for changes on parent props for non-standalone components
                        return undefined;
                        return component.index !== undefined ? getState(component.index, component.name) : _this6.dataKeys.map(function(key) {
                            return getState(key, component.name);
                        }).filter(Boolean);
                    }).filter(Boolean);
                    return stateChanges;
                }
            },
            {
                key: "applyExternalMutations",
                value: function applyExternalMutations(props, externalMutations) {
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($1331767f05251f48$exports)))(externalMutations)) {
                        var callbacks = props.externalEventMutations.reduce(function(memo, mutation) {
                            memo = (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(mutation.callback) ? memo.concat(mutation.callback) : memo;
                            return memo;
                        }, []);
                        var compiledCallbacks = callbacks.length ? function() {
                            callbacks.forEach(function(c) {
                                return c();
                            });
                        } : undefined;
                        this.setState(externalMutations, compiledCallbacks);
                    }
                }
            },
            {
                key: "getCalculatedValues",
                value: function getCalculatedValues(props) {
                    var sharedEvents = props.sharedEvents;
                    var components = WrappedComponent.expectedComponents;
                    var componentEvents = $617aed0754382a89$export$553d7b5edf647c91(props, components);
                    var getSharedEventState = sharedEvents && (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(sharedEvents.getEventState) ? sharedEvents.getEventState : function() {
                        return undefined;
                    };
                    var baseProps = this.getBaseProps(props, getSharedEventState);
                    var dataKeys = (0, (/*@__PURE__*/$parcel$interopDefault($9c7d1fa85e24a67e$exports)))(baseProps).filter(function(key) {
                        return key !== "parent";
                    });
                    var hasEvents = props.events || props.sharedEvents || componentEvents;
                    var events = this.getAllEvents(props);
                    return {
                        componentEvents: componentEvents,
                        getSharedEventState: getSharedEventState,
                        baseProps: baseProps,
                        dataKeys: dataKeys,
                        hasEvents: hasEvents,
                        events: events
                    };
                }
            },
            {
                key: "getExternalMutations",
                value: function getExternalMutations(props) {
                    var sharedEvents = props.sharedEvents, externalEventMutations = props.externalEventMutations;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($1331767f05251f48$exports)))(externalEventMutations) || sharedEvents ? undefined : $617aed0754382a89$export$569063dd8d69bab3(externalEventMutations, this.baseProps, this.state);
                }
            },
            {
                key: "cacheValues",
                value: function cacheValues(obj) {
                    var _this7 = this;
                    (0, (/*@__PURE__*/$parcel$interopDefault($9c7d1fa85e24a67e$exports)))(obj).forEach(function(key) {
                        _this7[key] = obj[key];
                    });
                }
            },
            {
                key: "getBaseProps",
                value: function getBaseProps(props, getSharedEventState) {
                    getSharedEventState = getSharedEventState || this.getSharedEventState.bind(this);
                    var sharedParentState = getSharedEventState("parent", "parent");
                    var parentState = this.getEventState("parent", "parent");
                    var baseParentProps = (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, parentState, sharedParentState);
                    var parentPropsList = baseParentProps.parentControlledProps;
                    var parentProps = parentPropsList ? (0, (/*@__PURE__*/$parcel$interopDefault($205d4e9b2dc98184$exports)))(baseParentProps, parentPropsList) : {};
                    var modifiedProps = (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, parentProps, props);
                    return typeof WrappedComponent.getBaseProps === "function" ? WrappedComponent.getBaseProps(modifiedProps) : {};
                }
            },
            {
                key: "getAllEvents",
                value: function getAllEvents(props) {
                    if (Array.isArray(this.componentEvents)) {
                        var _this$componentEvents;
                        return Array.isArray(props.events) ? (_this$componentEvents = this.componentEvents).concat.apply(_this$componentEvents, $93ca7d87628fcb54$var$_toConsumableArray(props.events)) : this.componentEvents;
                    }
                    return props.events;
                }
            },
            {
                key: "getComponentProps",
                value: function getComponentProps(component, type, index) {
                    var name = this.props.name || WrappedComponent.role;
                    var key = this.dataKeys && this.dataKeys[index] || index;
                    var id = "".concat(name, "-").concat(type, "-").concat(key);
                    var baseProps = this.baseProps[key] && this.baseProps[key][type] || this.baseProps[key];
                    if (!baseProps && !this.hasEvents) return undefined;
                    if (this.hasEvents) {
                        var baseEvents = this.getEvents(this.props, type, key);
                        var componentProps = (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({
                            index: index,
                            key: id
                        }, this.getEventState(key, type), this.getSharedEventState(key, type), component.props, baseProps, {
                            id: id
                        });
                        var events = (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, $617aed0754382a89$export$19e5623225f61ca7(baseEvents, key, componentProps), componentProps.events);
                        return (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, componentProps, {
                            events: events
                        });
                    }
                    return (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({
                        index: index,
                        key: id
                    }, component.props, baseProps, {
                        id: id
                    });
                }
            },
            {
                key: "renderContainer",
                value: function renderContainer(component, children) {
                    var isContainer = component.type && component.type.role === "container";
                    var parentProps = isContainer ? this.getComponentProps(component, "parent", "parent") : {};
                    if (parentProps.events) {
                        this.globalEvents = $617aed0754382a89$export$1e2d2a8dd008ed46(parentProps.events);
                        parentProps.events = $617aed0754382a89$export$3e07820b9c881f93(parentProps.events);
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(component, parentProps, children);
                }
            },
            {
                key: "animateComponent",
                value: function animateComponent(props, defaultAnimationWhitelist) {
                    var _props$animate;
                    var animationWhitelist = typeof props.animate === "object" && ((_props$animate = props.animate) === null || _props$animate === void 0 ? void 0 : _props$animate.animationWhitelist) || defaultAnimationWhitelist;
                    var Comp = this.constructor;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $da20f519b879985c$export$f4670afbcd6d45ab), {
                        animate: props.animate,
                        animationWhitelist: animationWhitelist
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement(Comp, props));
                } // Used by `VictoryLine` and `VictoryArea`
            },
            {
                key: "renderContinuousData",
                value: function renderContinuousData(props) {
                    var _this8 = this;
                    var dataComponent = props.dataComponent, labelComponent = props.labelComponent, groupComponent = props.groupComponent;
                    var dataKeys = (0, (/*@__PURE__*/$parcel$interopDefault($a58ee22f5be18a99$exports)))(this.dataKeys, "all");
                    var labelComponents = dataKeys.reduce(function(memo, key) {
                        var labelProps = _this8.getComponentProps(labelComponent, "labels", key);
                        if (labelProps && labelProps.text !== undefined && labelProps.text !== null) memo = memo.concat(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(labelComponent, labelProps));
                        return memo;
                    }, []);
                    var dataProps = this.getComponentProps(dataComponent, "data", "all");
                    var children = [
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(dataComponent, dataProps)
                    ].concat($93ca7d87628fcb54$var$_toConsumableArray(labelComponents));
                    return this.renderContainer(groupComponent, children);
                }
            },
            {
                key: "renderData",
                value: function renderData(props) {
                    var _this9 = this;
                    var shouldRenderDatum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $93ca7d87628fcb54$var$datumHasXandY;
                    var dataComponent = props.dataComponent, labelComponent = props.labelComponent, groupComponent = props.groupComponent;
                    var dataComponents = this.dataKeys.reduce(function(validDataComponents, _dataKey, index) {
                        var dataProps = _this9.getComponentProps(dataComponent, "data", index);
                        if (shouldRenderDatum(dataProps.datum)) validDataComponents.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(dataComponent, dataProps));
                        return validDataComponents;
                    }, []);
                    var labelComponents = this.dataKeys.map(function(_dataKey, index) {
                        var labelProps = _this9.getComponentProps(labelComponent, "labels", index);
                        if (labelProps.text !== undefined && labelProps.text !== null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(labelComponent, labelProps);
                        return undefined;
                    }).filter(Boolean);
                    var children = [].concat($93ca7d87628fcb54$var$_toConsumableArray(dataComponents), $93ca7d87628fcb54$var$_toConsumableArray(labelComponents));
                    return this.renderContainer(groupComponent, children);
                }
            }
        ]);
        return AddEventsMixin;
    }(WrappedComponent);
    return AddEventsMixin;
}

var $a9e703a4a20da87d$exports = {};

$parcel$export($a9e703a4a20da87d$exports, "getSafeUserProps", () => $a9e703a4a20da87d$export$c17686e242f4c700);
$parcel$export($a9e703a4a20da87d$exports, "withSafeUserProps", () => $a9e703a4a20da87d$export$a4ee095fe335fca8);

var $8T3gX = parcelRequire("8T3gX");
function $a9e703a4a20da87d$var$_slicedToArray(arr, i) {
    return $a9e703a4a20da87d$var$_arrayWithHoles(arr) || $a9e703a4a20da87d$var$_iterableToArrayLimit(arr, i) || $a9e703a4a20da87d$var$_unsupportedIterableToArray(arr, i) || $a9e703a4a20da87d$var$_nonIterableRest();
}
function $a9e703a4a20da87d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a9e703a4a20da87d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a9e703a4a20da87d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a9e703a4a20da87d$var$_arrayLikeToArray(o, minLen);
}
function $a9e703a4a20da87d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a9e703a4a20da87d$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a9e703a4a20da87d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a9e703a4a20da87d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a9e703a4a20da87d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a9e703a4a20da87d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a9e703a4a20da87d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a9e703a4a20da87d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a9e703a4a20da87d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/*
  USER_PROPS_SAFELIST is to contain any string deemed safe for user props.
  The startsWidth array will contain the start of any accepted user-prop that
  starts with these characters.
  The exactMatch will contain a list of exact prop names that are accepted.
*/ var $a9e703a4a20da87d$var$USER_PROPS_SAFELIST = {
    startsWith: [
        "data-",
        "aria-"
    ],
    exactMatch: []
}; // Normally we'd use Template Literal Types, but we're avoiding it to maximize TS compatibility with TS < 4.1
// `data-${string}` | `aria-${string}`;
/**
 * doesPropStartWith: Function that takes a prop's key and runs it against all
 * options in the USER_PROPS_SAFELIST and checks to see if it starts with any
 * of those options.
 * @param {string} key: prop key to be tested against whitelist
 * @returns {Boolean}: returns true if the key starts with an option or false if
 * otherwise
 */ var $a9e703a4a20da87d$var$doesPropStartWith = function(key) {
    var startsWith = false;
    $a9e703a4a20da87d$var$USER_PROPS_SAFELIST.startsWith.forEach(function(starterString) {
        var regex = new RegExp("\\b(".concat(starterString, ")(\\w|-)+"), "g");
        if (regex.test(key)) startsWith = true;
    });
    return startsWith;
};
/**
 * isExactMatch: checks to see if the given key matches any of the 'exactMatch'
 * items in the whitelist
 * @param {String} key: prop key to be tested against the whitelist-exact match
 * array.
 * @returns {Boolean}: return true if whitelist contains that key, otherwise
 * returns false.
 */ var $a9e703a4a20da87d$var$isExactMatch = function(key) {
    return $a9e703a4a20da87d$var$USER_PROPS_SAFELIST.exactMatch.includes(key);
};
/**
 * testIfSafeProp: tests prop's key against both startsWith and exactMatch values
 * @param {String} key: prop key to be tested against the whitelist
 * @returns {Boolean}: returns true if found in whitelist, otherwise returns false
 */ var $a9e703a4a20da87d$var$testIfSafeProp = function(key) {
    if ($a9e703a4a20da87d$var$doesPropStartWith(key) || $a9e703a4a20da87d$var$isExactMatch(key)) return true;
    return false;
};
/**
 * Gets the value from props if a function value is provided
 * @param {any} value: maybe function value
 * @param {Object} props: props object
 * @returns {any} newValue
 */ var $a9e703a4a20da87d$var$getValue = function(value, props) {
    if (typeof value === "function") return value(props);
    return value;
};
var $a9e703a4a20da87d$export$c17686e242f4c700 = function(props) {
    var propsToFilter = $a9e703a4a20da87d$var$_objectSpread({}, props);
    return Object.fromEntries(Object.entries(propsToFilter).filter(function(_ref) {
        var _ref2 = $a9e703a4a20da87d$var$_slicedToArray(_ref, 1), key = _ref2[0];
        return $a9e703a4a20da87d$var$testIfSafeProp(key);
    }).map(function(_ref3) {
        var _ref4 = $a9e703a4a20da87d$var$_slicedToArray(_ref3, 2), key = _ref4[0], value = _ref4[1];
        return [
            key,
            $a9e703a4a20da87d$var$getValue(value, props)
        ];
    }));
};
var $a9e703a4a20da87d$export$a4ee095fe335fca8 = function(component, props) {
    return /*#__PURE__*/ $8T3gX.cloneElement(component, $a9e703a4a20da87d$export$c17686e242f4c700(props));
};



var $601c5515cb26e353$exports = {};

/** Used to generate unique IDs. */ var $601c5515cb26e353$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $601c5515cb26e353$var$uniqueId(prefix) {
    var id = ++$601c5515cb26e353$var$idCounter;
    return $4360b921cc50ac20$exports(prefix) + id;
}
$601c5515cb26e353$exports = $601c5515cb26e353$var$uniqueId;





var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");



var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

function $87064561561942f5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $87064561561942f5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $87064561561942f5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $87064561561942f5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $87064561561942f5$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $87064561561942f5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $87064561561942f5$var$_setPrototypeOf(subClass, superClass);
}
function $87064561561942f5$var$_setPrototypeOf(o, p) {
    $87064561561942f5$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $87064561561942f5$var$_setPrototypeOf(o, p);
}
function $87064561561942f5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $87064561561942f5$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $87064561561942f5$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $87064561561942f5$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $87064561561942f5$var$_possibleConstructorReturn(this, result);
    };
}
function $87064561561942f5$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $87064561561942f5$var$_assertThisInitialized(self);
}
function $87064561561942f5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $87064561561942f5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $87064561561942f5$var$_getPrototypeOf(o) {
    $87064561561942f5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $87064561561942f5$var$_getPrototypeOf(o);
}
var $87064561561942f5$export$602eac185826482c = /*#__PURE__*/ function(_ref) {
    $87064561561942f5$var$_inherits(Portal, _ref);
    var _super = $87064561561942f5$var$_createSuper(Portal);
    function Portal(props) {
        var _this;
        $87064561561942f5$var$_classCallCheck(this, Portal);
        _this = _super.call(this, props);
        _this.map = void 0;
        _this.index = void 0;
        _this.portalRegister = function() {
            return ++_this.index;
        };
        _this.portalUpdate = function(key, element) {
            _this.map[key] = element;
            _this.forceUpdate();
        };
        _this.portalDeregister = function(key) {
            delete _this.map[key];
            _this.forceUpdate();
        };
        _this.map = {};
        _this.index = 1;
        return _this;
    }
    $87064561561942f5$var$_createClass(Portal, [
        {
            key: "getChildren",
            value: function getChildren() {
                var _this2 = this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($9c7d1fa85e24a67e$exports)))(this.map).map(function(key) {
                    var el = _this2.map[key];
                    return el ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(el, {
                        key: key
                    }) : el;
                });
            } // Overridden in victory-core-native
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("svg", this.props, this.getChildren());
            }
        }
    ]);
    return Portal;
}((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Component);
$87064561561942f5$export$602eac185826482c.displayName = "Portal";
$87064561561942f5$export$602eac185826482c.propTypes = {
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    height: $9dba2b2bbfc485d5$export$1832c645056d4ce2,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    viewBox: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    width: $9dba2b2bbfc485d5$export$1832c645056d4ce2
};



var $8T3gX = parcelRequire("8T3gX");
var $51828b9610c699de$export$60d741e20e0aa309 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createContext({});
$51828b9610c699de$export$60d741e20e0aa309.displayName = "PortalContext";





function $1433d8d5e8c8f7e5$var$_extends() {
    $1433d8d5e8c8f7e5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1433d8d5e8c8f7e5$var$_extends.apply(this, arguments);
}
function $1433d8d5e8c8f7e5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1433d8d5e8c8f7e5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1433d8d5e8c8f7e5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1433d8d5e8c8f7e5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1433d8d5e8c8f7e5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1433d8d5e8c8f7e5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1433d8d5e8c8f7e5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1433d8d5e8c8f7e5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1433d8d5e8c8f7e5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1433d8d5e8c8f7e5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1433d8d5e8c8f7e5$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $1433d8d5e8c8f7e5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $1433d8d5e8c8f7e5$var$_setPrototypeOf(subClass, superClass);
}
function $1433d8d5e8c8f7e5$var$_setPrototypeOf(o, p) {
    $1433d8d5e8c8f7e5$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1433d8d5e8c8f7e5$var$_setPrototypeOf(o, p);
}
function $1433d8d5e8c8f7e5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1433d8d5e8c8f7e5$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $1433d8d5e8c8f7e5$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $1433d8d5e8c8f7e5$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $1433d8d5e8c8f7e5$var$_possibleConstructorReturn(this, result);
    };
}
function $1433d8d5e8c8f7e5$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $1433d8d5e8c8f7e5$var$_assertThisInitialized(self);
}
function $1433d8d5e8c8f7e5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1433d8d5e8c8f7e5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $1433d8d5e8c8f7e5$var$_getPrototypeOf(o) {
    $1433d8d5e8c8f7e5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1433d8d5e8c8f7e5$var$_getPrototypeOf(o);
}
var $1433d8d5e8c8f7e5$export$b173aa1b45712272 = /*#__PURE__*/ function(_React$Component) {
    $1433d8d5e8c8f7e5$var$_inherits(VictoryContainer, _React$Component);
    var _super = $1433d8d5e8c8f7e5$var$_createSuper(VictoryContainer);
    // @ts-expect-error Ref will be initialized on mount
    // @ts-expect-error Ref will be initialized on mount
    function VictoryContainer(props) {
        var _this;
        $1433d8d5e8c8f7e5$var$_classCallCheck(this, VictoryContainer);
        _this = _super.call(this, props);
        _this.containerId = void 0;
        _this.portalRef = void 0;
        _this.containerRef = void 0;
        _this.shouldHandleWheel = void 0;
        _this.savePortalRef = function(portal) {
            _this.portalRef = portal;
            return portal;
        };
        _this.portalUpdate = function(key, el) {
            return _this.portalRef.portalUpdate(key, el);
        };
        _this.portalRegister = function() {
            return _this.portalRef.portalRegister();
        };
        _this.portalDeregister = function(key) {
            return _this.portalRef.portalDeregister(key);
        };
        _this.saveContainerRef = function(container) {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(_this.props.containerRef)) _this.props.containerRef(container);
            _this.containerRef = container;
            return container;
        };
        _this.handleWheel = function(e) {
            return e.preventDefault();
        };
        _this.containerId = !(0, (/*@__PURE__*/$parcel$interopDefault($cd2b0b1294af0960$exports)))(props) || props.containerId === undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($601c5515cb26e353$exports)))("victory-container-") : props.containerId;
        _this.shouldHandleWheel = !!(props && props.events && props.events.onWheel);
        return _this;
    }
    $1433d8d5e8c8f7e5$var$_createClass(VictoryContainer, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.shouldHandleWheel && this.containerRef) this.containerRef.addEventListener("wheel", this.handleWheel);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.shouldHandleWheel && this.containerRef) this.containerRef.removeEventListener("wheel", this.handleWheel);
            }
        },
        {
            key: "getIdForElement",
            value: function getIdForElement(elementName) {
                return "".concat(this.containerId, "-").concat(elementName);
            } // overridden in custom containers
        },
        {
            key: "getChildren",
            value: function getChildren(props) {
                return props.children;
            } // Get props defined by the Open UI Automation (OUIA) 1.0-RC spec
        },
        {
            key: "getOUIAProps",
            value: function getOUIAProps(props) {
                var ouiaId = props.ouiaId, ouiaSafe = props.ouiaSafe, ouiaType = props.ouiaType;
                return $1433d8d5e8c8f7e5$var$_objectSpread($1433d8d5e8c8f7e5$var$_objectSpread($1433d8d5e8c8f7e5$var$_objectSpread({}, ouiaId && {
                    "data-ouia-component-id": ouiaId
                }), ouiaType && {
                    "data-ouia-component-type": ouiaType
                }), ouiaSafe !== undefined && {
                    "data-ouia-safe": ouiaSafe
                });
            }
        },
        {
            key: "renderContainer",
            value: function renderContainer(props, svgProps, style) {
                var title = props.title, desc = props.desc, portalComponent = props.portalComponent, className = props.className, width = props.width, height = props.height, portalZIndex = props.portalZIndex, responsive = props.responsive;
                var children = this.getChildren(props);
                var dimensions = responsive ? {
                    width: "100%",
                    height: "100%"
                } : {
                    width: width,
                    height: height
                };
                var divStyle = (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
                    pointerEvents: "none",
                    touchAction: "none",
                    position: "relative"
                }, dimensions);
                var portalDivStyle = (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
                    zIndex: portalZIndex,
                    position: "absolute",
                    top: 0,
                    left: 0
                }, dimensions);
                var svgStyle = (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
                    pointerEvents: "all"
                }, dimensions);
                var portalSvgStyle = (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
                    overflow: "visible"
                }, dimensions);
                var portalProps = {
                    width: width,
                    height: height,
                    viewBox: svgProps.viewBox,
                    preserveAspectRatio: svgProps.preserveAspectRatio,
                    style: portalSvgStyle
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $51828b9610c699de$export$60d741e20e0aa309).Provider, {
                    value: {
                        portalUpdate: this.portalUpdate,
                        portalRegister: this.portalRegister,
                        portalDeregister: this.portalDeregister
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("div", $1433d8d5e8c8f7e5$var$_extends({
                    style: (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, style, divStyle),
                    className: className,
                    ref: this.saveContainerRef
                }, this.getOUIAProps(props)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("svg", $1433d8d5e8c8f7e5$var$_extends({}, svgProps, {
                    style: svgStyle
                }), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("title", {
                    id: this.getIdForElement("title")
                }, title) : null, desc ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("desc", {
                    id: this.getIdForElement("desc")
                }, desc) : null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("div", {
                    style: portalDivStyle
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(portalComponent, $1433d8d5e8c8f7e5$var$_objectSpread($1433d8d5e8c8f7e5$var$_objectSpread({}, portalProps), {}, {
                    ref: this.savePortalRef
                })))));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, width = _this$props.width, height = _this$props.height, responsive = _this$props.responsive, events = _this$props.events, title = _this$props.title, desc = _this$props.desc, tabIndex = _this$props.tabIndex, preserveAspectRatio = _this$props.preserveAspectRatio, role = _this$props.role;
                var style = responsive ? this.props.style : $0a5de8228869aa1e$export$30a06c8d3562193f(this.props.style, [
                    "height",
                    "width"
                ]);
                var userProps = $a9e703a4a20da87d$export$c17686e242f4c700(this.props);
                var svgProps = (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))($1433d8d5e8c8f7e5$var$_objectSpread({
                    width: width,
                    height: height,
                    tabIndex: tabIndex,
                    role: role,
                    "aria-labelledby": [
                        title && this.getIdForElement("title"),
                        this.props["aria-labelledby"]
                    ].filter(Boolean).join(" ") || undefined,
                    "aria-describedby": [
                        desc && this.getIdForElement("desc"),
                        this.props["aria-describedby"]
                    ].filter(Boolean).join(" ") || undefined,
                    viewBox: responsive ? "0 0 ".concat(width, " ").concat(height) : undefined,
                    preserveAspectRatio: responsive ? preserveAspectRatio : undefined
                }, userProps), events);
                return this.renderContainer(this.props, svgProps, style);
            }
        }
    ]);
    return VictoryContainer;
}((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Component);
$1433d8d5e8c8f7e5$export$b173aa1b45712272.displayName = "VictoryContainer";
$1433d8d5e8c8f7e5$export$b173aa1b45712272.role = "container";
$1433d8d5e8c8f7e5$export$b173aa1b45712272.propTypes = {
    "aria-describedby": (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    "aria-labelledby": (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    containerId: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    containerRef: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    desc: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    events: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    height: $9dba2b2bbfc485d5$export$1832c645056d4ce2,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    origin: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        x: $9dba2b2bbfc485d5$export$1832c645056d4ce2,
        y: $9dba2b2bbfc485d5$export$1832c645056d4ce2
    }),
    ouiaId: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    ouiaSafe: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    ouiaType: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    polar: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    portalComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    portalZIndex: $9dba2b2bbfc485d5$export$32744b5b3bba4764,
    preserveAspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    responsive: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    role: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    tabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    theme: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    width: $9dba2b2bbfc485d5$export$1832c645056d4ce2
};
$1433d8d5e8c8f7e5$export$b173aa1b45712272.defaultProps = {
    className: "VictoryContainer",
    portalComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $87064561561942f5$export$602eac185826482c), null),
    portalZIndex: 99,
    responsive: true,
    role: "img"
};
$1433d8d5e8c8f7e5$export$b173aa1b45712272.contextType = (0, $fb8bdbdaa14fb6cc$export$2e2bcd8739ae039);





var $fdGrT = parcelRequire("fdGrT");

var $8T3gX = parcelRequire("8T3gX");


var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");



function $5d2ca5b3e3e5812f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5d2ca5b3e3e5812f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5d2ca5b3e3e5812f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5d2ca5b3e3e5812f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5d2ca5b3e3e5812f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $5d2ca5b3e3e5812f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $5d2ca5b3e3e5812f$var$_setPrototypeOf(subClass, superClass);
}
function $5d2ca5b3e3e5812f$var$_setPrototypeOf(o, p) {
    $5d2ca5b3e3e5812f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5d2ca5b3e3e5812f$var$_setPrototypeOf(o, p);
}
function $5d2ca5b3e3e5812f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5d2ca5b3e3e5812f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $5d2ca5b3e3e5812f$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $5d2ca5b3e3e5812f$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $5d2ca5b3e3e5812f$var$_possibleConstructorReturn(this, result);
    };
}
function $5d2ca5b3e3e5812f$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $5d2ca5b3e3e5812f$var$_assertThisInitialized(self);
}
function $5d2ca5b3e3e5812f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5d2ca5b3e3e5812f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5d2ca5b3e3e5812f$var$_getPrototypeOf(o) {
    $5d2ca5b3e3e5812f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5d2ca5b3e3e5812f$var$_getPrototypeOf(o);
}
var $5d2ca5b3e3e5812f$export$458e39702099cd5e = /*#__PURE__*/ function(_React$Component) {
    $5d2ca5b3e3e5812f$var$_inherits(VictoryPortal, _React$Component);
    var _super = $5d2ca5b3e3e5812f$var$_createSuper(VictoryPortal);
    function VictoryPortal() {
        var _this;
        $5d2ca5b3e3e5812f$var$_classCallCheck(this, VictoryPortal);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.checkedContext = void 0;
        _this.renderInPlace = void 0;
        _this.element = void 0;
        _this.portalKey = void 0;
        return _this;
    }
    $5d2ca5b3e3e5812f$var$_createClass(VictoryPortal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!this.checkedContext) {
                    if (typeof this.context.portalUpdate !== "function") {
                        var msg = "`renderInPortal` is not supported outside of `VictoryContainer`. Component will be rendered in place";
                        $8590ed3b940180fa$export$c106dd0671a0fc2d(msg);
                        this.renderInPlace = true;
                    }
                    this.checkedContext = true;
                }
                this.forceUpdate();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (!this.renderInPlace) {
                    this.portalKey = this.portalKey || this.context.portalRegister();
                    this.context.portalUpdate(this.portalKey, this.element);
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.context && this.context.portalDeregister) this.context.portalDeregister(this.portalKey);
            } // Overridden in victory-core-native
        },
        {
            key: "renderPortal",
            value: function renderPortal(child) {
                if (this.renderInPlace) return child;
                this.element = child;
                return null;
            }
        },
        {
            key: "render",
            value: function render() {
                var children = Array.isArray(this.props.children) ? this.props.children[0] : this.props.children;
                var groupComponent = this.props.groupComponent;
                var childProps = children && children.props || {};
                var standardProps = childProps.groupComponent ? {
                    groupComponent: groupComponent,
                    standalone: false
                } : {};
                var newProps = (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))(standardProps, childProps, $0a5de8228869aa1e$export$30a06c8d3562193f(this.props, [
                    "children",
                    "groupComponent"
                ]));
                var child = children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(children, newProps);
                return this.renderPortal(child);
            }
        }
    ]);
    return VictoryPortal;
}((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Component);
$5d2ca5b3e3e5812f$export$458e39702099cd5e.displayName = "VictoryPortal";
$5d2ca5b3e3e5812f$export$458e39702099cd5e.role = "portal";
$5d2ca5b3e3e5812f$export$458e39702099cd5e.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    groupComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element
};
$5d2ca5b3e3e5812f$export$458e39702099cd5e.defaultProps = {
    groupComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("g", null)
};
$5d2ca5b3e3e5812f$export$458e39702099cd5e.contextType = (0, $51828b9610c699de$export$60d741e20e0aa309);



var $8T3gX = parcelRequire("8T3gX");
var $dfe2911367ea308b$var$_excluded = [
    "desc"
];
function $dfe2911367ea308b$var$_extends() {
    $dfe2911367ea308b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dfe2911367ea308b$var$_extends.apply(this, arguments);
}
function $dfe2911367ea308b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $dfe2911367ea308b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $dfe2911367ea308b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $dfe2911367ea308b$export$c79fc6492f3af13d = function(props) {
    // eslint-disable-next-line react/prop-types
    var desc = props.desc, rest = $dfe2911367ea308b$var$_objectWithoutProperties(props, $dfe2911367ea308b$var$_excluded);
    return desc ? /*#__PURE__*/ // @ts-expect-error FIXME: "id cannot be a number"
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("rect", $dfe2911367ea308b$var$_extends({
        vectorEffect: "non-scaling-stroke"
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("desc", null, desc)) : /*#__PURE__*/ // @ts-expect-error FIXME: "id cannot be a number"
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("rect", $dfe2911367ea308b$var$_extends({
        vectorEffect: "non-scaling-stroke"
    }, rest));
};



var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");
var $719221856adca4bf$var$_excluded = [
    "children",
    "title",
    "desc"
];
function $719221856adca4bf$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $719221856adca4bf$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $719221856adca4bf$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $719221856adca4bf$export$5f1af8db9871e1d6 = function(props) {
    var children = props.children, title = props.title, desc = props.desc, rest = $719221856adca4bf$var$_objectWithoutProperties(props, $719221856adca4bf$var$_excluded);
    return(/*#__PURE__*/ // @ts-expect-error FIXME: "id cannot be a number"
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("text", rest, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("title", null, title), desc && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("desc", null, desc), children));
};
$719221856adca4bf$export$5f1af8db9871e1d6.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    desc: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
};



var $8T3gX = parcelRequire("8T3gX");
var $d858a3092d8e6d8f$export$f2c08a339e307379 = function(props) {
    return(/*#__PURE__*/ // @ts-expect-error FIXME: "id cannot be a number"
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("tspan", props));
};






/**
 * Given an object with CSS/SVG transform definitions, return the string value
 * for use with the `transform` CSS property or SVG attribute. Note that we
 * can't always guarantee the order will match the author's intended order, so
 * authors should only use the object notation if they know that their transform
 * is commutative or that there is only one.
 * @param {Object} obj An object of transform definitions.
 * @returns {String} The generated transform string.
 */ var $adad185069bfc115$export$9ebaeae2c52fdc4c = function(obj) {
    for(var _len = arguments.length, more = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)more[_key - 1] = arguments[_key];
    if (more.length > 0) return more.reduce(function(memo, currentObj) {
        return [
            memo,
            $adad185069bfc115$export$9ebaeae2c52fdc4c(currentObj)
        ].join(" ");
    }, $adad185069bfc115$export$9ebaeae2c52fdc4c(obj)).trim();
    if (obj === undefined || obj === null || typeof obj === "string") return obj;
    var transforms = [];
    for(var key in obj)if (obj.hasOwnProperty(key)) {
        var value = obj[key];
        transforms.push("".concat(key, "(").concat(value, ")"));
    }
    return transforms.join(" ").trim();
};
function $adad185069bfc115$export$75f9af112506f7de(name) {
    var scales = {
        grayscale: [
            "#cccccc",
            "#969696",
            "#636363",
            "#252525"
        ],
        qualitative: [
            "#334D5C",
            "#45B29D",
            "#EFC94C",
            "#E27A3F",
            "#DF5A49",
            "#4F7DA1",
            "#55DBC1",
            "#EFDA97",
            "#E2A37F",
            "#DF948A"
        ],
        heatmap: [
            "#428517",
            "#77D200",
            "#D6D305",
            "#EC8E19",
            "#C92B05"
        ],
        warm: [
            "#940031",
            "#C43343",
            "#DC5429",
            "#FF821D",
            "#FFAF55"
        ],
        cool: [
            "#2746B9",
            "#0B69D4",
            "#2794DB",
            "#31BB76",
            "#60E83B"
        ],
        red: [
            "#FCAE91",
            "#FB6A4A",
            "#DE2D26",
            "#A50F15",
            "#750B0E"
        ],
        blue: [
            "#002C61",
            "#004B8F",
            "#006BC9",
            "#3795E5",
            "#65B4F4"
        ],
        green: [
            "#354722",
            "#466631",
            "#649146",
            "#8AB25C",
            "#A9C97E"
        ]
    };
    return name ? scales[name] : scales.grayscale;
}


var $b3e4dc1b6aee4a20$exports = {};

$parcel$export($b3e4dc1b6aee4a20$exports, "convertLengthToPixels", () => $b3e4dc1b6aee4a20$export$396301afc5af34f7);
$parcel$export($b3e4dc1b6aee4a20$exports, "_approximateTextSizeInternal", () => $b3e4dc1b6aee4a20$export$be29fb065c04437f);
$parcel$export($b3e4dc1b6aee4a20$exports, "approximateTextSize", () => $b3e4dc1b6aee4a20$export$e04f4b4b0a988f5d);



function $b3e4dc1b6aee4a20$var$_slicedToArray(arr, i) {
    return $b3e4dc1b6aee4a20$var$_arrayWithHoles(arr) || $b3e4dc1b6aee4a20$var$_iterableToArrayLimit(arr, i) || $b3e4dc1b6aee4a20$var$_unsupportedIterableToArray(arr, i) || $b3e4dc1b6aee4a20$var$_nonIterableRest();
}
function $b3e4dc1b6aee4a20$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b3e4dc1b6aee4a20$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $b3e4dc1b6aee4a20$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $b3e4dc1b6aee4a20$var$_toConsumableArray(arr) {
    return $b3e4dc1b6aee4a20$var$_arrayWithoutHoles(arr) || $b3e4dc1b6aee4a20$var$_iterableToArray(arr) || $b3e4dc1b6aee4a20$var$_unsupportedIterableToArray(arr) || $b3e4dc1b6aee4a20$var$_nonIterableSpread();
}
function $b3e4dc1b6aee4a20$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b3e4dc1b6aee4a20$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b3e4dc1b6aee4a20$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b3e4dc1b6aee4a20$var$_arrayLikeToArray(o, minLen);
}
function $b3e4dc1b6aee4a20$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $b3e4dc1b6aee4a20$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $b3e4dc1b6aee4a20$var$_arrayLikeToArray(arr);
}
function $b3e4dc1b6aee4a20$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
// Based on measuring specific character widths
// as in the following example https://bl.ocks.org/tophtucker/62f93a4658387bb61e4510c37e2e97cf
// prettier-ignore
var $b3e4dc1b6aee4a20$var$fonts = {
    "American Typewriter": {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.25,
            0.4203125,
            0.3296875,
            0.6,
            0.6375,
            0.8015625,
            0.8203125,
            0.1875,
            0.45625,
            0.45625,
            0.6375,
            0.5,
            0.2734375,
            0.309375,
            0.2734375,
            0.4390625,
            0.6375,
            0.6375,
            0.6375,
            0.6375,
            0.6375,
            0.6375,
            0.6375,
            0.6375,
            0.6375,
            0.6375,
            0.2734375,
            0.2734375,
            0.5,
            0.5,
            0.5,
            0.6,
            0.6921875,
            0.7640625,
            0.6921875,
            0.6375,
            0.728125,
            0.6734375,
            0.6203125,
            0.7109375,
            0.784375,
            0.3828125,
            0.6421875,
            0.7859375,
            0.6375,
            0.9484375,
            0.7640625,
            0.65625,
            0.6375,
            0.65625,
            0.7296875,
            0.6203125,
            0.6375,
            0.7109375,
            0.740625,
            0.940625,
            0.784375,
            0.7578125,
            0.6203125,
            0.4375,
            0.5,
            0.4375,
            0.5,
            0.5,
            0.4921875,
            0.5734375,
            0.5890625,
            0.5109375,
            0.6,
            0.528125,
            0.43125,
            0.5578125,
            0.6375,
            0.3109375,
            0.40625,
            0.6234375,
            0.309375,
            0.928125,
            0.6375,
            0.546875,
            0.6,
            0.58125,
            0.4921875,
            0.4921875,
            0.4,
            0.6203125,
            0.625,
            0.825,
            0.6375,
            0.640625,
            0.528125,
            0.5,
            0.5,
            0.5,
            0.6671875
        ],
        avg: 0.5793421052631578
    },
    Arial: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.278125,
            0.278125,
            0.35625,
            0.55625,
            0.55625,
            0.890625,
            0.6671875,
            0.1921875,
            0.334375,
            0.334375,
            0.390625,
            0.584375,
            0.278125,
            0.334375,
            0.278125,
            0.278125,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.278125,
            0.278125,
            0.584375,
            0.584375,
            0.584375,
            0.55625,
            1.015625,
            0.6703125,
            0.6671875,
            0.7234375,
            0.7234375,
            0.6671875,
            0.6109375,
            0.778125,
            0.7234375,
            0.278125,
            0.5,
            0.6671875,
            0.55625,
            0.834375,
            0.7234375,
            0.778125,
            0.6671875,
            0.778125,
            0.7234375,
            0.6671875,
            0.6109375,
            0.7234375,
            0.6671875,
            0.9453125,
            0.6671875,
            0.6671875,
            0.6109375,
            0.278125,
            0.278125,
            0.278125,
            0.4703125,
            0.584375,
            0.334375,
            0.55625,
            0.55625,
            0.5,
            0.55625,
            0.55625,
            0.3125,
            0.55625,
            0.55625,
            0.2234375,
            0.2703125,
            0.5,
            0.2234375,
            0.834375,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.346875,
            0.5,
            0.278125,
            0.55625,
            0.5,
            0.7234375,
            0.5,
            0.5,
            0.5,
            0.334375,
            0.2609375,
            0.334375,
            0.584375
        ],
        avg: 0.528733552631579
    },
    "Arial Black": {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.33125,
            0.334375,
            0.5,
            0.6609375,
            0.6671875,
            1,
            0.890625,
            0.278125,
            0.390625,
            0.390625,
            0.55625,
            0.6609375,
            0.334375,
            0.334375,
            0.334375,
            0.28125,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.334375,
            0.334375,
            0.6609375,
            0.6609375,
            0.6609375,
            0.6109375,
            0.7453125,
            0.78125,
            0.778125,
            0.778125,
            0.778125,
            0.7234375,
            0.6671875,
            0.834375,
            0.834375,
            0.390625,
            0.6671875,
            0.834375,
            0.6671875,
            0.9453125,
            0.834375,
            0.834375,
            0.7234375,
            0.834375,
            0.78125,
            0.7234375,
            0.7234375,
            0.834375,
            0.7796875,
            1.003125,
            0.78125,
            0.78125,
            0.7234375,
            0.390625,
            0.28125,
            0.390625,
            0.6609375,
            0.5125,
            0.334375,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.41875,
            0.6671875,
            0.6671875,
            0.334375,
            0.384375,
            0.6671875,
            0.334375,
            1,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.4703125,
            0.6109375,
            0.4453125,
            0.6671875,
            0.6140625,
            0.946875,
            0.6671875,
            0.615625,
            0.55625,
            0.390625,
            0.278125,
            0.390625,
            0.6609375
        ],
        avg: 0.6213157894736842
    },
    Baskerville: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.25,
            0.25,
            0.40625,
            0.6671875,
            0.490625,
            0.875,
            0.7015625,
            0.178125,
            0.2453125,
            0.246875,
            0.4171875,
            0.6671875,
            0.25,
            0.3125,
            0.25,
            0.521875,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.25,
            0.25,
            0.6671875,
            0.6671875,
            0.6671875,
            0.396875,
            0.9171875,
            0.684375,
            0.615625,
            0.71875,
            0.7609375,
            0.625,
            0.553125,
            0.771875,
            0.803125,
            0.3546875,
            0.515625,
            0.78125,
            0.6046875,
            0.928125,
            0.75,
            0.8234375,
            0.5625,
            0.96875,
            0.7296875,
            0.5421875,
            0.6984375,
            0.771875,
            0.7296875,
            0.9484375,
            0.771875,
            0.678125,
            0.6359375,
            0.3640625,
            0.521875,
            0.3640625,
            0.46875,
            0.5125,
            0.334375,
            0.46875,
            0.521875,
            0.428125,
            0.521875,
            0.4375,
            0.3890625,
            0.4765625,
            0.53125,
            0.25,
            0.359375,
            0.4640625,
            0.240625,
            0.803125,
            0.53125,
            0.5,
            0.521875,
            0.521875,
            0.365625,
            0.334375,
            0.2921875,
            0.521875,
            0.4640625,
            0.678125,
            0.4796875,
            0.465625,
            0.428125,
            0.4796875,
            0.5109375,
            0.4796875,
            0.6671875
        ],
        avg: 0.5323519736842108
    },
    Courier: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.5984375,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6078125,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.61875,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.615625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6140625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625
        ],
        avg: 0.6020559210526316
    },
    "Courier New": {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.5984375,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625
        ],
        avg: 0.6015296052631579
    },
    cursive: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.1921875,
            0.24375,
            0.40625,
            0.5671875,
            0.3984375,
            0.721875,
            0.909375,
            0.2328125,
            0.434375,
            0.365625,
            0.4734375,
            0.5578125,
            0.19375,
            0.3484375,
            0.19375,
            0.7734375,
            0.503125,
            0.4171875,
            0.5453125,
            0.45,
            0.6046875,
            0.4703125,
            0.5984375,
            0.55625,
            0.503125,
            0.5546875,
            0.20625,
            0.2,
            0.5625,
            0.5546875,
            0.546875,
            0.403125,
            0.70625,
            0.734375,
            0.7078125,
            0.64375,
            0.85,
            0.753125,
            0.75,
            0.6484375,
            1.0765625,
            0.44375,
            0.5359375,
            0.8359375,
            0.653125,
            1.0109375,
            1.1515625,
            0.6796875,
            0.6984375,
            1.0625,
            0.8234375,
            0.5125,
            0.9234375,
            0.8546875,
            0.70625,
            0.9109375,
            0.7421875,
            0.715625,
            0.6015625,
            0.4640625,
            0.3359375,
            0.4109375,
            0.5421875,
            0.5421875,
            0.4328125,
            0.5125,
            0.5,
            0.3859375,
            0.7375,
            0.359375,
            0.75625,
            0.540625,
            0.5328125,
            0.3203125,
            0.5296875,
            0.5015625,
            0.484375,
            0.7890625,
            0.5640625,
            0.4203125,
            0.703125,
            0.471875,
            0.4734375,
            0.35,
            0.4125,
            0.5640625,
            0.471875,
            0.6484375,
            0.5296875,
            0.575,
            0.4140625,
            0.415625,
            0.20625,
            0.3796875,
            0.5421875
        ],
        avg: 0.5604440789473684
    },
    fantasy: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.215625,
            0.2625,
            0.3265625,
            0.6109375,
            0.534375,
            0.7625,
            0.7828125,
            0.2,
            0.4359375,
            0.4359375,
            0.3765625,
            0.5109375,
            0.2796875,
            0.4609375,
            0.2796875,
            0.5296875,
            0.6640625,
            0.253125,
            0.521875,
            0.4765625,
            0.6640625,
            0.490625,
            0.528125,
            0.5546875,
            0.496875,
            0.5421875,
            0.2796875,
            0.2796875,
            0.5625,
            0.4609375,
            0.5625,
            0.4828125,
            0.609375,
            0.740625,
            0.7234375,
            0.740625,
            0.8265625,
            0.7234375,
            0.6171875,
            0.7359375,
            0.765625,
            0.240625,
            0.5453125,
            0.715625,
            0.6078125,
            0.8640625,
            0.653125,
            0.9125,
            0.6484375,
            0.946875,
            0.6921875,
            0.653125,
            0.6953125,
            0.8015625,
            0.58125,
            0.784375,
            0.671875,
            0.6265625,
            0.690625,
            0.4359375,
            0.5296875,
            0.4359375,
            0.53125,
            0.5,
            0.2875,
            0.5375,
            0.603125,
            0.4984375,
            0.60625,
            0.53125,
            0.434375,
            0.6421875,
            0.56875,
            0.209375,
            0.4671875,
            0.5484375,
            0.2203125,
            0.709375,
            0.55,
            0.5984375,
            0.6140625,
            0.5765625,
            0.40625,
            0.4734375,
            0.3734375,
            0.559375,
            0.4421875,
            0.6421875,
            0.4890625,
            0.578125,
            0.4484375,
            0.2546875,
            0.2203125,
            0.2546875,
            0.55
        ],
        avg: 0.536496710526316
    },
    Geneva: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.3328125,
            0.3046875,
            0.5,
            0.6671875,
            0.6671875,
            0.90625,
            0.728125,
            0.3046875,
            0.446875,
            0.446875,
            0.5078125,
            0.6671875,
            0.3046875,
            0.3796875,
            0.3046875,
            0.5390625,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.3046875,
            0.3046875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.56875,
            0.871875,
            0.728125,
            0.6375,
            0.6515625,
            0.7015625,
            0.5765625,
            0.5546875,
            0.675,
            0.690625,
            0.2421875,
            0.4921875,
            0.6640625,
            0.584375,
            0.7890625,
            0.709375,
            0.7359375,
            0.584375,
            0.78125,
            0.60625,
            0.60625,
            0.640625,
            0.6671875,
            0.728125,
            0.946875,
            0.6109375,
            0.6109375,
            0.5765625,
            0.446875,
            0.5390625,
            0.446875,
            0.6671875,
            0.6671875,
            0.5921875,
            0.5546875,
            0.6109375,
            0.546875,
            0.603125,
            0.5765625,
            0.390625,
            0.6109375,
            0.584375,
            0.2359375,
            0.334375,
            0.5390625,
            0.2359375,
            0.8953125,
            0.584375,
            0.60625,
            0.603125,
            0.603125,
            0.3875,
            0.509375,
            0.44375,
            0.584375,
            0.565625,
            0.78125,
            0.53125,
            0.571875,
            0.5546875,
            0.4515625,
            0.246875,
            0.4515625,
            0.6671875
        ],
        avg: 0.5762664473684211
    },
    Georgia: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.2421875,
            0.33125,
            0.4125,
            0.64375,
            0.6109375,
            0.81875,
            0.7109375,
            0.215625,
            0.375,
            0.375,
            0.4734375,
            0.64375,
            0.2703125,
            0.375,
            0.2703125,
            0.46875,
            0.6140625,
            0.4296875,
            0.559375,
            0.553125,
            0.565625,
            0.5296875,
            0.5671875,
            0.503125,
            0.596875,
            0.5671875,
            0.3125,
            0.3125,
            0.64375,
            0.64375,
            0.64375,
            0.4796875,
            0.9296875,
            0.715625,
            0.6546875,
            0.6421875,
            0.75,
            0.6546875,
            0.6,
            0.7265625,
            0.815625,
            0.390625,
            0.51875,
            0.7203125,
            0.6046875,
            0.928125,
            0.7671875,
            0.7453125,
            0.6109375,
            0.7453125,
            0.7234375,
            0.5625,
            0.61875,
            0.7578125,
            0.70625,
            0.99375,
            0.7125,
            0.6640625,
            0.6015625,
            0.375,
            0.46875,
            0.375,
            0.64375,
            0.65,
            0.5,
            0.5046875,
            0.56875,
            0.4546875,
            0.575,
            0.484375,
            0.39375,
            0.509375,
            0.5828125,
            0.29375,
            0.3671875,
            0.546875,
            0.2875,
            0.88125,
            0.5921875,
            0.5390625,
            0.571875,
            0.5640625,
            0.4109375,
            0.4328125,
            0.3453125,
            0.5765625,
            0.5203125,
            0.75625,
            0.50625,
            0.5171875,
            0.4453125,
            0.43125,
            0.375,
            0.43125,
            0.64375
        ],
        avg: 0.5551809210526316
    },
    "Gill Sans": {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.2765625,
            0.271875,
            0.3546875,
            0.584375,
            0.5421875,
            0.6765625,
            0.625,
            0.1890625,
            0.3234375,
            0.3234375,
            0.4171875,
            0.584375,
            0.2203125,
            0.3234375,
            0.2203125,
            0.28125,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.2203125,
            0.2296875,
            0.584375,
            0.584375,
            0.584375,
            0.334375,
            1.0109375,
            0.6671875,
            0.5640625,
            0.709375,
            0.75,
            0.5,
            0.4703125,
            0.740625,
            0.7296875,
            0.25,
            0.3125,
            0.65625,
            0.490625,
            0.78125,
            0.78125,
            0.8234375,
            0.5109375,
            0.8234375,
            0.6046875,
            0.459375,
            0.6046875,
            0.709375,
            0.6046875,
            1.0421875,
            0.709375,
            0.6046875,
            0.646875,
            0.334375,
            0.28125,
            0.334375,
            0.4703125,
            0.5828125,
            0.334375,
            0.428125,
            0.5,
            0.4390625,
            0.5109375,
            0.4796875,
            0.296875,
            0.428125,
            0.5,
            0.2203125,
            0.2265625,
            0.5,
            0.2203125,
            0.771875,
            0.5,
            0.553125,
            0.5,
            0.5,
            0.3984375,
            0.3859375,
            0.334375,
            0.5,
            0.4390625,
            0.7203125,
            0.5,
            0.4390625,
            0.4171875,
            0.334375,
            0.2609375,
            0.334375,
            0.584375
        ],
        avg: 0.4933717105263159
    },
    Helvetica: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.2796875,
            0.2765625,
            0.3546875,
            0.5546875,
            0.5546875,
            0.8890625,
            0.665625,
            0.190625,
            0.3328125,
            0.3328125,
            0.3890625,
            0.5828125,
            0.2765625,
            0.3328125,
            0.2765625,
            0.3015625,
            0.5546875,
            0.5546875,
            0.5546875,
            0.5546875,
            0.5546875,
            0.5546875,
            0.5546875,
            0.5546875,
            0.5546875,
            0.5546875,
            0.2765625,
            0.2765625,
            0.584375,
            0.5828125,
            0.584375,
            0.5546875,
            1.0140625,
            0.665625,
            0.665625,
            0.721875,
            0.721875,
            0.665625,
            0.609375,
            0.7765625,
            0.721875,
            0.2765625,
            0.5,
            0.665625,
            0.5546875,
            0.8328125,
            0.721875,
            0.7765625,
            0.665625,
            0.7765625,
            0.721875,
            0.665625,
            0.609375,
            0.721875,
            0.665625,
            0.94375,
            0.665625,
            0.665625,
            0.609375,
            0.2765625,
            0.3546875,
            0.2765625,
            0.4765625,
            0.5546875,
            0.3328125,
            0.5546875,
            0.5546875,
            0.5,
            0.5546875,
            0.5546875,
            0.2765625,
            0.5546875,
            0.5546875,
            0.221875,
            0.240625,
            0.5,
            0.221875,
            0.8328125,
            0.5546875,
            0.5546875,
            0.5546875,
            0.5546875,
            0.3328125,
            0.5,
            0.2765625,
            0.5546875,
            0.5,
            0.721875,
            0.5,
            0.5,
            0.5,
            0.3546875,
            0.259375,
            0.353125,
            0.5890625
        ],
        avg: 0.5279276315789471
    },
    "Helvetica Neue": {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.278125,
            0.259375,
            0.4265625,
            0.55625,
            0.55625,
            1,
            0.6453125,
            0.278125,
            0.2703125,
            0.26875,
            0.353125,
            0.6,
            0.278125,
            0.3890625,
            0.278125,
            0.36875,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.278125,
            0.278125,
            0.6,
            0.6,
            0.6,
            0.55625,
            0.8,
            0.6625,
            0.6859375,
            0.7234375,
            0.7046875,
            0.6125,
            0.575,
            0.759375,
            0.7234375,
            0.259375,
            0.5203125,
            0.6703125,
            0.55625,
            0.871875,
            0.7234375,
            0.7609375,
            0.6484375,
            0.7609375,
            0.6859375,
            0.6484375,
            0.575,
            0.7234375,
            0.6140625,
            0.9265625,
            0.6125,
            0.6484375,
            0.6125,
            0.259375,
            0.36875,
            0.259375,
            0.6,
            0.5,
            0.25625,
            0.5375,
            0.59375,
            0.5375,
            0.59375,
            0.5375,
            0.2984375,
            0.575,
            0.55625,
            0.2234375,
            0.2375,
            0.5203125,
            0.2234375,
            0.853125,
            0.55625,
            0.575,
            0.59375,
            0.59375,
            0.334375,
            0.5,
            0.315625,
            0.55625,
            0.5,
            0.759375,
            0.51875,
            0.5,
            0.48125,
            0.334375,
            0.2234375,
            0.334375,
            0.6
        ],
        avg: 0.5279440789473684
    },
    "Hoefler Text": {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.2359375,
            0.2234375,
            0.3921875,
            0.7125,
            0.49375,
            0.8859375,
            0.771875,
            0.2125,
            0.3078125,
            0.309375,
            0.375,
            0.4234375,
            0.234375,
            0.3125,
            0.234375,
            0.3,
            0.5828125,
            0.365625,
            0.434375,
            0.3921875,
            0.5234375,
            0.3984375,
            0.5125,
            0.4328125,
            0.46875,
            0.5125,
            0.234375,
            0.234375,
            0.515625,
            0.4234375,
            0.515625,
            0.340625,
            0.7609375,
            0.7359375,
            0.6359375,
            0.721875,
            0.8125,
            0.6375,
            0.5875,
            0.8078125,
            0.853125,
            0.4296875,
            0.503125,
            0.78125,
            0.609375,
            0.9609375,
            0.8515625,
            0.8140625,
            0.6125,
            0.8140625,
            0.71875,
            0.49375,
            0.7125,
            0.76875,
            0.771875,
            1.125,
            0.7765625,
            0.7734375,
            0.65625,
            0.321875,
            0.3078125,
            0.321875,
            0.3546875,
            0.5,
            0.3375,
            0.446875,
            0.5359375,
            0.45,
            0.5296875,
            0.4546875,
            0.425,
            0.4921875,
            0.54375,
            0.2671875,
            0.240625,
            0.5390625,
            0.25,
            0.815625,
            0.5375,
            0.5234375,
            0.5390625,
            0.5421875,
            0.365625,
            0.36875,
            0.35625,
            0.5171875,
            0.5015625,
            0.75,
            0.5,
            0.509375,
            0.44375,
            0.2421875,
            0.14375,
            0.2421875,
            0.35
        ],
        avg: 0.5116447368421051
    },
    "Montserrat": {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.2625,
            0.2609375,
            0.3734375,
            0.696875,
            0.615625,
            0.8296875,
            0.6703125,
            0.203125,
            0.3296875,
            0.3296875,
            0.3875,
            0.575,
            0.2125,
            0.3828125,
            0.2125,
            0.3953125,
            0.6625,
            0.3625,
            0.56875,
            0.5640625,
            0.6625,
            0.5671875,
            0.609375,
            0.5890625,
            0.6390625,
            0.609375,
            0.2125,
            0.2125,
            0.575,
            0.575,
            0.575,
            0.5671875,
            1.034375,
            0.7171875,
            0.7546875,
            0.7203125,
            0.8265625,
            0.6703125,
            0.634375,
            0.7734375,
            0.8140625,
            0.303125,
            0.5078125,
            0.7125,
            0.5890625,
            0.95625,
            0.8140625,
            0.8390625,
            0.71875,
            0.8390625,
            0.7234375,
            0.615625,
            0.575,
            0.7921875,
            0.6984375,
            1.1125,
            0.65625,
            0.6359375,
            0.6515625,
            0.31875,
            0.396875,
            0.31875,
            0.5765625,
            0.5,
            0.6,
            0.590625,
            0.678125,
            0.5640625,
            0.678125,
            0.6046875,
            0.375,
            0.6875,
            0.678125,
            0.2703125,
            0.365625,
            0.6015625,
            0.2703125,
            1.0625,
            0.678125,
            0.628125,
            0.678125,
            0.678125,
            0.4015625,
            0.4890625,
            0.40625,
            0.6734375,
            0.5421875,
            0.8796875,
            0.534375,
            0.5671875,
            0.5125,
            0.334375,
            0.2953125,
            0.334375,
            0.575
        ],
        avg: 0.571792763157895
    },
    monospace: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.5984375,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6078125,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.61875,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.615625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6140625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625
        ],
        avg: 0.6020559210526316
    },
    Overpass: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.2296875,
            0.2765625,
            0.4203125,
            0.68125,
            0.584375,
            0.8515625,
            0.7015625,
            0.2203125,
            0.3453125,
            0.3453125,
            0.53125,
            0.63125,
            0.2234375,
            0.3953125,
            0.2234375,
            0.509375,
            0.65,
            0.4046875,
            0.6171875,
            0.60625,
            0.6484375,
            0.60625,
            0.6015625,
            0.5375,
            0.615625,
            0.6015625,
            0.2234375,
            0.2234375,
            0.63125,
            0.63125,
            0.63125,
            0.5015625,
            0.8203125,
            0.696875,
            0.6671875,
            0.65,
            0.6859375,
            0.6015625,
            0.559375,
            0.690625,
            0.7078125,
            0.2953125,
            0.565625,
            0.678125,
            0.58125,
            0.8046875,
            0.7109375,
            0.740625,
            0.6421875,
            0.740625,
            0.6765625,
            0.6046875,
            0.590625,
            0.696875,
            0.6640625,
            0.853125,
            0.65,
            0.6671875,
            0.6625,
            0.3734375,
            0.509375,
            0.3734375,
            0.63125,
            0.5125,
            0.4,
            0.5328125,
            0.5625,
            0.51875,
            0.5625,
            0.546875,
            0.3359375,
            0.5625,
            0.565625,
            0.25625,
            0.3203125,
            0.55,
            0.265625,
            0.85,
            0.565625,
            0.5671875,
            0.5625,
            0.5625,
            0.4046875,
            0.4765625,
            0.3796875,
            0.565625,
            0.521875,
            0.7265625,
            0.53125,
            0.5390625,
            0.5125,
            0.3671875,
            0.275,
            0.3671875,
            0.63125
        ],
        avg: 0.5430756578947369
    },
    Palatino: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.25,
            0.278125,
            0.371875,
            0.60625,
            0.5,
            0.840625,
            0.778125,
            0.209375,
            0.334375,
            0.334375,
            0.390625,
            0.60625,
            0.2578125,
            0.334375,
            0.25,
            0.60625,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.25,
            0.25,
            0.60625,
            0.60625,
            0.60625,
            0.4453125,
            0.7484375,
            0.778125,
            0.6109375,
            0.709375,
            0.775,
            0.6109375,
            0.55625,
            0.7640625,
            0.8328125,
            0.3375,
            0.346875,
            0.7265625,
            0.6109375,
            0.946875,
            0.83125,
            0.7875,
            0.6046875,
            0.7875,
            0.66875,
            0.525,
            0.6140625,
            0.778125,
            0.7234375,
            1,
            0.6671875,
            0.6671875,
            0.6671875,
            0.334375,
            0.60625,
            0.334375,
            0.60625,
            0.5,
            0.334375,
            0.5,
            0.565625,
            0.4453125,
            0.6109375,
            0.4796875,
            0.340625,
            0.55625,
            0.5828125,
            0.2921875,
            0.2671875,
            0.5640625,
            0.2921875,
            0.8828125,
            0.5828125,
            0.546875,
            0.6015625,
            0.5609375,
            0.3953125,
            0.425,
            0.3265625,
            0.603125,
            0.565625,
            0.834375,
            0.5171875,
            0.55625,
            0.5,
            0.334375,
            0.60625,
            0.334375,
            0.60625
        ],
        avg: 0.5408552631578947
    },
    "RedHatText": {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.2328125,
            0.2203125,
            0.35625,
            0.6890625,
            0.55,
            0.7390625,
            0.6703125,
            0.2140625,
            0.4015625,
            0.4015625,
            0.4546875,
            0.53125,
            0.2203125,
            0.45625,
            0.2203125,
            0.515625,
            0.6609375,
            0.3078125,
            0.5484375,
            0.5875,
            0.61875,
            0.5703125,
            0.6203125,
            0.559375,
            0.6140625,
            0.6203125,
            0.2203125,
            0.2234375,
            0.465625,
            0.534375,
            0.465625,
            0.5125,
            0.7671875,
            0.6609375,
            0.6703125,
            0.7265625,
            0.728125,
            0.6203125,
            0.6109375,
            0.8,
            0.73125,
            0.253125,
            0.6,
            0.6125,
            0.6078125,
            0.8625,
            0.7390625,
            0.8109375,
            0.6546875,
            0.809375,
            0.6484375,
            0.6234375,
            0.6171875,
            0.7125,
            0.6609375,
            0.8984375,
            0.6546875,
            0.646875,
            0.60625,
            0.3625,
            0.5203125,
            0.3625,
            0.540625,
            0.4609375,
            0.5234375,
            0.5265625,
            0.584375,
            0.509375,
            0.5828125,
            0.5578125,
            0.3703125,
            0.5828125,
            0.553125,
            0.2234375,
            0.24375,
            0.4890625,
            0.2234375,
            0.8453125,
            0.553125,
            0.58125,
            0.584375,
            0.5828125,
            0.353125,
            0.453125,
            0.378125,
            0.553125,
            0.5015625,
            0.6984375,
            0.4875,
            0.4984375,
            0.459375,
            0.3953125,
            0.2921875,
            0.3953125,
            0.58125
        ],
        avg: 0.5341940789473685
    },
    "sans-serif": {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.278125,
            0.278125,
            0.35625,
            0.55625,
            0.55625,
            0.890625,
            0.6671875,
            0.1921875,
            0.334375,
            0.334375,
            0.390625,
            0.584375,
            0.278125,
            0.334375,
            0.278125,
            0.303125,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.278125,
            0.278125,
            0.5859375,
            0.584375,
            0.5859375,
            0.55625,
            1.015625,
            0.6671875,
            0.6671875,
            0.7234375,
            0.7234375,
            0.6671875,
            0.6109375,
            0.778125,
            0.7234375,
            0.278125,
            0.5,
            0.6671875,
            0.55625,
            0.834375,
            0.7234375,
            0.778125,
            0.6671875,
            0.778125,
            0.7234375,
            0.6671875,
            0.6109375,
            0.7234375,
            0.6671875,
            0.9453125,
            0.6671875,
            0.6671875,
            0.6109375,
            0.278125,
            0.35625,
            0.278125,
            0.478125,
            0.55625,
            0.334375,
            0.55625,
            0.55625,
            0.5,
            0.55625,
            0.55625,
            0.278125,
            0.55625,
            0.55625,
            0.2234375,
            0.2421875,
            0.5,
            0.2234375,
            0.834375,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.334375,
            0.5,
            0.278125,
            0.55625,
            0.5,
            0.7234375,
            0.5,
            0.5,
            0.5,
            0.35625,
            0.2609375,
            0.3546875,
            0.590625
        ],
        avg: 0.5293256578947368
    },
    Seravek: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.215625,
            0.296875,
            0.4171875,
            0.6734375,
            0.4953125,
            0.9125,
            0.740625,
            0.2421875,
            0.3375,
            0.3375,
            0.409375,
            0.60625,
            0.2609375,
            0.35625,
            0.25625,
            0.41875,
            0.5921875,
            0.3515625,
            0.475,
            0.4875,
            0.5375,
            0.509375,
            0.5484375,
            0.4546875,
            0.5421875,
            0.5484375,
            0.25625,
            0.2546875,
            0.5875,
            0.6171875,
            0.5875,
            0.4578125,
            0.8140625,
            0.6765625,
            0.5703125,
            0.6109375,
            0.684375,
            0.5109375,
            0.4953125,
            0.678125,
            0.6859375,
            0.2625,
            0.2625,
            0.5859375,
            0.4734375,
            0.846875,
            0.709375,
            0.740625,
            0.509375,
            0.740625,
            0.584375,
            0.5015625,
            0.528125,
            0.675,
            0.5953125,
            0.9453125,
            0.596875,
            0.540625,
            0.540625,
            0.359375,
            0.4203125,
            0.359375,
            0.5109375,
            0.421875,
            0.4046875,
            0.5015625,
            0.5421875,
            0.446875,
            0.5453125,
            0.484375,
            0.38125,
            0.5140625,
            0.5546875,
            0.240625,
            0.2640625,
            0.490625,
            0.2765625,
            0.8625,
            0.5546875,
            0.546875,
            0.5453125,
            0.5453125,
            0.3625,
            0.41875,
            0.3890625,
            0.5453125,
            0.4703125,
            0.7546875,
            0.4921875,
            0.4609375,
            0.453125,
            0.4015625,
            0.2640625,
            0.4015625,
            0.58125
        ],
        avg: 0.5044078947368421
    },
    serif: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.2484375,
            0.334375,
            0.409375,
            0.5,
            0.5,
            0.834375,
            0.778125,
            0.18125,
            0.334375,
            0.334375,
            0.5,
            0.5640625,
            0.25,
            0.334375,
            0.25,
            0.278125,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.278125,
            0.278125,
            0.5640625,
            0.5640625,
            0.5640625,
            0.4453125,
            0.921875,
            0.7234375,
            0.6671875,
            0.6671875,
            0.7234375,
            0.6109375,
            0.55625,
            0.7234375,
            0.7234375,
            0.334375,
            0.390625,
            0.7234375,
            0.6109375,
            0.890625,
            0.7234375,
            0.7234375,
            0.55625,
            0.7234375,
            0.6671875,
            0.55625,
            0.6109375,
            0.7234375,
            0.7234375,
            0.9453125,
            0.7234375,
            0.7234375,
            0.6109375,
            0.334375,
            0.340625,
            0.334375,
            0.4703125,
            0.5,
            0.3453125,
            0.4453125,
            0.5,
            0.4453125,
            0.5,
            0.4453125,
            0.3828125,
            0.5,
            0.5,
            0.278125,
            0.3359375,
            0.5,
            0.278125,
            0.778125,
            0.5,
            0.5,
            0.5,
            0.5,
            0.3375,
            0.390625,
            0.2796875,
            0.5,
            0.5,
            0.7234375,
            0.5,
            0.5,
            0.4453125,
            0.48125,
            0.2015625,
            0.48125,
            0.5421875
        ],
        avg: 0.5126315789473684
    },
    Tahoma: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.3109375,
            0.3328125,
            0.4015625,
            0.728125,
            0.546875,
            0.9765625,
            0.70625,
            0.2109375,
            0.3828125,
            0.3828125,
            0.546875,
            0.728125,
            0.303125,
            0.3640625,
            0.303125,
            0.3953125,
            0.546875,
            0.546875,
            0.546875,
            0.546875,
            0.546875,
            0.546875,
            0.546875,
            0.546875,
            0.546875,
            0.546875,
            0.3546875,
            0.3546875,
            0.728125,
            0.728125,
            0.728125,
            0.475,
            0.909375,
            0.6109375,
            0.590625,
            0.6015625,
            0.6796875,
            0.5625,
            0.521875,
            0.66875,
            0.6765625,
            0.3734375,
            0.4171875,
            0.6046875,
            0.4984375,
            0.771875,
            0.66875,
            0.7078125,
            0.5515625,
            0.7078125,
            0.6375,
            0.5578125,
            0.5875,
            0.65625,
            0.60625,
            0.903125,
            0.58125,
            0.5890625,
            0.559375,
            0.3828125,
            0.39375,
            0.3828125,
            0.728125,
            0.5625,
            0.546875,
            0.525,
            0.553125,
            0.4625,
            0.553125,
            0.5265625,
            0.3546875,
            0.553125,
            0.5578125,
            0.2296875,
            0.328125,
            0.51875,
            0.2296875,
            0.840625,
            0.5578125,
            0.54375,
            0.553125,
            0.553125,
            0.3609375,
            0.446875,
            0.3359375,
            0.5578125,
            0.4984375,
            0.7421875,
            0.4953125,
            0.4984375,
            0.4453125,
            0.48125,
            0.3828125,
            0.48125,
            0.728125
        ],
        avg: 0.5384374999999998
    },
    "Times New Roman": {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.2484375,
            0.334375,
            0.409375,
            0.5,
            0.5,
            0.834375,
            0.778125,
            0.18125,
            0.334375,
            0.334375,
            0.5,
            0.5640625,
            0.25,
            0.334375,
            0.25,
            0.28125,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.278125,
            0.278125,
            0.5640625,
            0.5640625,
            0.5640625,
            0.4453125,
            0.921875,
            0.7234375,
            0.6671875,
            0.6671875,
            0.7234375,
            0.6109375,
            0.55625,
            0.7234375,
            0.7234375,
            0.334375,
            0.390625,
            0.73125,
            0.6109375,
            0.890625,
            0.7375,
            0.7234375,
            0.55625,
            0.7234375,
            0.6765625,
            0.55625,
            0.6109375,
            0.7234375,
            0.7234375,
            0.9453125,
            0.7234375,
            0.7234375,
            0.6109375,
            0.334375,
            0.28125,
            0.334375,
            0.4703125,
            0.51875,
            0.334375,
            0.4453125,
            0.503125,
            0.4453125,
            0.503125,
            0.4453125,
            0.4359375,
            0.5,
            0.5,
            0.278125,
            0.35625,
            0.50625,
            0.278125,
            0.778125,
            0.5,
            0.5,
            0.5046875,
            0.5,
            0.340625,
            0.390625,
            0.2796875,
            0.5,
            0.5,
            0.7234375,
            0.5,
            0.5,
            0.4453125,
            0.48125,
            0.2015625,
            0.48125,
            0.5421875
        ],
        avg: 0.5134375
    },
    "Trebuchet MS": {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.3015625,
            0.3671875,
            0.325,
            0.53125,
            0.525,
            0.6015625,
            0.70625,
            0.1609375,
            0.3671875,
            0.3671875,
            0.3671875,
            0.525,
            0.3671875,
            0.3671875,
            0.3671875,
            0.525,
            0.525,
            0.525,
            0.525,
            0.525,
            0.525,
            0.525,
            0.525,
            0.525,
            0.525,
            0.525,
            0.3671875,
            0.3671875,
            0.525,
            0.525,
            0.525,
            0.3671875,
            0.771875,
            0.590625,
            0.5671875,
            0.5984375,
            0.6140625,
            0.5359375,
            0.525,
            0.6765625,
            0.6546875,
            0.2796875,
            0.4765625,
            0.5765625,
            0.5078125,
            0.7109375,
            0.6390625,
            0.675,
            0.5578125,
            0.7421875,
            0.5828125,
            0.48125,
            0.58125,
            0.6484375,
            0.5875,
            0.853125,
            0.5578125,
            0.5703125,
            0.5515625,
            0.3671875,
            0.3578125,
            0.3671875,
            0.525,
            0.53125,
            0.525,
            0.5265625,
            0.5578125,
            0.4953125,
            0.5578125,
            0.546875,
            0.375,
            0.503125,
            0.546875,
            0.2859375,
            0.3671875,
            0.5046875,
            0.2953125,
            0.83125,
            0.546875,
            0.5375,
            0.5578125,
            0.5578125,
            0.3890625,
            0.40625,
            0.396875,
            0.546875,
            0.490625,
            0.7453125,
            0.5015625,
            0.49375,
            0.475,
            0.3671875,
            0.525,
            0.3671875,
            0.525
        ],
        avg: 0.5085197368421052
    },
    Verdana: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.35,
            0.39375,
            0.459375,
            0.81875,
            0.6359375,
            1.0765625,
            0.759375,
            0.26875,
            0.4546875,
            0.4546875,
            0.6359375,
            0.81875,
            0.3640625,
            0.4546875,
            0.3640625,
            0.4703125,
            0.6359375,
            0.6359375,
            0.6359375,
            0.6359375,
            0.6359375,
            0.6359375,
            0.6359375,
            0.6359375,
            0.6359375,
            0.6359375,
            0.4546875,
            0.4546875,
            0.81875,
            0.81875,
            0.81875,
            0.546875,
            1,
            0.684375,
            0.6859375,
            0.6984375,
            0.771875,
            0.6328125,
            0.575,
            0.7765625,
            0.7515625,
            0.421875,
            0.4546875,
            0.69375,
            0.5578125,
            0.84375,
            0.7484375,
            0.7875,
            0.603125,
            0.7875,
            0.7,
            0.684375,
            0.6171875,
            0.7328125,
            0.684375,
            0.9890625,
            0.6859375,
            0.615625,
            0.6859375,
            0.4546875,
            0.46875,
            0.4546875,
            0.81875,
            0.6421875,
            0.6359375,
            0.6015625,
            0.6234375,
            0.521875,
            0.6234375,
            0.596875,
            0.384375,
            0.6234375,
            0.6328125,
            0.275,
            0.3765625,
            0.5921875,
            0.275,
            0.9734375,
            0.6328125,
            0.6078125,
            0.6234375,
            0.6234375,
            0.43125,
            0.521875,
            0.3953125,
            0.6328125,
            0.5921875,
            0.81875,
            0.5921875,
            0.5921875,
            0.5265625,
            0.6359375,
            0.4546875,
            0.6359375,
            0.81875
        ],
        avg: 0.6171875000000003
    }
}; // https://developer.mozilla.org/en/docs/Web/CSS/length
// Absolute sizes in pixels for obsolete measurement units.
var $b3e4dc1b6aee4a20$var$absoluteMeasurementUnitsToPixels = {
    mm: 3.8,
    sm: 38,
    pt: 1.33,
    pc: 16,
    in: 96,
    px: 1
};
var $b3e4dc1b6aee4a20$var$relativeMeasurementUnitsCoef = {
    em: 1,
    ex: 0.5
};
var $b3e4dc1b6aee4a20$var$coefficients = {
    heightOverlapCoef: 1.05,
    // Coefficient for height value to prevent overlap.
    lineCapitalCoef: 1.15 // Coefficient for height value. Reserve space for capital chars.
};
var $b3e4dc1b6aee4a20$var$defaultStyle = {
    lineHeight: 1,
    letterSpacing: "0px",
    fontSize: 0,
    angle: 0,
    fontFamily: ""
};
var $b3e4dc1b6aee4a20$var$_degreeToRadian = function(angle) {
    return angle * Math.PI / 180;
};
var $b3e4dc1b6aee4a20$var$_getFontData = function(fontFamily) {
    var possibleFonts = fontFamily.split(",").map(function(f) {
        return f.replace(/'|"/g, "");
    });
    var fontMatch = possibleFonts.find(function(f) {
        return $b3e4dc1b6aee4a20$var$fonts[f];
    }) || "Helvetica";
    return $b3e4dc1b6aee4a20$var$fonts[fontMatch];
};
var $b3e4dc1b6aee4a20$var$_splitToLines = function(text) {
    return Array.isArray(text) ? text : text.toString().split(/\r\n|\r|\n/g);
};
var $b3e4dc1b6aee4a20$var$_getSizeWithRotate = function(axisSize, dependentSize, angle) {
    var angleInRadian = $b3e4dc1b6aee4a20$var$_degreeToRadian(angle);
    return Math.abs(Math.cos(angleInRadian) * axisSize) + Math.abs(Math.sin(angleInRadian) * dependentSize);
};
var $b3e4dc1b6aee4a20$export$396301afc5af34f7 = function(length, fontSize) {
    var _length$match;
    var attribute = (_length$match = length.match(/[a-zA-Z%]+/)) === null || _length$match === void 0 ? void 0 : _length$match[0];
    var value = Number(length.match(/[0-9.,]+/));
    var result;
    if (!attribute) result = value || 0;
    else if ($b3e4dc1b6aee4a20$var$absoluteMeasurementUnitsToPixels.hasOwnProperty(attribute)) result = value * $b3e4dc1b6aee4a20$var$absoluteMeasurementUnitsToPixels[attribute];
    else if ($b3e4dc1b6aee4a20$var$relativeMeasurementUnitsCoef.hasOwnProperty(attribute)) result = (fontSize ? value * fontSize : value * $b3e4dc1b6aee4a20$var$defaultStyle.fontSize) * $b3e4dc1b6aee4a20$var$relativeMeasurementUnitsCoef[attribute];
    else result = value;
    return result;
};
var $b3e4dc1b6aee4a20$var$_prepareParams = function(inputStyle, index) {
    var lineStyle = Array.isArray(inputStyle) ? inputStyle[index] : inputStyle;
    var style = (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, lineStyle, $b3e4dc1b6aee4a20$var$defaultStyle);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, style, {
        fontFamily: style.fontFamily,
        letterSpacing: typeof style.letterSpacing === "number" ? style.letterSpacing : $b3e4dc1b6aee4a20$export$396301afc5af34f7(String(style.letterSpacing), style.fontSize),
        fontSize: typeof style.fontSize === "number" ? style.fontSize : $b3e4dc1b6aee4a20$export$396301afc5af34f7(String(style.fontSize))
    });
};
var $b3e4dc1b6aee4a20$var$_approximateTextWidthInternal = function(text, style) {
    if (text === undefined || text === "" || text === null) return 0;
    var widths = $b3e4dc1b6aee4a20$var$_splitToLines(text).map(function(line, index) {
        var len = line.toString().length;
        var _prepareParams2 = $b3e4dc1b6aee4a20$var$_prepareParams(style, index), fontSize = _prepareParams2.fontSize, letterSpacing = _prepareParams2.letterSpacing, fontFamily = _prepareParams2.fontFamily;
        var fontData = $b3e4dc1b6aee4a20$var$_getFontData(fontFamily);
        var width = line.toString().split("").map(function(c) {
            return c.charCodeAt(0) < fontData.widths.length ? fontData.widths[c.charCodeAt(0)] : fontData.avg;
        }).reduce(function(cur, acc) {
            return acc + cur;
        }, 0) * fontSize;
        return width + letterSpacing * Math.max(len - 1, 0);
    });
    return Math.max.apply(Math, $b3e4dc1b6aee4a20$var$_toConsumableArray(widths));
};
var $b3e4dc1b6aee4a20$var$_approximateTextHeightInternal = function(text, style) {
    if (text === undefined || text === "" || text === null) return 0;
    return $b3e4dc1b6aee4a20$var$_splitToLines(text).reduce(function(total, line, index) {
        var lineStyle = $b3e4dc1b6aee4a20$var$_prepareParams(style, index);
        var containsCaps = line.toString().match(/[(A-Z)(0-9)]/);
        var height = containsCaps ? lineStyle.fontSize * $b3e4dc1b6aee4a20$var$coefficients.lineCapitalCoef : lineStyle.fontSize;
        return total + lineStyle.lineHeight * height;
    }, 0);
};
var $b3e4dc1b6aee4a20$var$_approximateDimensionsInternal = function(text, style) {
    var angle = Array.isArray(style) ? style[0] && style[0].angle : style && style.angle;
    var height = $b3e4dc1b6aee4a20$var$_approximateTextHeightInternal(text, style);
    var width = $b3e4dc1b6aee4a20$var$_approximateTextWidthInternal(text, style);
    var widthWithRotate = angle ? $b3e4dc1b6aee4a20$var$_getSizeWithRotate(width, height, angle) : width;
    var heightWithRotate = angle ? $b3e4dc1b6aee4a20$var$_getSizeWithRotate(height, width, angle) : height;
    return {
        width: widthWithRotate,
        height: heightWithRotate * $b3e4dc1b6aee4a20$var$coefficients.heightOverlapCoef
    };
};
var $b3e4dc1b6aee4a20$var$_getMeasurementContainer = (0, (/*@__PURE__*/$parcel$interopDefault($5659748bd598a7eb$exports)))(function() {
    var element = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    element.setAttribute("xlink", "http://www.w3.org/1999/xlink");
    element.setAttribute("width", "300");
    element.setAttribute("height", "300");
    element.setAttribute("viewBox", "0 0 300 300");
    var containerElement = document.createElementNS("http://www.w3.org/2000/svg", "text");
    element.appendChild(containerElement);
    element.style.position = "fixed";
    element.style.top = "-9999px";
    element.style.left = "-9999px";
    document.body.appendChild(element);
    return containerElement;
});
var $b3e4dc1b6aee4a20$var$styleToKeyComponent = function(style) {
    if (!style) return "null";
    return "".concat(style.angle, ":").concat(style.fontFamily, ":").concat(style.fontSize, ":").concat(style.letterSpacing, ":").concat(style.lineHeight);
};
var $b3e4dc1b6aee4a20$var$_measureDimensionsInternal = (0, (/*@__PURE__*/$parcel$interopDefault($5659748bd598a7eb$exports)))(function(text, style) {
    var containerElement = $b3e4dc1b6aee4a20$var$_getMeasurementContainer();
    var lines = $b3e4dc1b6aee4a20$var$_splitToLines(text);
    var heightAcc = 0;
    for (var _ref of lines.entries()){
        var _ref2 = $b3e4dc1b6aee4a20$var$_slicedToArray(_ref, 2);
        var i = _ref2[0];
        var line = _ref2[1];
        var textElement = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
        var params = $b3e4dc1b6aee4a20$var$_prepareParams(style, i);
        textElement.style.fontFamily = params.fontFamily;
        textElement.style.fontSize = "".concat(params.fontSize, "px");
        textElement.style.lineHeight = params.lineHeight;
        textElement.style.fontFamily = params.fontFamily;
        textElement.style.letterSpacing = params.letterSpacing;
        textElement.textContent = line;
        textElement.setAttribute("x", "0");
        textElement.setAttribute("y", "".concat(heightAcc));
        containerElement.appendChild(textElement);
        heightAcc += params.lineHeight * textElement.getBoundingClientRect().height;
    }
    var _containerElement$get = containerElement.getBoundingClientRect(), width = _containerElement$get.width;
    containerElement.innerHTML = "";
    return {
        width: style !== null && style !== void 0 && style.angle ? $b3e4dc1b6aee4a20$var$_getSizeWithRotate(width, heightAcc, style === null || style === void 0 ? void 0 : style.angle) : width,
        height: style !== null && style !== void 0 && style.angle ? $b3e4dc1b6aee4a20$var$_getSizeWithRotate(heightAcc, width, style === null || style === void 0 ? void 0 : style.angle) : heightAcc
    };
}, function(text, style) {
    var totalText = Array.isArray(text) ? text.join() : text;
    var totalStyle = Array.isArray(style) ? style.map($b3e4dc1b6aee4a20$var$styleToKeyComponent).join() : $b3e4dc1b6aee4a20$var$styleToKeyComponent(style);
    return "".concat(totalText, "::").concat(totalStyle);
});
var $b3e4dc1b6aee4a20$export$be29fb065c04437f = {
    impl: function(text, style) {
        var __debugForceApproximate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        // Attempt to first measure the element in DOM. If there is no DOM, fallback
        // to the less accurate approximation algorithm.
        var isClient = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
        if (!isClient || __debugForceApproximate) return $b3e4dc1b6aee4a20$var$_approximateDimensionsInternal(text, style);
        return $b3e4dc1b6aee4a20$var$_measureDimensionsInternal(text, style);
    }
};
var $b3e4dc1b6aee4a20$export$e04f4b4b0a988f5d = function(text, style) {
    return $b3e4dc1b6aee4a20$export$be29fb065c04437f.impl(text, style);
};



function $b8620e9b9f9774cb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b8620e9b9f9774cb$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b8620e9b9f9774cb$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b8620e9b9f9774cb$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b8620e9b9f9774cb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b8620e9b9f9774cb$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b8620e9b9f9774cb$var$_toConsumableArray(arr) {
    return $b8620e9b9f9774cb$var$_arrayWithoutHoles(arr) || $b8620e9b9f9774cb$var$_iterableToArray(arr) || $b8620e9b9f9774cb$var$_unsupportedIterableToArray(arr) || $b8620e9b9f9774cb$var$_nonIterableSpread();
}
function $b8620e9b9f9774cb$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b8620e9b9f9774cb$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b8620e9b9f9774cb$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b8620e9b9f9774cb$var$_arrayLikeToArray(o, minLen);
}
function $b8620e9b9f9774cb$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $b8620e9b9f9774cb$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $b8620e9b9f9774cb$var$_arrayLikeToArray(arr);
}
function $b8620e9b9f9774cb$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $b8620e9b9f9774cb$var$defaultStyles = {
    fill: "#252525",
    fontSize: 14,
    fontFamily: "'Gill Sans', 'Gill Sans MT', 'Ser\xadavek', 'Trebuchet MS', sans-serif",
    stroke: "transparent"
};
var $b8620e9b9f9774cb$var$getPosition = function(props, dimension) {
    if (!props.datum) return 0;
    var scaledPoint = $0a5de8228869aa1e$export$2290ec7febe36dd6(props, props.datum);
    return scaledPoint[dimension];
};
var $b8620e9b9f9774cb$var$getFontSize = function(style) {
    var baseSize = style && style.fontSize;
    if (typeof baseSize === "number") return baseSize;
    else if (baseSize === undefined || baseSize === null) return $b8620e9b9f9774cb$var$defaultStyles.fontSize;
    else if (typeof baseSize === "string") {
        var fontSize = Number(baseSize.replace("px", ""));
        if (!isNaN(fontSize)) return fontSize;
        $8590ed3b940180fa$export$c106dd0671a0fc2d("fontSize should be expressed as a number of pixels");
        return $b8620e9b9f9774cb$var$defaultStyles.fontSize;
    }
    return $b8620e9b9f9774cb$var$defaultStyles.fontSize;
};
var $b8620e9b9f9774cb$var$getSingleValue = function(prop) {
    var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return Array.isArray(prop) ? prop[index] || prop[0] : prop;
};
var $b8620e9b9f9774cb$var$shouldUseMultilineBackgrounds = function(props) {
    var backgroundStyle = props.backgroundStyle, backgroundPadding = props.backgroundPadding;
    return Array.isArray(backgroundStyle) && !(0, (/*@__PURE__*/$parcel$interopDefault($1331767f05251f48$exports)))(backgroundStyle) || Array.isArray(backgroundPadding) && !(0, (/*@__PURE__*/$parcel$interopDefault($1331767f05251f48$exports)))(backgroundPadding);
};
var $b8620e9b9f9774cb$var$getStyles = function(style, props) {
    if (props.disableInlineStyles) {
        var baseStyles = $0a5de8228869aa1e$export$b94dbb3a3654958c(style, props);
        return {
            // Font size is necessary to calculate the y position of the label
            fontSize: $b8620e9b9f9774cb$var$getFontSize(baseStyles)
        };
    }
    var getSingleStyle = function(s) {
        s = s ? (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, s, $b8620e9b9f9774cb$var$defaultStyles) : $b8620e9b9f9774cb$var$defaultStyles;
        var baseStyles = $0a5de8228869aa1e$export$b94dbb3a3654958c(s, props);
        return (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, baseStyles, {
            fontSize: $b8620e9b9f9774cb$var$getFontSize(baseStyles)
        });
    };
    return Array.isArray(style) && !(0, (/*@__PURE__*/$parcel$interopDefault($1331767f05251f48$exports)))(style) ? style.map(function(s) {
        return getSingleStyle(s);
    }) : getSingleStyle(style);
};
var $b8620e9b9f9774cb$var$getBackgroundStyles = function(style, props) {
    if (!style) return undefined;
    return Array.isArray(style) && !(0, (/*@__PURE__*/$parcel$interopDefault($1331767f05251f48$exports)))(style) ? style.map(function(s) {
        return $0a5de8228869aa1e$export$b94dbb3a3654958c(s, props);
    }) : $0a5de8228869aa1e$export$b94dbb3a3654958c(style, props);
};
var $b8620e9b9f9774cb$var$getBackgroundPadding = function(props) {
    if (props.backgroundPadding && Array.isArray(props.backgroundPadding)) return props.backgroundPadding.map(function(backgroundPadding) {
        var padding = $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(backgroundPadding, props);
        return $0a5de8228869aa1e$export$d7501e6bee71bfee({
            padding: padding
        });
    });
    var padding = $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(props.backgroundPadding, props);
    return $0a5de8228869aa1e$export$d7501e6bee71bfee({
        padding: padding
    });
};
var $b8620e9b9f9774cb$var$getLineHeight = function(props) {
    var lineHeight = $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(props.lineHeight, props);
    if (Array.isArray(lineHeight)) return (0, (/*@__PURE__*/$parcel$interopDefault($1331767f05251f48$exports)))(lineHeight) ? [
        1
    ] : lineHeight;
    return lineHeight;
};
var $b8620e9b9f9774cb$var$getContent = function(text, props) {
    if (text === undefined || text === null) return undefined;
    if (Array.isArray(text)) return text.map(function(line) {
        return $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(line, props);
    });
    var child = $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(text, props);
    if (child === undefined || child === null) return undefined;
    return Array.isArray(child) ? child : "".concat(child).split("\n");
};
var $b8620e9b9f9774cb$var$getDy = function(props, verticalAnchor, lineHeight) {
    var dy = props.dy ? $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(props.dy, props) : 0;
    var length = props.inline ? 1 : props.text.length;
    var capHeight = $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(props.capHeight, props);
    var anchor = verticalAnchor ? $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(verticalAnchor, props) : "middle";
    var fontSizes = $b8620e9b9f9774cb$var$_toConsumableArray(Array(length).keys()).map(function(i) {
        return $b8620e9b9f9774cb$var$getSingleValue(props.style, i).fontSize;
    });
    var lineHeights = $b8620e9b9f9774cb$var$_toConsumableArray(Array(length).keys()).map(function(i) {
        return $b8620e9b9f9774cb$var$getSingleValue(lineHeight, i);
    });
    if (anchor === "start") return dy + (capHeight / 2 + lineHeights[0] / 2) * fontSizes[0];
    else if (props.inline) return anchor === "end" ? dy + (capHeight / 2 - lineHeights[0] / 2) * fontSizes[0] : dy + capHeight / 2 * fontSizes[0];
    else if (length === 1) return anchor === "end" ? dy + (capHeight / 2 + (0.5 - length) * lineHeights[0]) * fontSizes[0] : dy + (capHeight / 2 + (0.5 - length / 2) * lineHeights[0]) * fontSizes[0];
    var allHeights = $b8620e9b9f9774cb$var$_toConsumableArray(Array(length).keys()).reduce(function(memo, i) {
        return memo + (capHeight / 2 + (0.5 - length) * lineHeights[i]) * fontSizes[i] / length;
    }, 0);
    return anchor === "end" ? dy + allHeights : dy + allHeights / 2 + capHeight / 2 * lineHeights[length - 1] * fontSizes[length - 1];
};
var $b8620e9b9f9774cb$var$getTransform = function(props, x, y) {
    var polar = props.polar;
    var style = $b8620e9b9f9774cb$var$getSingleValue(props.style);
    var defaultAngle = polar ? $e6236e426b53ba14$export$c5bce4840d298b9b(props) : 0;
    var baseAngle = style.angle === undefined ? $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(props.angle, props) : style.angle;
    var angle = baseAngle === undefined ? defaultAngle : baseAngle;
    var transform = props.transform || style.transform;
    var transformPart = transform && $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(transform, props);
    var rotatePart = angle && {
        rotate: [
            angle,
            x,
            y
        ]
    };
    return transformPart || angle ? $adad185069bfc115$export$9ebaeae2c52fdc4c(transformPart, rotatePart) : undefined;
};
var $b8620e9b9f9774cb$var$getXCoordinate = function(calculatedProps, labelSizeWidth) {
    var direction = calculatedProps.direction, textAnchor = calculatedProps.textAnchor, x = calculatedProps.x, dx = calculatedProps.dx;
    if (direction === "rtl") return x - labelSizeWidth;
    switch(textAnchor){
        case "middle":
            return Math.round(x - labelSizeWidth / 2);
        case "end":
            return Math.round(x - labelSizeWidth);
        default:
            // start
            return x + (dx || 0);
    }
};
var $b8620e9b9f9774cb$var$getYCoordinate = function(calculatedProps, textHeight) {
    var verticalAnchor = calculatedProps.verticalAnchor, y = calculatedProps.y, _calculatedProps$orig = calculatedProps.originalDy, originalDy = _calculatedProps$orig === void 0 ? 0 : _calculatedProps$orig;
    var offset = y + originalDy;
    switch(verticalAnchor){
        case "start":
            return Math.floor(offset);
        case "end":
            return Math.ceil(offset - textHeight);
        default:
            // middle
            return Math.floor(offset - textHeight / 2);
    }
};
var $b8620e9b9f9774cb$var$getFullBackground = function(calculatedProps, tspanValues) {
    var _calculatedProps$dx = calculatedProps.dx, dx = _calculatedProps$dx === void 0 ? 0 : _calculatedProps$dx, transform = calculatedProps.transform, backgroundComponent = calculatedProps.backgroundComponent, backgroundStyle = calculatedProps.backgroundStyle, inline = calculatedProps.inline, backgroundPadding = calculatedProps.backgroundPadding, capHeight = calculatedProps.capHeight;
    var textSizes = tspanValues.map(function(tspan) {
        return tspan.textSize;
    });
    var height = inline ? Math.max.apply(Math, $b8620e9b9f9774cb$var$_toConsumableArray(textSizes.map(function(size) {
        return size.height;
    }))) : textSizes.reduce(function(memo, size, i) {
        var capHeightAdjustment = i ? 0 : capHeight / 2;
        return memo + size.height * (tspanValues[i].lineHeight - capHeightAdjustment);
    }, 0);
    var width = inline ? textSizes.reduce(function(memo, size, index) {
        var offset = index ? dx : 0;
        return memo + size.width + offset;
    }, 0) : Math.max.apply(Math, $b8620e9b9f9774cb$var$_toConsumableArray(textSizes.map(function(size) {
        return size.width;
    })));
    var xCoordinate = $b8620e9b9f9774cb$var$getXCoordinate(calculatedProps, width);
    var yCoordinate = $b8620e9b9f9774cb$var$getYCoordinate(calculatedProps, height);
    var backgroundProps = {
        key: "background",
        height: height + backgroundPadding.top + backgroundPadding.bottom,
        style: backgroundStyle,
        transform: transform,
        width: width + backgroundPadding.left + backgroundPadding.right,
        x: inline ? xCoordinate - backgroundPadding.left : xCoordinate + dx - backgroundPadding.left,
        y: yCoordinate
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(backgroundComponent, (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, backgroundComponent.props, backgroundProps));
};
var $b8620e9b9f9774cb$var$getInlineXOffset = function(calculatedProps, textElements, index) {
    var textAnchor = calculatedProps.textAnchor;
    var widths = textElements.map(function(t) {
        return t.widthWithPadding;
    });
    var totalWidth = widths.reduce(function(memo, width) {
        return memo + width;
    }, 0);
    var centerOffset = -totalWidth / 2;
    switch(textAnchor){
        case "start":
            return widths.reduce(function(memo, width, i) {
                memo = i < index ? memo + width : memo;
                return memo;
            }, 0);
        case "end":
            return widths.reduce(function(memo, width, i) {
                memo = i > index ? memo - width : memo;
                return memo;
            }, 0);
        default:
            // middle
            return widths.reduce(function(memo, width, i) {
                var offsetWidth = i < index ? width : 0;
                memo = i === index ? memo + width / 2 : memo + offsetWidth;
                return memo;
            }, centerOffset);
    }
};
var $b8620e9b9f9774cb$var$getChildBackgrounds = function(calculatedProps, tspanValues) {
    var dy = calculatedProps.dy, dx = calculatedProps.dx, transform = calculatedProps.transform, backgroundStyle = calculatedProps.backgroundStyle, backgroundPadding = calculatedProps.backgroundPadding, backgroundComponent = calculatedProps.backgroundComponent, inline = calculatedProps.inline, y = calculatedProps.y;
    var textElements = tspanValues.map(function(current, i) {
        var previous = $b8620e9b9f9774cb$var$getSingleValue(tspanValues, i - 1);
        var labelSize = current.textSize;
        var totalLineHeight = current.fontSize * current.lineHeight;
        var textHeight = Math.ceil(totalLineHeight);
        var padding = $b8620e9b9f9774cb$var$getSingleValue(backgroundPadding, i);
        var prevPadding = $b8620e9b9f9774cb$var$getSingleValue(backgroundPadding, i - 1);
        var xOffset = inline ? dx || 0 : 0;
        var childDy = i && !inline ? previous.fontSize * previous.lineHeight + prevPadding.top + prevPadding.bottom : dy - totalLineHeight * 0.5 - (current.fontSize - current.capHeight);
        return {
            textHeight: textHeight,
            labelSize: labelSize,
            heightWithPadding: textHeight + padding.top + padding.bottom,
            widthWithPadding: labelSize.width + padding.left + padding.right + xOffset,
            y: y,
            fontSize: current.fontSize,
            dy: childDy
        };
    });
    return textElements.map(function(textElement, i) {
        var xCoordinate = $b8620e9b9f9774cb$var$getXCoordinate(calculatedProps, textElement.labelSize.width);
        var yCoordinate = textElements.slice(0, i + 1).reduce(function(prev, curr) {
            return prev + curr.dy;
        }, y);
        var padding = $b8620e9b9f9774cb$var$getSingleValue(backgroundPadding, i);
        var height = textElement.heightWithPadding;
        var xCoord = inline ? $b8620e9b9f9774cb$var$getInlineXOffset(calculatedProps, textElements, i) + xCoordinate - padding.left : xCoordinate;
        var yCoord = inline ? $b8620e9b9f9774cb$var$getYCoordinate(calculatedProps, height) - padding.top : yCoordinate;
        var backgroundProps = {
            key: "tspan-background-".concat(i),
            height: height,
            style: $b8620e9b9f9774cb$var$getSingleValue(backgroundStyle, i),
            width: textElement.widthWithPadding,
            transform: transform,
            x: xCoord - padding.left,
            y: yCoord
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(backgroundComponent, (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, backgroundComponent.props, backgroundProps));
    });
};
var $b8620e9b9f9774cb$var$getBackgroundElement = function(calculatedProps, tspanValues) {
    return $b8620e9b9f9774cb$var$shouldUseMultilineBackgrounds(calculatedProps) ? $b8620e9b9f9774cb$var$getChildBackgrounds(calculatedProps, tspanValues) : $b8620e9b9f9774cb$var$getFullBackground(calculatedProps, tspanValues);
};
var $b8620e9b9f9774cb$var$calculateSpanDy = function(tspanValues, i, calculatedProps) {
    var current = $b8620e9b9f9774cb$var$getSingleValue(tspanValues, i);
    var previous = $b8620e9b9f9774cb$var$getSingleValue(tspanValues, i - 1);
    var previousHeight = previous.fontSize * previous.lineHeight;
    var currentHeight = current.fontSize * current.lineHeight;
    var previousCaps = previous.fontSize - previous.capHeight;
    var currentCaps = current.fontSize - current.capHeight;
    var textHeight = previousHeight - previous.fontSize / 2 + current.fontSize / 2 - previousHeight / 2 + currentHeight / 2 - currentCaps / 2 + previousCaps / 2;
    return $b8620e9b9f9774cb$var$shouldUseMultilineBackgrounds(calculatedProps) ? textHeight + current.backgroundPadding.top + previous.backgroundPadding.bottom : textHeight;
};
var $b8620e9b9f9774cb$var$getTSpanDy = function(tspanValues, calculatedProps, i) {
    var inline = calculatedProps.inline;
    var current = $b8620e9b9f9774cb$var$getSingleValue(tspanValues, i);
    if (i && !inline) return $b8620e9b9f9774cb$var$calculateSpanDy(tspanValues, i, calculatedProps);
    else if (inline) return i === 0 ? current.backgroundPadding.top : undefined;
    return current.backgroundPadding.top;
};
var $b8620e9b9f9774cb$var$evaluateProps = function(props) {
    /* Potential evaluated props are
    1) text
    2) style
    3) everything else
  */ var text = $b8620e9b9f9774cb$var$getContent(props.text, props);
    var style = $b8620e9b9f9774cb$var$getStyles(props.style, (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, props, {
        text: text
    }));
    var backgroundStyle = $b8620e9b9f9774cb$var$getBackgroundStyles(props.backgroundStyle, (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, props, {
        text: text,
        style: style
    }));
    var backgroundPadding = $b8620e9b9f9774cb$var$getBackgroundPadding((0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, props, {
        text: text,
        style: style,
        backgroundStyle: backgroundStyle
    }));
    var id = $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(props.id, props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, props, {
        backgroundStyle: backgroundStyle,
        backgroundPadding: backgroundPadding,
        style: style,
        text: text,
        id: id
    });
};
var $b8620e9b9f9774cb$var$getCalculatedProps = function(props) {
    var ariaLabel = $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(props.ariaLabel, props);
    var style = $b8620e9b9f9774cb$var$getSingleValue(props.style);
    var lineHeight = $b8620e9b9f9774cb$var$getLineHeight(props);
    var direction = props.direction ? $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(props.direction, props) : "inherit";
    var textAnchor = props.textAnchor ? $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(props.textAnchor, props) : style.textAnchor || "start";
    var verticalAnchor = props.verticalAnchor ? $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(props.verticalAnchor, props) : style.verticalAnchor || "middle";
    var dx = props.dx ? $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(props.dx, props) : 0;
    var dy = $b8620e9b9f9774cb$var$getDy(props, verticalAnchor, lineHeight);
    var x = props.x !== undefined ? props.x : $b8620e9b9f9774cb$var$getPosition(props, "x");
    var y = props.y !== undefined ? props.y : $b8620e9b9f9774cb$var$getPosition(props, "y");
    var transform = $b8620e9b9f9774cb$var$getTransform(props, x, y);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, props, {
        ariaLabel: ariaLabel,
        lineHeight: lineHeight,
        direction: direction,
        textAnchor: textAnchor,
        verticalAnchor: verticalAnchor,
        dx: dx,
        dy: dy,
        originalDy: props.dy,
        transform: transform,
        x: x,
        y: y
    });
};
var $b8620e9b9f9774cb$var$renderLabel = function(calculatedProps, tspanValues) {
    var ariaLabel = calculatedProps.ariaLabel, inline = calculatedProps.inline, className = calculatedProps.className, title = calculatedProps.title, events = calculatedProps.events, direction = calculatedProps.direction, text = calculatedProps.text, textAnchor = calculatedProps.textAnchor, dx = calculatedProps.dx, dy = calculatedProps.dy, transform = calculatedProps.transform, x = calculatedProps.x, y = calculatedProps.y, desc = calculatedProps.desc, id = calculatedProps.id, tabIndex = calculatedProps.tabIndex, tspanComponent = calculatedProps.tspanComponent, textComponent = calculatedProps.textComponent;
    var userProps = $a9e703a4a20da87d$export$c17686e242f4c700(calculatedProps);
    var textProps = $b8620e9b9f9774cb$var$_objectSpread($b8620e9b9f9774cb$var$_objectSpread({
        "aria-label": ariaLabel,
        key: "text"
    }, events), {}, {
        direction: direction,
        dx: dx,
        x: x,
        y: y + dy,
        transform: transform,
        className: className,
        title: title,
        desc: $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(desc, calculatedProps),
        tabIndex: $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(tabIndex, calculatedProps),
        id: id
    }, userProps);
    var tspans = text.map(function(line, i) {
        var currentStyle = tspanValues[i].style;
        var tspanProps = {
            key: "".concat(id, "-key-").concat(i),
            x: !inline ? x : undefined,
            dx: inline ? dx + tspanValues[i].backgroundPadding.left : dx,
            dy: $b8620e9b9f9774cb$var$getTSpanDy(tspanValues, calculatedProps, i),
            textAnchor: currentStyle.textAnchor || textAnchor,
            style: currentStyle,
            children: line
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(tspanComponent, tspanProps);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(textComponent, textProps, tspans);
};
var $b8620e9b9f9774cb$export$5c9ddd0cb3c79d22 = function(props) {
    props = $b8620e9b9f9774cb$var$evaluateProps(props);
    if (props.text === null || props.text === undefined) return null;
    var calculatedProps = $b8620e9b9f9774cb$var$getCalculatedProps(props);
    var text = calculatedProps.text, style = calculatedProps.style, capHeight = calculatedProps.capHeight, backgroundPadding = calculatedProps.backgroundPadding, lineHeight = calculatedProps.lineHeight;
    var tspanValues = text.map(function(line, i) {
        var currentStyle = $b8620e9b9f9774cb$var$getSingleValue(style, i);
        var capHeightPx = $b3e4dc1b6aee4a20$export$396301afc5af34f7("".concat(capHeight, "em"), currentStyle.fontSize);
        var currentLineHeight = $b8620e9b9f9774cb$var$getSingleValue(lineHeight, i);
        return {
            style: currentStyle,
            fontSize: currentStyle.fontSize || $b8620e9b9f9774cb$var$defaultStyles.fontSize,
            capHeight: capHeightPx,
            text: line,
            // @ts-expect-error TODO: This looks like a bug:
            textSize: $b3e4dc1b6aee4a20$export$e04f4b4b0a988f5d(line, currentStyle),
            lineHeight: currentLineHeight,
            backgroundPadding: $b8620e9b9f9774cb$var$getSingleValue(backgroundPadding, i)
        };
    });
    var label = $b8620e9b9f9774cb$var$renderLabel(calculatedProps, tspanValues);
    if (props.backgroundStyle) {
        var backgroundElement = $b8620e9b9f9774cb$var$getBackgroundElement(calculatedProps, tspanValues);
        var children = [
            backgroundElement,
            label
        ];
        var backgroundWithLabel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(props.groupComponent, {}, children);
        return props.renderInPortal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $5d2ca5b3e3e5812f$export$458e39702099cd5e), null, backgroundWithLabel) : backgroundWithLabel;
    }
    return props.renderInPortal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $5d2ca5b3e3e5812f$export$458e39702099cd5e), null, label) : label;
};
$b8620e9b9f9774cb$export$5c9ddd0cb3c79d22.displayName = "VictoryLabel";
$b8620e9b9f9774cb$export$5c9ddd0cb3c79d22.role = "label";
$b8620e9b9f9774cb$export$5c9ddd0cb3c79d22.defaultStyles = $b8620e9b9f9774cb$var$defaultStyles;
$b8620e9b9f9774cb$export$5c9ddd0cb3c79d22.propTypes = {
    active: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    angle: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]),
    ariaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]),
    backgroundComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    backgroundPadding: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array
    ]),
    backgroundStyle: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array
    ]),
    capHeight: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        $9dba2b2bbfc485d5$export$1832c645056d4ce2,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    data: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array,
    datum: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    // @ts-expect-error "Function is not assignable to string"
    desc: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]),
    direction: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        "rtl",
        "ltr",
        "inherit"
    ]),
    dx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]),
    dy: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]),
    events: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    groupComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]),
    index: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    inline: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    labelPlacement: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        "parallel",
        "perpendicular",
        "vertical"
    ]),
    lineHeight: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        $9dba2b2bbfc485d5$export$1832c645056d4ce2,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array
    ]),
    origin: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        x: $9dba2b2bbfc485d5$export$1832c645056d4ce2.isRequired,
        y: $9dba2b2bbfc485d5$export$1832c645056d4ce2.isRequired
    }),
    polar: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    renderInPortal: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        x: $9dba2b2bbfc485d5$export$dcdf75081b88279d,
        y: $9dba2b2bbfc485d5$export$dcdf75081b88279d
    }),
    style: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array
    ]),
    tabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]),
    text: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array
    ]),
    // @ts-expect-error Function is not assignable to string"
    textAnchor: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            "start",
            "middle",
            "end",
            "inherit"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]),
    textComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    transform: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]),
    tspanComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    // @ts-expect-error Function is not assignable to string"
    verticalAnchor: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            "start",
            "middle",
            "end"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]),
    // @ts-expect-error Number is not assignable to string
    x: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    // @ts-expect-error Number is not assignable to string
    y: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ])
};
$b8620e9b9f9774cb$export$5c9ddd0cb3c79d22.defaultProps = {
    backgroundComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $dfe2911367ea308b$export$c79fc6492f3af13d), null),
    groupComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("g", null),
    direction: "inherit",
    textComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $719221856adca4bf$export$5f1af8db9871e1d6), null),
    tspanComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $d858a3092d8e6d8f$export$f2c08a339e307379), null),
    capHeight: 0.71,
    // Magic number from d3.
    lineHeight: 1
};


// *
// * Colors
// *
var $c870d22bbc3e0049$var$colors = [
    "#252525",
    "#525252",
    "#737373",
    "#969696",
    "#bdbdbd",
    "#d9d9d9",
    "#f0f0f0"
];
var $c870d22bbc3e0049$var$charcoal = "#252525";
var $c870d22bbc3e0049$var$grey = "#969696"; // *
// * Typography
// *
var $c870d22bbc3e0049$var$sansSerif = "'Gill Sans', 'Seravek', 'Trebuchet MS', sans-serif";
var $c870d22bbc3e0049$var$letterSpacing = "normal";
var $c870d22bbc3e0049$var$fontSize = 14; // *
// * Layout
// *
var $c870d22bbc3e0049$var$baseProps = {
    width: 450,
    height: 300,
    padding: 50,
    colorScale: $c870d22bbc3e0049$var$colors
}; // *
// * Labels
// *
var $c870d22bbc3e0049$var$baseLabelStyles = {
    fontFamily: $c870d22bbc3e0049$var$sansSerif,
    fontSize: $c870d22bbc3e0049$var$fontSize,
    letterSpacing: $c870d22bbc3e0049$var$letterSpacing,
    padding: 10,
    fill: $c870d22bbc3e0049$var$charcoal,
    stroke: "transparent"
};
var $c870d22bbc3e0049$var$centeredLabelStyles = (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
    textAnchor: "middle"
}, $c870d22bbc3e0049$var$baseLabelStyles); // *
// * Strokes
// *
var $c870d22bbc3e0049$var$strokeLinecap = "round";
var $c870d22bbc3e0049$var$strokeLinejoin = "round";
var $c870d22bbc3e0049$export$6f416a6db2dfcd5c = {
    area: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        style: {
            data: {
                fill: $c870d22bbc3e0049$var$charcoal
            },
            labels: $c870d22bbc3e0049$var$baseLabelStyles
        }
    }, $c870d22bbc3e0049$var$baseProps),
    axis: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        style: {
            axis: {
                fill: "transparent",
                stroke: $c870d22bbc3e0049$var$charcoal,
                strokeWidth: 1,
                strokeLinecap: $c870d22bbc3e0049$var$strokeLinecap,
                strokeLinejoin: $c870d22bbc3e0049$var$strokeLinejoin
            },
            axisLabel: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, $c870d22bbc3e0049$var$centeredLabelStyles, {
                padding: 25
            }),
            grid: {
                fill: "none",
                stroke: "none",
                pointerEvents: "painted"
            },
            ticks: {
                fill: "transparent",
                size: 1,
                stroke: "transparent"
            },
            tickLabels: $c870d22bbc3e0049$var$baseLabelStyles
        }
    }, $c870d22bbc3e0049$var$baseProps),
    bar: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        style: {
            data: {
                fill: $c870d22bbc3e0049$var$charcoal,
                padding: 8,
                strokeWidth: 0
            },
            labels: $c870d22bbc3e0049$var$baseLabelStyles
        }
    }, $c870d22bbc3e0049$var$baseProps),
    boxplot: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        style: {
            max: {
                padding: 8,
                stroke: $c870d22bbc3e0049$var$charcoal,
                strokeWidth: 1
            },
            maxLabels: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, $c870d22bbc3e0049$var$baseLabelStyles, {
                padding: 3
            }),
            median: {
                padding: 8,
                stroke: $c870d22bbc3e0049$var$charcoal,
                strokeWidth: 1
            },
            medianLabels: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, $c870d22bbc3e0049$var$baseLabelStyles, {
                padding: 3
            }),
            min: {
                padding: 8,
                stroke: $c870d22bbc3e0049$var$charcoal,
                strokeWidth: 1
            },
            minLabels: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, $c870d22bbc3e0049$var$baseLabelStyles, {
                padding: 3
            }),
            q1: {
                padding: 8,
                fill: $c870d22bbc3e0049$var$grey
            },
            q1Labels: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, $c870d22bbc3e0049$var$baseLabelStyles, {
                padding: 3
            }),
            q3: {
                padding: 8,
                fill: $c870d22bbc3e0049$var$grey
            },
            q3Labels: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, $c870d22bbc3e0049$var$baseLabelStyles, {
                padding: 3
            })
        },
        boxWidth: 20
    }, $c870d22bbc3e0049$var$baseProps),
    candlestick: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        style: {
            data: {
                stroke: $c870d22bbc3e0049$var$charcoal,
                strokeWidth: 1
            },
            labels: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, $c870d22bbc3e0049$var$baseLabelStyles, {
                padding: 5
            })
        },
        candleColors: {
            positive: "#ffffff",
            negative: $c870d22bbc3e0049$var$charcoal
        }
    }, $c870d22bbc3e0049$var$baseProps),
    chart: $c870d22bbc3e0049$var$baseProps,
    errorbar: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        borderWidth: 8,
        style: {
            data: {
                fill: "transparent",
                stroke: $c870d22bbc3e0049$var$charcoal,
                strokeWidth: 2
            },
            labels: $c870d22bbc3e0049$var$baseLabelStyles
        }
    }, $c870d22bbc3e0049$var$baseProps),
    group: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        colorScale: $c870d22bbc3e0049$var$colors
    }, $c870d22bbc3e0049$var$baseProps),
    histogram: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        style: {
            data: {
                fill: $c870d22bbc3e0049$var$grey,
                stroke: $c870d22bbc3e0049$var$charcoal,
                strokeWidth: 2
            },
            labels: $c870d22bbc3e0049$var$baseLabelStyles
        }
    }, $c870d22bbc3e0049$var$baseProps),
    legend: {
        colorScale: $c870d22bbc3e0049$var$colors,
        gutter: 10,
        orientation: "vertical",
        titleOrientation: "top",
        style: {
            data: {
                type: "circle"
            },
            labels: $c870d22bbc3e0049$var$baseLabelStyles,
            title: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, $c870d22bbc3e0049$var$baseLabelStyles, {
                padding: 5
            })
        }
    },
    line: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        style: {
            data: {
                fill: "transparent",
                stroke: $c870d22bbc3e0049$var$charcoal,
                strokeWidth: 2
            },
            labels: $c870d22bbc3e0049$var$baseLabelStyles
        }
    }, $c870d22bbc3e0049$var$baseProps),
    pie: {
        style: {
            data: {
                padding: 10,
                stroke: "transparent",
                strokeWidth: 1
            },
            labels: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, $c870d22bbc3e0049$var$baseLabelStyles, {
                padding: 20
            })
        },
        colorScale: $c870d22bbc3e0049$var$colors,
        width: 400,
        height: 400,
        padding: 50
    },
    scatter: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        style: {
            data: {
                fill: $c870d22bbc3e0049$var$charcoal,
                stroke: "transparent",
                strokeWidth: 0
            },
            labels: $c870d22bbc3e0049$var$baseLabelStyles
        }
    }, $c870d22bbc3e0049$var$baseProps),
    stack: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        colorScale: $c870d22bbc3e0049$var$colors
    }, $c870d22bbc3e0049$var$baseProps),
    tooltip: {
        style: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, $c870d22bbc3e0049$var$baseLabelStyles, {
            padding: 0,
            pointerEvents: "none"
        }),
        flyoutStyle: {
            stroke: $c870d22bbc3e0049$var$charcoal,
            strokeWidth: 1,
            fill: "#f0f0f0",
            pointerEvents: "none"
        },
        flyoutPadding: 5,
        cornerRadius: 5,
        pointerLength: 10
    },
    voronoi: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        style: {
            data: {
                fill: "transparent",
                stroke: "transparent",
                strokeWidth: 0
            },
            labels: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, $c870d22bbc3e0049$var$baseLabelStyles, {
                padding: 5,
                pointerEvents: "none"
            }),
            flyout: {
                stroke: $c870d22bbc3e0049$var$charcoal,
                strokeWidth: 1,
                fill: "#f0f0f0",
                pointerEvents: "none"
            }
        }
    }, $c870d22bbc3e0049$var$baseProps)
};



// *
// * Colors
// *
var $e5c68eb3bf810a05$var$yellow200 = "#FFF59D";
var $e5c68eb3bf810a05$var$deepOrange600 = "#F4511E";
var $e5c68eb3bf810a05$var$lime300 = "#DCE775";
var $e5c68eb3bf810a05$var$lightGreen500 = "#8BC34A";
var $e5c68eb3bf810a05$var$teal700 = "#00796B";
var $e5c68eb3bf810a05$var$cyan900 = "#006064";
var $e5c68eb3bf810a05$var$colors = [
    $e5c68eb3bf810a05$var$deepOrange600,
    $e5c68eb3bf810a05$var$yellow200,
    $e5c68eb3bf810a05$var$lime300,
    $e5c68eb3bf810a05$var$lightGreen500,
    $e5c68eb3bf810a05$var$teal700,
    $e5c68eb3bf810a05$var$cyan900
];
var $e5c68eb3bf810a05$var$blueGrey50 = "#ECEFF1";
var $e5c68eb3bf810a05$var$blueGrey300 = "#90A4AE";
var $e5c68eb3bf810a05$var$blueGrey700 = "#455A64";
var $e5c68eb3bf810a05$var$grey900 = "#212121"; // *
// * Typography
// *
var $e5c68eb3bf810a05$var$sansSerif = "'Helvetica Neue', 'Helvetica', sans-serif";
var $e5c68eb3bf810a05$var$letterSpacing = "normal";
var $e5c68eb3bf810a05$var$fontSize = 12; // *
// * Layout
// *
var $e5c68eb3bf810a05$var$padding = 8;
var $e5c68eb3bf810a05$var$baseProps = {
    width: 350,
    height: 350,
    padding: 50
}; // *
// * Labels
// *
var $e5c68eb3bf810a05$var$baseLabelStyles = {
    fontFamily: $e5c68eb3bf810a05$var$sansSerif,
    fontSize: $e5c68eb3bf810a05$var$fontSize,
    letterSpacing: $e5c68eb3bf810a05$var$letterSpacing,
    padding: $e5c68eb3bf810a05$var$padding,
    fill: $e5c68eb3bf810a05$var$blueGrey700,
    stroke: "transparent",
    strokeWidth: 0
};
var $e5c68eb3bf810a05$var$centeredLabelStyles = (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
    textAnchor: "middle"
}, $e5c68eb3bf810a05$var$baseLabelStyles); // *
// * Strokes
// *
var $e5c68eb3bf810a05$var$strokeDasharray = "10, 5";
var $e5c68eb3bf810a05$var$strokeLinecap = "round";
var $e5c68eb3bf810a05$var$strokeLinejoin = "round";
var $e5c68eb3bf810a05$export$15d6f59453b50ec6 = {
    area: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        style: {
            data: {
                fill: $e5c68eb3bf810a05$var$grey900
            },
            labels: $e5c68eb3bf810a05$var$baseLabelStyles
        }
    }, $e5c68eb3bf810a05$var$baseProps),
    axis: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        style: {
            axis: {
                fill: "transparent",
                stroke: $e5c68eb3bf810a05$var$blueGrey300,
                strokeWidth: 2,
                strokeLinecap: $e5c68eb3bf810a05$var$strokeLinecap,
                strokeLinejoin: $e5c68eb3bf810a05$var$strokeLinejoin
            },
            axisLabel: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, $e5c68eb3bf810a05$var$centeredLabelStyles, {
                padding: $e5c68eb3bf810a05$var$padding,
                stroke: "transparent"
            }),
            grid: {
                fill: "none",
                stroke: $e5c68eb3bf810a05$var$blueGrey50,
                strokeDasharray: $e5c68eb3bf810a05$var$strokeDasharray,
                strokeLinecap: $e5c68eb3bf810a05$var$strokeLinecap,
                strokeLinejoin: $e5c68eb3bf810a05$var$strokeLinejoin,
                pointerEvents: "painted"
            },
            ticks: {
                fill: "transparent",
                size: 5,
                stroke: $e5c68eb3bf810a05$var$blueGrey300,
                strokeWidth: 1,
                strokeLinecap: $e5c68eb3bf810a05$var$strokeLinecap,
                strokeLinejoin: $e5c68eb3bf810a05$var$strokeLinejoin
            },
            tickLabels: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, $e5c68eb3bf810a05$var$baseLabelStyles, {
                fill: $e5c68eb3bf810a05$var$blueGrey700
            })
        }
    }, $e5c68eb3bf810a05$var$baseProps),
    polarDependentAxis: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        style: {
            ticks: {
                fill: "transparent",
                size: 1,
                stroke: "transparent"
            }
        }
    }),
    bar: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        style: {
            data: {
                fill: $e5c68eb3bf810a05$var$blueGrey700,
                padding: $e5c68eb3bf810a05$var$padding,
                strokeWidth: 0
            },
            labels: $e5c68eb3bf810a05$var$baseLabelStyles
        }
    }, $e5c68eb3bf810a05$var$baseProps),
    boxplot: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        style: {
            max: {
                padding: $e5c68eb3bf810a05$var$padding,
                stroke: $e5c68eb3bf810a05$var$blueGrey700,
                strokeWidth: 1
            },
            maxLabels: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, $e5c68eb3bf810a05$var$baseLabelStyles, {
                padding: 3
            }),
            median: {
                padding: $e5c68eb3bf810a05$var$padding,
                stroke: $e5c68eb3bf810a05$var$blueGrey700,
                strokeWidth: 1
            },
            medianLabels: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, $e5c68eb3bf810a05$var$baseLabelStyles, {
                padding: 3
            }),
            min: {
                padding: $e5c68eb3bf810a05$var$padding,
                stroke: $e5c68eb3bf810a05$var$blueGrey700,
                strokeWidth: 1
            },
            minLabels: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, $e5c68eb3bf810a05$var$baseLabelStyles, {
                padding: 3
            }),
            q1: {
                padding: $e5c68eb3bf810a05$var$padding,
                fill: $e5c68eb3bf810a05$var$blueGrey700
            },
            q1Labels: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, $e5c68eb3bf810a05$var$baseLabelStyles, {
                padding: 3
            }),
            q3: {
                padding: $e5c68eb3bf810a05$var$padding,
                fill: $e5c68eb3bf810a05$var$blueGrey700
            },
            q3Labels: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, $e5c68eb3bf810a05$var$baseLabelStyles, {
                padding: 3
            })
        },
        boxWidth: 20
    }, $e5c68eb3bf810a05$var$baseProps),
    candlestick: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        style: {
            data: {
                stroke: $e5c68eb3bf810a05$var$blueGrey700
            },
            labels: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, $e5c68eb3bf810a05$var$baseLabelStyles, {
                padding: 5
            })
        },
        candleColors: {
            positive: "#ffffff",
            negative: $e5c68eb3bf810a05$var$blueGrey700
        }
    }, $e5c68eb3bf810a05$var$baseProps),
    chart: $e5c68eb3bf810a05$var$baseProps,
    errorbar: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        borderWidth: 8,
        style: {
            data: {
                fill: "transparent",
                opacity: 1,
                stroke: $e5c68eb3bf810a05$var$blueGrey700,
                strokeWidth: 2
            },
            labels: $e5c68eb3bf810a05$var$baseLabelStyles
        }
    }, $e5c68eb3bf810a05$var$baseProps),
    group: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        colorScale: $e5c68eb3bf810a05$var$colors
    }, $e5c68eb3bf810a05$var$baseProps),
    histogram: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        style: {
            data: {
                fill: $e5c68eb3bf810a05$var$blueGrey700,
                stroke: $e5c68eb3bf810a05$var$grey900,
                strokeWidth: 2
            },
            labels: $e5c68eb3bf810a05$var$baseLabelStyles
        }
    }, $e5c68eb3bf810a05$var$baseProps),
    legend: {
        colorScale: $e5c68eb3bf810a05$var$colors,
        gutter: 10,
        orientation: "vertical",
        titleOrientation: "top",
        style: {
            data: {
                type: "circle"
            },
            labels: $e5c68eb3bf810a05$var$baseLabelStyles,
            title: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, $e5c68eb3bf810a05$var$baseLabelStyles, {
                padding: 5
            })
        }
    },
    line: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        style: {
            data: {
                fill: "transparent",
                opacity: 1,
                stroke: $e5c68eb3bf810a05$var$blueGrey700,
                strokeWidth: 2
            },
            labels: $e5c68eb3bf810a05$var$baseLabelStyles
        }
    }, $e5c68eb3bf810a05$var$baseProps),
    pie: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        colorScale: $e5c68eb3bf810a05$var$colors,
        style: {
            data: {
                padding: $e5c68eb3bf810a05$var$padding,
                stroke: $e5c68eb3bf810a05$var$blueGrey50,
                strokeWidth: 1
            },
            labels: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, $e5c68eb3bf810a05$var$baseLabelStyles, {
                padding: 20
            })
        }
    }, $e5c68eb3bf810a05$var$baseProps),
    scatter: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        style: {
            data: {
                fill: $e5c68eb3bf810a05$var$blueGrey700,
                opacity: 1,
                stroke: "transparent",
                strokeWidth: 0
            },
            labels: $e5c68eb3bf810a05$var$baseLabelStyles
        }
    }, $e5c68eb3bf810a05$var$baseProps),
    stack: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        colorScale: $e5c68eb3bf810a05$var$colors
    }, $e5c68eb3bf810a05$var$baseProps),
    tooltip: {
        style: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, $e5c68eb3bf810a05$var$baseLabelStyles, {
            padding: 0,
            pointerEvents: "none"
        }),
        flyoutStyle: {
            stroke: $e5c68eb3bf810a05$var$grey900,
            strokeWidth: 1,
            fill: "#f0f0f0",
            pointerEvents: "none"
        },
        flyoutPadding: 5,
        cornerRadius: 5,
        pointerLength: 10
    },
    voronoi: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        style: {
            data: {
                fill: "transparent",
                stroke: "transparent",
                strokeWidth: 0
            },
            labels: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, $e5c68eb3bf810a05$var$baseLabelStyles, {
                padding: 5,
                pointerEvents: "none"
            }),
            flyout: {
                stroke: $e5c68eb3bf810a05$var$grey900,
                strokeWidth: 1,
                fill: "#f0f0f0",
                pointerEvents: "none"
            }
        }
    }, $e5c68eb3bf810a05$var$baseProps)
};



var $7fc64db73a6d2950$export$2c7826f4d98fe551 = {
    grayscale: (0, $c870d22bbc3e0049$export$6f416a6db2dfcd5c),
    material: (0, $e5c68eb3bf810a05$export$15d6f59453b50ec6)
};


function $1aa9babdc5b1f3d6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1aa9babdc5b1f3d6$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1aa9babdc5b1f3d6$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1aa9babdc5b1f3d6$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1aa9babdc5b1f3d6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1aa9babdc5b1f3d6$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1aa9babdc5b1f3d6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1aa9babdc5b1f3d6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1aa9babdc5b1f3d6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1aa9babdc5b1f3d6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1aa9babdc5b1f3d6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $1aa9babdc5b1f3d6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $1aa9babdc5b1f3d6$var$_setPrototypeOf(subClass, superClass);
}
function $1aa9babdc5b1f3d6$var$_setPrototypeOf(o, p) {
    $1aa9babdc5b1f3d6$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1aa9babdc5b1f3d6$var$_setPrototypeOf(o, p);
}
function $1aa9babdc5b1f3d6$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1aa9babdc5b1f3d6$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $1aa9babdc5b1f3d6$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $1aa9babdc5b1f3d6$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $1aa9babdc5b1f3d6$var$_possibleConstructorReturn(this, result);
    };
}
function $1aa9babdc5b1f3d6$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $1aa9babdc5b1f3d6$var$_assertThisInitialized(self);
}
function $1aa9babdc5b1f3d6$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1aa9babdc5b1f3d6$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $1aa9babdc5b1f3d6$var$_getPrototypeOf(o) {
    $1aa9babdc5b1f3d6$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1aa9babdc5b1f3d6$var$_getPrototypeOf(o);
}
var $1aa9babdc5b1f3d6$var$fallbackProps = {
    width: 450,
    height: 300,
    padding: 50
};
var $1aa9babdc5b1f3d6$var$defaultData = [
    {
        x: 1,
        y: 1
    },
    {
        x: 2,
        y: 2
    },
    {
        x: 3,
        y: 3
    },
    {
        x: 4,
        y: 4
    }
];
var $1aa9babdc5b1f3d6$var$VictoryBar = /*#__PURE__*/ function(_React$Component) {
    $1aa9babdc5b1f3d6$var$_inherits(VictoryBar, _React$Component);
    var _super = $1aa9babdc5b1f3d6$var$_createSuper(VictoryBar);
    function VictoryBar() {
        $1aa9babdc5b1f3d6$var$_classCallCheck(this, VictoryBar);
        return _super.apply(this, arguments);
    }
    $1aa9babdc5b1f3d6$var$_createClass(VictoryBar, [
        {
            key: "shouldAnimate",
            value: function shouldAnimate() {
                return !!this.props.animate;
            }
        },
        {
            key: "render",
            value: function render() {
                var animationWhitelist = VictoryBar.animationWhitelist, role = VictoryBar.role;
                var props = (0, $0a5de8228869aa1e$exports).modifyProps(this.props, $1aa9babdc5b1f3d6$var$fallbackProps, role);
                if (this.shouldAnimate()) return this.animateComponent(props, animationWhitelist);
                var children = this.renderData(props);
                var component = props.standalone ? this.renderContainer(props.containerComponent, children) : children;
                return (0, $a9e703a4a20da87d$exports).withSafeUserProps(component, props);
            }
        }
    ]);
    return VictoryBar;
}((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Component);
$1aa9babdc5b1f3d6$var$VictoryBar.animationWhitelist = [
    "data",
    "domain",
    "height",
    "padding",
    "style",
    "width"
];
$1aa9babdc5b1f3d6$var$VictoryBar.displayName = "VictoryBar";
$1aa9babdc5b1f3d6$var$VictoryBar.role = "bar";
$1aa9babdc5b1f3d6$var$VictoryBar.defaultTransitions = {
    onLoad: {
        duration: 2000,
        before: function() {
            return {
                _y: 0,
                _y1: 0,
                _y0: 0
            };
        },
        after: function(datum) {
            return {
                _y: datum._y,
                _y1: datum._y1,
                _y0: datum._y0
            };
        }
    },
    onExit: {
        duration: 500,
        before: function() {
            return {
                _y: 0,
                yOffset: 0
            };
        }
    },
    onEnter: {
        duration: 500,
        before: function() {
            return {
                _y: 0,
                _y1: 0,
                _y0: 0
            };
        },
        after: function(datum) {
            return {
                _y: datum._y,
                _y1: datum._y1,
                _y0: datum._y0
            };
        }
    }
};
$1aa9babdc5b1f3d6$var$VictoryBar.propTypes = $1aa9babdc5b1f3d6$var$_objectSpread($1aa9babdc5b1f3d6$var$_objectSpread($1aa9babdc5b1f3d6$var$_objectSpread({}, (0, $70dbe1f62d5c55ed$export$fe6a43517f1f6b90).baseProps), (0, $70dbe1f62d5c55ed$export$fe6a43517f1f6b90).dataProps), {}, {
    alignment: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        "start",
        "middle",
        "end"
    ]),
    barRatio: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    barWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]),
    cornerRadius: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            top: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
            ]),
            topLeft: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
            ]),
            topRight: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
            ]),
            bottom: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
            ]),
            bottomLeft: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
            ]),
            bottomRight: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
            ])
        })
    ]),
    getPath: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
});
$1aa9babdc5b1f3d6$var$VictoryBar.defaultProps = {
    containerComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $1433d8d5e8c8f7e5$export$b173aa1b45712272), null),
    data: $1aa9babdc5b1f3d6$var$defaultData,
    dataComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $27000e11d83e1f32$export$2e2bcd8739ae039), null),
    groupComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("g", {
        role: "presentation"
    }),
    labelComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $b8620e9b9f9774cb$export$5c9ddd0cb3c79d22), null),
    samples: 50,
    sortOrder: "ascending",
    standalone: true,
    theme: (0, $7fc64db73a6d2950$export$2c7826f4d98fe551).grayscale
};
$1aa9babdc5b1f3d6$var$VictoryBar.getDomain = (0, $91b6bedde0b7fe96$exports).getDomainWithZero;
$1aa9babdc5b1f3d6$var$VictoryBar.getData = (0, $ce15a7815a86f8a8$exports).getData;
$1aa9babdc5b1f3d6$var$VictoryBar.getBaseProps = function(props) {
    return (0, $2bf684df5f83713c$export$a7ec8144096537e7)(props, $1aa9babdc5b1f3d6$var$fallbackProps);
};
$1aa9babdc5b1f3d6$var$VictoryBar.expectedComponents = [
    "dataComponent",
    "labelComponent",
    "groupComponent",
    "containerComponent"
];
var $1aa9babdc5b1f3d6$export$2e2bcd8739ae039 = (0, $93ca7d87628fcb54$export$aadfb65bee660f96)($1aa9babdc5b1f3d6$var$VictoryBar);





var $fdGrT = parcelRequire("fdGrT");

var $8T3gX = parcelRequire("8T3gX");


var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");




var $8T3gX = parcelRequire("8T3gX");
var $2924ee13cc09bb69$var$_excluded = [
    "desc"
];
function $2924ee13cc09bb69$var$_extends() {
    $2924ee13cc09bb69$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2924ee13cc09bb69$var$_extends.apply(this, arguments);
}
function $2924ee13cc09bb69$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2924ee13cc09bb69$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2924ee13cc09bb69$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $2924ee13cc09bb69$export$c89a927ffc67e6fa = function(props) {
    // eslint-disable-next-line react/prop-types
    var desc = props.desc, rest = $2924ee13cc09bb69$var$_objectWithoutProperties(props, $2924ee13cc09bb69$var$_excluded);
    return desc ? /*#__PURE__*/ // @ts-expect-error FIXME: "id cannot be a number"
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("circle", $2924ee13cc09bb69$var$_extends({
        vectorEffect: "non-scaling-stroke"
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("desc", null, desc)) : /*#__PURE__*/ // @ts-expect-error FIXME: "id cannot be a number"
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("circle", $2924ee13cc09bb69$var$_extends({
        vectorEffect: "non-scaling-stroke"
    }, rest));
};


function $21a3de71cf887274$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $21a3de71cf887274$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $21a3de71cf887274$var$ownKeys(Object(source), !0).forEach(function(key) {
            $21a3de71cf887274$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $21a3de71cf887274$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $21a3de71cf887274$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $21a3de71cf887274$var$evaluateProps = function(props) {
    /**
   * Potential evaluated prop is:
   * `id`
   */ var id = $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(props.id, props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, props, {
        id: id
    });
};
var $21a3de71cf887274$export$668799e4797757a8 = function(props) {
    props = $21a3de71cf887274$var$evaluateProps(props);
    return props.polar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(props.circleComponent, $21a3de71cf887274$var$_objectSpread($21a3de71cf887274$var$_objectSpread({}, props.events), {}, {
        style: props.style,
        role: props.role,
        shapeRendering: props.shapeRendering,
        cx: props.x,
        cy: props.y,
        r: props.height,
        className: props.className
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(props.rectComponent, $21a3de71cf887274$var$_objectSpread($21a3de71cf887274$var$_objectSpread({}, props.events), {}, {
        style: props.style,
        role: props.role,
        shapeRendering: props.shapeRendering,
        x: props.x,
        y: props.y,
        rx: props.rx,
        ry: props.ry,
        width: props.width,
        height: props.height,
        className: props.className
    }));
};
$21a3de71cf887274$export$668799e4797757a8.propTypes = $21a3de71cf887274$var$_objectSpread($21a3de71cf887274$var$_objectSpread({}, (0, $70dbe1f62d5c55ed$export$fe6a43517f1f6b90).primitiveProps), {}, {
    circleComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    rectComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    rx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    ry: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    x: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    y: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number
});
$21a3de71cf887274$export$668799e4797757a8.defaultProps = {
    circleComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $2924ee13cc09bb69$export$c89a927ffc67e6fa), null),
    rectComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $dfe2911367ea308b$export$c79fc6492f3af13d), null),
    role: "presentation",
    shapeRendering: "auto"
};

var $f6442d40b5d79512$exports = {};

$parcel$export($f6442d40b5d79512$exports, "usePreviousProps", () => $7edbb8fbb61a490d$export$3fef799656c4afcc);
$parcel$export($f6442d40b5d79512$exports, "useAnimationState", () => $379ed5e9cdf6c34a$export$7ee548861327febe);

var $8T3gX = parcelRequire("8T3gX");
function $7edbb8fbb61a490d$export$3fef799656c4afcc(props) {
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef();
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(function() {
        ref.current = props;
    });
    return ref.current;
}


var $17477d2910b68364$exports = {};


var $6af3cdb838677e75$exports = {};

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $6af3cdb838677e75$var$baseSome(collection, predicate) {
    var result;
    $fc4011160035cb96$exports(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
$6af3cdb838677e75$exports = $6af3cdb838677e75$var$baseSome;




/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $17477d2910b68364$var$some(collection, predicate, guard) {
    var func = $b47d971f66a6f054$exports(collection) ? $a56761d28df36f98$exports : $6af3cdb838677e75$exports;
    if (guard && $f5d86346a533d383$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $9dd1d38dfe69ddcf$exports(predicate, 3));
}
$17477d2910b68364$exports = $17477d2910b68364$var$some;




var $8T3gX = parcelRequire("8T3gX");


function $379ed5e9cdf6c34a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $379ed5e9cdf6c34a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $379ed5e9cdf6c34a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $379ed5e9cdf6c34a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $379ed5e9cdf6c34a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $379ed5e9cdf6c34a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $379ed5e9cdf6c34a$var$_slicedToArray(arr, i) {
    return $379ed5e9cdf6c34a$var$_arrayWithHoles(arr) || $379ed5e9cdf6c34a$var$_iterableToArrayLimit(arr, i) || $379ed5e9cdf6c34a$var$_unsupportedIterableToArray(arr, i) || $379ed5e9cdf6c34a$var$_nonIterableRest();
}
function $379ed5e9cdf6c34a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $379ed5e9cdf6c34a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $379ed5e9cdf6c34a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $379ed5e9cdf6c34a$var$_arrayLikeToArray(o, minLen);
}
function $379ed5e9cdf6c34a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $379ed5e9cdf6c34a$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $379ed5e9cdf6c34a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $379ed5e9cdf6c34a$var$INITIAL_STATE = {
    nodesShouldLoad: false,
    nodesDoneLoad: false,
    animating: true
};
var $379ed5e9cdf6c34a$export$7ee548861327febe = function() {
    var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $379ed5e9cdf6c34a$var$INITIAL_STATE;
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(initialState), _React$useState2 = $379ed5e9cdf6c34a$var$_slicedToArray(_React$useState, 2), state = _React$useState2[0], _setState = _React$useState2[1]; // This allows us to use a state object and maintain the same API as this.setState
    var setState = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback(function(newState) {
        _setState(function(oldState) {
            return $379ed5e9cdf6c34a$var$_objectSpread($379ed5e9cdf6c34a$var$_objectSpread({}, oldState), newState);
        });
    }, [
        _setState
    ]); // This is a copy of Wrapper.getAnimationProps
    var getAnimationProps = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback(function(props, child, index) {
        if (!(props !== null && props !== void 0 && props.animate)) return child.props.animate;
        var getFilteredState = function() {
            var childrenTransitions = state && state.childrenTransitions;
            childrenTransitions = $9373b80aaace1e85$export$e3f2d7f0b529e664(childrenTransitions) ? childrenTransitions[index] : childrenTransitions;
            return (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({
                childrenTransitions: childrenTransitions
            }, state);
        };
        var getTransitions = props.animate && props.animate.getTransitions;
        var filteredState = getFilteredState();
        var parentState = props.animate && props.animate.parentState || filteredState;
        if (!getTransitions) {
            var getTransitionProps = $524d0cfad536a1ac$export$6b6ada6937a70120(props, filteredState, function(newState) {
                return setState(newState);
            });
            getTransitions = function(childComponent) {
                return getTransitionProps(childComponent, index);
            };
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({
            getTransitions: getTransitions,
            parentState: parentState
        }, props.animate, child.props.animate);
    }, [
        state,
        setState
    ]); // This is a copy of Wrapper.setAnimationState
    var setAnimationState = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback(function(props, nextProps) {
        if (!(props !== null && props !== void 0 && props.animate)) return;
        if (props.animate.parentState) {
            var nodesWillExit = props.animate.parentState.nodesWillExit;
            var oldProps = nodesWillExit ? props : null;
            var newState = (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({
                oldProps: oldProps,
                nextProps: nextProps
            }, props.animate.parentState);
            setState(newState);
        } else {
            var oldChildren = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(props.children);
            var nextChildren = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(nextProps.children);
            var isContinuous = function(child) {
                var check = function(c) {
                    return c.type && c.type.continuous;
                };
                return Array.isArray(child) ? (0, (/*@__PURE__*/$parcel$interopDefault($17477d2910b68364$exports)))(child, check) : check(child);
            };
            var continuous = !props.polar && (0, (/*@__PURE__*/$parcel$interopDefault($17477d2910b68364$exports)))(oldChildren, function(child) {
                return isContinuous(child) || child.props.children && isContinuous(child.props.children);
            });
            var _Transitions$getIniti = $524d0cfad536a1ac$export$bb6f0ae72af8f4e4(oldChildren, nextChildren), _nodesWillExit = _Transitions$getIniti.nodesWillExit, nodesWillEnter = _Transitions$getIniti.nodesWillEnter, childrenTransitions = _Transitions$getIniti.childrenTransitions, nodesShouldEnter = _Transitions$getIniti.nodesShouldEnter;
            setState({
                nodesWillExit: _nodesWillExit,
                nodesWillEnter: nodesWillEnter,
                nodesShouldEnter: nodesShouldEnter,
                childrenTransitions: $9373b80aaace1e85$export$e3f2d7f0b529e664(childrenTransitions) ? childrenTransitions[0] : childrenTransitions,
                oldProps: _nodesWillExit ? props : undefined,
                nextProps: nextProps,
                continuous: continuous
            });
        }
    }, [
        setState
    ]);
    var getProps = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback(function(initialProps) {
        return state && state.nodesWillExit ? state.oldProps || initialProps : initialProps;
    }, [
        state
    ]);
    return {
        state: state,
        setState: setState,
        getAnimationProps: getAnimationProps,
        setAnimationState: setAnimationState,
        getProps: getProps
    };
};



var $8c0cae78a8f93a11$exports = {};

$parcel$export($8c0cae78a8f93a11$exports, "addBinsToParentPropsIfHistogram", () => $8c0cae78a8f93a11$export$78d928a53f8fad9c);
$parcel$export($8c0cae78a8f93a11$exports, "getDataFromChildren", () => $8c0cae78a8f93a11$export$7f4a7a2d57d55cb3);
$parcel$export($8c0cae78a8f93a11$exports, "getData", () => $8c0cae78a8f93a11$export$7a171f172be0782e);
$parcel$export($8c0cae78a8f93a11$exports, "getWidth", () => $8c0cae78a8f93a11$export$3c49c185de0c2bfc);
$parcel$export($8c0cae78a8f93a11$exports, "getDefaultDomainPadding", () => $8c0cae78a8f93a11$export$f444ec12e5de5ae6);
$parcel$export($8c0cae78a8f93a11$exports, "getDomainFromChildren", () => $8c0cae78a8f93a11$export$52c10c492484f2d6);
$parcel$export($8c0cae78a8f93a11$exports, "getDomain", () => $8c0cae78a8f93a11$export$3e8733322718eb9);
$parcel$export($8c0cae78a8f93a11$exports, "getScale", () => $8c0cae78a8f93a11$export$5cdac61cf538712e);
$parcel$export($8c0cae78a8f93a11$exports, "getAllEvents", () => $8c0cae78a8f93a11$export$86fc571c51e65680);
$parcel$export($8c0cae78a8f93a11$exports, "getColor", () => $8c0cae78a8f93a11$export$5551a2d24ff40153);
$parcel$export($8c0cae78a8f93a11$exports, "getStyle", () => $8c0cae78a8f93a11$export$3d2f074408bd1b82);
$parcel$export($8c0cae78a8f93a11$exports, "getChildStyle", () => $8c0cae78a8f93a11$export$48ffc51b4bec1d57);
$parcel$export($8c0cae78a8f93a11$exports, "getStringsFromCategories", () => $8c0cae78a8f93a11$export$92915b258f643ac6);
$parcel$export($8c0cae78a8f93a11$exports, "getStringsFromData", () => $8c0cae78a8f93a11$export$d76e4ab22a13df1);
$parcel$export($8c0cae78a8f93a11$exports, "getCategoryAndAxisStringsFromChildren", () => $8c0cae78a8f93a11$export$696fdeddca8d40bb);
$parcel$export($8c0cae78a8f93a11$exports, "getStringsFromChildren", () => $8c0cae78a8f93a11$export$6f6bd247605c9540);
$parcel$export($8c0cae78a8f93a11$exports, "getCategories", () => $8c0cae78a8f93a11$export$7a0f33e8df10bd94);


var $02a01f9a4517f244$exports = {};


/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $02a01f9a4517f244$var$uniqBy(array, iteratee) {
    return array && array.length ? $6d06713981607225$exports(array, $9dd1d38dfe69ddcf$exports(iteratee, 2)) : [];
}
$02a01f9a4517f244$exports = $02a01f9a4517f244$var$uniqBy;


var $c8c0f3fd1062a95a$exports = {};

var $4eebfe7de68750bd$exports = {};
var $50cda7ae5476513e$exports = {};
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $50cda7ae5476513e$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
$50cda7ae5476513e$exports = $50cda7ae5476513e$var$arrayAggregator;


var $2be794fa29755ab8$exports = {};

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $2be794fa29755ab8$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $fc4011160035cb96$exports(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
$2be794fa29755ab8$exports = $2be794fa29755ab8$var$baseAggregator;




/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $4eebfe7de68750bd$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $b47d971f66a6f054$exports(collection) ? $50cda7ae5476513e$exports : $2be794fa29755ab8$exports, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $9dd1d38dfe69ddcf$exports(iteratee, 2), accumulator);
    };
}
$4eebfe7de68750bd$exports = $4eebfe7de68750bd$var$createAggregator;


/** Used for built-in method references. */ var $c8c0f3fd1062a95a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c8c0f3fd1062a95a$var$hasOwnProperty = $c8c0f3fd1062a95a$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $c8c0f3fd1062a95a$var$groupBy = $4eebfe7de68750bd$exports(function(result, value, key) {
    if ($c8c0f3fd1062a95a$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $5cd807a6ad780171$exports(result, key, [
        value
    ]);
});
$c8c0f3fd1062a95a$exports = $c8c0f3fd1062a95a$var$groupBy;








var $8T3gX = parcelRequire("8T3gX");
var $f052c55858268509$exports = {};

$parcel$export($f052c55858268509$exports, "getAxis", () => $f052c55858268509$export$8a3a0724d206787a);
$parcel$export($f052c55858268509$exports, "findAxisComponents", () => $f052c55858268509$export$a8881c09d1729550);
$parcel$export($f052c55858268509$exports, "getAxisComponent", () => $f052c55858268509$export$149ea8cb13929199);
$parcel$export($f052c55858268509$exports, "getAxisComponentsWithParent", () => $f052c55858268509$export$163de174e65609b3);
$parcel$export($f052c55858268509$exports, "getOrigin", () => $f052c55858268509$export$5a759dc7a1cfb72a);
$parcel$export($f052c55858268509$exports, "getOriginSign", () => $f052c55858268509$export$144c8e1bc7195ba3);
$parcel$export($f052c55858268509$exports, "isVertical", () => $f052c55858268509$export$42c0085b96d0f4c4);
$parcel$export($f052c55858268509$exports, "stringTicks", () => $f052c55858268509$export$48925bfd75c7d063);
$parcel$export($f052c55858268509$exports, "getTickFormat", () => $f052c55858268509$export$f8d146f1874725c1);
$parcel$export($f052c55858268509$exports, "getTicks", () => $f052c55858268509$export$3d27d42b1034de5c);
$parcel$export($f052c55858268509$exports, "getDomain", () => $f052c55858268509$export$3e8733322718eb9);
$parcel$export($f052c55858268509$exports, "getAxisValue", () => $f052c55858268509$export$5449ad6059eac91c);
$parcel$export($f052c55858268509$exports, "modifyProps", () => $f052c55858268509$export$9c2da7bc2aacbf9b);






var $f23105c349809ed7$exports = {};

var $bf42abb82c233549$exports = {};
var $7436f511d523412a$exports = {};

/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */ function $7436f511d523412a$var$baseInverter(object, setter, iteratee, accumulator) {
    $b8b184dbd2d79b13$exports(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
    });
    return accumulator;
}
$7436f511d523412a$exports = $7436f511d523412a$var$baseInverter;


/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */ function $bf42abb82c233549$var$createInverter(setter, toIteratee) {
    return function(object, iteratee) {
        return $7436f511d523412a$exports(object, setter, toIteratee(iteratee), {});
    };
}
$bf42abb82c233549$exports = $bf42abb82c233549$var$createInverter;



/** Used for built-in method references. */ var $f23105c349809ed7$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f23105c349809ed7$var$nativeObjectToString = $f23105c349809ed7$var$objectProto.toString;
/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */ var $f23105c349809ed7$var$invert = $bf42abb82c233549$exports(function(result, value, key) {
    if (value != null && typeof value.toString != "function") value = $f23105c349809ed7$var$nativeObjectToString.call(value);
    result[value] = key;
}, $8c05603d1b1154c7$exports($30121ce9c4b4eb3d$exports));
$f23105c349809ed7$exports = $f23105c349809ed7$var$invert;








var $8T3gX = parcelRequire("8T3gX");



function $f052c55858268509$var$_toConsumableArray(arr) {
    return $f052c55858268509$var$_arrayWithoutHoles(arr) || $f052c55858268509$var$_iterableToArray(arr) || $f052c55858268509$var$_unsupportedIterableToArray(arr) || $f052c55858268509$var$_nonIterableSpread();
}
function $f052c55858268509$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f052c55858268509$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f052c55858268509$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f052c55858268509$var$_arrayLikeToArray(o, minLen);
}
function $f052c55858268509$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $f052c55858268509$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $f052c55858268509$var$_arrayLikeToArray(arr);
}
function $f052c55858268509$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f052c55858268509$export$8a3a0724d206787a(props) {
    var dependentAxis = props.dependentAxis;
    return dependentAxis ? "y" : "x";
}
function $f052c55858268509$export$a8881c09d1729550(childComponents, predicate) {
    predicate = predicate || (0, (/*@__PURE__*/$parcel$interopDefault($30121ce9c4b4eb3d$exports)));
    var findAxes = function(children) {
        return children.reduce(function(memo, child) {
            if (child.type && child.type.role === "axis" && predicate(child)) return memo.concat(child);
            else if (child.props && child.props.children) return memo.concat(findAxes((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(child.props.children)));
            return memo;
        }, []);
    };
    return findAxes(childComponents);
}
function $f052c55858268509$export$149ea8cb13929199(childComponents, axis) {
    var matchesAxis = function(component) {
        var type = component.type.getAxis(component.props);
        return type === axis;
    };
    return $f052c55858268509$export$a8881c09d1729550(childComponents, matchesAxis)[0];
}
function $f052c55858268509$export$163de174e65609b3(childComponents, type) {
    var matchesType = function(child) {
        return type === "dependent" ? child.props.dependentAxis : !child.props.dependentAxis;
    };
    var findComponents = function(children) {
        return children.reduce(function(memo, child) {
            if (child.type && child.type.role === "axis" && matchesType(child)) return memo.concat(child);
            else if (child.props && child.props.children) {
                var childAxis = findComponents((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(child.props.children));
                return childAxis.length > 0 ? memo.concat(child) : memo;
            }
            return memo;
        }, []);
    };
    return findComponents(childComponents);
}
function $f052c55858268509$export$5a759dc7a1cfb72a(domain) {
    var getSingleOrigin = function(d) {
        var domainMin = Math.min.apply(Math, $f052c55858268509$var$_toConsumableArray(d));
        var domainMax = Math.max.apply(Math, $f052c55858268509$var$_toConsumableArray(d));
        return domainMax < 0 ? domainMax : Math.max(0, domainMin);
    };
    return {
        x: $9373b80aaace1e85$export$b492f6d933283c58(domain.x) ? new Date(Math.min.apply(Math, $f052c55858268509$var$_toConsumableArray(domain.x))) : getSingleOrigin(domain.x),
        y: $9373b80aaace1e85$export$b492f6d933283c58(domain.y) ? new Date(Math.min.apply(Math, $f052c55858268509$var$_toConsumableArray(domain.y))) : getSingleOrigin(domain.y)
    };
}
function $f052c55858268509$export$144c8e1bc7195ba3(origin, domain) {
    var getSign = function() {
        return origin <= 0 && Math.max.apply(Math, $f052c55858268509$var$_toConsumableArray(domain)) <= 0 ? "negative" : "positive";
    };
    return $9373b80aaace1e85$export$b492f6d933283c58(domain) ? "positive" : getSign();
}
function $f052c55858268509$export$42c0085b96d0f4c4(props) {
    var orientation = props.orientation || (props.dependentAxis ? "left" : "bottom");
    var vertical = {
        top: false,
        bottom: false,
        left: true,
        right: true
    };
    return vertical[orientation];
}
function $f052c55858268509$export$48925bfd75c7d063(props) {
    return props.tickValues !== undefined && $9373b80aaace1e85$export$37b75fcede59d7ed(props.tickValues);
}
function $f052c55858268509$var$getDefaultTickFormat(props) {
    var tickValues = props.tickValues;
    var axis = $f052c55858268509$export$8a3a0724d206787a(props);
    var stringMap = props.stringMap && props.stringMap[axis];
    var fallbackFormat = tickValues && !$9373b80aaace1e85$export$b492f6d933283c58(tickValues) ? function(x) {
        return x;
    } : undefined;
    if (!stringMap) return $f052c55858268509$export$48925bfd75c7d063(props) ? function(x, index) {
        return tickValues[index];
    } : fallbackFormat;
    var invertedStringMap = stringMap && (0, (/*@__PURE__*/$parcel$interopDefault($f23105c349809ed7$exports)))(stringMap);
    var tickValueArray = (0, (/*@__PURE__*/$parcel$interopDefault($b863eb497ad75781$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($0f1b14d3de521ffa$exports)))(stringMap), function(n) {
        return n;
    });
    var dataNames = tickValueArray.map(function(tick) {
        return invertedStringMap[tick];
    }); // string ticks should have one tick of padding at the beginning
    var dataTicks = [
        ""
    ].concat($f052c55858268509$var$_toConsumableArray(dataNames), [
        ""
    ]);
    return function(x) {
        return dataTicks[x];
    };
}
function $f052c55858268509$var$getStringTicks(props) {
    var axis = $f052c55858268509$export$8a3a0724d206787a(props);
    var stringMap = props.stringMap && props.stringMap[axis];
    var categories = Array.isArray(props.categories) ? props.categories : props.categories && props.categories[axis];
    var ticksFromCategories = categories && $9373b80aaace1e85$export$8d027a851e7abfc8(categories) ? categories.map(function(tick) {
        return stringMap[tick];
    }) : undefined;
    var ticksFromStringMap = stringMap && (0, (/*@__PURE__*/$parcel$interopDefault($0f1b14d3de521ffa$exports)))(stringMap);
    return ticksFromCategories && ticksFromCategories.length !== 0 ? ticksFromCategories : ticksFromStringMap;
}
function $f052c55858268509$var$getTickArray(props) {
    var tickValues = props.tickValues, tickFormat = props.tickFormat;
    var axis = $f052c55858268509$export$8a3a0724d206787a(props);
    var stringMap = props.stringMap && props.stringMap[axis];
    var getTicksFromFormat = function() {
        if (!tickFormat || !Array.isArray(tickFormat)) return undefined;
        return $9373b80aaace1e85$export$37b75fcede59d7ed(tickFormat) ? tickFormat.map(function(t, i) {
            return i;
        }) : tickFormat;
    };
    var ticks = tickValues;
    if (stringMap) ticks = $f052c55858268509$var$getStringTicks(props);
    if (tickValues && $9373b80aaace1e85$export$37b75fcede59d7ed(tickValues)) ticks = stringMap ? tickValues.map(function(tick) {
        return stringMap[tick];
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($a2e6c83a615b2213$exports)))(1, tickValues.length + 1);
    var tickArray = ticks ? (0, (/*@__PURE__*/$parcel$interopDefault($bd8625fe3238ec95$exports)))(ticks) : getTicksFromFormat();
    var buildTickArray = function(arr) {
        var newTickArray = [];
        var domain = props.domain && props.domain[axis] || props.domain;
        if (arr) {
            arr.forEach(function(t, index) {
                if (Array.isArray(domain)) {
                    if (t >= $9373b80aaace1e85$export$df8687355ccb4d94(domain) && t <= $9373b80aaace1e85$export$a8f783d9de5392f5(domain)) newTickArray.push({
                        value: t,
                        index: index
                    });
                } else newTickArray.push({
                    value: t,
                    index: index
                });
            });
            return newTickArray;
        }
        return undefined;
    };
    return Array.isArray(tickArray) && tickArray.length ? buildTickArray(tickArray) : undefined;
}
function $f052c55858268509$export$f8d146f1874725c1(props, scale) {
    var tickFormat = props.tickFormat;
    var axis = $f052c55858268509$export$8a3a0724d206787a(props);
    var stringMap = props.stringMap && props.stringMap[axis];
    if (!tickFormat) {
        var defaultTickFormat = $f052c55858268509$var$getDefaultTickFormat(props); // If there is no user-provided tick format, we use d3's tickFormat function
        // by default. This changed the default formatting for some scale types when
        // we upgraded to d3-scale@4..
        var scaleTickFormat = scale.tickFormat && (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(scale.tickFormat) ? scale.tickFormat() : function(x) {
            return x;
        };
        return defaultTickFormat || scaleTickFormat;
    } else if (tickFormat && Array.isArray(tickFormat)) {
        var tickArray = $f052c55858268509$var$getTickArray(props);
        var tickArrayIndices = tickArray === null || tickArray === void 0 ? void 0 : tickArray.map(function(v) {
            return v.index;
        });
        var filteredTickFormat = tickFormat.filter(function(t, index) {
            return tickArrayIndices === null || tickArrayIndices === void 0 ? void 0 : tickArrayIndices.includes(index);
        });
        return function(x, index) {
            return filteredTickFormat[index];
        };
    } else if (tickFormat && (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(tickFormat)) {
        var applyStringTicks = function(tick, index, ticks) {
            var invertedStringMap = (0, (/*@__PURE__*/$parcel$interopDefault($f23105c349809ed7$exports)))(stringMap);
            var stringTickArray = ticks.map(function(t) {
                return invertedStringMap[t];
            });
            return props.tickFormat(invertedStringMap[tick], index, stringTickArray);
        };
        return stringMap ? applyStringTicks : tickFormat;
    }
    return function(x) {
        return x;
    };
}
function $f052c55858268509$var$downsampleTicks(ticks, tickCount) {
    if (!tickCount || !Array.isArray(ticks) || ticks.length <= tickCount) return ticks;
    var k = Math.floor(ticks.length / tickCount);
    return ticks.filter(function(d, i) {
        return i % k === 0;
    });
}
function $f052c55858268509$export$3d27d42b1034de5c(props, scale) {
    var filterZero = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var tickCount = props.tickCount;
    var tickArray = $f052c55858268509$var$getTickArray(props);
    var tickValues = tickArray ? tickArray.map(function(v) {
        return v.value;
    }) : undefined;
    if (tickValues) return $f052c55858268509$var$downsampleTicks(tickValues, tickCount);
    else if (scale.ticks && (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(scale.ticks)) {
        // eslint-disable-next-line no-magic-numbers
        var defaultTickCount = tickCount || 5;
        var scaleTicks = scale.ticks(defaultTickCount);
        var scaledTickArray = Array.isArray(scaleTicks) && scaleTicks.length ? scaleTicks : scale.domain();
        var ticks = $f052c55858268509$var$downsampleTicks(scaledTickArray, tickCount);
        if (filterZero) {
            var filteredTicks = (0, (/*@__PURE__*/$parcel$interopDefault($8ba9a2795a3c2065$exports)))(ticks, 0) ? (0, (/*@__PURE__*/$parcel$interopDefault($a58ee22f5be18a99$exports)))(ticks, 0) : ticks;
            return filteredTicks.length ? filteredTicks : ticks;
        }
        return ticks;
    }
    return scale.domain();
}
/**
 * Returns a domain based tickValues
 * @param {Object} props: the props object
 * @param {String} axis: either x or y
 * @returns {Array} returns a domain from tickValues
 */ // eslint-disable-next-line max-statements
function $f052c55858268509$var$getDomainFromData(props, axis) {
    var polar = props.polar, _props$startAngle = props.startAngle, startAngle = _props$startAngle === void 0 ? 0 : _props$startAngle, _props$endAngle = props.endAngle, endAngle = _props$endAngle === void 0 ? 360 : _props$endAngle;
    var tickArray = $f052c55858268509$var$getTickArray(props);
    var tickValues = tickArray ? tickArray.map(function(v) {
        return v.value;
    }) : undefined;
    if (!Array.isArray(tickValues)) return undefined;
    var minDomain = $91b6bedde0b7fe96$export$385f5052ad9e995e(props, axis);
    var maxDomain = $91b6bedde0b7fe96$export$de470f0b6b2c75e9(props, axis);
    var tickStrings = $f052c55858268509$export$48925bfd75c7d063(props);
    var ticks = tickValues.map(function(value) {
        return Number(value);
    });
    var defaultMin = tickStrings ? 1 : $9373b80aaace1e85$export$df8687355ccb4d94(ticks);
    var defaultMax = tickStrings ? tickValues.length : $9373b80aaace1e85$export$a8f783d9de5392f5(ticks);
    var min = minDomain !== undefined ? minDomain : defaultMin;
    var max = maxDomain !== undefined ? maxDomain : defaultMax;
    var initialDomain = $91b6bedde0b7fe96$export$aafa8294ef4dae28(min, max);
    var domain = polar && axis === "x" && Math.abs(startAngle - endAngle) === 360 ? $91b6bedde0b7fe96$export$55b0a14e0335d29c(initialDomain, ticks) : initialDomain;
    if ($f052c55858268509$export$42c0085b96d0f4c4(props) && !polar) domain.reverse();
    return domain;
} // exposed for use by VictoryChart
function $f052c55858268509$export$3e8733322718eb9(props, axis) {
    var inherentAxis = $f052c55858268509$export$8a3a0724d206787a(props);
    if (axis && axis !== inherentAxis) return undefined;
    return $91b6bedde0b7fe96$export$a486abbfbc863f25($f052c55858268509$var$getDomainFromData)(props, inherentAxis);
}
function $f052c55858268509$export$5449ad6059eac91c(props, axis) {
    if (!props.axisValue) return undefined;
    var scaleAxis = axis === "x" ? "y" : "x";
    var scale = (0, (/*@__PURE__*/$parcel$interopDefault($cd2b0b1294af0960$exports)))(props.scale) && (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(props.scale[scaleAxis]) ? props.scale[scaleAxis] : undefined;
    if (!scale) return undefined;
    var stringMapAxis = axis === "x" ? "y" : "x";
    var stringMap = (0, (/*@__PURE__*/$parcel$interopDefault($cd2b0b1294af0960$exports)))(props.stringMap) && props.stringMap[stringMapAxis];
    var axisValue = stringMap && typeof props.axisValue === "string" ? stringMap[props.axisValue] : props.axisValue;
    return scale(axisValue);
}
function $f052c55858268509$export$9c2da7bc2aacbf9b(props, fallbackProps) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cd2b0b1294af0960$exports)))(props.theme)) return $0a5de8228869aa1e$export$9c2da7bc2aacbf9b(props, fallbackProps, "axis");
    var role = "axis";
    if (props.dependentAxis && props.theme.dependentAxis) role = "dependentAxis";
    else if (!props.dependentAxis && props.theme.independentAxis) role = "independentAxis";
    if (role === "axis") return $0a5de8228869aa1e$export$9c2da7bc2aacbf9b(props, fallbackProps, "axis");
    var axisTheme = (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, props.theme[role], props.theme.axis);
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, props.theme, {
        axis: axisTheme
    });
    return $0a5de8228869aa1e$export$9c2da7bc2aacbf9b((0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, props, {
        theme: theme
    }), fallbackProps, "axis");
}










function $8c0cae78a8f93a11$var$_toConsumableArray(arr) {
    return $8c0cae78a8f93a11$var$_arrayWithoutHoles(arr) || $8c0cae78a8f93a11$var$_iterableToArray(arr) || $8c0cae78a8f93a11$var$_unsupportedIterableToArray(arr) || $8c0cae78a8f93a11$var$_nonIterableSpread();
}
function $8c0cae78a8f93a11$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8c0cae78a8f93a11$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8c0cae78a8f93a11$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8c0cae78a8f93a11$var$_arrayLikeToArray(o, minLen);
}
function $8c0cae78a8f93a11$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $8c0cae78a8f93a11$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $8c0cae78a8f93a11$var$_arrayLikeToArray(arr);
}
function $8c0cae78a8f93a11$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8c0cae78a8f93a11$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8c0cae78a8f93a11$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8c0cae78a8f93a11$var$ownKeys(Object(source), !0).forEach(function(key) {
            $8c0cae78a8f93a11$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8c0cae78a8f93a11$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8c0cae78a8f93a11$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8c0cae78a8f93a11$export$78d928a53f8fad9c(_ref) {
    var children = _ref.children, props = _ref.props, childComponents = _ref.childComponents, parentProps = _ref.parentProps;
    var someChildrenAreHistograms = children.some(function(child) {
        return child.type && child.type.role === "histogram";
    });
    var allChildrenAreHistograms = someChildrenAreHistograms && children.length && children.every(function(child) {
        return child.type && child.type.role === "histogram";
    });
    if (someChildrenAreHistograms && !allChildrenAreHistograms) $8590ed3b940180fa$export$c106dd0671a0fc2d("VictoryHistogram only supports being stacked with other VictoryHistogram components. Check to make sure that you are only passing VictoryHistogram components to VictoryStack");
     // if we are stacking histograms, we need to generate explicit bins
    // or else each histogram may end up having different bins
    if (!allChildrenAreHistograms) return parentProps;
    var childBins = props.bins || childComponents[0].props.bins; // if we have explicit bins then we don't need to calculate them
    if (!Array.isArray(childBins)) {
        var combinedData = children.reduce(function(memo, child) {
            var xAccessor = $0a5de8228869aa1e$export$f5ddff6606408ce8(child.props.x || "x");
            return memo.concat(child.props.data.map(function(datum) {
                return {
                    x: xAccessor(datum)
                };
            }));
        }, []); // use the same function to generate bins as VictoryHistogram but with
        // the combined data from above, then get explicit bins from that
        var getFormattedHistogramData = children[0].type.getFormattedData;
        childBins = getFormattedHistogramData({
            data: combinedData,
            bins: childBins
        }).reduce(function(memo, _ref2, index) {
            var x0 = _ref2.x0, x1 = _ref2.x1;
            return index === 0 ? memo.concat([
                x0,
                x1
            ]) : memo.concat(x1);
        }, []);
    }
    return $8c0cae78a8f93a11$var$_objectSpread($8c0cae78a8f93a11$var$_objectSpread({}, parentProps), {}, {
        bins: childBins
    });
}
function $8c0cae78a8f93a11$export$7f4a7a2d57d55cb3(props, childComponents) {
    var polar = props.polar, startAngle = props.startAngle, endAngle = props.endAngle, categories = props.categories, minDomain = props.minDomain, maxDomain = props.maxDomain;
    var parentProps = {
        polar: polar,
        startAngle: startAngle,
        endAngle: endAngle,
        categories: categories,
        minDomain: minDomain,
        maxDomain: maxDomain
    };
    var stack = 0;
    var children = childComponents ? childComponents.slice(0) : (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(props.children);
    parentProps = $8c0cae78a8f93a11$export$78d928a53f8fad9c({
        children: children,
        props: props,
        childComponents: childComponents,
        parentProps: parentProps
    });
    var iteratee = function(child, childName, parent) {
        var childProps = (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, child.props, parentProps);
        var childData;
        if (!$ce15a7815a86f8a8$export$959c1930e1bd68c1(child)) return null;
        else if (child.type && (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(child.type.getData)) {
            child = parent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(child, parent.props) : child;
            childData = child.type.getData(childProps);
        } else childData = $ce15a7815a86f8a8$export$7a171f172be0782e(childProps);
        stack += 1;
        return childData.map(function(datum, index) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
                _stack: stack,
                _group: index
            }, datum);
        });
    };
    var stacked = children.filter(function(c) {
        return c.type && c.type.role === "stack";
    }).length;
    var combine = function(memo, val) {
        return memo.concat((0, (/*@__PURE__*/$parcel$interopDefault($02a01f9a4517f244$exports)))(val, "_group"));
    };
    var datasets = $0a5de8228869aa1e$export$8d02402a54f5e88d(children, iteratee, props, [], combine);
    var group = stacked ? "_group" : "_stack";
    return (0, (/*@__PURE__*/$parcel$interopDefault($0f1b14d3de521ffa$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($c8c0f3fd1062a95a$exports)))(datasets, group));
}
function $8c0cae78a8f93a11$export$7a171f172be0782e(props, childComponents) {
    if (props.data) return $ce15a7815a86f8a8$export$7a171f172be0782e(props);
    childComponents = childComponents || (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(props.children);
    return $8c0cae78a8f93a11$export$7f4a7a2d57d55cb3(props, childComponents);
}
function $8c0cae78a8f93a11$export$3c49c185de0c2bfc(props, groupLength, seriesLength) {
    var datasets = props.datasets, horizontal = props.horizontal;
    var range = horizontal ? $0a5de8228869aa1e$export$fef151b94550e9f5(props, "y") : $0a5de8228869aa1e$export$fef151b94550e9f5(props, "x");
    var extent = Math.abs(range[1] - range[0]);
    seriesLength = seriesLength !== undefined ? seriesLength : Array.isArray(datasets[0]) && datasets[0].length || 1;
    groupLength = groupLength || datasets.length;
    var bars = groupLength * seriesLength;
    var barRatio = 0.5;
    return Math.round(barRatio * extent / bars);
}
function $8c0cae78a8f93a11$export$f444ec12e5de5ae6(props, axis, childComponents) {
    if (props.polar || axis !== "x") return undefined;
    var groupComponent = childComponents.filter(function(child) {
        return child.type && child.type.role && child.type.role === "group";
    });
    if (groupComponent.length < 1) return undefined;
    var _groupComponent$0$pro = groupComponent[0].props, offset = _groupComponent$0$pro.offset, children = _groupComponent$0$pro.children;
    if (!offset) return undefined;
    var firstChild = Array.isArray(children) && children[0];
    if (!firstChild) return undefined;
    var barWidth = firstChild.props.barWidth;
    var dataLength = firstChild.props.data && firstChild.props.data.length || 1;
    if (firstChild && firstChild.type.role === "stack") {
        var nestedChild = firstChild.props.children && firstChild.props.children[0];
        if (!nestedChild) return undefined;
        barWidth = nestedChild.props.barWidth;
        dataLength = firstChild.props.children.length;
    }
    var width = barWidth || $8c0cae78a8f93a11$export$3c49c185de0c2bfc(props, children.length, dataLength);
    return {
        x: width * children.length / 2 + (offset - width * ((children.length - 1) / 2))
    };
}
function $8c0cae78a8f93a11$export$52c10c492484f2d6(props, axis, childComponents) {
    // eslint-disable-line max-statements, complexity, max-len
    var children = childComponents ? childComponents.slice(0) : (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(props.children);
    var parentData = props.data ? $ce15a7815a86f8a8$export$7a171f172be0782e(props) : undefined;
    var polar = props.polar, startAngle = props.startAngle, endAngle = props.endAngle, categories = props.categories, minDomain = props.minDomain, maxDomain = props.maxDomain, horizontal = props.horizontal;
    var baseParentProps = {
        horizontal: horizontal,
        polar: polar,
        startAngle: startAngle,
        endAngle: endAngle,
        minDomain: minDomain,
        maxDomain: maxDomain,
        categories: categories
    };
    var parentProps = parentData ? (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))(baseParentProps, {
        data: parentData
    }) : baseParentProps;
    var iteratee = function(child) {
        var sharedProps = (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, child.props, parentProps);
        if (!$91b6bedde0b7fe96$export$9b264bdd6864cf49(child)) return null;
        else if (child.type && (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(child.type.getDomain)) return child.props && child.type.getDomain(sharedProps, axis);
        return $91b6bedde0b7fe96$export$3e8733322718eb9(sharedProps, axis);
    };
    var childDomains = $0a5de8228869aa1e$export$8d02402a54f5e88d(children, iteratee, props);
    var min = childDomains.length === 0 ? 0 : $9373b80aaace1e85$export$df8687355ccb4d94(childDomains);
    var max = childDomains.length === 0 ? 1 : $9373b80aaace1e85$export$a8f783d9de5392f5(childDomains);
    return [
        min,
        max
    ];
}
function $8c0cae78a8f93a11$export$3e8733322718eb9(props, axis, childComponents) {
    childComponents = childComponents || (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(props.children);
    var propsDomain = $91b6bedde0b7fe96$export$2e477808c106ba09(props, axis);
    var domainPadding = $8c0cae78a8f93a11$export$f444ec12e5de5ae6(props, axis, childComponents);
    var domain;
    if (propsDomain) domain = propsDomain;
    else {
        var minDomain = $91b6bedde0b7fe96$export$385f5052ad9e995e(props, axis);
        var maxDomain = $91b6bedde0b7fe96$export$de470f0b6b2c75e9(props, axis);
        var dataset = (props.data || props.y) && $ce15a7815a86f8a8$export$7a171f172be0782e(props);
        var dataDomain = dataset ? $91b6bedde0b7fe96$export$d41344f8a7de2b5c(props, axis, dataset) : [];
        var childDomain = $8c0cae78a8f93a11$export$52c10c492484f2d6(props, axis, childComponents);
        var min = minDomain || $9373b80aaace1e85$export$df8687355ccb4d94([].concat($8c0cae78a8f93a11$var$_toConsumableArray(dataDomain), $8c0cae78a8f93a11$var$_toConsumableArray(childDomain)));
        var max = maxDomain || $9373b80aaace1e85$export$a8f783d9de5392f5([].concat($8c0cae78a8f93a11$var$_toConsumableArray(dataDomain), $8c0cae78a8f93a11$var$_toConsumableArray(childDomain)));
        domain = $91b6bedde0b7fe96$export$aafa8294ef4dae28(min, max);
    }
    return $91b6bedde0b7fe96$export$510ae4770a7da719(domain, (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        domainPadding: domainPadding
    }, props), axis);
}
function $8c0cae78a8f93a11$export$5cdac61cf538712e(props, axis, childComponents) {
    if (props.data) return $bf1178a7a28a9ee4$export$cc504192b2543d0c(props, axis);
    var children = childComponents ? childComponents.slice(0) : (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(props.children);
    var iteratee = function(child) {
        var sharedProps = (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, child.props, {
            horizontal: props.horizontal
        });
        return $bf1178a7a28a9ee4$export$ff60de4f71778a2c(sharedProps, axis);
    };
    var childScale = (0, (/*@__PURE__*/$parcel$interopDefault($bd8625fe3238ec95$exports)))($0a5de8228869aa1e$export$8d02402a54f5e88d(children, iteratee, props)); // default to linear scale if more than one uniq scale type is given by children
    return childScale.length > 1 ? $bf1178a7a28a9ee4$export$f8a8079677dfe10e("linear") : $bf1178a7a28a9ee4$export$f8a8079677dfe10e(childScale[0]);
}
function $8c0cae78a8f93a11$export$86fc571c51e65680(props) {
    var components = [
        "groupComponent",
        "containerComponent",
        "labelComponent"
    ];
    var componentEvents = $617aed0754382a89$export$553d7b5edf647c91(props, components);
    var events = props.events;
    if (Array.isArray(componentEvents)) events = Array.isArray(props.events) ? componentEvents.concat.apply(componentEvents, $8c0cae78a8f93a11$var$_toConsumableArray(props.events)) : componentEvents;
    return events || [];
}
function $8c0cae78a8f93a11$export$5551a2d24ff40153(calculatedProps, child, index) {
    // check for styles first
    var style = calculatedProps.style;
    var colorScale = calculatedProps.colorScale, color = calculatedProps.color;
    if (style && style.data && style.data.fill) return style.data.fill;
    colorScale = child.props && child.props.colorScale ? child.props.colorScale : colorScale;
    color = child.props && child.props.color ? child.props.color : color;
    if (!colorScale && !color) return undefined;
    var colors = Array.isArray(colorScale) ? colorScale : $adad185069bfc115$export$75f9af112506f7de(colorScale);
    return color || colors[index % colors.length];
}
function $8c0cae78a8f93a11$export$3d2f074408bd1b82(theme, style, role) {
    var defaultStyle = theme && theme[role] && theme[role].style ? theme[role].style : {};
    return $0a5de8228869aa1e$export$ffd58b7f6f099a57(style, defaultStyle);
}
function $8c0cae78a8f93a11$export$48ffc51b4bec1d57(child, index, calculatedProps) {
    var style = calculatedProps.style, role = calculatedProps.role;
    var childStyle = child.props.style || {};
    if (Array.isArray(childStyle)) return childStyle;
    var childRole = child.type && child.type.role;
    var defaultFill = childRole === "stack" ? undefined : $8c0cae78a8f93a11$export$5551a2d24ff40153(calculatedProps, child, index);
    var defaultColor = childRole === "line" ? {
        fill: "none",
        stroke: defaultFill
    } : {
        fill: defaultFill
    };
    var dataWidth = role === "stack" ? {} : {
        width: $8c0cae78a8f93a11$export$3c49c185de0c2bfc(calculatedProps)
    };
    var dataStyle = (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, childStyle.data, (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, dataWidth, style.data, defaultColor));
    var labelsStyle = (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, childStyle.labels, style.labels);
    return {
        parent: style.parent,
        data: dataStyle,
        labels: labelsStyle
    };
}
function $8c0cae78a8f93a11$export$92915b258f643ac6(childComponents, axis) {
    var iteratee = function(child) {
        var childProps = child.props || {};
        if (!$91b6bedde0b7fe96$export$9b264bdd6864cf49(child) || !childProps.categories) return null;
        var categories = childProps.categories && !Array.isArray(childProps.categories) ? childProps.categories[axis] : childProps.props.categories;
        var categoryStrings = categories && categories.filter(function(val) {
            return typeof val === "string";
        });
        return categoryStrings ? $9373b80aaace1e85$export$c499305a875a8ee9(categoryStrings) : [];
    };
    return $0a5de8228869aa1e$export$8d02402a54f5e88d(childComponents.slice(0), iteratee);
}
function $8c0cae78a8f93a11$export$d76e4ab22a13df1(childComponents) {
    var iteratee = function(child) {
        var childProps = child.props || {};
        var data;
        if (!$ce15a7815a86f8a8$export$959c1930e1bd68c1(child)) return null;
        else if (child.type && (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(child.type.getData)) data = child.type.getData(childProps);
        else data = $ce15a7815a86f8a8$export$7a171f172be0782e(childProps);
        return data.map(function(d) {
            return {
                x: d.xName,
                y: d.yName
            };
        });
    };
    var initialMemo = {
        x: [],
        y: []
    };
    var combine = function(memo, datum) {
        var x = Array.isArray(datum) ? datum.map(function(d) {
            return d.x;
        }).filter(Boolean) : datum.x;
        var y = Array.isArray(datum) ? datum.map(function(d) {
            return d.y;
        }).filter(Boolean) : datum.y;
        return {
            x: x !== undefined ? memo.x.concat(x) : memo.x,
            y: y !== undefined ? memo.y.concat(y) : memo.y
        };
    };
    return $0a5de8228869aa1e$export$8d02402a54f5e88d(childComponents.slice(0), iteratee, {}, initialMemo, combine);
}
function $8c0cae78a8f93a11$export$696fdeddca8d40bb(props, axis, childComponents) {
    var categories = (0, (/*@__PURE__*/$parcel$interopDefault($2537df67cd52c170$exports)))(props.categories) ? props.categories[axis] : props.categories;
    var axisComponent = $f052c55858268509$export$149ea8cb13929199(childComponents, axis);
    var axisStrings = axisComponent ? $ce15a7815a86f8a8$export$5bbc662142373468(axisComponent.props, axis) : [];
    var categoryStrings = categories || $8c0cae78a8f93a11$export$92915b258f643ac6(childComponents, axis);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bd8625fe3238ec95$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($c287c7303a1fc294$exports)))([].concat($8c0cae78a8f93a11$var$_toConsumableArray(categoryStrings), $8c0cae78a8f93a11$var$_toConsumableArray(axisStrings))));
}
function $8c0cae78a8f93a11$export$6f6bd247605c9540(props, childComponents) {
    childComponents = childComponents || (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(props.children);
    var xStrings = $8c0cae78a8f93a11$export$696fdeddca8d40bb(props, "x", childComponents);
    var yStrings = $8c0cae78a8f93a11$export$696fdeddca8d40bb(props, "y", childComponents);
    var dataStrings = $8c0cae78a8f93a11$export$d76e4ab22a13df1(childComponents);
    return {
        x: (0, (/*@__PURE__*/$parcel$interopDefault($bd8625fe3238ec95$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($c287c7303a1fc294$exports)))([].concat($8c0cae78a8f93a11$var$_toConsumableArray(xStrings), $8c0cae78a8f93a11$var$_toConsumableArray(dataStrings.x)))),
        y: (0, (/*@__PURE__*/$parcel$interopDefault($bd8625fe3238ec95$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($c287c7303a1fc294$exports)))([].concat($8c0cae78a8f93a11$var$_toConsumableArray(yStrings), $8c0cae78a8f93a11$var$_toConsumableArray(dataStrings.y))))
    };
}
function $8c0cae78a8f93a11$export$7a0f33e8df10bd94(props, childComponents, allStrings) {
    var xPropCategories = props.categories && !Array.isArray(props.categories) ? props.categories.x : props.categories;
    var yPropCategories = props.categories && !Array.isArray(props.categories) ? props.categories.y : props.categories;
    var fallbackRequired = !xPropCategories || !yPropCategories;
    var fallbackProps = fallbackRequired ? allStrings || $8c0cae78a8f93a11$export$6f6bd247605c9540(props, childComponents) : {};
    var xCategories = xPropCategories || fallbackProps.x;
    var yCategories = yPropCategories || fallbackProps.y;
    return {
        x: xCategories.length > 0 ? xCategories : undefined,
        y: yCategories.length > 0 ? yCategories : undefined
    };
}




var $8278c1c3dbe83bdd$exports = {};
/**
 * The inverse of `_.toPairs`; this method returns an object composed
 * from key-value `pairs`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} pairs The key-value pairs.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.fromPairs([['a', 1], ['b', 2]]);
 * // => { 'a': 1, 'b': 2 }
 */ function $8278c1c3dbe83bdd$var$fromPairs(pairs) {
    var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
    while(++index < length){
        var pair = pairs[index];
        result[pair[0]] = pair[1];
    }
    return result;
}
$8278c1c3dbe83bdd$exports = $8278c1c3dbe83bdd$var$fromPairs;







var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");



var $8VBTQ = parcelRequire("8VBTQ");
function $4b70f72d9ea1bec7$var$_slicedToArray(arr, i) {
    return $4b70f72d9ea1bec7$var$_arrayWithHoles(arr) || $4b70f72d9ea1bec7$var$_iterableToArrayLimit(arr, i) || $4b70f72d9ea1bec7$var$_unsupportedIterableToArray(arr, i) || $4b70f72d9ea1bec7$var$_nonIterableRest();
}
function $4b70f72d9ea1bec7$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4b70f72d9ea1bec7$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $4b70f72d9ea1bec7$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $4b70f72d9ea1bec7$var$_toConsumableArray(arr) {
    return $4b70f72d9ea1bec7$var$_arrayWithoutHoles(arr) || $4b70f72d9ea1bec7$var$_iterableToArray(arr) || $4b70f72d9ea1bec7$var$_unsupportedIterableToArray(arr) || $4b70f72d9ea1bec7$var$_nonIterableSpread();
}
function $4b70f72d9ea1bec7$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4b70f72d9ea1bec7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4b70f72d9ea1bec7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4b70f72d9ea1bec7$var$_arrayLikeToArray(o, minLen);
}
function $4b70f72d9ea1bec7$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $4b70f72d9ea1bec7$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $4b70f72d9ea1bec7$var$_arrayLikeToArray(arr);
}
function $4b70f72d9ea1bec7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4b70f72d9ea1bec7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4b70f72d9ea1bec7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4b70f72d9ea1bec7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4b70f72d9ea1bec7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4b70f72d9ea1bec7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $4b70f72d9ea1bec7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $4b70f72d9ea1bec7$var$_setPrototypeOf(subClass, superClass);
}
function $4b70f72d9ea1bec7$var$_setPrototypeOf(o, p) {
    $4b70f72d9ea1bec7$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $4b70f72d9ea1bec7$var$_setPrototypeOf(o, p);
}
function $4b70f72d9ea1bec7$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $4b70f72d9ea1bec7$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $4b70f72d9ea1bec7$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $4b70f72d9ea1bec7$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $4b70f72d9ea1bec7$var$_possibleConstructorReturn(this, result);
    };
}
function $4b70f72d9ea1bec7$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $4b70f72d9ea1bec7$var$_assertThisInitialized(self);
}
function $4b70f72d9ea1bec7$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $4b70f72d9ea1bec7$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $4b70f72d9ea1bec7$var$_getPrototypeOf(o) {
    $4b70f72d9ea1bec7$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $4b70f72d9ea1bec7$var$_getPrototypeOf(o);
}
// This file is not currently tested, and it is first on the list of files
// to refactor in our current refactoring effort. Please do not make changes
// to this file without manual testing and/or refactoring and adding tests.
var $4b70f72d9ea1bec7$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    $4b70f72d9ea1bec7$var$_inherits(VictorySharedEvents, _React$Component);
    var _super = $4b70f72d9ea1bec7$var$_createSuper(VictorySharedEvents);
    function VictorySharedEvents(props) {
        var _this;
        $4b70f72d9ea1bec7$var$_classCallCheck(this, VictorySharedEvents);
        _this = _super.call(this, props);
        _this.state = _this.state || {};
        _this.getScopedEvents = (0, $617aed0754382a89$exports).getScopedEvents.bind($4b70f72d9ea1bec7$var$_assertThisInitialized(_this));
        _this.getEventState = (0, $617aed0754382a89$exports).getEventState.bind($4b70f72d9ea1bec7$var$_assertThisInitialized(_this));
        _this.baseProps = _this.getBaseProps(props);
        _this.sharedEventsCache = {};
        _this.globalEvents = {};
        _this.prevGlobalEventKeys = [];
        _this.boundGlobalEvents = {};
        return _this;
    }
    $4b70f72d9ea1bec7$var$_createClass(VictorySharedEvents, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($15022e88a09b93ad$exports)))(this.props, nextProps)) {
                    this.baseProps = this.getBaseProps(nextProps);
                    var externalMutations = this.getExternalMutations(nextProps, this.baseProps);
                    this.applyExternalMutations(nextProps, externalMutations);
                }
                return true;
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                var globalEventKeys = (0, (/*@__PURE__*/$parcel$interopDefault($9c7d1fa85e24a67e$exports)))(this.globalEvents);
                globalEventKeys.forEach(function(key) {
                    return _this2.addGlobalListener(key);
                });
                this.prevGlobalEventKeys = globalEventKeys;
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this3 = this;
                var globalEventKeys = (0, (/*@__PURE__*/$parcel$interopDefault($9c7d1fa85e24a67e$exports)))(this.globalEvents);
                var removedGlobalEventKeys = (0, (/*@__PURE__*/$parcel$interopDefault($faa0050d5f48da66$exports)))(this.prevGlobalEventKeys, globalEventKeys);
                removedGlobalEventKeys.forEach(function(key) {
                    return _this3.removeGlobalListener(key);
                });
                var addedGlobalEventKeys = (0, (/*@__PURE__*/$parcel$interopDefault($faa0050d5f48da66$exports)))(globalEventKeys, this.prevGlobalEventKeys);
                addedGlobalEventKeys.forEach(function(key) {
                    return _this3.addGlobalListener(key);
                });
                this.prevGlobalEventKeys = globalEventKeys;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var _this4 = this;
                this.prevGlobalEventKeys.forEach(function(key) {
                    return _this4.removeGlobalListener(key);
                });
            }
        },
        {
            key: "addGlobalListener",
            value: function addGlobalListener(key) {
                var _this5 = this;
                var boundListener = function(event) {
                    var listener = _this5.globalEvents[key];
                    return listener && listener((0, $617aed0754382a89$exports).emulateReactEvent(event));
                };
                this.boundGlobalEvents[key] = boundListener;
                window.addEventListener((0, $617aed0754382a89$exports).getGlobalEventNameFromKey(key), boundListener);
            }
        },
        {
            key: "removeGlobalListener",
            value: function removeGlobalListener(key) {
                window.removeEventListener((0, $617aed0754382a89$exports).getGlobalEventNameFromKey(key), this.boundGlobalEvents[key]);
            }
        },
        {
            key: "getAllEvents",
            value: function getAllEvents(props) {
                var components = [
                    "container",
                    "groupComponent"
                ];
                var componentEvents = (0, $617aed0754382a89$exports).getComponentEvents(props, components);
                if (Array.isArray(componentEvents)) return Array.isArray(props.events) ? componentEvents.concat.apply(componentEvents, $4b70f72d9ea1bec7$var$_toConsumableArray(props.events)) : componentEvents;
                return props.events;
            }
        },
        {
            key: "applyExternalMutations",
            value: function applyExternalMutations(props, externalMutations) {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($1331767f05251f48$exports)))(externalMutations)) {
                    var callbacks = props.externalEventMutations.reduce(function(memo, mutation) {
                        memo = (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(mutation.callback) ? memo.concat(mutation.callback) : memo;
                        return memo;
                    }, []);
                    var compiledCallbacks = callbacks.length ? function() {
                        callbacks.forEach(function(c) {
                            return c();
                        });
                    } : undefined;
                    this.setState(externalMutations, compiledCallbacks);
                }
            }
        },
        {
            key: "getExternalMutations",
            value: function getExternalMutations(props, baseProps) {
                return !(0, (/*@__PURE__*/$parcel$interopDefault($1331767f05251f48$exports)))(props.externalEventMutations) ? (0, $617aed0754382a89$exports).getExternalMutationsWithChildren(props.externalEventMutations, baseProps, this.state, (0, (/*@__PURE__*/$parcel$interopDefault($9c7d1fa85e24a67e$exports)))(baseProps)) : undefined;
            }
        },
        {
            key: "cacheSharedEvents",
            value: function cacheSharedEvents(name, sharedEvents, cacheValues) {
                this.sharedEventsCache[name] = [
                    sharedEvents,
                    cacheValues
                ];
            }
        },
        {
            key: "getCachedSharedEvents",
            value: function getCachedSharedEvents(name, cacheValues) {
                var _ref = this.sharedEventsCache[name] || [], _ref2 = $4b70f72d9ea1bec7$var$_slicedToArray(_ref, 2), sharedEvents = _ref2[0], prevCacheValues = _ref2[1];
                if (sharedEvents && (0, (/*@__PURE__*/$parcel$interopDefault($15022e88a09b93ad$exports)))(cacheValues, prevCacheValues)) return sharedEvents;
                return undefined;
            }
        },
        {
            key: "getBaseProps",
            value: function getBaseProps(props) {
                var container = props.container;
                var children = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(this.props.children);
                var childBaseProps = this.getBasePropsFromChildren(children);
                var parentBaseProps = container ? container.props : {};
                return (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, childBaseProps, {
                    parent: parentBaseProps
                });
            }
        },
        {
            key: "getBasePropsFromChildren",
            value: function getBasePropsFromChildren(childComponents) {
                var iteratee = function(child, childName) {
                    if (child.type && (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(child.type.getBaseProps)) {
                        var _baseProps = child.props && child.type.getBaseProps(child.props);
                        return _baseProps ? [
                            [
                                childName,
                                _baseProps
                            ]
                        ] : null;
                    }
                    return null;
                };
                var baseProps = (0, $0a5de8228869aa1e$exports).reduceChildren(childComponents, iteratee);
                return (0, (/*@__PURE__*/$parcel$interopDefault($8278c1c3dbe83bdd$exports)))(baseProps);
            }
        },
        {
            key: "getNewChildren",
            value: function getNewChildren(props, baseProps) {
                var _this6 = this;
                var events = props.events, eventKey = props.eventKey;
                var alterChildren = function(children, childNames) {
                    return children.reduce(function(memo, child, index) {
                        if (child.props.children) {
                            var newChildren = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(child.props.children);
                            var names = childNames.slice(index, index + newChildren.length);
                            var results = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(child, child.props, alterChildren(newChildren, names));
                            return memo.concat(results);
                        } else if (childNames[index] !== "parent" && child.type && (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(child.type.getBaseProps)) {
                            var name = child.props.name || childNames[index];
                            var childEvents = Array.isArray(events) && events.filter(function(event) {
                                if (event.target === "parent") return false;
                                return Array.isArray(event.childName) ? event.childName.indexOf(name) > -1 : event.childName === name || event.childName === "all";
                            });
                            var sharedEventsCacheValues = [
                                name,
                                baseProps,
                                childEvents,
                                (0, (/*@__PURE__*/$parcel$interopDefault($8VBTQ)))(_this6.state[name])
                            ];
                            var sharedEvents = _this6.getCachedSharedEvents(name, sharedEventsCacheValues) || {
                                events: childEvents,
                                // partially apply child name and baseProps,
                                getEvents: function(evts, target) {
                                    return _this6.getScopedEvents(evts, target, name, baseProps);
                                },
                                // partially apply child name
                                getEventState: function(key, target) {
                                    return _this6.getEventState(key, target, name);
                                }
                            };
                            _this6.cacheSharedEvents(name, sharedEvents, sharedEventsCacheValues);
                            return memo.concat(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(child, (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
                                key: "events-".concat(name),
                                sharedEvents: sharedEvents,
                                eventKey: eventKey,
                                name: name
                            }, child.props)));
                        }
                        return memo.concat(child);
                    }, []);
                };
                var childNames = (0, (/*@__PURE__*/$parcel$interopDefault($9c7d1fa85e24a67e$exports)))(baseProps);
                var childComponents = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(props.children);
                return alterChildren(childComponents, childNames);
            }
        },
        {
            key: "getContainer",
            value: function getContainer(props, baseProps, events) {
                var _this7 = this;
                var children = this.getNewChildren(props, baseProps);
                var parents = Array.isArray(events) && events.filter(function(event) {
                    return event.target === "parent";
                });
                var sharedEvents = parents.length > 0 ? {
                    events: parents,
                    // partially apply childName (null) and baseProps,
                    getEvents: function(evts, target) {
                        return _this7.getScopedEvents(evts, target, null, baseProps);
                    },
                    getEventState: this.getEventState
                } : null;
                var container = props.container || props.groupComponent;
                var role = container.type && container.type.role;
                var containerProps = container.props || {};
                var boundGetEvents = (0, $617aed0754382a89$exports).getEvents.bind(this);
                var parentEvents = sharedEvents && boundGetEvents({
                    sharedEvents: sharedEvents
                }, "parent");
                var parentProps = (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, this.getEventState("parent", "parent"), containerProps, baseProps.parent, {
                    children: children
                });
                var containerEvents = (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, (0, $617aed0754382a89$exports).getPartialEvents(parentEvents, "parent", parentProps), containerProps.events);
                this.globalEvents = (0, $617aed0754382a89$exports).getGlobalEvents(containerEvents);
                var localEvents = (0, $617aed0754382a89$exports).omitGlobalEvents(containerEvents);
                return role === "container" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(container, (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, parentProps, {
                    events: localEvents
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(container, localEvents, children);
            }
        },
        {
            key: "render",
            value: function render() {
                var events = this.getAllEvents(this.props);
                if (events) return this.getContainer(this.props, this.baseProps, events);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(this.props.container, {
                    children: this.props.children
                });
            }
        }
    ]);
    return VictorySharedEvents;
}((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Component);
$4b70f72d9ea1bec7$export$2e2bcd8739ae039.displayName = "VictorySharedEvents";
$4b70f72d9ea1bec7$export$2e2bcd8739ae039.role = "shared-event-wrapper";
$4b70f72d9ea1bec7$export$2e2bcd8739ae039.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node
    ]),
    container: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    eventKey: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, $9dba2b2bbfc485d5$exports).allOfType([
            (0, $9dba2b2bbfc485d5$exports).integer,
            (0, $9dba2b2bbfc485d5$exports).nonNegative
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    events: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        childName: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array
        ]),
        eventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        eventKey: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, $9dba2b2bbfc485d5$exports).allOfType([
                (0, $9dba2b2bbfc485d5$exports).integer,
                (0, $9dba2b2bbfc485d5$exports).nonNegative
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
        ]),
        target: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    })),
    externalEventMutations: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        callback: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        childName: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array
        ]),
        eventKey: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array,
            (0, $9dba2b2bbfc485d5$exports).allOfType([
                (0, $9dba2b2bbfc485d5$exports).integer,
                (0, $9dba2b2bbfc485d5$exports).nonNegative
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
        ]),
        mutation: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        target: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array
        ])
    })),
    groupComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node
};
$4b70f72d9ea1bec7$export$2e2bcd8739ae039.defaultProps = {
    groupComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("g", null)
};
$4b70f72d9ea1bec7$export$2e2bcd8739ae039.contextType = (0, $fb8bdbdaa14fb6cc$export$2e2bcd8739ae039);





var $fdGrT = parcelRequire("fdGrT");

var $8T3gX = parcelRequire("8T3gX");


var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");



var $8T3gX = parcelRequire("8T3gX");
var $2160e47ba7941278$var$_excluded = [
    "desc"
];
function $2160e47ba7941278$var$_extends() {
    $2160e47ba7941278$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2160e47ba7941278$var$_extends.apply(this, arguments);
}
function $2160e47ba7941278$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2160e47ba7941278$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2160e47ba7941278$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $2160e47ba7941278$export$17d680238e50603e = function(props) {
    // eslint-disable-next-line react/prop-types
    var desc = props.desc, rest = $2160e47ba7941278$var$_objectWithoutProperties(props, $2160e47ba7941278$var$_excluded);
    return desc ? /*#__PURE__*/ // @ts-expect-error FIXME: "id cannot be a number"
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("line", $2160e47ba7941278$var$_extends({
        vectorEffect: "non-scaling-stroke"
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("desc", null, desc)) : /*#__PURE__*/ // @ts-expect-error FIXME: "id cannot be a number"
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("line", $2160e47ba7941278$var$_extends({
        vectorEffect: "non-scaling-stroke"
    }, rest));
};


function $0fd51547873f73ee$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0fd51547873f73ee$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0fd51547873f73ee$var$ownKeys(Object(source), !0).forEach(function(key) {
            $0fd51547873f73ee$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0fd51547873f73ee$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0fd51547873f73ee$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $0fd51547873f73ee$var$evaluateProps = function(props) {
    /**
   * Potential evaluated props are:
   * `ariaLabel`
   * `desc`
   * `id`
   * `style`
   * `tabIndex`
   */ var ariaLabel = $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(props.ariaLabel, props);
    var desc = $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(props.desc, props);
    var id = $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(props.id, props);
    var style = $0a5de8228869aa1e$export$b94dbb3a3654958c((0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        stroke: "black"
    }, props.style), props);
    var tabIndex = $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(props.tabIndex, props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, props, {
        ariaLabel: ariaLabel,
        desc: desc,
        id: id,
        style: style,
        tabIndex: tabIndex
    });
};
var $0fd51547873f73ee$export$8b98feb4a2766c75 = function(props) {
    props = $0fd51547873f73ee$var$evaluateProps(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(props.lineComponent, $0fd51547873f73ee$var$_objectSpread($0fd51547873f73ee$var$_objectSpread({}, props.events), {}, {
        "aria-label": props.ariaLabel,
        style: props.style,
        desc: props.desc,
        tabIndex: props.tabIndex,
        className: props.className,
        role: props.role,
        shapeRendering: props.shapeRendering,
        x1: props.x1,
        x2: props.x2,
        y1: props.y1,
        y2: props.y2,
        transform: props.transform,
        clipPath: props.clipPath
    }));
};
$0fd51547873f73ee$export$8b98feb4a2766c75.propTypes = $0fd51547873f73ee$var$_objectSpread($0fd51547873f73ee$var$_objectSpread({}, (0, $70dbe1f62d5c55ed$export$fe6a43517f1f6b90).primitiveProps), {}, {
    datum: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    lineComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    x1: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    x2: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    y1: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    y2: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number
});
$0fd51547873f73ee$export$8b98feb4a2766c75.defaultProps = {
    lineComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $2160e47ba7941278$export$17d680238e50603e), null),
    role: "presentation",
    shapeRendering: "auto"
};





function $5d956bbfd2f7bd8b$var$_toConsumableArray(arr) {
    return $5d956bbfd2f7bd8b$var$_arrayWithoutHoles(arr) || $5d956bbfd2f7bd8b$var$_iterableToArray(arr) || $5d956bbfd2f7bd8b$var$_unsupportedIterableToArray(arr) || $5d956bbfd2f7bd8b$var$_nonIterableSpread();
}
function $5d956bbfd2f7bd8b$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5d956bbfd2f7bd8b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5d956bbfd2f7bd8b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5d956bbfd2f7bd8b$var$_arrayLikeToArray(o, minLen);
}
function $5d956bbfd2f7bd8b$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $5d956bbfd2f7bd8b$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $5d956bbfd2f7bd8b$var$_arrayLikeToArray(arr);
}
function $5d956bbfd2f7bd8b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5d956bbfd2f7bd8b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $5d956bbfd2f7bd8b$var$orientationSign = {
    top: -1,
    left: -1,
    right: 1,
    bottom: 1
};
var $5d956bbfd2f7bd8b$var$exists = function(val) {
    return val !== null && val !== undefined;
};
var $5d956bbfd2f7bd8b$var$getCurrentAxis = function(props, axis) {
    var orientation = props.orientation, horizontal = props.horizontal;
    if (orientation) {
        var dimensions = {
            top: "x",
            bottom: "x",
            left: "y",
            right: "y"
        };
        return dimensions[orientation];
    }
    var otherAxis = axis === "x" ? "y" : "x";
    return horizontal ? otherAxis : axis;
};
var $5d956bbfd2f7bd8b$var$getScale = function(props) {
    var axis = (0, $f052c55858268509$exports).getAxis(props);
    var currentAxis = $5d956bbfd2f7bd8b$var$getCurrentAxis(props, axis);
    var scale = (0, $bf1178a7a28a9ee4$exports).getBaseScale(props, axis);
    var propsDomain = props.domain && props.domain[axis];
    var domain = propsDomain || (0, $f052c55858268509$exports).getDomain(props) || scale.domain();
    scale.range((0, $0a5de8228869aa1e$exports).getRange(props, currentAxis));
    scale.domain(domain);
    return scale;
};
var $5d956bbfd2f7bd8b$var$getStyleObject = function(props) {
    var theme = props.theme, dependentAxis = props.dependentAxis;
    var generalAxisStyle = theme && theme.axis && theme.axis.style;
    var axisType = dependentAxis ? "dependentAxis" : "independentAxis";
    var specificAxisStyle = theme && theme[axisType] && theme[axisType].style;
    var mergeStyles = function() {
        var styleNamespaces = [
            "axis",
            "axisLabel",
            "grid",
            "parent",
            "tickLabels",
            "ticks"
        ];
        return styleNamespaces.reduce(function(memo, curr) {
            memo[curr] = (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, specificAxisStyle[curr], generalAxisStyle[curr]);
            return memo;
        }, {});
    };
    return generalAxisStyle && specificAxisStyle ? mergeStyles() : specificAxisStyle || generalAxisStyle;
};
var $5d956bbfd2f7bd8b$export$ffd58b7f6f099a57 = function(props, styleObject) {
    var style = props.style || {};
    styleObject = styleObject || {};
    var parentStyleProps = {
        height: "100%",
        width: "100%"
    };
    return {
        parent: (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))(style.parent, styleObject.parent, parentStyleProps),
        axis: (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, style.axis, styleObject.axis),
        axisLabel: (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, style.axisLabel, styleObject.axisLabel),
        grid: (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, style.grid, styleObject.grid),
        ticks: (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, style.ticks, styleObject.ticks),
        tickLabels: (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, style.tickLabels, styleObject.tickLabels)
    };
};
var $5d956bbfd2f7bd8b$var$getTickProps = function(layout, style, datum) {
    var position = layout.position, transform = layout.transform;
    return {
        x1: transform.x,
        y1: transform.y,
        x2: transform.x + position.x2,
        y2: transform.y + position.y2,
        style: style,
        datum: datum
    };
}; // eslint-disable-next-line max-params
var $5d956bbfd2f7bd8b$var$getTickLabelProps = function(layout, style, anchors, datum, text) {
    var position = layout.position, transform = layout.transform;
    return {
        style: style,
        x: transform.x + position.x,
        y: transform.y + position.y,
        verticalAnchor: anchors.verticalAnchor,
        textAnchor: anchors.textAnchor,
        angle: style.angle,
        text: text,
        datum: datum
    };
};
var $5d956bbfd2f7bd8b$var$getGridProps = function(layout, style, datum) {
    var edge = layout.edge, transform = layout.transform;
    return {
        x1: transform.x,
        y1: transform.y,
        x2: edge.x + transform.x,
        y2: edge.y + transform.y,
        style: style,
        datum: datum
    };
};
var $5d956bbfd2f7bd8b$var$getAxisProps = function(modifiedProps, calculatedValues, globalTransform) {
    var style = calculatedValues.style, padding = calculatedValues.padding, isVertical = calculatedValues.isVertical;
    var width = modifiedProps.width, height = modifiedProps.height;
    return {
        style: style.axis,
        x1: isVertical ? globalTransform.x : padding.left + globalTransform.x,
        x2: isVertical ? globalTransform.x : width - padding.right + globalTransform.x,
        y1: isVertical ? padding.top + globalTransform.y : globalTransform.y,
        y2: isVertical ? height - padding.bottom + globalTransform.y : globalTransform.y
    };
};
var $5d956bbfd2f7bd8b$var$getEvaluatedStyles = function(style, props) {
    return {
        tickStyle: (0, $0a5de8228869aa1e$exports).evaluateStyle(style.ticks, props),
        labelStyle: (0, $0a5de8228869aa1e$exports).evaluateStyle(style.tickLabels, props),
        gridStyle: (0, $0a5de8228869aa1e$exports).evaluateStyle(style.grid, props)
    };
};
var $5d956bbfd2f7bd8b$var$getAxisLabelProps = function(props, calculatedValues, globalTransform) {
    var style = calculatedValues.style, orientation = calculatedValues.orientation, padding = calculatedValues.padding, labelPadding = calculatedValues.labelPadding, isVertical = calculatedValues.isVertical;
    var sign = $5d956bbfd2f7bd8b$var$orientationSign[orientation];
    var hPadding = padding.left + padding.right;
    var vPadding = padding.top + padding.bottom;
    var verticalAnchor = sign < 0 ? "end" : "start";
    var labelStyle = style.axisLabel;
    var angle = isVertical ? -90 : 0; // eslint-disable-line no-magic-numbers
    var x = isVertical ? globalTransform.x + sign * labelPadding : (props.width - hPadding) / 2 + padding.left + globalTransform.x;
    var y = isVertical ? (props.height - vPadding) / 2 + padding.top + globalTransform.y : sign * labelPadding + globalTransform.y;
    return {
        x: x,
        y: y,
        verticalAnchor: labelStyle.verticalAnchor || verticalAnchor,
        textAnchor: labelStyle.textAnchor || "middle",
        angle: labelStyle.angle === undefined ? angle : labelStyle.angle,
        style: labelStyle,
        text: props.label
    };
};
var $5d956bbfd2f7bd8b$var$getAnchors = function(orientation, isVertical) {
    var anchorOrientation = {
        top: "end",
        left: "end",
        right: "start",
        bottom: "start"
    };
    var anchor = anchorOrientation[orientation];
    return {
        textAnchor: isVertical ? anchor : "middle",
        verticalAnchor: isVertical ? "middle" : anchor
    };
};
var $5d956bbfd2f7bd8b$var$getLabelPadding = function(props, style) {
    var labelStyle = style.axisLabel || {};
    if (labelStyle.padding !== undefined && labelStyle.padding !== null) return labelStyle.padding;
    var isVertical = (0, $f052c55858268509$exports).isVertical(props); // TODO: magic numbers
    /* eslint-disable no-magic-numbers*/ var fontSize = labelStyle.fontSize || 14;
    return props.label ? fontSize * (isVertical ? 2.3 : 1.6) : 0;
/* eslint-enable no-magic-numbers*/ };
var $5d956bbfd2f7bd8b$var$getDefaultOrientations = function(axis, originSign, horizontal) {
    var sign = originSign || "positive";
    var orientations = {
        positive: {
            x: "bottom",
            y: "left"
        },
        negative: {
            x: "top",
            y: "right"
        }
    };
    var horizontalOrientations = {
        positive: {
            x: "left",
            y: "bottom"
        },
        negative: {
            x: "right",
            y: "top"
        }
    };
    return horizontal ? horizontalOrientations[sign][axis] : orientations[sign][axis];
};
var $5d956bbfd2f7bd8b$var$getStandaloneOffset = function(props, calculatedValues) {
    var style = calculatedValues.style, scale = calculatedValues.scale, orientation = calculatedValues.orientation, padding = calculatedValues.padding, axis = calculatedValues.axis, ticks = calculatedValues.ticks, stringTicks = calculatedValues.stringTicks, isVertical = calculatedValues.isVertical, labelPadding = calculatedValues.labelPadding;
    var polar = props.polar, horizontal = props.horizontal;
    var sharedProps = {
        scale: $5d956bbfd2f7bd8b$var$_defineProperty({}, axis, scale),
        polar: polar,
        horizontal: horizontal,
        ticks: ticks,
        stringTicks: stringTicks
    };
    var xPadding = orientation === "right" ? padding.right : padding.left;
    var yPadding = orientation === "top" ? padding.top : padding.bottom;
    var offsetX = props.offsetX !== null && props.offsetX !== undefined ? props.offsetX : xPadding;
    var offsetY = props.offsetY !== null && props.offsetY !== undefined ? props.offsetY : yPadding;
    var fontSize = style.axisLabel.fontSize || 14; // eslint-disable-line no-magic-numbers
    var tickSizes = ticks.map(function(data, index) {
        var tick = stringTicks ? props.tickValues[data - 1] : data;
        var tickStyle = (0, $0a5de8228869aa1e$exports).evaluateStyle(style.ticks, (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, sharedProps, {
            tick: tick,
            index: index
        }));
        return tickStyle.size || 0;
    });
    var totalPadding = fontSize + 2 * Math.max.apply(Math, $5d956bbfd2f7bd8b$var$_toConsumableArray(tickSizes)) + labelPadding;
    var minimumPadding = 1.2 * fontSize; // eslint-disable-line no-magic-numbers
    var x = isVertical ? totalPadding : minimumPadding;
    var y = isVertical ? minimumPadding : totalPadding;
    return {
        x: offsetX !== null && offsetX !== undefined ? offsetX : x,
        y: offsetY !== null && offsetY !== undefined ? offsetY : y
    };
}; // eslint-disable-next-line complexity
var $5d956bbfd2f7bd8b$var$getOffset = function(props, calculatedValues) {
    var scale = calculatedValues.scale, origin = calculatedValues.origin, orientation = calculatedValues.orientation, orientations = calculatedValues.orientations, domain = calculatedValues.domain, padding = calculatedValues.padding;
    var top = padding.top, bottom = padding.bottom, left = padding.left, right = padding.right;
    var calculatedOrientation = {
        x: orientation === "bottom" || orientation === "top" ? orientation : orientations.x,
        y: orientation === "left" || orientation === "right" ? orientation : orientations.y
    }; // make the axes line up, and cross when appropriate
    var orientationOffset = {
        x: calculatedOrientation.y === "left" ? left : right,
        y: calculatedOrientation.x === "bottom" ? bottom : top
    };
    var originOffset = {
        x: calculatedOrientation.y === "left" ? 0 : props.width,
        y: calculatedOrientation.x === "bottom" ? props.height : 0
    };
    var originPosition = {
        x: origin.x === domain.x[0] || origin.x === domain.x[1] ? 0 : scale.x(origin.x),
        y: origin.y === domain.y[0] || origin.y === domain.y[1] ? 0 : scale.y(origin.y)
    };
    var x = originPosition.x ? Math.abs(originOffset.x - originPosition.x) : orientationOffset.x;
    var y = originPosition.y ? Math.abs(originOffset.y - originPosition.y) : orientationOffset.y;
    var offsetX = $5d956bbfd2f7bd8b$var$exists(props.offsetX) ? props.offsetX : x;
    var offsetY = $5d956bbfd2f7bd8b$var$exists(props.offsetY) ? props.offsetY : y;
    return {
        x: offsetX,
        y: offsetY
    };
}; // eslint-disable-next-line complexity
var $5d956bbfd2f7bd8b$var$getHorizontalOffset = function(props, calculatedValues) {
    var scale = calculatedValues.scale, origin = calculatedValues.origin, orientation = calculatedValues.orientation, orientations = calculatedValues.orientations, domain = calculatedValues.domain, padding = calculatedValues.padding;
    var top = padding.top, bottom = padding.bottom, left = padding.left, right = padding.right;
    var calculatedOrientation = {
        y: orientation === "bottom" || orientation === "top" ? orientation : orientations.x,
        x: orientation === "left" || orientation === "right" ? orientation : orientations.y
    }; // make the axes line up, and cross when appropriate
    var orientationOffset = {
        x: calculatedOrientation.y === "bottom" ? bottom : top,
        y: calculatedOrientation.x === "left" ? left : right
    };
    var originOffset = {
        y: calculatedOrientation.x === "left" ? 0 : props.width,
        x: calculatedOrientation.y === "bottom" ? props.height : 0
    };
    var originPosition = {
        x: origin.x === domain.x[0] || origin.x === domain.x[1] ? 0 : scale.x(origin.x),
        y: origin.y === domain.y[0] || origin.y === domain.y[1] ? 0 : scale.y(origin.y)
    };
    var y = originPosition.x ? Math.abs(originOffset.x - originPosition.x) : orientationOffset.x;
    var x = originPosition.y ? Math.abs(originOffset.y - originPosition.y) : orientationOffset.y;
    var offsetX = $5d956bbfd2f7bd8b$var$exists(props.offsetX) ? props.offsetX : x;
    var offsetY = $5d956bbfd2f7bd8b$var$exists(props.offsetY) ? props.offsetY : y;
    return {
        x: offsetX,
        y: offsetY
    };
};
var $5d956bbfd2f7bd8b$var$getTransform = function(props, calculatedValues, offset) {
    var orientation = calculatedValues.orientation, axis = calculatedValues.axis;
    var axisValue = (0, $f052c55858268509$exports).getAxisValue(props, axis);
    return ({
        top: {
            x: 0,
            y: axisValue !== undefined ? axisValue : offset.y
        },
        bottom: {
            x: 0,
            y: axisValue !== undefined ? axisValue : props.height - offset.y
        },
        left: {
            x: axisValue !== undefined ? axisValue : offset.x,
            y: 0
        },
        right: {
            x: axisValue !== undefined ? axisValue : props.width - offset.x,
            y: 0
        }
    })[orientation];
};
var $5d956bbfd2f7bd8b$var$getTickPosition = function(style, orientation, isVertical) {
    var tickStyle = style.tickStyle, labelStyle = style.labelStyle;
    var size = tickStyle.size || 0;
    var tickPadding = tickStyle.padding || 0;
    var labelPadding = labelStyle.padding || 0;
    var tickSpacing = size + tickPadding + labelPadding;
    var sign = $5d956bbfd2f7bd8b$var$orientationSign[orientation];
    return {
        x: isVertical ? sign * tickSpacing : 0,
        x2: isVertical ? sign * size : 0,
        y: isVertical ? 0 : sign * tickSpacing,
        y2: isVertical ? 0 : sign * size
    };
};
var $5d956bbfd2f7bd8b$var$getTickTransform = function(tick, globalTransform, isVertical) {
    return {
        x: isVertical ? globalTransform.x : tick + globalTransform.x,
        y: isVertical ? tick + globalTransform.y : globalTransform.y
    };
};
var $5d956bbfd2f7bd8b$var$getGridEdge = function(props, calculatedValues) {
    var orientation = calculatedValues.orientation, padding = calculatedValues.padding, isVertical = calculatedValues.isVertical;
    var sign = -$5d956bbfd2f7bd8b$var$orientationSign[orientation];
    var x = isVertical ? sign * (props.width - (padding.left + padding.right)) : 0;
    var y = isVertical ? 0 : sign * (props.height - (padding.top + padding.bottom));
    return {
        x: x,
        y: y
    };
};
var $5d956bbfd2f7bd8b$var$getGridOffset = function(calculatedValues, offset) {
    var padding = calculatedValues.padding, orientation = calculatedValues.orientation, crossAxis = calculatedValues.crossAxis;
    var xPadding = orientation === "right" ? padding.right : padding.left;
    var yPadding = orientation === "top" ? padding.top : padding.bottom;
    return {
        x: crossAxis ? offset.x - xPadding : 0,
        y: crossAxis ? offset.y - yPadding : 0
    };
};
var $5d956bbfd2f7bd8b$var$getLayoutProps = function(modifiedProps, calculatedValues) {
    var offset;
    if (calculatedValues.domain.x && calculatedValues.domain.y) offset = modifiedProps.horizontal ? $5d956bbfd2f7bd8b$var$getHorizontalOffset(modifiedProps, calculatedValues) : $5d956bbfd2f7bd8b$var$getOffset(modifiedProps, calculatedValues);
    else offset = $5d956bbfd2f7bd8b$var$getStandaloneOffset(modifiedProps, calculatedValues);
    return {
        globalTransform: $5d956bbfd2f7bd8b$var$getTransform(modifiedProps, calculatedValues, offset),
        gridOffset: $5d956bbfd2f7bd8b$var$getGridOffset(calculatedValues, offset),
        gridEdge: $5d956bbfd2f7bd8b$var$getGridEdge(modifiedProps, calculatedValues)
    };
};
var $5d956bbfd2f7bd8b$var$getOrientation = function(props) {
    if (props.orientation) return props.orientation;
    var defaultOrientations = {
        dependent: props.horizontal ? "bottom" : "left",
        independent: props.horizontal ? "left" : "bottom"
    };
    return props.dependentAxis ? defaultOrientations.dependent : defaultOrientations.independent;
}; // eslint-disable-next-line complexity
var $5d956bbfd2f7bd8b$var$getCalculatedValues = function(props) {
    var defaultStyles = $5d956bbfd2f7bd8b$var$getStyleObject(props);
    var style = $5d956bbfd2f7bd8b$export$ffd58b7f6f099a57(props, defaultStyles);
    var padding = (0, $0a5de8228869aa1e$exports).getPadding(props);
    var labelPadding = $5d956bbfd2f7bd8b$var$getLabelPadding(props, style);
    var stringTicks = (0, $f052c55858268509$exports).stringTicks(props) ? props.tickValues : undefined;
    var axis = (0, $f052c55858268509$exports).getAxis(props);
    var axisDomain = (0, $f052c55858268509$exports).getDomain(props);
    var axisScale = $5d956bbfd2f7bd8b$var$getScale(props);
    var xAxisDomain = axis === "x" ? axisDomain : undefined;
    var yAxisDomain = axis === "y" ? axisDomain : undefined;
    var xAxisScale = axis === "x" ? axisScale : undefined;
    var yAxisScale = axis === "y" ? axisScale : undefined;
    var crossAxis = !(props.crossAxis === false || props.standalone === true);
    var ticks = (0, $f052c55858268509$exports).getTicks(props, axisScale, crossAxis);
    var tickFormat = (0, $f052c55858268509$exports).getTickFormat(props, axisScale);
    var range = {
        x: (0, $0a5de8228869aa1e$exports).getRange(props, "x"),
        y: (0, $0a5de8228869aa1e$exports).getRange(props, "y")
    }; // use full domain if passed in from parent,
    // otherwise use the just the one axis available
    var domain = {
        x: props.domain && props.domain.x ? props.domain.x : xAxisDomain,
        y: props.domain && props.domain.y ? props.domain.y : yAxisDomain
    }; // use full scale if passed in from parent,
    // otherwise use the just the one axis available
    var scale = {
        x: props.domain && props.domain.x ? (0, $bf1178a7a28a9ee4$exports).getBaseScale(props, "x").domain(props.domain.x).range(props.horizontal ? range.y : range.x) : xAxisScale,
        y: props.domain && props.domain.y ? (0, $bf1178a7a28a9ee4$exports).getBaseScale(props, "y").domain(props.domain.y).range(props.horizontal ? range.x : range.y) : yAxisScale
    };
    var origin = domain.x && domain.y ? (0, $f052c55858268509$exports).getOrigin(domain) : undefined;
    var originSign = origin ? {
        x: (0, $f052c55858268509$exports).getOriginSign(origin.x, domain.x),
        y: (0, $f052c55858268509$exports).getOriginSign(origin.y, domain.y)
    } : undefined;
    var orientations = originSign ? {
        x: $5d956bbfd2f7bd8b$var$getDefaultOrientations("x", originSign.y, props.horizontal),
        y: $5d956bbfd2f7bd8b$var$getDefaultOrientations("y", originSign.x, props.horizontal)
    } : undefined;
    var orientation = orientations ? props.orientation || orientations[axis] : $5d956bbfd2f7bd8b$var$getOrientation(props);
    var isVertical = (0, $f052c55858268509$exports).isVertical(Object.assign({}, props, {
        orientation: orientation
    }));
    var anchors = $5d956bbfd2f7bd8b$var$getAnchors(orientation, isVertical);
    return {
        anchors: anchors,
        axis: axis,
        crossAxis: crossAxis,
        domain: domain,
        isVertical: isVertical,
        labelPadding: labelPadding,
        orientation: orientation,
        orientations: orientations,
        origin: origin,
        padding: padding,
        scale: scale,
        stringTicks: stringTicks,
        style: style,
        tickFormat: tickFormat,
        ticks: ticks
    };
};
var $5d956bbfd2f7bd8b$export$a7ec8144096537e7 = function(props, fallbackProps) {
    props = (0, $f052c55858268509$exports).modifyProps(props, fallbackProps);
    var calculatedValues = $5d956bbfd2f7bd8b$var$getCalculatedValues(props);
    var axis = calculatedValues.axis, style = calculatedValues.style, orientation = calculatedValues.orientation, isVertical = calculatedValues.isVertical, scale = calculatedValues.scale, ticks = calculatedValues.ticks, tickFormat = calculatedValues.tickFormat, anchors = calculatedValues.anchors, domain = calculatedValues.domain, stringTicks = calculatedValues.stringTicks;
    var otherAxis = axis === "x" ? "y" : "x";
    var _props = props, width = _props.width, height = _props.height, standalone = _props.standalone, theme = _props.theme, polar = _props.polar, padding = _props.padding, horizontal = _props.horizontal;
    var _getLayoutProps = $5d956bbfd2f7bd8b$var$getLayoutProps(props, calculatedValues), globalTransform = _getLayoutProps.globalTransform, gridOffset = _getLayoutProps.gridOffset, gridEdge = _getLayoutProps.gridEdge;
    var sharedProps = {
        scale: $5d956bbfd2f7bd8b$var$_defineProperty({}, axis, scale[axis]),
        polar: polar,
        horizontal: horizontal,
        ticks: ticks,
        stringTicks: stringTicks
    };
    var axisProps = $5d956bbfd2f7bd8b$var$getAxisProps(props, calculatedValues, globalTransform);
    var axisLabelProps = $5d956bbfd2f7bd8b$var$getAxisLabelProps(props, calculatedValues, globalTransform);
    var initialChildProps = {
        parent: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
            style: style.parent,
            ticks: ticks,
            standalone: standalone,
            theme: theme,
            width: width,
            height: height,
            padding: padding,
            domain: domain
        }, sharedProps)
    };
    var gridProps = {
        dimension: otherAxis,
        range: $5d956bbfd2f7bd8b$var$_defineProperty({}, otherAxis, (0, $0a5de8228869aa1e$exports).getRange(props, otherAxis)),
        scale: props.scale && props.scale[otherAxis] ? $5d956bbfd2f7bd8b$var$_defineProperty({}, otherAxis, props.scale[otherAxis]) : undefined
    };
    return ticks.reduce(function(childProps, tickValue, index) {
        var _scale$axis, _scale$axis2, _scale$axis3;
        var tick = stringTicks ? stringTicks[index] : tickValue;
        var text = tickFormat(tickValue, index, ticks);
        var styles = $5d956bbfd2f7bd8b$var$getEvaluatedStyles(style, (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, sharedProps, {
            tick: tick,
            tickValue: tickValue,
            index: index,
            text: text
        }));
        var tickLayout = {
            position: $5d956bbfd2f7bd8b$var$getTickPosition(styles, orientation, isVertical),
            transform: $5d956bbfd2f7bd8b$var$getTickTransform((_scale$axis = scale[axis]) === null || _scale$axis === void 0 ? void 0 : _scale$axis.call(scale, tickValue), globalTransform, isVertical)
        };
        var gridLayout = {
            edge: gridEdge,
            transform: {
                x: isVertical ? -gridOffset.x + globalTransform.x : ((_scale$axis2 = scale[axis]) === null || _scale$axis2 === void 0 ? void 0 : _scale$axis2.call(scale, tickValue)) + globalTransform.x,
                y: isVertical ? ((_scale$axis3 = scale[axis]) === null || _scale$axis3 === void 0 ? void 0 : _scale$axis3.call(scale, tickValue)) + globalTransform.y : gridOffset.y + globalTransform.y
            }
        };
        childProps[index] = {
            axis: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
                dimension: axis
            }, sharedProps, axisProps),
            axisLabel: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, sharedProps, axisLabelProps),
            ticks: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, sharedProps, $5d956bbfd2f7bd8b$var$getTickProps(tickLayout, styles.tickStyle, tickValue)),
            tickLabels: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, sharedProps, $5d956bbfd2f7bd8b$var$getTickLabelProps(tickLayout, styles.labelStyle, anchors, tickValue, text)),
            grid: (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, sharedProps, gridProps, $5d956bbfd2f7bd8b$var$getGridProps(gridLayout, styles.gridStyle, tickValue))
        };
        return childProps;
    }, initialChildProps);
};


function $9d7fdac323143f69$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9d7fdac323143f69$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9d7fdac323143f69$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9d7fdac323143f69$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9d7fdac323143f69$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9d7fdac323143f69$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9d7fdac323143f69$var$_toConsumableArray(arr) {
    return $9d7fdac323143f69$var$_arrayWithoutHoles(arr) || $9d7fdac323143f69$var$_iterableToArray(arr) || $9d7fdac323143f69$var$_unsupportedIterableToArray(arr) || $9d7fdac323143f69$var$_nonIterableSpread();
}
function $9d7fdac323143f69$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9d7fdac323143f69$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9d7fdac323143f69$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9d7fdac323143f69$var$_arrayLikeToArray(o, minLen);
}
function $9d7fdac323143f69$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $9d7fdac323143f69$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $9d7fdac323143f69$var$_arrayLikeToArray(arr);
}
function $9d7fdac323143f69$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9d7fdac323143f69$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9d7fdac323143f69$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $9d7fdac323143f69$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9d7fdac323143f69$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9d7fdac323143f69$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $9d7fdac323143f69$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $9d7fdac323143f69$var$_setPrototypeOf(subClass, superClass);
}
function $9d7fdac323143f69$var$_setPrototypeOf(o, p) {
    $9d7fdac323143f69$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9d7fdac323143f69$var$_setPrototypeOf(o, p);
}
function $9d7fdac323143f69$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $9d7fdac323143f69$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $9d7fdac323143f69$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $9d7fdac323143f69$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $9d7fdac323143f69$var$_possibleConstructorReturn(this, result);
    };
}
function $9d7fdac323143f69$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $9d7fdac323143f69$var$_assertThisInitialized(self);
}
function $9d7fdac323143f69$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $9d7fdac323143f69$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $9d7fdac323143f69$var$_getPrototypeOf(o) {
    $9d7fdac323143f69$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $9d7fdac323143f69$var$_getPrototypeOf(o);
}
var $9d7fdac323143f69$var$fallbackProps = {
    width: 450,
    height: 300,
    padding: 50
};
var $9d7fdac323143f69$var$options = {
    components: [
        {
            name: "axis",
            index: 0
        },
        {
            name: "axisLabel",
            index: 0
        },
        {
            name: "grid"
        },
        {
            name: "parent",
            index: "parent"
        },
        {
            name: "ticks"
        },
        {
            name: "tickLabels"
        }
    ]
};
var $9d7fdac323143f69$var$VictoryAxisBase = /*#__PURE__*/ function(_React$Component) {
    $9d7fdac323143f69$var$_inherits(VictoryAxisBase, _React$Component);
    var _super = $9d7fdac323143f69$var$_createSuper(VictoryAxisBase);
    function VictoryAxisBase() {
        $9d7fdac323143f69$var$_classCallCheck(this, VictoryAxisBase);
        return _super.apply(this, arguments);
    }
    $9d7fdac323143f69$var$_createClass(VictoryAxisBase, [
        {
            key: "renderLine",
            value: function renderLine(props) {
                var axisComponent = props.axisComponent;
                var axisProps = this.getComponentProps(axisComponent, "axis", 0);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(axisComponent, axisProps);
            }
        },
        {
            key: "renderLabel",
            value: function renderLabel(props) {
                var axisLabelComponent = props.axisLabelComponent, label = props.label;
                if (!label) return null;
                var axisLabelProps = this.getComponentProps(axisLabelComponent, "axisLabel", 0);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(axisLabelComponent, axisLabelProps);
            }
        },
        {
            key: "renderGridAndTicks",
            value: function renderGridAndTicks(props) {
                var _this = this;
                var tickComponent = props.tickComponent, tickLabelComponent = props.tickLabelComponent, gridComponent = props.gridComponent, name = props.name;
                var shouldRender = function(componentProps) {
                    var _componentProps$style = componentProps.style, style = _componentProps$style === void 0 ? {} : _componentProps$style, _componentProps$event = componentProps.events, events = _componentProps$event === void 0 ? {} : _componentProps$event;
                    var visible = style.stroke !== "transparent" && style.stroke !== "none" && style.strokeWidth !== 0;
                    return visible || !(0, (/*@__PURE__*/$parcel$interopDefault($1331767f05251f48$exports)))(events);
                };
                return this.dataKeys.map(function(key, index) {
                    var tickProps = _this.getComponentProps(tickComponent, "ticks", index);
                    var BaseTickComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(tickComponent, tickProps);
                    var TickComponent = shouldRender(BaseTickComponent.props) ? BaseTickComponent : undefined;
                    var gridProps = _this.getComponentProps(gridComponent, "grid", index);
                    var BaseGridComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(gridComponent, gridProps);
                    var GridComponent = shouldRender(BaseGridComponent.props) ? BaseGridComponent : undefined;
                    var tickLabelProps = _this.getComponentProps(tickLabelComponent, "tickLabels", index);
                    var TickLabel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(tickLabelComponent, tickLabelProps);
                    var children = [
                        GridComponent,
                        TickComponent,
                        TickLabel
                    ].filter(Boolean);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(props.groupComponent, {
                        key: "".concat(name, "-tick-group-").concat(key)
                    }, children);
                });
            }
        },
        {
            key: "fixLabelOverlap",
            value: function fixLabelOverlap(gridAndTicks, props) {
                var isVertical = (0, $f052c55858268509$exports).isVertical(props);
                var size = isVertical ? props.height : props.width;
                var isVictoryLabel = function(child) {
                    return child.type && child.type.role === "label";
                };
                var labels = gridAndTicks.map(function(gridAndTick) {
                    return gridAndTick.props.children;
                }).reduce(function(accumulator, childArr) {
                    return accumulator.concat(childArr);
                }, []).filter(isVictoryLabel).map(function(child) {
                    return child.props;
                });
                var paddingToObject = function(padding) {
                    return typeof padding === "object" ? (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                    }, padding) : {
                        top: padding,
                        right: padding,
                        bottom: padding,
                        left: padding
                    };
                };
                var labelsSumSize = labels.reduce(function(sum, label) {
                    var padding = paddingToObject(label.style.padding);
                    var labelSize = (0, $b3e4dc1b6aee4a20$exports).approximateTextSize(label.text, {
                        angle: label.angle,
                        fontSize: label.style.fontSize,
                        letterSpacing: label.style.letterSpacing,
                        fontFamily: label.style.fontFamily
                    });
                    return sum + (isVertical ? labelSize.height + padding.top + padding.bottom : labelSize.width + padding.right + padding.left);
                }, 0);
                var availiableLabelCount = Math.floor(size * gridAndTicks.length / labelsSumSize);
                var divider = Math.ceil(gridAndTicks.length / availiableLabelCount) || 1;
                var getLabelCoord = function(gridAndTick) {
                    return gridAndTick.props.children.filter(isVictoryLabel).reduce(function(prev, child) {
                        return (isVertical ? child.props.y : child.props.x) || 0;
                    }, 0);
                };
                var sorted = gridAndTicks.sort(function(a, b) {
                    return isVertical ? getLabelCoord(b) - getLabelCoord(a) // ordinary axis has top-bottom orientation
                     : getLabelCoord(a) - getLabelCoord(b);
                } // ordinary axis has left-right orientation
                );
                return sorted.filter(function(gridAndTick, index) {
                    return index % divider === 0;
                });
            } // Overridden in native versions
        },
        {
            key: "shouldAnimate",
            value: function shouldAnimate() {
                return !!this.props.animate;
            }
        },
        {
            key: "render",
            value: function render() {
                var animationWhitelist = $9d7fdac323143f69$export$bfb0532f7f73bea1.animationWhitelist;
                var props = (0, $f052c55858268509$exports).modifyProps(this.props, $9d7fdac323143f69$var$fallbackProps);
                var userProps = (0, $a9e703a4a20da87d$exports).getSafeUserProps(this.props);
                if (this.shouldAnimate()) return this.animateComponent(props, animationWhitelist);
                var gridAndTicks = this.renderGridAndTicks(props);
                var modifiedGridAndTicks = props.fixLabelOverlap ? this.fixLabelOverlap(gridAndTicks, props) : gridAndTicks;
                var children = [
                    this.renderLine(props),
                    this.renderLabel(props)
                ].concat($9d7fdac323143f69$var$_toConsumableArray(modifiedGridAndTicks));
                var container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(props.containerComponent, userProps);
                return props.standalone ? this.renderContainer(container, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(props.groupComponent, userProps, children);
            }
        }
    ]);
    return VictoryAxisBase;
}((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Component);
$9d7fdac323143f69$var$VictoryAxisBase.animationWhitelist = [
    "style",
    "domain",
    "range",
    "tickCount",
    "tickValues",
    "offsetX",
    "offsetY",
    "padding",
    "width",
    "height"
];
$9d7fdac323143f69$var$VictoryAxisBase.displayName = "VictoryAxis";
$9d7fdac323143f69$var$VictoryAxisBase.role = "axis";
$9d7fdac323143f69$var$VictoryAxisBase.defaultTransitions = {
    onExit: {
        duration: 500
    },
    onEnter: {
        duration: 500
    }
};
$9d7fdac323143f69$var$VictoryAxisBase.propTypes = $9d7fdac323143f69$var$_objectSpread($9d7fdac323143f69$var$_objectSpread({}, (0, $70dbe1f62d5c55ed$export$fe6a43517f1f6b90).baseProps), {}, {
    axisComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    axisLabelComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    axisValue: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    categories: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            x: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string),
            y: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string)
        })
    ]),
    crossAxis: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    dependentAxis: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    events: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        target: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            "axis",
            "axisLabel",
            "grid",
            "ticks",
            "tickLabels"
        ]),
        eventKey: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array,
            (0, $9dba2b2bbfc485d5$exports).allOfType([
                (0, $9dba2b2bbfc485d5$exports).integer,
                (0, $9dba2b2bbfc485d5$exports).nonNegative
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
        ]),
        eventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    })),
    fixLabelOverlap: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    gridComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    groupComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    invertAxis: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    offsetX: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    offsetY: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    orientation: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        "top",
        "bottom",
        "left",
        "right"
    ]),
    origin: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        x: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        y: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number
    }),
    stringMap: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        parent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        axis: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        axisLabel: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        grid: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        ticks: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        tickLabels: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    }),
    tickComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    tickCount: (0, $9dba2b2bbfc485d5$exports).allOfType([
        (0, $9dba2b2bbfc485d5$exports).integer,
        (0, $9dba2b2bbfc485d5$exports).greaterThanZero
    ]),
    tickFormat: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, $9dba2b2bbfc485d5$exports).homogeneousArray
    ]),
    tickLabelComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    tickValues: (0, $9dba2b2bbfc485d5$exports).homogeneousArray
});
$9d7fdac323143f69$var$VictoryAxisBase.defaultProps = {
    axisComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $0fd51547873f73ee$export$8b98feb4a2766c75), null),
    axisLabelComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $b8620e9b9f9774cb$export$5c9ddd0cb3c79d22), null),
    tickLabelComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $b8620e9b9f9774cb$export$5c9ddd0cb3c79d22), null),
    tickComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $0fd51547873f73ee$export$8b98feb4a2766c75), null),
    gridComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $0fd51547873f73ee$export$8b98feb4a2766c75), null),
    standalone: true,
    theme: (0, $7fc64db73a6d2950$export$2c7826f4d98fe551).grayscale,
    containerComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $1433d8d5e8c8f7e5$export$b173aa1b45712272), null),
    groupComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("g", {
        role: "presentation"
    }),
    fixLabelOverlap: false
};
$9d7fdac323143f69$var$VictoryAxisBase.getDomain = (0, $f052c55858268509$exports).getDomain;
$9d7fdac323143f69$var$VictoryAxisBase.getAxis = (0, $f052c55858268509$exports).getAxis;
$9d7fdac323143f69$var$VictoryAxisBase.getStyles = function(props) {
    return (0, $5d956bbfd2f7bd8b$export$ffd58b7f6f099a57)(props);
};
$9d7fdac323143f69$var$VictoryAxisBase.getBaseProps = function(props) {
    return (0, $5d956bbfd2f7bd8b$export$a7ec8144096537e7)(props, $9d7fdac323143f69$var$fallbackProps);
};
$9d7fdac323143f69$var$VictoryAxisBase.expectedComponents = [
    "axisComponent",
    "axisLabelComponent",
    "groupComponent",
    "containerComponent",
    "tickComponent",
    "tickLabelComponent",
    "gridComponent"
];
var $9d7fdac323143f69$export$bfb0532f7f73bea1 = (0, $93ca7d87628fcb54$export$aadfb65bee660f96)($9d7fdac323143f69$var$VictoryAxisBase, $9d7fdac323143f69$var$options);





var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");


var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");



function $a29577c877d46ffc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a29577c877d46ffc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a29577c877d46ffc$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a29577c877d46ffc$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a29577c877d46ffc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a29577c877d46ffc$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $a29577c877d46ffc$var$getArcPath = function(props) {
    var cx = props.cx, cy = props.cy, r = props.r, startAngle = props.startAngle, endAngle = props.endAngle, closedPath = props.closedPath; // Always draw the path as two arcs so that complete circles may be rendered.
    var halfAngle = Math.abs(endAngle - startAngle) / 2 + startAngle;
    var x1 = cx + r * Math.cos($0a5de8228869aa1e$export$c9fcf1a7df975d78(startAngle));
    var y1 = cy - r * Math.sin($0a5de8228869aa1e$export$c9fcf1a7df975d78(startAngle));
    var x2 = cx + r * Math.cos($0a5de8228869aa1e$export$c9fcf1a7df975d78(halfAngle));
    var y2 = cy - r * Math.sin($0a5de8228869aa1e$export$c9fcf1a7df975d78(halfAngle));
    var x3 = cx + r * Math.cos($0a5de8228869aa1e$export$c9fcf1a7df975d78(endAngle));
    var y3 = cy - r * Math.sin($0a5de8228869aa1e$export$c9fcf1a7df975d78(endAngle));
    var largerArcFlag1 = halfAngle - startAngle <= 180 ? 0 : 1;
    var largerArcFlag2 = endAngle - halfAngle <= 180 ? 0 : 1;
    var arcStart = closedPath ? " M ".concat(cx, ", ").concat(cy, " L ").concat(x1, ", ").concat(y1) : "M ".concat(x1, ", ").concat(y1);
    var arc1 = "A ".concat(r, ", ").concat(r, ", 0, ").concat(largerArcFlag1, ", 0, ").concat(x2, ", ").concat(y2);
    var arc2 = "A ".concat(r, ", ").concat(r, ", 0, ").concat(largerArcFlag2, ", 0, ").concat(x3, ", ").concat(y3);
    var arcEnd = closedPath ? "Z" : "";
    return "".concat(arcStart, " ").concat(arc1, " ").concat(arc2, " ").concat(arcEnd);
};
var $a29577c877d46ffc$var$evaluateProps = function(props) {
    /**
   * Potential evaluated props are:
   * `ariaLabel`
   * `desc`
   * `id`
   * `style`
   * `tabIndex`
   */ var ariaLabel = $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(props.ariaLabel, props);
    var desc = $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(props.desc, props);
    var id = $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(props.id, props);
    var style = $0a5de8228869aa1e$export$b94dbb3a3654958c((0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        stroke: "black",
        fill: "none"
    }, props.style), props);
    var tabIndex = $0a5de8228869aa1e$export$1e9fd61bf4a24ae1(props.tabIndex, props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, props, {
        ariaLabel: ariaLabel,
        desc: desc,
        id: id,
        style: style,
        tabIndex: tabIndex
    });
};
var $a29577c877d46ffc$export$6ef80ffb606dd232 = function(props) {
    props = $a29577c877d46ffc$var$evaluateProps(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(props.pathComponent, $a29577c877d46ffc$var$_objectSpread($a29577c877d46ffc$var$_objectSpread({}, props.events), {}, {
        "aria-label": props.ariaLabel,
        d: $a29577c877d46ffc$var$getArcPath(props),
        style: props.style,
        desc: props.desc,
        tabIndex: props.tabIndex,
        className: props.className,
        role: props.role,
        shapeRendering: props.shapeRendering,
        transform: props.transform,
        clipPath: props.clipPath
    }));
};
$a29577c877d46ffc$export$6ef80ffb606dd232.propTypes = $a29577c877d46ffc$var$_objectSpread($a29577c877d46ffc$var$_objectSpread({}, (0, $70dbe1f62d5c55ed$export$fe6a43517f1f6b90).primitiveProps), {}, {
    closedPath: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    cx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    cy: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    datum: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    endAngle: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    pathComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    r: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    startAngle: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number
});
$a29577c877d46ffc$export$6ef80ffb606dd232.defaultProps = {
    pathComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $32ee7a22ce6f8360$export$4b2950bdac9b6ee9), null),
    role: "presentation",
    shapeRendering: "auto"
};






var $10bc585ab843e523$var$getPosition = function(r, angle, axis) {
    return axis === "x" ? r * Math.cos(angle) : -r * Math.sin(angle);
};
var $10bc585ab843e523$var$getAxisType = function(props) {
    var typicalType = props.dependentAxis ? "radial" : "angular";
    var invertedType = typicalType === "angular" ? "radial" : "angular";
    return props.horizontal ? invertedType : typicalType;
};
var $10bc585ab843e523$var$filterTicks = function(ticks, scale) {
    var compareTicks = function(t) {
        return scale(t) % (2 * Math.PI);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($02a01f9a4517f244$exports)))(ticks, compareTicks);
};
var $10bc585ab843e523$var$getEvaluatedStyles = function(style, props) {
    return {
        tickStyle: (0, $0a5de8228869aa1e$exports).evaluateStyle(style.ticks, props),
        labelStyle: (0, $0a5de8228869aa1e$exports).evaluateStyle(style.tickLabels, props),
        gridStyle: (0, $0a5de8228869aa1e$exports).evaluateStyle(style.grid, props)
    };
};
var $10bc585ab843e523$var$getStyleObject = function(props) {
    var _props$theme = props.theme, theme = _props$theme === void 0 ? {} : _props$theme, dependentAxis = props.dependentAxis;
    var generalAxisStyle = theme.polarAxis && theme.polarAxis.style || theme.axis && theme.axis.style;
    var polarAxisType = dependentAxis ? "polarDependentAxis" : "polarIndependentAxis";
    var standardAxisType = dependentAxis ? "dependentAxis" : "independentAxis";
    var specificAxisStyle = theme[polarAxisType] && theme[polarAxisType].style || theme[standardAxisType] && theme[standardAxisType].style;
    var mergeStyles = function() {
        var styleNamespaces = [
            "axis",
            "axisLabel",
            "grid",
            "parent",
            "tickLabels",
            "ticks"
        ];
        return styleNamespaces.reduce(function(memo, curr) {
            memo[curr] = (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, specificAxisStyle[curr], generalAxisStyle[curr]);
            return memo;
        }, {});
    };
    return generalAxisStyle && specificAxisStyle ? mergeStyles() : specificAxisStyle || generalAxisStyle;
};
var $10bc585ab843e523$var$getRadius = function(props) {
    var _Helpers$getPadding = (0, $0a5de8228869aa1e$exports).getPadding(props), left = _Helpers$getPadding.left, right = _Helpers$getPadding.right, top = _Helpers$getPadding.top, bottom = _Helpers$getPadding.bottom;
    var width = props.width, height = props.height;
    return Math.min(width - left - right, height - top - bottom) / 2;
};
var $10bc585ab843e523$var$getRange = function(props, axis) {
    // Return the range from props if one is given.
    if (props.range && props.range[axis]) return props.range[axis];
    else if (props.range && Array.isArray(props.range)) return props.range;
    var axisType = $10bc585ab843e523$var$getAxisType(props);
    if (axisType === "angular") {
        var startAngle = (0, $0a5de8228869aa1e$exports).degreesToRadians(props.startAngle);
        var endAngle = (0, $0a5de8228869aa1e$exports).degreesToRadians(props.endAngle);
        return [
            startAngle,
            endAngle
        ];
    }
    var radius = $10bc585ab843e523$var$getRadius(props);
    return [
        props.innerRadius || 0,
        radius
    ];
}; // exposed for use by VictoryChart (necessary?)
var $10bc585ab843e523$export$5cdac61cf538712e = function(props) {
    var axis = (0, $f052c55858268509$exports).getAxis(props);
    var scale = (0, $bf1178a7a28a9ee4$exports).getBaseScale(props, axis);
    var domain = (0, $f052c55858268509$exports).getDomain(props, axis) || scale.domain();
    var range = $10bc585ab843e523$var$getRange(props, axis);
    scale.range(range);
    scale.domain(domain);
    return scale;
};
var $10bc585ab843e523$export$ffd58b7f6f099a57 = function(props, styleObject) {
    if (props.disableInlineStyles) return {};
    var style = props.style || {};
    styleObject = styleObject || {};
    var parentStyleProps = {
        height: "auto",
        width: "100%"
    };
    return {
        parent: (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))(parentStyleProps, style.parent, styleObject.parent),
        axis: (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, style.axis, styleObject.axis),
        axisLabel: (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, style.axisLabel, styleObject.axisLabel),
        grid: (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, style.grid, styleObject.grid),
        ticks: (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, style.ticks, styleObject.ticks),
        tickLabels: (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, style.tickLabels, styleObject.tickLabels)
    };
};
var $10bc585ab843e523$var$getAxisAngle = function(props) {
    var axisAngle = props.axisAngle, startAngle = props.startAngle, dependentAxis = props.dependentAxis;
    var axis = (0, $f052c55858268509$exports).getAxis(props);
    var axisValue = (0, $f052c55858268509$exports).getAxisValue(props, axis);
    if (axisValue === undefined || !dependentAxis) return axisAngle === undefined ? startAngle : axisAngle;
    return (0, $0a5de8228869aa1e$exports).radiansToDegrees(axisValue);
}; // eslint-disable-next-line max-params
var $10bc585ab843e523$var$getTickProps = function(props, calculatedValues, tickValue, index) {
    var axisType = calculatedValues.axisType, radius = calculatedValues.radius, scale = calculatedValues.scale, style = calculatedValues.style, stringTicks = calculatedValues.stringTicks, ticks = calculatedValues.ticks, tickFormat = calculatedValues.tickFormat, origin = calculatedValues.origin;
    var text = tickFormat(tickValue, index, ticks);
    var tick = stringTicks ? stringTicks[index] : tickValue;
    var _getEvaluatedStyles = $10bc585ab843e523$var$getEvaluatedStyles(style, {
        tick: tick,
        tickValue: tickValue,
        index: index,
        ticks: ticks,
        stringTicks: stringTicks,
        radius: radius,
        scale: scale,
        axisType: axisType,
        text: text
    }), tickStyle = _getEvaluatedStyles.tickStyle;
    var axisAngle = axisType === "radial" ? $10bc585ab843e523$var$getAxisAngle(props, scale) : undefined;
    var tickPadding = tickStyle.padding || tickStyle.size || 0;
    var padAngle = (0, $0a5de8228869aa1e$exports).degreesToRadians(90 - axisAngle);
    var tickAngle = axisType === "angular" ? scale(tickValue) : (0, $0a5de8228869aa1e$exports).degreesToRadians(-1 * axisAngle);
    var tickRadius = axisType === "angular" ? radius : scale(tickValue);
    return axisType === "angular" ? {
        index: index,
        datum: tick,
        style: tickStyle,
        x1: $10bc585ab843e523$var$getPosition(tickRadius, tickAngle, "x") + origin.x,
        y1: $10bc585ab843e523$var$getPosition(tickRadius, tickAngle, "y") + origin.y,
        x2: $10bc585ab843e523$var$getPosition(tickRadius + tickPadding, tickAngle, "x") + origin.x,
        y2: $10bc585ab843e523$var$getPosition(tickRadius + tickPadding, tickAngle, "y") + origin.y
    } : {
        index: index,
        datum: tick,
        style: tickStyle,
        x1: tickRadius * Math.cos(tickAngle) + Math.cos(padAngle) * tickPadding + origin.x,
        x2: tickRadius * Math.cos(tickAngle) - Math.cos(padAngle) * tickPadding + origin.x,
        y1: tickRadius * Math.sin(tickAngle) + Math.sin(padAngle) * tickPadding + origin.y,
        y2: tickRadius * Math.sin(tickAngle) - Math.sin(padAngle) * tickPadding + origin.y
    };
}; // eslint-disable-next-line max-params
var $10bc585ab843e523$var$getTickLabelProps = function(props, calculatedValues, tickValue, index) {
    var axisType = calculatedValues.axisType, radius = calculatedValues.radius, tickFormat = calculatedValues.tickFormat, style = calculatedValues.style, scale = calculatedValues.scale, ticks = calculatedValues.ticks, stringTicks = calculatedValues.stringTicks, origin = calculatedValues.origin;
    var text = tickFormat(tickValue, index, ticks);
    var tick = stringTicks ? stringTicks[index] : tickValue;
    var _getEvaluatedStyles2 = $10bc585ab843e523$var$getEvaluatedStyles(style, {
        text: text,
        tick: tick,
        tickValue: tickValue,
        index: index,
        ticks: ticks,
        stringTicks: stringTicks,
        radius: radius,
        scale: scale,
        axisType: axisType
    }), labelStyle = _getEvaluatedStyles2.labelStyle;
    var tickLabelComponent = props.tickLabelComponent;
    var labelPlacement = tickLabelComponent.props && tickLabelComponent.props.labelPlacement ? tickLabelComponent.props.labelPlacement : props.labelPlacement;
    var tickPadding = labelStyle.padding || 0;
    var angularPadding = 0; // TODO: do some geometry
    var axisAngle = axisType === "radial" ? $10bc585ab843e523$var$getAxisAngle(props, scale) : undefined;
    var labelAngle = axisType === "angular" ? (0, $0a5de8228869aa1e$exports).radiansToDegrees(scale(tickValue)) : axisAngle + angularPadding;
    var textAngle = labelStyle.angle === undefined ? (0, $e6236e426b53ba14$exports).getPolarAngle((0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, props, {
        labelPlacement: labelPlacement
    }), labelAngle) : labelStyle.angle;
    var labelRadius = axisType === "angular" ? radius + tickPadding : scale(tickValue);
    var textAnchor = labelStyle.textAnchor || (0, $e6236e426b53ba14$exports).getPolarTextAnchor((0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, props, {
        labelPlacement: labelPlacement
    }), labelAngle);
    return {
        index: index,
        datum: tick,
        style: labelStyle,
        angle: textAngle,
        textAnchor: textAnchor,
        text: text,
        x: labelRadius * Math.cos((0, $0a5de8228869aa1e$exports).degreesToRadians(labelAngle)) + origin.x,
        y: -labelRadius * Math.sin((0, $0a5de8228869aa1e$exports).degreesToRadians(labelAngle)) + origin.y
    };
}; // eslint-disable-next-line max-params
var $10bc585ab843e523$var$getGridProps = function(props, calculatedValues, tickValue, index) {
    var axisType = calculatedValues.axisType, radius = calculatedValues.radius, style = calculatedValues.style, scale = calculatedValues.scale, stringTicks = calculatedValues.stringTicks, ticks = calculatedValues.ticks, tickFormat = calculatedValues.tickFormat, origin = calculatedValues.origin;
    var text = tickFormat(tickValue, index, ticks);
    var startAngle = props.startAngle, endAngle = props.endAngle, _props$innerRadius = props.innerRadius, innerRadius = _props$innerRadius === void 0 ? 0 : _props$innerRadius;
    var tick = stringTicks ? stringTicks[index] : tickValue;
    var _getEvaluatedStyles3 = $10bc585ab843e523$var$getEvaluatedStyles(style, {
        tick: tick,
        tickValue: tickValue,
        index: index,
        ticks: ticks,
        stringTicks: stringTicks,
        radius: radius,
        scale: scale,
        axisType: axisType,
        text: text
    }), gridStyle = _getEvaluatedStyles3.gridStyle;
    var angle = scale(tickValue);
    return axisType === "angular" ? {
        index: index,
        datum: tick,
        style: gridStyle,
        x1: $10bc585ab843e523$var$getPosition(radius, angle, "x") + origin.x,
        y1: $10bc585ab843e523$var$getPosition(radius, angle, "y") + origin.y,
        x2: $10bc585ab843e523$var$getPosition(innerRadius, angle, "x") + origin.x,
        y2: $10bc585ab843e523$var$getPosition(innerRadius, angle, "y") + origin.y
    } : {
        style: gridStyle,
        index: index,
        datum: tick,
        cx: origin.x,
        cy: origin.y,
        r: scale(tickValue),
        startAngle: startAngle,
        endAngle: endAngle
    };
};
var $10bc585ab843e523$var$getAxisLabelProps = function(props, calculatedValues) {
    var axisType = calculatedValues.axisType, radius = calculatedValues.radius, style = calculatedValues.style, scale = calculatedValues.scale, origin = calculatedValues.origin;
    var axisLabelComponent = props.axisLabelComponent;
    if (axisType !== "radial") return {};
    var labelPlacement = axisLabelComponent.props && axisLabelComponent.props.labelPlacement ? axisLabelComponent.props.labelPlacement : props.labelPlacement;
    var labelStyle = style && style.axisLabel || {};
    var axisAngle = axisType === "radial" ? $10bc585ab843e523$var$getAxisAngle(props, scale) : undefined;
    var textAngle = labelStyle.angle === undefined ? (0, $e6236e426b53ba14$exports).getPolarAngle((0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, props, {
        labelPlacement: labelPlacement
    }), axisAngle) : labelStyle.angle;
    var labelRadius = radius + (labelStyle.padding || 0);
    var textAnchor = labelStyle.textAnchor || (0, $e6236e426b53ba14$exports).getPolarTextAnchor((0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, props, {
        labelPlacement: labelPlacement
    }), axisAngle);
    var verticalAnchor = labelStyle.verticalAnchor || (0, $e6236e426b53ba14$exports).getPolarVerticalAnchor((0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, props, {
        labelPlacement: labelPlacement
    }), axisAngle);
    return {
        style: labelStyle,
        angle: textAngle,
        textAnchor: textAnchor,
        verticalAnchor: verticalAnchor,
        text: props.label,
        x: $10bc585ab843e523$var$getPosition(labelRadius, (0, $0a5de8228869aa1e$exports).degreesToRadians(axisAngle), "x") + origin.x,
        y: $10bc585ab843e523$var$getPosition(labelRadius, (0, $0a5de8228869aa1e$exports).degreesToRadians(axisAngle), "y") + origin.y
    };
};
var $10bc585ab843e523$var$getAxisProps = function(modifiedProps, calculatedValues) {
    var style = calculatedValues.style, axisType = calculatedValues.axisType, radius = calculatedValues.radius, scale = calculatedValues.scale, origin = calculatedValues.origin;
    var startAngle = modifiedProps.startAngle, endAngle = modifiedProps.endAngle, _modifiedProps$innerR = modifiedProps.innerRadius, innerRadius = _modifiedProps$innerR === void 0 ? 0 : _modifiedProps$innerR;
    var axisAngle = axisType === "radial" ? (0, $0a5de8228869aa1e$exports).degreesToRadians($10bc585ab843e523$var$getAxisAngle(modifiedProps, scale)) : undefined;
    return axisType === "radial" ? {
        style: style.axis,
        x1: $10bc585ab843e523$var$getPosition(innerRadius, axisAngle, "x") + origin.x,
        x2: $10bc585ab843e523$var$getPosition(radius, axisAngle, "x") + origin.x,
        y1: $10bc585ab843e523$var$getPosition(innerRadius, axisAngle, "y") + origin.y,
        y2: $10bc585ab843e523$var$getPosition(radius, axisAngle, "y") + origin.y
    } : {
        style: style.axis,
        cx: origin.x,
        cy: origin.y,
        r: radius,
        startAngle: startAngle,
        endAngle: endAngle
    };
};
var $10bc585ab843e523$var$getCalculatedValues = function(props) {
    props = (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
        polar: true
    }, props);
    var defaultStyles = $10bc585ab843e523$var$getStyleObject(props);
    var style = $10bc585ab843e523$export$ffd58b7f6f099a57(props, defaultStyles);
    var padding = (0, $0a5de8228869aa1e$exports).getPadding(props);
    var axis = (0, $f052c55858268509$exports).getAxis(props);
    var axisType = $10bc585ab843e523$var$getAxisType(props);
    var stringTicks = (0, $f052c55858268509$exports).stringTicks(props) ? props.tickValues : undefined;
    var domain = (0, $f052c55858268509$exports).getDomain(props, axis);
    var range = $10bc585ab843e523$var$getRange(props, axis);
    var scale = $10bc585ab843e523$export$5cdac61cf538712e(props);
    var initialTicks = (0, $f052c55858268509$exports).getTicks(props, scale);
    var ticks = axisType === "angular" ? $10bc585ab843e523$var$filterTicks(initialTicks, scale) : initialTicks;
    var tickFormat = (0, $f052c55858268509$exports).getTickFormat(props, scale);
    var radius = $10bc585ab843e523$var$getRadius(props);
    var origin = (0, $0a5de8228869aa1e$exports).getPolarOrigin(props);
    return {
        axis: axis,
        style: style,
        padding: padding,
        stringTicks: stringTicks,
        axisType: axisType,
        scale: scale,
        ticks: ticks,
        tickFormat: tickFormat,
        domain: domain,
        range: range,
        radius: radius,
        origin: origin
    };
};
var $10bc585ab843e523$export$a7ec8144096537e7 = function(props, fallbackProps) {
    props = (0, $f052c55858268509$exports).modifyProps(props, fallbackProps);
    var calculatedValues = $10bc585ab843e523$var$getCalculatedValues(props);
    var style = calculatedValues.style, scale = calculatedValues.scale, ticks = calculatedValues.ticks, domain = calculatedValues.domain;
    var _props = props, width = _props.width, height = _props.height, standalone = _props.standalone, theme = _props.theme, name = _props.name;
    var axisProps = $10bc585ab843e523$var$getAxisProps(props, calculatedValues);
    var axisLabelProps = $10bc585ab843e523$var$getAxisLabelProps(props, calculatedValues);
    var initialChildProps = {
        parent: {
            style: style.parent,
            ticks: ticks,
            scale: scale,
            width: width,
            height: height,
            domain: domain,
            standalone: standalone,
            theme: theme,
            name: name
        }
    };
    return ticks.reduce(function(childProps, tick, index) {
        childProps[index] = {
            axis: axisProps,
            axisLabel: axisLabelProps,
            ticks: $10bc585ab843e523$var$getTickProps(props, calculatedValues, tick, index),
            tickLabels: $10bc585ab843e523$var$getTickLabelProps(props, calculatedValues, tick, index),
            grid: $10bc585ab843e523$var$getGridProps(props, calculatedValues, tick, index)
        };
        return childProps;
    }, initialChildProps);
};


function $1362317551388a3f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1362317551388a3f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1362317551388a3f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1362317551388a3f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1362317551388a3f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1362317551388a3f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1362317551388a3f$var$_toConsumableArray(arr) {
    return $1362317551388a3f$var$_arrayWithoutHoles(arr) || $1362317551388a3f$var$_iterableToArray(arr) || $1362317551388a3f$var$_unsupportedIterableToArray(arr) || $1362317551388a3f$var$_nonIterableSpread();
}
function $1362317551388a3f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1362317551388a3f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1362317551388a3f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1362317551388a3f$var$_arrayLikeToArray(o, minLen);
}
function $1362317551388a3f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $1362317551388a3f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1362317551388a3f$var$_arrayLikeToArray(arr);
}
function $1362317551388a3f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1362317551388a3f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1362317551388a3f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1362317551388a3f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1362317551388a3f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1362317551388a3f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $1362317551388a3f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $1362317551388a3f$var$_setPrototypeOf(subClass, superClass);
}
function $1362317551388a3f$var$_setPrototypeOf(o, p) {
    $1362317551388a3f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1362317551388a3f$var$_setPrototypeOf(o, p);
}
function $1362317551388a3f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1362317551388a3f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $1362317551388a3f$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $1362317551388a3f$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $1362317551388a3f$var$_possibleConstructorReturn(this, result);
    };
}
function $1362317551388a3f$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $1362317551388a3f$var$_assertThisInitialized(self);
}
function $1362317551388a3f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1362317551388a3f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $1362317551388a3f$var$_getPrototypeOf(o) {
    $1362317551388a3f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1362317551388a3f$var$_getPrototypeOf(o);
}
var $1362317551388a3f$var$fallbackProps = {
    width: 450,
    height: 300,
    padding: 50
};
var $1362317551388a3f$var$options = {
    components: [
        {
            name: "axis",
            index: 0
        },
        {
            name: "axisLabel",
            index: 0
        },
        {
            name: "grid"
        },
        {
            name: "parent",
            index: "parent"
        },
        {
            name: "ticks"
        },
        {
            name: "tickLabels"
        }
    ]
};
var $1362317551388a3f$var$VictoryPolarAxis = /*#__PURE__*/ function(_React$Component) {
    $1362317551388a3f$var$_inherits(VictoryPolarAxis, _React$Component);
    var _super = $1362317551388a3f$var$_createSuper(VictoryPolarAxis);
    function VictoryPolarAxis() {
        $1362317551388a3f$var$_classCallCheck(this, VictoryPolarAxis);
        return _super.apply(this, arguments);
    }
    $1362317551388a3f$var$_createClass(VictoryPolarAxis, [
        {
            key: "renderAxisLine",
            value: function renderAxisLine(props) {
                var dependentAxis = props.dependentAxis;
                var axisComponent = dependentAxis ? props.axisComponent : props.circularAxisComponent;
                var axisProps = this.getComponentProps(axisComponent, "axis", 0);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(axisComponent, axisProps);
            }
        },
        {
            key: "renderLabel",
            value: function renderLabel(props) {
                var axisLabelComponent = props.axisLabelComponent, dependentAxis = props.dependentAxis, label = props.label;
                if (!label || !dependentAxis) return null;
                var axisLabelProps = this.getComponentProps(axisLabelComponent, "axisLabel", 0);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(axisLabelComponent, axisLabelProps);
            }
        },
        {
            key: "renderAxis",
            value: function renderAxis(props) {
                var _this = this;
                var tickComponent = props.tickComponent, tickLabelComponent = props.tickLabelComponent, name = props.name;
                var shouldRender = function(componentProps) {
                    var _componentProps$style = componentProps.style, style = _componentProps$style === void 0 ? {} : _componentProps$style, _componentProps$event = componentProps.events, events = _componentProps$event === void 0 ? {} : _componentProps$event;
                    var visible = style.stroke !== "transparent" && style.stroke !== "none" && style.strokeWidth !== 0;
                    return visible || !(0, (/*@__PURE__*/$parcel$interopDefault($1331767f05251f48$exports)))(events);
                };
                var axisType = props.dependentAxis ? "radial" : "angular";
                var gridComponent = axisType === "radial" ? props.circularGridComponent : props.gridComponent;
                var tickComponents = this.dataKeys.map(function(key, index) {
                    var tickProps = (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
                        key: "".concat(name, "-tick-").concat(key)
                    }, _this.getComponentProps(tickComponent, "ticks", index));
                    var TickComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(tickComponent, tickProps);
                    return shouldRender(TickComponent.props) ? TickComponent : undefined;
                }).filter(Boolean);
                var gridComponents = this.dataKeys.map(function(key, index) {
                    var gridProps = (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
                        key: "".concat(name, "-grid-").concat(key)
                    }, _this.getComponentProps(gridComponent, "grid", index));
                    var GridComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(gridComponent, gridProps);
                    return shouldRender(GridComponent.props) ? GridComponent : undefined;
                }).filter(Boolean);
                var tickLabelComponents = this.dataKeys.map(function(key, index) {
                    var tickLabelProps = (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
                        key: "".concat(name, "-tick-").concat(key)
                    }, _this.getComponentProps(tickLabelComponent, "tickLabels", index));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(tickLabelComponent, tickLabelProps);
                });
                var axis = this.renderAxisLine(props);
                var axisLabel = this.renderLabel(props);
                var children = [
                    axis,
                    axisLabel
                ].concat($1362317551388a3f$var$_toConsumableArray(tickComponents), $1362317551388a3f$var$_toConsumableArray(gridComponents), $1362317551388a3f$var$_toConsumableArray(tickLabelComponents));
                return this.renderGroup(props, children);
            } // Overridden in victory-native
        },
        {
            key: "renderGroup",
            value: function renderGroup(props, children) {
                var groupComponent = props.groupComponent;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(groupComponent, {}, children);
            }
        },
        {
            key: "shouldAnimate",
            value: function shouldAnimate() {
                return !!this.props.animate;
            }
        },
        {
            key: "render",
            value: function render() {
                var animationWhitelist = VictoryPolarAxis.animationWhitelist;
                var props = (0, $f052c55858268509$exports).modifyProps(this.props, $1362317551388a3f$var$fallbackProps);
                if (this.shouldAnimate()) return this.animateComponent(props, animationWhitelist);
                var children = this.renderAxis(props);
                return props.standalone ? this.renderContainer(props.containerComponent, children) : children;
            }
        }
    ]);
    return VictoryPolarAxis;
}((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Component);
$1362317551388a3f$var$VictoryPolarAxis.animationWhitelist = [
    "style",
    "domain",
    "range",
    "tickCount",
    "tickValues",
    "padding",
    "width",
    "height"
];
$1362317551388a3f$var$VictoryPolarAxis.displayName = "VictoryAxis";
$1362317551388a3f$var$VictoryPolarAxis.role = "axis";
$1362317551388a3f$var$VictoryPolarAxis.defaultTransitions = {
    onExit: {
        duration: 500
    },
    onEnter: {
        duration: 500
    }
};
$1362317551388a3f$var$VictoryPolarAxis.propTypes = $1362317551388a3f$var$_objectSpread($1362317551388a3f$var$_objectSpread({}, (0, $70dbe1f62d5c55ed$export$fe6a43517f1f6b90).baseProps), {}, {
    axisAngle: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    axisComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    axisLabelComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    axisValue: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    categories: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            x: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string),
            y: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string)
        })
    ]),
    circularAxisComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    circularGridComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    containerComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    dependentAxis: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    disableInlineStyles: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    endAngle: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    events: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        target: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            "axis",
            "axisLabel",
            "grid",
            "ticks",
            "tickLabels"
        ]),
        eventKey: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array,
            (0, $9dba2b2bbfc485d5$exports).allOfType([
                (0, $9dba2b2bbfc485d5$exports).integer,
                (0, $9dba2b2bbfc485d5$exports).nonNegative
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
        ]),
        eventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    })),
    gridComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    innerRadius: (0, $9dba2b2bbfc485d5$exports).nonNegative,
    labelPlacement: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        "parallel",
        "perpendicular",
        "vertical"
    ]),
    startAngle: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    stringMap: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        parent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        axis: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        axisLabel: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        grid: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        ticks: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        tickLabels: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    }),
    tickComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    tickCount: (0, $9dba2b2bbfc485d5$exports).allOfType([
        (0, $9dba2b2bbfc485d5$exports).integer,
        (0, $9dba2b2bbfc485d5$exports).greaterThanZero
    ]),
    tickFormat: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, $9dba2b2bbfc485d5$exports).homogeneousArray
    ]),
    tickLabelComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    tickValues: (0, $9dba2b2bbfc485d5$exports).homogeneousArray
});
$1362317551388a3f$var$VictoryPolarAxis.defaultProps = {
    axisComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $0fd51547873f73ee$export$8b98feb4a2766c75), null),
    axisLabelComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $b8620e9b9f9774cb$export$5c9ddd0cb3c79d22), null),
    circularAxisComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $a29577c877d46ffc$export$6ef80ffb606dd232), null),
    circularGridComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $a29577c877d46ffc$export$6ef80ffb606dd232), null),
    containerComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $1433d8d5e8c8f7e5$export$b173aa1b45712272), null),
    endAngle: 360,
    gridComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $0fd51547873f73ee$export$8b98feb4a2766c75), null),
    groupComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("g", {
        role: "presentation"
    }),
    labelPlacement: "parallel",
    startAngle: 0,
    standalone: true,
    theme: (0, $7fc64db73a6d2950$export$2c7826f4d98fe551).grayscale,
    tickComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $0fd51547873f73ee$export$8b98feb4a2766c75), null),
    tickLabelComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $b8620e9b9f9774cb$export$5c9ddd0cb3c79d22), null)
};
$1362317551388a3f$var$VictoryPolarAxis.getDomain = (0, $f052c55858268509$exports).getDomain;
$1362317551388a3f$var$VictoryPolarAxis.getAxis = (0, $f052c55858268509$exports).getAxis;
$1362317551388a3f$var$VictoryPolarAxis.getScale = (0, $10bc585ab843e523$export$5cdac61cf538712e);
$1362317551388a3f$var$VictoryPolarAxis.getStyles = function(props) {
    return (0, $10bc585ab843e523$export$ffd58b7f6f099a57)(props, $1362317551388a3f$var$fallbackProps.style);
};
$1362317551388a3f$var$VictoryPolarAxis.getBaseProps = function(props) {
    return (0, $10bc585ab843e523$export$a7ec8144096537e7)(props, $1362317551388a3f$var$fallbackProps);
};
$1362317551388a3f$var$VictoryPolarAxis.expectedComponents = [
    "axisComponent",
    "circularAxisComponent",
    "groupComponent",
    "containerComponent",
    "tickComponent",
    "tickLabelComponent",
    "gridComponent",
    "circularGridComponent"
];
var $1362317551388a3f$export$2e2bcd8739ae039 = (0, $93ca7d87628fcb54$export$aadfb65bee660f96)($1362317551388a3f$var$VictoryPolarAxis, $1362317551388a3f$var$options);





var $8T3gX = parcelRequire("8T3gX");

function $86a9cbadb4f45f58$var$_toConsumableArray(arr) {
    return $86a9cbadb4f45f58$var$_arrayWithoutHoles(arr) || $86a9cbadb4f45f58$var$_iterableToArray(arr) || $86a9cbadb4f45f58$var$_unsupportedIterableToArray(arr) || $86a9cbadb4f45f58$var$_nonIterableSpread();
}
function $86a9cbadb4f45f58$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $86a9cbadb4f45f58$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $86a9cbadb4f45f58$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $86a9cbadb4f45f58$var$_arrayLikeToArray(o, minLen);
}
function $86a9cbadb4f45f58$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $86a9cbadb4f45f58$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $86a9cbadb4f45f58$var$_arrayLikeToArray(arr);
}
function $86a9cbadb4f45f58$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $86a9cbadb4f45f58$var$fallbackProps = {
    width: 450,
    height: 300,
    padding: 50
};
function $86a9cbadb4f45f58$var$getAxisProps(child, props, calculatedProps) {
    var domain = calculatedProps.domain, scale = calculatedProps.scale, stringMap = calculatedProps.stringMap, categories = calculatedProps.categories, horizontal = calculatedProps.horizontal;
    return {
        stringMap: stringMap,
        horizontal: horizontal,
        categories: categories,
        startAngle: props.startAngle,
        endAngle: props.endAngle,
        innerRadius: props.innerRadius,
        domain: domain,
        scale: scale
    };
}
function $86a9cbadb4f45f58$export$346acb397113a116(props, calculatedProps) {
    var backgroundElement = props.backgroundComponent;
    var height = props.polar ? calculatedProps.range.y[1] : calculatedProps.range.y[0] - calculatedProps.range.y[1];
    var width = calculatedProps.range.x[1] - calculatedProps.range.x[0];
    var xScale = props.horizontal ? calculatedProps.scale.y.range()[0] : calculatedProps.scale.x.range()[0];
    var yScale = props.horizontal ? calculatedProps.scale.x.range()[1] : calculatedProps.scale.y.range()[1];
    var xCoordinate = props.polar ? calculatedProps.origin.x : xScale;
    var yCoordinate = props.polar ? calculatedProps.origin.y : yScale;
    var parentName = props.name || "chart";
    var backgroundProps = {
        height: height,
        polar: props.polar,
        scale: calculatedProps.scale,
        style: props.style.background,
        x: xCoordinate,
        y: yCoordinate,
        key: "".concat(parentName, "-background"),
        width: width
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(backgroundElement, (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, backgroundElement.props, backgroundProps));
}
function $86a9cbadb4f45f58$var$getChildProps(child, props, calculatedProps) {
    var axisChild = (0, $f052c55858268509$exports).findAxisComponents([
        child
    ]);
    if (axisChild.length > 0) return $86a9cbadb4f45f58$var$getAxisProps(axisChild[0], props, calculatedProps);
    var categories = calculatedProps.categories, domain = calculatedProps.domain, range = calculatedProps.range, scale = calculatedProps.scale, stringMap = calculatedProps.stringMap, horizontal = calculatedProps.horizontal;
    return {
        categories: categories,
        domain: domain,
        range: range,
        scale: scale,
        stringMap: stringMap,
        horizontal: horizontal
    };
}
function $86a9cbadb4f45f58$var$getStyles(props) {
    var styleProps = props.style && props.style.parent;
    return {
        parent: (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, styleProps, {
            height: "100%",
            width: "100%",
            userSelect: "none"
        })
    };
}
function $86a9cbadb4f45f58$export$25e30bf3739198c8(props, childComponents) {
    var style = $86a9cbadb4f45f58$var$getStyles(props);
    props = (0, $0a5de8228869aa1e$exports).modifyProps(props, $86a9cbadb4f45f58$var$fallbackProps, "chart");
    var _props = props, horizontal = _props.horizontal, polar = _props.polar;
    var allStrings = (0, $8c0cae78a8f93a11$exports).getStringsFromChildren(props, childComponents);
    var categories = (0, $8c0cae78a8f93a11$exports).getCategories(props, childComponents, allStrings);
    var stringMap = $86a9cbadb4f45f58$var$createStringMap(props, childComponents, allStrings);
    var domain = {
        x: $86a9cbadb4f45f58$var$getDomain((0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, props, {
            categories: categories
        }), "x", childComponents),
        y: $86a9cbadb4f45f58$var$getDomain((0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({}, props, {
            categories: categories
        }), "y", childComponents)
    };
    var range = {
        x: (0, $0a5de8228869aa1e$exports).getRange(props, "x"),
        y: (0, $0a5de8228869aa1e$exports).getRange(props, "y")
    };
    var baseScale = {
        x: (0, $bf1178a7a28a9ee4$exports).getScaleFromProps(props, "x") || (0, $8c0cae78a8f93a11$exports).getScale(props, "x"),
        y: (0, $bf1178a7a28a9ee4$exports).getScaleFromProps(props, "y") || (0, $8c0cae78a8f93a11$exports).getScale(props, "y")
    };
    var scale = {
        x: baseScale.x.domain(domain.x).range(horizontal ? range.y : range.x),
        y: baseScale.y.domain(domain.y).range(horizontal ? range.x : range.y)
    };
    var origin = polar ? (0, $0a5de8228869aa1e$exports).getPolarOrigin(props) : (0, $f052c55858268509$exports).getOrigin(domain);
    var padding = (0, $0a5de8228869aa1e$exports).getPadding(props);
    return {
        categories: categories,
        domain: domain,
        range: range,
        horizontal: horizontal,
        scale: scale,
        stringMap: stringMap,
        style: style,
        origin: origin,
        padding: padding
    };
}
function $86a9cbadb4f45f58$export$f8cf48ee793b41be(props, childComponents, calculatedProps) {
    childComponents = childComponents || $86a9cbadb4f45f58$export$ee57d186db3cb364(props);
    calculatedProps = calculatedProps || $86a9cbadb4f45f58$export$25e30bf3739198c8(props, childComponents);
    var baseStyle = calculatedProps.style.parent;
    var height = props.height, polar = props.polar, theme = props.theme, width = props.width;
    var _calculatedProps = calculatedProps, origin = _calculatedProps.origin, horizontal = _calculatedProps.horizontal;
    var parentName = props.name || "chart";
    return childComponents.map(function(child, index) {
        var role = child.type && child.type.role;
        var style = Array.isArray(child.props.style) ? child.props.style : (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, child.props.style, {
            parent: baseStyle
        });
        var childProps = $86a9cbadb4f45f58$var$getChildProps(child, props, calculatedProps);
        var name = child.props.name || "".concat(parentName, "-").concat(role, "-").concat(index);
        var newProps = (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({
            horizontal: horizontal,
            height: height,
            polar: polar,
            theme: theme,
            width: width,
            style: style,
            name: name,
            origin: polar ? origin : undefined,
            padding: calculatedProps.padding,
            key: "".concat(name, "-key-").concat(index),
            standalone: false
        }, childProps);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(child, newProps);
    });
}
var $86a9cbadb4f45f58$export$ee57d186db3cb364 = function(props, defaultAxes) {
    var childComponents = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(props.children);
    var newChildComponents = $86a9cbadb4f45f58$var$_toConsumableArray(childComponents);
    if (childComponents.length === 0) newChildComponents.push(defaultAxes.independent, defaultAxes.dependent);
    else {
        var axisComponents = {
            dependent: (0, $f052c55858268509$exports).getAxisComponentsWithParent(childComponents, "dependent"),
            independent: (0, $f052c55858268509$exports).getAxisComponentsWithParent(childComponents, "independent")
        };
        if (axisComponents.dependent.length === 0 && axisComponents.independent.length === 0) newChildComponents = props.prependDefaultAxes ? [
            defaultAxes.independent,
            defaultAxes.dependent
        ].concat(newChildComponents) : newChildComponents.concat([
            defaultAxes.independent,
            defaultAxes.dependent
        ]);
    }
    return newChildComponents;
};
var $86a9cbadb4f45f58$var$getDomain = function(props, axis, childComponents) {
    childComponents = childComponents || (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(props.children);
    var domain = (0, $8c0cae78a8f93a11$exports).getDomain(props, axis, childComponents);
    var axisComponent = (0, $f052c55858268509$exports).getAxisComponent(childComponents, axis);
    var invertDomain = axisComponent && axisComponent.props && axisComponent.props.invertAxis;
    return invertDomain ? domain.concat().reverse() : domain;
};
var $86a9cbadb4f45f58$var$createStringMap = function(props, childComponents, allStrings) {
    var x = !allStrings.x || allStrings.x.length === 0 ? null : allStrings.x.reduce(function(memo, string, index) {
        memo[string] = index + 1;
        return memo;
    }, {});
    var y = !allStrings.y || allStrings.y.length === 0 ? null : allStrings.y.reduce(function(memo, string, index) {
        memo[string] = index + 1;
        return memo;
    }, {});
    return {
        x: x,
        y: y
    };
};



function $33c1fffcca3bd289$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $33c1fffcca3bd289$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $33c1fffcca3bd289$var$ownKeys(Object(source), !0).forEach(function(key) {
            $33c1fffcca3bd289$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $33c1fffcca3bd289$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $33c1fffcca3bd289$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $33c1fffcca3bd289$var$fallbackProps = {
    width: 450,
    height: 300,
    padding: 50
};
var $33c1fffcca3bd289$var$VictoryChartImpl = function(initialProps) {
    var role = "chart";
    var _Hooks$useAnimationSt = (0, $f6442d40b5d79512$exports).useAnimationState(), getAnimationProps = _Hooks$useAnimationSt.getAnimationProps, setAnimationState = _Hooks$useAnimationSt.setAnimationState, getProps = _Hooks$useAnimationSt.getProps;
    var props = getProps(initialProps);
    var modifiedProps = (0, $0a5de8228869aa1e$exports).modifyProps(props, $33c1fffcca3bd289$var$fallbackProps, role);
    var desc = modifiedProps.desc, eventKey = modifiedProps.eventKey, containerComponent = modifiedProps.containerComponent, standalone = modifiedProps.standalone, groupComponent = modifiedProps.groupComponent, externalEventMutations = modifiedProps.externalEventMutations, width = modifiedProps.width, height = modifiedProps.height, theme = modifiedProps.theme, polar = modifiedProps.polar, name = modifiedProps.name, title = modifiedProps.title;
    var axes = props.polar ? modifiedProps.defaultPolarAxes : modifiedProps.defaultAxes;
    var childComponents = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(function() {
        return (0, $86a9cbadb4f45f58$export$ee57d186db3cb364)(modifiedProps, axes);
    }, [
        modifiedProps,
        axes
    ]);
    var calculatedProps = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(function() {
        return (0, $86a9cbadb4f45f58$export$25e30bf3739198c8)(modifiedProps, childComponents);
    }, [
        modifiedProps,
        childComponents
    ]);
    var domain = calculatedProps.domain, scale = calculatedProps.scale, style = calculatedProps.style, origin = calculatedProps.origin, horizontal = calculatedProps.horizontal;
    var newChildren = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(function() {
        var children = (0, $86a9cbadb4f45f58$export$f8cf48ee793b41be)(props, childComponents, calculatedProps);
        var mappedChildren = children.map(function(child, index) {
            var childProps = (0, (/*@__PURE__*/$parcel$interopDefault($1ee3d57e58d770bc$exports)))({
                animate: getAnimationProps(props, child, index)
            }, child.props);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(child, childProps);
        });
        if (props.style && props.style.background) {
            var backgroundComponent = (0, $86a9cbadb4f45f58$export$346acb397113a116)(props, calculatedProps);
            mappedChildren.unshift(backgroundComponent);
        }
        return mappedChildren;
    }, [
        getAnimationProps,
        childComponents,
        props,
        calculatedProps
    ]);
    var containerProps = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(function() {
        if (standalone) return {
            desc: desc,
            domain: domain,
            width: width,
            height: height,
            horizontal: horizontal,
            name: name,
            origin: polar ? origin : undefined,
            polar: polar,
            theme: theme,
            title: title,
            scale: scale,
            standalone: standalone,
            style: style.parent
        };
        return {};
    }, [
        desc,
        domain,
        height,
        horizontal,
        name,
        origin,
        polar,
        scale,
        standalone,
        style,
        title,
        theme,
        width
    ]);
    var container = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(function() {
        if (standalone) {
            var defaultContainerProps = (0, (/*@__PURE__*/$parcel$interopDefault($d1c8f644a77a8c56$exports)))({}, containerComponent.props, containerProps, (0, $a9e703a4a20da87d$exports).getSafeUserProps(initialProps));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(containerComponent, defaultContainerProps);
        }
        return groupComponent;
    }, [
        groupComponent,
        standalone,
        containerComponent,
        containerProps,
        initialProps
    ]);
    var events = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(function() {
        return (0, $8c0cae78a8f93a11$exports).getAllEvents(props);
    }, [
        props
    ]);
    var previousProps = (0, $f6442d40b5d79512$exports).usePreviousProps(initialProps);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(function() {
        // This is called before dismount to keep state in sync
        return function() {
            if (initialProps.animate) setAnimationState(previousProps, initialProps);
        };
    }, [
        setAnimationState,
        previousProps,
        initialProps
    ]);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($1331767f05251f48$exports)))(events)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $4b70f72d9ea1bec7$export$2e2bcd8739ae039), {
        container: container,
        eventKey: eventKey,
        events: events,
        externalEventMutations: externalEventMutations
    }, newChildren);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(container, container.props, newChildren);
};
$33c1fffcca3bd289$var$VictoryChartImpl.propTypes = $33c1fffcca3bd289$var$_objectSpread($33c1fffcca3bd289$var$_objectSpread({}, (0, $70dbe1f62d5c55ed$export$fe6a43517f1f6b90).baseProps), {}, {
    backgroundComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node
    ]),
    defaultAxes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        independent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
        dependent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element
    }),
    defaultPolarAxes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        independent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
        dependent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element
    }),
    endAngle: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    innerRadius: (0, $9dba2b2bbfc485d5$exports).nonNegative,
    prependDefaultAxes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    startAngle: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number
});
$33c1fffcca3bd289$var$VictoryChartImpl.defaultProps = {
    backgroundComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $21a3de71cf887274$export$668799e4797757a8), null),
    containerComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $1433d8d5e8c8f7e5$export$b173aa1b45712272), null),
    defaultAxes: {
        independent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $9d7fdac323143f69$export$bfb0532f7f73bea1), null),
        dependent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $9d7fdac323143f69$export$bfb0532f7f73bea1), {
            dependentAxis: true
        })
    },
    defaultPolarAxes: {
        independent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $1362317551388a3f$export$2e2bcd8739ae039), null),
        dependent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $1362317551388a3f$export$2e2bcd8739ae039), {
            dependentAxis: true
        })
    },
    groupComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("g", null),
    standalone: true,
    theme: (0, $7fc64db73a6d2950$export$2c7826f4d98fe551).grayscale
};
var $33c1fffcca3bd289$export$fcee0f6ad310645a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).memo($33c1fffcca3bd289$var$VictoryChartImpl, (0, (/*@__PURE__*/$parcel$interopDefault($15022e88a09b93ad$exports))));
$33c1fffcca3bd289$export$fcee0f6ad310645a.displayName = "VictoryChart"; // @ts-expect-error FIXME: Does this "expectedComponents" do anything?
$33c1fffcca3bd289$export$fcee0f6ad310645a.expectedComponents = [
    "groupComponent",
    "containerComponent"
];






function $b03bf1bab5378afb$export$a5271b6194b1fe93() {
    const [attendees] = (0, $de6e1888d0a1ea86$export$f755a54f5b6ffe30)();
    if (!attendees) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Attendees"
    });
    const byCert = (0, $2914d071bbef92ec$export$ab5e74a2c43c30ea)(Object.values(attendees), (att)=>(0, $d5b1995fb206c61d$export$e070336f589a23cb)(att));
    const data = [
        ...byCert
    ].map(([key, values])=>({
            x: key,
            y: values.length
        }));
    (0, $2914d071bbef92ec$export$7a7adbcc2fafd347)(data, "x");
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $641d70d805eb1289$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $641d70d805eb1289$export$2e2bcd8739ae039).Title, {
                className: "text-center",
                children: "Attendees by Certification"
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $641d70d805eb1289$export$2e2bcd8739ae039).Body, {
                children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $33c1fffcca3bd289$export$fcee0f6ad310645a), {
                    domainPadding: {
                        x: 50
                    },
                    children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $1aa9babdc5b1f3d6$export$2e2bcd8739ae039), {
                        dataComponent: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $27000e11d83e1f32$export$2e2bcd8739ae039), {}),
                        data: data
                    })
                })
            })
        ]
    });
}




var $8T3gX = parcelRequire("8T3gX");



function $cf76239006404943$export$1696dc646f93b51() {
    const [cards] = (0, $de6e1888d0a1ea86$export$5fe928848609fec7)();
    if (!cards) return [];
    return Object.values(cards).filter((card)=>card.status === (0, $aaa72a458935fe7a$export$490c7ce941281ba8).DONE);
}
function $cf76239006404943$export$d1159e3ce687ceaf(cards) {
    if (!cards) return [];
    const motors = [];
    for (const card of cards){
        if (!card.motors) continue;
        motors.push(...Object.values(card.motors));
    }
    return motors;
}





function $ffc35015653eca6a$export$2e2bcd8739ae039() {
    const flownCards = (0, $cf76239006404943$export$1696dc646f93b51)();
    const [attendees] = (0, $de6e1888d0a1ea86$export$f755a54f5b6ffe30)();
    if (!attendees) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Attendees"
    });
    const flightsByLCO = [
        ...(0, $2914d071bbef92ec$export$ab5e74a2c43c30ea)(flownCards, (card)=>card.lcoId ?? "")
    ];
    (0, $2914d071bbef92ec$export$7a7adbcc2fafd347)(flightsByLCO, ([, cards])=>-cards.length);
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $641d70d805eb1289$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $641d70d805eb1289$export$2e2bcd8739ae039).Title, {
                className: "text-center",
                children: "LCO Activity"
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $641d70d805eb1289$export$2e2bcd8739ae039).Body, {
                className: "statlist",
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                        className: "text-center fw-bold",
                        children: "Officer"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                        className: "fw-bold",
                        children: "Flights Launched"
                    }),
                    flightsByLCO.map(([userId, cards])=>{
                        if (!cards.length) return null;
                        const user = attendees[userId];
                        if (!user) return null;
                        return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $8T3gX.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                                    children: user?.name ?? "(unknown)"
                                }),
                                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                                    children: cards.length
                                })
                            ]
                        }, userId);
                    })
                ]
            })
        ]
    });
}



parcelRequire("8T3gX");





function $074bf65152689928$export$cd59bed153815be9() {
    const motors = (0, $cf76239006404943$export$d1159e3ce687ceaf)((0, $cf76239006404943$export$1696dc646f93b51)());
    const impulses = motors.map((motor)=>motor.impulse ?? 0).filter((impulse)=>impulse > 0);
    let body = /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
        children: "No motors found"
    });
    if (impulses.length > 0) {
        const range = {
            min: impulses[0],
            max: impulses[0]
        };
        impulses.forEach((impulse)=>{
            range.min = Math.min(range.min, impulse);
            range.max = Math.max(range.max, impulse);
        });
        // Get names of all impulse classes that are in the range of the motors flown
        const impulsesInRange = (0, $0e759b381c300a7c$export$f0f2cabfa1c044ac).filter(({ min: min , max: max  })=>{
            return max > range.min && min < range.max;
        });
        const byCert = (0, $2914d071bbef92ec$export$ab5e74a2c43c30ea)(motors, (motor)=>(0, $0e759b381c300a7c$export$e5d022af76390349)(motor.impulse) ?? "unknown");
        const data = impulsesInRange.map(({ name: name  })=>({
                x: name,
                y: byCert.get(name)?.length ?? 0
            }));
        body = /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $33c1fffcca3bd289$export$fcee0f6ad310645a), {
            domainPadding: {
                x: [
                    50,
                    0
                ]
            },
            children: [
                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $9d7fdac323143f69$export$bfb0532f7f73bea1), {
                    dependentAxis: true
                }),
                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $9d7fdac323143f69$export$bfb0532f7f73bea1), {
                    tickLabelComponent: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $b8620e9b9f9774cb$export$5c9ddd0cb3c79d22), {
                        textAnchor: "end"
                    })
                }),
                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $1aa9babdc5b1f3d6$export$2e2bcd8739ae039), {
                    dataComponent: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $27000e11d83e1f32$export$2e2bcd8739ae039), {}),
                    data: data
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $641d70d805eb1289$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $641d70d805eb1289$export$2e2bcd8739ae039).Title, {
                className: "text-center",
                children: "Motors Flown by Class"
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $641d70d805eb1289$export$2e2bcd8739ae039).Body, {
                children: body
            })
        ]
    });
}




var $8T3gX = parcelRequire("8T3gX");




function $c0fc704d4d6f15b6$export$9dc32951783e2d13() {
    const motors = (0, $cf76239006404943$export$d1159e3ce687ceaf)((0, $cf76239006404943$export$1696dc646f93b51)());
    const entries = [
        ...(0, $2914d071bbef92ec$export$ab5e74a2c43c30ea)(motors, (motor)=>(0, $0e759b381c300a7c$export$6ef5e39af8f569c9)(motor.tcMotorId ?? "")?.manufacturerAbbrev ?? "(unknown)")
    ];
    (0, $2914d071bbef92ec$export$7a7adbcc2fafd347)(entries, ([, motors])=>-motors.length);
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $641d70d805eb1289$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $641d70d805eb1289$export$2e2bcd8739ae039).Title, {
                className: "text-center",
                children: "Motors Flown by Manufacturer"
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $641d70d805eb1289$export$2e2bcd8739ae039).Body, {
                className: "statlist",
                children: entries.map(([manufacturer, motors])=>{
                    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $8T3gX.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                                children: manufacturer
                            }),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                                children: motors.length
                            })
                        ]
                    }, manufacturer);
                })
            })
        ]
    });
}




var $8T3gX = parcelRequire("8T3gX");




function $19eb7e854ad895dc$export$2e2bcd8739ae039() {
    const [cards] = (0, $de6e1888d0a1ea86$export$5fe928848609fec7)();
    const [attendees] = (0, $de6e1888d0a1ea86$export$f755a54f5b6ffe30)();
    if (!cards) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Cards"
    });
    if (!attendees) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Attendees"
    });
    const cardsByRSO = [
        ...(0, $2914d071bbef92ec$export$ab5e74a2c43c30ea)(Object.values(cards), (card)=>card.rsoId ?? "")
    ];
    (0, $2914d071bbef92ec$export$7a7adbcc2fafd347)(cardsByRSO, ([, cards])=>-cards.length);
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $641d70d805eb1289$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $641d70d805eb1289$export$2e2bcd8739ae039).Title, {
                className: "text-center",
                children: "RSO Activity"
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $641d70d805eb1289$export$2e2bcd8739ae039).Body, {
                className: "statlist",
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                        className: "text-center fw-bold",
                        children: "RSO"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                        className: "fw-bold",
                        children: "Rockets Reviewed"
                    }),
                    cardsByRSO.map(([userId, cards])=>{
                        if (!cards.length) return null;
                        const user = attendees[userId];
                        if (!user) return null;
                        return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $8T3gX.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                                    children: user?.name ?? "(unknown)"
                                }),
                                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                                    children: cards.length
                                })
                            ]
                        }, userId);
                    })
                ]
            })
        ]
    });
}


function $0961fa7a8ef6050e$export$2e2bcd8739ae039() {
    const [launch] = (0, $de6e1888d0a1ea86$export$75eeb04b2db35f42)();
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("h1", {
                children: [
                    launch?.name ?? "(untitled)",
                    " Launch Stats"
                ]
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                className: "deck",
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $b03bf1bab5378afb$export$a5271b6194b1fe93), {}),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $074bf65152689928$export$cd59bed153815be9), {}),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $c0fc704d4d6f15b6$export$9dc32951783e2d13), {}),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $19eb7e854ad895dc$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $ffc35015653eca6a$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
}








function $4cafc1ae92bff46f$export$bb29c16f5612603e({ cards: cards  }) {
    if (!cards) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Cards"
    });
    (0, $2914d071bbef92ec$export$7a7adbcc2fafd347)(cards, (card)=>card.rocket?.name);
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
        className: "deck",
        children: cards.map((card)=>/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $71a39fa71327480b$export$1c9fa03e23146e86), {
                card: card
            }, card.id))
    });
}
function $4cafc1ae92bff46f$var$NotFound({ isLCO: isLCO , isRiding: isRiding  }) {
    if (isRiding) {
        if (isLCO) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $de9ec3fa47e50b10$export$aefd2927936d3a35), {
            meme: (0, $34d01c052e43b9cc$exports),
            topText: "An LCO trying to ride-along with themselves?",
            bottomText: "That seems like a bad idea",
            style: {
                width: "50%"
            }
        });
        else return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $1d0a237fe4c0025c$export$2e2bcd8739ae039), {
            variant: "warning text-center",
            children: "LCO temporarily unavailable"
        });
    }
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $1d0a237fe4c0025c$export$2e2bcd8739ae039), {
        variant: "warning text-center",
        children: "Page Not Found"
    });
}
function $4cafc1ae92bff46f$var$RideAlongRoutes({ children: children , ...props }) {
    let location = (0, $3T949.useLocation)();
    const { pathname: pathname  } = location;
    const roleApi = (0, $65c18c84559ec290$export$42f63dcbdf962527)();
    const [launch] = (0, $de6e1888d0a1ea86$export$75eeb04b2db35f42)();
    const rtPath = (0, $71b3f0397fe2ca79$export$5350b4cf31a863ce).with({
        launchId: launch?.id ?? ""
    });
    const [ridealongPath] = (0, $febfa929b76327ac$export$fe4c1a3a7af84c36)(rtPath);
    const [currentAttendee, currentAttendeeLoading] = (0, $de6e1888d0a1ea86$export$67c1131f3997904d)();
    const isLCO = roleApi.isLCO(currentAttendee);
    const isRiding = /\/ridealong$/.test(pathname);
    // Capture this state here because `launch` changes every time we set the
    // ridealong path, which causes a re-render loop if we have `launch` in the
    // effect dependencies.
    const rideAlongPath = launch && isLCO && !isRiding ? pathname : null;
    // Capture and publish navigation events for the "LCO ride along" feature
    (0, $8T3gX.useEffect)(()=>{
        if (!rideAlongPath) return;
        (0, $febfa929b76327ac$export$2ef6846d36515d5)(rtPath, rideAlongPath).catch((err)=>console.error("ridealong error", err));
    }, [
        rtPath,
        rideAlongPath
    ]);
    if (!currentAttendee && currentAttendeeLoading) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "User (Launch)"
    });
    // Override location if user is doing "LCO ride along"
    if (!isLCO && ridealongPath && isRiding) location = {
        ...location,
        pathname: ridealongPath
    };
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $3T949.Routes), {
        ...props,
        location: location,
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3T949.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)($4cafc1ae92bff46f$var$NotFound, {
                    isLCO: isLCO,
                    isRiding: isRiding
                })
            }),
            children
        ]
    });
}
function $4cafc1ae92bff46f$var$Launch() {
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)($4cafc1ae92bff46f$var$RideAlongRoutes, {
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3T949.Route), {
                path: "cards",
                element: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $8a68470a9a873614$export$c17ac35ce77f7737), {})
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3T949.Route), {
                path: "cards/:cardId",
                element: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $6c14caa5b06d34a6$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3T949.Route), {
                path: "cards/:cardId/summary",
                element: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $6c8d476d6469cc07$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3T949.Route), {
                path: "edit",
                element: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $44a4895b71a1d3ae$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3T949.Route), {
                path: "profile",
                element: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $d090a7b2f8ec46c6$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3T949.Route), {
                path: "report",
                element: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $0961fa7a8ef6050e$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3T949.Route), {
                path: "rso",
                element: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $ee866c7918c934e6$export$73cbf78008b0464), {})
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3T949.Route), {
                path: "lco",
                element: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3e4428930bc62d59$export$7cf1a375f6043cd1), {})
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3T949.Route), {
                path: "users/:filter",
                element: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $4f1825c325b077e3$export$289b7ec390c4c77f), {})
            })
        ]
    });
}
var $4cafc1ae92bff46f$export$2e2bcd8739ae039 = $4cafc1ae92bff46f$var$Launch;



parcelRequire("8T3gX");

var $f91d43ae1b6ac28b$exports = {};
"use strict";
Object.defineProperty($f91d43ae1b6ac28b$exports, "__esModule", {
    value: true
});
$f91d43ae1b6ac28b$exports.default = $f91d43ae1b6ac28b$var$all;
var $eb04ead2a25a6c9f$exports = {};
"use strict";
Object.defineProperty($eb04ead2a25a6c9f$exports, "__esModule", {
    value: true
});
$eb04ead2a25a6c9f$exports.default = $eb04ead2a25a6c9f$var$createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ // Mostly taken from ReactPropTypes.
function $eb04ead2a25a6c9f$var$createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        var componentNameSafe = componentName || "<<anonymous>>";
        var propFullNameSafe = propFullName || propName;
        if (props[propName] == null) {
            if (isRequired) return new Error("Required " + location + " `" + propFullNameSafe + "` was not specified " + ("in `" + componentNameSafe + "`."));
            return null;
        }
        for(var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)args[_key - 6] = arguments[_key];
        return validate.apply(undefined, [
            props,
            propName,
            componentNameSafe,
            location,
            propFullNameSafe
        ].concat(args));
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}
$eb04ead2a25a6c9f$exports = $eb04ead2a25a6c9f$exports["default"];


var $f91d43ae1b6ac28b$var$_createChainableTypeChecker2 = $f91d43ae1b6ac28b$var$_interopRequireDefault($eb04ead2a25a6c9f$exports);
function $f91d43ae1b6ac28b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f91d43ae1b6ac28b$var$all() {
    for(var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++)validators[_key] = arguments[_key];
    function allPropTypes() {
        for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var error = null;
        validators.forEach(function(validator) {
            if (error != null) return;
            var result = validator.apply(undefined, args);
            if (result != null) error = result;
        });
        return error;
    }
    return (0, $f91d43ae1b6ac28b$var$_createChainableTypeChecker2.default)(allPropTypes);
}
$f91d43ae1b6ac28b$exports = $f91d43ae1b6ac28b$exports["default"];



var $8T3gX = parcelRequire("8T3gX");



var $8T3gX = parcelRequire("8T3gX");

var $8T3gX = parcelRequire("8T3gX");
function $c62e37a90c71790c$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are stricting equal to the last state value
    var _useReducer = (0, $8T3gX.useReducer)(function(state) {
        return !state;
    }, false), dispatch = _useReducer[1];
    return dispatch;
}




var $8T3gX = parcelRequire("8T3gX");
const $666c02a03fb0c723$var$NavContext = /*#__PURE__*/ $8T3gX.createContext(null);
$666c02a03fb0c723$var$NavContext.displayName = "NavContext";
var $666c02a03fb0c723$export$2e2bcd8739ae039 = $666c02a03fb0c723$var$NavContext;



var $8T3gX = parcelRequire("8T3gX");
const $558081ce47b825cd$var$SelectableContext = /*#__PURE__*/ $8T3gX.createContext(null);
const $558081ce47b825cd$export$eef49b42fde998a3 = (eventKey, href = null)=>{
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $558081ce47b825cd$export$2e2bcd8739ae039 = $558081ce47b825cd$var$SelectableContext;



var $8T3gX = parcelRequire("8T3gX");
const $2659c869ea27d9ce$var$TabContext = /*#__PURE__*/ $8T3gX.createContext(null);
var $2659c869ea27d9ce$export$2e2bcd8739ae039 = $2659c869ea27d9ce$var$TabContext;




var $8T3gX = parcelRequire("8T3gX");







const $b26dee297b53c60d$var$_excluded = [
    "as",
    "active",
    "eventKey"
];
function $b26dee297b53c60d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b26dee297b53c60d$export$d7a68693710982a({ key: key , onClick: onClick , active: active , id: id , role: role , disabled: disabled  }) {
    const parentOnSelect = (0, $8T3gX.useContext)((0, $558081ce47b825cd$export$2e2bcd8739ae039));
    const navContext = (0, $8T3gX.useContext)((0, $666c02a03fb0c723$export$2e2bcd8739ae039));
    const tabContext = (0, $8T3gX.useContext)((0, $2659c869ea27d9ce$export$2e2bcd8739ae039));
    let isActive = active;
    const props = {
        role: role
    };
    if (navContext) {
        if (!role && navContext.role === "tablist") props.role = "tab";
        const contextControllerId = navContext.getControllerId(key != null ? key : null);
        const contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, $a963951f5e3bf39d$export$5cc3b7b83e34ade7)("event-key")] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props["aria-controls"] = contextControlledId;
    }
    if (props.role === "tab") {
        props["aria-selected"] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props["aria-disabled"] = true;
        }
    }
    props.onClick = (0, $47b6b666cdb493de$export$2e2bcd8739ae039)((e)=>{
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive: isActive
        }
    ];
}
const $b26dee297b53c60d$var$NavItem = /*#__PURE__*/ $8T3gX.forwardRef((_ref, ref)=>{
    let { as: Component = (0, $2188ccbcf240de19$export$2e2bcd8739ae039) , active: active , eventKey: eventKey  } = _ref, options = $b26dee297b53c60d$var$_objectWithoutPropertiesLoose(_ref, $b26dee297b53c60d$var$_excluded);
    const [props, meta] = $b26dee297b53c60d$export$d7a68693710982a(Object.assign({
        key: (0, $558081ce47b825cd$export$eef49b42fde998a3)(eventKey, options.href),
        active: active
    }, options));
    // @ts-ignore
    props[(0, $a963951f5e3bf39d$export$5cc3b7b83e34ade7)("active")] = meta.isActive;
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
$b26dee297b53c60d$var$NavItem.displayName = "NavItem";
var $b26dee297b53c60d$export$2e2bcd8739ae039 = $b26dee297b53c60d$var$NavItem;



const $7870cf6ffd5f70ac$var$_excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function $7870cf6ffd5f70ac$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $7870cf6ffd5f70ac$var$noop = ()=>{};
const $7870cf6ffd5f70ac$var$EVENT_KEY_ATTR = (0, $a963951f5e3bf39d$export$5cc3b7b83e34ade7)("event-key");
const $7870cf6ffd5f70ac$var$Nav = /*#__PURE__*/ $8T3gX.forwardRef((_ref, ref)=>{
    let { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = "div" , onSelect: onSelect , activeKey: activeKey , role: role , onKeyDown: onKeyDown  } = _ref, props = $7870cf6ffd5f70ac$var$_objectWithoutPropertiesLoose(_ref, $7870cf6ffd5f70ac$var$_excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    const forceUpdate = (0, $c62e37a90c71790c$export$2e2bcd8739ae039)();
    const needsRefocusRef = (0, $8T3gX.useRef)(false);
    const parentOnSelect = (0, $8T3gX.useContext)((0, $558081ce47b825cd$export$2e2bcd8739ae039));
    const tabContext = (0, $8T3gX.useContext)((0, $2659c869ea27d9ce$export$2e2bcd8739ae039));
    let getControlledId, getControllerId;
    if (tabContext) {
        role = role || "tablist";
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    const listNode = (0, $8T3gX.useRef)(null);
    const getNextActiveTab = (offset)=>{
        const currentListNode = listNode.current;
        if (!currentListNode) return null;
        const items = (0, $a6d31758637e51b3$export$2e2bcd8739ae039)(currentListNode, `[${$7870cf6ffd5f70ac$var$EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
        const activeChild = currentListNode.querySelector("[aria-selected=true]");
        if (!activeChild || activeChild !== document.activeElement) return null;
        const index = items.indexOf(activeChild);
        if (index === -1) return null;
        let nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    const handleSelect = (key, event)=>{
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        let nextActiveChild;
        switch(event.key){
            case "ArrowLeft":
            case "ArrowUp":
                nextActiveChild = getNextActiveTab(-1);
                break;
            case "ArrowRight":
            case "ArrowDown":
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, $a963951f5e3bf39d$export$7776c0a7cd2eb3e0)("EventKey")] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, $8T3gX.useEffect)(()=>{
        if (listNode.current && needsRefocusRef.current) {
            const activeChild = listNode.current.querySelector(`[${$7870cf6ffd5f70ac$var$EVENT_KEY_ATTR}][aria-selected=true]`);
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    const mergedRef = (0, $3334d009365bf881$export$2e2bcd8739ae039)(ref, listNode);
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $558081ce47b825cd$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $666c02a03fb0c723$export$2e2bcd8739ae039).Provider, {
            value: {
                role: role,
                // used by NavLink to determine it's role
                activeKey: (0, $558081ce47b825cd$export$eef49b42fde998a3)(activeKey),
                getControlledId: getControlledId || $7870cf6ffd5f70ac$var$noop,
                getControllerId: getControllerId || $7870cf6ffd5f70ac$var$noop
            },
            children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
$7870cf6ffd5f70ac$var$Nav.displayName = "Nav";
var $7870cf6ffd5f70ac$export$2e2bcd8739ae039 = Object.assign($7870cf6ffd5f70ac$var$Nav, {
    Item: (0, $b26dee297b53c60d$export$2e2bcd8739ae039)
});




var $8T3gX = parcelRequire("8T3gX");
// TODO: check
const $f72c0fd9c172dc76$var$context = /*#__PURE__*/ $8T3gX.createContext(null);
$f72c0fd9c172dc76$var$context.displayName = "NavbarContext";
var $f72c0fd9c172dc76$export$2e2bcd8739ae039 = $f72c0fd9c172dc76$var$context;




var $eaea13f1d67e249c$export$2e2bcd8739ae039 = (0, $94fe4a2899ec2691$export$2e2bcd8739ae039)("nav-item");




var $8T3gX = parcelRequire("8T3gX");





const $2600e70c1eb4947a$var$NavLink = /*#__PURE__*/ $8T3gX.forwardRef(({ bsPrefix: bsPrefix , className: className , as: Component = (0, $b8fe270a58aab61c$export$2e2bcd8739ae039) , active: active , eventKey: eventKey , disabled: disabled = false , ...props }, ref)=>{
    bsPrefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, "nav-link");
    const [navItemProps, meta] = (0, $b26dee297b53c60d$export$d7a68693710982a)({
        key: (0, $558081ce47b825cd$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        disabled: disabled,
        ...props
    });
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(Component, {
        ...props,
        ...navItemProps,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, bsPrefix, disabled && "disabled", meta.isActive && "active")
    });
});
$2600e70c1eb4947a$var$NavLink.displayName = "NavLink";
var $2600e70c1eb4947a$export$2e2bcd8739ae039 = $2600e70c1eb4947a$var$NavLink;



const $78e51fea6d7509ba$var$Nav = /*#__PURE__*/ $8T3gX.forwardRef((uncontrolledProps, ref)=>{
    const { as: as = "div" , bsPrefix: initialBsPrefix , variant: variant , fill: fill = false , justify: justify = false , navbar: navbar , navbarScroll: navbarScroll , className: className , activeKey: activeKey , ...props } = (0, $43a5c6b75c3b0a1f$export$2e2bcd8739ae039)(uncontrolledProps, {
        activeKey: "onSelect"
    });
    const bsPrefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(initialBsPrefix, "nav");
    let navbarBsPrefix;
    let cardHeaderBsPrefix;
    let isNavbar = false;
    const navbarContext = (0, $8T3gX.useContext)((0, $f72c0fd9c172dc76$export$2e2bcd8739ae039));
    const cardHeaderContext = (0, $8T3gX.useContext)((0, $d603951200a4e5d9$export$2e2bcd8739ae039));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardHeaderContext) ({ cardHeaderBsPrefix: cardHeaderBsPrefix  } = cardHeaderContext);
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $7870cf6ffd5f70ac$export$2e2bcd8739ae039), {
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, {
            [bsPrefix]: !isNavbar,
            [`${navbarBsPrefix}-nav`]: isNavbar,
            [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
            [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
            [`${bsPrefix}-${variant}`]: !!variant,
            [`${bsPrefix}-fill`]: fill,
            [`${bsPrefix}-justified`]: justify
        }),
        ...props
    });
});
$78e51fea6d7509ba$var$Nav.displayName = "Nav";
var $78e51fea6d7509ba$export$2e2bcd8739ae039 = Object.assign($78e51fea6d7509ba$var$Nav, {
    Item: (0, $eaea13f1d67e249c$export$2e2bcd8739ae039),
    Link: (0, $2600e70c1eb4947a$export$2e2bcd8739ae039)
});




parcelRequire("8T3gX");

parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
function $6d79c1a7b93332a8$export$f1e2e59418dd4e9f({ to: to , children: children , ...props }) {
    const navigate = (0, $3T949.useNavigate)();
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $78e51fea6d7509ba$export$2e2bcd8739ae039).Link, {
        onClick: ()=>navigate(String(to)),
        ...props,
        children: children
    });
}









var $c9001a85079fb984$exports = {};

$c9001a85079fb984$exports = new URL((parcelRequire("bCIFA")).resolve("hiaEU"), import.meta.url).toString();


var $2b82cc310a1928bc$exports = {};

$2b82cc310a1928bc$exports = new URL((parcelRequire("bCIFA")).resolve("7pM2K"), import.meta.url).toString();


var $883be8d8ff842f0c$exports = {};

$883be8d8ff842f0c$exports = new URL((parcelRequire("bCIFA")).resolve("feb7y"), import.meta.url).toString();


var $554693387514604b$exports = {};

$554693387514604b$exports = new URL((parcelRequire("bCIFA")).resolve("1HMdq"), import.meta.url).toString();


function $8b22b063715bd52f$export$2e2bcd8739ae039() {
    const [attendee] = (0, $de6e1888d0a1ea86$export$67c1131f3997904d)();
    const [launch] = (0, $de6e1888d0a1ea86$export$75eeb04b2db35f42)();
    const isOfficer = (0, $65c18c84559ec290$export$bb4710074625bd7e)();
    const makeNewCard = (0, $72515a87b1746ba0$export$392f9c076db9c98e)();
    if (!attendee) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Attendee"
    });
    if (!launch) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Launch (home)"
    });
    function launchUrl(suffix) {
        if (!launch?.id) throw Error("No launch id"); // Should never happen
        return `/launches/${launch.id}/${suffix}`;
    }
    if (!attendee.name) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h2", {
                children: '"Hi, My Name Is..."'
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                className: "text-tip",
                children: [
                    "Knowing who's here helps keep the launch safe and fun! You can always change this later in ",
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $6d79c1a7b93332a8$export$f1e2e59418dd4e9f), {
                        to: "profile",
                        children: "Your Profile"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $93bb41ab6836e9eb$export$2e2bcd8739ae039), {
                attendeeFields: {
                    launchId: launch.id,
                    userId: attendee.id
                }
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $98f5e3369323c0ef$export$c5c6c16075fd4665), {
                className: "mt-3",
                to: ".",
                children: "Done"
            })
        ]
    });
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                className: "d-flex mb-2",
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("h2", {
                        className: "flex-grow-1",
                        children: [
                            "Welcome to ",
                            launch.name
                        ]
                    }),
                    isOfficer ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $98f5e3369323c0ef$export$c5c6c16075fd4665), {
                        className: "btn-sm text-nowrap my-auto ms-2",
                        to: "edit",
                        children: [
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $e576e18ceea528e3$export$2e2bcd8739ae039), {
                                name: "pencil-fill"
                            }),
                            " Edit"
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                className: "d-grid",
                style: {
                    gap: "1em",
                    gridTemplateColumns: "repeat(auto-fit, minmax(20em, 1fr))"
                },
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $641d70d805eb1289$export$2e2bcd8739ae039), {
                        className: "d-flex flex-row",
                        children: [
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("img", {
                                className: "me-4",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($554693387514604b$exports))).toString(),
                                style: {
                                    height: "12em"
                                }
                            }),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                                className: "flex-grow-1 nav flex-column",
                                children: [
                                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h5", {
                                        className: "mt-3",
                                        children: "Spectators"
                                    }),
                                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $6d79c1a7b93332a8$export$f1e2e59418dd4e9f), {
                                        to: "users/all",
                                        children: "View Attendees"
                                    }),
                                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $6d79c1a7b93332a8$export$f1e2e59418dd4e9f), {
                                        to: "ridealong",
                                        children: "Ride Along With Launch Control"
                                    }),
                                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $6d79c1a7b93332a8$export$f1e2e59418dd4e9f), {
                                        to: launchUrl("report"),
                                        children: "See Launch Stats"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $641d70d805eb1289$export$2e2bcd8739ae039), {
                        className: "d-flex flex-row",
                        children: [
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("img", {
                                className: "me-4",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($c9001a85079fb984$exports))).toString(),
                                style: {
                                    height: "12em"
                                }
                            }),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                                className: "flex-grow-1 nav flex-column",
                                children: [
                                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h5", {
                                        className: "mt-3",
                                        children: "Fliers"
                                    }),
                                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $6d79c1a7b93332a8$export$f1e2e59418dd4e9f), {
                                        to: "cards",
                                        children: "My Flight Cards"
                                    }),
                                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $78e51fea6d7509ba$export$2e2bcd8739ae039).Link, {
                                        onClick: makeNewCard,
                                        children: "New Flight Card"
                                    }),
                                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $6d79c1a7b93332a8$export$f1e2e59418dd4e9f), {
                                        to: "users/officers",
                                        children: "View Club Officers"
                                    })
                                ]
                            })
                        ]
                    }),
                    isOfficer ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $641d70d805eb1289$export$2e2bcd8739ae039), {
                        className: "d-flex flex-row ",
                        children: [
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("img", {
                                className: "me-4",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($2b82cc310a1928bc$exports))).toString(),
                                style: {
                                    maxHeight: "12em"
                                }
                            }),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                                className: "flex-grow-1 nav flex-column",
                                children: [
                                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h5", {
                                        className: "mt-3",
                                        children: "Officers"
                                    }),
                                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $6d79c1a7b93332a8$export$f1e2e59418dd4e9f), {
                                        disabled: true,
                                        to: "rso",
                                        children: "Registration Desk"
                                    }),
                                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $6d79c1a7b93332a8$export$f1e2e59418dd4e9f), {
                                        to: "rso",
                                        children: "Range Safety"
                                    }),
                                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $6d79c1a7b93332a8$export$f1e2e59418dd4e9f), {
                                        to: "lco",
                                        children: "Launch Control"
                                    })
                                ]
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $641d70d805eb1289$export$2e2bcd8739ae039), {
                        className: "d-flex flex-row ",
                        children: [
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("img", {
                                className: "me-4",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($883be8d8ff842f0c$exports))).toString(),
                                style: {
                                    height: "13em"
                                }
                            }),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                                className: "flex-grow-1 nav flex-column",
                                children: [
                                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h5", {
                                        className: "mt-3",
                                        children: "Other"
                                    }),
                                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $6d79c1a7b93332a8$export$f1e2e59418dd4e9f), {
                                        to: "/launches",
                                        children: "Other Launches"
                                    }),
                                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $6d79c1a7b93332a8$export$f1e2e59418dd4e9f), {
                                        to: "profile",
                                        children: "My Profile"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("a", {
                                        className: "nav-link",
                                        rel: "noreferrer",
                                        target: "_blank",
                                        href: "https://github.com/broofa/flightcard/discussions",
                                        children: "Support (Github)"
                                    }),
                                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $6d79c1a7b93332a8$export$f1e2e59418dd4e9f), {
                                        to: "/",
                                        onClick: ()=>(0, $febfa929b76327ac$export$73693bad9f5880b0).signOut(),
                                        children: "Log Out"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $8T3gX = parcelRequire("8T3gX");






var $8T3gX = parcelRequire("8T3gX");


var $3T949 = parcelRequire("3T949");






function $4d79b2f2c852613d$export$db26f60c51fe81bd(props) {
    const [launches, launchesLoading] = (0, $de6e1888d0a1ea86$export$84bb215878bdb6d8)();
    const [currentUser] = (0, $de6e1888d0a1ea86$export$3901076af3749fa9)();
    const [copyId, setCopyId] = (0, $8T3gX.useState)("");
    const navigate = (0, $3T949.useNavigate)();
    if (!currentUser) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "User"
    });
    if (launchesLoading) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Launches"
    });
    const createLaunch = async (e)=>{
        const target = e.target;
        const launchId = (0, $40b0ef4339cb3cfb$export$ac4959f4f1338dfc)();
        // Hide modal so button can't get clicked twice by mistake
        target.disabled = true;
        // Create launch object
        const newLaunch = {
            id: launchId,
            name: "New Launch"
        };
        // Copy properties if needed
        const srcLaunch = launches?.[copyId];
        if (srcLaunch) {
            newLaunch.host = srcLaunch.host;
            newLaunch.location = srcLaunch.location;
        }
        const transaction = (0, $febfa929b76327ac$export$bc6fa55e832fa0cb)();
        // Save launch
        transaction.update((0, $71b3f0397fe2ca79$export$90058626e653e0cd).with({
            launchId: newLaunch.id ?? ""
        }), newLaunch);
        // Make current user the first officer
        transaction.update((0, $71b3f0397fe2ca79$export$63aafa5cd2e21081).with({
            launchId: newLaunch.id ?? "",
            userId: currentUser.id
        }), true);
        // Add current user as attendee
        transaction.update((0, $71b3f0397fe2ca79$export$9b60127abde046a1).with({
            launchId: newLaunch.id ?? "",
            userId: currentUser.id
        }), {
            id: currentUser.id,
            name: currentUser.name ?? (0, $febfa929b76327ac$export$4bd2facc4a3e6aa1),
            photoURL: currentUser.photoURL ?? (0, $febfa929b76327ac$export$4bd2facc4a3e6aa1),
            waiverTime: Date.now()
        });
        // Copy launch pads
        if (srcLaunch) {
            const pads = await (0, $febfa929b76327ac$export$c10e31973268dac4)((0, $71b3f0397fe2ca79$export$83289c7452cd8ea9).with({
                launchId: srcLaunch.id
            }));
            const newPads = {};
            for (const pad of Object.values(pads)){
                pad.id = (0, $40b0ef4339cb3cfb$export$ac4959f4f1338dfc)();
                newPads[pad.id] = pad;
            }
            transaction.update((0, $71b3f0397fe2ca79$export$83289c7452cd8ea9).with({
                launchId: launchId
            }), newPads);
        }
        await transaction.commit();
        // Go to new launch page
        navigate(`/launches/${launchId}/edit`);
    };
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $dcbe90c8bc15d3fe$export$2e2bcd8739ae039), {
        ...props,
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $dcbe90c8bc15d3fe$export$2e2bcd8739ae039).Header, {
                closeButton: true,
                children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $dcbe90c8bc15d3fe$export$2e2bcd8739ae039).Title, {
                    children: "New Launch"
                })
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $dcbe90c8bc15d3fe$export$2e2bcd8739ae039).Body, {
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("p", {
                        children: [
                            "Has your club used ",
                            (0, $5c148f2ca1c26c40$export$1d977c709458e273),
                            " previously? If so, you can select one of your previous launches below to copy the host, location, and pad configuration to your new launch."
                        ]
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("p", {
                        className: "text-tip",
                        children: '... or just click "Create Launch" to start with a fresh, new launch! :-)'
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e2399cea1a8ec78e$export$2e2bcd8739ae039), {
                        className: "mt-3",
                        value: copyId,
                        onChange: (e)=>setCopyId(e.target.value),
                        children: [
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("option", {
                                children: "(Optional) Launch to copy..."
                            }),
                            (0, $2914d071bbef92ec$export$7a7adbcc2fafd347)(Object.values(launches ?? []), "name").map((launch)=>/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("option", {
                                    value: launch.id,
                                    children: launch.name
                                }, launch.id))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $dcbe90c8bc15d3fe$export$2e2bcd8739ae039).Footer, {
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                        variant: "secondary",
                        onClick: props.onHide,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                        onClick: createLaunch,
                        children: "Create Launch"
                    })
                ]
            })
        ]
    });
}



parcelRequire("8T3gX");


function $7d6ec0c4ec0c1420$var$dateString(ts) {
    return new Date(`${ts}T00:00:00`).toLocaleDateString();
}
function $7d6ec0c4ec0c1420$export$2e2bcd8739ae039({ launch: launch , ...props }) {
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $641d70d805eb1289$export$2e2bcd8739ae039), {
        ...props,
        children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $641d70d805eb1289$export$2e2bcd8739ae039).Body, {
            children: [
                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $641d70d805eb1289$export$2e2bcd8739ae039).Title, {
                    children: launch.name
                }),
                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                    children: [
                        "Dates: ",
                        $7d6ec0c4ec0c1420$var$dateString(launch.startDate),
                        " - ",
                        $7d6ec0c4ec0c1420$var$dateString(launch.endDate)
                    ]
                }),
                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                    children: [
                        "Location: ",
                        launch.location
                    ]
                }),
                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                    children: [
                        "Host: ",
                        launch.host
                    ]
                }),
                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $a147a5343133f2a5$export$29d11c0fe2fc51d8), {
                    className: "mt-2",
                    to: `/launches/${launch.id}`,
                    children: [
                        "Check into ",
                        launch.name
                    ]
                })
            ]
        })
    }, launch.id);
}



function $eb6cc02af4a42113$export$2e2bcd8739ae039() {
    const [launches, launchesLoading] = (0, $de6e1888d0a1ea86$export$84bb215878bdb6d8)();
    const [currentUser] = (0, $de6e1888d0a1ea86$export$3901076af3749fa9)();
    const [showLaunchModal, setShowLaunchModal] = (0, $8T3gX.useState)(false);
    if (!currentUser) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Current User"
    });
    if (launchesLoading) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Launches"
    });
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
        children: [
            showLaunchModal ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $4d79b2f2c852613d$export$db26f60c51fe81bd), {
                show: true,
                onHide: ()=>setShowLaunchModal(false)
            }) : null,
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                className: "d-flex mb-3",
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h2", {
                        className: "flex-grow-1 my-0",
                        children: launches ? "Current and Upcoming Launches" : "No Launches Found"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                        className: "flex-grow-0",
                        size: "sm",
                        onClick: ()=>setShowLaunchModal(true),
                        children: "New Launch ..."
                    })
                ]
            }),
            launches ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("p", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("span", {
                                className: "fw-bold",
                                children: "'Just here to explore the app?"
                            }),
                            " ",
                            'Check into one of the "',
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("span", {
                                className: "mock",
                                children: "Test"
                            }),
                            '" launches to see what a launch with plenty of people and flights looks like.'
                        ]
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                        className: "deck",
                        children: Object.values(launches).filter((l)=>!l.startDate || Date.parse(`${l.endDate}T23:59:59`) >= Date.now()).map((l)=>/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $7d6ec0c4ec0c1420$export$2e2bcd8739ae039), {
                                launch: l,
                                className: (0, $a147a5343133f2a5$export$1343a74baacb0543)({
                                    "mock-badge": (0, $f31a31c32b1a153a$export$e27e8a613b80545b)(l)
                                })
                            }, l.id))
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("h2", {
                        children: "Past Launches"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                        className: "deck",
                        children: Object.values(launches).filter((l)=>Date.parse(`${l.endDate}T23:59:59`) < Date.now()).map((l)=>/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $7d6ec0c4ec0c1420$export$2e2bcd8739ae039), {
                                launch: l,
                                className: (0, $a147a5343133f2a5$export$1343a74baacb0543)({
                                    "mock-badge": (0, $f31a31c32b1a153a$export$e27e8a613b80545b)(l)
                                })
                            }, l.id))
                    })
                ]
            }) : /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("p", {
                children: 'This is rather unexpected. Try clicking the "New Launch" button and let\'s see what happens...?'
            })
        ]
    });
}





parcelRequire("8T3gX");


var $8T3gX = parcelRequire("8T3gX");





var $8T3gX = parcelRequire("8T3gX");


const $b6af7aa44833b6db$var$NavbarBrand = /*#__PURE__*/ $8T3gX.forwardRef(({ bsPrefix: bsPrefix , className: className , as: as , ...props }, ref)=>{
    bsPrefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, "navbar-brand");
    const Component = as || (props.href ? "a" : "span");
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, bsPrefix)
    });
});
$b6af7aa44833b6db$var$NavbarBrand.displayName = "NavbarBrand";
var $b6af7aa44833b6db$export$2e2bcd8739ae039 = $b6af7aa44833b6db$var$NavbarBrand;



var $8T3gX = parcelRequire("8T3gX");



var $8T3gX = parcelRequire("8T3gX");






const $1fb6ad03c67a227f$var$MARGINS = {
    height: [
        "marginTop",
        "marginBottom"
    ],
    width: [
        "marginLeft",
        "marginRight"
    ]
};
function $1fb6ad03c67a227f$var$getDefaultDimensionValue(dimension, elem) {
    const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
    const value = elem[offset];
    const margins = $1fb6ad03c67a227f$var$MARGINS[dimension];
    return value + // @ts-ignore
    parseInt((0, $cefc685938ef1085$export$2e2bcd8739ae039)(elem, margins[0]), 10) + // @ts-ignore
    parseInt((0, $cefc685938ef1085$export$2e2bcd8739ae039)(elem, margins[1]), 10);
}
const $1fb6ad03c67a227f$var$collapseStyles = {
    [(0, $63c98853081657d7$export$84cbff306f539230)]: "collapse",
    [(0, $63c98853081657d7$export$4aacc83d4d59139f)]: "collapsing",
    [(0, $63c98853081657d7$export$df38205c966be359)]: "collapsing",
    [(0, $63c98853081657d7$export$78e9e6e3e014d60a)]: "collapse show"
};
const $1fb6ad03c67a227f$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).forwardRef(({ onEnter: onEnter , onEntering: onEntering , onEntered: onEntered , onExit: onExit , onExiting: onExiting , className: className , children: children , dimension: dimension = "height" , in: inProp = false , timeout: timeout = 300 , mountOnEnter: mountOnEnter = false , unmountOnExit: unmountOnExit = false , appear: appear = false , getDimensionValue: getDimensionValue = $1fb6ad03c67a227f$var$getDefaultDimensionValue , ...props }, ref)=>{
    /* Compute dimension */ const computedDimension = typeof dimension === "function" ? dimension() : dimension;
    /* -- Expanding -- */ const handleEnter = (0, $8T3gX.useMemo)(()=>(0, $198ccd59a96f9030$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = "0";
        }, onEnter), [
        computedDimension,
        onEnter
    ]);
    const handleEntering = (0, $8T3gX.useMemo)(()=>(0, $198ccd59a96f9030$export$2e2bcd8739ae039)((elem)=>{
            const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
            elem.style[computedDimension] = `${elem[scroll]}px`;
        }, onEntering), [
        computedDimension,
        onEntering
    ]);
    const handleEntered = (0, $8T3gX.useMemo)(()=>(0, $198ccd59a96f9030$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onEntered), [
        computedDimension,
        onEntered
    ]);
    /* -- Collapsing -- */ const handleExit = (0, $8T3gX.useMemo)(()=>(0, $198ccd59a96f9030$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
            (0, $a46c705cdf1e8082$export$2e2bcd8739ae039)(elem);
        }, onExit), [
        onExit,
        getDimensionValue,
        computedDimension
    ]);
    const handleExiting = (0, $8T3gX.useMemo)(()=>(0, $198ccd59a96f9030$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onExiting), [
        computedDimension,
        onExiting
    ]);
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $4d7e429a98f3ba4d$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $2675c0d5845ad502$export$2e2bcd8739ae039),
        ...props,
        "aria-expanded": props.role ? inProp : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting,
        childRef: children.ref,
        in: inProp,
        timeout: timeout,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        children: (state, innerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, children.props.className, $1fb6ad03c67a227f$var$collapseStyles[state], computedDimension === "width" && "collapse-horizontal")
            })
    });
});
var // @ts-ignore
$1fb6ad03c67a227f$export$2e2bcd8739ae039 = $1fb6ad03c67a227f$var$Collapse;





const $7a9d9af8293b0923$var$NavbarCollapse = /*#__PURE__*/ $8T3gX.forwardRef(({ children: children , bsPrefix: bsPrefix , ...props }, ref)=>{
    bsPrefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, "navbar-collapse");
    const context = (0, $8T3gX.useContext)((0, $f72c0fd9c172dc76$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $1fb6ad03c67a227f$export$2e2bcd8739ae039), {
        in: !!(context && context.expanded),
        ...props,
        children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
            ref: ref,
            className: bsPrefix,
            children: children
        })
    });
});
$7a9d9af8293b0923$var$NavbarCollapse.displayName = "NavbarCollapse";
var $7a9d9af8293b0923$export$2e2bcd8739ae039 = $7a9d9af8293b0923$var$NavbarCollapse;




var $8T3gX = parcelRequire("8T3gX");




const $137e1f5331af1e3d$var$NavbarToggle = /*#__PURE__*/ $8T3gX.forwardRef(({ bsPrefix: bsPrefix , className: className , children: children , label: label = "Toggle navigation" , // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "button" , onClick: onClick , ...props }, ref)=>{
    bsPrefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, "navbar-toggler");
    const { onToggle: onToggle , expanded: expanded  } = (0, $8T3gX.useContext)((0, $f72c0fd9c172dc76$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $47b6b666cdb493de$export$2e2bcd8739ae039)((e)=>{
        if (onClick) onClick(e);
        if (onToggle) onToggle();
    });
    if (Component === "button") props.type = "button";
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(Component, {
        ...props,
        ref: ref,
        onClick: handleClick,
        "aria-label": label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, bsPrefix, !expanded && "collapsed"),
        children: children || /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("span", {
            className: `${bsPrefix}-icon`
        })
    });
});
$137e1f5331af1e3d$var$NavbarToggle.displayName = "NavbarToggle";
var $137e1f5331af1e3d$export$2e2bcd8739ae039 = $137e1f5331af1e3d$var$NavbarToggle;



var $8T3gX = parcelRequire("8T3gX");



var $8T3gX = parcelRequire("8T3gX");
var $2ca1ae6104ed84b0$var$matchersByWindow = new WeakMap();
var $2ca1ae6104ed84b0$var$getMatcher = function getMatcher(query, targetWindow) {
    if (!query || !targetWindow) return undefined;
    var matchers = $2ca1ae6104ed84b0$var$matchersByWindow.get(targetWindow) || new Map();
    $2ca1ae6104ed84b0$var$matchersByWindow.set(targetWindow, matchers);
    var mql = matchers.get(query);
    if (!mql) {
        mql = targetWindow.matchMedia(query);
        mql.refCount = 0;
        matchers.set(mql.media, mql);
    }
    return mql;
};
function $2ca1ae6104ed84b0$export$2e2bcd8739ae039(query, targetWindow) {
    if (targetWindow === void 0) targetWindow = typeof window === "undefined" ? undefined : window;
    var mql = $2ca1ae6104ed84b0$var$getMatcher(query, targetWindow);
    var _useState = (0, $8T3gX.useState)(function() {
        return mql ? mql.matches : false;
    }), matches = _useState[0], setMatches = _useState[1];
    (0, $92e18d6cf48ef440$export$2e2bcd8739ae039)(function() {
        var mql = $2ca1ae6104ed84b0$var$getMatcher(query, targetWindow);
        if (!mql) return setMatches(false);
        var matchers = $2ca1ae6104ed84b0$var$matchersByWindow.get(targetWindow);
        var handleChange = function handleChange() {
            setMatches(mql.matches);
        };
        mql.refCount++;
        mql.addListener(handleChange);
        handleChange();
        return function() {
            mql.removeListener(handleChange);
            mql.refCount--;
            if (mql.refCount <= 0) matchers == null || matchers.delete(mql.media);
            mql = undefined;
        };
    }, [
        query
    ]);
    return matches;
}



var $8T3gX = parcelRequire("8T3gX");
function $bf955b65038bd645$export$9c6950edc251641e(breakpointValues) {
    var names = Object.keys(breakpointValues);
    function and(query, next) {
        if (query === next) return next;
        return query ? query + " and " + next : next;
    }
    function getNext(breakpoint) {
        return names[Math.min(names.indexOf(breakpoint) + 1, names.length - 1)];
    }
    function getMaxQuery(breakpoint) {
        var next = getNext(breakpoint);
        var value = breakpointValues[next];
        if (typeof value === "number") value = value - 0.2 + "px";
        else value = "calc(" + value + " - 0.2px)";
        return "(max-width: " + value + ")";
    }
    function getMinQuery(breakpoint) {
        var value = breakpointValues[breakpoint];
        if (typeof value === "number") value = value + "px";
        return "(min-width: " + value + ")";
    }
    /**
   * Match a set of breakpoints
   *
   * ```tsx
   * const MidSizeOnly = () => {
   *   const isMid = useBreakpoint({ lg: 'down', sm: 'up' });
   *
   *   if (isMid) return <div>On a Reasonable sized Screen!</div>
   *   return null;
   * }
   * ```
   * @param breakpointMap An object map of breakpoints and directions, queries are constructed using "and" to join
   * breakpoints together
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ function useBreakpoint(breakpointOrMap, direction, window) {
        var breakpointMap;
        if (typeof breakpointOrMap === "object") {
            breakpointMap = breakpointOrMap;
            window = direction;
            direction = true;
        } else {
            var _breakpointMap;
            direction = direction || true;
            breakpointMap = (_breakpointMap = {}, _breakpointMap[breakpointOrMap] = direction, _breakpointMap);
        }
        var query = (0, $8T3gX.useMemo)(function() {
            return Object.entries(breakpointMap).reduce(function(query, _ref) {
                var key = _ref[0], direction = _ref[1];
                if (direction === "up" || direction === true) query = and(query, getMinQuery(key));
                if (direction === "down" || direction === true) query = and(query, getMaxQuery(key));
                return query;
            }, "");
        }, [
            JSON.stringify(breakpointMap)
        ]);
        return (0, $2ca1ae6104ed84b0$export$2e2bcd8739ae039)(query, window);
    }
    return useBreakpoint;
}
var $bf955b65038bd645$var$useBreakpoint = $bf955b65038bd645$export$9c6950edc251641e({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
});
var $bf955b65038bd645$export$2e2bcd8739ae039 = $bf955b65038bd645$var$useBreakpoint;




var $8T3gX = parcelRequire("8T3gX");



var $d270ee07fcd2b4b9$export$2e2bcd8739ae039 = (0, $94fe4a2899ec2691$export$2e2bcd8739ae039)("offcanvas-body");




var $8T3gX = parcelRequire("8T3gX");





const $cb5c6a6f7d10a0dc$var$transitionStyles = {
    [(0, $63c98853081657d7$export$df38205c966be359)]: "show",
    [(0, $63c98853081657d7$export$78e9e6e3e014d60a)]: "show"
};
const $cb5c6a6f7d10a0dc$var$OffcanvasToggling = /*#__PURE__*/ $8T3gX.forwardRef(({ bsPrefix: bsPrefix , className: className , children: children , in: inProp = false , mountOnEnter: mountOnEnter = false , unmountOnExit: unmountOnExit = false , appear: appear = false , ...props }, ref)=>{
    bsPrefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, "offcanvas");
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $4d7e429a98f3ba4d$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $2675c0d5845ad502$export$2e2bcd8739ae039),
        in: inProp,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        ...props,
        childRef: children.ref,
        children: (status, innerProps)=>/*#__PURE__*/ $8T3gX.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, children.props.className, (status === (0, $63c98853081657d7$export$df38205c966be359) || status === (0, $63c98853081657d7$export$4aacc83d4d59139f)) && `${bsPrefix}-toggling`, $cb5c6a6f7d10a0dc$var$transitionStyles[status])
            })
    });
});
$cb5c6a6f7d10a0dc$var$OffcanvasToggling.displayName = "OffcanvasToggling";
var $cb5c6a6f7d10a0dc$export$2e2bcd8739ae039 = $cb5c6a6f7d10a0dc$var$OffcanvasToggling;






var $8T3gX = parcelRequire("8T3gX");



const $245aa7b452cc59bc$var$OffcanvasHeader = /*#__PURE__*/ $8T3gX.forwardRef(({ bsPrefix: bsPrefix , className: className , closeLabel: closeLabel = "Close" , closeButton: closeButton = false , ...props }, ref)=>{
    bsPrefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, "offcanvas-header");
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $12e6cf7b31b2a1d0$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$245aa7b452cc59bc$var$OffcanvasHeader.displayName = "OffcanvasHeader";
var $245aa7b452cc59bc$export$2e2bcd8739ae039 = $245aa7b452cc59bc$var$OffcanvasHeader;




const $ffb1dd7203903fc4$var$DivStyledAsH5 = (0, $87aacb5e98a57b39$export$2e2bcd8739ae039)("h5");
var $ffb1dd7203903fc4$export$2e2bcd8739ae039 = (0, $94fe4a2899ec2691$export$2e2bcd8739ae039)("offcanvas-title", {
    Component: $ffb1dd7203903fc4$var$DivStyledAsH5
});





function $24e86ba3ce09220a$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $cb5c6a6f7d10a0dc$export$2e2bcd8739ae039), {
        ...props
    });
}
function $24e86ba3ce09220a$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $e996a38072c77732$export$2e2bcd8739ae039), {
        ...props
    });
}
const $24e86ba3ce09220a$var$Offcanvas = /*#__PURE__*/ $8T3gX.forwardRef(({ bsPrefix: bsPrefix , className: className , children: children , "aria-labelledby": ariaLabelledby , placement: placement = "start" , responsive: responsive , show: /* BaseModal props */ show = false , backdrop: backdrop = true , keyboard: keyboard = true , scroll: scroll = false , onEscapeKeyDown: onEscapeKeyDown , onShow: onShow , onHide: onHide , container: container , autoFocus: autoFocus = true , enforceFocus: enforceFocus = true , restoreFocus: restoreFocus = true , restoreFocusOptions: restoreFocusOptions , onEntered: onEntered , onExit: onExit , onExiting: onExiting , onEnter: onEnter , onEntering: onEntering , onExited: onExited , backdropClassName: backdropClassName , manager: propsManager , renderStaticNode: renderStaticNode = false , ...props }, ref)=>{
    const modalManager = (0, $8T3gX.useRef)();
    bsPrefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(bsPrefix, "offcanvas");
    const { onToggle: onToggle  } = (0, $8T3gX.useContext)((0, $f72c0fd9c172dc76$export$2e2bcd8739ae039)) || {};
    const [showOffcanvas, setShowOffcanvas] = (0, $8T3gX.useState)(false);
    const hideResponsiveOffcanvas = (0, $bf955b65038bd645$export$2e2bcd8739ae039)(responsive || "xs", "up");
    (0, $8T3gX.useEffect)(()=>{
        // Handles the case where screen is resized while the responsive
        // offcanvas is shown. If `responsive` not provided, just use `show`.
        setShowOffcanvas(responsive ? show && !hideResponsiveOffcanvas : show);
    }, [
        show,
        responsive,
        hideResponsiveOffcanvas
    ]);
    const handleHide = (0, $47b6b666cdb493de$export$2e2bcd8739ae039)(()=>{
        onToggle == null || onToggle();
        onHide == null || onHide();
    });
    const modalContext = (0, $8T3gX.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        if (scroll) {
            // Have to use a different modal manager since the shared
            // one handles overflow.
            if (!modalManager.current) modalManager.current = new (0, $a5528457b47db029$export$2e2bcd8739ae039)({
                handleContainerOverflow: false
            });
            return modalManager.current;
        }
        return (0, $a5528457b47db029$export$a03641438014b436)();
    }
    const handleEnter = (node, ...args)=>{
        if (node) node.style.visibility = "visible";
        onEnter == null || onEnter(node, ...args);
    };
    const handleExited = (node, ...args)=>{
        if (node) node.style.visibility = "";
        onExited == null || onExited(...args);
    };
    const renderBackdrop = (0, $8T3gX.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(`${bsPrefix}-backdrop`, backdropClassName)
        }), [
        backdropClassName,
        bsPrefix
    ]);
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
            ...dialogProps,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, responsive ? `${bsPrefix}-${responsive}` : bsPrefix, `${bsPrefix}-${placement}`),
            "aria-labelledby": ariaLabelledby,
            children: children
        });
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
        children: [
            !showOffcanvas && (responsive || renderStaticNode) && renderDialog({}),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $b373b5e0423f0924$export$2e2bcd8739ae039).Provider, {
                value: modalContext,
                children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $9e490e809df060ee$export$2e2bcd8739ae039), {
                    show: showOffcanvas,
                    ref: ref,
                    backdrop: backdrop,
                    container: container,
                    keyboard: keyboard,
                    autoFocus: autoFocus,
                    enforceFocus: enforceFocus && !scroll,
                    restoreFocus: restoreFocus,
                    restoreFocusOptions: restoreFocusOptions,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onShow: onShow,
                    onHide: handleHide,
                    onEnter: handleEnter,
                    onEntering: onEntering,
                    onEntered: onEntered,
                    onExit: onExit,
                    onExiting: onExiting,
                    onExited: handleExited,
                    manager: getModalManager(),
                    transition: $24e86ba3ce09220a$var$DialogTransition,
                    backdropTransition: $24e86ba3ce09220a$var$BackdropTransition,
                    renderBackdrop: renderBackdrop,
                    renderDialog: renderDialog
                })
            })
        ]
    });
});
$24e86ba3ce09220a$var$Offcanvas.displayName = "Offcanvas";
var $24e86ba3ce09220a$export$2e2bcd8739ae039 = Object.assign($24e86ba3ce09220a$var$Offcanvas, {
    Body: (0, $d270ee07fcd2b4b9$export$2e2bcd8739ae039),
    Header: (0, $245aa7b452cc59bc$export$2e2bcd8739ae039),
    Title: (0, $ffb1dd7203903fc4$export$2e2bcd8739ae039)
});




const $2ec4c21cac7818cf$var$NavbarOffcanvas = /*#__PURE__*/ $8T3gX.forwardRef((props, ref)=>{
    const context = (0, $8T3gX.useContext)((0, $f72c0fd9c172dc76$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $24e86ba3ce09220a$export$2e2bcd8739ae039), {
        ref: ref,
        show: !!(context != null && context.expanded),
        ...props,
        renderStaticNode: true
    });
});
$2ec4c21cac7818cf$var$NavbarOffcanvas.displayName = "NavbarOffcanvas";
var $2ec4c21cac7818cf$export$2e2bcd8739ae039 = $2ec4c21cac7818cf$var$NavbarOffcanvas;





const $1f3f14ed7e426b69$var$NavbarText = (0, $94fe4a2899ec2691$export$2e2bcd8739ae039)("navbar-text", {
    Component: "span"
});
const $1f3f14ed7e426b69$var$Navbar = /*#__PURE__*/ $8T3gX.forwardRef((props, ref)=>{
    const { bsPrefix: initialBsPrefix , expand: expand = true , variant: variant = "light" , bg: bg , fixed: fixed , sticky: sticky , className: className , // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = "nav" , expanded: expanded , onToggle: onToggle , onSelect: onSelect , collapseOnSelect: collapseOnSelect = false , ...controlledProps } = (0, $43a5c6b75c3b0a1f$export$2e2bcd8739ae039)(props, {
        expanded: "onToggle"
    });
    const bsPrefix = (0, $fa98af941750c85d$export$7f387860ebffb32c)(initialBsPrefix, "navbar");
    const handleCollapse = (0, $8T3gX.useCallback)((...args)=>{
        onSelect == null || onSelect(...args);
        if (collapseOnSelect && expanded) onToggle == null || onToggle(false);
    }, [
        onSelect,
        collapseOnSelect,
        expanded,
        onToggle
    ]);
    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one
    if (controlledProps.role === undefined && Component !== "nav") controlledProps.role = "navigation";
    let expandClass = `${bsPrefix}-expand`;
    if (typeof expand === "string") expandClass = `${expandClass}-${expand}`;
    const navbarContext = (0, $8T3gX.useMemo)(()=>({
            onToggle: ()=>onToggle == null ? void 0 : onToggle(!expanded),
            bsPrefix: bsPrefix,
            expanded: !!expanded,
            expand: expand
        }), [
        bsPrefix,
        expanded,
        expand,
        onToggle
    ]);
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $f72c0fd9c172dc76$export$2e2bcd8739ae039).Provider, {
        value: navbarContext,
        children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $558081ce47b825cd$export$2e2bcd8739ae039).Provider, {
            value: handleCollapse,
            children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)(Component, {
                ref: ref,
                ...controlledProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d1aa3e5fa51b632d$exports)))(className, bsPrefix, expand && expandClass, variant && `${bsPrefix}-${variant}`, bg && `bg-${bg}`, sticky && `sticky-${sticky}`, fixed && `fixed-${fixed}`)
            })
        })
    });
});
$1f3f14ed7e426b69$var$Navbar.displayName = "Navbar";
var $1f3f14ed7e426b69$export$2e2bcd8739ae039 = Object.assign($1f3f14ed7e426b69$var$Navbar, {
    Brand: (0, $b6af7aa44833b6db$export$2e2bcd8739ae039),
    Collapse: (0, $7a9d9af8293b0923$export$2e2bcd8739ae039),
    Offcanvas: (0, $2ec4c21cac7818cf$export$2e2bcd8739ae039),
    Text: $1f3f14ed7e426b69$var$NavbarText,
    Toggle: (0, $137e1f5331af1e3d$export$2e2bcd8739ae039)
});



var $fIsAN = parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");


var $ca13933cdca0f2b5$exports = {};

$ca13933cdca0f2b5$exports = new URL((parcelRequire("bCIFA")).resolve("fRjTb"), import.meta.url).toString();


function $7c192130d736c5da$export$ee57ba49aae4a7c4() {
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $1f3f14ed7e426b69$export$2e2bcd8739ae039), {
                bg: "dark",
                variant: "dark",
                className: "position-sticky top-0",
                style: {
                    zIndex: 3
                },
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $fIsAN.NavLink), {
                        to: "/launches",
                        className: "text-center p-1",
                        children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ca13933cdca0f2b5$exports))),
                            style: {
                                height: "2.5em"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                        className: "flex-grow-1",
                        children: (0, $5c148f2ca1c26c40$export$1d977c709458e273)
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $fIsAN.NavLink), {
                        to: "",
                        className: "p-2",
                        onClick: ()=>(0, $febfa929b76327ac$export$73693bad9f5880b0).signOut(),
                        children: "Log Out"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                className: "p-3",
                style: {
                    minHeight: "calc(100vh - 38px - 65px)"
                },
                children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3T949.Outlet), {})
            })
        ]
    });
}



parcelRequire("8T3gX");


var $fIsAN = parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");



function $3832f41ec0a5987e$var$NavBarLink({ launchId: launchId , path: path , icon: icon , label: label  }) {
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $fIsAN.NavLink), {
        to: `/launches/${launchId}/${path}`,
        className: "flex-grow-1 text-center py-2 text-decoration-none",
        children: label ? label : /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $e576e18ceea528e3$export$2e2bcd8739ae039), {
            size: "2em",
            name: icon ?? ""
        })
    }, path);
}
function $3832f41ec0a5987e$export$67fb918b6e0c5286() {
    const [launch, loading, error] = (0, $de6e1888d0a1ea86$export$75eeb04b2db35f42)();
    const [currentUser] = (0, $de6e1888d0a1ea86$export$3901076af3749fa9)();
    if (loading) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Launch (navbar)"
    });
    else if (error) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $1d0a237fe4c0025c$export$2e2bcd8739ae039), {
        variant: "danger",
        children: [
            "LaunchRoute: ",
            error.message
        ]
    });
    else if (!launch) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $1d0a237fe4c0025c$export$2e2bcd8739ae039), {
        variant: "warning",
        children: "Launch Not Found"
    });
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $1f3f14ed7e426b69$export$2e2bcd8739ae039), {
                bg: "dark",
                variant: "dark",
                className: "position-sticky top-0",
                style: {
                    zIndex: 3
                },
                children: currentUser && launch ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)($3832f41ec0a5987e$var$NavBarLink, {
                            launchId: launch.id,
                            path: "",
                            icon: "house-fill"
                        }),
                        /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)($3832f41ec0a5987e$var$NavBarLink, {
                            launchId: launch.id,
                            path: "cards",
                            icon: "card-fill"
                        }),
                        /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)($3832f41ec0a5987e$var$NavBarLink, {
                            launchId: launch.id,
                            path: "rso",
                            label: "RSO"
                        }),
                        /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)($3832f41ec0a5987e$var$NavBarLink, {
                            launchId: launch.id,
                            path: "lco",
                            label: "LCO"
                        })
                    ]
                }) : null
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
                className: "p-3",
                style: {
                    minHeight: "calc(100vh - 38px - 65px)"
                },
                children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3T949.Outlet), {})
            })
        ]
    });
}




var $8T3gX = parcelRequire("8T3gX");







function $aaefed0cad2d34ec$export$b5b16ca84785baf7() {
    const [launch] = (0, $de6e1888d0a1ea86$export$75eeb04b2db35f42)();
    const [currentUser] = (0, $de6e1888d0a1ea86$export$3901076af3749fa9)();
    const agreeRef = (0, $8T3gX.useRef)(null);
    if (!currentUser) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "User"
    });
    if (!launch) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Launch"
    });
    const rtPath = (0, $71b3f0397fe2ca79$export$9b60127abde046a1).with({
        launchId: launch.id,
        userId: currentUser.id
    });
    async function launchAgree() {
        await (0, $a147a5343133f2a5$export$95dc765ca5d5cc35)(agreeRef.current, (0, $febfa929b76327ac$export$2ef6846d36515d5)(rtPath, {
            ...currentUser,
            waiverTime: Date.now()
        }));
    }
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
        className: "m-4",
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("h1", {
                style: {
                    textAlign: "center"
                },
                children: [
                    "This is a Dangerous Activity",
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("br", {}),
                    "☠",
                    " ",
                    "☠",
                    " ",
                    "☠",
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("strong", {
                    children: "Before proceeding, you must agree to the following:"
                })
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("ol", {
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("li", {
                        children: [
                            "You meet all attendance requirements set by the event hosts.",
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("em", {
                                className: "text-danger",
                                children: "Unsure what these are? Contact the event host."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("li", {
                        children: [
                            "You hold harmless the authors of ",
                            (0, $5c148f2ca1c26c40$export$1d977c709458e273),
                            " (this application).",
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("em", {
                                className: "text-danger",
                                children: "This app is experimental and under active development. Do not expect it to be reliable or correct. Always verify any information it provides with an independent source."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("div", {
                className: "d-flex justify-content-between mt-3",
                children: [
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $98f5e3369323c0ef$export$c5c6c16075fd4665), {
                        variant: "danger",
                        to: "/launches",
                        children: "No Thanks"
                    }),
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $049664ec30473d5e$export$2e2bcd8739ae039), {
                        ref: agreeRef,
                        onClick: launchAgree,
                        children: "I Agree"
                    })
                ]
            })
        ]
    });
}



parcelRequire("8T3gX");


function $8ba368de75b225e2$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("h1", {
                className: "m-4",
                children: [
                    "Welcome to ",
                    (0, $5c148f2ca1c26c40$export$1d977c709458e273)
                ]
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)("p", {
                children: [
                    "Pretend there's useful content here, and then head over to ...",
                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $98f5e3369323c0ef$export$c5c6c16075fd4665), {
                        className: "d-block my-3",
                        to: "/launches",
                        children: "Launches"
                    })
                ]
            })
        ]
    });
}





var $8T3gX = parcelRequire("8T3gX");


var $8T3gX = parcelRequire("8T3gX");
var $055b341d413064cf$exports = {};

$parcel$export($055b341d413064cf$exports, "flashItem", () => $055b341d413064cf$export$952c2845537ed8c4, (v) => $055b341d413064cf$export$952c2845537ed8c4 = v);
var $055b341d413064cf$export$952c2845537ed8c4;
$055b341d413064cf$export$952c2845537ed8c4 = `SfciLW_flashItem`;



function $ec4c13abb310f46f$export$3278302e3b4f4aa({ className: className , children: children , ...props }) {
    const ref = (0, $8T3gX.useRef)(null);
    (0, $8T3gX.useEffect)(()=>{
        const el = ref.current;
        if (el) {
            el.style.height = `${el.scrollHeight}px`;
            el.ontransitionend = ()=>{
                el.style.height = "auto";
            };
        }
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
        className: (0, $a147a5343133f2a5$export$1343a74baacb0543)(className, (0, (/*@__PURE__*/$parcel$interopDefault($055b341d413064cf$exports))).flashItem),
        ref: ref,
        ...props,
        children: children
    });
}


function $7a7b339865ca290c$export$26c05df95da5fc70(props) {
    const [flashes, setFlashes] = (0, $8T3gX.useState)([]);
    (0, $8T3gX.useEffect)(()=>{
        function onFlashChange(e) {
            setFlashes(e.detail);
        }
        document.addEventListener("flashEvent", onFlashChange);
        return ()=>document.removeEventListener("flashEvent", onFlashChange);
    }, []);
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $e9bc3aadba8432ee$exports.Fragment), {
        children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)("div", {
            ...props,
            children: flashes.map((node, i)=>{
                return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $ec4c13abb310f46f$export$3278302e3b4f4aa), {
                    children: node
                }, i);
            })
        })
    });
}


const $5c148f2ca1c26c40$export$1d977c709458e273 = "FlightCard";
const $5c148f2ca1c26c40$export$d64425f8a23d9468 = "(anonymous)";
// REF: https://stackoverflow.com/a/69592617/109538
function $5c148f2ca1c26c40$var$RequireAuth() {
    const [authUser, loading, error] = (0, $99363374ad4a13cf$export$7bff60a5db1bae35)();
    const location = (0, $3T949.useLocation)();
    if (loading) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "User Credentials"
    });
    else if (error) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $1d0a237fe4c0025c$export$2e2bcd8739ae039), {
        variant: "danger",
        children: [
            "Authentication error: ",
            error.message
        ]
    });
    else if (!authUser) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3T949.Navigate), {
        to: "/login",
        state: {
            from: location
        },
        replace: true
    });
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3T949.Outlet), {});
}
function $5c148f2ca1c26c40$var$RequireWaiver() {
    const [attendee, loading] = (0, $de6e1888d0a1ea86$export$67c1131f3997904d)();
    if (loading) return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $a147a5343133f2a5$export$669f6ea7d267feaf), {
        wat: "Attendee (Waiver)"
    });
    return attendee?.waiverTime ? /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3T949.Outlet), {}) : /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $aaefed0cad2d34ec$export$b5b16ca84785baf7), {});
}
function $5c148f2ca1c26c40$export$2e2bcd8739ae039() {
    const match = (0, $3T949.useMatch)("/launches/:launchId/*");
    const { launchId: launchId  } = match?.params ?? {};
    return /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $e9bc3aadba8432ee$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $99363374ad4a13cf$export$5600659300053830), {
                children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $5d52285becd1fc5d$export$8cb21553fa7d1d8a), {
                    launchId: launchId,
                    children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $3T949.Routes), {
                        children: [
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3T949.Route), {
                                path: "/login",
                                element: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $f5e4100d4916d807$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $3T949.Route), {
                                element: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)($5c148f2ca1c26c40$var$RequireAuth, {}),
                                children: [
                                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $3T949.Route), {
                                        element: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $7c192130d736c5da$export$ee57ba49aae4a7c4), {}),
                                        children: [
                                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3T949.Route), {
                                                path: "/",
                                                element: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3T949.Navigate), {
                                                    to: "/welcome"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3T949.Route), {
                                                path: "/welcome",
                                                element: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $8ba368de75b225e2$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3T949.Route), {
                                                path: "/admin",
                                                element: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $edcfd3fe3755e00b$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3T949.Route), {
                                                path: "/launches",
                                                element: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $eb6cc02af4a42113$export$2e2bcd8739ae039), {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3T949.Route), {
                                        element: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)($5c148f2ca1c26c40$var$RequireWaiver, {}),
                                        children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsxs)((0, $3T949.Route), {
                                            path: "/launches/:launchid",
                                            element: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3832f41ec0a5987e$export$67fb918b6e0c5286), {}),
                                            children: [
                                                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3T949.Route), {
                                                    index: true,
                                                    element: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $8b22b063715bd52f$export$2e2bcd8739ae039), {})
                                                }),
                                                /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $3T949.Route), {
                                                    path: "*",
                                                    element: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $4cafc1ae92bff46f$export$2e2bcd8739ae039), {})
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $7a7b339865ca290c$export$26c05df95da5fc70), {
                style: {
                    position: "fixed",
                    maxWidth: "min(90vw, 30em)",
                    right: "min(5vw, 1em)",
                    bottom: "2em"
                }
            })
        ]
    });
}


const $484936ff8a45841e$var$root = (0, $11011d7422997104$export$882461b6382ed46c)(document.querySelector("#content"));
$484936ff8a45841e$var$root.render(/*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $fIsAN.BrowserRouter), {
    children: /*#__PURE__*/ (0, $e9bc3aadba8432ee$exports.jsx)((0, $5c148f2ca1c26c40$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=index.6aa734e1.js.map
